
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire16a5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire16a5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eCLAF", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $aa5987bd0b2fafe8$export$ffb0004e005737fa, (v) => $aa5987bd0b2fafe8$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $aa5987bd0b2fafe8$export$34b9dba7ce09269b, (v) => $aa5987bd0b2fafe8$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $aa5987bd0b2fafe8$export$25062201e9e25d76, (v) => $aa5987bd0b2fafe8$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa5987bd0b2fafe8$export$ffb0004e005737fa;
var $aa5987bd0b2fafe8$export$34b9dba7ce09269b;
var $aa5987bd0b2fafe8$export$25062201e9e25d76;
"use strict";
var $aa5987bd0b2fafe8$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $aa5987bd0b2fafe8$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $aa5987bd0b2fafe8$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $aa5987bd0b2fafe8$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$aa5987bd0b2fafe8$export$ffb0004e005737fa = $aa5987bd0b2fafe8$var$REACT_FRAGMENT_TYPE;
$aa5987bd0b2fafe8$export$34b9dba7ce09269b = $aa5987bd0b2fafe8$var$jsxProd;
$aa5987bd0b2fafe8$export$25062201e9e25d76 = $aa5987bd0b2fafe8$var$jsxProd;

});

parcelRegister("c8Lsf", function(module, exports) {

$parcel$export(module.exports, "Children", () => $8d6b0ae052da41be$export$dca3b0875bd9a954, (v) => $8d6b0ae052da41be$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $8d6b0ae052da41be$export$16fa2f45be04daa8, (v) => $8d6b0ae052da41be$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $8d6b0ae052da41be$export$ffb0004e005737fa, (v) => $8d6b0ae052da41be$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $8d6b0ae052da41be$export$e2c29f18771995cb, (v) => $8d6b0ae052da41be$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $8d6b0ae052da41be$export$221d75b3f55bb0bd, (v) => $8d6b0ae052da41be$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $8d6b0ae052da41be$export$5f8d39834fd61797, (v) => $8d6b0ae052da41be$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8d6b0ae052da41be$export$74bf444e3cd11ea5, (v) => $8d6b0ae052da41be$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $8d6b0ae052da41be$export$1ced07cd6b1985ce, (v) => $8d6b0ae052da41be$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $8d6b0ae052da41be$export$abd8e32b826d7ea7, (v) => $8d6b0ae052da41be$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $8d6b0ae052da41be$export$69a3209f1a06c04d, (v) => $8d6b0ae052da41be$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $8d6b0ae052da41be$export$e530037191fcd5d7, (v) => $8d6b0ae052da41be$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $8d6b0ae052da41be$export$fd42f52fd3ae1109, (v) => $8d6b0ae052da41be$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $8d6b0ae052da41be$export$c8a8987d4410bf2d, (v) => $8d6b0ae052da41be$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $8d6b0ae052da41be$export$7d1e3a5e95ceca43, (v) => $8d6b0ae052da41be$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $8d6b0ae052da41be$export$257a8862b851cb5b, (v) => $8d6b0ae052da41be$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $8d6b0ae052da41be$export$a8257692ac88316c, (v) => $8d6b0ae052da41be$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $8d6b0ae052da41be$export$488013bae63b21da, (v) => $8d6b0ae052da41be$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $8d6b0ae052da41be$export$7c73462e0d25e514, (v) => $8d6b0ae052da41be$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $8d6b0ae052da41be$export$7568632d0d33d16d, (v) => $8d6b0ae052da41be$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $8d6b0ae052da41be$export$f93f40ac0ca7e3a8, (v) => $8d6b0ae052da41be$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $8d6b0ae052da41be$export$1f96ae73734a86cc, (v) => $8d6b0ae052da41be$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $8d6b0ae052da41be$export$9a47ced3238df325, (v) => $8d6b0ae052da41be$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $8d6b0ae052da41be$export$35808ee640e87ca7, (v) => $8d6b0ae052da41be$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $8d6b0ae052da41be$export$fae74005e78b1a27, (v) => $8d6b0ae052da41be$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $8d6b0ae052da41be$export$dc8fbce3eb94dc1e, (v) => $8d6b0ae052da41be$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $8d6b0ae052da41be$export$6a7bc4e911dc01cf, (v) => $8d6b0ae052da41be$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $8d6b0ae052da41be$export$6d9c69b0de29b591, (v) => $8d6b0ae052da41be$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $8d6b0ae052da41be$export$f680877a34711e37, (v) => $8d6b0ae052da41be$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $8d6b0ae052da41be$export$d5a552a76deda3c2, (v) => $8d6b0ae052da41be$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $8d6b0ae052da41be$export$aaabe4eda9ed9969, (v) => $8d6b0ae052da41be$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $8d6b0ae052da41be$export$e5c5a5f917a5871c, (v) => $8d6b0ae052da41be$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $8d6b0ae052da41be$export$1538c33de8887b59, (v) => $8d6b0ae052da41be$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $8d6b0ae052da41be$export$fca7f784ae7a249a, (v) => $8d6b0ae052da41be$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $8d6b0ae052da41be$export$13e3392192263954, (v) => $8d6b0ae052da41be$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $8d6b0ae052da41be$export$b8f5890fc79d6aca, (v) => $8d6b0ae052da41be$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $8d6b0ae052da41be$export$60241385465d0a34, (v) => $8d6b0ae052da41be$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $8d6b0ae052da41be$export$306c0aa65ff9ec16, (v) => $8d6b0ae052da41be$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $8d6b0ae052da41be$export$7b286972b8d8ccbf, (v) => $8d6b0ae052da41be$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $8d6b0ae052da41be$export$83d89fbfd8236492, (v) => $8d6b0ae052da41be$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8d6b0ae052da41be$export$dca3b0875bd9a954;
var $8d6b0ae052da41be$export$16fa2f45be04daa8;
var $8d6b0ae052da41be$export$ffb0004e005737fa;
var $8d6b0ae052da41be$export$e2c29f18771995cb;
var $8d6b0ae052da41be$export$221d75b3f55bb0bd;
var $8d6b0ae052da41be$export$5f8d39834fd61797;
var $8d6b0ae052da41be$export$74bf444e3cd11ea5;
var $8d6b0ae052da41be$export$1ced07cd6b1985ce;
var $8d6b0ae052da41be$export$abd8e32b826d7ea7;
var $8d6b0ae052da41be$export$69a3209f1a06c04d;
var $8d6b0ae052da41be$export$e530037191fcd5d7;
var $8d6b0ae052da41be$export$fd42f52fd3ae1109;
var $8d6b0ae052da41be$export$c8a8987d4410bf2d;
var $8d6b0ae052da41be$export$7d1e3a5e95ceca43;
var $8d6b0ae052da41be$export$257a8862b851cb5b;
var $8d6b0ae052da41be$export$a8257692ac88316c;
var $8d6b0ae052da41be$export$488013bae63b21da;
var $8d6b0ae052da41be$export$7c73462e0d25e514;
var $8d6b0ae052da41be$export$7568632d0d33d16d;
var $8d6b0ae052da41be$export$f93f40ac0ca7e3a8;
var $8d6b0ae052da41be$export$1f96ae73734a86cc;
var $8d6b0ae052da41be$export$9a47ced3238df325;
var $8d6b0ae052da41be$export$35808ee640e87ca7;
var $8d6b0ae052da41be$export$fae74005e78b1a27;
var $8d6b0ae052da41be$export$dc8fbce3eb94dc1e;
var $8d6b0ae052da41be$export$6a7bc4e911dc01cf;
var $8d6b0ae052da41be$export$6d9c69b0de29b591;
var $8d6b0ae052da41be$export$f680877a34711e37;
var $8d6b0ae052da41be$export$d5a552a76deda3c2;
var $8d6b0ae052da41be$export$aaabe4eda9ed9969;
var $8d6b0ae052da41be$export$e5c5a5f917a5871c;
var $8d6b0ae052da41be$export$1538c33de8887b59;
var $8d6b0ae052da41be$export$fca7f784ae7a249a;
var $8d6b0ae052da41be$export$13e3392192263954;
var $8d6b0ae052da41be$export$b8f5890fc79d6aca;
var $8d6b0ae052da41be$export$60241385465d0a34;
var $8d6b0ae052da41be$export$306c0aa65ff9ec16;
var $8d6b0ae052da41be$export$7b286972b8d8ccbf;
var $8d6b0ae052da41be$export$83d89fbfd8236492;
"use strict";
var $8d6b0ae052da41be$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8d6b0ae052da41be$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8d6b0ae052da41be$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8d6b0ae052da41be$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8d6b0ae052da41be$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8d6b0ae052da41be$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8d6b0ae052da41be$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8d6b0ae052da41be$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8d6b0ae052da41be$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8d6b0ae052da41be$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8d6b0ae052da41be$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $8d6b0ae052da41be$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8d6b0ae052da41be$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8d6b0ae052da41be$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8d6b0ae052da41be$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8d6b0ae052da41be$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8d6b0ae052da41be$var$assign = Object.assign, $8d6b0ae052da41be$var$emptyObject = {};
function $8d6b0ae052da41be$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8d6b0ae052da41be$var$emptyObject;
    this.updater = updater || $8d6b0ae052da41be$var$ReactNoopUpdateQueue;
}
$8d6b0ae052da41be$var$Component.prototype.isReactComponent = {};
$8d6b0ae052da41be$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$8d6b0ae052da41be$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $8d6b0ae052da41be$var$ComponentDummy() {}
$8d6b0ae052da41be$var$ComponentDummy.prototype = $8d6b0ae052da41be$var$Component.prototype;
function $8d6b0ae052da41be$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8d6b0ae052da41be$var$emptyObject;
    this.updater = updater || $8d6b0ae052da41be$var$ReactNoopUpdateQueue;
}
var $8d6b0ae052da41be$var$pureComponentPrototype = $8d6b0ae052da41be$var$PureComponent.prototype = new $8d6b0ae052da41be$var$ComponentDummy();
$8d6b0ae052da41be$var$pureComponentPrototype.constructor = $8d6b0ae052da41be$var$PureComponent;
$8d6b0ae052da41be$var$assign($8d6b0ae052da41be$var$pureComponentPrototype, $8d6b0ae052da41be$var$Component.prototype);
$8d6b0ae052da41be$var$pureComponentPrototype.isPureReactComponent = !0;
var $8d6b0ae052da41be$var$isArrayImpl = Array.isArray, $8d6b0ae052da41be$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $8d6b0ae052da41be$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8d6b0ae052da41be$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $8d6b0ae052da41be$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $8d6b0ae052da41be$var$cloneAndReplaceKey(oldElement, newKey) {
    return $8d6b0ae052da41be$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $8d6b0ae052da41be$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $8d6b0ae052da41be$var$REACT_ELEMENT_TYPE;
}
function $8d6b0ae052da41be$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $8d6b0ae052da41be$var$userProvidedKeyEscapeRegex = /\/+/g;
function $8d6b0ae052da41be$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $8d6b0ae052da41be$var$escape("" + element.key) : index.toString(36);
}
function $8d6b0ae052da41be$var$noop$1() {}
function $8d6b0ae052da41be$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($8d6b0ae052da41be$var$noop$1, $8d6b0ae052da41be$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $8d6b0ae052da41be$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $8d6b0ae052da41be$var$REACT_ELEMENT_TYPE:
                case $8d6b0ae052da41be$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $8d6b0ae052da41be$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $8d6b0ae052da41be$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $8d6b0ae052da41be$var$getElementKey(children, 0) : nameSoFar, $8d6b0ae052da41be$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($8d6b0ae052da41be$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $8d6b0ae052da41be$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($8d6b0ae052da41be$var$isValidElement(callback) && (callback = $8d6b0ae052da41be$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($8d6b0ae052da41be$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($8d6b0ae052da41be$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $8d6b0ae052da41be$var$getElementKey(nameSoFar, i), invokeCallback += $8d6b0ae052da41be$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $8d6b0ae052da41be$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $8d6b0ae052da41be$var$getElementKey(nameSoFar, i++), invokeCallback += $8d6b0ae052da41be$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $8d6b0ae052da41be$var$mapIntoArray($8d6b0ae052da41be$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $8d6b0ae052da41be$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $8d6b0ae052da41be$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $8d6b0ae052da41be$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $8d6b0ae052da41be$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $8d6b0ae052da41be$var$noop() {}
$8d6b0ae052da41be$export$dca3b0875bd9a954 = {
    map: $8d6b0ae052da41be$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $8d6b0ae052da41be$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $8d6b0ae052da41be$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $8d6b0ae052da41be$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$8d6b0ae052da41be$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$8d6b0ae052da41be$export$16fa2f45be04daa8 = $8d6b0ae052da41be$var$Component;
$8d6b0ae052da41be$export$ffb0004e005737fa = $8d6b0ae052da41be$var$REACT_FRAGMENT_TYPE;
$8d6b0ae052da41be$export$e2c29f18771995cb = $8d6b0ae052da41be$var$REACT_PROFILER_TYPE;
$8d6b0ae052da41be$export$221d75b3f55bb0bd = $8d6b0ae052da41be$var$PureComponent;
$8d6b0ae052da41be$export$5f8d39834fd61797 = $8d6b0ae052da41be$var$REACT_STRICT_MODE_TYPE;
$8d6b0ae052da41be$export$74bf444e3cd11ea5 = $8d6b0ae052da41be$var$REACT_SUSPENSE_TYPE;
$8d6b0ae052da41be$export$1ced07cd6b1985ce = $8d6b0ae052da41be$var$ReactSharedInternals;
$8d6b0ae052da41be$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $8d6b0ae052da41be$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$8d6b0ae052da41be$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$8d6b0ae052da41be$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $8d6b0ae052da41be$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$8d6b0ae052da41be$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $8d6b0ae052da41be$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$8d6b0ae052da41be$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $8d6b0ae052da41be$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $8d6b0ae052da41be$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$8d6b0ae052da41be$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$8d6b0ae052da41be$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $8d6b0ae052da41be$var$ReactElement(type, key, void 0, void 0, null, props);
};
$8d6b0ae052da41be$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8d6b0ae052da41be$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $8d6b0ae052da41be$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$8d6b0ae052da41be$export$a8257692ac88316c = $8d6b0ae052da41be$var$isValidElement;
$8d6b0ae052da41be$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $8d6b0ae052da41be$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $8d6b0ae052da41be$var$lazyInitializer
    };
};
$8d6b0ae052da41be$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $8d6b0ae052da41be$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$8d6b0ae052da41be$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $8d6b0ae052da41be$var$ReactSharedInternals.T, currentTransition = {};
    $8d6b0ae052da41be$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $8d6b0ae052da41be$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($8d6b0ae052da41be$var$noop, $8d6b0ae052da41be$var$reportGlobalError);
    } catch (error) {
        $8d6b0ae052da41be$var$reportGlobalError(error);
    } finally{
        $8d6b0ae052da41be$var$ReactSharedInternals.T = prevTransition;
    }
};
$8d6b0ae052da41be$export$f93f40ac0ca7e3a8 = function() {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useCacheRefresh();
};
$8d6b0ae052da41be$export$1f96ae73734a86cc = function(usable) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.use(usable);
};
$8d6b0ae052da41be$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$8d6b0ae052da41be$export$35808ee640e87ca7 = function(callback, deps) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$8d6b0ae052da41be$export$fae74005e78b1a27 = function(Context) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useContext(Context);
};
$8d6b0ae052da41be$export$dc8fbce3eb94dc1e = function() {};
$8d6b0ae052da41be$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$8d6b0ae052da41be$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $8d6b0ae052da41be$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$8d6b0ae052da41be$export$f680877a34711e37 = function() {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useId();
};
$8d6b0ae052da41be$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$8d6b0ae052da41be$export$aaabe4eda9ed9969 = function(create, deps) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$8d6b0ae052da41be$export$e5c5a5f917a5871c = function(create, deps) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$8d6b0ae052da41be$export$1538c33de8887b59 = function(create, deps) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useMemo(create, deps);
};
$8d6b0ae052da41be$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$8d6b0ae052da41be$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$8d6b0ae052da41be$export$b8f5890fc79d6aca = function(initialValue) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useRef(initialValue);
};
$8d6b0ae052da41be$export$60241385465d0a34 = function(initialState) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useState(initialState);
};
$8d6b0ae052da41be$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$8d6b0ae052da41be$export$7b286972b8d8ccbf = function() {
    return $8d6b0ae052da41be$var$ReactSharedInternals.H.useTransition();
};
$8d6b0ae052da41be$export$83d89fbfd8236492 = "19.1.1";

});

parcelRegister("31Jtn", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $2344bd0db54c71be$export$882461b6382ed46c, (v) => $2344bd0db54c71be$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $2344bd0db54c71be$export$757ceba2d55c277e, (v) => $2344bd0db54c71be$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $2344bd0db54c71be$export$83d89fbfd8236492, (v) => $2344bd0db54c71be$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $2344bd0db54c71be$export$882461b6382ed46c;
var $2344bd0db54c71be$export$757ceba2d55c277e;
var $2344bd0db54c71be$export$83d89fbfd8236492;
"use strict";

var $5xrAo = parcelRequire("5xrAo");

var $baslc = parcelRequire("baslc");

var $ePvRJ = parcelRequire("ePvRJ");
function $2344bd0db54c71be$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2344bd0db54c71be$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $2344bd0db54c71be$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $2344bd0db54c71be$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $2344bd0db54c71be$var$assertIsMounted(fiber) {
    if ($2344bd0db54c71be$var$getNearestMountedFiber(fiber) !== fiber) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(188));
}
function $2344bd0db54c71be$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $2344bd0db54c71be$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $2344bd0db54c71be$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $2344bd0db54c71be$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($2344bd0db54c71be$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $2344bd0db54c71be$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $2344bd0db54c71be$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $2344bd0db54c71be$var$assign = Object.assign, $2344bd0db54c71be$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $2344bd0db54c71be$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2344bd0db54c71be$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2344bd0db54c71be$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2344bd0db54c71be$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2344bd0db54c71be$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2344bd0db54c71be$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $2344bd0db54c71be$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2344bd0db54c71be$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2344bd0db54c71be$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2344bd0db54c71be$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2344bd0db54c71be$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $2344bd0db54c71be$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2344bd0db54c71be$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $2344bd0db54c71be$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $2344bd0db54c71be$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $2344bd0db54c71be$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2344bd0db54c71be$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $2344bd0db54c71be$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2344bd0db54c71be$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2344bd0db54c71be$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $2344bd0db54c71be$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $2344bd0db54c71be$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $2344bd0db54c71be$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $2344bd0db54c71be$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $2344bd0db54c71be$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $2344bd0db54c71be$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $2344bd0db54c71be$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $2344bd0db54c71be$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $2344bd0db54c71be$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $2344bd0db54c71be$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $2344bd0db54c71be$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $2344bd0db54c71be$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $2344bd0db54c71be$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $2344bd0db54c71be$var$getComponentNameFromType(type.type) || "Memo";
        case $2344bd0db54c71be$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $2344bd0db54c71be$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $2344bd0db54c71be$var$isArrayImpl = Array.isArray, $2344bd0db54c71be$var$ReactSharedInternals = $baslc.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2344bd0db54c71be$var$ReactDOMSharedInternals = $ePvRJ.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2344bd0db54c71be$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $2344bd0db54c71be$var$valueStack = [], $2344bd0db54c71be$var$index = -1;
function $2344bd0db54c71be$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $2344bd0db54c71be$var$pop(cursor) {
    0 > $2344bd0db54c71be$var$index || (cursor.current = $2344bd0db54c71be$var$valueStack[$2344bd0db54c71be$var$index], $2344bd0db54c71be$var$valueStack[$2344bd0db54c71be$var$index] = null, $2344bd0db54c71be$var$index--);
}
function $2344bd0db54c71be$var$push(cursor, value) {
    $2344bd0db54c71be$var$index++;
    $2344bd0db54c71be$var$valueStack[$2344bd0db54c71be$var$index] = cursor.current;
    cursor.current = value;
}
var $2344bd0db54c71be$var$contextStackCursor = $2344bd0db54c71be$var$createCursor(null), $2344bd0db54c71be$var$contextFiberStackCursor = $2344bd0db54c71be$var$createCursor(null), $2344bd0db54c71be$var$rootInstanceStackCursor = $2344bd0db54c71be$var$createCursor(null), $2344bd0db54c71be$var$hostTransitionProviderCursor = $2344bd0db54c71be$var$createCursor(null);
function $2344bd0db54c71be$var$pushHostContainer(fiber, nextRootInstance) {
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$rootInstanceStackCursor, nextRootInstance);
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$contextFiberStackCursor, fiber);
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $2344bd0db54c71be$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $2344bd0db54c71be$var$getOwnHostContext(nextRootInstance), fiber = $2344bd0db54c71be$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$contextStackCursor);
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$contextStackCursor, fiber);
}
function $2344bd0db54c71be$var$popHostContainer() {
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$contextStackCursor);
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$contextFiberStackCursor);
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$rootInstanceStackCursor);
}
function $2344bd0db54c71be$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $2344bd0db54c71be$var$push($2344bd0db54c71be$var$hostTransitionProviderCursor, fiber);
    var context = $2344bd0db54c71be$var$contextStackCursor.current;
    var JSCompiler_inline_result = $2344bd0db54c71be$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($2344bd0db54c71be$var$push($2344bd0db54c71be$var$contextFiberStackCursor, fiber), $2344bd0db54c71be$var$push($2344bd0db54c71be$var$contextStackCursor, JSCompiler_inline_result));
}
function $2344bd0db54c71be$var$popHostContext(fiber) {
    $2344bd0db54c71be$var$contextFiberStackCursor.current === fiber && ($2344bd0db54c71be$var$pop($2344bd0db54c71be$var$contextStackCursor), $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$contextFiberStackCursor));
    $2344bd0db54c71be$var$hostTransitionProviderCursor.current === fiber && ($2344bd0db54c71be$var$pop($2344bd0db54c71be$var$hostTransitionProviderCursor), $2344bd0db54c71be$var$HostTransitionContext._currentValue = $2344bd0db54c71be$var$sharedNotPendingObject);
}
var $2344bd0db54c71be$var$hasOwnProperty = Object.prototype.hasOwnProperty, $2344bd0db54c71be$var$scheduleCallback$3 = $5xrAo.unstable_scheduleCallback, $2344bd0db54c71be$var$cancelCallback$1 = $5xrAo.unstable_cancelCallback, $2344bd0db54c71be$var$shouldYield = $5xrAo.unstable_shouldYield, $2344bd0db54c71be$var$requestPaint = $5xrAo.unstable_requestPaint, $2344bd0db54c71be$var$now = $5xrAo.unstable_now, $2344bd0db54c71be$var$getCurrentPriorityLevel = $5xrAo.unstable_getCurrentPriorityLevel, $2344bd0db54c71be$var$ImmediatePriority = $5xrAo.unstable_ImmediatePriority, $2344bd0db54c71be$var$UserBlockingPriority = $5xrAo.unstable_UserBlockingPriority, $2344bd0db54c71be$var$NormalPriority$1 = $5xrAo.unstable_NormalPriority, $2344bd0db54c71be$var$LowPriority = $5xrAo.unstable_LowPriority, $2344bd0db54c71be$var$IdlePriority = $5xrAo.unstable_IdlePriority, $2344bd0db54c71be$var$log$1 = $5xrAo.log, $2344bd0db54c71be$var$unstable_setDisableYieldValue = $5xrAo.unstable_setDisableYieldValue, $2344bd0db54c71be$var$rendererID = null, $2344bd0db54c71be$var$injectedHook = null;
function $2344bd0db54c71be$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $2344bd0db54c71be$var$log$1 && $2344bd0db54c71be$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($2344bd0db54c71be$var$injectedHook && "function" === typeof $2344bd0db54c71be$var$injectedHook.setStrictMode) try {
        $2344bd0db54c71be$var$injectedHook.setStrictMode($2344bd0db54c71be$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $2344bd0db54c71be$var$clz32 = Math.clz32 ? Math.clz32 : $2344bd0db54c71be$var$clz32Fallback, $2344bd0db54c71be$var$log = Math.log, $2344bd0db54c71be$var$LN2 = Math.LN2;
function $2344bd0db54c71be$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($2344bd0db54c71be$var$log(x) / $2344bd0db54c71be$var$LN2 | 0) | 0;
}
var $2344bd0db54c71be$var$nextTransitionLane = 256, $2344bd0db54c71be$var$nextRetryLane = 4194304;
function $2344bd0db54c71be$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $2344bd0db54c71be$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $2344bd0db54c71be$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $2344bd0db54c71be$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2344bd0db54c71be$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $2344bd0db54c71be$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $2344bd0db54c71be$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2344bd0db54c71be$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $2344bd0db54c71be$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $2344bd0db54c71be$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2344bd0db54c71be$var$claimNextTransitionLane() {
    var lane = $2344bd0db54c71be$var$nextTransitionLane;
    $2344bd0db54c71be$var$nextTransitionLane <<= 1;
    0 === ($2344bd0db54c71be$var$nextTransitionLane & 4194048) && ($2344bd0db54c71be$var$nextTransitionLane = 256);
    return lane;
}
function $2344bd0db54c71be$var$claimNextRetryLane() {
    var lane = $2344bd0db54c71be$var$nextRetryLane;
    $2344bd0db54c71be$var$nextRetryLane <<= 1;
    0 === ($2344bd0db54c71be$var$nextRetryLane & 62914560) && ($2344bd0db54c71be$var$nextRetryLane = 4194304);
    return lane;
}
function $2344bd0db54c71be$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $2344bd0db54c71be$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $2344bd0db54c71be$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $2344bd0db54c71be$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $2344bd0db54c71be$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $2344bd0db54c71be$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $2344bd0db54c71be$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $2344bd0db54c71be$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $2344bd0db54c71be$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $2344bd0db54c71be$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $2344bd0db54c71be$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $2344bd0db54c71be$var$resolveUpdatePriority() {
    var updatePriority = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $2344bd0db54c71be$var$getEventPriority(updatePriority.type);
}
function $2344bd0db54c71be$var$runWithPriority(priority, fn) {
    var previousPriority = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
    try {
        return $2344bd0db54c71be$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $2344bd0db54c71be$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $2344bd0db54c71be$var$randomKey = Math.random().toString(36).slice(2), $2344bd0db54c71be$var$internalInstanceKey = "__reactFiber$" + $2344bd0db54c71be$var$randomKey, $2344bd0db54c71be$var$internalPropsKey = "__reactProps$" + $2344bd0db54c71be$var$randomKey, $2344bd0db54c71be$var$internalContainerInstanceKey = "__reactContainer$" + $2344bd0db54c71be$var$randomKey, $2344bd0db54c71be$var$internalEventHandlersKey = "__reactEvents$" + $2344bd0db54c71be$var$randomKey, $2344bd0db54c71be$var$internalEventHandlerListenersKey = "__reactListeners$" + $2344bd0db54c71be$var$randomKey, $2344bd0db54c71be$var$internalEventHandlesSetKey = "__reactHandles$" + $2344bd0db54c71be$var$randomKey, $2344bd0db54c71be$var$internalRootNodeResourcesKey = "__reactResources$" + $2344bd0db54c71be$var$randomKey, $2344bd0db54c71be$var$internalHoistableMarker = "__reactMarker$" + $2344bd0db54c71be$var$randomKey;
function $2344bd0db54c71be$var$detachDeletedInstance(node) {
    delete node[$2344bd0db54c71be$var$internalInstanceKey];
    delete node[$2344bd0db54c71be$var$internalPropsKey];
    delete node[$2344bd0db54c71be$var$internalEventHandlersKey];
    delete node[$2344bd0db54c71be$var$internalEventHandlerListenersKey];
    delete node[$2344bd0db54c71be$var$internalEventHandlesSetKey];
}
function $2344bd0db54c71be$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$2344bd0db54c71be$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$2344bd0db54c71be$var$internalContainerInstanceKey] || parentNode[$2344bd0db54c71be$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $2344bd0db54c71be$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$2344bd0db54c71be$var$internalInstanceKey]) return parentNode;
                targetNode = $2344bd0db54c71be$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $2344bd0db54c71be$var$getInstanceFromNode(node) {
    if (node = node[$2344bd0db54c71be$var$internalInstanceKey] || node[$2344bd0db54c71be$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $2344bd0db54c71be$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(33));
}
function $2344bd0db54c71be$var$getResourcesFromRoot(root) {
    var resources = root[$2344bd0db54c71be$var$internalRootNodeResourcesKey];
    resources || (resources = root[$2344bd0db54c71be$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $2344bd0db54c71be$var$markNodeAsHoistable(node) {
    node[$2344bd0db54c71be$var$internalHoistableMarker] = !0;
}
var $2344bd0db54c71be$var$allNativeEvents = new Set(), $2344bd0db54c71be$var$registrationNameDependencies = {};
function $2344bd0db54c71be$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $2344bd0db54c71be$var$registerDirectEvent(registrationName, dependencies);
    $2344bd0db54c71be$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $2344bd0db54c71be$var$registerDirectEvent(registrationName, dependencies) {
    $2344bd0db54c71be$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$2344bd0db54c71be$var$allNativeEvents.add(dependencies[registrationName]);
}
var $2344bd0db54c71be$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $2344bd0db54c71be$var$illegalAttributeNameCache = {}, $2344bd0db54c71be$var$validatedAttributeNameCache = {};
function $2344bd0db54c71be$var$isAttributeNameSafe(attributeName) {
    if ($2344bd0db54c71be$var$hasOwnProperty.call($2344bd0db54c71be$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($2344bd0db54c71be$var$hasOwnProperty.call($2344bd0db54c71be$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($2344bd0db54c71be$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $2344bd0db54c71be$var$validatedAttributeNameCache[attributeName] = !0;
    $2344bd0db54c71be$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $2344bd0db54c71be$var$setValueForAttribute(node, name, value) {
    if ($2344bd0db54c71be$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $2344bd0db54c71be$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $2344bd0db54c71be$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $2344bd0db54c71be$var$prefix, $2344bd0db54c71be$var$suffix;
function $2344bd0db54c71be$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $2344bd0db54c71be$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $2344bd0db54c71be$var$prefix = match && match[1] || "";
        $2344bd0db54c71be$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $2344bd0db54c71be$var$prefix + name + $2344bd0db54c71be$var$suffix;
}
var $2344bd0db54c71be$var$reentry = !1;
function $2344bd0db54c71be$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $2344bd0db54c71be$var$reentry) return "";
    $2344bd0db54c71be$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $2344bd0db54c71be$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $2344bd0db54c71be$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $2344bd0db54c71be$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $2344bd0db54c71be$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $2344bd0db54c71be$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $2344bd0db54c71be$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $2344bd0db54c71be$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $2344bd0db54c71be$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $2344bd0db54c71be$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $2344bd0db54c71be$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $2344bd0db54c71be$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $2344bd0db54c71be$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $2344bd0db54c71be$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $2344bd0db54c71be$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $2344bd0db54c71be$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $2344bd0db54c71be$var$trackValueOnNode(node) {
    var valueField = $2344bd0db54c71be$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $2344bd0db54c71be$var$track(node) {
    node._valueTracker || (node._valueTracker = $2344bd0db54c71be$var$trackValueOnNode(node));
}
function $2344bd0db54c71be$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $2344bd0db54c71be$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $2344bd0db54c71be$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $2344bd0db54c71be$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $2344bd0db54c71be$var$getToStringValue(value);
        } else element.value !== "" + $2344bd0db54c71be$var$getToStringValue(value) && (element.value = "" + $2344bd0db54c71be$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $2344bd0db54c71be$var$setDefaultValue(element, type, $2344bd0db54c71be$var$getToStringValue(value)) : null != defaultValue ? $2344bd0db54c71be$var$setDefaultValue(element, type, $2344bd0db54c71be$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $2344bd0db54c71be$var$getToStringValue(name) : element.removeAttribute("name");
}
function $2344bd0db54c71be$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $2344bd0db54c71be$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $2344bd0db54c71be$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $2344bd0db54c71be$var$setDefaultValue(node, type, value) {
    "number" === type && $2344bd0db54c71be$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $2344bd0db54c71be$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $2344bd0db54c71be$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $2344bd0db54c71be$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $2344bd0db54c71be$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $2344bd0db54c71be$var$getToStringValue(defaultValue) : "";
}
function $2344bd0db54c71be$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(92));
            if ($2344bd0db54c71be$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $2344bd0db54c71be$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $2344bd0db54c71be$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $2344bd0db54c71be$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $2344bd0db54c71be$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $2344bd0db54c71be$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $2344bd0db54c71be$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $2344bd0db54c71be$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $2344bd0db54c71be$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $2344bd0db54c71be$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2344bd0db54c71be$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $2344bd0db54c71be$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $2344bd0db54c71be$var$sanitizeURL(url) {
    return $2344bd0db54c71be$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $2344bd0db54c71be$var$currentReplayingEvent = null;
function $2344bd0db54c71be$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $2344bd0db54c71be$var$restoreTarget = null, $2344bd0db54c71be$var$restoreQueue = null;
function $2344bd0db54c71be$var$restoreStateOfTarget(target) {
    var internalInstance = $2344bd0db54c71be$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$2344bd0db54c71be$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $2344bd0db54c71be$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$2344bd0db54c71be$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(90));
                            $2344bd0db54c71be$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $2344bd0db54c71be$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $2344bd0db54c71be$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $2344bd0db54c71be$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $2344bd0db54c71be$var$isInsideEventHandler = !1;
function $2344bd0db54c71be$var$batchedUpdates$1(fn, a, b) {
    if ($2344bd0db54c71be$var$isInsideEventHandler) return fn(a, b);
    $2344bd0db54c71be$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($2344bd0db54c71be$var$isInsideEventHandler = !1, null !== $2344bd0db54c71be$var$restoreTarget || null !== $2344bd0db54c71be$var$restoreQueue) {
            if ($2344bd0db54c71be$var$flushSyncWork$1(), $2344bd0db54c71be$var$restoreTarget && (a = $2344bd0db54c71be$var$restoreTarget, fn = $2344bd0db54c71be$var$restoreQueue, $2344bd0db54c71be$var$restoreQueue = $2344bd0db54c71be$var$restoreTarget = null, $2344bd0db54c71be$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$2344bd0db54c71be$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $2344bd0db54c71be$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$2344bd0db54c71be$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $2344bd0db54c71be$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2344bd0db54c71be$var$passiveBrowserEventsSupported = !1;
if ($2344bd0db54c71be$var$canUseDOM) try {
    var $2344bd0db54c71be$var$options = {};
    Object.defineProperty($2344bd0db54c71be$var$options, "passive", {
        get: function() {
            $2344bd0db54c71be$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $2344bd0db54c71be$var$options, $2344bd0db54c71be$var$options);
    window.removeEventListener("test", $2344bd0db54c71be$var$options, $2344bd0db54c71be$var$options);
} catch (e) {
    $2344bd0db54c71be$var$passiveBrowserEventsSupported = !1;
}
var $2344bd0db54c71be$var$root = null, $2344bd0db54c71be$var$startText = null, $2344bd0db54c71be$var$fallbackText = null;
function $2344bd0db54c71be$var$getData() {
    if ($2344bd0db54c71be$var$fallbackText) return $2344bd0db54c71be$var$fallbackText;
    var start, startValue = $2344bd0db54c71be$var$startText, startLength = startValue.length, end, endValue = "value" in $2344bd0db54c71be$var$root ? $2344bd0db54c71be$var$root.value : $2344bd0db54c71be$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $2344bd0db54c71be$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $2344bd0db54c71be$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $2344bd0db54c71be$var$functionThatReturnsTrue() {
    return !0;
}
function $2344bd0db54c71be$var$functionThatReturnsFalse() {
    return !1;
}
function $2344bd0db54c71be$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $2344bd0db54c71be$var$functionThatReturnsTrue : $2344bd0db54c71be$var$functionThatReturnsFalse;
        this.isPropagationStopped = $2344bd0db54c71be$var$functionThatReturnsFalse;
        return this;
    }
    $2344bd0db54c71be$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $2344bd0db54c71be$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $2344bd0db54c71be$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $2344bd0db54c71be$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $2344bd0db54c71be$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2344bd0db54c71be$var$SyntheticEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$EventInterface), $2344bd0db54c71be$var$UIEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$EventInterface, {
    view: 0,
    detail: 0
}), $2344bd0db54c71be$var$SyntheticUIEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$UIEventInterface), $2344bd0db54c71be$var$lastMovementX, $2344bd0db54c71be$var$lastMovementY, $2344bd0db54c71be$var$lastMouseEvent, $2344bd0db54c71be$var$MouseEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2344bd0db54c71be$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $2344bd0db54c71be$var$lastMouseEvent && ($2344bd0db54c71be$var$lastMouseEvent && "mousemove" === event.type ? ($2344bd0db54c71be$var$lastMovementX = event.screenX - $2344bd0db54c71be$var$lastMouseEvent.screenX, $2344bd0db54c71be$var$lastMovementY = event.screenY - $2344bd0db54c71be$var$lastMouseEvent.screenY) : $2344bd0db54c71be$var$lastMovementY = $2344bd0db54c71be$var$lastMovementX = 0, $2344bd0db54c71be$var$lastMouseEvent = event);
        return $2344bd0db54c71be$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $2344bd0db54c71be$var$lastMovementY;
    }
}), $2344bd0db54c71be$var$SyntheticMouseEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$MouseEventInterface), $2344bd0db54c71be$var$DragEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$MouseEventInterface, {
    dataTransfer: 0
}), $2344bd0db54c71be$var$SyntheticDragEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$DragEventInterface), $2344bd0db54c71be$var$FocusEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$UIEventInterface, {
    relatedTarget: 0
}), $2344bd0db54c71be$var$SyntheticFocusEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$FocusEventInterface), $2344bd0db54c71be$var$AnimationEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2344bd0db54c71be$var$SyntheticAnimationEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$AnimationEventInterface), $2344bd0db54c71be$var$ClipboardEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $2344bd0db54c71be$var$SyntheticClipboardEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$ClipboardEventInterface), $2344bd0db54c71be$var$CompositionEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$EventInterface, {
    data: 0
}), $2344bd0db54c71be$var$SyntheticCompositionEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$CompositionEventInterface), $2344bd0db54c71be$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2344bd0db54c71be$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2344bd0db54c71be$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2344bd0db54c71be$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $2344bd0db54c71be$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $2344bd0db54c71be$var$getEventModifierState() {
    return $2344bd0db54c71be$var$modifierStateGetter;
}
var $2344bd0db54c71be$var$KeyboardEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $2344bd0db54c71be$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $2344bd0db54c71be$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $2344bd0db54c71be$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2344bd0db54c71be$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $2344bd0db54c71be$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $2344bd0db54c71be$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $2344bd0db54c71be$var$SyntheticKeyboardEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$KeyboardEventInterface), $2344bd0db54c71be$var$PointerEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2344bd0db54c71be$var$SyntheticPointerEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$PointerEventInterface), $2344bd0db54c71be$var$TouchEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2344bd0db54c71be$var$getEventModifierState
}), $2344bd0db54c71be$var$SyntheticTouchEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$TouchEventInterface), $2344bd0db54c71be$var$TransitionEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2344bd0db54c71be$var$SyntheticTransitionEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$TransitionEventInterface), $2344bd0db54c71be$var$WheelEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2344bd0db54c71be$var$SyntheticWheelEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$WheelEventInterface), $2344bd0db54c71be$var$ToggleEventInterface = $2344bd0db54c71be$var$assign({}, $2344bd0db54c71be$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $2344bd0db54c71be$var$SyntheticToggleEvent = $2344bd0db54c71be$var$createSyntheticEvent($2344bd0db54c71be$var$ToggleEventInterface), $2344bd0db54c71be$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $2344bd0db54c71be$var$canUseCompositionEvent = $2344bd0db54c71be$var$canUseDOM && "CompositionEvent" in window, $2344bd0db54c71be$var$documentMode = null;
$2344bd0db54c71be$var$canUseDOM && "documentMode" in document && ($2344bd0db54c71be$var$documentMode = document.documentMode);
var $2344bd0db54c71be$var$canUseTextInputEvent = $2344bd0db54c71be$var$canUseDOM && "TextEvent" in window && !$2344bd0db54c71be$var$documentMode, $2344bd0db54c71be$var$useFallbackCompositionData = $2344bd0db54c71be$var$canUseDOM && (!$2344bd0db54c71be$var$canUseCompositionEvent || $2344bd0db54c71be$var$documentMode && 8 < $2344bd0db54c71be$var$documentMode && 11 >= $2344bd0db54c71be$var$documentMode), $2344bd0db54c71be$var$SPACEBAR_CHAR = String.fromCharCode(32), $2344bd0db54c71be$var$hasSpaceKeypress = !1;
function $2344bd0db54c71be$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $2344bd0db54c71be$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2344bd0db54c71be$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $2344bd0db54c71be$var$isComposing = !1;
function $2344bd0db54c71be$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $2344bd0db54c71be$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $2344bd0db54c71be$var$hasSpaceKeypress = !0;
            return $2344bd0db54c71be$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $2344bd0db54c71be$var$SPACEBAR_CHAR && $2344bd0db54c71be$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $2344bd0db54c71be$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($2344bd0db54c71be$var$isComposing) return "compositionend" === domEventName || !$2344bd0db54c71be$var$canUseCompositionEvent && $2344bd0db54c71be$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $2344bd0db54c71be$var$getData(), $2344bd0db54c71be$var$fallbackText = $2344bd0db54c71be$var$startText = $2344bd0db54c71be$var$root = null, $2344bd0db54c71be$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $2344bd0db54c71be$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $2344bd0db54c71be$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2344bd0db54c71be$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$2344bd0db54c71be$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $2344bd0db54c71be$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $2344bd0db54c71be$var$restoreTarget ? $2344bd0db54c71be$var$restoreQueue ? $2344bd0db54c71be$var$restoreQueue.push(target) : $2344bd0db54c71be$var$restoreQueue = [
        target
    ] : $2344bd0db54c71be$var$restoreTarget = target;
    inst = $2344bd0db54c71be$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $2344bd0db54c71be$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $2344bd0db54c71be$var$activeElement$1 = null, $2344bd0db54c71be$var$activeElementInst$1 = null;
function $2344bd0db54c71be$var$runEventInBatch(dispatchQueue) {
    $2344bd0db54c71be$var$processDispatchQueue(dispatchQueue, 0);
}
function $2344bd0db54c71be$var$getInstIfValueChanged(targetInst) {
    var targetNode = $2344bd0db54c71be$var$getNodeFromInstance(targetInst);
    if ($2344bd0db54c71be$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $2344bd0db54c71be$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $2344bd0db54c71be$var$isInputEventSupported = !1;
if ($2344bd0db54c71be$var$canUseDOM) {
    var $2344bd0db54c71be$var$JSCompiler_inline_result$jscomp$282;
    if ($2344bd0db54c71be$var$canUseDOM) {
        var $2344bd0db54c71be$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$2344bd0db54c71be$var$isSupported$jscomp$inline_417) {
            var $2344bd0db54c71be$var$element$jscomp$inline_418 = document.createElement("div");
            $2344bd0db54c71be$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $2344bd0db54c71be$var$isSupported$jscomp$inline_417 = "function" === typeof $2344bd0db54c71be$var$element$jscomp$inline_418.oninput;
        }
        $2344bd0db54c71be$var$JSCompiler_inline_result$jscomp$282 = $2344bd0db54c71be$var$isSupported$jscomp$inline_417;
    } else $2344bd0db54c71be$var$JSCompiler_inline_result$jscomp$282 = !1;
    $2344bd0db54c71be$var$isInputEventSupported = $2344bd0db54c71be$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $2344bd0db54c71be$var$stopWatchingForValueChange() {
    $2344bd0db54c71be$var$activeElement$1 && ($2344bd0db54c71be$var$activeElement$1.detachEvent("onpropertychange", $2344bd0db54c71be$var$handlePropertyChange), $2344bd0db54c71be$var$activeElementInst$1 = $2344bd0db54c71be$var$activeElement$1 = null);
}
function $2344bd0db54c71be$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $2344bd0db54c71be$var$getInstIfValueChanged($2344bd0db54c71be$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $2344bd0db54c71be$var$createAndAccumulateChangeEvent(dispatchQueue, $2344bd0db54c71be$var$activeElementInst$1, nativeEvent, $2344bd0db54c71be$var$getEventTarget(nativeEvent));
        $2344bd0db54c71be$var$batchedUpdates$1($2344bd0db54c71be$var$runEventInBatch, dispatchQueue);
    }
}
function $2344bd0db54c71be$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($2344bd0db54c71be$var$stopWatchingForValueChange(), $2344bd0db54c71be$var$activeElement$1 = target, $2344bd0db54c71be$var$activeElementInst$1 = targetInst, $2344bd0db54c71be$var$activeElement$1.attachEvent("onpropertychange", $2344bd0db54c71be$var$handlePropertyChange)) : "focusout" === domEventName && $2344bd0db54c71be$var$stopWatchingForValueChange();
}
function $2344bd0db54c71be$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $2344bd0db54c71be$var$getInstIfValueChanged($2344bd0db54c71be$var$activeElementInst$1);
}
function $2344bd0db54c71be$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $2344bd0db54c71be$var$getInstIfValueChanged(targetInst);
}
function $2344bd0db54c71be$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $2344bd0db54c71be$var$getInstIfValueChanged(targetInst);
}
function $2344bd0db54c71be$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2344bd0db54c71be$var$objectIs = "function" === typeof Object.is ? Object.is : $2344bd0db54c71be$var$is;
function $2344bd0db54c71be$var$shallowEqual(objA, objB) {
    if ($2344bd0db54c71be$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$2344bd0db54c71be$var$hasOwnProperty.call(objB, currentKey) || !$2344bd0db54c71be$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $2344bd0db54c71be$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $2344bd0db54c71be$var$getNodeForCharacterOffset(root, offset) {
    var node = $2344bd0db54c71be$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $2344bd0db54c71be$var$getLeafNode(node);
    }
}
function $2344bd0db54c71be$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $2344bd0db54c71be$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $2344bd0db54c71be$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $2344bd0db54c71be$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $2344bd0db54c71be$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $2344bd0db54c71be$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $2344bd0db54c71be$var$skipSelectionChangeEvent = $2344bd0db54c71be$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $2344bd0db54c71be$var$activeElement = null, $2344bd0db54c71be$var$activeElementInst = null, $2344bd0db54c71be$var$lastSelection = null, $2344bd0db54c71be$var$mouseDown = !1;
function $2344bd0db54c71be$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $2344bd0db54c71be$var$mouseDown || null == $2344bd0db54c71be$var$activeElement || $2344bd0db54c71be$var$activeElement !== $2344bd0db54c71be$var$getActiveElement(doc) || (doc = $2344bd0db54c71be$var$activeElement, "selectionStart" in doc && $2344bd0db54c71be$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $2344bd0db54c71be$var$lastSelection && $2344bd0db54c71be$var$shallowEqual($2344bd0db54c71be$var$lastSelection, doc) || ($2344bd0db54c71be$var$lastSelection = doc, doc = $2344bd0db54c71be$var$accumulateTwoPhaseListeners($2344bd0db54c71be$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $2344bd0db54c71be$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $2344bd0db54c71be$var$activeElement)));
}
function $2344bd0db54c71be$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $2344bd0db54c71be$var$vendorPrefixes = {
    animationend: $2344bd0db54c71be$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $2344bd0db54c71be$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $2344bd0db54c71be$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $2344bd0db54c71be$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $2344bd0db54c71be$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $2344bd0db54c71be$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $2344bd0db54c71be$var$makePrefixMap("Transition", "TransitionEnd")
}, $2344bd0db54c71be$var$prefixedEventNames = {}, $2344bd0db54c71be$var$style = {};
$2344bd0db54c71be$var$canUseDOM && ($2344bd0db54c71be$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $2344bd0db54c71be$var$vendorPrefixes.animationend.animation, delete $2344bd0db54c71be$var$vendorPrefixes.animationiteration.animation, delete $2344bd0db54c71be$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $2344bd0db54c71be$var$vendorPrefixes.transitionend.transition);
function $2344bd0db54c71be$var$getVendorPrefixedEventName(eventName) {
    if ($2344bd0db54c71be$var$prefixedEventNames[eventName]) return $2344bd0db54c71be$var$prefixedEventNames[eventName];
    if (!$2344bd0db54c71be$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $2344bd0db54c71be$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $2344bd0db54c71be$var$style) return $2344bd0db54c71be$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $2344bd0db54c71be$var$ANIMATION_END = $2344bd0db54c71be$var$getVendorPrefixedEventName("animationend"), $2344bd0db54c71be$var$ANIMATION_ITERATION = $2344bd0db54c71be$var$getVendorPrefixedEventName("animationiteration"), $2344bd0db54c71be$var$ANIMATION_START = $2344bd0db54c71be$var$getVendorPrefixedEventName("animationstart"), $2344bd0db54c71be$var$TRANSITION_RUN = $2344bd0db54c71be$var$getVendorPrefixedEventName("transitionrun"), $2344bd0db54c71be$var$TRANSITION_START = $2344bd0db54c71be$var$getVendorPrefixedEventName("transitionstart"), $2344bd0db54c71be$var$TRANSITION_CANCEL = $2344bd0db54c71be$var$getVendorPrefixedEventName("transitioncancel"), $2344bd0db54c71be$var$TRANSITION_END = $2344bd0db54c71be$var$getVendorPrefixedEventName("transitionend"), $2344bd0db54c71be$var$topLevelEventsToReactNames = new Map(), $2344bd0db54c71be$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$2344bd0db54c71be$var$simpleEventPluginEvents.push("scrollEnd");
function $2344bd0db54c71be$var$registerSimpleEvent(domEventName, reactName) {
    $2344bd0db54c71be$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $2344bd0db54c71be$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $2344bd0db54c71be$var$CapturedStacks = new WeakMap();
function $2344bd0db54c71be$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $2344bd0db54c71be$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $2344bd0db54c71be$var$getStackByFiberInDevAndProd(source)
        };
        $2344bd0db54c71be$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $2344bd0db54c71be$var$getStackByFiberInDevAndProd(source)
    };
}
var $2344bd0db54c71be$var$concurrentQueues = [], $2344bd0db54c71be$var$concurrentQueuesIndex = 0, $2344bd0db54c71be$var$concurrentlyUpdatedLanes = 0;
function $2344bd0db54c71be$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $2344bd0db54c71be$var$concurrentQueuesIndex, i = $2344bd0db54c71be$var$concurrentlyUpdatedLanes = $2344bd0db54c71be$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $2344bd0db54c71be$var$concurrentQueues[i];
        $2344bd0db54c71be$var$concurrentQueues[i++] = null;
        var queue = $2344bd0db54c71be$var$concurrentQueues[i];
        $2344bd0db54c71be$var$concurrentQueues[i++] = null;
        var update = $2344bd0db54c71be$var$concurrentQueues[i];
        $2344bd0db54c71be$var$concurrentQueues[i++] = null;
        var lane = $2344bd0db54c71be$var$concurrentQueues[i];
        $2344bd0db54c71be$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $2344bd0db54c71be$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $2344bd0db54c71be$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $2344bd0db54c71be$var$concurrentQueues[$2344bd0db54c71be$var$concurrentQueuesIndex++] = fiber;
    $2344bd0db54c71be$var$concurrentQueues[$2344bd0db54c71be$var$concurrentQueuesIndex++] = queue;
    $2344bd0db54c71be$var$concurrentQueues[$2344bd0db54c71be$var$concurrentQueuesIndex++] = update;
    $2344bd0db54c71be$var$concurrentQueues[$2344bd0db54c71be$var$concurrentQueuesIndex++] = lane;
    $2344bd0db54c71be$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $2344bd0db54c71be$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $2344bd0db54c71be$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $2344bd0db54c71be$var$getRootForUpdatedFiber(fiber);
}
function $2344bd0db54c71be$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $2344bd0db54c71be$var$enqueueUpdate$1(fiber, null, null, lane);
    return $2344bd0db54c71be$var$getRootForUpdatedFiber(fiber);
}
function $2344bd0db54c71be$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $2344bd0db54c71be$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $2344bd0db54c71be$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $2344bd0db54c71be$var$nestedUpdateCount) throw $2344bd0db54c71be$var$nestedUpdateCount = 0, $2344bd0db54c71be$var$rootWithNestedUpdates = null, Error($2344bd0db54c71be$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $2344bd0db54c71be$var$emptyContextObject = {};
function $2344bd0db54c71be$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2344bd0db54c71be$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $2344bd0db54c71be$var$FiberNode(tag, pendingProps, key, mode);
}
function $2344bd0db54c71be$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $2344bd0db54c71be$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $2344bd0db54c71be$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $2344bd0db54c71be$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $2344bd0db54c71be$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $2344bd0db54c71be$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $2344bd0db54c71be$var$isHostHoistableType(type, pendingProps, $2344bd0db54c71be$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $2344bd0db54c71be$var$REACT_ACTIVITY_TYPE:
            return type = $2344bd0db54c71be$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $2344bd0db54c71be$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $2344bd0db54c71be$var$REACT_FRAGMENT_TYPE:
            return $2344bd0db54c71be$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $2344bd0db54c71be$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $2344bd0db54c71be$var$REACT_PROFILER_TYPE:
            return type = $2344bd0db54c71be$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $2344bd0db54c71be$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $2344bd0db54c71be$var$REACT_SUSPENSE_TYPE:
            return type = $2344bd0db54c71be$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $2344bd0db54c71be$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $2344bd0db54c71be$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $2344bd0db54c71be$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $2344bd0db54c71be$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $2344bd0db54c71be$var$REACT_PROVIDER_TYPE:
                case $2344bd0db54c71be$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $2344bd0db54c71be$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $2344bd0db54c71be$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $2344bd0db54c71be$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $2344bd0db54c71be$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($2344bd0db54c71be$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $2344bd0db54c71be$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $2344bd0db54c71be$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $2344bd0db54c71be$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $2344bd0db54c71be$var$createFiberFromText(content, mode, lanes) {
    content = $2344bd0db54c71be$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $2344bd0db54c71be$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $2344bd0db54c71be$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $2344bd0db54c71be$var$forkStack = [], $2344bd0db54c71be$var$forkStackIndex = 0, $2344bd0db54c71be$var$treeForkProvider = null, $2344bd0db54c71be$var$treeForkCount = 0, $2344bd0db54c71be$var$idStack = [], $2344bd0db54c71be$var$idStackIndex = 0, $2344bd0db54c71be$var$treeContextProvider = null, $2344bd0db54c71be$var$treeContextId = 1, $2344bd0db54c71be$var$treeContextOverflow = "";
function $2344bd0db54c71be$var$pushTreeFork(workInProgress, totalChildren) {
    $2344bd0db54c71be$var$forkStack[$2344bd0db54c71be$var$forkStackIndex++] = $2344bd0db54c71be$var$treeForkCount;
    $2344bd0db54c71be$var$forkStack[$2344bd0db54c71be$var$forkStackIndex++] = $2344bd0db54c71be$var$treeForkProvider;
    $2344bd0db54c71be$var$treeForkProvider = workInProgress;
    $2344bd0db54c71be$var$treeForkCount = totalChildren;
}
function $2344bd0db54c71be$var$pushTreeId(workInProgress, totalChildren, index) {
    $2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex++] = $2344bd0db54c71be$var$treeContextId;
    $2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex++] = $2344bd0db54c71be$var$treeContextOverflow;
    $2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex++] = $2344bd0db54c71be$var$treeContextProvider;
    $2344bd0db54c71be$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $2344bd0db54c71be$var$treeContextId;
    workInProgress = $2344bd0db54c71be$var$treeContextOverflow;
    var baseLength = 32 - $2344bd0db54c71be$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $2344bd0db54c71be$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $2344bd0db54c71be$var$treeContextId = 1 << 32 - $2344bd0db54c71be$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $2344bd0db54c71be$var$treeContextOverflow = length + workInProgress;
    } else $2344bd0db54c71be$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $2344bd0db54c71be$var$treeContextOverflow = workInProgress;
}
function $2344bd0db54c71be$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($2344bd0db54c71be$var$pushTreeFork(workInProgress, 1), $2344bd0db54c71be$var$pushTreeId(workInProgress, 1, 0));
}
function $2344bd0db54c71be$var$popTreeContext(workInProgress) {
    for(; workInProgress === $2344bd0db54c71be$var$treeForkProvider;)$2344bd0db54c71be$var$treeForkProvider = $2344bd0db54c71be$var$forkStack[--$2344bd0db54c71be$var$forkStackIndex], $2344bd0db54c71be$var$forkStack[$2344bd0db54c71be$var$forkStackIndex] = null, $2344bd0db54c71be$var$treeForkCount = $2344bd0db54c71be$var$forkStack[--$2344bd0db54c71be$var$forkStackIndex], $2344bd0db54c71be$var$forkStack[$2344bd0db54c71be$var$forkStackIndex] = null;
    for(; workInProgress === $2344bd0db54c71be$var$treeContextProvider;)$2344bd0db54c71be$var$treeContextProvider = $2344bd0db54c71be$var$idStack[--$2344bd0db54c71be$var$idStackIndex], $2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex] = null, $2344bd0db54c71be$var$treeContextOverflow = $2344bd0db54c71be$var$idStack[--$2344bd0db54c71be$var$idStackIndex], $2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex] = null, $2344bd0db54c71be$var$treeContextId = $2344bd0db54c71be$var$idStack[--$2344bd0db54c71be$var$idStackIndex], $2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex] = null;
}
var $2344bd0db54c71be$var$hydrationParentFiber = null, $2344bd0db54c71be$var$nextHydratableInstance = null, $2344bd0db54c71be$var$isHydrating = !1, $2344bd0db54c71be$var$hydrationErrors = null, $2344bd0db54c71be$var$rootOrSingletonContext = !1, $2344bd0db54c71be$var$HydrationMismatchException = Error($2344bd0db54c71be$var$formatProdErrorMessage(519));
function $2344bd0db54c71be$var$throwOnHydrationMismatch(fiber) {
    var error = Error($2344bd0db54c71be$var$formatProdErrorMessage(418, ""));
    $2344bd0db54c71be$var$queueHydrationError($2344bd0db54c71be$var$createCapturedValueAtFiber(error, fiber));
    throw $2344bd0db54c71be$var$HydrationMismatchException;
}
function $2344bd0db54c71be$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$2344bd0db54c71be$var$internalInstanceKey] = fiber;
    instance[$2344bd0db54c71be$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("cancel", instance);
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $2344bd0db54c71be$var$mediaEventTypes.length; type++)$2344bd0db54c71be$var$listenToNonDelegatedEvent($2344bd0db54c71be$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("error", instance);
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("invalid", instance);
            $2344bd0db54c71be$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $2344bd0db54c71be$var$track(instance);
            break;
        case "select":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("invalid", instance), $2344bd0db54c71be$var$initTextarea(instance, props.value, props.defaultValue, props.children), $2344bd0db54c71be$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $2344bd0db54c71be$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($2344bd0db54c71be$var$listenToNonDelegatedEvent("beforetoggle", instance), $2344bd0db54c71be$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $2344bd0db54c71be$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $2344bd0db54c71be$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $2344bd0db54c71be$var$noop$1), instance = !0) : instance = !1;
    instance || $2344bd0db54c71be$var$throwOnHydrationMismatch(fiber);
}
function $2344bd0db54c71be$var$popToNextHostParent(fiber) {
    for($2344bd0db54c71be$var$hydrationParentFiber = fiber.return; $2344bd0db54c71be$var$hydrationParentFiber;)switch($2344bd0db54c71be$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $2344bd0db54c71be$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $2344bd0db54c71be$var$rootOrSingletonContext = !0;
            return;
        default:
            $2344bd0db54c71be$var$hydrationParentFiber = $2344bd0db54c71be$var$hydrationParentFiber.return;
    }
}
function $2344bd0db54c71be$var$popHydrationState(fiber) {
    if (fiber !== $2344bd0db54c71be$var$hydrationParentFiber) return !1;
    if (!$2344bd0db54c71be$var$isHydrating) return $2344bd0db54c71be$var$popToNextHostParent(fiber), $2344bd0db54c71be$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $2344bd0db54c71be$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $2344bd0db54c71be$var$nextHydratableInstance && $2344bd0db54c71be$var$throwOnHydrationMismatch(fiber);
    $2344bd0db54c71be$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $2344bd0db54c71be$var$nextHydratableInstance = $2344bd0db54c71be$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $2344bd0db54c71be$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $2344bd0db54c71be$var$nextHydratableInstance, $2344bd0db54c71be$var$isSingletonScope(fiber.type) ? (fiber = $2344bd0db54c71be$var$previousHydratableOnEnteringScopedSingleton, $2344bd0db54c71be$var$previousHydratableOnEnteringScopedSingleton = null, $2344bd0db54c71be$var$nextHydratableInstance = fiber) : $2344bd0db54c71be$var$nextHydratableInstance = tag) : $2344bd0db54c71be$var$nextHydratableInstance = $2344bd0db54c71be$var$hydrationParentFiber ? $2344bd0db54c71be$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $2344bd0db54c71be$var$resetHydrationState() {
    $2344bd0db54c71be$var$nextHydratableInstance = $2344bd0db54c71be$var$hydrationParentFiber = null;
    $2344bd0db54c71be$var$isHydrating = !1;
}
function $2344bd0db54c71be$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $2344bd0db54c71be$var$hydrationErrors;
    null !== queuedErrors && (null === $2344bd0db54c71be$var$workInProgressRootRecoverableErrors ? $2344bd0db54c71be$var$workInProgressRootRecoverableErrors = queuedErrors : $2344bd0db54c71be$var$workInProgressRootRecoverableErrors.push.apply($2344bd0db54c71be$var$workInProgressRootRecoverableErrors, queuedErrors), $2344bd0db54c71be$var$hydrationErrors = null);
    return queuedErrors;
}
function $2344bd0db54c71be$var$queueHydrationError(error) {
    null === $2344bd0db54c71be$var$hydrationErrors ? $2344bd0db54c71be$var$hydrationErrors = [
        error
    ] : $2344bd0db54c71be$var$hydrationErrors.push(error);
}
var $2344bd0db54c71be$var$valueCursor = $2344bd0db54c71be$var$createCursor(null), $2344bd0db54c71be$var$currentlyRenderingFiber$1 = null, $2344bd0db54c71be$var$lastContextDependency = null;
function $2344bd0db54c71be$var$pushProvider(providerFiber, context, nextValue) {
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $2344bd0db54c71be$var$popProvider(context) {
    context._currentValue = $2344bd0db54c71be$var$valueCursor.current;
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$valueCursor);
}
function $2344bd0db54c71be$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $2344bd0db54c71be$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $2344bd0db54c71be$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $2344bd0db54c71be$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $2344bd0db54c71be$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $2344bd0db54c71be$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $2344bd0db54c71be$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($2344bd0db54c71be$var$HostTransitionContext) : current = [
                $2344bd0db54c71be$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $2344bd0db54c71be$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $2344bd0db54c71be$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$2344bd0db54c71be$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $2344bd0db54c71be$var$prepareToReadContext(workInProgress) {
    $2344bd0db54c71be$var$currentlyRenderingFiber$1 = workInProgress;
    $2344bd0db54c71be$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $2344bd0db54c71be$var$readContext(context) {
    return $2344bd0db54c71be$var$readContextForConsumer($2344bd0db54c71be$var$currentlyRenderingFiber$1, context);
}
function $2344bd0db54c71be$var$readContextDuringReconciliation(consumer, context) {
    null === $2344bd0db54c71be$var$currentlyRenderingFiber$1 && $2344bd0db54c71be$var$prepareToReadContext(consumer);
    return $2344bd0db54c71be$var$readContextForConsumer(consumer, context);
}
function $2344bd0db54c71be$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $2344bd0db54c71be$var$lastContextDependency) {
        if (null === consumer) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(308));
        $2344bd0db54c71be$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $2344bd0db54c71be$var$lastContextDependency = $2344bd0db54c71be$var$lastContextDependency.next = context;
    return value;
}
var $2344bd0db54c71be$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $2344bd0db54c71be$var$scheduleCallback$2 = $5xrAo.unstable_scheduleCallback, $2344bd0db54c71be$var$NormalPriority = $5xrAo.unstable_NormalPriority, $2344bd0db54c71be$var$CacheContext = {
    $$typeof: $2344bd0db54c71be$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $2344bd0db54c71be$var$createCache() {
    return {
        controller: new $2344bd0db54c71be$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $2344bd0db54c71be$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $2344bd0db54c71be$var$scheduleCallback$2($2344bd0db54c71be$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $2344bd0db54c71be$var$currentEntangledListeners = null, $2344bd0db54c71be$var$currentEntangledPendingCount = 0, $2344bd0db54c71be$var$currentEntangledLane = 0, $2344bd0db54c71be$var$currentEntangledActionThenable = null;
function $2344bd0db54c71be$var$entangleAsyncAction(transition, thenable) {
    if (null === $2344bd0db54c71be$var$currentEntangledListeners) {
        var entangledListeners = $2344bd0db54c71be$var$currentEntangledListeners = [];
        $2344bd0db54c71be$var$currentEntangledPendingCount = 0;
        $2344bd0db54c71be$var$currentEntangledLane = $2344bd0db54c71be$var$requestTransitionLane();
        $2344bd0db54c71be$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $2344bd0db54c71be$var$currentEntangledPendingCount++;
    thenable.then($2344bd0db54c71be$var$pingEngtangledActionScope, $2344bd0db54c71be$var$pingEngtangledActionScope);
    return thenable;
}
function $2344bd0db54c71be$var$pingEngtangledActionScope() {
    if (0 === --$2344bd0db54c71be$var$currentEntangledPendingCount && null !== $2344bd0db54c71be$var$currentEntangledListeners) {
        null !== $2344bd0db54c71be$var$currentEntangledActionThenable && ($2344bd0db54c71be$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $2344bd0db54c71be$var$currentEntangledListeners;
        $2344bd0db54c71be$var$currentEntangledListeners = null;
        $2344bd0db54c71be$var$currentEntangledLane = 0;
        $2344bd0db54c71be$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $2344bd0db54c71be$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $2344bd0db54c71be$var$prevOnStartTransitionFinish = $2344bd0db54c71be$var$ReactSharedInternals.S;
$2344bd0db54c71be$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $2344bd0db54c71be$var$entangleAsyncAction(transition, returnValue);
    null !== $2344bd0db54c71be$var$prevOnStartTransitionFinish && $2344bd0db54c71be$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $2344bd0db54c71be$var$resumedCache = $2344bd0db54c71be$var$createCursor(null);
function $2344bd0db54c71be$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $2344bd0db54c71be$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $2344bd0db54c71be$var$workInProgressRoot.pooledCache;
}
function $2344bd0db54c71be$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $2344bd0db54c71be$var$push($2344bd0db54c71be$var$resumedCache, $2344bd0db54c71be$var$resumedCache.current) : $2344bd0db54c71be$var$push($2344bd0db54c71be$var$resumedCache, prevCachePool.pool);
}
function $2344bd0db54c71be$var$getSuspendedCache() {
    var cacheFromPool = $2344bd0db54c71be$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $2344bd0db54c71be$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $2344bd0db54c71be$var$SuspenseException = Error($2344bd0db54c71be$var$formatProdErrorMessage(460)), $2344bd0db54c71be$var$SuspenseyCommitException = Error($2344bd0db54c71be$var$formatProdErrorMessage(474)), $2344bd0db54c71be$var$SuspenseActionException = Error($2344bd0db54c71be$var$formatProdErrorMessage(542)), $2344bd0db54c71be$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $2344bd0db54c71be$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $2344bd0db54c71be$var$noop$3() {}
function $2344bd0db54c71be$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($2344bd0db54c71be$var$noop$3, $2344bd0db54c71be$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $2344bd0db54c71be$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($2344bd0db54c71be$var$noop$3, $2344bd0db54c71be$var$noop$3);
            else {
                thenableState = $2344bd0db54c71be$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $2344bd0db54c71be$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $2344bd0db54c71be$var$suspendedThenable = thenable;
            throw $2344bd0db54c71be$var$SuspenseException;
    }
}
var $2344bd0db54c71be$var$suspendedThenable = null;
function $2344bd0db54c71be$var$getSuspendedThenable() {
    if (null === $2344bd0db54c71be$var$suspendedThenable) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(459));
    var thenable = $2344bd0db54c71be$var$suspendedThenable;
    $2344bd0db54c71be$var$suspendedThenable = null;
    return thenable;
}
function $2344bd0db54c71be$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $2344bd0db54c71be$var$SuspenseException || rejectedReason === $2344bd0db54c71be$var$SuspenseActionException) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(483));
}
var $2344bd0db54c71be$var$hasForceUpdate = !1;
function $2344bd0db54c71be$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $2344bd0db54c71be$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $2344bd0db54c71be$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2344bd0db54c71be$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($2344bd0db54c71be$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $2344bd0db54c71be$var$getRootForUpdatedFiber(fiber);
        $2344bd0db54c71be$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $2344bd0db54c71be$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $2344bd0db54c71be$var$getRootForUpdatedFiber(fiber);
}
function $2344bd0db54c71be$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $2344bd0db54c71be$var$markRootEntangled(root, lane);
    }
}
function $2344bd0db54c71be$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $2344bd0db54c71be$var$didReadFromEntangledAsyncAction = !1;
function $2344bd0db54c71be$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($2344bd0db54c71be$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $2344bd0db54c71be$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $2344bd0db54c71be$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $2344bd0db54c71be$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $2344bd0db54c71be$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($2344bd0db54c71be$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $2344bd0db54c71be$var$currentEntangledLane && ($2344bd0db54c71be$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $2344bd0db54c71be$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $2344bd0db54c71be$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $2344bd0db54c71be$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $2344bd0db54c71be$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $2344bd0db54c71be$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$2344bd0db54c71be$var$callCallback(callbacks[updateQueue], context);
}
var $2344bd0db54c71be$var$currentTreeHiddenStackCursor = $2344bd0db54c71be$var$createCursor(null), $2344bd0db54c71be$var$prevEntangledRenderLanesCursor = $2344bd0db54c71be$var$createCursor(0);
function $2344bd0db54c71be$var$pushHiddenContext(fiber, context) {
    fiber = $2344bd0db54c71be$var$entangledRenderLanes;
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$prevEntangledRenderLanesCursor, fiber);
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$currentTreeHiddenStackCursor, context);
    $2344bd0db54c71be$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $2344bd0db54c71be$var$reuseHiddenContextOnStack() {
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$prevEntangledRenderLanesCursor, $2344bd0db54c71be$var$entangledRenderLanes);
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$currentTreeHiddenStackCursor, $2344bd0db54c71be$var$currentTreeHiddenStackCursor.current);
}
function $2344bd0db54c71be$var$popHiddenContext() {
    $2344bd0db54c71be$var$entangledRenderLanes = $2344bd0db54c71be$var$prevEntangledRenderLanesCursor.current;
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$currentTreeHiddenStackCursor);
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$prevEntangledRenderLanesCursor);
}
var $2344bd0db54c71be$var$renderLanes = 0, $2344bd0db54c71be$var$currentlyRenderingFiber = null, $2344bd0db54c71be$var$currentHook = null, $2344bd0db54c71be$var$workInProgressHook = null, $2344bd0db54c71be$var$didScheduleRenderPhaseUpdate = !1, $2344bd0db54c71be$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $2344bd0db54c71be$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $2344bd0db54c71be$var$localIdCounter = 0, $2344bd0db54c71be$var$thenableIndexCounter$1 = 0, $2344bd0db54c71be$var$thenableState$1 = null, $2344bd0db54c71be$var$globalClientIdCounter = 0;
function $2344bd0db54c71be$var$throwInvalidHookError() {
    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(321));
}
function $2344bd0db54c71be$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$2344bd0db54c71be$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $2344bd0db54c71be$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $2344bd0db54c71be$var$renderLanes = nextRenderLanes;
    $2344bd0db54c71be$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $2344bd0db54c71be$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $2344bd0db54c71be$var$HooksDispatcherOnMount : $2344bd0db54c71be$var$HooksDispatcherOnUpdate;
    $2344bd0db54c71be$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $2344bd0db54c71be$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $2344bd0db54c71be$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $2344bd0db54c71be$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $2344bd0db54c71be$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $2344bd0db54c71be$var$finishRenderingHooks(current) {
    $2344bd0db54c71be$var$ReactSharedInternals.H = $2344bd0db54c71be$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $2344bd0db54c71be$var$currentHook && null !== $2344bd0db54c71be$var$currentHook.next;
    $2344bd0db54c71be$var$renderLanes = 0;
    $2344bd0db54c71be$var$workInProgressHook = $2344bd0db54c71be$var$currentHook = $2344bd0db54c71be$var$currentlyRenderingFiber = null;
    $2344bd0db54c71be$var$didScheduleRenderPhaseUpdate = !1;
    $2344bd0db54c71be$var$thenableIndexCounter$1 = 0;
    $2344bd0db54c71be$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(300));
    null === current || $2344bd0db54c71be$var$didReceiveUpdate || (current = current.dependencies, null !== current && $2344bd0db54c71be$var$checkIfContextChanged(current) && ($2344bd0db54c71be$var$didReceiveUpdate = !0));
}
function $2344bd0db54c71be$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $2344bd0db54c71be$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $2344bd0db54c71be$var$didScheduleRenderPhaseUpdateDuringThisPass && ($2344bd0db54c71be$var$thenableState$1 = null);
        $2344bd0db54c71be$var$thenableIndexCounter$1 = 0;
        $2344bd0db54c71be$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $2344bd0db54c71be$var$workInProgressHook = $2344bd0db54c71be$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $2344bd0db54c71be$var$ReactSharedInternals.H = $2344bd0db54c71be$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($2344bd0db54c71be$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $2344bd0db54c71be$var$TransitionAwareHostComponent() {
    var dispatcher = $2344bd0db54c71be$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $2344bd0db54c71be$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $2344bd0db54c71be$var$currentHook ? $2344bd0db54c71be$var$currentHook.memoizedState : null) !== dispatcher && ($2344bd0db54c71be$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $2344bd0db54c71be$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $2344bd0db54c71be$var$localIdCounter;
    $2344bd0db54c71be$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $2344bd0db54c71be$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $2344bd0db54c71be$var$resetHooksOnUnwind(workInProgress) {
    if ($2344bd0db54c71be$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $2344bd0db54c71be$var$didScheduleRenderPhaseUpdate = !1;
    }
    $2344bd0db54c71be$var$renderLanes = 0;
    $2344bd0db54c71be$var$workInProgressHook = $2344bd0db54c71be$var$currentHook = $2344bd0db54c71be$var$currentlyRenderingFiber = null;
    $2344bd0db54c71be$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $2344bd0db54c71be$var$thenableIndexCounter$1 = $2344bd0db54c71be$var$localIdCounter = 0;
    $2344bd0db54c71be$var$thenableState$1 = null;
}
function $2344bd0db54c71be$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2344bd0db54c71be$var$workInProgressHook ? $2344bd0db54c71be$var$currentlyRenderingFiber.memoizedState = $2344bd0db54c71be$var$workInProgressHook = hook : $2344bd0db54c71be$var$workInProgressHook = $2344bd0db54c71be$var$workInProgressHook.next = hook;
    return $2344bd0db54c71be$var$workInProgressHook;
}
function $2344bd0db54c71be$var$updateWorkInProgressHook() {
    if (null === $2344bd0db54c71be$var$currentHook) {
        var nextCurrentHook = $2344bd0db54c71be$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $2344bd0db54c71be$var$currentHook.next;
    var nextWorkInProgressHook = null === $2344bd0db54c71be$var$workInProgressHook ? $2344bd0db54c71be$var$currentlyRenderingFiber.memoizedState : $2344bd0db54c71be$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $2344bd0db54c71be$var$workInProgressHook = nextWorkInProgressHook, $2344bd0db54c71be$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $2344bd0db54c71be$var$currentlyRenderingFiber.alternate) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(467));
            throw Error($2344bd0db54c71be$var$formatProdErrorMessage(310));
        }
        $2344bd0db54c71be$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $2344bd0db54c71be$var$currentHook.memoizedState,
            baseState: $2344bd0db54c71be$var$currentHook.baseState,
            baseQueue: $2344bd0db54c71be$var$currentHook.baseQueue,
            queue: $2344bd0db54c71be$var$currentHook.queue,
            next: null
        };
        null === $2344bd0db54c71be$var$workInProgressHook ? $2344bd0db54c71be$var$currentlyRenderingFiber.memoizedState = $2344bd0db54c71be$var$workInProgressHook = nextCurrentHook : $2344bd0db54c71be$var$workInProgressHook = $2344bd0db54c71be$var$workInProgressHook.next = nextCurrentHook;
    }
    return $2344bd0db54c71be$var$workInProgressHook;
}
function $2344bd0db54c71be$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $2344bd0db54c71be$var$useThenable(thenable) {
    var index = $2344bd0db54c71be$var$thenableIndexCounter$1;
    $2344bd0db54c71be$var$thenableIndexCounter$1 += 1;
    null === $2344bd0db54c71be$var$thenableState$1 && ($2344bd0db54c71be$var$thenableState$1 = []);
    thenable = $2344bd0db54c71be$var$trackUsedThenable($2344bd0db54c71be$var$thenableState$1, thenable, index);
    index = $2344bd0db54c71be$var$currentlyRenderingFiber;
    null === (null === $2344bd0db54c71be$var$workInProgressHook ? index.memoizedState : $2344bd0db54c71be$var$workInProgressHook.next) && (index = index.alternate, $2344bd0db54c71be$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $2344bd0db54c71be$var$HooksDispatcherOnMount : $2344bd0db54c71be$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $2344bd0db54c71be$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $2344bd0db54c71be$var$useThenable(usable);
        if (usable.$$typeof === $2344bd0db54c71be$var$REACT_CONTEXT_TYPE) return $2344bd0db54c71be$var$readContext(usable);
    }
    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(438, String(usable)));
}
function $2344bd0db54c71be$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $2344bd0db54c71be$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $2344bd0db54c71be$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $2344bd0db54c71be$var$createFunctionComponentUpdateQueue(), $2344bd0db54c71be$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $2344bd0db54c71be$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $2344bd0db54c71be$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $2344bd0db54c71be$var$updateReducer(reducer) {
    var hook = $2344bd0db54c71be$var$updateWorkInProgressHook();
    return $2344bd0db54c71be$var$updateReducerImpl(hook, $2344bd0db54c71be$var$currentHook, reducer);
}
function $2344bd0db54c71be$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($2344bd0db54c71be$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($2344bd0db54c71be$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $2344bd0db54c71be$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($2344bd0db54c71be$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $2344bd0db54c71be$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $2344bd0db54c71be$var$currentlyRenderingFiber.lanes |= revertLane, $2344bd0db54c71be$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $2344bd0db54c71be$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $2344bd0db54c71be$var$currentlyRenderingFiber.lanes |= updateLane, $2344bd0db54c71be$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$2344bd0db54c71be$var$objectIs(pendingQueue, hook.memoizedState) && ($2344bd0db54c71be$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $2344bd0db54c71be$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $2344bd0db54c71be$var$rerenderReducer(reducer) {
    var hook = $2344bd0db54c71be$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $2344bd0db54c71be$var$objectIs(newState, hook.memoizedState) || ($2344bd0db54c71be$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $2344bd0db54c71be$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $2344bd0db54c71be$var$currentlyRenderingFiber, hook = $2344bd0db54c71be$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $2344bd0db54c71be$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$2344bd0db54c71be$var$objectIs(($2344bd0db54c71be$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $2344bd0db54c71be$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $2344bd0db54c71be$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $2344bd0db54c71be$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $2344bd0db54c71be$var$workInProgressHook && $2344bd0db54c71be$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $2344bd0db54c71be$var$pushSimpleEffect(9, $2344bd0db54c71be$var$createEffectInstance(), $2344bd0db54c71be$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $2344bd0db54c71be$var$workInProgressRoot) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($2344bd0db54c71be$var$renderLanes & 124) || $2344bd0db54c71be$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $2344bd0db54c71be$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $2344bd0db54c71be$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $2344bd0db54c71be$var$createFunctionComponentUpdateQueue(), $2344bd0db54c71be$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $2344bd0db54c71be$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $2344bd0db54c71be$var$checkIfSnapshotChanged(inst) && $2344bd0db54c71be$var$forceStoreRerender(fiber);
}
function $2344bd0db54c71be$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $2344bd0db54c71be$var$checkIfSnapshotChanged(inst) && $2344bd0db54c71be$var$forceStoreRerender(fiber);
    });
}
function $2344bd0db54c71be$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2344bd0db54c71be$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2344bd0db54c71be$var$forceStoreRerender(fiber) {
    var root = $2344bd0db54c71be$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $2344bd0db54c71be$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $2344bd0db54c71be$var$mountStateImpl(initialState) {
    var hook = $2344bd0db54c71be$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($2344bd0db54c71be$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2344bd0db54c71be$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $2344bd0db54c71be$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2344bd0db54c71be$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $2344bd0db54c71be$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $2344bd0db54c71be$var$updateReducerImpl(hook, $2344bd0db54c71be$var$currentHook, "function" === typeof reducer ? reducer : $2344bd0db54c71be$var$basicStateReducer);
}
function $2344bd0db54c71be$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($2344bd0db54c71be$var$isRenderPhaseUpdate(fiber)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $2344bd0db54c71be$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $2344bd0db54c71be$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $2344bd0db54c71be$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $2344bd0db54c71be$var$ReactSharedInternals.T, currentTransition = {};
        $2344bd0db54c71be$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $2344bd0db54c71be$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $2344bd0db54c71be$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $2344bd0db54c71be$var$onActionError(actionQueue, node, error);
        } finally{
            $2344bd0db54c71be$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $2344bd0db54c71be$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $2344bd0db54c71be$var$onActionError(actionQueue, node, error$38);
    }
}
function $2344bd0db54c71be$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $2344bd0db54c71be$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $2344bd0db54c71be$var$onActionError(actionQueue, node, error);
    }) : $2344bd0db54c71be$var$onActionSuccess(actionQueue, node, returnValue);
}
function $2344bd0db54c71be$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $2344bd0db54c71be$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $2344bd0db54c71be$var$runActionStateAction(actionQueue, nextState)));
}
function $2344bd0db54c71be$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $2344bd0db54c71be$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $2344bd0db54c71be$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $2344bd0db54c71be$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $2344bd0db54c71be$var$mountActionState(action, initialStateProp) {
    if ($2344bd0db54c71be$var$isHydrating) {
        var ssrFormState = $2344bd0db54c71be$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $2344bd0db54c71be$var$currentlyRenderingFiber;
                if ($2344bd0db54c71be$var$isHydrating) {
                    if ($2344bd0db54c71be$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $2344bd0db54c71be$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $2344bd0db54c71be$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $2344bd0db54c71be$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $2344bd0db54c71be$var$nextHydratableInstance = $2344bd0db54c71be$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $2344bd0db54c71be$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $2344bd0db54c71be$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2344bd0db54c71be$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $2344bd0db54c71be$var$dispatchSetState.bind(null, $2344bd0db54c71be$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $2344bd0db54c71be$var$mountStateImpl(!1);
    inRootOrSingleton = $2344bd0db54c71be$var$dispatchOptimisticSetState.bind(null, $2344bd0db54c71be$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $2344bd0db54c71be$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $2344bd0db54c71be$var$dispatchActionState.bind(null, $2344bd0db54c71be$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $2344bd0db54c71be$var$updateActionState(action) {
    var stateHook = $2344bd0db54c71be$var$updateWorkInProgressHook();
    return $2344bd0db54c71be$var$updateActionStateImpl(stateHook, $2344bd0db54c71be$var$currentHook, action);
}
function $2344bd0db54c71be$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $2344bd0db54c71be$var$updateReducerImpl(stateHook, currentStateHook, $2344bd0db54c71be$var$actionStateReducer)[0];
    stateHook = $2344bd0db54c71be$var$updateReducer($2344bd0db54c71be$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $2344bd0db54c71be$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $2344bd0db54c71be$var$SuspenseException) throw $2344bd0db54c71be$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $2344bd0db54c71be$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($2344bd0db54c71be$var$currentlyRenderingFiber.flags |= 2048, $2344bd0db54c71be$var$pushSimpleEffect(9, $2344bd0db54c71be$var$createEffectInstance(), $2344bd0db54c71be$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $2344bd0db54c71be$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $2344bd0db54c71be$var$rerenderActionState(action) {
    var stateHook = $2344bd0db54c71be$var$updateWorkInProgressHook(), currentStateHook = $2344bd0db54c71be$var$currentHook;
    if (null !== currentStateHook) return $2344bd0db54c71be$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $2344bd0db54c71be$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $2344bd0db54c71be$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $2344bd0db54c71be$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $2344bd0db54c71be$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $2344bd0db54c71be$var$createFunctionComponentUpdateQueue(), $2344bd0db54c71be$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $2344bd0db54c71be$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $2344bd0db54c71be$var$updateRef() {
    return $2344bd0db54c71be$var$updateWorkInProgressHook().memoizedState;
}
function $2344bd0db54c71be$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $2344bd0db54c71be$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $2344bd0db54c71be$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $2344bd0db54c71be$var$pushSimpleEffect(1 | hookFlags, $2344bd0db54c71be$var$createEffectInstance(), create, createDeps);
}
function $2344bd0db54c71be$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $2344bd0db54c71be$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $2344bd0db54c71be$var$currentHook && null !== deps && $2344bd0db54c71be$var$areHookInputsEqual(deps, $2344bd0db54c71be$var$currentHook.memoizedState.deps) ? hook.memoizedState = $2344bd0db54c71be$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($2344bd0db54c71be$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $2344bd0db54c71be$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $2344bd0db54c71be$var$mountEffect(create, createDeps) {
    $2344bd0db54c71be$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $2344bd0db54c71be$var$updateEffect(create, createDeps) {
    $2344bd0db54c71be$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $2344bd0db54c71be$var$updateInsertionEffect(create, deps) {
    return $2344bd0db54c71be$var$updateEffectImpl(4, 2, create, deps);
}
function $2344bd0db54c71be$var$updateLayoutEffect(create, deps) {
    return $2344bd0db54c71be$var$updateEffectImpl(4, 4, create, deps);
}
function $2344bd0db54c71be$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $2344bd0db54c71be$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $2344bd0db54c71be$var$updateEffectImpl(4, 4, $2344bd0db54c71be$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $2344bd0db54c71be$var$mountDebugValue() {}
function $2344bd0db54c71be$var$updateCallback(callback, deps) {
    var hook = $2344bd0db54c71be$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2344bd0db54c71be$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $2344bd0db54c71be$var$updateMemo(nextCreate, deps) {
    var hook = $2344bd0db54c71be$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2344bd0db54c71be$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($2344bd0db54c71be$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $2344bd0db54c71be$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $2344bd0db54c71be$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $2344bd0db54c71be$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($2344bd0db54c71be$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $2344bd0db54c71be$var$requestDeferredLane();
    $2344bd0db54c71be$var$currentlyRenderingFiber.lanes |= hook;
    $2344bd0db54c71be$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $2344bd0db54c71be$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($2344bd0db54c71be$var$objectIs(value, prevValue)) return value;
    if (null !== $2344bd0db54c71be$var$currentTreeHiddenStackCursor.current) return hook = $2344bd0db54c71be$var$mountDeferredValueImpl(hook, value, initialValue), $2344bd0db54c71be$var$objectIs(hook, prevValue) || ($2344bd0db54c71be$var$didReceiveUpdate = !0), hook;
    if (0 === ($2344bd0db54c71be$var$renderLanes & 42)) return $2344bd0db54c71be$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $2344bd0db54c71be$var$requestDeferredLane();
    $2344bd0db54c71be$var$currentlyRenderingFiber.lanes |= hook;
    $2344bd0db54c71be$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $2344bd0db54c71be$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
    $2344bd0db54c71be$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $2344bd0db54c71be$var$ReactSharedInternals.T, currentTransition = {};
    $2344bd0db54c71be$var$ReactSharedInternals.T = currentTransition;
    $2344bd0db54c71be$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $2344bd0db54c71be$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $2344bd0db54c71be$var$chainThenableValue(returnValue, finishedState);
            $2344bd0db54c71be$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $2344bd0db54c71be$var$requestUpdateLane(fiber));
        } else $2344bd0db54c71be$var$dispatchSetStateInternal(fiber, queue, finishedState, $2344bd0db54c71be$var$requestUpdateLane(fiber));
    } catch (error) {
        $2344bd0db54c71be$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $2344bd0db54c71be$var$requestUpdateLane());
    } finally{
        $2344bd0db54c71be$var$ReactDOMSharedInternals.p = previousPriority, $2344bd0db54c71be$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2344bd0db54c71be$var$noop$2() {}
function $2344bd0db54c71be$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(476));
    var queue = $2344bd0db54c71be$var$ensureFormComponentIsStateful(formFiber).queue;
    $2344bd0db54c71be$var$startTransition(formFiber, queue, pendingState, $2344bd0db54c71be$var$sharedNotPendingObject, null === action ? $2344bd0db54c71be$var$noop$2 : function() {
        $2344bd0db54c71be$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $2344bd0db54c71be$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $2344bd0db54c71be$var$sharedNotPendingObject,
        baseState: $2344bd0db54c71be$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2344bd0db54c71be$var$basicStateReducer,
            lastRenderedState: $2344bd0db54c71be$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2344bd0db54c71be$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $2344bd0db54c71be$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $2344bd0db54c71be$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $2344bd0db54c71be$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $2344bd0db54c71be$var$requestUpdateLane());
}
function $2344bd0db54c71be$var$useHostTransitionStatus() {
    return $2344bd0db54c71be$var$readContext($2344bd0db54c71be$var$HostTransitionContext);
}
function $2344bd0db54c71be$var$updateId() {
    return $2344bd0db54c71be$var$updateWorkInProgressHook().memoizedState;
}
function $2344bd0db54c71be$var$updateRefresh() {
    return $2344bd0db54c71be$var$updateWorkInProgressHook().memoizedState;
}
function $2344bd0db54c71be$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $2344bd0db54c71be$var$requestUpdateLane();
                fiber = $2344bd0db54c71be$var$createUpdate(lane);
                var root$41 = $2344bd0db54c71be$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($2344bd0db54c71be$var$scheduleUpdateOnFiber(root$41, provider, lane), $2344bd0db54c71be$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $2344bd0db54c71be$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $2344bd0db54c71be$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $2344bd0db54c71be$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $2344bd0db54c71be$var$isRenderPhaseUpdate(fiber) ? $2344bd0db54c71be$var$enqueueRenderPhaseUpdate(queue, action) : (action = $2344bd0db54c71be$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($2344bd0db54c71be$var$scheduleUpdateOnFiber(action, fiber, lane), $2344bd0db54c71be$var$entangleTransitionUpdate(action, queue, lane)));
}
function $2344bd0db54c71be$var$dispatchSetState(fiber, queue, action) {
    var lane = $2344bd0db54c71be$var$requestUpdateLane();
    $2344bd0db54c71be$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $2344bd0db54c71be$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2344bd0db54c71be$var$isRenderPhaseUpdate(fiber)) $2344bd0db54c71be$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($2344bd0db54c71be$var$objectIs(eagerState, currentState)) return $2344bd0db54c71be$var$enqueueUpdate$1(fiber, queue, update, 0), null === $2344bd0db54c71be$var$workInProgressRoot && $2344bd0db54c71be$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $2344bd0db54c71be$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $2344bd0db54c71be$var$scheduleUpdateOnFiber(action, fiber, lane), $2344bd0db54c71be$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $2344bd0db54c71be$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $2344bd0db54c71be$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2344bd0db54c71be$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $2344bd0db54c71be$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $2344bd0db54c71be$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $2344bd0db54c71be$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $2344bd0db54c71be$var$currentlyRenderingFiber || null !== alternate && alternate === $2344bd0db54c71be$var$currentlyRenderingFiber;
}
function $2344bd0db54c71be$var$enqueueRenderPhaseUpdate(queue, update) {
    $2344bd0db54c71be$var$didScheduleRenderPhaseUpdateDuringThisPass = $2344bd0db54c71be$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $2344bd0db54c71be$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $2344bd0db54c71be$var$markRootEntangled(root, lane);
    }
}
var $2344bd0db54c71be$var$ContextOnlyDispatcher = {
    readContext: $2344bd0db54c71be$var$readContext,
    use: $2344bd0db54c71be$var$use,
    useCallback: $2344bd0db54c71be$var$throwInvalidHookError,
    useContext: $2344bd0db54c71be$var$throwInvalidHookError,
    useEffect: $2344bd0db54c71be$var$throwInvalidHookError,
    useImperativeHandle: $2344bd0db54c71be$var$throwInvalidHookError,
    useLayoutEffect: $2344bd0db54c71be$var$throwInvalidHookError,
    useInsertionEffect: $2344bd0db54c71be$var$throwInvalidHookError,
    useMemo: $2344bd0db54c71be$var$throwInvalidHookError,
    useReducer: $2344bd0db54c71be$var$throwInvalidHookError,
    useRef: $2344bd0db54c71be$var$throwInvalidHookError,
    useState: $2344bd0db54c71be$var$throwInvalidHookError,
    useDebugValue: $2344bd0db54c71be$var$throwInvalidHookError,
    useDeferredValue: $2344bd0db54c71be$var$throwInvalidHookError,
    useTransition: $2344bd0db54c71be$var$throwInvalidHookError,
    useSyncExternalStore: $2344bd0db54c71be$var$throwInvalidHookError,
    useId: $2344bd0db54c71be$var$throwInvalidHookError,
    useHostTransitionStatus: $2344bd0db54c71be$var$throwInvalidHookError,
    useFormState: $2344bd0db54c71be$var$throwInvalidHookError,
    useActionState: $2344bd0db54c71be$var$throwInvalidHookError,
    useOptimistic: $2344bd0db54c71be$var$throwInvalidHookError,
    useMemoCache: $2344bd0db54c71be$var$throwInvalidHookError,
    useCacheRefresh: $2344bd0db54c71be$var$throwInvalidHookError
}, $2344bd0db54c71be$var$HooksDispatcherOnMount = {
    readContext: $2344bd0db54c71be$var$readContext,
    use: $2344bd0db54c71be$var$use,
    useCallback: function(callback, deps) {
        $2344bd0db54c71be$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $2344bd0db54c71be$var$readContext,
    useEffect: $2344bd0db54c71be$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $2344bd0db54c71be$var$mountEffectImpl(4194308, 4, $2344bd0db54c71be$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $2344bd0db54c71be$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $2344bd0db54c71be$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $2344bd0db54c71be$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($2344bd0db54c71be$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2344bd0db54c71be$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $2344bd0db54c71be$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $2344bd0db54c71be$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($2344bd0db54c71be$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $2344bd0db54c71be$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $2344bd0db54c71be$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $2344bd0db54c71be$var$dispatchReducerAction.bind(null, $2344bd0db54c71be$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $2344bd0db54c71be$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $2344bd0db54c71be$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $2344bd0db54c71be$var$dispatchSetState.bind(null, $2344bd0db54c71be$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $2344bd0db54c71be$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2344bd0db54c71be$var$mountWorkInProgressHook();
        return $2344bd0db54c71be$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $2344bd0db54c71be$var$mountStateImpl(!1);
        stateHook = $2344bd0db54c71be$var$startTransition.bind(null, $2344bd0db54c71be$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $2344bd0db54c71be$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $2344bd0db54c71be$var$currentlyRenderingFiber, hook = $2344bd0db54c71be$var$mountWorkInProgressHook();
        if ($2344bd0db54c71be$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $2344bd0db54c71be$var$workInProgressRoot) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(349));
            0 !== ($2344bd0db54c71be$var$workInProgressRootRenderLanes & 124) || $2344bd0db54c71be$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $2344bd0db54c71be$var$mountEffect($2344bd0db54c71be$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $2344bd0db54c71be$var$pushSimpleEffect(9, $2344bd0db54c71be$var$createEffectInstance(), $2344bd0db54c71be$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $2344bd0db54c71be$var$mountWorkInProgressHook(), identifierPrefix = $2344bd0db54c71be$var$workInProgressRoot.identifierPrefix;
        if ($2344bd0db54c71be$var$isHydrating) {
            var JSCompiler_inline_result = $2344bd0db54c71be$var$treeContextOverflow;
            var idWithLeadingBit = $2344bd0db54c71be$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $2344bd0db54c71be$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $2344bd0db54c71be$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $2344bd0db54c71be$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $2344bd0db54c71be$var$useHostTransitionStatus,
    useFormState: $2344bd0db54c71be$var$mountActionState,
    useActionState: $2344bd0db54c71be$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $2344bd0db54c71be$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $2344bd0db54c71be$var$dispatchOptimisticSetState.bind(null, $2344bd0db54c71be$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $2344bd0db54c71be$var$useMemoCache,
    useCacheRefresh: function() {
        return $2344bd0db54c71be$var$mountWorkInProgressHook().memoizedState = $2344bd0db54c71be$var$refreshCache.bind(null, $2344bd0db54c71be$var$currentlyRenderingFiber);
    }
}, $2344bd0db54c71be$var$HooksDispatcherOnUpdate = {
    readContext: $2344bd0db54c71be$var$readContext,
    use: $2344bd0db54c71be$var$use,
    useCallback: $2344bd0db54c71be$var$updateCallback,
    useContext: $2344bd0db54c71be$var$readContext,
    useEffect: $2344bd0db54c71be$var$updateEffect,
    useImperativeHandle: $2344bd0db54c71be$var$updateImperativeHandle,
    useInsertionEffect: $2344bd0db54c71be$var$updateInsertionEffect,
    useLayoutEffect: $2344bd0db54c71be$var$updateLayoutEffect,
    useMemo: $2344bd0db54c71be$var$updateMemo,
    useReducer: $2344bd0db54c71be$var$updateReducer,
    useRef: $2344bd0db54c71be$var$updateRef,
    useState: function() {
        return $2344bd0db54c71be$var$updateReducer($2344bd0db54c71be$var$basicStateReducer);
    },
    useDebugValue: $2344bd0db54c71be$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2344bd0db54c71be$var$updateWorkInProgressHook();
        return $2344bd0db54c71be$var$updateDeferredValueImpl(hook, $2344bd0db54c71be$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $2344bd0db54c71be$var$updateReducer($2344bd0db54c71be$var$basicStateReducer)[0], start = $2344bd0db54c71be$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2344bd0db54c71be$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2344bd0db54c71be$var$updateSyncExternalStore,
    useId: $2344bd0db54c71be$var$updateId,
    useHostTransitionStatus: $2344bd0db54c71be$var$useHostTransitionStatus,
    useFormState: $2344bd0db54c71be$var$updateActionState,
    useActionState: $2344bd0db54c71be$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $2344bd0db54c71be$var$updateWorkInProgressHook();
        return $2344bd0db54c71be$var$updateOptimisticImpl(hook, $2344bd0db54c71be$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $2344bd0db54c71be$var$useMemoCache,
    useCacheRefresh: $2344bd0db54c71be$var$updateRefresh
}, $2344bd0db54c71be$var$HooksDispatcherOnRerender = {
    readContext: $2344bd0db54c71be$var$readContext,
    use: $2344bd0db54c71be$var$use,
    useCallback: $2344bd0db54c71be$var$updateCallback,
    useContext: $2344bd0db54c71be$var$readContext,
    useEffect: $2344bd0db54c71be$var$updateEffect,
    useImperativeHandle: $2344bd0db54c71be$var$updateImperativeHandle,
    useInsertionEffect: $2344bd0db54c71be$var$updateInsertionEffect,
    useLayoutEffect: $2344bd0db54c71be$var$updateLayoutEffect,
    useMemo: $2344bd0db54c71be$var$updateMemo,
    useReducer: $2344bd0db54c71be$var$rerenderReducer,
    useRef: $2344bd0db54c71be$var$updateRef,
    useState: function() {
        return $2344bd0db54c71be$var$rerenderReducer($2344bd0db54c71be$var$basicStateReducer);
    },
    useDebugValue: $2344bd0db54c71be$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2344bd0db54c71be$var$updateWorkInProgressHook();
        return null === $2344bd0db54c71be$var$currentHook ? $2344bd0db54c71be$var$mountDeferredValueImpl(hook, value, initialValue) : $2344bd0db54c71be$var$updateDeferredValueImpl(hook, $2344bd0db54c71be$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $2344bd0db54c71be$var$rerenderReducer($2344bd0db54c71be$var$basicStateReducer)[0], start = $2344bd0db54c71be$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2344bd0db54c71be$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2344bd0db54c71be$var$updateSyncExternalStore,
    useId: $2344bd0db54c71be$var$updateId,
    useHostTransitionStatus: $2344bd0db54c71be$var$useHostTransitionStatus,
    useFormState: $2344bd0db54c71be$var$rerenderActionState,
    useActionState: $2344bd0db54c71be$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $2344bd0db54c71be$var$updateWorkInProgressHook();
        if (null !== $2344bd0db54c71be$var$currentHook) return $2344bd0db54c71be$var$updateOptimisticImpl(hook, $2344bd0db54c71be$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $2344bd0db54c71be$var$useMemoCache,
    useCacheRefresh: $2344bd0db54c71be$var$updateRefresh
}, $2344bd0db54c71be$var$thenableState = null, $2344bd0db54c71be$var$thenableIndexCounter = 0;
function $2344bd0db54c71be$var$unwrapThenable(thenable) {
    var index = $2344bd0db54c71be$var$thenableIndexCounter;
    $2344bd0db54c71be$var$thenableIndexCounter += 1;
    null === $2344bd0db54c71be$var$thenableState && ($2344bd0db54c71be$var$thenableState = []);
    return $2344bd0db54c71be$var$trackUsedThenable($2344bd0db54c71be$var$thenableState, thenable, index);
}
function $2344bd0db54c71be$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $2344bd0db54c71be$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $2344bd0db54c71be$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $2344bd0db54c71be$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $2344bd0db54c71be$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $2344bd0db54c71be$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $2344bd0db54c71be$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $2344bd0db54c71be$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $2344bd0db54c71be$var$REACT_LAZY_TYPE && $2344bd0db54c71be$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $2344bd0db54c71be$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $2344bd0db54c71be$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $2344bd0db54c71be$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $2344bd0db54c71be$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $2344bd0db54c71be$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $2344bd0db54c71be$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2344bd0db54c71be$var$REACT_ELEMENT_TYPE:
                    return lanes = $2344bd0db54c71be$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2344bd0db54c71be$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $2344bd0db54c71be$var$REACT_PORTAL_TYPE:
                    return newChild = $2344bd0db54c71be$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $2344bd0db54c71be$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($2344bd0db54c71be$var$isArrayImpl(newChild) || $2344bd0db54c71be$var$getIteratorFn(newChild)) return newChild = $2344bd0db54c71be$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $2344bd0db54c71be$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2344bd0db54c71be$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $2344bd0db54c71be$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2344bd0db54c71be$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2344bd0db54c71be$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $2344bd0db54c71be$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $2344bd0db54c71be$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($2344bd0db54c71be$var$isArrayImpl(newChild) || $2344bd0db54c71be$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $2344bd0db54c71be$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2344bd0db54c71be$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $2344bd0db54c71be$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2344bd0db54c71be$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2344bd0db54c71be$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $2344bd0db54c71be$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $2344bd0db54c71be$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($2344bd0db54c71be$var$isArrayImpl(newChild) || $2344bd0db54c71be$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $2344bd0db54c71be$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2344bd0db54c71be$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $2344bd0db54c71be$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2344bd0db54c71be$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $2344bd0db54c71be$var$isHydrating && $2344bd0db54c71be$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $2344bd0db54c71be$var$isHydrating && $2344bd0db54c71be$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2344bd0db54c71be$var$isHydrating && $2344bd0db54c71be$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $2344bd0db54c71be$var$isHydrating && $2344bd0db54c71be$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $2344bd0db54c71be$var$isHydrating && $2344bd0db54c71be$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2344bd0db54c71be$var$isHydrating && $2344bd0db54c71be$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $2344bd0db54c71be$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2344bd0db54c71be$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $2344bd0db54c71be$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $2344bd0db54c71be$var$REACT_LAZY_TYPE && $2344bd0db54c71be$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $2344bd0db54c71be$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $2344bd0db54c71be$var$REACT_FRAGMENT_TYPE ? (lanes = $2344bd0db54c71be$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $2344bd0db54c71be$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2344bd0db54c71be$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $2344bd0db54c71be$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $2344bd0db54c71be$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $2344bd0db54c71be$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($2344bd0db54c71be$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($2344bd0db54c71be$var$getIteratorFn(newChild)) {
                key = $2344bd0db54c71be$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2344bd0db54c71be$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2344bd0db54c71be$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2344bd0db54c71be$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2344bd0db54c71be$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $2344bd0db54c71be$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $2344bd0db54c71be$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $2344bd0db54c71be$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $2344bd0db54c71be$var$SuspenseException || x === $2344bd0db54c71be$var$SuspenseActionException) throw x;
            var fiber = $2344bd0db54c71be$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $2344bd0db54c71be$var$reconcileChildFibers = $2344bd0db54c71be$var$createChildReconciler(!0), $2344bd0db54c71be$var$mountChildFibers = $2344bd0db54c71be$var$createChildReconciler(!1), $2344bd0db54c71be$var$suspenseHandlerStackCursor = $2344bd0db54c71be$var$createCursor(null), $2344bd0db54c71be$var$shellBoundary = null;
function $2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseStackCursor, $2344bd0db54c71be$var$suspenseStackCursor.current & 1);
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseHandlerStackCursor, handler);
    null === $2344bd0db54c71be$var$shellBoundary && (null === current || null !== $2344bd0db54c71be$var$currentTreeHiddenStackCursor.current ? $2344bd0db54c71be$var$shellBoundary = handler : null !== current.memoizedState && ($2344bd0db54c71be$var$shellBoundary = handler));
}
function $2344bd0db54c71be$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseStackCursor, $2344bd0db54c71be$var$suspenseStackCursor.current), $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseHandlerStackCursor, fiber), null === $2344bd0db54c71be$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($2344bd0db54c71be$var$shellBoundary = fiber);
        }
    } else $2344bd0db54c71be$var$reuseSuspenseHandlerOnStack(fiber);
}
function $2344bd0db54c71be$var$reuseSuspenseHandlerOnStack() {
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseStackCursor, $2344bd0db54c71be$var$suspenseStackCursor.current);
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseHandlerStackCursor, $2344bd0db54c71be$var$suspenseHandlerStackCursor.current);
}
function $2344bd0db54c71be$var$popSuspenseHandler(fiber) {
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$suspenseHandlerStackCursor);
    $2344bd0db54c71be$var$shellBoundary === fiber && ($2344bd0db54c71be$var$shellBoundary = null);
    $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$suspenseStackCursor);
}
var $2344bd0db54c71be$var$suspenseStackCursor = $2344bd0db54c71be$var$createCursor(0);
function $2344bd0db54c71be$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $2344bd0db54c71be$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $2344bd0db54c71be$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $2344bd0db54c71be$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $2344bd0db54c71be$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2344bd0db54c71be$var$requestUpdateLane(), update = $2344bd0db54c71be$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2344bd0db54c71be$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2344bd0db54c71be$var$scheduleUpdateOnFiber(payload, inst, lane), $2344bd0db54c71be$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2344bd0db54c71be$var$requestUpdateLane(), update = $2344bd0db54c71be$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2344bd0db54c71be$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2344bd0db54c71be$var$scheduleUpdateOnFiber(payload, inst, lane), $2344bd0db54c71be$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $2344bd0db54c71be$var$requestUpdateLane(), update = $2344bd0db54c71be$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $2344bd0db54c71be$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($2344bd0db54c71be$var$scheduleUpdateOnFiber(callback, inst, lane), $2344bd0db54c71be$var$entangleTransitions(callback, inst, lane));
    }
};
function $2344bd0db54c71be$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$2344bd0db54c71be$var$shallowEqual(oldProps, newProps) || !$2344bd0db54c71be$var$shallowEqual(oldState, newState) : !0;
}
function $2344bd0db54c71be$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $2344bd0db54c71be$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $2344bd0db54c71be$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $2344bd0db54c71be$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $2344bd0db54c71be$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $2344bd0db54c71be$var$defaultOnUncaughtError(error) {
    $2344bd0db54c71be$var$reportGlobalError(error);
}
function $2344bd0db54c71be$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $2344bd0db54c71be$var$defaultOnRecoverableError(error) {
    $2344bd0db54c71be$var$reportGlobalError(error);
}
function $2344bd0db54c71be$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $2344bd0db54c71be$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $2344bd0db54c71be$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $2344bd0db54c71be$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $2344bd0db54c71be$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $2344bd0db54c71be$var$createClassErrorUpdate(lane) {
    lane = $2344bd0db54c71be$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $2344bd0db54c71be$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $2344bd0db54c71be$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $2344bd0db54c71be$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed ? $2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $2344bd0db54c71be$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $2344bd0db54c71be$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $2344bd0db54c71be$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $2344bd0db54c71be$var$shellBoundary ? $2344bd0db54c71be$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $2344bd0db54c71be$var$workInProgressRootExitStatus && ($2344bd0db54c71be$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $2344bd0db54c71be$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $2344bd0db54c71be$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $2344bd0db54c71be$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $2344bd0db54c71be$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($2344bd0db54c71be$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $2344bd0db54c71be$var$attachPingListener(root, value, rootRenderLanes);
        $2344bd0db54c71be$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($2344bd0db54c71be$var$isHydrating) return returnFiber = $2344bd0db54c71be$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $2344bd0db54c71be$var$HydrationMismatchException && (root = Error($2344bd0db54c71be$var$formatProdErrorMessage(422), {
        cause: value
    }), $2344bd0db54c71be$var$queueHydrationError($2344bd0db54c71be$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $2344bd0db54c71be$var$HydrationMismatchException && (returnFiber = Error($2344bd0db54c71be$var$formatProdErrorMessage(423), {
        cause: value
    }), $2344bd0db54c71be$var$queueHydrationError($2344bd0db54c71be$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $2344bd0db54c71be$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $2344bd0db54c71be$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $2344bd0db54c71be$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $2344bd0db54c71be$var$workInProgressRootExitStatus && ($2344bd0db54c71be$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($2344bd0db54c71be$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $2344bd0db54c71be$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $2344bd0db54c71be$var$workInProgressRootConcurrentErrors ? $2344bd0db54c71be$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $2344bd0db54c71be$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $2344bd0db54c71be$var$workInProgressRootExitStatus && ($2344bd0db54c71be$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $2344bd0db54c71be$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $2344bd0db54c71be$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $2344bd0db54c71be$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed || !$2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $2344bd0db54c71be$var$createClassErrorUpdate(rootRenderLanes), $2344bd0db54c71be$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $2344bd0db54c71be$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $2344bd0db54c71be$var$SelectiveHydrationException = Error($2344bd0db54c71be$var$formatProdErrorMessage(461)), $2344bd0db54c71be$var$didReceiveUpdate = !1;
function $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $2344bd0db54c71be$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $2344bd0db54c71be$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $2344bd0db54c71be$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $2344bd0db54c71be$var$prepareToReadContext(workInProgress);
    nextProps = $2344bd0db54c71be$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $2344bd0db54c71be$var$checkDidRenderIdHook();
    if (null !== current && !$2344bd0db54c71be$var$didReceiveUpdate) return $2344bd0db54c71be$var$bailoutHooks(current, workInProgress, renderLanes), $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2344bd0db54c71be$var$isHydrating && key && $2344bd0db54c71be$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2344bd0db54c71be$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$2344bd0db54c71be$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $2344bd0db54c71be$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $2344bd0db54c71be$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$2344bd0db54c71be$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $2344bd0db54c71be$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $2344bd0db54c71be$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $2344bd0db54c71be$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($2344bd0db54c71be$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($2344bd0db54c71be$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $2344bd0db54c71be$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($2344bd0db54c71be$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $2344bd0db54c71be$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $2344bd0db54c71be$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $2344bd0db54c71be$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $2344bd0db54c71be$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $2344bd0db54c71be$var$pushHiddenContext(workInProgress, prevState) : $2344bd0db54c71be$var$reuseHiddenContextOnStack(), $2344bd0db54c71be$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $2344bd0db54c71be$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($2344bd0db54c71be$var$pushTransition(workInProgress, prevState.cachePool), $2344bd0db54c71be$var$pushHiddenContext(workInProgress, prevState), $2344bd0db54c71be$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $2344bd0db54c71be$var$pushTransition(workInProgress, null), $2344bd0db54c71be$var$reuseHiddenContextOnStack(), $2344bd0db54c71be$var$reuseSuspenseHandlerOnStack(workInProgress));
    $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $2344bd0db54c71be$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $2344bd0db54c71be$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $2344bd0db54c71be$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $2344bd0db54c71be$var$pushTransition(workInProgress, null);
    $2344bd0db54c71be$var$reuseHiddenContextOnStack();
    $2344bd0db54c71be$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $2344bd0db54c71be$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $2344bd0db54c71be$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $2344bd0db54c71be$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2344bd0db54c71be$var$prepareToReadContext(workInProgress);
    Component = $2344bd0db54c71be$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $2344bd0db54c71be$var$checkDidRenderIdHook();
    if (null !== current && !$2344bd0db54c71be$var$didReceiveUpdate) return $2344bd0db54c71be$var$bailoutHooks(current, workInProgress, renderLanes), $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2344bd0db54c71be$var$isHydrating && nextProps && $2344bd0db54c71be$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $2344bd0db54c71be$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $2344bd0db54c71be$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $2344bd0db54c71be$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $2344bd0db54c71be$var$finishRenderingHooks(current);
    Component = $2344bd0db54c71be$var$checkDidRenderIdHook();
    if (null !== current && !$2344bd0db54c71be$var$didReceiveUpdate) return $2344bd0db54c71be$var$bailoutHooks(current, workInProgress, renderLanes), $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2344bd0db54c71be$var$isHydrating && Component && $2344bd0db54c71be$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2344bd0db54c71be$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2344bd0db54c71be$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $2344bd0db54c71be$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $2344bd0db54c71be$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $2344bd0db54c71be$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $2344bd0db54c71be$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $2344bd0db54c71be$var$readContext(contextType) : $2344bd0db54c71be$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($2344bd0db54c71be$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $2344bd0db54c71be$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $2344bd0db54c71be$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $2344bd0db54c71be$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $2344bd0db54c71be$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $2344bd0db54c71be$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $2344bd0db54c71be$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $2344bd0db54c71be$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $2344bd0db54c71be$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2344bd0db54c71be$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2344bd0db54c71be$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $2344bd0db54c71be$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($2344bd0db54c71be$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $2344bd0db54c71be$var$hasForceUpdate || $2344bd0db54c71be$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $2344bd0db54c71be$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $2344bd0db54c71be$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $2344bd0db54c71be$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $2344bd0db54c71be$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $2344bd0db54c71be$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $2344bd0db54c71be$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2344bd0db54c71be$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2344bd0db54c71be$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $2344bd0db54c71be$var$hasForceUpdate || null !== current && null !== current.dependencies && $2344bd0db54c71be$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($2344bd0db54c71be$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $2344bd0db54c71be$var$hasForceUpdate || $2344bd0db54c71be$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $2344bd0db54c71be$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $2344bd0db54c71be$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $2344bd0db54c71be$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $2344bd0db54c71be$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $2344bd0db54c71be$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $2344bd0db54c71be$var$resetHydrationState();
    workInProgress.flags |= 256;
    $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $2344bd0db54c71be$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $2344bd0db54c71be$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $2344bd0db54c71be$var$getSuspendedCache()
    };
}
function $2344bd0db54c71be$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $2344bd0db54c71be$var$workInProgressDeferredLane);
    return current;
}
function $2344bd0db54c71be$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($2344bd0db54c71be$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($2344bd0db54c71be$var$isHydrating) {
            showFallback ? $2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $2344bd0db54c71be$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($2344bd0db54c71be$var$isHydrating) {
                var nextInstance = $2344bd0db54c71be$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $2344bd0db54c71be$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $2344bd0db54c71be$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $2344bd0db54c71be$var$treeContextProvider ? {
                            id: $2344bd0db54c71be$var$treeContextId,
                            overflow: $2344bd0db54c71be$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $2344bd0db54c71be$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $2344bd0db54c71be$var$hydrationParentFiber = workInProgress, $2344bd0db54c71be$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $2344bd0db54c71be$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $2344bd0db54c71be$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $2344bd0db54c71be$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $2344bd0db54c71be$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $2344bd0db54c71be$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $2344bd0db54c71be$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $2344bd0db54c71be$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $2344bd0db54c71be$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2344bd0db54c71be$var$SUSPENDED_MARKER, nextProps;
        $2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $2344bd0db54c71be$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $2344bd0db54c71be$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($2344bd0db54c71be$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($2344bd0db54c71be$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $2344bd0db54c71be$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $2344bd0db54c71be$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $2344bd0db54c71be$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $2344bd0db54c71be$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $2344bd0db54c71be$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2344bd0db54c71be$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(workInProgress), $2344bd0db54c71be$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($2344bd0db54c71be$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $2344bd0db54c71be$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $2344bd0db54c71be$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($2344bd0db54c71be$var$didReceiveUpdate || $2344bd0db54c71be$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $2344bd0db54c71be$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $2344bd0db54c71be$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $2344bd0db54c71be$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $2344bd0db54c71be$var$enqueueConcurrentRenderForLane(current, nextProps), $2344bd0db54c71be$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $2344bd0db54c71be$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $2344bd0db54c71be$var$renderDidSuspendDelayIfPossible();
            workInProgress = $2344bd0db54c71be$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $2344bd0db54c71be$var$nextHydratableInstance = $2344bd0db54c71be$var$getNextHydratable(nextInstance.nextSibling), $2344bd0db54c71be$var$hydrationParentFiber = workInProgress, $2344bd0db54c71be$var$isHydrating = !0, $2344bd0db54c71be$var$hydrationErrors = null, $2344bd0db54c71be$var$rootOrSingletonContext = !1, null !== current && ($2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex++] = $2344bd0db54c71be$var$treeContextId, $2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex++] = $2344bd0db54c71be$var$treeContextOverflow, $2344bd0db54c71be$var$idStack[$2344bd0db54c71be$var$idStackIndex++] = $2344bd0db54c71be$var$treeContextProvider, $2344bd0db54c71be$var$treeContextId = current.id, $2344bd0db54c71be$var$treeContextOverflow = current.overflow, $2344bd0db54c71be$var$treeContextProvider = workInProgress), workInProgress = $2344bd0db54c71be$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $2344bd0db54c71be$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $2344bd0db54c71be$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $2344bd0db54c71be$var$createWorkInProgress(digest, showFallback) : (showFallback = $2344bd0db54c71be$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $2344bd0db54c71be$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $2344bd0db54c71be$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $2344bd0db54c71be$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $2344bd0db54c71be$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2344bd0db54c71be$var$SUSPENDED_MARKER, nextProps;
    $2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $2344bd0db54c71be$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $2344bd0db54c71be$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $2344bd0db54c71be$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $2344bd0db54c71be$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $2344bd0db54c71be$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $2344bd0db54c71be$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $2344bd0db54c71be$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $2344bd0db54c71be$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $2344bd0db54c71be$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $2344bd0db54c71be$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $2344bd0db54c71be$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $2344bd0db54c71be$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $2344bd0db54c71be$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $2344bd0db54c71be$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $2344bd0db54c71be$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $2344bd0db54c71be$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $2344bd0db54c71be$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $2344bd0db54c71be$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $2344bd0db54c71be$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $2344bd0db54c71be$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $2344bd0db54c71be$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($2344bd0db54c71be$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $2344bd0db54c71be$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $2344bd0db54c71be$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $2344bd0db54c71be$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $2344bd0db54c71be$var$checkIfContextChanged(current) ? !0 : !1;
}
function $2344bd0db54c71be$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $2344bd0db54c71be$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $2344bd0db54c71be$var$pushProvider(workInProgress, $2344bd0db54c71be$var$CacheContext, current.memoizedState.cache);
            $2344bd0db54c71be$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $2344bd0db54c71be$var$pushHostContext(workInProgress);
            break;
        case 4:
            $2344bd0db54c71be$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $2344bd0db54c71be$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $2344bd0db54c71be$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $2344bd0db54c71be$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($2344bd0db54c71be$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $2344bd0db54c71be$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseStackCursor, $2344bd0db54c71be$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $2344bd0db54c71be$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $2344bd0db54c71be$var$pushProvider(workInProgress, $2344bd0db54c71be$var$CacheContext, current.memoizedState.cache);
    }
    return $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $2344bd0db54c71be$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $2344bd0db54c71be$var$didReceiveUpdate = !0;
        else {
            if (!$2344bd0db54c71be$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $2344bd0db54c71be$var$didReceiveUpdate = !1, $2344bd0db54c71be$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $2344bd0db54c71be$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $2344bd0db54c71be$var$didReceiveUpdate = !1, $2344bd0db54c71be$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $2344bd0db54c71be$var$pushTreeId(workInProgress, $2344bd0db54c71be$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $2344bd0db54c71be$var$shouldConstruct(lazyComponent) ? (current = $2344bd0db54c71be$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $2344bd0db54c71be$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $2344bd0db54c71be$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $2344bd0db54c71be$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $2344bd0db54c71be$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $2344bd0db54c71be$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $2344bd0db54c71be$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $2344bd0db54c71be$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $2344bd0db54c71be$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $2344bd0db54c71be$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $2344bd0db54c71be$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $2344bd0db54c71be$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $2344bd0db54c71be$var$cloneUpdateQueue(current, workInProgress);
                $2344bd0db54c71be$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $2344bd0db54c71be$var$pushProvider(workInProgress, $2344bd0db54c71be$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $2344bd0db54c71be$var$propagateContextChanges(workInProgress, [
                    $2344bd0db54c71be$var$CacheContext
                ], renderLanes, !0);
                $2344bd0db54c71be$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $2344bd0db54c71be$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $2344bd0db54c71be$var$createCapturedValueAtFiber(Error($2344bd0db54c71be$var$formatProdErrorMessage(424)), workInProgress);
                        $2344bd0db54c71be$var$queueHydrationError(init);
                        workInProgress = $2344bd0db54c71be$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $2344bd0db54c71be$var$nextHydratableInstance = $2344bd0db54c71be$var$getNextHydratable(current.firstChild);
                        $2344bd0db54c71be$var$hydrationParentFiber = workInProgress;
                        $2344bd0db54c71be$var$isHydrating = !0;
                        $2344bd0db54c71be$var$hydrationErrors = null;
                        $2344bd0db54c71be$var$rootOrSingletonContext = !0;
                        renderLanes = $2344bd0db54c71be$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $2344bd0db54c71be$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $2344bd0db54c71be$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $2344bd0db54c71be$var$markRef(current, workInProgress), null === current ? (renderLanes = $2344bd0db54c71be$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $2344bd0db54c71be$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $2344bd0db54c71be$var$getOwnerDocumentFromRootContainer($2344bd0db54c71be$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$2344bd0db54c71be$var$internalInstanceKey] = workInProgress, lazyComponent[$2344bd0db54c71be$var$internalPropsKey] = current, $2344bd0db54c71be$var$setInitialProperties(lazyComponent, renderLanes, current), $2344bd0db54c71be$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $2344bd0db54c71be$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $2344bd0db54c71be$var$pushHostContext(workInProgress), null === current && $2344bd0db54c71be$var$isHydrating && (lazyComponent = workInProgress.stateNode = $2344bd0db54c71be$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $2344bd0db54c71be$var$rootInstanceStackCursor.current), $2344bd0db54c71be$var$hydrationParentFiber = workInProgress, $2344bd0db54c71be$var$rootOrSingletonContext = !0, init = $2344bd0db54c71be$var$nextHydratableInstance, $2344bd0db54c71be$var$isSingletonScope(workInProgress.type) ? ($2344bd0db54c71be$var$previousHydratableOnEnteringScopedSingleton = init, $2344bd0db54c71be$var$nextHydratableInstance = $2344bd0db54c71be$var$getNextHydratable(lazyComponent.firstChild)) : $2344bd0db54c71be$var$nextHydratableInstance = init), $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $2344bd0db54c71be$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $2344bd0db54c71be$var$isHydrating) {
                if (init = lazyComponent = $2344bd0db54c71be$var$nextHydratableInstance) lazyComponent = $2344bd0db54c71be$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $2344bd0db54c71be$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $2344bd0db54c71be$var$hydrationParentFiber = workInProgress, $2344bd0db54c71be$var$nextHydratableInstance = $2344bd0db54c71be$var$getNextHydratable(lazyComponent.firstChild), $2344bd0db54c71be$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $2344bd0db54c71be$var$throwOnHydrationMismatch(workInProgress);
            }
            $2344bd0db54c71be$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $2344bd0db54c71be$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $2344bd0db54c71be$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $2344bd0db54c71be$var$renderWithHooks(current, workInProgress, $2344bd0db54c71be$var$TransitionAwareHostComponent, null, null, renderLanes), $2344bd0db54c71be$var$HostTransitionContext._currentValue = init);
            $2344bd0db54c71be$var$markRef(current, workInProgress);
            $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $2344bd0db54c71be$var$isHydrating) {
                if (current = renderLanes = $2344bd0db54c71be$var$nextHydratableInstance) renderLanes = $2344bd0db54c71be$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $2344bd0db54c71be$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $2344bd0db54c71be$var$hydrationParentFiber = workInProgress, $2344bd0db54c71be$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $2344bd0db54c71be$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $2344bd0db54c71be$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $2344bd0db54c71be$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $2344bd0db54c71be$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $2344bd0db54c71be$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $2344bd0db54c71be$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $2344bd0db54c71be$var$prepareToReadContext(workInProgress), init = $2344bd0db54c71be$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $2344bd0db54c71be$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $2344bd0db54c71be$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $2344bd0db54c71be$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $2344bd0db54c71be$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $2344bd0db54c71be$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $2344bd0db54c71be$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $2344bd0db54c71be$var$prepareToReadContext(workInProgress), lazyComponent = $2344bd0db54c71be$var$readContext($2344bd0db54c71be$var$CacheContext), null === current ? (init = $2344bd0db54c71be$var$peekCacheFromPool(), null === init && (init = $2344bd0db54c71be$var$workInProgressRoot, prevState = $2344bd0db54c71be$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $2344bd0db54c71be$var$initializeUpdateQueue(workInProgress), $2344bd0db54c71be$var$pushProvider(workInProgress, $2344bd0db54c71be$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($2344bd0db54c71be$var$cloneUpdateQueue(current, workInProgress), $2344bd0db54c71be$var$processUpdateQueue(workInProgress, null, null, renderLanes), $2344bd0db54c71be$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $2344bd0db54c71be$var$pushProvider(workInProgress, $2344bd0db54c71be$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $2344bd0db54c71be$var$pushProvider(workInProgress, $2344bd0db54c71be$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $2344bd0db54c71be$var$propagateContextChanges(workInProgress, [
                $2344bd0db54c71be$var$CacheContext
            ], renderLanes, !0))), $2344bd0db54c71be$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2344bd0db54c71be$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $2344bd0db54c71be$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$2344bd0db54c71be$var$preloadResource(resource)) {
        resource = $2344bd0db54c71be$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($2344bd0db54c71be$var$workInProgressRootRenderLanes & 4194048) === $2344bd0db54c71be$var$workInProgressRootRenderLanes ? null !== $2344bd0db54c71be$var$shellBoundary : ($2344bd0db54c71be$var$workInProgressRootRenderLanes & 62914560) !== $2344bd0db54c71be$var$workInProgressRootRenderLanes && 0 === ($2344bd0db54c71be$var$workInProgressRootRenderLanes & 536870912) || resource !== $2344bd0db54c71be$var$shellBoundary)) throw $2344bd0db54c71be$var$suspendedThenable = $2344bd0db54c71be$var$noopSuspenseyCommitThenable, $2344bd0db54c71be$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $2344bd0db54c71be$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $2344bd0db54c71be$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $2344bd0db54c71be$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $2344bd0db54c71be$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$2344bd0db54c71be$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $2344bd0db54c71be$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $2344bd0db54c71be$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $2344bd0db54c71be$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2344bd0db54c71be$var$bubbleProperties(workInProgress), null;
        case 1:
            return $2344bd0db54c71be$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $2344bd0db54c71be$var$popProvider($2344bd0db54c71be$var$CacheContext);
            $2344bd0db54c71be$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $2344bd0db54c71be$var$popHydrationState(workInProgress) ? $2344bd0db54c71be$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $2344bd0db54c71be$var$upgradeHydrationErrorsToRecoverable());
            $2344bd0db54c71be$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($2344bd0db54c71be$var$markUpdate(workInProgress), null !== renderLanes ? ($2344bd0db54c71be$var$bubbleProperties(workInProgress), $2344bd0db54c71be$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($2344bd0db54c71be$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($2344bd0db54c71be$var$markUpdate(workInProgress), $2344bd0db54c71be$var$bubbleProperties(workInProgress), $2344bd0db54c71be$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($2344bd0db54c71be$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $2344bd0db54c71be$var$markUpdate(workInProgress), $2344bd0db54c71be$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $2344bd0db54c71be$var$popHostContext(workInProgress);
            renderLanes = $2344bd0db54c71be$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2344bd0db54c71be$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(166));
                    $2344bd0db54c71be$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $2344bd0db54c71be$var$contextStackCursor.current;
                $2344bd0db54c71be$var$popHydrationState(workInProgress) ? $2344bd0db54c71be$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $2344bd0db54c71be$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $2344bd0db54c71be$var$markUpdate(workInProgress));
            }
            $2344bd0db54c71be$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $2344bd0db54c71be$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2344bd0db54c71be$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(166));
                    $2344bd0db54c71be$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $2344bd0db54c71be$var$contextStackCursor.current;
                if ($2344bd0db54c71be$var$popHydrationState(workInProgress)) $2344bd0db54c71be$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $2344bd0db54c71be$var$getOwnerDocumentFromRootContainer($2344bd0db54c71be$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$2344bd0db54c71be$var$internalInstanceKey] = workInProgress;
                    current[$2344bd0db54c71be$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($2344bd0db54c71be$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $2344bd0db54c71be$var$markUpdate(workInProgress);
                }
            }
            $2344bd0db54c71be$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2344bd0db54c71be$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(166));
                current = $2344bd0db54c71be$var$rootInstanceStackCursor.current;
                if ($2344bd0db54c71be$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $2344bd0db54c71be$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$2344bd0db54c71be$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $2344bd0db54c71be$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $2344bd0db54c71be$var$throwOnHydrationMismatch(workInProgress);
                } else current = $2344bd0db54c71be$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$2344bd0db54c71be$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $2344bd0db54c71be$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $2344bd0db54c71be$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(317));
                        type[$2344bd0db54c71be$var$internalInstanceKey] = workInProgress;
                    } else $2344bd0db54c71be$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $2344bd0db54c71be$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $2344bd0db54c71be$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $2344bd0db54c71be$var$popSuspenseHandler(workInProgress), workInProgress;
                    $2344bd0db54c71be$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $2344bd0db54c71be$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $2344bd0db54c71be$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $2344bd0db54c71be$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $2344bd0db54c71be$var$popHostContainer(), null === current && $2344bd0db54c71be$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $2344bd0db54c71be$var$bubbleProperties(workInProgress), null;
        case 10:
            return $2344bd0db54c71be$var$popProvider(workInProgress.type), $2344bd0db54c71be$var$bubbleProperties(workInProgress), null;
        case 19:
            $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $2344bd0db54c71be$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $2344bd0db54c71be$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $2344bd0db54c71be$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $2344bd0db54c71be$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $2344bd0db54c71be$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $2344bd0db54c71be$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$2344bd0db54c71be$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseStackCursor, $2344bd0db54c71be$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $2344bd0db54c71be$var$now() > $2344bd0db54c71be$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $2344bd0db54c71be$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $2344bd0db54c71be$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $2344bd0db54c71be$var$scheduleRetryEffect(workInProgress, current), $2344bd0db54c71be$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$2344bd0db54c71be$var$isHydrating) return $2344bd0db54c71be$var$bubbleProperties(workInProgress), null;
                    } else 2 * $2344bd0db54c71be$var$now() - type.renderingStartTime > $2344bd0db54c71be$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $2344bd0db54c71be$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $2344bd0db54c71be$var$now(), workInProgress.sibling = null, current = $2344bd0db54c71be$var$suspenseStackCursor.current, $2344bd0db54c71be$var$push($2344bd0db54c71be$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $2344bd0db54c71be$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $2344bd0db54c71be$var$popSuspenseHandler(workInProgress), $2344bd0db54c71be$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($2344bd0db54c71be$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $2344bd0db54c71be$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $2344bd0db54c71be$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $2344bd0db54c71be$var$popProvider($2344bd0db54c71be$var$CacheContext), $2344bd0db54c71be$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2344bd0db54c71be$var$unwindWork(current, workInProgress) {
    $2344bd0db54c71be$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $2344bd0db54c71be$var$popProvider($2344bd0db54c71be$var$CacheContext), $2344bd0db54c71be$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $2344bd0db54c71be$var$popHostContext(workInProgress), null;
        case 13:
            $2344bd0db54c71be$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(340));
                $2344bd0db54c71be$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$suspenseStackCursor), null;
        case 4:
            return $2344bd0db54c71be$var$popHostContainer(), null;
        case 10:
            return $2344bd0db54c71be$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $2344bd0db54c71be$var$popSuspenseHandler(workInProgress), $2344bd0db54c71be$var$popHiddenContext(), null !== current && $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $2344bd0db54c71be$var$popProvider($2344bd0db54c71be$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $2344bd0db54c71be$var$unwindInterruptedWork(current, interruptedWork) {
    $2344bd0db54c71be$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $2344bd0db54c71be$var$popProvider($2344bd0db54c71be$var$CacheContext);
            $2344bd0db54c71be$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $2344bd0db54c71be$var$popHostContext(interruptedWork);
            break;
        case 4:
            $2344bd0db54c71be$var$popHostContainer();
            break;
        case 13:
            $2344bd0db54c71be$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$suspenseStackCursor);
            break;
        case 10:
            $2344bd0db54c71be$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $2344bd0db54c71be$var$popSuspenseHandler(interruptedWork);
            $2344bd0db54c71be$var$popHiddenContext();
            null !== current && $2344bd0db54c71be$var$pop($2344bd0db54c71be$var$resumedCache);
            break;
        case 24:
            $2344bd0db54c71be$var$popProvider($2344bd0db54c71be$var$CacheContext);
    }
}
function $2344bd0db54c71be$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2344bd0db54c71be$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $2344bd0db54c71be$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2344bd0db54c71be$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $2344bd0db54c71be$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $2344bd0db54c71be$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $2344bd0db54c71be$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $2344bd0db54c71be$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2344bd0db54c71be$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $2344bd0db54c71be$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2344bd0db54c71be$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $2344bd0db54c71be$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $2344bd0db54c71be$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $2344bd0db54c71be$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2344bd0db54c71be$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $2344bd0db54c71be$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$2344bd0db54c71be$var$internalPropsKey] = newProps;
    } catch (error) {
        $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2344bd0db54c71be$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $2344bd0db54c71be$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $2344bd0db54c71be$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $2344bd0db54c71be$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $2344bd0db54c71be$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $2344bd0db54c71be$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $2344bd0db54c71be$var$noop$1));
    else if (4 !== tag && (27 === tag && $2344bd0db54c71be$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($2344bd0db54c71be$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$2344bd0db54c71be$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $2344bd0db54c71be$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $2344bd0db54c71be$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($2344bd0db54c71be$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$2344bd0db54c71be$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $2344bd0db54c71be$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $2344bd0db54c71be$var$setInitialProperties(singleton, type, props);
        singleton[$2344bd0db54c71be$var$internalInstanceKey] = finishedWork;
        singleton[$2344bd0db54c71be$var$internalPropsKey] = props;
    } catch (error) {
        $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $2344bd0db54c71be$var$offscreenSubtreeIsHidden = !1, $2344bd0db54c71be$var$offscreenSubtreeWasHidden = !1, $2344bd0db54c71be$var$needsFormReset = !1, $2344bd0db54c71be$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $2344bd0db54c71be$var$nextEffect = null;
function $2344bd0db54c71be$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $2344bd0db54c71be$var$eventsEnabled = $2344bd0db54c71be$var$_enabled;
    root = $2344bd0db54c71be$var$getActiveElementDeep(root);
    if ($2344bd0db54c71be$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $2344bd0db54c71be$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $2344bd0db54c71be$var$_enabled = !1;
    for($2344bd0db54c71be$var$nextEffect = firstChild; null !== $2344bd0db54c71be$var$nextEffect;)if (firstChild = $2344bd0db54c71be$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $2344bd0db54c71be$var$nextEffect = root;
    else for(; null !== $2344bd0db54c71be$var$nextEffect;){
        firstChild = $2344bd0db54c71be$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $2344bd0db54c71be$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $2344bd0db54c71be$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $2344bd0db54c71be$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $2344bd0db54c71be$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $2344bd0db54c71be$var$nextEffect = root;
            break;
        }
        $2344bd0db54c71be$var$nextEffect = firstChild.return;
    }
}
function $2344bd0db54c71be$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2344bd0db54c71be$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $2344bd0db54c71be$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $2344bd0db54c71be$var$commitClassCallbacks(finishedWork);
            flags & 512 && $2344bd0db54c71be$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $2344bd0db54c71be$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $2344bd0db54c71be$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $2344bd0db54c71be$var$commitHostMount(finishedWork);
            flags & 512 && $2344bd0db54c71be$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2344bd0db54c71be$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $2344bd0db54c71be$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $2344bd0db54c71be$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $2344bd0db54c71be$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $2344bd0db54c71be$var$offscreenSubtreeWasHidden;
                prevProps = $2344bd0db54c71be$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $2344bd0db54c71be$var$offscreenSubtreeWasHidden;
                $2344bd0db54c71be$var$offscreenSubtreeIsHidden = flags;
                ($2344bd0db54c71be$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $2344bd0db54c71be$var$offscreenSubtreeIsHidden = prevProps;
                $2344bd0db54c71be$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $2344bd0db54c71be$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $2344bd0db54c71be$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $2344bd0db54c71be$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $2344bd0db54c71be$var$hostParent = null, $2344bd0db54c71be$var$hostParentIsContainer = !1;
function $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$2344bd0db54c71be$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $2344bd0db54c71be$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($2344bd0db54c71be$var$injectedHook && "function" === typeof $2344bd0db54c71be$var$injectedHook.onCommitFiberUnmount) try {
        $2344bd0db54c71be$var$injectedHook.onCommitFiberUnmount($2344bd0db54c71be$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden || $2344bd0db54c71be$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden || $2344bd0db54c71be$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $2344bd0db54c71be$var$hostParent, prevHostParentIsContainer = $2344bd0db54c71be$var$hostParentIsContainer;
            $2344bd0db54c71be$var$isSingletonScope(deletedFiber.type) && ($2344bd0db54c71be$var$hostParent = deletedFiber.stateNode, $2344bd0db54c71be$var$hostParentIsContainer = !1);
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2344bd0db54c71be$var$releaseSingletonInstance(deletedFiber.stateNode);
            $2344bd0db54c71be$var$hostParent = prevHostParent;
            $2344bd0db54c71be$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden || $2344bd0db54c71be$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $2344bd0db54c71be$var$hostParent;
            prevHostParentIsContainer = $2344bd0db54c71be$var$hostParentIsContainer;
            $2344bd0db54c71be$var$hostParent = null;
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2344bd0db54c71be$var$hostParent = prevHostParent;
            $2344bd0db54c71be$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $2344bd0db54c71be$var$hostParent) {
                if ($2344bd0db54c71be$var$hostParentIsContainer) try {
                    (9 === $2344bd0db54c71be$var$hostParent.nodeType ? $2344bd0db54c71be$var$hostParent.body : "HTML" === $2344bd0db54c71be$var$hostParent.nodeName ? $2344bd0db54c71be$var$hostParent.ownerDocument.body : $2344bd0db54c71be$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2344bd0db54c71be$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $2344bd0db54c71be$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2344bd0db54c71be$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $2344bd0db54c71be$var$hostParent && ($2344bd0db54c71be$var$hostParentIsContainer ? (finishedRoot = $2344bd0db54c71be$var$hostParent, $2344bd0db54c71be$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $2344bd0db54c71be$var$retryIfBlockedOn(finishedRoot)) : $2344bd0db54c71be$var$clearSuspenseBoundary($2344bd0db54c71be$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $2344bd0db54c71be$var$hostParent;
            prevHostParentIsContainer = $2344bd0db54c71be$var$hostParentIsContainer;
            $2344bd0db54c71be$var$hostParent = deletedFiber.stateNode.containerInfo;
            $2344bd0db54c71be$var$hostParentIsContainer = !0;
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2344bd0db54c71be$var$hostParent = prevHostParent;
            $2344bd0db54c71be$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden || $2344bd0db54c71be$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden || $2344bd0db54c71be$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden || ($2344bd0db54c71be$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $2344bd0db54c71be$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden = (prevHostParent = $2344bd0db54c71be$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $2344bd0db54c71be$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $2344bd0db54c71be$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $2344bd0db54c71be$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2344bd0db54c71be$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $2344bd0db54c71be$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $2344bd0db54c71be$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($2344bd0db54c71be$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $2344bd0db54c71be$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $2344bd0db54c71be$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $2344bd0db54c71be$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($2344bd0db54c71be$var$isSingletonScope(parent.type)) {
                        $2344bd0db54c71be$var$hostParent = parent.stateNode;
                        $2344bd0db54c71be$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $2344bd0db54c71be$var$hostParent = parent.stateNode;
                    $2344bd0db54c71be$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $2344bd0db54c71be$var$hostParent = parent.stateNode.containerInfo;
                    $2344bd0db54c71be$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $2344bd0db54c71be$var$hostParent) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(160));
        $2344bd0db54c71be$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $2344bd0db54c71be$var$hostParent = null;
        $2344bd0db54c71be$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$2344bd0db54c71be$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $2344bd0db54c71be$var$currentHoistableRoot = null;
function $2344bd0db54c71be$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($2344bd0db54c71be$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $2344bd0db54c71be$var$commitHookEffectListMount(3, finishedWork), $2344bd0db54c71be$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2344bd0db54c71be$var$offscreenSubtreeWasHidden || null === current || $2344bd0db54c71be$var$safelyDetachRef(current, current.return));
            flags & 64 && $2344bd0db54c71be$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $2344bd0db54c71be$var$currentHoistableRoot;
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2344bd0db54c71be$var$offscreenSubtreeWasHidden || null === current || $2344bd0db54c71be$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$2344bd0db54c71be$var$internalHoistableMarker] || currentResource[$2344bd0db54c71be$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $2344bd0db54c71be$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$2344bd0db54c71be$var$internalInstanceKey] = finishedWork;
                                        $2344bd0db54c71be$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $2344bd0db54c71be$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2344bd0db54c71be$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $2344bd0db54c71be$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2344bd0db54c71be$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($2344bd0db54c71be$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$2344bd0db54c71be$var$internalInstanceKey] = finishedWork;
                                $2344bd0db54c71be$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $2344bd0db54c71be$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $2344bd0db54c71be$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $2344bd0db54c71be$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $2344bd0db54c71be$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $2344bd0db54c71be$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2344bd0db54c71be$var$offscreenSubtreeWasHidden || null === current || $2344bd0db54c71be$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $2344bd0db54c71be$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2344bd0db54c71be$var$offscreenSubtreeWasHidden || null === current || $2344bd0db54c71be$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $2344bd0db54c71be$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $2344bd0db54c71be$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($2344bd0db54c71be$var$needsFormReset = !0);
            break;
        case 6:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $2344bd0db54c71be$var$tagCaches = null;
            hoistableRoot = $2344bd0db54c71be$var$currentHoistableRoot;
            $2344bd0db54c71be$var$currentHoistableRoot = $2344bd0db54c71be$var$getHoistableRoot(root.containerInfo);
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$currentHoistableRoot = hoistableRoot;
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $2344bd0db54c71be$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $2344bd0db54c71be$var$needsFormReset && ($2344bd0db54c71be$var$needsFormReset = !1, $2344bd0db54c71be$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $2344bd0db54c71be$var$currentHoistableRoot;
            $2344bd0db54c71be$var$currentHoistableRoot = $2344bd0db54c71be$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            $2344bd0db54c71be$var$currentHoistableRoot = flags;
            break;
        case 12:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($2344bd0db54c71be$var$globalMostRecentFallbackTime = $2344bd0db54c71be$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2344bd0db54c71be$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $2344bd0db54c71be$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $2344bd0db54c71be$var$offscreenSubtreeWasHidden;
            $2344bd0db54c71be$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $2344bd0db54c71be$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $2344bd0db54c71be$var$offscreenSubtreeIsHidden || $2344bd0db54c71be$var$offscreenSubtreeWasHidden || $2344bd0db54c71be$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $2344bd0db54c71be$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $2344bd0db54c71be$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $2344bd0db54c71be$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2344bd0db54c71be$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $2344bd0db54c71be$var$recursivelyTraverseMutationEffects(root, finishedWork), $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork);
    }
}
function $2344bd0db54c71be$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($2344bd0db54c71be$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $2344bd0db54c71be$var$getHostSibling(finishedWork);
                    $2344bd0db54c71be$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($2344bd0db54c71be$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $2344bd0db54c71be$var$getHostSibling(finishedWork);
                    $2344bd0db54c71be$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $2344bd0db54c71be$var$getHostSibling(finishedWork);
                    $2344bd0db54c71be$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $2344bd0db54c71be$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $2344bd0db54c71be$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $2344bd0db54c71be$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$2344bd0db54c71be$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $2344bd0db54c71be$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $2344bd0db54c71be$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $2344bd0db54c71be$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $2344bd0db54c71be$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $2344bd0db54c71be$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $2344bd0db54c71be$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $2344bd0db54c71be$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $2344bd0db54c71be$var$safelyDetachRef(finishedWork, finishedWork.return);
                $2344bd0db54c71be$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2344bd0db54c71be$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $2344bd0db54c71be$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $2344bd0db54c71be$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2344bd0db54c71be$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2344bd0db54c71be$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$2344bd0db54c71be$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $2344bd0db54c71be$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $2344bd0db54c71be$var$commitClassCallbacks(finishedWork);
                $2344bd0db54c71be$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $2344bd0db54c71be$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $2344bd0db54c71be$var$commitHostMount(finishedWork);
                $2344bd0db54c71be$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $2344bd0db54c71be$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2344bd0db54c71be$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $2344bd0db54c71be$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2344bd0db54c71be$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $2344bd0db54c71be$var$releaseCache(previousCache));
}
function $2344bd0db54c71be$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $2344bd0db54c71be$var$releaseCache(current));
}
function $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2344bd0db54c71be$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $2344bd0db54c71be$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2344bd0db54c71be$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $2344bd0db54c71be$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $2344bd0db54c71be$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $2344bd0db54c71be$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $2344bd0db54c71be$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $2344bd0db54c71be$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2344bd0db54c71be$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $2344bd0db54c71be$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $2344bd0db54c71be$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2344bd0db54c71be$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $2344bd0db54c71be$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $2344bd0db54c71be$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $2344bd0db54c71be$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $2344bd0db54c71be$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $2344bd0db54c71be$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2344bd0db54c71be$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $2344bd0db54c71be$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2344bd0db54c71be$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2344bd0db54c71be$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $2344bd0db54c71be$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2344bd0db54c71be$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2344bd0db54c71be$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2344bd0db54c71be$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2344bd0db54c71be$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $2344bd0db54c71be$var$suspenseyCommitFlag = 8192;
function $2344bd0db54c71be$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $2344bd0db54c71be$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$2344bd0db54c71be$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $2344bd0db54c71be$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $2344bd0db54c71be$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $2344bd0db54c71be$var$suspenseyCommitFlag && null !== fiber.memoizedState && $2344bd0db54c71be$var$suspendResource($2344bd0db54c71be$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $2344bd0db54c71be$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $2344bd0db54c71be$var$currentHoistableRoot;
            $2344bd0db54c71be$var$currentHoistableRoot = $2344bd0db54c71be$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $2344bd0db54c71be$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $2344bd0db54c71be$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $2344bd0db54c71be$var$suspenseyCommitFlag, $2344bd0db54c71be$var$suspenseyCommitFlag = 16777216, $2344bd0db54c71be$var$recursivelyAccumulateSuspenseyCommit(fiber), $2344bd0db54c71be$var$suspenseyCommitFlag = previousHoistableRoot) : $2344bd0db54c71be$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $2344bd0db54c71be$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $2344bd0db54c71be$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $2344bd0db54c71be$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2344bd0db54c71be$var$nextEffect = childToDelete;
            $2344bd0db54c71be$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2344bd0db54c71be$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2344bd0db54c71be$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $2344bd0db54c71be$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2344bd0db54c71be$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $2344bd0db54c71be$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $2344bd0db54c71be$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $2344bd0db54c71be$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $2344bd0db54c71be$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $2344bd0db54c71be$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $2344bd0db54c71be$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $2344bd0db54c71be$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2344bd0db54c71be$var$nextEffect = childToDelete;
            $2344bd0db54c71be$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2344bd0db54c71be$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $2344bd0db54c71be$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $2344bd0db54c71be$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $2344bd0db54c71be$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $2344bd0db54c71be$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2344bd0db54c71be$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $2344bd0db54c71be$var$nextEffect;){
        var fiber = $2344bd0db54c71be$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $2344bd0db54c71be$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $2344bd0db54c71be$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $2344bd0db54c71be$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $2344bd0db54c71be$var$nextEffect;){
            cache = $2344bd0db54c71be$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $2344bd0db54c71be$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $2344bd0db54c71be$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $2344bd0db54c71be$var$nextEffect = sibling;
                break a;
            }
            $2344bd0db54c71be$var$nextEffect = returnFiber;
        }
    }
}
var $2344bd0db54c71be$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $2344bd0db54c71be$var$readContext($2344bd0db54c71be$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $2344bd0db54c71be$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $2344bd0db54c71be$var$executionContext = 0, $2344bd0db54c71be$var$workInProgressRoot = null, $2344bd0db54c71be$var$workInProgress = null, $2344bd0db54c71be$var$workInProgressRootRenderLanes = 0, $2344bd0db54c71be$var$workInProgressSuspendedReason = 0, $2344bd0db54c71be$var$workInProgressThrownValue = null, $2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings = !1, $2344bd0db54c71be$var$workInProgressRootIsPrerendering = !1, $2344bd0db54c71be$var$workInProgressRootDidAttachPingListener = !1, $2344bd0db54c71be$var$entangledRenderLanes = 0, $2344bd0db54c71be$var$workInProgressRootExitStatus = 0, $2344bd0db54c71be$var$workInProgressRootSkippedLanes = 0, $2344bd0db54c71be$var$workInProgressRootInterleavedUpdatedLanes = 0, $2344bd0db54c71be$var$workInProgressRootPingedLanes = 0, $2344bd0db54c71be$var$workInProgressDeferredLane = 0, $2344bd0db54c71be$var$workInProgressSuspendedRetryLanes = 0, $2344bd0db54c71be$var$workInProgressRootConcurrentErrors = null, $2344bd0db54c71be$var$workInProgressRootRecoverableErrors = null, $2344bd0db54c71be$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $2344bd0db54c71be$var$globalMostRecentFallbackTime = 0, $2344bd0db54c71be$var$workInProgressRootRenderTargetTime = Infinity, $2344bd0db54c71be$var$workInProgressTransitions = null, $2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed = null, $2344bd0db54c71be$var$pendingEffectsStatus = 0, $2344bd0db54c71be$var$pendingEffectsRoot = null, $2344bd0db54c71be$var$pendingFinishedWork = null, $2344bd0db54c71be$var$pendingEffectsLanes = 0, $2344bd0db54c71be$var$pendingEffectsRemainingLanes = 0, $2344bd0db54c71be$var$pendingPassiveTransitions = null, $2344bd0db54c71be$var$pendingRecoverableErrors = null, $2344bd0db54c71be$var$nestedUpdateCount = 0, $2344bd0db54c71be$var$rootWithNestedUpdates = null;
function $2344bd0db54c71be$var$requestUpdateLane() {
    if (0 !== ($2344bd0db54c71be$var$executionContext & 2) && 0 !== $2344bd0db54c71be$var$workInProgressRootRenderLanes) return $2344bd0db54c71be$var$workInProgressRootRenderLanes & -$2344bd0db54c71be$var$workInProgressRootRenderLanes;
    if (null !== $2344bd0db54c71be$var$ReactSharedInternals.T) {
        var actionScopeLane = $2344bd0db54c71be$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $2344bd0db54c71be$var$requestTransitionLane();
    }
    return $2344bd0db54c71be$var$resolveUpdatePriority();
}
function $2344bd0db54c71be$var$requestDeferredLane() {
    0 === $2344bd0db54c71be$var$workInProgressDeferredLane && ($2344bd0db54c71be$var$workInProgressDeferredLane = 0 === ($2344bd0db54c71be$var$workInProgressRootRenderLanes & 536870912) || $2344bd0db54c71be$var$isHydrating ? $2344bd0db54c71be$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $2344bd0db54c71be$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $2344bd0db54c71be$var$workInProgressDeferredLane;
}
function $2344bd0db54c71be$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $2344bd0db54c71be$var$workInProgressRoot && (2 === $2344bd0db54c71be$var$workInProgressSuspendedReason || 9 === $2344bd0db54c71be$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $2344bd0db54c71be$var$prepareFreshStack(root, 0), $2344bd0db54c71be$var$markRootSuspended(root, $2344bd0db54c71be$var$workInProgressRootRenderLanes, $2344bd0db54c71be$var$workInProgressDeferredLane, !1);
    $2344bd0db54c71be$var$markRootUpdated$1(root, lane);
    if (0 === ($2344bd0db54c71be$var$executionContext & 2) || root !== $2344bd0db54c71be$var$workInProgressRoot) root === $2344bd0db54c71be$var$workInProgressRoot && (0 === ($2344bd0db54c71be$var$executionContext & 2) && ($2344bd0db54c71be$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $2344bd0db54c71be$var$workInProgressRootExitStatus && $2344bd0db54c71be$var$markRootSuspended(root, $2344bd0db54c71be$var$workInProgressRootRenderLanes, $2344bd0db54c71be$var$workInProgressDeferredLane, !1)), $2344bd0db54c71be$var$ensureRootIsScheduled(root);
}
function $2344bd0db54c71be$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($2344bd0db54c71be$var$executionContext & 6)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $2344bd0db54c71be$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $2344bd0db54c71be$var$renderRootConcurrent(root$jscomp$0, lanes) : $2344bd0db54c71be$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $2344bd0db54c71be$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $2344bd0db54c71be$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$2344bd0db54c71be$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $2344bd0db54c71be$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $2344bd0db54c71be$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($2344bd0db54c71be$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $2344bd0db54c71be$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($2344bd0db54c71be$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $2344bd0db54c71be$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $2344bd0db54c71be$var$workInProgressRootRecoverableErrors;
                            $2344bd0db54c71be$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $2344bd0db54c71be$var$workInProgressRootRecoverableErrors ? $2344bd0db54c71be$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $2344bd0db54c71be$var$workInProgressRootRecoverableErrors.push.apply($2344bd0db54c71be$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $2344bd0db54c71be$var$prepareFreshStack(root$jscomp$0, 0);
                $2344bd0db54c71be$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($2344bd0db54c71be$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $2344bd0db54c71be$var$markRootSuspended(shouldTimeSlice, lanes, $2344bd0db54c71be$var$workInProgressDeferredLane, !$2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $2344bd0db54c71be$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($2344bd0db54c71be$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $2344bd0db54c71be$var$globalMostRecentFallbackTime + 300 - $2344bd0db54c71be$var$now(), 10 < exitStatus)) {
                    $2344bd0db54c71be$var$markRootSuspended(shouldTimeSlice, lanes, $2344bd0db54c71be$var$workInProgressDeferredLane, !$2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $2344bd0db54c71be$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $2344bd0db54c71be$var$scheduleTimeout($2344bd0db54c71be$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $2344bd0db54c71be$var$workInProgressRootRecoverableErrors, $2344bd0db54c71be$var$workInProgressTransitions, $2344bd0db54c71be$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2344bd0db54c71be$var$workInProgressDeferredLane, $2344bd0db54c71be$var$workInProgressRootInterleavedUpdatedLanes, $2344bd0db54c71be$var$workInProgressSuspendedRetryLanes, $2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $2344bd0db54c71be$var$commitRootWhenReady(shouldTimeSlice, forceSync, $2344bd0db54c71be$var$workInProgressRootRecoverableErrors, $2344bd0db54c71be$var$workInProgressTransitions, $2344bd0db54c71be$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2344bd0db54c71be$var$workInProgressDeferredLane, $2344bd0db54c71be$var$workInProgressRootInterleavedUpdatedLanes, $2344bd0db54c71be$var$workInProgressSuspendedRetryLanes, $2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $2344bd0db54c71be$var$ensureRootIsScheduled(root$jscomp$0);
}
function $2344bd0db54c71be$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($2344bd0db54c71be$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $2344bd0db54c71be$var$noop
        }, $2344bd0db54c71be$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $2344bd0db54c71be$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($2344bd0db54c71be$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $2344bd0db54c71be$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $2344bd0db54c71be$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $2344bd0db54c71be$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$2344bd0db54c71be$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $2344bd0db54c71be$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$2344bd0db54c71be$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$2344bd0db54c71be$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $2344bd0db54c71be$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $2344bd0db54c71be$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $2344bd0db54c71be$var$flushSyncWork$1() {
    return 0 === ($2344bd0db54c71be$var$executionContext & 6) ? ($2344bd0db54c71be$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $2344bd0db54c71be$var$resetWorkInProgressStack() {
    if (null !== $2344bd0db54c71be$var$workInProgress) {
        if (0 === $2344bd0db54c71be$var$workInProgressSuspendedReason) var interruptedWork = $2344bd0db54c71be$var$workInProgress.return;
        else interruptedWork = $2344bd0db54c71be$var$workInProgress, $2344bd0db54c71be$var$lastContextDependency = $2344bd0db54c71be$var$currentlyRenderingFiber$1 = null, $2344bd0db54c71be$var$resetHooksOnUnwind(interruptedWork), $2344bd0db54c71be$var$thenableState = null, $2344bd0db54c71be$var$thenableIndexCounter = 0, interruptedWork = $2344bd0db54c71be$var$workInProgress;
        for(; null !== interruptedWork;)$2344bd0db54c71be$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $2344bd0db54c71be$var$workInProgress = null;
    }
}
function $2344bd0db54c71be$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $2344bd0db54c71be$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $2344bd0db54c71be$var$resetWorkInProgressStack();
    $2344bd0db54c71be$var$workInProgressRoot = root;
    $2344bd0db54c71be$var$workInProgress = timeoutHandle = $2344bd0db54c71be$var$createWorkInProgress(root.current, null);
    $2344bd0db54c71be$var$workInProgressRootRenderLanes = lanes;
    $2344bd0db54c71be$var$workInProgressSuspendedReason = 0;
    $2344bd0db54c71be$var$workInProgressThrownValue = null;
    $2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $2344bd0db54c71be$var$workInProgressRootIsPrerendering = $2344bd0db54c71be$var$checkIfRootIsPrerendering(root, lanes);
    $2344bd0db54c71be$var$workInProgressRootDidAttachPingListener = !1;
    $2344bd0db54c71be$var$workInProgressSuspendedRetryLanes = $2344bd0db54c71be$var$workInProgressDeferredLane = $2344bd0db54c71be$var$workInProgressRootPingedLanes = $2344bd0db54c71be$var$workInProgressRootInterleavedUpdatedLanes = $2344bd0db54c71be$var$workInProgressRootSkippedLanes = $2344bd0db54c71be$var$workInProgressRootExitStatus = 0;
    $2344bd0db54c71be$var$workInProgressRootRecoverableErrors = $2344bd0db54c71be$var$workInProgressRootConcurrentErrors = null;
    $2344bd0db54c71be$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $2344bd0db54c71be$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $2344bd0db54c71be$var$entangledRenderLanes = lanes;
    $2344bd0db54c71be$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $2344bd0db54c71be$var$handleThrow(root, thrownValue) {
    $2344bd0db54c71be$var$currentlyRenderingFiber = null;
    $2344bd0db54c71be$var$ReactSharedInternals.H = $2344bd0db54c71be$var$ContextOnlyDispatcher;
    thrownValue === $2344bd0db54c71be$var$SuspenseException || thrownValue === $2344bd0db54c71be$var$SuspenseActionException ? (thrownValue = $2344bd0db54c71be$var$getSuspendedThenable(), $2344bd0db54c71be$var$workInProgressSuspendedReason = 3) : thrownValue === $2344bd0db54c71be$var$SuspenseyCommitException ? (thrownValue = $2344bd0db54c71be$var$getSuspendedThenable(), $2344bd0db54c71be$var$workInProgressSuspendedReason = 4) : $2344bd0db54c71be$var$workInProgressSuspendedReason = thrownValue === $2344bd0db54c71be$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $2344bd0db54c71be$var$workInProgressThrownValue = thrownValue;
    null === $2344bd0db54c71be$var$workInProgress && ($2344bd0db54c71be$var$workInProgressRootExitStatus = 1, $2344bd0db54c71be$var$logUncaughtError(root, $2344bd0db54c71be$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $2344bd0db54c71be$var$pushDispatcher() {
    var prevDispatcher = $2344bd0db54c71be$var$ReactSharedInternals.H;
    $2344bd0db54c71be$var$ReactSharedInternals.H = $2344bd0db54c71be$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $2344bd0db54c71be$var$ContextOnlyDispatcher : prevDispatcher;
}
function $2344bd0db54c71be$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $2344bd0db54c71be$var$ReactSharedInternals.A;
    $2344bd0db54c71be$var$ReactSharedInternals.A = $2344bd0db54c71be$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $2344bd0db54c71be$var$renderDidSuspendDelayIfPossible() {
    $2344bd0db54c71be$var$workInProgressRootExitStatus = 4;
    $2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings || ($2344bd0db54c71be$var$workInProgressRootRenderLanes & 4194048) !== $2344bd0db54c71be$var$workInProgressRootRenderLanes && null !== $2344bd0db54c71be$var$suspenseHandlerStackCursor.current || ($2344bd0db54c71be$var$workInProgressRootIsPrerendering = !0);
    0 === ($2344bd0db54c71be$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($2344bd0db54c71be$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $2344bd0db54c71be$var$workInProgressRoot || $2344bd0db54c71be$var$markRootSuspended($2344bd0db54c71be$var$workInProgressRoot, $2344bd0db54c71be$var$workInProgressRootRenderLanes, $2344bd0db54c71be$var$workInProgressDeferredLane, !1);
}
function $2344bd0db54c71be$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $2344bd0db54c71be$var$executionContext;
    $2344bd0db54c71be$var$executionContext |= 2;
    var prevDispatcher = $2344bd0db54c71be$var$pushDispatcher(), prevAsyncDispatcher = $2344bd0db54c71be$var$pushAsyncDispatcher();
    if ($2344bd0db54c71be$var$workInProgressRoot !== root || $2344bd0db54c71be$var$workInProgressRootRenderLanes !== lanes) $2344bd0db54c71be$var$workInProgressTransitions = null, $2344bd0db54c71be$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $2344bd0db54c71be$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $2344bd0db54c71be$var$workInProgressSuspendedReason && null !== $2344bd0db54c71be$var$workInProgress) {
            var unitOfWork = $2344bd0db54c71be$var$workInProgress, thrownValue = $2344bd0db54c71be$var$workInProgressThrownValue;
            switch($2344bd0db54c71be$var$workInProgressSuspendedReason){
                case 8:
                    $2344bd0db54c71be$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $2344bd0db54c71be$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $2344bd0db54c71be$var$workInProgressSuspendedReason;
                    $2344bd0db54c71be$var$workInProgressSuspendedReason = 0;
                    $2344bd0db54c71be$var$workInProgressThrownValue = null;
                    $2344bd0db54c71be$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $2344bd0db54c71be$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $2344bd0db54c71be$var$workInProgressSuspendedReason, $2344bd0db54c71be$var$workInProgressSuspendedReason = 0, $2344bd0db54c71be$var$workInProgressThrownValue = null, $2344bd0db54c71be$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $2344bd0db54c71be$var$workLoopSync();
        exitStatus = $2344bd0db54c71be$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $2344bd0db54c71be$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $2344bd0db54c71be$var$lastContextDependency = $2344bd0db54c71be$var$currentlyRenderingFiber$1 = null;
    $2344bd0db54c71be$var$executionContext = prevExecutionContext;
    $2344bd0db54c71be$var$ReactSharedInternals.H = prevDispatcher;
    $2344bd0db54c71be$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $2344bd0db54c71be$var$workInProgress && ($2344bd0db54c71be$var$workInProgressRoot = null, $2344bd0db54c71be$var$workInProgressRootRenderLanes = 0, $2344bd0db54c71be$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $2344bd0db54c71be$var$workLoopSync() {
    for(; null !== $2344bd0db54c71be$var$workInProgress;)$2344bd0db54c71be$var$performUnitOfWork($2344bd0db54c71be$var$workInProgress);
}
function $2344bd0db54c71be$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $2344bd0db54c71be$var$executionContext;
    $2344bd0db54c71be$var$executionContext |= 2;
    var prevDispatcher = $2344bd0db54c71be$var$pushDispatcher(), prevAsyncDispatcher = $2344bd0db54c71be$var$pushAsyncDispatcher();
    $2344bd0db54c71be$var$workInProgressRoot !== root || $2344bd0db54c71be$var$workInProgressRootRenderLanes !== lanes ? ($2344bd0db54c71be$var$workInProgressTransitions = null, $2344bd0db54c71be$var$workInProgressRootRenderTargetTime = $2344bd0db54c71be$var$now() + 500, $2344bd0db54c71be$var$prepareFreshStack(root, lanes)) : $2344bd0db54c71be$var$workInProgressRootIsPrerendering = $2344bd0db54c71be$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $2344bd0db54c71be$var$workInProgressSuspendedReason && null !== $2344bd0db54c71be$var$workInProgress) {
            lanes = $2344bd0db54c71be$var$workInProgress;
            var thrownValue = $2344bd0db54c71be$var$workInProgressThrownValue;
            b: switch($2344bd0db54c71be$var$workInProgressSuspendedReason){
                case 1:
                    $2344bd0db54c71be$var$workInProgressSuspendedReason = 0;
                    $2344bd0db54c71be$var$workInProgressThrownValue = null;
                    $2344bd0db54c71be$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($2344bd0db54c71be$var$isThenableResolved(thrownValue)) {
                        $2344bd0db54c71be$var$workInProgressSuspendedReason = 0;
                        $2344bd0db54c71be$var$workInProgressThrownValue = null;
                        $2344bd0db54c71be$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $2344bd0db54c71be$var$workInProgressSuspendedReason && 9 !== $2344bd0db54c71be$var$workInProgressSuspendedReason || $2344bd0db54c71be$var$workInProgressRoot !== root || ($2344bd0db54c71be$var$workInProgressSuspendedReason = 7);
                        $2344bd0db54c71be$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $2344bd0db54c71be$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $2344bd0db54c71be$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $2344bd0db54c71be$var$isThenableResolved(thrownValue) ? ($2344bd0db54c71be$var$workInProgressSuspendedReason = 0, $2344bd0db54c71be$var$workInProgressThrownValue = null, $2344bd0db54c71be$var$replaySuspendedUnitOfWork(lanes)) : ($2344bd0db54c71be$var$workInProgressSuspendedReason = 0, $2344bd0db54c71be$var$workInProgressThrownValue = null, $2344bd0db54c71be$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($2344bd0db54c71be$var$workInProgress.tag){
                        case 26:
                            resource = $2344bd0db54c71be$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $2344bd0db54c71be$var$workInProgress;
                            if (resource ? $2344bd0db54c71be$var$preloadResource(resource) : 1) {
                                $2344bd0db54c71be$var$workInProgressSuspendedReason = 0;
                                $2344bd0db54c71be$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $2344bd0db54c71be$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($2344bd0db54c71be$var$workInProgress = returnFiber, $2344bd0db54c71be$var$completeUnitOfWork(returnFiber)) : $2344bd0db54c71be$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $2344bd0db54c71be$var$workInProgressSuspendedReason = 0;
                    $2344bd0db54c71be$var$workInProgressThrownValue = null;
                    $2344bd0db54c71be$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $2344bd0db54c71be$var$workInProgressSuspendedReason = 0;
                    $2344bd0db54c71be$var$workInProgressThrownValue = null;
                    $2344bd0db54c71be$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $2344bd0db54c71be$var$resetWorkInProgressStack();
                    $2344bd0db54c71be$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(462));
            }
        }
        $2344bd0db54c71be$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $2344bd0db54c71be$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $2344bd0db54c71be$var$lastContextDependency = $2344bd0db54c71be$var$currentlyRenderingFiber$1 = null;
    $2344bd0db54c71be$var$ReactSharedInternals.H = prevDispatcher;
    $2344bd0db54c71be$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $2344bd0db54c71be$var$executionContext = prevExecutionContext;
    if (null !== $2344bd0db54c71be$var$workInProgress) return 0;
    $2344bd0db54c71be$var$workInProgressRoot = null;
    $2344bd0db54c71be$var$workInProgressRootRenderLanes = 0;
    $2344bd0db54c71be$var$finishQueueingConcurrentUpdates();
    return $2344bd0db54c71be$var$workInProgressRootExitStatus;
}
function $2344bd0db54c71be$var$workLoopConcurrentByScheduler() {
    for(; null !== $2344bd0db54c71be$var$workInProgress && !$2344bd0db54c71be$var$shouldYield();)$2344bd0db54c71be$var$performUnitOfWork($2344bd0db54c71be$var$workInProgress);
}
function $2344bd0db54c71be$var$performUnitOfWork(unitOfWork) {
    var next = $2344bd0db54c71be$var$beginWork(unitOfWork.alternate, unitOfWork, $2344bd0db54c71be$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2344bd0db54c71be$var$completeUnitOfWork(unitOfWork) : $2344bd0db54c71be$var$workInProgress = next;
}
function $2344bd0db54c71be$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $2344bd0db54c71be$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $2344bd0db54c71be$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $2344bd0db54c71be$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $2344bd0db54c71be$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $2344bd0db54c71be$var$resetHooksOnUnwind(next);
        default:
            $2344bd0db54c71be$var$unwindInterruptedWork(current, next), next = $2344bd0db54c71be$var$workInProgress = $2344bd0db54c71be$var$resetWorkInProgress(next, $2344bd0db54c71be$var$entangledRenderLanes), next = $2344bd0db54c71be$var$beginWork(current, next, $2344bd0db54c71be$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2344bd0db54c71be$var$completeUnitOfWork(unitOfWork) : $2344bd0db54c71be$var$workInProgress = next;
}
function $2344bd0db54c71be$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $2344bd0db54c71be$var$lastContextDependency = $2344bd0db54c71be$var$currentlyRenderingFiber$1 = null;
    $2344bd0db54c71be$var$resetHooksOnUnwind(unitOfWork);
    $2344bd0db54c71be$var$thenableState = null;
    $2344bd0db54c71be$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($2344bd0db54c71be$var$throwException(root, returnFiber, unitOfWork, thrownValue, $2344bd0db54c71be$var$workInProgressRootRenderLanes)) {
            $2344bd0db54c71be$var$workInProgressRootExitStatus = 1;
            $2344bd0db54c71be$var$logUncaughtError(root, $2344bd0db54c71be$var$createCapturedValueAtFiber(thrownValue, root.current));
            $2344bd0db54c71be$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $2344bd0db54c71be$var$workInProgress = returnFiber, error;
        $2344bd0db54c71be$var$workInProgressRootExitStatus = 1;
        $2344bd0db54c71be$var$logUncaughtError(root, $2344bd0db54c71be$var$createCapturedValueAtFiber(thrownValue, root.current));
        $2344bd0db54c71be$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($2344bd0db54c71be$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($2344bd0db54c71be$var$workInProgressRootIsPrerendering || 0 !== ($2344bd0db54c71be$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $2344bd0db54c71be$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $2344bd0db54c71be$var$unwindUnitOfWork(unitOfWork, root);
    } else $2344bd0db54c71be$var$completeUnitOfWork(unitOfWork);
}
function $2344bd0db54c71be$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $2344bd0db54c71be$var$unwindUnitOfWork(completedWork, $2344bd0db54c71be$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $2344bd0db54c71be$var$completeWork(completedWork.alternate, completedWork, $2344bd0db54c71be$var$entangledRenderLanes);
        if (null !== next) {
            $2344bd0db54c71be$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $2344bd0db54c71be$var$workInProgress = completedWork;
            return;
        }
        $2344bd0db54c71be$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $2344bd0db54c71be$var$workInProgressRootExitStatus && ($2344bd0db54c71be$var$workInProgressRootExitStatus = 5);
}
function $2344bd0db54c71be$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $2344bd0db54c71be$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $2344bd0db54c71be$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $2344bd0db54c71be$var$workInProgress = unitOfWork;
            return;
        }
        $2344bd0db54c71be$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $2344bd0db54c71be$var$workInProgressRootExitStatus = 6;
    $2344bd0db54c71be$var$workInProgress = null;
}
function $2344bd0db54c71be$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $2344bd0db54c71be$var$flushPendingEffects();
    while (0 !== $2344bd0db54c71be$var$pendingEffectsStatus);
    if (0 !== ($2344bd0db54c71be$var$executionContext & 6)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $2344bd0db54c71be$var$concurrentlyUpdatedLanes;
        $2344bd0db54c71be$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $2344bd0db54c71be$var$workInProgressRoot && ($2344bd0db54c71be$var$workInProgress = $2344bd0db54c71be$var$workInProgressRoot = null, $2344bd0db54c71be$var$workInProgressRootRenderLanes = 0);
        $2344bd0db54c71be$var$pendingFinishedWork = finishedWork;
        $2344bd0db54c71be$var$pendingEffectsRoot = root;
        $2344bd0db54c71be$var$pendingEffectsLanes = lanes;
        $2344bd0db54c71be$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $2344bd0db54c71be$var$pendingPassiveTransitions = transitions;
        $2344bd0db54c71be$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $2344bd0db54c71be$var$scheduleCallback$1($2344bd0db54c71be$var$NormalPriority$1, function() {
            $2344bd0db54c71be$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $2344bd0db54c71be$var$ReactSharedInternals.T;
            $2344bd0db54c71be$var$ReactSharedInternals.T = null;
            transitions = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
            $2344bd0db54c71be$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $2344bd0db54c71be$var$executionContext;
            $2344bd0db54c71be$var$executionContext |= 4;
            try {
                $2344bd0db54c71be$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $2344bd0db54c71be$var$executionContext = spawnedLane, $2344bd0db54c71be$var$ReactDOMSharedInternals.p = transitions, $2344bd0db54c71be$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $2344bd0db54c71be$var$pendingEffectsStatus = 1;
        $2344bd0db54c71be$var$flushMutationEffects();
        $2344bd0db54c71be$var$flushLayoutEffects();
        $2344bd0db54c71be$var$flushSpawnedWork();
    }
}
function $2344bd0db54c71be$var$flushMutationEffects() {
    if (1 === $2344bd0db54c71be$var$pendingEffectsStatus) {
        $2344bd0db54c71be$var$pendingEffectsStatus = 0;
        var root = $2344bd0db54c71be$var$pendingEffectsRoot, finishedWork = $2344bd0db54c71be$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $2344bd0db54c71be$var$ReactSharedInternals.T;
            $2344bd0db54c71be$var$ReactSharedInternals.T = null;
            var previousPriority = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
            $2344bd0db54c71be$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2344bd0db54c71be$var$executionContext;
            $2344bd0db54c71be$var$executionContext |= 4;
            try {
                $2344bd0db54c71be$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $2344bd0db54c71be$var$selectionInformation, curFocusedElem = $2344bd0db54c71be$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $2344bd0db54c71be$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $2344bd0db54c71be$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $2344bd0db54c71be$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $2344bd0db54c71be$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $2344bd0db54c71be$var$_enabled = !!$2344bd0db54c71be$var$eventsEnabled;
                $2344bd0db54c71be$var$selectionInformation = $2344bd0db54c71be$var$eventsEnabled = null;
            } finally{
                $2344bd0db54c71be$var$executionContext = prevExecutionContext, $2344bd0db54c71be$var$ReactDOMSharedInternals.p = previousPriority, $2344bd0db54c71be$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $2344bd0db54c71be$var$pendingEffectsStatus = 2;
    }
}
function $2344bd0db54c71be$var$flushLayoutEffects() {
    if (2 === $2344bd0db54c71be$var$pendingEffectsStatus) {
        $2344bd0db54c71be$var$pendingEffectsStatus = 0;
        var root = $2344bd0db54c71be$var$pendingEffectsRoot, finishedWork = $2344bd0db54c71be$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $2344bd0db54c71be$var$ReactSharedInternals.T;
            $2344bd0db54c71be$var$ReactSharedInternals.T = null;
            var previousPriority = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
            $2344bd0db54c71be$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2344bd0db54c71be$var$executionContext;
            $2344bd0db54c71be$var$executionContext |= 4;
            try {
                $2344bd0db54c71be$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $2344bd0db54c71be$var$executionContext = prevExecutionContext, $2344bd0db54c71be$var$ReactDOMSharedInternals.p = previousPriority, $2344bd0db54c71be$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $2344bd0db54c71be$var$pendingEffectsStatus = 3;
    }
}
function $2344bd0db54c71be$var$flushSpawnedWork() {
    if (4 === $2344bd0db54c71be$var$pendingEffectsStatus || 3 === $2344bd0db54c71be$var$pendingEffectsStatus) {
        $2344bd0db54c71be$var$pendingEffectsStatus = 0;
        $2344bd0db54c71be$var$requestPaint();
        var root = $2344bd0db54c71be$var$pendingEffectsRoot, finishedWork = $2344bd0db54c71be$var$pendingFinishedWork, lanes = $2344bd0db54c71be$var$pendingEffectsLanes, recoverableErrors = $2344bd0db54c71be$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $2344bd0db54c71be$var$pendingEffectsStatus = 5 : ($2344bd0db54c71be$var$pendingEffectsStatus = 0, $2344bd0db54c71be$var$pendingFinishedWork = $2344bd0db54c71be$var$pendingEffectsRoot = null, $2344bd0db54c71be$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $2344bd0db54c71be$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($2344bd0db54c71be$var$injectedHook && "function" === typeof $2344bd0db54c71be$var$injectedHook.onCommitFiberRoot) try {
            $2344bd0db54c71be$var$injectedHook.onCommitFiberRoot($2344bd0db54c71be$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $2344bd0db54c71be$var$ReactSharedInternals.T;
            remainingLanes = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
            $2344bd0db54c71be$var$ReactDOMSharedInternals.p = 2;
            $2344bd0db54c71be$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $2344bd0db54c71be$var$ReactSharedInternals.T = finishedWork, $2344bd0db54c71be$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($2344bd0db54c71be$var$pendingEffectsLanes & 3) && $2344bd0db54c71be$var$flushPendingEffects();
        $2344bd0db54c71be$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $2344bd0db54c71be$var$rootWithNestedUpdates ? $2344bd0db54c71be$var$nestedUpdateCount++ : ($2344bd0db54c71be$var$nestedUpdateCount = 0, $2344bd0db54c71be$var$rootWithNestedUpdates = root) : $2344bd0db54c71be$var$nestedUpdateCount = 0;
        $2344bd0db54c71be$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $2344bd0db54c71be$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $2344bd0db54c71be$var$releaseCache(remainingLanes)));
}
function $2344bd0db54c71be$var$flushPendingEffects(wasDelayedCommit) {
    $2344bd0db54c71be$var$flushMutationEffects();
    $2344bd0db54c71be$var$flushLayoutEffects();
    $2344bd0db54c71be$var$flushSpawnedWork();
    return $2344bd0db54c71be$var$flushPassiveEffects(wasDelayedCommit);
}
function $2344bd0db54c71be$var$flushPassiveEffects() {
    if (5 !== $2344bd0db54c71be$var$pendingEffectsStatus) return !1;
    var root = $2344bd0db54c71be$var$pendingEffectsRoot, remainingLanes = $2344bd0db54c71be$var$pendingEffectsRemainingLanes;
    $2344bd0db54c71be$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $2344bd0db54c71be$var$lanesToEventPriority($2344bd0db54c71be$var$pendingEffectsLanes), prevTransition = $2344bd0db54c71be$var$ReactSharedInternals.T, previousPriority = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
    try {
        $2344bd0db54c71be$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $2344bd0db54c71be$var$ReactSharedInternals.T = null;
        renderPriority = $2344bd0db54c71be$var$pendingPassiveTransitions;
        $2344bd0db54c71be$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $2344bd0db54c71be$var$pendingEffectsRoot, lanes = $2344bd0db54c71be$var$pendingEffectsLanes;
        $2344bd0db54c71be$var$pendingEffectsStatus = 0;
        $2344bd0db54c71be$var$pendingFinishedWork = $2344bd0db54c71be$var$pendingEffectsRoot = null;
        $2344bd0db54c71be$var$pendingEffectsLanes = 0;
        if (0 !== ($2344bd0db54c71be$var$executionContext & 6)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(331));
        var prevExecutionContext = $2344bd0db54c71be$var$executionContext;
        $2344bd0db54c71be$var$executionContext |= 4;
        $2344bd0db54c71be$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $2344bd0db54c71be$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $2344bd0db54c71be$var$executionContext = prevExecutionContext;
        $2344bd0db54c71be$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($2344bd0db54c71be$var$injectedHook && "function" === typeof $2344bd0db54c71be$var$injectedHook.onPostCommitFiberRoot) try {
            $2344bd0db54c71be$var$injectedHook.onPostCommitFiberRoot($2344bd0db54c71be$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $2344bd0db54c71be$var$ReactDOMSharedInternals.p = previousPriority, $2344bd0db54c71be$var$ReactSharedInternals.T = prevTransition, $2344bd0db54c71be$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $2344bd0db54c71be$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $2344bd0db54c71be$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $2344bd0db54c71be$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $2344bd0db54c71be$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($2344bd0db54c71be$var$markRootUpdated$1(rootFiber, 2), $2344bd0db54c71be$var$ensureRootIsScheduled(rootFiber));
}
function $2344bd0db54c71be$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $2344bd0db54c71be$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $2344bd0db54c71be$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed || !$2344bd0db54c71be$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $2344bd0db54c71be$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $2344bd0db54c71be$var$createClassErrorUpdate(2);
                instance = $2344bd0db54c71be$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($2344bd0db54c71be$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $2344bd0db54c71be$var$markRootUpdated$1(instance, 2), $2344bd0db54c71be$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $2344bd0db54c71be$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $2344bd0db54c71be$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($2344bd0db54c71be$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $2344bd0db54c71be$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $2344bd0db54c71be$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $2344bd0db54c71be$var$workInProgressRoot === root && ($2344bd0db54c71be$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $2344bd0db54c71be$var$workInProgressRootExitStatus || 3 === $2344bd0db54c71be$var$workInProgressRootExitStatus && ($2344bd0db54c71be$var$workInProgressRootRenderLanes & 62914560) === $2344bd0db54c71be$var$workInProgressRootRenderLanes && 300 > $2344bd0db54c71be$var$now() - $2344bd0db54c71be$var$globalMostRecentFallbackTime ? 0 === ($2344bd0db54c71be$var$executionContext & 2) && $2344bd0db54c71be$var$prepareFreshStack(root, 0) : $2344bd0db54c71be$var$workInProgressRootPingedLanes |= pingedLanes, $2344bd0db54c71be$var$workInProgressSuspendedRetryLanes === $2344bd0db54c71be$var$workInProgressRootRenderLanes && ($2344bd0db54c71be$var$workInProgressSuspendedRetryLanes = 0));
    $2344bd0db54c71be$var$ensureRootIsScheduled(root);
}
function $2344bd0db54c71be$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $2344bd0db54c71be$var$claimNextRetryLane());
    boundaryFiber = $2344bd0db54c71be$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($2344bd0db54c71be$var$markRootUpdated$1(boundaryFiber, retryLane), $2344bd0db54c71be$var$ensureRootIsScheduled(boundaryFiber));
}
function $2344bd0db54c71be$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $2344bd0db54c71be$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2344bd0db54c71be$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($2344bd0db54c71be$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $2344bd0db54c71be$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2344bd0db54c71be$var$scheduleCallback$1(priorityLevel, callback) {
    return $2344bd0db54c71be$var$scheduleCallback$3(priorityLevel, callback);
}
var $2344bd0db54c71be$var$firstScheduledRoot = null, $2344bd0db54c71be$var$lastScheduledRoot = null, $2344bd0db54c71be$var$didScheduleMicrotask = !1, $2344bd0db54c71be$var$mightHavePendingSyncWork = !1, $2344bd0db54c71be$var$isFlushingWork = !1, $2344bd0db54c71be$var$currentEventTransitionLane = 0;
function $2344bd0db54c71be$var$ensureRootIsScheduled(root) {
    root !== $2344bd0db54c71be$var$lastScheduledRoot && null === root.next && (null === $2344bd0db54c71be$var$lastScheduledRoot ? $2344bd0db54c71be$var$firstScheduledRoot = $2344bd0db54c71be$var$lastScheduledRoot = root : $2344bd0db54c71be$var$lastScheduledRoot = $2344bd0db54c71be$var$lastScheduledRoot.next = root);
    $2344bd0db54c71be$var$mightHavePendingSyncWork = !0;
    $2344bd0db54c71be$var$didScheduleMicrotask || ($2344bd0db54c71be$var$didScheduleMicrotask = !0, $2344bd0db54c71be$var$scheduleImmediateRootScheduleTask());
}
function $2344bd0db54c71be$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$2344bd0db54c71be$var$isFlushingWork && $2344bd0db54c71be$var$mightHavePendingSyncWork) {
        $2344bd0db54c71be$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $2344bd0db54c71be$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $2344bd0db54c71be$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $2344bd0db54c71be$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $2344bd0db54c71be$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $2344bd0db54c71be$var$getNextLanes(root$174, root$174 === $2344bd0db54c71be$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $2344bd0db54c71be$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $2344bd0db54c71be$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $2344bd0db54c71be$var$isFlushingWork = !1;
    }
}
function $2344bd0db54c71be$var$processRootScheduleInImmediateTask() {
    $2344bd0db54c71be$var$processRootScheduleInMicrotask();
}
function $2344bd0db54c71be$var$processRootScheduleInMicrotask() {
    $2344bd0db54c71be$var$mightHavePendingSyncWork = $2344bd0db54c71be$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $2344bd0db54c71be$var$currentEventTransitionLane && ($2344bd0db54c71be$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $2344bd0db54c71be$var$currentEventTransitionLane), $2344bd0db54c71be$var$currentEventTransitionLane = 0);
    for(var currentTime = $2344bd0db54c71be$var$now(), prev = null, root = $2344bd0db54c71be$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $2344bd0db54c71be$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $2344bd0db54c71be$var$firstScheduledRoot = next : prev.next = next, null === next && ($2344bd0db54c71be$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $2344bd0db54c71be$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $2344bd0db54c71be$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $2344bd0db54c71be$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $2344bd0db54c71be$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $2344bd0db54c71be$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $2344bd0db54c71be$var$workInProgressRoot;
    suspendedLanes = $2344bd0db54c71be$var$workInProgressRootRenderLanes;
    suspendedLanes = $2344bd0db54c71be$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $2344bd0db54c71be$var$workInProgressSuspendedReason || 9 === $2344bd0db54c71be$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $2344bd0db54c71be$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $2344bd0db54c71be$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $2344bd0db54c71be$var$cancelCallback$1(pingedLanes);
        switch($2344bd0db54c71be$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $2344bd0db54c71be$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $2344bd0db54c71be$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $2344bd0db54c71be$var$IdlePriority;
                break;
            default:
                suspendedLanes = $2344bd0db54c71be$var$NormalPriority$1;
        }
        pingedLanes = $2344bd0db54c71be$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $2344bd0db54c71be$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $2344bd0db54c71be$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $2344bd0db54c71be$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $2344bd0db54c71be$var$pendingEffectsStatus && 5 !== $2344bd0db54c71be$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($2344bd0db54c71be$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $2344bd0db54c71be$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $2344bd0db54c71be$var$getNextLanes(root, root === $2344bd0db54c71be$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $2344bd0db54c71be$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $2344bd0db54c71be$var$scheduleTaskForRootDuringMicrotask(root, $2344bd0db54c71be$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $2344bd0db54c71be$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $2344bd0db54c71be$var$performSyncWorkOnRoot(root, lanes) {
    if ($2344bd0db54c71be$var$flushPendingEffects()) return null;
    $2344bd0db54c71be$var$performWorkOnRoot(root, lanes, !0);
}
function $2344bd0db54c71be$var$scheduleImmediateRootScheduleTask() {
    $2344bd0db54c71be$var$scheduleMicrotask(function() {
        0 !== ($2344bd0db54c71be$var$executionContext & 6) ? $2344bd0db54c71be$var$scheduleCallback$3($2344bd0db54c71be$var$ImmediatePriority, $2344bd0db54c71be$var$processRootScheduleInImmediateTask) : $2344bd0db54c71be$var$processRootScheduleInMicrotask();
    });
}
function $2344bd0db54c71be$var$requestTransitionLane() {
    0 === $2344bd0db54c71be$var$currentEventTransitionLane && ($2344bd0db54c71be$var$currentEventTransitionLane = $2344bd0db54c71be$var$claimNextTransitionLane());
    return $2344bd0db54c71be$var$currentEventTransitionLane;
}
function $2344bd0db54c71be$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $2344bd0db54c71be$var$sanitizeURL("" + actionProp);
}
function $2344bd0db54c71be$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $2344bd0db54c71be$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $2344bd0db54c71be$var$coerceFormActionProp((nativeEventTarget[$2344bd0db54c71be$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$2344bd0db54c71be$var$internalPropsKey] || null) ? $2344bd0db54c71be$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $2344bd0db54c71be$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $2344bd0db54c71be$var$currentEventTransitionLane) {
                                var formData = submitter ? $2344bd0db54c71be$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $2344bd0db54c71be$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $2344bd0db54c71be$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $2344bd0db54c71be$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $2344bd0db54c71be$var$i$jscomp$inline_1528 = 0; $2344bd0db54c71be$var$i$jscomp$inline_1528 < $2344bd0db54c71be$var$simpleEventPluginEvents.length; $2344bd0db54c71be$var$i$jscomp$inline_1528++){
    var $2344bd0db54c71be$var$eventName$jscomp$inline_1529 = $2344bd0db54c71be$var$simpleEventPluginEvents[$2344bd0db54c71be$var$i$jscomp$inline_1528], $2344bd0db54c71be$var$domEventName$jscomp$inline_1530 = $2344bd0db54c71be$var$eventName$jscomp$inline_1529.toLowerCase(), $2344bd0db54c71be$var$capitalizedEvent$jscomp$inline_1531 = $2344bd0db54c71be$var$eventName$jscomp$inline_1529[0].toUpperCase() + $2344bd0db54c71be$var$eventName$jscomp$inline_1529.slice(1);
    $2344bd0db54c71be$var$registerSimpleEvent($2344bd0db54c71be$var$domEventName$jscomp$inline_1530, "on" + $2344bd0db54c71be$var$capitalizedEvent$jscomp$inline_1531);
}
$2344bd0db54c71be$var$registerSimpleEvent($2344bd0db54c71be$var$ANIMATION_END, "onAnimationEnd");
$2344bd0db54c71be$var$registerSimpleEvent($2344bd0db54c71be$var$ANIMATION_ITERATION, "onAnimationIteration");
$2344bd0db54c71be$var$registerSimpleEvent($2344bd0db54c71be$var$ANIMATION_START, "onAnimationStart");
$2344bd0db54c71be$var$registerSimpleEvent("dblclick", "onDoubleClick");
$2344bd0db54c71be$var$registerSimpleEvent("focusin", "onFocus");
$2344bd0db54c71be$var$registerSimpleEvent("focusout", "onBlur");
$2344bd0db54c71be$var$registerSimpleEvent($2344bd0db54c71be$var$TRANSITION_RUN, "onTransitionRun");
$2344bd0db54c71be$var$registerSimpleEvent($2344bd0db54c71be$var$TRANSITION_START, "onTransitionStart");
$2344bd0db54c71be$var$registerSimpleEvent($2344bd0db54c71be$var$TRANSITION_CANCEL, "onTransitionCancel");
$2344bd0db54c71be$var$registerSimpleEvent($2344bd0db54c71be$var$TRANSITION_END, "onTransitionEnd");
$2344bd0db54c71be$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2344bd0db54c71be$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2344bd0db54c71be$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2344bd0db54c71be$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2344bd0db54c71be$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2344bd0db54c71be$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2344bd0db54c71be$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2344bd0db54c71be$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2344bd0db54c71be$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2344bd0db54c71be$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2344bd0db54c71be$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2344bd0db54c71be$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($2344bd0db54c71be$var$mediaEventTypes));
function $2344bd0db54c71be$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2344bd0db54c71be$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2344bd0db54c71be$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $2344bd0db54c71be$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$2344bd0db54c71be$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$2344bd0db54c71be$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($2344bd0db54c71be$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $2344bd0db54c71be$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $2344bd0db54c71be$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $2344bd0db54c71be$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $2344bd0db54c71be$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$2344bd0db54c71be$var$listeningMarker]) {
        rootContainerElement[$2344bd0db54c71be$var$listeningMarker] = !0;
        $2344bd0db54c71be$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($2344bd0db54c71be$var$nonDelegatedEvents.has(domEventName) || $2344bd0db54c71be$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $2344bd0db54c71be$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$2344bd0db54c71be$var$listeningMarker] || (ownerDocument[$2344bd0db54c71be$var$listeningMarker] = !0, $2344bd0db54c71be$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $2344bd0db54c71be$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($2344bd0db54c71be$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $2344bd0db54c71be$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $2344bd0db54c71be$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $2344bd0db54c71be$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$2344bd0db54c71be$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $2344bd0db54c71be$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $2344bd0db54c71be$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $2344bd0db54c71be$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $2344bd0db54c71be$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $2344bd0db54c71be$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $2344bd0db54c71be$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticTouchEvent;
                        break;
                    case $2344bd0db54c71be$var$ANIMATION_END:
                    case $2344bd0db54c71be$var$ANIMATION_ITERATION:
                    case $2344bd0db54c71be$var$ANIMATION_START:
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticAnimationEvent;
                        break;
                    case $2344bd0db54c71be$var$TRANSITION_END:
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $2344bd0db54c71be$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $2344bd0db54c71be$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($2344bd0db54c71be$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $2344bd0db54c71be$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($2344bd0db54c71be$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$2344bd0db54c71be$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $2344bd0db54c71be$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $2344bd0db54c71be$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $2344bd0db54c71be$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $2344bd0db54c71be$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $2344bd0db54c71be$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $2344bd0db54c71be$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $2344bd0db54c71be$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $2344bd0db54c71be$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $2344bd0db54c71be$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $2344bd0db54c71be$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $2344bd0db54c71be$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $2344bd0db54c71be$var$getParent(inCapturePhase);
                                reactEventName = $2344bd0db54c71be$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $2344bd0db54c71be$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $2344bd0db54c71be$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $2344bd0db54c71be$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $2344bd0db54c71be$var$getTargetInstForChangeEvent;
                else if ($2344bd0db54c71be$var$isTextInputElement(reactName)) {
                    if ($2344bd0db54c71be$var$isInputEventSupported) getTargetInstFunc = $2344bd0db54c71be$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $2344bd0db54c71be$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $2344bd0db54c71be$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $2344bd0db54c71be$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $2344bd0db54c71be$var$getTargetInstForChangeEvent) : getTargetInstFunc = $2344bd0db54c71be$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $2344bd0db54c71be$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $2344bd0db54c71be$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $2344bd0db54c71be$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($2344bd0db54c71be$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $2344bd0db54c71be$var$activeElement = handleEventFunc, $2344bd0db54c71be$var$activeElementInst = targetInst, $2344bd0db54c71be$var$lastSelection = null;
                    break;
                case "focusout":
                    $2344bd0db54c71be$var$lastSelection = $2344bd0db54c71be$var$activeElementInst = $2344bd0db54c71be$var$activeElement = null;
                    break;
                case "mousedown":
                    $2344bd0db54c71be$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2344bd0db54c71be$var$mouseDown = !1;
                    $2344bd0db54c71be$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($2344bd0db54c71be$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $2344bd0db54c71be$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($2344bd0db54c71be$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $2344bd0db54c71be$var$isComposing ? $2344bd0db54c71be$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($2344bd0db54c71be$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($2344bd0db54c71be$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $2344bd0db54c71be$var$isComposing && (fallbackData = $2344bd0db54c71be$var$getData()) : ($2344bd0db54c71be$var$root = nativeEventTarget, $2344bd0db54c71be$var$startText = "value" in $2344bd0db54c71be$var$root ? $2344bd0db54c71be$var$root.value : $2344bd0db54c71be$var$root.textContent, $2344bd0db54c71be$var$isComposing = !0)), handleEventFunc = $2344bd0db54c71be$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $2344bd0db54c71be$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $2344bd0db54c71be$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $2344bd0db54c71be$var$canUseTextInputEvent ? $2344bd0db54c71be$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $2344bd0db54c71be$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $2344bd0db54c71be$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $2344bd0db54c71be$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $2344bd0db54c71be$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $2344bd0db54c71be$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $2344bd0db54c71be$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $2344bd0db54c71be$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $2344bd0db54c71be$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($2344bd0db54c71be$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $2344bd0db54c71be$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($2344bd0db54c71be$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $2344bd0db54c71be$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $2344bd0db54c71be$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $2344bd0db54c71be$var$getListener(target, registrationName), null != stateNode && listeners.unshift($2344bd0db54c71be$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $2344bd0db54c71be$var$getListener(target, registrationName), null != stateNode && listeners.push($2344bd0db54c71be$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $2344bd0db54c71be$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $2344bd0db54c71be$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $2344bd0db54c71be$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($2344bd0db54c71be$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($2344bd0db54c71be$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $2344bd0db54c71be$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $2344bd0db54c71be$var$normalizeMarkupForTextOrAttribute(clientText);
    return $2344bd0db54c71be$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $2344bd0db54c71be$var$noop$1() {}
function $2344bd0db54c71be$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $2344bd0db54c71be$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $2344bd0db54c71be$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $2344bd0db54c71be$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $2344bd0db54c71be$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $2344bd0db54c71be$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $2344bd0db54c71be$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $2344bd0db54c71be$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2344bd0db54c71be$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $2344bd0db54c71be$var$setProp(domElement, tag, "name", props.name, props, null), $2344bd0db54c71be$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $2344bd0db54c71be$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $2344bd0db54c71be$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($2344bd0db54c71be$var$setProp(domElement, tag, "encType", props.encType, props, null), $2344bd0db54c71be$var$setProp(domElement, tag, "method", props.method, props, null), $2344bd0db54c71be$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2344bd0db54c71be$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2344bd0db54c71be$var$noop$1);
            break;
        case "onScroll":
            null != value && $2344bd0db54c71be$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2344bd0db54c71be$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $2344bd0db54c71be$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("toggle", domElement);
            $2344bd0db54c71be$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $2344bd0db54c71be$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $2344bd0db54c71be$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $2344bd0db54c71be$var$aliases.get(key) || key, $2344bd0db54c71be$var$setValueForAttribute(domElement, key, value);
    }
}
function $2344bd0db54c71be$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $2344bd0db54c71be$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $2344bd0db54c71be$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $2344bd0db54c71be$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $2344bd0db54c71be$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2344bd0db54c71be$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2344bd0db54c71be$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$2344bd0db54c71be$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$2344bd0db54c71be$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $2344bd0db54c71be$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $2344bd0db54c71be$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("error", domElement);
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($2344bd0db54c71be$var$formatProdErrorMessage(137, tag));
                    default:
                        $2344bd0db54c71be$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $2344bd0db54c71be$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $2344bd0db54c71be$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $2344bd0db54c71be$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $2344bd0db54c71be$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $2344bd0db54c71be$var$track(domElement);
            return;
        case "select":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $2344bd0db54c71be$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $2344bd0db54c71be$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $2344bd0db54c71be$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(91));
                    break;
                default:
                    $2344bd0db54c71be$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $2344bd0db54c71be$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $2344bd0db54c71be$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $2344bd0db54c71be$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("toggle", domElement);
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("cancel", domElement);
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $2344bd0db54c71be$var$mediaEventTypes.length; hasSrc++)$2344bd0db54c71be$var$listenToNonDelegatedEvent($2344bd0db54c71be$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("error", domElement);
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $2344bd0db54c71be$var$listenToNonDelegatedEvent("error", domElement), $2344bd0db54c71be$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2344bd0db54c71be$var$formatProdErrorMessage(137, tag));
                default:
                    $2344bd0db54c71be$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($2344bd0db54c71be$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $2344bd0db54c71be$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $2344bd0db54c71be$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $2344bd0db54c71be$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $2344bd0db54c71be$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $2344bd0db54c71be$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $2344bd0db54c71be$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $2344bd0db54c71be$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $2344bd0db54c71be$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $2344bd0db54c71be$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $2344bd0db54c71be$var$updateOptions(domElement, !!lastProps, tag, !0) : $2344bd0db54c71be$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $2344bd0db54c71be$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $2344bd0db54c71be$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $2344bd0db54c71be$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $2344bd0db54c71be$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $2344bd0db54c71be$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $2344bd0db54c71be$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $2344bd0db54c71be$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($2344bd0db54c71be$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $2344bd0db54c71be$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $2344bd0db54c71be$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $2344bd0db54c71be$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $2344bd0db54c71be$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $2344bd0db54c71be$var$eventsEnabled = null, $2344bd0db54c71be$var$selectionInformation = null;
function $2344bd0db54c71be$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $2344bd0db54c71be$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $2344bd0db54c71be$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $2344bd0db54c71be$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $2344bd0db54c71be$var$currentPopstateTransitionEvent = null;
function $2344bd0db54c71be$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $2344bd0db54c71be$var$currentPopstateTransitionEvent) return !1;
        $2344bd0db54c71be$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $2344bd0db54c71be$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $2344bd0db54c71be$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $2344bd0db54c71be$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $2344bd0db54c71be$var$localPromise = "function" === typeof Promise ? Promise : void 0, $2344bd0db54c71be$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2344bd0db54c71be$var$localPromise ? function(callback) {
    return $2344bd0db54c71be$var$localPromise.resolve(null).then(callback).catch($2344bd0db54c71be$var$handleErrorInNextTick);
} : $2344bd0db54c71be$var$scheduleTimeout;
function $2344bd0db54c71be$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $2344bd0db54c71be$var$isSingletonScope(type) {
    return "head" === type;
}
function $2344bd0db54c71be$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $2344bd0db54c71be$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $2344bd0db54c71be$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $2344bd0db54c71be$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$2344bd0db54c71be$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $2344bd0db54c71be$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $2344bd0db54c71be$var$retryIfBlockedOn(suspenseInstance);
}
function $2344bd0db54c71be$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $2344bd0db54c71be$var$clearContainerSparingly(node);
                $2344bd0db54c71be$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $2344bd0db54c71be$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$2344bd0db54c71be$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $2344bd0db54c71be$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $2344bd0db54c71be$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $2344bd0db54c71be$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $2344bd0db54c71be$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $2344bd0db54c71be$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $2344bd0db54c71be$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $2344bd0db54c71be$var$previousHydratableOnEnteringScopedSingleton = null;
function $2344bd0db54c71be$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $2344bd0db54c71be$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $2344bd0db54c71be$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($2344bd0db54c71be$var$formatProdErrorMessage(451));
    }
}
function $2344bd0db54c71be$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $2344bd0db54c71be$var$detachDeletedInstance(instance);
}
var $2344bd0db54c71be$var$preloadPropsMap = new Map(), $2344bd0db54c71be$var$preconnectsSet = new Set();
function $2344bd0db54c71be$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $2344bd0db54c71be$var$previousDispatcher = $2344bd0db54c71be$var$ReactDOMSharedInternals.d;
$2344bd0db54c71be$var$ReactDOMSharedInternals.d = {
    f: $2344bd0db54c71be$var$flushSyncWork,
    r: $2344bd0db54c71be$var$requestFormReset,
    D: $2344bd0db54c71be$var$prefetchDNS,
    C: $2344bd0db54c71be$var$preconnect,
    L: $2344bd0db54c71be$var$preload,
    m: $2344bd0db54c71be$var$preloadModule,
    X: $2344bd0db54c71be$var$preinitScript,
    S: $2344bd0db54c71be$var$preinitStyle,
    M: $2344bd0db54c71be$var$preinitModuleScript
};
function $2344bd0db54c71be$var$flushSyncWork() {
    var previousWasRendering = $2344bd0db54c71be$var$previousDispatcher.f(), wasRendering = $2344bd0db54c71be$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $2344bd0db54c71be$var$requestFormReset(form) {
    var formInst = $2344bd0db54c71be$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $2344bd0db54c71be$var$requestFormReset$1(formInst) : $2344bd0db54c71be$var$previousDispatcher.r(form);
}
var $2344bd0db54c71be$var$globalDocument = "undefined" === typeof document ? null : document;
function $2344bd0db54c71be$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $2344bd0db54c71be$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $2344bd0db54c71be$var$preconnectsSet.has(limitedEscapedHref) || ($2344bd0db54c71be$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $2344bd0db54c71be$var$setInitialProperties(href, "link", rel), $2344bd0db54c71be$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $2344bd0db54c71be$var$prefetchDNS(href) {
    $2344bd0db54c71be$var$previousDispatcher.D(href);
    $2344bd0db54c71be$var$preconnectAs("dns-prefetch", href, null);
}
function $2344bd0db54c71be$var$preconnect(href, crossOrigin) {
    $2344bd0db54c71be$var$previousDispatcher.C(href, crossOrigin);
    $2344bd0db54c71be$var$preconnectAs("preconnect", href, crossOrigin);
}
function $2344bd0db54c71be$var$preload(href, as, options) {
    $2344bd0db54c71be$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $2344bd0db54c71be$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $2344bd0db54c71be$var$getStyleKey(href);
                break;
            case "script":
                key = $2344bd0db54c71be$var$getScriptKey(href);
        }
        $2344bd0db54c71be$var$preloadPropsMap.has(key) || (href = $2344bd0db54c71be$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $2344bd0db54c71be$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($2344bd0db54c71be$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($2344bd0db54c71be$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $2344bd0db54c71be$var$setInitialProperties(as, "link", href), $2344bd0db54c71be$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $2344bd0db54c71be$var$preloadModule(href, options) {
    $2344bd0db54c71be$var$previousDispatcher.m(href, options);
    var ownerDocument = $2344bd0db54c71be$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $2344bd0db54c71be$var$getScriptKey(href);
        }
        if (!$2344bd0db54c71be$var$preloadPropsMap.has(key) && (href = $2344bd0db54c71be$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $2344bd0db54c71be$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($2344bd0db54c71be$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $2344bd0db54c71be$var$setInitialProperties(as, "link", href);
            $2344bd0db54c71be$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $2344bd0db54c71be$var$preinitStyle(href, precedence, options) {
    $2344bd0db54c71be$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $2344bd0db54c71be$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $2344bd0db54c71be$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $2344bd0db54c71be$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($2344bd0db54c71be$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $2344bd0db54c71be$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $2344bd0db54c71be$var$preloadPropsMap.get(key)) && $2344bd0db54c71be$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $2344bd0db54c71be$var$markNodeAsHoistable(link);
                $2344bd0db54c71be$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $2344bd0db54c71be$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $2344bd0db54c71be$var$preinitScript(src, options) {
    $2344bd0db54c71be$var$previousDispatcher.X(src, options);
    var ownerDocument = $2344bd0db54c71be$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2344bd0db54c71be$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2344bd0db54c71be$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2344bd0db54c71be$var$getScriptSelectorFromKey(key)), resource || (src = $2344bd0db54c71be$var$assign({
            src: src,
            async: !0
        }, options), (options = $2344bd0db54c71be$var$preloadPropsMap.get(key)) && $2344bd0db54c71be$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2344bd0db54c71be$var$markNodeAsHoistable(resource), $2344bd0db54c71be$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2344bd0db54c71be$var$preinitModuleScript(src, options) {
    $2344bd0db54c71be$var$previousDispatcher.M(src, options);
    var ownerDocument = $2344bd0db54c71be$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2344bd0db54c71be$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2344bd0db54c71be$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2344bd0db54c71be$var$getScriptSelectorFromKey(key)), resource || (src = $2344bd0db54c71be$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $2344bd0db54c71be$var$preloadPropsMap.get(key)) && $2344bd0db54c71be$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2344bd0db54c71be$var$markNodeAsHoistable(resource), $2344bd0db54c71be$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2344bd0db54c71be$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $2344bd0db54c71be$var$rootInstanceStackCursor.current) ? $2344bd0db54c71be$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $2344bd0db54c71be$var$getStyleKey(pendingProps.href), pendingProps = $2344bd0db54c71be$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $2344bd0db54c71be$var$getStyleKey(pendingProps.href);
                var styles$244 = $2344bd0db54c71be$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($2344bd0db54c71be$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $2344bd0db54c71be$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $2344bd0db54c71be$var$preloadPropsMap.set(type, pendingProps), styles$244 || $2344bd0db54c71be$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $2344bd0db54c71be$var$getScriptKey(pendingProps), pendingProps = $2344bd0db54c71be$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($2344bd0db54c71be$var$formatProdErrorMessage(444, type));
    }
}
function $2344bd0db54c71be$var$getStyleKey(href) {
    return 'href="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $2344bd0db54c71be$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $2344bd0db54c71be$var$stylesheetPropsFromRawProps(rawProps) {
    return $2344bd0db54c71be$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $2344bd0db54c71be$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $2344bd0db54c71be$var$setInitialProperties(key, "link", preloadProps), $2344bd0db54c71be$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $2344bd0db54c71be$var$getScriptKey(src) {
    return '[src="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $2344bd0db54c71be$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $2344bd0db54c71be$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $2344bd0db54c71be$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $2344bd0db54c71be$var$markNodeAsHoistable(instance), instance;
            var styleProps = $2344bd0db54c71be$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $2344bd0db54c71be$var$markNodeAsHoistable(instance);
            $2344bd0db54c71be$var$setInitialProperties(instance, "style", styleProps);
            $2344bd0db54c71be$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $2344bd0db54c71be$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($2344bd0db54c71be$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $2344bd0db54c71be$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $2344bd0db54c71be$var$stylesheetPropsFromRawProps(props);
            (styleProps = $2344bd0db54c71be$var$preloadPropsMap.get(styleProps)) && $2344bd0db54c71be$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $2344bd0db54c71be$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2344bd0db54c71be$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $2344bd0db54c71be$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $2344bd0db54c71be$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($2344bd0db54c71be$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $2344bd0db54c71be$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $2344bd0db54c71be$var$preloadPropsMap.get(instance$250)) instance = $2344bd0db54c71be$var$assign({}, props), $2344bd0db54c71be$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $2344bd0db54c71be$var$markNodeAsHoistable(styleProps);
            $2344bd0db54c71be$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($2344bd0db54c71be$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $2344bd0db54c71be$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $2344bd0db54c71be$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $2344bd0db54c71be$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $2344bd0db54c71be$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $2344bd0db54c71be$var$tagCaches = null;
function $2344bd0db54c71be$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $2344bd0db54c71be$var$tagCaches) {
        var cache = new Map();
        var caches = $2344bd0db54c71be$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $2344bd0db54c71be$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$2344bd0db54c71be$var$internalHoistableMarker] || node[$2344bd0db54c71be$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $2344bd0db54c71be$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $2344bd0db54c71be$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $2344bd0db54c71be$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $2344bd0db54c71be$var$suspendedState = null;
function $2344bd0db54c71be$var$noop() {}
function $2344bd0db54c71be$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $2344bd0db54c71be$var$suspendedState) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(475));
    var state = $2344bd0db54c71be$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $2344bd0db54c71be$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($2344bd0db54c71be$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $2344bd0db54c71be$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $2344bd0db54c71be$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $2344bd0db54c71be$var$stylesheetPropsFromRawProps(props);
            (key = $2344bd0db54c71be$var$preloadPropsMap.get(key)) && $2344bd0db54c71be$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $2344bd0db54c71be$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2344bd0db54c71be$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $2344bd0db54c71be$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $2344bd0db54c71be$var$waitForCommitToBeReady() {
    if (null === $2344bd0db54c71be$var$suspendedState) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(475));
    var state = $2344bd0db54c71be$var$suspendedState;
    state.stylesheets && 0 === state.count && $2344bd0db54c71be$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $2344bd0db54c71be$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $2344bd0db54c71be$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $2344bd0db54c71be$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $2344bd0db54c71be$var$precedencesByRoot = null;
function $2344bd0db54c71be$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $2344bd0db54c71be$var$precedencesByRoot = new Map(), resources.forEach($2344bd0db54c71be$var$insertStylesheetIntoRoot, state), $2344bd0db54c71be$var$precedencesByRoot = null, $2344bd0db54c71be$var$onUnsuspend.call(state));
}
function $2344bd0db54c71be$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $2344bd0db54c71be$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $2344bd0db54c71be$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $2344bd0db54c71be$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $2344bd0db54c71be$var$HostTransitionContext = {
    $$typeof: $2344bd0db54c71be$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $2344bd0db54c71be$var$sharedNotPendingObject,
    _currentValue2: $2344bd0db54c71be$var$sharedNotPendingObject,
    _threadCount: 0
};
function $2344bd0db54c71be$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $2344bd0db54c71be$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2344bd0db54c71be$var$createLaneMap(0);
    this.hiddenUpdates = $2344bd0db54c71be$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $2344bd0db54c71be$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $2344bd0db54c71be$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $2344bd0db54c71be$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $2344bd0db54c71be$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $2344bd0db54c71be$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $2344bd0db54c71be$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $2344bd0db54c71be$var$emptyContextObject;
    parentComponent = $2344bd0db54c71be$var$emptyContextObject;
    return parentComponent;
}
function $2344bd0db54c71be$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $2344bd0db54c71be$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $2344bd0db54c71be$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $2344bd0db54c71be$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($2344bd0db54c71be$var$scheduleUpdateOnFiber(element, rootFiber, lane), $2344bd0db54c71be$var$entangleTransitions(element, rootFiber, lane));
}
function $2344bd0db54c71be$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $2344bd0db54c71be$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $2344bd0db54c71be$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $2344bd0db54c71be$var$markRetryLaneImpl(fiber, retryLane);
}
function $2344bd0db54c71be$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $2344bd0db54c71be$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $2344bd0db54c71be$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $2344bd0db54c71be$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $2344bd0db54c71be$var$_enabled = !0;
function $2344bd0db54c71be$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2344bd0db54c71be$var$ReactSharedInternals.T;
    $2344bd0db54c71be$var$ReactSharedInternals.T = null;
    var previousPriority = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
    try {
        $2344bd0db54c71be$var$ReactDOMSharedInternals.p = 2, $2344bd0db54c71be$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2344bd0db54c71be$var$ReactDOMSharedInternals.p = previousPriority, $2344bd0db54c71be$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2344bd0db54c71be$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2344bd0db54c71be$var$ReactSharedInternals.T;
    $2344bd0db54c71be$var$ReactSharedInternals.T = null;
    var previousPriority = $2344bd0db54c71be$var$ReactDOMSharedInternals.p;
    try {
        $2344bd0db54c71be$var$ReactDOMSharedInternals.p = 8, $2344bd0db54c71be$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2344bd0db54c71be$var$ReactDOMSharedInternals.p = previousPriority, $2344bd0db54c71be$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2344bd0db54c71be$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($2344bd0db54c71be$var$_enabled) {
        var blockedOn = $2344bd0db54c71be$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $2344bd0db54c71be$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2344bd0db54c71be$var$return_targetInst, targetContainer), $2344bd0db54c71be$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($2344bd0db54c71be$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($2344bd0db54c71be$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $2344bd0db54c71be$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $2344bd0db54c71be$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $2344bd0db54c71be$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $2344bd0db54c71be$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $2344bd0db54c71be$var$ensureRootIsScheduled(fiber);
                                0 === ($2344bd0db54c71be$var$executionContext & 6) && ($2344bd0db54c71be$var$workInProgressRootRenderTargetTime = $2344bd0db54c71be$var$now() + 500, $2344bd0db54c71be$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $2344bd0db54c71be$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $2344bd0db54c71be$var$scheduleUpdateOnFiber(root, fiber, 2), $2344bd0db54c71be$var$flushSyncWork$1(), $2344bd0db54c71be$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $2344bd0db54c71be$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $2344bd0db54c71be$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2344bd0db54c71be$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $2344bd0db54c71be$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $2344bd0db54c71be$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $2344bd0db54c71be$var$getEventTarget(nativeEvent);
    return $2344bd0db54c71be$var$findInstanceBlockingTarget(nativeEvent);
}
var $2344bd0db54c71be$var$return_targetInst = null;
function $2344bd0db54c71be$var$findInstanceBlockingTarget(targetNode) {
    $2344bd0db54c71be$var$return_targetInst = null;
    targetNode = $2344bd0db54c71be$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $2344bd0db54c71be$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $2344bd0db54c71be$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $2344bd0db54c71be$var$return_targetInst = targetNode;
    return null;
}
function $2344bd0db54c71be$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($2344bd0db54c71be$var$getCurrentPriorityLevel()){
                case $2344bd0db54c71be$var$ImmediatePriority:
                    return 2;
                case $2344bd0db54c71be$var$UserBlockingPriority:
                    return 8;
                case $2344bd0db54c71be$var$NormalPriority$1:
                case $2344bd0db54c71be$var$LowPriority:
                    return 32;
                case $2344bd0db54c71be$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $2344bd0db54c71be$var$hasScheduledReplayAttempt = !1, $2344bd0db54c71be$var$queuedFocus = null, $2344bd0db54c71be$var$queuedDrag = null, $2344bd0db54c71be$var$queuedMouse = null, $2344bd0db54c71be$var$queuedPointers = new Map(), $2344bd0db54c71be$var$queuedPointerCaptures = new Map(), $2344bd0db54c71be$var$queuedExplicitHydrationTargets = [], $2344bd0db54c71be$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $2344bd0db54c71be$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $2344bd0db54c71be$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $2344bd0db54c71be$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $2344bd0db54c71be$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $2344bd0db54c71be$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2344bd0db54c71be$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $2344bd0db54c71be$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $2344bd0db54c71be$var$getInstanceFromNode(blockedOn), null !== blockedOn && $2344bd0db54c71be$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $2344bd0db54c71be$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $2344bd0db54c71be$var$queuedFocus = $2344bd0db54c71be$var$accumulateOrCreateContinuousQueuedReplayableEvent($2344bd0db54c71be$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $2344bd0db54c71be$var$queuedDrag = $2344bd0db54c71be$var$accumulateOrCreateContinuousQueuedReplayableEvent($2344bd0db54c71be$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $2344bd0db54c71be$var$queuedMouse = $2344bd0db54c71be$var$accumulateOrCreateContinuousQueuedReplayableEvent($2344bd0db54c71be$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $2344bd0db54c71be$var$queuedPointers.set(pointerId, $2344bd0db54c71be$var$accumulateOrCreateContinuousQueuedReplayableEvent($2344bd0db54c71be$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $2344bd0db54c71be$var$queuedPointerCaptures.set(pointerId, $2344bd0db54c71be$var$accumulateOrCreateContinuousQueuedReplayableEvent($2344bd0db54c71be$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $2344bd0db54c71be$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $2344bd0db54c71be$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $2344bd0db54c71be$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $2344bd0db54c71be$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $2344bd0db54c71be$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $2344bd0db54c71be$var$requestUpdateLane();
                            lane = $2344bd0db54c71be$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $2344bd0db54c71be$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $2344bd0db54c71be$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $2344bd0db54c71be$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $2344bd0db54c71be$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $2344bd0db54c71be$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $2344bd0db54c71be$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $2344bd0db54c71be$var$currentReplayingEvent = null;
        } else return targetContainers = $2344bd0db54c71be$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $2344bd0db54c71be$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $2344bd0db54c71be$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $2344bd0db54c71be$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $2344bd0db54c71be$var$replayUnblockedEvents() {
    $2344bd0db54c71be$var$hasScheduledReplayAttempt = !1;
    null !== $2344bd0db54c71be$var$queuedFocus && $2344bd0db54c71be$var$attemptReplayContinuousQueuedEvent($2344bd0db54c71be$var$queuedFocus) && ($2344bd0db54c71be$var$queuedFocus = null);
    null !== $2344bd0db54c71be$var$queuedDrag && $2344bd0db54c71be$var$attemptReplayContinuousQueuedEvent($2344bd0db54c71be$var$queuedDrag) && ($2344bd0db54c71be$var$queuedDrag = null);
    null !== $2344bd0db54c71be$var$queuedMouse && $2344bd0db54c71be$var$attemptReplayContinuousQueuedEvent($2344bd0db54c71be$var$queuedMouse) && ($2344bd0db54c71be$var$queuedMouse = null);
    $2344bd0db54c71be$var$queuedPointers.forEach($2344bd0db54c71be$var$attemptReplayContinuousQueuedEventInMap);
    $2344bd0db54c71be$var$queuedPointerCaptures.forEach($2344bd0db54c71be$var$attemptReplayContinuousQueuedEventInMap);
}
function $2344bd0db54c71be$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $2344bd0db54c71be$var$hasScheduledReplayAttempt || ($2344bd0db54c71be$var$hasScheduledReplayAttempt = !0, $5xrAo.unstable_scheduleCallback($5xrAo.unstable_NormalPriority, $2344bd0db54c71be$var$replayUnblockedEvents)));
}
var $2344bd0db54c71be$var$lastScheduledReplayQueue = null;
function $2344bd0db54c71be$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $2344bd0db54c71be$var$lastScheduledReplayQueue !== formReplayingQueue && ($2344bd0db54c71be$var$lastScheduledReplayQueue = formReplayingQueue, $5xrAo.unstable_scheduleCallback($5xrAo.unstable_NormalPriority, function() {
        $2344bd0db54c71be$var$lastScheduledReplayQueue === formReplayingQueue && ($2344bd0db54c71be$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $2344bd0db54c71be$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $2344bd0db54c71be$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $2344bd0db54c71be$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $2344bd0db54c71be$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $2344bd0db54c71be$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $2344bd0db54c71be$var$queuedFocus && $2344bd0db54c71be$var$scheduleCallbackIfUnblocked($2344bd0db54c71be$var$queuedFocus, unblocked);
    null !== $2344bd0db54c71be$var$queuedDrag && $2344bd0db54c71be$var$scheduleCallbackIfUnblocked($2344bd0db54c71be$var$queuedDrag, unblocked);
    null !== $2344bd0db54c71be$var$queuedMouse && $2344bd0db54c71be$var$scheduleCallbackIfUnblocked($2344bd0db54c71be$var$queuedMouse, unblocked);
    $2344bd0db54c71be$var$queuedPointers.forEach(unblock);
    $2344bd0db54c71be$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $2344bd0db54c71be$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $2344bd0db54c71be$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $2344bd0db54c71be$var$queuedExplicitHydrationTargets.length && (i = $2344bd0db54c71be$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$2344bd0db54c71be$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $2344bd0db54c71be$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$2344bd0db54c71be$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $2344bd0db54c71be$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$2344bd0db54c71be$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $2344bd0db54c71be$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $2344bd0db54c71be$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $2344bd0db54c71be$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2344bd0db54c71be$var$ReactDOMHydrationRoot.prototype.render = $2344bd0db54c71be$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(409));
    var current = root.current, lane = $2344bd0db54c71be$var$requestUpdateLane();
    $2344bd0db54c71be$var$updateContainerImpl(current, lane, children, root, null, null);
};
$2344bd0db54c71be$var$ReactDOMHydrationRoot.prototype.unmount = $2344bd0db54c71be$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $2344bd0db54c71be$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $2344bd0db54c71be$var$flushSyncWork$1();
        container[$2344bd0db54c71be$var$internalContainerInstanceKey] = null;
    }
};
function $2344bd0db54c71be$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2344bd0db54c71be$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $2344bd0db54c71be$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $2344bd0db54c71be$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $2344bd0db54c71be$var$queuedExplicitHydrationTargets[i].priority; i++);
        $2344bd0db54c71be$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $2344bd0db54c71be$var$attemptExplicitHydrationTarget(target);
    }
};
var $2344bd0db54c71be$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $baslc.version;
if ("19.1.1" !== $2344bd0db54c71be$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(527, $2344bd0db54c71be$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$2344bd0db54c71be$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($2344bd0db54c71be$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $2344bd0db54c71be$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $2344bd0db54c71be$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $2344bd0db54c71be$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $2344bd0db54c71be$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2344bd0db54c71be$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2344bd0db54c71be$var$hook$jscomp$inline_2257.isDisabled && $2344bd0db54c71be$var$hook$jscomp$inline_2257.supportsFiber) try {
        $2344bd0db54c71be$var$rendererID = $2344bd0db54c71be$var$hook$jscomp$inline_2257.inject($2344bd0db54c71be$var$internals$jscomp$inline_2256), $2344bd0db54c71be$var$injectedHook = $2344bd0db54c71be$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$2344bd0db54c71be$export$882461b6382ed46c = function(container, options) {
    if (!$2344bd0db54c71be$var$isValidContainer(container)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2344bd0db54c71be$var$defaultOnUncaughtError, onCaughtError = $2344bd0db54c71be$var$defaultOnCaughtError, onRecoverableError = $2344bd0db54c71be$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $2344bd0db54c71be$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$2344bd0db54c71be$var$internalContainerInstanceKey] = options.current;
    $2344bd0db54c71be$var$listenToAllSupportedEvents(container);
    return new $2344bd0db54c71be$var$ReactDOMRoot(options);
};
$2344bd0db54c71be$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$2344bd0db54c71be$var$isValidContainer(container)) throw Error($2344bd0db54c71be$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2344bd0db54c71be$var$defaultOnUncaughtError, onCaughtError = $2344bd0db54c71be$var$defaultOnCaughtError, onRecoverableError = $2344bd0db54c71be$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $2344bd0db54c71be$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $2344bd0db54c71be$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $2344bd0db54c71be$var$requestUpdateLane();
    isStrictMode = $2344bd0db54c71be$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $2344bd0db54c71be$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $2344bd0db54c71be$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $2344bd0db54c71be$var$markRootUpdated$1(initialChildren, options);
    $2344bd0db54c71be$var$ensureRootIsScheduled(initialChildren);
    container[$2344bd0db54c71be$var$internalContainerInstanceKey] = initialChildren.current;
    $2344bd0db54c71be$var$listenToAllSupportedEvents(container);
    return new $2344bd0db54c71be$var$ReactDOMHydrationRoot(initialChildren);
};
$2344bd0db54c71be$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("5xrAo", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gZJSz"));

});
parcelRegister("gZJSz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $c5f5ee8152810754$export$c4744153514ff05d, (v) => $c5f5ee8152810754$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $c5f5ee8152810754$export$3e506c1ccc9cc1a7, (v) => $c5f5ee8152810754$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $c5f5ee8152810754$export$e26fe2ed2fa76875, (v) => $c5f5ee8152810754$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $c5f5ee8152810754$export$502329bbf4b505b1, (v) => $c5f5ee8152810754$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $c5f5ee8152810754$export$6e3807111c4874c4, (v) => $c5f5ee8152810754$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $c5f5ee8152810754$export$c27134553091fb3a, (v) => $c5f5ee8152810754$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $c5f5ee8152810754$export$33ee1acdc04fd2a2, (v) => $c5f5ee8152810754$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $c5f5ee8152810754$export$b00a404bbd5edef2, (v) => $c5f5ee8152810754$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $c5f5ee8152810754$export$d66a1c1c77bd778b, (v) => $c5f5ee8152810754$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $c5f5ee8152810754$export$d3dfb8e4810cb555, (v) => $c5f5ee8152810754$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $c5f5ee8152810754$export$72fdf0e06517287b, (v) => $c5f5ee8152810754$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $c5f5ee8152810754$export$816d2913ae6b83b1, (v) => $c5f5ee8152810754$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $c5f5ee8152810754$export$61bcfe829111a1d0, (v) => $c5f5ee8152810754$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $c5f5ee8152810754$export$7ee8c9beb337bc3f, (v) => $c5f5ee8152810754$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $c5f5ee8152810754$export$b5836b71941fa3ed, (v) => $c5f5ee8152810754$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $c5f5ee8152810754$export$cf845f2c119da08a, (v) => $c5f5ee8152810754$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c5f5ee8152810754$export$c4744153514ff05d;
var $c5f5ee8152810754$export$3e506c1ccc9cc1a7;
var $c5f5ee8152810754$export$e26fe2ed2fa76875;
var $c5f5ee8152810754$export$502329bbf4b505b1;
var $c5f5ee8152810754$export$6e3807111c4874c4;
var $c5f5ee8152810754$export$c27134553091fb3a;
var $c5f5ee8152810754$export$33ee1acdc04fd2a2;
var $c5f5ee8152810754$export$b00a404bbd5edef2;
var $c5f5ee8152810754$export$d66a1c1c77bd778b;
var $c5f5ee8152810754$export$d3dfb8e4810cb555;
var $c5f5ee8152810754$export$72fdf0e06517287b;
var $c5f5ee8152810754$export$816d2913ae6b83b1;
var $c5f5ee8152810754$export$61bcfe829111a1d0;
var $c5f5ee8152810754$export$7ee8c9beb337bc3f;
var $c5f5ee8152810754$export$b5836b71941fa3ed;
var $c5f5ee8152810754$export$cf845f2c119da08a;
"use strict";
function $c5f5ee8152810754$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $c5f5ee8152810754$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $c5f5ee8152810754$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $c5f5ee8152810754$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $c5f5ee8152810754$var$compare(left, last)) rightIndex < length && 0 > $c5f5ee8152810754$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $c5f5ee8152810754$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $c5f5ee8152810754$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$c5f5ee8152810754$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $c5f5ee8152810754$var$localPerformance = performance;
    $c5f5ee8152810754$export$c4744153514ff05d = function() {
        return $c5f5ee8152810754$var$localPerformance.now();
    };
} else {
    var $c5f5ee8152810754$var$localDate = Date, $c5f5ee8152810754$var$initialTime = $c5f5ee8152810754$var$localDate.now();
    $c5f5ee8152810754$export$c4744153514ff05d = function() {
        return $c5f5ee8152810754$var$localDate.now() - $c5f5ee8152810754$var$initialTime;
    };
}
var $c5f5ee8152810754$var$taskQueue = [], $c5f5ee8152810754$var$timerQueue = [], $c5f5ee8152810754$var$taskIdCounter = 1, $c5f5ee8152810754$var$currentTask = null, $c5f5ee8152810754$var$currentPriorityLevel = 3, $c5f5ee8152810754$var$isPerformingWork = !1, $c5f5ee8152810754$var$isHostCallbackScheduled = !1, $c5f5ee8152810754$var$isHostTimeoutScheduled = !1, $c5f5ee8152810754$var$needsPaint = !1, $c5f5ee8152810754$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $c5f5ee8152810754$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $c5f5ee8152810754$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $c5f5ee8152810754$var$advanceTimers(currentTime) {
    for(var timer = $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$timerQueue); null !== timer;){
        if (null === timer.callback) $c5f5ee8152810754$var$pop($c5f5ee8152810754$var$timerQueue);
        else if (timer.startTime <= currentTime) $c5f5ee8152810754$var$pop($c5f5ee8152810754$var$timerQueue), timer.sortIndex = timer.expirationTime, $c5f5ee8152810754$var$push($c5f5ee8152810754$var$taskQueue, timer);
        else break;
        timer = $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$timerQueue);
    }
}
function $c5f5ee8152810754$var$handleTimeout(currentTime) {
    $c5f5ee8152810754$var$isHostTimeoutScheduled = !1;
    $c5f5ee8152810754$var$advanceTimers(currentTime);
    if (!$c5f5ee8152810754$var$isHostCallbackScheduled) {
        if (null !== $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$taskQueue)) $c5f5ee8152810754$var$isHostCallbackScheduled = !0, $c5f5ee8152810754$var$isMessageLoopRunning || ($c5f5ee8152810754$var$isMessageLoopRunning = !0, $c5f5ee8152810754$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$timerQueue);
            null !== firstTimer && $c5f5ee8152810754$var$requestHostTimeout($c5f5ee8152810754$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $c5f5ee8152810754$var$isMessageLoopRunning = !1, $c5f5ee8152810754$var$taskTimeoutID = -1, $c5f5ee8152810754$var$frameInterval = 5, $c5f5ee8152810754$var$startTime = -1;
function $c5f5ee8152810754$var$shouldYieldToHost() {
    return $c5f5ee8152810754$var$needsPaint ? !0 : $c5f5ee8152810754$export$c4744153514ff05d() - $c5f5ee8152810754$var$startTime < $c5f5ee8152810754$var$frameInterval ? !1 : !0;
}
function $c5f5ee8152810754$var$performWorkUntilDeadline() {
    $c5f5ee8152810754$var$needsPaint = !1;
    if ($c5f5ee8152810754$var$isMessageLoopRunning) {
        var currentTime = $c5f5ee8152810754$export$c4744153514ff05d();
        $c5f5ee8152810754$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $c5f5ee8152810754$var$isHostCallbackScheduled = !1;
                $c5f5ee8152810754$var$isHostTimeoutScheduled && ($c5f5ee8152810754$var$isHostTimeoutScheduled = !1, $c5f5ee8152810754$var$localClearTimeout($c5f5ee8152810754$var$taskTimeoutID), $c5f5ee8152810754$var$taskTimeoutID = -1);
                $c5f5ee8152810754$var$isPerformingWork = !0;
                var previousPriorityLevel = $c5f5ee8152810754$var$currentPriorityLevel;
                try {
                    b: {
                        $c5f5ee8152810754$var$advanceTimers(currentTime);
                        for($c5f5ee8152810754$var$currentTask = $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$taskQueue); null !== $c5f5ee8152810754$var$currentTask && !($c5f5ee8152810754$var$currentTask.expirationTime > currentTime && $c5f5ee8152810754$var$shouldYieldToHost());){
                            var callback = $c5f5ee8152810754$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $c5f5ee8152810754$var$currentTask.callback = null;
                                $c5f5ee8152810754$var$currentPriorityLevel = $c5f5ee8152810754$var$currentTask.priorityLevel;
                                var continuationCallback = callback($c5f5ee8152810754$var$currentTask.expirationTime <= currentTime);
                                currentTime = $c5f5ee8152810754$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $c5f5ee8152810754$var$currentTask.callback = continuationCallback;
                                    $c5f5ee8152810754$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $c5f5ee8152810754$var$currentTask === $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$taskQueue) && $c5f5ee8152810754$var$pop($c5f5ee8152810754$var$taskQueue);
                                $c5f5ee8152810754$var$advanceTimers(currentTime);
                            } else $c5f5ee8152810754$var$pop($c5f5ee8152810754$var$taskQueue);
                            $c5f5ee8152810754$var$currentTask = $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$taskQueue);
                        }
                        if (null !== $c5f5ee8152810754$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$timerQueue);
                            null !== firstTimer && $c5f5ee8152810754$var$requestHostTimeout($c5f5ee8152810754$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $c5f5ee8152810754$var$currentTask = null, $c5f5ee8152810754$var$currentPriorityLevel = previousPriorityLevel, $c5f5ee8152810754$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $c5f5ee8152810754$var$schedulePerformWorkUntilDeadline() : $c5f5ee8152810754$var$isMessageLoopRunning = !1;
        }
    }
}
var $c5f5ee8152810754$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $c5f5ee8152810754$var$localSetImmediate) $c5f5ee8152810754$var$schedulePerformWorkUntilDeadline = function() {
    $c5f5ee8152810754$var$localSetImmediate($c5f5ee8152810754$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $c5f5ee8152810754$var$channel = new MessageChannel(), $c5f5ee8152810754$var$port = $c5f5ee8152810754$var$channel.port2;
    $c5f5ee8152810754$var$channel.port1.onmessage = $c5f5ee8152810754$var$performWorkUntilDeadline;
    $c5f5ee8152810754$var$schedulePerformWorkUntilDeadline = function() {
        $c5f5ee8152810754$var$port.postMessage(null);
    };
} else $c5f5ee8152810754$var$schedulePerformWorkUntilDeadline = function() {
    $c5f5ee8152810754$var$localSetTimeout($c5f5ee8152810754$var$performWorkUntilDeadline, 0);
};
function $c5f5ee8152810754$var$requestHostTimeout(callback, ms) {
    $c5f5ee8152810754$var$taskTimeoutID = $c5f5ee8152810754$var$localSetTimeout(function() {
        callback($c5f5ee8152810754$export$c4744153514ff05d());
    }, ms);
}
$c5f5ee8152810754$export$3e506c1ccc9cc1a7 = 5;
$c5f5ee8152810754$export$e26fe2ed2fa76875 = 1;
$c5f5ee8152810754$export$502329bbf4b505b1 = 4;
$c5f5ee8152810754$export$6e3807111c4874c4 = 3;
$c5f5ee8152810754$export$c27134553091fb3a = null;
$c5f5ee8152810754$export$33ee1acdc04fd2a2 = 2;
$c5f5ee8152810754$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$c5f5ee8152810754$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $c5f5ee8152810754$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$c5f5ee8152810754$export$d3dfb8e4810cb555 = function() {
    return $c5f5ee8152810754$var$currentPriorityLevel;
};
$c5f5ee8152810754$export$72fdf0e06517287b = function(eventHandler) {
    switch($c5f5ee8152810754$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $c5f5ee8152810754$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $c5f5ee8152810754$var$currentPriorityLevel;
    $c5f5ee8152810754$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $c5f5ee8152810754$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$c5f5ee8152810754$export$816d2913ae6b83b1 = function() {
    $c5f5ee8152810754$var$needsPaint = !0;
};
$c5f5ee8152810754$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $c5f5ee8152810754$var$currentPriorityLevel;
    $c5f5ee8152810754$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $c5f5ee8152810754$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$c5f5ee8152810754$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $c5f5ee8152810754$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $c5f5ee8152810754$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $c5f5ee8152810754$var$push($c5f5ee8152810754$var$timerQueue, priorityLevel), null === $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$taskQueue) && priorityLevel === $c5f5ee8152810754$var$peek($c5f5ee8152810754$var$timerQueue) && ($c5f5ee8152810754$var$isHostTimeoutScheduled ? ($c5f5ee8152810754$var$localClearTimeout($c5f5ee8152810754$var$taskTimeoutID), $c5f5ee8152810754$var$taskTimeoutID = -1) : $c5f5ee8152810754$var$isHostTimeoutScheduled = !0, $c5f5ee8152810754$var$requestHostTimeout($c5f5ee8152810754$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $c5f5ee8152810754$var$push($c5f5ee8152810754$var$taskQueue, priorityLevel), $c5f5ee8152810754$var$isHostCallbackScheduled || $c5f5ee8152810754$var$isPerformingWork || ($c5f5ee8152810754$var$isHostCallbackScheduled = !0, $c5f5ee8152810754$var$isMessageLoopRunning || ($c5f5ee8152810754$var$isMessageLoopRunning = !0, $c5f5ee8152810754$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$c5f5ee8152810754$export$b5836b71941fa3ed = $c5f5ee8152810754$var$shouldYieldToHost;
$c5f5ee8152810754$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $c5f5ee8152810754$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $c5f5ee8152810754$var$currentPriorityLevel;
        $c5f5ee8152810754$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $c5f5ee8152810754$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("baslc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("c8Lsf"));

});

parcelRegister("ePvRJ", function(module, exports) {
'use strict';
function $acbe8bf1ef3349e6$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($acbe8bf1ef3349e6$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$acbe8bf1ef3349e6$var$checkDCE();

module.exports = (parcelRequire("6ZscQ"));

});
parcelRegister("6ZscQ", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $516e51c3312f7ee2$export$69ce8ef3fe5cead0, (v) => $516e51c3312f7ee2$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $516e51c3312f7ee2$export$d39a5bbd09211389, (v) => $516e51c3312f7ee2$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $516e51c3312f7ee2$export$cd75ccfd720a3cd4, (v) => $516e51c3312f7ee2$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $516e51c3312f7ee2$export$a0816fa17a9e79be, (v) => $516e51c3312f7ee2$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $516e51c3312f7ee2$export$7292efcadded39f3, (v) => $516e51c3312f7ee2$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $516e51c3312f7ee2$export$da407abadb9b8f86, (v) => $516e51c3312f7ee2$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $516e51c3312f7ee2$export$314cfea32580671c, (v) => $516e51c3312f7ee2$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $516e51c3312f7ee2$export$513ccb98c53b8039, (v) => $516e51c3312f7ee2$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $516e51c3312f7ee2$export$dbca993bc2d264a, (v) => $516e51c3312f7ee2$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $516e51c3312f7ee2$export$4797a8006f0655d0, (v) => $516e51c3312f7ee2$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $516e51c3312f7ee2$export$c78a37762a8d58e1, (v) => $516e51c3312f7ee2$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $516e51c3312f7ee2$export$606f11b2eb45ecc6, (v) => $516e51c3312f7ee2$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $516e51c3312f7ee2$export$f7e8a0bf92324b1e, (v) => $516e51c3312f7ee2$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $516e51c3312f7ee2$export$83d89fbfd8236492, (v) => $516e51c3312f7ee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $516e51c3312f7ee2$export$69ce8ef3fe5cead0;
var $516e51c3312f7ee2$export$d39a5bbd09211389;
var $516e51c3312f7ee2$export$cd75ccfd720a3cd4;
var $516e51c3312f7ee2$export$a0816fa17a9e79be;
var $516e51c3312f7ee2$export$7292efcadded39f3;
var $516e51c3312f7ee2$export$da407abadb9b8f86;
var $516e51c3312f7ee2$export$314cfea32580671c;
var $516e51c3312f7ee2$export$513ccb98c53b8039;
var $516e51c3312f7ee2$export$dbca993bc2d264a;
var $516e51c3312f7ee2$export$4797a8006f0655d0;
var $516e51c3312f7ee2$export$c78a37762a8d58e1;
var $516e51c3312f7ee2$export$606f11b2eb45ecc6;
var $516e51c3312f7ee2$export$f7e8a0bf92324b1e;
var $516e51c3312f7ee2$export$83d89fbfd8236492;
"use strict";

var $baslc = parcelRequire("baslc");
function $516e51c3312f7ee2$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $516e51c3312f7ee2$var$noop() {}
var $516e51c3312f7ee2$var$Internals = {
    d: {
        f: $516e51c3312f7ee2$var$noop,
        r: function() {
            throw Error($516e51c3312f7ee2$var$formatProdErrorMessage(522));
        },
        D: $516e51c3312f7ee2$var$noop,
        C: $516e51c3312f7ee2$var$noop,
        L: $516e51c3312f7ee2$var$noop,
        m: $516e51c3312f7ee2$var$noop,
        X: $516e51c3312f7ee2$var$noop,
        S: $516e51c3312f7ee2$var$noop,
        M: $516e51c3312f7ee2$var$noop
    },
    p: 0,
    findDOMNode: null
}, $516e51c3312f7ee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $516e51c3312f7ee2$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $516e51c3312f7ee2$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $516e51c3312f7ee2$var$ReactSharedInternals = $baslc.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $516e51c3312f7ee2$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$516e51c3312f7ee2$export$69ce8ef3fe5cead0 = $516e51c3312f7ee2$var$Internals;
$516e51c3312f7ee2$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($516e51c3312f7ee2$var$formatProdErrorMessage(299));
    return $516e51c3312f7ee2$var$createPortal$1(children, container, null, key);
};
$516e51c3312f7ee2$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $516e51c3312f7ee2$var$ReactSharedInternals.T, previousUpdatePriority = $516e51c3312f7ee2$var$Internals.p;
    try {
        if ($516e51c3312f7ee2$var$ReactSharedInternals.T = null, $516e51c3312f7ee2$var$Internals.p = 2, fn) return fn();
    } finally{
        $516e51c3312f7ee2$var$ReactSharedInternals.T = previousTransition, $516e51c3312f7ee2$var$Internals.p = previousUpdatePriority, $516e51c3312f7ee2$var$Internals.d.f();
    }
};
$516e51c3312f7ee2$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $516e51c3312f7ee2$var$Internals.d.C(href, options));
};
$516e51c3312f7ee2$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $516e51c3312f7ee2$var$Internals.d.D(href);
};
$516e51c3312f7ee2$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $516e51c3312f7ee2$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $516e51c3312f7ee2$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $516e51c3312f7ee2$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$516e51c3312f7ee2$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $516e51c3312f7ee2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $516e51c3312f7ee2$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $516e51c3312f7ee2$var$Internals.d.M(href);
    }
};
$516e51c3312f7ee2$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $516e51c3312f7ee2$var$getCrossOriginStringAs(as, options.crossOrigin);
        $516e51c3312f7ee2$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$516e51c3312f7ee2$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $516e51c3312f7ee2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $516e51c3312f7ee2$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $516e51c3312f7ee2$var$Internals.d.m(href);
    }
};
$516e51c3312f7ee2$export$4797a8006f0655d0 = function(form) {
    $516e51c3312f7ee2$var$Internals.d.r(form);
};
$516e51c3312f7ee2$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$516e51c3312f7ee2$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $516e51c3312f7ee2$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$516e51c3312f7ee2$export$f7e8a0bf92324b1e = function() {
    return $516e51c3312f7ee2$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$516e51c3312f7ee2$export$83d89fbfd8236492 = "19.1.1";

});



var $d6899a6188537778$exports = {};
'use strict';

$d6899a6188537778$exports = (parcelRequire("eCLAF"));


parcelRequire("baslc");
var $feb3c2d3b6de7499$exports = {};
'use strict';
function $feb3c2d3b6de7499$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($feb3c2d3b6de7499$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$feb3c2d3b6de7499$var$checkDCE();

$feb3c2d3b6de7499$exports = (parcelRequire("31Jtn"));



var $fee147b415f7ff33$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $fee147b415f7ff33$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $fee147b415f7ff33$var$__typeError("Cannot " + msg);
var $fee147b415f7ff33$export$18a094aefa070634 = (obj, member, getter)=>($fee147b415f7ff33$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $fee147b415f7ff33$export$addf369becd23283 = (obj, member, value1)=>member.has(obj) ? $fee147b415f7ff33$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
var $fee147b415f7ff33$export$42432efe6614d3b4 = (obj, member, value1, setter)=>($fee147b415f7ff33$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value1) : member.set(obj, value1), value1);
var $fee147b415f7ff33$export$fa92d15b718fce20 = (obj, member, method)=>($fee147b415f7ff33$var$__accessCheck(obj, member, "access private method"), method);
var $fee147b415f7ff33$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $fee147b415f7ff33$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $fee147b415f7ff33$export$18a094aefa070634(obj, member, getter);
        }
    });



// src/utils.ts
var $b204d4f45461ab39$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $b204d4f45461ab39$export$8793edee2d425525() {}
function $b204d4f45461ab39$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $b204d4f45461ab39$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $b204d4f45461ab39$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $b204d4f45461ab39$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $b204d4f45461ab39$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $b204d4f45461ab39$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $b204d4f45461ab39$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$b204d4f45461ab39$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $b204d4f45461ab39$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($b204d4f45461ab39$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $b204d4f45461ab39$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$b204d4f45461ab39$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $b204d4f45461ab39$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $b204d4f45461ab39$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $b204d4f45461ab39$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$b204d4f45461ab39$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $b204d4f45461ab39$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$b204d4f45461ab39$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $b204d4f45461ab39$var$hasOwn = Object.prototype.hasOwnProperty;
function $b204d4f45461ab39$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $b204d4f45461ab39$export$7a8558113332b71e(a) && $b204d4f45461ab39$export$7a8558113332b71e(b);
    if (!array && !($b204d4f45461ab39$export$53b83ca8eaab0383(a) && $b204d4f45461ab39$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $b204d4f45461ab39$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $b204d4f45461ab39$export$77a71fc411098696(aItem, bItem);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $b204d4f45461ab39$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $b204d4f45461ab39$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $b204d4f45461ab39$export$53b83ca8eaab0383(o) {
    if (!$b204d4f45461ab39$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$b204d4f45461ab39$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $b204d4f45461ab39$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $b204d4f45461ab39$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
function $b204d4f45461ab39$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $b204d4f45461ab39$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $b204d4f45461ab39$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $b204d4f45461ab39$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $b204d4f45461ab39$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $b204d4f45461ab39$export$1aa5a89531b7670d = Symbol();
function $b204d4f45461ab39$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $b204d4f45461ab39$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $b204d4f45461ab39$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}







// src/notifyManager.ts
var $f6f1973e83103746$export$7c76da44185e6090 = (cb)=>setTimeout(cb, 0);
function $f6f1973e83103746$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $f6f1973e83103746$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $f6f1973e83103746$export$520687f44db6e1ab = $f6f1973e83103746$export$316a8efd03cd1458();





// src/subscribable.ts
var $15818b8c37ef3cb7$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $5ae4d1fd12e36b30$var$_focused, $5ae4d1fd12e36b30$var$_cleanup, $5ae4d1fd12e36b30$var$_setup;
var $5ae4d1fd12e36b30$export$86f1af424b2ca4de = class extends (0, $15818b8c37ef3cb7$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $5ae4d1fd12e36b30$var$_focused);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $5ae4d1fd12e36b30$var$_cleanup);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $5ae4d1fd12e36b30$var$_setup);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $5ae4d1fd12e36b30$var$_setup, (onFocus)=>{
            if (!(0, $b204d4f45461ab39$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5ae4d1fd12e36b30$var$_cleanup)) this.setEventListener((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5ae4d1fd12e36b30$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5ae4d1fd12e36b30$var$_cleanup)) == null || _a.call(this);
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $5ae4d1fd12e36b30$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $5ae4d1fd12e36b30$var$_setup, setup);
        (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5ae4d1fd12e36b30$var$_cleanup)) == null || _a.call(this);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $5ae4d1fd12e36b30$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5ae4d1fd12e36b30$var$_focused) !== focused;
        if (changed) {
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $5ae4d1fd12e36b30$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5ae4d1fd12e36b30$var$_focused) === "boolean") return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5ae4d1fd12e36b30$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$5ae4d1fd12e36b30$var$_focused = new WeakMap();
$5ae4d1fd12e36b30$var$_cleanup = new WeakMap();
$5ae4d1fd12e36b30$var$_setup = new WeakMap();
var $5ae4d1fd12e36b30$export$6bf54661be5b02cf = new $5ae4d1fd12e36b30$export$86f1af424b2ca4de();





var $f43b4df52e5a8fa8$var$_online, $f43b4df52e5a8fa8$var$_cleanup, $f43b4df52e5a8fa8$var$_setup;
var $f43b4df52e5a8fa8$export$58774fb55d5ff7fc = class extends (0, $15818b8c37ef3cb7$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $f43b4df52e5a8fa8$var$_online, true);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $f43b4df52e5a8fa8$var$_cleanup);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $f43b4df52e5a8fa8$var$_setup);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $f43b4df52e5a8fa8$var$_setup, (onOnline)=>{
            if (!(0, $b204d4f45461ab39$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $f43b4df52e5a8fa8$var$_cleanup)) this.setEventListener((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $f43b4df52e5a8fa8$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $f43b4df52e5a8fa8$var$_cleanup)) == null || _a.call(this);
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $f43b4df52e5a8fa8$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $f43b4df52e5a8fa8$var$_setup, setup);
        (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $f43b4df52e5a8fa8$var$_cleanup)) == null || _a.call(this);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $f43b4df52e5a8fa8$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $f43b4df52e5a8fa8$var$_online) !== online;
        if (changed) {
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $f43b4df52e5a8fa8$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $f43b4df52e5a8fa8$var$_online);
    }
};
$f43b4df52e5a8fa8$var$_online = new WeakMap();
$f43b4df52e5a8fa8$var$_cleanup = new WeakMap();
$f43b4df52e5a8fa8$var$_setup = new WeakMap();
var $f43b4df52e5a8fa8$export$b113e788b2dd3fdc = new $f43b4df52e5a8fa8$export$58774fb55d5ff7fc();




function $1cb7992ab8b9cdb7$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $1cb7992ab8b9cdb7$export$216296c47a9d1275(promise) {
    var _a;
    let data;
    (_a = promise.then((result)=>{
        data = result;
        return result;
    }, (0, $b204d4f45461ab39$export$8793edee2d425525))) == null || _a.catch((0, $b204d4f45461ab39$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}



function $1e1b83be2817e275$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $1e1b83be2817e275$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $f43b4df52e5a8fa8$export$b113e788b2dd3fdc).isOnline() : true;
}
var $1e1b83be2817e275$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $1e1b83be2817e275$export$986cc6445c1d323(value) {
    return value instanceof $1e1b83be2817e275$export$a8430ed4188f35a9;
}
function $1e1b83be2817e275$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $1cb7992ab8b9cdb7$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved()) {
            const error = new $1e1b83be2817e275$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            (_a = config.onCancel) == null || _a.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $5ae4d1fd12e36b30$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $f43b4df52e5a8fa8$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$1e1b83be2817e275$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved()) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $b204d4f45461ab39$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $1e1b83be2817e275$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $b204d4f45461ab39$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}




var $5637481a4e098dcf$var$_gcTimeout;
var $5637481a4e098dcf$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $5637481a4e098dcf$var$_gcTimeout);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $b204d4f45461ab39$export$e539f754e934e270)(this.gcTime)) (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $5637481a4e098dcf$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $b204d4f45461ab39$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5637481a4e098dcf$var$_gcTimeout)) {
            clearTimeout((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $5637481a4e098dcf$var$_gcTimeout));
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $5637481a4e098dcf$var$_gcTimeout, void 0);
        }
    }
};
$5637481a4e098dcf$var$_gcTimeout = new WeakMap();


var $857b44af3733d895$var$_initialState, $857b44af3733d895$var$_revertState, $857b44af3733d895$var$_cache, $857b44af3733d895$var$_client, $857b44af3733d895$var$_retryer, $857b44af3733d895$var$_defaultOptions, $857b44af3733d895$var$_abortSignalConsumed, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn;
var $857b44af3733d895$export$62297b13309008b2 = class extends (0, $5637481a4e098dcf$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $857b44af3733d895$var$_Query_instances);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $857b44af3733d895$var$_initialState);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $857b44af3733d895$var$_revertState);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $857b44af3733d895$var$_cache);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $857b44af3733d895$var$_client);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $857b44af3733d895$var$_retryer);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $857b44af3733d895$var$_defaultOptions);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $857b44af3733d895$var$_abortSignalConsumed);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_abortSignalConsumed, false);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_client, config.client);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_cache, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_initialState, $857b44af3733d895$var$getDefaultState(this.options));
        this.state = config.state ?? (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $b204d4f45461ab39$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer)) == null ? void 0 : _a.promise;
        (_b = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, $b204d4f45461ab39$export$8793edee2d425525)).catch((0, $b204d4f45461ab39$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, $b204d4f45461ab39$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $b204d4f45461ab39$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $b204d4f45461ab39$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $b204d4f45461ab39$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer)) {
                    if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_abortSignalConsumed)) (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer)) == null ? void 0 : _a.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer)) {
                (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer).continueRetry();
                return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $b204d4f45461ab39$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_client),
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_retryer, (0, $1e1b83be2817e275$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $1e1b83be2817e275$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_revertState),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            const data = await (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_f = (_e = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_cache).config).onSuccess) == null || _f.call(_e, data, this);
            (_h = (_g = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_cache).config).onSettled) == null || _h.call(_g, data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $1e1b83be2817e275$export$a8430ed4188f35a9)) {
                if (error.silent) return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $857b44af3733d895$var$_Query_instances, $857b44af3733d895$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            (_j = (_i = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_cache).config).onError) == null || _j.call(_i, error, this);
            (_l = (_k = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_cache).config).onSettled) == null || _l.call(_k, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
};
$857b44af3733d895$var$_initialState = new WeakMap();
$857b44af3733d895$var$_revertState = new WeakMap();
$857b44af3733d895$var$_cache = new WeakMap();
$857b44af3733d895$var$_client = new WeakMap();
$857b44af3733d895$var$_retryer = new WeakMap();
$857b44af3733d895$var$_defaultOptions = new WeakMap();
$857b44af3733d895$var$_abortSignalConsumed = new WeakMap();
$857b44af3733d895$var$_Query_instances = new WeakSet();
$857b44af3733d895$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...$857b44af3733d895$export$f3df9013f2b58bce(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $857b44af3733d895$var$_revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $857b44af3733d895$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $857b44af3733d895$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $1e1b83be2817e275$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $857b44af3733d895$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $fcfe3a80e1a60282$var$_queries;
var $fcfe3a80e1a60282$export$5dde0cd941da8468 = class extends (0, $15818b8c37ef3cb7$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $fcfe3a80e1a60282$var$_queries);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $fcfe3a80e1a60282$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $b204d4f45461ab39$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $857b44af3733d895$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $fcfe3a80e1a60282$var$_queries).has(query.queryHash)) {
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $fcfe3a80e1a60282$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $fcfe3a80e1a60282$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $fcfe3a80e1a60282$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $fcfe3a80e1a60282$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $fcfe3a80e1a60282$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $b204d4f45461ab39$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $b204d4f45461ab39$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$fcfe3a80e1a60282$var$_queries = new WeakMap();








var $76e0c4900c4d3c73$var$_observers, $76e0c4900c4d3c73$var$_mutationCache, $76e0c4900c4d3c73$var$_retryer, $76e0c4900c4d3c73$var$_Mutation_instances, $76e0c4900c4d3c73$var$dispatch_fn;
var $76e0c4900c4d3c73$export$17b8b19c814bcf56 = class extends (0, $5637481a4e098dcf$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $76e0c4900c4d3c73$var$_Mutation_instances);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $76e0c4900c4d3c73$var$_observers);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $76e0c4900c4d3c73$var$_mutationCache);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $76e0c4900c4d3c73$var$_retryer);
        this.mutationId = config.mutationId;
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $76e0c4900c4d3c73$var$_mutationCache, config.mutationCache);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $76e0c4900c4d3c73$var$_observers, []);
        this.state = config.state || $76e0c4900c4d3c73$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_observers).includes(observer)) {
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $76e0c4900c4d3c73$var$_observers, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const onContinue = ()=>{
            (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $76e0c4900c4d3c73$var$_Mutation_instances, $76e0c4900c4d3c73$var$dispatch_fn).call(this, {
                type: "continue"
            });
        };
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $76e0c4900c4d3c73$var$_retryer, (0, $1e1b83be2817e275$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $76e0c4900c4d3c73$var$_Mutation_instances, $76e0c4900c4d3c73$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $76e0c4900c4d3c73$var$_Mutation_instances, $76e0c4900c4d3c73$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_retryer).canStart();
        try {
            if (restored) onContinue();
            else {
                (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $76e0c4900c4d3c73$var$_Mutation_instances, $76e0c4900c4d3c73$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await ((_b = (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $76e0c4900c4d3c73$var$_Mutation_instances, $76e0c4900c4d3c73$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_retryer).start();
            await ((_f = (_e = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $76e0c4900c4d3c73$var$_Mutation_instances, $76e0c4900c4d3c73$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $76e0c4900c4d3c73$var$_Mutation_instances, $76e0c4900c4d3c73$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        } finally{
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).runNext(this);
        }
    }
};
$76e0c4900c4d3c73$var$_observers = new WeakMap();
$76e0c4900c4d3c73$var$_mutationCache = new WeakMap();
$76e0c4900c4d3c73$var$_retryer = new WeakMap();
$76e0c4900c4d3c73$var$_Mutation_instances = new WeakSet();
$76e0c4900c4d3c73$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $76e0c4900c4d3c73$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $76e0c4900c4d3c73$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $448a6c8b1db0be7b$var$_mutations, $448a6c8b1db0be7b$var$_scopes, $448a6c8b1db0be7b$var$_mutationId;
var $448a6c8b1db0be7b$export$1fcfd9a244434844 = class extends (0, $15818b8c37ef3cb7$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $448a6c8b1db0be7b$var$_mutations);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $448a6c8b1db0be7b$var$_scopes);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $448a6c8b1db0be7b$var$_mutationId);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $448a6c8b1db0be7b$var$_mutations, /* @__PURE__ */ new Set());
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $448a6c8b1db0be7b$var$_scopes, /* @__PURE__ */ new Map());
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $448a6c8b1db0be7b$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $76e0c4900c4d3c73$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $fee147b415f7ff33$export$b1fe7cbb4502036b)(this, $448a6c8b1db0be7b$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_mutations).add(mutation);
        const scope = $448a6c8b1db0be7b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_mutations).delete(mutation)) {
            const scope = $448a6c8b1db0be7b$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $448a6c8b1db0be7b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = $448a6c8b1db0be7b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_mutations).clear();
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $448a6c8b1db0be7b$var$_mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $b204d4f45461ab39$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $b204d4f45461ab39$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $b204d4f45461ab39$export$8793edee2d425525)))));
    }
};
$448a6c8b1db0be7b$var$_mutations = new WeakMap();
$448a6c8b1db0be7b$var$_scopes = new WeakMap();
$448a6c8b1db0be7b$var$_mutationId = new WeakMap();
function $448a6c8b1db0be7b$var$scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}







function $b7a640ca300f984f$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $b204d4f45461ab39$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $b204d4f45461ab39$export$8c6246b73dd61f4a) : (0, $b204d4f45461ab39$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $b7a640ca300f984f$var$getPreviousPageParam : $b7a640ca300f984f$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $b7a640ca300f984f$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $b7a640ca300f984f$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $b7a640ca300f984f$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $b7a640ca300f984f$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $b7a640ca300f984f$var$getNextPageParam(options, data) != null;
}
function $b7a640ca300f984f$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $b7a640ca300f984f$var$getPreviousPageParam(options, data) != null;
}


var $79c9c45c793aba73$var$_queryCache, $79c9c45c793aba73$var$_mutationCache, $79c9c45c793aba73$var$_defaultOptions, $79c9c45c793aba73$var$_queryDefaults, $79c9c45c793aba73$var$_mutationDefaults, $79c9c45c793aba73$var$_mountCount, $79c9c45c793aba73$var$_unsubscribeFocus, $79c9c45c793aba73$var$_unsubscribeOnline;
var $79c9c45c793aba73$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $79c9c45c793aba73$var$_queryCache);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $79c9c45c793aba73$var$_mutationCache);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $79c9c45c793aba73$var$_defaultOptions);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $79c9c45c793aba73$var$_queryDefaults);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $79c9c45c793aba73$var$_mutationDefaults);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $79c9c45c793aba73$var$_mountCount);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $79c9c45c793aba73$var$_unsubscribeFocus);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $79c9c45c793aba73$var$_unsubscribeOnline);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_queryCache, config.queryCache || new (0, $fcfe3a80e1a60282$export$5dde0cd941da8468)());
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_mutationCache, config.mutationCache || new (0, $448a6c8b1db0be7b$export$1fcfd9a244434844)());
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_defaultOptions, config.defaultOptions || {});
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_mountCount, 0);
    }
    mount() {
        (0, $fee147b415f7ff33$export$b1fe7cbb4502036b)(this, $79c9c45c793aba73$var$_mountCount)._++;
        if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_mountCount) !== 1) return;
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_unsubscribeFocus, (0, $5ae4d1fd12e36b30$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).onFocus();
            }
        }));
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_unsubscribeOnline, (0, $f43b4df52e5a8fa8$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $fee147b415f7ff33$export$b1fe7cbb4502036b)(this, $79c9c45c793aba73$var$_mountCount)._--;
        if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_mountCount) !== 0) return;
        (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_unsubscribeFocus, void 0);
        (_b = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $b204d4f45461ab39$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $b204d4f45461ab39$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache);
        (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache);
        return (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $b204d4f45461ab39$export$8793edee2d425525)).catch((0, $b204d4f45461ab39$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $b204d4f45461ab39$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $b204d4f45461ab39$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, $b204d4f45461ab39$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $b204d4f45461ab39$export$8793edee2d425525)).catch((0, $b204d4f45461ab39$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $b7a640ca300f984f$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $b204d4f45461ab39$export$8793edee2d425525)).catch((0, $b204d4f45461ab39$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $b7a640ca300f984f$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $f43b4df52e5a8fa8$export$b113e788b2dd3fdc).isOnline()) return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache);
    }
    getMutationCache() {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $79c9c45c793aba73$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryDefaults).set((0, $b204d4f45461ab39$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $b204d4f45461ab39$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_mutationDefaults).set((0, $b204d4f45461ab39$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $b204d4f45461ab39$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $b204d4f45461ab39$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $b204d4f45461ab39$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_queryCache).clear();
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $79c9c45c793aba73$var$_mutationCache).clear();
    }
};
$79c9c45c793aba73$var$_queryCache = new WeakMap();
$79c9c45c793aba73$var$_mutationCache = new WeakMap();
$79c9c45c793aba73$var$_defaultOptions = new WeakMap();
$79c9c45c793aba73$var$_queryDefaults = new WeakMap();
$79c9c45c793aba73$var$_mutationDefaults = new WeakMap();
$79c9c45c793aba73$var$_mountCount = new WeakMap();
$79c9c45c793aba73$var$_unsubscribeFocus = new WeakMap();
$79c9c45c793aba73$var$_unsubscribeOnline = new WeakMap();


var $baslc = parcelRequire("baslc");

"use client";
var $797f0ac2fbf7fdb2$export$da112d31b0149f31 = $baslc.createContext(void 0);
var $797f0ac2fbf7fdb2$export$22e77b9572c4fded = (queryClient)=>{
    const client = $baslc.useContext($797f0ac2fbf7fdb2$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $797f0ac2fbf7fdb2$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $baslc.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $d6899a6188537778$exports.jsx)($797f0ac2fbf7fdb2$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};



var $baslc = parcelRequire("baslc");
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $baslc = parcelRequire("baslc");

var $ePvRJ = parcelRequire("ePvRJ");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $788450170d0f774a$var$_extends() {
    $788450170d0f774a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $788450170d0f774a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $788450170d0f774a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($788450170d0f774a$export$e19cd5f9376f8cee || ($788450170d0f774a$export$e19cd5f9376f8cee = {}));
const $788450170d0f774a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $788450170d0f774a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $788450170d0f774a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $788450170d0f774a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $788450170d0f774a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $788450170d0f774a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $788450170d0f774a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $788450170d0f774a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $788450170d0f774a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $788450170d0f774a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $788450170d0f774a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $788450170d0f774a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $788450170d0f774a$export$fe53371bee54353d(to);
    }
    return $788450170d0f774a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $788450170d0f774a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $788450170d0f774a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $788450170d0f774a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $788450170d0f774a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $788450170d0f774a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $788450170d0f774a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $788450170d0f774a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $788450170d0f774a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $788450170d0f774a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $788450170d0f774a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $788450170d0f774a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $788450170d0f774a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $788450170d0f774a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $788450170d0f774a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $788450170d0f774a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $788450170d0f774a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $788450170d0f774a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $788450170d0f774a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($788450170d0f774a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $788450170d0f774a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $788450170d0f774a$export$e19cd5f9376f8cee.Push;
        let location = $788450170d0f774a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $788450170d0f774a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $788450170d0f774a$export$e19cd5f9376f8cee.Replace;
        let location = $788450170d0f774a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $788450170d0f774a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $788450170d0f774a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $788450170d0f774a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($788450170d0f774a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($788450170d0f774a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $788450170d0f774a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($788450170d0f774a$var$ResultType || ($788450170d0f774a$var$ResultType = {}));
const $788450170d0f774a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $788450170d0f774a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $788450170d0f774a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $788450170d0f774a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $788450170d0f774a$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($788450170d0f774a$var$isIndexRoute(route)) {
            let indexRoute = $788450170d0f774a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $788450170d0f774a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $788450170d0f774a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $788450170d0f774a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $788450170d0f774a$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $788450170d0f774a$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $788450170d0f774a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $788450170d0f774a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $788450170d0f774a$var$flattenRoutes(routes);
    $788450170d0f774a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $788450170d0f774a$export$30d21fd6d7295f52(pathname);
        matches = $788450170d0f774a$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $788450170d0f774a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $788450170d0f774a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $788450170d0f774a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $788450170d0f774a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $788450170d0f774a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $788450170d0f774a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $788450170d0f774a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $788450170d0f774a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $788450170d0f774a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $788450170d0f774a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $788450170d0f774a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $788450170d0f774a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $788450170d0f774a$var$paramRe = /^:[\w-]+$/;
const $788450170d0f774a$var$dynamicSegmentValue = 3;
const $788450170d0f774a$var$indexRouteValue = 2;
const $788450170d0f774a$var$emptySegmentValue = 1;
const $788450170d0f774a$var$staticSegmentValue = 10;
const $788450170d0f774a$var$splatPenalty = -2;
const $788450170d0f774a$var$isSplat = (s)=>s === "*";
function $788450170d0f774a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($788450170d0f774a$var$isSplat)) initialScore += $788450170d0f774a$var$splatPenalty;
    if (index) initialScore += $788450170d0f774a$var$indexRouteValue;
    return segments.filter((s)=>!$788450170d0f774a$var$isSplat(s)).reduce((score, segment)=>score + ($788450170d0f774a$var$paramRe.test(segment) ? $788450170d0f774a$var$dynamicSegmentValue : segment === "" ? $788450170d0f774a$var$emptySegmentValue : $788450170d0f774a$var$staticSegmentValue), initialScore);
}
function $788450170d0f774a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $788450170d0f774a$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $788450170d0f774a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $788450170d0f774a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $788450170d0f774a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $788450170d0f774a$export$a5c6d149b50c1d86($788450170d0f774a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $788450170d0f774a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $788450170d0f774a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $788450170d0f774a$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $788450170d0f774a$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $788450170d0f774a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $788450170d0f774a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $788450170d0f774a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $788450170d0f774a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $788450170d0f774a$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $788450170d0f774a$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $788450170d0f774a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $788450170d0f774a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $788450170d0f774a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $788450170d0f774a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $788450170d0f774a$var$normalizeSearch(search),
        hash: $788450170d0f774a$var$normalizeHash(hash)
    };
}
function $788450170d0f774a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $788450170d0f774a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $788450170d0f774a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $788450170d0f774a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $788450170d0f774a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $788450170d0f774a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $788450170d0f774a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $788450170d0f774a$var$_extends({}, toArg);
        $788450170d0f774a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $788450170d0f774a$var$getInvalidPathError("?", "pathname", "search", to));
        $788450170d0f774a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $788450170d0f774a$var$getInvalidPathError("#", "pathname", "hash", to));
        $788450170d0f774a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $788450170d0f774a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $788450170d0f774a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $788450170d0f774a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $788450170d0f774a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $788450170d0f774a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $788450170d0f774a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $788450170d0f774a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $788450170d0f774a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $788450170d0f774a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $788450170d0f774a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $788450170d0f774a$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $788450170d0f774a$export$4051a07651545597(data, init) {
    return new $788450170d0f774a$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $788450170d0f774a$export$42a99a7a4bc0e76a extends Error {
}
class $788450170d0f774a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $788450170d0f774a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $788450170d0f774a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $788450170d0f774a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $788450170d0f774a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $788450170d0f774a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $788450170d0f774a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $788450170d0f774a$var$unwrapTrackedPromise(value) {
    if (!$788450170d0f774a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $788450170d0f774a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $788450170d0f774a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $788450170d0f774a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $788450170d0f774a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $788450170d0f774a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $788450170d0f774a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $788450170d0f774a$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $788450170d0f774a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $788450170d0f774a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $788450170d0f774a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $788450170d0f774a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $788450170d0f774a$var$validMutationMethods = new Set($788450170d0f774a$var$validMutationMethodsArr);
const $788450170d0f774a$var$validRequestMethodsArr = [
    "get",
    ...$788450170d0f774a$var$validMutationMethodsArr
];
const $788450170d0f774a$var$validRequestMethods = new Set($788450170d0f774a$var$validRequestMethodsArr);
const $788450170d0f774a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $788450170d0f774a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $788450170d0f774a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $788450170d0f774a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $788450170d0f774a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $788450170d0f774a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $788450170d0f774a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $788450170d0f774a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $788450170d0f774a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $788450170d0f774a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $788450170d0f774a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $788450170d0f774a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $788450170d0f774a$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $788450170d0f774a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $788450170d0f774a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $788450170d0f774a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $788450170d0f774a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$788450170d0f774a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$788450170d0f774a$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $788450170d0f774a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $788450170d0f774a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $788450170d0f774a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $788450170d0f774a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $788450170d0f774a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$788450170d0f774a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($788450170d0f774a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $788450170d0f774a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $788450170d0f774a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $788450170d0f774a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $788450170d0f774a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $788450170d0f774a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $788450170d0f774a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $788450170d0f774a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $788450170d0f774a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $788450170d0f774a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($788450170d0f774a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $788450170d0f774a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $788450170d0f774a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $788450170d0f774a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $788450170d0f774a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $788450170d0f774a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $788450170d0f774a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $788450170d0f774a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $788450170d0f774a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $788450170d0f774a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $788450170d0f774a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $788450170d0f774a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $788450170d0f774a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $788450170d0f774a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $788450170d0f774a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $788450170d0f774a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $788450170d0f774a$var$findNearestBoundary(matches).route.id,
            {
                type: $788450170d0f774a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $788450170d0f774a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($788450170d0f774a$var$isErrorResult(result) && $788450170d0f774a$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $788450170d0f774a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $788450170d0f774a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $788450170d0f774a$var$_extends({
            matches: updatedMatches || matches
        }, $788450170d0f774a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $788450170d0f774a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $788450170d0f774a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $788450170d0f774a$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $788450170d0f774a$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $788450170d0f774a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $788450170d0f774a$var$ResultType.error,
            error: $788450170d0f774a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($788450170d0f774a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $788450170d0f774a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($788450170d0f774a$var$isDeferredResult(result)) throw $788450170d0f774a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($788450170d0f774a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $788450170d0f774a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $788450170d0f774a$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $788450170d0f774a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $788450170d0f774a$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($788450170d0f774a$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $788450170d0f774a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $788450170d0f774a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $788450170d0f774a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $788450170d0f774a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $788450170d0f774a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $788450170d0f774a$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $788450170d0f774a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $788450170d0f774a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $788450170d0f774a$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $788450170d0f774a$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$788450170d0f774a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $788450170d0f774a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $788450170d0f774a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $788450170d0f774a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $788450170d0f774a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $788450170d0f774a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $788450170d0f774a$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $788450170d0f774a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $788450170d0f774a$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $788450170d0f774a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $788450170d0f774a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $788450170d0f774a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $788450170d0f774a$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($788450170d0f774a$var$isRedirectResult(actionResult) || $788450170d0f774a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $788450170d0f774a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($788450170d0f774a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $788450170d0f774a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $788450170d0f774a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($788450170d0f774a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($788450170d0f774a$var$isDeferredResult(actionResult)) throw $788450170d0f774a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $788450170d0f774a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $788450170d0f774a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $788450170d0f774a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $788450170d0f774a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $788450170d0f774a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $788450170d0f774a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $788450170d0f774a$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $788450170d0f774a$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $788450170d0f774a$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $788450170d0f774a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $788450170d0f774a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $788450170d0f774a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $788450170d0f774a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $788450170d0f774a$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $788450170d0f774a$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $788450170d0f774a$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($788450170d0f774a$var$isDeferredResult(result)) result = await $788450170d0f774a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $788450170d0f774a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($788450170d0f774a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $788450170d0f774a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($788450170d0f774a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $788450170d0f774a$export$3e9cee6b33872309(!$788450170d0f774a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $788450170d0f774a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $788450170d0f774a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $788450170d0f774a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $788450170d0f774a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($788450170d0f774a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $788450170d0f774a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $788450170d0f774a$export$e19cd5f9376f8cee.Replace : $788450170d0f774a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $788450170d0f774a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($788450170d0f774a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $788450170d0f774a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $788450170d0f774a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $788450170d0f774a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $788450170d0f774a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $788450170d0f774a$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($788450170d0f774a$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $788450170d0f774a$var$ResultType.redirect,
                response: $788450170d0f774a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $788450170d0f774a$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $788450170d0f774a$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $788450170d0f774a$var$ResultType.error,
                    error: $788450170d0f774a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $788450170d0f774a$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $788450170d0f774a$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $788450170d0f774a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $788450170d0f774a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $788450170d0f774a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $788450170d0f774a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $788450170d0f774a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $788450170d0f774a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $788450170d0f774a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $788450170d0f774a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $788450170d0f774a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $788450170d0f774a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $788450170d0f774a$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $788450170d0f774a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$788450170d0f774a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $788450170d0f774a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $788450170d0f774a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $788450170d0f774a$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $788450170d0f774a$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $788450170d0f774a$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $788450170d0f774a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $788450170d0f774a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $788450170d0f774a$export$4d0306f8f6a4585b = Symbol("deferred");
function $788450170d0f774a$export$3336b097a6fbc59a(routes, opts) {
    $788450170d0f774a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $788450170d0f774a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $788450170d0f774a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $788450170d0f774a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $788450170d0f774a$var$createLocation("", $788450170d0f774a$export$fe53371bee54353d(url), null, "default");
        let matches = $788450170d0f774a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$788450170d0f774a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $788450170d0f774a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $788450170d0f774a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $788450170d0f774a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $788450170d0f774a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($788450170d0f774a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $788450170d0f774a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $788450170d0f774a$var$createLocation("", $788450170d0f774a$export$fe53371bee54353d(url), null, "default");
        let matches = $788450170d0f774a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$788450170d0f774a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $788450170d0f774a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $788450170d0f774a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $788450170d0f774a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $788450170d0f774a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $788450170d0f774a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($788450170d0f774a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$788450170d0f774a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $788450170d0f774a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($788450170d0f774a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $788450170d0f774a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $788450170d0f774a$var$isResponse(result) ? result : $788450170d0f774a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($788450170d0f774a$var$isDataStrategyResult(e) && $788450170d0f774a$var$isResponse(e.result)) {
                if (e.type === $788450170d0f774a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($788450170d0f774a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $788450170d0f774a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $788450170d0f774a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $788450170d0f774a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($788450170d0f774a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($788450170d0f774a$var$isDeferredResult(result)) {
            let error = $788450170d0f774a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $788450170d0f774a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($788450170d0f774a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($788450170d0f774a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $788450170d0f774a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $788450170d0f774a$var$_extends({}, context, {
                statusCode: $788450170d0f774a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $788450170d0f774a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $788450170d0f774a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $788450170d0f774a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $788450170d0f774a$var$isErrorResult(pendingActionResult[1]) ? $788450170d0f774a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $788450170d0f774a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $788450170d0f774a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $788450170d0f774a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $788450170d0f774a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $788450170d0f774a$var$callDataStrategyImpl(dataStrategy || $788450170d0f774a$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($788450170d0f774a$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $788450170d0f774a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($788450170d0f774a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $788450170d0f774a$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $788450170d0f774a$export$fec11da027c70692(routes, context, error) {
    let newContext = $788450170d0f774a$var$_extends({}, context, {
        statusCode: $788450170d0f774a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $788450170d0f774a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $788450170d0f774a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $788450170d0f774a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $788450170d0f774a$export$cae722b0cc860f13(to ? to : ".", $788450170d0f774a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $788450170d0f774a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $788450170d0f774a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $788450170d0f774a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $788450170d0f774a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $788450170d0f774a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$788450170d0f774a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$788450170d0f774a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $788450170d0f774a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $788450170d0f774a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $788450170d0f774a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$788450170d0f774a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$788450170d0f774a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $788450170d0f774a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $788450170d0f774a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $788450170d0f774a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $788450170d0f774a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $788450170d0f774a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($788450170d0f774a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $788450170d0f774a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $788450170d0f774a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $788450170d0f774a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $788450170d0f774a$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $788450170d0f774a$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $788450170d0f774a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $788450170d0f774a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $788450170d0f774a$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $788450170d0f774a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $788450170d0f774a$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($788450170d0f774a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $788450170d0f774a$var$shouldRevalidateLoader(match, $788450170d0f774a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $788450170d0f774a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $788450170d0f774a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $788450170d0f774a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $788450170d0f774a$var$shouldRevalidateLoader(fetcherMatch, $788450170d0f774a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $788450170d0f774a$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $788450170d0f774a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $788450170d0f774a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $788450170d0f774a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $788450170d0f774a$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $788450170d0f774a$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$788450170d0f774a$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $788450170d0f774a$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $788450170d0f774a$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$788450170d0f774a$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $788450170d0f774a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $788450170d0f774a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $788450170d0f774a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$788450170d0f774a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $788450170d0f774a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $788450170d0f774a$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $788450170d0f774a$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $788450170d0f774a$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $788450170d0f774a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $788450170d0f774a$var$ResultType.data,
                result: undefined
            });
        };
        return $788450170d0f774a$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $788450170d0f774a$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $788450170d0f774a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $788450170d0f774a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $788450170d0f774a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $788450170d0f774a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $788450170d0f774a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $788450170d0f774a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($788450170d0f774a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $788450170d0f774a$var$ResultType.error,
                error: e
            };
        }
        if (type === $788450170d0f774a$var$ResultType.error) return {
            type: $788450170d0f774a$var$ResultType.error,
            error: new $788450170d0f774a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $788450170d0f774a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $788450170d0f774a$var$ResultType.error) {
        if ($788450170d0f774a$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $788450170d0f774a$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $788450170d0f774a$var$ResultType.error,
                error: new $788450170d0f774a$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $788450170d0f774a$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $788450170d0f774a$var$ResultType.error,
            error: result,
            statusCode: $788450170d0f774a$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($788450170d0f774a$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $788450170d0f774a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($788450170d0f774a$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $788450170d0f774a$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $788450170d0f774a$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $788450170d0f774a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $788450170d0f774a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$788450170d0f774a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $788450170d0f774a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $788450170d0f774a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($788450170d0f774a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $788450170d0f774a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $788450170d0f774a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($788450170d0f774a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $788450170d0f774a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $788450170d0f774a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $788450170d0f774a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $788450170d0f774a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $788450170d0f774a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $788450170d0f774a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $788450170d0f774a$export$3e9cee6b33872309(!$788450170d0f774a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($788450170d0f774a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $788450170d0f774a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $788450170d0f774a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($788450170d0f774a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $788450170d0f774a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $788450170d0f774a$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $788450170d0f774a$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($788450170d0f774a$var$isErrorResult(result)) {
            let boundaryMatch = $788450170d0f774a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $788450170d0f774a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($788450170d0f774a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $788450170d0f774a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($788450170d0f774a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $788450170d0f774a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $788450170d0f774a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $788450170d0f774a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $788450170d0f774a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $788450170d0f774a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $788450170d0f774a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $788450170d0f774a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $788450170d0f774a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $788450170d0f774a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $788450170d0f774a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $788450170d0f774a$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($788450170d0f774a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $788450170d0f774a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $788450170d0f774a$export$8ccf933b0513f8d0(path) : path;
    return $788450170d0f774a$export$fe53371bee54353d($788450170d0f774a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $788450170d0f774a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $788450170d0f774a$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $788450170d0f774a$var$ResultType.data || result.type === $788450170d0f774a$var$ResultType.error);
}
function $788450170d0f774a$var$isRedirectDataStrategyResultResult(result) {
    return $788450170d0f774a$var$isResponse(result.result) && $788450170d0f774a$var$redirectStatusCodes.has(result.result.status);
}
function $788450170d0f774a$var$isDeferredResult(result) {
    return result.type === $788450170d0f774a$var$ResultType.deferred;
}
function $788450170d0f774a$var$isErrorResult(result) {
    return result.type === $788450170d0f774a$var$ResultType.error;
}
function $788450170d0f774a$var$isRedirectResult(result) {
    return (result && result.type) === $788450170d0f774a$var$ResultType.redirect;
}
function $788450170d0f774a$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $788450170d0f774a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $788450170d0f774a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $788450170d0f774a$var$isRedirectResponse(result) {
    if (!$788450170d0f774a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $788450170d0f774a$var$isValidMethod(method) {
    return $788450170d0f774a$var$validRequestMethods.has(method.toLowerCase());
}
function $788450170d0f774a$var$isMutationMethod(method) {
    return $788450170d0f774a$var$validMutationMethods.has(method.toLowerCase());
}
async function $788450170d0f774a$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$788450170d0f774a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($788450170d0f774a$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $788450170d0f774a$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $788450170d0f774a$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($788450170d0f774a$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $788450170d0f774a$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $788450170d0f774a$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $788450170d0f774a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $788450170d0f774a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $788450170d0f774a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $788450170d0f774a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $788450170d0f774a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $788450170d0f774a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $788450170d0f774a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $788450170d0f774a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $788450170d0f774a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $788450170d0f774a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $788450170d0f774a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $788450170d0f774a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $788450170d0f774a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $788450170d0f774a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $788450170d0f774a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $788450170d0f774a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($788450170d0f774a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $788450170d0f774a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($788450170d0f774a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $788450170d0f774a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $baslc = parcelRequire("baslc");

function $548c01f246e0e865$var$_extends() {
    $548c01f246e0e865$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $548c01f246e0e865$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $548c01f246e0e865$export$3add0d5dce533e2e = /*#__PURE__*/ $baslc.createContext(null);
const $548c01f246e0e865$export$145dfa71566a64dc = /*#__PURE__*/ $baslc.createContext(null);
const $548c01f246e0e865$var$AwaitContext = /*#__PURE__*/ $baslc.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $548c01f246e0e865$export$26749e8557646306 = /*#__PURE__*/ $baslc.createContext(null);
const $548c01f246e0e865$export$c7914228fb69b0f5 = /*#__PURE__*/ $baslc.createContext(null);
const $548c01f246e0e865$export$9072aa6dd1f93057 = /*#__PURE__*/ $baslc.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $548c01f246e0e865$var$RouteErrorContext = /*#__PURE__*/ $baslc.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $548c01f246e0e865$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$548c01f246e0e865$export$9c954a9d03d32f4a() && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $baslc.useContext($548c01f246e0e865$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $548c01f246e0e865$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $788450170d0f774a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $548c01f246e0e865$export$9c954a9d03d32f4a() {
    return $baslc.useContext($548c01f246e0e865$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $548c01f246e0e865$export$45d76561a5302f2b() {
    !$548c01f246e0e865$export$9c954a9d03d32f4a() && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    return $baslc.useContext($548c01f246e0e865$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $548c01f246e0e865$export$1b3f31771c5d07c() {
    return $baslc.useContext($548c01f246e0e865$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $548c01f246e0e865$export$6c330e8992e8a295(pattern) {
    !$548c01f246e0e865$export$9c954a9d03d32f4a() && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $548c01f246e0e865$export$45d76561a5302f2b();
    return $baslc.useMemo(()=>(0, $788450170d0f774a$export$81336c211d5ff295)(pattern, (0, $788450170d0f774a$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $548c01f246e0e865$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $548c01f246e0e865$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $baslc.useContext($548c01f246e0e865$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $baslc.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $548c01f246e0e865$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $baslc.useContext($548c01f246e0e865$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $548c01f246e0e865$var$useNavigateStable() : $548c01f246e0e865$var$useNavigateUnstable();
}
function $548c01f246e0e865$var$useNavigateUnstable() {
    !$548c01f246e0e865$export$9c954a9d03d32f4a() && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $baslc.useContext($548c01f246e0e865$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $baslc.useContext($548c01f246e0e865$export$26749e8557646306);
    let { matches: matches } = $baslc.useContext($548c01f246e0e865$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $548c01f246e0e865$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $788450170d0f774a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $baslc.useRef(false);
    $548c01f246e0e865$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $baslc.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $788450170d0f774a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $788450170d0f774a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $548c01f246e0e865$var$OutletContext = /*#__PURE__*/ $baslc.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $548c01f246e0e865$export$4138103a3ae699cc() {
    return $baslc.useContext($548c01f246e0e865$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $548c01f246e0e865$export$a3be3530d8e40d0b(context) {
    let outlet = $baslc.useContext($548c01f246e0e865$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $548c01f246e0e865$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $baslc.useContext($548c01f246e0e865$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $548c01f246e0e865$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $baslc.useContext($548c01f246e0e865$export$26749e8557646306);
    let { matches: matches } = $baslc.useContext($548c01f246e0e865$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $548c01f246e0e865$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $788450170d0f774a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $baslc.useMemo(()=>(0, $788450170d0f774a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $548c01f246e0e865$export$5d3fca4a98652595(routes, locationArg) {
    return $548c01f246e0e865$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $548c01f246e0e865$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$548c01f246e0e865$export$9c954a9d03d32f4a() && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $baslc.useContext($548c01f246e0e865$export$26749e8557646306);
    let { matches: parentMatches } = $baslc.useContext($548c01f246e0e865$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $548c01f246e0e865$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $788450170d0f774a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $788450170d0f774a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $548c01f246e0e865$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $788450170d0f774a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $788450170d0f774a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $548c01f246e0e865$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $788450170d0f774a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $548c01f246e0e865$var$DefaultErrorComponent() {
    let error = $548c01f246e0e865$export$ed527bf60f6e05f2();
    let message = (0, $788450170d0f774a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $baslc.createElement($baslc.Fragment, null, /*#__PURE__*/ $baslc.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $baslc.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $baslc.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $548c01f246e0e865$var$defaultErrorElement = /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$DefaultErrorComponent, null);
class $548c01f246e0e865$var$RenderErrorBoundary extends $baslc.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $548c01f246e0e865$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $baslc.useContext($548c01f246e0e865$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $548c01f246e0e865$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $548c01f246e0e865$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $548c01f246e0e865$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $baslc.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $548c01f246e0e865$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($548c01f246e0e865$var$DataRouterHook || {});
var $548c01f246e0e865$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($548c01f246e0e865$var$DataRouterStateHook || {});
function $548c01f246e0e865$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $548c01f246e0e865$var$useDataRouterContext(hookName) {
    let ctx = $baslc.useContext($548c01f246e0e865$export$3add0d5dce533e2e);
    !ctx && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $548c01f246e0e865$var$useDataRouterState(hookName) {
    let state = $baslc.useContext($548c01f246e0e865$export$145dfa71566a64dc);
    !state && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    return state;
}
function $548c01f246e0e865$var$useRouteContext(hookName) {
    let route = $baslc.useContext($548c01f246e0e865$export$9072aa6dd1f93057);
    !route && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $548c01f246e0e865$var$useCurrentRouteId(hookName) {
    let route = $548c01f246e0e865$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $548c01f246e0e865$export$5fc8298006ad9e58() {
    return $548c01f246e0e865$var$useCurrentRouteId($548c01f246e0e865$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $548c01f246e0e865$export$d0fd4b7106de2769() {
    let state = $548c01f246e0e865$var$useDataRouterState($548c01f246e0e865$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $548c01f246e0e865$export$600dc272ed516c15() {
    let dataRouterContext = $548c01f246e0e865$var$useDataRouterContext($548c01f246e0e865$var$DataRouterHook.UseRevalidator);
    let state = $548c01f246e0e865$var$useDataRouterState($548c01f246e0e865$var$DataRouterStateHook.UseRevalidator);
    return $baslc.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $548c01f246e0e865$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $548c01f246e0e865$var$useDataRouterState($548c01f246e0e865$var$DataRouterStateHook.UseMatches);
    return $baslc.useMemo(()=>matches.map((m)=>(0, $788450170d0f774a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $548c01f246e0e865$export$1448a5050d252c4d() {
    let state = $548c01f246e0e865$var$useDataRouterState($548c01f246e0e865$var$DataRouterStateHook.UseLoaderData);
    let routeId = $548c01f246e0e865$var$useCurrentRouteId($548c01f246e0e865$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $548c01f246e0e865$export$fd5d37484eab868d(routeId) {
    let state = $548c01f246e0e865$var$useDataRouterState($548c01f246e0e865$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $548c01f246e0e865$export$fdc00f3f26066d5e() {
    let state = $548c01f246e0e865$var$useDataRouterState($548c01f246e0e865$var$DataRouterStateHook.UseActionData);
    let routeId = $548c01f246e0e865$var$useCurrentRouteId($548c01f246e0e865$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $548c01f246e0e865$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $baslc.useContext($548c01f246e0e865$var$RouteErrorContext);
    let state = $548c01f246e0e865$var$useDataRouterState($548c01f246e0e865$var$DataRouterStateHook.UseRouteError);
    let routeId = $548c01f246e0e865$var$useCurrentRouteId($548c01f246e0e865$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $548c01f246e0e865$export$78a72ddb39bdd145() {
    let value = $baslc.useContext($548c01f246e0e865$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $548c01f246e0e865$export$17f53340677d5831() {
    let value = $baslc.useContext($548c01f246e0e865$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $548c01f246e0e865$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $548c01f246e0e865$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $548c01f246e0e865$var$useDataRouterContext($548c01f246e0e865$var$DataRouterHook.UseBlocker);
    let state = $548c01f246e0e865$var$useDataRouterState($548c01f246e0e865$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $baslc.useState("");
    let blockerFunction = $baslc.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $548c01f246e0e865$var$_extends({}, currentLocation, {
                pathname: (0, $788450170d0f774a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $548c01f246e0e865$var$_extends({}, nextLocation, {
                pathname: (0, $788450170d0f774a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $baslc.useEffect(()=>{
        let key = String(++$548c01f246e0e865$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $baslc.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $788450170d0f774a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $548c01f246e0e865$var$useNavigateStable() {
    let { router: router } = $548c01f246e0e865$var$useDataRouterContext($548c01f246e0e865$var$DataRouterHook.UseNavigateStable);
    let id = $548c01f246e0e865$var$useCurrentRouteId($548c01f246e0e865$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $baslc.useRef(false);
    $548c01f246e0e865$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $baslc.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $548c01f246e0e865$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $548c01f246e0e865$var$alreadyWarned$1 = {};
function $548c01f246e0e865$var$warningOnce(key, cond, message) {
    if (!cond && !$548c01f246e0e865$var$alreadyWarned$1[key]) $548c01f246e0e865$var$alreadyWarned$1[key] = true;
}
const $548c01f246e0e865$var$alreadyWarned = {};
function $548c01f246e0e865$var$warnOnce(key, message) {}
const $548c01f246e0e865$var$logDeprecation = (flag, msg, link)=>$548c01f246e0e865$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $548c01f246e0e865$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $548c01f246e0e865$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $548c01f246e0e865$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $548c01f246e0e865$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $548c01f246e0e865$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $548c01f246e0e865$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $548c01f246e0e865$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $548c01f246e0e865$var$START_TRANSITION = "startTransition";
const $548c01f246e0e865$var$startTransitionImpl = $baslc[$548c01f246e0e865$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $548c01f246e0e865$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $baslc.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $baslc.useCallback((newState)=>{
        if (v7_startTransition && $548c01f246e0e865$var$startTransitionImpl) $548c01f246e0e865$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $baslc.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $baslc.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $baslc.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $baslc.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $baslc.useEffect(()=>$548c01f246e0e865$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $baslc.createElement($baslc.Fragment, null, /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $548c01f246e0e865$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $548c01f246e0e865$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $548c01f246e0e865$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $baslc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $788450170d0f774a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $baslc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $baslc.useCallback((newState)=>{
        v7_startTransition && $548c01f246e0e865$var$startTransitionImpl ? $548c01f246e0e865$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $baslc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $baslc.useEffect(()=>$548c01f246e0e865$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $548c01f246e0e865$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$548c01f246e0e865$export$9c954a9d03d32f4a() && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $baslc.useContext($548c01f246e0e865$export$26749e8557646306);
    let { matches: matches } = $baslc.useContext($548c01f246e0e865$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $548c01f246e0e865$export$45d76561a5302f2b();
    let navigate = $548c01f246e0e865$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $788450170d0f774a$export$cae722b0cc860f13)(to, (0, $788450170d0f774a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $baslc.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $548c01f246e0e865$export$910ae8079b2c2852(props) {
    return $548c01f246e0e865$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $548c01f246e0e865$export$e7b0ac011bb776c6(_props) {
    (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $548c01f246e0e865$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $788450170d0f774a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$548c01f246e0e865$export$9c954a9d03d32f4a() && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $baslc.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $548c01f246e0e865$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $788450170d0f774a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $baslc.useMemo(()=>{
        let trailingPathname = (0, $788450170d0f774a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $548c01f246e0e865$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $548c01f246e0e865$export$5d3fca4a98652595($548c01f246e0e865$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $548c01f246e0e865$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$ResolveAwait, null, children));
}
var $548c01f246e0e865$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($548c01f246e0e865$var$AwaitRenderStatus || {});
const $548c01f246e0e865$var$neverSettledPromise = new Promise(()=>{});
class $548c01f246e0e865$var$AwaitErrorBoundary extends $baslc.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $548c01f246e0e865$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $548c01f246e0e865$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $548c01f246e0e865$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $548c01f246e0e865$var$AwaitRenderStatus.error : "_data" in promise ? $548c01f246e0e865$var$AwaitRenderStatus.success : $548c01f246e0e865$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $548c01f246e0e865$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $548c01f246e0e865$var$AwaitRenderStatus.error && promise._error instanceof (0, $788450170d0f774a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $548c01f246e0e865$var$neverSettledPromise;
        if (status === $548c01f246e0e865$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $548c01f246e0e865$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $548c01f246e0e865$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $baslc.createElement($548c01f246e0e865$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $548c01f246e0e865$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $548c01f246e0e865$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $baslc.createElement($baslc.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $548c01f246e0e865$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $baslc.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $baslc.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $baslc.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $548c01f246e0e865$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $548c01f246e0e865$export$e7b0ac011bb776c6) && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $548c01f246e0e865$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $548c01f246e0e865$export$daf73786167a7f72(matches) {
    return $548c01f246e0e865$var$_renderMatches(matches);
}
function $548c01f246e0e865$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $baslc.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $baslc.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $baslc.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $548c01f246e0e865$export$f30f7e456d254e83(routes, opts) {
    return (0, $788450170d0f774a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $548c01f246e0e865$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $788450170d0f774a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $548c01f246e0e865$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $c9ac255259af38e5$var$_extends() {
    $c9ac255259af38e5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c9ac255259af38e5$var$_extends.apply(this, arguments);
}
function $c9ac255259af38e5$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c9ac255259af38e5$var$defaultMethod = "get";
const $c9ac255259af38e5$var$defaultEncType = "application/x-www-form-urlencoded";
function $c9ac255259af38e5$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c9ac255259af38e5$var$isButtonElement(object) {
    return $c9ac255259af38e5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c9ac255259af38e5$var$isFormElement(object) {
    return $c9ac255259af38e5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c9ac255259af38e5$var$isInputElement(object) {
    return $c9ac255259af38e5$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c9ac255259af38e5$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c9ac255259af38e5$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c9ac255259af38e5$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c9ac255259af38e5$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c9ac255259af38e5$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c9ac255259af38e5$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c9ac255259af38e5$var$_formDataSupportsSubmitter = null;
function $c9ac255259af38e5$var$isFormDataSubmitterSupported() {
    if ($c9ac255259af38e5$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c9ac255259af38e5$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c9ac255259af38e5$var$_formDataSupportsSubmitter = true;
    }
    return $c9ac255259af38e5$var$_formDataSupportsSubmitter;
}
const $c9ac255259af38e5$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c9ac255259af38e5$var$getFormEncType(encType) {
    if (encType != null && !$c9ac255259af38e5$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c9ac255259af38e5$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c9ac255259af38e5$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $788450170d0f774a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $c9ac255259af38e5$var$defaultMethod;
        encType = $c9ac255259af38e5$var$getFormEncType(target.getAttribute("enctype")) || $c9ac255259af38e5$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c9ac255259af38e5$var$isButtonElement(target) || $c9ac255259af38e5$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $788450170d0f774a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c9ac255259af38e5$var$defaultMethod;
        encType = $c9ac255259af38e5$var$getFormEncType(target.getAttribute("formenctype")) || $c9ac255259af38e5$var$getFormEncType(form.getAttribute("enctype")) || $c9ac255259af38e5$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c9ac255259af38e5$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c9ac255259af38e5$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c9ac255259af38e5$var$defaultMethod;
        action = null;
        encType = $c9ac255259af38e5$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c9ac255259af38e5$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $c9ac255259af38e5$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $c9ac255259af38e5$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $c9ac255259af38e5$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $c9ac255259af38e5$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $c9ac255259af38e5$export$1f3f55432a00e06d(routes, opts) {
    return (0, $788450170d0f774a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c9ac255259af38e5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $788450170d0f774a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c9ac255259af38e5$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $548c01f246e0e865$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c9ac255259af38e5$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $788450170d0f774a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c9ac255259af38e5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $788450170d0f774a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c9ac255259af38e5$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $548c01f246e0e865$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c9ac255259af38e5$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c9ac255259af38e5$var$_extends({}, state, {
        errors: $c9ac255259af38e5$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c9ac255259af38e5$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $788450170d0f774a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c9ac255259af38e5$export$7ad602f0e94e62d1 = /*#__PURE__*/ $baslc.createContext({
    isTransitioning: false
});
const $c9ac255259af38e5$export$148fd98d095596d4 = /*#__PURE__*/ $baslc.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c9ac255259af38e5$var$START_TRANSITION = "startTransition";
const $c9ac255259af38e5$var$startTransitionImpl = $baslc[$c9ac255259af38e5$var$START_TRANSITION];
const $c9ac255259af38e5$var$FLUSH_SYNC = "flushSync";
const $c9ac255259af38e5$var$flushSyncImpl = $ePvRJ[$c9ac255259af38e5$var$FLUSH_SYNC];
const $c9ac255259af38e5$var$USE_ID = "useId";
const $c9ac255259af38e5$var$useIdImpl = $baslc[$c9ac255259af38e5$var$USE_ID];
function $c9ac255259af38e5$var$startTransitionSafe(cb) {
    if ($c9ac255259af38e5$var$startTransitionImpl) $c9ac255259af38e5$var$startTransitionImpl(cb);
    else cb();
}
function $c9ac255259af38e5$var$flushSyncSafe(cb) {
    if ($c9ac255259af38e5$var$flushSyncImpl) $c9ac255259af38e5$var$flushSyncImpl(cb);
    else cb();
}
class $c9ac255259af38e5$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c9ac255259af38e5$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $baslc.useState(router.state);
    let [pendingState, setPendingState] = $baslc.useState();
    let [vtContext, setVtContext] = $baslc.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $baslc.useState();
    let [transition, setTransition] = $baslc.useState();
    let [interruption, setInterruption] = $baslc.useState();
    let fetcherData = $baslc.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $baslc.useCallback((cb)=>{
        if (v7_startTransition) $c9ac255259af38e5$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $baslc.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $c9ac255259af38e5$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $c9ac255259af38e5$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $c9ac255259af38e5$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $c9ac255259af38e5$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $c9ac255259af38e5$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $baslc.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $baslc.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c9ac255259af38e5$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $baslc.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $baslc.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $baslc.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $baslc.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $baslc.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $baslc.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $baslc.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $baslc.useEffect(()=>(0, $548c01f246e0e865$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $baslc.createElement($baslc.Fragment, null, /*#__PURE__*/ $baslc.createElement((0, $548c01f246e0e865$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $baslc.createElement((0, $548c01f246e0e865$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $baslc.createElement($c9ac255259af38e5$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $baslc.createElement($c9ac255259af38e5$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $baslc.createElement((0, $548c01f246e0e865$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $baslc.createElement($c9ac255259af38e5$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $c9ac255259af38e5$var$MemoizedDataRoutes = /*#__PURE__*/ $baslc.memo($c9ac255259af38e5$var$DataRoutes);
function $c9ac255259af38e5$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $548c01f246e0e865$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c9ac255259af38e5$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $baslc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $788450170d0f774a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $baslc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $baslc.useCallback((newState)=>{
        v7_startTransition && $c9ac255259af38e5$var$startTransitionImpl ? $c9ac255259af38e5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $baslc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $baslc.useEffect(()=>(0, $548c01f246e0e865$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $baslc.createElement((0, $548c01f246e0e865$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c9ac255259af38e5$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $baslc.useRef();
    if (historyRef.current == null) historyRef.current = (0, $788450170d0f774a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $baslc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $baslc.useCallback((newState)=>{
        v7_startTransition && $c9ac255259af38e5$var$startTransitionImpl ? $c9ac255259af38e5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $baslc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $baslc.useEffect(()=>(0, $548c01f246e0e865$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $baslc.createElement((0, $548c01f246e0e865$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c9ac255259af38e5$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $baslc.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $baslc.useCallback((newState)=>{
        v7_startTransition && $c9ac255259af38e5$var$startTransitionImpl ? $c9ac255259af38e5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $baslc.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $baslc.useEffect(()=>(0, $548c01f246e0e865$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $baslc.createElement((0, $548c01f246e0e865$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $c9ac255259af38e5$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c9ac255259af38e5$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c9ac255259af38e5$export$a6c7ac8248d6e38a = /*#__PURE__*/ $baslc.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $c9ac255259af38e5$var$_objectWithoutPropertiesLoose(_ref7, $c9ac255259af38e5$var$_excluded);
    let { basename: basename } = $baslc.useContext((0, $548c01f246e0e865$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c9ac255259af38e5$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c9ac255259af38e5$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $788450170d0f774a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $548c01f246e0e865$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $c9ac255259af38e5$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $baslc.createElement("a", $c9ac255259af38e5$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c9ac255259af38e5$export$b0d92dbee9b5b60d = /*#__PURE__*/ $baslc.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $c9ac255259af38e5$var$_objectWithoutPropertiesLoose(_ref8, $c9ac255259af38e5$var$_excluded2);
    let path = (0, $548c01f246e0e865$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    let routerState = $baslc.useContext((0, $548c01f246e0e865$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $baslc.useContext((0, $548c01f246e0e865$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c9ac255259af38e5$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $788450170d0f774a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $baslc.createElement($c9ac255259af38e5$export$a6c7ac8248d6e38a, $c9ac255259af38e5$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c9ac255259af38e5$export$a7fed597f4b8afd8 = /*#__PURE__*/ $baslc.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c9ac255259af38e5$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $c9ac255259af38e5$var$_objectWithoutPropertiesLoose(_ref9, $c9ac255259af38e5$var$_excluded3);
    let submit = $c9ac255259af38e5$export$47c85c6e3a081d3();
    let formAction = $c9ac255259af38e5$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $baslc.createElement("form", $c9ac255259af38e5$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c9ac255259af38e5$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $c9ac255259af38e5$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c9ac255259af38e5$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c9ac255259af38e5$var$DataRouterHook || ($c9ac255259af38e5$var$DataRouterHook = {}));
var $c9ac255259af38e5$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c9ac255259af38e5$var$DataRouterStateHook || ($c9ac255259af38e5$var$DataRouterStateHook = {}));
// Internal hooks
function $c9ac255259af38e5$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $c9ac255259af38e5$var$useDataRouterContext(hookName) {
    let ctx = $baslc.useContext((0, $548c01f246e0e865$export$3add0d5dce533e2e));
    !ctx && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $c9ac255259af38e5$var$useDataRouterState(hookName) {
    let state = $baslc.useContext((0, $548c01f246e0e865$export$145dfa71566a64dc));
    !state && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c9ac255259af38e5$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    let location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    let path = (0, $548c01f246e0e865$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $baslc.useCallback((event)=>{
        if ($c9ac255259af38e5$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $788450170d0f774a$export$fe53371bee54353d)(location) === (0, $788450170d0f774a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c9ac255259af38e5$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $baslc.useRef($c9ac255259af38e5$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $baslc.useRef(false);
    let location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    let searchParams = $baslc.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c9ac255259af38e5$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    let setSearchParams = $baslc.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c9ac255259af38e5$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c9ac255259af38e5$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $c9ac255259af38e5$var$fetcherId = 0;
let $c9ac255259af38e5$var$getUniqueFetcherId = ()=>"__" + String(++$c9ac255259af38e5$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c9ac255259af38e5$export$47c85c6e3a081d3() {
    let { router: router } = $c9ac255259af38e5$var$useDataRouterContext($c9ac255259af38e5$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $baslc.useContext((0, $548c01f246e0e865$export$26749e8557646306));
    let currentRouteId = (0, $548c01f246e0e865$export$5fc8298006ad9e58)();
    return $baslc.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c9ac255259af38e5$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c9ac255259af38e5$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c9ac255259af38e5$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c9ac255259af38e5$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $baslc.useContext((0, $548c01f246e0e865$export$26749e8557646306));
    let routeContext = $baslc.useContext((0, $548c01f246e0e865$export$9072aa6dd1f93057));
    !routeContext && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c9ac255259af38e5$var$_extends({}, (0, $548c01f246e0e865$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $788450170d0f774a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $788450170d0f774a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c9ac255259af38e5$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c9ac255259af38e5$var$useDataRouterContext($c9ac255259af38e5$var$DataRouterHook.UseFetcher);
    let state = $c9ac255259af38e5$var$useDataRouterState($c9ac255259af38e5$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $baslc.useContext($c9ac255259af38e5$export$148fd98d095596d4);
    let route = $baslc.useContext((0, $548c01f246e0e865$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    !route && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $c9ac255259af38e5$var$useIdImpl ? $c9ac255259af38e5$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $baslc.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($c9ac255259af38e5$var$getUniqueFetcherId());
    // Registration/cleanup
    $baslc.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $baslc.useCallback((href, opts)=>{
        !routeId && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c9ac255259af38e5$export$47c85c6e3a081d3();
    let submit = $baslc.useCallback((target, opts)=>{
        submitImpl(target, $c9ac255259af38e5$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $baslc.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $baslc.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $baslc.createElement($c9ac255259af38e5$export$a7fed597f4b8afd8, $c9ac255259af38e5$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $788450170d0f774a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $baslc.useMemo(()=>$c9ac255259af38e5$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c9ac255259af38e5$export$fa996778a3a31087() {
    let state = $c9ac255259af38e5$var$useDataRouterState($c9ac255259af38e5$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $c9ac255259af38e5$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $c9ac255259af38e5$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c9ac255259af38e5$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c9ac255259af38e5$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $c9ac255259af38e5$var$useDataRouterContext($c9ac255259af38e5$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c9ac255259af38e5$var$useDataRouterState($c9ac255259af38e5$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $baslc.useContext((0, $548c01f246e0e865$export$26749e8557646306));
    let location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    let matches = (0, $548c01f246e0e865$export$2378eb7f5ff86053)();
    let navigation = (0, $548c01f246e0e865$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $baslc.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c9ac255259af38e5$var$usePageHide($baslc.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c9ac255259af38e5$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c9ac255259af38e5$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c9ac255259af38e5$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $baslc.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c9ac255259af38e5$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c9ac255259af38e5$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $baslc.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c9ac255259af38e5$var$_extends({}, location, {
                    pathname: (0, $788450170d0f774a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c9ac255259af38e5$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $baslc.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c9ac255259af38e5$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $baslc.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c9ac255259af38e5$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $baslc.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c9ac255259af38e5$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $548c01f246e0e865$export$b273b3273281a049)(when);
    $baslc.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $baslc.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c9ac255259af38e5$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $baslc.useContext($c9ac255259af38e5$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $788450170d0f774a$export$3e9cee6b33872309)(false);
    let { basename: basename } = $c9ac255259af38e5$var$useDataRouterContext($c9ac255259af38e5$var$DataRouterHook.useViewTransitionState);
    let path = (0, $548c01f246e0e865$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $788450170d0f774a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $788450170d0f774a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $788450170d0f774a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $788450170d0f774a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $baslc = parcelRequire("baslc");

// import { $ZodType } from "./schemas.js";
/** A special constant with type `never` */ const $3902e9f6ee6db121$export$96c94437c95d7862 = Object.freeze({
    status: "aborted"
});
/*@__NO_SIDE_EFFECTS__*/ function $3902e9f6ee6db121$export$3122533d606194de(name, initializer, params) {
    function init(inst, def) {
        var _a;
        Object.defineProperty(inst, "_zod", {
            value: inst._zod ?? {},
            enumerable: false
        });
        (_a = inst._zod).traits ?? (_a.traits = new Set());
        inst._zod.traits.add(name);
        initializer(inst, def);
        // support prototype modifications
        for(const k in _.prototype)if (!(k in inst)) Object.defineProperty(inst, k, {
            value: _.prototype[k].bind(inst)
        });
        inst._zod.constr = _;
        inst._zod.def = def;
    }
    // doesn't work if Parent has a constructor with arguments
    const Parent = params?.Parent ?? Object;
    class Definition extends Parent {
    }
    Object.defineProperty(Definition, "name", {
        value: name
    });
    function _(def) {
        var _a;
        const inst = params?.Parent ? new Definition() : this;
        init(inst, def);
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        for (const fn of inst._zod.deferred)fn();
        return inst;
    }
    Object.defineProperty(_, "init", {
        value: init
    });
    Object.defineProperty(_, Symbol.hasInstance, {
        value: (inst)=>{
            if (params?.Parent && inst instanceof params.Parent) return true;
            return inst?._zod?.traits?.has(name);
        }
    });
    Object.defineProperty(_, "name", {
        value: name
    });
    return _;
}
const $3902e9f6ee6db121$export$7d40e40c5b5a6c8f = Symbol("zod_brand");
class $3902e9f6ee6db121$export$13016bcec11ba196 extends Error {
    constructor(){
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
    }
}
class $3902e9f6ee6db121$export$a36d4c29b1151bde extends Error {
    constructor(name){
        super(`Encountered unidirectional transform during encode: ${name}`);
        this.name = "ZodEncodeError";
    }
}
const $3902e9f6ee6db121$export$f9cd1e43211d8a4a = {};
function $3902e9f6ee6db121$export$e506a1d27d1eaa20(newConfig) {
    if (newConfig) Object.assign($3902e9f6ee6db121$export$f9cd1e43211d8a4a, newConfig);
    return $3902e9f6ee6db121$export$f9cd1e43211d8a4a;
}


var $adf26e260fc47ffe$exports = {};

$parcel$export($adf26e260fc47ffe$exports, "cuid", () => $adf26e260fc47ffe$export$e057ec210c7d3443);
$parcel$export($adf26e260fc47ffe$exports, "cuid2", () => $adf26e260fc47ffe$export$af5866a6cccce9f0);
$parcel$export($adf26e260fc47ffe$exports, "ulid", () => $adf26e260fc47ffe$export$c34778236461ea95);
$parcel$export($adf26e260fc47ffe$exports, "xid", () => $adf26e260fc47ffe$export$5eecaf20006cb6cb);
$parcel$export($adf26e260fc47ffe$exports, "ksuid", () => $adf26e260fc47ffe$export$f49b11deeb9beb0f);
$parcel$export($adf26e260fc47ffe$exports, "nanoid", () => $adf26e260fc47ffe$export$ac4959f4f1338dfc);
$parcel$export($adf26e260fc47ffe$exports, "duration", () => $adf26e260fc47ffe$export$1f34108aa9eb96ab);
$parcel$export($adf26e260fc47ffe$exports, "extendedDuration", () => $adf26e260fc47ffe$export$e30244ba59a8cd84);
$parcel$export($adf26e260fc47ffe$exports, "guid", () => $adf26e260fc47ffe$export$46e8f25c7328f77e);
$parcel$export($adf26e260fc47ffe$exports, "uuid", () => $adf26e260fc47ffe$export$31b40729666a4ae0);
$parcel$export($adf26e260fc47ffe$exports, "uuid4", () => $adf26e260fc47ffe$export$19f53698e68b2496);
$parcel$export($adf26e260fc47ffe$exports, "uuid6", () => $adf26e260fc47ffe$export$1d78c41b29712c01);
$parcel$export($adf26e260fc47ffe$exports, "uuid7", () => $adf26e260fc47ffe$export$b3092b3ac1fa0ace);
$parcel$export($adf26e260fc47ffe$exports, "email", () => $adf26e260fc47ffe$export$d290fa47940df19d);
$parcel$export($adf26e260fc47ffe$exports, "html5Email", () => $adf26e260fc47ffe$export$d2c782992f0a89ee);
$parcel$export($adf26e260fc47ffe$exports, "rfc5322Email", () => $adf26e260fc47ffe$export$54f6bc2d4fd0bb08);
$parcel$export($adf26e260fc47ffe$exports, "unicodeEmail", () => $adf26e260fc47ffe$export$f8855510ae7521df);
$parcel$export($adf26e260fc47ffe$exports, "idnEmail", () => $adf26e260fc47ffe$export$d402ea1c27a77371);
$parcel$export($adf26e260fc47ffe$exports, "browserEmail", () => $adf26e260fc47ffe$export$9d1ec0311c8ce72e);
$parcel$export($adf26e260fc47ffe$exports, "emoji", () => $adf26e260fc47ffe$export$a19185d1233fc4b2);
$parcel$export($adf26e260fc47ffe$exports, "ipv4", () => $adf26e260fc47ffe$export$291a17a16047f284);
$parcel$export($adf26e260fc47ffe$exports, "ipv6", () => $adf26e260fc47ffe$export$4e0c86a59c658526);
$parcel$export($adf26e260fc47ffe$exports, "cidrv4", () => $adf26e260fc47ffe$export$fc96793d9715e5a1);
$parcel$export($adf26e260fc47ffe$exports, "cidrv6", () => $adf26e260fc47ffe$export$b6e650831cac87fb);
$parcel$export($adf26e260fc47ffe$exports, "base64", () => $adf26e260fc47ffe$export$b3b2de96497acc47);
$parcel$export($adf26e260fc47ffe$exports, "base64url", () => $adf26e260fc47ffe$export$7d21597c7bc64465);
$parcel$export($adf26e260fc47ffe$exports, "hostname", () => $adf26e260fc47ffe$export$640106f6dc7d2706);
$parcel$export($adf26e260fc47ffe$exports, "domain", () => $adf26e260fc47ffe$export$21779e503be4cd98);
$parcel$export($adf26e260fc47ffe$exports, "e164", () => $adf26e260fc47ffe$export$2fa5ed24c9ef198e);
$parcel$export($adf26e260fc47ffe$exports, "date", () => $adf26e260fc47ffe$export$324d90190a8b822a);
$parcel$export($adf26e260fc47ffe$exports, "time", () => $adf26e260fc47ffe$export$2da9be4cfdb689b1);
$parcel$export($adf26e260fc47ffe$exports, "datetime", () => $adf26e260fc47ffe$export$7ba4466dbd0f07e1);
$parcel$export($adf26e260fc47ffe$exports, "string", () => $adf26e260fc47ffe$export$22b082955e083ec3);
$parcel$export($adf26e260fc47ffe$exports, "bigint", () => $adf26e260fc47ffe$export$a0f65b52274bcc00);
$parcel$export($adf26e260fc47ffe$exports, "integer", () => $adf26e260fc47ffe$export$32744b5b3bba4764);
$parcel$export($adf26e260fc47ffe$exports, "number", () => $adf26e260fc47ffe$export$98e628dec113755e);
$parcel$export($adf26e260fc47ffe$exports, "boolean", () => $adf26e260fc47ffe$export$4a21f16c33752377);
$parcel$export($adf26e260fc47ffe$exports, "null", () => $adf26e260fc47ffe$export$7b1b591b262c240);
$parcel$export($adf26e260fc47ffe$exports, "undefined", () => $adf26e260fc47ffe$export$1db45310990710a5);
$parcel$export($adf26e260fc47ffe$exports, "lowercase", () => $adf26e260fc47ffe$export$5b1f80f3c282648c);
$parcel$export($adf26e260fc47ffe$exports, "uppercase", () => $adf26e260fc47ffe$export$6cfe151e6b925e83);
$parcel$export($adf26e260fc47ffe$exports, "hex", () => $adf26e260fc47ffe$export$834dfc94dde4b3d8);
$parcel$export($adf26e260fc47ffe$exports, "md5_hex", () => $adf26e260fc47ffe$export$7d7ef811f6d53a1);
$parcel$export($adf26e260fc47ffe$exports, "md5_base64", () => $adf26e260fc47ffe$export$85425f7cda9f4890);
$parcel$export($adf26e260fc47ffe$exports, "md5_base64url", () => $adf26e260fc47ffe$export$e54699b04083758c);
$parcel$export($adf26e260fc47ffe$exports, "sha1_hex", () => $adf26e260fc47ffe$export$2f163473ef893e12);
$parcel$export($adf26e260fc47ffe$exports, "sha1_base64", () => $adf26e260fc47ffe$export$fc9670fedfd2524a);
$parcel$export($adf26e260fc47ffe$exports, "sha1_base64url", () => $adf26e260fc47ffe$export$5b6729b977839ffd);
$parcel$export($adf26e260fc47ffe$exports, "sha256_hex", () => $adf26e260fc47ffe$export$a923016129fea5fb);
$parcel$export($adf26e260fc47ffe$exports, "sha256_base64", () => $adf26e260fc47ffe$export$ebc25582a9e85396);
$parcel$export($adf26e260fc47ffe$exports, "sha256_base64url", () => $adf26e260fc47ffe$export$9b7979bfebd9716e);
$parcel$export($adf26e260fc47ffe$exports, "sha384_hex", () => $adf26e260fc47ffe$export$61d1fe464d10a5d1);
$parcel$export($adf26e260fc47ffe$exports, "sha384_base64", () => $adf26e260fc47ffe$export$103403cb96133ac3);
$parcel$export($adf26e260fc47ffe$exports, "sha384_base64url", () => $adf26e260fc47ffe$export$eeafcb7aab6a9870);
$parcel$export($adf26e260fc47ffe$exports, "sha512_hex", () => $adf26e260fc47ffe$export$e246a4310a1ad74d);
$parcel$export($adf26e260fc47ffe$exports, "sha512_base64", () => $adf26e260fc47ffe$export$f698997e063dbdae);
$parcel$export($adf26e260fc47ffe$exports, "sha512_base64url", () => $adf26e260fc47ffe$export$a63330069e1b81f6);
const $adf26e260fc47ffe$export$e057ec210c7d3443 = /^[cC][^\s-]{8,}$/;
const $adf26e260fc47ffe$export$af5866a6cccce9f0 = /^[0-9a-z]+$/;
const $adf26e260fc47ffe$export$c34778236461ea95 = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/;
const $adf26e260fc47ffe$export$5eecaf20006cb6cb = /^[0-9a-vA-V]{20}$/;
const $adf26e260fc47ffe$export$f49b11deeb9beb0f = /^[A-Za-z0-9]{27}$/;
const $adf26e260fc47ffe$export$ac4959f4f1338dfc = /^[a-zA-Z0-9_-]{21}$/;
const $adf26e260fc47ffe$export$1f34108aa9eb96ab = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/;
const $adf26e260fc47ffe$export$e30244ba59a8cd84 = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
const $adf26e260fc47ffe$export$46e8f25c7328f77e = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/;
const $adf26e260fc47ffe$export$31b40729666a4ae0 = (version)=>{
    if (!version) return /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/;
    return new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${version}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`);
};
const $adf26e260fc47ffe$export$19f53698e68b2496 = /*@__PURE__*/ $adf26e260fc47ffe$export$31b40729666a4ae0(4);
const $adf26e260fc47ffe$export$1d78c41b29712c01 = /*@__PURE__*/ $adf26e260fc47ffe$export$31b40729666a4ae0(6);
const $adf26e260fc47ffe$export$b3092b3ac1fa0ace = /*@__PURE__*/ $adf26e260fc47ffe$export$31b40729666a4ae0(7);
const $adf26e260fc47ffe$export$d290fa47940df19d = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/;
const $adf26e260fc47ffe$export$d2c782992f0a89ee = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
const $adf26e260fc47ffe$export$54f6bc2d4fd0bb08 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const $adf26e260fc47ffe$export$f8855510ae7521df = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
const $adf26e260fc47ffe$export$d402ea1c27a77371 = /^[^\s@"]{1,64}@[^\s@]{1,255}$/u;
const $adf26e260fc47ffe$export$9d1ec0311c8ce72e = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $adf26e260fc47ffe$var$_emoji = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
function $adf26e260fc47ffe$export$a19185d1233fc4b2() {
    return new RegExp($adf26e260fc47ffe$var$_emoji, "u");
}
const $adf26e260fc47ffe$export$291a17a16047f284 = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $adf26e260fc47ffe$export$4e0c86a59c658526 = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/;
const $adf26e260fc47ffe$export$fc96793d9715e5a1 = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/;
const $adf26e260fc47ffe$export$b6e650831cac87fb = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/;
const $adf26e260fc47ffe$export$b3b2de96497acc47 = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/;
const $adf26e260fc47ffe$export$7d21597c7bc64465 = /^[A-Za-z0-9_-]*$/;
const $adf26e260fc47ffe$export$640106f6dc7d2706 = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/;
const $adf26e260fc47ffe$export$21779e503be4cd98 = /^([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
const $adf26e260fc47ffe$export$2fa5ed24c9ef198e = /^\+(?:[0-9]){6,14}[0-9]$/;
// const dateSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $adf26e260fc47ffe$var$dateSource = `(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))`;
const $adf26e260fc47ffe$export$324d90190a8b822a = /*@__PURE__*/ new RegExp(`^${$adf26e260fc47ffe$var$dateSource}$`);
function $adf26e260fc47ffe$var$timeSource(args) {
    const hhmm = `(?:[01]\\d|2[0-3]):[0-5]\\d`;
    const regex = typeof args.precision === "number" ? args.precision === -1 ? `${hhmm}` : args.precision === 0 ? `${hhmm}:[0-5]\\d` : `${hhmm}:[0-5]\\d\\.\\d{${args.precision}}` : `${hhmm}(?::[0-5]\\d(?:\\.\\d+)?)?`;
    return regex;
}
function $adf26e260fc47ffe$export$2da9be4cfdb689b1(args) {
    return new RegExp(`^${$adf26e260fc47ffe$var$timeSource(args)}$`);
}
function $adf26e260fc47ffe$export$7ba4466dbd0f07e1(args) {
    const time = $adf26e260fc47ffe$var$timeSource({
        precision: args.precision
    });
    const opts = [
        "Z"
    ];
    if (args.local) opts.push("");
    // if (args.offset) opts.push(`([+-]\\d{2}:\\d{2})`);
    if (args.offset) opts.push(`([+-](?:[01]\\d|2[0-3]):[0-5]\\d)`);
    const timeRegex = `${time}(?:${opts.join("|")})`;
    return new RegExp(`^${$adf26e260fc47ffe$var$dateSource}T(?:${timeRegex})$`);
}
const $adf26e260fc47ffe$export$22b082955e083ec3 = (params)=>{
    const regex = params ? `[\\s\\S]{${params?.minimum ?? 0},${params?.maximum ?? ""}}` : `[\\s\\S]*`;
    return new RegExp(`^${regex}$`);
};
const $adf26e260fc47ffe$export$a0f65b52274bcc00 = /^\d+n?$/;
const $adf26e260fc47ffe$export$32744b5b3bba4764 = /^\d+$/;
const $adf26e260fc47ffe$export$98e628dec113755e = /^-?\d+(?:\.\d+)?/i;
const $adf26e260fc47ffe$export$4a21f16c33752377 = /true|false/i;
const $adf26e260fc47ffe$export$7b1b591b262c240 = /null/i;
const $adf26e260fc47ffe$export$1db45310990710a5 = /undefined/i;
const $adf26e260fc47ffe$export$5b1f80f3c282648c = /^[^A-Z]*$/;
const $adf26e260fc47ffe$export$6cfe151e6b925e83 = /^[^a-z]*$/;
const $adf26e260fc47ffe$export$834dfc94dde4b3d8 = /^[0-9a-fA-F]*$/;
// Hash regexes for different algorithms and encodings
// Helper function to create base64 regex with exact length and padding
function $adf26e260fc47ffe$var$fixedBase64(bodyLength, padding) {
    return new RegExp(`^[A-Za-z0-9+/]{${bodyLength}}${padding}$`);
}
// Helper function to create base64url regex with exact length (no padding)
function $adf26e260fc47ffe$var$fixedBase64url(length) {
    return new RegExp(`^[A-Za-z0-9-_]{${length}}$`);
}
const $adf26e260fc47ffe$export$7d7ef811f6d53a1 = /^[0-9a-fA-F]{32}$/;
const $adf26e260fc47ffe$export$85425f7cda9f4890 = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64(22, "==");
const $adf26e260fc47ffe$export$e54699b04083758c = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64url(22);
const $adf26e260fc47ffe$export$2f163473ef893e12 = /^[0-9a-fA-F]{40}$/;
const $adf26e260fc47ffe$export$fc9670fedfd2524a = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64(27, "=");
const $adf26e260fc47ffe$export$5b6729b977839ffd = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64url(27);
const $adf26e260fc47ffe$export$a923016129fea5fb = /^[0-9a-fA-F]{64}$/;
const $adf26e260fc47ffe$export$ebc25582a9e85396 = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64(43, "=");
const $adf26e260fc47ffe$export$9b7979bfebd9716e = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64url(43);
const $adf26e260fc47ffe$export$61d1fe464d10a5d1 = /^[0-9a-fA-F]{96}$/;
const $adf26e260fc47ffe$export$103403cb96133ac3 = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64(64, "");
const $adf26e260fc47ffe$export$eeafcb7aab6a9870 = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64url(64);
const $adf26e260fc47ffe$export$e246a4310a1ad74d = /^[0-9a-fA-F]{128}$/;
const $adf26e260fc47ffe$export$f698997e063dbdae = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64(86, "==");
const $adf26e260fc47ffe$export$a63330069e1b81f6 = /*@__PURE__*/ $adf26e260fc47ffe$var$fixedBase64url(86);


var $ff926c078a178a32$exports = {};

$parcel$export($ff926c078a178a32$exports, "assertEqual", () => $ff926c078a178a32$export$27555cdfb0b84a1a);
$parcel$export($ff926c078a178a32$exports, "assertNotEqual", () => $ff926c078a178a32$export$49eedac51f614f7d);
$parcel$export($ff926c078a178a32$exports, "assertIs", () => $ff926c078a178a32$export$6fee1f82edcf4a03);
$parcel$export($ff926c078a178a32$exports, "assertNever", () => $ff926c078a178a32$export$cbadc5a7223772a8);
$parcel$export($ff926c078a178a32$exports, "assert", () => $ff926c078a178a32$export$a7a9523472993e97);
$parcel$export($ff926c078a178a32$exports, "getEnumValues", () => $ff926c078a178a32$export$70a5d58ec00f3c11);
$parcel$export($ff926c078a178a32$exports, "joinValues", () => $ff926c078a178a32$export$e79b744344f50f50);
$parcel$export($ff926c078a178a32$exports, "stringifyPrimitive", () => $ff926c078a178a32$export$5859860f650378f4);
$parcel$export($ff926c078a178a32$exports, "jsonStringifyReplacer", () => $ff926c078a178a32$export$f4defb13cab882b2);
$parcel$export($ff926c078a178a32$exports, "cached", () => $ff926c078a178a32$export$ade7a147f5129058);
$parcel$export($ff926c078a178a32$exports, "nullish", () => $ff926c078a178a32$export$69fd1b70ebae5687);
$parcel$export($ff926c078a178a32$exports, "cleanRegex", () => $ff926c078a178a32$export$78d521805d6c22e4);
$parcel$export($ff926c078a178a32$exports, "floatSafeRemainder", () => $ff926c078a178a32$export$7807b52a740a7117);
$parcel$export($ff926c078a178a32$exports, "defineLazy", () => $ff926c078a178a32$export$d43070a5843c1e2);
$parcel$export($ff926c078a178a32$exports, "objectClone", () => $ff926c078a178a32$export$103832c7353c2f50);
$parcel$export($ff926c078a178a32$exports, "assignProp", () => $ff926c078a178a32$export$2e23d0571746a3fb);
$parcel$export($ff926c078a178a32$exports, "mergeDefs", () => $ff926c078a178a32$export$8969f8c824382d73);
$parcel$export($ff926c078a178a32$exports, "cloneDef", () => $ff926c078a178a32$export$21596dc63856f4c1);
$parcel$export($ff926c078a178a32$exports, "getElementAtPath", () => $ff926c078a178a32$export$4b74d241e1cc7892);
$parcel$export($ff926c078a178a32$exports, "promiseAllObject", () => $ff926c078a178a32$export$3db3408dad58da23);
$parcel$export($ff926c078a178a32$exports, "randomString", () => $ff926c078a178a32$export$7fa8378418b4411e);
$parcel$export($ff926c078a178a32$exports, "esc", () => $ff926c078a178a32$export$a1a11b095f88289a);
$parcel$export($ff926c078a178a32$exports, "captureStackTrace", () => $ff926c078a178a32$export$756e5cd2d260237b);
$parcel$export($ff926c078a178a32$exports, "isObject", () => $ff926c078a178a32$export$a6cdc56e425d0d0a);
$parcel$export($ff926c078a178a32$exports, "allowsEval", () => $ff926c078a178a32$export$1f119cb4d720843b);
$parcel$export($ff926c078a178a32$exports, "isPlainObject", () => $ff926c078a178a32$export$53b83ca8eaab0383);
$parcel$export($ff926c078a178a32$exports, "shallowClone", () => $ff926c078a178a32$export$370e8311c3cdebd9);
$parcel$export($ff926c078a178a32$exports, "numKeys", () => $ff926c078a178a32$export$71667e74ba29447f);
$parcel$export($ff926c078a178a32$exports, "getParsedType", () => $ff926c078a178a32$export$3e9057828ebd5c7a);
$parcel$export($ff926c078a178a32$exports, "propertyKeyTypes", () => $ff926c078a178a32$export$b99c149ecf60be48);
$parcel$export($ff926c078a178a32$exports, "primitiveTypes", () => $ff926c078a178a32$export$c34ffd355f76f0e4);
$parcel$export($ff926c078a178a32$exports, "escapeRegex", () => $ff926c078a178a32$export$104ed90cc1a13451);
$parcel$export($ff926c078a178a32$exports, "clone", () => $ff926c078a178a32$export$9cd59f9826255e47);
$parcel$export($ff926c078a178a32$exports, "normalizeParams", () => $ff926c078a178a32$export$d6b7b25dfacfd300);
$parcel$export($ff926c078a178a32$exports, "createTransparentProxy", () => $ff926c078a178a32$export$6ebbd8d3cb03909b);
$parcel$export($ff926c078a178a32$exports, "optionalKeys", () => $ff926c078a178a32$export$240159211e66adb9);
$parcel$export($ff926c078a178a32$exports, "NUMBER_FORMAT_RANGES", () => $ff926c078a178a32$export$8e78302060ccf26f);
$parcel$export($ff926c078a178a32$exports, "BIGINT_FORMAT_RANGES", () => $ff926c078a178a32$export$538d1d6d5cfcb3b6);
$parcel$export($ff926c078a178a32$exports, "pick", () => $ff926c078a178a32$export$357523c63a2253b9);
$parcel$export($ff926c078a178a32$exports, "omit", () => $ff926c078a178a32$export$30a06c8d3562193f);
$parcel$export($ff926c078a178a32$exports, "extend", () => $ff926c078a178a32$export$8b58be045bf06082);
$parcel$export($ff926c078a178a32$exports, "safeExtend", () => $ff926c078a178a32$export$40c90eb222f50efb);
$parcel$export($ff926c078a178a32$exports, "merge", () => $ff926c078a178a32$export$4950aa0f605343fb);
$parcel$export($ff926c078a178a32$exports, "partial", () => $ff926c078a178a32$export$e45945969df8035a);
$parcel$export($ff926c078a178a32$exports, "required", () => $ff926c078a178a32$export$a7a0278c004aac3f);
$parcel$export($ff926c078a178a32$exports, "aborted", () => $ff926c078a178a32$export$bd75b6d981b9c7f2);
$parcel$export($ff926c078a178a32$exports, "prefixIssues", () => $ff926c078a178a32$export$7f35a4c434118b9e);
$parcel$export($ff926c078a178a32$exports, "unwrapMessage", () => $ff926c078a178a32$export$56590e5a47837d61);
$parcel$export($ff926c078a178a32$exports, "finalizeIssue", () => $ff926c078a178a32$export$c5e667bbfc286a9d);
$parcel$export($ff926c078a178a32$exports, "getSizableOrigin", () => $ff926c078a178a32$export$67a7c9c676c45d2b);
$parcel$export($ff926c078a178a32$exports, "getLengthableOrigin", () => $ff926c078a178a32$export$479f5a070abeb487);
$parcel$export($ff926c078a178a32$exports, "issue", () => $ff926c078a178a32$export$69ad3503f98be476);
$parcel$export($ff926c078a178a32$exports, "cleanEnum", () => $ff926c078a178a32$export$9b57aa937148f32);
$parcel$export($ff926c078a178a32$exports, "base64ToUint8Array", () => $ff926c078a178a32$export$f01069a3c307e50e);
$parcel$export($ff926c078a178a32$exports, "uint8ArrayToBase64", () => $ff926c078a178a32$export$36bac84b1c2da9c7);
$parcel$export($ff926c078a178a32$exports, "base64urlToUint8Array", () => $ff926c078a178a32$export$b9fa2551f2db41e1);
$parcel$export($ff926c078a178a32$exports, "uint8ArrayToBase64url", () => $ff926c078a178a32$export$975f78e50159df6f);
$parcel$export($ff926c078a178a32$exports, "hexToUint8Array", () => $ff926c078a178a32$export$6c74ef56152ffb8d);
$parcel$export($ff926c078a178a32$exports, "uint8ArrayToHex", () => $ff926c078a178a32$export$c44b02fb03dbac82);
$parcel$export($ff926c078a178a32$exports, "Class", () => $ff926c078a178a32$export$4c85e640eb41c31b);
// functions
function $ff926c078a178a32$export$27555cdfb0b84a1a(val) {
    return val;
}
function $ff926c078a178a32$export$49eedac51f614f7d(val) {
    return val;
}
function $ff926c078a178a32$export$6fee1f82edcf4a03(_arg) {}
function $ff926c078a178a32$export$cbadc5a7223772a8(_x) {
    throw new Error();
}
function $ff926c078a178a32$export$a7a9523472993e97(_) {}
function $ff926c078a178a32$export$70a5d58ec00f3c11(entries) {
    const numericValues = Object.values(entries).filter((v)=>typeof v === "number");
    const values = Object.entries(entries).filter(([k, _])=>numericValues.indexOf(+k) === -1).map(([_, v])=>v);
    return values;
}
function $ff926c078a178a32$export$e79b744344f50f50(array, separator = "|") {
    return array.map((val)=>$ff926c078a178a32$export$5859860f650378f4(val)).join(separator);
}
function $ff926c078a178a32$export$f4defb13cab882b2(_, value) {
    if (typeof value === "bigint") return value.toString();
    return value;
}
function $ff926c078a178a32$export$ade7a147f5129058(getter) {
    const set = false;
    return {
        get value () {
            if (!set) {
                const value = getter();
                Object.defineProperty(this, "value", {
                    value: value
                });
                return value;
            }
            throw new Error("cached value already set");
        }
    };
}
function $ff926c078a178a32$export$69fd1b70ebae5687(input) {
    return input === null || input === undefined;
}
function $ff926c078a178a32$export$78d521805d6c22e4(source) {
    const start = source.startsWith("^") ? 1 : 0;
    const end = source.endsWith("$") ? source.length - 1 : source.length;
    return source.slice(start, end);
}
function $ff926c078a178a32$export$7807b52a740a7117(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepString = step.toString();
    let stepDecCount = (stepString.split(".")[1] || "").length;
    if (stepDecCount === 0 && /\d?e-\d?/.test(stepString)) {
        const match = stepString.match(/\d?e-(\d?)/);
        if (match?.[1]) stepDecCount = Number.parseInt(match[1]);
    }
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = Number.parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = Number.parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / 10 ** decCount;
}
const $ff926c078a178a32$var$EVALUATING = Symbol("evaluating");
function $ff926c078a178a32$export$d43070a5843c1e2(object, key, getter) {
    let value = undefined;
    Object.defineProperty(object, key, {
        get () {
            if (value === $ff926c078a178a32$var$EVALUATING) // Circular reference detected, return undefined to break the cycle
            return undefined;
            if (value === undefined) {
                value = $ff926c078a178a32$var$EVALUATING;
                value = getter();
            }
            return value;
        },
        set (v) {
            Object.defineProperty(object, key, {
                value: v
            });
        // object[key] = v;
        },
        configurable: true
    });
}
function $ff926c078a178a32$export$103832c7353c2f50(obj) {
    return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}
function $ff926c078a178a32$export$2e23d0571746a3fb(target, prop, value) {
    Object.defineProperty(target, prop, {
        value: value,
        writable: true,
        enumerable: true,
        configurable: true
    });
}
function $ff926c078a178a32$export$8969f8c824382d73(...defs) {
    const mergedDescriptors = {};
    for (const def of defs){
        const descriptors = Object.getOwnPropertyDescriptors(def);
        Object.assign(mergedDescriptors, descriptors);
    }
    return Object.defineProperties({}, mergedDescriptors);
}
function $ff926c078a178a32$export$21596dc63856f4c1(schema) {
    return $ff926c078a178a32$export$8969f8c824382d73(schema._zod.def);
}
function $ff926c078a178a32$export$4b74d241e1cc7892(obj, path) {
    if (!path) return obj;
    return path.reduce((acc, key)=>acc?.[key], obj);
}
function $ff926c078a178a32$export$3db3408dad58da23(promisesObj) {
    const keys = Object.keys(promisesObj);
    const promises = keys.map((key)=>promisesObj[key]);
    return Promise.all(promises).then((results)=>{
        const resolvedObj = {};
        for(let i = 0; i < keys.length; i++)resolvedObj[keys[i]] = results[i];
        return resolvedObj;
    });
}
function $ff926c078a178a32$export$7fa8378418b4411e(length = 10) {
    const chars = "abcdefghijklmnopqrstuvwxyz";
    let str = "";
    for(let i = 0; i < length; i++)str += chars[Math.floor(Math.random() * chars.length)];
    return str;
}
function $ff926c078a178a32$export$a1a11b095f88289a(str) {
    return JSON.stringify(str);
}
const $ff926c078a178a32$export$756e5cd2d260237b = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args)=>{};
function $ff926c078a178a32$export$a6cdc56e425d0d0a(data) {
    return typeof data === "object" && data !== null && !Array.isArray(data);
}
const $ff926c078a178a32$export$1f119cb4d720843b = $ff926c078a178a32$export$ade7a147f5129058(()=>{
    // @ts-ignore
    if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) return false;
    try {
        const F = Function;
        new F("");
        return true;
    } catch (_) {
        return false;
    }
});
function $ff926c078a178a32$export$53b83ca8eaab0383(o) {
    if ($ff926c078a178a32$export$a6cdc56e425d0d0a(o) === false) return false;
    // modified constructor
    const ctor = o.constructor;
    if (ctor === undefined) return true;
    // modified prototype
    const prot = ctor.prototype;
    if ($ff926c078a178a32$export$a6cdc56e425d0d0a(prot) === false) return false;
    // ctor doesn't have static `isPrototypeOf`
    if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) return false;
    return true;
}
function $ff926c078a178a32$export$370e8311c3cdebd9(o) {
    if ($ff926c078a178a32$export$53b83ca8eaab0383(o)) return {
        ...o
    };
    return o;
}
function $ff926c078a178a32$export$71667e74ba29447f(data) {
    let keyCount = 0;
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) keyCount++;
    return keyCount;
}
const $ff926c078a178a32$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return "undefined";
        case "string":
            return "string";
        case "number":
            return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
            return "boolean";
        case "function":
            return "function";
        case "bigint":
            return "bigint";
        case "symbol":
            return "symbol";
        case "object":
            if (Array.isArray(data)) return "array";
            if (data === null) return "null";
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return "promise";
            if (typeof Map !== "undefined" && data instanceof Map) return "map";
            if (typeof Set !== "undefined" && data instanceof Set) return "set";
            if (typeof Date !== "undefined" && data instanceof Date) return "date";
            // @ts-ignore
            if (typeof File !== "undefined" && data instanceof File) return "file";
            return "object";
        default:
            throw new Error(`Unknown data type: ${t}`);
    }
};
const $ff926c078a178a32$export$b99c149ecf60be48 = new Set([
    "string",
    "number",
    "symbol"
]);
const $ff926c078a178a32$export$c34ffd355f76f0e4 = new Set([
    "string",
    "number",
    "bigint",
    "boolean",
    "symbol",
    "undefined"
]);
function $ff926c078a178a32$export$104ed90cc1a13451(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function $ff926c078a178a32$export$9cd59f9826255e47(inst, def, params) {
    const cl = new inst._zod.constr(def ?? inst._zod.def);
    if (!def || params?.parent) cl._zod.parent = inst;
    return cl;
}
function $ff926c078a178a32$export$d6b7b25dfacfd300(_params) {
    const params = _params;
    if (!params) return {};
    if (typeof params === "string") return {
        error: ()=>params
    };
    if (params?.message !== undefined) {
        if (params?.error !== undefined) throw new Error("Cannot specify both `message` and `error` params");
        params.error = params.message;
    }
    delete params.message;
    if (typeof params.error === "string") return {
        ...params,
        error: ()=>params.error
    };
    return params;
}
function $ff926c078a178a32$export$6ebbd8d3cb03909b(getter) {
    let target;
    return new Proxy({}, {
        get (_, prop, receiver) {
            target ?? (target = getter());
            return Reflect.get(target, prop, receiver);
        },
        set (_, prop, value, receiver) {
            target ?? (target = getter());
            return Reflect.set(target, prop, value, receiver);
        },
        has (_, prop) {
            target ?? (target = getter());
            return Reflect.has(target, prop);
        },
        deleteProperty (_, prop) {
            target ?? (target = getter());
            return Reflect.deleteProperty(target, prop);
        },
        ownKeys (_) {
            target ?? (target = getter());
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor (_, prop) {
            target ?? (target = getter());
            return Reflect.getOwnPropertyDescriptor(target, prop);
        },
        defineProperty (_, prop, descriptor) {
            target ?? (target = getter());
            return Reflect.defineProperty(target, prop, descriptor);
        }
    });
}
function $ff926c078a178a32$export$5859860f650378f4(value) {
    if (typeof value === "bigint") return value.toString() + "n";
    if (typeof value === "string") return `"${value}"`;
    return `${value}`;
}
function $ff926c078a178a32$export$240159211e66adb9(shape) {
    return Object.keys(shape).filter((k)=>{
        return shape[k]._zod.optin === "optional" && shape[k]._zod.optout === "optional";
    });
}
const $ff926c078a178a32$export$8e78302060ccf26f = {
    safeint: [
        Number.MIN_SAFE_INTEGER,
        Number.MAX_SAFE_INTEGER
    ],
    int32: [
        -2147483648,
        2147483647
    ],
    uint32: [
        0,
        4294967295
    ],
    float32: [
        -340282346638528860000000000000000000000,
        3.4028234663852886e38
    ],
    float64: [
        -Number.MAX_VALUE,
        Number.MAX_VALUE
    ]
};
const $ff926c078a178a32$export$538d1d6d5cfcb3b6 = {
    int64: [
        /* @__PURE__*/ BigInt("-9223372036854775808"),
        /* @__PURE__*/ BigInt("9223372036854775807")
    ],
    uint64: [
        /* @__PURE__*/ BigInt(0),
        /* @__PURE__*/ BigInt("18446744073709551615")
    ]
};
function $ff926c078a178a32$export$357523c63a2253b9(schema, mask) {
    const currDef = schema._zod.def;
    const def = $ff926c078a178a32$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const newShape = {};
            for(const key in mask){
                if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                newShape[key] = currDef.shape[key];
            }
            $ff926c078a178a32$export$2e23d0571746a3fb(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return $ff926c078a178a32$export$9cd59f9826255e47(schema, def);
}
function $ff926c078a178a32$export$30a06c8d3562193f(schema, mask) {
    const currDef = schema._zod.def;
    const def = $ff926c078a178a32$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const newShape = {
                ...schema._zod.def.shape
            };
            for(const key in mask){
                if (!(key in currDef.shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                delete newShape[key];
            }
            $ff926c078a178a32$export$2e23d0571746a3fb(this, "shape", newShape); // self-caching
            return newShape;
        },
        checks: []
    });
    return $ff926c078a178a32$export$9cd59f9826255e47(schema, def);
}
function $ff926c078a178a32$export$8b58be045bf06082(schema, shape) {
    if (!$ff926c078a178a32$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to extend: expected a plain object");
    const checks = schema._zod.def.checks;
    const hasChecks = checks && checks.length > 0;
    if (hasChecks) throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
    const def = $ff926c078a178a32$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            $ff926c078a178a32$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        },
        checks: []
    });
    return $ff926c078a178a32$export$9cd59f9826255e47(schema, def);
}
function $ff926c078a178a32$export$40c90eb222f50efb(schema, shape) {
    if (!$ff926c078a178a32$export$53b83ca8eaab0383(shape)) throw new Error("Invalid input to safeExtend: expected a plain object");
    const def = {
        ...schema._zod.def,
        get shape () {
            const _shape = {
                ...schema._zod.def.shape,
                ...shape
            };
            $ff926c078a178a32$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        },
        checks: schema._zod.def.checks
    };
    return $ff926c078a178a32$export$9cd59f9826255e47(schema, def);
}
function $ff926c078a178a32$export$4950aa0f605343fb(a, b) {
    const def = $ff926c078a178a32$export$8969f8c824382d73(a._zod.def, {
        get shape () {
            const _shape = {
                ...a._zod.def.shape,
                ...b._zod.def.shape
            };
            $ff926c078a178a32$export$2e23d0571746a3fb(this, "shape", _shape); // self-caching
            return _shape;
        },
        get catchall () {
            return b._zod.def.catchall;
        },
        checks: []
    });
    return $ff926c078a178a32$export$9cd59f9826255e47(a, def);
}
function $ff926c078a178a32$export$e45945969df8035a(Class, schema, mask) {
    const def = $ff926c078a178a32$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for(const key in mask){
                if (!(key in oldShape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                // if (oldShape[key]!._zod.optin === "optional") continue;
                shape[key] = Class ? new Class({
                    type: "optional",
                    innerType: oldShape[key]
                }) : oldShape[key];
            }
            else for(const key in oldShape)// if (oldShape[key]!._zod.optin === "optional") continue;
            shape[key] = Class ? new Class({
                type: "optional",
                innerType: oldShape[key]
            }) : oldShape[key];
            $ff926c078a178a32$export$2e23d0571746a3fb(this, "shape", shape); // self-caching
            return shape;
        },
        checks: []
    });
    return $ff926c078a178a32$export$9cd59f9826255e47(schema, def);
}
function $ff926c078a178a32$export$a7a0278c004aac3f(Class, schema, mask) {
    const def = $ff926c078a178a32$export$8969f8c824382d73(schema._zod.def, {
        get shape () {
            const oldShape = schema._zod.def.shape;
            const shape = {
                ...oldShape
            };
            if (mask) for(const key in mask){
                if (!(key in shape)) throw new Error(`Unrecognized key: "${key}"`);
                if (!mask[key]) continue;
                // overwrite with non-optional
                shape[key] = new Class({
                    type: "nonoptional",
                    innerType: oldShape[key]
                });
            }
            else for(const key in oldShape)// overwrite with non-optional
            shape[key] = new Class({
                type: "nonoptional",
                innerType: oldShape[key]
            });
            $ff926c078a178a32$export$2e23d0571746a3fb(this, "shape", shape); // self-caching
            return shape;
        },
        checks: []
    });
    return $ff926c078a178a32$export$9cd59f9826255e47(schema, def);
}
function $ff926c078a178a32$export$bd75b6d981b9c7f2(x, startIndex = 0) {
    if (x.aborted === true) return true;
    for(let i = startIndex; i < x.issues.length; i++){
        if (x.issues[i]?.continue !== true) return true;
    }
    return false;
}
function $ff926c078a178a32$export$7f35a4c434118b9e(path, issues) {
    return issues.map((iss)=>{
        var _a;
        (_a = iss).path ?? (_a.path = []);
        iss.path.unshift(path);
        return iss;
    });
}
function $ff926c078a178a32$export$56590e5a47837d61(message) {
    return typeof message === "string" ? message : message?.message;
}
function $ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, config) {
    const full = {
        ...iss,
        path: iss.path ?? []
    };
    // for backwards compatibility
    if (!iss.message) {
        const message = $ff926c078a178a32$export$56590e5a47837d61(iss.inst?._zod.def?.error?.(iss)) ?? $ff926c078a178a32$export$56590e5a47837d61(ctx?.error?.(iss)) ?? $ff926c078a178a32$export$56590e5a47837d61(config.customError?.(iss)) ?? $ff926c078a178a32$export$56590e5a47837d61(config.localeError?.(iss)) ?? "Invalid input";
        full.message = message;
    }
    // delete (full as any).def;
    delete full.inst;
    delete full.continue;
    if (!ctx?.reportInput) delete full.input;
    return full;
}
function $ff926c078a178a32$export$67a7c9c676c45d2b(input) {
    if (input instanceof Set) return "set";
    if (input instanceof Map) return "map";
    // @ts-ignore
    if (input instanceof File) return "file";
    return "unknown";
}
function $ff926c078a178a32$export$479f5a070abeb487(input) {
    if (Array.isArray(input)) return "array";
    if (typeof input === "string") return "string";
    return "unknown";
}
function $ff926c078a178a32$export$69ad3503f98be476(...args) {
    const [iss, input, inst] = args;
    if (typeof iss === "string") return {
        message: iss,
        code: "custom",
        input: input,
        inst: inst
    };
    return {
        ...iss
    };
}
function $ff926c078a178a32$export$9b57aa937148f32(obj) {
    return Object.entries(obj).filter(([k, _])=>{
        // return true if NaN, meaning it's not a number, thus a string key
        return Number.isNaN(Number.parseInt(k, 10));
    }).map((el)=>el[1]);
}
function $ff926c078a178a32$export$f01069a3c307e50e(base64) {
    const binaryString = atob(base64);
    const bytes = new Uint8Array(binaryString.length);
    for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
    return bytes;
}
function $ff926c078a178a32$export$36bac84b1c2da9c7(bytes) {
    let binaryString = "";
    for(let i = 0; i < bytes.length; i++)binaryString += String.fromCharCode(bytes[i]);
    return btoa(binaryString);
}
function $ff926c078a178a32$export$b9fa2551f2db41e1(base64url) {
    const base64 = base64url.replace(/-/g, "+").replace(/_/g, "/");
    const padding = "=".repeat((4 - base64.length % 4) % 4);
    return $ff926c078a178a32$export$f01069a3c307e50e(base64 + padding);
}
function $ff926c078a178a32$export$975f78e50159df6f(bytes) {
    return $ff926c078a178a32$export$36bac84b1c2da9c7(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $ff926c078a178a32$export$6c74ef56152ffb8d(hex) {
    const cleanHex = hex.replace(/^0x/, "");
    if (cleanHex.length % 2 !== 0) throw new Error("Invalid hex string length");
    const bytes = new Uint8Array(cleanHex.length / 2);
    for(let i = 0; i < cleanHex.length; i += 2)bytes[i / 2] = Number.parseInt(cleanHex.slice(i, i + 2), 16);
    return bytes;
}
function $ff926c078a178a32$export$c44b02fb03dbac82(bytes) {
    return Array.from(bytes).map((b)=>b.toString(16).padStart(2, "0")).join("");
}
class $ff926c078a178a32$export$4c85e640eb41c31b {
    constructor(..._args){}
}


const $644dcc0398eaee1d$export$c05d9110ef20bb2c = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheck", (inst, def)=>{
    var _a;
    inst._zod ?? (inst._zod = {});
    inst._zod.def = def;
    (_a = inst._zod).onattach ?? (_a.onattach = []);
});
const $644dcc0398eaee1d$var$numericOriginMap = {
    number: "number",
    bigint: "bigint",
    object: "date"
};
const $644dcc0398eaee1d$export$294415ecbdd02022 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckLessThan", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $644dcc0398eaee1d$var$numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.maximum : bag.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
        if (def.value < curr) {
            if (def.inclusive) bag.maximum = def.value;
            else bag.exclusiveMaximum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) return;
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$8b670f58decbca18 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckGreaterThan", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    const origin = $644dcc0398eaee1d$var$numericOriginMap[typeof def.value];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        const curr = (def.inclusive ? bag.minimum : bag.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
        if (def.value > curr) {
            if (def.inclusive) bag.minimum = def.value;
            else bag.exclusiveMinimum = def.value;
        }
    });
    inst._zod.check = (payload)=>{
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) return;
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: def.value,
            input: payload.value,
            inclusive: def.inclusive,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$ae602e11c1dd0628 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckMultipleOf", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        var _a;
        (_a = inst._zod.bag).multipleOf ?? (_a.multipleOf = def.value);
    });
    inst._zod.check = (payload)=>{
        if (typeof payload.value !== typeof def.value) throw new Error("Cannot mix number and bigint in multiple_of check.");
        const isMultiple = typeof payload.value === "bigint" ? payload.value % def.value === BigInt(0) : $ff926c078a178a32$export$7807b52a740a7117(payload.value, def.value) === 0;
        if (isMultiple) return;
        payload.issues.push({
            origin: typeof payload.value,
            code: "not_multiple_of",
            divisor: def.value,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$5c26c85ad6aed3e8 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckNumberFormat", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    def.format = def.format || "float64";
    const isInt = def.format?.includes("int");
    const origin = isInt ? "int" : "number";
    const [minimum, maximum] = $ff926c078a178a32$export$8e78302060ccf26f[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
        if (isInt) bag.pattern = $adf26e260fc47ffe$export$32744b5b3bba4764;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (isInt) {
            if (!Number.isInteger(input)) {
                // invalid_format issue
                // payload.issues.push({
                //   expected: def.format,
                //   format: def.format,
                //   code: "invalid_format",
                //   input,
                //   inst,
                // });
                // invalid_type issue
                payload.issues.push({
                    expected: origin,
                    format: def.format,
                    code: "invalid_type",
                    continue: false,
                    input: input,
                    inst: inst
                });
                return;
            // not_multiple_of issue
            // payload.issues.push({
            //   code: "not_multiple_of",
            //   origin: "number",
            //   input,
            //   inst,
            //   divisor: 1,
            // });
            }
            if (!Number.isSafeInteger(input)) {
                if (input > 0) // too_big
                payload.issues.push({
                    input: input,
                    code: "too_big",
                    maximum: Number.MAX_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    continue: !def.abort
                });
                else // too_small
                payload.issues.push({
                    input: input,
                    code: "too_small",
                    minimum: Number.MIN_SAFE_INTEGER,
                    note: "Integers must be within the safe integer range.",
                    inst: inst,
                    origin: origin,
                    continue: !def.abort
                });
                return;
            }
        }
        if (input < minimum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "number",
            input: input,
            code: "too_big",
            maximum: maximum,
            inst: inst
        });
    };
});
const $644dcc0398eaee1d$export$a0a6d75ce7dc4d36 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckBigIntFormat", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def); // no format checks
    const [minimum, maximum] = $ff926c078a178a32$export$538d1d6d5cfcb3b6[def.format];
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        bag.minimum = minimum;
        bag.maximum = maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        if (input < minimum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_small",
            minimum: minimum,
            inclusive: true,
            inst: inst,
            continue: !def.abort
        });
        if (input > maximum) payload.issues.push({
            origin: "bigint",
            input: input,
            code: "too_big",
            maximum: maximum,
            inst: inst
        });
    };
});
const $644dcc0398eaee1d$export$b3cec505675cf50c = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckMaxSize", (inst, def)=>{
    var _a;
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$ff926c078a178a32$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size <= def.maximum) return;
        payload.issues.push({
            origin: $ff926c078a178a32$export$67a7c9c676c45d2b(input),
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$59fb0a2e7217c42b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckMinSize", (inst, def)=>{
    var _a;
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$ff926c078a178a32$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size >= def.minimum) return;
        payload.issues.push({
            origin: $ff926c078a178a32$export$67a7c9c676c45d2b(input),
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$af532c490f33cd47 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckSizeEquals", (inst, def)=>{
    var _a;
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$ff926c078a178a32$export$69fd1b70ebae5687(val) && val.size !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.size;
        bag.maximum = def.size;
        bag.size = def.size;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const size = input.size;
        if (size === def.size) return;
        const tooBig = size > def.size;
        payload.issues.push({
            origin: $ff926c078a178a32$export$67a7c9c676c45d2b(input),
            ...tooBig ? {
                code: "too_big",
                maximum: def.size
            } : {
                code: "too_small",
                minimum: def.size
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$b07b097887f4c15a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckMaxLength", (inst, def)=>{
    var _a;
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$ff926c078a178a32$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
        if (def.maximum < curr) inst._zod.bag.maximum = def.maximum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length <= def.maximum) return;
        const origin = $ff926c078a178a32$export$479f5a070abeb487(input);
        payload.issues.push({
            origin: origin,
            code: "too_big",
            maximum: def.maximum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$cd5336aa96b8417c = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckMinLength", (inst, def)=>{
    var _a;
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$ff926c078a178a32$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const curr = inst._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
        if (def.minimum > curr) inst._zod.bag.minimum = def.minimum;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length >= def.minimum) return;
        const origin = $ff926c078a178a32$export$479f5a070abeb487(input);
        payload.issues.push({
            origin: origin,
            code: "too_small",
            minimum: def.minimum,
            inclusive: true,
            input: input,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$ccdb9b9d477068fb = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckLengthEquals", (inst, def)=>{
    var _a;
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    (_a = inst._zod.def).when ?? (_a.when = (payload)=>{
        const val = payload.value;
        return !$ff926c078a178a32$export$69fd1b70ebae5687(val) && val.length !== undefined;
    });
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.minimum = def.length;
        bag.maximum = def.length;
        bag.length = def.length;
    });
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const length = input.length;
        if (length === def.length) return;
        const origin = $ff926c078a178a32$export$479f5a070abeb487(input);
        const tooBig = length > def.length;
        payload.issues.push({
            origin: origin,
            ...tooBig ? {
                code: "too_big",
                maximum: def.length
            } : {
                code: "too_small",
                minimum: def.length
            },
            inclusive: true,
            exact: true,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$e0c7f6847ab1b629 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckStringFormat", (inst, def)=>{
    var _a, _b;
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = def.format;
        if (def.pattern) {
            bag.patterns ?? (bag.patterns = new Set());
            bag.patterns.add(def.pattern);
        }
    });
    if (def.pattern) (_a = inst._zod).check ?? (_a.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? {
                pattern: def.pattern.toString()
            } : {},
            inst: inst,
            continue: !def.abort
        });
    });
    else (_b = inst._zod).check ?? (_b.check = ()=>{});
});
const $644dcc0398eaee1d$export$6faea86ff718d6df = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckRegex", (inst, def)=>{
    $644dcc0398eaee1d$export$e0c7f6847ab1b629.init(inst, def);
    inst._zod.check = (payload)=>{
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "regex",
            input: payload.value,
            pattern: def.pattern.toString(),
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$e18e268bd5c9f27a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckLowerCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$5b1f80f3c282648c);
    $644dcc0398eaee1d$export$e0c7f6847ab1b629.init(inst, def);
});
const $644dcc0398eaee1d$export$6d0944a5127e820a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckUpperCase", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$6cfe151e6b925e83);
    $644dcc0398eaee1d$export$e0c7f6847ab1b629.init(inst, def);
});
const $644dcc0398eaee1d$export$600021c28f0498dc = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckIncludes", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    const escapedRegex = $ff926c078a178a32$export$104ed90cc1a13451(def.includes);
    const pattern = new RegExp(typeof def.position === "number" ? `^.{${def.position}}${escapedRegex}` : escapedRegex);
    def.pattern = pattern;
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.includes(def.includes, def.position)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "includes",
            includes: def.includes,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$8e83a74b4b83cc62 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckStartsWith", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`^${$ff926c078a178a32$export$104ed90cc1a13451(def.prefix)}.*`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.startsWith(def.prefix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "starts_with",
            prefix: def.prefix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$4a10f85c6af4e92 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckEndsWith", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    const pattern = new RegExp(`.*${$ff926c078a178a32$export$104ed90cc1a13451(def.suffix)}$`);
    def.pattern ?? (def.pattern = pattern);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.patterns ?? (bag.patterns = new Set());
        bag.patterns.add(pattern);
    });
    inst._zod.check = (payload)=>{
        if (payload.value.endsWith(def.suffix)) return;
        payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: "ends_with",
            suffix: def.suffix,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
///////////////////////////////////
/////    $ZodCheckProperty    /////
///////////////////////////////////
function $644dcc0398eaee1d$var$handleCheckPropertyResult(result, payload, property) {
    if (result.issues.length) payload.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(property, result.issues));
}
const $644dcc0398eaee1d$export$d36a4eecd766dbc0 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckProperty", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        const result = def.schema._zod.run({
            value: payload.value[def.property],
            issues: []
        }, {});
        if (result instanceof Promise) return result.then((result)=>$644dcc0398eaee1d$var$handleCheckPropertyResult(result, payload, def.property));
        $644dcc0398eaee1d$var$handleCheckPropertyResult(result, payload, def.property);
        return;
    };
});
const $644dcc0398eaee1d$export$5546147f1877f806 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckMimeType", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    const mimeSet = new Set(def.mime);
    inst._zod.onattach.push((inst)=>{
        inst._zod.bag.mime = def.mime;
    });
    inst._zod.check = (payload)=>{
        if (mimeSet.has(payload.value.type)) return;
        payload.issues.push({
            code: "invalid_value",
            values: def.mime,
            input: payload.value.type,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $644dcc0398eaee1d$export$1bda1934456013d3 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCheckOverwrite", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    inst._zod.check = (payload)=>{
        payload.value = def.tx(payload.value);
    };
});




class $d4ecf008c2deb17a$export$bceacc74c2212615 {
    constructor(args = []){
        this.content = [];
        this.indent = 0;
        if (this) this.args = args;
    }
    indented(fn) {
        this.indent += 1;
        fn(this);
        this.indent -= 1;
    }
    write(arg) {
        if (typeof arg === "function") {
            arg(this, {
                execution: "sync"
            });
            arg(this, {
                execution: "async"
            });
            return;
        }
        const content = arg;
        const lines = content.split("\n").filter((x)=>x);
        const minIndent = Math.min(...lines.map((x)=>x.length - x.trimStart().length));
        const dedented = lines.map((x)=>x.slice(minIndent)).map((x)=>" ".repeat(this.indent * 2) + x);
        for (const line of dedented)this.content.push(line);
    }
    compile() {
        const F = Function;
        const args = this?.args;
        const content = this?.content ?? [
            ``
        ];
        const lines = [
            ...content.map((x)=>`  ${x}`)
        ];
        // console.log(lines.join("\n"));
        return new F(...args, lines.join("\n"));
    }
}





const $81abeb876ab51d15$var$initializer = (inst, def)=>{
    inst.name = "$ZodError";
    Object.defineProperty(inst, "_zod", {
        value: inst._zod,
        enumerable: false
    });
    Object.defineProperty(inst, "issues", {
        value: def,
        enumerable: false
    });
    inst.message = JSON.stringify(def, $ff926c078a178a32$export$f4defb13cab882b2, 2);
    Object.defineProperty(inst, "toString", {
        value: ()=>inst.message,
        enumerable: false
    });
};
const $81abeb876ab51d15$export$544878318730b1d8 = (0, $3902e9f6ee6db121$export$3122533d606194de)("$ZodError", $81abeb876ab51d15$var$initializer);
const $81abeb876ab51d15$export$4e07b515db2f7672 = (0, $3902e9f6ee6db121$export$3122533d606194de)("$ZodError", $81abeb876ab51d15$var$initializer, {
    Parent: Error
});
function $81abeb876ab51d15$export$4d7e0dfd5ca8366f(error, mapper = (issue)=>issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of error.issues)if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
    } else formErrors.push(mapper(sub));
    return {
        formErrors: formErrors,
        fieldErrors: fieldErrors
    };
}
function $81abeb876ab51d15$export$7b5b869ee98c16ab(error, _mapper) {
    const mapper = _mapper || function(issue) {
        return issue.message;
    };
    const fieldErrors = {
        _errors: []
    };
    const processError = (error)=>{
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) issue.errors.map((issues)=>processError({
                    issues: issues
                }));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            });
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            });
            else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
            else {
                let curr = fieldErrors;
                let i = 0;
                while(i < issue.path.length){
                    const el = issue.path[i];
                    const terminal = i === issue.path.length - 1;
                    if (!terminal) curr[el] = curr[el] || {
                        _errors: []
                    };
                    else {
                        curr[el] = curr[el] || {
                            _errors: []
                        };
                        curr[el]._errors.push(mapper(issue));
                    }
                    curr = curr[el];
                    i++;
                }
            }
        }
    };
    processError(error);
    return fieldErrors;
}
function $81abeb876ab51d15$export$93701dc89257de2f(error, _mapper) {
    const mapper = _mapper || function(issue) {
        return issue.message;
    };
    const result = {
        errors: []
    };
    const processError = (error, path = [])=>{
        var _a, _b;
        for (const issue of error.issues){
            if (issue.code === "invalid_union" && issue.errors.length) // regular union error
            issue.errors.map((issues)=>processError({
                    issues: issues
                }, issue.path));
            else if (issue.code === "invalid_key") processError({
                issues: issue.issues
            }, issue.path);
            else if (issue.code === "invalid_element") processError({
                issues: issue.issues
            }, issue.path);
            else {
                const fullpath = [
                    ...path,
                    ...issue.path
                ];
                if (fullpath.length === 0) {
                    result.errors.push(mapper(issue));
                    continue;
                }
                let curr = result;
                let i = 0;
                while(i < fullpath.length){
                    const el = fullpath[i];
                    const terminal = i === fullpath.length - 1;
                    if (typeof el === "string") {
                        curr.properties ?? (curr.properties = {});
                        (_a = curr.properties)[el] ?? (_a[el] = {
                            errors: []
                        });
                        curr = curr.properties[el];
                    } else {
                        curr.items ?? (curr.items = []);
                        (_b = curr.items)[el] ?? (_b[el] = {
                            errors: []
                        });
                        curr = curr.items[el];
                    }
                    if (terminal) curr.errors.push(mapper(issue));
                    i++;
                }
            }
        }
    };
    processError(error);
    return result;
}
function $81abeb876ab51d15$export$47768e8997ceb13a(_path) {
    const segs = [];
    const path = _path.map((seg)=>typeof seg === "object" ? seg.key : seg);
    for (const seg of path){
        if (typeof seg === "number") segs.push(`[${seg}]`);
        else if (typeof seg === "symbol") segs.push(`[${JSON.stringify(String(seg))}]`);
        else if (/[^\w$]/.test(seg)) segs.push(`[${JSON.stringify(seg)}]`);
        else {
            if (segs.length) segs.push(".");
            segs.push(seg);
        }
    }
    return segs.join("");
}
function $81abeb876ab51d15$export$44eaaa72d914fe8c(error) {
    const lines = [];
    // sort by path length
    const issues = [
        ...error.issues
    ].sort((a, b)=>(a.path ?? []).length - (b.path ?? []).length);
    // Process each issue
    for (const issue of issues){
        lines.push(`\u{2716} ${issue.message}`);
        if (issue.path?.length) lines.push(`  \u{2192} at ${$81abeb876ab51d15$export$47768e8997ceb13a(issue.path)}`);
    }
    // Convert Map to formatted string
    return lines.join("\n");
}



const $160c3afc845a29d6$export$dcd1bb9991b57edf = (_Err)=>(schema, value, _ctx, _params)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: false
        }) : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $3902e9f6ee6db121$export$13016bcec11ba196();
        if (result.issues.length) {
            const e = new (_params?.Err ?? _Err)(result.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20())));
            $ff926c078a178a32$export$756e5cd2d260237b(e, _params?.callee);
            throw e;
        }
        return result.value;
    };
const $160c3afc845a29d6$export$98e6a39c04603d36 = /* @__PURE__*/ $160c3afc845a29d6$export$dcd1bb9991b57edf($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$1fcca22dc6c780d0 = (_Err)=>async (schema, value, _ctx, params)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: true
        }) : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        if (result.issues.length) {
            const e = new (params?.Err ?? _Err)(result.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20())));
            $ff926c078a178a32$export$756e5cd2d260237b(e, params?.callee);
            throw e;
        }
        return result.value;
    };
const $160c3afc845a29d6$export$59b6f938fbf579e3 = /* @__PURE__*/ $160c3afc845a29d6$export$1fcca22dc6c780d0($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$5ec32605bf51e98e = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? {
            ..._ctx,
            async: false
        } : {
            async: false
        };
        const result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) throw new $3902e9f6ee6db121$export$13016bcec11ba196();
        return result.issues.length ? {
            success: false,
            error: new (_Err ?? $81abeb876ab51d15$export$544878318730b1d8)(result.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20())))
        } : {
            success: true,
            data: result.value
        };
    };
const $160c3afc845a29d6$export$b48ee232557adc37 = /* @__PURE__*/ $160c3afc845a29d6$export$5ec32605bf51e98e($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$c08c7322f5625faf = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            async: true
        }) : {
            async: true
        };
        let result = schema._zod.run({
            value: value,
            issues: []
        }, ctx);
        if (result instanceof Promise) result = await result;
        return result.issues.length ? {
            success: false,
            error: new _Err(result.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20())))
        } : {
            success: true,
            data: result.value
        };
    };
const $160c3afc845a29d6$export$9b07b0d6e0389261 = /* @__PURE__*/ $160c3afc845a29d6$export$c08c7322f5625faf($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$50e4445ccc10715b = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $160c3afc845a29d6$export$dcd1bb9991b57edf(_Err)(schema, value, ctx);
    };
const $160c3afc845a29d6$export$c564cdbbe6da493 = /* @__PURE__*/ $160c3afc845a29d6$export$50e4445ccc10715b($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$bb4a21772f43c982 = (_Err)=>(schema, value, _ctx)=>{
        return $160c3afc845a29d6$export$dcd1bb9991b57edf(_Err)(schema, value, _ctx);
    };
const $160c3afc845a29d6$export$2f872c0f2117be69 = /* @__PURE__*/ $160c3afc845a29d6$export$bb4a21772f43c982($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$9954740a1a5eaaf1 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $160c3afc845a29d6$export$1fcca22dc6c780d0(_Err)(schema, value, ctx);
    };
const $160c3afc845a29d6$export$1a62660bbffb8f11 = /* @__PURE__*/ $160c3afc845a29d6$export$9954740a1a5eaaf1($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$74b09e12c8956d91 = (_Err)=>async (schema, value, _ctx)=>{
        return $160c3afc845a29d6$export$1fcca22dc6c780d0(_Err)(schema, value, _ctx);
    };
const $160c3afc845a29d6$export$e4c183687a6ff9b = /* @__PURE__*/ $160c3afc845a29d6$export$74b09e12c8956d91($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$6d688d774257f486 = (_Err)=>(schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $160c3afc845a29d6$export$5ec32605bf51e98e(_Err)(schema, value, ctx);
    };
const $160c3afc845a29d6$export$c094f85f253e4d7d = /* @__PURE__*/ $160c3afc845a29d6$export$6d688d774257f486($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$b2ef531a734faad5 = (_Err)=>(schema, value, _ctx)=>{
        return $160c3afc845a29d6$export$5ec32605bf51e98e(_Err)(schema, value, _ctx);
    };
const $160c3afc845a29d6$export$7a47376c130cfeac = /* @__PURE__*/ $160c3afc845a29d6$export$b2ef531a734faad5($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$fa2ac180d22758d6 = (_Err)=>async (schema, value, _ctx)=>{
        const ctx = _ctx ? Object.assign(_ctx, {
            direction: "backward"
        }) : {
            direction: "backward"
        };
        return $160c3afc845a29d6$export$c08c7322f5625faf(_Err)(schema, value, ctx);
    };
const $160c3afc845a29d6$export$ed163a34170fecc5 = /* @__PURE__*/ $160c3afc845a29d6$export$fa2ac180d22758d6($81abeb876ab51d15$export$4e07b515db2f7672);
const $160c3afc845a29d6$export$f66d2b402dc6318c = (_Err)=>async (schema, value, _ctx)=>{
        return $160c3afc845a29d6$export$c08c7322f5625faf(_Err)(schema, value, _ctx);
    };
const $160c3afc845a29d6$export$9f879005292a9bc9 = /* @__PURE__*/ $160c3afc845a29d6$export$f66d2b402dc6318c($81abeb876ab51d15$export$4e07b515db2f7672);




const $c4500b3bb166b976$export$83d89fbfd8236492 = {
    major: 4,
    minor: 1,
    patch: 5
};


const $e919c1e0a57df477$export$f43a5c3966de8238 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodType", (inst, def)=>{
    var _a;
    inst ?? (inst = {});
    inst._zod.def = def; // set _def property
    inst._zod.bag = inst._zod.bag || {}; // initialize _bag object
    inst._zod.version = (0, $c4500b3bb166b976$export$83d89fbfd8236492);
    const checks = [
        ...inst._zod.def.checks ?? []
    ];
    // if inst is itself a checks.$ZodCheck, run it as a check
    if (inst._zod.traits.has("$ZodCheck")) checks.unshift(inst);
    for (const ch of checks)for (const fn of ch._zod.onattach)fn(inst);
    if (checks.length === 0) {
        // deferred initializer
        // inst._zod.parse is not yet defined
        (_a = inst._zod).deferred ?? (_a.deferred = []);
        inst._zod.deferred?.push(()=>{
            inst._zod.run = inst._zod.parse;
        });
    } else {
        const runChecks = (payload, checks, ctx)=>{
            let isAborted = $ff926c078a178a32$export$bd75b6d981b9c7f2(payload);
            let asyncResult;
            for (const ch of checks){
                if (ch._zod.def.when) {
                    const shouldRun = ch._zod.def.when(payload);
                    if (!shouldRun) continue;
                } else if (isAborted) continue;
                const currLen = payload.issues.length;
                const _ = ch._zod.check(payload);
                if (_ instanceof Promise && ctx?.async === false) throw new $3902e9f6ee6db121$export$13016bcec11ba196();
                if (asyncResult || _ instanceof Promise) asyncResult = (asyncResult ?? Promise.resolve()).then(async ()=>{
                    await _;
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) return;
                    if (!isAborted) isAborted = $ff926c078a178a32$export$bd75b6d981b9c7f2(payload, currLen);
                });
                else {
                    const nextLen = payload.issues.length;
                    if (nextLen === currLen) continue;
                    if (!isAborted) isAborted = $ff926c078a178a32$export$bd75b6d981b9c7f2(payload, currLen);
                }
            }
            if (asyncResult) return asyncResult.then(()=>{
                return payload;
            });
            return payload;
        };
        // const handleChecksResult = (
        //   checkResult: ParsePayload,
        //   originalResult: ParsePayload,
        //   ctx: ParseContextInternal
        // ): util.MaybeAsync<ParsePayload> => {
        //   // if the checks mutated the value && there are no issues, re-parse the result
        //   if (checkResult.value !== originalResult.value && !checkResult.issues.length)
        //     return inst._zod.parse(checkResult, ctx);
        //   return originalResult;
        // };
        const handleCanaryResult = (canary, payload, ctx)=>{
            // abort if the canary is aborted
            if ($ff926c078a178a32$export$bd75b6d981b9c7f2(canary)) {
                canary.aborted = true;
                return canary;
            }
            // run checks first, then
            const checkResult = runChecks(payload, checks, ctx);
            if (checkResult instanceof Promise) {
                if (ctx.async === false) throw new $3902e9f6ee6db121$export$13016bcec11ba196();
                return checkResult.then((checkResult)=>inst._zod.parse(checkResult, ctx));
            }
            return inst._zod.parse(checkResult, ctx);
        };
        inst._zod.run = (payload, ctx)=>{
            if (ctx.skipChecks) return inst._zod.parse(payload, ctx);
            if (ctx.direction === "backward") {
                // run canary
                // initial pass (no checks)
                const canary = inst._zod.parse({
                    value: payload.value,
                    issues: []
                }, {
                    ...ctx,
                    skipChecks: true
                });
                if (canary instanceof Promise) return canary.then((canary)=>{
                    return handleCanaryResult(canary, payload, ctx);
                });
                return handleCanaryResult(canary, payload, ctx);
            }
            // forward
            const result = inst._zod.parse(payload, ctx);
            if (result instanceof Promise) {
                if (ctx.async === false) throw new $3902e9f6ee6db121$export$13016bcec11ba196();
                return result.then((result)=>runChecks(result, checks, ctx));
            }
            return runChecks(result, checks, ctx);
        };
    }
    inst["~standard"] = {
        validate: (value)=>{
            try {
                const r = (0, $160c3afc845a29d6$export$b48ee232557adc37)(inst, value);
                return r.success ? {
                    value: r.data
                } : {
                    issues: r.error?.issues
                };
            } catch (_) {
                return (0, $160c3afc845a29d6$export$9b07b0d6e0389261)(inst, value).then((r)=>r.success ? {
                        value: r.data
                    } : {
                        issues: r.error?.issues
                    });
            }
        },
        vendor: "zod",
        version: 1
    };
});
const $e919c1e0a57df477$export$4342b4432d7b1471 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodString", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = [
        ...inst?._zod.bag?.patterns ?? []
    ].pop() ?? $adf26e260fc47ffe$export$22b082955e083ec3(inst._zod.bag);
    inst._zod.parse = (payload, _)=>{
        if (def.coerce) try {
            payload.value = String(payload.value);
        } catch (_) {}
        if (typeof payload.value === "string") return payload;
        payload.issues.push({
            expected: "string",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$2d69a0d3057a5c7d = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodStringFormat", (inst, def)=>{
    // check initialization must come first
    $644dcc0398eaee1d$export$e0c7f6847ab1b629.init(inst, def);
    $e919c1e0a57df477$export$4342b4432d7b1471.init(inst, def);
});
const $e919c1e0a57df477$export$4ca4397e3147da59 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodGUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$46e8f25c7328f77e);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$8794aae384e3c177 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodUUID", (inst, def)=>{
    if (def.version) {
        const versionMap = {
            v1: 1,
            v2: 2,
            v3: 3,
            v4: 4,
            v5: 5,
            v6: 6,
            v7: 7,
            v8: 8
        };
        const v = versionMap[def.version];
        if (v === undefined) throw new Error(`Invalid UUID version: "${def.version}"`);
        def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$31b40729666a4ae0(v));
    } else def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$31b40729666a4ae0());
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$a3726aadb6108cdc = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodEmail", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$d290fa47940df19d);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$7e12af57cac08b7a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodURL", (inst, def)=>{
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        try {
            // Trim whitespace from input
            const trimmed = payload.value.trim();
            // @ts-ignore
            const url = new URL(trimmed);
            if (def.hostname) {
                def.hostname.lastIndex = 0;
                if (!def.hostname.test(url.hostname)) payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid hostname",
                    pattern: $adf26e260fc47ffe$export$640106f6dc7d2706.source,
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
            }
            if (def.protocol) {
                def.protocol.lastIndex = 0;
                if (!def.protocol.test(url.protocol.endsWith(":") ? url.protocol.slice(0, -1) : url.protocol)) payload.issues.push({
                    code: "invalid_format",
                    format: "url",
                    note: "Invalid protocol",
                    pattern: def.protocol.source,
                    input: payload.value,
                    inst: inst,
                    continue: !def.abort
                });
            }
            // Set the output value based on normalize flag
            if (def.normalize) // Use normalized URL
            payload.value = url.href;
            else // Preserve the original input (trimmed)
            payload.value = trimmed;
            return;
        } catch (_) {
            payload.issues.push({
                code: "invalid_format",
                format: "url",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $e919c1e0a57df477$export$154cd448b85bb5a3 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodEmoji", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$a19185d1233fc4b2());
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$5a160d28c6d62c88 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodNanoID", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$ac4959f4f1338dfc);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$f4f84bd3c6706e60 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$e057ec210c7d3443);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$faf1483c11362df6 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCUID2", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$af5866a6cccce9f0);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$c5788701f4f55294 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodULID", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$c34778236461ea95);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$e721fd3317199b85 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodXID", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$5eecaf20006cb6cb);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$baa9849ea82bee6e = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodKSUID", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$f49b11deeb9beb0f);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$3273e4d2df37774b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodISODateTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$7ba4466dbd0f07e1(def));
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$75b9bf98f4d806dc = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodISODate", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$324d90190a8b822a);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$e9b9c3c2359a3ebc = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodISOTime", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$2da9be4cfdb689b1(def));
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$d9e850ab18e4b22e = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodISODuration", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$1f34108aa9eb96ab);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$93fc833bbf7ceb99 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodIPv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$291a17a16047f284);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = `ipv4`;
    });
});
const $e919c1e0a57df477$export$8c939a460418a1bf = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodIPv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$4e0c86a59c658526);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        const bag = inst._zod.bag;
        bag.format = `ipv6`;
    });
    inst._zod.check = (payload)=>{
        try {
            // @ts-ignore
            new URL(`http://[${payload.value}]`);
        // return;
        } catch  {
            payload.issues.push({
                code: "invalid_format",
                format: "ipv6",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
const $e919c1e0a57df477$export$e164feaf5ae5296b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCIDRv4", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$fc96793d9715e5a1);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
const $e919c1e0a57df477$export$3c3aacb740759234 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCIDRv6", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$b6e650831cac87fb); // not used for validation
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        const [address, prefix] = payload.value.split("/");
        try {
            if (!prefix) throw new Error();
            const prefixNum = Number(prefix);
            if (`${prefixNum}` !== prefix) throw new Error();
            if (prefixNum < 0 || prefixNum > 128) throw new Error();
            // @ts-ignore
            new URL(`http://[${address}]`);
        } catch  {
            payload.issues.push({
                code: "invalid_format",
                format: "cidrv6",
                input: payload.value,
                inst: inst,
                continue: !def.abort
            });
        }
    };
});
function $e919c1e0a57df477$export$5f5b3f6a560c676b(data) {
    if (data === "") return true;
    if (data.length % 4 !== 0) return false;
    try {
        // @ts-ignore
        atob(data);
        return true;
    } catch  {
        return false;
    }
}
const $e919c1e0a57df477$export$d7d4932079e2113d = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodBase64", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$b3b2de96497acc47);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        inst._zod.bag.contentEncoding = "base64";
    });
    inst._zod.check = (payload)=>{
        if ($e919c1e0a57df477$export$5f5b3f6a560c676b(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
function $e919c1e0a57df477$export$eb95420c5686a3be(data) {
    if (!$adf26e260fc47ffe$export$7d21597c7bc64465.test(data)) return false;
    const base64 = data.replace(/[-_]/g, (c)=>c === "-" ? "+" : "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    return $e919c1e0a57df477$export$5f5b3f6a560c676b(padded);
}
const $e919c1e0a57df477$export$f5c3c3bbec012fa6 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodBase64URL", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$7d21597c7bc64465);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.onattach.push((inst)=>{
        inst._zod.bag.contentEncoding = "base64url";
    });
    inst._zod.check = (payload)=>{
        if ($e919c1e0a57df477$export$eb95420c5686a3be(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "base64url",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e919c1e0a57df477$export$46d3507e8483217 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodE164", (inst, def)=>{
    def.pattern ?? (def.pattern = $adf26e260fc47ffe$export$2fa5ed24c9ef198e);
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
});
function $e919c1e0a57df477$export$5fc0c2a4042aff0a(token, algorithm = null) {
    try {
        const tokensParts = token.split(".");
        if (tokensParts.length !== 3) return false;
        const [header] = tokensParts;
        if (!header) return false;
        // @ts-ignore
        const parsedHeader = JSON.parse(atob(header));
        if ("typ" in parsedHeader && parsedHeader?.typ !== "JWT") return false;
        if (!parsedHeader.alg) return false;
        if (algorithm && (!("alg" in parsedHeader) || parsedHeader.alg !== algorithm)) return false;
        return true;
    } catch  {
        return false;
    }
}
const $e919c1e0a57df477$export$f515616cf0cda103 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodJWT", (inst, def)=>{
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if ($e919c1e0a57df477$export$5fc0c2a4042aff0a(payload.value, def.alg)) return;
        payload.issues.push({
            code: "invalid_format",
            format: "jwt",
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e919c1e0a57df477$export$9dde4397c7b8a192 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCustomStringFormat", (inst, def)=>{
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    inst._zod.check = (payload)=>{
        if (def.fn(payload.value)) return;
        payload.issues.push({
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            inst: inst,
            continue: !def.abort
        });
    };
});
const $e919c1e0a57df477$export$b7292ed81eaafd49 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodNumber", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = inst._zod.bag.pattern ?? $adf26e260fc47ffe$export$98e628dec113755e;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Number(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) return payload;
        const received = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? "Infinity" : undefined : undefined;
        payload.issues.push({
            expected: "number",
            code: "invalid_type",
            input: input,
            inst: inst,
            ...received ? {
                received: received
            } : {}
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$2cfebe79b769ec9 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodNumber", (inst, def)=>{
    $644dcc0398eaee1d$export$5c26c85ad6aed3e8.init(inst, def);
    $e919c1e0a57df477$export$b7292ed81eaafd49.init(inst, def); // no format checksp
});
const $e919c1e0a57df477$export$828bf41e557d7dda = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodBoolean", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $adf26e260fc47ffe$export$4a21f16c33752377;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = Boolean(payload.value);
        } catch (_) {}
        const input = payload.value;
        if (typeof input === "boolean") return payload;
        payload.issues.push({
            expected: "boolean",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$7600843f2a3baa73 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodBigInt", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $adf26e260fc47ffe$export$a0f65b52274bcc00;
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = BigInt(payload.value);
        } catch (_) {}
        if (typeof payload.value === "bigint") return payload;
        payload.issues.push({
            expected: "bigint",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$487194b75209a5dd = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodBigInt", (inst, def)=>{
    $644dcc0398eaee1d$export$a0a6d75ce7dc4d36.init(inst, def);
    $e919c1e0a57df477$export$7600843f2a3baa73.init(inst, def); // no format checks
});
const $e919c1e0a57df477$export$c9e7e1831bb8dd12 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodSymbol", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "symbol") return payload;
        payload.issues.push({
            expected: "symbol",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$379ccf61f9830869 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodUndefined", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $adf26e260fc47ffe$export$1db45310990710a5;
    inst._zod.values = new Set([
        undefined
    ]);
    inst._zod.optin = "optional";
    inst._zod.optout = "optional";
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "undefined",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$d05db4d7bc9da27d = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodNull", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.pattern = $adf26e260fc47ffe$export$7b1b591b262c240;
    inst._zod.values = new Set([
        null
    ]);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (input === null) return payload;
        payload.issues.push({
            expected: "null",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$de3a83ac65a18f35 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodAny", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $e919c1e0a57df477$export$37ea092643879ea0 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodUnknown", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload)=>payload;
});
const $e919c1e0a57df477$export$4b2a18191b39c3b4 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodNever", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        payload.issues.push({
            expected: "never",
            code: "invalid_type",
            input: payload.value,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$6fd82db70787afbb = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodVoid", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (typeof input === "undefined") return payload;
        payload.issues.push({
            expected: "void",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$9a0ab9fbd61629f8 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodDate", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (def.coerce) try {
            payload.value = new Date(payload.value);
        } catch (_err) {}
        const input = payload.value;
        const isDate = input instanceof Date;
        const isValidDate = isDate && !Number.isNaN(input.getTime());
        if (isValidDate) return payload;
        payload.issues.push({
            expected: "date",
            code: "invalid_type",
            input: input,
            ...isDate ? {
                received: "Invalid Date"
            } : {},
            inst: inst
        });
        return payload;
    };
});
function $e919c1e0a57df477$var$handleArrayResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(index, result.issues));
    final.value[index] = result.value;
}
const $e919c1e0a57df477$export$fd77bdade7d2292b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodArray", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                expected: "array",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = Array(input.length);
        const proms = [];
        for(let i = 0; i < input.length; i++){
            const item = input[i];
            const result = def.element._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$e919c1e0a57df477$var$handleArrayResult(result, payload, i)));
            else $e919c1e0a57df477$var$handleArrayResult(result, payload, i);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload; //handleArrayResultsAsync(parseResults, final);
    };
});
function $e919c1e0a57df477$var$handlePropertyResult(result, final, key, input) {
    if (result.issues.length) final.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(key, result.issues));
    if (result.value === undefined) {
        if (key in input) final.value[key] = undefined;
    } else final.value[key] = result.value;
}
function $e919c1e0a57df477$var$normalizeDef(def) {
    const keys = Object.keys(def.shape);
    for (const k of keys){
        if (!def.shape[k]._zod.traits.has("$ZodType")) throw new Error(`Invalid element at key "${k}": expected a Zod schema`);
    }
    const okeys = $ff926c078a178a32$export$240159211e66adb9(def.shape);
    return {
        ...def,
        keys: keys,
        keySet: new Set(keys),
        numKeys: keys.length,
        optionalKeys: new Set(okeys)
    };
}
function $e919c1e0a57df477$var$handleCatchall(proms, input, payload, ctx, def, inst) {
    const unrecognized = [];
    // iterate over input keys
    const keySet = def.keySet;
    const _catchall = def.catchall._zod;
    const t = _catchall.def.type;
    for (const key of Object.keys(input)){
        if (keySet.has(key)) continue;
        if (t === "never") {
            unrecognized.push(key);
            continue;
        }
        const r = _catchall.run({
            value: input[key],
            issues: []
        }, ctx);
        if (r instanceof Promise) proms.push(r.then((r)=>$e919c1e0a57df477$var$handlePropertyResult(r, payload, key, input)));
        else $e919c1e0a57df477$var$handlePropertyResult(r, payload, key, input);
    }
    if (unrecognized.length) payload.issues.push({
        code: "unrecognized_keys",
        keys: unrecognized,
        input: input,
        inst: inst
    });
    if (!proms.length) return payload;
    return Promise.all(proms).then(()=>{
        return payload;
    });
}
const $e919c1e0a57df477$export$54037a1ef79a4f1a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodObject", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    const _normalized = $ff926c078a178a32$export$ade7a147f5129058(()=>$e919c1e0a57df477$var$normalizeDef(def));
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "propValues", ()=>{
        const shape = def.shape;
        const propValues = {};
        for(const key in shape){
            const field = shape[key]._zod;
            if (field.values) {
                propValues[key] ?? (propValues[key] = new Set());
                for (const v of field.values)propValues[key].add(v);
            }
        }
        return propValues;
    });
    const isObject = $ff926c078a178a32$export$a6cdc56e425d0d0a;
    const catchall = def.catchall;
    let value;
    inst._zod.parse = (payload, ctx)=>{
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        payload.value = {};
        const proms = [];
        const shape = value.shape;
        for (const key of value.keys){
            const el = shape[key];
            const r = el._zod.run({
                value: input[key],
                issues: []
            }, ctx);
            if (r instanceof Promise) proms.push(r.then((r)=>$e919c1e0a57df477$var$handlePropertyResult(r, payload, key, input)));
            else $e919c1e0a57df477$var$handlePropertyResult(r, payload, key, input);
        }
        if (!catchall) return proms.length ? Promise.all(proms).then(()=>payload) : payload;
        return $e919c1e0a57df477$var$handleCatchall(proms, input, payload, ctx, _normalized.value, inst);
    };
});
const $e919c1e0a57df477$export$330feb3f8e03c085 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodObjectJIT", (inst, def)=>{
    // requires cast because technically $ZodObject doesn't extend
    $e919c1e0a57df477$export$54037a1ef79a4f1a.init(inst, def);
    const superParse = inst._zod.parse;
    const _normalized = $ff926c078a178a32$export$ade7a147f5129058(()=>$e919c1e0a57df477$var$normalizeDef(def));
    const generateFastpass = (shape)=>{
        const doc = new (0, $d4ecf008c2deb17a$export$bceacc74c2212615)([
            "shape",
            "payload",
            "ctx"
        ]);
        const normalized = _normalized.value;
        const parseStr = (key)=>{
            const k = $ff926c078a178a32$export$a1a11b095f88289a(key);
            return `shape[${k}]._zod.run({ value: input[${k}], issues: [] }, ctx)`;
        };
        doc.write(`const input = payload.value;`);
        const ids = Object.create(null);
        let counter = 0;
        for (const key of normalized.keys)ids[key] = `key_${counter++}`;
        // A: preserve key order {
        doc.write(`const newResult = {}`);
        for (const key of normalized.keys){
            const id = ids[key];
            const k = $ff926c078a178a32$export$a1a11b095f88289a(key);
            doc.write(`const ${id} = ${parseStr(key)};`);
            doc.write(`
        if (${id}.issues.length) {
          payload.issues = payload.issues.concat(${id}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${k}, ...iss.path] : [${k}]
          })));
        }
        
        if (${id}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${id}.value;
        }
      `);
        }
        doc.write(`payload.value = newResult;`);
        doc.write(`return payload;`);
        const fn = doc.compile();
        return (payload, ctx)=>fn(shape, payload, ctx);
    };
    let fastpass;
    const isObject = $ff926c078a178a32$export$a6cdc56e425d0d0a;
    const jit = !$3902e9f6ee6db121$export$f9cd1e43211d8a4a.jitless;
    const allowsEval = $ff926c078a178a32$export$1f119cb4d720843b;
    const fastEnabled = jit && allowsEval.value; // && !def.catchall;
    const catchall = def.catchall;
    let value;
    inst._zod.parse = (payload, ctx)=>{
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject(input)) {
            payload.issues.push({
                expected: "object",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        if (jit && fastEnabled && ctx?.async === false && ctx.jitless !== true) {
            // always synchronous
            if (!fastpass) fastpass = generateFastpass(def.shape);
            payload = fastpass(payload, ctx);
            if (!catchall) return payload;
            return $e919c1e0a57df477$var$handleCatchall([], input, payload, ctx, value, inst);
        }
        return superParse(payload, ctx);
    };
});
function $e919c1e0a57df477$var$handleUnionResults(results, final, inst, ctx) {
    for (const result of results)if (result.issues.length === 0) {
        final.value = result.value;
        return final;
    }
    const nonaborted = results.filter((r)=>!$ff926c078a178a32$export$bd75b6d981b9c7f2(r));
    if (nonaborted.length === 1) {
        final.value = nonaborted[0].value;
        return nonaborted[0];
    }
    final.issues.push({
        code: "invalid_union",
        input: final.value,
        inst: inst,
        errors: results.map((result)=>result.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20())))
    });
    return final;
}
const $e919c1e0a57df477$export$37a2350ef0bd638c = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodUnion", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.options.some((o)=>o._zod.optin === "optional") ? "optional" : undefined);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.options.some((o)=>o._zod.optout === "optional") ? "optional" : undefined);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        if (def.options.every((o)=>o._zod.values)) return new Set(def.options.flatMap((option)=>Array.from(option._zod.values)));
        return undefined;
    });
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        if (def.options.every((o)=>o._zod.pattern)) {
            const patterns = def.options.map((o)=>o._zod.pattern);
            return new RegExp(`^(${patterns.map((p)=>$ff926c078a178a32$export$78d521805d6c22e4(p.source)).join("|")})$`);
        }
        return undefined;
    });
    const single = def.options.length === 1;
    const first = def.options[0]._zod.run;
    inst._zod.parse = (payload, ctx)=>{
        if (single) return first(payload, ctx);
        let async = false;
        const results = [];
        for (const option of def.options){
            const result = option._zod.run({
                value: payload.value,
                issues: []
            }, ctx);
            if (result instanceof Promise) {
                results.push(result);
                async = true;
            } else {
                if (result.issues.length === 0) return result;
                results.push(result);
            }
        }
        if (!async) return $e919c1e0a57df477$var$handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results)=>{
            return $e919c1e0a57df477$var$handleUnionResults(results, payload, inst, ctx);
        });
    };
});
const $e919c1e0a57df477$export$aad4f17edfb83795 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodDiscriminatedUnion", (inst, def)=>{
    $e919c1e0a57df477$export$37a2350ef0bd638c.init(inst, def);
    const _super = inst._zod.parse;
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "propValues", ()=>{
        const propValues = {};
        for (const option of def.options){
            const pv = option._zod.propValues;
            if (!pv || Object.keys(pv).length === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
            for (const [k, v] of Object.entries(pv)){
                if (!propValues[k]) propValues[k] = new Set();
                for (const val of v)propValues[k].add(val);
            }
        }
        return propValues;
    });
    const disc = $ff926c078a178a32$export$ade7a147f5129058(()=>{
        const opts = def.options;
        const map = new Map();
        for (const o of opts){
            const values = o._zod.propValues?.[def.discriminator];
            if (!values || values.size === 0) throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(o)}"`);
            for (const v of values){
                if (map.has(v)) throw new Error(`Duplicate discriminator value "${String(v)}"`);
                map.set(v, o);
            }
        }
        return map;
    });
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$ff926c078a178a32$export$a6cdc56e425d0d0a(input)) {
            payload.issues.push({
                code: "invalid_type",
                expected: "object",
                input: input,
                inst: inst
            });
            return payload;
        }
        const opt = disc.value.get(input?.[def.discriminator]);
        if (opt) return opt._zod.run(payload, ctx);
        if (def.unionFallback) return _super(payload, ctx);
        // no matching discriminator
        payload.issues.push({
            code: "invalid_union",
            errors: [],
            note: "No matching discriminator",
            discriminator: def.discriminator,
            input: input,
            path: [
                def.discriminator
            ],
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$2299250b426aba4b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodIntersection", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        const left = def.left._zod.run({
            value: input,
            issues: []
        }, ctx);
        const right = def.right._zod.run({
            value: input,
            issues: []
        }, ctx);
        const async = left instanceof Promise || right instanceof Promise;
        if (async) return Promise.all([
            left,
            right
        ]).then(([left, right])=>{
            return $e919c1e0a57df477$var$handleIntersectionResults(payload, left, right);
        });
        return $e919c1e0a57df477$var$handleIntersectionResults(payload, left, right);
    };
});
function $e919c1e0a57df477$var$mergeValues(a, b) {
    // const aType = parse.t(a);
    // const bType = parse.t(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    if (a instanceof Date && b instanceof Date && +a === +b) return {
        valid: true,
        data: a
    };
    if ($ff926c078a178a32$export$53b83ca8eaab0383(a) && $ff926c078a178a32$export$53b83ca8eaab0383(b)) {
        const bKeys = Object.keys(b);
        const sharedKeys = Object.keys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $e919c1e0a57df477$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    key,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    }
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return {
            valid: false,
            mergeErrorPath: []
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $e919c1e0a57df477$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false,
                mergeErrorPath: [
                    index,
                    ...sharedValue.mergeErrorPath
                ]
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    }
    return {
        valid: false,
        mergeErrorPath: []
    };
}
function $e919c1e0a57df477$var$handleIntersectionResults(result, left, right) {
    if (left.issues.length) result.issues.push(...left.issues);
    if (right.issues.length) result.issues.push(...right.issues);
    if ($ff926c078a178a32$export$bd75b6d981b9c7f2(result)) return result;
    const merged = $e919c1e0a57df477$var$mergeValues(left.value, right.value);
    if (!merged.valid) throw new Error(`Unmergable intersection. Error path: ` + `${JSON.stringify(merged.mergeErrorPath)}`);
    result.value = merged.data;
    return result;
}
const $e919c1e0a57df477$export$bba1b90a721dbd94 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodTuple", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    const items = def.items;
    const optStart = items.length - [
        ...items
    ].reverse().findIndex((item)=>item._zod.optin !== "optional");
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!Array.isArray(input)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "tuple",
                code: "invalid_type"
            });
            return payload;
        }
        payload.value = [];
        const proms = [];
        if (!def.rest) {
            const tooBig = input.length > items.length;
            const tooSmall = input.length < optStart - 1;
            if (tooBig || tooSmall) {
                payload.issues.push({
                    ...tooBig ? {
                        code: "too_big",
                        maximum: items.length
                    } : {
                        code: "too_small",
                        minimum: items.length
                    },
                    input: input,
                    inst: inst,
                    origin: "array"
                });
                return payload;
            }
        }
        let i = -1;
        for (const item of items){
            i++;
            if (i >= input.length) {
                if (i >= optStart) continue;
            }
            const result = item._zod.run({
                value: input[i],
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$e919c1e0a57df477$var$handleTupleResult(result, payload, i)));
            else $e919c1e0a57df477$var$handleTupleResult(result, payload, i);
        }
        if (def.rest) {
            const rest = input.slice(items.length);
            for (const el of rest){
                i++;
                const result = def.rest._zod.run({
                    value: el,
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>$e919c1e0a57df477$var$handleTupleResult(result, payload, i)));
                else $e919c1e0a57df477$var$handleTupleResult(result, payload, i);
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $e919c1e0a57df477$var$handleTupleResult(result, final, index) {
    if (result.issues.length) final.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(index, result.issues));
    final.value[index] = result.value;
}
const $e919c1e0a57df477$export$cc20b90ec1a8c208 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodRecord", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!$ff926c078a178a32$export$53b83ca8eaab0383(input)) {
            payload.issues.push({
                expected: "record",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        if (def.keyType._zod.values) {
            const values = def.keyType._zod.values;
            payload.value = {};
            for (const key of values)if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[key] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[key] = result.value;
                }
            }
            let unrecognized;
            for(const key in input)if (!values.has(key)) {
                unrecognized = unrecognized ?? [];
                unrecognized.push(key);
            }
            if (unrecognized && unrecognized.length > 0) payload.issues.push({
                code: "unrecognized_keys",
                input: input,
                inst: inst,
                keys: unrecognized
            });
        } else {
            payload.value = {};
            for (const key of Reflect.ownKeys(input)){
                if (key === "__proto__") continue;
                const keyResult = def.keyType._zod.run({
                    value: key,
                    issues: []
                }, ctx);
                if (keyResult instanceof Promise) throw new Error("Async schemas not supported in object keys currently");
                if (keyResult.issues.length) {
                    payload.issues.push({
                        code: "invalid_key",
                        origin: "record",
                        issues: keyResult.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20())),
                        input: key,
                        path: [
                            key
                        ],
                        inst: inst
                    });
                    payload.value[keyResult.value] = keyResult.value;
                    continue;
                }
                const result = def.valueType._zod.run({
                    value: input[key],
                    issues: []
                }, ctx);
                if (result instanceof Promise) proms.push(result.then((result)=>{
                    if (result.issues.length) payload.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[keyResult.value] = result.value;
                }));
                else {
                    if (result.issues.length) payload.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(key, result.issues));
                    payload.value[keyResult.value] = result.value;
                }
            }
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
const $e919c1e0a57df477$export$5ccfd30a7e358409 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodMap", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Map)) {
            payload.issues.push({
                expected: "map",
                code: "invalid_type",
                input: input,
                inst: inst
            });
            return payload;
        }
        const proms = [];
        payload.value = new Map();
        for (const [key, value] of input){
            const keyResult = def.keyType._zod.run({
                value: key,
                issues: []
            }, ctx);
            const valueResult = def.valueType._zod.run({
                value: value,
                issues: []
            }, ctx);
            if (keyResult instanceof Promise || valueResult instanceof Promise) proms.push(Promise.all([
                keyResult,
                valueResult
            ]).then(([keyResult, valueResult])=>{
                $e919c1e0a57df477$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
            }));
            else $e919c1e0a57df477$var$handleMapResult(keyResult, valueResult, payload, key, input, inst, ctx);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $e919c1e0a57df477$var$handleMapResult(keyResult, valueResult, final, key, input, inst, ctx) {
    if (keyResult.issues.length) {
        if ($ff926c078a178a32$export$b99c149ecf60be48.has(typeof key)) final.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(key, keyResult.issues));
        else final.issues.push({
            code: "invalid_key",
            origin: "map",
            input: input,
            inst: inst,
            issues: keyResult.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20()))
        });
    }
    if (valueResult.issues.length) {
        if ($ff926c078a178a32$export$b99c149ecf60be48.has(typeof key)) final.issues.push(...$ff926c078a178a32$export$7f35a4c434118b9e(key, valueResult.issues));
        else final.issues.push({
            origin: "map",
            code: "invalid_element",
            input: input,
            inst: inst,
            key: key,
            issues: valueResult.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20()))
        });
    }
    final.value.set(keyResult.value, valueResult.value);
}
const $e919c1e0a57df477$export$20cf27bc33a30268 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodSet", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        const input = payload.value;
        if (!(input instanceof Set)) {
            payload.issues.push({
                input: input,
                inst: inst,
                expected: "set",
                code: "invalid_type"
            });
            return payload;
        }
        const proms = [];
        payload.value = new Set();
        for (const item of input){
            const result = def.valueType._zod.run({
                value: item,
                issues: []
            }, ctx);
            if (result instanceof Promise) proms.push(result.then((result)=>$e919c1e0a57df477$var$handleSetResult(result, payload)));
            else $e919c1e0a57df477$var$handleSetResult(result, payload);
        }
        if (proms.length) return Promise.all(proms).then(()=>payload);
        return payload;
    };
});
function $e919c1e0a57df477$var$handleSetResult(result, final) {
    if (result.issues.length) final.issues.push(...result.issues);
    final.value.add(result.value);
}
const $e919c1e0a57df477$export$31462b6e6c50b618 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodEnum", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    const values = $ff926c078a178a32$export$70a5d58ec00f3c11(def.entries);
    const valuesSet = new Set(values);
    inst._zod.values = valuesSet;
    inst._zod.pattern = new RegExp(`^(${values.filter((k)=>$ff926c078a178a32$export$b99c149ecf60be48.has(typeof k)).map((o)=>typeof o === "string" ? $ff926c078a178a32$export$104ed90cc1a13451(o) : o.toString()).join("|")})$`);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (valuesSet.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$86699355265fa258 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodLiteral", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    if (def.values.length === 0) throw new Error("Cannot create literal schema with no valid values");
    inst._zod.values = new Set(def.values);
    inst._zod.pattern = new RegExp(`^(${def.values.map((o)=>typeof o === "string" ? $ff926c078a178a32$export$104ed90cc1a13451(o) : o ? $ff926c078a178a32$export$104ed90cc1a13451(o.toString()) : String(o)).join("|")})$`);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        if (inst._zod.values.has(input)) return payload;
        payload.issues.push({
            code: "invalid_value",
            values: def.values,
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$1997de0576a81377 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodFile", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        const input = payload.value;
        // @ts-ignore
        if (input instanceof File) return payload;
        payload.issues.push({
            expected: "file",
            code: "invalid_type",
            input: input,
            inst: inst
        });
        return payload;
    };
});
const $e919c1e0a57df477$export$14b591f873519189 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodTransform", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $3902e9f6ee6db121$export$a36d4c29b1151bde(inst.constructor.name);
        const _out = def.transform(payload.value, payload);
        if (ctx.async) {
            const output = _out instanceof Promise ? _out : Promise.resolve(_out);
            return output.then((output)=>{
                payload.value = output;
                return payload;
            });
        }
        if (_out instanceof Promise) throw new $3902e9f6ee6db121$export$13016bcec11ba196();
        payload.value = _out;
        return payload;
    };
});
function $e919c1e0a57df477$var$handleOptionalResult(result, input) {
    if (result.issues.length && input === undefined) return {
        issues: [],
        value: undefined
    };
    return result;
}
const $e919c1e0a57df477$export$980e9af565c4d7aa = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodOptional", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    inst._zod.optout = "optional";
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        return def.innerType._zod.values ? new Set([
            ...def.innerType._zod.values,
            undefined
        ]) : undefined;
    });
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$ff926c078a178a32$export$78d521805d6c22e4(pattern.source)})?$`) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        if (def.innerType._zod.optin === "optional") {
            const result = def.innerType._zod.run(payload, ctx);
            if (result instanceof Promise) return result.then((r)=>$e919c1e0a57df477$var$handleOptionalResult(r, payload.value));
            return $e919c1e0a57df477$var$handleOptionalResult(result, payload.value);
        }
        if (payload.value === undefined) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e919c1e0a57df477$export$7994573b6604ec66 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodNullable", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType._zod.optin);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType._zod.optout);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "pattern", ()=>{
        const pattern = def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${$ff926c078a178a32$export$78d521805d6c22e4(pattern.source)}|null)$`) : undefined;
    });
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        return def.innerType._zod.values ? new Set([
            ...def.innerType._zod.values,
            null
        ]) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        // Forward direction (decode): allow null to pass through
        if (payload.value === null) return payload;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e919c1e0a57df477$export$ae2d21004b7243f7 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodDefault", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    // inst._zod.qin = "true";
    inst._zod.optin = "optional";
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply defaults for undefined input
        if (payload.value === undefined) {
            payload.value = def.defaultValue;
            /**
             * $ZodDefault returns the default value immediately in forward direction.
             * It doesn't pass the default value into the validator ("prefault"). There's no reason to pass the default value through validation. The validity of the default is enforced by TypeScript statically. Otherwise, it's the responsibility of the user to ensure the default is valid. In the case of pipes with divergent in/out types, you can specify the default on the `in` schema of your ZodPipe to set a "prefault" for the pipe.   */ return payload;
        }
        // Forward direction: continue with default handling
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$e919c1e0a57df477$var$handleDefaultResult(result, def));
        return $e919c1e0a57df477$var$handleDefaultResult(result, def);
    };
});
function $e919c1e0a57df477$var$handleDefaultResult(payload, def) {
    if (payload.value === undefined) payload.value = def.defaultValue;
    return payload;
}
const $e919c1e0a57df477$export$29a8d757258be679 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodPrefault", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.optin = "optional";
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply prefault for undefined input
        if (payload.value === undefined) payload.value = def.defaultValue;
        return def.innerType._zod.run(payload, ctx);
    };
});
const $e919c1e0a57df477$export$30ca726c4c50a6d7 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodNonOptional", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>{
        const v = def.innerType._zod.values;
        return v ? new Set([
            ...v
        ].filter((x)=>x !== undefined)) : undefined;
    });
    inst._zod.parse = (payload, ctx)=>{
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>$e919c1e0a57df477$var$handleNonOptionalResult(result, inst));
        return $e919c1e0a57df477$var$handleNonOptionalResult(result, inst);
    };
});
function $e919c1e0a57df477$var$handleNonOptionalResult(payload, inst) {
    if (!payload.issues.length && payload.value === undefined) payload.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: payload.value,
        inst: inst
    });
    return payload;
}
const $e919c1e0a57df477$export$3cc4d03e729326ea = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodSuccess", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") throw new $3902e9f6ee6db121$export$a36d4c29b1151bde("ZodSuccess");
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.issues.length === 0;
            return payload;
        });
        payload.value = result.issues.length === 0;
        return payload;
    };
});
const $e919c1e0a57df477$export$d6f8b228374f6d37 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCatch", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType._zod.optin);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType._zod.optout);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        // Forward direction (decode): apply catch logic
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then((result)=>{
            payload.value = result.value;
            if (result.issues.length) {
                payload.value = def.catchValue({
                    ...payload,
                    error: {
                        issues: result.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20()))
                    },
                    input: payload.value
                });
                payload.issues = [];
            }
            return payload;
        });
        payload.value = result.value;
        if (result.issues.length) {
            payload.value = def.catchValue({
                ...payload,
                error: {
                    issues: result.issues.map((iss)=>$ff926c078a178a32$export$c5e667bbfc286a9d(iss, ctx, $3902e9f6ee6db121$export$e506a1d27d1eaa20()))
                },
                input: payload.value
            });
            payload.issues = [];
        }
        return payload;
    };
});
const $e919c1e0a57df477$export$528f71701e6a7aee = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodNaN", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "number" || !Number.isNaN(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "nan",
                code: "invalid_type"
            });
            return payload;
        }
        return payload;
    };
});
const $e919c1e0a57df477$export$4cb25cfde430326c = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodPipe", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>def.in._zod.values);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.in._zod.optin);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.out._zod.optout);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$e919c1e0a57df477$var$handlePipeResult(right, def.in, ctx));
            return $e919c1e0a57df477$var$handlePipeResult(right, def.in, ctx);
        }
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) return left.then((left)=>$e919c1e0a57df477$var$handlePipeResult(left, def.out, ctx));
        return $e919c1e0a57df477$var$handlePipeResult(left, def.out, ctx);
    };
});
function $e919c1e0a57df477$var$handlePipeResult(left, next, ctx) {
    if (left.issues.length) {
        // prevent further checks
        left.aborted = true;
        return left;
    }
    return next._zod.run({
        value: left.value,
        issues: left.issues
    }, ctx);
}
const $e919c1e0a57df477$export$c622e07db8a40b53 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCodec", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>def.in._zod.values);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.in._zod.optin);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.out._zod.optout);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.in._zod.propValues);
    inst._zod.parse = (payload, ctx)=>{
        const direction = ctx.direction || "forward";
        if (direction === "forward") {
            const left = def.in._zod.run(payload, ctx);
            if (left instanceof Promise) return left.then((left)=>$e919c1e0a57df477$var$handleCodecAResult(left, def, ctx));
            return $e919c1e0a57df477$var$handleCodecAResult(left, def, ctx);
        } else {
            const right = def.out._zod.run(payload, ctx);
            if (right instanceof Promise) return right.then((right)=>$e919c1e0a57df477$var$handleCodecAResult(right, def, ctx));
            return $e919c1e0a57df477$var$handleCodecAResult(right, def, ctx);
        }
    };
});
function $e919c1e0a57df477$var$handleCodecAResult(result, def, ctx) {
    if (result.issues.length) {
        // prevent further checks
        result.aborted = true;
        return result;
    }
    const direction = ctx.direction || "forward";
    if (direction === "forward") {
        const transformed = def.transform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value)=>$e919c1e0a57df477$var$handleCodecTxResult(result, value, def.out, ctx));
        return $e919c1e0a57df477$var$handleCodecTxResult(result, transformed, def.out, ctx);
    } else {
        const transformed = def.reverseTransform(result.value, result);
        if (transformed instanceof Promise) return transformed.then((value)=>$e919c1e0a57df477$var$handleCodecTxResult(result, value, def.in, ctx));
        return $e919c1e0a57df477$var$handleCodecTxResult(result, transformed, def.in, ctx);
    }
}
function $e919c1e0a57df477$var$handleCodecTxResult(left, value, nextSchema, ctx) {
    // Check if transform added any issues
    if (left.issues.length) {
        left.aborted = true;
        return left;
    }
    return nextSchema._zod.run({
        value: value,
        issues: left.issues
    }, ctx);
}
const $e919c1e0a57df477$export$f9f268f3fbb1601b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodReadonly", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "propValues", ()=>def.innerType._zod.propValues);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "values", ()=>def.innerType._zod.values);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optin", ()=>def.innerType._zod.optin);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optout", ()=>def.innerType._zod.optout);
    inst._zod.parse = (payload, ctx)=>{
        if (ctx.direction === "backward") return def.innerType._zod.run(payload, ctx);
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) return result.then($e919c1e0a57df477$var$handleReadonlyResult);
        return $e919c1e0a57df477$var$handleReadonlyResult(result);
    };
});
function $e919c1e0a57df477$var$handleReadonlyResult(payload) {
    payload.value = Object.freeze(payload.value);
    return payload;
}
const $e919c1e0a57df477$export$37ea86c57a77af54 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodTemplateLiteral", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    const regexParts = [];
    for (const part of def.parts){
        if (typeof part === "object" && part !== null) {
            // is Zod schema
            if (!part._zod.pattern) // if (!source)
            throw new Error(`Invalid template literal part, no pattern found: ${[
                ...part._zod.traits
            ].shift()}`);
            const source = part._zod.pattern instanceof RegExp ? part._zod.pattern.source : part._zod.pattern;
            if (!source) throw new Error(`Invalid template literal part: ${part._zod.traits}`);
            const start = source.startsWith("^") ? 1 : 0;
            const end = source.endsWith("$") ? source.length - 1 : source.length;
            regexParts.push(source.slice(start, end));
        } else if (part === null || $ff926c078a178a32$export$c34ffd355f76f0e4.has(typeof part)) regexParts.push($ff926c078a178a32$export$104ed90cc1a13451(`${part}`));
        else throw new Error(`Invalid template literal part: ${part}`);
    }
    inst._zod.pattern = new RegExp(`^${regexParts.join("")}$`);
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "string") {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                expected: "template_literal",
                code: "invalid_type"
            });
            return payload;
        }
        inst._zod.pattern.lastIndex = 0;
        if (!inst._zod.pattern.test(payload.value)) {
            payload.issues.push({
                input: payload.value,
                inst: inst,
                code: "invalid_format",
                format: def.format ?? "template_literal",
                pattern: inst._zod.pattern.source
            });
            return payload;
        }
        return payload;
    };
});
const $e919c1e0a57df477$export$877c6e9c05ede764 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodFunction", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._def = def;
    inst._zod.def = def;
    inst.implement = (func)=>{
        if (typeof func !== "function") throw new Error("implement() must be called with a function");
        return function(...args) {
            const parsedArgs = inst._def.input ? (0, $160c3afc845a29d6$export$98e6a39c04603d36)(inst._def.input, args) : args;
            const result = Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return (0, $160c3afc845a29d6$export$98e6a39c04603d36)(inst._def.output, result);
            return result;
        };
    };
    inst.implementAsync = (func)=>{
        if (typeof func !== "function") throw new Error("implementAsync() must be called with a function");
        return async function(...args) {
            const parsedArgs = inst._def.input ? await (0, $160c3afc845a29d6$export$59b6f938fbf579e3)(inst._def.input, args) : args;
            const result = await Reflect.apply(func, this, parsedArgs);
            if (inst._def.output) return await (0, $160c3afc845a29d6$export$59b6f938fbf579e3)(inst._def.output, result);
            return result;
        };
    };
    inst._zod.parse = (payload, _ctx)=>{
        if (typeof payload.value !== "function") {
            payload.issues.push({
                code: "invalid_type",
                expected: "function",
                input: payload.value,
                inst: inst
            });
            return payload;
        }
        // Check if output is a promise type to determine if we should use async implementation
        const hasPromiseOutput = inst._def.output && inst._def.output._zod.def.type === "promise";
        if (hasPromiseOutput) payload.value = inst.implementAsync(payload.value);
        else payload.value = inst.implement(payload.value);
        return payload;
    };
    inst.input = (...args)=>{
        const F = inst.constructor;
        if (Array.isArray(args[0])) return new F({
            type: "function",
            input: new $e919c1e0a57df477$export$bba1b90a721dbd94({
                type: "tuple",
                items: args[0],
                rest: args[1]
            }),
            output: inst._def.output
        });
        return new F({
            type: "function",
            input: args[0],
            output: inst._def.output
        });
    };
    inst.output = (output)=>{
        const F = inst.constructor;
        return new F({
            type: "function",
            input: inst._def.input,
            output: output
        });
    };
    return inst;
});
const $e919c1e0a57df477$export$bdefabff0dd84ca4 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodPromise", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, ctx)=>{
        return Promise.resolve(payload.value).then((inner)=>def.innerType._zod.run({
                value: inner,
                issues: []
            }, ctx));
    };
});
const $e919c1e0a57df477$export$662fecee2efa1a66 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodLazy", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    // let _innerType!: any;
    // util.defineLazy(def, "getter", () => {
    //   if (!_innerType) {
    //     _innerType = def.getter();
    //   }
    //   return () => _innerType;
    // });
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "innerType", ()=>def.getter());
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "pattern", ()=>inst._zod.innerType._zod.pattern);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "propValues", ()=>inst._zod.innerType._zod.propValues);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optin", ()=>inst._zod.innerType._zod.optin ?? undefined);
    $ff926c078a178a32$export$d43070a5843c1e2(inst._zod, "optout", ()=>inst._zod.innerType._zod.optout ?? undefined);
    inst._zod.parse = (payload, ctx)=>{
        const inner = inst._zod.innerType;
        return inner._zod.run(payload, ctx);
    };
});
const $e919c1e0a57df477$export$3a5d0e5e098b79ba = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("$ZodCustom", (inst, def)=>{
    $644dcc0398eaee1d$export$c05d9110ef20bb2c.init(inst, def);
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst._zod.parse = (payload, _)=>{
        return payload;
    };
    inst._zod.check = (payload)=>{
        const input = payload.value;
        const r = def.fn(input);
        if (r instanceof Promise) return r.then((r)=>$e919c1e0a57df477$var$handleRefineResult(r, payload, input, inst));
        $e919c1e0a57df477$var$handleRefineResult(r, payload, input, inst);
        return;
    };
});
function $e919c1e0a57df477$var$handleRefineResult(result, payload, input, inst) {
    if (!result) {
        const _iss = {
            code: "custom",
            input: input,
            inst: inst,
            path: [
                ...inst._zod.def.path ?? []
            ],
            continue: !inst._zod.def.abort
        };
        if (inst._zod.def.params) _iss.params = inst._zod.def.params;
        payload.issues.push($ff926c078a178a32$export$69ad3503f98be476(_iss));
    }
}



function $b93bb84d2922cb59$export$25986a84359f8f7f(Class, params) {
    return new Class({
        type: "string",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$614049477c642ce0(Class, params) {
    return new Class({
        type: "string",
        coerce: true,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$471b39521bec3299(Class, params) {
    return new Class({
        type: "string",
        format: "email",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$129b5399d64cccb0(Class, params) {
    return new Class({
        type: "string",
        format: "guid",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$f2f3139038bea52c(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a5559d7da37a112f(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v4",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$53b427a8173231a(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v6",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$588d23d6e9ec2ed5(Class, params) {
    return new Class({
        type: "string",
        format: "uuid",
        check: "string_format",
        abort: false,
        version: "v7",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$e3f203373341d39(Class, params) {
    return new Class({
        type: "string",
        format: "url",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$936e26d261396f46(Class, params) {
    return new Class({
        type: "string",
        format: "emoji",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a030949b19390ea0(Class, params) {
    return new Class({
        type: "string",
        format: "nanoid",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$639125837b796148(Class, params) {
    return new Class({
        type: "string",
        format: "cuid",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$36b63ef9af7972c2(Class, params) {
    return new Class({
        type: "string",
        format: "cuid2",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$95acf3b3fa11bdc9(Class, params) {
    return new Class({
        type: "string",
        format: "ulid",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$bbb0a2cfb079fa90(Class, params) {
    return new Class({
        type: "string",
        format: "xid",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$1306ede2f9ea153f(Class, params) {
    return new Class({
        type: "string",
        format: "ksuid",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$c77a1c80cebc2aad(Class, params) {
    return new Class({
        type: "string",
        format: "ipv4",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$964dfe0e2e4e8895(Class, params) {
    return new Class({
        type: "string",
        format: "ipv6",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$feaac4e27a421ddc(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv4",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a0518ffc5273ec92(Class, params) {
    return new Class({
        type: "string",
        format: "cidrv6",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$9fdb09384fbc4988(Class, params) {
    return new Class({
        type: "string",
        format: "base64",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$178c70fb89c949fa(Class, params) {
    return new Class({
        type: "string",
        format: "base64url",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$b8bf0b70d4bc7855(Class, params) {
    return new Class({
        type: "string",
        format: "e164",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$4a9318e6b46f1aa1(Class, params) {
    return new Class({
        type: "string",
        format: "jwt",
        check: "string_format",
        abort: false,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
const $b93bb84d2922cb59$export$3a3ade082c590099 = {
    Any: null,
    Minute: -1,
    Second: 0,
    Millisecond: 3,
    Microsecond: 6
};
function $b93bb84d2922cb59$export$a62adeb27809351b(Class, params) {
    return new Class({
        type: "string",
        format: "datetime",
        check: "string_format",
        offset: false,
        local: false,
        precision: null,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$e4f19dd0a54e7a59(Class, params) {
    return new Class({
        type: "string",
        format: "date",
        check: "string_format",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$36f9f051d5e817c(Class, params) {
    return new Class({
        type: "string",
        format: "time",
        check: "string_format",
        precision: null,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$7d70539c76fbff4(Class, params) {
    return new Class({
        type: "string",
        format: "duration",
        check: "string_format",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$9249bb0b45639623(Class, params) {
    return new Class({
        type: "number",
        checks: [],
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$272511620e4661dd(Class, params) {
    return new Class({
        type: "number",
        coerce: true,
        checks: [],
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$3d5b343b1f51efdd(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "safeint",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$656ad65d6cf64174(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float32",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$9ddff8176107cc11(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "float64",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$5ec965fd114a2f9f(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "int32",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a43c28c6e86e066e(Class, params) {
    return new Class({
        type: "number",
        check: "number_format",
        abort: false,
        format: "uint32",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$e23c41ce5ce2db39(Class, params) {
    return new Class({
        type: "boolean",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$c3eb0e1c7c887e5c(Class, params) {
    return new Class({
        type: "boolean",
        coerce: true,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$c96ff33878177e4c(Class, params) {
    return new Class({
        type: "bigint",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$8ff745acc355d077(Class, params) {
    return new Class({
        type: "bigint",
        coerce: true,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$cb7d3ec922804f3f(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "int64",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$c51606f0dfa0f5a1(Class, params) {
    return new Class({
        type: "bigint",
        check: "bigint_format",
        abort: false,
        format: "uint64",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a8f93f5b7c030e84(Class, params) {
    return new Class({
        type: "symbol",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$60e4c9fe67803d40(Class, params) {
    return new Class({
        type: "undefined",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a2cbb38cda512d16(Class, params) {
    return new Class({
        type: "null",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$4678886173313220(Class) {
    return new Class({
        type: "any"
    });
}
function $b93bb84d2922cb59$export$e0ed508a47e00801(Class) {
    return new Class({
        type: "unknown"
    });
}
function $b93bb84d2922cb59$export$887f43204ffc2a69(Class, params) {
    return new Class({
        type: "never",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$9480825d3c8e9ad6(Class, params) {
    return new Class({
        type: "void",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$da799735c76175a(Class, params) {
    return new Class({
        type: "date",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$2efeac445ea43f33(Class, params) {
    return new Class({
        type: "date",
        coerce: true,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a5e7e1f8491a5e50(Class, params) {
    return new Class({
        type: "nan",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$2a42c74e76a068a(value, params) {
    return new $644dcc0398eaee1d$export$294415ecbdd02022({
        check: "less_than",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: false
    });
}
function $b93bb84d2922cb59$export$7a060cf3d60b84a6(value, params) {
    return new $644dcc0398eaee1d$export$294415ecbdd02022({
        check: "less_than",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: true
    });
}
function $b93bb84d2922cb59$export$7582466e3ab4d25b(value, params) {
    return new $644dcc0398eaee1d$export$8b670f58decbca18({
        check: "greater_than",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: false
    });
}
function $b93bb84d2922cb59$export$a1c6d8834a3b19c9(value, params) {
    return new $644dcc0398eaee1d$export$8b670f58decbca18({
        check: "greater_than",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        value: value,
        inclusive: true
    });
}
function $b93bb84d2922cb59$export$ddfc6f0a2e49a568(params) {
    return $b93bb84d2922cb59$export$7582466e3ab4d25b(0, params);
}
function $b93bb84d2922cb59$export$d30568dda7134ca5(params) {
    return $b93bb84d2922cb59$export$2a42c74e76a068a(0, params);
}
function $b93bb84d2922cb59$export$c3e51eea33419c94(params) {
    return $b93bb84d2922cb59$export$7a060cf3d60b84a6(0, params);
}
function $b93bb84d2922cb59$export$93ec5f75848b1928(params) {
    return $b93bb84d2922cb59$export$a1c6d8834a3b19c9(0, params);
}
function $b93bb84d2922cb59$export$c41e40f80e978ab1(value, params) {
    return new $644dcc0398eaee1d$export$ae602e11c1dd0628({
        check: "multiple_of",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        value: value
    });
}
function $b93bb84d2922cb59$export$3eed6ccb98bc18db(maximum, params) {
    return new $644dcc0398eaee1d$export$b3cec505675cf50c({
        check: "max_size",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        maximum: maximum
    });
}
function $b93bb84d2922cb59$export$e379713268c2c18a(minimum, params) {
    return new $644dcc0398eaee1d$export$59fb0a2e7217c42b({
        check: "min_size",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        minimum: minimum
    });
}
function $b93bb84d2922cb59$export$2621565b966a8d23(size, params) {
    return new $644dcc0398eaee1d$export$af532c490f33cd47({
        check: "size_equals",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        size: size
    });
}
function $b93bb84d2922cb59$export$ec76627108655a22(maximum, params) {
    const ch = new $644dcc0398eaee1d$export$b07b097887f4c15a({
        check: "max_length",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        maximum: maximum
    });
    return ch;
}
function $b93bb84d2922cb59$export$21f6711a906c1450(minimum, params) {
    return new $644dcc0398eaee1d$export$cd5336aa96b8417c({
        check: "min_length",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        minimum: minimum
    });
}
function $b93bb84d2922cb59$export$620b9f7ab17ff8a9(length, params) {
    return new $644dcc0398eaee1d$export$ccdb9b9d477068fb({
        check: "length_equals",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        length: length
    });
}
function $b93bb84d2922cb59$export$c4768a1bd8f8393(pattern, params) {
    return new $644dcc0398eaee1d$export$6faea86ff718d6df({
        check: "string_format",
        format: "regex",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        pattern: pattern
    });
}
function $b93bb84d2922cb59$export$ea67c3edeec85c63(params) {
    return new $644dcc0398eaee1d$export$e18e268bd5c9f27a({
        check: "string_format",
        format: "lowercase",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$2998381b41c6902a(params) {
    return new $644dcc0398eaee1d$export$6d0944a5127e820a({
        check: "string_format",
        format: "uppercase",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$fccf016a6caa651d(includes, params) {
    return new $644dcc0398eaee1d$export$600021c28f0498dc({
        check: "string_format",
        format: "includes",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        includes: includes
    });
}
function $b93bb84d2922cb59$export$2f37aaf99060de76(prefix, params) {
    return new $644dcc0398eaee1d$export$8e83a74b4b83cc62({
        check: "string_format",
        format: "starts_with",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        prefix: prefix
    });
}
function $b93bb84d2922cb59$export$eaeaa2fcd833167e(suffix, params) {
    return new $644dcc0398eaee1d$export$4a10f85c6af4e92({
        check: "string_format",
        format: "ends_with",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params),
        suffix: suffix
    });
}
function $b93bb84d2922cb59$export$537db06738ee7f1b(property, schema, params) {
    return new $644dcc0398eaee1d$export$d36a4eecd766dbc0({
        check: "property",
        property: property,
        schema: schema,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$267177285a1a8b37(types, params) {
    return new $644dcc0398eaee1d$export$5546147f1877f806({
        check: "mime_type",
        mime: types,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$aeea8f004f34f8c2(tx) {
    return new $644dcc0398eaee1d$export$1bda1934456013d3({
        check: "overwrite",
        tx: tx
    });
}
function $b93bb84d2922cb59$export$2b99bb23a814f78e(form) {
    return $b93bb84d2922cb59$export$aeea8f004f34f8c2((input)=>input.normalize(form));
}
function $b93bb84d2922cb59$export$8be2de0b60774d1e() {
    return $b93bb84d2922cb59$export$aeea8f004f34f8c2((input)=>input.trim());
}
function $b93bb84d2922cb59$export$d9cfe939403a2525() {
    return $b93bb84d2922cb59$export$aeea8f004f34f8c2((input)=>input.toLowerCase());
}
function $b93bb84d2922cb59$export$cf76ef1ae9e9944e() {
    return $b93bb84d2922cb59$export$aeea8f004f34f8c2((input)=>input.toUpperCase());
}
function $b93bb84d2922cb59$export$4ea446333e3db634(Class, element, params) {
    return new Class({
        type: "array",
        element: element,
        // get element() {
        //   return element;
        // },
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$48eec03fd15d025b(Class, options, params) {
    return new Class({
        type: "union",
        options: options,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$ffbf51421b0acee1(Class, discriminator, options, params) {
    return new Class({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$3d0d84e16c5ea809(Class, left, right) {
    return new Class({
        type: "intersection",
        left: left,
        right: right
    });
}
function $b93bb84d2922cb59$export$a13693bfb304605a(Class, items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $e919c1e0a57df477$export$f43a5c3966de8238;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new Class({
        type: "tuple",
        items: items,
        rest: rest,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$64440e3f2e29d7bc(Class, keyType, valueType, params) {
    return new Class({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a0135aecf4a782ab(Class, keyType, valueType, params) {
    return new Class({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$c37fd9e9b598996d(Class, valueType, params) {
    return new Class({
        type: "set",
        valueType: valueType,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$3290a9b46bcfecc1(Class, values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    // if (Array.isArray(values)) {
    //   for (const value of values) {
    //     entries[value] = value;
    //   }
    // } else {
    //   Object.assign(entries, values);
    // }
    // const entries: util.EnumLike = {};
    // for (const val of values) {
    //   entries[val] = val;
    // }
    return new Class({
        type: "enum",
        entries: entries,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$6b94bba2375b9e3d(Class, entries, params) {
    return new Class({
        type: "enum",
        entries: entries,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$a03e276eec27de8b(Class, value, params) {
    return new Class({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$e335cd0b9f8bab1e(Class, params) {
    return new Class({
        type: "file",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$fa4a3df4db7f3166(Class, fn) {
    return new Class({
        type: "transform",
        transform: fn
    });
}
function $b93bb84d2922cb59$export$6d07c57dda792495(Class, innerType) {
    return new Class({
        type: "optional",
        innerType: innerType
    });
}
function $b93bb84d2922cb59$export$4e46ee4534ff341d(Class, innerType) {
    return new Class({
        type: "nullable",
        innerType: innerType
    });
}
function $b93bb84d2922cb59$export$d4b0f68d0d916971(Class, innerType, defaultValue) {
    return new Class({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : $ff926c078a178a32$export$370e8311c3cdebd9(defaultValue);
        }
    });
}
function $b93bb84d2922cb59$export$24cb0533b28b009b(Class, innerType, params) {
    return new Class({
        type: "nonoptional",
        innerType: innerType,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$6f570707f72cba02(Class, innerType) {
    return new Class({
        type: "success",
        innerType: innerType
    });
}
function $b93bb84d2922cb59$export$7f43fa37c3d8a0b3(Class, innerType, catchValue) {
    return new Class({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : ()=>catchValue
    });
}
function $b93bb84d2922cb59$export$fc24e256ce7b145(Class, in_, out) {
    return new Class({
        type: "pipe",
        in: in_,
        out: out
    });
}
function $b93bb84d2922cb59$export$4fe7ff2cfb7a6dd7(Class, innerType) {
    return new Class({
        type: "readonly",
        innerType: innerType
    });
}
function $b93bb84d2922cb59$export$f30d99994777b6d(Class, parts, params) {
    return new Class({
        type: "template_literal",
        parts: parts,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
}
function $b93bb84d2922cb59$export$137d76f65e4bcae1(Class, getter) {
    return new Class({
        type: "lazy",
        getter: getter
    });
}
function $b93bb84d2922cb59$export$d91bbb815217feb6(Class, innerType) {
    return new Class({
        type: "promise",
        innerType: innerType
    });
}
function $b93bb84d2922cb59$export$8bfc2ce1398e3071(Class, fn, _params) {
    const norm = $ff926c078a178a32$export$d6b7b25dfacfd300(_params);
    norm.abort ?? (norm.abort = true); // default to abort:false
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...norm
    });
    return schema;
}
function $b93bb84d2922cb59$export$ac822e05051812e1(Class, fn, _params) {
    const schema = new Class({
        type: "custom",
        check: "custom",
        fn: fn,
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(_params)
    });
    return schema;
}
function $b93bb84d2922cb59$export$f2b01ecb843d7ab9(fn) {
    const ch = $b93bb84d2922cb59$export$d37145829e4ff88e((payload)=>{
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push($ff926c078a178a32$export$69ad3503f98be476(issue, payload.value, ch._zod.def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                _issue.input ?? (_issue.input = payload.value);
                _issue.inst ?? (_issue.inst = ch);
                _issue.continue ?? (_issue.continue = !ch._zod.def.abort); // abort is always undefined, so this is always true...
                payload.issues.push($ff926c078a178a32$export$69ad3503f98be476(_issue));
            }
        };
        return fn(payload.value, payload);
    });
    return ch;
}
function $b93bb84d2922cb59$export$d37145829e4ff88e(fn, params) {
    const ch = new $644dcc0398eaee1d$export$c05d9110ef20bb2c({
        check: "custom",
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(params)
    });
    ch._zod.check = fn;
    return ch;
}
function $b93bb84d2922cb59$export$a75528509e3a7006(Classes, _params) {
    const params = $ff926c078a178a32$export$d6b7b25dfacfd300(_params);
    let truthyArray = params.truthy ?? [
        "true",
        "1",
        "yes",
        "on",
        "y",
        "enabled"
    ];
    let falsyArray = params.falsy ?? [
        "false",
        "0",
        "no",
        "off",
        "n",
        "disabled"
    ];
    if (params.case !== "sensitive") {
        truthyArray = truthyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
        falsyArray = falsyArray.map((v)=>typeof v === "string" ? v.toLowerCase() : v);
    }
    const truthySet = new Set(truthyArray);
    const falsySet = new Set(falsyArray);
    const _Codec = Classes.Codec ?? $e919c1e0a57df477$export$c622e07db8a40b53;
    const _Boolean = Classes.Boolean ?? $e919c1e0a57df477$export$828bf41e557d7dda;
    const _String = Classes.String ?? $e919c1e0a57df477$export$4342b4432d7b1471;
    const stringSchema = new _String({
        type: "string",
        error: params.error
    });
    const booleanSchema = new _Boolean({
        type: "boolean",
        error: params.error
    });
    const codec = new _Codec({
        type: "pipe",
        in: stringSchema,
        out: booleanSchema,
        transform: (input, payload)=>{
            let data = input;
            if (params.case !== "sensitive") data = data.toLowerCase();
            if (truthySet.has(data)) return true;
            else if (falsySet.has(data)) return false;
            else {
                payload.issues.push({
                    code: "invalid_value",
                    expected: "stringbool",
                    values: [
                        ...truthySet,
                        ...falsySet
                    ],
                    input: payload.value,
                    inst: codec,
                    continue: false
                });
                return {};
            }
        },
        reverseTransform: (input, _payload)=>{
            if (input === true) return truthyArray[0] || "true";
            else return falsyArray[0] || "false";
        },
        error: params.error
    });
    return codec;
}
function $b93bb84d2922cb59$export$e25dde89ba546b88(Class, format, fnOrRegex, _params = {}) {
    const params = $ff926c078a178a32$export$d6b7b25dfacfd300(_params);
    const def = {
        ...$ff926c078a178a32$export$d6b7b25dfacfd300(_params),
        check: "string_format",
        type: "string",
        format: format,
        fn: typeof fnOrRegex === "function" ? fnOrRegex : (val)=>fnOrRegex.test(val),
        ...params
    };
    if (fnOrRegex instanceof RegExp) def.pattern = fnOrRegex;
    const inst = new Class(def);
    return inst;
}

const $e68fe56b6c2caecc$export$26c272954616d4a2 = Symbol("ZodOutput");
const $e68fe56b6c2caecc$export$4159eb10f43487af = Symbol("ZodInput");
class $e68fe56b6c2caecc$export$dc03955eec152cc5 {
    constructor(){
        this._map = new Map();
        this._idmap = new Map();
    }
    add(schema, ..._meta) {
        const meta = _meta[0];
        this._map.set(schema, meta);
        if (meta && typeof meta === "object" && "id" in meta) {
            if (this._idmap.has(meta.id)) throw new Error(`ID ${meta.id} already exists in the registry`);
            this._idmap.set(meta.id, schema);
        }
        return this;
    }
    clear() {
        this._map = new Map();
        this._idmap = new Map();
        return this;
    }
    remove(schema) {
        const meta = this._map.get(schema);
        if (meta && typeof meta === "object" && "id" in meta) this._idmap.delete(meta.id);
        this._map.delete(schema);
        return this;
    }
    get(schema) {
        // return this._map.get(schema) as any;
        // inherit metadata
        const p = schema._zod.parent;
        if (p) {
            const pm = {
                ...this.get(p) ?? {}
            };
            delete pm.id; // do not inherit id
            const f = {
                ...pm,
                ...this._map.get(schema)
            };
            return Object.keys(f).length ? f : undefined;
        }
        return this._map.get(schema);
    }
    has(schema) {
        return this._map.has(schema);
    }
}
function $e68fe56b6c2caecc$export$4bb7493d241fd8a5() {
    return new $e68fe56b6c2caecc$export$dc03955eec152cc5();
}
const $e68fe56b6c2caecc$export$bc58ce2776ecdb6f = /*@__PURE__*/ $e68fe56b6c2caecc$export$4bb7493d241fd8a5();





const $fbf271dcc0d8a0ad$export$8ceba53cbe6a272e = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodISODateTime", (inst, def)=>{
    $e919c1e0a57df477$export$3273e4d2df37774b.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $fbf271dcc0d8a0ad$export$7ba4466dbd0f07e1(params) {
    return $b93bb84d2922cb59$export$a62adeb27809351b($fbf271dcc0d8a0ad$export$8ceba53cbe6a272e, params);
}
const $fbf271dcc0d8a0ad$export$e7f25b469dafa5ec = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodISODate", (inst, def)=>{
    $e919c1e0a57df477$export$75b9bf98f4d806dc.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $fbf271dcc0d8a0ad$export$324d90190a8b822a(params) {
    return $b93bb84d2922cb59$export$e4f19dd0a54e7a59($fbf271dcc0d8a0ad$export$e7f25b469dafa5ec, params);
}
const $fbf271dcc0d8a0ad$export$ee190fc7c4074018 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodISOTime", (inst, def)=>{
    $e919c1e0a57df477$export$e9b9c3c2359a3ebc.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $fbf271dcc0d8a0ad$export$2da9be4cfdb689b1(params) {
    return $b93bb84d2922cb59$export$36f9f051d5e817c($fbf271dcc0d8a0ad$export$ee190fc7c4074018, params);
}
const $fbf271dcc0d8a0ad$export$164bac5916a0e7e9 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodISODuration", (inst, def)=>{
    $e919c1e0a57df477$export$d9e850ab18e4b22e.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $fbf271dcc0d8a0ad$export$1f34108aa9eb96ab(params) {
    return $b93bb84d2922cb59$export$7d70539c76fbff4($fbf271dcc0d8a0ad$export$164bac5916a0e7e9, params);
}





const $2d641df072b0d964$var$initializer = (inst, issues)=>{
    (0, $81abeb876ab51d15$export$544878318730b1d8).init(inst, issues);
    inst.name = "ZodError";
    Object.defineProperties(inst, {
        format: {
            value: (mapper)=>$81abeb876ab51d15$export$7b5b869ee98c16ab(inst, mapper)
        },
        flatten: {
            value: (mapper)=>$81abeb876ab51d15$export$4d7e0dfd5ca8366f(inst, mapper)
        },
        addIssue: {
            value: (issue)=>{
                inst.issues.push(issue);
                inst.message = JSON.stringify(inst.issues, $ff926c078a178a32$export$f4defb13cab882b2, 2);
            }
        },
        addIssues: {
            value: (issues)=>{
                inst.issues.push(...issues);
                inst.message = JSON.stringify(inst.issues, $ff926c078a178a32$export$f4defb13cab882b2, 2);
            }
        },
        isEmpty: {
            get () {
                return inst.issues.length === 0;
            }
        }
    });
// Object.defineProperty(inst, "isEmpty", {
//   get() {
//     return inst.issues.length === 0;
//   },
// });
};
const $2d641df072b0d964$export$f98dac4b251ab333 = $3902e9f6ee6db121$export$3122533d606194de("ZodError", $2d641df072b0d964$var$initializer);
const $2d641df072b0d964$export$42f76a3b4eb5449a = $3902e9f6ee6db121$export$3122533d606194de("ZodError", $2d641df072b0d964$var$initializer, {
    Parent: Error
}); // /** @deprecated Use `z.core.$ZodErrorMapCtx` instead. */
 // export type ErrorMapCtx = core.$ZodErrorMapCtx;


const $e2ce915f849d501a$export$98e6a39c04603d36 = /* @__PURE__ */ $160c3afc845a29d6$export$dcd1bb9991b57edf((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$59b6f938fbf579e3 = /* @__PURE__ */ $160c3afc845a29d6$export$1fcca22dc6c780d0((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$b48ee232557adc37 = /* @__PURE__ */ $160c3afc845a29d6$export$5ec32605bf51e98e((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$9b07b0d6e0389261 = /* @__PURE__ */ $160c3afc845a29d6$export$c08c7322f5625faf((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$c564cdbbe6da493 = /* @__PURE__ */ $160c3afc845a29d6$export$50e4445ccc10715b((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$2f872c0f2117be69 = /* @__PURE__ */ $160c3afc845a29d6$export$bb4a21772f43c982((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$1a62660bbffb8f11 = /* @__PURE__ */ $160c3afc845a29d6$export$9954740a1a5eaaf1((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$e4c183687a6ff9b = /* @__PURE__ */ $160c3afc845a29d6$export$74b09e12c8956d91((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$c094f85f253e4d7d = /* @__PURE__ */ $160c3afc845a29d6$export$6d688d774257f486((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$7a47376c130cfeac = /* @__PURE__ */ $160c3afc845a29d6$export$b2ef531a734faad5((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$ed163a34170fecc5 = /* @__PURE__ */ $160c3afc845a29d6$export$fa2ac180d22758d6((0, $2d641df072b0d964$export$42f76a3b4eb5449a));
const $e2ce915f849d501a$export$9f879005292a9bc9 = /* @__PURE__ */ $160c3afc845a29d6$export$f66d2b402dc6318c((0, $2d641df072b0d964$export$42f76a3b4eb5449a));


const $8ad647561ba7dbe6$export$2afb8ab49d4b92c0 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodType", (inst, def)=>{
    $e919c1e0a57df477$export$f43a5c3966de8238.init(inst, def);
    inst.def = def;
    inst.type = def.type;
    Object.defineProperty(inst, "_def", {
        value: def
    });
    // base methods
    inst.check = (...checks)=>{
        return inst.clone({
            ...def,
            checks: [
                ...def.checks ?? [],
                ...checks.map((ch)=>typeof ch === "function" ? {
                        _zod: {
                            check: ch,
                            def: {
                                check: "custom"
                            },
                            onattach: []
                        }
                    } : ch)
            ]
        });
    };
    inst.clone = (def, params)=>$ff926c078a178a32$export$9cd59f9826255e47(inst, def, params);
    inst.brand = ()=>inst;
    inst.register = (reg, meta)=>{
        reg.add(inst, meta);
        return inst;
    };
    // parsing
    inst.parse = (data, params)=>$e2ce915f849d501a$export$98e6a39c04603d36(inst, data, params, {
            callee: inst.parse
        });
    inst.safeParse = (data, params)=>$e2ce915f849d501a$export$b48ee232557adc37(inst, data, params);
    inst.parseAsync = async (data, params)=>$e2ce915f849d501a$export$59b6f938fbf579e3(inst, data, params, {
            callee: inst.parseAsync
        });
    inst.safeParseAsync = async (data, params)=>$e2ce915f849d501a$export$9b07b0d6e0389261(inst, data, params);
    inst.spa = inst.safeParseAsync;
    // encoding/decoding
    inst.encode = (data, params)=>$e2ce915f849d501a$export$c564cdbbe6da493(inst, data, params);
    inst.decode = (data, params)=>$e2ce915f849d501a$export$2f872c0f2117be69(inst, data, params);
    inst.encodeAsync = async (data, params)=>$e2ce915f849d501a$export$1a62660bbffb8f11(inst, data, params);
    inst.decodeAsync = async (data, params)=>$e2ce915f849d501a$export$e4c183687a6ff9b(inst, data, params);
    inst.safeEncode = (data, params)=>$e2ce915f849d501a$export$c094f85f253e4d7d(inst, data, params);
    inst.safeDecode = (data, params)=>$e2ce915f849d501a$export$7a47376c130cfeac(inst, data, params);
    inst.safeEncodeAsync = async (data, params)=>$e2ce915f849d501a$export$ed163a34170fecc5(inst, data, params);
    inst.safeDecodeAsync = async (data, params)=>$e2ce915f849d501a$export$9f879005292a9bc9(inst, data, params);
    // refinements
    inst.refine = (check, params)=>inst.check($8ad647561ba7dbe6$export$edc9d475108b3212(check, params));
    inst.superRefine = (refinement)=>inst.check($8ad647561ba7dbe6$export$e0f31df04c32a6bf(refinement));
    inst.overwrite = (fn)=>inst.check($b93bb84d2922cb59$export$aeea8f004f34f8c2(fn));
    // wrappers
    inst.optional = ()=>$8ad647561ba7dbe6$export$516e28dec6a4b6d4(inst);
    inst.nullable = ()=>$8ad647561ba7dbe6$export$133fc36489ac9add(inst);
    inst.nullish = ()=>$8ad647561ba7dbe6$export$516e28dec6a4b6d4($8ad647561ba7dbe6$export$133fc36489ac9add(inst));
    inst.nonoptional = (params)=>$8ad647561ba7dbe6$export$e6aa51fdda6cd70d(inst, params);
    inst.array = ()=>$8ad647561ba7dbe6$export$2f23118c22fb2630(inst);
    inst.or = (arg)=>$8ad647561ba7dbe6$export$971dd5b0dfd021b6([
            inst,
            arg
        ]);
    inst.and = (arg)=>$8ad647561ba7dbe6$export$bc86dfbf7795668c(inst, arg);
    inst.transform = (tx)=>$8ad647561ba7dbe6$export$a4627e546088548d(inst, $8ad647561ba7dbe6$export$51186ad6e864892a(tx));
    inst.default = (def)=>$8ad647561ba7dbe6$export$d4b0f68d0d916971(inst, def);
    inst.prefault = (def)=>$8ad647561ba7dbe6$export$569da376ae266d0a(inst, def);
    // inst.coalesce = (def, params) => coalesce(inst, def, params);
    inst.catch = (params)=>$8ad647561ba7dbe6$export$e1d4808a6ac94c4c(inst, params);
    inst.pipe = (target)=>$8ad647561ba7dbe6$export$a4627e546088548d(inst, target);
    inst.readonly = ()=>$8ad647561ba7dbe6$export$6ec456bd5b7b3c51(inst);
    // meta
    inst.describe = (description)=>{
        const cl = inst.clone();
        $e68fe56b6c2caecc$export$bc58ce2776ecdb6f.add(cl, {
            description: description
        });
        return cl;
    };
    Object.defineProperty(inst, "description", {
        get () {
            return $e68fe56b6c2caecc$export$bc58ce2776ecdb6f.get(inst)?.description;
        },
        configurable: true
    });
    inst.meta = (...args)=>{
        if (args.length === 0) return $e68fe56b6c2caecc$export$bc58ce2776ecdb6f.get(inst);
        const cl = inst.clone();
        $e68fe56b6c2caecc$export$bc58ce2776ecdb6f.add(cl, args[0]);
        return cl;
    };
    // helpers
    inst.isOptional = ()=>inst.safeParse(undefined).success;
    inst.isNullable = ()=>inst.safeParse(null).success;
    return inst;
});
const $8ad647561ba7dbe6$export$f6d83ce3dacef2be = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("_ZodString", (inst, def)=>{
    $e919c1e0a57df477$export$4342b4432d7b1471.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    const bag = inst._zod.bag;
    inst.format = bag.format ?? null;
    inst.minLength = bag.minimum ?? null;
    inst.maxLength = bag.maximum ?? null;
    // validations
    inst.regex = (...args)=>inst.check($b93bb84d2922cb59$export$c4768a1bd8f8393(...args));
    inst.includes = (...args)=>inst.check($b93bb84d2922cb59$export$fccf016a6caa651d(...args));
    inst.startsWith = (...args)=>inst.check($b93bb84d2922cb59$export$2f37aaf99060de76(...args));
    inst.endsWith = (...args)=>inst.check($b93bb84d2922cb59$export$eaeaa2fcd833167e(...args));
    inst.min = (...args)=>inst.check($b93bb84d2922cb59$export$21f6711a906c1450(...args));
    inst.max = (...args)=>inst.check($b93bb84d2922cb59$export$ec76627108655a22(...args));
    inst.length = (...args)=>inst.check($b93bb84d2922cb59$export$620b9f7ab17ff8a9(...args));
    inst.nonempty = (...args)=>inst.check($b93bb84d2922cb59$export$21f6711a906c1450(1, ...args));
    inst.lowercase = (params)=>inst.check($b93bb84d2922cb59$export$ea67c3edeec85c63(params));
    inst.uppercase = (params)=>inst.check($b93bb84d2922cb59$export$2998381b41c6902a(params));
    // transforms
    inst.trim = ()=>inst.check($b93bb84d2922cb59$export$8be2de0b60774d1e());
    inst.normalize = (...args)=>inst.check($b93bb84d2922cb59$export$2b99bb23a814f78e(...args));
    inst.toLowerCase = ()=>inst.check($b93bb84d2922cb59$export$d9cfe939403a2525());
    inst.toUpperCase = ()=>inst.check($b93bb84d2922cb59$export$cf76ef1ae9e9944e());
});
const $8ad647561ba7dbe6$export$1230eb29b8d3b502 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodString", (inst, def)=>{
    $e919c1e0a57df477$export$4342b4432d7b1471.init(inst, def);
    $8ad647561ba7dbe6$export$f6d83ce3dacef2be.init(inst, def);
    inst.email = (params)=>inst.check($b93bb84d2922cb59$export$471b39521bec3299($8ad647561ba7dbe6$export$770096fb2a685237, params));
    inst.url = (params)=>inst.check($b93bb84d2922cb59$export$e3f203373341d39($8ad647561ba7dbe6$export$82127fa72e650526, params));
    inst.jwt = (params)=>inst.check($b93bb84d2922cb59$export$4a9318e6b46f1aa1($8ad647561ba7dbe6$export$5c0d807bd77507f, params));
    inst.emoji = (params)=>inst.check($b93bb84d2922cb59$export$936e26d261396f46($8ad647561ba7dbe6$export$f072c1a26a31d55b, params));
    inst.guid = (params)=>inst.check($b93bb84d2922cb59$export$129b5399d64cccb0($8ad647561ba7dbe6$export$2827a6bad660427b, params));
    inst.uuid = (params)=>inst.check($b93bb84d2922cb59$export$f2f3139038bea52c($8ad647561ba7dbe6$export$7ee22ce365e4d3b5, params));
    inst.uuidv4 = (params)=>inst.check($b93bb84d2922cb59$export$a5559d7da37a112f($8ad647561ba7dbe6$export$7ee22ce365e4d3b5, params));
    inst.uuidv6 = (params)=>inst.check($b93bb84d2922cb59$export$53b427a8173231a($8ad647561ba7dbe6$export$7ee22ce365e4d3b5, params));
    inst.uuidv7 = (params)=>inst.check($b93bb84d2922cb59$export$588d23d6e9ec2ed5($8ad647561ba7dbe6$export$7ee22ce365e4d3b5, params));
    inst.nanoid = (params)=>inst.check($b93bb84d2922cb59$export$a030949b19390ea0($8ad647561ba7dbe6$export$9e180e3f910c7773, params));
    inst.guid = (params)=>inst.check($b93bb84d2922cb59$export$129b5399d64cccb0($8ad647561ba7dbe6$export$2827a6bad660427b, params));
    inst.cuid = (params)=>inst.check($b93bb84d2922cb59$export$639125837b796148($8ad647561ba7dbe6$export$c6b7c3c30ab9362e, params));
    inst.cuid2 = (params)=>inst.check($b93bb84d2922cb59$export$36b63ef9af7972c2($8ad647561ba7dbe6$export$536dc9ce9eec8565, params));
    inst.ulid = (params)=>inst.check($b93bb84d2922cb59$export$95acf3b3fa11bdc9($8ad647561ba7dbe6$export$a060914fca5da3d4, params));
    inst.base64 = (params)=>inst.check($b93bb84d2922cb59$export$9fdb09384fbc4988($8ad647561ba7dbe6$export$237b9f5cee85a1c1, params));
    inst.base64url = (params)=>inst.check($b93bb84d2922cb59$export$178c70fb89c949fa($8ad647561ba7dbe6$export$62a2e9135a9e2356, params));
    inst.xid = (params)=>inst.check($b93bb84d2922cb59$export$bbb0a2cfb079fa90($8ad647561ba7dbe6$export$d53bc3b8251fa017, params));
    inst.ksuid = (params)=>inst.check($b93bb84d2922cb59$export$1306ede2f9ea153f($8ad647561ba7dbe6$export$1bbac5f87dca43e4, params));
    inst.ipv4 = (params)=>inst.check($b93bb84d2922cb59$export$c77a1c80cebc2aad($8ad647561ba7dbe6$export$567930edb18e0c3a, params));
    inst.ipv6 = (params)=>inst.check($b93bb84d2922cb59$export$964dfe0e2e4e8895($8ad647561ba7dbe6$export$75c5c5fd479ecddf, params));
    inst.cidrv4 = (params)=>inst.check($b93bb84d2922cb59$export$feaac4e27a421ddc($8ad647561ba7dbe6$export$ac524bc9ec5fac50, params));
    inst.cidrv6 = (params)=>inst.check($b93bb84d2922cb59$export$a0518ffc5273ec92($8ad647561ba7dbe6$export$b8cae7a616378f16, params));
    inst.e164 = (params)=>inst.check($b93bb84d2922cb59$export$b8bf0b70d4bc7855($8ad647561ba7dbe6$export$fac79817565ec0f7, params));
    // iso
    inst.datetime = (params)=>inst.check($fbf271dcc0d8a0ad$export$7ba4466dbd0f07e1(params));
    inst.date = (params)=>inst.check($fbf271dcc0d8a0ad$export$324d90190a8b822a(params));
    inst.time = (params)=>inst.check($fbf271dcc0d8a0ad$export$2da9be4cfdb689b1(params));
    inst.duration = (params)=>inst.check($fbf271dcc0d8a0ad$export$1f34108aa9eb96ab(params));
});
function $8ad647561ba7dbe6$export$22b082955e083ec3(params) {
    return $b93bb84d2922cb59$export$25986a84359f8f7f($8ad647561ba7dbe6$export$1230eb29b8d3b502, params);
}
const $8ad647561ba7dbe6$export$6f00fc81f4be18e5 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodStringFormat", (inst, def)=>{
    $e919c1e0a57df477$export$2d69a0d3057a5c7d.init(inst, def);
    $8ad647561ba7dbe6$export$f6d83ce3dacef2be.init(inst, def);
});
const $8ad647561ba7dbe6$export$770096fb2a685237 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodEmail", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$a3726aadb6108cdc.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$d290fa47940df19d(params) {
    return $b93bb84d2922cb59$export$471b39521bec3299($8ad647561ba7dbe6$export$770096fb2a685237, params);
}
const $8ad647561ba7dbe6$export$2827a6bad660427b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodGUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$4ca4397e3147da59.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$46e8f25c7328f77e(params) {
    return $b93bb84d2922cb59$export$129b5399d64cccb0($8ad647561ba7dbe6$export$2827a6bad660427b, params);
}
const $8ad647561ba7dbe6$export$7ee22ce365e4d3b5 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodUUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$8794aae384e3c177.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$31b40729666a4ae0(params) {
    return $b93bb84d2922cb59$export$f2f3139038bea52c($8ad647561ba7dbe6$export$7ee22ce365e4d3b5, params);
}
function $8ad647561ba7dbe6$export$abe4376e1bf796d6(params) {
    return $b93bb84d2922cb59$export$a5559d7da37a112f($8ad647561ba7dbe6$export$7ee22ce365e4d3b5, params);
}
function $8ad647561ba7dbe6$export$b1fe4fcff87f98e5(params) {
    return $b93bb84d2922cb59$export$53b427a8173231a($8ad647561ba7dbe6$export$7ee22ce365e4d3b5, params);
}
function $8ad647561ba7dbe6$export$a7b512db306b38d7(params) {
    return $b93bb84d2922cb59$export$588d23d6e9ec2ed5($8ad647561ba7dbe6$export$7ee22ce365e4d3b5, params);
}
const $8ad647561ba7dbe6$export$82127fa72e650526 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodURL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$7e12af57cac08b7a.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$128fa18b7194ef(params) {
    return $b93bb84d2922cb59$export$e3f203373341d39($8ad647561ba7dbe6$export$82127fa72e650526, params);
}
function $8ad647561ba7dbe6$export$cddedb4cb7866be8(params) {
    return $b93bb84d2922cb59$export$e3f203373341d39($8ad647561ba7dbe6$export$82127fa72e650526, {
        protocol: /^https?$/,
        hostname: $adf26e260fc47ffe$exports.domain,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$f072c1a26a31d55b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodEmoji", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$154cd448b85bb5a3.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$a19185d1233fc4b2(params) {
    return $b93bb84d2922cb59$export$936e26d261396f46($8ad647561ba7dbe6$export$f072c1a26a31d55b, params);
}
const $8ad647561ba7dbe6$export$9e180e3f910c7773 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodNanoID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$5a160d28c6d62c88.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$ac4959f4f1338dfc(params) {
    return $b93bb84d2922cb59$export$a030949b19390ea0($8ad647561ba7dbe6$export$9e180e3f910c7773, params);
}
const $8ad647561ba7dbe6$export$c6b7c3c30ab9362e = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodCUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$f4f84bd3c6706e60.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$e057ec210c7d3443(params) {
    return $b93bb84d2922cb59$export$639125837b796148($8ad647561ba7dbe6$export$c6b7c3c30ab9362e, params);
}
const $8ad647561ba7dbe6$export$536dc9ce9eec8565 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodCUID2", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$faf1483c11362df6.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$af5866a6cccce9f0(params) {
    return $b93bb84d2922cb59$export$36b63ef9af7972c2($8ad647561ba7dbe6$export$536dc9ce9eec8565, params);
}
const $8ad647561ba7dbe6$export$a060914fca5da3d4 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodULID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$c5788701f4f55294.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$c34778236461ea95(params) {
    return $b93bb84d2922cb59$export$95acf3b3fa11bdc9($8ad647561ba7dbe6$export$a060914fca5da3d4, params);
}
const $8ad647561ba7dbe6$export$d53bc3b8251fa017 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodXID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$e721fd3317199b85.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$5eecaf20006cb6cb(params) {
    return $b93bb84d2922cb59$export$bbb0a2cfb079fa90($8ad647561ba7dbe6$export$d53bc3b8251fa017, params);
}
const $8ad647561ba7dbe6$export$1bbac5f87dca43e4 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodKSUID", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$baa9849ea82bee6e.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$f49b11deeb9beb0f(params) {
    return $b93bb84d2922cb59$export$1306ede2f9ea153f($8ad647561ba7dbe6$export$1bbac5f87dca43e4, params);
}
const $8ad647561ba7dbe6$export$567930edb18e0c3a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodIPv4", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$93fc833bbf7ceb99.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$291a17a16047f284(params) {
    return $b93bb84d2922cb59$export$c77a1c80cebc2aad($8ad647561ba7dbe6$export$567930edb18e0c3a, params);
}
const $8ad647561ba7dbe6$export$75c5c5fd479ecddf = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodIPv6", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$8c939a460418a1bf.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$4e0c86a59c658526(params) {
    return $b93bb84d2922cb59$export$964dfe0e2e4e8895($8ad647561ba7dbe6$export$75c5c5fd479ecddf, params);
}
const $8ad647561ba7dbe6$export$ac524bc9ec5fac50 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodCIDRv4", (inst, def)=>{
    $e919c1e0a57df477$export$e164feaf5ae5296b.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$fc96793d9715e5a1(params) {
    return $b93bb84d2922cb59$export$feaac4e27a421ddc($8ad647561ba7dbe6$export$ac524bc9ec5fac50, params);
}
const $8ad647561ba7dbe6$export$b8cae7a616378f16 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodCIDRv6", (inst, def)=>{
    $e919c1e0a57df477$export$3c3aacb740759234.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$b6e650831cac87fb(params) {
    return $b93bb84d2922cb59$export$a0518ffc5273ec92($8ad647561ba7dbe6$export$b8cae7a616378f16, params);
}
const $8ad647561ba7dbe6$export$237b9f5cee85a1c1 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodBase64", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$d7d4932079e2113d.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$b3b2de96497acc47(params) {
    return $b93bb84d2922cb59$export$9fdb09384fbc4988($8ad647561ba7dbe6$export$237b9f5cee85a1c1, params);
}
const $8ad647561ba7dbe6$export$62a2e9135a9e2356 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodBase64URL", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$f5c3c3bbec012fa6.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$7d21597c7bc64465(params) {
    return $b93bb84d2922cb59$export$178c70fb89c949fa($8ad647561ba7dbe6$export$62a2e9135a9e2356, params);
}
const $8ad647561ba7dbe6$export$fac79817565ec0f7 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodE164", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$46d3507e8483217.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$2fa5ed24c9ef198e(params) {
    return $b93bb84d2922cb59$export$b8bf0b70d4bc7855($8ad647561ba7dbe6$export$fac79817565ec0f7, params);
}
const $8ad647561ba7dbe6$export$5c0d807bd77507f = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodJWT", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$f515616cf0cda103.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$6b49f0d0c2777fe9(params) {
    return $b93bb84d2922cb59$export$4a9318e6b46f1aa1($8ad647561ba7dbe6$export$5c0d807bd77507f, params);
}
const $8ad647561ba7dbe6$export$a75d00728843496d = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodCustomStringFormat", (inst, def)=>{
    // ZodStringFormat.init(inst, def);
    $e919c1e0a57df477$export$9dde4397c7b8a192.init(inst, def);
    $8ad647561ba7dbe6$export$6f00fc81f4be18e5.init(inst, def);
});
function $8ad647561ba7dbe6$export$80ce5102b3890b72(format, fnOrRegex, _params = {}) {
    return $b93bb84d2922cb59$export$e25dde89ba546b88($8ad647561ba7dbe6$export$a75d00728843496d, format, fnOrRegex, _params);
}
function $8ad647561ba7dbe6$export$640106f6dc7d2706(_params) {
    return $b93bb84d2922cb59$export$e25dde89ba546b88($8ad647561ba7dbe6$export$a75d00728843496d, "hostname", $adf26e260fc47ffe$exports.hostname, _params);
}
function $8ad647561ba7dbe6$export$834dfc94dde4b3d8(_params) {
    return $b93bb84d2922cb59$export$e25dde89ba546b88($8ad647561ba7dbe6$export$a75d00728843496d, "hex", $adf26e260fc47ffe$exports.hex, _params);
}
function $8ad647561ba7dbe6$export$d6af199866bfb566(alg, params) {
    const enc = params?.enc ?? "hex";
    const format = `${alg}_${enc}`;
    const regex = $adf26e260fc47ffe$exports[format];
    if (!regex) throw new Error(`Unrecognized hash format: ${format}`);
    return $b93bb84d2922cb59$export$e25dde89ba546b88($8ad647561ba7dbe6$export$a75d00728843496d, format, regex, params);
}
const $8ad647561ba7dbe6$export$5b070a55c0c43e09 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodNumber", (inst, def)=>{
    $e919c1e0a57df477$export$b7292ed81eaafd49.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.gt = (value, params)=>inst.check($b93bb84d2922cb59$export$7582466e3ab4d25b(value, params));
    inst.gte = (value, params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(value, params));
    inst.lt = (value, params)=>inst.check($b93bb84d2922cb59$export$2a42c74e76a068a(value, params));
    inst.lte = (value, params)=>inst.check($b93bb84d2922cb59$export$7a060cf3d60b84a6(value, params));
    inst.max = (value, params)=>inst.check($b93bb84d2922cb59$export$7a060cf3d60b84a6(value, params));
    inst.int = (params)=>inst.check($8ad647561ba7dbe6$export$7d260a2a5f8bc19e(params));
    inst.safe = (params)=>inst.check($8ad647561ba7dbe6$export$7d260a2a5f8bc19e(params));
    inst.positive = (params)=>inst.check($b93bb84d2922cb59$export$7582466e3ab4d25b(0, params));
    inst.nonnegative = (params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(0, params));
    inst.negative = (params)=>inst.check($b93bb84d2922cb59$export$2a42c74e76a068a(0, params));
    inst.nonpositive = (params)=>inst.check($b93bb84d2922cb59$export$7a060cf3d60b84a6(0, params));
    inst.multipleOf = (value, params)=>inst.check($b93bb84d2922cb59$export$c41e40f80e978ab1(value, params));
    inst.step = (value, params)=>inst.check($b93bb84d2922cb59$export$c41e40f80e978ab1(value, params));
    // inst.finite = (params) => inst.check(core.finite(params));
    inst.finite = ()=>inst;
    const bag = inst._zod.bag;
    inst.minValue = Math.max(bag.minimum ?? Number.NEGATIVE_INFINITY, bag.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null;
    inst.maxValue = Math.min(bag.maximum ?? Number.POSITIVE_INFINITY, bag.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null;
    inst.isInt = (bag.format ?? "").includes("int") || Number.isSafeInteger(bag.multipleOf ?? 0.5);
    inst.isFinite = true;
    inst.format = bag.format ?? null;
});
function $8ad647561ba7dbe6$export$98e628dec113755e(params) {
    return $b93bb84d2922cb59$export$9249bb0b45639623($8ad647561ba7dbe6$export$5b070a55c0c43e09, params);
}
const $8ad647561ba7dbe6$export$1d835e7a0f492f73 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodNumberFormat", (inst, def)=>{
    $e919c1e0a57df477$export$2cfebe79b769ec9.init(inst, def);
    $8ad647561ba7dbe6$export$5b070a55c0c43e09.init(inst, def);
});
function $8ad647561ba7dbe6$export$7d260a2a5f8bc19e(params) {
    return $b93bb84d2922cb59$export$3d5b343b1f51efdd($8ad647561ba7dbe6$export$1d835e7a0f492f73, params);
}
function $8ad647561ba7dbe6$export$1a4bac2aea11f30e(params) {
    return $b93bb84d2922cb59$export$656ad65d6cf64174($8ad647561ba7dbe6$export$1d835e7a0f492f73, params);
}
function $8ad647561ba7dbe6$export$76f82835c9736f87(params) {
    return $b93bb84d2922cb59$export$9ddff8176107cc11($8ad647561ba7dbe6$export$1d835e7a0f492f73, params);
}
function $8ad647561ba7dbe6$export$1d95835383bb05a(params) {
    return $b93bb84d2922cb59$export$5ec965fd114a2f9f($8ad647561ba7dbe6$export$1d835e7a0f492f73, params);
}
function $8ad647561ba7dbe6$export$de9ffb9418dd7d0d(params) {
    return $b93bb84d2922cb59$export$a43c28c6e86e066e($8ad647561ba7dbe6$export$1d835e7a0f492f73, params);
}
const $8ad647561ba7dbe6$export$723d146f80596191 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodBoolean", (inst, def)=>{
    $e919c1e0a57df477$export$828bf41e557d7dda.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$4a21f16c33752377(params) {
    return $b93bb84d2922cb59$export$e23c41ce5ce2db39($8ad647561ba7dbe6$export$723d146f80596191, params);
}
const $8ad647561ba7dbe6$export$67d741fd70ff98f4 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodBigInt", (inst, def)=>{
    $e919c1e0a57df477$export$7600843f2a3baa73.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.gte = (value, params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(value, params));
    inst.gt = (value, params)=>inst.check($b93bb84d2922cb59$export$7582466e3ab4d25b(value, params));
    inst.gte = (value, params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(value, params));
    inst.min = (value, params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(value, params));
    inst.lt = (value, params)=>inst.check($b93bb84d2922cb59$export$2a42c74e76a068a(value, params));
    inst.lte = (value, params)=>inst.check($b93bb84d2922cb59$export$7a060cf3d60b84a6(value, params));
    inst.max = (value, params)=>inst.check($b93bb84d2922cb59$export$7a060cf3d60b84a6(value, params));
    inst.positive = (params)=>inst.check($b93bb84d2922cb59$export$7582466e3ab4d25b(BigInt(0), params));
    inst.negative = (params)=>inst.check($b93bb84d2922cb59$export$2a42c74e76a068a(BigInt(0), params));
    inst.nonpositive = (params)=>inst.check($b93bb84d2922cb59$export$7a060cf3d60b84a6(BigInt(0), params));
    inst.nonnegative = (params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(BigInt(0), params));
    inst.multipleOf = (value, params)=>inst.check($b93bb84d2922cb59$export$c41e40f80e978ab1(value, params));
    const bag = inst._zod.bag;
    inst.minValue = bag.minimum ?? null;
    inst.maxValue = bag.maximum ?? null;
    inst.format = bag.format ?? null;
});
function $8ad647561ba7dbe6$export$a0f65b52274bcc00(params) {
    return $b93bb84d2922cb59$export$c96ff33878177e4c($8ad647561ba7dbe6$export$67d741fd70ff98f4, params);
}
const $8ad647561ba7dbe6$export$7483f4dc330f3456 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodBigIntFormat", (inst, def)=>{
    $e919c1e0a57df477$export$487194b75209a5dd.init(inst, def);
    $8ad647561ba7dbe6$export$67d741fd70ff98f4.init(inst, def);
});
function $8ad647561ba7dbe6$export$af207e6076994812(params) {
    return $b93bb84d2922cb59$export$cb7d3ec922804f3f($8ad647561ba7dbe6$export$7483f4dc330f3456, params);
}
function $8ad647561ba7dbe6$export$870002f71f6ee2de(params) {
    return $b93bb84d2922cb59$export$c51606f0dfa0f5a1($8ad647561ba7dbe6$export$7483f4dc330f3456, params);
}
const $8ad647561ba7dbe6$export$bcc3b40f6b638044 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodSymbol", (inst, def)=>{
    $e919c1e0a57df477$export$c9e7e1831bb8dd12.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$8f701197936bc2a6(params) {
    return $b93bb84d2922cb59$export$a8f93f5b7c030e84($8ad647561ba7dbe6$export$bcc3b40f6b638044, params);
}
const $8ad647561ba7dbe6$export$4e780e961c30340d = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodUndefined", (inst, def)=>{
    $e919c1e0a57df477$export$379ccf61f9830869.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$1db45310990710a5(params) {
    return $b93bb84d2922cb59$export$60e4c9fe67803d40($8ad647561ba7dbe6$export$4e780e961c30340d, params);
}
const $8ad647561ba7dbe6$export$a96281f914484f2d = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodNull", (inst, def)=>{
    $e919c1e0a57df477$export$d05db4d7bc9da27d.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$7b1b591b262c240(params) {
    return $b93bb84d2922cb59$export$a2cbb38cda512d16($8ad647561ba7dbe6$export$a96281f914484f2d, params);
}
const $8ad647561ba7dbe6$export$b9d1edb536b4e4eb = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodAny", (inst, def)=>{
    $e919c1e0a57df477$export$de3a83ac65a18f35.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$4154a199d7d90455() {
    return $b93bb84d2922cb59$export$4678886173313220($8ad647561ba7dbe6$export$b9d1edb536b4e4eb);
}
const $8ad647561ba7dbe6$export$ef3b1bb1630977ae = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodUnknown", (inst, def)=>{
    $e919c1e0a57df477$export$37ea092643879ea0.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$19282c40b967aec6() {
    return $b93bb84d2922cb59$export$e0ed508a47e00801($8ad647561ba7dbe6$export$ef3b1bb1630977ae);
}
const $8ad647561ba7dbe6$export$1e576a20c3ce9fb5 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodNever", (inst, def)=>{
    $e919c1e0a57df477$export$4b2a18191b39c3b4.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$b3e22bcfd64c1022(params) {
    return $b93bb84d2922cb59$export$887f43204ffc2a69($8ad647561ba7dbe6$export$1e576a20c3ce9fb5, params);
}
const $8ad647561ba7dbe6$export$7d39f5df85f21031 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodVoid", (inst, def)=>{
    $e919c1e0a57df477$export$6fd82db70787afbb.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$490e536ee7389aeb(params) {
    return $b93bb84d2922cb59$export$9480825d3c8e9ad6($8ad647561ba7dbe6$export$7d39f5df85f21031, params);
}
const $8ad647561ba7dbe6$export$e974be33bdc55521 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodDate", (inst, def)=>{
    $e919c1e0a57df477$export$9a0ab9fbd61629f8.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.min = (value, params)=>inst.check($b93bb84d2922cb59$export$a1c6d8834a3b19c9(value, params));
    inst.max = (value, params)=>inst.check($b93bb84d2922cb59$export$7a060cf3d60b84a6(value, params));
    const c = inst._zod.bag;
    inst.minDate = c.minimum ? new Date(c.minimum) : null;
    inst.maxDate = c.maximum ? new Date(c.maximum) : null;
});
function $8ad647561ba7dbe6$export$324d90190a8b822a(params) {
    return $b93bb84d2922cb59$export$da799735c76175a($8ad647561ba7dbe6$export$e974be33bdc55521, params);
}
const $8ad647561ba7dbe6$export$7acfc3e64785411 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodArray", (inst, def)=>{
    $e919c1e0a57df477$export$fd77bdade7d2292b.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.element = def.element;
    inst.min = (minLength, params)=>inst.check($b93bb84d2922cb59$export$21f6711a906c1450(minLength, params));
    inst.nonempty = (params)=>inst.check($b93bb84d2922cb59$export$21f6711a906c1450(1, params));
    inst.max = (maxLength, params)=>inst.check($b93bb84d2922cb59$export$ec76627108655a22(maxLength, params));
    inst.length = (len, params)=>inst.check($b93bb84d2922cb59$export$620b9f7ab17ff8a9(len, params));
    inst.unwrap = ()=>inst.element;
});
function $8ad647561ba7dbe6$export$2f23118c22fb2630(element, params) {
    return $b93bb84d2922cb59$export$4ea446333e3db634($8ad647561ba7dbe6$export$7acfc3e64785411, element, params);
}
function $8ad647561ba7dbe6$export$7e1278799275f68e(schema) {
    const shape = schema._zod.def.shape;
    return $8ad647561ba7dbe6$export$78a99c8d44d72635(Object.keys(shape));
}
const $8ad647561ba7dbe6$export$736315c5b55efbad = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodObject", (inst, def)=>{
    $e919c1e0a57df477$export$330feb3f8e03c085.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    (0, $ff926c078a178a32$exports).defineLazy(inst, "shape", ()=>def.shape);
    inst.keyof = ()=>$8ad647561ba7dbe6$export$78a99c8d44d72635(Object.keys(inst._zod.def.shape));
    inst.catchall = (catchall)=>inst.clone({
            ...inst._zod.def,
            catchall: catchall
        });
    inst.passthrough = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $8ad647561ba7dbe6$export$19282c40b967aec6()
        });
    inst.loose = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $8ad647561ba7dbe6$export$19282c40b967aec6()
        });
    inst.strict = ()=>inst.clone({
            ...inst._zod.def,
            catchall: $8ad647561ba7dbe6$export$b3e22bcfd64c1022()
        });
    inst.strip = ()=>inst.clone({
            ...inst._zod.def,
            catchall: undefined
        });
    inst.extend = (incoming)=>{
        return (0, $ff926c078a178a32$exports).extend(inst, incoming);
    };
    inst.safeExtend = (incoming)=>{
        return (0, $ff926c078a178a32$exports).safeExtend(inst, incoming);
    };
    inst.merge = (other)=>(0, $ff926c078a178a32$exports).merge(inst, other);
    inst.pick = (mask)=>(0, $ff926c078a178a32$exports).pick(inst, mask);
    inst.omit = (mask)=>(0, $ff926c078a178a32$exports).omit(inst, mask);
    inst.partial = (...args)=>(0, $ff926c078a178a32$exports).partial($8ad647561ba7dbe6$export$aa56fec1e9d629b8, inst, args[0]);
    inst.required = (...args)=>(0, $ff926c078a178a32$exports).required($8ad647561ba7dbe6$export$eb04319818b4702e, inst, args[0]);
});
function $8ad647561ba7dbe6$export$be5493f9613cbbe(shape, params) {
    const def = {
        type: "object",
        get shape () {
            (0, $ff926c078a178a32$exports).assignProp(this, "shape", shape ? (0, $ff926c078a178a32$exports).objectClone(shape) : {});
            return this.shape;
        },
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    };
    return new $8ad647561ba7dbe6$export$736315c5b55efbad(def);
}
function $8ad647561ba7dbe6$export$8fb0df5f40d0b477(shape, params) {
    return new $8ad647561ba7dbe6$export$736315c5b55efbad({
        type: "object",
        get shape () {
            (0, $ff926c078a178a32$exports).assignProp(this, "shape", (0, $ff926c078a178a32$exports).objectClone(shape));
            return this.shape;
        },
        catchall: $8ad647561ba7dbe6$export$b3e22bcfd64c1022(),
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
function $8ad647561ba7dbe6$export$bc233bd5e67eecd(shape, params) {
    return new $8ad647561ba7dbe6$export$736315c5b55efbad({
        type: "object",
        get shape () {
            (0, $ff926c078a178a32$exports).assignProp(this, "shape", (0, $ff926c078a178a32$exports).objectClone(shape));
            return this.shape;
        },
        catchall: $8ad647561ba7dbe6$export$19282c40b967aec6(),
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$a8b236cb5070a311 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodUnion", (inst, def)=>{
    $e919c1e0a57df477$export$37a2350ef0bd638c.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.options = def.options;
});
function $8ad647561ba7dbe6$export$971dd5b0dfd021b6(options, params) {
    return new $8ad647561ba7dbe6$export$a8b236cb5070a311({
        type: "union",
        options: options,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$5ef2424805ac76a3 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodDiscriminatedUnion", (inst, def)=>{
    $8ad647561ba7dbe6$export$a8b236cb5070a311.init(inst, def);
    $e919c1e0a57df477$export$aad4f17edfb83795.init(inst, def);
});
function $8ad647561ba7dbe6$export$4b888e40c4ee26dd(discriminator, options, params) {
    // const [options, params] = args;
    return new $8ad647561ba7dbe6$export$5ef2424805ac76a3({
        type: "union",
        options: options,
        discriminator: discriminator,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$c02deaf0bb5203d4 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodIntersection", (inst, def)=>{
    $e919c1e0a57df477$export$2299250b426aba4b.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$bc86dfbf7795668c(left, right) {
    return new $8ad647561ba7dbe6$export$c02deaf0bb5203d4({
        type: "intersection",
        left: left,
        right: right
    });
}
const $8ad647561ba7dbe6$export$e2a18bb771d8e6a3 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodTuple", (inst, def)=>{
    $e919c1e0a57df477$export$bba1b90a721dbd94.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.rest = (rest)=>inst.clone({
            ...inst._zod.def,
            rest: rest
        });
});
function $8ad647561ba7dbe6$export$65e3907585753458(items, _paramsOrRest, _params) {
    const hasRest = _paramsOrRest instanceof $e919c1e0a57df477$export$f43a5c3966de8238;
    const params = hasRest ? _params : _paramsOrRest;
    const rest = hasRest ? _paramsOrRest : null;
    return new $8ad647561ba7dbe6$export$e2a18bb771d8e6a3({
        type: "tuple",
        items: items,
        rest: rest,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$a2acc09968cb4b7f = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodRecord", (inst, def)=>{
    $e919c1e0a57df477$export$cc20b90ec1a8c208.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function $8ad647561ba7dbe6$export$e5185e241753e543(keyType, valueType, params) {
    return new $8ad647561ba7dbe6$export$a2acc09968cb4b7f({
        type: "record",
        keyType: keyType,
        valueType: valueType,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
function $8ad647561ba7dbe6$export$669401d1edf671b3(keyType, valueType, params) {
    const k = $ff926c078a178a32$export$9cd59f9826255e47(keyType);
    k._zod.values = undefined;
    return new $8ad647561ba7dbe6$export$a2acc09968cb4b7f({
        type: "record",
        keyType: k,
        valueType: valueType,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$163b6a2b712d9542 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodMap", (inst, def)=>{
    $e919c1e0a57df477$export$5ccfd30a7e358409.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.keyType = def.keyType;
    inst.valueType = def.valueType;
});
function $8ad647561ba7dbe6$export$871de8747c9eaa88(keyType, valueType, params) {
    return new $8ad647561ba7dbe6$export$163b6a2b712d9542({
        type: "map",
        keyType: keyType,
        valueType: valueType,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$977057706f816712 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodSet", (inst, def)=>{
    $e919c1e0a57df477$export$20cf27bc33a30268.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.min = (...args)=>inst.check($b93bb84d2922cb59$export$e379713268c2c18a(...args));
    inst.nonempty = (params)=>inst.check($b93bb84d2922cb59$export$e379713268c2c18a(1, params));
    inst.max = (...args)=>inst.check($b93bb84d2922cb59$export$3eed6ccb98bc18db(...args));
    inst.size = (...args)=>inst.check($b93bb84d2922cb59$export$2621565b966a8d23(...args));
});
function $8ad647561ba7dbe6$export$adaa4cf7ef1b65be(valueType, params) {
    return new $8ad647561ba7dbe6$export$977057706f816712({
        type: "set",
        valueType: valueType,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$d325d1f0e1c20179 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodEnum", (inst, def)=>{
    $e919c1e0a57df477$export$31462b6e6c50b618.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.enum = def.entries;
    inst.options = Object.values(def.entries);
    const keys = new Set(Object.keys(def.entries));
    inst.extract = (values, params)=>{
        const newEntries = {};
        for (const value of values){
            if (keys.has(value)) newEntries[value] = def.entries[value];
            else throw new Error(`Key ${value} not found in enum`);
        }
        return new $8ad647561ba7dbe6$export$d325d1f0e1c20179({
            ...def,
            checks: [],
            ...(0, $ff926c078a178a32$exports).normalizeParams(params),
            entries: newEntries
        });
    };
    inst.exclude = (values, params)=>{
        const newEntries = {
            ...def.entries
        };
        for (const value of values){
            if (keys.has(value)) delete newEntries[value];
            else throw new Error(`Key ${value} not found in enum`);
        }
        return new $8ad647561ba7dbe6$export$d325d1f0e1c20179({
            ...def,
            checks: [],
            ...(0, $ff926c078a178a32$exports).normalizeParams(params),
            entries: newEntries
        });
    };
});
function $8ad647561ba7dbe6$export$78a99c8d44d72635(values, params) {
    const entries = Array.isArray(values) ? Object.fromEntries(values.map((v)=>[
            v,
            v
        ])) : values;
    return new $8ad647561ba7dbe6$export$d325d1f0e1c20179({
        type: "enum",
        entries: entries,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
function $8ad647561ba7dbe6$export$6fe7eca19ebe5199(entries, params) {
    return new $8ad647561ba7dbe6$export$d325d1f0e1c20179({
        type: "enum",
        entries: entries,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$7e44096782a165d3 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodLiteral", (inst, def)=>{
    $e919c1e0a57df477$export$86699355265fa258.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.values = new Set(def.values);
    Object.defineProperty(inst, "value", {
        get () {
            if (def.values.length > 1) throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
            return def.values[0];
        }
    });
});
function $8ad647561ba7dbe6$export$c8ec6e1ec9fefcb0(value, params) {
    return new $8ad647561ba7dbe6$export$7e44096782a165d3({
        type: "literal",
        values: Array.isArray(value) ? value : [
            value
        ],
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$1aa10ff06069e07d = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodFile", (inst, def)=>{
    $e919c1e0a57df477$export$1997de0576a81377.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.min = (size, params)=>inst.check($b93bb84d2922cb59$export$e379713268c2c18a(size, params));
    inst.max = (size, params)=>inst.check($b93bb84d2922cb59$export$3eed6ccb98bc18db(size, params));
    inst.mime = (types, params)=>inst.check($b93bb84d2922cb59$export$267177285a1a8b37(Array.isArray(types) ? types : [
            types
        ], params));
});
function $8ad647561ba7dbe6$export$c2a28f090bb0afd6(params) {
    return $b93bb84d2922cb59$export$e335cd0b9f8bab1e($8ad647561ba7dbe6$export$1aa10ff06069e07d, params);
}
const $8ad647561ba7dbe6$export$cf1499e83869147b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodTransform", (inst, def)=>{
    $e919c1e0a57df477$export$14b591f873519189.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst._zod.parse = (payload, _ctx)=>{
        if (_ctx.direction === "backward") throw new $3902e9f6ee6db121$export$a36d4c29b1151bde(inst.constructor.name);
        payload.addIssue = (issue)=>{
            if (typeof issue === "string") payload.issues.push((0, $ff926c078a178a32$exports).issue(issue, payload.value, def));
            else {
                // for Zod 3 backwards compatibility
                const _issue = issue;
                if (_issue.fatal) _issue.continue = false;
                _issue.code ?? (_issue.code = "custom");
                _issue.input ?? (_issue.input = payload.value);
                _issue.inst ?? (_issue.inst = inst);
                // _issue.continue ??= true;
                payload.issues.push((0, $ff926c078a178a32$exports).issue(_issue));
            }
        };
        const output = def.transform(payload.value, payload);
        if (output instanceof Promise) return output.then((output)=>{
            payload.value = output;
            return payload;
        });
        payload.value = output;
        return payload;
    };
});
function $8ad647561ba7dbe6$export$51186ad6e864892a(fn) {
    return new $8ad647561ba7dbe6$export$cf1499e83869147b({
        type: "transform",
        transform: fn
    });
}
const $8ad647561ba7dbe6$export$aa56fec1e9d629b8 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodOptional", (inst, def)=>{
    $e919c1e0a57df477$export$980e9af565c4d7aa.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $8ad647561ba7dbe6$export$516e28dec6a4b6d4(innerType) {
    return new $8ad647561ba7dbe6$export$aa56fec1e9d629b8({
        type: "optional",
        innerType: innerType
    });
}
const $8ad647561ba7dbe6$export$aaac0b8b429cef5 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodNullable", (inst, def)=>{
    $e919c1e0a57df477$export$7994573b6604ec66.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $8ad647561ba7dbe6$export$133fc36489ac9add(innerType) {
    return new $8ad647561ba7dbe6$export$aaac0b8b429cef5({
        type: "nullable",
        innerType: innerType
    });
}
function $8ad647561ba7dbe6$export$69fd1b70ebae5687(innerType) {
    return $8ad647561ba7dbe6$export$516e28dec6a4b6d4($8ad647561ba7dbe6$export$133fc36489ac9add(innerType));
}
const $8ad647561ba7dbe6$export$bb19b37874861e7e = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodDefault", (inst, def)=>{
    $e919c1e0a57df477$export$ae2d21004b7243f7.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeDefault = inst.unwrap;
});
function $8ad647561ba7dbe6$export$d4b0f68d0d916971(innerType, defaultValue) {
    return new $8ad647561ba7dbe6$export$bb19b37874861e7e({
        type: "default",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $ff926c078a178a32$exports).shallowClone(defaultValue);
        }
    });
}
const $8ad647561ba7dbe6$export$b619aec225e4abe9 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodPrefault", (inst, def)=>{
    $e919c1e0a57df477$export$29a8d757258be679.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $8ad647561ba7dbe6$export$569da376ae266d0a(innerType, defaultValue) {
    return new $8ad647561ba7dbe6$export$b619aec225e4abe9({
        type: "prefault",
        innerType: innerType,
        get defaultValue () {
            return typeof defaultValue === "function" ? defaultValue() : (0, $ff926c078a178a32$exports).shallowClone(defaultValue);
        }
    });
}
const $8ad647561ba7dbe6$export$eb04319818b4702e = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodNonOptional", (inst, def)=>{
    $e919c1e0a57df477$export$30ca726c4c50a6d7.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $8ad647561ba7dbe6$export$e6aa51fdda6cd70d(innerType, params) {
    return new $8ad647561ba7dbe6$export$eb04319818b4702e({
        type: "nonoptional",
        innerType: innerType,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$89dfce00a343f317 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodSuccess", (inst, def)=>{
    $e919c1e0a57df477$export$3cc4d03e729326ea.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $8ad647561ba7dbe6$export$fe7c49d056ea1d88(innerType) {
    return new $8ad647561ba7dbe6$export$89dfce00a343f317({
        type: "success",
        innerType: innerType
    });
}
const $8ad647561ba7dbe6$export$75a44ec6249ac76b = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodCatch", (inst, def)=>{
    $e919c1e0a57df477$export$d6f8b228374f6d37.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
    inst.removeCatch = inst.unwrap;
});
function $8ad647561ba7dbe6$export$e1d4808a6ac94c4c(innerType, catchValue) {
    return new $8ad647561ba7dbe6$export$75a44ec6249ac76b({
        type: "catch",
        innerType: innerType,
        catchValue: typeof catchValue === "function" ? catchValue : ()=>catchValue
    });
}
const $8ad647561ba7dbe6$export$26ccfa0145e8511f = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodNaN", (inst, def)=>{
    $e919c1e0a57df477$export$528f71701e6a7aee.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$9e06de0973666692(params) {
    return $b93bb84d2922cb59$export$a5e7e1f8491a5e50($8ad647561ba7dbe6$export$26ccfa0145e8511f, params);
}
const $8ad647561ba7dbe6$export$8c4c5c16b952637a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodPipe", (inst, def)=>{
    $e919c1e0a57df477$export$4cb25cfde430326c.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.in = def.in;
    inst.out = def.out;
});
function $8ad647561ba7dbe6$export$a4627e546088548d(in_, out) {
    return new $8ad647561ba7dbe6$export$8c4c5c16b952637a({
        type: "pipe",
        in: in_,
        out: out
    });
}
const $8ad647561ba7dbe6$export$d2591c20339f7464 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodCodec", (inst, def)=>{
    $8ad647561ba7dbe6$export$8c4c5c16b952637a.init(inst, def);
    $e919c1e0a57df477$export$c622e07db8a40b53.init(inst, def);
});
function $8ad647561ba7dbe6$export$1c37c01eba8ed446(in_, out, params) {
    return new $8ad647561ba7dbe6$export$d2591c20339f7464({
        type: "pipe",
        in: in_,
        out: out,
        transform: params.decode,
        reverseTransform: params.encode
    });
}
const $8ad647561ba7dbe6$export$5d1f7ef05c4e493a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodReadonly", (inst, def)=>{
    $e919c1e0a57df477$export$f9f268f3fbb1601b.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $8ad647561ba7dbe6$export$6ec456bd5b7b3c51(innerType) {
    return new $8ad647561ba7dbe6$export$5d1f7ef05c4e493a({
        type: "readonly",
        innerType: innerType
    });
}
const $8ad647561ba7dbe6$export$e6e9ee3f9fd7fdd9 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodTemplateLiteral", (inst, def)=>{
    $e919c1e0a57df477$export$37ea86c57a77af54.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$859cd210a8f40722(parts, params) {
    return new $8ad647561ba7dbe6$export$e6e9ee3f9fd7fdd9({
        type: "template_literal",
        parts: parts,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
}
const $8ad647561ba7dbe6$export$378d0cfce37406e6 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodLazy", (inst, def)=>{
    $e919c1e0a57df477$export$662fecee2efa1a66.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.getter();
});
function $8ad647561ba7dbe6$export$488013bae63b21da(getter) {
    return new $8ad647561ba7dbe6$export$378d0cfce37406e6({
        type: "lazy",
        getter: getter
    });
}
const $8ad647561ba7dbe6$export$3f196b0127d6e50a = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodPromise", (inst, def)=>{
    $e919c1e0a57df477$export$bdefabff0dd84ca4.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
    inst.unwrap = ()=>inst._zod.def.innerType;
});
function $8ad647561ba7dbe6$export$c957ef27a0ebfd4(innerType) {
    return new $8ad647561ba7dbe6$export$3f196b0127d6e50a({
        type: "promise",
        innerType: innerType
    });
}
const $8ad647561ba7dbe6$export$d4602ba55673f53c = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodFunction", (inst, def)=>{
    $e919c1e0a57df477$export$877c6e9c05ede764.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$6e2aba165ec1f1d9(params) {
    return new $8ad647561ba7dbe6$export$d4602ba55673f53c({
        type: "function",
        input: Array.isArray(params?.input) ? $8ad647561ba7dbe6$export$65e3907585753458(params?.input) : params?.input ?? $8ad647561ba7dbe6$export$2f23118c22fb2630($8ad647561ba7dbe6$export$19282c40b967aec6()),
        output: params?.output ?? $8ad647561ba7dbe6$export$19282c40b967aec6()
    });
}
const $8ad647561ba7dbe6$export$76cf7569fb33e487 = /*@__PURE__*/ $3902e9f6ee6db121$export$3122533d606194de("ZodCustom", (inst, def)=>{
    $e919c1e0a57df477$export$3a5d0e5e098b79ba.init(inst, def);
    $8ad647561ba7dbe6$export$2afb8ab49d4b92c0.init(inst, def);
});
function $8ad647561ba7dbe6$export$35dc45686fc2dbd7(fn) {
    const ch = new $644dcc0398eaee1d$export$c05d9110ef20bb2c({
        check: "custom"
    });
    ch._zod.check = fn;
    return ch;
}
function $8ad647561ba7dbe6$export$4c00f665f0d4b443(fn, _params) {
    return $b93bb84d2922cb59$export$8bfc2ce1398e3071($8ad647561ba7dbe6$export$76cf7569fb33e487, fn ?? (()=>true), _params);
}
function $8ad647561ba7dbe6$export$edc9d475108b3212(fn, _params = {}) {
    return $b93bb84d2922cb59$export$ac822e05051812e1($8ad647561ba7dbe6$export$76cf7569fb33e487, fn, _params);
}
function $8ad647561ba7dbe6$export$e0f31df04c32a6bf(fn) {
    return $b93bb84d2922cb59$export$f2b01ecb843d7ab9(fn);
}
function $8ad647561ba7dbe6$export$3d916e7c22dbd8b5(cls, params = {
    error: `Input not instance of ${cls.name}`
}) {
    const inst = new $8ad647561ba7dbe6$export$76cf7569fb33e487({
        type: "custom",
        check: "custom",
        fn: (data)=>data instanceof cls,
        abort: true,
        ...(0, $ff926c078a178a32$exports).normalizeParams(params)
    });
    inst._zod.bag.Class = cls;
    return inst;
}
const $8ad647561ba7dbe6$export$c1250768cb298588 = (...args)=>$b93bb84d2922cb59$export$a75528509e3a7006({
        Codec: $8ad647561ba7dbe6$export$d2591c20339f7464,
        Boolean: $8ad647561ba7dbe6$export$723d146f80596191,
        String: $8ad647561ba7dbe6$export$1230eb29b8d3b502
    }, ...args);
function $8ad647561ba7dbe6$export$7b419323e6ed4f31(params) {
    const jsonSchema = $8ad647561ba7dbe6$export$488013bae63b21da(()=>{
        return $8ad647561ba7dbe6$export$971dd5b0dfd021b6([
            $8ad647561ba7dbe6$export$22b082955e083ec3(params),
            $8ad647561ba7dbe6$export$98e628dec113755e(),
            $8ad647561ba7dbe6$export$4a21f16c33752377(),
            $8ad647561ba7dbe6$export$7b1b591b262c240(),
            $8ad647561ba7dbe6$export$2f23118c22fb2630(jsonSchema),
            $8ad647561ba7dbe6$export$e5185e241753e543($8ad647561ba7dbe6$export$22b082955e083ec3(), jsonSchema)
        ]);
    });
    return jsonSchema;
}
function $8ad647561ba7dbe6$export$fc37fe19dfda43ee(fn, schema) {
    return $8ad647561ba7dbe6$export$a4627e546088548d($8ad647561ba7dbe6$export$51186ad6e864892a(fn), schema);
}


var $37be088548bec045$export$a71624947af1f122 = /*#__PURE__*/ function(FETCH_ERROR) {
    FETCH_ERROR["UNAUTHORIZED"] = "unauthorized";
    return FETCH_ERROR;
}({});



var $baslc = parcelRequire("baslc");

const $db460ec523d03a1f$export$4deb8271613f9a04 = $8ad647561ba7dbe6$export$78a99c8d44d72635([
    "en",
    "sv"
]);



function $c4ca4a382efaa136$export$649085c284c9b129(data, field) {
    return field.split(".").reduce((acc, curr)=>{
        if (acc == null) return undefined;
        return acc[curr];
    }, data);
}


const $71cfbd958b321b74$var$valueAtPathSchema = $8ad647561ba7dbe6$export$971dd5b0dfd021b6([
    $8ad647561ba7dbe6$export$22b082955e083ec3(),
    $8ad647561ba7dbe6$export$65e3907585753458([
        $8ad647561ba7dbe6$export$22b082955e083ec3(),
        $8ad647561ba7dbe6$export$e5185e241753e543($8ad647561ba7dbe6$export$22b082955e083ec3(), $8ad647561ba7dbe6$export$22b082955e083ec3())
    ])
]).optional();
function $71cfbd958b321b74$export$96821b152ac0bcb4(locale, path, options = {}) {
    let defaultValue;
    if (typeof options === "string") defaultValue = options;
    else if (typeof options === "object" && "defaultValue" in options) defaultValue = options.defaultValue;
    let keys;
    if (typeof options === "object") {
        if ("keys" in options && typeof options.keys === "object") keys = options.keys;
        else if (typeof options === "object" && !("keys" in options) && !("defaultValue" in options)) keys = options;
    }
    return $71cfbd958b321b74$var$getLocaleValue(locale, path, {
        ...defaultValue && {
            defaultValue: defaultValue
        },
        ...keys && {
            keys: keys
        }
    });
}
function $71cfbd958b321b74$var$getLocaleValue(locale, path, { defaultValue: defaultValue, previousPaths: previousPaths = [], keys: keys = {} } = {}) {
    const valueAtPath = $71cfbd958b321b74$var$valueAtPathSchema.parse((0, $c4ca4a382efaa136$export$649085c284c9b129)(locale, path));
    if (!valueAtPath) {
        if (defaultValue) return defaultValue;
        return path;
    }
    let value = typeof valueAtPath === "string" ? valueAtPath : valueAtPath[0];
    // Get all keys from the value and append to provided keys
    if (valueAtPath instanceof Array) {
        value = valueAtPath[0];
        for (const [key, value] of Object.entries(valueAtPath[1]))keys = {
            ...keys,
            [key]: value
        };
    }
    const matchKeys = value.match(/{[a-zA-Z0-9]+}/g);
    if (matchKeys !== null) for (const key of Object.keys(keys))value = value.replace(new RegExp(`{${key}}`, "g"), keys[key] ?? "");
    const matchPlaceholders = value.match(/:[a-zA-Z0-9.]+(\{[a-zA-Z0-9.:,]+\})?(\[[a-zA-Z0-9]+\])?/g);
    if (matchPlaceholders !== null) {
        if (previousPaths.includes(path)) throw new Error(`Circular reference detected for path: ${path}`);
        previousPaths = [
            ...previousPaths,
            path
        ];
        for (const placeholder of matchPlaceholders){
            const matchPlaceholder = placeholder.match(/(:[a-zA-Z0-9.]+)(?:\{([a-zA-Z0-9.:,]+)\})?(?:\[([a-zA-Z0-9]+)\])?/);
            const allMatches = matchPlaceholder?.[0];
            const placeholderValue = matchPlaceholder?.[1];
            //const placeholderKeys = matchPlaceholder?.[2];
            const placeholderModifier = matchPlaceholder?.[3];
            if (!allMatches || !placeholderValue) continue;
            let keyValue = $71cfbd958b321b74$var$getLocaleValue(locale, placeholderValue.slice(1), {
                previousPaths: previousPaths,
                keys: keys
            });
            if (placeholderModifier) keyValue = $71cfbd958b321b74$var$applyModifier(keyValue, placeholderModifier);
            value = value.replace(allMatches, keyValue);
        }
    }
    return value;
}
function $71cfbd958b321b74$var$applyModifier(value, modifier) {
    switch(modifier){
        case "lowercase":
            return value.toLowerCase();
        case "uppercase":
            return value.toUpperCase();
        case "capitalize":
            return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        default:
            return value;
    }
}


var $013da61274bf5d05$exports = {};
'use strict';
var $632bc0ecd5cb58e4$exports = {};

$parcel$export($632bc0ecd5cb58e4$exports, "createStore", () => $632bc0ecd5cb58e4$export$f51a9068ac82ea43, (v) => $632bc0ecd5cb58e4$export$f51a9068ac82ea43 = v);
var $632bc0ecd5cb58e4$export$f51a9068ac82ea43;
'use strict';
const $632bc0ecd5cb58e4$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $632bc0ecd5cb58e4$var$createStore = (createState)=>createState ? $632bc0ecd5cb58e4$var$createStoreImpl(createState) : $632bc0ecd5cb58e4$var$createStoreImpl;
$632bc0ecd5cb58e4$export$f51a9068ac82ea43 = $632bc0ecd5cb58e4$var$createStore;


var $44196f50a1fc9f49$exports = {};

$parcel$export($44196f50a1fc9f49$exports, "create", () => $44196f50a1fc9f49$export$185802fd694ee1f5, (v) => $44196f50a1fc9f49$export$185802fd694ee1f5 = v);
$parcel$export($44196f50a1fc9f49$exports, "useStore", () => $44196f50a1fc9f49$export$6ccbb43953eebf8, (v) => $44196f50a1fc9f49$export$6ccbb43953eebf8 = v);
var $44196f50a1fc9f49$export$185802fd694ee1f5;
var $44196f50a1fc9f49$export$6ccbb43953eebf8;
'use strict';

var $baslc = parcelRequire("baslc");

const $44196f50a1fc9f49$var$identity = (arg)=>arg;
function $44196f50a1fc9f49$var$useStore(api, selector = $44196f50a1fc9f49$var$identity) {
    const slice = $baslc.useSyncExternalStore(api.subscribe, $baslc.useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), $baslc.useCallback(()=>selector(api.getInitialState()), [
        api,
        selector
    ]));
    $baslc.useDebugValue(slice);
    return slice;
}
const $44196f50a1fc9f49$var$createImpl = (createState)=>{
    const api = $632bc0ecd5cb58e4$export$f51a9068ac82ea43(createState);
    const useBoundStore = (selector)=>$44196f50a1fc9f49$var$useStore(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $44196f50a1fc9f49$var$create = (createState)=>createState ? $44196f50a1fc9f49$var$createImpl(createState) : $44196f50a1fc9f49$var$createImpl;
$44196f50a1fc9f49$export$185802fd694ee1f5 = $44196f50a1fc9f49$var$create;
$44196f50a1fc9f49$export$6ccbb43953eebf8 = $44196f50a1fc9f49$var$useStore;


Object.keys($632bc0ecd5cb58e4$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($013da61274bf5d05$exports, k)) Object.defineProperty($013da61274bf5d05$exports, k, {
        enumerable: true,
        get: function() {
            return $632bc0ecd5cb58e4$exports[k];
        }
    });
});
Object.keys($44196f50a1fc9f49$exports).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call($013da61274bf5d05$exports, k)) Object.defineProperty($013da61274bf5d05$exports, k, {
        enumerable: true,
        get: function() {
            return $44196f50a1fc9f49$exports[k];
        }
    });
});


var $ed8a2fc5bbccb9d6$export$2e2bcd8739ae039 = {
    title: "Companies",
    locale: {
        english: "English",
        swedish: "Swedish"
    },
    home: {
        home: "Home",
        welcome: "Welcome to Companies"
    },
    time: {
        time: "Time",
        project: "Project",
        task: "Task",
        description: "Description",
        startTime: "Start time",
        endTime: "End time",
        total: "Total",
        today: "Today",
        start: "Start",
        stop: "Stop",
        edit: "Edit",
        delete: "Delete",
        add: "Add time",
        submit: "Save",
        noTimes: "No times for this date.",
        confirmDelete: "Are you sure you want to delete this time entry?",
        confirmStartDifferentDay: "Start time is not on the same day as the date. Are you sure you want to proceed?"
    },
    report: {
        report: "Report"
    },
    login: {
        login: "login",
        title: "Logga in",
        email: "Email",
        password: "Password",
        submit: "Login",
        error: "Login failed. Please try again"
    },
    logout: "Logout",
    confirmation: "Are you sure?",
    yes: "Yes",
    no: "No",
    ok: "OK",
    cancel: "Cancel",
    loading: "Loading...",
    error: {
        code: {
            title: "Server responded with error",
            message: "The following error occurred: {error}"
        }
    }
};


var $891ad4a622e66aac$export$2e2bcd8739ae039 = {
    title: "Companies",
    locale: {
        english: "Engelska",
        swedish: "Svenska"
    },
    home: {
        home: "Hem",
        welcome: "V\xe4lkommen till Companies"
    },
    time: {
        time: "Tid",
        project: "Projekt",
        task: "Uppgift",
        description: "Beskrivning",
        startTime: "Starttid",
        endTime: "Sluttid",
        total: "Totalt",
        today: "Idag",
        start: "Start",
        stop: "Stop",
        edit: "Redigera",
        delete: "Radera",
        add: "L\xe4gg till tid",
        submit: "Spara",
        noTimes: "Inga tider f\xf6r detta datum.",
        confirmDelete: "\xc4r du s\xe4ker p\xe5 att du vill radera denna tidsregistrering?",
        confirmStartDifferentDay: "Starttiden \xe4r inte p\xe5 samma dag som datumet. \xc4r du s\xe4ker p\xe5 att du vill forts\xe4tta?"
    },
    report: {
        report: "Rapport"
    },
    login: {
        login: "logga in",
        title: "Logga in",
        email: "E-postadress",
        password: "l\xf6senord",
        submit: "Logga in",
        error: "Inloggning misslyckades. F\xf6rs\xf6k igen"
    },
    logout: "Logga ut",
    confirmation: "\xc4r du s\xe4ker?",
    yes: "Ja",
    no: "Nej",
    ok: "OK",
    cancel: "Avbryt",
    loading: "L\xe4ser in...",
    error: {
        code: {
            title: "Server responded with error",
            message: "The following error occurred: {error}"
        }
    }
};


function $911cd2935e9d5127$export$f92dfeb71e9bb569(key, schema, defaultValue) {
    const item = localStorage.getItem(key);
    if (item === null) return defaultValue;
    return schema.parse(JSON.parse(item));
}
function $911cd2935e9d5127$export$8a8216c44337cd5(key, value) {
    return localStorage.setItem(key, JSON.stringify(value));
}
function $911cd2935e9d5127$export$fe2d9b4e03920b4c(key) {
    return localStorage.removeItem(key);
}


const $eaf53d8fc6d3f278$var$locales = {
    en: $ed8a2fc5bbccb9d6$export$2e2bcd8739ae039,
    sv: $891ad4a622e66aac$export$2e2bcd8739ae039
};
const $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7 = (0, $013da61274bf5d05$exports.create)((set, get)=>{
    const currentLanguage = (0, $911cd2935e9d5127$export$f92dfeb71e9bb569)("current-language", (0, $db460ec523d03a1f$export$4deb8271613f9a04), "en");
    const getLocaleName = (language)=>{
        switch(language){
            case "sv":
                return "sv-SE";
            case "en":
            default:
                return "en-US";
        }
    };
    return {
        locale: $eaf53d8fc6d3f278$var$locales[currentLanguage],
        currentLanguage: currentLanguage,
        currentLocaleName: getLocaleName(currentLanguage),
        setLocale: (locale)=>{
            (0, $911cd2935e9d5127$export$8a8216c44337cd5)("current-language", locale);
            set({
                currentLanguage: locale,
                locale: $eaf53d8fc6d3f278$var$locales[locale],
                currentLocaleName: getLocaleName(locale)
            });
        },
        get: (path, options = {})=>{
            const { currentLanguage: currentLanguage } = get();
            return (0, $71cfbd958b321b74$export$96821b152ac0bcb4)($eaf53d8fc6d3f278$var$locales[currentLanguage], path, options);
        }
    };
});


function $e0f39c23c3c9ecf4$export$da6ac23acb078b0d() {
    const { locale: t, get: getLocale } = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state);
    const [isOpen, setIsOpen] = (0, $baslc.useState)(false);
    const [header, setHeader] = (0, $baslc.useState)("");
    const [message, setMessage] = (0, $baslc.useState)("");
    return {
        isOpen: isOpen,
        header: header,
        message: message,
        setIsOpen: setIsOpen,
        open: ({ code: code, message: message, info: info })=>{
            if (message && info) {
                setHeader(message);
                setMessage(info);
                return;
            }
            if (message) {
                setHeader(t.error.code.title);
                setMessage(message);
                return;
            }
            setHeader(t.error.code.title);
            setMessage(getLocale("error.code.message", {
                error: code
            }));
            return;
        }
    };
}



var $11cd73f86c2a91d7$export$1be1fc439b849fdf;
var $11cd73f86c2a91d7$export$95a3b7b12ab518f9;
var $11cd73f86c2a91d7$export$6922d3b3a607469e;
var $11cd73f86c2a91d7$export$9a6132153fba2e0;
var $11cd73f86c2a91d7$export$4feba8a1bc8e9afd;
var $11cd73f86c2a91d7$export$5c593627aef9f076;
'use strict';
const $11cd73f86c2a91d7$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...args)=>api.dispatch(...args),
            ...initial
        };
    };
const $11cd73f86c2a91d7$var$redux = $11cd73f86c2a91d7$var$reduxImpl;
const $11cd73f86c2a91d7$var$trackedConnections = /* @__PURE__ */ new Map();
const $11cd73f86c2a91d7$var$getTrackedConnectionState = (name)=>{
    const api = $11cd73f86c2a91d7$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $11cd73f86c2a91d7$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $11cd73f86c2a91d7$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $11cd73f86c2a91d7$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $11cd73f86c2a91d7$var$removeStoreFromTrackedConnections = (name, store)=>{
    if (store === void 0) return;
    const connectionInfo = $11cd73f86c2a91d7$var$trackedConnections.get(name);
    if (!connectionInfo) return;
    delete connectionInfo.stores[store];
    if (Object.keys(connectionInfo.stores).length === 0) $11cd73f86c2a91d7$var$trackedConnections.delete(name);
};
const $11cd73f86c2a91d7$var$findCallerName = (stack)=>{
    var _a, _b;
    if (!stack) return void 0;
    const traceLines = stack.split("\n");
    const apiSetStateLineIndex = traceLines.findIndex((traceLine)=>traceLine.includes("api.setState"));
    if (apiSetStateLineIndex < 0) return void 0;
    const callerLine = ((_a = traceLines[apiSetStateLineIndex + 1]) == null ? void 0 : _a.trim()) || "";
    return (_b = /.+ (.+) .+/.exec(callerLine)) == null ? void 0 : _b[1];
};
const $11cd73f86c2a91d7$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection: connection, ...connectionInformation } = $11cd73f86c2a91d7$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || $11cd73f86c2a91d7$var$findCallerName(new Error().stack) || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$11cd73f86c2a91d7$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        api.devtools = {
            cleanup: ()=>{
                if (connection && typeof connection.unsubscribe === "function") connection.unsubscribe();
                $11cd73f86c2a91d7$var$removeStoreFromTrackedConnections(options.name, store);
            }
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...args)=>{
                originalDispatch(...args);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $11cd73f86c2a91d7$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($11cd73f86c2a91d7$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($11cd73f86c2a91d7$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $11cd73f86c2a91d7$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($11cd73f86c2a91d7$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $11cd73f86c2a91d7$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $11cd73f86c2a91d7$var$devtools = $11cd73f86c2a91d7$var$devtoolsImpl;
const $11cd73f86c2a91d7$var$parseJsonThen = (stringified, fn)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) fn(parsed);
};
const $11cd73f86c2a91d7$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $11cd73f86c2a91d7$var$subscribeWithSelector = $11cd73f86c2a91d7$var$subscribeWithSelectorImpl;
function $11cd73f86c2a91d7$var$combine(initialState, create) {
    return (...args)=>Object.assign({}, initialState, create(...args));
}
function $11cd73f86c2a91d7$var$createJSONStorage(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $11cd73f86c2a91d7$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $11cd73f86c2a91d7$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $11cd73f86c2a91d7$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $11cd73f86c2a91d7$var$persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $11cd73f86c2a91d7$var$createJSONStorage(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            return setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            return setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $11cd73f86c2a91d7$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) {
                            const migration = options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            if (migration instanceof Promise) return migration.then((result)=>[
                                    true,
                                    result
                                ]);
                            return [
                                true,
                                migration
                            ];
                        }
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $11cd73f86c2a91d7$var$persist = $11cd73f86c2a91d7$var$persistImpl;
$11cd73f86c2a91d7$export$1be1fc439b849fdf = $11cd73f86c2a91d7$var$combine;
$11cd73f86c2a91d7$export$95a3b7b12ab518f9 = $11cd73f86c2a91d7$var$createJSONStorage;
$11cd73f86c2a91d7$export$6922d3b3a607469e = $11cd73f86c2a91d7$var$devtools;
$11cd73f86c2a91d7$export$9a6132153fba2e0 = $11cd73f86c2a91d7$var$persist;
$11cd73f86c2a91d7$export$4feba8a1bc8e9afd = $11cd73f86c2a91d7$var$redux;
$11cd73f86c2a91d7$export$5c593627aef9f076 = $11cd73f86c2a91d7$var$subscribeWithSelector;


const $45422d7966ef8166$export$650ce9f0b4df82fd = (0, $013da61274bf5d05$exports.create)((0, $11cd73f86c2a91d7$export$9a6132153fba2e0)((set)=>({
        isAuth: false,
        setIsAuth: (auth)=>set({
                isAuth: auth
            })
    }), {
    name: "auth"
}));



function $4063212f19a2e3fa$export$38eaa17faae8f579() {
    const { locale: t } = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state);
    const isAuth = (0, $45422d7966ef8166$export$650ce9f0b4df82fd)((state)=>state.isAuth);
    return [
        ...isAuth ? [
            {
                title: t.time.time,
                slug: "/time"
            },
            {
                title: t.report.report,
                slug: "/report"
            }
        ] : [
            {
                title: t.home.home,
                slug: "/home"
            },
            {
                separator: true
            },
            {
                title: t.login.login,
                slug: "/login"
            }
        ]
    ];
}



function $68b4b3b014c4b751$export$36aebdc2569f2447() {
    const isAuth = (0, $45422d7966ef8166$export$650ce9f0b4df82fd)((state)=>state.isAuth);
    return [
        ...isAuth ? [
            {
                title: "Logout",
                slug: "/logout"
            }
        ] : []
    ];
}




function $dfaad8cc0baf2ff9$export$b359ddbc2eba6d20() {
    const location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    const slug1 = location.pathname.split("/")[1] || null;
    const menu = (0, $4063212f19a2e3fa$export$38eaa17faae8f579)();
    const menuItem = menu.find((item)=>"slug" in item && item.slug === `/${slug1}`);
    if (menuItem && "children" in menuItem && menuItem.children) return menuItem.children;
    return [];
}


const $2ccd26ee17720849$var$API_BASE_URL = "/api";
async function $2ccd26ee17720849$export$596d806903d1f59e(email, password) {
    const response = await fetch(`${$2ccd26ee17720849$var$API_BASE_URL}/login`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            email: email,
            password: password
        })
    });
    if (!response.ok) throw new Error("Failed to login");
    return;
}
async function $2ccd26ee17720849$export$a0973bcfe11b05c9() {
    const response = await fetch(`${$2ccd26ee17720849$var$API_BASE_URL}/logout`, {
        method: "POST",
        credentials: "include"
    });
    if (!response.ok) throw new Error("Failed to logout");
    return;
}
async function $2ccd26ee17720849$export$e2853351e15b7895(currentPassword, password) {
    const response = await fetch(`${$2ccd26ee17720849$var$API_BASE_URL}/user`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({
            currentPassword: currentPassword,
            password: password
        })
    });
    if (!response.ok) throw new Error("Failed to update password");
    return;
}


const $d9482e4a5ea3dee8$var$listeners = new Map();
function $d9482e4a5ea3dee8$export$af631764ddc44097(name, callback) {
    if (!$d9482e4a5ea3dee8$var$listeners.has(name)) $d9482e4a5ea3dee8$var$listeners.set(name, []);
    $d9482e4a5ea3dee8$var$listeners.get(name)?.push(callback);
    return {
        unsubscribe: ()=>{
            const listner = $d9482e4a5ea3dee8$var$listeners.get(name);
            if (listner) listner.splice(listner.indexOf(callback), 1);
        }
    };
}
function $d9482e4a5ea3dee8$export$8f35fbd5db0f3634(name, data) {
    $d9482e4a5ea3dee8$var$listeners.get(name)?.forEach((callback)=>callback(data));
}









/*!
 * Font Awesome Free 7.0.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2025 Fonticons, Inc.
 */ var $159afdcd077ecfe9$export$82e9f45cca5ba907 = "fas";
var $159afdcd077ecfe9$export$f22454595d96c106 = {
    prefix: 'fas',
    iconName: '0',
    icon: [
        320,
        512,
        [],
        "30",
        "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160l0 128c0 88.4-71.6 160-160 160S0 408.4 0 320L0 192zM160 96c-53 0-96 43-96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96z"
    ]
};
var $159afdcd077ecfe9$export$8398cb2addc9e182 = {
    prefix: 'fas',
    iconName: '1',
    icon: [
        256,
        512,
        [],
        "31",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l64 0 0 320-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-352c0-17.7-14.3-32-32-32L32 32z"
    ]
};
var $159afdcd077ecfe9$export$ed1a0ff7bd680a1d = {
    prefix: 'fas',
    iconName: '2',
    icon: [
        384,
        512,
        [],
        "32",
        "M48 64c0-17.7 14.3-32 32-32l171 0c60.2 0 109 48.8 109 109 0 43.8-26.2 83.3-66.4 100.4l-139.1 59C119 315.4 96 350.2 96 388.7l0 27.3 224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-59.3c0-64.2 38.4-122.2 97.5-147.3l139.1-59c16.6-7.1 27.4-23.4 27.4-41.4 0-24.9-20.2-45-45-45L80 96C62.3 96 48 81.7 48 64z"
    ]
};
var $159afdcd077ecfe9$export$74b7ff79ce1818d6 = {
    prefix: 'fas',
    iconName: '3',
    icon: [
        320,
        512,
        [],
        "33",
        "M80 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l112 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l160 0c70.7 0 128 57.3 128 128 0 38.2-16.8 72.5-43.3 96 26.6 23.5 43.3 57.8 43.3 96 0 70.7-57.3 128-128 128L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c35.3 0 64-28.7 64-64s-28.7-64-64-64L80 288z"
    ]
};
var $159afdcd077ecfe9$export$969b2215780d58fd = {
    prefix: 'fas',
    iconName: '4',
    icon: [
        384,
        512,
        [],
        "34",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 288c0 35.3 28.7 64 64 64l192 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 224-192 0 0-224z"
    ]
};
var $159afdcd077ecfe9$export$3919f68a5b3825a9 = {
    prefix: 'fas',
    iconName: '5',
    icon: [
        320,
        512,
        [],
        "35",
        "M0 64C0 46.3 14.3 32 32 32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0 0 112 120 0c75.1 0 136 60.9 136 136S259.1 480 184 480L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l152 0c39.8 0 72-32.2 72-72s-32.2-72-72-72L32 272c-17.7 0-32-14.3-32-32L0 64z"
    ]
};
var $159afdcd077ecfe9$export$580ac17b31ffb5c3 = {
    prefix: 'fas',
    iconName: '6',
    icon: [
        384,
        512,
        [],
        "36",
        "M256 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-88 0c-48.6 0-88 39.4-88 88l0 32.2c22.9-15.3 50.4-24.2 80-24.2l48 0c79.5 0 144 64.5 144 144S287.5 480 208 480l-48 0C80.5 480 16 415.5 16 336l0-152C16 100.1 84.1 32 168 32l88 0zM80 336c0 44.2 35.8 80 80 80l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0c-44.2 0-80 35.8-80 80z"
    ]
};
var $159afdcd077ecfe9$export$ee79cab31be16d23 = {
    prefix: 'fas',
    iconName: '7',
    icon: [
        320,
        512,
        [],
        "37",
        "M0 64C0 46.3 14.3 32 32 32l256 0c11.5 0 22 6.1 27.7 16.1s5.7 22.2-.1 32.1l-224 384c-8.9 15.3-28.5 20.4-43.8 11.5s-20.4-28.5-11.5-43.8L232.3 96 32 96C14.3 96 0 81.7 0 64z"
    ]
};
var $159afdcd077ecfe9$export$45d84c4b2c560d2f = {
    prefix: 'fas',
    iconName: '8',
    icon: [
        320,
        512,
        [],
        "38",
        "M304 160c0-70.7-57.3-128-128-128l-32 0c-70.7 0-128 57.3-128 128 0 34.6 13.7 66 36 89-31.5 23.3-52 60.8-52 103 0 70.7 57.3 128 128 128l64 0c70.7 0 128-57.3 128-128 0-42.2-20.5-79.7-52-103 22.3-23 36-54.4 36-89zM176.1 288l15.9 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64s28.7-64 64-64l48.1 0zm0-64L144 224c-35.3 0-64-28.7-64-64 0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64 0 35.3-28.6 64-64 64z"
    ]
};
var $159afdcd077ecfe9$export$a120f1e4223629f2 = {
    prefix: 'fas',
    iconName: '9',
    icon: [
        384,
        512,
        [],
        "39",
        "M208 320c29.6 0 57.1-8.9 80-24.2l0 32.2c0 48.6-39.4 88-88 88L96 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l104 0c83.9 0 152-68.1 152-152l0-152.1C351.9 96.4 287.5 32 208 32l-48 0C80.5 32 16 96.5 16 176S80.5 320 160 320l48 0zm80-144c0 44.2-35.8 80-80 80l-48 0c-44.2 0-80-35.8-80-80s35.8-80 80-80l48 0c44.2 0 80 35.8 80 80z"
    ]
};
var $159afdcd077ecfe9$export$fb420d3e4d8c6a18 = {
    prefix: 'fas',
    iconName: 'dollar-sign',
    icon: [
        320,
        512,
        [
            128178,
            61781,
            "dollar",
            "usd"
        ],
        "24",
        "M136 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-114.9 0c-24.9 0-45.1 20.2-45.1 45.1 0 22.5 16.5 41.5 38.7 44.7l91.6 13.1c53.8 7.7 93.7 53.7 93.7 108 0 60.3-48.9 109.1-109.1 109.1l-10.9 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-72 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l130.9 0c24.9 0 45.1-20.2 45.1-45.1 0-22.5-16.5-41.5-38.7-44.7l-91.6-13.1C55.9 273.5 16 227.4 16 173.1 16 112.9 64.9 64 125.1 64l10.9 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$a4ffb0775547fcdf = $159afdcd077ecfe9$export$fb420d3e4d8c6a18;
var $159afdcd077ecfe9$export$72cca07d38a28589 = $159afdcd077ecfe9$export$fb420d3e4d8c6a18;
var $159afdcd077ecfe9$export$c6406747800cf702 = {
    prefix: 'fas',
    iconName: 'dog',
    icon: [
        576,
        512,
        [
            128021
        ],
        "f6d3",
        "M32 112c16.6 0 30.2 12.6 31.8 28.7l.3 6.6C65.8 163.4 79.4 176 96 176l179.1 0 140.9 60.4 0 243.6c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-131.3C296 361 268.8 368 240 368s-56-7-80-19.3L160 480c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-245.6c-37.3-13.2-64-48.6-64-90.4 0-17.7 14.3-32 32-32zM355.8-32c7.7 0 14.9 3.6 19.6 9.8L392 0 444.1 0c12.7 0 24.9 5.1 33.9 14.1L496 32 552 32c13.3 0 24 10.7 24 24l0 24c0 44.2-35.8 80-80 80l-64 0-7 28-124.7-53.4 31.6-147.2C334.3-23.9 344.2-32 355.8-32zM448 44a20 20 0 1 0 0 40 20 20 0 1 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$a06617a1a4ccea67 = {
    prefix: 'fas',
    iconName: 'truck-moving',
    icon: [
        640,
        512,
        [],
        "f4df",
        "M64 32C28.7 32 0 60.7 0 96L0 424c0 48.6 39.4 88 88 88 25.2 0 48-10.6 64-27.6 16 17 38.8 27.6 64 27.6 40.3 0 74.2-27.1 84.7-64l134.6 0c10.4 36.9 44.4 64 84.7 64 43 0 78.9-30.9 86.5-71.7 20-10.8 33.5-32 33.5-56.3l0-146.7c0-17-6.7-33.3-18.7-45.3L576 146.7c-12-12-28.3-18.7-45.3-18.7l-50.7 0 0-32c0-35.3-28.7-64-64-64L64 32zM480 192l50.7 0 45.3 45.3 0 50.7-96 0 0-96zM88 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm392 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM216 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $159afdcd077ecfe9$export$decde496a29c5b23 = {
    prefix: 'fas',
    iconName: 'rotate',
    icon: [
        512,
        512,
        [
            128260,
            "sync-alt"
        ],
        "f2f1",
        "M480.1 192l7.9 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2S477.9 .2 471 7L419.3 58.8C375 22.1 318 0 256 0 127 0 20.3 95.4 2.6 219.5 .1 237 12.2 253.2 29.7 255.7s33.7-9.7 36.2-27.1C79.2 135.5 159.3 64 256 64 300.4 64 341.2 79 373.7 104.3L327 151c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 192 344 192l136.1 0zm29.4 100.5c2.5-17.5-9.7-33.7-27.1-36.2s-33.7 9.7-36.2 27.1c-13.3 93-93.4 164.5-190.1 164.5-44.4 0-85.2-15-117.7-40.3L185 361c6.9-6.9 8.9-17.2 5.2-26.2S177.7 320 168 320L24 320c-13.3 0-24 10.7-24 24L0 488c0 9.7 5.8 18.5 14.8 22.2S34.1 511.8 41 505l51.8-51.8C137 489.9 194 512 256 512 385 512 491.7 416.6 509.4 292.5z"
    ]
};
var $159afdcd077ecfe9$export$2ff2056be8c281e4 = $159afdcd077ecfe9$export$decde496a29c5b23;
var $159afdcd077ecfe9$export$814c9edba7b84aa4 = {
    prefix: 'fas',
    iconName: 'square-minus',
    icon: [
        448,
        512,
        [
            61767,
            "minus-square"
        ],
        "f146",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm72 200l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$ffe9387966b3e681 = $159afdcd077ecfe9$export$814c9edba7b84aa4;
var $159afdcd077ecfe9$export$97c42b56d462df72 = {
    prefix: 'fas',
    iconName: 'align-justify',
    icon: [
        448,
        512,
        [],
        "f039",
        "M448 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32L32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32z"
    ]
};
var $159afdcd077ecfe9$export$5655108e1162ba45 = {
    prefix: 'fas',
    iconName: 'calendar-check',
    icon: [
        448,
        512,
        [],
        "f274",
        "M320 0c17.7 0 32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32zm22 161.7c-10.7-7.8-25.7-5.4-33.5 5.3L189.1 331.2 137 279.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.9 7.5 18.8 7s13.4-4.1 17.5-9.8L347.3 195.2c7.8-10.7 5.4-25.7-5.3-33.5z"
    ]
};
var $159afdcd077ecfe9$export$5a54c83033a0a56a = {
    prefix: 'fas',
    iconName: 'face-kiss',
    icon: [
        512,
        512,
        [
            128535,
            "kiss"
        ],
        "f596",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 288l32 0c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32 7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-96-80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$c762a77aabf64fd0 = $159afdcd077ecfe9$export$5a54c83033a0a56a;
var $159afdcd077ecfe9$export$64c1570509eaf40d = {
    prefix: 'fas',
    iconName: 'kitchen-set',
    icon: [
        576,
        512,
        [],
        "e51a",
        "M240 144a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288 64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112l71.8 0c8.8-9.8 21.6-16 35.8-16l104 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-104 0c-14.2 0-27-6.2-35.8-16l-71.8 0zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24l0 8 96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-240 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l96 0 0-8c0-13.3 10.7-24 24-24zM288 464l0-112 224 0 0 112c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48zM48 320l128 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-80c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0 32 16 0zM24 464l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$c062100d54a2da00 = {
    prefix: 'fas',
    iconName: 'dna',
    icon: [
        384,
        512,
        [
            129516
        ],
        "f471",
        "M352 0c17.7 0 32 14.3 32 32 0 57.8-24.4 104.8-57.4 144.5-24.1 28.9-53.8 55.1-83.6 79.5 29.8 24.5 59.5 50.6 83.6 79.5 33 39.6 57.4 86.7 57.4 144.5 0 17.7-14.3 32-32 32s-32-14.3-32-32L64 480c0 17.7-14.3 32-32 32S0 497.7 0 480C0 422.2 24.4 375.2 57.4 335.5 81.5 306.6 111.2 280.5 141 256 111.2 231.5 81.5 205.4 57.4 176.5 24.4 136.8 0 89.8 0 32 0 14.3 14.3 0 32 0S64 14.3 64 32l256 0c0-17.7 14.3-32 32-32zM283.5 384l-182.9 0c-8.2 10.5-15.1 21.1-20.6 32l224.2 0c-5.6-10.9-12.5-21.5-20.6-32zM238 336c-14.3-13-29.8-25.8-46-39-16.2 13.1-31.7 26-46 39l92 0zM100.5 128l182.9 0c8.2-10.5 15.1-21.1 20.6-32L79.9 96c5.6 10.9 12.5 21.5 20.6 32zM146 176c14.3 13 29.8 25.8 46 39 16.2-13.1 31.7-26 46-39l-92 0z"
    ]
};
var $159afdcd077ecfe9$export$84a2f9476730c40e = {
    prefix: 'fas',
    iconName: 'child-reaching',
    icon: [
        384,
        512,
        [],
        "e59d",
        "M256 64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM152.9 169.3c-23.7-8.4-44.5-24.3-58.8-45.8L74.6 94.2C64.8 79.5 45 75.6 30.3 85.4S11.6 115 21.4 129.8L40.9 159c18.1 27.1 42.8 48.4 71.1 62.4L112 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-258.4c29.1-14.2 54.4-36.2 72.7-64.2l18.2-27.9c9.6-14.8 5.4-34.6-9.4-44.3s-34.6-5.5-44.3 9.4L291 122.4c-21.8 33.4-58.9 53.6-98.8 53.6-12.6 0-24.9-2-36.6-5.8-.9-.3-1.8-.7-2.7-.9z"
    ]
};
var $159afdcd077ecfe9$export$6f95f90dd1f6d86b = {
    prefix: 'fas',
    iconName: 'paste',
    icon: [
        512,
        512,
        [
            "file-clipboard"
        ],
        "f0ea",
        "M64 0C28.7 0 0 28.7 0 64L0 384c0 35.3 28.7 64 64 64l112 0 0-224c0-61.9 50.1-112 112-112l64 0 0-48c0-35.3-28.7-64-64-64L64 0zM248 112l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zm40 48c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-165.5c0-17-6.7-33.3-18.7-45.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7L288 160z"
    ]
};
var $159afdcd077ecfe9$export$ca3229c47de163fa = $159afdcd077ecfe9$export$6f95f90dd1f6d86b;
var $159afdcd077ecfe9$export$1439f0d6365138da = {
    prefix: 'fas',
    iconName: 'meteor',
    icon: [
        512,
        512,
        [
            9732
        ],
        "f753",
        "M493.7 .9l-194.2 74.7 2.3-29.3c1-12.8-12.8-21.5-24-15.1L101.3 133.4C38.6 169.7 0 236.6 0 309 0 421.1 90.9 512 203 512 275.4 512 342.3 473.4 378.6 410.7L480.8 234.3c6.5-11.1-2.2-25-15.1-24l-29.3 2.3 74.7-194.2c.6-1.5 .9-3.2 .9-4.8 0-7.5-6-13.5-13.5-13.5-1.7 0-3.3 .3-4.8 .9zM192 192a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $159afdcd077ecfe9$export$4aac79b9ae3cfdb8 = {
    prefix: 'fas',
    iconName: 'gears',
    icon: [
        640,
        512,
        [
            "cogs"
        ],
        "f085",
        "M415.9 210.5c12.2-3.3 25 2.5 30.5 13.8L465 261.9c10.3 1.4 20.4 4.2 29.9 8.1l35-23.3c10.5-7 24.4-5.6 33.3 3.3l19.2 19.2c8.9 8.9 10.3 22.9 3.3 33.3l-23.3 34.9c1.9 4.7 3.6 9.6 5 14.7 1.4 5.1 2.3 10.1 3 15.2l37.7 18.6c11.3 5.6 17.1 18.4 13.8 30.5l-7 26.2c-3.3 12.1-14.6 20.3-27.2 19.5l-42-2.7c-6.3 8.1-13.6 15.6-21.9 22l2.7 41.9c.8 12.6-7.4 24-19.5 27.2l-26.2 7c-12.2 3.3-24.9-2.5-30.5-13.8l-18.6-37.6c-10.3-1.4-20.4-4.2-29.9-8.1l-35 23.3c-10.5 7-24.4 5.6-33.3-3.3l-19.2-19.2c-8.9-8.9-10.3-22.8-3.3-33.3l23.3-35c-1.9-4.7-3.6-9.6-5-14.7s-2.3-10.2-3-15.2l-37.7-18.6c-11.3-5.6-17-18.4-13.8-30.5l7-26.2c3.3-12.1 14.6-20.3 27.2-19.5l41.9 2.7c6.3-8.1 13.6-15.6 21.9-22l-2.7-41.8c-.8-12.6 7.4-24 19.5-27.2l26.2-7zM448.4 340a44 44 0 1 0 .1 88 44 44 0 1 0 -.1-88zM224.9-45.5l26.2 7c12.1 3.3 20.3 14.7 19.5 27.2l-2.7 41.8c8.3 6.4 15.6 13.8 21.9 22l42-2.7c12.5-.8 23.9 7.4 27.2 19.5l7 26.2c3.2 12.1-2.5 24.9-13.8 30.5l-37.7 18.6c-.7 5.1-1.7 10.2-3 15.2s-3.1 10-5 14.7l23.3 35c7 10.5 5.6 24.4-3.3 33.3L307.3 262c-8.9 8.9-22.8 10.3-33.3 3.3L239 242c-9.5 3.9-19.6 6.7-29.9 8.1l-18.6 37.6c-5.6 11.3-18.4 17-30.5 13.8l-26.2-7c-12.2-3.3-20.3-14.7-19.5-27.2l2.7-41.9c-8.3-6.4-15.6-13.8-21.9-22l-42 2.7c-12.5 .8-23.9-7.4-27.2-19.5l-7-26.2c-3.2-12.1 2.5-24.9 13.8-30.5l37.7-18.6c.7-5.1 1.7-10.1 3-15.2 1.4-5.1 3-10 5-14.7L55.1 46.5c-7-10.5-5.6-24.4 3.3-33.3L77.6-6c8.9-8.9 22.8-10.3 33.3-3.3l35 23.3c9.5-3.9 19.6-6.7 29.9-8.1l18.6-37.6c5.6-11.3 18.3-17 30.5-13.8zM192.4 84a44 44 0 1 0 0 88 44 44 0 1 0 0-88z"
    ]
};
var $159afdcd077ecfe9$export$af1575770afc9559 = $159afdcd077ecfe9$export$4aac79b9ae3cfdb8;
var $159afdcd077ecfe9$export$430d63b54b1d4009 = {
    prefix: 'fas',
    iconName: 'file-circle-plus',
    icon: [
        576,
        512,
        [
            58606
        ],
        "e494",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3l0-38.1c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $159afdcd077ecfe9$export$78792ed87d92a3ad = {
    prefix: 'fas',
    iconName: 'icicles',
    icon: [
        512,
        512,
        [],
        "f7ad",
        "M75.8 304.8L1 35.7C.3 33.2 0 30.7 0 28.2 0 12.6 12.6 0 28.2 0L482.4 0c16.3 0 29.6 13.2 29.6 29.6 0 1.6-.1 3.3-.4 4.9L434.6 496.1c-1.5 9.2-9.5 15.9-18.8 15.9-9.2 0-17.1-6.6-18.7-15.6L336 160 307.2 303.9c-1.9 9.3-10.1 16.1-19.6 16.1-9.2 0-17.2-6.2-19.4-15.1L240 192 210.6 368.2c-1.5 9.1-9.4 15.8-18.6 15.8s-17.1-6.7-18.6-15.8L144 192 115.9 304.3c-2.3 9.2-10.6 15.7-20.1 15.7-9.3 0-17.5-6.2-20-15.2z"
    ]
};
var $159afdcd077ecfe9$export$cf36928a9c52e98a = {
    prefix: 'fas',
    iconName: 'arrow-trend-up',
    icon: [
        576,
        512,
        [],
        "e098",
        "M384 160c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-82.7-169.4 169.4c-12.5 12.5-32.8 12.5-45.3 0L192 269.3 54.6 406.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0L320 306.7 466.7 160 384 160z"
    ]
};
var $159afdcd077ecfe9$export$f0f9d0c0b0d511dd = {
    prefix: 'fas',
    iconName: 'hexagon-nodes-bolt',
    icon: [
        576,
        512,
        [],
        "e69a",
        "M248 106.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 98.8c-2.8 1.3-5.5 2.9-8 4.7l-80.1-45.8c1.6-20.8-8.6-41.6-27.9-52.8C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c1.3 .8 2.6 1.5 4 2.1l0 90.8c-1.3 .6-2.7 1.3-4 2.1C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c19.3-11.1 29.4-32 27.8-52.8l50.5-28.9c-11.5-11.2-19.9-25.6-23.8-41.7L88 306.1c-2.6-1.8-5.2-3.3-8-4.7l0-90.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-.1 1.4-.2 2.8-.2 4.3c0 22.3 13.1 41.6 32 50.6l0 98.8c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56c30.7 0 55.6-24.7 56-55.2c-7.5-12.9-13.5-26.8-17.6-41.5c-4.2-4-9.1-7.3-14.4-9.9l0-98.8c2.8-1.3 5.5-2.9 8-4.7l10.5 6c5.5-15.3 13.1-29.5 22.4-42.5l-9.1-5.2c.1-1.4 .2-2.8 .2-4.3c0-22.3-13.1-41.6-32-50.6l0-98.8zM440.5 132C425 105.2 390.8 96 364 111.5c-19.3 11.1-29.4 32-27.8 52.8l-50.6 28.9c11.5 11.2 19.9 25.6 23.8 41.7L360 205.9c.4 .3 .8 .6 1.3 .9c21.7-9.5 45.6-14.8 70.8-14.8c2 0 4 0 5.9 .1c12.1-17.3 13.8-40.6 2.6-60.1zM432 512a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm47.9-225c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356l35.6 0c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9L411.6 380 376 380c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1 .6z"
    ]
};
var $159afdcd077ecfe9$export$d96973f90e8f6e47 = {
    prefix: 'fas',
    iconName: 'question',
    icon: [
        320,
        512,
        [
            10067,
            10068,
            61736
        ],
        "3f",
        "M64 160c0-53 43-96 96-96s96 43 96 96c0 42.7-27.9 78.9-66.5 91.4-28.4 9.2-61.5 35.3-61.5 76.6l0 24c0 17.7 14.3 32 32 32s32-14.3 32-32l0-24c0-1.7 .6-4.1 3.5-7.3 3-3.3 7.9-6.5 13.7-8.4 64.3-20.7 110.8-81 110.8-152.3 0-88.4-71.6-160-160-160S0 71.6 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm96 352c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40 17.9 40 40 40z"
    ]
};
var $159afdcd077ecfe9$export$740142a89118fbc0 = {
    prefix: 'fas',
    iconName: 'hands-bound',
    icon: [
        576,
        512,
        [],
        "e4f9",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 213.9c0 14.2 5.1 27.9 14.3 38.7L99.6 352 96 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-3.6 0 85.3-99.5c9.2-10.8 14.3-24.5 14.3-38.7L576 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112.8-69.3 92.4c-5.7 7.6-16.1 9.6-24.2 4.8-9.7-5.7-12.1-18.7-5.1-27.5L441 180c10.8-13.5 8.9-33.3-4.4-44.5s-33-9.8-44.5 3.2l-46.7 52.5C329 209.7 320 233.4 320 258.1l0 93.9-64 0 0-93.9c0-24.6-9-48.4-25.4-66.8l-46.7-52.5c-11.5-13-31.3-14.4-44.5-3.2S124.2 166.4 135 180l27.6 34.5c7 8.8 4.7 21.8-5.1 27.5-8.1 4.8-18.6 2.7-24.2-4.8L64 144.8 64 32zm64 448l0 32 128 0 0-32 64 0 0 32 128 0 0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L96 432c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0z"
    ]
};
var $159afdcd077ecfe9$export$1ae0a37b36ace746 = {
    prefix: 'fas',
    iconName: 'person-walking-luggage',
    icon: [
        512,
        512,
        [],
        "e554",
        "M264.3 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-8 181.3l-22.6 22.6c-6 6-9.4 14.1-9.4 22.6l0 37.5c0 12.3-7 23-17.2 28.4-.9 4.2-2.4 8.4-4.3 12.3l-69 138.1-.8-.4-27.7 55.3c-9.9 19.8-33.9 27.8-53.7 17.9L14.6 521c-19.8-9.9-27.8-33.9-17.9-53.7L47.3 366.3c9.9-19.8 33.9-27.8 53.7-17.9l30.7 15.3 28.3-56.6c.3-.6 .4-1.2 .4-1.8l0-16.9c0-.2 0-.3 0-.5l0-37.5c0-25.5 10.1-49.9 28.1-67.9l35.1-35.1c22.8-22.8 53.6-35.6 85.8-35.6 36.9 0 71.8 16.8 94.8 45.6L422.1 180c6.1 7.6 15.3 12 25 12l33.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-33.2 0c-29.2 0-56.7-13.3-75-36l-3.8-4.7 0 115.2 34.5 29.6c17.7 15.2 29.3 36.2 32.6 59.3L448 507.5c2.5 17.5-9.7 33.7-27.2 36.2s-33.7-9.7-36.2-27.2L372 428.4c-1.1-7.7-5-14.7-10.9-19.8l-71.4-61.2c-21.3-18.2-33.5-44.9-33.5-72.9l0-69.3zm.1 165.8c2.4 2.3 4.8 4.6 7.4 6.8l46 39.4-2.2 7.6c-4.5 15.7-12.9 30-24.4 41.5l-68.3 68.3c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L238 421.1c3.8-3.8 6.6-8.6 8.1-13.8L256.4 371z"
    ]
};
var $159afdcd077ecfe9$export$148bcede94488555 = {
    prefix: 'fas',
    iconName: 'file-arrow-down',
    icon: [
        384,
        512,
        [
            "file-download"
        ],
        "f56d",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM175 441c9.4 9.4 24.6 9.4 33.9 0l64-64c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-23 23 0-86.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 86.1-23-23c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64z"
    ]
};
var $159afdcd077ecfe9$export$1013b9966d758343 = $159afdcd077ecfe9$export$148bcede94488555;
var $159afdcd077ecfe9$export$2337c975289bdd84 = {
    prefix: 'fas',
    iconName: 'person-booth',
    icon: [
        576,
        512,
        [],
        "f756",
        "M40 24A56 56 0 1 1 152 24 56 56 0 1 1 40 24zm51.1 88c23.5 0 45.5 11.3 59.1 30.4l48.7 68.2c6 8.4 15.7 13.4 26 13.4l31.1 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-31.1 0c-31 0-60.1-15-78.1-40.2l-2.8-3.9 0 80.1 41.6 31.2C209.8 373.3 224 401.8 224 432l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80c0-10.1-4.7-19.6-12.8-25.6L70.4 348.8C46.2 330.7 32 302.2 32 272l0-100.9C32 138.5 58.5 112 91.1 112zM32 512l0-132.7c3.1 2.7 6.3 5.4 9.6 7.9L96 428 96 512c0 17.7-14.3 32-32 32s-32-14.3-32-32zm544-88l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-168 0c-7.1 0-13.8-3.1-18.4-8.6s-6.5-12.6-5.3-19.6l30.7-176.7-63.1-137.6 0 72c-5.2-1-10.5-1.6-16-1.6l-32 0 0-120c0-30.9 25.1-56 56-56L520 0c30.9 0 56 25.1 56 56l0 368zM288 336c5.5 0 10.8-.6 16-1.6L304 520c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-184 32 0z"
    ]
};
var $159afdcd077ecfe9$export$4982360d3b844c19 = {
    prefix: 'fas',
    iconName: 'locust',
    icon: [
        576,
        512,
        [],
        "e520",
        "M328 32c137 0 248 111 248 248l0 40-.4 8.2C571.5 368.5 537.4 400 496 400l-12.3 0 25.2 44.1c6.6 11.5 2.6 26.2-8.9 32.8s-26.2 2.6-32.7-8.9l-38.8-67.9-80.4 0-48.2 69.7c-7.5 10.9-22.5 13.6-33.4 6.1s-13.6-22.5-6.1-33.4l29.3-42.3-74.5 0-51.7 70.2c-7.9 10.7-22.9 12.9-33.6 5.1s-12.9-22.9-5.1-33.6l40.5-55-43-16.4-79.3 100.5c-8.2 10.4-23.3 12.2-33.7 4s-12.2-23.3-4-33.7l240-304 2.1-2.3c5.2-5.1 12.5-7.5 19.9-6.6 8.4 1.1 15.6 6.5 18.9 14.3l21.7 50.7 40.9-55.5 2.1-2.4c5.1-5.3 12.5-8 20-7.2 8.5 1 15.9 6.5 19.3 14.4l41.8 97.5 64.2 0c10.2 0 20 2 29 5.5-16.4-94-98.3-165.5-197-165.5l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0zM488 296a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM43.5 331.1C36.2 321.4 32 309.5 32 296.8 32 265.5 57.5 240 88.9 240l27.6 0-72.9 91.1zM225.1 240l48.2 0 1.4-1.9-16.9-39.5-32.7 41.5zm107.8 0l46.7 0-17.2-40-29.5 40z"
    ]
};
var $159afdcd077ecfe9$export$b356b1dbe7d7f736 = {
    prefix: 'fas',
    iconName: 'right-long',
    icon: [
        576,
        512,
        [
            "long-arrow-alt-right"
        ],
        "f30b",
        "M566.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9S384 396.9 384 384l0-64-336 0c-26.5 0-48-21.5-48-48l0-32c0-26.5 21.5-48 48-48l336 0 0-64c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128z"
    ]
};
var $159afdcd077ecfe9$export$533e1f578f74c066 = $159afdcd077ecfe9$export$b356b1dbe7d7f736;
var $159afdcd077ecfe9$export$41ce20639e8fef2b = {
    prefix: 'fas',
    iconName: 'truck-droplet',
    icon: [
        576,
        512,
        [],
        "e58c",
        "M64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l3.3 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l3.3 0c35.3 0 64-28.7 64-64l0-146.7c0-17-6.7-33.3-18.7-45.3L512 146.7c-12-12-28.3-18.7-45.3-18.7l-50.7 0 0-32c0-35.3-28.7-64-64-64L64 32zM512 237.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM208 304c-39.8 0-72-32.2-72-72 0-33.2 34.5-78 55.8-102.4 8.7-10 23.8-10 32.5 0 21.2 24.4 55.8 69.1 55.8 102.4 0 48-32.2 72-72 72z"
    ]
};
var $159afdcd077ecfe9$export$bb2a6b1b5e852300 = {
    prefix: 'fas',
    iconName: 'hand-holding-medical',
    icon: [
        576,
        512,
        [],
        "e05c",
        "M240 24c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 56 56 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-56 0 0 56c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-56-56 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l56 0 0-56zM66.7 384l42.5-42.5c24-24 56.6-37.5 90.5-37.5L352 304c17.7 0 32 14.3 32 32s-14.3 32-32 32l-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5s9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l34.7 0z"
    ]
};
var $159afdcd077ecfe9$export$b276ec3dc9760d39 = {
    prefix: 'fas',
    iconName: 'hand-point-left',
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l208 0 0-64-208 0zM192 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm-64-64c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0c-17.7 0-32 14.3-32 32zm96 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0zm88-96l-.6 0c5.4 9.4 8.6 20.3 8.6 32 0 13.2-4 25.4-10.8 35.6 24.9 8.7 42.8 32.5 42.8 60.4 0 11.7-3.1 22.6-8.6 32l8.6 0c88.4 0 160-71.6 160-160l0-61.7c0-42.4-16.9-83.1-46.9-113.1l-11.6-11.6C429.5 77.5 396.9 64 363 64l-27 0c-35.3 0-64 28.7-64 64l0 88c0 22.1 17.9 40 40 40s40-17.9 40-40l0-56c0-8.8 7.2-16 16-16s16 7.2 16 16l0 56c0 39.8-32.2 72-72 72z"
    ]
};
var $159afdcd077ecfe9$export$693bd40950ed2c3a = {
    prefix: 'fas',
    iconName: 'calculator',
    icon: [
        384,
        512,
        [
            128425
        ],
        "f1ec",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM96 64l192 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L96 160c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32zm16 168a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM88 352a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm128-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm80 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM64 424c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 448c-13.3 0-24-10.7-24-24zm232-24c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$fee0376c250cdef = {
    prefix: 'fas',
    iconName: 'minus',
    icon: [
        448,
        512,
        [
            8211,
            8722,
            10134,
            "subtract"
        ],
        "f068",
        "M0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$f8cb2531ef1fc4a2 = $159afdcd077ecfe9$export$fee0376c250cdef;
var $159afdcd077ecfe9$export$a0a53d8e3c68e9f1 = {
    prefix: 'fas',
    iconName: 'arrow-up-z-a',
    icon: [
        512,
        512,
        [
            "sort-alpha-up-alt"
        ],
        "f882",
        "M150.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 141.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80zM288 64c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9S307.1 224 320 224l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9S461 32 448 32L320 32c-17.7 0-32 14.3-32 32zM412.6 273.7C407.2 262.8 396.1 256 384 256s-23.2 6.8-28.6 17.7l-80 160c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9l-80-160zM384 359.6l20.2 40.4-40.4 0 20.2-40.4z"
    ]
};
var $159afdcd077ecfe9$export$95ef20828693fb0f = $159afdcd077ecfe9$export$a0a53d8e3c68e9f1;
var $159afdcd077ecfe9$export$843f63d64e6f7951 = {
    prefix: 'fas',
    iconName: 'microphone-slash',
    icon: [
        576,
        512,
        [],
        "f131",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L424.7 358.8C458.9 324.2 480 276.6 480 224l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 39.3-15.7 74.9-41.3 100.9L356.8 291C373.6 273.7 384 250 384 224l0-128c0-53-43-96-96-96s-96 43-96 96l0 30.2-151-151zm298.3 434l-41.4-41.4c-3.3 .2-6.5 .3-9.8 .3-79.5 0-144-64.5-144-144l0-10.2-43.6-43.6c-2.8 3.9-4.4 8.7-4.4 13.8l0 40c0 97.9 73.3 178.7 168 190.5l0 49.5-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-49.5c9.3-1.2 18.4-3 27.3-5.4z"
    ]
};
var $159afdcd077ecfe9$export$3643b719db23d46e = {
    prefix: 'fas',
    iconName: 'square-pen',
    icon: [
        448,
        512,
        [
            "pen-square",
            "pencil-square"
        ],
        "f14b",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM325.8 139.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-23.8 23.8-71-71 23.8-23.8c15.6-15.6 40.9-15.6 56.6 0zM119.9 289l91.5-91.6 71 71-91.6 91.5c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z"
    ]
};
var $159afdcd077ecfe9$export$fbb231ccb3d960bc = $159afdcd077ecfe9$export$3643b719db23d46e;
var $159afdcd077ecfe9$export$35d253ecd249e771 = $159afdcd077ecfe9$export$3643b719db23d46e;
var $159afdcd077ecfe9$export$ca492f58fe30a42f = {
    prefix: 'fas',
    iconName: 'hand-fist',
    icon: [
        384,
        512,
        [
            9994,
            "fist-raised"
        ],
        "f6de",
        "M160 0c17.7 0 32 14.3 32 32l0 112-64 0 0-112c0-17.7 14.3-32 32-32zM32 64c0-17.7 14.3-32 32-32S96 46.3 96 64l0 80-64 0 0-80zm192 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96zm96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6l0 8.6c0 52.3-25.1 98.8-64 128l0 96c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-78.4c-17.3-7.9-33.2-18.8-46.9-32.5L37.5 357.5C13.5 333.5 0 300.9 0 267l0-27c0-35.3 28.7-64 64-64l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72z"
    ]
};
var $159afdcd077ecfe9$export$fa0323a4d7489a8d = $159afdcd077ecfe9$export$ca492f58fe30a42f;
var $159afdcd077ecfe9$export$435fe17e9d6170d6 = {
    prefix: 'fas',
    iconName: 'comment-sms',
    icon: [
        512,
        512,
        [
            "sms"
        ],
        "f7cd",
        "M256 480c141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240c0 54.3 19.2 104.3 51.6 144.5L2.8 476.8c-4.8 9-3.3 20 3.6 27.5s17.8 9.8 27.1 5.8l118.4-50.7C183.7 472.6 218.9 480 256 480zM140.8 172.8l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6c23 0 41.6 18.6 41.6 41.6s-18.6 41.6-41.6 41.6l-25.6 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l25.6 0c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6zm188.8 41.6c0-23 18.6-41.6 41.6-41.6l19.2 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-19.2 0c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6c23 0 41.6 18.6 41.6 41.6s-18.6 41.6-41.6 41.6l-25.6 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l25.6 0c5.3 0 9.6-4.3 9.6-9.6s-4.3-9.6-9.6-9.6c-23 0-41.6-18.6-41.6-41.6zm-98.3-33.8l24.7 41.1 24.7-41.1c3.7-6.2 11.1-9.1 18-7.2s11.7 8.2 11.7 15.4l0 102.4c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-44.6-8.7 14.5c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8l-8.7-14.5 0 44.6c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-102.4c0-7.2 4.8-13.5 11.7-15.4s14.3 1 18 7.2z"
    ]
};
var $159afdcd077ecfe9$export$9dbcc3443daa7323 = $159afdcd077ecfe9$export$435fe17e9d6170d6;
var $159afdcd077ecfe9$export$3bee83bf278fddbe = {
    prefix: 'fas',
    iconName: 'sim-card',
    icon: [
        384,
        512,
        [],
        "f7c4",
        "M0 64C0 28.7 28.7 0 64 0L258.7 0c17 0 33.3 6.7 45.3 18.7L365.3 80c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 256c-17.7 0-32 14.3-32 32l0 40 128 0 0-72-96 0zM64 416c0 17.7 14.3 32 32 32l48 0 0-72-80 0 0 40zm256 0l0-40-128 0 0 72 96 0c17.7 0 32-14.3 32-32zm0-128c0-17.7-14.3-32-32-32l-48 0 0 72 80 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$33fb4280dc20f0dd = {
    prefix: 'fas',
    iconName: 'scale-balanced',
    icon: [
        640,
        512,
        [
            9878,
            "balance-scale"
        ],
        "f24e",
        "M384 32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L398.4 96c-5.2 25.8-22.9 47.1-46.4 57.3l0 294.7 160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-23.5-10.3-41.2-31.6-46.4-57.3L128 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32zm55.6 288L584.4 320 512 195.8 439.6 320zM512 416c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9zM126.8 195.8L54.4 320 199.3 320 126.8 195.8zM.9 337.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9S11.7 382 .9 337.1z"
    ]
};
var $159afdcd077ecfe9$export$fec323dcfd81d750 = $159afdcd077ecfe9$export$33fb4280dc20f0dd;
var $159afdcd077ecfe9$export$9eefe7fcdf123b76 = {
    prefix: 'fas',
    iconName: 'car',
    icon: [
        512,
        512,
        [
            128664,
            "automobile"
        ],
        "f1b9",
        "M135.2 117.4l-26.1 74.6 293.8 0-26.1-74.6C372.3 104.6 360.2 96 346.6 96L165.4 96c-13.6 0-25.7 8.6-30.2 21.4zM39.6 196.8L74.8 96.3C88.3 57.8 124.6 32 165.4 32l181.2 0c40.8 0 77.1 25.8 90.6 64.3l35.2 100.5c23.2 9.6 39.6 32.5 39.6 59.2l0 192c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-320 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32L0 256c0-26.7 16.4-49.6 39.6-59.2zM128 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$240a6c53cf7ac525 = $159afdcd077ecfe9$export$9eefe7fcdf123b76;
var $159afdcd077ecfe9$export$c3605731beb92daf = {
    prefix: 'fas',
    iconName: 'crop-simple',
    icon: [
        512,
        512,
        [
            "crop-alt"
        ],
        "f565",
        "M128 32c0-17.7-14.3-32-32-32S64 14.3 64 32l0 32-32 0C14.3 64 0 78.3 0 96s14.3 32 32 32l32 0 0 256c0 35.3 28.7 64 64 64l208 0 0-64-208 0 0-352zM384 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-256c0-35.3-28.7-64-64-64l-208 0 0 64 208 0 0 352z"
    ]
};
var $159afdcd077ecfe9$export$d932915fde4f1010 = $159afdcd077ecfe9$export$c3605731beb92daf;
var $159afdcd077ecfe9$export$b48a5be96314835a = {
    prefix: 'fas',
    iconName: 'medal',
    icon: [
        448,
        512,
        [
            127941
        ],
        "f5a2",
        "M224.3 128L139.7-12.9c-6.5-10.8-20.1-14.7-31.3-9.1L21.8 21.3C9.9 27.2 5.1 41.6 11 53.5L80.6 192.6c-30.1 33.9-48.3 78.5-48.3 127.4 0 106 86 192 192 192s192-86 192-192c0-48.9-18.3-93.5-48.3-127.4L437.6 53.5c5.9-11.9 1.1-26.3-10.7-32.2L340.2-22.1c-11.2-5.6-24.9-1.6-31.3 9.1L224.3 128zm30.8 142.5c1.4 2.8 4 4.7 7 5.1l50.1 7.3c7.7 1.1 10.7 10.5 5.2 16l-36.3 35.4c-2.2 2.2-3.2 5.2-2.7 8.3l8.6 49.9c1.3 7.6-6.7 13.5-13.6 9.9l-44.8-23.6c-2.7-1.4-6-1.4-8.7 0l-44.8 23.6c-6.9 3.6-14.9-2.2-13.6-9.9l8.6-49.9c.5-3-.5-6.1-2.7-8.3l-36.3-35.4c-5.6-5.4-2.5-14.8 5.2-16l50.1-7.3c3-.4 5.7-2.4 7-5.1l22.4-45.4c3.4-7 13.3-7 16.8 0l22.4 45.4z"
    ]
};
var $159afdcd077ecfe9$export$7c265716d4399676 = {
    prefix: 'fas',
    iconName: 'scroll',
    icon: [
        576,
        512,
        [
            128220
        ],
        "f70e",
        "M0 112C0 70.5 31.6 36.4 72 32.4l0-.4 280 0c53 0 96 43 96 96l0 176-176 0c-39.8 0-72 32.2-72 72l0 60c0 24.3-19.7 44-44 44s-44-19.7-44-44l0-228-64 0c-26.5 0-48-21.5-48-48l0-48zM236.8 480c7.1-13.1 11.2-28.1 11.2-44l0-60c0-13.3 10.7-24 24-24l248 0c13.3 0 24 10.7 24 24l0 24c0 44.2-35.8 80-80 80l-227.2 0zM80 80c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$77cb1a465c4fe84 = {
    prefix: 'fas',
    iconName: 'file-excel',
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM164 266.7c-7.4-11-22.3-14-33.3-6.7s-14 22.3-6.7 33.3L163.2 352 124 410.7c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l28-42 28 42c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3L220.8 352 260 293.3c7.4-11 4.4-25.9-6.7-33.3s-25.9-4.4-33.3 6.7l-28 42-28-42z"
    ]
};
var $159afdcd077ecfe9$export$f253a38d7142e29f = {
    prefix: 'fas',
    iconName: 'filter',
    icon: [
        512,
        512,
        [],
        "f0b0",
        "M32 64C19.1 64 7.4 71.8 2.4 83.8S.2 109.5 9.4 118.6L192 301.3 192 416c0 8.5 3.4 16.6 9.4 22.6l64 64c9.2 9.2 22.9 11.9 34.9 6.9S320 492.9 320 480l0-178.7 182.6-182.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 64 480 64L32 64z"
    ]
};
var $159afdcd077ecfe9$export$5b9205e1042594b7 = {
    prefix: 'fas',
    iconName: 'drum',
    icon: [
        512,
        512,
        [
            129345
        ],
        "f569",
        "M501.2 76.1c11.1-7.3 14.2-22.1 6.9-33.2s-22.1-14.2-33.2-6.9L370.2 104.5C335.8 98.7 297 96 256 96 114.6 96 0 128 0 208L0 368c0 31.3 27.4 58.8 72 78.7L72 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 119.4c33 8.9 71.1 14.5 112 16.1L232 376c0-13.3 10.7-24 24-24s24 10.7 24 24l0 103.5c40.9-1.6 79-7.2 112-16.1L392 344c0-13.3 10.7-24 24-24s24 10.7 24 24l0 102.7c44.6-19.9 72-47.4 72-78.7l0-160c0-41.1-30.2-69.5-78.8-87.4l67.9-44.5zM307.4 145.6l-64.6 42.3c-11.1 7.3-14.2 22.1-6.9 33.2s22.1 14.2 33.2 6.9l111.1-72.8c14.7 3.2 27.9 7 39.4 11.5 38.8 15.1 44.4 30.6 44.4 41.3 0 .8-2.7 17.2-46 35.9-38.9 16.8-96 28.1-162 28.1S132.9 260.7 94 243.9c-43.3-18.7-46-35.1-46-35.9 0-10.6 5.6-26.2 44.4-41.3 38.3-14.9 95.4-22.7 163.6-22.7 18 0 35.1 .5 51.4 1.6z"
    ]
};
var $159afdcd077ecfe9$export$184725965b3402dc = {
    prefix: 'fas',
    iconName: 'map-pin',
    icon: [
        320,
        512,
        [
            128205
        ],
        "f276",
        "M192 284.4C256.1 269.9 304 212.5 304 144 304 64.5 239.5 0 160 0S16 64.5 16 144c0 68.5 47.9 125.9 112 140.4L128 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-195.6zM168 96c-30.9 0-56 25.1-56 56 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4 46.6-104 104-104 13.3 0 24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $159afdcd077ecfe9$export$f4d7840209109993 = {
    prefix: 'fas',
    iconName: 'scale-unbalanced-flip',
    icon: [
        640,
        512,
        [
            "balance-scale-right"
        ],
        "f516",
        "M118.2 62.4C101.5 56.8 92.4 38.6 98 21.9S121.7-3.9 138.5 1.6l113 37.7c13.9-23.5 39.6-39.3 68.9-39.3 44.2 0 80 35.8 80 80 0 3-.2 5.9-.5 8.8l122.6 40.9c16.8 5.6 25.8 23.7 20.2 40.5s-23.7 25.8-40.5 20.2L366.7 145.2c-4.5 3.2-9.3 5.9-14.4 8.2l0 326.7c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0 0-294.7c-21-9.2-37.2-27-44.2-49l-125.9-42zM200.8 288L128.3 163.8 55.9 288 200.8 288zm-72.4 96c-62.9 0-115.2-34-126-78.9-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1-10.8 44.8-63.1 78.9-126 78.9zm382.8-92.2l-72.4 124.2 144.9 0-72.4-124.2zm126 141.3C626.4 478 574.1 512 511.2 512s-115.2-34-126-78.9c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8l95.2 163.2c5.7 9.8 9.3 21.1 6.7 32.1z"
    ]
};
var $159afdcd077ecfe9$export$2238e05f8920005a = $159afdcd077ecfe9$export$f4d7840209109993;
var $159afdcd077ecfe9$export$917a3d30f6cd766 = {
    prefix: 'fas',
    iconName: 'arrows-to-circle',
    icon: [
        512,
        512,
        [],
        "e4bd",
        "M9.4 9.4C21.9-3.1 42.1-3.1 54.6 9.4L128 82.7 128 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l18.7 0-73.4-73.4C-3.1 42.1-3.1 21.9 9.4 9.4zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM502.6 54.6L429.3 128 448 128c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 18.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-45.3 448L384 429.3 384 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-18.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0zM9.4 457.4L82.7 384 64 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.7-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3z"
    ]
};
var $159afdcd077ecfe9$export$6f095630677adc = {
    prefix: 'fas',
    iconName: 'envelope',
    icon: [
        512,
        512,
        [
            128386,
            9993,
            61443
        ],
        "f0e0",
        "M48 64c-26.5 0-48 21.5-48 48 0 15.1 7.1 29.3 19.2 38.4l208 156c17.1 12.8 40.5 12.8 57.6 0l208-156c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48L48 64zM0 196L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-188-198.4 148.8c-34.1 25.6-81.1 25.6-115.2 0L0 196z"
    ]
};
var $159afdcd077ecfe9$export$8afab767536f59ad = {
    prefix: 'fas',
    iconName: 'baby',
    icon: [
        384,
        512,
        [],
        "f77c",
        "M120 88a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM7.7 144.5c13-17.9 38-21.8 55.9-8.8L99.8 162c26.8 19.5 59.1 30 92.2 30s65.4-10.5 92.2-30l36.2-26.4c17.9-13 42.9-9 55.9 8.8s9 42.9-8.8 55.9l-36.2 26.4c-13.6 9.9-28.1 18.2-43.3 25l0 36.3-192 0 0-36.3c-15.2-6.7-29.7-15.1-43.3-25L16.5 200.3c-17.9-13-21.8-38-8.8-55.9zM97.5 329.3l60.6 53-26 37.2 24.3 24.3c15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-48-48C38 438.6 36.1 417 47.2 401.1l50.2-71.8zm128.5 53l60.6-53 50.2 71.8c11.1 15.9 9.2 37.5-4.5 51.2l-48 48c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6l24.3-24.3-26-37.2z"
    ]
};
var $159afdcd077ecfe9$export$a1ab39cd66c4e50e = {
    prefix: 'fas',
    iconName: 'square-caret-down',
    icon: [
        448,
        512,
        [
            "caret-square-down"
        ],
        "f150",
        "M384 480c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0zM224 352c-6.7 0-13-2.8-17.6-7.7l-104-112c-6.5-7-8.2-17.2-4.4-25.9S110.5 192 120 192l208 0c9.5 0 18.2 5.7 22 14.4s2.1 18.9-4.4 25.9l-104 112c-4.5 4.9-10.9 7.7-17.6 7.7z"
    ]
};
var $159afdcd077ecfe9$export$61aea18df1c84401 = $159afdcd077ecfe9$export$a1ab39cd66c4e50e;
var $159afdcd077ecfe9$export$e5075400db564e24 = {
    prefix: 'fas',
    iconName: 'tent',
    icon: [
        512,
        512,
        [],
        "e57d",
        "M26.9 206.9L3.7 444.9C1.8 463.7 16.6 480 35.5 480l172.7 0c26.5 0 48-21.5 48-48l0-129c0-8.3 6.7-15 15-15 5.5 0 10.6 3 13.2 7.9l86.1 159c8.4 15.5 24.6 25.1 42.2 25.1l64.1 0c18.9 0 33.7-16.3 31.8-35.1L485.6 207.1c-1.9-19.6-12.8-37.3-29.5-47.8L280.9 48.3c-15.7-10-35.8-9.9-51.5 .1L56.1 159.2c-16.5 10.6-27.3 28.2-29.2 47.7z"
    ]
};
var $159afdcd077ecfe9$export$406fe05808a3753e = {
    prefix: 'fas',
    iconName: 'a',
    icon: [
        384,
        512,
        [
            97
        ],
        "41",
        "M221.5 51.7C216.6 39.8 204.9 32 192 32s-24.6 7.8-29.5 19.7c-93.3 224-146.7 352-160 384-6.8 16.3 .9 35 17.2 41.8s35-.9 41.8-17.2l31.8-76.3 197.3 0 31.8 76.3c6.8 16.3 25.5 24 41.8 17.2s24-25.5 17.2-41.8c-13.3-32-66.7-160-160-384zM264 320l-144 0 72-172.8 72 172.8z"
    ]
};
var $159afdcd077ecfe9$export$ca9e3368f1d9500a = {
    prefix: 'fas',
    iconName: 'parachute-box',
    icon: [
        512,
        512,
        [],
        "f4cd",
        "M128 224C128 152.2 144.3 88.4 169.5 43.4 195.1-2.4 226.6-24 256-24s60.9 21.6 86.5 67.4C367.7 88.4 384 152.2 384 224l-104 0 0 96 8 0c9.3 0 18.1 2 26 5.5l118.4-101.5-.5 0c0-78.4-17.7-150.6-47.6-204-6.1-11-12.9-21.3-20.3-30.9 86.5 35.9 147.8 115.1 147.8 218.9 0 7-3.1 13.7-8.4 18.2L347.4 360.1c3 7.4 4.6 15.4 4.6 23.9l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-64c0-8.4 1.6-16.5 4.6-23.9L8.4 226.2C3.1 221.7 0 215 0 208 0 104.2 61.3 24.9 147.8-10.9 140.5-1.4 133.7 9 127.6 20 97.7 73.4 80 145.6 80 224l-.5 0 118.4 101.5c8-3.5 16.8-5.5 26-5.5l8 0 0-96-104 0z"
    ]
};
var $159afdcd077ecfe9$export$9206260ff0c0c616 = {
    prefix: 'fas',
    iconName: 'cart-arrow-down',
    icon: [
        640,
        512,
        [],
        "f218",
        "M0 8C0-5.3 10.7-16 24-16l45.3 0c27.1 0 50.3 19.4 55.1 46l.4 2 187.2 0 0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-102.1 177.4 0c20 0 35.1 18.2 31.4 37.9L537.8 235.8c-5.7 30.3-32.1 52.2-62.9 52.2l-303.6 0 5.1 28.3c2.1 11.4 12 19.7 23.6 19.7L456 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-255.9 0c-34.8 0-64.6-24.9-70.8-59.1L77.2 38.6c-.7-3.8-4-6.6-7.9-6.6L24 32C10.7 32 0 21.3 0 8zM160 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $159afdcd077ecfe9$export$4f25939fdf728c27 = {
    prefix: 'fas',
    iconName: 'bridge-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e4ca",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l8 0 0 64-40 0 0 112c37.6 9.4 64 43.2 64 82l0 94c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96 6.4 0 12.7 .6 18.7 1.8 34.7-49.5 92.2-81.8 157.3-81.8 28.6 0 55.6 6.2 80 17.4l0-65.4-40 0 0-64 8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM424 96l0 64-80 0 0-64 80 0zM296 96l0 64-80 0 0-64 80 0zM88 96l80 0 0 64-80 0 0-64zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-140c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$3507214fff1cc655 = {
    prefix: 'fas',
    iconName: 'cloud-arrow-up',
    icon: [
        576,
        512,
        [
            62338,
            "cloud-upload",
            "cloud-upload-alt"
        ],
        "f0ee",
        "M144 480c-79.5 0-144-64.5-144-144 0-63.4 41-117.2 97.9-136.5-1.3-7.7-1.9-15.5-1.9-23.5 0-79.5 64.5-144 144-144 55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96 0 15.7-3.8 30.6-10.5 43.7 44 20.3 74.5 64.7 74.5 116.3 0 70.7-57.3 128-128 128l-304 0zM305 191c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 102.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z"
    ]
};
var $159afdcd077ecfe9$export$a48720e6366f5d9a = $159afdcd077ecfe9$export$3507214fff1cc655;
var $159afdcd077ecfe9$export$e73b3e819b9d14a5 = $159afdcd077ecfe9$export$3507214fff1cc655;
var $159afdcd077ecfe9$export$c115e8063ee02632 = {
    prefix: 'fas',
    iconName: 'at',
    icon: [
        512,
        512,
        [
            61946
        ],
        "40",
        "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0 512 114.6 512 256l0 32c0 53-43 96-96 96-29.3 0-55.6-13.2-73.2-33.9-22.8 21-53.3 33.9-86.8 33.9-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1 5.7-5 13.1-8.1 21.3-8.1 17.7 0 32 14.3 32 32l0 112c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $159afdcd077ecfe9$export$1d2b135cc5a2c852 = {
    prefix: 'fas',
    iconName: 'indian-rupee-sign',
    icon: [
        320,
        512,
        [
            "indian-rupee",
            "inr"
        ],
        "e1bc",
        "M0 64C0 46.3 14.3 32 32 32l264 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-76.7 0c17.7 19.8 30.1 44.6 34.7 72l42 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-42 0c-10.4 62.2-60.8 110.9-123.8 118.9L274.6 422c14.4 10.3 17.7 30.3 7.4 44.6s-30.3 17.7-44.6 7.4L13.4 314C2.1 306-2.7 291.5 1.5 278.2S18.1 256 32 256l80 0c35.8 0 66.1-23.5 76.3-56L24 200c-13.3 0-24-10.7-24-24s10.7-24 24-24l164.3 0c-10.2-32.5-40.5-56-76.3-56L32 96C14.3 96 0 81.7 0 64z"
    ]
};
var $159afdcd077ecfe9$export$be886a4def17c565 = $159afdcd077ecfe9$export$1d2b135cc5a2c852;
var $159afdcd077ecfe9$export$12c6d8b3e052490b = $159afdcd077ecfe9$export$1d2b135cc5a2c852;
var $159afdcd077ecfe9$export$d7895f386f8bd8b8 = {
    prefix: 'fas',
    iconName: 'truck',
    icon: [
        576,
        512,
        [
            128666,
            9951
        ],
        "f0d1",
        "M0 96C0 60.7 28.7 32 64 32l288 0c35.3 0 64 28.7 64 64l0 32 50.7 0c17 0 33.3 6.7 45.3 18.7L557.3 192c12 12 18.7 28.3 18.7 45.3L576 384c0 35.3-28.7 64-64 64l-3.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64L64 448c-35.3 0-64-28.7-64-64L0 96zM512 288l0-50.7-45.3-45.3-50.7 0 0 96 96 0zM192 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm232 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $159afdcd077ecfe9$export$fd7622d4b8d3674b = {
    prefix: 'fas',
    iconName: 'chalkboard-user',
    icon: [
        640,
        512,
        [
            "chalkboard-teacher"
        ],
        "f51c",
        "M128 96c0-35.3 28.7-64 64-64l352 0c35.3 0 64 28.7 64 64l0 240-96 0 0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 16-129.1 0c10.9-18.8 17.1-40.7 17.1-64 0-70.7-57.3-128-128-128-5.4 0-10.8 .3-16 1l0-49zM333 448c-5.1-24.2-16.3-46.1-32.1-64L608 384c0 35.3-28.7 64-64 64l-211 0zM64 272a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM0 480c0-53 43-96 96-96l96 0c53 0 96 43 96 96 0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$443fcf69b0155291 = $159afdcd077ecfe9$export$fd7622d4b8d3674b;
var $159afdcd077ecfe9$export$76de2a120043c9f8 = {
    prefix: 'fas',
    iconName: 'user-check',
    icon: [
        640,
        512,
        [],
        "f4fc",
        "M286 304c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7L78 512c-16.4 0-29.7-13.3-29.7-29.7 0-98.5 79.8-178.3 178.3-178.3l59.4 0zM585.7 105.9c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5L522.1 274.9c-4.2 5.7-10.7 9.4-17.7 9.8s-14-2.2-18.9-7.3l-46.4-48c-9.2-9.5-9-24.7 .6-33.9 9.5-9.2 24.7-8.9 33.9 .6l26.5 27.4 85.6-117.7zM256.3 248a120 120 0 1 1 0-240 120 120 0 1 1 0 240z"
    ]
};
var $159afdcd077ecfe9$export$a9174995732e03c5 = {
    prefix: 'fas',
    iconName: 'user-ninja',
    icon: [
        448,
        512,
        [
            129399
        ],
        "f504",
        "M352 128c0 70.7-57.3 128-128 128-57.2 0-105.6-37.5-122-89.3-1.1 1.3-2.2 2.6-3.5 3.8-15.8 15.8-38.8 20.7-53.6 22.1-8.1 .8-14.6-5.7-13.8-13.8 1.4-14.7 6.3-37.8 22.1-53.6 5.8-5.8 12.6-10.1 19.6-13.4-7-3.2-13.8-7.6-19.6-13.4-15.8-15.8-20.7-38.8-22.1-53.6-.8-8.1 5.7-14.6 13.8-13.8 14.7 1.4 37.8 6.3 53.6 22.1 4.8 4.8 8.7 10.4 11.7 16.1 21.3-41.2 64.3-69.4 113.8-69.4 70.7 0 128 57.3 128 128zM144 112c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L160 96c-8.8 0-16 7.2-16 16zm-1.4 211l67 50.2c8.5 6.4 20.3 6.4 28.8 0l67-50.2c6.5-4.9 15.2-6.2 22.6-2.8 61.4 28.2 104.1 90.2 104.1 162.1 0 16.4-13.3 29.7-29.7 29.7L45.7 512c-16.4 0-29.7-13.3-29.7-29.7 0-72 42.7-134 104.1-162.1 7.4-3.4 16.1-2.1 22.6 2.8z"
    ]
};
var $159afdcd077ecfe9$export$77a38850ff8b0407 = {
    prefix: 'fas',
    iconName: 'plant-wilt',
    icon: [
        512,
        512,
        [],
        "e5aa",
        "M344-32c66.3 0 120 53.7 120 120l0 6.2c29.3 12.2 48 41.3 48 76.9 0 27.9-25.3 74.8-66 111.7-3.8 3.5-8.8 5.3-14 5.3s-10.2-1.8-14-5.3c-40.7-36.8-66-83.7-66-111.7 0-35.6 18.7-64.7 48-76.9l0-6.2c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 424c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-296c0-30.9-25.1-56-56-56s-56 25.1-56 56l0 38.2c29.3 12.2 48 41.3 48 76.9 0 27.9-25.3 74.8-66 111.7-3.8 3.5-8.8 5.3-14 5.3s-10.2-1.8-14-5.3C25.3 405.9 0 359 0 331.1 0 295.4 18.7 266.4 48 254.2L48 216c0-66.3 53.7-120 120-120 20.2 0 39.3 5 56 13.8L224 88c0-66.3 53.7-120 120-120z"
    ]
};
var $159afdcd077ecfe9$export$e521c542d18b85c3 = {
    prefix: 'fas',
    iconName: 'weight-scale',
    icon: [
        448,
        512,
        [
            "weight"
        ],
        "f496",
        "M116.6 192c-3-10.1-4.6-20.9-4.6-32 0-61.9 50.1-112 112-112S336 98.1 336 160c0 11.1-1.6 21.9-4.6 32l-71 0 24.6-44.3c6.4-11.6 2.3-26.2-9.3-32.6s-26.2-2.3-32.6 9.3l-37.6 67.7-88.8 0zM128 32L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-64 0C293.3 11.9 260 0 224 0s-69.3 11.9-96 32z"
    ]
};
var $159afdcd077ecfe9$export$cf3bafa68a60bae4 = $159afdcd077ecfe9$export$e521c542d18b85c3;
var $159afdcd077ecfe9$export$f1011352b01c1c0 = {
    prefix: 'fas',
    iconName: 'caret-right',
    icon: [
        256,
        512,
        [],
        "f0da",
        "M32.5 96c0-12.9 7.8-24.6 19.8-29.6S78 64.2 87.1 73.4l160 160c12.5 12.5 12.5 32.8 0 45.3l-160 160c-9.2 9.2-22.9 11.9-34.9 6.9S32.5 428.9 32.5 416l0-320z"
    ]
};
var $159afdcd077ecfe9$export$6248ec7440b2ffcb = {
    prefix: 'fas',
    iconName: 'florin-sign',
    icon: [
        384,
        512,
        [],
        "e184",
        "M314.7 32c-38.8 0-73.7 23.3-88.6 59.1L170.7 224 64 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l80 0-45.1 108.3c-5 11.9-16.6 19.7-29.5 19.7L32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l37.3 0c38.8 0 73.7-23.3 88.6-59.1L213.3 288 320 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 45.1-108.3c5-11.9 16.6-19.7 29.5-19.7L352 96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-37.3 0z"
    ]
};
var $159afdcd077ecfe9$export$9b6162797ab1b255 = {
    prefix: 'fas',
    iconName: 'bell',
    icon: [
        448,
        512,
        [
            128276,
            61602
        ],
        "f0f3",
        "M224 0c-17.7 0-32 14.3-32 32l0 3.2C119 50 64 114.6 64 192l0 21.7c0 48.1-16.4 94.8-46.4 132.4L7.8 358.3C2.7 364.6 0 372.4 0 380.5 0 400.1 15.9 416 35.5 416l376.9 0c19.6 0 35.5-15.9 35.5-35.5 0-8.1-2.7-15.9-7.8-22.2l-9.8-12.2C400.4 308.5 384 261.8 384 213.7l0-21.7c0-77.4-55-142-128-156.8l0-3.2c0-17.7-14.3-32-32-32zM162 464c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48l-124 0z"
    ]
};
var $159afdcd077ecfe9$export$d317bc452442782d = {
    prefix: 'fas',
    iconName: 'lari-sign',
    icon: [
        384,
        512,
        [],
        "e1c8",
        "M144 0c13.3 0 24 10.7 24 24l0 41.5c7.9-1 15.9-1.5 24-1.5s16.1 .5 24 1.5L216 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 54c58.9 23.8 103.2 76 116.2 139.7 3.5 17.3-7.7 34.2-25 37.7s-34.2-7.7-37.7-25c-6.7-33.2-26.4-61.8-53.4-80.2l0 81.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-101.8c-7.8-1.5-15.8-2.2-24-2.2s-16.2 .8-24 2.2L168 232c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-81.8c-33.8 23-56 61.9-56 105.8 0 70.7 57.3 128 128 128l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l16.9 0C18.5 350 0 305.2 0 256 0 175.4 49.6 106.4 120 78l0-54c0-13.3 10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$9b53510cf4010e4d = {
    prefix: 'fas',
    iconName: 'mill-sign',
    icon: [
        384,
        512,
        [],
        "e1ed",
        "M297-22.2c12.3 5 18.2 19 13.2 31.3l-29 71.3C338.8 85.1 384 133.3 384 192l0 208c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-208c0-26.5-21.5-48-48-48-6.4 0-12.5 1.2-18 3.5l-30 73.8 0 178.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-21.2-57.8 142.2c-5 12.3-19 18.2-31.3 13.2s-18.2-19-13.2-31.3L160 251.3 160 192c0-26.5-21.5-48-48-48s-48 21.5-48 48l0 208c0 17.7-14.3 32-32 32S0 417.7 0 400L0 112c0-17.7 14.3-32 32-32 10.9 0 20.5 5.4 26.3 13.7 16-8.7 34.3-13.7 53.7-13.7 31.3 0 59.7 12.9 80 33.6 9.6-9.8 20.9-17.8 33.5-23.5L265.8-9c5-12.3 19-18.2 31.3-13.2z"
    ]
};
var $159afdcd077ecfe9$export$22c642403aeeaeaf = {
    prefix: 'fas',
    iconName: 'person-snowboarding',
    icon: [
        576,
        512,
        [
            127938,
            "snowboarding"
        ],
        "f7ce",
        "M424.5 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM166.4 45.5c10.2-14.4 30.2-17.9 44.6-7.7l272 192c14.4 10.2 17.9 30.2 7.7 44.6s-30.2 17.9-44.6 7.7l-92.2-65.1-62.2 53.3 32.1 26.7c18.2 15.2 28.8 37.7 28.8 61.5l0 87.8 77.5 15.2c6.2 1.2 12.6 .9 18.7-.8l41.2-11.8c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-41.2 11.8c-13.4 3.8-27.4 4.4-41.1 1.8L87.1 443.3c-17.2-3.4-33-11.8-45.3-24.1L15.5 393c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l26.2 26.2c5.6 5.6 12.8 9.4 20.6 11l64.2 12.6 0-123.7c0-27.7 12-54 32.8-72.2l69-60.4-88.2-62.3C159.6 80 156.2 60 166.4 45.5zm58.1 375.7l64 12.5 0-75.3c0-4.7-2.1-9.3-5.8-12.3l-58.2-48.5 0 123.6z"
    ]
};
var $159afdcd077ecfe9$export$72683772d587302a = $159afdcd077ecfe9$export$22c642403aeeaeaf;
var $159afdcd077ecfe9$export$7c85aba0f9624b29 = {
    prefix: 'fas',
    iconName: 'tty',
    icon: [
        512,
        512,
        [
            "teletype"
        ],
        "f1e4",
        "M450.2 266.8c15.8 6.5 34.1 .3 42.6-14.6l2.4-4.2c27.9-48.9 23.6-118.8-31.3-154.5-126-82-289.6-82-415.6 0-54.9 35.7-59.3 105.7-31.3 154.5l2.4 4.2c8.5 14.9 26.7 21.1 42.6 14.6l81.9-33.7c13.9-5.7 22.4-19.9 20.9-34.9l-5.1-51c62.5-21 130.8-19.9 192.6 3.3l-4.8 47.7c-1.5 15 7 29.2 20.9 34.9l81.9 33.7zM32 352a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM64 416a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm352 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM256 320a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm128-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM128 448c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32z"
    ]
};
var $159afdcd077ecfe9$export$14bcd5c43dc736f9 = $159afdcd077ecfe9$export$7c85aba0f9624b29;
var $159afdcd077ecfe9$export$a28757068b9a3a9a = {
    prefix: 'fas',
    iconName: 'users-rectangle',
    icon: [
        576,
        512,
        [],
        "e594",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm224 72a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 152c53 0 96 43 96 96l0 24c0 13.3-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24l0-24c0-53 43-96 96-96zm96-64a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM168 272.3c-15.2 22.8-24 50.2-24 79.7l0 24c0 8.4 1.4 16.5 4.1 24l-46.8 0C89.6 400 80 390.4 80 378.7L80 368c0-50.3 38.7-91.6 88-95.7zM427.9 400c2.7-7.5 4.1-15.6 4.1-24l0-24c0-29.5-8.8-56.9-24-79.7 49.3 4.1 88 45.3 88 95.7l0 10.7c0 11.8-9.6 21.3-21.3 21.3l-46.8 0zM96 192a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $159afdcd077ecfe9$export$59edacfad04cd121 = {
    prefix: 'fas',
    iconName: 'mobile',
    icon: [
        384,
        512,
        [
            128241,
            "mobile-android",
            "mobile-phone"
        ],
        "f3ce",
        "M80 0C44.7 0 16 28.7 16 64l0 384c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L80 0zm72 416l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$82f602311a698c32 = $159afdcd077ecfe9$export$59edacfad04cd121;
var $159afdcd077ecfe9$export$475a9be8da747e57 = $159afdcd077ecfe9$export$59edacfad04cd121;
var $159afdcd077ecfe9$export$b9d8fdf63999a76d = {
    prefix: 'fas',
    iconName: 'arrows-turn-to-dots',
    icon: [
        448,
        512,
        [],
        "e4c1",
        "M265.4-6.6c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L285.3 64 352 64c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32c0-17.7-14.3-32-32-32l-66.7 0 25.4 25.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3l80-80zm-82.7 272l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L162.7 400 96 400c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32S0 481.7 0 464l0-32c0-53 43-96 96-96l66.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0zM320 368a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM64 160a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"
    ]
};
var $159afdcd077ecfe9$export$de6218b649cbb6a9 = {
    prefix: 'fas',
    iconName: 'exclamation',
    icon: [
        128,
        512,
        [
            10069,
            10071,
            61738
        ],
        "21",
        "M64 432c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40c0-22.1 17.9-40 40-40zM64 0c26.5 0 48 21.5 48 48 0 .6 0 1.1 0 1.7l-16 304c-.9 17-15 30.3-32 30.3S33 370.7 32 353.7L16 49.7c0-.6 0-1.1 0-1.7 0-26.5 21.5-48 48-48z"
    ]
};
var $159afdcd077ecfe9$export$16a3f12c6ae9650 = {
    prefix: 'fas',
    iconName: 'church',
    icon: [
        512,
        512,
        [
            9962
        ],
        "f51d",
        "M280-8c0-13.3-10.7-24-24-24S232-21.3 232-8l0 24-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 48-98.6 65.8C120 186.7 112 201.6 112 217.7l0 38.3-79.8 45.6C12.3 313 0 334.2 0 357.1L0 448c0 35.3 28.7 64 64 64 74.7 0 85.4 0 320 0l64 0c35.3 0 64-28.7 64-64l0-90.9c0-23-12.3-44.2-32.2-55.6L400 256 400 217.7c0-16-8-31-21.4-39.9l-98.6-65.8 0-48 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-24zM256 320c35.3 0 64 28.7 64 64l0 80-128 0 0-80c0-35.3 28.7-64 64-64z"
    ]
};
var $159afdcd077ecfe9$export$d20aaceb882ca545 = {
    prefix: 'fas',
    iconName: 'toggle-off',
    icon: [
        576,
        512,
        [],
        "f204",
        "M384 128c70.7 0 128 57.3 128 128S454.7 384 384 384l-192 0c-70.7 0-128-57.3-128-128s57.3-128 128-128l192 0zM576 256c0-106-86-192-192-192L192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192zM192 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var $159afdcd077ecfe9$export$cdbdd2118099ae07 = {
    prefix: 'fas',
    iconName: 'shoe-prints',
    icon: [
        576,
        512,
        [],
        "f54b",
        "M296 192c-21.1-12.1-42.3-24.2-72-29.3l0-140.3C257.7 13 311.4 0 352 0 448 0 576 48 576 128s-119.6 96-176 96c-48 0-76-16-104-32zM128 32l48 0 0 128-48 0c-35.3 0-64-28.7-64-64s28.7-64 64-64zM232 320c28-16 56-32 104-32 56.4 0 176 16 176 96S384 512 288 512c-40.5 0-94.3-13-128-22.4l0-140.3c29.7-5.2 50.9-17.3 72-29.4zM64 480c-35.3 0-64-28.7-64-64s28.7-64 64-64l48 0 0 128-48 0z"
    ]
};
var $159afdcd077ecfe9$export$61fa9809253098e5 = {
    prefix: 'fas',
    iconName: 'file-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e4eb",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3l0-38.1c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-140c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$79204db8777905c8 = {
    prefix: 'fas',
    iconName: 'wallet',
    icon: [
        512,
        512,
        [],
        "f555",
        "M64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L72 128c-13.3 0-24-10.7-24-24S58.7 80 72 80l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L64 32zM416 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$6563a67224e7f879 = {
    prefix: 'fas',
    iconName: 'message',
    icon: [
        512,
        512,
        [
            "comment-alt"
        ],
        "f27a",
        "M0 352L0 128C0 75 43 32 96 32l320 0c53 0 96 43 96 96l0 224c0 53-43 96-96 96l-120 0c-5.2 0-10.2 1.7-14.4 4.8L166.4 539.2c-4.2 3.1-9.2 4.8-14.4 4.8-13.3 0-24-10.7-24-24l0-72-32 0c-53 0-96-43-96-96z"
    ]
};
var $159afdcd077ecfe9$export$6e96904d9af0ec4a = $159afdcd077ecfe9$export$6563a67224e7f879;
var $159afdcd077ecfe9$export$29c432d69ccf85a5 = {
    prefix: 'fas',
    iconName: 'trophy',
    icon: [
        512,
        512,
        [
            127942
        ],
        "f091",
        "M144.3 0l224 0c26.5 0 48.1 21.8 47.1 48.2-.2 5.3-.4 10.6-.7 15.8l49.6 0c26.1 0 49.1 21.6 47.1 49.8-7.5 103.7-60.5 160.7-118 190.5-15.8 8.2-31.9 14.3-47.2 18.8-20.2 28.6-41.2 43.7-57.9 51.8l0 73.1 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 0-73.1c-16-7.7-35.9-22-55.3-48.3-18.4-4.8-38.4-12.1-57.9-23.1-54.1-30.3-102.9-87.4-109.9-189.9-1.9-28.1 21-49.7 47.1-49.7l49.6 0c-.3-5.2-.5-10.4-.7-15.8-1-26.5 20.6-48.2 47.1-48.2zM101.5 112l-52.4 0c6.2 84.7 45.1 127.1 85.2 149.6-14.4-37.3-26.3-86-32.8-149.6zM380 256.8c40.5-23.8 77.1-66.1 83.3-144.8L411 112c-6.2 60.9-17.4 108.2-31 144.8z"
    ]
};
var $159afdcd077ecfe9$export$635e4d8cc8428961 = {
    prefix: 'fas',
    iconName: 'face-dizzy',
    icon: [
        512,
        512,
        [
            "dizzy"
        ],
        "f567",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM134.1 153.9l25.9 25.9 25.9-25.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3l-25.9 25.9 25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-25.9-25.9-25.9 25.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l25.9-25.9-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0zm192 0l25.9 25.9 25.9-25.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3l-25.9 25.9 25.9 25.9c7.8 7.8 7.8 20.5 0 28.3s-20.5 7.8-28.3 0l-25.9-25.9-25.9 25.9c-7.8 7.8-20.5 7.8-28.3 0s-7.8-20.5 0-28.3l25.9-25.9-25.9-25.9c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0zM256 304a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $159afdcd077ecfe9$export$89a2b10dabc487e8 = $159afdcd077ecfe9$export$635e4d8cc8428961;
var $159afdcd077ecfe9$export$7fc18cf2d526c341 = {
    prefix: 'fas',
    iconName: 'bacteria',
    icon: [
        640,
        512,
        [],
        "e059",
        "M256-32c13.3 0 24 10.7 24 24l0 11c8.6 2.2 16.9 5.6 24.8 10.3L311 7c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-6.3 6.3c4.6 7.8 8 16.2 10.3 24.8l11 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11 0c-2.2 8.6-5.6 16.9-10.3 24.8L345 151c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-4.1-4.1-30.1 30.1 4.1 4.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-4.1-4.1c-10 10-20 20-30.1 30.1L217 279c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-6.3-6.3c-7.8 4.6-16.2 8-24.8 10.3l0 11c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11c-8.6-2.2-16.9-5.6-24.8-10.3L73 313c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l6.3-6.3c-4.6-7.8-8-16.2-10.3-24.8l-11 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l11 0c2.2-8.6 5.6-16.9 10.3-24.8L39 169c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l4.1 4.1c10-10 20-20 30.1-30.1L103 105c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l4.1 4.1 30.1-30.1-4.1-4.1c-9.4-9.4-9.4-24.6 0-33.9S191.6-2.3 201 7l6.3 6.3c7.8-4.6 16.2-8 24.8-10.3l0-11c0-13.3 10.7-24 24-24zM128 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM240 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm296 40l0 11c8.6 2.2 16.9 5.6 24.8 10.3L567 199c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-6.3 6.3c4.6 7.8 8 16.2 10.3 24.8l11 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11 0c-2.2 8.6-5.6 16.9-10.3 24.8L601 343c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-4.1-4.1-30.1 30.1 4.1 4.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-4.1-4.1c-10 10-20 20-30.1 30.1L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-6.3-6.3c-7.8 4.6-16.2 8-24.8 10.3l0 11c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-11c-8.6-2.2-16.9-5.6-24.8-10.3L329 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l6.3-6.3c-4.6-7.8-8-16.2-10.3-24.8l-11 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l11 0c2.2-8.6 5.6-16.9 10.3-24.8L295 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l4.1 4.1c10-10 20-20 30.1-30.1L359 297c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l4.1 4.1 30.1-30.1-4.1-4.1c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l6.3 6.3c7.8-4.6 16.2-8 24.8-10.3l0-11c0-13.3 10.7-24 24-24s24 10.7 24 24zM448 384a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $159afdcd077ecfe9$export$c9c5b76ec992eab4 = {
    prefix: 'fas',
    iconName: 'ear-deaf',
    icon: [
        512,
        512,
        [
            "deaf",
            "deafness",
            "hard-of-hearing"
        ],
        "f2a4",
        "M502.6 54.6l-40 40c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l40-40c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm-320 320l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM240 128c-57.6 0-105.1 43.6-111.3 99.5-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3c9.7-88 84.3-156.5 174.9-156.5 97.2 0 176 78.8 176 176 0 46-17.7 87.9-46.6 119.3-12 13-17.4 24.8-17.4 34.7l0 6.1c0 61.9-50.1 112-112 112-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48l0-6.1c0-32.9 17.4-59.6 34.4-78 18.4-20 29.6-46.6 29.6-75.9 0-61.9-50.1-112-112-112zm0 80c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$4b666adf83f0de01 = $159afdcd077ecfe9$export$c9c5b76ec992eab4;
var $159afdcd077ecfe9$export$85c6a9ab2fa2631e = $159afdcd077ecfe9$export$c9c5b76ec992eab4;
var $159afdcd077ecfe9$export$ebecf90a5676e17a = $159afdcd077ecfe9$export$c9c5b76ec992eab4;
var $159afdcd077ecfe9$export$804bfc5c390e1a2a = {
    prefix: 'fas',
    iconName: 'people-arrows',
    icon: [
        512,
        512,
        [
            "people-arrows-left-right"
        ],
        "e068",
        "M32 64A64 64 0 1 1 160 64 64 64 0 1 1 32 64zM0 224c0-35.3 28.7-64 64-64l64 0c3.2 0 6.4 .2 9.5 .7L93.1 205.1C65 233.2 65 278.8 93.1 306.9l56 56c3.4 3.4 7 6.4 10.9 9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-120.6C12.9 332.4 0 311.7 0 288l0-64zM352 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm66.9 141.1l-44.4-44.4c3.1-.5 6.3-.7 9.5-.7l64 0c35.3 0 64 28.7 64 64l0 64c0 23.7-12.9 44.4-32 55.4L480 464c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1c3.9-2.6 7.5-5.6 10.9-9l56-56c28.1-28.1 28.1-73.7 0-101.8zM302.8 177.8c9-3.7 19.3-1.7 26.2 5.2l56 56c9.4 9.4 9.4 24.6 0 33.9l-56 56c-6.9 6.9-17.2 8.9-26.2 5.2S288 321.7 288 312l0-24-64 0 0 24c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-56-56c-9.4-9.4-9.4-24.6 0-33.9l56-56c6.9-6.9 17.2-8.9 26.2-5.2S224 190.3 224 200l0 24 64 0 0-24c0-9.7 5.8-18.5 14.8-22.2z"
    ]
};
var $159afdcd077ecfe9$export$da01f044c59e3598 = $159afdcd077ecfe9$export$804bfc5c390e1a2a;
var $159afdcd077ecfe9$export$765c446e974b5e59 = {
    prefix: 'fas',
    iconName: 'hands-clapping',
    icon: [
        512,
        512,
        [],
        "e1a8",
        "M344 8l0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64c0-13.3 10.7-24 24-24S344-5.3 344 8zM220 10.7l32 48c7.4 11 4.4 25.9-6.7 33.3s-25.9 4.4-33.3-6.7l-32-48c-7.4-11-4.4-25.9 6.7-33.3S212.6-.3 220 10.7zM135 119c9.4-9.4 24.6-9.4 33.9 0L292.7 242.7c10.1 10.1 27.3 2.9 27.3-11.3l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4-64 38.4-145.8 28.3-198.5-24.4L7 361c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l53 53c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L23 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l93 93c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1L55 185c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l117 117c6.1 6.1 16 6.1 22.1 0s6.1-16 0-22.1l-93-93c-9.4-9.4-9.4-24.6 0-33.9zM433.1 484.9c-24.2 14.5-50.9 22.1-77.7 23.1 48.1-39.6 76.6-99 76.6-162.4l0-98.1c8.2-.1 16-6.4 16-16l0-39.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 153.6c0 57.1-30 110-78.9 139.4zM453.3 4c11 7.4 14 22.3 6.7 33.3l-32 48c-7.4 11-22.3 14-33.3 6.7s-14-22.3-6.7-33.3l32-48c7.4-11 22.3-14 33.3-6.7z"
    ]
};
var $159afdcd077ecfe9$export$61c2a6b698f55df6 = {
    prefix: 'fas',
    iconName: 'virus-covid-slash',
    icon: [
        576,
        512,
        [],
        "e4a9",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-83-83 11.4-11.4c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-11.3 11.3-23.8-23.8c17.9-23.5 29.9-51.7 34.1-82.3l33.6 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-33.6 0c-4.2-30.7-16.3-58.8-34.1-82.3l23.8-23.8 11.3 11.3c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L440.7 46.7c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l11.3 11.3-23.8 23.8C370.8 97.9 342.7 85.8 312 81.6l0-33.6 16 0c13.3 0 24-10.7 24-24S341.3 0 328 0L248 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.6c-30.7 4.2-58.8 16.3-82.3 34.1L157.9 92 169.2 80.6c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L123.9 58.1 41-24.9zM113.6 232l-33.6 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 33.6 0c4.2 30.7 16.3 58.8 34.1 82.3l-23.8 23.8-11.3-11.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56.6 56.6c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-11.3-11.3 23.8-23.8c23.5 17.9 51.7 29.9 82.3 34.1l0 33.6-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0-33.6c13.4-1.8 26.4-5.2 38.7-9.9L123.5 193.3c-4.7 12.3-8 25.2-9.9 38.7z"
    ]
};
var $159afdcd077ecfe9$export$31c6cf6f5d38dc0 = {
    prefix: 'fas',
    iconName: 'calendar-days',
    icon: [
        448,
        512,
        [
            "calendar-alt"
        ],
        "f073",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zM64 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
var $159afdcd077ecfe9$export$cbc139f33cff356 = $159afdcd077ecfe9$export$31c6cf6f5d38dc0;
var $159afdcd077ecfe9$export$99749ac517cbef07 = {
    prefix: 'fas',
    iconName: 'diamond-turn-right',
    icon: [
        512,
        512,
        [
            "directions"
        ],
        "f5eb",
        "M215 17L17 215C6.1 225.9 0 240.6 0 256s6.1 30.1 17 41L215 495c10.9 10.9 25.6 17 41 17s30.1-6.1 41-17L495 297c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41L297 17C286.1 6.1 271.4 0 256 0s-30.1 6.1-41 17zM385 257l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-78.1 0c-13.3 0-24 10.7-24 24l0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40c0-39.8 32.2-72 72-72l78.1 0-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9z"
    ]
};
var $159afdcd077ecfe9$export$6a6973de44442fe5 = $159afdcd077ecfe9$export$99749ac517cbef07;
var $159afdcd077ecfe9$export$cdc9f5e7e94e76da = {
    prefix: 'fas',
    iconName: 'hand-point-up',
    icon: [
        384,
        512,
        [
            9757
        ],
        "f0a6",
        "M32 32C32 14.3 46.3 0 64 0S96 14.3 96 32l0 208-64 0 0-208zM224 192c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-64-64c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-17.7 14.3-32 32-32zm160 96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm-96 88l0-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6l0 8.6c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L37.5 453.5C13.5 429.5 0 396.9 0 363l0-27c0-35.3 28.7-64 64-64l88 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72z"
    ]
};
var $159afdcd077ecfe9$export$a527a6267c55a54c = {
    prefix: 'fas',
    iconName: 'bezier-curve',
    icon: [
        640,
        512,
        [],
        "f55b",
        "M296 136l0-48 48 0 0 48-48 0zM288 32c-26.5 0-48 21.5-48 48l0 4-118.4 0C111.2 62.7 89.3 48 64 48 28.7 48 0 76.7 0 112s28.7 64 64 64c25.3 0 47.2-14.7 57.6-36l66.9 0c-58.9 39.6-98.9 105-104 180L80 320c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-3.3 0c5.9-67 48.5-123.4 107.5-149.1 8.6 12.7 23.2 21.1 39.8 21.1l64 0c16.6 0 31.1-8.4 39.8-21.1 59 25.7 101.6 82.1 107.5 149.1l-3.3 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-4.5 0c-5-75-45.1-140.4-104-180l66.9 0c10.4 21.3 32.3 36 57.6 36 35.3 0 64-28.7 64-64s-28.7-64-64-64c-25.3 0-47.2 14.7-57.6 36l-118.4 0 0-4c0-26.5-21.5-48-48-48l-64 0zM88 376l48 0 0 48-48 0 0-48zm416 48l0-48 48 0 0 48-48 0z"
    ]
};
var $159afdcd077ecfe9$export$f3d75c19191f1688 = {
    prefix: 'fas',
    iconName: 'person-half-dress',
    icon: [
        384,
        512,
        [],
        "e548",
        "M143.4-3.9c9.7-16.8 27.8-28.1 48.6-28.1 30.9 0 56 25.1 56 56 0 25.4-16.9 46.8-40 53.7l0 0c-5.1 1.5-10.4 2.3-16 2.3-30.9 0-56-25.1-56-56l0 0c0-10.1 2.7-19.7 7.4-27.9zM318.3 299.1L272 236.7 272 512c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160 0-.4 0-238.6c36.2 4.4 69.2 23.4 91.2 53l70.5 95c10.5 14.2 7.6 34.2-6.6 44.8s-34.2 7.6-44.8-6.6zM176 113l0 399c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-25.8 0c-10.9 0-18.6-10.7-15.2-21.1l43-129-48.3 65.1c-10.5 14.2-30.6 17.2-44.8 6.6s-17.2-30.6-6.6-44.8l70.5-95c22-29.6 55.1-48.6 91.2-53z"
    ]
};
var $159afdcd077ecfe9$export$287bdd70ab874659 = {
    prefix: 'fas',
    iconName: 'square-poll-horizontal',
    icon: [
        448,
        512,
        [
            "poll-h"
        ],
        "f682",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM256 152c0 13.3-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24zm72 80c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l208 0zM192 360c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$456a238f0144d430 = $159afdcd077ecfe9$export$287bdd70ab874659;
var $159afdcd077ecfe9$export$5e17b20e0f6b132b = {
    prefix: 'fas',
    iconName: 'school-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e56d",
        "M64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l276 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-88c0-22.1 17.9-40 40-40l48 0c1 0 1.9 0 2.9 .1 26.3-74.6 97.5-128.1 181.1-128.1 28.6 0 55.6 6.2 80 17.4l0-33.4c0-35.3-28.7-64-64-64l-64 0-127.9-115.1c-18.3-16.4-46-16.4-64.2 0L128 128 64 128zm64 240c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM112 256l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM288 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7l-36.7 36.7 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $159afdcd077ecfe9$export$54608d0a883fea4d = {
    prefix: 'fas',
    iconName: 'hand-lizard',
    icon: [
        512,
        512,
        [],
        "f258",
        "M0 112C0 85.5 21.5 64 48 64l238.5 0c36.8 0 71.2 18 92.1 48.2l113.5 164c13 18.7 19.9 41 19.9 63.8l0 76c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-13.8-78.1-50.2-161.9 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l128 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L48 160c-26.5 0-48-21.5-48-48z"
    ]
};
var $159afdcd077ecfe9$export$49a36efd66df775 = {
    prefix: 'fas',
    iconName: 'chalkboard',
    icon: [
        576,
        512,
        [
            "blackboard"
        ],
        "f51b",
        "M96 64c-35.3 0-64 28.7-64 64l0 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-256c0-35.3-28.7-64-64-64L96 64zM480 384l-64 0 0-32c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 32-160 0 0-256 384 0 0 256z"
    ]
};
var $159afdcd077ecfe9$export$f497e01bf522fd9c = $159afdcd077ecfe9$export$49a36efd66df775;
var $159afdcd077ecfe9$export$c1a3ba061b4f60c4 = {
    prefix: 'fas',
    iconName: 'up-right-from-square',
    icon: [
        512,
        512,
        [
            "external-link-alt"
        ],
        "f35d",
        "M290.4 19.8C295.4 7.8 307.1 0 320 0L480 0c17.7 0 32 14.3 32 32l0 160c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9L400 157.3 246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 112 297.4 54.6c-9.2-9.2-11.9-22.9-6.9-34.9zM0 176c0-44.2 35.8-80 80-80l80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 80c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 176z"
    ]
};
var $159afdcd077ecfe9$export$d7f107e456ab0306 = $159afdcd077ecfe9$export$c1a3ba061b4f60c4;
var $159afdcd077ecfe9$export$7ec6541fee081990 = {
    prefix: 'fas',
    iconName: 'square-full',
    icon: [
        512,
        512,
        [
            128997,
            128998,
            128999,
            129000,
            129001,
            129002,
            129003,
            11035,
            11036
        ],
        "f45c",
        "M0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z"
    ]
};
var $159afdcd077ecfe9$export$57813571c0e10a0a = {
    prefix: 'fas',
    iconName: 'clover',
    icon: [
        512,
        512,
        [],
        "e139",
        "M310.4 16C346.6 16 376 45.4 376 81.7l0 5.2c0 11.2-2.7 22.3-7.8 32.2l-2.3 4.2-20.1 33.5c-1.1 1.9-1.2 3.4-1.1 4.5 .2 1.3 .9 2.7 2.1 3.9s2.6 1.9 3.9 2.1c1.1 .2 2.6 .1 4.5-1.1l33.5-20.1 4.2-2.3c10-5.1 21-7.8 32.2-7.8l5.2 0c36.2 0 65.6 29.4 65.6 65.7 0 17.4-6.9 34.1-19.2 46.4l-1.3 1.3c-3.7 3.7-3.7 9.6 0 13.3l1.3 1.3c12.3 12.3 19.2 29 19.2 46.4 0 36.2-29.4 65.6-65.6 65.6l-5.2 0c-12.8 0-25.5-3.5-36.5-10.1l-33.5-20.1c-1.9-1.1-3.4-1.2-4.5-1.1-1.3 .2-2.7 .9-3.9 2.1s-1.9 2.6-2.1 3.9c-.2 1.1-.1 2.6 1.1 4.5l20.1 33.5c6.6 11 10.1 23.6 10.1 36.5l0 5.2c0 36.2-29.4 65.6-65.6 65.6-17.4 0-34.1-6.9-46.4-19.2l-1.3-1.3c-3.7-3.7-9.6-3.7-13.3 0l-1.3 1.3c-12.3 12.3-29 19.2-46.4 19.2-36.2 0-65.6-29.4-65.7-65.6l0-5.2c0-12.8 3.5-25.5 10.1-36.5l20.1-33.5c1.1-1.9 1.2-3.4 1.1-4.5-.2-1.3-.9-2.7-2.1-3.9s-2.6-1.9-3.9-2.1c-.5-.1-1.2-.1-1.9 0l-2.5 1-33.5 20.1c-11 6.6-23.6 10.1-36.5 10.1l-5.2 0C45.4 376 16 346.6 16 310.4 16 293 22.9 276.3 35.2 264l1.3-1.3 1.2-1.5c2.1-3.1 2.1-7.2 0-10.3l-1.2-1.5-1.3-1.3C22.9 235.8 16 219.1 16 201.7 16 165.4 45.4 136 81.7 136l5.2 0c12.8 0 25.5 3.5 36.5 10.1l33.5 20.1 2.5 1c.7 .1 1.4 .1 1.9 .1 1.3-.2 2.7-.9 3.9-2.1s1.9-2.6 2.1-3.9c.1-.5 .1-1.2-.1-1.9l-1-2.5-20.1-33.5c-6.6-11-10.1-23.6-10.1-36.5l0-5.2c0-36.2 29.4-65.7 65.7-65.7 17.4 0 34.1 6.9 46.4 19.2l1.3 1.3c3.7 3.6 9.6 3.7 13.3 0l1.3-1.3 4.8-4.4C280.5 21.3 295.1 16 310.4 16z"
    ]
};
var $159afdcd077ecfe9$export$c88ac21fe7c88ae6 = {
    prefix: 'fas',
    iconName: 'teeth-open',
    icon: [
        512,
        512,
        [],
        "f62f",
        "M64 32C28.7 32 0 60.7 0 96l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80c0-35.3-28.7-64-64-64L64 32zm0 272c-35.3 0-64 28.7-64 64l0 48c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-48c0-35.3-28.7-64-64-64L64 304zm80-160c0-26.5 21.5-48 48-48s48 21.5 48 48l0 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-24zm128 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 24c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-24zM80 112c17.7 0 32 14.3 32 32l0 24c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-24c0-17.7 14.3-32 32-32zm320 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 24c0 13.3-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24l0-24zM48 384l0-16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32zm144 48c-26.5 0-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 16c0 26.5-21.5 48-48 48zm128 0c-26.5 0-48-21.5-48-48l0-16c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16l0 16c0 26.5-21.5 48-48 48zm112-16c-17.7 0-32-14.3-32-32l0-16c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 16c0 17.7-14.3 32-32 32z"
    ]
};
var $159afdcd077ecfe9$export$2f8a7938c06a2142 = {
    prefix: 'fas',
    iconName: 'bars-staggered',
    icon: [
        512,
        512,
        [
            "reorder",
            "stream"
        ],
        "f550",
        "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$75d2bb378a2fc102 = $159afdcd077ecfe9$export$2f8a7938c06a2142;
var $159afdcd077ecfe9$export$ed81ab40fc4e904 = $159afdcd077ecfe9$export$2f8a7938c06a2142;
var $159afdcd077ecfe9$export$e3a174a50618c208 = {
    prefix: 'fas',
    iconName: 'warehouse',
    icon: [
        576,
        512,
        [],
        "f494",
        "M0 142.1L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-240c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 240c0 17.7 14.3 32 32 32s32-14.3 32-32l0-337.9c0-27.5-17.6-52-43.8-60.7L303.2 5.1c-9.9-3.3-20.5-3.3-30.4 0L43.8 81.4C17.6 90.1 0 114.6 0 142.1zM464 256l-352 0 0 64 352 0 0-64zM112 416l352 0 0-64-352 0 0 64zm352 32l-352 0 0 64 352 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$c74a20c81b957b6a = {
    prefix: 'fas',
    iconName: 'swatchbook',
    icon: [
        512,
        512,
        [],
        "f5c3",
        "M0 48C0 21.5 21.5 0 48 0l96 0c26.5 0 48 21.5 48 48l0 368c0 53-43 96-96 96S0 469 0 416L0 48zM240 409.6l0-271.5 48.1-48.1c18.7-18.7 49.1-18.7 67.9 0l67.9 67.9c18.7 18.7 18.7 49.1 0 67.9L240 409.6zM205.5 512l192-192 66.6 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-258.5 0zM80 64c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L80 64zM64 208l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM96 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$295287303c0e9c7c = {
    prefix: 'fas',
    iconName: 'campground',
    icon: [
        512,
        512,
        [
            9978
        ],
        "f6bb",
        "M344.8 52.3c11.2-13.7 9.2-33.8-4.5-45s-33.8-9.2-45 4.5l-39.2 48-39.2-48C205.6-1.9 185.4-4 171.7 7.2s-15.7 31.4-4.5 45l47.4 58-202 246.9C4.5 367.1 0 379.6 0 392.6L0 432c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-39.4c0-12.9-4.5-25.5-12.7-35.5l-202-246.9 47.4-58zM256 288l112 128-224 0 112-128z"
    ]
};
var $159afdcd077ecfe9$export$3e15790fe68c095b = {
    prefix: 'fas',
    iconName: 'person-walking-arrow-right',
    icon: [
        576,
        512,
        [],
        "e552",
        "M104.5 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm-8 181.3L73.9 227.9c-6 6-9.4 14.1-9.4 22.6l0 37.5c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-37.5c0-25.5 10.1-49.9 28.1-67.9l35.1-35.1c22.8-22.8 53.6-35.6 85.8-35.6 36.9 0 71.8 16.8 94.8 45.6L262.3 180c6.1 7.6 15.3 12 25 12l33.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-33.2 0c-29.2 0-56.7-13.3-75-36l-3.8-4.7 0 115.2 34.5 29.6c17.7 15.2 29.3 36.2 32.6 59.3l12.6 88.1c2.5 17.5-9.7 33.7-27.2 36.2s-33.7-9.7-36.2-27.2l-12.6-88.1c-1.1-7.7-5-14.7-10.9-19.8L130 347.5c-21.3-18.2-33.5-44.9-33.5-72.9l0-69.3zM96.6 371c2.4 2.3 4.8 4.6 7.4 6.8l46 39.4-2.2 7.6c-4.5 15.7-12.9 30-24.4 41.5L55.1 534.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l68.3-68.3c3.8-3.8 6.6-8.6 8.1-13.8L96.6 371zM505.5 345c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-102.1 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l102.1 0-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9l-72 72z"
    ]
};
var $159afdcd077ecfe9$export$58d7d709c0a8ca5f = {
    prefix: 'fas',
    iconName: 'glasses',
    icon: [
        576,
        512,
        [],
        "f530",
        "M143.3 96c-14 0-26.5 9.2-30.6 22.6L70.4 256 224 256c17.7 0 32 14.3 32 32l64 0c0-17.7 14.3-32 32-32l153.6 0-42.3-137.4C459.2 105.2 446.8 96 432.7 96L400 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l32.7 0c42.1 0 79.4 27.5 91.8 67.8l45.4 147.5c4.1 13.2 6.1 26.9 6.1 40.7l0 96c0 53-43 96-96 96l-64 0c-53 0-96-43-96-96l0-32-64 0 0 32c0 53-43 96-96 96l-64 0c-53 0-96-43-96-96l0-96c0-13.8 2.1-27.5 6.1-40.7L51.5 99.8C63.9 59.5 101.1 32 143.3 32L176 32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32.7 0zM64 320l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64-128 0zm416 96c17.7 0 32-14.3 32-32l0-64-128 0 0 64c0 17.7 14.3 32 32 32l64 0z"
    ]
};
var $159afdcd077ecfe9$export$fbeef2513e05ad08 = {
    prefix: 'fas',
    iconName: 'circle-pause',
    icon: [
        512,
        512,
        [
            62092,
            "pause-circle"
        ],
        "f28b",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM224 192l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$d8cf08a0362da8db = $159afdcd077ecfe9$export$fbeef2513e05ad08;
var $159afdcd077ecfe9$export$5f9bd9f6df021f93 = {
    prefix: 'fas',
    iconName: 'memory',
    icon: [
        512,
        512,
        [],
        "f538",
        "M64 64C28.7 64 0 92.7 0 128l0 7.4C0 142.2 4.4 148 10.1 151.7 23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6l0 55.4 512 0 0-55.4c0-6.8-4.4-12.6-10.1-16.3-13.2-8.6-21.9-23.4-21.9-40.3s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3l0-7.4c0-35.3-28.7-64-64-64L64 64zM512 416l0-64-512 0 0 64c0 17.7 14.3 32 32 32l64 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 88 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 88 0 0-24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 24 64 0c17.7 0 32-14.3 32-32zM160 160l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$b2727de8ccdbb5ec = {
    prefix: 'fas',
    iconName: 'gift',
    icon: [
        512,
        512,
        [
            127873
        ],
        "f06b",
        "M321.5 68.8C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-73.3 0 34.8-59.2zm-131 0l34.8 59.2-73.3 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zm89.6-24.3l-24.1 41-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0c-48.6 0-88 39.4-88 88 0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40 0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4zM480 272l-200 0 0 208 136 0c35.3 0 64-28.7 64-64l0-144zm-248 0l-200 0 0 144c0 35.3 28.7 64 64 64l136 0 0-208z"
    ]
};
var $159afdcd077ecfe9$export$6a4ef2ef77625063 = {
    prefix: 'fas',
    iconName: 'money-bill-wheat',
    icon: [
        512,
        512,
        [],
        "e52a",
        "M176-16c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80 0-8.8 7.2-16 16-16zM56 0l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 48C42.7 48 32 37.3 32 24S42.7 0 56 0zM24 72l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 120C10.7 120 0 109.3 0 96S10.7 72 24 72zm8 96c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM272 0c0-8.8 7.2-16 16-16 44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80zM400-16c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80 0-8.8 7.2-16 16-16zm80 144c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16zM352 112c8.8 0 16 7.2 16 16 0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-96 16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16zM0 304c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 304zM48 416l0 48 48 0c0-26.5-21.5-48-48-48zM96 304l-48 0 0 48c26.5 0 48-21.5 48-48zM464 416c-26.5 0-48 21.5-48 48l48 0 0-48zM416 304c0 26.5 21.5 48 48 48l0-48-48 0zm-96 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"
    ]
};
var $159afdcd077ecfe9$export$1156dc6acb0058bd = {
    prefix: 'fas',
    iconName: 'dungeon',
    icon: [
        512,
        512,
        [],
        "f6d9",
        "M347.5 144.8c6.5 5.4 12.5 11.3 18 17.7 8.7 10.2 23.7 14 35.1 6.9l54.1-33.8c11.2-7 14.7-21.7 6.9-32.2-15.3-20.5-33.5-38.6-54.1-53.8-10.4-7.6-24.7-4.3-31.8 6.4l-35.1 52.6c-7.8 11.6-3.8 27.3 7 36.2zM327.8 41.1c8.6-12.9 2.9-30.5-12.2-34.1-19.1-4.6-39.1-7-59.6-7s-40.4 2.4-59.6 7c-15.1 3.6-20.8 21.2-12.2 34.1l40 60c5.2 7.8 14.5 11.7 23.9 11.2 5.2-.3 10.6-.3 15.8 0 9.4 .5 18.7-3.4 23.9-11.2l40-60zM50.5 103.3c-7.9 10.5-4.3 25.3 6.9 32.2l54.1 33.8c11.4 7.1 26.3 3.3 35.1-6.9 5.5-6.4 11.5-12.3 18-17.7 10.8-8.9 14.8-24.6 7-36.2L136.4 55.9c-7.1-10.7-21.5-14-31.8-6.4-20.6 15.1-38.8 33.3-54.1 53.8zm62 141.1c.8-9.9-3.3-19.9-11.8-25.1L41 182c-12.9-8-29.9-2.3-33.6 12.5-4.9 19.7-7.5 40.3-7.5 61.6l0 24c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24l0-24c0-3.9 .2-7.8 .5-11.6zm287.1 0c.3 3.8 .5 7.7 .5 11.6l0 24c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24l0-24c0-21.2-2.6-41.8-7.5-61.6-3.6-14.7-20.7-20.5-33.6-12.5l-59.7 37.3c-8.4 5.3-12.6 15.2-11.8 25.1zM88 352l-64 0c-13.3 0-24 10.7-24 24L0 488c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm400 0l-64 0c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zM280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 304c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304zm-80 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 272c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272zm160 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 272c0 13.3 10.7 24 24 24s24-10.7 24-24l0-272z"
    ]
};
var $159afdcd077ecfe9$export$25ea11267429d202 = {
    prefix: 'fas',
    iconName: 'suitcase-medical',
    icon: [
        512,
        512,
        [
            "medkit"
        ],
        "f0fa",
        "M192 56l0 40 128 0 0-40c0-4.4-3.6-8-8-8L200 48c-4.4 0-8 3.6-8 8zm-48 8l0-8c0-30.9 25.1-56 56-56L312 0c30.9 0 56 25.1 56 56l0 424-224 0 0-416zM96 176l0 304-32 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l32 0 0 80zM416 480l0-384 32 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-32 0zM244 208c-8.8 0-16 7.2-16 16l0 36-36 0c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16l36 0 0 36c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-36 36 0c8.8 0 16-7.2 16-16l0-24c0-8.8-7.2-16-16-16l-36 0 0-36c0-8.8-7.2-16-16-16l-24 0z"
    ]
};
var $159afdcd077ecfe9$export$e75f02bae5b7d34b = $159afdcd077ecfe9$export$25ea11267429d202;
var $159afdcd077ecfe9$export$c48422e9da776c1b = {
    prefix: 'fas',
    iconName: 'person-cane',
    icon: [
        448,
        512,
        [],
        "e53c",
        "M232-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM144 236.7L97.7 299.1c-10.5 14.2-30.6 17.2-44.8 6.6s-17.2-30.6-6.6-44.8l70.5-95C142 132 181.7 112 224 112s82 20 107.2 53.9l70.5 95c10.5 14.2 7.6 34.2-6.6 44.8s-34.2 7.6-44.8-6.6L304 236.7 304 512c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-275.3zM392 384c-4.4 0-8 3.6-8 8 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-128c0-4.4-3.6-8-8-8z"
    ]
};
var $159afdcd077ecfe9$export$dbfb0a9f89ad94a4 = {
    prefix: 'fas',
    iconName: 'gauge',
    icon: [
        512,
        512,
        [
            "dashboard",
            "gauge-med",
            "tachometer-alt-average"
        ],
        "f624",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-26.9-16.5-49.9-40-59.3L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 172.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $159afdcd077ecfe9$export$b7ce24136743d0f1 = $159afdcd077ecfe9$export$dbfb0a9f89ad94a4;
var $159afdcd077ecfe9$export$f948a9dd257979f3 = $159afdcd077ecfe9$export$dbfb0a9f89ad94a4;
var $159afdcd077ecfe9$export$6f22c345e5a92d1a = $159afdcd077ecfe9$export$dbfb0a9f89ad94a4;
var $159afdcd077ecfe9$export$f5c53ce8ec380d11 = {
    prefix: 'fas',
    iconName: 'envelope-open-text',
    icon: [
        576,
        512,
        [],
        "f658",
        "M288 33.9L96.4 175.8 254.5 293c5.3 3.9 11.2 6.9 17.5 8.7L272 464c0 5.5 .5 10.8 1.3 16L96 480c-35.3 0-64-28.7-64-64l0-239.9c0-20.3 9.6-39.4 25.9-51.4L254.5-21c9.7-7.2 21.4-11 33.5-11s23.8 3.9 33.5 11L518.1 124.7c7.2 5.3 13.1 12 17.4 19.6-2.5-.2-5-.3-7.5-.3L436.6 144 288 33.9zM320 240c0-26.5 21.5-48 48-48l160 0c26.5 0 48 21.5 48 48l0 224c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-224zm80 16c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0z"
    ]
};
var $159afdcd077ecfe9$export$b34d64c205c732a9 = {
    prefix: 'fas',
    iconName: 'toolbox',
    icon: [
        512,
        512,
        [
            129520
        ],
        "f552",
        "M176 56l0 40 160 0 0-40c0-4.4-3.6-8-8-8L184 48c-4.4 0-8 3.6-8 8zM128 96l0-40c0-30.9 25.1-56 56-56L328 0c30.9 0 56 25.1 56 56l0 40 28.1 0c12.7 0 24.9 5.1 33.9 14.1l51.9 51.9c9 9 14.1 21.2 14.1 33.9l0 76.1-136 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-144 0 0-16c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-136 0 0-76.1c0-12.7 5.1-24.9 14.1-33.9l51.9-51.9c9-9 21.2-14.1 33.9-14.1L128 96zM0 416l0-96 136 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 144 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 136 0 0 96c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64z"
    ]
};
var $159afdcd077ecfe9$export$a1cca9928dcf9798 = {
    prefix: 'fas',
    iconName: 'power-off',
    icon: [
        512,
        512,
        [
            9211
        ],
        "f011",
        "M288 0c0-17.7-14.3-32-32-32S224-17.7 224 0l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32L288 0zM146.3 98.4c14.5-10.1 18-30.1 7.9-44.6s-30.1-18-44.6-7.9C43.4 92.1 0 169 0 256 0 397.4 114.6 512 256 512S512 397.4 512 256c0-87-43.4-163.9-109.7-210.1-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6c49.8 34.8 82.3 92.4 82.3 157.6 0 106-86 192-192 192S64 362 64 256c0-65.2 32.5-122.9 82.3-157.6z"
    ]
};
var $159afdcd077ecfe9$export$79046b073b6c584d = {
    prefix: 'fas',
    iconName: 'signal',
    icon: [
        512,
        512,
        [
            128246,
            "signal-5",
            "signal-perfect"
        ],
        "f012",
        "M488 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400zM360 128c-13.3 0-24 10.7-24 24l0 304c0 13.3 10.7 24 24 24s24-10.7 24-24l0-304c0-13.3-10.7-24-24-24zM280 248c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zM152 320c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zM48 384c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$3417071118065933 = $159afdcd077ecfe9$export$79046b073b6c584d;
var $159afdcd077ecfe9$export$1aea50ab3e99cc95 = $159afdcd077ecfe9$export$79046b073b6c584d;
var $159afdcd077ecfe9$export$7e05388be208e313 = {
    prefix: 'fas',
    iconName: 'arrows-spin',
    icon: [
        512,
        512,
        [],
        "e4bb",
        "M481.7 240.1c-17.6-1.2-32.9 12-34.2 29.7-3.3 47-23.6 89.4-54.8 121L361 359c-6.9-6.9-17.2-8.9-26.2-5.2S320 366.3 320 376l0 112c0 13.3 10.7 24 24 24l112 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-35-35c41.7-42.2 68.9-98.8 73.4-161.8 1.2-17.6-12-32.9-29.7-34.2zM39 41L74 76c-41.7 42.2-68.9 98.8-73.4 161.8-1.2 17.6 12 32.9 29.7 34.2s32.9-12 34.2-29.7c3.3-47 23.6-89.4 54.8-121L151 153c6.9 6.9 17.2 8.9 26.2 5.2S192 145.7 192 136l0-112c0-13.3-10.7-24-24-24L56 0C46.3 0 37.5 5.8 33.8 14.8S32.2 34.1 39 41zm201-10.7c-1.2 17.6 12 32.9 29.7 34.2 47 3.3 89.4 23.6 121 54.8L359 151c-6.9 6.9-8.9 17.2-5.2 26.2S366.3 192 376 192l112 0c13.3 0 24-10.7 24-24l0-112c0-9.7-5.8-18.5-14.8-22.2S477.9 32.2 471 39L436 74c-42.2-41.7-98.8-68.9-161.8-73.4-17.6-1.2-32.9 12-34.2 29.7zM41 473l35-35c42.2 41.7 98.8 68.9 161.8 73.4 17.6 1.2 32.9-12 34.2-29.7s-12-32.9-29.7-34.2c-47-3.3-89.4-23.6-121-54.8L153 361c6.9-6.9 8.9-17.2 5.2-26.2S145.7 320 136 320L24 320c-13.3 0-24 10.7-24 24L0 456c0 9.7 5.8 18.5 14.8 22.2S34.1 479.8 41 473z"
    ]
};
var $159afdcd077ecfe9$export$e5a289fb22ffb8cb = {
    prefix: 'fas',
    iconName: 'joint',
    icon: [
        576,
        512,
        [],
        "f595",
        "M360 0c13.3 0 24 10.7 24 24l0 19c0 40.3 16 79 44.5 107.5l21 21C469 191 480 217.4 480 245l0 19c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19c0-14.9-5.9-29.1-16.4-39.6l-21-21C357.1 146.9 336 96 336 43l0-19c0-13.3 10.7-24 24-24zM552 288c-13.3 0-24-10.7-24-24l0-19c0-40.3-16-79-44.5-107.5l-21-21C443 97 432 70.6 432 43l0-19c0-13.3 10.7-24 24-24s24 10.7 24 24l0 19c0 14.9 5.9 29.1 16.4 39.6l21 21C554.9 141.1 576 192 576 245l0 19c0 13.3-10.7 24-24 24zM292.7 320c5.6 0 10.7 2.9 13.6 7.6L394.6 471c1.3 2.1 0 4.9-2.4 5.2-16.1 2.5-32.4 3.7-48.7 3.7l-38.1 0c-5.6 0-10.7-2.9-13.6-7.6l-79-128.4c-6-9.8 0-22.6 11.5-23.3 6.7-.4 13.4-.6 20.2-.6l48.3 0zM459.3 465.9c-6.4 1-12.7-1.9-16.1-7.4L374.1 346.1c-6.7-10.9 1.5-24.7 14.2-22.9 1.3 .2 2.6 .4 3.8 .6l136.4 21c27.3 4.2 47.4 27.7 47.4 55.3s-20.1 51.1-47.4 55.3l-69.2 10.6zM138.7 336c6.7-1.5 13.6 1.4 17.2 7.2l68.9 112c6.6 10.7-1.2 24.4-13.8 23.1-13-1.4-25.9-3.5-38.6-6.5L31.2 439.2C12.9 435 0 418.7 0 400s12.9-35 31.2-39.2L138.7 336z"
    ]
};
var $159afdcd077ecfe9$export$983e9c27cac7ed1c = {
    prefix: 'fas',
    iconName: 'braille',
    icon: [
        384,
        512,
        [],
        "f2a1",
        "M80 144a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 192a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0 136c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0 56c44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80 35.8 80 80 80zm248-80c0 13.3-10.7 24-24 24s-24-10.7-24-24 10.7-24 24-24 24 10.7 24 24zm56 0c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zM304 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 104a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
    ]
};
var $159afdcd077ecfe9$export$1d307c13b511e8e1 = {
    prefix: 'fas',
    iconName: 'basket-shopping',
    icon: [
        576,
        512,
        [
            "shopping-basket"
        ],
        "f291",
        "M288 0c6.6 0 12.9 2.7 17.4 7.5l144 152 .5 .5 78.1 0c17.7 0 32 14.3 32 32 0 14.5-9.6 26.7-22.8 30.7L491.1 429.9c-6.5 29.3-32.5 50.1-62.5 50.1l-281.3 0c-30 0-56-20.8-62.5-50.1l-46-207.2c-13.2-3.9-22.8-16.2-22.8-30.7 0-17.7 14.3-32 32-32l78.1 0 .5-.5 144-152C275.1 2.7 281.4 0 288 0zm0 58.9L192.2 160 383.8 160 288 58.9zM208 264c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112zm80-24c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm128 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112z"
    ]
};
var $159afdcd077ecfe9$export$ca6d443595a6578f = $159afdcd077ecfe9$export$1d307c13b511e8e1;
var $159afdcd077ecfe9$export$f402c7c97f3383f0 = {
    prefix: 'fas',
    iconName: 'bridge',
    icon: [
        512,
        512,
        [],
        "e4c8",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l8 0 0 64-40 0 0 112c37.6 9.4 64 43.2 64 82l0 94c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96s96 43 96 96l0 64c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-94c0-38.8 26.4-72.6 64-82l0-112-40 0 0-64 8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM424 96l0 64-80 0 0-64 80 0zM296 96l0 64-80 0 0-64 80 0zM88 96l80 0 0 64-80 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$9b2dbe133273f284 = {
    prefix: 'fas',
    iconName: 'plane-arrival',
    icon: [
        576,
        512,
        [
            128748
        ],
        "f5af",
        "M386.6 193.1L265.9 3.7c-4.8-7.6-12.6-12.8-21.4-14.3l-43.1-7.6c-10.8-1.9-20.2 7.3-18.6 18.1l24 161.6-105-18.5-33.8-61.8C64.5 74.7 58.2 70.2 51.1 69L34 66c-9.8-1.7-18.8 5.9-18.8 15.8l.6 106.3c.2 30.9 22.4 57.3 52.9 62.7l13.5 2.4 0 0 417.6 73.6c30.5 5.4 59.5-15 64.9-45.4s-15-59.5-45.4-64.9L386.6 193.1zM224 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm131.2-15.3a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448z"
    ]
};
var $159afdcd077ecfe9$export$6357093f67788b33 = {
    prefix: 'fas',
    iconName: 'cash-register',
    icon: [
        512,
        512,
        [],
        "f788",
        "M96 0C60.7 0 32 28.7 32 64s28.7 64 64 64l48 0 0 32-57 0c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-69.6c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160l-217 0 0-32 48 0c35.3 0 64-28.7 64-64S291.3 0 256 0L96 0zm0 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 424c0-13.3 10.7-24 24-24l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 448c-13.3 0-24-10.7-24-24zm48-160a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
    ]
};
var $159afdcd077ecfe9$export$a95486586631edc7 = {
    prefix: 'fas',
    iconName: 'ring',
    icon: [
        512,
        512,
        [],
        "f70b",
        "M64 208c0 7.8 4.4 18.7 17.1 30.3 45.4-24.2 107.7-38.3 174.9-38.3s129.5 14.1 174.9 38.3c12.8-11.6 17.1-22.5 17.1-30.3 0-12.3-10.8-32-47.9-50.6-35.2-17.6-86.1-29.4-144.1-29.4s-108.9 11.8-144.1 29.4C74.8 176 64 195.7 64 208zm192 40c-47 0-89.3 7.6-122.9 19.7 33.2 12.4 75.7 20.3 122.9 20.3s89.7-7.8 122.9-20.3C345.3 255.6 303 248 256 248zM0 208C0 158.4 39.4 122.2 83.3 100.2 129.1 77.3 190.3 64 256 64s126.9 13.3 172.7 36.2c43.9 22 83.3 58.2 83.3 107.8l0 96c0 49.6-39.4 85.8-83.3 107.8-45.9 22.9-107 36.2-172.7 36.2S129.1 434.7 83.3 411.8C39.4 389.8 0 353.6 0 304l0-96z"
    ]
};
var $159afdcd077ecfe9$export$cdaf45d4e50ac035 = {
    prefix: 'fas',
    iconName: 'share-nodes',
    icon: [
        512,
        512,
        [
            "share-alt"
        ],
        "f1e0",
        "M384 192c53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 5.4 .5 10.8 1.3 16L159.6 184.1c-16.9-15-39.2-24.1-63.6-24.1-53 0-96 43-96 96s43 96 96 96c24.4 0 46.6-9.1 63.6-24.1L289.3 400c-.9 5.2-1.3 10.5-1.3 16 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-24.4 0-46.6 9.1-63.6 24.1L190.7 272c.9-5.2 1.3-10.5 1.3-16s-.5-10.8-1.3-16l129.7-72.1c16.9 15 39.2 24.1 63.6 24.1z"
    ]
};
var $159afdcd077ecfe9$export$f8e8bb0b3aa8c658 = $159afdcd077ecfe9$export$cdaf45d4e50ac035;
var $159afdcd077ecfe9$export$38c8c32017dd9cc = {
    prefix: 'fas',
    iconName: 'person-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e53f",
        "M280 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 212.7L341 286.6c12.8-17.5 28.5-32.7 46.3-45l-56.2-75.7C306 132 266.3 112 224 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L144 236.7 144 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-275.3zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-140c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$8a910017964bb8c2 = {
    prefix: 'fas',
    iconName: 'binoculars',
    icon: [
        512,
        512,
        [],
        "f1e5",
        "M128 32l32 0c17.7 0 32 14.3 32 32l0 32-96 0 0-32c0-17.7 14.3-32 32-32zm64 96l0 320c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32l0-59.1c0-34.6 9.4-68.6 27.2-98.3 13.7-22.8 22.5-48.2 25.8-74.6L60.5 156c2-16 15.6-28 31.8-28l99.8 0zm227.8 0c16.1 0 29.8 12 31.8 28L459 216c3.3 26.4 12.1 51.8 25.8 74.6 17.8 29.7 27.2 63.7 27.2 98.3l0 59.1c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-320 99.8 0zM320 64c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 32-96 0 0-32zm-32 64l0 160-64 0 0-160 64 0z"
    ]
};
var $159afdcd077ecfe9$export$a6df39524c41472c = {
    prefix: 'fas',
    iconName: 'kip-sign',
    icon: [
        384,
        512,
        [],
        "e1c4",
        "M340.8 88.3c13.4-11.5 15-31.7 3.5-45.1s-31.7-15-45.1-3.5L128 186.4 128 64c0-17.7-14.3-32-32-32S64 46.3 64 64l0 168-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 168c0 17.7 14.3 32 32 32s32-14.3 32-32l0-122.4 171.2 146.7c13.4 11.5 33.6 9.9 45.1-3.5s9.9-33.6-3.5-45.1L173.2 280 352 280c13.3 0 24-10.7 24-24s-10.7-24-24-24L173.2 232 340.8 88.3z"
    ]
};
var $159afdcd077ecfe9$export$4cb736b866cbb7ec = {
    prefix: 'fas',
    iconName: 'hard-drive',
    icon: [
        448,
        512,
        [
            128436,
            "hdd"
        ],
        "f0a0",
        "M64 32C28.7 32 0 60.7 0 96L0 260.1C18.1 247.4 40.2 240 64 240l320 0c23.8 0 45.9 7.4 64 20.1L448 96c0-35.3-28.7-64-64-64L64 32zM448 352c0-35.3-28.7-64-64-64L64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64zM224 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$62551e9c5ba7093f = $159afdcd077ecfe9$export$4cb736b866cbb7ec;
var $159afdcd077ecfe9$export$e6fd420a918b43b5 = {
    prefix: 'fas',
    iconName: 'ranking-star',
    icon: [
        576,
        512,
        [],
        "e561",
        "M321.8 54.1L298.2 6.3c-3.9-8.3-16.1-8.6-20.4 0l-23.6 47.8-52.3 7.5c-9.3 1.4-13.3 12.9-6.4 19.8l38 37-9 52.1c-1.4 9.3 8.2 16.5 16.8 12.2l46.9-24.8 46.6 24.4c8.6 4.3 18.3-2.9 16.8-12.2l-9-52.1 38-36.6c6.8-6.8 2.9-18.3-6.4-19.8l-52.3-7.5zM256 256c-26.5 0-48 21.5-48 48l0 160c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48l-64 0zM48 320c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-64 0zM416 432l0 32c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-64 0c-26.5 0-48 21.5-48 48z"
    ]
};
var $159afdcd077ecfe9$export$48c51dda34e9f04c = {
    prefix: 'fas',
    iconName: 'user-tie',
    icon: [
        448,
        512,
        [],
        "f508",
        "M224 248a120 120 0 1 1 0-240 120 120 0 1 1 0 240zm-30.5 56l61 0c9.7 0 17.5 7.8 17.5 17.5 0 4.2-1.5 8.2-4.2 11.4l-27.4 32 31 115.1 .6 0 34.6-138.5c2.2-8.7 11.1-14 19.5-10.8 61.9 23.6 105.9 83.6 105.9 153.8 0 15.1-12.3 27.4-27.4 27.4L43.4 512c-15.1 0-27.4-12.3-27.4-27.4 0-70.2 44-130.2 105.9-153.8 8.4-3.2 17.3 2.1 19.5 10.8l34.6 138.5 .6 0 31-115.1-27.4-32c-2.7-3.2-4.2-7.2-4.2-11.4 0-9.7 7.8-17.5 17.5-17.5z"
    ]
};
var $159afdcd077ecfe9$export$37fe3659ba7b6b54 = {
    prefix: 'fas',
    iconName: 'ellipsis',
    icon: [
        448,
        512,
        [
            "ellipsis-h"
        ],
        "f141",
        "M0 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm168 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm224-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $159afdcd077ecfe9$export$c9f2fedd4489a2ee = $159afdcd077ecfe9$export$37fe3659ba7b6b54;
var $159afdcd077ecfe9$export$4ab2f33219630bad = {
    prefix: 'fas',
    iconName: 'store-slash',
    icon: [
        576,
        512,
        [],
        "e071",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-58.6-58.6c1.1-4 1.6-8.2 1.6-12.5l0-151.2c-12.5 4.6-26.1 7.2-40.5 7.2-8.1 0-15.9-.8-23.5-2.4l0 66.4-30.2 0-137.5-137.5c2.9-3.6 5.5-7.4 7.6-11.5 11.6 22 34.7 37 61.3 37 26.8 0 49.8-15.1 61.4-37.1 11.4 22.1 34.5 37.1 60.8 37.1 45.6 0 78.4-43.7 65.6-87.5L513.8 72.3C506.8 48.4 484.9 32 460 32L116 32c-5.5 0-10.8 .8-15.9 2.3L41-24.9zM151.5 221.3L48.7 118.6 38.9 152.5c-12.8 43.7 20 87.5 65.6 87.5 18.1 0 34.7-7.1 47-18.7zM410.2 480l-128-128-154.2 0 0-66.4c-7.6 1.6-15.5 2.4-23.5 2.4-14.4 0-28-2.6-40.5-7.2L64 432c0 26.5 21.5 48 48 48l298.2 0z"
    ]
};
var $159afdcd077ecfe9$export$89a1764fbb7ad2cb = {
    prefix: 'fas',
    iconName: 'percent',
    icon: [
        448,
        512,
        [
            62101,
            62785,
            "percentage"
        ],
        "25",
        "M192 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM448 384a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM438.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-384 384c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l384-384z"
    ]
};
var $159afdcd077ecfe9$export$89333857fc063a2e = $159afdcd077ecfe9$export$89a1764fbb7ad2cb;
var $159afdcd077ecfe9$export$7a4a0e4caa1e4e6f = {
    prefix: 'fas',
    iconName: 'file-zipper',
    icon: [
        384,
        512,
        [
            "file-archive"
        ],
        "f1c6",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM64 72c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 48C74.7 48 64 58.7 64 72zm0 96c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm64 72l-32 0c-17.7 0-32 14.3-32 32l0 48c0 26.5 21.5 48 48 48s48-21.5 48-48l0-48c0-17.7-14.3-32-32-32zm-16 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $159afdcd077ecfe9$export$bf2047a9946b5c3f = $159afdcd077ecfe9$export$7a4a0e4caa1e4e6f;
var $159afdcd077ecfe9$export$e9d85839f7751f01 = {
    prefix: 'fas',
    iconName: 'display',
    icon: [
        512,
        512,
        [],
        "e163",
        "M448 96l0 256-384 0 0-256 384 0zM64 32C28.7 32 0 60.7 0 96L0 352c0 35.3 28.7 64 64 64l144 0-16 48-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0-16-48 144 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 32z"
    ]
};
var $159afdcd077ecfe9$export$7fe2894454d8eb8a = {
    prefix: 'fas',
    iconName: 'icons',
    icon: [
        512,
        512,
        [
            "heart-music-camera-bolt"
        ],
        "f86d",
        "M174.9 272c10.7 0 20.7 5.3 26.6 14.2l11.8 17.8 26.7 0c26.5 0 48 21.5 48 48l0 112c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 352c0-26.5 21.5-48 48-48l26.7 0 11.8-17.8c5.9-8.9 15.9-14.2 26.6-14.2l61.7 0zm278.6-12c5.6-4.9 13.9-5.3 19.9-.9s8.3 12.4 5.3 19.3L440.3 368 496 368c6.7 0 12.6 4.1 15 10.4s.6 13.3-4.4 17.7l-128 112c-5.6 4.9-13.9 5.3-19.9 .9s-8.3-12.4-5.3-19.3l38.5-89.7-55.8 0c-6.7 0-12.6-4.1-15-10.4s-.6-13.3 4.4-17.7l128-112zM144 360a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM483.8 .4c6.5-1.1 13.1 .4 18.5 4.4 6.1 4.5 9.7 11.7 9.7 19.2l0 152-.3 4.9c-3.3 24.2-30.5 43.1-63.7 43.1-35.3 0-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .6 16 1.6l0-49.3-112 33.6 0 110.2-.3 4.9c-3.3 24.2-30.5 43.1-63.7 43.1-35.3 0-64-21.5-64-48s28.7-48 64-48c5.5 0 10.9 .6 16 1.6L304 72c0-10.6 7-20 17.1-23l160-48 2.7-.6zM188.9 0C226 0 256 30 256 67.1l0 6.1c0 56.1-75.2 112.1-110.3 135.3-10.8 7.1-24.6 7.1-35.4 0-35.1-23.1-110.3-79.2-110.3-135.3l0-6.1C0 30 30 0 67.1 0 88.2 0 108 9.9 120.7 26.8l7.3 9.8 7.3-9.8C148 9.9 167.8 0 188.9 0z"
    ]
};
var $159afdcd077ecfe9$export$ec74c13cedb0791d = $159afdcd077ecfe9$export$7fe2894454d8eb8a;
var $159afdcd077ecfe9$export$a6ad5df9d9f29553 = {
    prefix: 'fas',
    iconName: 'ruler-vertical',
    icon: [
        256,
        512,
        [],
        "f548",
        "M0 16C0-10.5 21.5-32 48-32l160 0c26.5 0 48 21.5 48 48l0 24-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 0 48-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 0 48-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 0 48-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 0 48-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 0 24c0 26.5-21.5 48-48 48L48 544c-26.5 0-48-21.5-48-48L0 16z"
    ]
};
var $159afdcd077ecfe9$export$757f50b8af780c19 = {
    prefix: 'fas',
    iconName: 'map-location-dot',
    icon: [
        640,
        512,
        [
            "map-marked-alt"
        ],
        "f5a0",
        "M576 48c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4L413.5 77.5 234.1 17.6c-8.1-2.7-16.8-2.1-24.4 1.7l-128 64C70.8 88.8 64 99.9 64 112l0 352c0 11.1 5.7 21.4 15.2 27.2s21.2 6.4 31.1 1.4l116.1-58.1 173.3 57.8c-4.3-6.4-8.5-13.1-12.6-19.9-11-18.3-21.9-39.3-30-61.8l-101.2-33.7 0-284.5 128 42.7 0 99.3c31-35.8 77-58.4 128-58.4 22.6 0 44.2 4.4 64 12.5L576 48zM512 224c-66.3 0-120 52.8-120 117.9 0 68.9 64.1 150.4 98.6 189.3 11.6 13 31.3 13 42.9 0 34.5-38.9 98.6-120.4 98.6-189.3 0-65.1-53.7-117.9-120-117.9zM472 344a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
    ]
};
var $159afdcd077ecfe9$export$a977d47c74d8e86c = $159afdcd077ecfe9$export$757f50b8af780c19;
var $159afdcd077ecfe9$export$8e521ef33062b00e = {
    prefix: 'fas',
    iconName: 'heart-crack',
    icon: [
        512,
        512,
        [
            128148,
            "heart-broken"
        ],
        "f7a9",
        "M133.1 32c17.3 0 34.2 3.4 49.9 9.7l54.8 85.2-75.4 75.4c-1.5 1.5-2.4 3.6-2.3 5.8s1 4.2 2.6 5.7l112 104c2.9 2.7 7.4 2.9 10.5 .3s3.8-7 1.7-10.4l-60.4-98.1 90.7-75.6c2.6-2.1 3.5-5.7 2.4-8.8L296.4 60.6C319.6 42.3 348.6 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 112.2-139.9 242.5-212.9 298.2-12.4 9.4-27.6 14.1-43.1 14.1s-30.8-4.6-43.1-14.1C139.9 410.2 0 279.9 0 167.7l0-2.6C0 91.6 59.6 32 133.1 32z"
    ]
};
var $159afdcd077ecfe9$export$4a565395cb65b282 = $159afdcd077ecfe9$export$8e521ef33062b00e;
var $159afdcd077ecfe9$export$1da3b2e53dcafa2d = {
    prefix: 'fas',
    iconName: 'cow',
    icon: [
        640,
        512,
        [
            128004
        ],
        "f6c8",
        "M96 224l0 192c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-88.2c9.9 6.6 20.6 12 32 16.1l0 24.2c0 8.8 7.2 16 16 16s16-7.2 16-16l0-16.9c5.3 .6 10.6 .9 16 .9s10.7-.3 16-.9l0 16.9c0 8.8 7.2 16 16 16s16-7.2 16-16l0-24.2c11.4-4 22.1-9.4 32-16.1l0 88.2c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-160 32 32 0 49.5c0 9.5 2.8 18.7 8.1 26.6L530 427c8.8 13.1 23.5 21 39.3 21 22.5 0 41.9-15.9 46.3-38l20.3-101.6c2.6-13-.3-26.5-8-37.3l-3.9-5.5 0-81.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 14.4-52.9-74.1C496 86.5 452.4 64 405.9 64L144 64C77.7 64 24 117.7 24 184l0 54C9.4 249.8 0 267.8 0 288l0 17.6c0 8 6.4 14.4 14.4 14.4 31.8 0 57.6-25.8 57.6-57.6L72 184c0-24.3 12.1-45.8 30.5-58.9-4.2 10.8-6.5 22.6-6.5 34.9l0 64zM560 336a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM166.6 166.6c-4.2-4.2-6.6-10-6.6-16 0-12.5 10.1-22.6 22.6-22.6l178.7 0c12.5 0 22.6 10.1 22.6 22.6 0 6-2.4 11.8-6.6 16l-23.4 23.4C332.2 211.8 302.7 224 272 224s-60.2-12.2-81.9-33.9l-23.4-23.4z"
    ]
};
var $159afdcd077ecfe9$export$7329a1ca27b90c5b = {
    prefix: 'fas',
    iconName: 'rss',
    icon: [
        448,
        512,
        [
            "feed"
        ],
        "f09e",
        "M0 64c0-17.7 14.3-32 32-32 229.8 0 416 186.2 416 416 0 17.7-14.3 32-32 32s-32-14.3-32-32C384 253.6 226.4 96 32 96 14.3 96 0 81.7 0 64zM0 416a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM32 160c159.1 0 288 128.9 288 288 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-123.7-100.3-224-224-224-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$67ad3d0233cd7b33 = $159afdcd077ecfe9$export$7329a1ca27b90c5b;
var $159afdcd077ecfe9$export$34c8b97060c09ff = {
    prefix: 'fas',
    iconName: 'magnifying-glass',
    icon: [
        512,
        512,
        [
            128269,
            "search"
        ],
        "f002",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
    ]
};
var $159afdcd077ecfe9$export$871a78837687ffe8 = $159afdcd077ecfe9$export$34c8b97060c09ff;
var $159afdcd077ecfe9$export$482eb125aaf0fbc2 = {
    prefix: 'fas',
    iconName: 'cloud-moon',
    icon: [
        640,
        512,
        [],
        "f6c3",
        "M480 0c14.6 0 28.8 1.6 42.5 4.7 7.4 1.7 13 7.8 13.9 15.4s-3 14.9-9.8 18.3c-45.4 22.6-76.6 69.5-76.6 123.6 0 76.2 61.8 138 138 138 3.7 0 7.4-.1 11.1-.4 7.6-.6 14.7 3.6 17.8 10.6s1.5 15.1-3.9 20.4c-26 25-59.1 42.7-95.9 49.9-11.1-25.3-30.2-46.3-54.1-59.8-7.6-63.4-61.6-112.6-127.1-112.6-11.2 0-22.1 1.5-32.5 4.2-4.8-4.2-9.9-8.2-15.2-11.8-.1-2.8-.2-5.6-.2-8.4 0-106 86-192 192-192zm-.1 431.9c0 44.2-35.8 80-80 80l-271.9 0c-53 0-96-43-96-96 0-47.6 34.6-87 80-94.6-.4-52.8 42.9-97.3 96-97.3 34.9 0 65.4 18.6 82.2 46.4 13-9.1 28.8-14.4 45.8-14.4 44.2 0 80 35.8 80 80 0 5.9-.6 11.7-1.9 17.2 37.4 6.7 65.8 39.4 65.8 78.7z"
    ]
};
var $159afdcd077ecfe9$export$2088efcf62cf3b1 = {
    prefix: 'fas',
    iconName: 'boxes-stacked',
    icon: [
        512,
        512,
        [
            62625,
            "boxes",
            "boxes-alt"
        ],
        "f468",
        "M224 0l0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64 32 0c35.3 0 64 28.7 64 64l0 128c0 5.5-.7 10.9-2 16l-252 0c-1.3-5.1-2-10.5-2-16l0-128c0-35.3 28.7-64 64-64l32 0zm96 512c-11.2 0-21.8-2.9-31-8 9.5-16.5 15-35.6 15-56l0-128c0-20.4-5.5-39.5-15-56 9.2-5.1 19.7-8 31-8l32 0 0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64 32 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64l-128 0zM0 320c0-35.3 28.7-64 64-64l32 0 0 64c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-64 32 0c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 320z"
    ]
};
var $159afdcd077ecfe9$export$2007320dd6cde6db = $159afdcd077ecfe9$export$2088efcf62cf3b1;
var $159afdcd077ecfe9$export$e6ef1d896ed63b3e = $159afdcd077ecfe9$export$2088efcf62cf3b1;
var $159afdcd077ecfe9$export$aa054a78ab078db3 = {
    prefix: 'fas',
    iconName: 'code-branch',
    icon: [
        448,
        512,
        [],
        "f126",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3l0 70.7 176 0c26.5 0 48-21.5 48-48l0-22.7c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 22.7c0 61.9-50.1 112-112 112l-176 0 0 70.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80S0 476.2 0 432c0-32.8 19.7-61 48-73.3l0-205.3C19.7 141 0 112.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm232 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM80 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$76f704d256def3c7 = {
    prefix: 'fas',
    iconName: 'ban',
    icon: [
        512,
        512,
        [
            128683,
            "cancel"
        ],
        "f05e",
        "M367.2 412.5L99.5 144.8c-22.4 31.4-35.5 69.8-35.5 111.2 0 106 86 192 192 192 41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3c22.4-31.4 35.5-69.8 35.5-111.2 0-106-86-192-192-192-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"
    ]
};
var $159afdcd077ecfe9$export$6d25ef56192f6d69 = $159afdcd077ecfe9$export$76f704d256def3c7;
var $159afdcd077ecfe9$export$3fe50bd8062cd141 = {
    prefix: 'fas',
    iconName: 'jug-detergent',
    icon: [
        384,
        512,
        [],
        "e519",
        "M96 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 24 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 96C74.7 96 64 85.3 64 72S74.7 48 88 48l8 0 0-24zM0 256c0-70.7 57.3-128 128-128l128 0c70.7 0 128 57.3 128 128l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256zm256 0l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $159afdcd077ecfe9$export$bb06d4a7bb6736fe = {
    prefix: 'fas',
    iconName: 'reply',
    icon: [
        512,
        512,
        [
            61714,
            "mail-reply"
        ],
        "f3e5",
        "M204.2 18.4c12 5 19.8 16.6 19.8 29.6l0 80 112 0c97.2 0 176 78.8 176 176 0 113.3-81.5 163.9-100.2 174.1-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-7.5 4.3-14.4 9.8-19.5 9.4-8.8 22.2-26.4 22.2-56.7 0-53-43-96-96-96l-96 0 0 80c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-160-160c-12.5-12.5-12.5-32.8 0-45.3l160-160c9.2-9.2 22.9-11.9 34.9-6.9z"
    ]
};
var $159afdcd077ecfe9$export$12e45ff70d2646a1 = $159afdcd077ecfe9$export$bb06d4a7bb6736fe;
var $159afdcd077ecfe9$export$8db7f2f70484e17e = {
    prefix: 'fas',
    iconName: 'sun-plant-wilt',
    icon: [
        640,
        512,
        [],
        "e57a",
        "M160 0c-5.5 0-10.6 2.8-13.5 7.4l-1.1 2.1-24.8 55.4-56.7-21.7c-5.9-2.2-12.5-.8-17 3.7S41 58 43.2 63.9l21.7 56.7-55.4 24.8C3.7 148 0 153.7 0 160s3.7 12 9.5 14.6l55.4 24.8-21.7 56.7c-2.2 5.9-.8 12.5 3.7 17s11.1 5.9 17 3.7l56.7-21.7 24.8 55.4c2.6 5.8 8.3 9.5 14.6 9.5s12-3.7 14.6-9.5l24.8-55.4 56.8 21.7c5.9 2.2 12.5 .8 17-3.7s5.9-11.1 3.7-17l-21.7-56.7 55.4-24.8c5.8-2.6 9.5-8.3 9.5-14.6s-3.7-12-9.5-14.6l-55.4-24.8 21.7-56.7 .7-2.2c1.2-5.3-.4-10.9-4.3-14.8s-9.5-5.5-14.8-4.3l-2.2 .7-56.8 21.7-24.8-55.4C172 3.7 166.3 0 160 0zm0 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm376 16l0 53.4c-14.8 7.7-24 23.1-24 44.6 0 16.8 16 44 37.4 67.2 5.8 6.2 15.5 6.2 21.2 0 21.4-23.3 37.4-50.6 37.4-67.2 0-21.5-9.2-37-24-44.6l0-53.4c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 22.7c-9.8-4.3-20.6-6.7-32-6.7-44.2 0-80 35.8-80 80l0 21.4c-14.8 7.6-24 23.1-24 44.6 0 16.8 16 44 37.4 67.2 5.8 6.2 15.5 6.2 21.2 0 21.4-23.3 37.4-50.6 37.4-67.2 0-21.5-9.2-37-24-44.6l0-21.4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176-424 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-104 0 0-272c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$b0babe4230e35ebe = {
    prefix: 'fas',
    iconName: 'bacterium',
    icon: [
        576,
        512,
        [],
        "e05a",
        "M408 16c0-13.3-10.7-24-24-24S360 2.7 360 16l0 23.4c-13.9 5.3-26.9 13.5-38.2 24.5L305 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l16.8 16.8-30.1 30.1-16.8-16.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l16.8 16.8c-10 10-20 20-30.1 30.1L177 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l16.8 16.8-30.1 30.1-16.8-16.8c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l16.8 16.8c-11 11.3-19.2 24.3-24.5 38.2L48 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l16.3 0c1.3 18.3 7.1 36.4 17.4 52.4L71 439c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l10.6-10.6c16 10.3 34.1 16.1 52.4 17.4l0 16.3c0 13.3 10.7 24 24 24s24-10.7 24-24l0-23.4c13.9-5.3 26.9-13.5 38.2-24.5L271 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16.8-16.8 30.1-30.1 16.8 16.8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16.8-16.8c10-10 20-20 30.1-30.1L399 337c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16.8-16.8 30.1-30.1 16.8 16.8c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-16.8-16.8c11-11.3 19.2-24.3 24.5-38.2l23.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16.3 0c-1.3-18.3-7.1-36.4-17.4-52.4L505 73c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L460.4 49.7c-16-10.3-34.1-16.1-52.4-17.4L408 16zM160 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM272 240a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$fe2d5012d9982673 = {
    prefix: 'fas',
    iconName: 'record-vinyl',
    icon: [
        512,
        512,
        [],
        "f8d9",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-112a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$f62f2879ccaea13f = {
    prefix: 'fas',
    iconName: 'floppy-disk',
    icon: [
        448,
        512,
        [
            128190,
            128426,
            "save"
        ],
        "f0c7",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm32 96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $159afdcd077ecfe9$export$1aaa83ff70706e1e = $159afdcd077ecfe9$export$f62f2879ccaea13f;
var $159afdcd077ecfe9$export$c00f55f36d386cb7 = {
    prefix: 'fas',
    iconName: 'toilets-portable',
    icon: [
        512,
        512,
        [],
        "e584",
        "M64 0l96 0c35.3 0 64 28.7 64 64l0 16-224 0 0-16C0 28.7 28.7 0 64 0zM0 128l224 0 0 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-128 0 0 8c0 13.3-10.7 24-24 24S0 501.3 0 488L0 128zM128 248l0 48c0 13.3 10.7 24 24 24l24 0 0-96-24 0c-13.3 0-24 10.7-24 24zM352 0l96 0c35.3 0 64 28.7 64 64l0 16-224 0 0-16c0-35.3 28.7-64 64-64zM288 128l224 0 0 360c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-128 0 0 8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-360zM416 248l0 48c0 13.3 10.7 24 24 24l24 0 0-96-24 0c-13.3 0-24 10.7-24 24z"
    ]
};
var $159afdcd077ecfe9$export$9db87eabf605857e = {
    prefix: 'fas',
    iconName: 'o',
    icon: [
        448,
        512,
        [
            111
        ],
        "4f",
        "M224 96a160 160 0 1 0 0 320 160 160 0 1 0 0-320zM448 256a224 224 0 1 1 -448 0 224 224 0 1 1 448 0z"
    ]
};
var $159afdcd077ecfe9$export$5c390baea5db4f77 = {
    prefix: 'fas',
    iconName: 'palette',
    icon: [
        512,
        512,
        [
            127912
        ],
        "f53f",
        "M512 256c0 .9 0 1.8 0 2.7-.4 36.5-33.6 61.3-70.1 61.3L344 320c-26.5 0-48 21.5-48 48 0 3.4 .4 6.7 1 9.9 2.1 10.2 6.5 20 10.8 29.9 6.1 13.8 12.1 27.5 12.1 42 0 31.8-21.6 60.7-53.4 62-3.5 .1-7 .2-10.6 .2-141.4 0-256-114.6-256-256S114.6 0 256 0 512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$db1382cd406cc506 = {
    prefix: 'fas',
    iconName: 'unlock',
    icon: [
        384,
        512,
        [
            128275
        ],
        "f09c",
        "M128 96c0-35.3 28.7-64 64-64 31.7 0 58 23 63.1 53.3 2.9 17.4 19.4 29.2 36.9 26.3s29.2-19.4 26.3-36.9C308.1 14.1 255.5-32 192-32 121.3-32 64 25.3 64 96l0 64c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-192 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$837bc776b490934d = {
    prefix: 'fas',
    iconName: 'ear-listen',
    icon: [
        512,
        512,
        [
            "assistive-listening-systems"
        ],
        "f2a2",
        "M379.6 .3c-8.9 1.2-17.2 6.2-22.4 14.1-6.8 10.4-7 24.1-.4 34.6 5.6 8.9 15.5 12.7 23.8 18.5 7.5 5.2 17.6 13.2 27.7 24.2 20 21.7 39.5 54.3 39.5 100.3 0 17.7 14.3 32 32 32s32-14.3 32-32c0-66-28.5-113.4-56.5-143.7-13.9-15.1-27.8-26.1-38.3-33.3-11-7.6-23.5-16.6-37.6-14.7zM240 128c-57.6 0-105.1 43.6-111.3 99.5-1.9 17.6-17.8 30.2-35.3 28.3s-30.2-17.8-28.3-35.3c9.7-88 84.3-156.5 174.9-156.5 97.2 0 176 78.8 176 176 0 46-17.7 87.9-46.6 119.3-12 13-17.4 24.8-17.4 34.7l0 6.1c0 61.9-50.1 112-112 112-17.7 0-32-14.3-32-32s14.3-32 32-32c26.5 0 48-21.5 48-48l0-6.1c0-32.9 17.4-59.6 34.4-78 18.4-20 29.6-46.6 29.6-75.9 0-61.9-50.1-112-112-112zM0 480a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM86.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zM240 208c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$8eeef3dc0035b165 = $159afdcd077ecfe9$export$837bc776b490934d;
var $159afdcd077ecfe9$export$37576dfab037d8bf = {
    prefix: 'fas',
    iconName: 'code-pull-request',
    icon: [
        512,
        512,
        [],
        "e13c",
        "M328 24c0-9.7-5.8-18.5-14.8-22.2S293.9 .2 287 7L231 63c-9.4 9.4-9.4 24.6 0 33.9l56 56c6.9 6.9 17.2 8.9 26.2 5.2S328 145.7 328 136l0-24 24 0c17.7 0 32 14.3 32 32l0 214.7c-28.3 12.3-48 40.5-48 73.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3L448 144c0-53-43-96-96-96l-24 0 0-24zM72 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm56 73.3c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80S16 35.8 16 80c0 32.8 19.7 61 48 73.3l0 205.3c-28.3 12.3-48 40.5-48 73.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-205.3zM72 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm344-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$fa6ecc35e7315db = {
    prefix: 'fas',
    iconName: 'key',
    icon: [
        512,
        512,
        [
            128273
        ],
        "f084",
        "M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $159afdcd077ecfe9$export$138b45e2afb1dfa4 = {
    prefix: 'fas',
    iconName: 'skull',
    icon: [
        512,
        512,
        [
            128128
        ],
        "f54c",
        "M416 427.4c58.5-44 96-111.6 96-187.4 0-132.5-114.6-240-256-240S0 107.5 0 240c0 75.8 37.5 143.4 96 187.4L96 464c0 26.5 21.5 48 48 48l32 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 64 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 32 0c26.5 0 48-21.5 48-48l0-36.6zM96 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $159afdcd077ecfe9$export$efc6d53e0dedceee = {
    prefix: 'fas',
    iconName: 'mars-stroke-up',
    icon: [
        384,
        512,
        [
            9896,
            "mars-stroke-v"
        ],
        "f22a",
        "M192 256a112 112 0 1 0 0 224 112 112 0 1 0 0-224zM16 368c0-86.3 62.1-158.1 144.1-173.1-.1-.9-.1-1.9-.1-2.9l0-16-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-61.4-28 22.4c-13.8 11-33.9 8.8-45-5s-8.8-33.9 5-45l80-64c11.7-9.3 28.3-9.3 40 0l80 64c13.8 11 16 31.2 5 45s-31.2 16-45 5l-28-22.4 0 61.4 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 16c0 1 0 1.9-.1 2.9 82 15 144.1 86.8 144.1 173.1 0 97.2-78.8 176-176 176S16 465.2 16 368z"
    ]
};
var $159afdcd077ecfe9$export$ed7aa1c25104f333 = $159afdcd077ecfe9$export$efc6d53e0dedceee;
var $159afdcd077ecfe9$export$9ebfff5c90672059 = {
    prefix: 'fas',
    iconName: 'fire-flame-simple',
    icon: [
        384,
        512,
        [
            "burn"
        ],
        "f46a",
        "M372.5 256.5l-.7-1.9C337.8 160.8 282 76.5 209.1 8.5l-3.3-3C202.1 2 197.1 0 192 0s-10.1 2-13.8 5.5l-3.3 3C102 76.5 46.2 160.8 12.2 254.6l-.7 1.9C3.9 277.3 0 299.4 0 321.6 0 426.7 86.8 512 192 512s192-85.3 192-190.4c0-22.2-3.9-44.2-11.5-65.1zm-90.8 49.5c4.1 9.3 6.2 19.4 6.2 29.5 0 53-43 96.5-96 96.5s-96-43.5-96-96.5c0-10.1 2.1-20.3 6.2-29.5l1.9-4.3c15.8-35.4 37.9-67.7 65.3-95.1l8.9-8.9c3.6-3.6 8.5-5.6 13.6-5.6s10 2 13.6 5.6l8.9 8.9c27.4 27.4 49.6 59.7 65.3 95.1l1.9 4.3z"
    ]
};
var $159afdcd077ecfe9$export$80ed4535efc60402 = $159afdcd077ecfe9$export$9ebfff5c90672059;
var $159afdcd077ecfe9$export$1744430f718caf6b = {
    prefix: 'fas',
    iconName: 'tree',
    icon: [
        448,
        512,
        [
            127794
        ],
        "f1bb",
        "M224-32c7 0 13.7 3.1 18.3 8.5l136 160c6.1 7.1 7.4 17.1 3.5 25.6S369.4 176 360 176l-24.9 0 75.2 88.5c6.1 7.1 7.4 17.1 3.5 25.6S401.4 304 392 304l-38.5 0 88.8 104.5c6.1 7.1 7.4 17.1 3.5 25.6S433.4 448 424 448l-168 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-168 0c-9.4 0-17.9-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L94.5 304 56 304c-9.4 0-17.9-5.4-21.8-13.9s-2.6-18.5 3.5-25.6L112.9 176 88 176c-9.4 0-17.9-5.4-21.8-13.9s-2.6-18.5 3.5-25.6l136-160C210.3-28.9 217-32 224-32z"
    ]
};
var $159afdcd077ecfe9$export$aa11b8edb09fed14 = {
    prefix: 'fas',
    iconName: 'smog',
    icon: [
        576,
        512,
        [],
        "f75f",
        "M176 288C96.5 288 32 223.5 32 144S96.5 0 176 0c27.2 0 52.6 7.5 74.3 20.6 20.1-13 44-20.6 69.7-20.6 47.4 0 88.7 25.7 110.9 64l1.1 0c61.9 0 112 50.1 112 112 0 60.3-47.6 109.4-107.2 111.9-22.6 20-52.3 32.1-84.8 32.1-32.5 0-62.1-12.1-84.7-32L176 288zM512 392c0 13.3-10.7 24-24 24L24 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l464 0c13.3 0 24 10.7 24 24zM88 464l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm176 0l288 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$cb39585371b75720 = {
    prefix: 'fas',
    iconName: 's',
    icon: [
        320,
        512,
        [
            115
        ],
        "53",
        "M0 157.5C0 88.2 56.2 32 125.5 32L272 32c17.7 0 32 14.3 32 32s-14.3 32-32 32L125.5 96c-34 0-61.5 27.5-61.5 61.5 0 31 23.1 57.2 53.9 61L210.1 230C272.9 237.9 320 291.2 320 354.5 320 423.8 263.8 480 194.5 480L48 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l146.5 0c34 0 61.5-27.5 61.5-61.5 0-31-23.1-57.2-53.9-61L109.9 282C47.1 274.1 0 220.8 0 157.5z"
    ]
};
var $159afdcd077ecfe9$export$859f204e59641ca4 = {
    prefix: 'fas',
    iconName: 'jedi',
    icon: [
        576,
        512,
        [],
        "f669",
        "M246 315.7l-21.2-31.9c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l29.5 19.7c2.1 1.4 4.9-.1 5-2.6L279.7 8c.1-4.5 3.8-8 8.3-8s8.1 3.5 8.3 8l9.4 281.9c.1 2.5 2.9 3.9 5 2.6l29.5-19.7c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1L330 315.7c-1.3 1.9-.2 4.5 2 4.9l37.6 7.5c3.7 .7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8L332 351.4c-2.2 .4-3.3 3-2 4.9l21.2 31.9c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1l-26.3-17.6c-2.2-1.4-5.1 .2-5 2.8l2.1 61.5c59.8-10.8 105.1-63.1 105.1-126 0-37-15.7-70.4-40.8-93.7-7-6.5-6.5-18.6 1-24.4 34-26.3 55.8-67.5 55.8-113.9 0-16.8-2.9-33-8.2-48-4.6-13 10.2-30 21.4-22 53.5 38 92.7 94.8 107.8 160.7 .5 2.1-.2 4.3-1.7 5.9l-28.4 28.4c-4 4-1.2 10.9 4.5 10.9l26 0c3.4 0 6.2 2.6 6.3 6 .1 3.3 .2 6.6 .2 10 0 17.5-1.7 34.7-4.8 51.3-.2 1.2-.9 2.4-1.7 3.3l-46.5 46.5c-4 4-1.2 10.9 4.5 10.9l14.6 0c4.6 0 7.7 4.8 5.7 9-44.5 89.5-136.9 151-243.7 151S88.8 450.5 44.3 361c-2.1-4.2 1-9 5.7-9l14.6 0c5.7 0 8.6-6.9 4.5-10.9L22.6 294.6c-.9-.9-1.5-2-1.7-3.3-3.2-16.6-4.8-33.8-4.8-51.3 0-3.3 .1-6.7 .2-10 .1-3.4 2.9-6 6.3-6l26 0c5.7 0 8.6-6.9 4.5-10.9L24.6 184.6c-1.5-1.5-2.2-3.8-1.7-5.9 15.2-66 54.3-122.8 107.8-160.7 11.3-8 26 8.9 21.4 22-5.3 15-8.2 31.2-8.2 48 0 46.3 21.9 87.5 55.8 113.9 7.5 5.8 8 17.9 1 24.4-25.1 23.4-40.8 56.7-40.8 93.7 0 62.9 45.4 115.2 105.1 126l2.1-61.5c.1-2.6-2.8-4.2-5-2.8l-26.3 17.6c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1L246 356.3c1.3-1.9 .2-4.5-2-4.9l-37.6-7.5c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l37.6-7.5c2.2-.4 3.3-3 2-4.9z"
    ]
};
var $159afdcd077ecfe9$export$baf9f153991b2ea = {
    prefix: 'fas',
    iconName: 'person-hiking',
    icon: [
        448,
        512,
        [
            "hiking"
        ],
        "f6ec",
        "M192-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM128 173.6c0-34 27.6-61.6 61.6-61.6 20.3 0 39.7 8.1 54 22.4l48.2 48.2c6 6 14.1 9.4 22.6 9.4l37.5 0c5.8 0 11.3 1.6 16 4.3l0-76.3c0-13.3 10.7-24 24-24s24 10.7 24 24l0 400c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-268.3c-4.7 2.7-10.2 4.3-16 4.3l-37.5 0c-25.5 0-49.9-10.1-67.9-28.1l-6.6-6.6 0 109.2 34.5 29.6c17.7 15.2 29.3 36.2 32.6 59.3l12.6 88.1c2.5 17.5-9.7 33.7-27.2 36.2s-33.7-9.7-36.2-27.2l-12.6-88.1c-1.1-7.7-5-14.7-10.9-19.8l-71.4-61.2c-21.3-18.2-33.5-44.9-33.5-72.9l0-101zm-4.8 203.7c2.3 2.3 4.7 4.4 7.1 6.5l44.9 38.5c-3.6 8.4-8.5 16.3-14.4 23.4L88.6 532.5c-11.3 13.6-31.5 15.4-45.1 4.1s-15.4-31.5-4.1-45.1l72.3-86.7c2.6-3.1 4.5-6.6 5.8-10.4l5.7-17.1zM0 160c0-35.3 28.7-64 64-64 17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96z"
    ]
};
var $159afdcd077ecfe9$export$b2ab0105a901499e = $159afdcd077ecfe9$export$baf9f153991b2ea;
var $159afdcd077ecfe9$export$159982ce2622211e = {
    prefix: 'fas',
    iconName: 'arrows-up-to-line',
    icon: [
        448,
        512,
        [],
        "e4c2",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l384 0c17.7 0 32-14.3 32-32S433.7 0 416 0L32 0zm86.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L64 237.3 64 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-242.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64zm256 0c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4 0 242.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-242.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
var $159afdcd077ecfe9$export$2f8a28204bb4b86f = {
    prefix: 'fas',
    iconName: 'mars-double',
    icon: [
        640,
        512,
        [
            9891
        ],
        "f227",
        "M288 32c0-17.7 14.3-32 32-32L448 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50.7-95 95c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176S0 401.2 0 304 78.8 128 176 128c37 0 71.4 11.4 99.8 31l95-95-50.7 0c-17.7 0-32-14.3-32-32zM176 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm160 64c-6.8 0-13.4-.4-20-1.1 23.6-18.9 43.3-42.5 57.6-69.4 43.3-15.5 74.4-56.9 74.4-105.5 0-25.2-8.3-48.5-22.4-67.2 7.1 2.1 14.6 3.2 22.4 3.2 17 0 32.7-5.3 45.7-14.3 11.7 23.6 18.3 50.2 18.3 78.3 0 97.2-78.8 176-176 176zM528 157.3L528 32c0-11.4-2.4-22.2-6.7-32L608 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50.7-48 48z"
    ]
};
var $159afdcd077ecfe9$export$f576739e9b18ea4f = {
    prefix: 'fas',
    iconName: 'thermometer',
    icon: [
        512,
        512,
        [],
        "f491",
        "M96 382.1l0-88.8c0-14.9 5.9-29.1 16.4-39.6l21.7-21.7 41 41c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 46.1-46.1 41 41c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 46.1-46.1 41 41c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-41-41 7.8-7.8c19.4-19.4 45.6-30.2 73-30.2 57 0 103.2 46.2 103.2 103.2 0 27.4-10.9 53.6-30.2 73L258.3 399.6c-10.5 10.5-24.7 16.4-39.6 16.4l-88.8 0-89 89c-9.4 9.4-24.6 9.4-33.9 0S-2.3 480.4 7 471l89-89z"
    ]
};
var $159afdcd077ecfe9$export$7c8b56f3f296a814 = {
    prefix: 'fas',
    iconName: 'paintbrush',
    icon: [
        576,
        512,
        [
            128396,
            "paint-brush"
        ],
        "f1fc",
        "M480.5 10.3L259.1 158c-29.1 19.4-47.6 50.9-50.6 85.3 62.3 12.8 111.4 61.9 124.3 124.3 34.5-3 65.9-21.5 85.3-50.6L565.7 95.5c6.7-10.1 10.3-21.9 10.3-34.1 0-33.9-27.5-61.4-61.4-61.4-12.1 0-24 3.6-34.1 10.3zM288 400c0-61.9-50.1-112-112-112S64 338.1 64 400c0 3.9 .2 7.8 .6 11.6 1.8 17.5-10.2 36.4-27.8 36.4L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0c61.9 0 112-50.1 112-112z"
    ]
};
var $159afdcd077ecfe9$export$594db3339e212bc9 = $159afdcd077ecfe9$export$7c8b56f3f296a814;
var $159afdcd077ecfe9$export$771cf879fba0cf93 = {
    prefix: 'fas',
    iconName: 'neuter',
    icon: [
        384,
        512,
        [
            9906
        ],
        "f22c",
        "M80 176a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM223.9 349.1C305.9 334.1 368 262.3 368 176 368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144.1 173.1-.1 1-.1 1.9-.1 2.9l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-1 0-1.9-.1-2.9z"
    ]
};
var $159afdcd077ecfe9$export$b627121801cad756 = {
    prefix: 'fas',
    iconName: 'square-phone-flip',
    icon: [
        448,
        512,
        [
            "phone-square-alt"
        ],
        "f87b",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm232 96.7l2.8 .8c32.3 8.8 59.9 40.1 51.8 78.2-18.5 87.5-87.4 156.3-174.9 174.9-38.1 8.1-69.4-19.5-78.2-51.8l-.8-2.8c-2.7-9.8 2.4-20.1 11.8-24l48.7-20.3c8.3-3.4 17.8-1.1 23.5 5.9l19.3 23.6c35.1-17.4 63.4-46.6 79.6-82.4l-22.1-18c-6.9-5.7-9.3-15.2-5.9-23.5l20.3-48.7c3.9-9.4 14.2-14.4 24-11.8z"
    ]
};
var $159afdcd077ecfe9$export$a41e77f0de98bba7 = $159afdcd077ecfe9$export$b627121801cad756;
var $159afdcd077ecfe9$export$8eee2c17ff89e724 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue-squint',
    icon: [
        512,
        512,
        [
            128541,
            "grin-tongue-squint"
        ],
        "f58a",
        "M0 256c0 104.4 62.5 194.2 152.2 234.1-5.3-13-8.2-27.2-8.2-42.1l0-61.7c-16.9-16.5-30.1-36.7-38.3-59.3-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1c11.9-3.7 23.9 6.3 19.6 18.1-8.3 22.6-21.5 42.8-38.3 59.3l0 61.7c0 14.9-2.9 29.1-8.2 42.1 89.7-39.8 152.2-129.6 152.2-234.1 0-141.4-114.6-256-256-256S0 114.6 0 256zm125.8-91.7c-6.2-5.2-7.6-14.3-3.1-21.1s13.3-9.2 20.6-5.5l79.6 40c5.4 2.7 8.8 8.2 8.8 14.3s-3.4 11.6-8.8 14.3l-79.6 40c-7.3 3.6-16.1 1.3-20.6-5.5s-3.1-15.9 3.1-21.1L159 192 125.8 164.3zm263.6-21.1c4.5 6.8 3.1 15.9-3.1 21.1L353 192 386.2 219.7c6.2 5.2 7.6 14.3 3.1 21.1s-13.3 9.2-20.6 5.5l-79.6-40c-5.4-2.7-8.8-8.2-8.8-14.3s3.4-11.6 8.8-14.3l79.6-40c7.3-3.6 16.1-1.3 20.6 5.5zM320 448l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $159afdcd077ecfe9$export$4edf34c3def09a31 = $159afdcd077ecfe9$export$8eee2c17ff89e724;
var $159afdcd077ecfe9$export$7a088030853df12c = {
    prefix: 'fas',
    iconName: 'comment-dollar',
    icon: [
        512,
        512,
        [],
        "f651",
        "M256 480c141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240c0 54.3 19.2 104.3 51.6 144.5L2.8 476.8c-4.8 9-3.3 20 3.6 27.5s17.8 9.8 27.1 5.8l118.4-50.7C183.7 472.6 218.9 480 256 480zm4-352c11 0 20 9 20 20l0 4 8 0c11 0 20 9 20 20s-9 20-20 20l-47.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 4.7c0 11-9 20-20 20s-20-9-20-20l0-4-24 0c-11 0-20-9-20-20s9-20 20-20l55.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-4c0-11 9-20 20-20z"
    ]
};
var $159afdcd077ecfe9$export$d4c909619093de2d = {
    prefix: 'fas',
    iconName: 'hippo',
    icon: [
        640,
        512,
        [
            129435
        ],
        "f6ed",
        "M407 47c9.4-9.4 24.6-9.4 33.9 0l17.2 17.2c1.9-.1 3.9-.2 5.8-.2l32 0c11.2 0 21.9 2.3 31.6 6.5L543 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L564 101.9c7.6 12.2 12 26.7 12 42.1 0 10.2 7.4 18.8 16.7 23 27.9 12.5 47.3 40.5 47.3 73 0 26.2-12.6 49.4-32 64l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-16-64 0 0 16c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-17.6c-11.8-2.4-22.7-7.4-32-14.4-1.5-1.1-2.9-2.3-4.3-3.5-17-14.7-27.7-36.4-27.7-60.5 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 44.7 26.2 83.2 64 101.2l0 10.8c0 17.7 14.3 32 32 32l32 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-76c-19.8 7.7-41.4 12-64 12s-44.2-4.3-64-12l0 76c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-118.9-18.1 40.7c-5.4 12.1-19.6 17.6-31.7 12.2S-3.3 362.4 2.1 350.3L24 300.9c5.3-11.9 8-24.7 8-37.7 0-107.5 85.2-195.2 191.8-199.1l.2-.1 64 0c41.7 0 83.4 12.1 117.2 25.7 1.7-1.8 3.5-3.6 5.3-5.2L407 81c-9.4-9.4-9.4-24.6 0-33.9zm73 185a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM480 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $159afdcd077ecfe9$export$8b89ca3201039376 = {
    prefix: 'fas',
    iconName: 'bowl-food',
    icon: [
        512,
        512,
        [],
        "e4c6",
        "M0 176c0-35.3 28.7-64 64-64 .5 0 1.1 0 1.6 0 7.4-36.5 39.7-64 78.4-64 15 0 29 4.1 40.9 11.2 13.3-25.7 40.1-43.2 71.1-43.2s57.8 17.6 71.1 43.2c12-7.1 26-11.2 40.9-11.2 38.7 0 71 27.5 78.4 64 .5 0 1.1 0 1.6 0 35.3 0 64 28.7 64 64 0 11.7-3.1 22.6-8.6 32L8.6 208C3.1 198.6 0 187.7 0 176zM0 283.4C0 268.3 12.3 256 27.4 256l457.1 0c15.1 0 27.4 12.3 27.4 27.4 0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28l-231.5 0c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4z"
    ]
};
var $159afdcd077ecfe9$export$f9409a7b020dbec4 = {
    prefix: 'fas',
    iconName: 'square-virus',
    icon: [
        448,
        512,
        [],
        "e578",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm160 80c13.3 0 24 10.7 24 24 0 22.9 27.7 34.4 43.9 18.2 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.2 16.2-4.7 43.9 18.2 43.9 13.3 0 24 10.7 24 24s-10.7 24-24 24c-22.9 0-34.4 27.7-18.2 43.9 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-16.2-16.2-43.9-4.7-43.9 18.2 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.9-27.7-34.4-43.9-18.2-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c16.2-16.2 4.7-43.9-18.2-43.9-13.3 0-24-10.7-24-24s10.7-24 24-24c22.9 0 34.4-27.7 18.2-43.9-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16.2 16.2 43.9 4.7 43.9-18.2 0-13.3 10.7-24 24-24zM192 248a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$dd9dc9b4227dbe94 = {
    prefix: 'fas',
    iconName: 'cloud-sun-rain',
    icon: [
        576,
        512,
        [
            127782
        ],
        "f743",
        "M303.2-3.2c-1.1-5.2-4.6-9.5-9.5-11.6s-10.5-1.5-14.9 1.4L208 33.6 137.3-13.3c-4.4-2.9-10-3.5-14.9-1.4s-8.5 6.4-9.5 11.6L96 80 12.8 96.8c-5.2 1.1-9.5 4.6-11.6 9.5s-1.5 10.5 1.4 14.9L49.6 192 2.7 262.7c-2.9 4.4-3.5 10-1.4 14.9s6.4 8.5 11.6 9.5L96 304 112.8 387.2c1.1 5.2 4.6 9.5 9.5 11.6s10.5 1.5 14.9-1.4l67.3-44.6c-15.8-19.4-26-43.5-28.2-69.9-37.5-13.1-64.4-48.7-64.4-90.7 0-53 43-96 96-96 21.7 0 41.8 7.2 57.8 19.4 15.5-17.6 36.9-30 61.1-34L320 80 303.2-3.2zM243 159.1c-8.8-9.3-21.2-15.1-35-15.1-26.5 0-48 21.5-48 48 0 17 8.9 32 22.2 40.5 10.2-31.4 32.1-57.4 60.7-73l.1-.4zM304 352l192 0c44.2 0 80-35.8 80-80 0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-30.8 0-57.5 17.4-70.9 42.8-9.3-6.8-20.7-10.8-33.1-10.8-30.9 0-56 25.1-56 56 0 3.2 .3 6.4 .8 9.4-36.9 7.1-64.8 39.6-64.8 78.6 0 44.2 35.8 80 80 80zm-19 49.1c-12.6-4.2-26.2 2.6-30.4 15.2l-21.4 64.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l21.4-64.1c4.2-12.6-2.6-26.2-15.2-30.4zm120 0c-12.6-4.2-26.2 2.6-30.4 15.2l-21.4 64.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l21.4-64.1c4.2-12.6-2.6-26.2-15.2-30.4zm120 0c-12.6-4.2-26.2 2.6-30.4 15.2l-21.4 64.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l21.4-64.1c4.2-12.6-2.6-26.2-15.2-30.4z"
    ]
};
var $159afdcd077ecfe9$export$becbc35d3541bcc = {
    prefix: 'fas',
    iconName: 'arrow-right-long',
    icon: [
        576,
        512,
        [
            "long-arrow-right"
        ],
        "f178",
        "M566.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L466.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l434.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $159afdcd077ecfe9$export$7ec6527cf8651899 = $159afdcd077ecfe9$export$becbc35d3541bcc;
var $159afdcd077ecfe9$export$fbbc7601eb465ac7 = {
    prefix: 'fas',
    iconName: 'building-un',
    icon: [
        512,
        512,
        [],
        "e4d9",
        "M32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 272-112 0c-20.9 0-39.5 10.1-51.2 25.6-8-6-18-9.6-28.8-9.6-26.5 0-48 21.5-48 48l0 64 64 0 0 48-144 0c-35.3 0-64-28.7-64-64L32 64zM144 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM144 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM427.4 380.5c9-2.1 18.3 2.2 22.5 10.5l26.1 52.2 0-43.3c0-11 9-20 20-20s20 9 20 20l0 128c0 9.3-6.4 17.3-15.4 19.5s-18.3-2.2-22.5-10.5L452 484.7 452 528c0 11-9 20-20 20s-20-9-20-20l0-128c0-9.3 6.4-17.3 15.4-19.5zM324 400l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-96c0-11 9-20 20-20s20 9 20 20l0 96c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-96c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $159afdcd077ecfe9$export$9e9af12b90a1abd2 = {
    prefix: 'fas',
    iconName: 'temperature-low',
    icon: [
        512,
        512,
        [],
        "f76b",
        "M96 96c0-53 43-96 96-96s96 43 96 96l0 164.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144S48 447.5 48 368c0-42.6 18.5-81 48-107.3L96 96zm96 336c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-28.7c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 28.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM464 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"
    ]
};
var $159afdcd077ecfe9$export$41821b9a6fd703de = {
    prefix: 'fas',
    iconName: 'door-open',
    icon: [
        448,
        512,
        [],
        "f52b",
        "M288 64l64 0 0 416c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-384c0-35.3-28.7-64-64-64l-96 0 0 0-160 0C60.7 0 32 28.7 32 64l0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-416zM160 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$e490f662af4d1c78 = {
    prefix: 'fas',
    iconName: 'align-left',
    icon: [
        448,
        512,
        [],
        "f036",
        "M288 64c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32L32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$84ffbd7161ca2008 = {
    prefix: 'fas',
    iconName: 'camera',
    icon: [
        512,
        512,
        [
            62258,
            "camera-alt"
        ],
        "f030",
        "M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0-10.4-31.2C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $159afdcd077ecfe9$export$8872b5664e88e793 = $159afdcd077ecfe9$export$84ffbd7161ca2008;
var $159afdcd077ecfe9$export$9c0b63b698611d06 = {
    prefix: 'fas',
    iconName: 'users-rays',
    icon: [
        640,
        512,
        [],
        "e593",
        "M31-33C21.7-23.6 21.7-8.4 31 1L87 57c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65-33c-9.4-9.4-24.6-9.4-33.9 0zM609-33c-9.4-9.4-24.6-9.4-33.9 0L519 23c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L609 1c9.4-9.4 9.4-24.6 0-33.9zM65 545l56-56c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L31 511c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zm544 0c9.4-9.4 9.4-24.6 0-33.9l-56-56c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l56 56c9.4 9.4 24.6 9.4 33.9 0zM320 208a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 32c-61.9 0-112 50.1-112 112l0 8c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24l0-8c0-61.9-50.1-112-112-112zm216-80a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM451.2 260.4C469.4 286.3 480 317.9 480 352l0 8c0 8.4-1.4 16.5-4.1 24l78.8 0c11.8 0 21.3-9.6 21.3-21.3l0-10.7c0-53-43-96-96-96-10 0-19.7 1.5-28.8 4.4zm-262.4 0c-9.1-2.9-18.8-4.4-28.8-4.4-53 0-96 43-96 96l0 10.7c0 11.8 9.6 21.3 21.3 21.3l78.8 0c-2.7-7.5-4.1-15.6-4.1-24l0-8c0-34.1 10.6-65.7 28.8-91.6zM216 160a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"
    ]
};
var $159afdcd077ecfe9$export$92ab27739d3a91b2 = {
    prefix: 'fas',
    iconName: 'rainbow',
    icon: [
        640,
        512,
        [
            127752
        ],
        "f75b",
        "M320 96C178.6 96 64 210.6 64 352l0 64c0 17.7-14.3 32-32 32S0 433.7 0 416l0-64C0 175.3 143.3 32 320 32S640 175.3 640 352l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64C576 210.6 461.4 96 320 96zm0 112c-79.5 0-144 64.5-144 144l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-114.9 93.1-208 208-208s208 93.1 208 208l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-79.5-64.5-144-144-144zM288 352l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-53 43-96 96-96s96 43 96 96l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $159afdcd077ecfe9$export$b2ce5e79d0eccaf8 = {
    prefix: 'fas',
    iconName: 'sitemap',
    icon: [
        512,
        512,
        [],
        "f0e8",
        "M192 64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-8 0 0 64 120 0c39.8 0 72 32.2 72 72l0 56 8 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l8 0 0-56c0-13.3-10.7-24-24-24l-120 0 0 80 8 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l8 0 0-80-120 0c-13.3 0-24 10.7-24 24l0 56 8 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l8 0 0-56c0-39.8 32.2-72 72-72l120 0 0-64-8 0c-17.7 0-32-14.3-32-32l0-64z"
    ]
};
var $159afdcd077ecfe9$export$1d1fbac384a76a12 = {
    prefix: 'fas',
    iconName: 'face-grin-stars',
    icon: [
        512,
        512,
        [
            129321,
            "grin-stars"
        ],
        "f587",
        "M256 512c141.4 0 256-114.6 256-256 0-24.4-3.4-48.1-9.8-70.5 18.6-36.1-2.7-83.6-46.7-90-46.9-58.3-118.9-95.5-199.5-95.5S103.4 37.3 56.5 95.5c-44 6.4-65.3 53.9-46.7 90-6.4 22.4-9.8 46-9.8 70.5 0 141.4 114.6 256 256 256zM386.7 324.9c11.9-3.7 23.9 6.3 19.6 18.1-22.4 61.3-81.3 105.1-150.3 105.1S128.1 404.2 105.7 342.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1zm-31.6-231c5.3-10.7 20.5-10.7 25.8 0l20.9 42.4 46.7 6.8c11.8 1.7 16.5 16.2 8 24.5l-33.8 33 8 46.6c2 11.7-10.3 20.7-20.9 15.2l-41.8-22-41.8 22c-10.5 5.5-22.9-3.4-20.9-15.2l8-46.6-33.8-33c-8.5-8.3-3.8-22.8 8-24.5l46.7-6.8 20.9-42.4zm-198.2 0l20.9 42.4 46.7 6.8c11.8 1.7 16.5 16.2 8 24.5l-33.8 33 8 46.6c2 11.7-10.3 20.7-20.9 15.2l-41.8-22-41.8 22c-10.5 5.5-22.9-3.4-20.9-15.2l8-46.6-33.8-33c-8.5-8.3-3.8-22.8 8-24.5l46.7-6.8 20.9-42.4c5.3-10.7 20.5-10.7 25.8 0z"
    ]
};
var $159afdcd077ecfe9$export$64347a5c8c402ef4 = $159afdcd077ecfe9$export$1d1fbac384a76a12;
var $159afdcd077ecfe9$export$f9dd5b1410e95035 = {
    prefix: 'fas',
    iconName: 'sort-up',
    icon: [
        384,
        512,
        [
            "sort-asc"
        ],
        "f0de",
        "M32 224c-12.9 0-24.6-7.8-29.6-19.8S.2 178.5 9.4 169.4l160-160c12.5-12.5 32.8-12.5 45.3 0l160 160c9.2 9.2 11.9 22.9 6.9 34.9S364.9 224 352 224L32 224z"
    ]
};
var $159afdcd077ecfe9$export$e4c8c924b1cc43a7 = $159afdcd077ecfe9$export$f9dd5b1410e95035;
var $159afdcd077ecfe9$export$b8c3e79e8c99c95b = {
    prefix: 'fas',
    iconName: 'eye',
    icon: [
        576,
        512,
        [
            128065
        ],
        "f06e",
        "M288 32c-80.8 0-145.5 36.8-192.6 80.6-46.8 43.5-78.1 95.4-93 131.1-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47.1 43.7 111.8 80.6 192.6 80.6s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64-11.5 0-22.3-3-31.7-8.4-1 10.9-.1 22.1 2.9 33.2 13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-12.2-45.7-55.5-74.8-101.1-70.8 5.3 9.3 8.4 20.1 8.4 31.7z"
    ]
};
var $159afdcd077ecfe9$export$85a918a11b7643c2 = {
    prefix: 'fas',
    iconName: 'caret-left',
    icon: [
        256,
        512,
        [],
        "f0d9",
        "M224 96c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c9.2 9.2 22.9 11.9 34.9 6.9S224 428.9 224 416l0-320z"
    ]
};
var $159afdcd077ecfe9$export$12de8220d30453a3 = {
    prefix: 'fas',
    iconName: 'apple-whole',
    icon: [
        448,
        512,
        [
            127822,
            127823,
            "apple-alt"
        ],
        "f5d1",
        "M224 112c-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80l16 0c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80l-16 0zM0 288c0-76.3 35.7-160 112-160 27.3 0 59.7 10.3 82.7 19.3 18.8 7.3 39.9 7.3 58.7 0 22.9-8.9 55.4-19.3 82.7-19.3 76.3 0 112 83.7 112 160 0 128-80 224-160 224-16.5 0-38.1-6.6-51.5-11.3-8.1-2.8-16.9-2.8-25 0-13.4 4.7-35 11.3-51.5 11.3-80 0-160-96-160-224z"
    ]
};
var $159afdcd077ecfe9$export$bcdd94f3977a0884 = $159afdcd077ecfe9$export$12de8220d30453a3;
var $159afdcd077ecfe9$export$4e3fe5b42a6cd494 = {
    prefix: 'fas',
    iconName: 'scroll-torah',
    icon: [
        576,
        512,
        [
            "torah"
        ],
        "f6a0",
        "M0 48C0 21.5 21.5 0 48 0 68.9 0 86.7 13.4 93.3 32l389.5 0c6.6-18.6 24.4-32 45.3-32 26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48-20.9 0-38.7-13.4-45.3-32L93.3 480c-6.6 18.6-24.4 32-45.3 32-26.5 0-48-21.5-48-48L0 48zM177.9 301c-1.2 2-1.9 4.2-1.9 6.6 0 6.9 5.6 12.5 12.5 12.5l56.9 0 30.5 49.2c2.6 4.2 7.2 6.8 12.2 6.8s9.6-2.6 12.2-6.8l30.5-49.2 56.9 0c6.9 0 12.5-5.6 12.5-12.5 0-2.3-.6-4.6-1.9-6.6l-27.8-45 27.8-45c1.2-2 1.9-4.2 1.9-6.6 0-6.9-5.6-12.5-12.5-12.5l-56.9 0-30.5-49.2c-2.6-4.2-7.2-6.8-12.2-6.8s-9.6 2.6-12.2 6.8l-30.5 49.2-56.9 0c-6.9 0-12.5 5.6-12.5 12.5 0 2.3 .6 4.6 1.9 6.6l27.8 45-27.8 45z"
    ]
};
var $159afdcd077ecfe9$export$54d07baabd8c2acb = $159afdcd077ecfe9$export$4e3fe5b42a6cd494;
var $159afdcd077ecfe9$export$aa54b16c409e882f = {
    prefix: 'fas',
    iconName: 'house-lock',
    icon: [
        640,
        512,
        [],
        "e510",
        "M528 224.1c44.2 0 80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80zM268.6 6.5c12.2-9.3 29.7-8.7 41.2 2l185 171.8C440.2 195 400 244.8 400 304l0 24.4c-19.6 17.6-32 43.1-32 71.5l0 96c0 5.5 .5 10.9 1.3 16.1L144 512c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208 2.4-2zM272 320c-26.5 0-48 21.5-48 48l0 96 96 0 0-87.3c0-16.5 7-31.5 18.4-42.1-8.7-9-20.9-14.6-34.4-14.6l-32 0zm256-47.9c-17.7 0-32 14.3-32 32l0 47.9 64 0 0-47.9c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$a63cecc8a4166c49 = {
    prefix: 'fas',
    iconName: 'arrows-left-right-to-line',
    icon: [
        576,
        512,
        [],
        "e4ba",
        "M32 96C14.3 96 0 110.3 0 128L0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-17.7-14.3-32-32-32zM390.6 342.6l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4-133.5 0 9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 133.5 0-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0zM576 128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256z"
    ]
};
var $159afdcd077ecfe9$export$ed8c149a0ea54bb4 = {
    prefix: 'fas',
    iconName: 'trash',
    icon: [
        448,
        512,
        [],
        "f1f8",
        "M136.7 5.9L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-8.7-26.1C306.9-7.2 294.7-16 280.9-16L167.1-16c-13.8 0-26 8.8-30.4 21.9zM416 144L32 144 53.1 467.1C54.7 492.4 75.7 512 101 512L347 512c25.3 0 46.3-19.6 47.9-44.9L416 144z"
    ]
};
var $159afdcd077ecfe9$export$8a5a0dbb2a17e253 = {
    prefix: 'fas',
    iconName: 'face-sad-tear',
    icon: [
        512,
        512,
        [
            128546,
            "sad-tear"
        ],
        "f5b4",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm271 98c5.5-1.3 11.1-2 17-2 24.1 0 45.4 11.8 58.5 30 7.7 10.8 22.7 13.2 33.5 5.5s13.2-22.7 5.5-33.5c-21.7-30.2-57.3-50-97.5-50-12.5 0-24.6 1.9-35.9 5.5 9.8 12.7 16.5 27.9 18.9 44.6zM176 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM185.4 292.8c-2.4-2.9-5.7-4.8-9.4-4.8s-7 1.9-9.4 4.8c-6.5 7.8-12.6 16.1-18.3 24.6-9 13.4-20.3 30.2-20.3 47.4 0 28.3 21.5 51.2 48 51.2s48-22.9 48-51.2c0-17.2-11.2-34-20.3-47.4-5.7-8.5-11.9-16.7-18.3-24.6z"
    ]
};
var $159afdcd077ecfe9$export$4b5241926f692f91 = $159afdcd077ecfe9$export$8a5a0dbb2a17e253;
var $159afdcd077ecfe9$export$b5698497901d7197 = {
    prefix: 'fas',
    iconName: 'fax',
    icon: [
        512,
        512,
        [
            128224,
            128439
        ],
        "f1ac",
        "M160 64l0 80 64 0 0-80 146.7 0 45.3 45.3 0 34.7 64 0 0-34.7c0-17-6.7-33.3-18.7-45.3L416 18.7C404 6.7 387.7 0 370.7 0L224 0c-35.3 0-64 28.7-64 64zM32 128c-17.7 0-32 14.3-32 32L0 448c0 17.7 14.3 32 32 32l48 0c17.7 0 32-14.3 32-32l0-288c0-17.7-14.3-32-32-32l-48 0zm448 64l-320 0 0 256c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32zM224 288a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM336 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM312 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM424 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM400 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$55686b1eb7d00307 = {
    prefix: 'fas',
    iconName: 'person-circle-plus',
    icon: [
        640,
        512,
        [],
        "e541",
        "M280 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 212.7L341 286.6c12.8-17.5 28.5-32.7 46.3-45l-56.2-75.7C306 132 266.3 112 224 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L144 236.7 144 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-275.3zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm16-208l0 48 48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $159afdcd077ecfe9$export$38d20d399463edf9 = {
    prefix: 'fas',
    iconName: 'hamsa',
    icon: [
        512,
        512,
        [],
        "f665",
        "M34.6 288L80 288c8.8 0 16-7.2 16-16L96 72c0-22.1 17.9-40 40-40s40 17.9 40 40l0 132c0 11 9 20 20 20s20-9 20-20l0-164c0-22.1 17.9-40 40-40s40 17.9 40 40l0 164c0 11 9 20 20 20s20-9 20-20l0-132c0-22.1 17.9-40 40-40s40 17.9 40 40l0 200c0 8.8 7.2 16 16 16l45.4 0c19.1 0 34.6 15.5 34.6 34.6 0 8.6-3.2 16.9-9 23.3L416.6 441c-41.1 45.2-99.4 71-160.6 71S136.6 486.2 95.4 441L9 345.9c-5.8-6.4-9-14.7-9-23.3 0-19.1 15.5-34.6 34.6-34.6zM256 288c-38.4 0-76.8 35.8-90.6 50.2-3.6 3.7-5.4 8.7-5.4 13.8s1.8 10.1 5.4 13.8C179.2 380.2 217.6 416 256 416s76.8-35.8 90.6-50.2c3.6-3.7 5.4-8.7 5.4-13.8s-1.8-10.1-5.4-13.8C332.8 323.8 294.4 288 256 288zm0 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$c8f8a597ffd676c0 = {
    prefix: 'fas',
    iconName: 'person-circle-question',
    icon: [
        640,
        512,
        [],
        "e542",
        "M280 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 212.7L341 286.6c12.8-17.5 28.5-32.7 46.3-45l-56.2-75.7C306 132 266.3 112 224 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L144 236.7 144 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-275.3zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-100c-11.6 0-21.3 8.2-23.5 19.2-1.8 8.7-10.2 14.3-18.9 12.5s-14.3-10.2-12.5-18.9c5.2-25.6 27.8-44.8 54.9-44.8 30.9 0 56 25.1 56 56 0 19.8-11.7 37.8-29.8 45.9l-10.4 4.6c-1.2 7.7-7.8 13.5-15.8 13.5-8.8 0-16-7.2-16-16 0-11.2 6.6-21.3 16.8-25.9l12.4-5.5c6.6-2.9 10.8-9.4 10.8-16.6 0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$7babcb2c90eb609a = {
    prefix: 'fas',
    iconName: 'clipboard-check',
    icon: [
        384,
        512,
        [],
        "f46c",
        "M256 0c23.7 0 44.4 12.9 55.4 32l8.6 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l8.6 0C83.6 12.9 104.3 0 128 0L256 0zm26.9 212.6c-10.7-7.8-25.7-5.4-33.5 5.3l-85.6 117.7-26.5-27.4c-9.2-9.5-24.4-9.8-33.9-.6s-9.8 24.4-.6 33.9l46.4 48c4.9 5.1 11.8 7.8 18.9 7.3s13.6-4.1 17.8-9.8L288.2 246.1c7.8-10.7 5.4-25.7-5.3-33.5zM136 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 64z"
    ]
};
var $159afdcd077ecfe9$export$928280bdd54fa173 = {
    prefix: 'fas',
    iconName: 'share-from-square',
    icon: [
        576,
        512,
        [
            61509,
            "share-square"
        ],
        "f14d",
        "M384.5 24l0 72-64 0c-79.5 0-144 64.5-144 144 0 93.4 82.8 134.8 100.6 142.6 2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8 0-8.3-5.9-15.5-12.8-20.3-8.9-6.2-19.2-18.2-19.2-40.5 0-45 36.5-81.5 81.5-81.5l30.5 0 0 72c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l136-136c9.4-9.4 9.4-24.6 0-33.9L425.5 7c-6.9-6.9-17.2-8.9-26.2-5.2S384.5 14.3 384.5 24zm-272 72c-44.2 0-80 35.8-80 80l0 256c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80l0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32c0 8.8-7.2 16-16 16l-256 0c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0z"
    ]
};
var $159afdcd077ecfe9$export$ae9e1434571f373c = $159afdcd077ecfe9$export$928280bdd54fa173;
var $159afdcd077ecfe9$export$32b0cd6133c2742 = {
    prefix: 'fas',
    iconName: 'receipt',
    icon: [
        384,
        512,
        [
            129534
        ],
        "f543",
        "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.2-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6S384 14.6 384 24l0 464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6l-40.4-34.6-40.4 34.6c-9 7.7-22.2 7.7-31.2 0l-40.4-34.6-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488L0 24C0 14.6 5.5 6.1 14 2.2zM104 136c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zM80 352c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm24-120c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z"
    ]
};
var $159afdcd077ecfe9$export$a7c5f5e4805fdab = {
    prefix: 'fas',
    iconName: 'equals',
    icon: [
        448,
        512,
        [
            62764
        ],
        "3d",
        "M32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 128zm0 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 320z"
    ]
};
var $159afdcd077ecfe9$export$877e5ae47a854215 = {
    prefix: 'fas',
    iconName: 'chevron-up',
    icon: [
        448,
        512,
        [],
        "f077",
        "M201.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 173.3 54.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
    ]
};
var $159afdcd077ecfe9$export$c4ff5306c5470939 = {
    prefix: 'fas',
    iconName: 'virus-slash',
    icon: [
        576,
        512,
        [],
        "e075",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-88.6-88.6c1.7-12.1-2-24.8-11.3-34-31.2-31.2-9.1-84.5 35-84.5 22.1 0 40-17.9 40-40s-17.9-40-40-40c-44.1 0-66.1-53.3-35-84.5 15.6-15.6 15.6-40.9 0-56.6s-40.9-15.6-56.6 0c-31.2 31.2-84.5 9.1-84.5-35 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 44.1-53.3 66.1-84.5 35-9.3-9.3-22-13-34-11.3L41-24.9zM72 216c-22.1 0-40 17.9-40 40s17.9 40 40 40c44.1 0 66.1 53.3 35 84.5-15.6 15.6-15.6 40.9 0 56.6s40.9 15.6 56.6 0c31.2-31.2 84.5-9.1 84.5 35 0 22.1 17.9 40 40 40s40-17.9 40-40c0-21.4 12.6-37.6 29.1-45.1l-240-240C109.6 203.4 93.4 216 72 216z"
    ]
};
var $159afdcd077ecfe9$export$f54d004dd5f1cb5e = {
    prefix: 'fas',
    iconName: 'slash',
    icon: [
        576,
        512,
        [],
        "f715",
        "M7-25c9.4-9.4 24.6-9.4 33.9 0L569 503c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 9C-2.3-.4-2.3-15.6 7-25z"
    ]
};
var $159afdcd077ecfe9$export$1fe4a9976a241685 = {
    prefix: 'fas',
    iconName: 'expand',
    icon: [
        448,
        512,
        [],
        "f065",
        "M32 32C14.3 32 0 46.3 0 64l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM64 352c0-17.7-14.3-32-32-32S0 334.3 0 352l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96z"
    ]
};
var $159afdcd077ecfe9$export$4a4e034527c933f5 = {
    prefix: 'fas',
    iconName: 'note-sticky',
    icon: [
        448,
        512,
        [
            62026,
            "sticky-note"
        ],
        "f249",
        "M64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 213.5c0 17-6.7 33.3-18.7 45.3L322.7 461.3c-12 12-28.3 18.7-45.3 18.7L64 480zM389.5 304L296 304c-13.3 0-24 10.7-24 24l0 93.5 117.5-117.5z"
    ]
};
var $159afdcd077ecfe9$export$80889adc5d98bf4a = $159afdcd077ecfe9$export$4a4e034527c933f5;
var $159afdcd077ecfe9$export$ccaa019a3fd4563f = {
    prefix: 'fas',
    iconName: 'table-columns',
    icon: [
        448,
        512,
        [
            "columns"
        ],
        "f0db",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 64l0 256 128 0 0-256-128 0zm320 0l-128 0 0 256 128 0 0-256z"
    ]
};
var $159afdcd077ecfe9$export$bb861166644ac28a = $159afdcd077ecfe9$export$ccaa019a3fd4563f;
var $159afdcd077ecfe9$export$d359c2cc7640953c = {
    prefix: 'fas',
    iconName: 'person-shelter',
    icon: [
        512,
        512,
        [],
        "e54f",
        "M271.9 4.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128C6.2 137.9 0 148.5 0 160L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32L64 178.6 256 68.9 448 178.6 448 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320c0-11.5-6.2-22.1-16.1-27.8l-224-128zM256 208a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm-8 192l16 0 0 88c0 13.3 10.7 24 24 24s24-10.7 24-24l0-174.5 26.9 49.9c6.3 11.7 20.8 16 32.5 9.8s16-20.8 9.8-32.5l-33.2-61.7C329.7 245.1 294.4 224 256 224s-73.7 21.1-91.9 54.9l-33.2 61.7c-6.3 11.7-1.9 26.2 9.8 32.5s26.2 1.9 32.5-9.8L200 313.5 200 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-88z"
    ]
};
var $159afdcd077ecfe9$export$9429fd8df55155d = {
    prefix: 'fas',
    iconName: 'circle-notch',
    icon: [
        512,
        512,
        [],
        "f1ce",
        "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8-79.3 23.6-137.1 97.1-137.1 184.1 0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256 512 397.4 397.4 512 256 512S0 397.4 0 256c0-116 77.1-213.9 182.9-245.4 16.9-5 34.8 4.6 39.8 21.5z"
    ]
};
var $159afdcd077ecfe9$export$efaeddad0a6e901b = {
    prefix: 'fas',
    iconName: 'water',
    icon: [
        512,
        512,
        [],
        "f773",
        "M410.6 124.1c20.7 15.6 46 30.7 74.2 34.5 13.1 1.8 25.2-7.5 27-20.6s-7.5-25.2-20.6-27c-15.9-2.1-33.2-11.3-51.7-25.2-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-18.5 13.9-35.8 23.1-51.7 25.2-13.1 1.8-22.4 13.8-20.6 27s13.8 22.4 27 20.6c28.2-3.8 53.6-18.9 74.2-34.5 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9c21.3-16.1 49.9-16.1 71.2 0zm0 144c20.7 15.6 46 30.7 74.2 34.5 13.1 1.8 25.2-7.5 27-20.6s-7.5-25.2-20.6-27c-15.9-2.1-33.2-11.3-51.7-25.2-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-18.5 13.9-35.8 23.1-51.7 25.2-13.1 1.7-22.4 13.8-20.6 27s13.8 22.4 27 20.6c28.2-3.8 53.6-18.9 74.2-34.5 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9c21.3-16.1 49.9-16.1 71.2 0zm-71.2 144c21.3-16.1 49.9-16.1 71.2 0 20.7 15.6 46 30.7 74.2 34.5 13.1 1.8 25.2-7.5 27-20.6s-7.5-25.2-20.6-27c-15.9-2.1-33.2-11.3-51.7-25.2-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-18.5 13.9-35.8 23.1-51.7 25.2-13.1 1.8-22.4 13.8-20.6 27s13.8 22.4 27 20.6c28.2-3.8 53.6-18.9 74.2-34.5 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9z"
    ]
};
var $159afdcd077ecfe9$export$bbcc9e0b6022772b = {
    prefix: 'fas',
    iconName: 'delete-left',
    icon: [
        640,
        512,
        [
            9003,
            "backspace"
        ],
        "f55a",
        "M576 128c0-35.3-28.7-64-64-64L205.3 64c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7L512 448c35.3 0 64-28.7 64-64l0-256zM284.1 188.1c9.4-9.4 24.6-9.4 33.9 0l33.9 33.9 33.9-33.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-33.9 33.9 33.9 33.9c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-33.9-33.9-33.9 33.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l33.9-33.9-33.9-33.9c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$e43e3f67102fc526 = $159afdcd077ecfe9$export$bbcc9e0b6022772b;
var $159afdcd077ecfe9$export$3e1327487ce53231 = {
    prefix: 'fas',
    iconName: 'broom-ball',
    icon: [
        576,
        512,
        [
            "quidditch",
            "quidditch-broom-ball"
        ],
        "f458",
        "M496 544a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM106.8 277.2c30.6-30.6 73.1-45.9 115.8-42.2L341 353.3c3.7 42.8-11.6 85.2-42.2 115.9-27.4 27.4-64.6 42.8-103.3 42.8L22.1 512c-12.2 0-22.1-9.9-22.1-22.1 0-6.3 2.7-12.3 7.3-16.5L133.7 359.7c4.2-3.7-.4-10.4-5.4-7.9L77.2 377.4c-6.1 3-13.2-1.4-13.2-8.2 0-31.5 12.5-61.8 34.8-84l8-8zm417-270c12.6-10.3 31.1-9.5 42.8 2.2s12.4 30.2 2.2 42.8l-2.2 2.4-192 192 34.8 34.7c4.2 4.2 6.6 10 6.6 16 0 12.5-10.1 22.6-22.6 22.6l-29.1 0-108.3-108.3 0-29.1c0-12.5 10.1-22.6 22.6-22.6 6 0 11.8 2.4 16 6.6l34.8 34.7 192-192 2.4-2.2z"
    ]
};
var $159afdcd077ecfe9$export$c00c446e6db1605f = $159afdcd077ecfe9$export$3e1327487ce53231;
var $159afdcd077ecfe9$export$791bfe29b97b4d42 = $159afdcd077ecfe9$export$3e1327487ce53231;
var $159afdcd077ecfe9$export$bbf24078bd1f73e6 = {
    prefix: 'fas',
    iconName: 'j',
    icon: [
        320,
        512,
        [
            106
        ],
        "4a",
        "M288 32c17.7 0 32 14.3 32 32l0 256c0 88.4-71.6 160-160 160S0 408.4 0 320l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32c0 53 43 96 96 96s96-43 96-96l0-256c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$76d92e7f30d064c5 = {
    prefix: 'fas',
    iconName: 'shuttle-space',
    icon: [
        576,
        512,
        [
            "space-shuttle"
        ],
        "f197",
        "M0 368l0 64c0 26.5 21.5 48 48 48l50 0c40.6 0 80.4-11 115.2-31.9l133.5-80.1-93.3 0-64.9 38.9c-14 8.4-28.9 14.7-44.5 19l0-66.4c9.7-5.6 17.8-13.7 23.4-23.4l198.8 0c67.1 0 127.8-20.6 170.3-70.6 4.6-5.4 4.6-13.3 0-18.8-42.5-50.1-103.2-70.6-170.3-70.6l-198.8 0c-5.6-9.7-13.7-17.8-23.4-23.4l0-66.4c15.6 4.2 30.6 10.6 44.5 19l64.9 38.9 93.3 0-133.5-80.1C178.4 43 138.6 32 98 32L48 32C21.5 32 0 53.5 0 80L0 368zm96 0l0 64-48 0 0-64 48 0zM96 80l0 64-48 0 0-64 48 0zM416 224c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$4d1c12ba2b4ca565 = $159afdcd077ecfe9$export$76d92e7f30d064c5;
var $159afdcd077ecfe9$export$6ec1acbf3f610b8f = {
    prefix: 'fas',
    iconName: 'yin-yang',
    icon: [
        512,
        512,
        [
            9775
        ],
        "f6ad",
        "M224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 352a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-448c53 0 96 43 96 96s-43 96-96 96-96 43-96 96 43 96 96 96C150 448 64 362 64 256S150 64 256 64zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$51577929c676143b = {
    prefix: 'fas',
    iconName: 'stop',
    icon: [
        448,
        512,
        [
            9209
        ],
        "f04d",
        "M64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z"
    ]
};
var $159afdcd077ecfe9$export$12ca996a6f686fe1 = {
    prefix: 'fas',
    iconName: 'trowel',
    icon: [
        576,
        512,
        [],
        "e589",
        "M407.9 181.4L277.3 312 342.6 377.4c7.9 7.9 11.1 19.4 8.4 30.3s-10.8 19.6-21.5 22.9l-256 80c-11.4 3.5-23.8 .5-32.2-7.9s-11.5-20.8-7.9-32.2l80-256c3.3-10.7 12-18.9 22.9-21.5s22.4 .5 30.3 8.4L232 266.7 362.6 136.1c-14.3-14.6-14.2-38 .3-52.5l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0s26.9 70.5 0 97.5l-95.4 95.4c-14.5 14.5-37.9 14.6-52.5 .3z"
    ]
};
var $159afdcd077ecfe9$export$be38a892fe9b4098 = {
    prefix: 'fas',
    iconName: 'hand-back-fist',
    icon: [
        384,
        512,
        [
            "hand-rock"
        ],
        "f255",
        "M7.4 253.6C2.6 245.9 0 237.1 0 228l0-36c0-26.5 21.5-48 48-48l16 0 0-80c0-26.5 21.5-48 48-48 17.3 0 32.4 9.1 40.9 22.8 4.3-22.1 23.8-38.8 47.1-38.8 23.4 0 42.9 16.8 47.1 38.9 7.3-4.4 15.8-6.9 24.9-6.9 22.1 0 40.8 15 46.3 35.4 5.5-2.2 11.4-3.4 17.7-3.4 26.5 0 48 21.5 48 48l0 96.9c0 9.9-2.3 19.7-6.8 28.6l-39.6 79.1c-10.8 21.7-33 35.4-57.2 35.4L96 352c-16.5 0-31.8-8.4-40.6-22.4l-48-76zM32 480l0-48c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$97a81eba394c8c44 = $159afdcd077ecfe9$export$be38a892fe9b4098;
var $159afdcd077ecfe9$export$15d012277c3ecf9a = {
    prefix: 'fas',
    iconName: 'temperature-high',
    icon: [
        512,
        512,
        [],
        "f769",
        "M96 96c0-53 43-96 96-96s96 43 96 96l0 164.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144S48 447.5 48 368c0-42.6 18.5-81 48-107.3L96 96zm96 336c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3L216 96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 212.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM464 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM352 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"
    ]
};
var $159afdcd077ecfe9$export$da07b6bc24a496ca = {
    prefix: 'fas',
    iconName: 'greater-than',
    icon: [
        512,
        512,
        [
            62769
        ],
        "3e",
        "M34.9 50.6c-7.4 16-.4 35.1 15.6 42.5L403.6 256 50.6 419c-16 7.4-23.1 26.4-15.6 42.5s26.4 23 42.5 15.6l416-192c11.3-5.2 18.6-16.6 18.6-29.1s-7.3-23.8-18.6-29.1L77.4 35c-16-7.4-35.1-.4-42.5 15.6z"
    ]
};
var $159afdcd077ecfe9$export$e94134641c0e2 = {
    prefix: 'fas',
    iconName: 'crutch',
    icon: [
        512,
        512,
        [],
        "f7f7",
        "M297.4 9.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-1.4-1.4-158.6 158.6c-18 18-42.4 28.1-67.9 28.1l-59 0c-8.5 0-16.6 3.4-22.6 9.4-61.7 61.7-92.8 92.8-93.3 93.3-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l16-16 0 0 77.3-77.3c6-6 9.4-14.1 9.4-22.6l0-59c0-25.5 10.1-49.9 28.1-67.9L298.7 56 297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3zM344 101.3L261.3 184 328 250.7 410.7 168 344 101.3zm-128 128l-30.6 30.6c-6 6-9.4 14.1-9.4 22.6l0 53.5 53.5 0c8.5 0 16.6-3.4 22.6-9.4L282.7 296 216 229.3z"
    ]
};
var $159afdcd077ecfe9$export$90261b091a6ebcaa = {
    prefix: 'fas',
    iconName: 'septagon',
    icon: [
        576,
        512,
        [
            "heptagon"
        ],
        "e820",
        "M267.4-31.5c15.9-5.5 33.5-4.6 48.8 2.7l172.4 83 6.3 3.5c14.2 9 24.5 23.3 28.3 39.9l42.6 186.5 1.2 7.2c1.6 14.3-1.7 28.8-9.4 41.1l-4.2 5.9-119.3 149.6c-12.1 15.2-30.6 24.1-50 24.1l-191.3 0c-19.5 0-37.9-8.9-50-24.1L23.5 338.4c-12.1-15.2-16.7-35.2-12.3-54.2l42.6-186.5 2-7c5.6-15.9 17.2-29 32.6-36.4l172.4-83 6.7-2.7z"
    ]
};
var $159afdcd077ecfe9$export$5946c0574351cb6f = $159afdcd077ecfe9$export$90261b091a6ebcaa;
var $159afdcd077ecfe9$export$6aab6c3359c2554c = {
    prefix: 'fas',
    iconName: 'street-view',
    icon: [
        512,
        512,
        [],
        "f21d",
        "M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 160l64 0c35.3 0 64 28.7 64 64l0 48c0 17.7-14.3 32-32 32l-1.8 0-11.1 99.5c-1.8 16.2-15.5 28.5-31.8 28.5l-38.7 0c-16.3 0-30-12.3-31.8-28.5l-11.1-99.5-1.8 0c-17.7 0-32-14.3-32-32l0-48c0-35.3 28.7-64 64-64zM412.4 400.2c-16.1-4.2-34.8-7.6-55.4-10.2l5.3-47.7c22.7 2.9 43.7 6.7 62.1 11.5 22.4 5.8 42.6 13.3 57.8 23.3 14.7 9.6 29.8 24.9 29.8 47s-15.1 37.4-29.8 47c-15.2 9.9-35.5 17.5-57.8 23.3-45.1 11.7-105.3 17.8-168.4 17.8s-123.3-6.1-168.4-17.8C65.2 488.4 45 480.9 29.8 471 15.1 461.4 0 446.1 0 424s15.1-37.4 29.8-47c15.2-9.9 35.5-17.5 57.8-23.3 18.5-4.8 39.5-8.6 62.1-11.5L155 390c-20.6 2.6-39.3 6.1-55.4 10.2-56.6 14.6-56.6 32.9 0 47.5 39.9 10.3 95.8 16.2 156.4 16.2s116.5-5.9 156.4-16.2c56.6-14.6 56.6-32.9 0-47.5z"
    ]
};
var $159afdcd077ecfe9$export$c38cf504b3bc58a2 = {
    prefix: 'fas',
    iconName: 'wave-square',
    icon: [
        512,
        512,
        [],
        "f83e",
        "M64 96c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 288 96 0 0-128c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 128c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-288-96 0 0 128c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-128z"
    ]
};
var $159afdcd077ecfe9$export$3cbcd1b7e35945d2 = {
    prefix: 'fas',
    iconName: 'angle-left',
    icon: [
        256,
        512,
        [
            8249
        ],
        "f104",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $159afdcd077ecfe9$export$7484ff654cd6474f = {
    prefix: 'fas',
    iconName: 'screwdriver',
    icon: [
        576,
        512,
        [
            129691
        ],
        "f54a",
        "M352.1 146.7l0-49.6c0-10.7 5.3-20.7 14.2-26.6L485.2-8.7c6.3-4.2 14.8-3.4 20.2 2l45.4 45.5c5.4 5.4 6.2 13.8 2 20.2L473.6 177.8c-5.9 8.9-15.9 14.2-26.6 14.2l-49.6 0-90.7 90.7c15 33.3 8.9 73.9-18.5 101.3L162.1 510.1c-18.7 18.7-49.1 18.7-67.9 0L34.1 449.9c-18.7-18.7-18.7-49.1 0-67.9L160.1 256c27.4-27.4 67.9-33.6 101.3-18.5l90.7-90.7z"
    ]
};
var $159afdcd077ecfe9$export$e87e41787bbedc98 = {
    prefix: 'fas',
    iconName: 'tractor',
    icon: [
        576,
        512,
        [
            128668
        ],
        "f722",
        "M160 96l0 96 133.4 0-57.6-96-75.8 0zM96 223L96 64c0-17.7 14.3-32 32-32l107.8 0c22.5 0 43.3 11.8 54.9 31.1l77.4 128.9 64 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 48 0c26.5 0 48 21.5 48 48l0 41.5c0 14.2-6.3 27.8-17.3 36.9l-35 29.2c26.5 15.2 44.3 43.7 44.3 76.4 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-14.4 3.5-28 9.6-40l-101.2 0c-3 13.4-7.9 26-14.4 37.7 7.7 9.4 7.2 23.4-1.6 32.2l-22.6 22.6c-8.8 8.8-22.7 9.3-32.2 1.6-9.3 5.2-19.3 9.3-29.8 12.3-1.2 12.1-11.4 21.6-23.9 21.6l-32 0c-12.4 0-22.7-9.5-23.9-21.6-10.5-3-20.4-7.2-29.8-12.3-9.4 7.7-23.4 7.2-32.2-1.6L35.5 453.8c-8.8-8.8-9.3-22.7-1.6-32.2-5.2-9.3-9.3-19.3-12.3-29.8-12.1-1.2-21.6-11.4-21.6-23.9l0-32c0-12.4 9.5-22.7 21.6-23.9 3-10.5 7.2-20.4 12.3-29.8-7.7-9.4-7.2-23.4 1.6-32.2l22.6-22.6c8.8-8.8 22.7-9.3 32.2-1.6 1.9-1 3.7-2 5.7-3zm64 65a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM440 424a40 40 0 1 0 80 0 40 40 0 1 0 -80 0z"
    ]
};
var $159afdcd077ecfe9$export$834071278537f121 = {
    prefix: 'fas',
    iconName: 'bridge-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e4cb",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l8 0 0 64-40 0 0 112c37.6 9.4 64 43.2 64 82l0 94c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96 6.4 0 12.7 .6 18.7 1.8 34.7-49.5 92.2-81.8 157.3-81.8 28.6 0 55.6 6.2 80 17.4l0-65.4-40 0 0-64 8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM424 96l0 64-80 0 0-64 80 0zM296 96l0 64-80 0 0-64 80 0zM88 96l80 0 0 64-80 0 0-64zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7l-36.7 36.7 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $159afdcd077ecfe9$export$507e8edd7676b2e9 = {
    prefix: 'fas',
    iconName: 'vials',
    icon: [
        512,
        512,
        [],
        "f493",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 352c0 53 43 96 96 96s96-43 96-96l0-352 64 0 0 352c0 53 43 96 96 96s96-43 96-96l0-352c17.7 0 32-14.3 32-32S497.7 0 480 0L32 0zM160 64l0 128-64 0 0-128 64 0zm256 0l0 128-64 0 0-128 64 0z"
    ]
};
var $159afdcd077ecfe9$export$acb2d72d28cd92d9 = {
    prefix: 'fas',
    iconName: 'stethoscope',
    icon: [
        576,
        512,
        [
            129658
        ],
        "f0f1",
        "M32 48C32 21.5 53.5 0 80 0l48 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 128c0 53 43 96 96 96s96-43 96-96l0-128-32 0c-17.7 0-32-14.3-32-32S238.3 0 256 0l48 0c26.5 0 48 21.5 48 48l0 144c0 77.4-55 142-128 156.8l0 19.2c0 61.9 50.1 112 112 112s112-50.1 112-112l0-85.5c-37.3-13.2-64-48.7-64-90.5 0-53 43-96 96-96s96 43 96 96c0 41.8-26.7 77.4-64 90.5l0 85.5c0 97.2-78.8 176-176 176S160 465.2 160 368l0-19.2C87 334 32 269.4 32 192L32 48zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$5c0b4709125e92f8 = {
    prefix: 'fas',
    iconName: 'podcast',
    icon: [
        448,
        512,
        [],
        "f2ce",
        "M336 359.8c39.1-32.3 64-81.1 64-135.8 0-97.2-78.8-176-176-176S48 126.8 48 224C48 278.7 72.9 327.5 112 359.8 112.4 377.4 115.2 400.2 118.4 421.6 48 383.9 0 309.5 0 224 0 100.3 100.3 0 224 0S448 100.3 448 224c0 85.6-48 159.9-118.5 197.6 3.3-21.4 6-44.2 6.4-61.8zm-14-53.4c-8.3-12.6-19.2-21.6-30.4-27.8-2.1-1.1-4.2-2.2-6.3-3.2 11.7-13.9 18.8-31.9 18.8-51.5 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 19.6 7.1 37.6 18.8 51.5-2.1 1-4.2 2-6.3 3.2-11.2 6.2-22.1 15.2-30.4 27.8-18.8-22.3-30.1-51-30.1-82.4 0-70.7 57.3-128 128-128s128 57.3 128 128c0 31.4-11.3 60.2-30.1 82.4zM224 312c32.9 0 64 8.6 64 43.8 0 33-12.9 104.1-20.6 132.9-5.1 19-24.5 23.4-43.4 23.4s-38.2-4.4-43.4-23.4c-7.8-28.5-20.6-99.7-20.6-132.8 0-35.1 31.1-43.8 64-43.8zm0-128a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $159afdcd077ecfe9$export$bc804c6ab898f610 = {
    prefix: 'fas',
    iconName: 'arrow-up-right-dots',
    icon: [
        512,
        512,
        [],
        "e4b7",
        "M96 32C78.3 32 64 46.3 64 64S78.3 96 96 96L114.7 96 9.4 201.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 141.3 160 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 32zM403.8 70.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zM279.7 194.2a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm162.2-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zM156.2 317.8a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm161.6-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm86.1 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zM70.1 403.8a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm86.1 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0zm161.6-38.1a38.1 38.1 0 1 0 0 76.2 38.1 38.1 0 1 0 0-76.2zm86.1 38.1a38.1 38.1 0 1 0 76.2 0 38.1 38.1 0 1 0 -76.2 0z"
    ]
};
var $159afdcd077ecfe9$export$7b8ce73615739d30 = {
    prefix: 'fas',
    iconName: 'chess-queen',
    icon: [
        512,
        512,
        [
            9819
        ],
        "f445",
        "M256 80a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM5.5 185L128 384 71.8 454.3c-5 6.3-7.8 14.1-7.8 22.2 0 19.6 15.9 35.5 35.5 35.5l312.9 0c19.6 0 35.5-15.9 35.5-35.5 0-8.1-2.7-15.9-7.8-22.2L384 384 506.5 185c3.6-5.9 5.5-12.7 5.5-19.6l0-.6c0-20.3-16.5-36.8-36.8-36.8-7.3 0-14.4 2.2-20.4 6.2l-16.9 11.3c-12.7 8.5-29.6 6.8-40.4-4l-34.1-34.1C356.1 100.1 346.2 96 336 96s-20.1 4.1-27.3 11.3l-30.1 30.1c-12.5 12.5-32.8 12.5-45.3 0l-30.1-30.1C196.1 100.1 186.2 96 176 96s-20.1 4.1-27.3 11.3l-34.1 34.1c-10.8 10.8-27.7 12.5-40.4 4L57.3 134.2c-6.1-4-13.2-6.2-20.4-6.2-20.3 0-36.8 16.5-36.8 36.8l0 .6c0 6.9 1.9 13.7 5.5 19.6z"
    ]
};
var $159afdcd077ecfe9$export$61add9eca991b5ec = {
    prefix: 'fas',
    iconName: 'anchor-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e4ab",
        "M320.5 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96c-53 0-96 43-96 96 0 41.8 26.7 77.4 64 90.5l0 257.9c-62.9-14.3-110.2-69.7-111.9-136.5l16.1 14.1c10 8.7 25.1 7.7 33.9-2.3s7.7-25.1-2.3-33.9l-64-56c-9-7.9-22.6-7.9-31.6 0l-64 56c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l16.2-14.2c2.1 113.1 94.4 204.1 208 204.1 16.6 0 32.7-1.9 48.2-5.6-20.3-30.5-32.2-67-32.2-106.4 0-27.3 5.7-53.3 16-76.9l0-136.6c37.3-13.2 64-48.7 64-90.5 0-53-43-96-96-96zm208 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-140c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$7480721bf113be3e = {
    prefix: 'fas',
    iconName: 'ellipsis-vertical',
    icon: [
        128,
        512,
        [
            "ellipsis-v"
        ],
        "f142",
        "M64 144a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0 224c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56zm56-112c0 30.9-25.1 56-56 56s-56-25.1-56-56 25.1-56 56-56 56 25.1 56 56z"
    ]
};
var $159afdcd077ecfe9$export$e58494c7fcb5380 = $159afdcd077ecfe9$export$7480721bf113be3e;
var $159afdcd077ecfe9$export$3772719b170306e2 = {
    prefix: 'fas',
    iconName: 'heart-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e4fe",
        "M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 17.6-3.4 35.6-9.5 53.7-21.8-8.6-45.6-13.4-70.5-13.4-106 0-192 86-192 192 0 28.5 6.2 55.6 17.4 80-.5 0-.9 0-1.4 0-15.5 0-30.8-4.6-43.1-14.1-73-55.7-212.9-186-212.9-298.2l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 228a20 20 0 1 0 0-40 20 20 0 1 0 0 40zm0-180c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$c49f030b19083ebe = {
    prefix: 'fas',
    iconName: 'building-circle-exclamation',
    icon: [
        576,
        512,
        [],
        "e4d3",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-10.5-14.6-19-30.7-25.1-48l-74.9 0 0-80c0-17.7 14.3-32 32-32l32 0c2 0 4 .2 5.9 .5 6-23.6 16.3-45.4 30.1-64.5l-4 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 4c27.5-19.8 60.3-32.4 96-35.4L416 64c0-35.3-28.7-64-64-64L96 0zm32 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-140c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$5709329dd2b70bdc = {
    prefix: 'fas',
    iconName: 'person-arrow-up-from-line',
    icon: [
        576,
        512,
        [],
        "e539",
        "M192-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM318.3 299.1l-46.3-62.4 0 243.3 272 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 544c-17.7 0-32-14.3-32-32s14.3-32 32-32l80 0 0-243.3-46.3 62.4c-10.5 14.2-30.6 17.2-44.8 6.6s-17.2-30.6-6.6-44.8l70.5-95C110 132 149.7 112 192 112s82 20 107.2 53.9l70.5 95c10.5 14.2 7.6 34.2-6.6 44.8s-34.2 7.6-44.8-6.6zM208 480l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128 32 0zM566.6 102.6c-12.5 12.5-32.8 12.5-45.3 0L496 77.3 496 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-146.7-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l80-80c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3z"
    ]
};
var $159afdcd077ecfe9$export$6a15ccae09bbaf93 = {
    prefix: 'fas',
    iconName: 'not-equal',
    icon: [
        448,
        512,
        [],
        "f53e",
        "M378.6 81.8c9.8-14.7 5.8-34.6-8.9-44.4s-34.6-5.8-44.4 8.9L270.9 128 32 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l196.2 0-85.3 128-110.9 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l68.2 0-30.8 46.2c-9.8 14.7-5.8 34.6 8.9 44.4s34.6 5.8 44.4-8.9L177.1 384 416 384c17.7 0 32-14.3 32-32s-14.3-32-32-32l-196.2 0 85.3-128 110.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-68.2 0 30.8-46.2z"
    ]
};
var $159afdcd077ecfe9$export$d401d4aeba21cdf3 = {
    prefix: 'fas',
    iconName: 'train-tram',
    icon: [
        384,
        512,
        [
            128650
        ],
        "e5b4",
        "M0 8C0-5.3 10.7-16 24-16l336 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8-120 0 0 64 40 0c53 0 96 43 96 96l0 160c0 31.2-14.9 59-38 76.5l64.3 76c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8l-74.6-88.1c-3.6 .4-7.3 .6-11.1 .6l-128 0c-3.8 0-7.5-.2-11.1-.6L42.3 535.5c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8l64.3-76C46.9 411 32 383.2 32 352l0-160c0-53 43-96 96-96l40 0 0-64-120 0 0 8c0 13.3-10.7 24-24 24S0 53.3 0 40L0 8zM128 160c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32l-128 0zm32 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$6ccbeeccfea6dc8a = {
    prefix: 'fas',
    iconName: 'plane-departure',
    icon: [
        576,
        512,
        [
            128747
        ],
        "f5b0",
        "M372 143.9L172.7 40.2c-8-4.1-17.3-4.8-25.7-1.7l-41.1 15c-10.3 3.7-13.8 16.4-7.1 25L200.3 206.4 100.1 242.8 40 206.2c-6.2-3.8-13.8-4.5-20.7-2.1L3 210.1c-9.4 3.4-13.4 14.5-8.3 23.1l53.6 91.8c15.6 26.7 48.1 38.4 77.1 27.8l12.9-4.7 0 0 398.4-145c29.1-10.6 44-42.7 33.5-71.8s-42.7-44-71.8-33.5L372 143.9zM32.2 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-512 0z"
    ]
};
var $159afdcd077ecfe9$export$a5fd2acfcb5247c6 = {
    prefix: 'fas',
    iconName: 'right-to-bracket',
    icon: [
        512,
        512,
        [
            "sign-in-alt"
        ],
        "f2f6",
        "M345 273c9.4-9.4 9.4-24.6 0-33.9L201 95c-6.9-6.9-17.2-8.9-26.2-5.2S160 102.3 160 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L345 273zm7 143c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0z"
    ]
};
var $159afdcd077ecfe9$export$e6709746115bd2ea = $159afdcd077ecfe9$export$a5fd2acfcb5247c6;
var $159afdcd077ecfe9$export$303efb6031da122 = {
    prefix: 'fas',
    iconName: 'sd-card',
    icon: [
        384,
        512,
        [],
        "f7c2",
        "M384 64c0-35.3-28.7-64-64-64L125.3 0C108.3 0 92 6.7 80 18.7L18.7 80C6.7 92 0 108.3 0 125.3L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384zM160 88l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24zm88 0l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$8403e4b31e8aa805 = {
    prefix: 'fas',
    iconName: 'house-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e50a",
        "M496 544a144 144 0 1 1 0-288 144 144 0 1 1 0 288zM268.6 6.5c12.2-9.3 29.7-8.7 41.2 2l217.6 202c-10.2-1.7-20.7-2.6-31.3-2.6-78.6 0-146.1 47.2-175.8 114.8-5.1-1.8-10.5-2.8-16.2-2.8l-32 0c-26.5 0-48 21.5-48 48l0 96 91 0c6.1 17.3 14.6 33.4 25.1 48L144 512c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208 2.4-2zM496 444a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm0-140c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16 8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$3570be7b68efb8db = {
    prefix: 'fas',
    iconName: 'shekel-sign',
    icon: [
        448,
        512,
        [
            8362,
            "ils",
            "shekel",
            "sheqel",
            "sheqel-sign"
        ],
        "f20b",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352 128 0c35.3 0 64 28.7 64 64l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-70.7-57.3-128-128-128L32 32zM320 480c70.7 0 128-57.3 128-128l0-288c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 288c0 35.3-28.7 64-64 64l-128 0 0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l160 0z"
    ]
};
var $159afdcd077ecfe9$export$ecadeff45b05a451 = $159afdcd077ecfe9$export$3570be7b68efb8db;
var $159afdcd077ecfe9$export$27e0e10e74d98736 = $159afdcd077ecfe9$export$3570be7b68efb8db;
var $159afdcd077ecfe9$export$28b3b26a80030d4e = $159afdcd077ecfe9$export$3570be7b68efb8db;
var $159afdcd077ecfe9$export$d84993fb5e8c6edd = $159afdcd077ecfe9$export$3570be7b68efb8db;
var $159afdcd077ecfe9$export$11b26516cae2104f = {
    prefix: 'fas',
    iconName: 'radio',
    icon: [
        512,
        512,
        [
            128251
        ],
        "f8d7",
        "M494.8 15c12.7-3.7 20-17.1 16.3-29.8S494-34.8 481.3-31L51.8 94.9C42.4 97.6 33.9 102.1 26.6 108 10.5 119.7 0 138.6 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L218.5 96 494.8 15zM368 208a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 248c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 272c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 368c-13.3 0-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$8846d49caaed1c0a = {
    prefix: 'fas',
    iconName: 'hand-dots',
    icon: [
        512,
        512,
        [
            "allergies"
        ],
        "f461",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4S-3.6 325.7 12.4 341L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208zM200 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-88 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$dcae2101babbffff = $159afdcd077ecfe9$export$8846d49caaed1c0a;
var $159afdcd077ecfe9$export$a57d448e8969ce8a = {
    prefix: 'fas',
    iconName: 'book-skull',
    icon: [
        448,
        512,
        [
            "book-dead"
        ],
        "f6b7",
        "M96 512l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-66.7c18.6-6.6 32-24.4 32-45.3l0-288c0-26.5-21.5-48-48-48L96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96zM64 416c0-17.7 14.3-32 32-32l256 0 0 64-256 0c-17.7 0-32-14.3-32-32zM272 163.2l0 12.8c0 8.8-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16l0-12.8c-19.4-11.7-32-30.3-32-51.2 0-35.3 35.8-64 80-64s80 28.7 80 64c0 20.9-12.6 39.5-32 51.2zM208 112a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm74.2 95.7c4.6 10.1 .1 21.9-9.9 26.5l-47.9 21.8 47.9 21.8c10.1 4.6 14.5 16.4 9.9 26.5s-16.4 14.5-26.5 9.9L224 294 144.3 330.2c-10.1 4.6-21.9 .1-26.5-9.9s-.1-21.9 9.9-26.5l47.9-21.8-47.9-21.8c-10.1-4.6-14.5-16.4-9.9-26.5s16.4-14.5 26.5-9.9L224 250 303.7 213.8c10.1-4.6 21.9-.1 26.5 9.9z"
    ]
};
var $159afdcd077ecfe9$export$b98a3f8c3941a74a = $159afdcd077ecfe9$export$a57d448e8969ce8a;
var $159afdcd077ecfe9$export$c98fdd5082b333ec = {
    prefix: 'fas',
    iconName: 'unlock-keyhole',
    icon: [
        384,
        512,
        [
            "unlock-alt"
        ],
        "f13e",
        "M192 32c-35.3 0-64 28.7-64 64l0 64 192 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l0-64c0-70.7 57.3-128 128-128 63.5 0 116.1 46.1 126.2 106.7 2.9 17.4-8.8 33.9-26.3 36.9s-33.9-8.8-36.9-26.3C250 55.1 223.7 32 192 32zm40 328c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0z"
    ]
};
var $159afdcd077ecfe9$export$b19f508797f3d9c3 = $159afdcd077ecfe9$export$c98fdd5082b333ec;
var $159afdcd077ecfe9$export$929df388c07f293d = {
    prefix: 'fas',
    iconName: 'file-arrow-up',
    icon: [
        384,
        512,
        [
            "file-upload"
        ],
        "f574",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM209 263c-9.4-9.4-24.6-9.4-33.9 0l-64 64c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l23-23 0 86.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-86.1 23 23c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64z"
    ]
};
var $159afdcd077ecfe9$export$dd55ded1264643d2 = $159afdcd077ecfe9$export$929df388c07f293d;
var $159afdcd077ecfe9$export$8ac6d81a3d5b40a1 = {
    prefix: 'fas',
    iconName: 'face-grin-tears',
    icon: [
        640,
        512,
        [
            128514,
            "grin-tears"
        ],
        "f588",
        "M554.8 203.4l16.3 2.3C547.7 88.4 444.2 0 320 0S92.3 88.4 68.9 205.7l16.3-2.3c37-5.3 68.6 26.4 63.4 63.4l-6.7 46.7c-4.1 29-21.6 53.2-45.8 66.8 43.7 78.5 127.6 131.7 223.8 131.7s180.1-53.1 223.8-131.7c-24.1-13.5-41.6-37.8-45.8-66.8l-6.7-46.7c-5.3-37 26.4-68.6 63.4-63.4zM470.3 326.9C447.9 388.2 389.1 432 320 432S192.1 388.2 169.7 326.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1c11.9-3.7 23.9 6.3 19.6 18.1zM212 208l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28s-28 12.5-28 28zm188-28c-15.5 0-28 12.5-28 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28zM640 300.6c0-25.6-18.8-47.3-44.1-50.9L549.1 243c-10.6-1.5-19.6 7.5-18.1 18.1l6.7 46.7c3.6 25.3 25.3 44.1 50.9 44.1 28.4 0 51.4-23 51.4-51.4zm-640 0C0 329 23 352 51.4 352 77 352 98.7 333.2 102.3 307.9l6.7-46.7c1.5-10.6-7.5-19.6-18.1-18.1l-46.7 6.7C18.8 253.3 0 275 0 300.6z"
    ]
};
var $159afdcd077ecfe9$export$b2f7512221512b5b = $159afdcd077ecfe9$export$8ac6d81a3d5b40a1;
var $159afdcd077ecfe9$export$ba236543926e3569 = {
    prefix: 'fas',
    iconName: 'pen-to-square',
    icon: [
        512,
        512,
        [
            "edit"
        ],
        "f044",
        "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L368 46.1 465.9 144 490.3 119.6c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L432 177.9 334.1 80 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z"
    ]
};
var $159afdcd077ecfe9$export$7be713e57d023733 = $159afdcd077ecfe9$export$ba236543926e3569;
var $159afdcd077ecfe9$export$7adefae4a1be1d97 = {
    prefix: 'fas',
    iconName: 'earth-europe',
    icon: [
        512,
        512,
        [
            "globe-europe"
        ],
        "f7a2",
        "M256.2 48c114.8 .1 207.8 93.2 207.8 208 0 22.1-3.4 43.4-9.8 63.4-2 .4-4.1 .6-6.2 .6l-2.7 0c-8.5 0-16.6-3.4-22.6-9.4l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6l0-50.7c0-8.8 7.2-16 16-16s16-7.2 16-16-7.2-16-16-16l-24 0c-13.3 0-24 10.7-24 24s-10.7 24-24 24l-56 0c-8.8 0-16 7.2-16 16s-7.2 16-16 16l-25.4 0c-12.5 0-22.6-10.1-22.6-22.6 0-6 2.4-11.8 6.6-16l70.1-70.1c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3l-14.1 0c-12.5 0-22.6-10.1-22.6-22.6 0-6 2.4-11.8 6.6-16l23.1-23.1c.8-.8 1.6-1.5 2.5-2.2zM438.4 356.1c-32.8 59.6-93.9 101.4-165.2 107.2-.7-2.3-1.1-4.8-1.1-7.3 0-13.3-10.7-24-24-24l-26.7 0c-8.5 0-16.6-3.4-22.6-9.4l-29.3-29.3c-6-6-9.4-14.1-9.4-22.6l0-66.7c0-17.7 14.3-32 32-32l98.7 0c8.5 0 16.6 3.4 22.6 9.4l29.3 29.3c6 6 14.1 9.4 22.6 9.4l5.5 0c8.5 0 16.6 3.4 22.6 9.4l16 16c4.2 4.2 10 6.6 16 6.6 4.8 0 9.3 1.5 13 4.1zM256 512l26.2-1.3c-8.6 .9-17.3 1.3-26.2 1.3zm26.2-1.3C411.3 497.6 512 388.6 512 256 512 114.6 397.4 0 256 0l0 0C114.6 0 0 114.6 0 256 0 383.5 93.2 489.3 215.3 508.8 228.5 510.9 242.1 512 256 512zM187.3 123.3l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $159afdcd077ecfe9$export$5318b8ede86cc96b = $159afdcd077ecfe9$export$7adefae4a1be1d97;
var $159afdcd077ecfe9$export$2ff38f330c834084 = {
    prefix: 'fas',
    iconName: 'face-grin-beam-sweat',
    icon: [
        576,
        512,
        [
            128517,
            "grin-beam-sweat"
        ],
        "f583",
        "M546.2-.1c14.7 17.8 29.8 40.1 29.8 64.1 0 36.4-27.6 64-64 64s-64-27.6-64-64c0-24 15.2-46.3 29.8-64.1 8.8-10.7 18.5-20.8 29-30 3-2.6 7.4-2.6 10.4 0 10.5 9.1 20.1 19.3 29 30zM288 0c42.5 0 82.6 10.4 117.8 28.7-3.6 10.9-5.8 22.7-5.8 35.3 0 62.9 49.1 112 112 112 6.4 0 12.7-.5 18.8-1.5 8.6 25.6 13.2 53 13.2 81.5 0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0zM418.7 308.9C379.5 321.1 335.1 328 288 328s-91.5-6.9-130.7-19.1c-11.9-3.7-23.9 6.3-19.6 18.1 22.4 61.3 81.3 105.1 150.3 105.1s127.9-43.8 150.3-105.1c4.3-11.8-7.7-21.8-19.6-18.1zM208 180c15.5 0 28 12.5 28 28l0 8c0 11 9 20 20 20s20-9 20-20l0-8c0-37.6-30.4-68-68-68s-68 30.4-68 68l0 8c0 11 9 20 20 20s20-9 20-20l0-8c0-15.5 12.5-28 28-28zm132 28c0-15.5 12.5-28 28-28s28 12.5 28 28l0 8c0 11 9 20 20 20s20-9 20-20l0-8c0-37.6-30.4-68-68-68s-68 30.4-68 68l0 8c0 11 9 20 20 20s20-9 20-20l0-8z"
    ]
};
var $159afdcd077ecfe9$export$14d0ccc54c5b6826 = $159afdcd077ecfe9$export$2ff38f330c834084;
var $159afdcd077ecfe9$export$625fb3848216f28c = {
    prefix: 'fas',
    iconName: 'circle-half-stroke',
    icon: [
        512,
        512,
        [
            9680,
            "adjust"
        ],
        "f042",
        "M448 256c0-106-86-192-192-192l0 384c106 0 192-86 192-192zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"
    ]
};
var $159afdcd077ecfe9$export$cfa06e4b68edca2d = $159afdcd077ecfe9$export$625fb3848216f28c;
var $159afdcd077ecfe9$export$41b1e14a6b0fe11b = {
    prefix: 'fas',
    iconName: 'person-military-to-person',
    icon: [
        512,
        512,
        [],
        "e54c",
        "M71 12.5c-8.6 1-15 8.2-15 16.8 0 9.3 7.5 16.8 16.7 16.9l111.4 0c8.8-.1 15.9-7.2 15.9-16L200 16c0-9.5-8.3-17-17.8-15.9L71 12.5zM189.5 78.1l-122.9 0c-1.6 5.7-2.5 11.7-2.5 17.9 0 35.3 28.7 64 64 64s64-28.7 64-64c0-6.2-.9-12.2-2.5-17.9zM32 256l0 32c0 17.7 14.3 32 32 32l128 0c1.8 0 3.5-.1 5.2-.4L53 208.6C40.1 220.3 32 237.2 32 256zm190.2 42.5c1.1-3.3 1.8-6.8 1.8-10.5l0-32c0-35.3-28.7-64-64-64l-64 0c-3.7 0-7.4 .3-10.9 .9L222.2 298.5zM384 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-35.3 0-64 28.7-64 64l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-35.3-28.7-64-64-64l-64 0zM215.8 450.1c5.2-4.6 8.2-11.1 8.2-18.1s-3-13.5-8.2-18.1l-64-56c-7.1-6.2-17.1-7.7-25.7-3.8S112 366.6 112 376l0 32-88 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l88 0 0 32c0 9.4 5.5 18 14.1 21.9s18.6 2.4 25.7-3.8l64-56zM288 431.9c0 6.9 3 13.5 8.1 18.1l64 56.4c7.1 6.2 17.1 7.8 25.7 3.9S400 497.8 400 488.4l0-32.4 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-32c0-9.4-5.5-18-14.1-21.9s-18.6-2.4-25.7 3.8l-64 56c-5.2 4.5-8.2 11.1-8.2 18z"
    ]
};
var $159afdcd077ecfe9$export$257af4c5fc557105 = {
    prefix: 'fas',
    iconName: 'table-cells-column-lock',
    icon: [
        640,
        512,
        [],
        "e678",
        "M256 224l0 192 64 0 0-192-64 0zm256-79c-46.7 5.8-85.6 36.8-102.7 79l-25.3 0 0 90.8c-10.1 15.2-16 33.4-16 53.1l0 96c0 5.5 .5 10.9 1.3 16.1L128 480c-35.3 0-64-28.7-64-64L64 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 49zM128 224l0 192 64 0 0-192-64 0zm432 48.1c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM416 368c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
var $159afdcd077ecfe9$export$40cb0a4a3a74dc03 = {
    prefix: 'fas',
    iconName: 'truck-field-un',
    icon: [
        640,
        512,
        [],
        "e58e",
        "M96 32C60.7 32 32 60.7 32 96l0 32c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l0 48c0 21.1 13.7 39.1 32.6 45.5-.4 3.4-.6 7-.6 10.5 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l144.7 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l.4 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-24.7 0-1.7-4.2-43.8-106.3c-12.3-30-41.6-49.5-74-49.5l-40.4 0C364.4 44.9 343.7 32 320 32L96 32zM384 224l0-96 31.9 0c6.5 0 12.3 3.9 14.8 9.9l35.4 86.1-82.1 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm280 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM256.6 132.9l27.4 41 0-29.9c0-11 9-20 20-20s20 9 20 20l0 96c0 8.8-5.8 16.6-14.2 19.1s-17.5-.7-22.4-8l-27.4-41 0 29.9c0 11-9 20-20 20s-20-9-20-20l0-96c0-8.8 5.8-16.6 14.2-19.1s17.5 .7 22.4 8zM132 144l0 64c0 6.6 5.4 12 12 12s12-5.4 12-12l0-64c0-11 9-20 20-20s20 9 20 20l0 64c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-64c0-11 9-20 20-20s20 9 20 20z"
    ]
};
var $159afdcd077ecfe9$export$95b9968e7fceb821 = {
    prefix: 'fas',
    iconName: 'clock',
    icon: [
        512,
        512,
        [
            128339,
            "clock-four"
        ],
        "f017",
        "M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $159afdcd077ecfe9$export$9a575facf1cab48f = $159afdcd077ecfe9$export$95b9968e7fceb821;
var $159afdcd077ecfe9$export$c9d7ef726d1a8742 = {
    prefix: 'fas',
    iconName: 'book',
    icon: [
        448,
        512,
        [
            128212
        ],
        "f02d",
        "M384 512L96 512c-53 0-96-43-96-96L0 96C0 43 43 0 96 0L400 0c26.5 0 48 21.5 48 48l0 288c0 20.9-13.4 38.7-32 45.3l0 66.7c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0zM96 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0 0-64-256 0zm32-232c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm24 72c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z"
    ]
};
var $159afdcd077ecfe9$export$600a1b26b33c3d47 = {
    prefix: 'fas',
    iconName: 'face-laugh-wink',
    icon: [
        512,
        512,
        [
            "laugh-wink"
        ],
        "f59c",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM101.6 314c-3.7-13.7 7.5-26 21.7-26l265.4 0c14.2 0 25.4 12.3 21.7 26-18.5 68-80.6 118-154.4 118S120 382 101.6 314zM144 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm164 8c0 11-9 20-20 20s-20-9-20-20c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60 0 11-9 20-20 20s-20-9-20-20-9-20-20-20l-16 0c-11 0-20 9-20 20z"
    ]
};
var $159afdcd077ecfe9$export$77ac40095f39933e = $159afdcd077ecfe9$export$600a1b26b33c3d47;
var $159afdcd077ecfe9$export$5d120e8b87ad33f4 = {
    prefix: 'fas',
    iconName: 'cloud-meatball',
    icon: [
        512,
        512,
        [],
        "f73b",
        "M0 224c0 53 43 96 96 96l26.9 0c3.5-12.1 10.1-23.3 19.2-32.4l1.4-1.4c15-15 35.3-22.9 56.1-22.2 14.2-15.1 34.2-23.9 55.4-23.9l2 0c21.1 0 41.1 8.8 55.4 23.9 20.8-.6 41.1 7.3 56.1 22.2l1.4 1.4c9.2 9.2 15.7 20.4 19.2 32.4l26.9 0c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0 1.1-5.2 1.6-10.5 1.6-16 0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28-18.7-35.7-56.1-60-99.2-60-61.9 0-112 50.1-112 112 0 7.1 .7 14.1 1.9 20.8-38.3 12.6-65.9 48.7-65.9 91.2zM156.5 424.3c9.5 6.3 14.2 17.7 11.9 28.8-1.8 9.2 1 18.7 7.7 25.3l1.4 1.4c6.6 6.6 16.1 9.5 25.3 7.7 11.1-2.2 22.5 2.5 28.8 11.9 5.2 7.8 14 12.5 23.3 12.5l2 0c9.4 0 18.1-4.7 23.3-12.5 6.3-9.5 17.7-14.2 28.8-11.9 9.2 1.8 18.7-1 25.3-7.7l1.4-1.4c6.6-6.6 9.5-16.1 7.7-25.3-2.2-11.1 2.5-22.5 11.9-28.8 7.8-5.2 12.5-14 12.5-23.3l0-2c0-9.4-4.7-18.1-12.5-23.3-9.5-6.3-14.2-17.7-11.9-28.8 1.8-9.2-1-18.7-7.7-25.3l-1.4-1.4c-6.6-6.6-16.1-9.5-25.3-7.7-11.1 2.2-22.5-2.5-28.8-11.9-5.2-7.8-14-12.5-23.3-12.5l-2 0c-9.4 0-18.1 4.7-23.3 12.5-6.3 9.5-17.7 14.2-28.8 11.9-9.2-1.8-18.7 1-25.3 7.7l-1.4 1.4c-6.6 6.6-9.5 16.1-7.7 25.3 2.2 11.1-2.5 22.5-11.9 28.8-7.8 5.2-12.5 14-12.5 23.3l0 2c0 9.4 4.7 18.1 12.5 23.3zM48 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm416 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $159afdcd077ecfe9$export$2acab8312b7a999b = {
    prefix: 'fas',
    iconName: 'chart-area',
    icon: [
        512,
        512,
        [
            "area-chart"
        ],
        "f1fe",
        "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zM240 96c6.7 0 13.1 2.8 17.7 7.8L328.8 181.3 375 135c9.4-9.4 24.6-9.4 33.9 0l64 64c4.5 4.5 7 10.6 7 17l0 112c0 13.3-10.7 24-24 24l-304 0c-13.3 0-24-10.7-24-24l0-112c0-6 2.3-11.8 6.3-16.2l88-96c4.5-5 11-7.8 17.7-7.8z"
    ]
};
var $159afdcd077ecfe9$export$fc2e595f0e0612cb = $159afdcd077ecfe9$export$2acab8312b7a999b;
var $159afdcd077ecfe9$export$fe44d4c71644ea0 = {
    prefix: 'fas',
    iconName: 'rupiah-sign',
    icon: [
        512,
        512,
        [],
        "e23d",
        "M0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144 0 54.3-30 101.5-74.4 126.1l41 136.7c5.1 16.9-4.5 34.8-21.5 39.8s-34.8-4.5-39.8-21.5L120.1 319.8c-2.7 .1-5.4 .2-8.1 .2l-48 0 0 128c0 17.7-14.3 32-32 32S0 465.7 0 448L0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160zm256-32l80 0c61.9 0 112 50.1 112 112S461.9 448 400 448l-48 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32zm80 160c26.5 0 48-21.5 48-48s-21.5-48-48-48l-48 0 0 96 48 0z"
    ]
};
var $159afdcd077ecfe9$export$d8724cf433389700 = {
    prefix: 'fas',
    iconName: 'text-width',
    icon: [
        448,
        512,
        [],
        "f035",
        "M40 0C17.9 0 0 17.9 0 40L0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 128 0 0 160-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-160 128 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-56c0-22.1-17.9-40-40-40L40 0zm78.6 406.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 229.5 0-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4-229.5 0 9.4-9.4z"
    ]
};
var $159afdcd077ecfe9$export$da3f1730d013e224 = {
    prefix: 'fas',
    iconName: 'satellite',
    icon: [
        512,
        512,
        [
            128752
        ],
        "f7bf",
        "M199 7c9.4-9.4 24.6-9.4 33.9 0l89.4 89.4 55-55c12.5-12.5 32.8-12.5 45.3 0l48 48c12.5 12.5 12.5 32.8 0 45.3l-55 55 89.4 89.4c9.4 9.4 9.4 24.6 0 33.9l-96 96c-9.4 9.4-24.6 9.4-33.9 0l-89.4-89.4-15.5 15.5c11.4 24.6 17.8 52 17.8 80.9 0 31.7-7.7 61.5-21.2 87.8-4.7 9-16.7 10.3-23.8 3.1l-96.3-96.3-60 60c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l60-60-96.3-96.3c-7.2-7.2-5.9-19.2 3.1-23.8 26.3-13.6 56.2-21.2 87.8-21.2 28.9 0 56.3 6.4 80.9 17.8L192.4 226.3 103 137c-9.4-9.4-9.4-24.6 0-33.9L199 7zm17 50.9l-62.1 62.1 72.4 72.4 62.1-62.1-72.4-72.4zM392 358.1l62.1-62.1-72.4-72.4-62.1 62.1 72.4 72.4z"
    ]
};
var $159afdcd077ecfe9$export$56d810b9ab2e30bc = {
    prefix: 'fas',
    iconName: 'magnifying-glass-minus',
    icon: [
        512,
        512,
        [
            "search-minus"
        ],
        "f010",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
var $159afdcd077ecfe9$export$efca97eef6a7a17d = $159afdcd077ecfe9$export$56d810b9ab2e30bc;
var $159afdcd077ecfe9$export$be015e72863c3635 = {
    prefix: 'fas',
    iconName: 'people-group',
    icon: [
        512,
        512,
        [],
        "e533",
        "M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm96 312c0 25-12.7 47-32 59.9l0 92.1c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-92.1C172.7 359 160 337 160 312l0-40c0-53 43-96 96-96s96 43 96 96l0 40zM96 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm16 240l0 32c0 32.5 12.1 62.1 32 84.7l0 75.3c0 1.2 0 2.5 .1 3.7-8.5 7.6-19.7 12.3-32.1 12.3l-32 0c-26.5 0-48-21.5-48-48l0-56.6C12.9 364.4 0 343.7 0 320l0-32c0-53 43-96 96-96 12.7 0 24.8 2.5 35.9 6.9-12.6 21.4-19.9 46.4-19.9 73.1zM368 464l0-75.3c19.9-22.5 32-52.2 32-84.7l0-32c0-26.7-7.3-51.6-19.9-73.1 11.1-4.5 23.2-6.9 35.9-6.9 53 0 96 43 96 96l0 32c0 23.7-12.9 44.4-32 55.4l0 56.6c0 26.5-21.5 48-48 48l-32 0c-12.3 0-23.6-4.6-32.1-12.3 0-1.2 .1-2.5 .1-3.7zM416 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $159afdcd077ecfe9$export$3cbda23149da6f11 = {
    prefix: 'fas',
    iconName: 'square-binary',
    icon: [
        448,
        512,
        [],
        "e69b",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm144 4c-24.3 0-44 19.7-44 44l0 48c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-48c0-24.3-19.7-44-44-44l-32 0zm-4 44c0-2.2 1.8-4 4-4l32 0c2.2 0 4 1.8 4 4l0 48c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-48zm140-44c-11 0-20 9-20 20 0 9.7 6.9 17.7 16 19.6l0 76.4c0 11 9 20 20 20s20-9 20-20l0-96c0-11-9-20-20-20l-16 0zM132 296c0 9.7 6.9 17.7 16 19.6l0 76.4c0 11 9 20 20 20s20-9 20-20l0-96c0-11-9-20-20-20l-16 0c-11 0-20 9-20 20zm96 24l0 48c0 24.3 19.7 44 44 44l32 0c24.3 0 44-19.7 44-44l0-48c0-24.3-19.7-44-44-44l-32 0c-24.3 0-44 19.7-44 44zm44-4l32 0c2.2 0 4 1.8 4 4l0 48c0 2.2-1.8 4-4 4l-32 0c-2.2 0-4-1.8-4-4l0-48c0-2.2 1.8-4 4-4z"
    ]
};
var $159afdcd077ecfe9$export$bf5896cc1ce4d55 = {
    prefix: 'fas',
    iconName: 'masks-theater',
    icon: [
        576,
        512,
        [
            127917,
            "theater-masks"
        ],
        "f630",
        "M-5 118L23.5 279.7c14 79.5 76.3 141.8 155.8 155.8l12.7 2.2c-16.5-28.6-27.1-60.7-30.6-94.5l-24.1 4.3c-9.7 1.7-18.8-5.8-16.9-15.5 4.8-24.7 19.1-46.6 39.7-60.9l0-74.6c-1.4 .8-3 1.3-4.7 1.6l-63 11.1c-8.7 1.5-17.3-4.4-15.9-13.1 3.1-19.6 18.4-36 39.1-39.7 17.2-3 33.9 3.5 44.6 15.8l0-22.7c0-22.5 6.9-52.4 32.3-73.4 26-21.5 67.7-43.9 124.9-54.2-30.5-16.3-86.3-32-163.8-18.4-80.3 14.2-128 50.1-150.1 76.1-9 10.5-10.8 24.9-8.4 38.5zM208 138.7l0 174.8c0 80.7 50.5 152.9 126.4 180.4L362.1 504c14.1 5.1 29.6 5.1 43.7 0L433.6 494C509.5 466.4 560 394.3 560 313.5l0-174.8c0-6.9-2.1-13.8-7-18.6-22.6-22.5-78.2-56-169-56s-146.4 33.6-169 56c-4.9 4.9-7 11.7-7 18.6zm66.1 187.1c-1.4-7 7-11 12.7-6.6 26.9 20.6 60.6 32.9 97.2 32.9s70.2-12.3 97.2-32.9c5.7-4.4 14.1-.4 12.7 6.6-10.1 51.4-55.5 90.3-109.9 90.3s-99.8-38.8-109.9-90.3zm.5-101.5C281.2 205.5 299 192 320 192s38.9 13.5 45.4 32.3c2.9 8.4-4.5 15.7-13.4 15.7l-64 0c-8.8 0-16.3-7.4-13.4-15.7zM480 240l-64 0c-8.8 0-16.3-7.4-13.4-15.7 6.5-18.8 24.4-32.3 45.4-32.3s38.9 13.5 45.4 32.3c2.9 8.4-4.5 15.7-13.4 15.7z"
    ]
};
var $159afdcd077ecfe9$export$3dbedc487b0159ac = $159afdcd077ecfe9$export$bf5896cc1ce4d55;
var $159afdcd077ecfe9$export$6675e2bf21fdb87e = {
    prefix: 'fas',
    iconName: 'cart-plus',
    icon: [
        640,
        512,
        [],
        "f217",
        "M0 8C0-5.3 10.7-16 24-16l45.3 0c27.1 0 50.3 19.4 55.1 46l.4 2 412.7 0c20 0 35.1 18.2 31.4 37.9L537.8 235.8c-5.7 30.3-32.1 52.2-62.9 52.2l-303.6 0 5.1 28.3c2.1 11.4 12 19.7 23.6 19.7L456 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-255.9 0c-34.8 0-64.6-24.9-70.8-59.1L77.2 38.6c-.7-3.8-4-6.6-7.9-6.6L24 32C10.7 32 0 21.3 0 8zM160 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm224 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM336 78.4c-13.3 0-24 10.7-24 24l0 33.6-33.6 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l33.6 0 0 33.6c0 13.3 10.7 24 24 24s24-10.7 24-24l0-33.6 33.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-33.6 0 0-33.6c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$bc43eb4655c78f49 = {
    prefix: 'fas',
    iconName: 'hands-asl-interpreting',
    icon: [
        640,
        512,
        [
            "american-sign-language-interpreting",
            "asl-interpreting",
            "hands-american-sign-language-interpreting"
        ],
        "f2a3",
        "M156.6 46.3c7.9-15.8 1.5-35-14.3-42.9s-35-1.5-42.9 14.3L13.5 189.4C4.6 207.2 0 226.8 0 246.7L0 256c0 70.7 57.3 128 128 128l80 0 0-.3c35.2-2.7 65.4-22.8 82.1-51.7 8.8-15.3 3.6-34.9-11.7-43.7s-34.9-3.6-43.7 11.7c-7 12-19.9 20-34.7 20-22.1 0-40-17.9-40-40s17.9-40 40-40c14.8 0 27.7 8 34.7 20 8.8 15.3 28.4 20.5 43.7 11.7s20.5-28.4 11.7-43.7c-12.8-22.1-33.6-39.1-58.4-47.1l80.8-22c17-4.6 27.1-22.2 22.5-39.3s-22.2-27.1-39.3-22.5l-100.7 27.5 81.6-68c13.6-11.3 15.4-31.5 4.1-45.1S249.1-3.9 235.5 7.4l-101.9 84.9 23-46zM483.4 465.7c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l85.9-171.7c8.9-17.8 13.5-37.4 13.5-57.2l0-9.3c0-70.7-57.3-128-128-128l-80 0 0 .3c-35.2 2.7-65.4 22.8-82.1 51.7-8.9 15.3-3.6 34.9 11.7 43.7s34.9 3.6 43.7-11.7c7-12 19.9-20 34.7-20 22.1 0 40 17.9 40 40s-17.9 40-40 40c-14.8 0-27.7-8-34.7-20-8.9-15.3-28.4-20.5-43.7-11.7s-20.5 28.4-11.7 43.7c12.8 22.1 33.6 39.1 58.4 47.1l-80.8 22c-17.1 4.6-27.1 22.2-22.5 39.3s22.2 27.1 39.3 22.5l100.7-27.5-81.6 68c-13.6 11.3-15.4 31.5-4.1 45.1s31.5 15.4 45.1 4.1l101.9-84.9-23 46z"
    ]
};
var $159afdcd077ecfe9$export$23a7517099ab1b86 = $159afdcd077ecfe9$export$bc43eb4655c78f49;
var $159afdcd077ecfe9$export$beb51abfb05a4eca = $159afdcd077ecfe9$export$bc43eb4655c78f49;
var $159afdcd077ecfe9$export$82846008645b0301 = $159afdcd077ecfe9$export$bc43eb4655c78f49;
var $159afdcd077ecfe9$export$59ce5ca5da74ff72 = {
    prefix: 'fas',
    iconName: 'table-cells-row-unlock',
    icon: [
        640,
        512,
        [],
        "e691",
        "M256 224l0 192 64 0 0-192-64 0zm256-79c-46.7 5.8-85.6 36.8-102.7 79l-25.3 0 0 90.8c-10.1 15.2-16 33.4-16 53.1l0 96c0 5.5 .5 10.9 1.3 16.1L128 480c-35.3 0-64-28.7-64-64L64 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 49zM128 224l0 192 64 0 0-192-64 0zm432 48c-.1-17.6-14.4-31.9-32-31.9-17.7 0-32 14.3-32 32l0 47.9 96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80 44.2 0 79.9 35.8 80 79.9l-48 0z"
    ]
};
var $159afdcd077ecfe9$export$b24d84ed5657d89a = {
    prefix: 'fas',
    iconName: 'rocket',
    icon: [
        512,
        512,
        [],
        "f135",
        "M128 320L24.5 320c-24.9 0-40.2-27.1-27.4-48.5L50 183.3C58.7 168.8 74.3 160 91.2 160l95 0c76.1-128.9 189.6-135.4 265.5-124.3 12.8 1.9 22.8 11.9 24.6 24.6 11.1 75.9 4.6 189.4-124.3 265.5l0 95c0 16.9-8.8 32.5-23.3 41.2l-88.2 52.9c-21.3 12.8-48.5-2.6-48.5-27.4L192 384c0-35.3-28.7-64-64-64l-.1 0zM400 160a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $159afdcd077ecfe9$export$ac094c06f566cca3 = {
    prefix: 'fas',
    iconName: 'shrimp',
    icon: [
        512,
        512,
        [
            129424
        ],
        "e448",
        "M72 32C32.2 32 0 64.2 0 104 0 141.9 29.3 172.9 66.4 175.8 77.6 257.2 147.4 320 232 320l56 0 0-192-216 0c-13.3 0-24-10.7-24-24S58.7 80 72 80l384 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32zM224 456c0 13.3 10.7 24 24 24l72 0 0-72.2-64.1-22.4c-12.5-4.4-26.2 2.2-30.6 14.7s2.2 26.2 14.7 30.6l4.5 1.6C233 433.9 224 443.9 224 456zm128 23.3c36.4-3.3 69.5-17.6 96.1-39.6l-86.5-34.6c-3 1.8-6.2 3.2-9.6 4.3l0 69.9zM472.6 415c24.6-30.3 39.4-68.9 39.4-111 0-12.3-1.3-24.3-3.7-35.9L382.8 355.1c.8 3.4 1.2 7 1.2 10.6 0 4.6-.7 9-1.9 13.1L472.6 415zM336 128l-16 0 0 192 18.3 0c9.9 0 19.1 3.2 26.6 8.5l133.5-92.4C471.8 172.6 409.1 128 336 128zM168 192a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$c04e864469c1d117 = {
    prefix: 'fas',
    iconName: 'tenge-sign',
    icon: [
        384,
        512,
        [
            8376,
            "tenge"
        ],
        "f7d7",
        "M0 56C0 42.7 10.7 32 24 32l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 80C10.7 80 0 69.3 0 56zM0 160c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0 0 256c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-256-128 0c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$af6ebee83047b793 = $159afdcd077ecfe9$export$c04e864469c1d117;
var $159afdcd077ecfe9$export$9c73560282dceccd = {
    prefix: 'fas',
    iconName: 'house-chimney-medical',
    icon: [
        512,
        512,
        [
            "clinic-medical"
        ],
        "f7f2",
        "M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208zM224 248l0 40-40 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l40 0 0 40c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-40 40 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-40 0 0-40c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
var $159afdcd077ecfe9$export$20d8a680febc7434 = $159afdcd077ecfe9$export$9c73560282dceccd;
var $159afdcd077ecfe9$export$b71a093b86e3da1f = {
    prefix: 'fas',
    iconName: 'users-slash',
    icon: [
        640,
        512,
        [],
        "e073",
        "M73-24.9c-9.4-9.4-24.6-9.4-33.9 0S29.7-.3 39 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L321.8 224c56.6-1 102.2-47.2 102.2-104 0-57.4-46.6-104-104-104-56.8 0-103 45.6-104 102.2L73-24.9zM512 288c-17.2 0-33.7 3.4-48.7 9.6l170 170c4.2-5.4 6.7-12.2 6.7-19.6l0-32c0-70.7-57.3-128-128-128zM59.9 97.7c-21.5 12.5-35.9 35.7-35.9 62.3 0 39.8 32.2 72 72 72 26.6 0 49.8-14.4 62.3-35.9L59.9 97.7zM250.2 288C196.8 313.9 160 368.7 160 432l0 16c0 17.7 14.3 32 32 32l250.2 0-192-192zM128 288C57.3 288 0 345.3 0 416l0 32c0 17.7 14.3 32 32 32l86.7 0c-4.3-9.8-6.7-20.6-6.7-32l0-16c0-53.2 20-101.8 52.9-138.6-11.7-3.5-24.1-5.4-36.9-5.4zM616 160a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"
    ]
};
var $159afdcd077ecfe9$export$b5378818301da1be = {
    prefix: 'fas',
    iconName: 'paper-plane',
    icon: [
        576,
        512,
        [
            61913
        ],
        "f1d8",
        "M536.4-26.3c9.8-3.5 20.6-1 28 6.3s9.8 18.2 6.3 28l-178 496.9c-5 13.9-18.1 23.1-32.8 23.1-14.2 0-27-8.6-32.3-21.7l-64.2-158c-4.5-11-2.5-23.6 5.2-32.6l94.5-112.4c5.1-6.1 4.7-15-.9-20.6s-14.6-6-20.6-.9L229.2 276.1c-9.1 7.6-21.6 9.6-32.6 5.2L38.1 216.8c-13.1-5.3-21.7-18.1-21.7-32.3 0-14.7 9.2-27.8 23.1-32.8l496.9-178z"
    ]
};
var $159afdcd077ecfe9$export$7fb8daedae341012 = {
    prefix: 'fas',
    iconName: 'book-atlas',
    icon: [
        448,
        512,
        [
            "atlas"
        ],
        "f558",
        "M96 512l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-66.7c18.6-6.6 32-24.4 32-45.3l0-288c0-26.5-21.5-48-48-48L96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96zM64 416c0-17.7 14.3-32 32-32l256 0 0 64-256 0c-17.7 0-32-14.3-32-32zM310.6 208L279 208c-1.4 23.1-6 44.2-12.6 61.2 22.7-12.5 39.4-34.8 44.2-61.2zm-173.1 0c4.8 26.4 21.5 48.7 44.2 61.2-6.7-17-11.2-38-12.6-61.2l-31.6 0zm76.4 55c4.5 9.6 8.2 13.8 10.2 15.5 2-1.7 5.7-5.8 10.2-15.5 6.2-13.4 11.1-32.5 12.7-55l-45.8 0c1.6 22.5 6.5 41.6 12.7 55zm-12.7-87l45.8 0c-1.6-22.5-6.5-41.6-12.7-55-4.5-9.6-8.2-13.8-10.2-15.5-2 1.7-5.7 5.8-10.2 15.5-6.2 13.4-11.1 32.5-12.7 55zm109.5 0c-4.8-26.4-21.5-48.7-44.2-61.2 6.7 17 11.2 38 12.6 61.2l31.6 0zM169 176c1.4-23.1 6-44.2 12.6-61.2-22.7 12.5-39.4 34.8-44.2 61.2l31.6 0zM96 192a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z"
    ]
};
var $159afdcd077ecfe9$export$380a9050e42fe5d7 = $159afdcd077ecfe9$export$7fb8daedae341012;
var $159afdcd077ecfe9$export$36583f5d3d5a971f = {
    prefix: 'fas',
    iconName: 'table',
    icon: [
        448,
        512,
        [],
        "f0ce",
        "M256 160l0 96 128 0 0-96-128 0zm-64 0l-128 0 0 96 128 0 0-96zM0 320L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-96zm384 0l-128 0 0 96 128 0 0-96zM192 416l0-96-128 0 0 96 128 0z"
    ]
};
var $159afdcd077ecfe9$export$e4b51a47a2f8b9db = {
    prefix: 'fas',
    iconName: 'heart',
    icon: [
        512,
        512,
        [
            128153,
            128154,
            128155,
            128156,
            128420,
            129293,
            129294,
            129505,
            9829,
            10084,
            61578
        ],
        "f004",
        "M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 112.2-139.9 242.5-212.9 298.2-12.4 9.4-27.6 14.1-43.1 14.1s-30.8-4.6-43.1-14.1C139.9 410.2 0 279.9 0 167.7l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1z"
    ]
};
var $159afdcd077ecfe9$export$7b69b3617b84259b = {
    prefix: 'fas',
    iconName: 'circle-chevron-up',
    icon: [
        512,
        512,
        [
            "chevron-circle-up"
        ],
        "f139",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z"
    ]
};
var $159afdcd077ecfe9$export$b786cf5db03f2c36 = $159afdcd077ecfe9$export$7b69b3617b84259b;
var $159afdcd077ecfe9$export$e6dadc1155c4ee48 = {
    prefix: 'fas',
    iconName: 'battery-half',
    icon: [
        640,
        512,
        [
            "battery-3"
        ],
        "f242",
        "M528 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l416 0zM112 64c-44.2 0-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80l416 0c44.2 0 80-35.8 80-80l0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80L112 64zm56 112c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-144 0z"
    ]
};
var $159afdcd077ecfe9$export$f9138caac2aedaed = $159afdcd077ecfe9$export$e6dadc1155c4ee48;
var $159afdcd077ecfe9$export$aa4baaed1c60f58d = {
    prefix: 'fas',
    iconName: 'font-awesome',
    icon: [
        512,
        512,
        [
            62501,
            62694,
            "font-awesome-flag",
            "font-awesome-logo-full"
        ],
        "f2b4",
        "M91.7 96C106.3 86.8 116 70.5 116 52 116 23.3 92.7 0 64 0S12 23.3 12 52c0 16.7 7.8 31.5 20 41l0 419 64 0 0-64 373.6 0c14.6 0 26.4-11.8 26.4-26.4 0-3.7-.8-7.3-2.3-10.7L432 272 493.7 133.1c1.5-3.4 2.3-7 2.3-10.7 0-14.6-11.8-26.4-26.4-26.4L91.7 96z"
    ]
};
var $159afdcd077ecfe9$export$102c25fde54d4843 = $159afdcd077ecfe9$export$aa4baaed1c60f58d;
var $159afdcd077ecfe9$export$6e20d421a2e0f320 = $159afdcd077ecfe9$export$aa4baaed1c60f58d;
var $159afdcd077ecfe9$export$74d1f89b5feb9d42 = {
    prefix: 'fas',
    iconName: 'handcuffs',
    icon: [
        576,
        512,
        [],
        "e4f8",
        "M320-32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zM192 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM152 96c-13.3 0-24 10.7-24 24l0 16c0 1 .1 1.9 .2 2.9-74.7 26.3-128.2 97.5-128.2 181.1 0 106 86 192 192 192s192-86 192-192c0-83.7-53.5-154.8-128.2-181.1 .1-.9 .2-1.9 .2-2.9l0-16c0-13.3-10.7-24-24-24l-80 0zM64 320a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm448 0c0 66.9-51.3 121.8-116.6 127.5-14.3 22.8-32.4 43.1-53.4 59.9 13.5 3 27.6 4.6 42 4.6 106 0 192-86 192-192 0-83.7-53.5-154.8-128.2-181.1 .1-.9 .2-1.9 .2-2.9l0-16c0-13.3-10.7-24-24-24l-80 0c-12.3 0-22.4 9.2-23.8 21.1 30.3 19.2 56.1 45 75.2 75.4 65.4 5.8 116.6 60.6 116.6 127.5zM384 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$ab6f71fd6878da90 = {
    prefix: 'fas',
    iconName: 'hat-cowboy-side',
    icon: [
        640,
        512,
        [],
        "f8c1",
        "M640 388.3c0 16.9-7.1 32.2-18.4 43.1l-35-23.3-292.7-195.1c-36.1-24.1-78.6-36.9-122-36.9l-3.9 0c-2.7 0-5.4 0-8 .1l22.2-100c5.7-25.8 28.6-44.1 55-44.1 12.2 0 24.1 4 33.8 11.3l4.7 3.5c26.3 19.7 62.4 19.7 88.6 0l4.7-3.5c9.8-7.3 21.6-11.3 33.8-11.3 26.4 0 49.3 18.3 55 44.1l33 148.5C574.5 232.3 640 302.6 640 388.3zM171.9 224c33.9 0 67.1 10 95.4 28.9L560 448 56 448c-30.9 0-56-25.1-56-56 0-92.8 75.2-168 168-168l3.9 0z"
    ]
};
var $159afdcd077ecfe9$export$5548c3eb51060fa8 = {
    prefix: 'fas',
    iconName: 'industry',
    icon: [
        512,
        512,
        [],
        "f275",
        "M32 32C14.3 32 0 46.3 0 64L0 432c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-279.8c0-18.2-19.4-29.7-35.4-21.1l-156.6 84.3 0-63.2c0-18.2-19.4-29.7-35.4-21.1L128 215.4 128 64c0-17.7-14.3-32-32-32L32 32z"
    ]
};
var $159afdcd077ecfe9$export$4d384ffc907ddaff = {
    prefix: 'fas',
    iconName: 'lines-leaning',
    icon: [
        384,
        512,
        [],
        "e51e",
        "M190.4 74.1c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-128 384c-5.6 16.8 3.5 34.9 20.2 40.5s34.9-3.5 40.5-20.2l128-384zm70.9-41.7c-17.4-2.9-33.9 8.9-36.8 26.3l-64 384c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3l64-384c2.9-17.4-8.9-33.9-26.3-36.8zM352 32c-17.7 0-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$2c31ca0d9bee400f = {
    prefix: 'fas',
    iconName: 'passport',
    icon: [
        384,
        512,
        [],
        "f5ab",
        "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM96 408c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zM278.6 208c-4.8 26.4-21.5 48.7-44.2 61.2 6.7-17 11.2-38 12.6-61.2l31.6 0zm-173.1 0l31.6 0c1.4 23.1 6 44.2 12.6 61.2-22.7-12.5-39.4-34.8-44.2-61.2zm76.4 55c-6.2-13.4-11.1-32.5-12.7-55l45.8 0c-1.6 22.5-6.5 41.6-12.7 55-4.5 9.6-8.2 13.8-10.2 15.5-2-1.7-5.7-5.8-10.2-15.5zm0-142c4.5-9.6 8.2-13.8 10.2-15.5 2 1.7 5.7 5.8 10.2 15.5 6.2 13.4 11.1 32.5 12.7 55l-45.8 0c1.6-22.5 6.5-41.6 12.7-55zm96.7 55L247 176c-1.4-23.1-6-44.2-12.6-61.2 22.7 12.5 39.4 34.8 44.2 61.2zM137 176l-31.6 0c4.8-26.4 21.5-48.7 44.2-61.2-6.7 17-11.2 38-12.6 61.2zm183 16a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"
    ]
};
var $159afdcd077ecfe9$export$a590003279d671b8 = {
    prefix: 'fas',
    iconName: 'infinity',
    icon: [
        640,
        512,
        [
            8734,
            9854
        ],
        "f534",
        "M0 256c0-88.4 71.6-160 160-160 50.4 0 97.8 23.7 128 64l32 42.7 32-42.7c30.2-40.3 77.6-64 128-64 88.4 0 160 71.6 160 160S568.4 416 480 416c-50.4 0-97.8-23.7-128-64l-32-42.7-32 42.7c-30.2 40.3-77.6 64-128 64-88.4 0-160-71.6-160-160zm280 0l-43.2-57.6c-18.1-24.2-46.6-38.4-76.8-38.4-53 0-96 43-96 96s43 96 96 96c30.2 0 58.7-14.2 76.8-38.4L280 256zm80 0l43.2 57.6c18.1 24.2 46.6 38.4 76.8 38.4 53 0 96-43 96-96s-43-96-96-96c-30.2 0-58.7 14.2-76.8 38.4L360 256z"
    ]
};
var $159afdcd077ecfe9$export$76c1aa4bf9a39458 = {
    prefix: 'fas',
    iconName: 'clone',
    icon: [
        512,
        512,
        [],
        "f24d",
        "M288 448l-224 0 0-224 48 0 0-64-48 0c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-48-64 0 0 48zm-64-96l224 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L224 0c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64z"
    ]
};
var $159afdcd077ecfe9$export$a8710cdb23198d53 = {
    prefix: 'fas',
    iconName: 'forward',
    icon: [
        576,
        512,
        [
            9193
        ],
        "f04e",
        "M371.7 43.1C360.1 32 343 28.9 328.3 35.2S304 56 304 72l0 136.3-172.3-165.1C120.1 32 103 28.9 88.3 35.2S64 56 64 72l0 368c0 16 9.6 30.5 24.3 36.8s31.8 3.2 43.4-7.9L304 303.7 304 440c0 16 9.6 30.5 24.3 36.8s31.8 3.2 43.4-7.9l192-184c7.9-7.5 12.3-18 12.3-28.9s-4.5-21.3-12.3-28.9l-192-184z"
    ]
};
var $159afdcd077ecfe9$export$bd6a7788954842b5 = {
    prefix: 'fas',
    iconName: 'm',
    icon: [
        448,
        512,
        [
            109
        ],
        "4d",
        "M22.7 33.4c13.5-4.1 28.1 1.1 35.9 12.9L224 294.3 389.4 46.3c7.8-11.7 22.4-17 35.9-12.9S448 49.9 448 64l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-278.3-133.4 200.1c-5.9 8.9-15.9 14.2-26.6 14.2s-20.7-5.3-26.6-14.2L64 169.7 64 448c0 17.7-14.3 32-32 32S0 465.7 0 448L0 64C0 49.9 9.2 37.5 22.7 33.4z"
    ]
};
var $159afdcd077ecfe9$export$b372a24046126ad8 = {
    prefix: 'fas',
    iconName: 'road-spikes',
    icon: [
        640,
        512,
        [],
        "e568",
        "M64 116.8c0-15.8 20.5-22 29.3-8.9l98.7 148 0-139.2c0-15.8 20.5-22 29.3-8.9l98.7 148 0-139.2c0-15.8 20.5-22 29.3-8.9l98.7 148 0-139.2c0-15.8 20.5-22 29.3-8.9L606.8 302.2c14.2 21.3-1.1 49.8-26.6 49.8L64 352 64 116.8zM32 384l576 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$64f9eb99c9749cce = {
    prefix: 'fas',
    iconName: 'mountain',
    icon: [
        512,
        512,
        [
            127956
        ],
        "f6fc",
        "M256.5 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5-7.2 12.1-20.3 19.5-34.3 19.5l-432 0c-14.1 0-27.1-7.4-34.3-19.5s-7.5-27.1-.8-39.5l216-400 2.9-4.6C231.7 6.2 243.6 0 256.5 0zM170.4 249.9l26.8 26.8c6.2 6.2 16.4 6.2 22.6 0l43.3-43.3c6-6 14.1-9.4 22.6-9.4l42.8 0-72.1-133.5-86.1 159.4z"
    ]
};
var $159afdcd077ecfe9$export$442fddbbd741c590 = {
    prefix: 'fas',
    iconName: 'chess',
    icon: [
        512,
        512,
        [],
        "f439",
        "M168 56l0 40-78.1 0c-14.3 0-25.9 11.6-25.9 25.9 0 4 .9 8 2.7 11.6l33.4 66.8c-11.4 1.8-20.2 11.7-20.2 23.7 0 13.3 10.7 24 24 24l5.6 0-13.6 136-56.2 70.3c-5 6.3-7.8 14.1-7.8 22.2 0 19.6 15.9 35.5 35.5 35.5l248.9 0c19.6 0 35.5-15.9 35.5-35.5 0-8.1-2.7-15.9-7.8-22.2L288 384 274.4 248 280 248c13.3 0 24-10.7 24-24 0-11.9-8.7-21.9-20.2-23.7l33.4-66.8c1.8-3.6 2.7-7.6 2.7-11.6 0-14.3-11.6-25.9-25.9-25.9l-78.1 0 0-40 16 0c13.3 0 24-10.7 24-24S245.3 8 232 8l-16 0 0-16c0-13.3-10.7-24-24-24S168-21.3 168-8l0 16-16 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0zM325.8 279.6l8.5 85.5 47.4 59.2 4.2 5.7c9.2 13.7 14.1 29.9 14.1 46.5 0 12.7-2.8 24.8-7.9 35.5l83.1 0c20.3 0 36.8-16.5 36.8-36.8 0-7.3-2.2-14.4-6.2-20.4l-25.8-38.7 0-64 13.3-13.3c12-12 18.7-28.3 18.7-45.3L512 192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16-32 0 0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32c0 22.4-10.2 42.4-26.2 55.6z"
    ]
};
var $159afdcd077ecfe9$export$7ed2bad15ae6237f = {
    prefix: 'fas',
    iconName: 'temperature-three-quarters',
    icon: [
        320,
        512,
        [
            "temperature-3",
            "thermometer-3",
            "thermometer-three-quarters"
        ],
        "f2c8",
        "M160 0C107 0 64 43 64 96l0 164.7C34.5 287 16 325.4 16 368 16 447.5 80.5 512 160 512s144-64.5 144-144c0-42.6-18.5-81-48-107.3L256 96c0-53-43-96-96-96zm64 368c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L136 152c0-13.3 10.7-24 24-24s24 10.7 24 24l0 156.7c23.5 9.5 40 32.5 40 59.3z"
    ]
};
var $159afdcd077ecfe9$export$89def3268ed9b4bc = $159afdcd077ecfe9$export$7ed2bad15ae6237f;
var $159afdcd077ecfe9$export$2f653125f4e6463 = $159afdcd077ecfe9$export$7ed2bad15ae6237f;
var $159afdcd077ecfe9$export$6c632d1dc30d4a77 = $159afdcd077ecfe9$export$7ed2bad15ae6237f;
var $159afdcd077ecfe9$export$fa30fcd1e0d0d8 = {
    prefix: 'fas',
    iconName: 'b',
    icon: [
        320,
        512,
        [
            98
        ],
        "42",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32l160 0c70.7 0 128-57.3 128-128 0-46.5-24.8-87.3-62-109.7 18.7-22.3 30-51 30-82.3 0-70.7-57.3-128-128-128L32 32zM160 224l-96 0 0-128 96 0c35.3 0 64 28.7 64 64s-28.7 64-64 64zM64 288l128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-128 0 0-128z"
    ]
};
var $159afdcd077ecfe9$export$bea811bbf570f05a = {
    prefix: 'fas',
    iconName: 'shield-virus',
    icon: [
        512,
        512,
        [],
        "e06c",
        "M253.4 2.9C249.2 1 244.7 0 240 0s-9.2 1-13.4 2.9L38.3 82.8c-22 9.3-38.4 31-38.3 57.2 .5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0 172.4-82.5 213.2-264 213.6-363.2 .1-26.2-16.3-47.9-38.3-57.2L253.4 2.9zM240 128c13.3 0 24 10.7 24 24 0 22.9 27.7 34.4 43.9 18.2 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.2 16.2-4.7 43.9 18.2 43.9 13.3 0 24 10.7 24 24s-10.7 24-24 24c-22.9 0-34.4 27.7-18.2 43.9 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-16.2-16.2-43.9-4.7-43.9 18.2 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.9-27.7-34.4-43.9-18.2-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c16.2-16.2 4.7-43.9-18.2-43.9-13.3 0-24-10.7-24-24s10.7-24 24-24c22.9 0 34.4-27.7 18.2-43.9-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16.2 16.2 43.9 4.7 43.9-18.2 0-13.3 10.7-24 24-24zM208 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$4a157bd81dcd8d80 = {
    prefix: 'fas',
    iconName: 'litecoin-sign',
    icon: [
        384,
        512,
        [],
        "e1d3",
        "M128 64c0-17.7-14.3-32-32-32S64 46.3 64 64l0 157.9-38.6 11c-12.7 3.6-20.1 16.9-16.5 29.7s16.9 20.1 29.7 16.5L64 271.8 64 448c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0 0-162.5 134.6-38.5c12.7-3.6 20.1-16.9 16.5-29.7s-16.9-20.1-29.7-16.5L128 203.6 128 64z"
    ]
};
var $159afdcd077ecfe9$export$64bfd48ed353c031 = {
    prefix: 'fas',
    iconName: 'dice-d6',
    icon: [
        512,
        512,
        [],
        "f6d1",
        "M224.4 8.3C244-2.8 268-2.8 287.6 8.3l176 99.7c20 11.4 32.4 32.6 32.4 55.7l0 197.4c0 23-12.4 44.3-32.4 55.7l-176 99.7c-19.6 11.1-43.6 11.1-63.1 0l-176-99.7C28.4 405.5 16 384.2 16 361.2l0-197.4c0-23 12.4-44.3 32.4-55.7l176-99.7zM102.6 155.6c-8.8-3.1-18.8 .3-23.8 8.6s-3.2 18.7 3.6 25l3.2 2.4 150.2 90.2 0 148.7c0 11 9 20 20 20 11 0 20-9 20-20l0-148.7 150.3-90.2c9.5-5.7 12.6-18 6.9-27.4s-18-12.5-27.4-6.9l-149.7 89.8-149.7-89.8-3.7-1.7z"
    ]
};
var $159afdcd077ecfe9$export$523960de087f5198 = {
    prefix: 'fas',
    iconName: 'grip-lines-vertical',
    icon: [
        192,
        512,
        [],
        "f7a5",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 64zm128 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384z"
    ]
};
var $159afdcd077ecfe9$export$14c9f1d85e53ae99 = {
    prefix: 'fas',
    iconName: 'golf-ball-tee',
    icon: [
        384,
        512,
        [
            "golf-ball"
        ],
        "f450",
        "M298.5 384.1c12.1 1.2 21.5 11.5 21.5 23.9s-9.4 22.6-21.5 23.9l-2.5 .1-80 0 0 88c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-88-80 0c-13.3 0-24-10.7-24-24 0-12.4 9.4-22.6 21.5-23.9l2.5-.1 208 0 2.5 .1zM192 0c106 0 192 86 192 192 0 57.4-25.2 108.8-65.1 144L65.1 336C25.2 300.8 0 249.4 0 192 0 86 86 0 192 0zm32 240c-7.7 0-14.2 5.5-15.7 12.8l-.6 6.4c-1.3 6.3-6.2 11.2-12.5 12.5l-6.4 .6c-7.3 1.5-12.8 8-12.8 15.7 0 8.8 7.2 16 16 16 26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm64-64c-7.7 0-14.2 5.5-15.7 12.8l-.6 6.4c-1.3 6.3-6.2 11.2-12.5 12.5l-6.4 .6c-7.3 1.5-12.8 8-12.8 15.7 0 8.8 7.2 16 16 16 26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-80-16c-7.7 0-14.2 5.5-15.7 12.8l-.6 6.4c-1.3 6.3-6.2 11.2-12.5 12.5l-6.4 .6c-7.3 1.5-12.8 8-12.8 15.7 0 8.8 7.2 16 16 16 26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$2251487a9a33c682 = $159afdcd077ecfe9$export$14c9f1d85e53ae99;
var $159afdcd077ecfe9$export$ab681aaf692a5a8a = {
    prefix: 'fas',
    iconName: 'hexagon',
    icon: [
        576,
        512,
        [
            11043
        ],
        "f312",
        "M33.5 220.3c-12.7 22.2-12.7 49.4 0 71.5l96.2 168.1c12.8 22.4 36.7 36.2 62.5 36.2l191.6 0c25.8 0 49.7-13.8 62.5-36.2l96.2-168.1c12.7-22.2 12.7-49.4 0-71.5L446.3 52.2C433.5 29.8 409.6 16 383.8 16L192.2 16c-25.8 0-49.7 13.8-62.5 36.2L33.5 220.3z"
    ]
};
var $159afdcd077ecfe9$export$ff7e93418af88b78 = {
    prefix: 'fas',
    iconName: 'folder-open',
    icon: [
        576,
        512,
        [
            128194,
            128449,
            61717
        ],
        "f07c",
        "M56 225.6L32.4 296.2 32.4 96c0-35.3 28.7-64 64-64l138.7 0c13.8 0 27.3 4.5 38.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4l117.3 0c35.3 0 64 28.7 64 64l0 16-365.4 0c-41.3 0-78 26.4-91.1 65.6zM477.8 448L99 448c-32.8 0-55.9-32.1-45.5-63.2l48-144C108 221.2 126.4 208 147 208l378.8 0c32.8 0 55.9 32.1 45.5 63.2l-48 144c-6.5 19.6-24.9 32.8-45.5 32.8z"
    ]
};
var $159afdcd077ecfe9$export$ab1408bfbe914cc9 = {
    prefix: 'fas',
    iconName: 'kaaba',
    icon: [
        512,
        512,
        [
            128331
        ],
        "f66b",
        "M256 51.3L92.8 112.4 247.5 171.1c5.5 2.1 11.5 2.1 17 0L419.2 112.4 256 51.3zM0 129.3c0-20 12.4-37.9 31.1-44.9l208-78c10.9-4.1 22.8-4.1 33.7 0l208 78c18.7 7 31.1 24.9 31.1 44.9l0 36-253.2 96c-1.8 .7-3.8 .7-5.7 0l-253.2-96 0-36zm0 140l0-52.7 236.1 89.6c12.8 4.9 26.9 4.9 39.7 0l236.1-89.6 0 52.7-128 48.6 0 51.3 128-48.6 0 62.2c0 20-12.4 37.9-31.1 44.9l-208 78c-10.9 4.1-22.8 4.1-33.7 0l-208-78C12.4 420.7 0 402.7 0 382.7l0-62.2 128 48.6 0-51.3-128-48.6zM236.1 410.1c12.8 4.9 26.9 4.9 39.7 0l60.1-22.8 0-51.3-77.2 29.3c-1.8 .7-3.8 .7-5.7 0l-77.2-29.3 0 51.3 60.1 22.8z"
    ]
};
var $159afdcd077ecfe9$export$e6094d25274088ab = {
    prefix: 'fas',
    iconName: 'hand-holding',
    icon: [
        576,
        512,
        [],
        "f4bd",
        "M66.7 384l42.5-42.5c24-24 56.6-37.5 90.5-37.5L352 304c17.7 0 32 14.3 32 32s-14.3 32-32 32l-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112.6 0 119.7-88.2c17.8-13.1 42.8-9.3 55.9 8.5s9.3 42.8-8.5 55.9L433.1 485.5c-23.4 17.2-51.6 26.5-80.7 26.5L32 512c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l34.7 0z"
    ]
};
var $159afdcd077ecfe9$export$a59391493212cfa2 = {
    prefix: 'fas',
    iconName: 'single-quote-right',
    icon: [
        192,
        512,
        [],
        "e81c",
        "M64 416c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 136c0 66.3-53.7 120-120 120l-8 0z"
    ]
};
var $159afdcd077ecfe9$export$8f534e1e0ab75bfe = {
    prefix: 'fas',
    iconName: 'bottle-droplet',
    icon: [
        320,
        512,
        [],
        "e4c4",
        "M80 0c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 103.3c64.9 20.4 112 81 112 152.7l0 192c0 35.3-28.7 64-64 64L64 544c-35.3 0-64-28.7-64-64L0 288c0-71.6 47.1-132.3 112-152.7L112 32C94.3 32 80 17.7 80 0zm80 416c35.3 0 64-32.4 64-64 0-21.2-28.9-64.5-47.9-90.6-8.1-11.1-24.2-11.1-32.3 0-19 26.1-47.9 69.4-47.9 90.6 0 31.6 28.7 64 64 64z"
    ]
};
var $159afdcd077ecfe9$export$26a3f9d2784b90d8 = {
    prefix: 'fas',
    iconName: 'window-minimize',
    icon: [
        512,
        512,
        [
            128469
        ],
        "f2d1",
        "M0 416c0-17.7 14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$930de8c26eb20490 = {
    prefix: 'fas',
    iconName: 'chevron-right',
    icon: [
        320,
        512,
        [
            9002
        ],
        "f054",
        "M311.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L243.2 256 73.9 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"
    ]
};
var $159afdcd077ecfe9$export$1199a8ce85311ab5 = {
    prefix: 'fas',
    iconName: 'egg',
    icon: [
        384,
        512,
        [
            129370
        ],
        "f7fb",
        "M192 496C86 496 0 394 0 288 0 176 64 16 192 16S384 176 384 288c0 106-86 208-192 208zM154.8 134c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2-11.2 31.6-16.9 65.1-16.9 93.5 0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8 10.1-28.5 25-54.1 43.7-71.2z"
    ]
};
var $159afdcd077ecfe9$export$8a56136f40511e5d = {
    prefix: 'fas',
    iconName: 'landmark-dome',
    icon: [
        512,
        512,
        [
            "landmark-alt"
        ],
        "f752",
        "M256 0c-17.7 0-32 14.3-32 32 0 .9 0 1.8 .1 2.6-80.5 13.4-144 76.9-157.5 157.4L64 192c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 160-51.2 38.4C4.7 460.4 0 469.9 0 480 0 497.7 14.3 512 32 512l448 0c17.7 0 32-14.3 32-32 0-10.1-4.7-19.6-12.8-25.6L448 416 448 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-2.7 0c-13.5-80.4-77-143.9-157.5-157.4 .1-.9 .1-1.7 .1-2.6 0-17.7-14.3-32-32-32zm80 256l64 0 0 160-64 0 0-160zM224 416l0-160 64 0 0 160-64 0zM112 256l64 0 0 160-64 0 0-160z"
    ]
};
var $159afdcd077ecfe9$export$8b9c180efffc50ab = $159afdcd077ecfe9$export$8a56136f40511e5d;
var $159afdcd077ecfe9$export$2571e33fa6c25993 = {
    prefix: 'fas',
    iconName: 'worm',
    icon: [
        448,
        512,
        [],
        "e599",
        "M224 96c0-53 43-96 96-96l38.4 0C407.9 0 448 40.1 448 89.6L448 376c0 75.1-60.9 136-136 136S176 451.1 176 376l0-80c0-22.1-17.9-40-40-40s-40 17.9-40 40l0 168c0 26.5-21.5 48-48 48S0 490.5 0 464L0 296c0-75.1 60.9-136 136-136s136 60.9 136 136l0 80c0 22.1 17.9 40 40 40s40-17.9 40-40l0-184-32 0c-53 0-96-43-96-96zm144-8a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$c950c1ba7f227d5b = {
    prefix: 'fas',
    iconName: 'user-injured',
    icon: [
        448,
        512,
        [],
        "f728",
        "M242.7 80L334 80c-10.7-24.6-29.5-44.9-52.9-57.6L242.7 80zm-.9-70.7C236 8.4 230 8 224 8 174.8 8 132.5 37.6 114 80l80.6 0 47.1-70.7zM224 248c66.3 0 120-53.7 120-120l-240 0c0 66.3 53.7 120 120 120zM98.7 341.8C49.3 370.2 16 423.5 16 484.6 16 499.7 28.3 512 43.4 512l151 0-95.8-170.2zm45.1-17.7l42.7 75.9 85.5 0c44.2 0 80 35.8 80 80 0 11.4-2.4 22.2-6.7 32l59.2 0c15.1 0 27.4-12.3 27.4-27.4 0-90.9-73.7-164.6-164.6-164.6l-86.9 0c-12.6 0-24.9 1.4-36.7 4.1zM213.5 448l36 64 22.5 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-58.5 0z"
    ]
};
var $159afdcd077ecfe9$export$eff51ea25b4de135 = {
    prefix: 'fas',
    iconName: 'strikethrough',
    icon: [
        512,
        512,
        [],
        "f0cc",
        "M96 157.5C96 88.2 152.2 32 221.5 32L368 32c17.7 0 32 14.3 32 32s-14.3 32-32 32L221.5 96c-34 0-61.5 27.5-61.5 61.5 0 31 23.1 57.2 53.9 61l44.1 5.5 222 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l83.1 0C103 204.6 96 181.8 96 157.5zM349.2 336l65.5 0c.9 6.1 1.4 12.2 1.4 18.5 0 69.3-56.2 125.5-125.5 125.5L144 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l146.5 0c34 0 61.5-27.5 61.5-61.5 0-6.4-1-12.7-2.8-18.5z"
    ]
};
var $159afdcd077ecfe9$export$890d5e011054935a = {
    prefix: 'fas',
    iconName: 'blog',
    icon: [
        512,
        512,
        [],
        "f781",
        "M224 24c0-13.3 10.7-24 24-24 145.8 0 264 118.2 264 264 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-119.3-96.7-216-216-216-13.3 0-24-10.7-24-24zM80 96c26.5 0 48 21.5 48 48l0 224c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16 79.5 0 144 64.5 144 144S255.5 512 176 512 32 447.5 32 368l0-224c0-26.5 21.5-48 48-48zm168 0c92.8 0 168 75.2 168 168 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-66.3-53.7-120-120-120-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$df6244b0501f2112 = {
    prefix: 'fas',
    iconName: 'stopwatch-20',
    icon: [
        448,
        512,
        [],
        "e06f",
        "M168.5 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 25.3c-108 11.9-192 103.5-192 214.7 0 119.3 96.7 216 216 216s216-96.7 216-216c0-39.8-10.8-77.1-29.6-109.2l28.2-28.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-23.4 23.4c-32.9-30.2-75.2-50.3-122-55.5l0-25.3 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zm-60 240c0-28.7 23.3-52 52-52s52 23.3 52 52l0 3.8c0 11.7-3.2 23.1-9.3 33l-43.8 71.2 33.1 0c11 0 20 9 20 20s-9 20-20 20l-57.8 0c-14.5 0-26.2-11.7-26.2-26.2 0-4.9 1.3-9.6 3.9-13.8l56.7-92.1c2.2-3.6 3.4-7.8 3.4-12.1l0-3.8c0-6.6-5.4-12-12-12s-12 5.4-12 12c0 11-9 20-20 20s-20-9-20-20zm180-52c28.7 0 52 23.3 52 52l0 96c0 28.7-23.3 52-52 52s-52-23.3-52-52l0-96c0-28.7 23.3-52 52-52zm-12 52l0 96c0 6.6 5.4 12 12 12s12-5.4 12-12l0-96c0-6.6-5.4-12-12-12s-12 5.4-12 12z"
    ]
};
var $159afdcd077ecfe9$export$f846b848b3ba3064 = {
    prefix: 'fas',
    iconName: 'truck-pickup',
    icon: [
        640,
        512,
        [
            128763
        ],
        "f63c",
        "M363.8 96l57.6 96-133.4 0 0-96 75.8 0zM496 192L418.6 63.1C407.1 43.8 386.2 32 363.8 32L256 32c-17.7 0-32 14.3-32 32l0 128-144 0c-26.5 0-48 21.5-48 48l0 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l32.4 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l160.7 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88c0-2.7-.1-5.4-.4-8l32.4 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-80c0-26.5-21.5-48-48-48l-64 0zM112 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm376-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $159afdcd077ecfe9$export$d7b60b8dbd03cfe4 = {
    prefix: 'fas',
    iconName: 'seedling',
    icon: [
        512,
        512,
        [
            127793,
            "sprout"
        ],
        "f4d8",
        "M512 32C512 140.1 435.4 230.3 333.6 251.4 325.7 193.3 299.6 141 261.1 100.5 301.2 40 369.9 0 448 0l32 0c17.7 0 32 14.3 32 32zM0 96C0 78.3 14.3 64 32 64l32 0c123.7 0 224 100.3 224 224l0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160C100.3 320 0 219.7 0 96z"
    ]
};
var $159afdcd077ecfe9$export$9f3035e3a8c62323 = $159afdcd077ecfe9$export$d7b60b8dbd03cfe4;
var $159afdcd077ecfe9$export$7e3f1701aa95ef01 = {
    prefix: 'fas',
    iconName: 'transgender',
    icon: [
        576,
        512,
        [
            9895,
            "transgender-alt"
        ],
        "f225",
        "M128-32c17.7 0 32 14.3 32 32s-14.3 32-32 32L97.9 32 136 70.1 151 55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-15 15 14.2 14.2c27.9-23.8 64.2-38.2 103.8-38.2 36.7 0 70.6 12.4 97.6 33.2L466.7 32 448 32c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.7-84.4 84.4c13 23.1 20.4 49.9 20.4 78.3 0 77.4-55 142-128 156.8l0 35.2 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 16c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-35.2c-73-14.8-128-79.4-128-156.8 0-31.4 9-60.7 24.7-85.4l-16.7-16.7-15 15c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l15-15-38.1-38.1 0 30.1c0 17.7-14.3 32-32 32S0 113.7 0 96L0 0C0-17.7 14.3-32 32-32l96 0zM288 336a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $159afdcd077ecfe9$export$9c36cf9334c052f = $159afdcd077ecfe9$export$7e3f1701aa95ef01;
var $159afdcd077ecfe9$export$228008b5e11032fa = {
    prefix: 'fas',
    iconName: 'star-half',
    icon: [
        576,
        512,
        [
            61731
        ],
        "f089",
        "M304.1 7.6c0-11.1-7.6-20.7-18.4-23.3s-21.9 2.5-27 12.4L193.1 125.3 33.2 150.7c-8.9 1.4-16.3 7.7-19.1 16.3s-.5 18 5.8 24.4l114.4 114.5-25.2 159.9c-1.4 8.9 2.3 17.9 9.6 23.2s16.9 6.1 25 2L291 416.1c8-4.1 13.1-12.4 13.1-21.4l0-387.1z"
    ]
};
var $159afdcd077ecfe9$export$ed36ad335b36be22 = {
    prefix: 'fas',
    iconName: 'photo-film',
    icon: [
        640,
        512,
        [
            "photo-video"
        ],
        "f87c",
        "M192 64c0-35.3 28.7-64 64-64L576 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64l0-224zM320 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm156.5 11.5C472.1 100.4 464.4 96 456 96s-16.1 4.4-20.5 11.5l-54 88.3-17.9-25.6c-4.5-6.4-11.8-10.2-19.7-10.2s-15.2 3.8-19.7 10.2l-56 80c-5.1 7.3-5.8 16.9-1.6 24.8S279.1 288 288 288l256 0c8.7 0 16.7-4.7 20.9-12.3s4.1-16.8-.5-24.3l-88-144zM144 128l0 160c0 61.9 50.1 112 112 112l192 0 0 16c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l80 0zM52 196l0 24c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-24c0-8.8-7.2-16-16-16l-24 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-24c0-8.8-7.2-16-16-16l-24 0zm0 96c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-24c0-8.8-7.2-16-16-16l-24 0z"
    ]
};
var $159afdcd077ecfe9$export$739f6a6a12dfb6ed = $159afdcd077ecfe9$export$ed36ad335b36be22;
var $159afdcd077ecfe9$export$f1b881c73328720c = {
    prefix: 'fas',
    iconName: 'pump-medical',
    icon: [
        320,
        512,
        [],
        "e06a",
        "M96 0l0 80 128 0 0-24 72 0c13.3 0 24-10.7 24-24S309.3 8 296 8l-72 0 0-8c0-17.7-14.3-32-32-32l-64 0C110.3-32 96-17.7 96 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 128zm64 120c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 40 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-40 0 0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$7b24b34ef6cc130c = {
    prefix: 'fas',
    iconName: 'fire',
    icon: [
        448,
        512,
        [
            128293
        ],
        "f06d",
        "M160.5-26.4c9.3-7.8 23-7.5 31.9 .9 12.3 11.6 23.3 24.4 33.9 37.4 13.5 16.5 29.7 38.3 45.3 64.2 5.2-6.8 10-12.8 14.2-17.9 1.1-1.3 2.2-2.7 3.3-4.1 7.9-9.8 17.7-22.1 30.8-22.1 13.4 0 22.8 11.9 30.8 22.1 1.3 1.7 2.6 3.3 3.9 4.8 10.3 12.4 24 30.3 37.7 52.4 27.2 43.9 55.6 106.4 55.6 176.6 0 123.7-100.3 224-224 224S0 411.7 0 288c0-91.1 41.1-170 80.5-225 19.9-27.7 39.7-49.9 54.6-65.1 8.2-8.4 16.5-16.7 25.5-24.2zM225.7 416c25.3 0 47.7-7 68.8-21 42.1-29.4 53.4-88.2 28.1-134.4-4.5-9-16-9.6-22.5-2l-25.2 29.3c-6.6 7.6-18.5 7.4-24.7-.5-17.3-22.1-49.1-62.4-65.3-83-5.4-6.9-15.2-8-21.5-1.9-18.3 17.8-51.5 56.8-51.5 104.3 0 68.6 50.6 109.2 113.7 109.2z"
    ]
};
var $159afdcd077ecfe9$export$f48a3ba52a0a9e56 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-plus',
    icon: [
        512,
        512,
        [
            "search-plus"
        ],
        "f00e",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 112c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$378f00e6b1a8185 = $159afdcd077ecfe9$export$f48a3ba52a0a9e56;
var $159afdcd077ecfe9$export$f9b579ba06048af = {
    prefix: 'fas',
    iconName: 'flask',
    icon: [
        448,
        512,
        [],
        "f0c3",
        "M288 0L128 0C110.3 0 96 14.3 96 32s14.3 32 32 32L128 215.5 7.5 426.3C2.6 435 0 444.7 0 454.7 0 486.4 25.6 512 57.3 512l333.4 0c31.6 0 57.3-25.6 57.3-57.3 0-10-2.6-19.8-7.5-28.4L320 215.5 320 64c17.7 0 32-14.3 32-32S337.7 0 320 0L288 0zM192 215.5l0-151.5 64 0 0 151.5c0 11.1 2.9 22.1 8.4 31.8l41.6 72.7-164 0 41.6-72.7c5.5-9.7 8.4-20.6 8.4-31.8z"
    ]
};
var $159afdcd077ecfe9$export$7370f36a39a38737 = {
    prefix: 'fas',
    iconName: 'align-right',
    icon: [
        448,
        512,
        [],
        "f038",
        "M448 64c0 17.7-14.3 32-32 32L192 96c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 224c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$85cb04eaefaf2d8b = {
    prefix: 'fas',
    iconName: 'cable-car',
    icon: [
        512,
        512,
        [
            128673,
            57551,
            "tram"
        ],
        "f7da",
        "M288-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM160 24a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM32 288c0-35.3 28.7-64 64-64l136 0 0-96.2-193.4 55.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l224-64 0 0 224-64c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-206.6 59 0 109.9 136 0c35.3 0 64 28.7 64 64l0 160c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-160zm80 0c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l56 0 0-96-56 0zm184 96l0-96-80 0 0 96 80 0zm48 0l56 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-56 0 0 96z"
    ]
};
var $159afdcd077ecfe9$export$a7a36674c079f293 = $159afdcd077ecfe9$export$85cb04eaefaf2d8b;
var $159afdcd077ecfe9$export$f04e7a0f1033a0cd = {
    prefix: 'fas',
    iconName: 'kit-medical',
    icon: [
        512,
        512,
        [
            "first-aid"
        ],
        "f479",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l16 0 0-384-16 0zm64 0l0 384 256 0 0-384-256 0zM448 448c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-16 0 0 384 16 0zM224 184c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 40 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-40 0 0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$5b01ccb2da4c4387 = $159afdcd077ecfe9$export$f04e7a0f1033a0cd;
var $159afdcd077ecfe9$export$1412f35381064d7d = {
    prefix: 'fas',
    iconName: 'grip-lines',
    icon: [
        448,
        512,
        [],
        "f7a4",
        "M32 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 288zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 160z"
    ]
};
var $159afdcd077ecfe9$export$128a6cab12423493 = {
    prefix: 'fas',
    iconName: 'burger',
    icon: [
        512,
        512,
        [
            "hamburger"
        ],
        "f805",
        "M48 384c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80 0-8.8-7.2-16-16-16L48 384zM32 202c0 12.2 9.9 22 22 22L458 224c12.2 0 22-9.9 22-22 0-17.2-2.6-34.4-10.8-49.5-22.2-40.8-82.3-120.5-213.2-120.5S65 111.6 42.8 152.5C34.6 167.6 32 184.8 32 202zM0 304c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 272c-17.7 0-32 14.3-32 32zM256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM120 128a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm248-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$bab3bb9f4f59363 = $159afdcd077ecfe9$export$128a6cab12423493;
var $159afdcd077ecfe9$export$b23df6bafb174693 = {
    prefix: 'fas',
    iconName: 'snowman',
    icon: [
        640,
        512,
        [
            9731,
            9924
        ],
        "f7d0",
        "M403 211.7c32.2-24.9 53-63.9 53-107.7 0-75.1-60.9-136-136-136S184 28.9 184 104c0 43.9 20.8 82.9 53 107.7-32.2 16.3-59 41.8-76.8 73.1L112 264.2 112 224c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 19.6-22.5-9.7c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5c36.1 15.5 75.9 32.5 119.4 51.2-3.9 14.9-6 30.6-6 46.7 0 70 39.1 130.8 96.6 161.9 7.9 4.3 16.9 6.1 25.9 6.1l123 0c9 0 18-1.8 25.9-6.1 57.5-31.1 96.6-92 96.6-161.9 0-16.2-2.1-31.8-6-46.7 43.5-18.7 83.4-35.7 119.4-51.2 12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6l-22.5 9.7 0-19.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40.2-48.2 20.6c-17.9-31.3-44.6-56.8-76.8-73.1zM296 416a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM248 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM292.2 159.3c-2.7-4.8-4.2-10.2-4.2-15.7 0-17.5 14.2-31.6 31.6-31.6l.8 0c17.5 0 31.6 14.2 31.6 31.6 0 5.5-1.4 10.9-4.2 15.7L327 195.8c-3.1 5.4-10.8 5.4-13.9 0l-20.9-36.6z"
    ]
};
var $159afdcd077ecfe9$export$c402efcf01d5ca07 = {
    prefix: 'fas',
    iconName: 'hotel',
    icon: [
        512,
        512,
        [
            127976
        ],
        "f594",
        "M16 24C16 10.7 26.7 0 40 0L472 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 416 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L40 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-416-8 0C26.7 48 16 37.3 16 24zm208 88l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM128 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm96 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM352 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM112 208l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm240-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM288 384l43.8 0c9.9 0 17.5-9 14-18.2-13.8-36.1-48.8-61.8-89.7-61.8s-75.9 25.7-89.7 61.8c-3.5 9.2 4.1 18.2 14 18.2l43.8 0 0 80 64 0 0-80z"
    ]
};
var $159afdcd077ecfe9$export$ae64371e02ee8e56 = {
    prefix: 'fas',
    iconName: 'print',
    icon: [
        512,
        512,
        [
            128424,
            128438,
            9113
        ],
        "f02f",
        "M64 64C64 28.7 92.7 0 128 0L341.5 0c17 0 33.3 6.7 45.3 18.7l42.5 42.5c12 12 18.7 28.3 18.7 45.3l0 37.5-384 0 0-80zM0 256c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 96c0 17.7-14.3 32-32 32l-32 0 0 64c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-64-32 0c-17.7 0-32-14.3-32-32l0-96zM128 416l0 32 256 0 0-96-256 0 0 64zM456 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$cc519c9529a46c5c = {
    prefix: 'fas',
    iconName: 'volleyball',
    icon: [
        512,
        512,
        [
            127952,
            "volleyball-ball"
        ],
        "f45f",
        "M512 258.9c-23.4 8-47.8 13.1-72.6 15.1 5.9-98.6-30.7-191.1-94.9-258.3 97.8 36 167.5 130 167.5 240.3 0 1 0 1.9 0 2.9zm-5.9 52c-5.2 23.7-13.6 46.2-24.9 66.9-94.7 52.2-214 50-308.4-13.6 21.7-31.3 49.8-58.9 83.8-80.5 79.5 41.6 168.5 49.1 249.5 27.1zM279.7 241.6c-3.7-89.7-41.7-170.5-101.3-229.7 22.3-7.1 46-11.2 70.5-11.9 92.5 55.9 150.3 160.3 142.4 273.8-38-3.2-75.9-13.7-111.6-32.3zM130.5 32.8C149.1 49.1 165.8 67.7 179.9 88.2 91.5 132.3 29.7 210.3 3.7 299.5 1.3 285.3 0 270.8 0 256 0 160.2 52.6 76.7 130.5 32.8zm73.4 97c16.3 34.5 26.1 72.6 27.9 112.8-75.8 48-126.8 121.3-148.3 202.5-17.6-16.1-33-34.6-45.5-55 2.1-108.1 63.7-210.4 165.9-260.3zM256 512c-47.7 0-92.3-13-130.5-35.7 4.8-24.3 12.6-48 23.2-70.4 82.4 54.4 180.8 68.9 271 47-44.4 37-101.5 59.2-163.7 59.2z"
    ]
};
var $159afdcd077ecfe9$export$a15e6fc8e68a76b0 = $159afdcd077ecfe9$export$cc519c9529a46c5c;
var $159afdcd077ecfe9$export$bf0b19daceaec9c2 = {
    prefix: 'fas',
    iconName: 'traffic-light',
    icon: [
        320,
        512,
        [
            128678
        ],
        "f637",
        "M64-32C28.7-32 0-3.3 0 32L0 384c0 88.4 71.6 160 160 160s160-71.6 160-160l0-352c0-35.3-28.7-64-64-64L64-32zm96 392c30.9 0 56 25.1 56 56s-25.1 56-56 56-56-25.1-56-56 25.1-56 56-56zm56-104a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zM160 152a56 56 0 1 1 0-112 56 56 0 1 1 0 112z"
    ]
};
var $159afdcd077ecfe9$export$9cbf8612c6cadc74 = {
    prefix: 'fas',
    iconName: 'plane-circle-check',
    icon: [
        640,
        512,
        [],
        "e555",
        "M232 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 78 71.5c-69.3 29-118 97.4-118 177.2 0 49.3 18.6 94.3 49.1 128.3L288 512 179.9 539c-10.1 2.5-19.9-5.1-19.9-15.5l0-19.8c0-4.9 2.2-9.5 6-12.5l66-52.8 0-99.7-162.9 54.3C58.7 396.4 48 388.7 48 377.8l0-43.7c0-9 3.8-17.5 10.4-23.6L232 151.3 232 24zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm201.4-60.9c-7.1-5.2-17.2-3.6-22.4 3.5l-53 72.9-26.8-26.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c3.3 3.3 7.9 5 12.6 4.6s8.9-2.8 11.7-6.5l64-88c5.2-7.1 3.6-17.2-3.5-22.3z"
    ]
};
var $159afdcd077ecfe9$export$e5a8f011aef571ac = {
    prefix: 'fas',
    iconName: 'users',
    icon: [
        640,
        512,
        [],
        "f0c0",
        "M320 16a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM96 88a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM0 416c0-70.7 57.3-128 128-128 12.8 0 25.2 1.9 36.9 5.4-32.9 36.8-52.9 85.4-52.9 138.6l0 16c0 11.4 2.4 22.2 6.7 32L32 480c-17.7 0-32-14.3-32-32l0-32zm521.3 64c4.3-9.8 6.7-20.6 6.7-32l0-16c0-53.2-20-101.8-52.9-138.6 11.7-3.5 24.1-5.4 36.9-5.4 70.7 0 128 57.3 128 128l0 32c0 17.7-14.3 32-32 32l-86.7 0zM472 160a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM160 432c0-88.4 71.6-160 160-160s160 71.6 160 160l0 16c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-16z"
    ]
};
var $159afdcd077ecfe9$export$a881f37164b11fbf = {
    prefix: 'fas',
    iconName: 'certificate',
    icon: [
        576,
        512,
        [],
        "f0a3",
        "M239.2-8c-6.1-6.2-15-8.7-23.4-6.4S200.9-5.6 198.8 2.8L183.5 63c-1.1 4.4-5.6 7-9.9 5.7L113.8 51.9c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l16.9 59.8c1.2 4.3-1.4 8.8-5.7 9.9L35.1 166.5c-8.4 2.1-15 8.7-17.3 17.1s.2 17.3 6.4 23.4l44.5 43.3c3.2 3.1 3.2 8.3 0 11.5L24.3 305.1c-6.2 6.1-8.7 15-6.4 23.4s8.9 14.9 17.3 17.1l60.2 15.3c4.4 1.1 7 5.6 5.7 9.9L84.2 430.5c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l59.8-16.9c4.3-1.2 8.8 1.4 9.9 5.7l15.3 60.2c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l43.3-44.5c3.1-3.2 8.3-3.2 11.5 0L337.3 520c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3L393.1 449c1.1-4.4 5.6-7 9.9-5.7l59.8 16.9c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-16.9-59.8c-1.2-4.3 1.4-8.8 5.7-9.9l60.2-15.3c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-44.5-43.3c-3.2-3.1-3.2-8.3 0-11.5l44.5-43.3c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-60.2-15.3c-4.4-1.1-7-5.6-5.7-9.9l16.9-59.8c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1L403 68.8c-4.3 1.2-8.8-1.4-9.9-5.7L377.8 2.8c-2.1-8.4-8.7-15-17.1-17.3s-17.3 .2-23.4 6.4L294 36.5c-3.1 3.2-8.3 3.2-11.5 0L239.2-8z"
    ]
};
var $159afdcd077ecfe9$export$cca6f644647deaf3 = {
    prefix: 'fas',
    iconName: 'alarm-clock',
    icon: [
        512,
        512,
        [
            9200
        ],
        "f34e",
        "M504.4 132.5c-4.5 10.5-18.4 9.8-24.9 .4-27.8-40-66.1-72.2-111-92.6-10.4-4.7-13.7-18.3-4.1-24.6 15-9.9 33-15.7 52.3-15.7 52.6 0 95.2 42.6 95.2 95.2 0 13.2-2.7 25.8-7.6 37.3zm-471.9 .4c-6.5 9.4-20.5 10.1-24.9-.4-4.9-11.5-7.6-24.1-7.6-37.3 0-52.6 42.6-95.2 95.2-95.2 19.3 0 37.3 5.8 52.3 15.7 9.6 6.3 6.3 19.9-4.1 24.6-44.8 20.4-83.1 52.6-111 92.6zM390.2 467.4C352.8 495.4 306.3 512 256 512s-96.8-16.6-134.1-44.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l35.2-35.2C48.6 384.8 32 338.3 32 288 32 164.3 132.3 64 256 64S480 164.3 480 288c0 50.3-16.6 96.8-44.6 134.2l35.2 35.2c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-35.2-35.2zM280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l56 56c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-49-49 0-94.1z"
    ]
};
var $159afdcd077ecfe9$export$2a66e6044c1f7036 = {
    prefix: 'fas',
    iconName: 'helicopter-symbol',
    icon: [
        512,
        512,
        [],
        "e502",
        "M445.4 224l64.7 0C495.6 108.2 403.8 16.4 288 2l0 64.7C368.4 80.1 431.9 143.6 445.4 224zM510 288l-64.7 0C431.9 368.4 368.4 431.9 288 445.3l0 64.7c115.8-14.4 207.6-106.2 222-222zM2 288C16.4 403.8 108.2 495.6 224 510l0-64.7C143.6 431.9 80.2 368.4 66.7 288L2 288zm0-64l64.7 0C80.2 143.6 143.6 80.1 224 66.7L224 2C108.2 16.4 16.4 108.2 2 224zm206-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 96 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64-96 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$e824540f5a6a8a57 = {
    prefix: 'fas',
    iconName: 'house-chimney-crack',
    icon: [
        512,
        512,
        [
            "house-damage"
        ],
        "f6f1",
        "M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-105.6 0-38.4-64 80.8-67.3c7.8-6.5 7.6-18.6-.4-24.9L218.6 263.2c-14.6-11.5-33.8 7-22.8 22L256 368 170.5 439.2c-6.1 5-7.5 13.8-3.5 20.5l31.3 52.2-86.4 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208z"
    ]
};
var $159afdcd077ecfe9$export$8d7e943005ce0b49 = $159afdcd077ecfe9$export$e824540f5a6a8a57;
var $159afdcd077ecfe9$export$50b6dcaa9ec03439 = {
    prefix: 'fas',
    iconName: 'person-military-pointing',
    icon: [
        512,
        512,
        [],
        "e54a",
        "M214.9 14.1C202 15.2 192 26 192 39 192 52.8 203.2 64 217 64l151 0c8.8 0 16-7.2 16-16l0-30.6C384 8 376 .7 366.7 1.4L214.9 14.1zM208 112c0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16L209.6 96c-1 5.2-1.6 10.5-1.6 16zM40 224c-22.1 0-40 17.9-40 40s17.9 40 40 40l152 0 0 89.4 162.8-162.8c-13.3-4.3-27.3-6.5-41.6-6.5L40 224zm345.7 20.9l-171.1 171.1 169.4 0 0-46.3 53.6 90.6c11.2 19 35.8 25.3 54.8 14.1s25.3-35.8 14.1-54.8L430.3 290.8c-11.2-19-26.6-34.5-44.6-45.9zM192 448l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32-192 0z"
    ]
};
var $159afdcd077ecfe9$export$24680dede86b1883 = {
    prefix: 'fas',
    iconName: 'database',
    icon: [
        448,
        512,
        [],
        "f1c0",
        "M448 205.8c-14.8 9.8-31.8 17.7-49.5 24-47 16.8-108.7 26.2-174.5 26.2S96.4 246.5 49.5 229.8c-17.6-6.3-34.7-14.2-49.5-24L0 288c0 44.2 100.3 80 224 80s224-35.8 224-80l0-82.2zm0-77.8l0-48C448 35.8 347.7 0 224 0S0 35.8 0 80l0 48c0 44.2 100.3 80 224 80s224-35.8 224-80zM398.5 389.8C351.6 406.5 289.9 416 224 416S96.4 406.5 49.5 389.8c-17.6-6.3-34.7-14.2-49.5-24L0 432c0 44.2 100.3 80 224 80s224-35.8 224-80l0-66.2c-14.8 9.8-31.8 17.7-49.5 24z"
    ]
};
var $159afdcd077ecfe9$export$d91b374112d4f8c1 = {
    prefix: 'fas',
    iconName: 'newspaper',
    icon: [
        512,
        512,
        [
            128240
        ],
        "f1ea",
        "M0 416L0 120c0-13.3 10.7-24 24-24s24 10.7 24 24l0 288c0 13.3 10.7 24 24 24s24-10.7 24-24L96 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM160 128l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm24 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-240 0zm-24-72c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-240 0c-13.3 0-24 10.7-24 24zM360 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0z"
    ]
};
var $159afdcd077ecfe9$export$a6c308ee087b4ded = {
    prefix: 'fas',
    iconName: 'cloud-rain',
    icon: [
        512,
        512,
        [
            127783,
            9926
        ],
        "f73d",
        "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.3-6.7-1.9-13.7-1.9-20.8 0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16 .5 0 1.1 0 1.6 0 53 0 96 43 96 96s-43 96-96 96L96 320zm1.6 68.2c1.1-2.5 3.6-4.2 6.4-4.2s5.3 1.6 6.4 4.2l30.2 68.2c2.2 5.1 3.4 10.5 3.4 16 0 21.9-18.1 39.6-40 39.6s-40-17.7-40-39.6c0-5.5 1.2-11 3.4-16l30.2-68.2zm152 0c1.1-2.5 3.6-4.2 6.4-4.2s5.3 1.6 6.4 4.2l30.2 68.2c2.2 5.1 3.4 10.5 3.4 16 0 21.9-18.1 39.6-40 39.6s-40-17.7-40-39.6c0-5.5 1.2-11 3.4-16l30.2-68.2zm121.8 68.2l30.2-68.2c1.1-2.5 3.6-4.2 6.4-4.2s5.3 1.6 6.4 4.2l30.2 68.2c2.2 5.1 3.4 10.5 3.4 16 0 21.9-18.1 39.6-40 39.6s-40-17.7-40-39.6c0-5.5 1.2-11 3.4-16z"
    ]
};
var $159afdcd077ecfe9$export$8d2b1b230601e804 = {
    prefix: 'fas',
    iconName: 'maximize',
    icon: [
        448,
        512,
        [
            "expand-arrows-alt"
        ],
        "f31e",
        "M168 32L24 32C10.7 32 0 42.7 0 56L0 200c0 9.7 5.8 18.5 14.8 22.2S34.1 223.8 41 217l40-40 79 79-79 79-40-40c-6.9-6.9-17.2-8.9-26.2-5.2S0 302.3 0 312L0 456c0 13.3 10.7 24 24 24l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-40-40 79-79 79 79-40 40c-6.9 6.9-8.9 17.2-5.2 26.2S270.3 480 280 480l144 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2l-40 40-79-79 79-79 40 40c6.9 6.9 17.2 8.9 26.2 5.2S448 209.7 448 200l0-144c0-13.3-10.7-24-24-24L280 32c-9.7 0-18.5 5.8-22.2 14.8S256.2 66.1 263 73l40 40-79 79-79-79 40-40c6.9-6.9 8.9-17.2 5.2-26.2S177.7 32 168 32z"
    ]
};
var $159afdcd077ecfe9$export$6219dcd88b5fa6c2 = $159afdcd077ecfe9$export$8d2b1b230601e804;
var $159afdcd077ecfe9$export$4ac9c4c370f7b157 = {
    prefix: 'fas',
    iconName: 'location-arrow',
    icon: [
        512,
        512,
        [],
        "f124",
        "M477.9 75.5c4.5-11.8 1.7-25.2-7.2-34.1s-22.3-11.8-34.1-7.2l-416 160C7.9 199-.3 211.2 0 224.7s9.1 25.4 21.9 29.6l176.8 58.9 58.9 176.8c4.3 12.8 16.1 21.6 29.6 21.9s25.7-7.9 30.6-20.5l160-416z"
    ]
};
var $159afdcd077ecfe9$export$a9947c2888b3c8fd = {
    prefix: 'fas',
    iconName: 'city',
    icon: [
        576,
        512,
        [
            127961
        ],
        "f64f",
        "M320 0c-35.3 0-64 28.7-64 64l0 32-48 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-64 0 0-72C96 10.7 85.3 0 72 0S48 10.7 48 24l0 74c-27.6 7.1-48 32.2-48 62L0 448c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-64 0 0-128c0-35.3-28.7-64-64-64L320 0zm64 112l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zm-16 80c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zm16 112l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zm112-16c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM256 304l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM240 192c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0zM128 304l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16zM112 192c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0z"
    ]
};
var $159afdcd077ecfe9$export$8cf137aceaaf4de0 = {
    prefix: 'fas',
    iconName: 'x-ray',
    icon: [
        512,
        512,
        [],
        "f497",
        "M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 320c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 96C14.3 96 0 81.7 0 64zm280 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 16-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 48-80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0 0 48-64 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l64 0 0 16c0 13.3 10.7 24 24 24s24-10.7 24-24l0-16 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-48 80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0 0-48 64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0 0-16z"
    ]
};
var $159afdcd077ecfe9$export$20932e4d438e4e4c = {
    prefix: 'fas',
    iconName: 'umbrella-beach',
    icon: [
        512,
        512,
        [
            127958
        ],
        "f5ca",
        "M497.5 341.1c-5.9 16.7-25.3 23-41.1 15.1l-178.2-89.1-1.6 3.2-88.8 177.7 292.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l84.2 0 103.2-206.3 1.6-3.2-165.4-82.7c-15.8-7.9-22.4-27.3-12.5-42 45.9-68.6 124.1-113.8 212.9-113.8 141.4 0 256 114.6 256 256 0 29.8-5.1 58.5-14.5 85.1z"
    ]
};
var $159afdcd077ecfe9$export$a02c5909359525be = {
    prefix: 'fas',
    iconName: 'arrow-right-to-bracket',
    icon: [
        512,
        512,
        [
            "sign-in"
        ],
        "f090",
        "M352 96l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm-9.4 182.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L242.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $159afdcd077ecfe9$export$a55eff0ca4f9c3df = $159afdcd077ecfe9$export$a02c5909359525be;
var $159afdcd077ecfe9$export$23b086400a31acfe = {
    prefix: 'fas',
    iconName: 'headset',
    icon: [
        448,
        512,
        [],
        "f590",
        "M224 64c-79 0-144.7 57.3-157.7 132.7 9.3-3 19.3-4.7 29.7-4.7l16 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-16 0c-53 0-96-43-96-96l0-64C0 100.3 100.3 0 224 0S448 100.3 448 224l0 168.1c0 66.3-53.8 120-120.1 120l-87.9-.1-32 0c-26.5 0-48-21.5-48-48s21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 0 40 0c39.8 0 72-32.2 72-72l0-20.9c-14.1 8.2-30.5 12.8-48 12.8l-16 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l16 0c10.4 0 20.3 1.6 29.7 4.7-13-75.3-78.6-132.7-157.7-132.7z"
    ]
};
var $159afdcd077ecfe9$export$d6f21e17ea797702 = {
    prefix: 'fas',
    iconName: 'splotch',
    icon: [
        512,
        512,
        [],
        "f5bc",
        "M208.5 62.3l28.1-36.9C248.8 9.4 267.8 0 288 0 316.5 0 341.6 18.7 349.8 46l17.8 59.4c10.3 34.4 36.1 62 69.8 74.6l39.8 14.9c20.9 7.9 34.8 27.9 34.8 50.2 0 16.9-7.9 32.8-21.5 42.9l-67.3 50.5c-24.3 18.2-37.2 47.9-33.8 78.1l2.5 22.7c4.3 38.7-26 72.6-65 72.6-14.8 0-29.3-5.1-40.9-14.3l-55.3-44.3c-4.5-3.6-9.3-6.7-14.5-9.2-15.8-7.9-33.7-10.4-51-7.3L82.4 451.9c-34.6 6.3-66.4-20.3-66.4-55.4 0-13.2 4.7-26 13.1-36.2l11.2-13.4c14.6-17.4 22.6-39.4 22.6-62.1 0-18.8-5.5-37.2-15.8-53L8.8 173.5C3.1 164.7 0 154.4 0 143.9 0 110.5 30.1 85.1 63 90.7l51.3 8.7c35.9 6.1 72.2-8.2 94.2-37.1z"
    ]
};
var $159afdcd077ecfe9$export$5608156cc81126e7 = {
    prefix: 'fas',
    iconName: 'up-long',
    icon: [
        320,
        512,
        [
            "long-arrow-alt-up"
        ],
        "f30c",
        "M137.4-22.6c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S300.9 160 288 160l-64 0 0 336c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-336-64 0c-12.9 0-24.6-7.8-29.6-19.8S.2 114.5 9.4 105.4l128-128z"
    ]
};
var $159afdcd077ecfe9$export$43c8f2a46326c55f = $159afdcd077ecfe9$export$5608156cc81126e7;
var $159afdcd077ecfe9$export$b75f0f1ba423de5f = {
    prefix: 'fas',
    iconName: 'hexagon-nodes',
    icon: [
        448,
        512,
        [],
        "e699",
        "M248 106.6c18.9-9 32-28.3 32-50.6c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 22.3 13.1 41.6 32 50.6l0 98.8c-2.8 1.3-5.5 2.9-8 4.7l-80.1-45.8c1.6-20.8-8.6-41.6-27.9-52.8C57.2 96 23 105.2 7.5 132S1.2 193 28 208.5c1.3 .8 2.6 1.5 4 2.1l0 90.8c-1.3 .6-2.7 1.3-4 2.1C1.2 319-8 353.2 7.5 380S57.2 416 84 400.5c19.3-11.1 29.4-32 27.8-52.8l50.5-28.9c-11.5-11.2-19.9-25.6-23.8-41.7L88 306.1c-2.6-1.8-5.2-3.3-8-4.7l0-90.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-.1 1.4-.2 2.8-.2 4.3c0 22.3 13.1 41.6 32 50.6l0 98.8c-18.9 9-32 28.3-32 50.6c0 30.9 25.1 56 56 56s56-25.1 56-56c0-22.3-13.1-41.6-32-50.6l0-98.8c2.8-1.3 5.5-2.9 8-4.7l80.1 45.8c-1.6 20.8 8.6 41.6 27.8 52.8c26.8 15.5 61 6.3 76.5-20.5s6.3-61-20.5-76.5c-1.3-.8-2.7-1.5-4-2.1l0-90.8c1.4-.6 2.7-1.3 4-2.1c26.8-15.5 36-49.7 20.5-76.5S390.8 96 364 111.5c-19.3 11.1-29.4 32-27.8 52.8l-50.6 28.9c11.5 11.2 19.9 25.6 23.8 41.7L360 205.9c2.6 1.8 5.2 3.3 8 4.7l0 90.8c-2.8 1.3-5.5 2.9-8 4.6l-80.1-45.8c.1-1.4 .2-2.8 .2-4.3c0-22.3-13.1-41.6-32-50.6l0-98.8z"
    ]
};
var $159afdcd077ecfe9$export$7a76c9d35b42d691 = {
    prefix: 'fas',
    iconName: 'hospital',
    icon: [
        576,
        512,
        [
            127973,
            62589,
            "hospital-alt",
            "hospital-wide"
        ],
        "f0f8",
        "M128 64c0-35.3 28.7-64 64-64L384 0c35.3 0 64 28.7 64 64l0 64 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l64 0 0-64zM272 352c-17.7 0-32 14.3-32 32l0 80 96 0 0-80c0-17.7-14.3-32-32-32l-32 0zM128 368l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM112 256c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zM512 368l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM496 256c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zM264 104l0 32-32 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16z"
    ]
};
var $159afdcd077ecfe9$export$cea7736417b94a3b = $159afdcd077ecfe9$export$7a76c9d35b42d691;
var $159afdcd077ecfe9$export$69c8cc0360f017e8 = $159afdcd077ecfe9$export$7a76c9d35b42d691;
var $159afdcd077ecfe9$export$dcd74f2821882a49 = {
    prefix: 'fas',
    iconName: 'person-harassing',
    icon: [
        576,
        512,
        [],
        "e549",
        "M192 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM59.4 304.5L88 256.9 88 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-244.7 47.4 57.1c11.3 13.6 31.5 15.5 45.1 4.2s15.5-31.5 4.2-45.1l-73.7-88.9c-18.2-22-45.3-34.7-73.9-34.7l-35.9 0c-33.7 0-64.9 17.7-82.3 46.6l-58.3 97c-9.1 15.1-4.2 34.8 10.9 43.9s34.8 4.2 43.9-10.9zM480 240a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM464 344l0 58.7-41.4-41.4c-7.3-7.3-17.6-10.6-27.8-9s-18.9 8.1-23.5 17.3l-48 96c-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l28.1-56.3 54.7 54.7c12.4 12.4 29.1 19.3 46.6 19.3 36.4 0 65.9-29.5 65.9-65.9L576 344c0-30.9-25.1-56-56-56s-56 25.1-56 56zM288 48c0 8.8 7.2 16 16 16l56 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-56 0c-8.8 0-16 7.2-16 16zm-.8 49.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c7.9 4 17.5 .7 21.5-7.2s.7-17.5-7.2-21.5l-48-24z"
    ]
};
var $159afdcd077ecfe9$export$18ab80cba7d5044f = {
    prefix: 'fas',
    iconName: 'money-bill-trend-up',
    icon: [
        512,
        512,
        [],
        "e529",
        "M480 8c0-13.3-10.7-24-24-24L354.2-16c-13.3 0-24 10.7-24 24s10.7 24 24 24l43.9 0-111.3 111.3-95.1-81.5c-9-7.7-22.2-7.7-31.2 0l-112 96c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l96.4-82.6 96.4 82.6c9.5 8.2 23.7 7.6 32.6-1.3l127-127 0 43.9c0 13.3 10.7 24 24 24s24-10.7 24-24L480 8zM48 256c-26.5 0-48 21.5-48 48L0 464c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L48 256zm47.3 56c-3.4 20.1-19.2 36-39.4 39.4-4.4 .7-8-2.9-8-7.3l0-32c0-4.4 3.6-8 8-8l32 0c4.4 0 8.1 3.6 7.3 8zm0 144.1c.7 4.4-2.9 8-7.3 8l-32 0c-4.4 0-8-3.6-8-8l0-32c0-4.4 3.6-8.1 8-7.3 20.1 3.4 36 19.2 39.4 39.4zM456 416.7c4.4-.7 8 2.9 8 7.3l0 32c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8.1-3.6-7.3-8 3.4-20.1 19.2-36 39.4-39.4zM416.7 312c-.7-4.4 2.9-8 7.3-8l32 0c4.4 0 8 3.6 8 8l0 32c0 4.4-3.6 8.1-8 7.3-20.1-3.4-36-19.2-39.4-39.4zM192 384a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $159afdcd077ecfe9$export$85ba06027671d290 = {
    prefix: 'fas',
    iconName: 'pen-ruler',
    icon: [
        512,
        512,
        [
            "pencil-ruler"
        ],
        "f5ae",
        "M404 0c19.2 0 37.6 7.6 51.1 21.2l35.7 35.7C504.4 70.4 512 88.8 512 108s-7.6 37.6-21.2 51.1L445.9 204 308 66.1 352.9 21.2C366.4 7.6 384.8 0 404 0zM58.9 315.1L274.1 100 412 237.9 196.9 453.1c-10.7 10.7-24.1 18.5-38.7 22.6L30.4 511.1c-8.3 2.3-17.3 0-23.4-6.2s-8.5-15.1-6.2-23.4L36.4 353.8c4.1-14.6 11.8-27.9 22.6-38.7zM225.4 80.8L80.8 225.4 11.7 156.3c-15.6-15.6-15.6-40.9 0-56.6l88-88c15.6-15.6 40.9-15.6 56.6 0l5.9 5.9-56.3 56.3c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0l56.3-56.3 34.9 34.9zM431.2 286.6l34.9 34.9-56.3 56.3c-7.8 7.8-7.8 20.5 0 28.3s20.5 7.8 28.3 0l56.3-56.3 5.9 5.9c15.6 15.6 15.6 40.9 0 56.6l-88 88c-15.6 15.6-40.9 15.6-56.6 0l-69.1-69.1 144.6-144.6z"
    ]
};
var $159afdcd077ecfe9$export$e3a7a1affea005f5 = $159afdcd077ecfe9$export$85ba06027671d290;
var $159afdcd077ecfe9$export$cb8434288c91ae83 = {
    prefix: 'fas',
    iconName: 'repeat',
    icon: [
        512,
        512,
        [
            128257
        ],
        "f363",
        "M470.6 118.6c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S352 19.1 352 32l0 32-160 0C86 64 0 150 0 256 0 273.7 14.3 288 32 288s32-14.3 32-32c0-70.7 57.3-128 128-128l160 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64zM41.4 393.4c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9S160 492.9 160 480l0-32 160 0c106 0 192-86 192-192 0-17.7-14.3-32-32-32s-32 14.3-32 32c0 70.7-57.3 128-128 128l-160 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64z"
    ]
};
var $159afdcd077ecfe9$export$5902c007d5703f2d = {
    prefix: 'fas',
    iconName: 'bone',
    icon: [
        640,
        512,
        [
            129460
        ],
        "f5d7",
        "M197.4 160c-3.9 0-7.2-2.8-8.1-6.6-10.2-42.1-48.1-73.4-93.3-73.4-53 0-96 43-96 96 0 29.1 12.9 55.1 33.3 72.7 4.3 3.7 4.3 10.8 0 14.5-20.4 17.6-33.3 43.7-33.3 72.7 0 53 43 96 96 96 45.2 0 83.1-31.3 93.3-73.4 .9-3.8 4.2-6.6 8.1-6.6l245.1 0c3.9 0 7.2 2.8 8.1 6.6 10.2 42.1 48.1 73.4 93.3 73.4 53 0 96-43 96-96 0-29.1-12.9-55.1-33.3-72.7-4.3-3.7-4.3-10.8 0-14.5 20.4-17.6 33.3-43.7 33.3-72.7 0-53-43-96-96-96-45.2 0-83.1 31.3-93.3 73.4-.9 3.8-4.2 6.6-8.1 6.6l-245.1 0z"
    ]
};
var $159afdcd077ecfe9$export$769724fc1434d618 = {
    prefix: 'fas',
    iconName: 'fire-flame-curved',
    icon: [
        384,
        512,
        [
            "fire-alt"
        ],
        "f7e4",
        "M153.6 29.9l16-21.3C173.6 3.2 180 0 186.7 0 198.4 0 208 9.6 208 21.3l0 22.1c0 13.1 5.4 25.7 14.9 34.7L307.6 159C356.4 205.6 384 270.2 384 337.7 384 434 306 512 209.7 512L192 512C86 512 0 426 0 320l0-3.8c0-48.8 19.4-95.6 53.9-130.1l3.5-3.5c4.2-4.2 10-6.6 16-6.6 12.5 0 22.6 10.1 22.6 22.6L96 288c0 35.3 28.7 64 64 64s64-28.7 64-64l0-3.9c0-18-7.2-35.3-19.9-48l-38.6-38.6c-24-24-37.5-56.7-37.5-90.7 0-27.7 9-54.8 25.6-76.9z"
    ]
};
var $159afdcd077ecfe9$export$70dc26b4926d0b1b = $159afdcd077ecfe9$export$769724fc1434d618;
var $159afdcd077ecfe9$export$d3724faf0c559353 = {
    prefix: 'fas',
    iconName: 'bus-simple',
    icon: [
        448,
        512,
        [
            "bus-alt"
        ],
        "f55e",
        "M96 0C43 0 0 43 0 96L0 384c0 29.8 20.4 54.9 48 62l0 34c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 192 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-34c27.6-7.1 48-32.2 48-62l0-288c0-53-43-96-96-96L96 0zM64 128c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L96 256c-17.7 0-32-14.3-32-32l0-96zM96 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$40616edfab6d332a = $159afdcd077ecfe9$export$d3724faf0c559353;
var $159afdcd077ecfe9$export$63f2d9e5f4689aa8 = {
    prefix: 'fas',
    iconName: 'venus-mars',
    icon: [
        640,
        512,
        [
            9892
        ],
        "f228",
        "M480-64c-17.7 0-32 14.3-32 32S462.3 0 480 0L530.7 0 474 56.7c-26.3-15.7-57.1-24.7-90-24.7-35.4 0-68.4 10.5-96 28.5-27.6-18-60.6-28.5-96-28.5-97.2 0-176 78.8-176 176 0 86.3 62.1 158.1 144 173.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9c23.3-4.3 44.9-13.1 64-25.6 27.6 18 60.6 28.5 96 28.5 97.2 0 176-78.8 176-176 0-41.1-14.1-79-37.8-109L576 45.3 576 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L480-64zM336 309.2c20.2-28.6 32-63.5 32-101.2s-11.8-72.6-32-101.2c14.6-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112S445.9 320 384 320c-17.2 0-33.5-3.9-48-10.8zM288 150.3c10.2 16.9 16 36.6 16 57.7s-5.8 40.9-16 57.7c-10.2-16.9-16-36.6-16-57.7s5.8-40.9 16-57.7zm-48-43.5c-20.2 28.6-32 63.5-32 101.2s11.8 72.6 32 101.2c-14.5 6.9-30.8 10.8-48 10.8-61.9 0-112-50.1-112-112S130.1 96 192 96c17.2 0 33.5 3.9 48 10.8z"
    ]
};
var $159afdcd077ecfe9$export$db34f7a6de38784f = {
    prefix: 'fas',
    iconName: 'blender',
    icon: [
        512,
        512,
        [],
        "f517",
        "M0 56C0 25.1 25.1 0 56 0L437.6 0c21.3 0 36.6 20.3 30.8 40.8L457.1 80 344 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l99.4 0-18.3 64-81.1 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l67.4 0-27.4 96-256 0-9.1-96-62.9 0c-30.9 0-56-25.1-56-56L0 56zM114.3 192L100.6 48 56 48c-4.4 0-8 3.6-8 8l0 128c0 4.4 3.6 8 8 8l58.3 0zM136 384l240 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-240 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm120 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$4f39e8dbaf09ea8b = {
    prefix: 'fas',
    iconName: 'u',
    icon: [
        384,
        512,
        [
            117
        ],
        "55",
        "M32 32c17.7 0 32 14.3 32 32l0 224c0 70.7 57.3 128 128 128s128-57.3 128-128l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32l0 224c0 106-86 192-192 192S0 394 0 288L0 64C0 46.3 14.3 32 32 32z"
    ]
};
var $159afdcd077ecfe9$export$c08b4b0e2b0dc027 = {
    prefix: 'fas',
    iconName: 'share',
    icon: [
        512,
        512,
        [
            "mail-forward"
        ],
        "f064",
        "M307.8 18.4c-12 5-19.8 16.6-19.8 29.6l0 80-112 0c-97.2 0-176 78.8-176 176 0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.8-22.2-26.4-22.2-56.7 0-53 43-96 96-96l96 0 0 80c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-9.2-9.2-22.9-11.9-34.9-6.9z"
    ]
};
var $159afdcd077ecfe9$export$81df7693d3f2f8da = $159afdcd077ecfe9$export$c08b4b0e2b0dc027;
var $159afdcd077ecfe9$export$d86c56ab43eb0deb = {
    prefix: 'fas',
    iconName: 'phone-flip',
    icon: [
        512,
        512,
        [
            128381,
            "phone-alt"
        ],
        "f879",
        "M351.8 25c7.8-18.8 28.4-28.9 48.1-23.5l5.5 1.5c64.6 17.6 119.8 80.2 103.7 156.4-37.1 175-174.8 312.7-349.8 349.8-76.3 16.2-138.8-39.1-156.4-103.7l-1.5-5.5c-5.4-19.7 4.7-40.3 23.5-48.1l97.3-40.5c16.5-6.9 35.6-2.1 47 11.8l38.6 47.2c70.3-34.9 126.8-93.3 159.3-164.9l-44.1-36.1c-13.9-11.3-18.6-30.4-11.8-47L351.8 25z"
    ]
};
var $159afdcd077ecfe9$export$a07a9b305deebf32 = $159afdcd077ecfe9$export$d86c56ab43eb0deb;
var $159afdcd077ecfe9$export$a3a5de5f6e2513ba = {
    prefix: 'fas',
    iconName: 'toilet-portable',
    icon: [
        320,
        512,
        [],
        "e583",
        "M0 64l0 16 320 0 0-16c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64zm24 64L0 128 0 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 224 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-360-296 0zm224 96l24 0 0 96-24 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$e7b4c26b5857fe9c = {
    prefix: 'fas',
    iconName: 'person-pregnant',
    icon: [
        384,
        512,
        [],
        "e31e",
        "M192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm80 321.2c8.6-4.5 16.8-10 24.3-16.5l4-3.4c22.6-19.4 35.7-47.7 35.7-77.6 0-35.9-18.8-69.1-49.6-87.6l-30.4-18.2 0-1.8c0-46.5-37.7-84.1-84.1-84.1-28.1 0-54.4 14.1-70 37.5L21.4 270.2c-9.8 14.7-5.8 34.6 8.9 44.4s34.6 5.8 44.4-8.9l29-43.5-30.5 113.5c-2.6 9.6-.6 19.9 5.5 27.8S94 416 104 416l8 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 32 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-110.8z"
    ]
};
var $159afdcd077ecfe9$export$7f24f1bf98af5411 = {
    prefix: 'fas',
    iconName: 'less-than',
    icon: [
        512,
        512,
        [
            62774
        ],
        "3c",
        "M477.1 50.6c7.4 16 .4 35.1-15.6 42.5L108.4 256 461.4 419c16 7.4 23 26.4 15.6 42.5s-26.4 23-42.5 15.6l-416-192C7.3 279.8 0 268.5 0 256S7.3 232.2 18.6 227l416-192c16-7.4 35.1-.4 42.5 15.6z"
    ]
};
var $159afdcd077ecfe9$export$4fa56a54e822dd25 = {
    prefix: 'fas',
    iconName: 'superscript',
    icon: [
        576,
        512,
        [],
        "f12b",
        "M544 32c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16C449.9 27.3 443.5 46.5 451.4 62.3 457 73.5 468.3 80 480 80l0 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-128zM96 64C78.3 64 64 78.3 64 96s14.3 32 32 32l15.3 0 89.6 128-89.6 128-15.3 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c10.4 0 20.2-5.1 26.2-13.6L240 311.8 325.8 434.4c6 8.6 15.8 13.6 26.2 13.6l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-15.3 0-89.6-128 89.6-128 15.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-10.4 0-20.2 5.1-26.2 13.6L240 200.2 154.2 77.6C148.2 69.1 138.4 64 128 64L96 64z"
    ]
};
var $159afdcd077ecfe9$export$229de76dfef2687f = {
    prefix: 'fas',
    iconName: 'circle-stop',
    icon: [
        512,
        512,
        [
            62094,
            "stop-circle"
        ],
        "f28d",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 160l128 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$47af2aad60ab3e7c = $159afdcd077ecfe9$export$229de76dfef2687f;
var $159afdcd077ecfe9$export$64185f27d82c259f = {
    prefix: 'fas',
    iconName: 'arrows-up-down',
    icon: [
        256,
        512,
        [
            "arrows-v"
        ],
        "f07d",
        "M150.6-22.6c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 77.3 96 434.7 54.6 393.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-41.4 41.4 0-357.5 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var $159afdcd077ecfe9$export$cec5f1bc9e068e48 = $159afdcd077ecfe9$export$64185f27d82c259f;
var $159afdcd077ecfe9$export$48a38da471b097a2 = {
    prefix: 'fas',
    iconName: 'poo-storm',
    icon: [
        512,
        512,
        [
            "poo-bolt"
        ],
        "f75a",
        "M268.9-31.8c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.3c2.8 8.2 4.3 16.9 4.3 26.1 0 21.7-8.5 37.2-21.9 47.6-13.9 10.8-34.1 17-58.1 17l-24 0c-48.6 0-88 39.4-88 88 0 14.8 3.7 28.8 10.2 41.1-42 6.6-74.2 43-74.2 86.9 0 46.6 36.2 84.7 81.9 87.8 3.1-12.4 9.9-23.8 19.6-32.5L242.7 225c12.2-10.9 28-17 44.4-17 44.6 0 76.5 43 63.7 85.7l-12.7 42.4c28.8 1.2 52.7 21.1 59.8 47.9l26.2 0c48.6 0 88-39.4 88-88 0-43.9-32.1-80.3-74.2-86.9 6.5-12.3 10.2-26.2 10.2-41.1 0-48.6-39.4-88-88-88l-9.4 0c.9-5.4 1.4-10.9 1.4-16.6 0-48.7-36.1-88.9-83.1-95.2zM144.6 416l61.8 0-31.2 104.1c-3.6 11.9 5.3 23.9 17.8 23.9 4.6 0 9-1.7 12.4-4.7L346.5 412.9c3.5-3.1 5.5-7.6 5.5-12.4 0-9.2-7.4-16.6-16.6-16.6l-61.8 0 31.2-104.1c3.6-11.9-5.3-23.9-17.8-23.9-4.6 0-9 1.7-12.4 4.7L133.5 387.1c-3.5 3.1-5.5 7.6-5.5 12.4 0 9.2 7.4 16.6 16.6 16.6z"
    ]
};
var $159afdcd077ecfe9$export$9a24e77f74d9cbd9 = $159afdcd077ecfe9$export$48a38da471b097a2;
var $159afdcd077ecfe9$export$a714fc79f58cc9ef = {
    prefix: 'fas',
    iconName: 'video-slash',
    icon: [
        576,
        512,
        [],
        "f4e2",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-153-153 0-222.2c0-35.3-28.7-64-64-64L129.8 64 41-24.9zM32 128l0 256c0 35.3 28.7 64 64 64l256 0c7.8 0 15.3-1.4 22.2-4L36 105.8c-2.6 6.9-4 14.4-4 22.2zM464 336l73.5 58.8c4.2 3.4 9.4 5.2 14.8 5.2 13.1 0 23.7-10.6 23.7-23.7l0-240.6c0-13.1-10.6-23.7-23.7-23.7-5.4 0-10.6 1.8-14.8 5.2L464 176 464 336z"
    ]
};
var $159afdcd077ecfe9$export$5a17e58bb7afb1d7 = {
    prefix: 'fas',
    iconName: 'square-xmark',
    icon: [
        448,
        512,
        [
            10062,
            "times-square",
            "xmark-square"
        ],
        "f2d3",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm71 135c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$c0248ac97142ea2a = $159afdcd077ecfe9$export$5a17e58bb7afb1d7;
var $159afdcd077ecfe9$export$9a364781d6b7602b = $159afdcd077ecfe9$export$5a17e58bb7afb1d7;
var $159afdcd077ecfe9$export$b9c3f9a906f96b82 = {
    prefix: 'fas',
    iconName: 'hand-holding-droplet',
    icon: [
        576,
        512,
        [
            "hand-holding-water"
        ],
        "f4c1",
        "M275.5 6.6L209.2 103C198 119.3 192 138.6 192 158.3l0 1.7c0 53 43 96 96 96s96-43 96-96l0-1.7c0-19.8-6-39-17.2-55.3L300.5 6.6C297.7 2.5 293 0 288 0s-9.7 2.5-12.5 6.6zM109.3 341.5L66.7 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 280 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z"
    ]
};
var $159afdcd077ecfe9$export$4265371b99d38b95 = $159afdcd077ecfe9$export$b9c3f9a906f96b82;
var $159afdcd077ecfe9$export$51790ddd26e431bc = {
    prefix: 'fas',
    iconName: 'won-sign',
    icon: [
        512,
        512,
        [
            8361,
            "krw",
            "won"
        ],
        "f159",
        "M62.4 53.9C56.8 37.1 38.7 28.1 21.9 33.6S-3.9 57.4 1.7 74.1L56.9 240 32 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l40.9 0 56.7 170.1c4.5 13.5 17.4 22.4 31.6 21.9s26.4-10.4 29.8-24.2L233 288 279 288 321 455.8c3.4 13.8 15.6 23.7 29.8 24.2s27.1-8.4 31.6-21.9L439.1 288 480 288c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24.9 0 55.3-165.9c5.6-16.8-3.5-34.9-20.2-40.5s-34.9 3.5-40.5 20.2l-62 186.1-54.6 0-45.9-183.8C283.5 42 270.7 32 256 32s-27.5 10-31 24.2L179 240 124.4 240 62.4 53.9zm78 234.1l26.6 0-11.4 45.6-15.2-45.6zM245 240l11-44.1 11 44.1-22 0zm100 48l26.6 0-15.2 45.6-11.4-45.6z"
    ]
};
var $159afdcd077ecfe9$export$2f65e07a45b95b50 = $159afdcd077ecfe9$export$51790ddd26e431bc;
var $159afdcd077ecfe9$export$5a1fd3ed9564d7fa = $159afdcd077ecfe9$export$51790ddd26e431bc;
var $159afdcd077ecfe9$export$887f6345573abcac = {
    prefix: 'fas',
    iconName: 'object-ungroup',
    icon: [
        640,
        512,
        [],
        "f248",
        "M32 119.4C12.9 108.4 0 87.7 0 64 0 28.7 28.7 0 64 0 87.7 0 108.4 12.9 119.4 32l209.1 0c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4l0 113.1c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32l-209.1 0c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4l0-113.1zM119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4l0 113.1c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-113.1c-9.7-5.6-17.8-13.7-23.4-23.4L119.4 96zM544 279.4c-9.7-5.6-17.8-13.7-23.4-23.4l-29.2 0c-5.3-17.7-14.8-33.5-27.4-46.4l0-17.6 56.6 0c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4l0 113.1c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32l-209.1 0c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4l0-24.6 64 0 0 24.6c9.7 5.6 17.8 13.7 23.4 23.4l209.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-113.1z"
    ]
};
var $159afdcd077ecfe9$export$805cd88398a70581 = {
    prefix: 'fas',
    iconName: 'comment',
    icon: [
        512,
        512,
        [
            128489,
            61669
        ],
        "f075",
        "M512 240c0 132.5-114.6 240-256 240-37.1 0-72.3-7.4-104.1-20.7L33.5 510.1c-9.4 4-20.2 1.7-27.1-5.8S-2 485.8 2.8 476.8l48.8-92.2C19.2 344.3 0 294.3 0 240 0 107.5 114.6 0 256 0S512 107.5 512 240z"
    ]
};
var $159afdcd077ecfe9$export$50d11c98c99e3b2d = {
    prefix: 'fas',
    iconName: 'hill-avalanche',
    icon: [
        576,
        512,
        [],
        "e507",
        "M440.1 401.9c34.2 23.1 81.1 19.5 111.4-10.8 34.4-34.4 34.4-90.1 0-124.5-27.8-27.8-69.5-33.1-102.6-16-11.8 6.1-16.4 20.6-10.3 32.3s20.6 16.4 32.3 10.3c15.1-7.8 34-5.3 46.6 7.3 15.6 15.6 15.6 40.9 0 56.6s-40.9 15.6-56.6 0l-81.7-81.7c22.3-14.2 37.1-39.1 37.1-67.5 0-33.9-21.1-62.9-50.9-74.5 1.9-6.8 2.9-14 2.9-21.5 0-44.2-35.8-80-80-80-27.3 0-51.5 13.7-65.9 34.6-5.8-20-24.2-34.6-46.1-34.6-26.5 0-48 21.5-48 48 0 4 .5 7.9 1.4 11.6L440.1 401.9zM480.4 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM68.7 87C43.5 61.8 .4 79.7 .4 115.3L.4 432c0 44.2 35.8 80 80 80l316.7 0c35.6 0 53.5-43.1 28.3-68.3L68.7 87z"
    ]
};
var $159afdcd077ecfe9$export$9adae865350879af = {
    prefix: 'fas',
    iconName: 'arrows-to-eye',
    icon: [
        640,
        512,
        [],
        "e4bf",
        "M176 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 38.1-63-63c-9.4-9.4-24.6-9.4-33.9 0S21.7 55.6 31 65l63 63-38.1 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l96 0c13.3 0 24-10.7 24-24l0-96zm0 400l0-96c0-13.3-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l38.1 0-63 63c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l63-63 0 38.1c0 13.3 10.7 24 24 24s24-10.7 24-24zm312 24c13.3 0 24-10.7 24-24l0-38.1 63 63c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-63-63 38.1 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-96 0c-13.3 0-24 10.7-24 24l0 96c0 13.3 10.7 24 24 24zM464 56l0 96c0 13.3 10.7 24 24 24l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-38.1 0 63-63c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-63 63 0-38.1c0-13.3-10.7-24-24-24s-24 10.7-24 24zM320 120c-57.3 0-99.4 34-125.6 64.3-20 23.1-32.4 45.8-37.6 56.1-2.5 5-4.9 9.7-4.9 15.6s2.3 10.6 4.9 15.6c5.2 10.3 17.6 33 37.6 56.1 26.2 30.3 68.2 64.3 125.6 64.3s99.4-34 125.6-64.3c20-23.1 32.4-45.8 37.6-56.1 2.5-5 4.9-9.7 4.9-15.6s-2.3-10.6-4.9-15.6c-5.2-10.3-17.6-33-37.6-56.1-26.2-30.3-68.2-64.3-125.6-64.3zM256 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $159afdcd077ecfe9$export$695fae58f55c3a87 = {
    prefix: 'fas',
    iconName: 'snowplow',
    icon: [
        640,
        512,
        [],
        "f7d2",
        "M128 160l0-96c0-35.3 28.7-64 64-64L296.4 0c24.2 0 46.4 13.7 57.2 35.4l87.6 175.1c4.4 8.9 6.8 18.7 6.8 28.6l0 56.9 80 0 0-80c0-48.6 39.4-88 88-88 13.3 0 24 10.7 24 24s-10.7 24-24 24c-22.1 0-40 17.9-40 40l0 208c0 22.1 17.9 40 40 40 13.3 0 24 10.7 24 24s-10.7 24-24 24c-48.6 0-88-39.4-88-88l0-80-63 0c9.5 16.5 15 35.6 15 56 0 61.9-50.1 112-112 112l-224 0c-61.9 0-112-50.1-112-112 0-30.5 12.2-58.2 32-78.4L64 224c0-35.3 28.7-64 64-64zm91.7 34.9l43.6 29.1 113.2 0-80-160-104.4 0 0 108.8 27.7 22.1zM416 400c0-26.5-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l224 0c26.5 0 48-21.5 48-48zm-280 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM232 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$dce43b02b3fe0c18 = {
    prefix: 'fas',
    iconName: 'chart-gantt',
    icon: [
        512,
        512,
        [],
        "e0e4",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zm64 112c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0zM384 288c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0z"
    ]
};
var $159afdcd077ecfe9$export$5c6bd8729527871b = {
    prefix: 'fas',
    iconName: 'video',
    icon: [
        576,
        512,
        [
            "video-camera"
        ],
        "f03d",
        "M96 64c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L96 64zM464 336l73.5 58.8c4.2 3.4 9.4 5.2 14.8 5.2 13.1 0 23.7-10.6 23.7-23.7l0-240.6c0-13.1-10.6-23.7-23.7-23.7-5.4 0-10.6 1.8-14.8 5.2L464 176 464 336z"
    ]
};
var $159afdcd077ecfe9$export$3a530df752193ccf = $159afdcd077ecfe9$export$5c6bd8729527871b;
var $159afdcd077ecfe9$export$3db75d5ac9e98468 = {
    prefix: 'fas',
    iconName: 'chess-pawn',
    icon: [
        384,
        512,
        [
            9823
        ],
        "f443",
        "M192-32c66.3 0 120 53.7 120 120 0 27-8.9 51.9-24 72 17.7 0 32 14.3 32 32s-14.3 32-32 32l-10.7 0 26.7 160 56.2 70.3c5 6.3 7.8 14.1 7.8 22.2 0 19.6-15.9 35.5-35.5 35.5L51.5 512c-19.6 0-35.5-15.9-35.5-35.5 0-8.1 2.7-15.9 7.8-22.2L80 384 106.7 224 96 224c-17.7 0-32-14.3-32-32s14.3-32 32-32c-15.1-20.1-24-45-24-72 0-66.3 53.7-120 120-120z"
    ]
};
var $159afdcd077ecfe9$export$20d991385719b5b4 = {
    prefix: 'fas',
    iconName: 'synagogue',
    icon: [
        576,
        512,
        [
            128333
        ],
        "f69b",
        "M16 80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32-128 0 0-32zm0 368l0-288 128 0 126.2-84.2c10.7-7.2 24.8-7.2 35.5 0l126.2 84.2 128 0 0 288c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64zM560 112l-128 0 0-32c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32zM224 384l0 80 128 0 0-80c0-35.3-28.7-64-64-64s-64 28.7-64 64zm64-152a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $159afdcd077ecfe9$export$5559de5f969b9590 = {
    prefix: 'fas',
    iconName: 'building-circle-check',
    icon: [
        576,
        512,
        [],
        "e4d2",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-10.5-14.6-19-30.7-25.1-48l-74.9 0 0-80c0-17.7 14.3-32 32-32l32 0c2 0 4 .2 5.9 .5 6-23.6 16.3-45.4 30.1-64.5l-4 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 4c27.5-19.8 60.3-32.4 96-35.4L416 64c0-35.3-28.7-64-64-64L96 0zm32 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-86.6-60.9c7.1 5.2 8.7 15.2 3.5 22.3l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5z"
    ]
};
var $159afdcd077ecfe9$export$16768a660ae3ca9d = {
    prefix: 'fas',
    iconName: 'calendar-plus',
    icon: [
        448,
        512,
        [],
        "f271",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zm96 192c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$1482162f7fe04ac = {
    prefix: 'fas',
    iconName: 'wheelchair-move',
    icon: [
        448,
        512,
        [
            "wheelchair-alt"
        ],
        "e2ce",
        "M312 56a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM205.4 124.1c-6.4-5.2-15.6-4.7-21.4 1.1l-33.4 33.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L138.8 80c29-29 75.2-31.4 107-5.5l81.3 66c21.4 17.4 23.8 49.2 5.2 69.5l-41.8 46 98 0c30.3 0 53 27.7 47.1 57.4L407.4 454.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L369 320 316.8 320c2.1 10.3 3.2 21 3.2 32 0 88.4-71.6 160-160 160S0 440.4 0 352 71.6 192 160 192c6 0 11.9 .3 17.8 1l50.4-50.4-22.7-18.5zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
    ]
};
var $159afdcd077ecfe9$export$7db9460785019040 = $159afdcd077ecfe9$export$1482162f7fe04ac;
var $159afdcd077ecfe9$export$d1886bc596424e6c = {
    prefix: 'fas',
    iconName: 'user-shield',
    icon: [
        576,
        512,
        [],
        "f505",
        "M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm-29.7 56C95.8 304 16 383.8 16 482.3 16 498.7 29.3 512 45.7 512l251.5 0C261 469.4 240 414.5 240 356.4l0-31.1c0-7.3 1-14.5 2.9-21.3l-48.6 0zm251 184.5l-13.3 6.3 0-188.1 96 32 0 19.6c0 55.8-32.2 106.5-82.7 130.3zM421.9 259.5l-112 37.3c-13.1 4.4-21.9 16.6-21.9 30.4l0 31.1c0 74.4 43 142.1 110.2 173.7l18.5 8.7c4.8 2.2 10 3.4 15.2 3.4s10.5-1.2 15.2-3.4l18.5-8.7C533 500.3 576 432.6 576 358.2l0-31.1c0-13.8-8.8-26-21.9-30.4l-112-37.3c-6.6-2.2-13.7-2.2-20.2 0z"
    ]
};
var $159afdcd077ecfe9$export$7e0c7fd2a2e88823 = {
    prefix: 'fas',
    iconName: 'bold',
    icon: [
        384,
        512,
        [],
        "f032",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l32 0 0 320-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0c70.7 0 128-57.3 128-128 0-46.5-24.8-87.3-62-109.7 18.7-22.3 30-51 30-82.3 0-70.7-57.3-128-128-128L32 32zM288 160c0 35.3-28.7 64-64 64l-96 0 0-128 96 0c35.3 0 64 28.7 64 64zM128 416l0-128 128 0c35.3 0 64 28.7 64 64s-28.7 64-64 64l-128 0z"
    ]
};
var $159afdcd077ecfe9$export$a6d8e50dcd4b4294 = {
    prefix: 'fas',
    iconName: 'heart-pulse',
    icon: [
        512,
        512,
        [
            "heartbeat"
        ],
        "f21e",
        "M256 107.9L241 87.1C216 52.5 175.9 32 133.1 32 59.6 32 0 91.6 0 165.1l0 2.6c0 23.6 6.2 48 16.6 72.3l106 0c3.2 0 6.1-1.9 7.4-4.9l31.8-76.3c3.7-8.8 12.3-14.6 21.8-14.8s18.3 5.4 22.2 14.1l51.3 113.9 41.4-82.8c4.1-8.1 12.4-13.3 21.5-13.3s17.4 5.1 21.5 13.3l23.2 46.3c1.4 2.7 4.1 4.4 7.2 4.4l123.6 0c10.5-24.3 16.6-48.7 16.6-72.3l0-2.6C512 91.6 452.4 32 378.9 32 336.2 32 296 52.5 271 87.1l-15 20.7zM469.6 288l-97.8 0c-21.2 0-40.6-12-50.1-31l-1.7-3.4-42.5 85.1c-4.1 8.3-12.7 13.5-22 13.3s-17.6-5.7-21.4-14.1l-49.3-109.5-10.5 25.2c-8.7 20.9-29.1 34.5-51.7 34.5l-80.2 0c47.2 73.8 123 141.7 170.4 177.9 12.4 9.4 27.6 14.1 43.1 14.1s30.8-4.6 43.1-14.1C346.6 429.7 422.4 361.8 469.6 288z"
    ]
};
var $159afdcd077ecfe9$export$ca880e19206e80aa = $159afdcd077ecfe9$export$a6d8e50dcd4b4294;
var $159afdcd077ecfe9$export$60b44cfa7af18422 = {
    prefix: 'fas',
    iconName: 'square-root-variable',
    icon: [
        576,
        512,
        [
            "square-root-alt"
        ],
        "f698",
        "M282.6 78.1c8-27.3 33-46.1 61.4-46.1l200 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L344 96 238.7 457c-3.6 12.3-14.1 21.2-26.8 22.8s-25.1-4.6-31.5-15.6L77.6 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l45.6 0c22.8 0 43.8 12.1 55.3 31.8l65.2 111.8 84.4-289.5zM393.4 233.4c12.5-12.5 32.8-12.5 45.3 0l41.4 41.4 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-41.4 41.4 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-41.4-41.4-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l41.4-41.4-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $159afdcd077ecfe9$export$28e4b96627e00057 = $159afdcd077ecfe9$export$60b44cfa7af18422;
var $159afdcd077ecfe9$export$2f78563e14e49916 = {
    prefix: 'fas',
    iconName: 'hands-bubbles',
    icon: [
        512,
        512,
        [
            "hands-wash"
        ],
        "e05e",
        "M384 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM128 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM0 160l.1 72.6c0 44.8 17.6 87.1 47.9 118.4 .3-77 40.1-148.4 105.4-189.3l1.9-1.2c-2.5-3.7-2.8-8.6-.4-12.7l62-107.4c6.6-11.5 2.7-26.2-8.8-32.8S182 5 175.4 16.5l-68 117.8 0 0 0 0-43.3 75 0-49.3c0-17.7-14.4-32-32-32S0 142.4 0 160zm213.6-35.9c14.1-8.8 29.8-12.7 45.2-12.1l36.5-63.3c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8l-67.1 116.2 27-16.9zm86.5-35.7l-16.4 28.4c15.1 5.5 28.6 15.6 38.3 29.7l19.7-34.2c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zm46.4 63.7l-12.5 21.7c2 8.6 2.5 17.5 1.7 26.1l4.3 0 0 0 34.4 0 13.7-23.8c6.6-11.5 2.7-26.2-8.8-32.8s-26.2-2.7-32.8 8.8zM283.1 175c-9.4-15-29.1-19.5-44.1-10.2l-60.2 37.6C127.3 234.7 96 291.2 96 352l0 8c0 8.9 .8 17.6 2.2 26.1 35.4 8.2 61.8 40 61.8 77.9 0 6.3-.7 12.5-2.1 18.4 25.2 18.6 56.4 29.6 90.1 29.6l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-92 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l124 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-124 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l156 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-156 0c-6.6 0-12-5.4-12-12s5.4-12 12-12l124 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-136 0 0 0 0 0-93.2 0 46.2-28.9c15-9.4 19.5-29.1 10.2-44.1z"
    ]
};
var $159afdcd077ecfe9$export$996b5dea53b124e3 = $159afdcd077ecfe9$export$2f78563e14e49916;
var $159afdcd077ecfe9$export$e6789173649caa25 = {
    prefix: 'fas',
    iconName: 'marker',
    icon: [
        512,
        512,
        [],
        "f5a1",
        "M408.8 0c-27.4 0-53.6 10.9-73 30.2L318.1 48 305 34.9c-28.1-28.1-73.7-28.1-101.8 0L103 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L237.1 68.9c9.4-9.4 24.6-9.4 33.9 0L284.1 81.9 184 182.1 329.9 328 481.8 176.2c19.4-19.4 30.2-45.6 30.2-73 0-57-46.2-103.2-103.2-103.2zM102.4 263.7c-49.9 49.9-83.3 114-95.5 183.5L.4 483.8C-1 491.6 1.5 499.4 7 505s13.4 8 21.1 6.7l36.7-6.5c69.5-12.3 133.6-45.6 183.5-95.5L296 361.9 150.1 216 102.4 263.7z"
    ]
};
var $159afdcd077ecfe9$export$97d84347d71ba297 = {
    prefix: 'fas',
    iconName: 'clipboard',
    icon: [
        384,
        512,
        [
            128203
        ],
        "f328",
        "M320 32l-8.6 0C300.4 12.9 279.7 0 256 0L128 0C104.3 0 83.6 12.9 72.6 32L64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-352c0-35.3-28.7-64-64-64zM136 112c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0z"
    ]
};
var $159afdcd077ecfe9$export$c5a9302c8c13c79a = {
    prefix: 'fas',
    iconName: 'place-of-worship',
    icon: [
        512,
        512,
        [],
        "f67f",
        "M160 79l0 81-44.8 33.6C103.1 202.7 96 216.9 96 232l0 40-60.6 30.3C13.7 313.2 0 335.3 0 359.6L0 448c0 35.3 28.7 64 64 64 74.7 0 85.4 0 320 0l64 0c35.3 0 64-28.7 64-64l0-88.4c0-24.2-13.7-46.4-35.4-57.2L416 272 416 232c0-15.1-7.1-29.3-19.2-38.4L352 160 352 79c0-9.5-4.2-18.5-11.5-24.6L271.4-3.2c-8.9-7.4-21.8-7.4-30.7 0L171.5 54.4C164.2 60.5 160 69.5 160 79zm96 241c35.3 0 64 28.7 64 64l0 80-128 0 0-80c0-35.3 28.7-64 64-64z"
    ]
};
var $159afdcd077ecfe9$export$8ec2f752344b69bd = {
    prefix: 'fas',
    iconName: 'cannabis',
    icon: [
        512,
        512,
        [],
        "f55f",
        "M256 0c5.3 0 10.3 2.7 13.3 7.1 15.8 23.5 36.7 63.7 49.2 109 7.3 26.4 11.8 55.3 10.3 84 11.6-8.9 23.7-16.7 35.9-23.7 41-23.3 84.4-36.9 112.2-42.5 5.2-1 10.7 .6 14.4 4.4s5.4 9.2 4.4 14.5c-5.6 27.7-19.3 70.9-42.7 111.7-9.1 15.9-19.9 31.7-32.5 46.3 27.9 6.6 52.5 17.2 67.3 25.4 5.1 2.8 8.2 8.2 8.2 14s-3.2 11.2-8.2 14c-15.2 8.4-40.9 19.5-69.8 26.1-20.2 4.6-42.9 7.2-65.2 4.6l8.3 33.2c1.5 6.1-.6 12.5-5.5 16.4s-11.6 4.6-17.2 1.8L280 417.2 280 488c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-70.8-58.5 29.1c-5.6 2.8-12.3 2.1-17.2-1.8s-7-10.3-5.5-16.4l8.3-33.2c-22.2 2.6-45 0-65.2-4.6-28.9-6.6-54.5-17.6-69.8-26.1-5.1-2.8-8.2-8.2-8.2-14s3.2-11.2 8.2-14l6.2-3.3c15-7.6 36.8-16.4 61.1-22.2-12.5-14.5-23.3-30.4-32.4-46.2-23.4-40.8-37.1-84-42.7-111.7-1.1-5.2 .6-10.7 4.4-14.5s9.2-5.4 14.4-4.4c27.9 5.5 71.2 19.2 112.2 42.5 12.2 6.9 24.3 14.8 35.8 23.7-1.4-28.7 3.1-57.6 10.3-84 12.5-45.3 33.4-85.5 49.2-109l1.2-1.6C246.9 2 251.3 0 256 0z"
    ]
};
var $159afdcd077ecfe9$export$b96e695bdcf3f3f5 = {
    prefix: 'fas',
    iconName: 'people-roof',
    icon: [
        576,
        512,
        [],
        "e537",
        "M302.3-12.6c-9-4.5-19.6-4.5-28.6 0l-256 128C1.9 123.3-4.5 142.5 3.4 158.3s27.1 22.2 42.9 14.3L288 51.8 529.7 172.6c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-256-128zM288 272a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c-53 0-96 43-96 96l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-53-43-96-96-96zM160 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm352 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 336c-44.2 0-80 35.8-80 80l0 33.1c0 17 13.8 30.9 30.9 30.9l87.8 0c-4.3-9.8-6.7-20.6-6.7-32l0-48c0-18.4 3.5-36 9.8-52.2-12.2-7.5-26.5-11.8-41.8-11.8zM425.4 480l87.8 0c17 0 30.9-13.8 30.9-30.9l0-33.1c0-44.2-35.8-80-80-80-15.3 0-29.6 4.3-41.8 11.8 6.3 16.2 9.8 33.8 9.8 52.2l0 48c0 11.4-2.4 22.2-6.7 32z"
    ]
};
var $159afdcd077ecfe9$export$c7675a37487adc45 = {
    prefix: 'fas',
    iconName: 'disease',
    icon: [
        512,
        512,
        [],
        "f7fa",
        "M236.5 29.4L224 48c-20 30-53.6 48-89.7 48L68 96c-37.5 0-67.9 30.4-67.9 67.9 0 18 7.2 35.2 19.9 47.9l27 27c11 11 17.2 25.9 17.2 41.5 0 15.8-6.4 30.9-17.7 42L33.4 335.1c-11.1 10.8-17.3 25.7-17.3 41.2 0 36.8 34.1 64.2 70.1 56.2l62.3-13.8c7.7-1.7 15.7-2.6 23.6-2.6 32.8 0 64.2 14.6 85.2 39.8l30.5 36.6c10.4 12.4 25.7 19.6 41.9 19.6 30.1 0 54.5-24.4 54.5-54.5l0-51.2c0-41.4 25.4-78.5 64-93.5l22.2-8.6c25.2-9.8 41.8-34.1 41.8-61.1 0-26.4-15.9-50.3-40.3-60.5L429 164.8c-33.2-13.9-57.6-43-65.5-78.1l-7.9-35.2c-6.8-30.1-33.5-51.5-64.3-51.5-22 0-42.6 11-54.8 29.4zM160 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$df8194b081d34b27 = {
    prefix: 'fas',
    iconName: 'book-bible',
    icon: [
        448,
        512,
        [
            "bible"
        ],
        "f647",
        "M96 512c-53 0-96-43-96-96L0 96C0 43 43 0 96 0L400 0c26.5 0 48 21.5 48 48l0 288c0 20.9-13.4 38.7-32 45.3l0 66.7c17.7 0 32 14.3 32 32s-14.3 32-32 32L96 512zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0 0-64-256 0zM192 80l0 48-48 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l48 0 0 112c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-112 48 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-48 0 0-48c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
var $159afdcd077ecfe9$export$2eac809b0670d139 = $159afdcd077ecfe9$export$df8194b081d34b27;
var $159afdcd077ecfe9$export$bd301515df6246af = {
    prefix: 'fas',
    iconName: 'chess-board',
    icon: [
        448,
        512,
        [],
        "f43c",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 64l0 64 64 0 0-64 64 0 0 64 64 0 0-64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64-64 0 0 64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0zm64 128l64 0 0-64-64 0 0 64zm0 64l0-64-64 0 0 64 64 0zm64 0l-64 0 0 64 64 0 0-64zm0 0l64 0 0-64-64 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$a9f5c0b9c1e77a6f = {
    prefix: 'fas',
    iconName: 'mars',
    icon: [
        512,
        512,
        [
            9794
        ],
        "f222",
        "M320 32c0-17.7 14.3-32 32-32L480 0c17.7 0 32 14.3 32 32l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-50.7-95 95c19.5 28.4 31 62.7 31 99.8 0 97.2-78.8 176-176 176S32 401.2 32 304 110.8 128 208 128c37 0 71.4 11.4 99.8 31l95-95-50.7 0c-17.7 0-32-14.3-32-32zM208 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
    ]
};
var $159afdcd077ecfe9$export$c2dee3bd177275a2 = {
    prefix: 'fas',
    iconName: 'laptop',
    icon: [
        640,
        512,
        [
            128187
        ],
        "f109",
        "M128 32C92.7 32 64 60.7 64 96l0 240 64 0 0-240 384 0 0 240 64 0 0-240c0-35.3-28.7-64-64-64L128 32zM19.2 384C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480l486.4 0c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2L19.2 384z"
    ]
};
var $159afdcd077ecfe9$export$e585697127cda27 = {
    prefix: 'fas',
    iconName: 'user-xmark',
    icon: [
        640,
        512,
        [
            "user-times"
        ],
        "f235",
        "M136.4 128a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zm-88 354.3c0-98.5 79.8-178.3 178.3-178.3l59.4 0c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7L78.1 512c-16.4 0-29.7-13.3-29.7-29.7zM612.3 124.1c9.4 9.4 9.4 24.6 0 33.9l-33.9 33.9 33.9 33.9c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-33.9-33.9-33.9 33.9c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l33.9-33.9-33.9-33.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l33.9 33.9 33.9-33.9c9.4-9.4 24.6-9.4 33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$45b996d071667753 = $159afdcd077ecfe9$export$e585697127cda27;
var $159afdcd077ecfe9$export$19357abad396e723 = {
    prefix: 'fas',
    iconName: 'flag-usa',
    icon: [
        448,
        512,
        [],
        "f74d",
        "M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 36.1-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-20.3-9-41.8-14.7-63.6-16.9l0 32.2c17.4 2.1 34.4 6.7 50.6 13.9l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3 0 62-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3l-63.5 13.6 0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3 0 61.9-44.7 16.2c-42.8 15.6-90 13.9-131.6-4.6l-16.1-7.2c-40.2-17.9-85-22.5-128.1-13.3l-63.5 13.6 0 32.7 70.2-15.1c36.4-7.8 74.3-3.9 108.4 11.3l16.1 7.2c49.2 21.9 105 23.8 155.6 5.4l33.7-12.3 0 33.5c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.4-23.7-122.5-13.4L64 400 64 480c0 17.7-14.3 32-32 32S0 497.7 0 480L0 32C0 14.3 14.3 0 32 0zm80 96a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
    ]
};
var $159afdcd077ecfe9$export$bd40d3a3a16fb147 = {
    prefix: 'fas',
    iconName: 'hand-middle-finger',
    icon: [
        448,
        512,
        [
            128405
        ],
        "f806",
        "M232 0c-22.1 0-40 17.9-40 40l0 164.2c-8.5-7.6-19.7-12.2-32-12.2-26.5 0-48 21.5-48 48l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-55.7c-2 1.4-3.9 3-5.8 4.5L55 284.8C40.4 297 32 315 32 334L32 372c0 38 16.9 74 46.1 98.3l5.4 4.5c28.8 24 65 37.1 102.4 37.1L304 512c70.7 0 128-57.3 128-128l0-96c0-26.5-21.5-48-48-48-12.4 0-23.6 4.7-32.1 12.3-1.9-24.8-22.6-44.3-47.9-44.3-12.3 0-23.5 4.6-32 12.2L272 40c0-22.1-17.9-40-40-40z"
    ]
};
var $159afdcd077ecfe9$export$55ceb5d0c144580a = {
    prefix: 'fas',
    iconName: 'mortar-pestle',
    icon: [
        512,
        512,
        [],
        "f5a7",
        "M504.3 11.1C493.3-1.6 474.5-3.7 461 6.2L252.3 160 397.3 160 502.6 54.6c11.8-11.8 12.6-30.8 1.6-43.5zM32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32c0 82.5 43.4 147.7 123.9 176.2-11.1 13.9-19.4 30.3-23.9 48.1-4.4 17.1 10.4 31.7 28.1 31.7l192 0c17.7 0 32.4-14.6 28.1-31.7-4.5-17.8-12.8-34.1-23.9-48.1 80.5-28.6 123.9-93.7 123.9-176.2 17.7 0 32-14.3 32-32s-14.3-32-32-32L32 192z"
    ]
};
var $159afdcd077ecfe9$export$3cd04b7c1624f598 = {
    prefix: 'fas',
    iconName: 'head-side-cough',
    icon: [
        512,
        512,
        [],
        "e061",
        "M96 512l64 0c53 0 96-43 96-96l0-80c0-8.8 7.2-16 16-16l1 0c26 0 47-21 47-47 0-11-3.9-21.6-10.9-30.1L273.3 200C271.4 197.6 270.1 194.7 269.7 191.7 254 83.3 160.7 0 48 0 40.4 0 32.9 .4 25.4 1.1 10.5 2.6 0 15.9 0 30.9L0 480c0 17.7 14.3 32 32 32l64 0zm16-320a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm63.1 237.2l-41.5-3.5c-12.2-1-21.6-11.2-21.6-23.4 0-10.8 7.3-20.2 17.8-22.8l40.4-10.1c19.2-4.8 37.8 9.7 37.8 29.5 0 17.8-15.2 31.8-32.9 30.3zM480 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-64 48a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm128 0a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM480 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$1125ac57be52258c = {
    prefix: 'fas',
    iconName: 'plane-lock',
    icon: [
        640,
        512,
        [],
        "e558",
        "M232 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 82.1 75.2C409.7 248.1 400 274.9 400 304l0 24.4c-7.3 6.6-13.6 14.2-18.7 22.7l-37.3-12.4 0 99.7 24 19.2 0 38.3c0 13.5 2.8 26.4 7.8 38.1L288 512 179.9 539c-10.1 2.5-19.9-5.1-19.9-15.5l0-19.8c0-4.9 2.2-9.5 6-12.5l66-52.8 0-99.7-162.9 54.3C58.7 396.4 48 388.7 48 377.8l0-43.7c0-9 3.8-17.5 10.4-23.6L232 151.3 232 24zM560 304.1c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM416 400c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
var $159afdcd077ecfe9$export$cfb37069d38f379e = {
    prefix: 'fas',
    iconName: 'battery-three-quarters',
    icon: [
        640,
        512,
        [
            "battery-4"
        ],
        "f241",
        "M528 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l416 0zM112 64c-44.2 0-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80l416 0c44.2 0 80-35.8 80-80l0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80L112 64zm56 112c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l224 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-224 0z"
    ]
};
var $159afdcd077ecfe9$export$35ffefed200d123c = $159afdcd077ecfe9$export$cfb37069d38f379e;
var $159afdcd077ecfe9$export$acef3e5c2029d285 = {
    prefix: 'fas',
    iconName: 'franc-sign',
    icon: [
        320,
        512,
        [],
        "e18f",
        "M80 32C62.3 32 48 46.3 48 64l0 256-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 88 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-88 0 0-64 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-96 176 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
    ]
};
var $159afdcd077ecfe9$export$3300e4b4d1d1936f = {
    prefix: 'fas',
    iconName: 'filter-circle-dollar',
    icon: [
        576,
        512,
        [
            "funnel-dollar"
        ],
        "f662",
        "M32 64C19.1 64 7.4 71.8 2.4 83.8S.2 109.5 9.4 118.6L192 301.3 192 416c0 8.5 3.4 16.6 9.4 22.6l64 64c2.5 2.5 5.3 4.5 8.3 6-21.2-30.9-33.6-68.3-33.6-108.6 0-99.4 75.5-181.1 172.3-191l90.4-90.4c9.2-9.2 11.9-22.9 6.9-34.9S492.9 64 480 64L32 64zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM416 320c0-8.8 7.2-16 16-16s16 7.2 16 16l0 8 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-45.8 0c-5.6 0-10.2 4.6-10.2 10.2 0 4.9 3.5 9.1 8.3 10l45 8.2c20 3.6 34.6 21.1 34.6 41.5 0 23.3-18.9 42.2-42.2 42.2l-5.8 0 0 8c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-8-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l53.8 0c5.6 0 10.2-4.6 10.2-10.2 0-4.9-3.5-9.1-8.3-10l-45-8.2c-20-3.6-34.6-21.1-34.6-41.5 0-22.6 17.7-41 40-42.1l0-8.1z"
    ]
};
var $159afdcd077ecfe9$export$cebe38ad8f0a143d = $159afdcd077ecfe9$export$3300e4b4d1d1936f;
var $159afdcd077ecfe9$export$549b99473b7201e6 = {
    prefix: 'fas',
    iconName: 'cheese',
    icon: [
        512,
        512,
        [],
        "f7ef",
        "M512 240.2l0 15.8-512 0c0-20 10-38.7 26.6-49.8L274.9 40.7c8.6-5.7 18.6-8.7 28.9-8.7 115 0 208.2 93.2 208.2 208.2zm0 63.8l0 112c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-112 512 0z"
    ]
};
var $159afdcd077ecfe9$export$bf5674308c61894f = {
    prefix: 'fas',
    iconName: 'circle-h',
    icon: [
        512,
        512,
        [
            9405,
            "hospital-symbol"
        ],
        "f47e",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm96-344l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-96 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 96 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$c8a3c78d99c23fed = $159afdcd077ecfe9$export$bf5674308c61894f;
var $159afdcd077ecfe9$export$51e9b8434982947d = {
    prefix: 'fas',
    iconName: 'school',
    icon: [
        576,
        512,
        [
            127979
        ],
        "f549",
        "M0 192c0-35.3 28.7-64 64-64l64 0 127.9-115.1c18.3-16.4 46-16.4 64.2 0L448 128 512 128c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192zM224 376l0 88 128 0 0-88c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zm-112 8c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm16-144l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM496 384c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm16-144l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM288 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var $159afdcd077ecfe9$export$d9769fb795c2db82 = {
    prefix: 'fas',
    iconName: 'dice-five',
    icon: [
        448,
        512,
        [
            9860
        ],
        "f523",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM96 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$6d274258ba4b0089 = {
    prefix: 'fas',
    iconName: 'tornado',
    icon: [
        448,
        512,
        [
            127786
        ],
        "f76f",
        "M0 32L0 45.6C0 62.7 1.7 79.6 5 96l352.8 0c3.2-6.9 7.5-13.3 13-18.8l38.6-38.6c4.2-4.2 6.6-10 6.6-16 0-12.5-10.1-22.6-22.6-22.6L32 0C14.3 0 0 14.3 0 32zM355.7 144l-336 0c12.4 29.7 30.2 56.8 52.7 80l339.6 0-47.2-62.9c-3.9-5.2-7-11-9.2-17.1zM242.6 334.7c8.2 4.8 15.8 10.7 22.5 17.3L445 352c2-9.8 3-19.9 3-30.1 0-17.1-2.9-34-8.6-49.9L136 272 242.6 334.7zM294.3 400c5.3 17 6.5 35.2 3.6 53l-5.9 35.7c-2 12.2 7.4 23.4 19.8 23.4 5.3 0 10.4-2.1 14.2-5.9l78.2-78.2c8.5-8.5 15.8-17.8 21.9-27.9l-131.8 0z"
    ]
};
var $159afdcd077ecfe9$export$2130e629ab767ab3 = {
    prefix: 'fas',
    iconName: 'jet-fighter',
    icon: [
        576,
        512,
        [
            "fighter-jet"
        ],
        "f0fb",
        "M496.2 206.8c-10.7-4.5-22.2-6.8-33.8-6.8L362 200 248 48 296 48c13.3 0 24-10.7 24-24S309.3 0 296 0L152 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l8 0 0 152-54.4 0-52.8-66c-3-3.8-7.6-6-12.5-6L16 128c-8.8 0-16 7.2-16 16l0 88 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 88c0 8.8 7.2 16 16 16l24.3 0c4.9 0 9.5-2.2 12.5-6l52.8-66 54.4 0 0 152-8 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 114-152 100.4 0c11.6 0 23.1-2.3 33.8-6.8l65-27.1c8.9-3.7 14.8-12.5 14.8-22.2s-5.8-18.4-14.8-22.2l-65-27.1z"
    ]
};
var $159afdcd077ecfe9$export$102b809faf56e033 = $159afdcd077ecfe9$export$2130e629ab767ab3;
var $159afdcd077ecfe9$export$aba24ca305bbe8c1 = {
    prefix: 'fas',
    iconName: 'thumbs-down',
    icon: [
        512,
        512,
        [
            128078,
            61576
        ],
        "f165",
        "M384 32c26.5 0 48 21.5 48 48 0 6.3-1.3 12.2-3.4 17.7 20.4 5.5 35.4 24.1 35.4 46.3 0 9.1-2.6 17.6-7 24.9 22.2 4.2 39 23.7 39 47.1 0 19.7-11.9 36.6-28.9 44 17 7.4 28.9 24.3 28.9 44 0 26.5-21.5 48-48 48l-160 0 28.2 70.4c2.5 6.3 3.8 13.1 3.8 19.9l0 4.2c0 27.3-22.1 49.4-49.4 49.4-18.7 0-35.8-10.6-44.2-27.3L170.1 356.3c-6.7-13.3-10.1-28-10.1-42.9l0-186.6c0-19.4 8.9-37.8 24-50l12.2-9.7C224.6 44.4 259.8 32 296.1 32L384 32zM80 96c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32L0 128c0-17.7 14.3-32 32-32l48 0z"
    ]
};
var $159afdcd077ecfe9$export$2a533051418ff4ca = {
    prefix: 'fas',
    iconName: 'broom',
    icon: [
        576,
        512,
        [
            129529
        ],
        "f51a",
        "M566.6 54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192-34.7-34.7c-4.2-4.2-10-6.6-16-6.6-12.5 0-22.6 10.1-22.6 22.6l0 29.1 108.3 108.3 29.1 0c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-34.7-34.7 192-192zM341.1 353.4L222.6 234.9c-42.7-3.7-85.2 11.7-115.8 42.3l-8 8c-22.3 22.3-34.8 52.5-34.8 84 0 6.8 7.1 11.2 13.2 8.2l51.1-25.5c5-2.5 9.5 4.1 5.4 7.9L7.3 473.4C2.7 477.6 0 483.6 0 489.9 0 502.1 9.9 512 22.1 512l173.3 0c38.8 0 75.9-15.4 103.4-42.8 30.6-30.6 45.9-73.1 42.3-115.8z"
    ]
};
var $159afdcd077ecfe9$export$d796c05153b1255c = {
    prefix: 'fas',
    iconName: 'file-import',
    icon: [
        384,
        512,
        [
            "arrow-right-to-file"
        ],
        "f56f",
        "M64 0C28.7 0 0 28.7 0 64l0 240 182.1 0-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-182.1 0 0 96c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176z"
    ]
};
var $159afdcd077ecfe9$export$32f14beaf6294476 = $159afdcd077ecfe9$export$d796c05153b1255c;
var $159afdcd077ecfe9$export$750d52edc1dafc7 = {
    prefix: 'fas',
    iconName: 'utensils',
    icon: [
        512,
        512,
        [
            127860,
            61685,
            "cutlery"
        ],
        "f2e7",
        "M63.9 14.4C63.1 6.2 56.2 0 48 0s-15.1 6.2-16 14.3L17.9 149.7c-1.3 6-1.9 12.1-1.9 18.2 0 45.9 35.1 83.6 80 87.7L96 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224.4c44.9-4.1 80-41.8 80-87.7 0-6.1-.6-12.2-1.9-18.2L223.9 14.3C223.1 6.2 216.2 0 208 0s-15.1 6.2-15.9 14.4L178.5 149.9c-.6 5.7-5.4 10.1-11.1 10.1-5.8 0-10.6-4.4-11.2-10.2L143.9 14.6C143.2 6.3 136.3 0 128 0s-15.2 6.3-15.9 14.6L99.8 149.8c-.5 5.8-5.4 10.2-11.2 10.2-5.8 0-10.6-4.4-11.1-10.1L63.9 14.4zM448 0C432 0 320 32 320 176l0 112c0 35.3 28.7 64 64 64l32 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-448c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$7034e54a8036c5c8 = $159afdcd077ecfe9$export$750d52edc1dafc7;
var $159afdcd077ecfe9$export$a75288855ea05282 = {
    prefix: 'fas',
    iconName: 'id-badge',
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm96 352l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16L96 448c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-24-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM152 64l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$6daa96b1986e2ef0 = {
    prefix: 'fas',
    iconName: 'spider',
    icon: [
        512,
        512,
        [
            128375
        ],
        "f717",
        "M369.3-31c11.9-3.5 24.4 2.7 29 13.9l.8 2.3 40 136c2.5 8.4 .1 17.5-6.1 23.7l-64.1 64.1 76.4-20.8 19.9-59.8 .9-2.3c5-11.1 17.7-16.8 29.5-12.9 11.8 3.9 18.5 16.1 15.8 28l-.7 2.4-24 72c-2.5 7.6-8.7 13.4-16.5 15.6l-91.1 24.8 91.1 24.8c7.7 2.1 13.9 8 16.5 15.6l24 72 .7 2.4c2.7 11.9-4.1 24.1-15.8 28-11.8 3.9-24.5-1.8-29.5-12.9l-.9-2.3-19.9-59.8-76.4-20.8 64.1 64.1c6.1 6.1 8.5 15.1 6.2 23.4l-40 144-.8 2.3c-4.4 11.3-16.8 17.7-28.8 14.4-12-3.3-19.3-15.2-17.2-27.2l.5-2.4 36.2-130.5-37.2-37.2C351 406 308.4 448 256 448s-95-42-96-94.1l-37 37 36 122.3 .6 2.4c2.2 11.9-4.9 23.9-16.8 27.4-11.9 3.5-24.4-2.7-29-13.9l-.8-2.3-40-136c-2.5-8.4-.1-17.5 6.1-23.8l64.1-64.1-76.4 20.8-19.9 59.8-.9 2.3c-5 11.1-17.7 16.8-29.5 12.9s-18.5-16.1-15.8-28l.7-2.4 24-72c2.5-7.6 8.7-13.4 16.5-15.6l91.1-24.8-91.1-24.8c-7.7-2.1-13.9-8-16.5-15.6l-24-72-.7-2.4c-2.7-11.9 4.1-24.1 15.8-28s24.5 1.8 29.5 12.9l.9 2.3 19.9 59.8 76.4 20.8-64.1-64.1c-6.2-6.2-8.5-15.3-6.1-23.7l40-136 .8-2.3c4.6-11.3 17.1-17.4 29-13.9 11.9 3.5 19 15.5 16.8 27.4l-.6 2.4-36 122.3 53 53c1-43.3 36.4-78.1 79.9-78.1s78.9 34.8 79.9 78.2l53.1-53.1-36-122.3-.6-2.4c-2.2-12 4.9-23.9 16.8-27.4z"
    ]
};
var $159afdcd077ecfe9$export$7955f08360418647 = {
    prefix: 'fas',
    iconName: 'mobile-retro',
    icon: [
        384,
        512,
        [],
        "e527",
        "M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zm80 96l0 64c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32zm8 192a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24zm64-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24zm64-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24zM168 40c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z"
    ]
};
var $159afdcd077ecfe9$export$905f45f8ffd6b8e5 = {
    prefix: 'fas',
    iconName: 'signs-post',
    icon: [
        512,
        512,
        [
            "map-signs"
        ],
        "f277",
        "M256.4 0c-17.7 0-32 14.3-32 32l0 32-160 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0 0 64-153.4 0c-4.2 0-8.3 1.7-11.3 4.7l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c3 3 7.1 4.7 11.3 4.7l153.4 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 160 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-160 0 0-64 153.4 0c4.2 0 8.3-1.7 11.3-4.7l48-48c6.2-6.2 6.2-16.4 0-22.6l-48-48c-3-3-7.1-4.7-11.3-4.7l-153.4 0 0-32c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$743f4b1071b3333a = $159afdcd077ecfe9$export$905f45f8ffd6b8e5;
var $159afdcd077ecfe9$export$88a8383ecdd39a54 = {
    prefix: 'fas',
    iconName: 'group-arrows-rotate',
    icon: [
        512,
        512,
        [],
        "e4f6",
        "M37.6 122.3c-11.5 18.7-20.6 39-27 60.5-5 16.9 4.6 34.8 21.5 39.8s34.8-4.6 39.8-21.5c18.4-61.9 67.3-110.8 129.2-129.2 16.9-5 26.6-22.9 21.5-39.8S199.8 5.6 182.9 10.6C161.4 17 141.1 26.1 122.3 37.6 112.3 15.4 89.9 0 64 0 28.7 0 0 28.7 0 64 0 89.9 15.4 112.3 37.6 122.3zm436.7 0c22.2-10 37.6-32.4 37.6-58.3 0-35.3-28.7-64-64-64-25.9 0-48.3 15.4-58.3 37.6-18.7-11.5-39-20.6-60.5-27-16.9-5-34.8 4.6-39.8 21.5s4.6 34.8 21.5 39.8c61.9 18.4 110.8 67.3 129.2 129.2 5 16.9 22.9 26.6 39.8 21.5s26.6-22.9 21.5-39.8c-6.4-21.5-15.5-41.8-27-60.5zM512 448c0-25.9-15.4-48.3-37.6-58.3 11.5-18.7 20.6-39 27-60.5 5-16.9-4.6-34.8-21.5-39.8s-34.8 4.6-39.8 21.5c-18.4 61.9-67.3 110.8-129.2 129.2-16.9 5-26.6 22.9-21.5 39.8s22.9 26.6 39.8 21.5c21.5-6.4 41.8-15.5 60.5-27 10 22.2 32.4 37.6 58.3 37.6 35.3 0 64-28.7 64-64zM37.6 389.7c-22.2 10-37.6 32.4-37.6 58.3 0 35.3 28.7 64 64 64 25.9 0 48.3-15.4 58.3-37.6 18.7 11.5 39 20.6 60.5 27 16.9 5 34.8-4.6 39.8-21.5s-4.6-34.8-21.5-39.8c-61.9-18.4-110.8-67.3-129.2-129.2-5-16.9-22.9-26.6-39.8-21.5S5.6 312.2 10.6 329.1c6.4 21.5 15.5 41.8 27 60.5zM256 192c15.6 0 30 5.6 41.1 14.9l-15.3 15.3c-6.6 6.6-1.9 17.8 7.4 17.8l60.5 0c5.7 0 10.4-4.7 10.4-10.4l0-60.5c0-9.3-11.2-13.9-17.8-7.4l-11.2 11.2c-19.8-17.9-46.2-28.9-75.1-28.9-43.6 0-81.3 24.9-99.8 61.1-6 11.8-1.4 26.3 10.4 32.3s26.3 1.4 32.3-10.4c10.6-20.8 32.2-34.9 57-34.9zm58.6 93.1c-10.6 20.8-32.2 34.9-57 34.9-15.7 0-30-5.6-41.1-14.9l15.3-15.3c6.6-6.6 1.9-17.8-7.4-17.8L164 272c-5.7 0-10.4 4.7-10.4 10.4l0 60.5c0 9.3 11.2 13.9 17.8 7.4l11.2-11.2c19.8 17.9 46.2 28.9 75.1 28.9 43.6 0 81.3-24.9 99.8-61.1 6-11.8 1.4-26.3-10.4-32.3s-26.3-1.4-32.3 10.4z"
    ]
};
var $159afdcd077ecfe9$export$7df274119d2469d1 = {
    prefix: 'fas',
    iconName: 'arrows-split-up-and-left',
    icon: [
        512,
        512,
        [],
        "e4bc",
        "M342.6-22.6c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l41.4-41.4 0 195.9c-18.8-10.9-40.7-17.1-64-17.1l-114.7 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 320 224 320c35.3 0 64 28.7 64 64 0 70.7 57.3 128 128 128l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-35.3 0-64-28.7-64-64l0-306.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var $159afdcd077ecfe9$export$38320138fc0262d0 = {
    prefix: 'fas',
    iconName: 'fill-drip',
    icon: [
        576,
        512,
        [],
        "f576",
        "M309.7 71.6l-64.4 64.4 33.4 33.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-33.4-33.4-96.4 96.4c-2.9 2.9-5.1 6.5-6.3 10.3l321.5 0 53.7-53.7c4.9-4.9 7.6-11.5 7.6-18.3s-2.7-13.5-7.6-18.3L346.3 71.6C341.5 66.7 334.9 64 328 64s-13.5 2.7-18.3 7.6zM58.3 232.4l96.4-96.4-49.4-49.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L200 90.7 264.4 26.3C281.3 9.5 304.1 0 328 0s46.7 9.5 63.6 26.3L517.7 152.4C534.5 169.3 544 192.1 544 216s-9.5 46.7-26.3 63.6L311.6 485.7C294.7 502.5 271.9 512 248 512s-46.7-9.5-63.6-26.3L58.3 359.6C41.5 342.7 32 319.9 32 296s9.5-46.7 26.3-63.6zM512 544c-35.3 0-64-28.7-64-64 0-25.2 32.6-79.6 51.2-108.7 6-9.4 19.5-9.4 25.5 0 18.7 29.1 51.2 83.5 51.2 108.7 0 35.3-28.7 64-64 64z"
    ]
};
var $159afdcd077ecfe9$export$7b96388ca2be471b = {
    prefix: 'fas',
    iconName: 'shield-heart',
    icon: [
        512,
        512,
        [],
        "e574",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2 .5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0 172.4-82.5 213.2-264 213.6-363.2 .1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM249.6 183.5l6.4 8.5 6.4-8.5c11.1-14.8 28.5-23.5 46.9-23.5 32.4 0 58.7 26.3 58.7 58.7l0 5.3c0 49.1-65.8 98.1-96.5 118.3-9.5 6.2-21.5 6.2-30.9 0-30.7-20.2-96.5-69.3-96.5-118.3l0-5.3c0-32.4 26.3-58.7 58.7-58.7 18.5 0 35.9 8.7 46.9 23.5z"
    ]
};
var $159afdcd077ecfe9$export$c8cd1786449517d3 = {
    prefix: 'fas',
    iconName: 'person-skiing-nordic',
    icon: [
        576,
        512,
        [
            "skiing-nordic"
        ],
        "f7ca",
        "M424.8 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm99.8 193.7c7.6 15.2 1.9 33.6-12.6 42l0 180.3-32 0 0-164.2-10.1 5c-27.4 13.7-60.7 6.1-79.4-18.2l-19.6-25.5-39.5 68.8 24.8 12.4c29.5 14.7 42.9 49.5 31.1 80.2l-28.2 73.4 149.4 0c7.9 0 15.6-2.3 22.2-6.7l7.9-5.3c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-7.9 5.3C543 506.9 526 512 508.6 512l-189.1 0c-.5 0-1 0-1.5 0L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l88 0c0-8.2 3.1-16.4 9.4-22.6l74.1-74.1 10.2-35.9c11.3 18.3 27.7 33.8 48.4 44.2l4.8 2.4-1.9 6.8c-3 10.5-8.6 20-16.3 27.7l-51.5 51.5 101.3 0 37.1-96.4-55.6-27.8C230.4 319 215.3 267 239.3 227.1l37.7-62.7-27.7-7.7c-9-2.5-18.1 3.2-20 12.3l-5.9 29.3c-3.1 15.6-17.1 26.3-32.5 25.7l-130 208-37.7 0 140.6-225c-3.4-6.3-4.6-13.8-3.1-21.3l5.9-29.3c9.1-45.6 55.1-73.8 99.9-61.4l32.5 9c46.7 13 88 40.8 117.6 79.3l24.9 32.3 40.4-20.2c15.8-7.9 35-1.5 42.9 14.3z"
    ]
};
var $159afdcd077ecfe9$export$6ea48260d7d09b1b = $159afdcd077ecfe9$export$c8cd1786449517d3;
var $159afdcd077ecfe9$export$5bb6a0c94ad2f4bb = {
    prefix: 'fas',
    iconName: 'square-check',
    icon: [
        448,
        512,
        [
            9745,
            9989,
            61510,
            "check-square"
        ],
        "f14a",
        "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM342 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L189.1 315.2 137 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.9 7.5 18.8 7s13.4-4.1 17.5-9.8L347.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z"
    ]
};
var $159afdcd077ecfe9$export$f0c8040f596df7fe = $159afdcd077ecfe9$export$5bb6a0c94ad2f4bb;
var $159afdcd077ecfe9$export$1ea66a88b8f620c9 = {
    prefix: 'fas',
    iconName: 'bath',
    icon: [
        512,
        512,
        [
            128705,
            "bathtub"
        ],
        "f2cd",
        "M96 77.3c0-7.3 5.9-13.3 13.3-13.3 3.5 0 6.9 1.4 9.4 3.9l14.9 14.9c-3.6 9.1-5.5 18.9-5.5 29.2 0 19.9 7.2 38 19.2 52-5.3 9.2-4 21.1 3.8 29 9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9-7.8-7.9-19.8-9.1-29-3.8-14-12-32.1-19.2-52-19.2-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0 66.6 0 32 34.6 32 77.3L32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 48c0 28.4 12.4 54 32 71.6L64 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16 256 0 0 16c0 17.7 14.3 32 32 32s32-14.3 32-32l0-40.4c19.6-17.6 32-43.1 32-71.6l0-48c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 256 96 77.3z"
    ]
};
var $159afdcd077ecfe9$export$40ae013b5e6269d8 = $159afdcd077ecfe9$export$1ea66a88b8f620c9;
var $159afdcd077ecfe9$export$a831eedd2f59c62f = {
    prefix: 'fas',
    iconName: 'chess-bishop',
    icon: [
        320,
        512,
        [
            9821
        ],
        "f43a",
        "M64 384L48.3 368.3C17.4 337.4 0 295.4 0 251.7 0 213.1 13.5 175.8 38.2 146.1L106.7 64 96 64C78.3 64 64 49.7 64 32S78.3 0 96 0L224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-10.7 0 47.6 57.1-85.9 85.9c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l82.3-82.3c18.7 27.3 28.7 59.7 28.7 93 0 43.7-17.4 85.7-48.3 116.6L256 384 312.2 454.3c5 6.3 7.8 14.1 7.8 22.2 0 19.6-15.9 35.5-35.5 35.5L35.5 512c-19.6 0-35.5-15.9-35.5-35.5 0-8.1 2.7-15.9 7.8-22.2L64 384z"
    ]
};
var $159afdcd077ecfe9$export$99cfe064ff0b71c9 = {
    prefix: 'fas',
    iconName: 'prescription-bottle-medical',
    icon: [
        384,
        512,
        [
            "prescription-bottle-alt"
        ],
        "f486",
        "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zM32 144l320 0 0 304c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-304zM160 248l0 40-40 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l40 0 0 40c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-40 40 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-40 0 0-40c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
var $159afdcd077ecfe9$export$65d1c884b8581d1a = $159afdcd077ecfe9$export$99cfe064ff0b71c9;
var $159afdcd077ecfe9$export$df9bd3777d1154d2 = {
    prefix: 'fas',
    iconName: 'draw-polygon',
    icon: [
        512,
        512,
        [
            58055,
            "vector-polygon"
        ],
        "f5ee",
        "M64 0c23.7 0 44.4 12.9 55.4 32l273.1 0c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 34-26.5 61.8-60 63.9l-2.1 2.9-71.5 99.1c3.6 8 5.6 16.9 5.6 26.2s-2 18.2-5.6 26.2l2.2 3.1 69.3 96 2.1 2.9c33.5 2.1 60 29.9 60 63.9 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32l-273.1 0c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4l0-273.1C12.9 108.4 0 87.7 0 64 0 28.7 28.7 0 64 0zM394.2 413.4l-65.5-90.6-2.2-3.1c-2.1 .2-4.3 .3-6.5 .3-35.3 0-64-28.7-64-64s28.7-64 64-64c2.2 0 4.4 .1 6.5 .3l67.7-93.7c-.6-.9-1.1-1.7-1.6-2.6L119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4l0 273.1c9.7 5.6 17.8 13.7 23.4 23.4l273.1 0c.5-.9 1.1-1.8 1.6-2.6z"
    ]
};
var $159afdcd077ecfe9$export$2294366830f9b562 = $159afdcd077ecfe9$export$df9bd3777d1154d2;
var $159afdcd077ecfe9$export$7fddf76ec23943d8 = {
    prefix: 'fas',
    iconName: 'i-cursor',
    icon: [
        256,
        512,
        [],
        "f246",
        "M.1 29.3C-1.4 47 11.7 62.4 29.3 63.9l8 .7C70.5 67.3 96 95 96 128.3l0 95.7-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 95.7c0 33.3-25.5 61-58.7 63.8l-8 .7C11.7 449.6-1.4 465 .1 482.7S17 513.4 34.7 511.9l8-.7c34.1-2.8 64.2-18.9 85.4-42.9 21.2 24 51.2 40 85.4 42.9l8 .7c17.6 1.5 33.1-11.6 34.5-29.2s-11.6-33.1-29.2-34.5l-8-.7C185.5 444.7 160 417 160 383.7l0-95.7 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-95.7c0-33.3 25.5-61 58.7-63.8l8-.7c17.6-1.5 30.7-16.9 29.2-34.5S239-1.4 221.3 .1l-8 .7c-34.1 2.8-64.2 18.9-85.4 42.9-21.2-24-51.2-40-85.4-42.9l-8-.7C17-1.4 1.6 11.7 .1 29.3z"
    ]
};
var $159afdcd077ecfe9$export$2a155a6e20f64134 = {
    prefix: 'fas',
    iconName: 'heart-circle-plus',
    icon: [
        576,
        512,
        [],
        "e500",
        "M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 17.6-3.4 35.6-9.5 53.7-21.8-8.6-45.6-13.4-70.5-13.4-106 0-192 86-192 192 0 28.5 6.2 55.6 17.4 80-.5 0-.9 0-1.4 0-15.5 0-30.8-4.6-43.1-14.1-73-55.7-212.9-186-212.9-298.2l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"
    ]
};
var $159afdcd077ecfe9$export$2a5c6f182c0cbcb = {
    prefix: 'fas',
    iconName: 'shield-dog',
    icon: [
        512,
        512,
        [],
        "e573",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2 .5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0 172.4-82.5 213.2-264 213.6-363.2 .1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160.9 286.2c4.8 1.2 9.9 1.8 15.1 1.8 35.3 0 64-28.7 64-64l0-64 44.2 0c12.1 0 23.2 6.8 28.6 17.7l7.2 14.3 64 0c8.8 0 16 7.2 16 16l0 32c0 44.2-35.8 80-80 80l-48 0 0 50.7c0 7.3-5.9 13.3-13.3 13.3-1.8 0-3.6-.4-5.2-1.1l-98.7-42.3c-6.6-2.8-10.8-9.3-10.8-16.4 0-2.8 .6-5.5 1.9-8l15-30zM160 160l48 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c0-8.8 7.2-16 16-16zm128 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $159afdcd077ecfe9$export$7bf8dfe2e6661a54 = {
    prefix: 'fas',
    iconName: 'greater-than-equal',
    icon: [
        448,
        512,
        [],
        "f532",
        "M21.9 94.4C5.1 88.8-3.9 70.6 1.7 53.9S25.4 28.1 42.1 33.6l384 128C439.2 166 448 178.2 448 192s-8.8 26-21.9 30.4l-384 128c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5L314.8 192 21.9 94.4zM416 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0z"
    ]
};
var $159afdcd077ecfe9$export$c6c3bd5f7d9b8bf2 = {
    prefix: 'fas',
    iconName: 'envelope-open',
    icon: [
        512,
        512,
        [
            62135
        ],
        "f2b6",
        "M64.4 175.8L256 33.9 447.6 175.8 289.5 293c-9.7 7.2-21.4 11-33.5 11s-23.8-3.9-33.5-11L64.4 175.8zM256-32c-12.1 0-23.8 3.9-33.5 11L25.9 124.7C9.6 136.8 0 155.8 0 176.1L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-239.9c0-20.3-9.6-39.4-25.9-51.4L289.5-21c-9.7-7.2-21.4-11-33.5-11z"
    ]
};
var $159afdcd077ecfe9$export$ac54ffffdb218383 = {
    prefix: 'fas',
    iconName: 'mound',
    icon: [
        512,
        512,
        [],
        "e52d",
        "M112.4 179.2C142 127.7 196.8 96 256.2 96s114.2 31.7 143.9 83.2L508.7 368c12.3 21.3-3.1 48-27.7 48L31.5 416c-24.6 0-40-26.6-27.7-48L112.4 179.2z"
    ]
};
var $159afdcd077ecfe9$export$4f1ce88b2b4cd5cd = {
    prefix: 'fas',
    iconName: 'voicemail',
    icon: [
        640,
        512,
        [],
        "f897",
        "M144 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM263.8 320c15.3-22.9 24.2-50.4 24.2-80 0-79.5-64.5-144-144-144S0 160.5 0 240 64.5 384 144 384l352 0c79.5 0 144-64.5 144-144S575.5 96 496 96 352 160.5 352 240c0 29.6 8.9 57.1 24.2 80l-112.5 0zM496 160a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
    ]
};
var $159afdcd077ecfe9$export$c8370e53051a657 = {
    prefix: 'fas',
    iconName: 'vest',
    icon: [
        448,
        512,
        [],
        "e085",
        "M200 464l0-170.1c0-3.9-.5-7.8-1.4-11.6L144.4 65.4C162.1 77.2 188.2 88 224 88s61.9-10.8 79.6-22.6L249.4 282.3c-1 3.8-1.4 7.7-1.4 11.6L248 464c0 26.5 21.5 48 48 48l104 0c26.5 0 48-21.5 48-48l0-193.5c0-9.5-2.8-18.7-8.1-26.6l-47.9-71.8c-5.3-7.9-8.1-17.1-8.1-26.6L384 48c0-26.5-21.5-48-48-48l-3.5 0c-.3 0-.6 0-1 0-.6 0-1.2 0-1.8 0-18.8 0-34.1 9.7-44.1 18.8-9.3 8.4-28.5 21.2-61.7 21.2s-52.4-12.8-61.7-21.2c-10-9.1-25.3-18.8-44.1-18.8-.6 0-1.2 0-1.8 0-.3 0-.6 0-1 0L112 0C85.5 0 64 21.5 64 48l0 97.5c0 9.5-2.8 18.7-8.1 26.6L8.1 243.9C2.8 251.8 0 261.1 0 270.5L0 464c0 26.5 21.5 48 48 48l104 0c26.5 0 48-21.5 48-48z"
    ]
};
var $159afdcd077ecfe9$export$b6b464c98c009494 = {
    prefix: 'fas',
    iconName: 'audio-description',
    icon: [
        512,
        512,
        [],
        "f29e",
        "M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm96 96l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 48 0 0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-35.3-28.7-64-64-64l-16 0c-35.3 0-64 28.7-64 64zm48 32l0-32c0-8.8 7.2-16 16-16l16 0c8.8 0 16 7.2 16 16l0 32-48 0zm152-96c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24l48 0c39.8 0 72-32.2 72-72l0-48c0-39.8-32.2-72-72-72l-48 0zm48 144l-24 0 0-96 24 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24z"
    ]
};
var $159afdcd077ecfe9$export$c7f24bdea332f90a = {
    prefix: 'fas',
    iconName: 'w',
    icon: [
        576,
        512,
        [
            119
        ],
        "57",
        "M20.8 34c16.5-6.2 35 2.2 41.2 18.7L172.2 346.7 257.3 55c4-13.7 16.5-23 30.7-23s26.7 9.4 30.7 23L403.8 346.7 514 52.8c6.2-16.5 24.6-24.9 41.2-18.7S580.2 58.7 574 75.2l-144 384c-4.8 12.9-17.4 21.3-31.2 20.7s-25.7-9.8-29.5-23L288 178.3 206.7 457c-3.9 13.2-15.8 22.5-29.5 23s-26.3-7.8-31.2-20.7L2 75.2C-4.2 58.7 4.2 40.2 20.8 34z"
    ]
};
var $159afdcd077ecfe9$export$1bc3e0ad56dc9eb0 = {
    prefix: 'fas',
    iconName: 'eye-dropper',
    icon: [
        512,
        512,
        [
            "eye-dropper-empty",
            "eyedropper"
        ],
        "f1fb",
        "M341.6 29.2l-101.6 101.6-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 101.6-101.6c39-39 39-102.2 0-141.1s-102.2-39-141.1 0zM55.4 323.3c-15 15-23.4 35.4-23.4 56.6l0 42.4-26.6 39.9c-8.5 12.7-6.8 29.6 4 40.4s27.7 12.5 40.4 4l39.9-26.6 42.4 0c21.2 0 41.6-8.4 56.6-23.4l109.4-109.4-45.3-45.3-109.4 109.4c-3 3-7.1 4.7-11.3 4.7l-36.1 0 0-36.1c0-4.2 1.7-8.3 4.7-11.3l109.4-109.4-45.3-45.3-109.4 109.4z"
    ]
};
var $159afdcd077ecfe9$export$ef304e9b7524c1f9 = $159afdcd077ecfe9$export$1bc3e0ad56dc9eb0;
var $159afdcd077ecfe9$export$91549a375c0b6d25 = $159afdcd077ecfe9$export$1bc3e0ad56dc9eb0;
var $159afdcd077ecfe9$export$30262489773a79a3 = {
    prefix: 'fas',
    iconName: 'circle-xmark',
    icon: [
        512,
        512,
        [
            61532,
            "times-circle",
            "xmark-circle"
        ],
        "f057",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM167 167c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$ab0ec50720a747eb = $159afdcd077ecfe9$export$30262489773a79a3;
var $159afdcd077ecfe9$export$90ac4096df8efdee = $159afdcd077ecfe9$export$30262489773a79a3;
var $159afdcd077ecfe9$export$3a48b9820e92f5ab = {
    prefix: 'fas',
    iconName: 'trailer',
    icon: [
        640,
        512,
        [],
        "e041",
        "M32 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 256 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-296.4 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8L96 416c-35.3 0-64-28.7-64-64L32 96zm408 16c-13.3 0-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24zM112 136l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24zm176-24c-13.3 0-24 10.7-24 24l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24zM264 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"
    ]
};
var $159afdcd077ecfe9$export$b458d393151b6960 = {
    prefix: 'fas',
    iconName: 'turkish-lira-sign',
    icon: [
        448,
        512,
        [
            "try",
            "turkish-lira"
        ],
        "e2bb",
        "M160 32c17.7 0 32 14.3 32 32l0 43.6 121.4-34.7c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-134.6 38.5 0 46.1 121.4-34.7c12.7-3.6 26 3.7 29.7 16.5s-3.7 26-16.5 29.7l-134.6 38.5 0 162.5 72 0c53 0 96-43 96-96 0-17.7 14.3-32 32-32s32 14.3 32 32c0 88.4-71.6 160-160 160l-104 0c-17.7 0-32-14.3-32-32l0-176.2-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11 0-46.1-25.4 7.3c-12.7 3.6-26-3.7-29.7-16.5s3.7-26 16.5-29.7l38.6-11 0-61.9c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$970dda513e46c41f = $159afdcd077ecfe9$export$b458d393151b6960;
var $159afdcd077ecfe9$export$40e66e5966827199 = $159afdcd077ecfe9$export$b458d393151b6960;
var $159afdcd077ecfe9$export$bae30a76735500e1 = {
    prefix: 'fas',
    iconName: 'volcano',
    icon: [
        512,
        512,
        [
            127755
        ],
        "f770",
        "M160 144c-35.3 0-64-28.7-64-64s28.7-64 64-64c15.7 0 30 5.6 41.2 15 11.2-18.6 31.6-31 54.8-31s43.6 12.4 54.8 31c11.1-9.4 25.5-15 41.2-15 35.3 0 64 28.7 64 64s-28.7 64-64 64c-14.7 0-28.3-5-39.1-13.3l-32 48C275.3 187 266 192 256 192s-19.3-5-24.9-13.3l-32-48C188.3 139 174.7 144 160 144zM144 352l48.4-24.2c10.2-5.1 21.6-7.8 33-7.8 19.6 0 38.4 7.8 52.2 21.6l32.5 32.5c6.3 6.3 14.9 9.9 23.8 9.9 11.3 0 21.8-5.6 28-15l9.7-14.6-59-66.3c-9.1-10.2-22.2-16.1-35.9-16.1l-41.8 0c-13.7 0-26.8 5.9-35.9 16.1l-59.9 67.4 4.7-3.5zm19.4-95.8c18.2-20.5 44.3-32.2 71.8-32.2l41.8 0c27.4 0 53.5 11.7 71.8 32.2l150.2 169c8.5 9.5 13.2 21.9 13.2 34.7 0 28.8-23.4 52.2-52.2 52.2L52.2 512C23.4 512 0 488.6 0 459.8 0 447.1 4.7 434.7 13.2 425.2l150.2-169z"
    ]
};
var $159afdcd077ecfe9$export$76cc39f249b6864e = {
    prefix: 'fas',
    iconName: 'wand-sparkles',
    icon: [
        512,
        512,
        [],
        "f72b",
        "M464 6.1c9.5-8.5 24-8.1 33 .9l8 8c9 9 9.4 23.5 .9 33l-85.8 95.9c-2.6 2.9-4.1 6.7-4.1 10.7l0 21.4c0 8.8-7.2 16-16 16l-15.8 0c-4.6 0-8.9 1.9-11.9 5.3L100.7 500.9c-6.3 7.1-15.3 11.1-24.8 11.1-8.8 0-17.3-3.5-23.5-9.8L9.7 459.7c-6.2-6.2-9.7-14.7-9.7-23.5 0-9.5 4-18.5 11.1-24.8l111.6-99.8c3.4-3 5.3-7.4 5.3-11.9l0-27.6c0-8.8 7.2-16 16-16l34.6 0c3.9 0 7.7-1.5 10.7-4.1L464 6.1zM432 288c3.6 0 6.7 2.4 7.7 5.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8l-14.8-51.7-51.7-14.8c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8zM87.7 69.8l14.8 51.7 51.7 14.8c3.4 1 5.8 4.1 5.8 7.7s-2.4 6.7-5.8 7.7l-51.7 14.8-14.8 51.7c-1 3.4-4.1 5.8-7.7 5.8s-6.7-2.4-7.7-5.8L57.5 166.5 5.8 151.7c-3.4-1-5.8-4.1-5.8-7.7s2.4-6.7 5.8-7.7l51.7-14.8 14.8-51.7c1-3.4 4.1-5.8 7.7-5.8s6.7 2.4 7.7 5.8zM208 0c3.7 0 6.9 2.5 7.8 6.1l6.8 27.3 27.3 6.8c3.6 .9 6.1 4.1 6.1 7.8s-2.5 6.9-6.1 7.8l-27.3 6.8-6.8 27.3c-.9 3.6-4.1 6.1-7.8 6.1s-6.9-2.5-7.8-6.1l-6.8-27.3-27.3-6.8c-3.6-.9-6.1-4.1-6.1-7.8s2.5-6.9 6.1-7.8l27.3-6.8 6.8-27.3c.9-3.6 4.1-6.1 7.8-6.1z"
    ]
};
var $159afdcd077ecfe9$export$eed3c491effe6d12 = {
    prefix: 'fas',
    iconName: 'microphone',
    icon: [
        384,
        512,
        [],
        "f130",
        "M192 0C139 0 96 43 96 96l0 128c0 53 43 96 96 96s96-43 96-96l0-128c0-53-43-96-96-96zM48 184c0-13.3-10.7-24-24-24S0 170.7 0 184l0 40c0 97.9 73.3 178.7 168 190.5l0 49.5-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-49.5c94.7-11.8 168-92.6 168-190.5l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c0 79.5-64.5 144-144 144S48 303.5 48 224l0-40z"
    ]
};
var $159afdcd077ecfe9$export$dc1083dcd1d7b9d6 = {
    prefix: 'fas',
    iconName: 'crown',
    icon: [
        576,
        512,
        [
            128081
        ],
        "f521",
        "M313 87.2c9.2-7.3 15-18.6 15-31.2 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 12.6 5.9 23.9 15 31.2L194.6 194.8c-10 15.7-31.3 19.6-46.2 8.4L88.9 158.7c4.5-6.4 7.1-14.3 7.1-22.7 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 21.8 17.5 39.6 39.2 40L87.8 393.5c4.7 31.3 31.6 54.5 63.3 54.5l273.8 0c31.7 0 58.6-23.2 63.3-54.5L520.8 176c21.7-.4 39.2-18.2 39.2-40 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 8.4 2.6 16.3 7.1 22.7l-59.4 44.6c-14.9 11.2-36.2 7.3-46.2-8.4L313 87.2z"
    ]
};
var $159afdcd077ecfe9$export$89af87b7d6c15adf = {
    prefix: 'fas',
    iconName: 'tent-arrow-turn-left',
    icon: [
        512,
        512,
        [],
        "e580",
        "M-.5 113l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 350.1 0c22.1 0 40 17.9 40 40l0 24c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24c0-48.6-39.4-88-88-88l-350.1 0 31-31c9.4-9.4 9.4-24.6 0-33.9S80.9-2.3 71.5 7L-.5 79c-9.4 9.4-9.4 24.6 0 33.9zM60.3 292.6L37.1 476c-2.4 19.1 12.5 36 31.7 36l154.5 0c17.7 0 32-14.3 32-32l0-117.4c0-5.9 4.7-10.6 10.6-10.6 4 0 7.7 2.3 9.5 5.9l68.2 136.5c5.4 10.8 16.5 17.7 28.6 17.7l71.9 0c19.3 0 34.2-16.9 31.7-36L452.7 292.7c-1.2-9.7-6.9-18.4-15.3-23.4L271.9 169.9c-10.2-6.1-22.9-6.1-33.1 .1L75.4 269.3c-8.3 5.1-13.9 13.7-15.1 23.3z"
    ]
};
var $159afdcd077ecfe9$export$27de16299ddd171 = {
    prefix: 'fas',
    iconName: 'truck-fast',
    icon: [
        640,
        512,
        [
            "shipping-fast"
        ],
        "f48b",
        "M64 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 32 50.7 0c17 0 33.3 6.7 45.3 18.7L621.3 192c12 12 18.7 28.3 18.7 45.3L640 384c0 35.3-28.7 64-64 64l-3.3 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-102.6 0c-10.4 36.9-44.4 64-84.7 64s-74.2-27.1-84.7-64l-3.3 0c-35.3 0-64-28.7-64-64l0-48-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 240c-13.3 0-24-10.7-24-24s10.7-24 24-24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 144c-13.3 0-24-10.7-24-24S10.7 96 24 96l40 0zM576 288l0-50.7-45.3-45.3-50.7 0 0 96 96 0zM256 424a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm232 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $159afdcd077ecfe9$export$5e419f47aaeb3c05 = $159afdcd077ecfe9$export$27de16299ddd171;
var $159afdcd077ecfe9$export$3842882ea09b25af = {
    prefix: 'fas',
    iconName: 'user-pen',
    icon: [
        640,
        512,
        [
            "user-edit"
        ],
        "f4ff",
        "M256.1 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm-29.7 56c-98.5 0-178.3 79.8-178.3 178.3 0 16.4 13.3 29.7 29.7 29.7l196.5 0 10.9-54.5c4.3-21.7 15-41.6 30.6-57.2l67.3-67.3c-28-18.3-61.4-28.9-97.4-28.9l-59.4 0zM332.3 466.9l-11.9 59.6c-.2 .9-.3 1.9-.3 2.9 0 8 6.5 14.6 14.6 14.6 1 0 1.9-.1 2.9-.3l59.6-11.9c12.4-2.5 23.8-8.6 32.7-17.5l118.9-118.9-80-80-118.9 118.9c-8.9 8.9-15 20.3-17.5 32.7zm267.8-123c22.1-22.1 22.1-57.9 0-80s-57.9-22.1-80 0l-28.8 28.8 80 80 28.8-28.8z"
    ]
};
var $159afdcd077ecfe9$export$a68a6960fc8eef82 = $159afdcd077ecfe9$export$3842882ea09b25af;
var $159afdcd077ecfe9$export$b00596a09aa07311 = {
    prefix: 'fas',
    iconName: 'user-clock',
    icon: [
        576,
        512,
        [],
        "f4fd",
        "M224 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zM194.3 304l59.4 0c3.9 0 7.9 .1 11.8 .4-16.2 28.2-25.5 60.8-25.5 95.6 0 41.8 13.4 80.5 36 112L45.7 512C29.3 512 16 498.7 16 482.3 16 383.8 95.8 304 194.3 304zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-80c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-48c0-8.8-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$f7f7c15f18cc19a1 = {
    prefix: 'fas',
    iconName: 'shower',
    icon: [
        512,
        512,
        [
            128703
        ],
        "f2cc",
        "M64 131.9c0-19.8 16.1-35.9 35.9-35.9 9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.1-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32 44.7 32 0 76.7 0 131.9L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-316.1zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$66068918abb14406 = {
    prefix: 'fas',
    iconName: 'square-caret-up',
    icon: [
        448,
        512,
        [
            "caret-square-up"
        ],
        "f151",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 160c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9S337.5 320 328 320l-208 0c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112c4.5-4.9 10.9-7.7 17.6-7.7z"
    ]
};
var $159afdcd077ecfe9$export$307ae80b26533ce5 = $159afdcd077ecfe9$export$66068918abb14406;
var $159afdcd077ecfe9$export$9a8788ec0e4a9a0b = {
    prefix: 'fas',
    iconName: 'map-location',
    icon: [
        640,
        512,
        [
            "map-marked"
        ],
        "f59f",
        "M576 48c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4L413.5 77.5 234.1 17.6c-8.1-2.7-16.8-2.1-24.4 1.7l-128 64C70.8 88.8 64 99.9 64 112l0 352c0 11.1 5.7 21.4 15.2 27.2s21.2 6.4 31.1 1.4l116.1-58.1 173.3 57.8c-4.3-6.4-8.5-13.1-12.6-19.9-11-18.3-21.9-39.3-30-61.8l-101.2-33.7 0-284.5 128 42.7 0 99.3c31-35.8 77-58.4 128-58.4 22.6 0 44.2 4.4 64 12.5L576 48zM392 341.9c0 68.9 64.1 150.4 98.6 189.3 11.6 13 31.3 13 42.9 0 34.5-38.9 98.6-120.4 98.6-189.3 0-65.1-53.7-117.9-120-117.9S392 276.8 392 341.9z"
    ]
};
var $159afdcd077ecfe9$export$df04458e7e32352c = $159afdcd077ecfe9$export$9a8788ec0e4a9a0b;
var $159afdcd077ecfe9$export$8bdfe14ac72a8b17 = {
    prefix: 'fas',
    iconName: 'pen-fancy',
    icon: [
        512,
        512,
        [
            128395,
            10002
        ],
        "f5ac",
        "M373.5 27.1c15-17.2 36.7-27.1 59.6-27.1 43.6 0 79 35.4 79 79 0 22.8-9.9 44.6-27.1 59.6L283.7 313.8 273 303 209 239 198.2 228.3 373.5 27.1zM161.1 259C162 260 188 286 239 337l13.9 13.9-17.1 74.2c-3.9 17.1-16.9 30.7-33.8 35.4l-169.8 47.5 92.3-92.3c1.2 .1 2.3 .2 3.5 .2 17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32c0 1.2 .1 2.4 .2 3.5L3.9 479.8 51.5 310c4.7-16.9 18.3-29.9 35.4-33.8L161.1 259z"
    ]
};
var $159afdcd077ecfe9$export$902a3969bb113dff = {
    prefix: 'fas',
    iconName: 'euro-sign',
    icon: [
        448,
        512,
        [
            8364,
            "eur",
            "euro"
        ],
        "f153",
        "M73.3 192C100.8 99.5 186.5 32 288 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-65.6 0-122 39.5-146.7 96L272 192c13.3 0 24 10.7 24 24s-10.7 24-24 24l-143.2 0c-.5 5.3-.8 10.6-.8 16s.3 10.7 .8 16L272 272c13.3 0 24 10.7 24 24s-10.7 24-24 24l-130.7 0c24.7 56.5 81.1 96 146.7 96l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-101.5 0-187.2-67.5-214.7-160L40 320c-13.3 0-24-10.7-24-24s10.7-24 24-24l24.6 0c-.7-10.5-.7-21.5 0-32L40 240c-13.3 0-24-10.7-24-24s10.7-24 24-24l33.3 0z"
    ]
};
var $159afdcd077ecfe9$export$4b859160cfeb12ff = $159afdcd077ecfe9$export$902a3969bb113dff;
var $159afdcd077ecfe9$export$bdabbefede2d3a2 = $159afdcd077ecfe9$export$902a3969bb113dff;
var $159afdcd077ecfe9$export$423555e8708eb4c7 = {
    prefix: 'fas',
    iconName: 'house-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e50b",
        "M496 544a144 144 0 1 1 0-288 144 144 0 1 1 0 288zM268.6 6.5c12.2-9.3 29.7-8.7 41.2 2l217.6 202c-10.2-1.7-20.7-2.6-31.3-2.6-78.6 0-146.2 47.2-175.9 114.8-5-1.8-10.5-2.8-16.1-2.8l-32 0c-26.5 0-48 21.5-48 48l0 96 90.9 0c6.1 17.3 14.6 33.4 25.2 48L144 512c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208 2.4-2zM555.3 340.7c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-36.7-36.7 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"
    ]
};
var $159afdcd077ecfe9$export$f0f37dbc60110b10 = {
    prefix: 'fas',
    iconName: 'lira-sign',
    icon: [
        384,
        512,
        [
            8356
        ],
        "f195",
        "M84.9 256l-28.4 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l11.6 0C53.2 124.7 116.8 42 207.6 42l8.2 0c33.6 0 66.2 11.3 92.5 32.2l16.1 12.7c13.9 11 16.2 31.1 5.2 45s-31.1 16.2-45 5.2l-16.1-12.7c-15-11.9-33.6-18.4-52.8-18.4l-8.2 0c-53.8 0-90.1 52.9-73.5 102l162.4 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-145.1 0c2.3 10.6 3.6 21.3 3.9 32l141.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L150 336c-4.8 18.6-12.6 36.5-23.6 52.9l-18.1 27.1 212.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-272 0c-11.8 0-22.6-6.5-28.2-16.9s-5-23 1.6-32.9l51.2-76.8c3.7-5.6 6.9-11.4 9.4-17.4l-26 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l34.8 0c-.5-10.8-2.6-21.6-6.4-32z"
    ]
};
var $159afdcd077ecfe9$export$30f1437f5a4e991d = {
    prefix: 'fas',
    iconName: 'yen-sign',
    icon: [
        384,
        512,
        [
            165,
            "cny",
            "jpy",
            "rmb",
            "yen"
        ],
        "f157",
        "M74.9 46.7c-9.6-14.9-29.4-19.2-44.2-9.6S11.5 66.4 21.1 81.3L143.7 272 88 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 0 32-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0 0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-32 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-55.7 0 122.6-190.7c9.6-14.9 5.3-34.7-9.6-44.2s-34.7-5.3-44.2 9.6L192 228.8 74.9 46.7z"
    ]
};
var $159afdcd077ecfe9$export$268a23eee8f089a2 = $159afdcd077ecfe9$export$30f1437f5a4e991d;
var $159afdcd077ecfe9$export$5460a9192eb79bf5 = $159afdcd077ecfe9$export$30f1437f5a4e991d;
var $159afdcd077ecfe9$export$e2a8016afc962883 = $159afdcd077ecfe9$export$30f1437f5a4e991d;
var $159afdcd077ecfe9$export$cf914b1afb9455a2 = $159afdcd077ecfe9$export$30f1437f5a4e991d;
var $159afdcd077ecfe9$export$9010ed816a8b9c97 = {
    prefix: 'fas',
    iconName: 'box-open',
    icon: [
        640,
        512,
        [],
        "f49e",
        "M560.3 237.2c10.4 11.8 28.3 14.4 41.8 5.5 14.7-9.8 18.7-29.7 8.9-44.4l-48-72c-2.8-4.2-6.6-7.7-11.1-10.2L351.4 4.7c-19.3-10.7-42.8-10.7-62.2 0L88.8 116c-5.4 3-9.7 7.4-12.6 12.8L27.7 218.7c-12.6 23.4-3.8 52.5 19.6 65.1l33 17.7 0 53.3c0 23 12.4 44.3 32.4 55.7l176 99.7c19.6 11.1 43.5 11.1 63.1 0l176-99.7c20.1-11.4 32.4-32.6 32.4-55.7l0-117.5zm-240-9.8L170.2 144 320.3 60.6 470.4 144 320.3 227.4zm-41.5 50.2l-21.3 46.2-165.8-88.8 25.4-47.2 161.7 89.8z"
    ]
};
var $159afdcd077ecfe9$export$f4419f7b2e53b340 = {
    prefix: 'fas',
    iconName: 'truck-field',
    icon: [
        640,
        512,
        [],
        "e58d",
        "M32 96c0-35.3 28.7-64 64-64l224 0c23.7 0 44.4 12.9 55.4 32l40.4 0c32.4 0 61.6 19.6 74 49.5l43.8 106.3 1.7 4.2 24.7 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-.4 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8l-144.7 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-3.6 .2-7.1 .6-10.5-19-6.4-32.6-24.4-32.6-45.5l0-48c-17.7 0-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32l0-32zm352 32l0 96 82.1 0-35.4-86.1c-2.5-6-8.3-9.9-14.8-9.9L384 128zM192 392a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm280 40a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $159afdcd077ecfe9$export$db853fbb474326cc = {
    prefix: 'fas',
    iconName: 'location-pin-lock',
    icon: [
        512,
        512,
        [],
        "e51f",
        "M0 188.6C0 84.4 86 0 192 0 294.1 0 377.6 78.3 383.6 177 320.7 185.1 272 238.8 272 304l0 24.4c-19.6 17.6-32 43.1-32 71.5l0 75.7c-9.9 11.6-18.9 21.7-26.4 29.8-11.8 12.8-31.5 12.8-43.3 0-50.2-54.5-170.4-197.5-170.4-316.8zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm240 48.1c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM288 400c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
var $159afdcd077ecfe9$export$8ecd436ef91fc02e = {
    prefix: 'fas',
    iconName: 'person-praying',
    icon: [
        384,
        512,
        [
            128720,
            "pray"
        ],
        "f683",
        "M320 64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM200.7 264l22.9 31.5c6.5 8.9 16.3 14.7 27.2 16.1s21.9-1.7 30.4-8.7l88-72c17.1-14 19.6-39.2 5.6-56.3s-39.2-19.6-56.3-5.6l-55.2 45.2-26.2-36c-15.6-21.5-40.6-34.2-67.2-34.2-30.9 0-59.2 17.1-73.6 44.4L47.8 280.9c-20.2 38.5-9.4 85.9 25.6 111.8L126.6 432 40 432c-22.1 0-40 17.9-40 40s17.9 40 40 40l208 0c17.3 0 32.6-11.1 38-27.5s-.3-34.4-14.2-44.7l-116.1-85.8 45-90z"
    ]
};
var $159afdcd077ecfe9$export$3b32c982141cad51 = $159afdcd077ecfe9$export$8ecd436ef91fc02e;
var $159afdcd077ecfe9$export$2c5a9d8548d8810e = {
    prefix: 'fas',
    iconName: 'clipboard-list',
    icon: [
        384,
        512,
        [],
        "f46d",
        "M311.4 32l8.6 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l8.6 0C83.6 12.9 104.3 0 128 0L256 0c23.7 0 44.4 12.9 55.4 32zM248 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 0c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24zm0 128c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24zM96 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$15854c4475080853 = {
    prefix: 'fas',
    iconName: 'sack-dollar',
    icon: [
        512,
        512,
        [
            128176
        ],
        "f81d",
        "M328 112l-144 0-37.3-74.5c-1.8-3.6-2.7-7.6-2.7-11.6 0-14.3 11.6-25.9 25.9-25.9L342.1 0c14.3 0 25.9 11.6 25.9 25.9 0 4-.9 8-2.7 11.6L328 112zM169.6 160l172.8 0 48.7 40.6C457.6 256 496 338 496 424.5 496 472.8 456.8 512 408.5 512l-305.1 0C55.2 512 16 472.8 16 424.5 16 338 54.4 256 120.9 200.6L169.6 160zM260 224c-11 0-20 9-20 20l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L216 384c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20z"
    ]
};
var $159afdcd077ecfe9$export$af9eaee7db3ba7a9 = {
    prefix: 'fas',
    iconName: 'mountain-sun',
    icon: [
        576,
        512,
        [],
        "e52f",
        "M256.5 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5-7.2 12.1-20.3 19.5-34.3 19.5l-432 0c-14.1 0-27.1-7.4-34.3-19.5s-7.5-27.1-.8-39.5l216-400 2.9-4.6C231.7 6.2 243.6 0 256.5 0zM170.4 249.9l26.8 26.8c6.2 6.2 16.4 6.2 22.6 0l43.3-43.3c6-6 14.1-9.4 22.6-9.4l42.8 0-72.1-133.5-86.1 159.4zM496.5 160a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
    ]
};
var $159afdcd077ecfe9$export$63f4908401ded049 = {
    prefix: 'fas',
    iconName: 'arrow-up-wide-short',
    icon: [
        576,
        512,
        [
            "sort-amount-up"
        ],
        "f161",
        "M150.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 141.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM320 480l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32zm0-128l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $159afdcd077ecfe9$export$28ef3e933e4b5364 = $159afdcd077ecfe9$export$63f4908401ded049;
var $159afdcd077ecfe9$export$d7e538fddb81da68 = {
    prefix: 'fas',
    iconName: 'users-line',
    icon: [
        576,
        512,
        [],
        "e592",
        "M224 128a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM176 336c0-61.9 50.1-112 112-112s112 50.1 112 112l0 8c0 13.3-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24l0-8zM392 144a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm27.2 100.4c9.1-2.9 18.8-4.4 28.8-4.4 53 0 96 43 96 96l0 10.7c0 11.8-9.6 21.3-21.3 21.3l-78.8 0c2.7-7.5 4.1-15.6 4.1-24l0-8c0-34.1-10.6-65.7-28.8-91.6zm-262.4 0c-18.2 26-28.8 57.5-28.8 91.6l0 8c0 8.4 1.4 16.5 4.1 24l-78.8 0C41.6 368 32 358.4 32 346.7L32 336c0-53 43-96 96-96 10 0 19.7 1.5 28.8 4.4zM72 144a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM0 440c0-13.3 10.7-24 24-24l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 464c-13.3 0-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$f823fee3712b2601 = {
    prefix: 'fas',
    iconName: 'star-of-david',
    icon: [
        512,
        512,
        [
            10017
        ],
        "f69a",
        "M415.9 311.9l-27.8 48.1 55.7 0-27.8-48.1zM383.6 256l-60.2-104-134.8 0-60.2 104 60.2 104 134.8 0 60.2-104zm64.7 0l58.4 100.9c3.5 6 5.3 12.8 5.3 19.7 0 21.7-17.6 39.4-39.4 39.4l-117 0-61.3 105.8C286.5 535.6 271.8 544 256 544s-30.5-8.4-38.4-22.2l-61.3-105.8-117 0c-21.7 0-39.4-17.6-39.4-39.4 0-6.9 1.8-13.7 5.3-19.7L63.7 256 5.3 155.1C1.8 149.1 0 142.3 0 135.4 0 113.6 17.6 96 39.4 96l117 0 61.3-105.8C225.5-23.6 240.2-32 256-32s30.5 8.4 38.4 22.2l61.3 105.8 117 0c21.7 0 39.4 17.6 39.4 39.4 0 6.9-1.8 13.7-5.3 19.7L448.3 256zM388.1 152l27.8 48.1 27.8-48.1-55.7 0zM291 96l-35-60.4-35 60.4 70 0zM123.9 152l-55.7 0 27.8 48.1 27.8-48.1zM96.1 311.9l-27.8 48.1 55.7 0-27.8-48.1zM221 416l35 60.4 35-60.4-70 0z"
    ]
};
var $159afdcd077ecfe9$export$b2d79133c81d6697 = {
    prefix: 'fas',
    iconName: 'notes-medical',
    icon: [
        512,
        512,
        [],
        "f481",
        "M96 352c0 35.3 28.7 64 64 64l181.5 0c17 0 33.3-6.7 45.3-18.7L493.3 290.7c12-12 18.7-28.3 18.7-45.3L512 64c0-35.3-28.7-64-64-64L160 0C124.7 0 96 28.7 96 64l0 288zM288 112l32 0c8.8 0 16 7.2 16 16l0 48 48 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-48 0 0 48c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-48-48 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l48 0 0-48c0-8.8 7.2-16 16-16zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 448c0 35.3 28.7 64 64 64l264 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L64 464c-8.8 0-16-7.2-16-16l0-328z"
    ]
};
var $159afdcd077ecfe9$export$299c200ad3db97b4 = {
    prefix: 'fas',
    iconName: 'austral-sign',
    icon: [
        448,
        512,
        [],
        "e0a9",
        "M266.5 240l-85 0 42.5-106.4 42.5 106.4zm68.9 0L262.9 58.3C256.5 42.4 241.1 32 224 32s-32.5 10.4-38.9 26.3L112.6 240 32 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l61.4 0-19.2 48-42.3 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l23.1 0-20.8 52.1c-6.6 16.4 1.4 35 17.9 41.6s35-1.4 41.6-17.9l30.3-75.9 200 0 30.3 75.9c6.6 16.4 25.2 24.4 41.6 17.9s24.4-25.2 17.9-41.6L392.9 384 416 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-42.3 0-19.2-48 61.4 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80.6 0zm-49.7 48l19.2 48-161.6 0 19.2-48 123.3 0z"
    ]
};
var $159afdcd077ecfe9$export$1204f2d171424659 = {
    prefix: 'fas',
    iconName: 'clipboard-user',
    icon: [
        384,
        512,
        [],
        "f7f3",
        "M311.4 32l8.6 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l8.6 0C83.6 12.9 104.3 0 128 0L256 0c23.7 0 44.4 12.9 55.4 32zM248 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0zM192 344a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM98.3 413c-12.9 15.6 2.2 35 22.4 35l142.5 0c20.2 0 35.3-19.4 22.4-35-14.7-17.7-36.9-29-61.7-29l-64 0c-24.8 0-47 11.3-61.7 29z"
    ]
};
var $159afdcd077ecfe9$export$6440b286d3cbac9b = {
    prefix: 'fas',
    iconName: 'file-image',
    icon: [
        384,
        512,
        [
            128443
        ],
        "f1c5",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM128 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM92.6 448l198.8 0c15.8 0 28.6-12.8 28.6-28.6 0-7.3-2.8-14.4-7.9-19.7L215.3 297.9c-6-6.3-14.4-9.9-23.2-9.9l-.3 0c-8.8 0-17.1 3.6-23.2 9.9L71.9 399.7C66.8 405 64 412.1 64 419.4 64 435.2 76.8 448 92.6 448z"
    ]
};
var $159afdcd077ecfe9$export$5b1d41cdd118ea6d = {
    prefix: 'fas',
    iconName: 'square-caret-right',
    icon: [
        448,
        512,
        [
            "caret-square-right"
        ],
        "f152",
        "M448 96c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320zM320 256c0 6.7-2.8 13-7.7 17.6l-112 104c-7 6.5-17.2 8.2-25.9 4.4S160 369.5 160 360l0-208c0-9.5 5.7-18.2 14.4-22s18.9-2.1 25.9 4.4l112 104c4.9 4.5 7.7 10.9 7.7 17.6z"
    ]
};
var $159afdcd077ecfe9$export$ae86c9de7e0f62fa = $159afdcd077ecfe9$export$5b1d41cdd118ea6d;
var $159afdcd077ecfe9$export$aa014b06d2d70598 = {
    prefix: 'fas',
    iconName: 'vial',
    icon: [
        512,
        512,
        [
            129514
        ],
        "f492",
        "M342.6 9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L306.7 64 28.1 342.6C10.1 360.6 0 385 0 410.5L0 416c0 53 43 96 96 96l5.5 0c25.5 0 49.9-10.1 67.9-28.1l278.6-278.6 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zM205.3 256l146.7-146.7 50.7 50.7-96 96-101.5 0z"
    ]
};
var $159afdcd077ecfe9$export$612d3e1afaf45fa5 = {
    prefix: 'fas',
    iconName: 'helicopter',
    icon: [
        576,
        512,
        [
            128641
        ],
        "f533",
        "M176 32c-13.3 0-24 10.7-24 24s10.7 24 24 24l152 0 0 48-220.8 0-32.8-39.4C69.9 83.2 63.1 80 56 80L24 80C15.7 80 8 84.3 3.6 91.4s-4.8 15.9-1.1 23.4l48 96C54.6 218.9 62.9 224 72 224l107.8 0 104 143.1c15.1 20.7 39.1 32.9 64.7 32.9l75.5 0c75.1 0 136-60.9 136-136S499.1 128 424 128l-48 0 0-48 152 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L176 32zM376 192l48 0c39.8 0 72 32.2 72 72s-32.2 72-72 72l-48 0 0-144zM552 416c-13.3 0-24 10.7-24 24 0 4.4-3.6 8-8 8l-272 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c30.9 0 56-25.1 56-56 0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$5030322c5fc886d7 = {
    prefix: 'fas',
    iconName: 'mitten',
    icon: [
        448,
        512,
        [],
        "f7b5",
        "M352 384L64 384 5.4 178.9C1.8 166.4 0 153.4 0 140.3 0 62.8 62.8 0 140.3 0l3.4 0c66 0 123.5 44.9 139.5 108.9l31.4 125.8 17.6-20.1C344.8 200.2 362.9 192 382 192l2.8 0c34.9 0 63.3 28.3 63.3 63.3 0 15.9-6 31.2-16.8 42.9L352 384zM32 464c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 16c0 17.7-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32l0-16z"
    ]
};
var $159afdcd077ecfe9$export$84666c793cb2a347 = {
    prefix: 'fas',
    iconName: 'gas-pump',
    icon: [
        512,
        512,
        [
            9981
        ],
        "f52f",
        "M32 64C32 28.7 60.7 0 96 0L256 0c35.3 0 64 28.7 64 64l0 192 8 0c48.6 0 88 39.4 88 88l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-154c-27.6-7.1-48-32.2-48-62l0-59.5-25.8-28.3c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l71.7 78.8c9.4 10.3 14.6 23.7 14.6 37.7L512 376c0 39.8-32.2 72-72 72s-72-32.2-72-72l0-32c0-22.1-17.9-40-40-40l-8 0 0 161.4c9.3 3.3 16 12.2 16 22.6 0 13.3-10.7 24-24 24L40 512c-13.3 0-24-10.7-24-24 0-10.5 6.7-19.3 16-22.6L32 64zM96 80l0 96c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16L112 64c-8.8 0-16 7.2-16 16z"
    ]
};
var $159afdcd077ecfe9$export$74d890536dbd21b7 = {
    prefix: 'fas',
    iconName: 'envelope-circle-check',
    icon: [
        640,
        512,
        [],
        "e4e8",
        "M64 112c0-26.5 21.5-48 48-48l416 0c26.5 0 48 21.5 48 48l0 81.4c-24.4-11.2-51.4-17.4-80-17.4-87.7 0-161.7 58.8-184.7 139.2-7.1-1.3-14.1-4.2-20.1-8.8l-208-156C71.1 141.3 64 127.1 64 112zM304 368c0 28.6 6.2 55.6 17.4 80L128 448c-35.3 0-64-28.7-64-64l0-188 198.4 148.8c12.6 9.4 26.9 15.4 41.7 17.9 0 1.8-.1 3.5-.1 5.3zm48 0a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm201.4-60.9c-7.1-5.2-17.2-3.6-22.4 3.5l-53 72.9-26.8-26.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c3.3 3.3 7.9 5 12.6 4.6s8.9-2.8 11.7-6.5l64-88c5.2-7.1 3.6-17.2-3.5-22.3z"
    ]
};
var $159afdcd077ecfe9$export$f3854553fe688388 = {
    prefix: 'fas',
    iconName: 'person-skating',
    icon: [
        512,
        512,
        [
            "skating"
        ],
        "f7c5",
        "M368 56a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM128 128c0-17.7 14.3-32 32-32l150.1 0c49.9 0 74.9 60.3 39.6 95.6l-63.9 63.9 69.8 31c17.3 7.7 28.5 24.9 28.5 43.9l0 85.6c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-75.2-82.4-36.6c-41-18.2-51-72-19.3-103.7l40.4-40.4-98.7 0c-17.7 0-32-14.3-32-32zM89.4 361.4l75.9-75.9c7.7 19.7 21.6 37.3 41 49.6l-71.6 71.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zm346.5 87.1c8.6 2.1 13.8 10.8 11.6 19.4l-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4L304 512c-8.8 0-16-7.2-16-16s7.2-16 16-16l88.8 0c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6zM143.2 486.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L12.7 419.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
    ]
};
var $159afdcd077ecfe9$export$21bd1d54bd4f2c5a = $159afdcd077ecfe9$export$f3854553fe688388;
var $159afdcd077ecfe9$export$2fa35dcbc038dbe9 = {
    prefix: 'fas',
    iconName: 'sun',
    icon: [
        576,
        512,
        [
            9728
        ],
        "f185",
        "M178.2-10.1c7.4-3.1 15.8-2.2 22.5 2.2l87.8 58.2 87.8-58.2c6.7-4.4 15.1-5.2 22.5-2.2S411.4-.5 413 7.3l20.9 103.2 103.2 20.9c7.8 1.6 14.4 7 17.4 14.3s2.2 15.8-2.2 22.5l-58.2 87.8 58.2 87.8c4.4 6.7 5.2 15.1 2.2 22.5s-9.6 12.8-17.4 14.3L433.8 401.4 413 504.7c-1.6 7.8-7 14.4-14.3 17.4s-15.8 2.2-22.5-2.2l-87.8-58.2-87.8 58.2c-6.7 4.4-15.1 5.2-22.5 2.2s-12.8-9.6-14.3-17.4L143 401.4 39.7 380.5c-7.8-1.6-14.4-7-17.4-14.3s-2.2-15.8 2.2-22.5L82.7 256 24.5 168.2c-4.4-6.7-5.2-15.1-2.2-22.5s9.6-12.8 17.4-14.3L143 110.6 163.9 7.3c1.6-7.8 7-14.4 14.3-17.4zM207.6 256a80.4 80.4 0 1 1 160.8 0 80.4 80.4 0 1 1 -160.8 0zm208.8 0a128.4 128.4 0 1 0 -256.8 0 128.4 128.4 0 1 0 256.8 0z"
    ]
};
var $159afdcd077ecfe9$export$dc3654cf8a596fbf = {
    prefix: 'fas',
    iconName: 'baseball',
    icon: [
        512,
        512,
        [
            129358,
            9918,
            "baseball-ball"
        ],
        "f433",
        "M232.4 1.1c-122.2 11.4-219.5 108.7-230.9 230.9 16.2-.1 32-1.8 47.2-5 13-2.7 25.7 5.5 28.4 18.5s-5.5 25.7-18.5 28.4c-18.4 3.9-37.6 6-57.1 6.1 11.4 122.2 108.7 219.5 230.9 230.9 .1-19.5 2.2-38.7 6.1-57.1 2.7-13 15.5-21.3 28.4-18.5s21.3 15.5 18.5 28.4c-3.2 15.2-4.9 31-5 47.2 122.2-11.4 219.5-108.7 230.9-230.9-16.2 .1-32 1.8-47.2 5-13 2.7-25.7-5.5-28.4-18.5s5.5-25.7 18.5-28.4c18.4-3.9 37.6-6 57.1-6.1-11.4-122.2-108.7-219.5-230.9-230.9-.1 19.5-2.2 38.7-6.1 57.1-2.7 13-15.5 21.3-28.4 18.5s-21.3-15.5-18.5-28.4c3.2-15.2 4.9-31 5-47.2zm2.8 151.4c-21.4 32.9-49.5 60.9-82.3 82.3-11.1 7.2-26 4.1-33.2-7s-4.1-26 7-33.2c27.2-17.7 50.5-41 68.3-68.3 7.2-11.1 22.1-14.3 33.2-7s14.3 22.1 7 33.2zM393.1 284.2c7.2 11.1 4.1 26-7 33.2-27.2 17.7-50.5 41-68.3 68.3-7.2 11.1-22.1 14.3-33.2 7s-14.3-22.1-7-33.2c21.4-32.9 49.5-60.9 82.3-82.3 11.1-7.2 26-4.1 33.2 7z"
    ]
};
var $159afdcd077ecfe9$export$63a3f8ceae07c7f3 = $159afdcd077ecfe9$export$dc3654cf8a596fbf;
var $159afdcd077ecfe9$export$7e9f0928967e03b = {
    prefix: 'fas',
    iconName: 'image',
    icon: [
        448,
        512,
        [],
        "f03e",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM272 224c8.4 0 16.1 4.4 20.5 11.5l88 144c4.5 7.4 4.7 16.7 .5 24.3S368.7 416 360 416L88 416c-8.9 0-17.2-5-21.3-12.9s-3.5-17.5 1.6-24.8l56-80c4.5-6.4 11.8-10.2 19.7-10.2s15.2 3.8 19.7 10.2l26.4 37.8 61.4-100.5c4.4-7.1 12.1-11.5 20.5-11.5z"
    ]
};
var $159afdcd077ecfe9$export$3db5bca65a1be8dc = {
    prefix: 'fas',
    iconName: 'notdef',
    icon: [
        384,
        512,
        [],
        "e1fe",
        "M64 390.3L153.5 256 64 121.7 64 390.3zM102.5 448L281.5 448 192 313.7 102.5 448zm128-192L320 390.3 320 121.7 230.5 256zM281.5 64L102.5 64 192 198.3 281.5 64zM0 48C0 21.5 21.5 0 48 0L336 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 48z"
    ]
};
var $159afdcd077ecfe9$export$44dee69e3a29b0e = {
    prefix: 'fas',
    iconName: 'basketball',
    icon: [
        512,
        512,
        [
            127936,
            "basketball-ball"
        ],
        "f434",
        "M92.7 58.8l78.4 78.4c18.2-25 28.9-55.9 28.9-89.2 0-14.1-1.9-27.7-5.5-40.6-38 9.4-72.6 27.2-101.8 51.4zM58.8 92.7c-24.2 29.2-42 63.8-51.4 101.8 12.9 3.6 26.5 5.5 40.6 5.5 33.3 0 64.1-10.7 89.2-28.9L58.8 92.7zM256 0c-4.6 0-9.2 .1-13.7 .4 3.7 15.3 5.7 31.2 5.7 47.6 0 46.6-15.9 89.4-42.6 123.4L256 222.1 419.3 58.8C374.9 22.1 318.1 0 256 0zM48 248c-16.4 0-32.4-2-47.6-5.7-.2 4.5-.4 9.1-.4 13.7 0 62.1 22.1 118.9 58.8 163.3L222.1 256 171.4 205.4C137.4 232.1 94.6 248 48 248zm463.6 21.7c.2-4.5 .4-9.1 .4-13.7 0-62.1-22.1-118.9-58.8-163.3L289.9 256 340.6 306.6c34-26.7 76.9-42.6 123.4-42.6 16.4 0 32.4 2 47.6 5.7zm-7.1 47.8c-12.9-3.6-26.5-5.5-40.6-5.5-33.3 0-64.1 10.7-89.2 28.9l78.4 78.4c24.2-29.2 42-63.8 51.4-101.8zM340.9 374.8c-18.2 25-28.9 55.9-28.9 89.2 0 14.1 1.9 27.7 5.5 40.6 38-9.4 72.6-27.2 101.8-51.4l-78.4-78.4zm-34.3-34.3L256 289.9 92.7 453.2c44.3 36.7 101.2 58.8 163.3 58.8 4.6 0 9.2-.1 13.7-.4-3.7-15.3-5.7-31.2-5.7-47.6 0-46.6 15.9-89.4 42.6-123.4z"
    ]
};
var $159afdcd077ecfe9$export$36550ab8ffcc5b28 = $159afdcd077ecfe9$export$44dee69e3a29b0e;
var $159afdcd077ecfe9$export$c72de95adaca18b8 = {
    prefix: 'fas',
    iconName: 'pencil',
    icon: [
        512,
        512,
        [
            9999,
            61504,
            "pencil-alt"
        ],
        "f303",
        "M36.4 353.2c4.1-14.6 11.8-27.9 22.6-38.7l181.2-181.2 33.9-33.9c16.6 16.6 51.3 51.3 104 104l33.9 33.9-33.9 33.9-181.2 181.2c-10.7 10.7-24.1 18.5-38.7 22.6L30.4 510.6c-8.3 2.3-17.3 0-23.4-6.2S-1.4 489.3 .9 481L36.4 353.2zm55.6-3.7c-4.4 4.7-7.6 10.4-9.3 16.6l-24.1 86.9 86.9-24.1c6.4-1.8 12.2-5.1 17-9.7L91.9 349.5zm354-146.1c-16.6-16.6-51.3-51.3-104-104L308 65.5C334.5 39 349.4 24.1 352.9 20.6 366.4 7 384.8-.6 404-.6S441.6 7 455.1 20.6l35.7 35.7C504.4 69.9 512 88.3 512 107.4s-7.6 37.6-21.2 51.1c-3.5 3.5-18.4 18.4-44.9 44.9z"
    ]
};
var $159afdcd077ecfe9$export$8210adc172262df = $159afdcd077ecfe9$export$c72de95adaca18b8;
var $159afdcd077ecfe9$export$5a200e8504b7367a = {
    prefix: 'fas',
    iconName: 'person-walking-arrow-loop-left',
    icon: [
        640,
        512,
        [],
        "e551",
        "M160 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM73.4 227.9l22.6-22.6 0 69.3c0 28 12.2 54.7 33.5 72.9l71.4 61.2c5.9 5.1 9.8 12.1 10.9 19.8l12.6 88.1c2.5 17.5 18.7 29.7 36.2 27.2s29.7-18.7 27.2-36.2l-12.6-88.1c-3.3-23.1-14.9-44.1-32.6-59.3l-34.5-29.6 0-115.2 3.8 4.7c18.2 22.8 45.8 36 75 36l33.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-33.2 0c-9.7 0-18.9-4.4-25-12l-17.9-22.4c-23-28.8-57.9-45.6-94.8-45.6-32.2 0-63.1 12.8-85.8 35.6L28.1 182.6C10.1 200.6 0 225 0 250.5L0 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-37.5c0-8.5 3.4-16.6 9.4-22.6zM85.8 407.3c-1.5 5.2-4.3 10-8.1 13.8L9.4 489.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.3-68.3c11.5-11.5 19.9-25.8 24.4-41.5l2.2-7.6-46-39.4c-2.5-2.2-5-4.4-7.4-6.8L85.8 407.3zM359 335c-9.4 9.4-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-31-31 102.1 0c1.2 0 2.4-.1 3.5-.3 56.1-3.9 100.5-50.6 100.5-107.7 0-59.6-48.4-108-108-108l-92 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l92 0c33.1 0 60 26.9 60 60s-26.9 60-60 60l-98.1 0 31-31c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-72 72z"
    ]
};
var $159afdcd077ecfe9$export$3397c7b4679acccc = {
    prefix: 'fas',
    iconName: 'dice-six',
    icon: [
        448,
        512,
        [
            9861
        ],
        "f526",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$52783a541b1bb03 = {
    prefix: 'fas',
    iconName: 'angles-down',
    icon: [
        384,
        512,
        [
            "angle-double-down"
        ],
        "f103",
        "M214.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 402.7 329.4 265.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-160 160zm160-352l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L192 210.7 329.4 73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
var $159afdcd077ecfe9$export$fd504117f273ca92 = $159afdcd077ecfe9$export$52783a541b1bb03;
var $159afdcd077ecfe9$export$1aa9423ec6b1d609 = {
    prefix: 'fas',
    iconName: 'syringe',
    icon: [
        576,
        512,
        [
            128137
        ],
        "f48e",
        "M497.5-17c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l15 15-46.1 46.1-63-63c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l7 7-78.1 78.1 41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-41-41-46.1 46.1 41 41c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-41-41-37.7 37.7c-10.5 10.5-16.4 24.7-16.4 39.6l0 88.8-57 57c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l57-57 88.8 0c14.9 0 29.1-5.9 39.6-16.4l229.7-229.7 7 7c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-63-63 46.1-46.1 15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-64-64z"
    ]
};
var $159afdcd077ecfe9$export$79d4dac715a51fdf = {
    prefix: 'fas',
    iconName: 'wheat-awn',
    icon: [
        576,
        512,
        [
            "wheat-alt"
        ],
        "e2cd",
        "M79.7 234.6c6.2-4.1 14.7-3.4 20.1 2.1l46.1 46.1 6.1 6.7c19.7 23.8 26.3 55 19.2 83.9 31.7-7.7 66.2 1 90.6 25.3l46.1 46.1c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-37.5 37.5-98.3 37.5-135.8 0L134.1 444.3 49.4 529c-9.4 9.4-24.5 9.4-33.9 0-9.4-9.4-9.4-24.6 0-33.9l84.7-84.7-30.5-30.5c-37.5-37.5-37.5-98.3 0-135.7l7.4-7.4 2.5-2.1zm104-104c6.2-4.1 14.7-3.4 20.1 2.1l46.1 46.1 6.1 6.7c19.7 23.8 26.3 55 19.2 83.9 31.7-7.7 66.2 1 90.6 25.3l46.1 46.1c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-37.5 37.5-98.3 37.5-135.8 0l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.7l7.4-7.4 2.5-2.1zM495.2 15c9.4-9.4 24.6-9.4 34 0 8.8 8.8 9.3 22.7 1.6 32.2L529.2 49 414.7 163.4c7.7 1 15.2 3 22.5 5.9L495.5 111c9.4-9.4 24.6-9.4 34 0 8.8 8.8 9.3 22.7 1.6 32.1l-1.7 1.8-52.7 52.7 39 39c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4c-37.5 37.5-98.3 37.5-135.8 0l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.7l7.4-7.4 2.5-2.1c6.2-4.1 14.7-3.4 20.1 2.1l39 39 52.7-52.7c9.4-9.4 24.6-9.4 34 0 8.8 8.8 9.3 22.7 1.6 32.1l-1.7 1.8-58.3 58.3c2.8 7.1 4.7 14.5 5.7 22.1L495.2 15z"
    ]
};
var $159afdcd077ecfe9$export$deaf03a29aa05e3a = $159afdcd077ecfe9$export$79d4dac715a51fdf;
var $159afdcd077ecfe9$export$a5f2976a01fdc970 = {
    prefix: 'fas',
    iconName: 'plane-up',
    icon: [
        512,
        512,
        [],
        "e22d",
        "M200 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 173.6 159.2c6.6 6.1 10.4 14.6 10.4 23.6l0 43.7c0 10.9-10.7 18.6-21.1 15.2l-162.9-54.3 0 99.7 66 52.8c3.8 3 6 7.6 6 12.5l0 19.8c0 10.4-9.8 18-19.9 15.5L256 512 147.9 539c-10.1 2.5-19.9-5.1-19.9-15.5l0-19.8c0-4.9 2.2-9.5 6-12.5l66-52.8 0-99.7-162.9 54.3C26.7 396.4 16 388.7 16 377.8l0-43.7c0-9 3.8-17.5 10.4-23.6L200 151.3 200 24z"
    ]
};
var $159afdcd077ecfe9$export$70e29dd05344623e = {
    prefix: 'fas',
    iconName: 'align-center',
    icon: [
        448,
        512,
        [],
        "f037",
        "M352 64c0-17.7-14.3-32-32-32L128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32z"
    ]
};
var $159afdcd077ecfe9$export$a274b02dc75663dc = {
    prefix: 'fas',
    iconName: 'hockey-puck',
    icon: [
        512,
        512,
        [],
        "f453",
        "M256 256C114.6 256 0 213 0 160s114.6-96 256-96 256 43 256 96-114.6 96-256 96zM0 352L0 242.7c16.9 12.3 37 22.2 58.1 30.1 53 19.9 123 31.2 197.9 31.2s144.9-11.3 197.9-31.2c21.2-7.9 41.2-17.8 58.1-30.1L512 352c0 53-114.6 96-256 96S0 405 0 352z"
    ]
};
var $159afdcd077ecfe9$export$827fbb87bdbe1028 = {
    prefix: 'fas',
    iconName: 'circle-arrow-left',
    icon: [
        512,
        512,
        [
            "arrow-circle-left"
        ],
        "f0a8",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM135 239l80-80c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-39 39 150.1 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-150.1 0 39 39c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-80-80c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$728262abb9f58d0a = $159afdcd077ecfe9$export$827fbb87bdbe1028;
var $159afdcd077ecfe9$export$4f3b3144ce966486 = {
    prefix: 'fas',
    iconName: 'plug-circle-bolt',
    icon: [
        640,
        512,
        [],
        "e55b",
        "M192-32c17.7 0 32 14.3 32 32l0 96 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7C165.2 398.1 96 319.1 96 224l0-64c-17.7 0-32-14.3-32-32S78.3 96 96 96l64 0 0-96c0-17.7 14.3-32 32-32zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm177.4-77c-5.8-4.2-13.8-4-19.4 .5l-80 64c-5.3 4.2-7.4 11.4-5.1 17.8S433.2 416 440 416l32.9 0-15.9 42.4c-2.5 6.7-.2 14.3 5.6 18.6s13.8 4 19.4-.5l80-64c5.3-4.2 7.4-11.4 5.1-17.8S558.8 384 552 384l-32.9 0 15.9-42.4c2.5-6.7 .2-14.3-5.6-18.6z"
    ]
};
var $159afdcd077ecfe9$export$5fbcef35138741a5 = {
    prefix: 'fas',
    iconName: 'restroom',
    icon: [
        640,
        512,
        [],
        "f7bd",
        "M80 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm40 304l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-154.8c-8.1 9.2-21.1 13.2-33.5 9.4-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C44.4 156.9 83.6 128 128 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1-12.4 3.9-25.4-.2-33.5-9.4L200 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-16 0zM320 0c13.3 0 24 10.7 24 24l0 464c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-464c0-13.3 10.7-24 24-24zM464 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM440 480l0-96-17.8 0c-10.9 0-18.6-10.7-15.2-21.1l9-26.9c-3.2 0-6.4-.5-9.5-1.5-16.9-5.3-26.3-23.2-21-40.1l29.7-95.2C428.4 156.9 467.6 128 512 128s83.6 28.9 96.8 71.2l29.7 95.2c5.3 16.9-4.1 34.8-21 40.1-3.2 1-6.4 1.5-9.5 1.5l9 26.9c3.5 10.4-4.3 21.1-15.2 21.1l-17.8 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$217195c80db39097 = {
    prefix: 'fas',
    iconName: 'anchor-lock',
    icon: [
        640,
        512,
        [],
        "e4ad",
        "M320.5 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96c-53 0-96 43-96 96 0 41.8 26.7 77.4 64 90.5l0 257.9c-62.9-14.3-110.2-69.7-111.9-136.5l16.1 14.1c10 8.7 25.1 7.7 33.9-2.3s7.7-25.1-2.3-33.9l-64-56c-9-7.9-22.6-7.9-31.6 0l-64 56c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l16.2-14.2c2.1 113.1 94.4 204.1 208 204.1 28.3 0 55.4-5.7 80-15.9l0-.2 0-72.2c-14.4 9.6-30.6 16.7-48 20.7l0-257.9c37.3-13.2 64-48.7 64-90.5 0-53-43-96-96-96zm272 304.1l0 47.9-64 0 0-47.9c0-17.7 14.3-32 32-32s32 14.3 32 32zM416.5 400l0 96c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-96c0-20.9-13.4-38.7-32-45.3l0-50.6c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 50.6c-18.6 6.6-32 24.4-32 45.3z"
    ]
};
var $159afdcd077ecfe9$export$5e239d90ef904a84 = {
    prefix: 'fas',
    iconName: 'timeline',
    icon: [
        576,
        512,
        [],
        "e29c",
        "M160 169.3c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80S48 51.8 48 96c0 32.8 19.7 61 48 73.3l0 54.7-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0 0 54.7c-28.3 12.3-48 40.5-48 73.3 0 44.2 35.8 80 80 80s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-54.7 224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-54.7c28.3-12.3 48-40.5 48-73.3 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 32.8 19.7 61 48 73.3l0 54.7-256 0 0-54.7z"
    ]
};
var $159afdcd077ecfe9$export$1e80f89fe84a215b = {
    prefix: 'fas',
    iconName: 'lightbulb',
    icon: [
        384,
        512,
        [
            128161
        ],
        "f0eb",
        "M292.9 384c7.3-22.3 21.9-42.5 38.4-59.9 32.7-34.4 52.7-80.9 52.7-132.1 0-106-86-192-192-192S0 86 0 192c0 51.2 20 97.7 52.7 132.1 16.5 17.4 31.2 37.6 38.4 59.9l201.7 0zM288 432l-192 0 0 16c0 44.2 35.8 80 80 80l32 0c44.2 0 80-35.8 80-80l0-16zM184 112c-39.8 0-72 32.2-72 72 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-66.3 53.7-120 120-120 13.3 0 24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $159afdcd077ecfe9$export$2f1e22e081a1ad05 = {
    prefix: 'fas',
    iconName: 'circle-arrow-right',
    icon: [
        512,
        512,
        [
            "arrow-circle-right"
        ],
        "f0a9",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm41-159c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-150.1 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l150.1 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80z"
    ]
};
var $159afdcd077ecfe9$export$7d3d828103aa3be7 = $159afdcd077ecfe9$export$2f1e22e081a1ad05;
var $159afdcd077ecfe9$export$808b88e8735e31e8 = {
    prefix: 'fas',
    iconName: 'mars-and-venus',
    icon: [
        512,
        512,
        [
            9893
        ],
        "f224",
        "M368 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l112 0c17.7 0 32 14.3 32 32l0 112c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.7-63 63c19.5 28.4 31 62.7 31 99.8 0 86.3-62.1 158.1-144 173.1l0 34.9 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-34.9c-81.9-15-144-86.8-144-173.1 0-97.2 78.8-176 176-176 37 0 71.4 11.4 99.8 31l63-63-34.7 0zM352 208a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z"
    ]
};
var $159afdcd077ecfe9$export$882cabd11f4943b8 = {
    prefix: 'fas',
    iconName: 'network-wired',
    icon: [
        576,
        512,
        [],
        "f6ff",
        "M248 88l80 0 0 48-80 0 0-48zm-8-56c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l16 0 0 32-224 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 32-16 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-16 0 0-32 192 0 0 32-16 0c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l96 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-16 0 0-32 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0 0-32 16 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48l-96 0zM448 376l8 0 0 48-80 0 0-48 72 0zm-256 0l8 0 0 48-80 0 0-48 72 0z"
    ]
};
var $159afdcd077ecfe9$export$18ba6a500873dba9 = {
    prefix: 'fas',
    iconName: 'building-shield',
    icon: [
        576,
        512,
        [],
        "e4d8",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l201.2 0c-12.5-14.7-23.2-30.8-31.8-48l-89.5 0 0-80c0-17.7 14.3-32 32-32l32 0 0-26.7c0-18.1 6.1-35.2 16.6-48.8-.4-1.4-.6-2.9-.6-4.5l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 1 86.7-28.9c3.1-1 6.2-1.8 9.3-2.5L416 64c0-35.3-28.7-64-64-64L96 0zm32 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM445.3 488.5l-13.3 6.3 0-188.1 96 32 0 19.6c0 55.8-32.2 106.5-82.7 130.3zM421.9 259.5l-112 37.3c-13.1 4.4-21.9 16.6-21.9 30.4l0 31.1c0 74.4 43 142.1 110.2 173.7l18.5 8.7c4.8 2.2 10 3.4 15.2 3.4s10.5-1.2 15.2-3.4l18.5-8.7C533 500.3 576 432.6 576 358.2l0-31.1c0-13.8-8.8-26-21.9-30.4l-112-37.3c-6.6-2.2-13.7-2.2-20.2 0z"
    ]
};
var $159afdcd077ecfe9$export$eba095993e51cc97 = {
    prefix: 'fas',
    iconName: 'code',
    icon: [
        576,
        512,
        [],
        "f121",
        "M360.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm64.6 136.1c-12.5 12.5-12.5 32.8 0 45.3l73.4 73.4-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0zm-274.7 0c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 150.6 182.6c12.5-12.5 12.5-32.8 0-45.3z"
    ]
};
var $159afdcd077ecfe9$export$2a9d3e120019c92d = {
    prefix: 'fas',
    iconName: 'feather-pointed',
    icon: [
        512,
        512,
        [
            "feather-alt"
        ],
        "f56b",
        "M475.3 .1c9.9-.8 19.6 3 26.6 10s10.8 16.7 10 26.6c-4 49.3-17.4 126.2-46.3 199.7-1.8 4.5-5.5 7.9-10.2 9.3L374.5 270c-3.9 1.2-6.5 4.7-6.5 8.8 0 5.1 4.1 9.2 9.2 9.2l38.6 0c12 0 19.7 12.8 13.5 23.1-4 6.7-8.3 13.2-12.7 19.6-2 2.9-5 5-8.4 6.1L310.5 366c-3.9 1.2-6.5 4.7-6.5 8.8 0 5.1 4.1 9.2 9.2 9.2l16 0c14.6 0 21 17.4 8.8 25.4-68 45-137.7 43.3-182.4 31.3-12.7-3.4-24-9.9-34.4-17.9L48 496c-8.8 8.8-23.2 8.8-32 0s-8.8-23.2 0-32l80-80 .5 .5c.7-1.3 1.6-2.5 2.7-3.6L256 224c8.8-8.8 8.8-23.2 0-32s-23.2-8.8-32 0L89.7 326.2c-8.9 8.9-24 4.4-25-8.2-4.3-53.2 9.3-123.1 72.6-186.4 91.1-91.1 254.2-124.7 337.9-131.5z"
    ]
};
var $159afdcd077ecfe9$export$68cf766c786bcd78 = $159afdcd077ecfe9$export$2a9d3e120019c92d;
var $159afdcd077ecfe9$export$877d3692c1f94bda = {
    prefix: 'fas',
    iconName: 'file-circle-question',
    icon: [
        576,
        512,
        [],
        "e4ef",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3l0-38.1c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-100c-11.6 0-21.3 8.2-23.5 19.2-1.8 8.7-10.2 14.3-18.9 12.5s-14.3-10.2-12.5-18.9c5.2-25.6 27.8-44.8 54.9-44.8 30.9 0 56 25.1 56 56 0 19.8-11.7 37.8-29.8 45.9l-10.4 4.6c-1.2 7.7-7.8 13.5-15.8 13.5-8.8 0-16-7.2-16-16 0-11.2 6.6-21.3 16.8-25.9l12.4-5.5c6.6-2.9 10.8-9.4 10.8-16.6 0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$afa7b53ac8ebcb5d = {
    prefix: 'fas',
    iconName: 'signature',
    icon: [
        640,
        512,
        [],
        "f5b7",
        "M192 128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 7.8c0 27.7-2.4 55.3-7.1 82.5l-84.4 25.3c-40.6 12.2-68.4 49.6-68.4 92l0 32.4-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72.5 0c4.2 36 34.8 64 72 64 26 0 50-13.9 62.9-36.5l13.9-24.3c26.8-47 46.5-97.7 58.4-150.5l94.4-28.3-12.5 37.5c-3.3 9.8-1.6 20.5 4.4 28.8S405.7 320 416 320l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-83.6 0 18-53.9c3.8-11.3 .9-23.8-7.4-32.4s-20.7-11.8-32.2-8.4L316.4 198.1c2.4-20.7 3.6-41.4 3.6-62.3l0-7.8c0-53-43-96-96-96s-96 43-96 96l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32zm-9.2 177l49-14.7c-10.4 33.8-24.5 66.4-42.1 97.2l-13.9 24.3c-1.5 2.6-4.3 4.3-7.4 4.3-4.7 0-8.5-3.8-8.5-8.5l0-71.9c0-14.1 9.3-26.6 22.8-30.7zM616 416c13.3 0 24-10.7 24-24s-10.7-24-24-24l-292.9 0c-6.5 16.3-13.7 32.3-21.6 48L616 416z"
    ]
};
var $159afdcd077ecfe9$export$9c4218a898614082 = {
    prefix: 'fas',
    iconName: 'earth-americas',
    icon: [
        512,
        512,
        [
            127758,
            "earth",
            "earth-america",
            "globe-americas"
        ],
        "f57d",
        "M55.7 199.7l30.9 30.9c6 6 14.1 9.4 22.6 9.4l21.5 0c8.5 0 16.6 3.4 22.6 9.4l29.3 29.3c6 6 9.4 14.1 9.4 22.6l0 37.5c0 8.5 3.4 16.6 9.4 22.6l13.3 13.3c6 6 9.4 14.1 9.4 22.6l0 18.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-2.7c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c6-6 9.4-14.1 9.4-22.6l0-34.7c0-17.7-14.3-32-32-32l-82.7 0c-8.5 0-16.6-3.4-22.6-9.4l-16-16c-4.2-4.2-6.6-10-6.6-16 0-12.5 10.1-22.6 22.6-22.6l34.7 0c12.5 0 22.6-10.1 22.6-22.6 0-6-2.4-11.8-6.6-16l-19.7-19.7C242 130 240 125.1 240 120s2-10 5.7-13.7l17.3-17.3c5.8-5.8 9.1-13.7 9.1-21.9 0-7.2-2.4-13.7-6.4-18.9-3.2-.1-6.4-.2-9.6-.2-95.4 0-175.7 64.2-200.3 151.7zM464 256c0-34.6-8.4-67.2-23.4-95.8-6.4 .9-12.7 3.9-17.9 9.1l-13.4 13.4c-6 6-9.4 14.1-9.4 22.6l0 34.7c0 17.7 14.3 32 32 32l24.1 0c2.5 0 5-.3 7.3-.8 .4-5 .5-10.1 .5-15.2zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"
    ]
};
var $159afdcd077ecfe9$export$c2118d3775773870 = $159afdcd077ecfe9$export$9c4218a898614082;
var $159afdcd077ecfe9$export$8b0f3a26397cf632 = $159afdcd077ecfe9$export$9c4218a898614082;
var $159afdcd077ecfe9$export$e96bcc7bde9498db = $159afdcd077ecfe9$export$9c4218a898614082;
var $159afdcd077ecfe9$export$28e93ec9f5e2ddf3 = {
    prefix: 'fas',
    iconName: 'carrot',
    icon: [
        640,
        512,
        [
            129365
        ],
        "f787",
        "M453.1-36.7L440.9-24.6c-31.2 31.2-31.2 81.9 0 113.1 15.6 15.6 31.2 31.2 46.9 46.9 31.2 31.2 81.9 31.2 113.1 0l12.1-12.1c6.2-6.2 6.2-16.4 0-22.6L600.9 88.6c-31.2-31.2-81.9-31.2-113.1 0 31.2-31.2 31.2-81.9 0-113.1L475.7-36.7c-6.2-6.2-16.4-6.2-22.6 0zM331.6 96c-45.2 0-87.1 20.4-115 54.3L273.3 207c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L191.6 193.2 67.2 466.8c-5.5 12.1-2.9 26.4 6.5 35.9s23.7 12 35.9 6.5l141.6-64.4-43.8-43.8c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.5 56.5 95.3-43.3c53.1-24.1 87.2-77.1 87.2-135.5 0-82.2-66.6-148.8-148.8-148.8z"
    ]
};
var $159afdcd077ecfe9$export$bf4d97a79734997f = {
    prefix: 'fas',
    iconName: 'temperature-full',
    icon: [
        320,
        512,
        [
            "temperature-4",
            "thermometer-4",
            "thermometer-full"
        ],
        "f2c7",
        "M160 0C107 0 64 43 64 96l0 164.7C34.5 287 16 325.4 16 368 16 447.5 80.5 512 160 512s144-64.5 144-144c0-42.6-18.5-81-48-107.3L256 96c0-53-43-96-96-96zm64 368c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3L136 96c0-13.3 10.7-24 24-24s24 10.7 24 24l0 212.7c23.5 9.5 40 32.5 40 59.3z"
    ]
};
var $159afdcd077ecfe9$export$db946f8dc50a57ca = $159afdcd077ecfe9$export$bf4d97a79734997f;
var $159afdcd077ecfe9$export$92b2e2293472dd50 = $159afdcd077ecfe9$export$bf4d97a79734997f;
var $159afdcd077ecfe9$export$74e07083cef79a6f = $159afdcd077ecfe9$export$bf4d97a79734997f;
var $159afdcd077ecfe9$export$2c0ab34218da6651 = {
    prefix: 'fas',
    iconName: 'table-cells-row-lock',
    icon: [
        640,
        512,
        [],
        "e67a",
        "M256 288l0-64 153.3 0c17.1-42.2 56-73.2 102.7-79l0-49c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 320c0 35.3 28.7 64 64 64l241.3 0c-.9-5.2-1.3-10.6-1.3-16.1l0-47.9-112 0 0-64 113.3 0c3.7-22 14.8-41.4 30.7-55.6l0-8.4-144 0zm0-192l192 0 0 64-192 0 0-64zM560 272.1l0 47.9-64 0 0-47.9c0-17.7 14.3-32 32-32s32 14.3 32 32zM416 368l0 96c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-96c0-20.9-13.4-38.7-32-45.3l0-50.6c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 50.6c-18.6 6.6-32 24.4-32 45.3z"
    ]
};
var $159afdcd077ecfe9$export$b16dcd08f3da1ba2 = {
    prefix: 'fas',
    iconName: 'bolt-lightning',
    icon: [
        384,
        512,
        [],
        "e0b7",
        "M0 256L28.5 28c2-16 15.6-28 31.8-28L228.9 0c15 0 27.1 12.1 27.1 27.1 0 3.2-.6 6.5-1.7 9.5L208 160 347.3 160c20.2 0 36.7 16.4 36.7 36.7 0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7l-2.9 0c-15.7 0-28.5-12.8-28.5-28.5 0-2.3 .3-4.6 .9-6.9L176 288 32 288c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$b416056e795d2eac = {
    prefix: 'fas',
    iconName: 'cloud-showers-water',
    icon: [
        512,
        512,
        [],
        "e4e4",
        "M279.2 55.7C263.9 22.8 230.6 0 192 0 139 0 96 43 96 96 60.7 96 32 124.7 32 160s28.7 64 64 64l320 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-1.6 0c-7.4-36.5-39.7-64-78.4-64-22.2 0-42.3 9.1-56.8 23.7zM410.6 476.1c20.7 15.6 46 30.7 74.2 34.5 13.1 1.8 25.2-7.5 27-20.6s-7.5-25.2-20.6-27c-15.9-2.1-33.2-11.3-51.7-25.2-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-18.5 13.9-35.8 23.1-51.7 25.2-13.1 1.8-22.4 13.8-20.6 27s13.8 22.4 27 20.6c28.2-3.8 53.6-18.9 74.2-34.5 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9c21.3-16.1 49.9-16.1 71.2 0zM100.1 303.6c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-21.3 64C29 365 35.8 378.6 48.4 382.8s26.2-2.6 30.4-15.2l21.3-64zm120 0c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-21.3 64c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l21.3-64zm112 0c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-21.3 64c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l21.3-64zm120 0c4.2-12.6-2.6-26.2-15.2-30.4s-26.2 2.6-30.4 15.2l-21.3 64c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l21.3-64z"
    ]
};
var $159afdcd077ecfe9$export$92c58defe6e4c5a7 = {
    prefix: 'fas',
    iconName: 'arrow-up-long',
    icon: [
        320,
        512,
        [
            "long-arrow-up"
        ],
        "f176",
        "M182.6-22.6c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L128 77.3 128 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-434.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128z"
    ]
};
var $159afdcd077ecfe9$export$ede1d50ec4b01670 = $159afdcd077ecfe9$export$92c58defe6e4c5a7;
var $159afdcd077ecfe9$export$6ea408c7266ed557 = {
    prefix: 'fas',
    iconName: 'address-card',
    icon: [
        576,
        512,
        [
            62140,
            "contact-card",
            "vcard"
        ],
        "f2bb",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm80 256l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16L80 384c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-24-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm240-48l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$4ac51eb0b298b190 = $159afdcd077ecfe9$export$6ea408c7266ed557;
var $159afdcd077ecfe9$export$91228257deb1bf18 = $159afdcd077ecfe9$export$6ea408c7266ed557;
var $159afdcd077ecfe9$export$6bce1afb61f2eb66 = {
    prefix: 'fas',
    iconName: 'angle-right',
    icon: [
        256,
        512,
        [
            8250
        ],
        "f105",
        "M247.1 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L179.2 256 41.9 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
    ]
};
var $159afdcd077ecfe9$export$dc130582748497c6 = {
    prefix: 'fas',
    iconName: 'face-meh',
    icon: [
        512,
        512,
        [
            128528,
            "meh"
        ],
        "f11a",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM176 320l160 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-160 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$6d2db489aaeeecd2 = $159afdcd077ecfe9$export$dc130582748497c6;
var $159afdcd077ecfe9$export$cbe485a104805f4f = {
    prefix: 'fas',
    iconName: 'arrow-up-from-ground-water',
    icon: [
        640,
        512,
        [],
        "e4b5",
        "M303 7c9.4-9.4 24.6-9.4 33.9 0l88 88c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47 0 278.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-278.1-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L303 7zM240 192l0 163.1c-10.6-2.2-21.3-3.2-32-3.1-32.5 .2-64.9 10.7-92.3 31.4-8.8 6.6-15.9 10.9-21.7 13.5l-.8 .4c-3.7 1.7-6.4 2.9-9.8 .3-6-4.5-12.6-8-19.3-10.4L64 240c0-26.5 21.5-48 48-48l128 0zm336 48l0 155.2c-1.1 .8-2.2 1.5-3.3 2.4-4.1 3.1-8.3 .8-12.6-1.5-.6-.3-1.2-.6-1.8-1-5.2-2.7-11.1-6.6-18-11.7-28.1-21.1-61.3-31.6-94.4-31.4-15.5 .1-31 2.5-46 7.3l0-167.3 128 0c26.5 0 48 21.5 48 48zM403.4 476.1C379.1 494.3 351.1 512 320 512s-59.1-17.7-83.4-35.9c-21.3-16.1-49.9-16.1-71.2 0-23.8 17.9-54.1 35.5-88.1 35.3-20.4-.1-40.7-6.7-59.8-21.1-10.6-8-12.7-23-4.7-33.6s23-12.7 33.6-4.7c11.3 8.5 21.6 11.4 31.2 11.5 17.6 .1 37.3-9.4 58.9-25.7 38.4-29 90.5-29 129 0 24 18.1 40.7 26.3 54.5 26.3s30.5-8.2 54.5-26.3c38.4-29 90.5-29 129 0 16.9 12.7 32.9 21.5 47.8 24.6 13.7 2.8 27.4 .9 42.3-10.3 10.6-8 25.6-5.9 33.6 4.7s5.9 25.6-4.7 33.6c-26.4 19.9-54.2 24.4-80.7 19.1-25.3-5.1-48.1-18.9-67.2-33.3-21.3-16.1-49.9-16.1-71.2 0z"
    ]
};
var $159afdcd077ecfe9$export$fc82fb79180cd17c = {
    prefix: 'fas',
    iconName: 'map',
    icon: [
        512,
        512,
        [
            128506,
            62072
        ],
        "f279",
        "M512 48c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4L349.5 77.5 170.1 17.6c-8.1-2.7-16.8-2.1-24.4 1.7l-128 64C6.8 88.8 0 99.9 0 112L0 464c0 11.1 5.7 21.4 15.2 27.2s21.2 6.4 31.1 1.4l116.1-58.1 179.4 59.8c8.1 2.7 16.8 2.1 24.4-1.7l128-64c10.8-5.4 17.7-16.5 17.7-28.6l0-352zM192 376.9l0-284.5 128 42.7 0 284.5-128-42.7z"
    ]
};
var $159afdcd077ecfe9$export$4c17261776a709f2 = {
    prefix: 'fas',
    iconName: 'user-plus',
    icon: [
        640,
        512,
        [],
        "f234",
        "M136 128a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zM48 482.3C48 383.8 127.8 304 226.3 304l59.4 0c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7L77.7 512C61.3 512 48 498.7 48 482.3zM544 96c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$f89d028573ffc0a6 = {
    prefix: 'fas',
    iconName: 'venus',
    icon: [
        384,
        512,
        [
            9792
        ],
        "f221",
        "M80 176a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM223.9 349.1C305.9 334.1 368 262.3 368 176 368 78.8 289.2 0 192 0S16 78.8 16 176c0 86.3 62.1 158.1 144.1 173.1-.1 1-.1 1.9-.1 2.9l0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-64c0-1 0-1.9-.1-2.9z"
    ]
};
var $159afdcd077ecfe9$export$ff7f40159cadb0ac = {
    prefix: 'fas',
    iconName: 'diagram-successor',
    icon: [
        448,
        512,
        [],
        "e47a",
        "M289.2 137.9c2.5-6 8.3-9.9 14.8-9.9l40 0 0-24c0-13.3-10.7-24-24-24l-98 0c1.3 5.1 2 10.5 2 16l0 64c0 35.3-28.7 64-64 64l-96 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l256 0c39.8 0 72 32.2 72 72l0 24 40 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-4.6-4.6-5.9-11.5-3.5-17.4zM384 480L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64zM160 160l0-64-96 0 0 64 96 0z"
    ]
};
var $159afdcd077ecfe9$export$b293ee8fb8e6b0c4 = {
    prefix: 'fas',
    iconName: 'head-side-cough-slash',
    icon: [
        576,
        512,
        [],
        "e062",
        "M535-24.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 537.1c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l25-25 0-447.2c0-15 10.5-28.3 25.4-29.8 7.4-.7 14.9-1.1 22.6-1.1 112.7 0 206 83.3 221.7 191.7 .4 3 1.7 5.9 3.6 8.3l2.2 2.6 227.5-227.5zM133.8 512L288 357.8 288 416c0 53-43 96-96 96l-58.2 0zM176 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm336 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-88 72a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-64 48a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm128 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm24 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-88-24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$59c351869dc27435 = {
    prefix: 'fas',
    iconName: 'diagram-project',
    icon: [
        512,
        512,
        [
            "project-diagram"
        ],
        "f542",
        "M0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 16 128 0 0-16c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-16-128 0 0 16c0 7.3-1.7 14.3-4.6 20.5l68.6 91.5 80 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-7.3 1.7-14.3 4.6-20.5L128 224 48 224c-26.5 0-48-21.5-48-48L0 80z"
    ]
};
var $159afdcd077ecfe9$export$30bf9f5b96509df1 = $159afdcd077ecfe9$export$59c351869dc27435;
var $159afdcd077ecfe9$export$5e63e8b85b5f119c = {
    prefix: 'fas',
    iconName: 'terminal',
    icon: [
        512,
        512,
        [],
        "f120",
        "M9.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L146.7 256 9.4 118.6zM224 384l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$947ee033a6942aa8 = {
    prefix: 'fas',
    iconName: 'house-fire',
    icon: [
        640,
        512,
        [],
        "e50c",
        "M448 192c14.1 .4 23.8 11.4 32.7 21.7 2 2.3 4 4.6 6 6.7l19 19.9 12.2-13.8c5.4-6.1 13.3-8.9 20.9-8.9 7.2 0 14.3 2.6 19.9 7.8 19.7 18.3 39.8 43.2 55 70.6 15.1 27.2 26.2 58.2 26.2 88.2 0 88.7-71.3 159.8-160 159.8-89.6 0-160-71.3-160-159.8 0-37.3 16-73.4 36.8-104.5 20.9-31.3 47.5-59 70.9-80.1 5.7-5.2 13.1-7.7 20.3-7.5zM268.6 6.5c12.2-9.3 29.7-8.7 41.2 2l147.5 137c-19.2-4.3-40 .5-55.5 14.4-36.4 32.6-67.7 69.8-90.3 106.4-10.3 16.6-19.7 34.9-26.8 53.7L272 320c-26.5 0-48 21.5-48 48l0 96 64.6 0c7.3 17.2 16.8 33.4 28.2 48L144 512c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208 2.4-2zM489.3 343.7c-5.4-4.7-13.1-4.7-18.5 0-17.7 15.4-54.7 51.9-54.7 88.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-36.5-37-73-54.7-88.4z"
    ]
};
var $159afdcd077ecfe9$export$7b028758c03b9655 = {
    prefix: 'fas',
    iconName: 'mask',
    icon: [
        576,
        512,
        [],
        "f6fa",
        "M288 64C64 64 0 160 0 272S80 448 176 448l8.4 0c24.2 0 46.4-13.7 57.2-35.4l23.2-46.3c4.4-8.8 13.3-14.3 23.2-14.3s18.8 5.5 23.2 14.3l23.2 46.3c10.8 21.7 33 35.4 57.2 35.4l8.4 0c96 0 176-64 176-176S512 64 288 64zM96 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm320-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $159afdcd077ecfe9$export$4cf54a379be7e59a = {
    prefix: 'fas',
    iconName: 'hurricane',
    icon: [
        384,
        512,
        [],
        "f751",
        "M0 208C0 104.4 75.7 18.5 174.9 2.6 184 1.2 192 8.6 192 17.9l0 63.3c0 8.4 6.5 15.3 14.7 16.5 100.3 14.9 177.3 101.3 177.3 205.7 0 103.6-75.7 189.5-174.9 205.4-9.2 1.5-17.1-5.9-17.1-15.2l0-63.3C192 421.9 185.5 415 177.3 413.7 77 398.9 0 312.4 0 208zm288 48a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm-96-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$11afa141d42099d0 = {
    prefix: 'fas',
    iconName: 'earth-africa',
    icon: [
        512,
        512,
        [
            127757,
            "globe-africa"
        ],
        "f57c",
        "M447.6 175c-31.6-74.6-105.5-127-191.6-127-22.1 0-43.4 3.5-63.4 9.8-.4 2-.6 4.1-.6 6.2l0 73.4c0 12.5 10.1 22.6 22.6 22.6 6 0 11.8-2.4 16-6.6l16-16c6-6 14.1-9.4 22.6-9.4l5.5 0c28.5 0 42.8 34.5 22.6 54.6-6 6-14.1 9.4-22.6 9.4l-61.5 0c-8.5 0-16.6 3.4-22.6 9.4l-21.3 21.3c-6 6-9.4 14.1-9.4 22.6l0 42.7c0 17.7 14.3 32 32 32l32 0c17.7 0 32 14.3 32 32l0 32c0 17.7 14.3 32 32 32l2.7 0c8.5 0 16.6-3.4 22.6-9.4l29.3-29.3c6-6 9.4-14.1 9.4-22.6l0-18.7c0-8.8 7.2-16 16-16s16-7.2 16-16l0-34.7c0-8.5-3.4-16.6-9.4-22.6l-16-16c-4.2-4.2-6.6-10-6.6-16 0-12.5 10.1-22.6 22.6-22.6l45 0c12.4 0 22.7-7.1 28-17zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"
    ]
};
var $159afdcd077ecfe9$export$64af36f3b403a57c = $159afdcd077ecfe9$export$11afa141d42099d0;
var $159afdcd077ecfe9$export$b6314cdc01bb5c43 = {
    prefix: 'fas',
    iconName: 'thumbtack',
    icon: [
        384,
        512,
        [
            128204,
            128392,
            "thumb-tack"
        ],
        "f08d",
        "M32 32C32 14.3 46.3 0 64 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-29.5 0 10.3 134.1c37.1 21.2 65.8 56.4 78.2 99.7l3.8 13.4c2.8 9.7 .8 20-5.2 28.1S362 352 352 352L32 352c-10 0-19.5-4.7-25.5-12.7s-8-18.4-5.2-28.1L5 297.8c12.4-43.3 41-78.5 78.2-99.7L93.5 64 64 64C46.3 64 32 49.7 32 32zM160 400l64 0 0 112c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-112z"
    ]
};
var $159afdcd077ecfe9$export$b63d0c7b519a9aae = $159afdcd077ecfe9$export$b6314cdc01bb5c43;
var $159afdcd077ecfe9$export$f6dcbf0a940428f4 = {
    prefix: 'fas',
    iconName: 'hand-point-down',
    icon: [
        384,
        512,
        [],
        "f0a7",
        "M32 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-208-64 0 0 208zM224 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64zm-64 64c17.7 0 32-14.3 32-32l0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 17.7 14.3 32 32 32zm160-96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64zm-96-88l0 .6c9.4-5.4 20.3-8.6 32-8.6 13.2 0 25.4 4 35.6 10.8 8.7-24.9 32.5-42.8 60.4-42.8 11.7 0 22.6 3.1 32 8.6l0-8.6C384 71.6 312.4 0 224 0L162.3 0C119.8 0 79.1 16.9 49.1 46.9L37.5 58.5C13.5 82.5 0 115.1 0 149l0 27c0 35.3 28.7 64 64 64l88 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-56 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l56 0c39.8 0 72 32.2 72 72z"
    ]
};
var $159afdcd077ecfe9$export$38c072b870a9e4ab = {
    prefix: 'fas',
    iconName: 'face-meh-blank',
    icon: [
        512,
        512,
        [
            128566,
            "meh-blank"
        ],
        "f5a4",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm208-48a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$e945435725f71e88 = $159afdcd077ecfe9$export$38c072b870a9e4ab;
var $159afdcd077ecfe9$export$ac389bf5cc37feb5 = {
    prefix: 'fas',
    iconName: 'temperature-empty',
    icon: [
        320,
        512,
        [
            "temperature-0",
            "thermometer-0",
            "thermometer-empty"
        ],
        "f2cb",
        "M64 96c0-53 43-96 96-96s96 43 96 96l0 164.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144S16 447.5 16 368c0-42.6 18.5-81 48-107.3L64 96zm96 336c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var $159afdcd077ecfe9$export$e99b7d2ccc282383 = $159afdcd077ecfe9$export$ac389bf5cc37feb5;
var $159afdcd077ecfe9$export$4c13a186ecce3b80 = $159afdcd077ecfe9$export$ac389bf5cc37feb5;
var $159afdcd077ecfe9$export$81a2f8298cf523f9 = $159afdcd077ecfe9$export$ac389bf5cc37feb5;
var $159afdcd077ecfe9$export$2b488402ec335d97 = {
    prefix: 'fas',
    iconName: 'border-none',
    icon: [
        448,
        512,
        [],
        "f850",
        "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM160 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM288 416c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM160 480c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM288 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 480c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm0-384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM416 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM32 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM416 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$73801ed54b42fabe = {
    prefix: 'fas',
    iconName: 'highlighter',
    icon: [
        576,
        512,
        [],
        "f591",
        "M315 315L473.4 99.9 444.1 70.6 229 229 315 315zm-187 5l0 0 0-71.7c0-15.3 7.2-29.6 19.5-38.6L420.6 8.4C428 2.9 437 0 446.2 0 457.6 0 468.5 4.5 476.6 12.6l54.8 54.8c8.1 8.1 12.6 19 12.6 30.5 0 9.2-2.9 18.2-8.4 25.6L334.4 396.5c-9 12.3-23.4 19.5-38.6 19.5l-71.7 0-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0l-50.7-50.7c-12.5-12.5-12.5-32.8 0-45.3L128 320zM7 466.3l51.7-51.7 70.6 70.6-19.7 19.7c-4.5 4.5-10.6 7-17 7L24 512c-13.3 0-24-10.7-24-24l0-4.7c0-6.4 2.5-12.5 7-17z"
    ]
};
var $159afdcd077ecfe9$export$53e23123cc9a6796 = {
    prefix: 'fas',
    iconName: 'money-bill-wave',
    icon: [
        512,
        512,
        [],
        "f53a",
        "M0 419.6L0 109.5c0-23.2 24.1-38.6 46.3-32 87.7 26.2 149.7 5.5 212.1-15.3 64.5-21.5 129.4-43.1 223.3-13.1 18.5 5.9 30.3 23.8 30.3 43.3l0 310.1c0 23.2-24.1 38.6-46.2 32-87.7-26.2-149.8-5.5-212.1 15.3-64.5 21.5-129.4 43.1-223.3 13.1-18.5-5.9-30.3-23.8-30.3-43.3zM336 256c0-53-35.8-96-80-96s-80 43-80 96 35.8 96 80 96 80-43 80-96zM120 413.6c4.4 0 7.9-3.8 7.2-8.1-4.6-27.8-27-49.5-55.2-53-4.4-.5-8 3.1-8 7.5l0 39.9c0 3.6 2.4 6.8 6 7.7 17.9 4.2 34.3 6.1 50 6.1zm318.5-51.1c5 .8 9.5-3 9.5-8l0-42.6c0-4.4-3.6-8.1-8-7.5-25.2 3.1-45.9 20.9-53.2 44.6-1.4 4.7 2.3 9.1 7.2 9.2 14.2 .4 29 1.7 44.4 4.3zM448 152l0-39.9c0-3.6-2.5-6.8-6-7.7-17.9-4.2-34.3-6.1-50-6.1-4.4 0-7.9 3.8-7.2 8.1 4.6 27.8 27 49.5 55.2 53 4.4 .5 8-3.1 8-7.5zM125.2 162.9c1.4-4.7-2.3-9.1-7.2-9.2-14.2-.4-29-1.7-44.4-4.3-5-.8-9.5 3-9.5 8L64 200c0 4.4 3.6 8.1 8 7.5 25.2-3.1 45.9-20.9 53.2-44.6z"
    ]
};
var $159afdcd077ecfe9$export$7a494edbf9b65575 = {
    prefix: 'fas',
    iconName: 'toilet-paper-slash',
    icon: [
        576,
        512,
        [],
        "e072",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-94.5-94.5c40.2-23 69.5-96.9 69.5-184.6 0-106-43-192-96-192s-96 86-96 192c0 24.1 2.2 47.2 6.3 68.4L304 238.2 304 224c0-58.9 11.8-114.5 33.2-157.2 5.9-11.7 13.1-23.7 21.9-34.8L128 32c-8.3 0-16.4 2.1-24.1 6.1l-63-63zM32 224l0 264c0 30.9 25.1 56 56 56l160 0c30.9 0 56-25.1 56-56l0-114.2-256-256C37.9 148.2 32 184.7 32 224zm416 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64z"
    ]
};
var $159afdcd077ecfe9$export$348a01df65a66c99 = {
    prefix: 'fas',
    iconName: 'file-shield',
    icon: [
        576,
        512,
        [],
        "e4f0",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l201.2 0C261 469.4 240 414.5 240 356.4l0-31.1c0-34.4 22-65 54.7-75.9l112-37.3c3.1-1 6.2-1.8 9.3-2.5l0-39.1c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zm87.8 312.5l-13.3 6.3 0-188.1 96 32 0 19.6c0 55.8-32.2 106.5-82.7 130.3zM421.9 259.5l-112 37.3c-13.1 4.4-21.9 16.6-21.9 30.4l0 31.1c0 74.4 43 142.1 110.2 173.7l18.5 8.7c4.8 2.2 10 3.4 15.2 3.4s10.5-1.2 15.2-3.4l18.5-8.7C533 500.3 576 432.6 576 358.2l0-31.1c0-13.8-8.8-26-21.9-30.4l-112-37.3c-6.6-2.2-13.7-2.2-20.2 0z"
    ]
};
var $159afdcd077ecfe9$export$3313bce3924ea7da = {
    prefix: 'fas',
    iconName: 'text-height',
    icon: [
        576,
        512,
        [],
        "f034",
        "M40 32C17.9 32 0 49.9 0 72l0 56c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 64 0 0 320-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-320 64 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-56c0-22.1-17.9-40-40-40L40 32zM438.6 361.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4 0-229.5 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-6-6-14.1-9.4-22.6-9.4s-16.6 3.4-22.6 9.4l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4 0 229.5-9.4-9.4z"
    ]
};
var $159afdcd077ecfe9$export$95a7394c24f57943 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue',
    icon: [
        512,
        512,
        [
            128539,
            "grin-tongue"
        ],
        "f589",
        "M0 256c0 104.4 62.5 194.2 152.2 234.1-5.3-13-8.2-27.2-8.2-42.1l0-61.7c-16.9-16.5-30.1-36.7-38.3-59.3-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1c11.9-3.7 23.9 6.3 19.6 18.1-8.3 22.6-21.5 42.8-38.3 59.3l0 61.7c0 14.9-2.9 29.1-8.2 42.1 89.7-39.8 152.2-129.6 152.2-234.1 0-141.4-114.6-256-256-256S0 114.6 0 256zm176-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm16 240l0-45.4c0-14.7-11.9-26.6-26.6-26.6l-2 0c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9l-2 0c-14.7 0-26.6 11.9-26.6 26.6l0 45.4c0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $159afdcd077ecfe9$export$ef222816a43a4b3a = $159afdcd077ecfe9$export$95a7394c24f57943;
var $159afdcd077ecfe9$export$d0de575ac166712b = {
    prefix: 'fas',
    iconName: 'file-signature',
    icon: [
        640,
        512,
        [],
        "f573",
        "M64.1 64c0-35.3 28.7-64 64-64L277.6 0c17 0 33.3 6.7 45.3 18.7L429.3 125.3c12 12 18.7 28.3 18.7 45.3l0 97.5-132 132-42.1 0-16.1-53.6c-4.7-15.7-19.1-26.4-35.5-26.4-11.3 0-21.9 5.1-28.9 13.9L133.3 409c-8.3 10.3-6.6 25.5 3.7 33.7s25.5 6.6 33.7-3.8l47.1-58.8 15.2 50.7c3 10.2 12.4 17.1 23 17.1l31.5 0c-.9 3.1-1.7 6.3-2.3 9.5l-10.9 54.5-146.2 0c-35.3 0-64-28.7-64-64l0-384zm208-5.5l0 93.5c0 13.3 10.7 24 24 24l93.5 0-117.5-117.5zm60.2 408.4c2.5-12.4 8.6-23.8 17.5-32.7l118.9-118.9 80 80-118.9 118.9c-8.9 8.9-20.3 15-32.7 17.5l-59.6 11.9c-.9 .2-1.9 .3-2.9 .3-8 0-14.6-6.5-14.6-14.6 0-1 .1-1.9 .3-2.9l11.9-59.6zm267.8-123l-28.8 28.8-80-80 28.8-28.8c22.1-22.1 57.9-22.1 80 0s22.1 57.9 0 80z"
    ]
};
var $159afdcd077ecfe9$export$6c0cfe6d58faf860 = {
    prefix: 'fas',
    iconName: 'building-wheat',
    icon: [
        640,
        512,
        [],
        "e4db",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l249.3 0c-6-14.8-9.3-31-9.3-48 0-17.7 7.2-33.7 18.8-45.3-11.9-19.4-18.8-42.3-18.8-66.7 0-17.7 7.2-33.7 18.8-45.3-11.9-19.4-18.8-42.3-18.8-66.7 0-25.2 14.5-46.9 35.6-57.4-2.4-7.1-3.6-14.7-3.6-22.6l0-32C368 96.7 388 70.1 415.9 60.1 413.9 26.6 386 0 352 0L96 0zM208 352l32 0c17.7 0 32 14.3 32 32l0 80-96 0 0-80c0-17.7 14.3-32 32-32zM128 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm144-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm352 0l-16 0c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16l16 0c44.2 0 80-35.8 80-80 0-8.8-7.2-16-16-16zm16 128c0-8.8-7.2-16-16-16l-16 0c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16l16 0c44.2 0 80-35.8 80-80zm0 112c0-8.8-7.2-16-16-16l-16 0c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16l16 0c44.2 0 80-35.8 80-80zM496 528c0-44.2-35.8-80-80-80l-16 0c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80l16 0c8.8 0 16-7.2 16-16zm-16-96c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80l-16 0c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80l16 0zm16-128c0-44.2-35.8-80-80-80l-16 0c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80l16 0c8.8 0 16-7.2 16-16zM512 64c-13.3 0-24 10.7-24 24l0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104c0-13.3-10.7-24-24-24zm96 64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32zM440 104c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$2a44d62160972254 = {
    prefix: 'fas',
    iconName: 'plug-circle-minus',
    icon: [
        640,
        512,
        [],
        "e55e",
        "M192-32c17.7 0 32 14.3 32 32l0 96 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7C165.2 398.1 96 319.1 96 224l0-64c-17.7 0-32-14.3-32-32S78.3 96 96 96l64 0 0-96c0-17.7 14.3-32 32-32zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"
    ]
};
var $159afdcd077ecfe9$export$65a345b33858a655 = {
    prefix: 'fas',
    iconName: 'futbol',
    icon: [
        512,
        512,
        [
            9917,
            "futbol-ball",
            "soccer-ball"
        ],
        "f1e3",
        "M417.3 360.1l-71.6-4.8c-5.2-.3-10.3 1.1-14.5 4.2s-7.2 7.4-8.4 12.5l-17.6 69.6C289.5 445.8 273 448 256 448s-33.5-2.2-49.2-6.4L189.2 372c-1.3-5-4.3-9.4-8.4-12.5s-9.3-4.5-14.5-4.2l-71.6 4.8c-17.6-27.2-28.5-59.2-30.4-93.6L125 228.3c4.4-2.8 7.6-7 9.2-11.9s1.4-10.2-.5-15l-26.7-66.6C128 109.2 155.3 89 186.7 76.9l55.2 46c4 3.3 9 5.1 14.1 5.1s10.2-1.8 14.1-5.1l55.2-46c31.3 12.1 58.7 32.3 79.6 57.9l-26.7 66.6c-1.9 4.8-2.1 10.1-.5 15s4.9 9.1 9.2 11.9l60.7 38.2c-1.9 34.4-12.8 66.4-30.4 93.6zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm14.1-325.7c-8.4-6.1-19.8-6.1-28.2 0L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6l59.2 0c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8z"
    ]
};
var $159afdcd077ecfe9$export$51a344ca0a215620 = $159afdcd077ecfe9$export$65a345b33858a655;
var $159afdcd077ecfe9$export$f4a29712c724ba2d = $159afdcd077ecfe9$export$65a345b33858a655;
var $159afdcd077ecfe9$export$eeda28b8ca4cb18e = {
    prefix: 'fas',
    iconName: 'circle-plus',
    icon: [
        512,
        512,
        [
            "plus-circle"
        ],
        "f055",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$d9cc3a81499af48c = $159afdcd077ecfe9$export$eeda28b8ca4cb18e;
var $159afdcd077ecfe9$export$9d355b4e79216962 = {
    prefix: 'fas',
    iconName: 'brazilian-real-sign',
    icon: [
        512,
        512,
        [],
        "e46c",
        "M400 16c17.7 0 32 14.3 32 32l0 16 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-48.9 0c-26 0-47.1 21.1-47.1 47.1 0 22.5 15.9 41.8 37.9 46.2l32.8 6.6c51.9 10.4 89.3 56 89.3 109 0 50.6-33.8 93.3-80 106.7l0 20.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-16-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64.9 0c26 0 47.1-21.1 47.1-47.1 0-22.5-15.9-41.8-37.9-46.2l-32.8-6.6c-51.9-10.4-89.3-56-89.3-109 0-50.6 33.8-93.2 80-106.7L368 48c0-17.7 14.3-32 32-32zM0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144 0 54.3-30 101.5-74.4 126.1l41 136.7c5.1 16.9-4.5 34.8-21.5 39.8s-34.8-4.5-39.8-21.5L120.1 319.8c-2.7 .1-5.4 .2-8.1 .2l-48 0 0 128c0 17.7-14.3 32-32 32S0 465.7 0 448L0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160z"
    ]
};
var $159afdcd077ecfe9$export$cafa834c96ebcb1a = {
    prefix: 'fas',
    iconName: 'star-and-crescent',
    icon: [
        512,
        512,
        [
            9770
        ],
        "f699",
        "M0 256c0-141.4 114.6-256 256-256 33 0 64.6 6.3 93.6 17.7 7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5 7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512 114.6 512 0 397.4 0 256zM375.4 137.4c3.5-7.1 13.7-7.1 17.2 0l31.5 63.8c1.4 2.8 4.1 4.8 7.2 5.3l70.4 10.2c7.9 1.1 11 10.8 5.3 16.4l-50.9 49.6c-2.3 2.2-3.3 5.4-2.8 8.5l12 70.1c1.3 7.8-6.9 13.8-13.9 10.1l-63-33.1c-2.8-1.5-6.1-1.5-8.9 0l-63 33.1c-7 3.7-15.3-2.3-13.9-10.1l12-70.1c.5-3.1-.5-6.3-2.8-8.5L261 233.1c-5.7-5.6-2.6-15.2 5.3-16.4l70.4-10.2c3.1-.5 5.8-2.4 7.2-5.3l31.5-63.8z"
    ]
};
var $159afdcd077ecfe9$export$c938968e28178994 = {
    prefix: 'fas',
    iconName: 'face-surprise',
    icon: [
        512,
        512,
        [
            128558,
            "surprise"
        ],
        "f5c2",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-48 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $159afdcd077ecfe9$export$46647c72213f53ba = $159afdcd077ecfe9$export$c938968e28178994;
var $159afdcd077ecfe9$export$684703c93d630cc5 = {
    prefix: 'fas',
    iconName: 'hospital-user',
    icon: [
        640,
        512,
        [],
        "f80d",
        "M64 64C64 28.7 92.7 0 128 0L384 0c35.3 0 64 28.7 64 64l0 121.3c-46.9 19-80 65-80 118.7 0 27.7 8.8 53.4 23.8 74.4-51.5 21-87.8 71.6-87.8 130.7 0 1 0 1.9 0 2.9l-176 0c-35.3 0-64-28.7-64-64L64 64zM208 400l0 64 53.4 0c7.2-29.4 21.3-56.1 40.4-78.3-6.1-19.5-24.3-33.7-45.8-33.7-26.5 0-48 21.5-48 48zM248 88c-8.8 0-16 7.2-16 16l0 32-32 0c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l32 0 0 32c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-32 32 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-32 0 0-32c0-8.8-7.2-16-16-16l-16 0zM416 304a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM352 512c0-53 43-96 96-96l96 0c53 0 96 43 96 96 0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$fc9f7bd981c34c45 = {
    prefix: 'fas',
    iconName: 'arrow-down-up-lock',
    icon: [
        576,
        512,
        [],
        "e4b0",
        "M262.6 422.6l-80 80c-12.5 12.5-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l25.4 25.4 0-114.7-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l256 0 0-114.7-25.4 25.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l80-80c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-25.4-25.4 0 94.8c-25.3 20.3-42.8 50.1-47 83.9l-145 0 0 114.7 25.4-25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM192 32l0 144-64 0 0-144c0-17.7 14.3-32 32-32s32 14.3 32 32zM496 304.1c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM352 400c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
var $159afdcd077ecfe9$export$72b780186370e953 = {
    prefix: 'fas',
    iconName: 'folder',
    icon: [
        512,
        512,
        [
            128193,
            128447,
            61716,
            "folder-blank"
        ],
        "f07b",
        "M64 448l384 0c35.3 0 64-28.7 64-64l0-240c0-35.3-28.7-64-64-64L298.7 80c-6.9 0-13.7-2.2-19.2-6.4L241.1 44.8C230 36.5 216.5 32 202.7 32L64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64z"
    ]
};
var $159afdcd077ecfe9$export$9ef114244d26da0 = $159afdcd077ecfe9$export$72b780186370e953;
var $159afdcd077ecfe9$export$273296afacf93991 = {
    prefix: 'fas',
    iconName: 'holly-berry',
    icon: [
        512,
        512,
        [],
        "f7aa",
        "M256.2 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM277 383.8c1 .1 2.1 .2 3.2 .2 39.8 0 72 32.2 72 72l0 22.7c0 16.4 16 27.9 31.6 22.8l12.8-4.3c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5L495.9 452c-5-18.3-4.4-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6-34.6 0-62.7-28.1-62.7-62.7l0-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-29.6-8.1c-2.9-.8-5.9-1-8.7-.7 4.2 9.7 5.8 20.8 3.7 32.3l-6.3 34.8c-1.5 8.4-1.4 17 .5 25.3l5.3 23.9c2.8 12.7 1.1 25.2-4 35.9zM127.8 234.5c-15.5-5.2-31.6 6.4-31.6 22.8l0 32c0 34.6-28.1 62.7-62.7 62.7-16.4 0-27.9 16-22.8 31.6L15 396.4c6 18 6.5 37.3 1.5 55.6l-5.3 19.4C6.4 489.4 22.8 505.8 40.7 501l19.4-5.3c18.3-5 37.6-4.5 55.6 1.5l12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8l0-32c0-34.6 28.1-62.7 62.7-62.7 16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5l-19.4 5.3c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3zM384.2 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $159afdcd077ecfe9$export$6a6f9cba7a1e5fe4 = {
    prefix: 'fas',
    iconName: 'venus-double',
    icon: [
        640,
        512,
        [
            9890
        ],
        "f226",
        "M192 288a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM368 176c0 86.3-62.1 158.1-144.1 173.1 .1 1 .1 1.9 .1 2.9l0 64 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-64c0-1 0-1.9 .1-2.9-82-15-144.1-86.8-144.1-173.1 0-97.2 78.8-176 176-176S368 78.8 368 176zM357.5 327c14.4-15.8 26.6-33.7 36.1-53.1 16.1 9 34.7 14.1 54.5 14.1 61.9 0 112-50.1 112-112S509.9 64 448 64c-19.8 0-38.3 5.1-54.5 14.1-9.5-19.4-21.6-37.3-36.1-53.1 26.4-15.9 57.4-25 90.5-25 97.2 0 176 78.8 176 176 0 86.3-62.1 158.1-144.1 173.1 .1 .9 .1 1.9 .1 2.9l0 64 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-64c0-1 0-1.9 .1-2.9-21.1-3.9-40.9-11.5-58.6-22.2z"
    ]
};
var $159afdcd077ecfe9$export$d4aa151a4554b74e = {
    prefix: 'fas',
    iconName: 'clipboard-question',
    icon: [
        384,
        512,
        [],
        "e4e3",
        "M311.4 32l8.6 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l8.6 0C83.6 12.9 104.3 0 128 0L256 0c23.7 0 44.4 12.9 55.4 32zM248 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0zM192 248c16.1 0 29.2 13.1 29.2 29.2 0 8.7-3.1 13.9-6.9 17.7-4.5 4.4-10.7 7.5-16.8 9.5-14.9 5-29.5 19.3-29.5 39.5 0 13.3 10.7 24 24 24 11.5 0 21.2-8.1 23.5-19 19.2-7.1 53.7-26.3 53.7-71.8 0-42.6-34.6-77.2-77.2-77.2s-77.2 34.6-77.2 77.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-16.1 13.1-29.2 29.2-29.2zm28 168c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28z"
    ]
};
var $159afdcd077ecfe9$export$9fae219b4d3ce0be = {
    prefix: 'fas',
    iconName: 'hotdog',
    icon: [
        512,
        512,
        [
            127789
        ],
        "f80f",
        "M288 0c-20.5 0-40.1 8.1-54.6 22.6L22.6 233.4C8.1 247.9 0 267.5 0 288 0 300.2 2.9 312.1 8.2 322.7L322.7 8.2C312.1 2.9 300.2 0 288 0zM224 512c20.5 0 40.1-8.1 54.6-22.6L489.4 278.6c14.5-14.5 22.6-34.1 22.6-54.6 0-12.2-2.9-24.1-8.2-34.7L189.3 503.8c10.7 5.4 22.6 8.2 34.7 8.2zM456.6 168.6c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-288 288c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0l288-288z"
    ]
};
var $159afdcd077ecfe9$export$c2af1be14cd87640 = {
    prefix: 'fas',
    iconName: 'arrow-up-from-bracket',
    icon: [
        448,
        512,
        [],
        "e09a",
        "M246.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3 192 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-210.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128zM64 352c0-17.7-14.3-32-32-32S0 334.3 0 352l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-64z"
    ]
};
var $159afdcd077ecfe9$export$6a99139787bf9967 = {
    prefix: 'fas',
    iconName: 'microscope',
    icon: [
        512,
        512,
        [
            128300
        ],
        "f610",
        "M176 0c-26.5 0-48 21.5-48 48l0 208c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-64 32 0c70.7 0 128 57.3 128 128S390.7 448 320 448L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16.9 0c30.4-34 48.9-78.8 48.9-128 0-106-86-192-192-192l-32 0 0-80c0-26.5-21.5-48-48-48L176 0zM120 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z"
    ]
};
var $159afdcd077ecfe9$export$8bb3c4d5c2f50243 = {
    prefix: 'fas',
    iconName: 'cloud',
    icon: [
        576,
        512,
        [
            9729
        ],
        "f0c2",
        "M0 336c0 79.5 64.5 144 144 144l304 0c70.7 0 128-57.3 128-128 0-51.6-30.5-96.1-74.5-116.3 6.7-13.1 10.5-28 10.5-43.7 0-53-43-96-96-96-17.7 0-34.2 4.8-48.4 13.1-24.1-45.8-72.2-77.1-127.6-77.1-79.5 0-144 64.5-144 144 0 8 .7 15.9 1.9 23.5-56.9 19.2-97.9 73.1-97.9 136.5z"
    ]
};
var $159afdcd077ecfe9$export$59669f486ab41d86 = {
    prefix: 'fas',
    iconName: 'baseball-bat-ball',
    icon: [
        576,
        512,
        [],
        "f432",
        "M464.1 544a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm8.4-576c15.1 0 29.7 5.8 40.7 16.2l47.2 44.8c12.6 12 19.1 29 17.5 46.3-1.2 13.3-7 25.8-16.5 35.2L363.1 309c-7.3 7.3-15.7 13.4-25 18L206 393c-9.2 4.6-17.7 10.7-25 18l-92 92 1.7 1.8c7.7 9.4 7.1 23.3-1.7 32.1s-22.7 9.3-32.1 1.7l-1.8-1.7-48-48-1.7-1.8c-7.7-9.4-7.1-23.3 1.7-32.1s22.7-9.3 32.1-1.7l1.8 1.7 92-92c7.3-7.3 13.4-15.7 18-25l66.1-132.1c4.6-9.2 10.7-17.7 18-25L430.8-14.7C441.9-25.8 456.9-32 472.5-32z"
    ]
};
var $159afdcd077ecfe9$export$ff2b8d5628da5f14 = {
    prefix: 'fas',
    iconName: 'car-rear',
    icon: [
        512,
        512,
        [
            "car-alt"
        ],
        "f5de",
        "M165.4 96l181.2 0c13.6 0 25.7 8.6 30.2 21.4l26.1 74.6-293.8 0 26.1-74.6c4.5-12.8 16.6-21.4 30.2-21.4zm-90.6 .3L39.6 196.8C16.4 206.4 0 229.3 0 256l0 96c0 23.7 12.9 44.4 32 55.4L32 448c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 256 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-40.6c19.1-11.1 32-31.7 32-55.4l0-96c0-26.7-16.4-49.6-39.6-59.2L437.2 96.3C423.7 57.8 387.4 32 346.6 32L165.4 32c-40.8 0-77.1 25.8-90.6 64.3zM208 288l96 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM48 280c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm360-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$7937ed2462a665c0 = $159afdcd077ecfe9$export$ff2b8d5628da5f14;
var $159afdcd077ecfe9$export$e1ef956136031821 = {
    prefix: 'fas',
    iconName: 'thumbtack-slash',
    icon: [
        576,
        512,
        [
            "thumb-tack-slash"
        ],
        "e68f",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L417.8 352 448 352c10 0 19.5-4.7 25.5-12.7s8-18.4 5.2-28.1L475 297.8c-12.4-43.3-41-78.5-78.2-99.7L386.5 64 416 64c17.7 0 32-14.3 32-32S433.7 0 416 0L160 0c-7.4 0-14.1 2.5-19.5 6.6L190.1 56.3 185.3 119.4 41-24.9zM282.2 352L149.7 219.6c-22.7 20.5-39.8 47.4-48.7 78.3l-3.8 13.4c-2.8 9.7-.8 20 5.2 28.1S118 352 128 352l154.2 0zM256 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112-64 0 0 112z"
    ]
};
var $159afdcd077ecfe9$export$e7a52e4a0831fa96 = $159afdcd077ecfe9$export$e1ef956136031821;
var $159afdcd077ecfe9$export$37bd38cf96417095 = {
    prefix: 'fas',
    iconName: 'plus-minus',
    icon: [
        384,
        512,
        [],
        "e43c",
        "M224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 128-128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0 0-128zM0 480c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 448c-17.7 0-32 14.3-32 32z"
    ]
};
var $159afdcd077ecfe9$export$c9382fa3394ef53a = {
    prefix: 'fas',
    iconName: 'house-circle-check',
    icon: [
        640,
        512,
        [],
        "e509",
        "M496 544a144 144 0 1 1 0-288 144 144 0 1 1 0 288zM268.6 6.5c12.2-9.3 29.7-8.7 41.2 2l217.6 202c-10.2-1.7-20.7-2.6-31.3-2.6-78.6 0-146.1 47.2-175.8 114.8-5.1-1.8-10.5-2.8-16.2-2.8l-32 0c-26.5 0-48 21.5-48 48l0 96 91 0c6.1 17.3 14.6 33.4 25.1 48L144 512c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208 2.4-2zM553.4 339.1c-7.1-5.2-17.1-3.6-22.3 3.5l-53 72.8-26.7-26.8c-6.2-6.2-16.4-6.2-22.6 0-6.2 6.2-6.2 16.4 0 22.6l40 40c3.3 3.3 7.9 5 12.6 4.7s8.9-2.8 11.7-6.6l64-88c5.2-7.1 3.6-17.1-3.5-22.3z"
    ]
};
var $159afdcd077ecfe9$export$80968bcfef6481ca = {
    prefix: 'fas',
    iconName: 'calendar-day',
    icon: [
        448,
        512,
        [],
        "f783",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zm0 256c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0z"
    ]
};
var $159afdcd077ecfe9$export$4280b2387fbdad12 = {
    prefix: 'fas',
    iconName: 'circle',
    icon: [
        512,
        512,
        [
            128308,
            128309,
            128992,
            128993,
            128994,
            128995,
            128996,
            9679,
            9898,
            9899,
            11044,
            61708,
            61915
        ],
        "f111",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"
    ]
};
var $159afdcd077ecfe9$export$e6a2ba52560007f5 = {
    prefix: 'fas',
    iconName: 'mobile-vibrate',
    icon: [
        576,
        512,
        [],
        "e816",
        "M384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-384c0-35.3 28.7-64 64-64L384 0zM248 416c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM48.8 133.4c9.4-7.7 23.3-7.1 32.1 1.7 9.4 9.4 9.4 24.6 0 33.9l-31 31 25.4 25.4 2.9 3.2c6.3 7.7 9.8 17.4 9.8 27.4 0 11.5-4.6 22.5-12.7 30.6l-25.4 25.4 31 31 1.7 1.8c7.7 9.4 7.1 23.3-1.7 32.1s-22.7 9.3-32.1 1.7L47 377 12.7 342.6C5.6 335.5 1.2 326.2 .2 316.3L0 312 .2 307.7c1-9.9 5.4-19.2 12.5-26.3L38.1 256 12.7 230.6C5.6 223.5 1.2 214.2 .2 204.3L0 200 .2 195.7c1-9.9 5.4-19.2 12.5-26.3L47 135 48.8 133.4zM495 135c8.8-8.8 22.7-9.3 32.1-1.7l1.8 1.7 34.3 34.3c7.1 7.1 11.5 16.4 12.5 26.3l.2 4.3-.2 4.3c-1 9.9-5.4 19.2-12.5 26.3l-25.4 25.4 25.4 25.4c7.1 7.1 11.5 16.4 12.5 26.3l.2 4.3-.2 4.3c-1 9.9-5.4 19.2-12.5 26.3l-34.3 34.3-1.8 1.7c-9.4 7.7-23.3 7.1-32.1-1.7s-9.3-22.7-1.7-32.1l1.7-1.8 31-31-25.4-25.4c-8.1-8.1-12.7-19.1-12.7-30.6 0-10 3.5-19.7 9.8-27.4l2.9-3.2 25.4-25.4-31-31c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$5d53da7627754bc6 = {
    prefix: 'fas',
    iconName: 'face-grin-squint',
    icon: [
        512,
        512,
        [
            128518,
            "grin-squint"
        ],
        "f585",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM386.7 308.9c11.9-3.7 23.9 6.3 19.6 18.1-22.4 61.3-81.3 105.1-150.3 105.1S128.1 388.2 105.7 326.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1zM122.6 143.2c4.5-6.8 13.3-9.2 20.6-5.5l79.6 40c5.4 2.7 8.8 8.2 8.8 14.3s-3.4 11.6-8.8 14.3l-79.6 40c-7.3 3.6-16.1 1.3-20.6-5.5s-3.1-15.9 3.1-21.1L159 192 125.8 164.3c-6.2-5.2-7.6-14.3-3.1-21.1zm263.6 21.1L353 192 386.2 219.7c6.2 5.2 7.6 14.3 3.1 21.1s-13.3 9.2-20.6 5.5l-79.6-40c-5.4-2.7-8.8-8.2-8.8-14.3s3.4-11.6 8.8-14.3l79.6-40c7.3-3.6 16.1-1.3 20.6 5.5s3.1 15.9-3.1 21.1z"
    ]
};
var $159afdcd077ecfe9$export$243ae757907b1580 = $159afdcd077ecfe9$export$5d53da7627754bc6;
var $159afdcd077ecfe9$export$6ea1decf8bb3513d = {
    prefix: 'fas',
    iconName: 'users-between-lines',
    icon: [
        576,
        512,
        [],
        "e591",
        "M24 16l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 64C10.7 64 0 53.3 0 40S10.7 16 24 16zm0 448l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24zM392 192a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm27.2 100.4c9.1-2.9 18.8-4.4 28.8-4.4 53 0 96 43 96 96l0 10.7c0 11.8-9.6 21.3-21.3 21.3l-78.8 0c2.7-7.5 4.1-15.6 4.1-24l0-8c0-34.1-10.6-65.7-28.8-91.6zm-262.4 0C138.6 318.3 128 349.9 128 384l0 8c0 8.4 1.4 16.5 4.1 24l-78.8 0C41.6 416 32 406.4 32 394.7L32 384c0-53 43-96 96-96 10 0 19.7 1.5 28.8 4.4zM72 192a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm152-16a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zM176 384c0-61.9 50.1-112 112-112s112 50.1 112 112l0 8c0 13.3-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24l0-8z"
    ]
};
var $159afdcd077ecfe9$export$bf221f0e8296233e = {
    prefix: 'fas',
    iconName: 'house-medical-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e513",
        "M309.8 8.6c-12.3-11.4-31.3-11.4-43.5 0l-224 208c-9.6 9-12.8 22.9-8 35.1S50.8 272 64 272l16 0 0 176c0 35.3 28.7 64 64 64l196 0c-21.2-29.5-34.3-65.3-35.9-104L272 408c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 20 0c34.9-48.5 91.7-80 156-80 10.7 0 21.1 .9 31.3 2.5L309.8 8.6zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 400z"
    ]
};
var $159afdcd077ecfe9$export$6e989c3c7050dbb = {
    prefix: 'fas',
    iconName: 'table-list',
    icon: [
        448,
        512,
        [
            "th-list"
        ],
        "f00b",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 0l0 64 64 0 0-64-64 0zm320 0l-192 0 0 64 192 0 0-64zM64 224l0 64 64 0 0-64-64 0zm320 0l-192 0 0 64 192 0 0-64zM64 352l0 64 64 0 0-64-64 0zm320 0l-192 0 0 64 192 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$daf2614a457122c0 = $159afdcd077ecfe9$export$6e989c3c7050dbb;
var $159afdcd077ecfe9$export$a25a266ce0c95019 = {
    prefix: 'fas',
    iconName: 'flask-vial',
    icon: [
        640,
        512,
        [],
        "e4f3",
        "M184.6 411.5c-3.1 7.3-5.4 14.9-6.8 22.6-14.5 8.8-31.5 13.9-49.8 13.9-53 0-96-43-96-96L32 64C14.3 64 0 49.7 0 32S14.3 0 32 0L224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 255.6-39.4 91.9zM96 64l0 128 64 0 0-128-64 0zM352 0L512 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 153.4 91.3 213c2.3 5.4 3.8 11.1 4.4 17l.3 .6-.3 0c.2 1.8 .3 3.6 .3 5.4 0 32.3-26.2 58.6-58.6 58.6l-266.9 0c-32.3 0-58.6-26.2-58.6-58.6 0-1.8 .1-3.6 .3-5.4l-.3 0 .3-.6c.6-5.8 2.1-11.6 4.4-17L320 217.4 320 64c-17.7 0-32-14.3-32-32S302.3 0 320 0l32 0zM453.2 242.6c-3.4-8-5.2-16.5-5.2-25.2l0-153.4-64 0 0 153.4c0 8.7-1.8 17.2-5.2 25.2l-33.2 77.4 140.7 0-33.2-77.4z"
    ]
};
var $159afdcd077ecfe9$export$59573943f9eebbd5 = {
    prefix: 'fas',
    iconName: 'circle-exclamation',
    icon: [
        512,
        512,
        [
            "exclamation-circle"
        ],
        "f06a",
        "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-192a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-192c-18.2 0-32.7 15.5-31.4 33.7l7.4 104c.9 12.6 11.4 22.3 23.9 22.3 12.6 0 23-9.7 23.9-22.3l7.4-104c1.3-18.2-13.1-33.7-31.4-33.7z"
    ]
};
var $159afdcd077ecfe9$export$220e07e14c5d7e5d = $159afdcd077ecfe9$export$59573943f9eebbd5;
var $159afdcd077ecfe9$export$9958afcdfece1b58 = {
    prefix: 'fas',
    iconName: 'taxi',
    icon: [
        512,
        512,
        [
            128662,
            "cab"
        ],
        "f1ba",
        "M192 0c-17.7 0-32 14.3-32 32l0 32-8.9 0c-42 0-79.1 27.3-91.6 67.4l-23 73.5C14.5 219.1 0 243.9 0 272L0 448c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-32 320 0 0 32c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-176c0-28.1-14.5-52.9-36.4-67.1l-23-73.5C440.1 91.3 402.9 64 360.9 64l-8.9 0 0-32c0-17.7-14.3-32-32-32L192 0zM151.1 128l209.9 0c14 0 26.4 9.1 30.5 22.5l13 41.5-296.9 0 13-41.5c4.2-13.4 16.5-22.5 30.5-22.5zM96 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm288 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$7bf12d9380f0971b = $159afdcd077ecfe9$export$9958afcdfece1b58;
var $159afdcd077ecfe9$export$ec658c0f040c3e1a = {
    prefix: 'fas',
    iconName: 'text-slash',
    icon: [
        576,
        512,
        [
            "remove-format"
        ],
        "f87d",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L322.7 256.9 368.2 96 471 96 465 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C545.6 61.3 522.7 32 491.5 32l-319 0c-19.8 0-37.3 12.1-44.5 30.1l-87-87zM180.4 114.5l4.6-18.5 116.7 0-30.8 109-90.5-90.5zM241 310.8L211.3 416 160 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-42.2 0 15.1-53.3-51.9-51.9z"
    ]
};
var $159afdcd077ecfe9$export$d91179f327329532 = $159afdcd077ecfe9$export$ec658c0f040c3e1a;
var $159afdcd077ecfe9$export$dace56f632fecf6f = {
    prefix: 'fas',
    iconName: 'people-pulling',
    icon: [
        576,
        512,
        [],
        "e535",
        "M80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM64 128c-35.3 0-64 28.7-64 64L0 320c0 17.7 14.3 32 32 32 9.8 0 18.5-4.4 24.4-11.2L80.4 485.3c2.9 17.4 19.4 29.2 36.8 26.3s29.2-19.4 26.3-36.8l-20.5-122.7 15.7 0 30 134.9c3.8 17.3 20.9 28.1 38.2 24.3s28.1-20.9 24.3-38.2l-57.3-258 116.3 53.8c.5 .3 1.1 .5 1.6 .7 8.6 3.6 18 3.1 25.9-.7 3.4-1.6 6.6-3.9 9.3-6.7 3.1-3.2 5.5-7 7.1-11.4 .1-.3 .2-.7 .3-1l2.5-7.5c5.7-17.1 18.3-30.9 34.7-38.2l8-3.5c1-.4 1.9-.8 2.9-1.2l-16.9 63.5c-5.6 21.1-.1 43.6 14.7 59.7l70.7 77.1 22 88.1c4.3 17.1 21.7 27.6 38.8 23.3s27.6-21.7 23.3-38.8l-23-92.1c-1.9-7.8-5.8-14.9-11.2-20.8l-49.5-54 19.3-65.5 9.6 23c4.4 10.6 12.5 19.3 22.8 24.5l26.7 13.3c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-21.4-10.7-15.3-36.8c-17.1-41.1-57.3-67.9-101.9-67.9-22.8 0-45.3 4.8-66.1 14l-8 3.5c-24.4 10.9-44.6 29-58.1 51.6L157.3 136.9C144.7 131 130.9 128 117 128l-53 0zM464 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM349.7 335.6l-25 62.4-59.4 59.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L372.3 441c4.6-4.6 8.2-10.1 10.6-16.1l14.5-36.2-40.7-44.4c-2.5-2.7-4.8-5.6-7-8.6z"
    ]
};
var $159afdcd077ecfe9$export$ae65f96ea7a4078d = {
    prefix: 'fas',
    iconName: 'backward',
    icon: [
        576,
        512,
        [
            9194
        ],
        "f04a",
        "M204.3 43.1C215.9 32 233 28.9 247.7 35.2S272 56 272 72l0 136.3 172.3-165.1C455.9 32 473 28.9 487.7 35.2S512 56 512 72l0 368c0 16-9.6 30.5-24.3 36.8s-31.8 3.2-43.4-7.9L272 303.7 272 440c0 16-9.6 30.5-24.3 36.8s-31.8 3.2-43.4-7.9l-192-184C4.5 277.3 0 266.9 0 256s4.5-21.3 12.3-28.9l192-184z"
    ]
};
var $159afdcd077ecfe9$export$6d2be7c5d395dd16 = {
    prefix: 'fas',
    iconName: 'car-burst',
    icon: [
        640,
        512,
        [
            "car-crash"
        ],
        "f5e1",
        "M232 16.1l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24zM32 168.1l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24zM281.5 70.6c9.4 9.4 24.6 9.4 33.9 0l33.9-33.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L281.5 36.6c-9.4 9.4-9.4 24.6 0 33.9zm-181 215l33.9-33.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L66.6 251.6c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM66.6 2.7c-9.4 9.4-9.4 24.6 0 33.9l33.9 33.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L100.5 2.7C91.1-6.7 76-6.7 66.6 2.7zM352.9 175.4L505 216.2c6.4 1.7 11.1 7.3 11.8 13.9l7.2 74-231.5-62 43.2-60.5c3.9-5.4 10.7-7.9 17.2-6.2zM223.6 228.5l-2.1 2.9c-21.7 5.5-39.9 22.3-46.1 45.5-4.1 15.5-12.4 46.4-24.8 92.7l-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6l8.3-30.9 278.2 74.5-8.3 30.9c-4.6 17.1 5.6 34.6 22.6 39.2l15.5 4.1c17.1 4.6 34.6-5.6 39.2-22.6 4.1-15.5 12.4-46.4 24.8-92.7l8.3-30.9c6.2-23.2-1.1-46.8-17.2-62.5l-.3-3.6-10-103c-3.2-33.2-26.7-60.9-58.9-69.5L369.5 113.6c-32.2-8.6-66.4 3.6-85.8 30.8l-60.2 84.2zm48.7 57.8a32 32 0 1 1 -16.6 61.8 32 32 0 1 1 16.6-61.8zm208.1 88.9a32 32 0 1 1 61.8 16.6 32 32 0 1 1 -61.8-16.6z"
    ]
};
var $159afdcd077ecfe9$export$8ff55566398404cd = $159afdcd077ecfe9$export$6d2be7c5d395dd16;
var $159afdcd077ecfe9$export$88bc01ff8dbecc55 = {
    prefix: 'fas',
    iconName: 'link',
    icon: [
        576,
        512,
        [
            128279,
            "chain"
        ],
        "f0c1",
        "M419.5 96c-16.6 0-32.7 4.5-46.8 12.7-15.8-16-34.2-29.4-54.5-39.5 28.2-24 64.1-37.2 101.3-37.2 86.4 0 156.5 70 156.5 156.5 0 41.5-16.5 81.3-45.8 110.6l-71.1 71.1c-29.3 29.3-69.1 45.8-110.6 45.8-86.4 0-156.5-70-156.5-156.5 0-1.5 0-3 .1-4.5 .5-17.7 15.2-31.6 32.9-31.1s31.6 15.2 31.1 32.9c0 .9 0 1.8 0 2.6 0 51.1 41.4 92.5 92.5 92.5 24.5 0 48-9.7 65.4-27.1l71.1-71.1c17.3-17.3 27.1-40.9 27.1-65.4 0-51.1-41.4-92.5-92.5-92.5zM275.2 173.3c-1.9-.8-3.8-1.9-5.5-3.1-12.6-6.5-27-10.2-42.1-10.2-24.5 0-48 9.7-65.4 27.1L91.1 258.2c-17.3 17.3-27.1 40.9-27.1 65.4 0 51.1 41.4 92.5 92.5 92.5 16.5 0 32.6-4.4 46.7-12.6 15.8 16 34.2 29.4 54.6 39.5-28.2 23.9-64 37.2-101.3 37.2-86.4 0-156.5-70-156.5-156.5 0-41.5 16.5-81.3 45.8-110.6l71.1-71.1c29.3-29.3 69.1-45.8 110.6-45.8 86.6 0 156.5 70.6 156.5 156.9 0 1.3 0 2.6 0 3.9-.4 17.7-15.1 31.6-32.8 31.2s-31.6-15.1-31.2-32.8c0-.8 0-1.5 0-2.3 0-33.7-18-63.3-44.8-79.6z"
    ]
};
var $159afdcd077ecfe9$export$b5d071e02a25554f = $159afdcd077ecfe9$export$88bc01ff8dbecc55;
var $159afdcd077ecfe9$export$5d2b6a700940df16 = {
    prefix: 'fas',
    iconName: 'backward-step',
    icon: [
        384,
        512,
        [
            "step-backward"
        ],
        "f048",
        "M363 36.8c-12.9-7-28.7-6.3-41 1.8L64 208.1 64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144.1 258 169.6c12.3 8.1 28 8.8 41 1.8s21-20.5 21-35.2l0-368c0-14.7-8.1-28.2-21-35.2z"
    ]
};
var $159afdcd077ecfe9$export$2884e379aed297d4 = $159afdcd077ecfe9$export$5d2b6a700940df16;
var $159afdcd077ecfe9$export$476af662c0c32cbc = {
    prefix: 'fas',
    iconName: 'x',
    icon: [
        384,
        512,
        [
            120
        ],
        "58",
        "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"
    ]
};
var $159afdcd077ecfe9$export$9a5c11a5e3d7f1e7 = {
    prefix: 'fas',
    iconName: 'circle-user',
    icon: [
        512,
        512,
        [
            62142,
            "user-circle"
        ],
        "f2bd",
        "M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2 35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"
    ]
};
var $159afdcd077ecfe9$export$be7d974e9e0dba1a = $159afdcd077ecfe9$export$9a5c11a5e3d7f1e7;
var $159afdcd077ecfe9$export$1f7600fa9fdb3978 = {
    prefix: 'fas',
    iconName: 'rectangle-list',
    icon: [
        512,
        512,
        [
            "list-alt"
        ],
        "f022",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm96 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm120-56l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$c6327a203ffc65a3 = $159afdcd077ecfe9$export$1f7600fa9fdb3978;
var $159afdcd077ecfe9$export$f69db0b876f7d753 = {
    prefix: 'fas',
    iconName: 'hand',
    icon: [
        512,
        512,
        [
            129306,
            9995,
            "hand-paper"
        ],
        "f256",
        "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4S-3.6 325.7 12.4 341L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208z"
    ]
};
var $159afdcd077ecfe9$export$6e6216c8b50471bb = $159afdcd077ecfe9$export$f69db0b876f7d753;
var $159afdcd077ecfe9$export$ecbd233b96906ee1 = {
    prefix: 'fas',
    iconName: 'van-shuttle',
    icon: [
        576,
        512,
        [
            128656,
            "shuttle-van"
        ],
        "f5b6",
        "M64 64C28.7 64 0 92.7 0 128L0 336c0 35.3 28.7 64 64 64l.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l104.7 0c4 44.9 41.7 80 87.6 80 46.1 0 83.9-35.4 87.7-80.5 31.7-3.8 56.3-30.8 56.3-63.5l0-101.3c0-13.8-4.5-27.3-12.8-38.4l-80-106.7C471.1 73.5 452.1 64 432 64L64 64zM504 224l-120 0 0-96 48 0 72 96zM64 224l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM392 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $159afdcd077ecfe9$export$9d63d851db698c09 = $159afdcd077ecfe9$export$ecbd233b96906ee1;
var $159afdcd077ecfe9$export$68b3af7444c89df7 = {
    prefix: 'fas',
    iconName: 'stairs',
    icon: [
        576,
        512,
        [],
        "e289",
        "M384 64c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32l-96 0 0 96c0 17.7-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32l96 0 0-96c0-17.7 14.3-32 32-32l96 0 0-96z"
    ]
};
var $159afdcd077ecfe9$export$5bcca85203ebd1e8 = {
    prefix: 'fas',
    iconName: 'horse-head',
    icon: [
        512,
        512,
        [],
        "f7ab",
        "M0 464L0 316.9C0 208.5 68.3 111.8 170.5 75.6L340.2 15.5c21.4-7.6 43.8 8.3 43.8 30.9 0 11-5.5 21.2-14.6 27.3L336 96c48.1 0 91.2 29.8 108.1 74.9l48.6 129.5c11.8 31.4 4.1 66.8-19.6 90.5-16 16-37.8 25.1-60.5 25.1l-3.4 0c-26.1 0-50.9-11.6-67.6-31.7l-32.3-38.7c-11.7 4.1-24.2 6.4-37.3 6.4l-.1 0c-6.3 0-12.5-.5-18.6-1.5-3.6-.6-7.2-1.4-10.7-2.3l0 0c-28.9-7.8-53.1-26.8-67.8-52.2-4.4-7.7-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c24 41.5 68.3 70 119.3 71.9l47.2 70.8c4 6.1 6.2 13.2 6.2 20.4 0 20.3-16.5 36.8-36.8 36.8L48 512c-26.5 0-48-21.5-48-48zM328 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$4689a147513594a7 = {
    prefix: 'fas',
    iconName: 'vault',
    icon: [
        512,
        512,
        [],
        "e2c5",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64 0 17.7 14.3 32 32 32s32-14.3 32-32l256 0c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0zm384-48c0 17.8-9.7 33.3-24 41.6l0 78.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-78.4c-14.3-8.3-24-23.8-24-41.6 0-26.5 21.5-48 48-48s48 21.5 48 48z"
    ]
};
var $159afdcd077ecfe9$export$48d1206500db2e9d = {
    prefix: 'fas',
    iconName: 'drum-steelpan',
    icon: [
        576,
        512,
        [],
        "f56a",
        "M288 32c159.1 0 288 48 288 128l0 192c0 80-128.9 128-288 128S0 432 0 352L0 160C0 80 128.9 32 288 32zM528 160c0-9.9-8-29.9-55-49.8-18.6-7.9-40.9-14.4-66-19.4l-27.8 43.6c-7.3 11.5-11.2 24.8-11.2 38.4 0 17.5 6.4 34.4 18.1 47.5l9.8 11c29.8-5.2 55.9-12.5 77.2-21.5 47.1-19.9 55-39.9 55-49.8zM349.2 237.3c-8-26.2-32.4-45.3-61.2-45.3s-53.3 19.1-61.2 45.3c19.4 1.7 39.9 2.7 61.2 2.7s41.8-.9 61.2-2.7zM169 90.8c-25.2 5-47.4 11.6-66 19.4-47.1 19.9-55 39.9-55 49.8s8 29.9 55 49.8c21.3 9 47.4 16.3 77.2 21.5l9.8-11c11.6-13.1 18.1-30 18.1-47.5 0-13.6-3.9-26.9-11.2-38.4L169 90.8zm56.3-8c-.9 4.3-1.4 8.7-1.4 13.2 0 35.3 28.7 64 64 64s64-28.7 64-64c0-4.5-.5-9-1.4-13.2-19.8-1.8-40.8-2.8-62.6-2.8s-42.8 1-62.6 2.8z"
    ]
};
var $159afdcd077ecfe9$export$47e4e0d519d33497 = {
    prefix: 'fas',
    iconName: 'thumbs-up',
    icon: [
        512,
        512,
        [
            128077,
            61575
        ],
        "f164",
        "M80 160c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32L0 192c0-17.7 14.3-32 32-32l48 0zM270.6 16C297.9 16 320 38.1 320 65.4l0 4.2c0 6.8-1.3 13.6-3.8 19.9L288 160 448 160c26.5 0 48 21.5 48 48 0 19.7-11.9 36.6-28.9 44 17 7.4 28.9 24.3 28.9 44 0 23.4-16.8 42.9-39 47.1 4.4 7.3 7 15.8 7 24.9 0 22.2-15 40.8-35.4 46.3 2.2 5.5 3.4 11.5 3.4 17.7 0 26.5-21.5 48-48 48l-87.9 0c-36.3 0-71.6-12.4-99.9-35.1L184 435.2c-15.2-12.1-24-30.5-24-50l0-186.6c0-14.9 3.5-29.6 10.1-42.9L226.3 43.3C234.7 26.6 251.8 16 270.6 16z"
    ]
};
var $159afdcd077ecfe9$export$722e92d2d93ffc68 = {
    prefix: 'fas',
    iconName: 'stamp',
    icon: [
        512,
        512,
        [],
        "f5bf",
        "M312 201.8c0-17.4 9.2-33.2 19.9-47 12.6-16.2 20.1-36.6 20.1-58.8 0-53-43-96-96-96s-96 43-96 96c0 22.1 7.5 42.5 20.1 58.8 10.7 13.8 19.9 29.6 19.9 47 0 29.9-24.3 54.2-54.2 54.2L112 256c-61.9 0-112 50.1-112 112 0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112l-33.8 0c-29.9 0-54.2-24.3-54.2-54.2zM56 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l400 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L56 464z"
    ]
};
var $159afdcd077ecfe9$export$232452c59d77c56e = {
    prefix: 'fas',
    iconName: 'menorah',
    icon: [
        640,
        512,
        [],
        "f676",
        "M20.8 7.4C22.8 2.9 27.1 0 32 0s9.2 2.9 11.2 7.4L61.3 49.7c1.8 4.1 2.7 8.6 2.7 13.1L64 64c0 17.7-14.3 32-32 32S0 81.7 0 64l0-1.2c0-4.5 .9-8.9 2.7-13.1L20.8 7.4zm96 0C118.8 2.9 123.1 0 128 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32S96 81.7 96 64l0-1.2c0-4.5 .9-8.9 2.7-13.1L116.8 7.4zm77.8 42.4L212.8 7.4C214.8 2.9 219.1 0 224 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM308.8 7.4C310.8 2.9 315.1 0 320 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L308.8 7.4zm77.8 42.4L404.8 7.4C406.8 2.9 411.1 0 416 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM500.8 7.4C502.8 2.9 507.1 0 512 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1L500.8 7.4zm77.8 42.4L596.8 7.4C598.8 2.9 603.1 0 608 0s9.2 2.9 11.2 7.4l18.2 42.4c1.8 4.1 2.7 8.6 2.7 13.1l0 1.2c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-1.2c0-4.5 .9-8.9 2.7-13.1zM32 128c17.7 0 32 14.3 32 32l0 128c0 17.7 14.3 32 32 32l192 0 0-160c0-17.7 14.3-32 32-32s32 14.3 32 32l0 160 192 0c17.7 0 32-14.3 32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 53-43 96-96 96l-192 0 0 64 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-320 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l128 0 0-64-192 0c-53 0-96-43-96-96L0 160c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 128-64 0 0-128c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 128-64 0 0-128c0-17.7 14.3-32 32-32zm192 0c17.7 0 32 14.3 32 32l0 128-64 0 0-128c0-17.7 14.3-32 32-32zm96 0c17.7 0 32 14.3 32 32l0 128-64 0 0-128c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$f2819bf60df55912 = {
    prefix: 'fas',
    iconName: 'children',
    icon: [
        640,
        512,
        [],
        "e4e1",
        "M160.5 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-72 480l0-80-17.8 0c-10.9 0-18.6-10.7-15.2-21.1L86.7 285.5 58 323.3c-10.7 14.1-30.8 16.8-44.8 6.2S-3.7 298.7 7 284.7L65.9 207c22.4-29.6 57.5-47 94.6-47s72.2 17.4 94.6 47L314 284.7c10.7 14.1 7.9 34.2-6.2 44.8s-34.2 7.9-44.8-6.2l-28.7-37.8 31.1 93.4c3.5 10.4-4.3 21.1-15.2 21.1l-17.8 0 0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80-16 0 0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32zM480.5 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-8 384l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-179.5-12.9 20.5c-9.4 15-29.2 19.4-44.1 10s-19.4-29.2-10-44.1l51.7-82.1c17.6-27.9 48.3-44.9 81.2-44.9l12.3 0c33 0 63.7 16.9 81.2 44.9L619.6 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10l-12.9-20.5 0 179.5c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-16 0z"
    ]
};
var $159afdcd077ecfe9$export$e022f62a119e1d93 = {
    prefix: 'fas',
    iconName: 'chart-line',
    icon: [
        512,
        512,
        [
            "line-chart"
        ],
        "f201",
        "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16L64 64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7 262.6 153.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l73.4-73.4 57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"
    ]
};
var $159afdcd077ecfe9$export$f729617a20de475b = $159afdcd077ecfe9$export$e022f62a119e1d93;
var $159afdcd077ecfe9$export$15da4ef8c0fb20d6 = {
    prefix: 'fas',
    iconName: 'square-envelope',
    icon: [
        448,
        512,
        [
            "envelope-square"
        ],
        "f199",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM209.1 267.9L108.4 207.4c-7.7-4.6-12.4-12.9-12.4-21.9 0-14.1 11.4-25.5 25.5-25.5l204.9 0c14.1 0 25.5 11.4 25.5 25.5 0 9-4.7 17.3-12.4 21.9L238.9 267.9c-4.5 2.7-9.6 4.1-14.9 4.1s-10.4-1.4-14.9-4.1zM352 237.3l0 82.7c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-82.7 96.7 58C202.1 301 213 304 224 304s21.9-3 31.3-8.7l96.7-58z"
    ]
};
var $159afdcd077ecfe9$export$354e159473e73552 = $159afdcd077ecfe9$export$15da4ef8c0fb20d6;
var $159afdcd077ecfe9$export$130df7ed74437774 = {
    prefix: 'fas',
    iconName: 'ban-smoking',
    icon: [
        512,
        512,
        [
            128685,
            "smoking-ban"
        ],
        "f54d",
        "M99.5 144.8l79.2 79.2-50.7 0c-17.7 0-32 14.3-32 32l0 32c0 17.7 14.3 32 32 32l146.7 0 92.5 92.5c-31.4 22.4-69.8 35.5-111.2 35.5-106 0-192-86-192-192 0-41.5 13.1-79.9 35.5-111.2zM333.3 288l-32-32 82.7 0 0 32-50.7 0zm32 32l18.7 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L269.3 224 144.8 99.5c31.4-22.4 69.8-35.5 111.2-35.5 106 0 192 86 192 192 0 41.5-13.1 79.9-35.5 111.2L365.3 320zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM272 96c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48l32 0c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48l-32 0c-8.8 0-16-7.2-16-16s-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$e50452a49dec29f = $159afdcd077ecfe9$export$130df7ed74437774;
var $159afdcd077ecfe9$export$4a5a13c01d46357c = {
    prefix: 'fas',
    iconName: 'truck-front',
    icon: [
        448,
        512,
        [],
        "e2b7",
        "M0 112C0 67.8 35.8 32 80 32l288 0c44.2 0 80 35.8 80 80l0 256c0 26.2-12.6 49.4-32 64l0 48c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-32-192 0 0 32c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-48C12.6 417.4 0 394.2 0 368L0 112zm96 80l0 64 256 0 0-64c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32zm32 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm224 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$f26673f8b10c3d46 = {
    prefix: 'fas',
    iconName: 'building',
    icon: [
        384,
        512,
        [
            127970,
            61687
        ],
        "f1ad",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM176 352l32 0c17.7 0 32 14.3 32 32l0 80-96 0 0-80c0-17.7 14.3-32 32-32zM96 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM240 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm144-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$554720e3bf74fe90 = {
    prefix: 'fas',
    iconName: 'bullseye',
    icon: [
        512,
        512,
        [],
        "f140",
        "M448 256a192 192 0 1 0 -384 0 192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 80a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-224a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM224 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$6e5225f0e6c0bacd = {
    prefix: 'fas',
    iconName: 'arrow-left-long',
    icon: [
        576,
        512,
        [
            "long-arrow-left"
        ],
        "f177",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 544 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-434.7 0 73.4-73.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-128 128z"
    ]
};
var $159afdcd077ecfe9$export$80896efc906118b4 = $159afdcd077ecfe9$export$6e5225f0e6c0bacd;
var $159afdcd077ecfe9$export$5d65c40a109eb09c = {
    prefix: 'fas',
    iconName: 'chess-rook',
    icon: [
        384,
        512,
        [
            9820
        ],
        "f447",
        "M0 32L0 133.5c0 17 6.7 33.3 18.7 45.3L64 224 64 384 7.8 454.3C2.7 460.6 0 468.4 0 476.5 0 496.1 15.9 512 35.5 512l312.9 0c19.6 0 35.5-15.9 35.5-35.5 0-8.1-2.7-15.9-7.8-22.2l-56.2-70.3 0-160 45.3-45.3c12-12 18.7-28.3 18.7-45.3L384 32c0-17.7-14.3-32-32-32L320 0c-17.7 0-32 14.3-32 32l0 32-48 0 0-32c0-17.7-14.3-32-32-32L176 0c-17.7 0-32 14.3-32 32l0 32-48 0 0-32C96 14.3 81.7 0 64 0L32 0C14.3 0 0 14.3 0 32z"
    ]
};
var $159afdcd077ecfe9$export$f35a116a762ef8fc = {
    prefix: 'fas',
    iconName: 'blender-phone',
    icon: [
        576,
        512,
        [],
        "f6b6",
        "M151.4 13.2c10.2 5.8 14.5 18.4 10 29.3L138.2 98.8c-3.9 9.6-13.7 15.4-24 14.4l-20.2-2C78.7 152.9 78 198.9 91.9 241.1l22.4-2.2c10.3-1 20 4.8 24 14.4l23.2 56.3c4.5 10.9 .2 23.4-10 29.3l-2.9 1.6c-33.6 19.2-81.7 16.2-106.2-21.6-56.3-86.6-56.3-199.1 0-285.7 24.6-37.7 72.7-40.7 106.2-21.6l2.9 1.6zM224 336L193.7 17.5C192.8 8.1 200.2 0 209.6 0l324 0c21.3 0 36.6 20.3 30.8 40.8L553.1 80 440 80c-13.3 0-24 10.7-24 24s10.7 24 24 24l99.4 0-18.3 64-81.1 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l67.4 0-27.4 96-256 0zm8 48l240 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-240 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm120 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$2d3ccb9b2099f3fe = {
    prefix: 'fas',
    iconName: 'arrow-turn-up',
    icon: [
        384,
        512,
        [
            "level-up"
        ],
        "f148",
        "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"
    ]
};
var $159afdcd077ecfe9$export$c227d3ba1de97ceb = $159afdcd077ecfe9$export$2d3ccb9b2099f3fe;
var $159afdcd077ecfe9$export$36cb1885ad7a570f = {
    prefix: 'fas',
    iconName: 'bicycle',
    icon: [
        640,
        512,
        [
            128690
        ],
        "f206",
        "M331.7 43.3C336 36.3 343.7 32 352 32l104 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-65.6 0 72.2 148.4c10.7-2.9 21.9-4.4 33.4-4.4 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-42 20.2-79.2 51.4-102.6l-20.4-41.9-73.5 147c-2.3 4.8-6.3 8.8-11.4 11.2-.6 .3-1.2 .5-1.8 .7-2.9 1.1-5.9 1.6-8.9 1.5L271 368c-7.9 63.1-61.7 112-127 112-70.7 0-128-57.3-128-128S73.3 224 144 224c10.8 0 21.2 1.3 31.2 3.8l28.5-56.9-11.5-26.9-40.2 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0c9.6 0 18.3 5.7 22.1 14.5l14.3 33.5 123.7 0-37.7-77.5c-3.6-7.4-3.2-16.2 1.2-23.2zM228.5 228.7l-45.6 91.3 84.8 0-39.1-91.3zM305.7 287l47.5-95-88.2 0 40.7 95zm168.7 75.5l-29.7-61c-12.8 13-20.7 30.8-20.7 50.5 0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72c-2.7 0-5.5 .2-8.1 .5l29.7 61c5.8 11.9 .8 26.3-11.1 32.1s-26.3 .8-32.1-11.1zM149.2 368c-20.2 0-33.4-21.3-24.3-39.4l24.2-48.5c-1.7-.1-3.4-.2-5.1-.2-39.8 0-72 32.2-72 72s32.2 72 72 72c34.3 0 62.9-23.9 70.2-56l-65 0z"
    ]
};
var $159afdcd077ecfe9$export$a30c52cde32bec7e = {
    prefix: 'fas',
    iconName: 'circle-arrow-down',
    icon: [
        512,
        512,
        [
            "arrow-circle-down"
        ],
        "f0ab",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM239 377l-80-80c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l39 39 0-150.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 150.1 39-39c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$6cfa36bbb3a057 = $159afdcd077ecfe9$export$a30c52cde32bec7e;
var $159afdcd077ecfe9$export$ec05accb7226d001 = {
    prefix: 'fas',
    iconName: 'gear',
    icon: [
        512,
        512,
        [
            9881,
            "cog"
        ],
        "f013",
        "M195.1 9.5C198.1-5.3 211.2-16 226.4-16l59.8 0c15.2 0 28.3 10.7 31.3 25.5L332 79.5c14.1 6 27.3 13.7 39.3 22.8l67.8-22.5c14.4-4.8 30.2 1.2 37.8 14.4l29.9 51.8c7.6 13.2 4.9 29.8-6.5 39.9L447 233.3c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l53.4 47.5c11.4 10.1 14 26.8 6.5 39.9l-29.9 51.8c-7.6 13.1-23.4 19.2-37.8 14.4l-67.8-22.5c-12.1 9.1-25.3 16.7-39.3 22.8l-14.4 69.9c-3.1 14.9-16.2 25.5-31.3 25.5l-59.8 0c-15.2 0-28.3-10.7-31.3-25.5l-14.4-69.9c-14.1-6-27.2-13.7-39.3-22.8L73.5 432.3c-14.4 4.8-30.2-1.2-37.8-14.4L5.8 366.1c-7.6-13.2-4.9-29.8 6.5-39.9l53.4-47.5c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7L12.3 185.8c-11.4-10.1-14-26.8-6.5-39.9L35.7 94.1c7.6-13.2 23.4-19.2 37.8-14.4l67.8 22.5c12.1-9.1 25.3-16.7 39.3-22.8L195.1 9.5zM256.3 336a80 80 0 1 0 -.6-160 80 80 0 1 0 .6 160z"
    ]
};
var $159afdcd077ecfe9$export$d6298bbfd1912a78 = $159afdcd077ecfe9$export$ec05accb7226d001;
var $159afdcd077ecfe9$export$1dc6221efb867885 = {
    prefix: 'fas',
    iconName: 'mars-and-venus-burst',
    icon: [
        640,
        512,
        [],
        "e523",
        "M464-32c0 17.7 14.3 32 32 32l34.7 0-63 63c-28.4-19.5-62.7-31-99.8-31-97.2 0-176 78.8-176 176 0 86.3 62.1 158.1 144 173.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9c81.9-15 144-86.8 144-173.1 0-37-11.4-71.4-31-99.8l63-63 0 34.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-112c0-17.7-14.3-32-32-32L496-64c-17.7 0-32 14.3-32 32zM368 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM190.9-21.9C188.4-28 182.6-32 176-32s-12.4 4-14.9 10.1l-29.4 74-76.2-23.1c-6.3-1.9-13.1 .2-17.2 5.3S33.8 46.5 37 52.2l39.5 69.1-65.6 45.1c-5.4 3.7-8 10.3-6.5 16.7s6.7 11.2 13.1 12.2l78.7 12.2-5.6 79.4c-.5 6.5 3.1 12.7 9 15.5s12.9 1.8 17.8-2.6L152.1 268c-5.3-19.1-8.1-39.2-8.1-60 0-65.4 28-124.2 72.6-165.1L190.9-21.9z"
    ]
};
var $159afdcd077ecfe9$export$743cce3ca4eb1d7d = {
    prefix: 'fas',
    iconName: 'otter',
    icon: [
        640,
        512,
        [
            129446
        ],
        "f700",
        "M181.5 197.1l12.9 6.4c5.9 3 12.4 4.5 19.1 4.5 23.5 0 42.6-19.1 42.6-42.6l0-21.4c0-35.3-28.7-64-64-64l-64 0c-35.3 0-64 28.7-64 64l0 21.4c0 23.5 19.1 42.6 42.6 42.6 6.6 0 13.1-1.5 19.1-4.5 9.3-4.7 16.4-8.2 21.2-10.6L135.1 185c-4.5-3-7.1-8-7.1-13.3l0-3.7c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 3.7c0 5.3-2.7 10.3-7.1 13.3l-11.8 7.9 8.4 4.2zm-8.6 49.4l-12.9-6.4-12.9 6.4c-12.6 6.3-26.5 9.6-40.5 9.6-3.6 0-7.1-.2-10.6-.6l0 .6c0 35.3 28.7 64 64 64l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l160 0 0-64c0-23.7 12.9-44.4 32-55.4 9.4-5.4 20.3-8.6 32-8.6l0-16c0-26.5 21.5-48 48-48 8.8 0 16 7.2 16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-99.7c0-48.2-30.8-91-76.6-106.3l-8.5-2.8c-8-2.7-12.6-11.1-10.4-19.3s10.3-13.2 18.6-11.6l19.9 4C576 86.1 640 164.2 640 254.9l0 1.1 0 0c0 123.7-100.3 224-224 224l-160.6 0C132 480 32 380 32 256.6l0-39.8c-10.1-14.6-16-32.3-16-51.4l0-21.4 0-1.4C6.7 139.3 0 130.5 0 120 0 106.7 10.7 96 24 96l2.8 0C44.8 58.2 83.3 32 128 32l64 0c44.7 0 83.2 26.2 101.2 64l2.8 0c13.3 0 24 10.7 24 24 0 10.5-6.7 19.3-16 22.6l0 1.4 0 21.4c0 1.4 0 2.8-.1 4.3 12-6.2 25.7-9.6 40.1-9.6l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-13.3 0-24 10.7-24 24l0 8 56.4 0c-15.2 17-24.4 39.4-24.4 64l-32 0c-42.3 0-78.2-27.4-91-65.3-5.1 .9-10.3 1.3-15.6 1.3-14.1 0-27.9-3.3-40.5-9.6zM96 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"
    ]
};
var $159afdcd077ecfe9$export$f2b13ad44c03c40f = {
    prefix: 'fas',
    iconName: 'circle-chevron-left',
    icon: [
        512,
        512,
        [
            "chevron-circle-left"
        ],
        "f137",
        "M512 256a256 256 0 1 0 -512 0 256 256 0 1 0 512 0zM271 135c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-87 87 87 87c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L167 273c-9.4-9.4-9.4-24.6 0-33.9L271 135z"
    ]
};
var $159afdcd077ecfe9$export$4a42c8c2451a33fd = $159afdcd077ecfe9$export$f2b13ad44c03c40f;
var $159afdcd077ecfe9$export$d7cf0978afd90002 = {
    prefix: 'fas',
    iconName: 'circle-question',
    icon: [
        512,
        512,
        [
            62108,
            "question-circle"
        ],
        "f059",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-336c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 47.2-36 67.2-56 74.5l0 3.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8.1c0-20.5 14.8-35.2 30.1-40.2 6.4-2.1 13.2-5.5 18.2-10.3 4.3-4.2 7.7-10 7.7-19.6 0-17.7-14.3-32-32-32zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$5ba67d7f2265c1a5 = $159afdcd077ecfe9$export$d7cf0978afd90002;
var $159afdcd077ecfe9$export$8a322f740d64e9fc = {
    prefix: 'fas',
    iconName: 'walkie-talkie',
    icon: [
        384,
        512,
        [],
        "f8ef",
        "M88-32c13.3 0 24 10.7 24 24l0 72 48 0c0-17.7 14.3-32 32-32s32 14.3 32 32l32 0c0-17.7 14.3-32 32-32s32 14.3 32 32l16 0c26.5 0 48 21.5 48 48l0 160.9c0 9.9-2.3 19.7-6.8 28.6l-20.2 40.4c-3.3 6.7-5.1 14-5.1 21.5l0 84.7c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-84.7c0-7.5-1.7-14.8-5.1-21.5L6.8 301.5C2.3 292.6 0 282.8 0 272.9L0 112C0 85.5 21.5 64 48 64l16 0 0-72c0-13.3 10.7-24 24-24zm32 176c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
var $159afdcd077ecfe9$export$3d626cfc365a7e36 = {
    prefix: 'fas',
    iconName: 'user-group',
    icon: [
        576,
        512,
        [
            128101,
            "user-friends"
        ],
        "f500",
        "M64 128a112 112 0 1 1 224 0 112 112 0 1 1 -224 0zM0 464c0-97.2 78.8-176 176-176s176 78.8 176 176l0 6c0 23.2-18.8 42-42 42L42 512c-23.2 0-42-18.8-42-42l0-6zM432 64a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 240c79.5 0 144 64.5 144 144l0 22.4c0 23-18.6 41.6-41.6 41.6l-144.8 0c6.6-12.5 10.4-26.8 10.4-42l0-6c0-51.5-17.4-98.9-46.5-136.7 22.6-14.7 49.6-23.3 78.5-23.3z"
    ]
};
var $159afdcd077ecfe9$export$46073bec205635d9 = $159afdcd077ecfe9$export$3d626cfc365a7e36;
var $159afdcd077ecfe9$export$af554427144a7e5c = {
    prefix: 'fas',
    iconName: 'house-chimney',
    icon: [
        512,
        512,
        [
            63499,
            "home-lg"
        ],
        "e3af",
        "M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208zM240 320c-26.5 0-48 21.5-48 48l0 96 128 0 0-96c0-26.5-21.5-48-48-48l-32 0z"
    ]
};
var $159afdcd077ecfe9$export$dbab81727ec94698 = $159afdcd077ecfe9$export$af554427144a7e5c;
var $159afdcd077ecfe9$export$122a80ae0f87f726 = {
    prefix: 'fas',
    iconName: 'right-from-bracket',
    icon: [
        512,
        512,
        [
            "sign-out-alt"
        ],
        "f2f5",
        "M505 273c9.4-9.4 9.4-24.6 0-33.9L361 95c-6.9-6.9-17.2-8.9-26.2-5.2S320 102.3 320 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L505 273zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z"
    ]
};
var $159afdcd077ecfe9$export$c844d6923b7096c2 = $159afdcd077ecfe9$export$122a80ae0f87f726;
var $159afdcd077ecfe9$export$cad54bead856a678 = {
    prefix: 'fas',
    iconName: 'file',
    icon: [
        384,
        512,
        [
            128196,
            128459,
            61462
        ],
        "f15b",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176z"
    ]
};
var $159afdcd077ecfe9$export$cfee4df0d5df6d21 = {
    prefix: 'fas',
    iconName: 'plane-slash',
    icon: [
        576,
        512,
        [],
        "e069",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-183.4-183.4 7.1-7.7 127.3 0c30.9 0 56-25.1 56-56s-25.1-56-56-56L392.7 200 233.5 26.4C227.5 19.8 218.9 16 209.9 16l-43.7 0c-10.9 0-18.6 10.7-15.2 21.1L175.1 109.2 41-24.9zM130.2 200l-24.6 0-52.8-66c-3-3.8-7.6-6-12.5-6l-19.8 0c-10.4 0-18 9.8-15.5 19.9L32 256 5 364.1C2.4 374.2 10.1 384 20.5 384l19.8 0c4.9 0 9.5-2.2 12.5-6l52.8-66 99.7 0-54.3 162.9c-3.5 10.4 4.3 21.1 15.2 21.1l43.7 0c9 0 17.5-3.8 23.6-10.4L320.7 390.5 130.2 200z"
    ]
};
var $159afdcd077ecfe9$export$af51c741ee9cc090 = {
    prefix: 'fas',
    iconName: 'cloud-showers-heavy',
    icon: [
        512,
        512,
        [],
        "f740",
        "M96 320c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.3-6.7-1.9-13.7-1.9-20.8 0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16 .5 0 1.1 0 1.6 0 53 0 96 43 96 96s-43 96-96 96L96 320zm6.8 79.6l-32 96C66.6 508.2 53 515 40.4 510.8S21 493 25.2 480.4l32-96C61.4 371.8 75 365 87.6 369.2S107 387 102.8 399.6zm120 0l-32 96c-4.2 12.6-17.8 19.4-30.4 15.2S141 493 145.2 480.4l32-96c4.2-12.6 17.8-19.4 30.4-15.2S227 387 222.8 399.6zm112 0l-32 96c-4.2 12.6-17.8 19.4-30.4 15.2S253 493 257.2 480.4l32-96c4.2-12.6 17.8-19.4 30.4-15.2S339 387 334.8 399.6zm120 0l-32 96c-4.2 12.6-17.8 19.4-30.4 15.2S373 493 377.2 480.4l32-96c4.2-12.6 17.8-19.4 30.4-15.2S459 387 454.8 399.6z"
    ]
};
var $159afdcd077ecfe9$export$e94ab3a30cf4aca5 = {
    prefix: 'fas',
    iconName: 'person-falling',
    icon: [
        512,
        512,
        [],
        "e546",
        "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 5.4c0 45-23.6 86.6-62.1 109.8l-4.6 2.8C131.4 184.7 96 247.1 96 314.6L96 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-69.4c0-16.7 3.3-33 9.4-48L359.2 500.2c11.1 13.7 31.3 15.8 45 4.7s15.8-31.3 4.7-45L295.2 320 400 320 438.4 371.2c10.6 14.1 30.7 17 44.8 6.4s17-30.7 6.4-44.8l-43.2-57.6C437.3 263.1 423.1 256 408 256l-89 0-62.9-75.5c40.3-36 63.9-87.9 63.9-143.1l0-5.4zM104 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
    ]
};
var $159afdcd077ecfe9$export$b5dc9dd0347bbb6 = {
    prefix: 'fas',
    iconName: 'turn-down',
    icon: [
        384,
        512,
        [
            10549,
            "level-down-alt"
        ],
        "f3be",
        "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S332.9 320 320 320l-64 0 0-160C256 71.6 184.4 0 96 0L32 0C14.3 0 0 14.3 0 32L0 96c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l0 160-64 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"
    ]
};
var $159afdcd077ecfe9$export$c07eb6ff5a382cbd = $159afdcd077ecfe9$export$b5dc9dd0347bbb6;
var $159afdcd077ecfe9$export$95457ede07b81517 = {
    prefix: 'fas',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
        512,
        512,
        [
            "expand-alt"
        ],
        "f424",
        "M344 0L488 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87-39-39c-6.9-6.9-8.9-17.2-5.2-26.2S334.3 0 344 0zM168 512L24 512c-13.3 0-24-10.7-24-24L0 344c0-9.7 5.8-18.5 14.8-22.2S34.1 320.2 41 327l39 39 87-87c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2S177.7 512 168 512z"
    ]
};
var $159afdcd077ecfe9$export$bcb8d86a3a1d6eb6 = $159afdcd077ecfe9$export$95457ede07b81517;
var $159afdcd077ecfe9$export$9eec597148166b36 = {
    prefix: 'fas',
    iconName: 'user-tag',
    icon: [
        640,
        512,
        [],
        "f507",
        "M256.1 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zM226.4 304l59.4 0c6.7 0 13.2 .4 19.7 1.1-.9 4.9-1.4 9.9-1.4 15l0 92.1c0 25.5 10.1 49.9 28.1 67.9l31.9 31.9-286.3 0c-16.4 0-29.7-13.3-29.7-29.7 0-98.5 79.8-178.3 178.3-178.3zM352.1 412.2l0-92.1c0-17.7 14.3-32 32-32l92.1 0c12.7 0 24.9 5.1 33.9 14.1l96 96c18.7 18.7 18.7 49.1 0 67.9l-76.1 76.1c-18.7 18.7-49.1 18.7-67.9 0l-96-96c-9-9-14.1-21.2-14.1-33.9zm104-44.2a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$72e2d874a963de0c = {
    prefix: 'fas',
    iconName: 'hand-sparkles',
    icon: [
        640,
        512,
        [],
        "e05d",
        "M320 0c17.7 0 32 14.3 32 32l0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112c0-17.7 14.3-32 32-32s32 14.3 32 32l0 178.2c-19.2 5.4-34.7 20.4-40.4 40.3l-6.5 22.7-22.7 6.5c-25.2 7.2-42.5 30.2-42.5 56.4 0 22.1 12.4 42 31.4 51.9-27.5 17.8-60.2 28.1-95.4 28.1l-19.2 0c-59.6 0-116.9-22.9-160-64L76.4 341c-16-15.2-16.6-40.6-1.4-56.6s40.6-16.6 56.6-1.4l60.5 57.6c0-1.5-.1-3.1-.1-4.6l0-272c0-17.7 14.3-32 32-32s32 14.3 32 32l0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208c0-17.7 14.3-32 32-32zm-7.3 326.6c-1.1-3.9-4.7-6.6-8.7-6.6s-7.6 2.7-8.7 6.6l-7.3 25.4-25.4 7.3c-3.9 1.1-6.6 4.7-6.6 8.7s2.7 7.6 6.6 8.7l25.4 7.3 7.3 25.4c1.1 3.9 4.7 6.6 8.7 6.6s7.6-2.7 8.7-6.6l7.3-25.4 25.4-7.3c3.9-1.1 6.6-4.7 6.6-8.7s-2.7-7.6-6.6-8.7l-25.4-7.3-7.3-25.4zM104 120l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L104 168 90.2 216.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L56 168 7.7 154.2C3.1 152.9 0 148.7 0 144s3.1-8.9 7.7-10.2L56 120 69.8 71.7C71.1 67.1 75.3 64 80 64s8.9 3.1 10.2 7.7L104 120zM584 408l48.3 13.8c4.6 1.3 7.7 5.5 7.7 10.2s-3.1 8.9-7.7 10.2L584 456 570.2 504.3c-1.3 4.6-5.5 7.7-10.2 7.7s-8.9-3.1-10.2-7.7L536 456 487.7 442.2c-4.6-1.3-7.7-5.5-7.7-10.2s3.1-8.9 7.7-10.2L536 408 549.8 359.7c1.3-4.6 5.5-7.7 10.2-7.7s8.9 3.1 10.2 7.7L584 408z"
    ]
};
var $159afdcd077ecfe9$export$ab3a06d4b53c0fc0 = {
    prefix: 'fas',
    iconName: 'arrows-to-dot',
    icon: [
        512,
        512,
        [],
        "e4be",
        "M256 0c17.7 0 32 14.3 32 32l0 32 32 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-9.2-9.2-11.9-22.9-6.9-34.9S179.1 64 192 64l32 0 0-32c0-17.7 14.3-32 32-32zM169.4 393.4l64-64c12.5-12.5 32.8-12.5 45.3 0l64 64c9.2 9.2 11.9 22.9 6.9 34.9S332.9 448 320 448l-32 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9zM32 224l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S64 332.9 64 320l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm297.4 54.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9S448 179.1 448 192l0 32 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$e8ea88c55e55be7c = {
    prefix: 'fas',
    iconName: 'face-sad-cry',
    icon: [
        512,
        512,
        [
            128557,
            "sad-cry"
        ],
        "f5b3",
        "M352 493.4c-29.6 12-62.1 18.6-96 18.6s-66.4-6.6-96-18.6L160 296c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 171.7C44.4 421.6 0 344 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256c0 88-44.4 165.6-112 211.7L400 296c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 197.4zM152 196l16 0c11 0 20 9 20 20s9 20 20 20 20-9 20-20c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60 0 11 9 20 20 20s20-9 20-20 9-20 20-20zm172 20c0-11 9-20 20-20l16 0c11 0 20 9 20 20s9 20 20 20 20-9 20-20c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60 0 11 9 20 20 20s20-9 20-20zM208 336l0 32c0 26.5 21.5 48 48 48s48-21.5 48-48l0-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
    ]
};
var $159afdcd077ecfe9$export$8e924e6bd422cef9 = $159afdcd077ecfe9$export$e8ea88c55e55be7c;
var $159afdcd077ecfe9$export$18659308f17918a5 = {
    prefix: 'fas',
    iconName: 'dong-sign',
    icon: [
        384,
        512,
        [],
        "e169",
        "M288-16c-17.7 0-32 14.3-32 32l0 32-104 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0 0 72.2c-22.9-15.3-50.4-24.2-80-24.2-79.5 0-144 64.5-144 144S96.5 432 176 432c30 0 57.8-9.1 80.8-24.8 3.3 14.2 16 24.8 31.2 24.8 17.7 0 32-14.3 32-32l0-304 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-32c0-17.7-14.3-32-32-32zM96 288a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 464z"
    ]
};
var $159afdcd077ecfe9$export$d12c2d6def120efe = {
    prefix: 'fas',
    iconName: 'people-line',
    icon: [
        576,
        512,
        [],
        "e534",
        "M288 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm96 312c0 25-12.7 47-32 59.9l0 44.1-128 0 0-44.1C204.7 359 192 337 192 312l0-40c0-53 43-96 96-96s96 43 96 96l0 40zm16 104l0-27.3c19.9-22.5 32-52.2 32-84.7l0-32c0-26.7-7.3-51.6-19.9-73.1 11.1-4.5 23.2-6.9 35.9-6.9 53 0 96 43 96 96l0 32c0 23.7-12.9 44.4-32 55.4l0 40.6-112 0zM64 375.4C44.9 364.4 32 343.7 32 320l0-32c0-53 43-96 96-96 12.7 0 24.8 2.5 35.9 6.9-12.6 21.4-19.9 46.4-19.9 73.1l0 32c0 32.5 12.1 62.1 32 84.7l0 27.3-112 0 0-40.6zM128 32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm320 0a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM24 464l528 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$97d1903b1e012ff7 = {
    prefix: 'fas',
    iconName: 'square-rss',
    icon: [
        448,
        512,
        [
            "rss-square"
        ],
        "f143",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM96 136c0-13.3 10.7-24 24-24 137 0 248 111 248 248 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-110.5-89.5-200-200-200-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24 83.9 0 152 68.1 152 152 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-57.4-46.6-104-104-104-13.3 0-24-10.7-24-24zm0 120a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$89c9b1cca2c11484 = $159afdcd077ecfe9$export$97d1903b1e012ff7;
var $159afdcd077ecfe9$export$23e8b4955c2d951b = {
    prefix: 'fas',
    iconName: 'calendar-minus',
    icon: [
        448,
        512,
        [],
        "f272",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zm24 264c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
var $159afdcd077ecfe9$export$eae84dfa654882b1 = {
    prefix: 'fas',
    iconName: 'chart-diagram',
    icon: [
        512,
        512,
        [],
        "e695",
        "M80 32C53.5 32 32 53.5 32 80s21.5 48 48 48l152 0 0 40-48 48-72 0c-39.8 0-72 32.2-72 72l0 64-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-64c0-13.3 10.7-24 24-24l72 0 48 48 0 40-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-40 48-48 72 0c13.3 0 24 10.7 24 24l0 64-8 0c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-8 0 0-64c0-39.8-32.2-72-72-72l-72 0-48-48 0-40 152 0c26.5 0 48-21.5 48-48s-21.5-48-48-48L80 32z"
    ]
};
var $159afdcd077ecfe9$export$5352cbdc070ce8d = {
    prefix: 'fas',
    iconName: 'face-tired',
    icon: [
        512,
        512,
        [
            128555,
            "tired"
        ],
        "f5c8",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM164.7 328.7c22-22 53.9-40.7 91.3-40.7s69.3 18.7 91.3 40.7c11.1 11.1 20.1 23.4 26.4 35.4 6.2 11.7 10.3 24.4 10.3 35.9 0 5.2-2.6 10.2-6.9 13.2s-9.8 3.7-14.7 1.8l-20.5-7.7c-26.9-10.1-55.5-15.3-84.3-15.3l-3.2 0c-28.8 0-57.3 5.2-84.3 15.3L149.6 415c-4.9 1.8-10.4 1.2-14.7-1.8S128 405.2 128 400c0-11.6 4.2-24.2 10.3-35.9 6.3-12 15.3-24.3 26.4-35.4zM122.6 159.2c4.5-6.8 13.3-9.2 20.6-5.5l79.6 40c5.4 2.7 8.8 8.2 8.8 14.3s-3.4 11.6-8.8 14.3l-79.6 40c-7.3 3.6-16.1 1.3-20.6-5.5s-3.1-15.9 3.1-21.1L159 208 125.8 180.3c-6.2-5.2-7.6-14.3-3.1-21.1zm263.6 21.1L353 208 386.2 235.7c6.2 5.2 7.6 14.3 3.1 21.1s-13.3 9.2-20.6 5.5l-79.6-40c-5.4-2.7-8.8-8.2-8.8-14.3s3.4-11.6 8.8-14.3l79.6-40c7.3-3.6 16.1-1.3 20.6 5.5s3.1 15.9-3.1 21.1z"
    ]
};
var $159afdcd077ecfe9$export$3d016d62cda18371 = $159afdcd077ecfe9$export$5352cbdc070ce8d;
var $159afdcd077ecfe9$export$f7bc8714c970afa4 = {
    prefix: 'fas',
    iconName: 'hand-point-right',
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M480 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-208 0 0-64 208 0zM320 288c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm64-64c0 17.7-14.3 32-32 32l-48 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l48 0c17.7 0 32 14.3 32 32zM288 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0zm-88-96l.6 0c-5.4 9.4-8.6 20.3-8.6 32 0 13.2 4 25.4 10.8 35.6-24.9 8.7-42.8 32.5-42.8 60.4 0 11.7 3.1 22.6 8.6 32l-8.6 0C71.6 448 0 376.4 0 288l0-61.7c0-42.4 16.9-83.1 46.9-113.1l11.6-11.6C82.5 77.5 115.1 64 149 64l27 0c35.3 0 64 28.7 64 64l0 88c0 22.1-17.9 40-40 40s-40-17.9-40-40l0-56c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 56c0 39.8 32.2 72 72 72z"
    ]
};
var $159afdcd077ecfe9$export$8e144ed4d52eef49 = {
    prefix: 'fas',
    iconName: 'arrow-up',
    icon: [
        384,
        512,
        [
            8593
        ],
        "f062",
        "M214.6 17.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 117.3 160 488c0 17.7 14.3 32 32 32s32-14.3 32-32l0-370.7 105.4 105.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160z"
    ]
};
var $159afdcd077ecfe9$export$b1f00c433aabac05 = {
    prefix: 'fas',
    iconName: 'cubes-stacked',
    icon: [
        512,
        512,
        [],
        "e4e6",
        "M192 32c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64zm32 352l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm192 0l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zM320 192l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm-182.6-3.9c12.5-12.5 32.8-12.5 45.3 0l45.3 45.3c12.5 12.5 12.5 32.8 0 45.3l-45.3 45.3c-12.5 12.5-32.8 12.5-45.3 0L92.1 278.6c-12.5-12.5-12.5-32.8 0-45.3l45.3-45.3zM32 384l64 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$f7367a7301f2dc0f = {
    prefix: 'fas',
    iconName: 'child-combatant',
    icon: [
        576,
        512,
        [
            "child-rifle"
        ],
        "e4e0",
        "M176.5 128a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-16 352l0-96 32 0 0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-192.2 20.9 33.2c9.4 15 29.2 19.4 44.1 10s19.4-29.2 10-44.1l-39.9-63.3C266.8 184 223.3 160 176.5 160S86.2 184 61.3 223.6L21.4 287c-9.4 15-4.9 34.7 10 44.1s34.7 4.9 44.1-10l20.9-33.2 0 192.2c0 17.7 14.3 32 32 32s32-14.3 32-32zM448.5 0l-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 100.3c-9.6 5.5-16 15.9-16 27.7l0 32c-17.7 0-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32l16 0 0 96c0 8.8 7.2 16 16 16l59.5 0c10.4 0 18-9.8 15.5-19.9l-23-92.1 44 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-26.7 53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2l0-84.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 56-16 5.3 0-109.3c0-11.8-6.4-22.2-16-27.7l0-116.3c0-8.8-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$9b027cdb5db3ae5c = $159afdcd077ecfe9$export$f7367a7301f2dc0f;
var $159afdcd077ecfe9$export$750a64470c2e0f3f = {
    prefix: 'fas',
    iconName: 'vest-patches',
    icon: [
        448,
        512,
        [],
        "e086",
        "M200 293.9L200 464c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 270.5c0-9.5 2.8-18.7 8.1-26.6l47.9-71.8c5.3-7.9 8.1-17.1 8.1-26.6L64 48C64 21.5 85.5 0 112 0l3.5 0c.3 0 .6 0 1 0 .6 0 1.2 0 1.8 0 18.8 0 34.1 9.7 44.1 18.8 9.3 8.4 28.5 21.2 61.7 21.2s52.4-12.8 61.7-21.2c10-9.1 25.3-18.8 44.1-18.8 .6 0 1.2 0 1.8 0 .3 0 .6 0 1 0L336 0c26.5 0 48 21.5 48 48l0 97.5c0 9.5 2.8 18.7 8.1 26.6l47.9 71.8c5.3 7.9 8.1 17.1 8.1 26.6L448 464c0 26.5-21.5 48-48 48l-104 0c-26.5 0-48-21.5-48-48l0-170.1c0-3.9 .5-7.8 1.4-11.6L303.6 65.4C285.9 77.2 259.8 88 224 88s-61.9-10.8-79.6-22.6l54.2 216.8c1 3.8 1.4 7.7 1.4 11.6zM96 456a40 40 0 1 0 0-80 40 40 0 1 0 0 80zM63.5 255.5c-4.7 4.7-4.7 12.3 0 17L79 288 63.5 303.5c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0L96 305 111.5 320.5c4.7 4.7 12.3 4.7 17 0s4.7-12.3 0-17L113 288 128.5 272.5c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0L96 271 80.5 255.5c-4.7-4.7-12.3-4.7-17 0zM304 280l0 40c0 8.8 7.2 16 16 16l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $159afdcd077ecfe9$export$a8a0de30198815a3 = {
    prefix: 'fas',
    iconName: 'martini-glass-empty',
    icon: [
        512,
        512,
        [
            "glass-martini"
        ],
        "f000",
        "M32 32C19.1 32 7.4 39.8 2.4 51.8S.2 77.5 9.4 86.6l214.6 214.6 0 146.7-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-146.7 214.6-214.6c9.2-9.2 11.9-22.9 6.9-34.9S492.9 32 480 32L32 32zM256 242.7L109.3 96 402.7 96 256 242.7z"
    ]
};
var $159afdcd077ecfe9$export$e96f280e39af4a91 = $159afdcd077ecfe9$export$a8a0de30198815a3;
var $159afdcd077ecfe9$export$78932e9c9abea6b7 = {
    prefix: 'fas',
    iconName: 'magnet',
    icon: [
        448,
        512,
        [
            129522
        ],
        "f076",
        "M0 176L0 288C0 411.7 100.3 512 224 512S448 411.7 448 288l0-112-128 0 0 112c0 53-43 96-96 96s-96-43-96-96l0-112-128 0zm0-48l128 0 0-64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64zm320 0l128 0 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 64z"
    ]
};
var $159afdcd077ecfe9$export$f3e925217e396f44 = {
    prefix: 'fas',
    iconName: 'road-barrier',
    icon: [
        640,
        512,
        [],
        "e562",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 266.3 149.2 96 64 96 64 64c0-17.7-14.3-32-32-32zM405.2 96l-74.3 0-5.4 10.7-90.6 181.3 74.3 0 5.4-10.7 90.6-181.3zM362.8 288l74.3 0 5.4-10.7 90.6-181.3-74.3 0-5.4 10.7-90.6 181.3zM202.8 96l-5.4 10.7-90.6 181.3 74.3 0 5.4-10.7 90.6-181.3-74.3 0zm288 192l85.2 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 53.7-85.2 170.3z"
    ]
};
var $159afdcd077ecfe9$export$aaaddd2cf7e20f64 = {
    prefix: 'fas',
    iconName: 'compass-drafting',
    icon: [
        512,
        512,
        [
            "drafting-compass"
        ],
        "f568",
        "M99.3 256.1l69.4-119.9c-5.6-12.2-8.8-25.8-8.8-40.2 0-53 43-96 96-96s96 43 96 96c0 14.3-3.1 27.9-8.8 40.2l44.4 76.7c-23.1 26-53.7 45.1-88.4 53.8L256 191.9 187.9 309.5c21.5 6.8 44.3 10.5 68.1 10.5 70.7 0 133.8-32.7 174.9-84 11.1-13.8 31.2-16 45-5s16 31.2 5 45c-52.7 65.8-133.9 108-224.8 108-35.4 0-69.4-6.4-100.7-18.1L98.7 463.7C94 471.8 87 478.4 78.6 482.6L23.2 510.3c-5 2.5-10.9 2.2-15.6-.7S0 501.5 0 496l0-55.4c0-8.4 2.2-16.7 6.5-24.1l60-103.7c-12.8-11.2-24.6-23.5-35.3-36.8-11.1-13.8-8.8-33.9 5-45s33.9-8.8 45 5c5.7 7.1 11.8 13.8 18.2 20.1zM381.1 407.9c32.5-13 62.4-31 88.9-52.9l35.6 61.5c4.2 7.3 6.5 15.6 6.5 24.1l0 55.4c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6 .7l-55.4-27.7c-8.4-4.2-15.4-10.8-20.1-18.9l-32.3-55.8zM256 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$c8c2b127d13b9d79 = $159afdcd077ecfe9$export$aaaddd2cf7e20f64;
var $159afdcd077ecfe9$export$8aaca358568da0e0 = {
    prefix: 'fas',
    iconName: 'square-person-confined',
    icon: [
        448,
        512,
        [],
        "e577",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm80 104c0-30.9 25.1-56 56-56s56 25.1 56 56l0 102.1c0 36.4-29.5 65.9-65.9 65.9-17.5 0-34.3-6.9-46.6-19.3l-54.7-54.7-28.1 56.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l48-96c4.6-9.2 13.3-15.6 23.5-17.3s20.5 1.7 27.8 9l41.4 41.4 0-58.7z"
    ]
};
var $159afdcd077ecfe9$export$2eff9f6cbe00a643 = {
    prefix: 'fas',
    iconName: 'plate-wheat',
    icon: [
        512,
        512,
        [],
        "e55a",
        "M176 32c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80l0-16c0-8.8 7.2-16 16-16zM56 64l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24S42.7 64 56 64zM24 136l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 184c-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 96c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM272 48c0-8.8 7.2-16 16-16 44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80l0-16zM400 32c44.2 0 80 35.8 80 80l0 16c0 8.8-7.2 16-16 16-44.2 0-80-35.8-80-80l0-16c0-8.8 7.2-16 16-16zm80 160l0 16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16zM352 176c8.8 0 16 7.2 16 16l0 16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80zm-96 16l0 16c0 44.2-35.8 80-80 80-8.8 0-16-7.2-16-16l0-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16zM3.5 347.6C1.6 332.9 13 320 27.8 320l456.4 0c14.8 0 26.2 12.9 24.4 27.6-6.3 50.2-44.4 89.4-92.6 98.4l0 2c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-2c-48.2-9-86.3-48.2-92.5-98.4z"
    ]
};
var $159afdcd077ecfe9$export$5c1f29f4c7cad367 = {
    prefix: 'fas',
    iconName: 'sign-hanging',
    icon: [
        512,
        512,
        [
            "sign"
        ],
        "f4d9",
        "M96 0c17.7 0 32 14.3 32 32l0 32 352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-352 0 0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352-32 0C14.3 128 0 113.7 0 96S14.3 64 32 64l32 0 0-32C64 14.3 78.3 0 96 0zM208 176l240 0c17.7 0 32 14.3 32 32l0 144c0 17.7-14.3 32-32 32l-240 0c-17.7 0-32-14.3-32-32l0-144c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$d21d0d6c8e9e8bf9 = $159afdcd077ecfe9$export$5c1f29f4c7cad367;
var $159afdcd077ecfe9$export$a44d0c11093d9c1e = {
    prefix: 'fas',
    iconName: 'car-battery',
    icon: [
        512,
        512,
        [
            "battery-car"
        ],
        "f5df",
        "M80 64c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l96 0c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l16 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l16 0zM392 184c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32zM64 240c0 13.3 10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 216c-13.3 0-24 10.7-24 24z"
    ]
};
var $159afdcd077ecfe9$export$9133165ca669dd4b = $159afdcd077ecfe9$export$a44d0c11093d9c1e;
var $159afdcd077ecfe9$export$312f2c01c6fedca8 = {
    prefix: 'fas',
    iconName: 'shirt',
    icon: [
        640,
        512,
        [
            128085,
            "t-shirt",
            "tshirt"
        ],
        "f553",
        "M320.2 112c44.2 0 80-35.8 80-80l53.5 0c17 0 33.3 6.7 45.3 18.7L617.6 169.4c12.5 12.5 12.5 32.8 0 45.3l-50.7 50.7c-12.5 12.5-32.8 12.5-45.3 0l-41.4-41.4 0 224c0 35.3-28.7 64-64 64l-192 0c-35.3 0-64-28.7-64-64l0-224-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0L22.9 214.6c-12.5-12.5-12.5-32.8 0-45.3L141.5 50.7c12-12 28.3-18.7 45.3-18.7l53.5 0c0 44.2 35.8 80 80 80z"
    ]
};
var $159afdcd077ecfe9$export$144e5f8bc4d705a6 = $159afdcd077ecfe9$export$312f2c01c6fedca8;
var $159afdcd077ecfe9$export$36edce3ba87c2b17 = $159afdcd077ecfe9$export$312f2c01c6fedca8;
var $159afdcd077ecfe9$export$dec46f8df1860e0 = {
    prefix: 'fas',
    iconName: 'paragraph',
    icon: [
        448,
        512,
        [
            182
        ],
        "f1dd",
        "M160 0L416 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 416c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-416-48 0 0 416c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160-48 0C71.6 320 0 248.4 0 160S71.6 0 160 0z"
    ]
};
var $159afdcd077ecfe9$export$dc2cce064a1e70bb = {
    prefix: 'fas',
    iconName: 'envelopes-bulk',
    icon: [
        576,
        512,
        [
            "mail-bulk"
        ],
        "f674",
        "M112 0C85.5 0 64 21.5 64 48l0 160 80 0 0-32c0-53 43-96 96-96l208 0 0-32c0-26.5-21.5-48-48-48L112 0zM240 128c-26.5 0-48 21.5-48 48l0 32 80 0c53 0 96 43 96 96l0 112 160 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-288 0zm200 64l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zM48 256c-26.5 0-48 21.5-48 48l0 10.4 156.6 86.2c1.1 .6 2.2 .9 3.4 .9s2.4-.3 3.4-.9L320 314.4 320 304c0-26.5-21.5-48-48-48L48 256zM320 369.2L186.6 442.6c-8.1 4.5-17.3 6.8-26.6 6.8s-18.4-2.4-26.6-6.8L0 369.2 0 464c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-94.8z"
    ]
};
var $159afdcd077ecfe9$export$dd24f40c5337e2e1 = $159afdcd077ecfe9$export$dc2cce064a1e70bb;
var $159afdcd077ecfe9$export$790dd5b32282b6fb = {
    prefix: 'fas',
    iconName: 'guitar',
    icon: [
        512,
        512,
        [],
        "f7a6",
        "M465 7c-9.4-9.4-24.6-9.4-33.9 0L383 55c-2.4 2.4-4.3 5.3-5.5 8.5l-15.4 41-77.5 77.6c-45.1-29.4-99.3-30.2-131 1.6-11 11-18 24.6-21.4 39.6-3.7 16.6-19.1 30.7-36.1 31.6-25.6 1.3-49.3 10.7-67.3 28.6-44.8 44.8-36.4 125.8 18.7 180.9S183.6 528 228.4 483.2c17.9-17.9 27.4-41.7 28.6-67.3 .9-17 15-32.3 31.6-36.1 15-3.4 28.6-10.5 39.6-21.4 31.8-31.8 31-85.9 1.6-131l77.6-77.6 41-15.4c3.2-1.2 6.1-3.1 8.5-5.5l48-48c9.4-9.4 9.4-24.6 0-33.9L465 7zM208 256a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $159afdcd077ecfe9$export$60710f3921019268 = {
    prefix: 'fas',
    iconName: 'suitcase',
    icon: [
        512,
        512,
        [
            129523
        ],
        "f0f2",
        "M200 48l112 0c4.4 0 8 3.6 8 8l0 40-128 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 424 224 0 0-424c0-30.9-25.1-56-56-56L200 0c-30.9 0-56 25.1-56 56zM416 96l0 384 32 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-32 0zM96 480l0-384-32 0C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l32 0z"
    ]
};
var $159afdcd077ecfe9$export$72ea8a5e4e86cd69 = {
    prefix: 'fas',
    iconName: 'circle-up',
    icon: [
        512,
        512,
        [
            61467,
            "arrow-alt-circle-up"
        ],
        "f35b",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm11.3-387.3l104 104c4.6 4.6 5.9 11.5 3.5 17.4S366.5 256 360 256l-56 0 0 96c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96-56 0c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l104-104c6.2-6.2 16.4-6.2 22.6 0z"
    ]
};
var $159afdcd077ecfe9$export$3747a8ef0995eadf = $159afdcd077ecfe9$export$72ea8a5e4e86cd69;
var $159afdcd077ecfe9$export$a2f384a559654618 = {
    prefix: 'fas',
    iconName: 'f',
    icon: [
        320,
        512,
        [
            102
        ],
        "46",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-128 224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32z"
    ]
};
var $159afdcd077ecfe9$export$f4595f012786d346 = {
    prefix: 'fas',
    iconName: 'xmarks-lines',
    icon: [
        640,
        512,
        [],
        "e59a",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l576 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416zM7 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0zM265 167c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55zM455 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$bd931e906edf2f47 = {
    prefix: 'fas',
    iconName: 'earth-oceania',
    icon: [
        512,
        512,
        [
            "globe-oceania"
        ],
        "e47b",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 150.6c0-12.5 10.1-22.6 22.6-22.6l41.4 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-18.7 0c-8.5 0-16.6-3.4-22.6-9.4l-16-16c-4.2-4.2-6.6-10-6.6-16zM432 256c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM411.3 379.3l-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM224 432c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zm-96-80c-17.7 0-32-14.3-32-32l0-18.7c0-8.5 3.4-16.6 9.4-22.6l48-48c4.2-4.2 10-6.6 16-6.6l6.6 0c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16 7.2-16 16-16l6.6 0c6 0 11.8 2.4 16 6.6l48 48c6 6 9.4 14.1 9.4 22.6l0 50.7c0 17.7-14.3 32-32 32l-50.7 0c-8.5 0-16.6-3.4-22.6-9.4l-13.3-13.3c-6-6-14.1-9.4-22.6-9.4L128 352z"
    ]
};
var $159afdcd077ecfe9$export$8ac3f5271448657d = $159afdcd077ecfe9$export$bd931e906edf2f47;
var $159afdcd077ecfe9$export$3786a0422a3f33ea = {
    prefix: 'fas',
    iconName: 'comment-slash',
    icon: [
        576,
        512,
        [],
        "f4b3",
        "M41-25C31.6-34.3 16.4-34.3 7-25S-2.3-.4 7 9L535 537c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96.6-96.6c44.4-43.2 71.6-101.8 71.6-166.5 0-132.5-114.6-240-256-240-63 0-120.8 21.4-165.4 56.8L41-25zm19.4 155C42.2 163 32 200.3 32 239.9 32 294.2 51.2 344.2 83.6 384.4L34.8 476.7c-4.8 9-3.3 20 3.6 27.5S56.1 514 65.5 510l118.4-50.7c31.8 13.3 67.1 20.7 104.1 20.7 36.4 0 70.9-7.1 102.3-19.9L60.3 130.1z"
    ]
};
var $159afdcd077ecfe9$export$436587205947bca5 = {
    prefix: 'fas',
    iconName: 'play',
    icon: [
        448,
        512,
        [
            9654
        ],
        "f04b",
        "M91.2 36.9c-12.4-6.8-27.4-6.5-39.6 .7S32 57.9 32 72l0 368c0 14.1 7.5 27.2 19.6 34.4s27.2 7.5 39.6 .7l336-184c12.8-7 20.8-20.5 20.8-35.1s-8-28.1-20.8-35.1l-336-184z"
    ]
};
var $159afdcd077ecfe9$export$2db4f9712313eafa = {
    prefix: 'fas',
    iconName: 'vial-circle-check',
    icon: [
        512,
        512,
        [],
        "e596",
        "M32 32C32 14.3 46.3 0 64 0L288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 161.4c-66.1 30.3-112 97.1-112 174.6 0 39.7 12 76.6 32.7 107.2-10.3 3.1-21.3 4.8-32.7 4.8-61.9 0-112-50.1-112-112L64 64C46.3 64 32 49.7 32 32zm96 32l0 128 96 0 0-128-96 0zm96 336a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm201.4-60.9c-7.1-5.2-17.2-3.6-22.4 3.5l-53 72.9-26.8-26.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c3.3 3.3 7.9 5 12.6 4.6s8.9-2.8 11.7-6.5l64-88c5.2-7.1 3.6-17.2-3.5-22.3z"
    ]
};
var $159afdcd077ecfe9$export$ea908d3d80c57d08 = {
    prefix: 'fas',
    iconName: 'bridge-circle-check',
    icon: [
        576,
        512,
        [],
        "e4c9",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l8 0 0 64-40 0 0 112c37.6 9.4 64 43.2 64 82l0 94c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-64c0-53 43-96 96-96 6.4 0 12.7 .6 18.7 1.8 34.7-49.5 92.2-81.8 157.3-81.8 28.6 0 55.6 6.2 80 17.4l0-65.4-40 0 0-64 8 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zM424 96l0 64-80 0 0-64 80 0zM296 96l0 64-80 0 0-64 80 0zM88 96l80 0 0 64-80 0 0-64zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-86.6-60.9c7.1 5.2 8.7 15.2 3.5 22.3l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5z"
    ]
};
var $159afdcd077ecfe9$export$66c557f70914132c = {
    prefix: 'fas',
    iconName: 'cedi-sign',
    icon: [
        384,
        512,
        [],
        "e0df",
        "M232 32c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 26.5C88.8 73.9 16 156.4 16 256S88.8 438.1 184 453.5l0 26.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24.6c46.8-3.7 89.1-23.6 121.3-53.9 12.9-12.1 13.4-32.4 1.3-45.2s-32.4-13.4-45.2-1.3c-20.7 19.6-47.6 32.7-77.3 36.2l0-270.1c29.8 3.5 56.6 16.6 77.3 36.2 12.9 12.1 33.1 11.5 45.2-1.3s11.5-33.1-1.3-45.2C321.1 80.2 278.8 60.3 232 56.6L232 32zm-48 91.8l0 264.4C124.3 373.8 80 320.1 80 256s44.3-117.8 104-132.2z"
    ]
};
var $159afdcd077ecfe9$export$7ee0dbd1e92e2859 = {
    prefix: 'fas',
    iconName: 'puzzle-piece',
    icon: [
        512,
        512,
        [
            129513
        ],
        "f12e",
        "M224 0c35.3 0 64 21.5 64 48 0 10.4-4.4 20-12 27.9-6.6 6.9-12 15.3-12 24.9 0 15 12.2 27.2 27.2 27.2l44.8 0c26.5 0 48 21.5 48 48l0 44.8c0 15 12.2 27.2 27.2 27.2 9.5 0 18-5.4 24.9-12 7.9-7.5 17.5-12 27.9-12 26.5 0 48 28.7 48 64s-21.5 64-48 64c-10.4 0-20.1-4.4-27.9-12-6.9-6.6-15.3-12-24.9-12-15 0-27.2 12.2-27.2 27.2L384 464c0 26.5-21.5 48-48 48l-56.8 0c-12.8 0-23.2-10.4-23.2-23.2 0-9.2 5.8-17.3 13.2-22.8 11.6-8.7 18.8-20.7 18.8-34 0-26.5-28.7-48-64-48s-64 21.5-64 48c0 13.3 7.2 25.3 18.8 34 7.4 5.5 13.2 13.5 13.2 22.8 0 12.8-10.4 23.2-23.2 23.2L48 512c-26.5 0-48-21.5-48-48L0 343.2c0-12.8 10.4-23.2 23.2-23.2 9.2 0 17.3 5.8 22.8 13.2 8.7 11.6 20.7 18.8 34 18.8 26.5 0 48-28.7 48-64s-21.5-64-48-64c-13.3 0-25.3 7.2-34 18.8-5.5 7.4-13.5 13.2-22.8 13.2-12.8 0-23.2-10.4-23.2-23.2L0 176c0-26.5 21.5-48 48-48l108.8 0c15 0 27.2-12.2 27.2-27.2 0-9.5-5.4-18-12-24.9-7.5-7.9-12-17.5-12-27.9 0-26.5 28.7-48 64-48z"
    ]
};
var $159afdcd077ecfe9$export$5e975cb293c48461 = {
    prefix: 'fas',
    iconName: 'helmet-un',
    icon: [
        512,
        512,
        [],
        "e503",
        "M479.5 224C471.2 98.9 367.2 0 240 0 107.5 0 0 107.5 0 240l0 56.3C0 344.8 39.2 384 87.7 384l127.3 0 128.6 121.4c4.5 4.2 10.4 6.6 16.5 6.6l96 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.5 0-1.5-1.5 0-174.5 112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-.5 0zM320 417.2l-78-73.7 32.4-55.5 45.6 0 0 129.2zM285.3 103.1l34.7 52 0-43.2c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52 0 43.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM160 112l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
    ]
};
var $159afdcd077ecfe9$export$b80f542550a05ea7 = {
    prefix: 'fas',
    iconName: 'glass-water',
    icon: [
        384,
        512,
        [],
        "e4f4",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM73 156.5l-6.6-92.5 251.3 0-6.6 92.5-24.2 12.1c-19.4 9.7-42.2 9.7-61.6 0-20.9-10.4-45.5-10.4-66.4 0-19.4 9.7-42.2 9.7-61.6 0L73 156.5z"
    ]
};
var $159afdcd077ecfe9$export$2a376a9d0d8fee96 = {
    prefix: 'fas',
    iconName: 'heart-circle-bolt',
    icon: [
        576,
        512,
        [],
        "e4fc",
        "M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 17.6-3.4 35.6-9.5 53.7-21.8-8.6-45.6-13.4-70.5-13.4-106 0-192 86-192 192 0 28.5 6.2 55.6 17.4 80-.5 0-.9 0-1.4 0-15.5 0-30.8-4.6-43.1-14.1-73-55.7-212.9-186-212.9-298.2l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm177.4-77c-5.8-4.2-13.8-4-19.4 .5l-80 64c-5.3 4.2-7.4 11.4-5.1 17.8S369.2 416 376 416l32.9 0-15.9 42.4c-2.5 6.7-.2 14.3 5.6 18.6s13.8 4 19.4-.5l80-64c5.3-4.2 7.4-11.4 5.1-17.8S494.8 384 488 384l-32.9 0 15.9-42.4c2.5-6.7 .2-14.3-5.6-18.6z"
    ]
};
var $159afdcd077ecfe9$export$821aeede187f23c9 = {
    prefix: 'fas',
    iconName: 'pump-soap',
    icon: [
        320,
        512,
        [],
        "e06b",
        "M96 0l0 80 128 0 0-24 72 0c13.3 0 24-10.7 24-24S309.3 8 296 8l-72 0 0-8c0-17.7-14.3-32-32-32l-64 0C110.3-32 96-17.7 96 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 128zM224 344c0 35.3-28.7 56-64 56s-64-20.7-64-56c0-32.5 37-80.9 50.9-97.9 3.2-3.9 8.1-6.1 13.1-6.1s9.9 2.2 13.1 6.1C187 263.1 224 311.5 224 344z"
    ]
};
var $159afdcd077ecfe9$export$c578e919f2c5c135 = {
    prefix: 'fas',
    iconName: 'hand-scissors',
    icon: [
        512,
        512,
        [],
        "f257",
        "M40 208c-22.1 0-40 17.9-40 40s17.9 40 40 40l180.2 0c-7.6 8.5-12.2 19.7-12.2 32 0 25.3 19.5 46 44.3 47.9-7.7 8.5-12.3 19.8-12.3 32.1 0 26.5 21.5 48 48 48l96 0c70.7 0 128-57.3 128-128l0-113.1c0-40.2-16-78.8-44.4-107.3-22.8-22.8-53.6-35.6-85.8-35.6L336 64c-21.3 0-39.3 13.9-45.6 33.1l74.5 23.7c8.4 2.7 13.1 11.7 10.4 20.1s-11.7 13.1-20.1 10.4l-67.1-21.4 0 .1-204-64.1C62.9 59.2 40.5 70.9 33.9 92s5.1 43.5 26.2 50.2L269.5 208 40 208z"
    ]
};
var $159afdcd077ecfe9$export$5879d0bca1aa497b = {
    prefix: 'fas',
    iconName: 'dolly',
    icon: [
        576,
        512,
        [
            "dolly-box"
        ],
        "f472",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l72.9 0 92.1 276.2c-22.5 17.6-37 45-37 75.8 0 53 43 96 96 96 52.4 0 95.1-42 96-94.3l202.1-67.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2L331.8 357c-17.2-22.1-43.9-36.5-74-37L165.7 43.8C156.9 17.6 132.5 0 104.9 0L32 0zM208 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM280.5 89.3c-25.2 8.2-39 35.3-30.8 60.5l39.6 121.7c8.2 25.2 35.3 39 60.5 30.8l121.7-39.6c25.2-8.2 39-35.3 30.8-60.5L462.8 80.5c-8.2-25.2-35.3-39-60.5-30.8L280.5 89.3z"
    ]
};
var $159afdcd077ecfe9$export$461bbb9e92cc531b = $159afdcd077ecfe9$export$5879d0bca1aa497b;
var $159afdcd077ecfe9$export$4b24ca1552f410af = {
    prefix: 'fas',
    iconName: 'paperclip',
    icon: [
        512,
        512,
        [
            128206
        ],
        "f0c6",
        "M224.6 12.8c56.2-56.2 147.4-56.2 203.6 0s56.2 147.4 0 203.6l-164 164c-34.4 34.4-90.1 34.4-124.5 0s-34.4-90.1 0-124.5L292.5 103.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L185 301.3c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l164-164c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-164 164c-53.1 53.1-53.1 139.2 0 192.3s139.2 53.1 192.3 0L428.3 284.3c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L343.4 459.6c-78.1 78.1-204.7 78.1-282.8 0s-78.1-204.7 0-282.8l164-164z"
    ]
};
var $159afdcd077ecfe9$export$a1672d808fbed0bd = {
    prefix: 'fas',
    iconName: 'democrat',
    icon: [
        640,
        512,
        [],
        "f747",
        "M64 32c0-8.9 3.8-20.9 6.2-27.3 1-2.8 3.8-4.7 6.8-4.7 1.9 0 3.8 .7 5.2 2.1L128 45.7 173.8 2.1c1.4-1.3 3.2-2.1 5.2-2.1 3 0 5.8 1.8 6.8 4.7 2.4 6.5 6.2 18.4 6.2 27.3 0 26.5-21.9 42-29.5 46.6l76.2 72.6c6 5.7 13.9 8.8 22.1 8.8l219.2 0 32 0c40.3 0 78.2 19 102.4 51.2l19.2 25.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4l-19.2-25.6c-5.3-7-11.8-12.8-19.2-17l0 87.4-352 0-40.4-94.3c-3.9-9.2-15.3-12.6-23.6-7l-42.1 28c-9.1 6.1-19.7 9.3-30.7 9.3l-2 0C23.9 256 0 232.1 0 202.7 0 190.6 4.1 178.9 11.7 169.4L87.6 74.6C78.1 67.4 64 53.2 64 32zM544 352l0 128c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-64-160 0 0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-128 352 0zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM368 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$38150b61dfd06fff = {
    prefix: 'fas',
    iconName: 'square-arrow-up-right',
    icon: [
        448,
        512,
        [
            "external-link-square"
        ],
        "f14c",
        "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM272 296c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-112 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l54.1 0-103 103c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l103-103 0 54.1z"
    ]
};
var $159afdcd077ecfe9$export$e04d83fed5ebcebf = $159afdcd077ecfe9$export$38150b61dfd06fff;
var $159afdcd077ecfe9$export$fd312949b97346ae = {
    prefix: 'fas',
    iconName: 'ferry',
    icon: [
        640,
        512,
        [],
        "e4ea",
        "M224 32c0-17.7 14.3-32 32-32L384 0c17.7 0 32 14.3 32 32l0 32 48 0c44.2 0 80 35.8 80 80l0 128-.1 0c.1 .7 .1 1.3 .1 2 0 30.2-7.6 59.8-22 86.3l-12.7 23.3-.6 1c-22.3-11.3-46.5-16.8-70.8-16.7-32.5 .2-64.9 10.7-92.4 31.4-22.1 16.6-29.1 16.6-51.2 0-28.1-21.1-61.3-31.6-94.4-31.4-23.6 .2-47.1 5.7-68.7 16.7l-.6-1-12.7-23.3c-14.4-26.5-22-56.2-22-86.3 0-.7 0-1.4 .1-2l-.1 0 0-128c0-44.2 35.8-80 80-80l48 0 0-32zM160 256l320 0 0-112c0-8.8-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16l0 112zM403.4 476.1C379.1 494.3 351.1 512 320 512s-59.1-17.7-83.4-35.9c-21.3-16.1-49.9-16.1-71.2 0-23.8 17.9-54.1 35.5-88.1 35.3-20.4-.1-40.7-6.7-59.8-21.1-10.6-8-12.7-23-4.7-33.6s23-12.7 33.6-4.7c11.3 8.5 21.6 11.4 31.2 11.5 17.6 .1 37.3-9.4 58.9-25.7 38.4-29 90.5-29 129 0 24 18.1 40.7 26.3 54.5 26.3s30.5-8.2 54.5-26.3c38.4-29 90.5-29 129 0 16.9 12.7 32.9 21.5 47.8 24.6 13.7 2.8 27.4 .9 42.3-10.3 10.6-8 25.6-5.9 33.6 4.7s5.9 25.6-4.7 33.6c-26.4 19.9-54.2 24.4-80.7 19.1-25.3-5.1-48.1-18.9-67.2-33.3-21.3-16.1-49.9-16.1-71.2 0z"
    ]
};
var $159afdcd077ecfe9$export$67c7a1518d0715ff = {
    prefix: 'fas',
    iconName: 'mosquito',
    icon: [
        576,
        512,
        [],
        "e52b",
        "M178.5 495.2c-7.5 9.6-21 12.1-31.3 5.3S133.5 480 138.9 469l1.2-2.2 36.2-58 0-41 .3-4c.6-3.9 2.2-7.7 4.6-10.9l39.3-52.2-66.2 59.5c-17 15.3-39 23.7-61.9 23.8l-8.1 0c-46.6 0-84.4-37.8-84.4-84.4 0-43 32.4-79.2 75.1-83.9l130.5-14.5-44.8-38.3-2.4-2.4c-5.3-6-7.3-14.4-5.3-22.3l13.3-53.4-25.9-38.9-1.3-2.1c-5.8-10.8-2.7-24.6 7.4-31.7 10.1-7.1 23.7-5.1 31.4 4.3l1.5 2 32 48 1.4 2.2c2.8 5.3 3.5 11.6 2.1 17.6l-12.3 49.2 53.3 45.7 0-28.8c0-11.8 6.5-22.1 16-27.7l0-60.5 .3-3.3c1.5-7.3 8-12.7 15.7-12.7s14.2 5.5 15.7 12.7l.3 3.2 0 60.5c9.6 5.5 16 15.8 16 27.7l0 28.9 53.4-45.8-12.3-49.2c-1.5-5.9-.7-12.2 2.1-17.6l1.4-2.2 32-48 1.5-2c7.7-9.4 21.3-11.5 31.4-4.3 10.1 7.1 13.1 20.9 7.4 31.7l-1.3 2.1-25.9 38.9 13.3 53.4c2 8-.1 16.3-5.3 22.3l-2.4 2.4-44.7 38.3 130.5 14.5c42.8 4.8 75.1 40.9 75.1 83.9 0 46.6-37.8 84.4-84.4 84.4l-8.1 0c-22.8 0-44.9-8.5-61.9-23.8l-66.1-59.5 39.2 52.2c2.4 3.2 4 7 4.6 10.9l.3 4 0 41 36.2 58 1.2 2.1c5.4 11 2 24.7-8.3 31.5s-23.8 4.4-31.3-5.3l-1.4-2-40-64-1.6-3.1c-1.4-3.1-2.1-6.6-2.1-10.1l0-39.8-32.4-43.1 0 74.7c0 17.7-14.3 32-32 32-17.7 0-32-14.3-32-32l0-74.6-32.3 43 0 39.8c0 3.5-.7 6.9-2.1 10.1l-1.6 3.1-40 64-1.4 2z"
    ]
};
var $159afdcd077ecfe9$export$37584b1a5e175b47 = {
    prefix: 'fas',
    iconName: 'building-circle-arrow-right',
    icon: [
        576,
        512,
        [],
        "e4d1",
        "M32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 144.7c-35.7 2.9-68.5 15.6-96 35.4l0-4c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l4 0c-13.8 19.2-24.1 41-30.1 64.5-1.9-.4-3.9-.5-5.9-.5l-32 0c-17.7 0-32 14.3-32 32l0 80 74.9 0c6.1 17.3 14.6 33.4 25.1 48L96 512c-35.3 0-64-28.7-64-64L32 64zM144 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM144 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm140.7-67.3c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7-89.4 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l89.4 0-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
    ]
};
var $159afdcd077ecfe9$export$47d93e9001818ee7 = {
    prefix: 'fas',
    iconName: 'left-right',
    icon: [
        512,
        512,
        [
            8596,
            "arrows-alt-h"
        ],
        "f337",
        "M502.6 406.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9S352 492.9 352 480l0-64-320 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l320 0 0-64c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c12.5 12.5 12.5 32.8 0 45.3zM9.4 150.6c-12.5-12.5-12.5-32.8 0-45.3l96-96c9.2-9.2 22.9-11.9 34.9-6.9S160 19.1 160 32l0 64 320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-320 0 0 64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-96-96z"
    ]
};
var $159afdcd077ecfe9$export$7937ea574fb1389 = $159afdcd077ecfe9$export$47d93e9001818ee7;
var $159afdcd077ecfe9$export$37c67e0b3dc6bd1b = {
    prefix: 'fas',
    iconName: 'virus',
    icon: [
        512,
        512,
        [],
        "e074",
        "M296 40c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 44.1-53.3 66.1-84.5 35-15.6-15.6-40.9-15.6-56.6 0s-15.6 40.9 0 56.6c31.2 31.2 9.1 84.5-35 84.5-22.1 0-40 17.9-40 40s17.9 40 40 40c44.1 0 66.1 53.3 35 84.5-15.6 15.6-15.6 40.9 0 56.6s40.9 15.6 56.6 0c31.2-31.2 84.5-9.1 84.5 35 0 22.1 17.9 40 40 40s40-17.9 40-40c0-44.1 53.3-66.1 84.5-35 15.6 15.6 40.9 15.6 56.6 0s15.6-40.9 0-56.6c-31.2-31.2-9.1-84.5 35-84.5 22.1 0 40-17.9 40-40s-17.9-40-40-40c-44.1 0-66.1-53.3-35-84.5 15.6-15.6 15.6-40.9 0-56.6s-40.9-15.6-56.6 0C349.3 106.1 296 84.1 296 40zM160 224a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$31ee86ac717db552 = {
    prefix: 'fas',
    iconName: 'gem',
    icon: [
        512,
        512,
        [
            128142
        ],
        "f3a5",
        "M116.7 33.8c4.5-6.1 11.7-9.8 19.3-9.8l240 0c7.6 0 14.8 3.6 19.3 9.8l112 152c6.8 9.2 6.1 21.9-1.5 30.4l-232 256c-4.5 5-11 7.9-17.8 7.9s-13.2-2.9-17.8-7.9l-232-256c-7.7-8.5-8.3-21.2-1.5-30.4l112-152zm38.5 39.8c-3.3 2.5-4.2 7-2.1 10.5L210.5 179.8 63.3 192c-4.1 .3-7.3 3.8-7.3 8s3.2 7.6 7.3 8l192 16c.4 0 .9 0 1.3 0l192-16c4.1-.3 7.3-3.8 7.3-8s-3.2-7.6-7.3-8l-147.2-12.3 57.4-95.6c2.1-3.5 1.2-8.1-2.1-10.5s-7.9-2-10.7 1L256 172.2 165.9 74.6c-2.8-3-7.4-3.4-10.7-1z"
    ]
};
var $159afdcd077ecfe9$export$505476859b9691c0 = {
    prefix: 'fas',
    iconName: 'toilet',
    icon: [
        448,
        512,
        [
            128701
        ],
        "f7d8",
        "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l8 0 0 148.9c-1.9 1.4-3.8 2.9-5.6 4.4-15.5 13.2-26.4 31.6-26.4 54.6 0 46.9 14.3 84.1 37 112.5 14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8S85.7 512 96 512l256 0c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8 22.7-28.4 37-65.5 37-112.5 0-23.1-10.9-41.5-26.4-54.6-1.8-1.5-3.7-3-5.6-4.4l0-148.9 8 0c13.3 0 24-10.7 24-24S437.3 0 424 0L24 0zM96 80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16zM224 288c-88.4 0-160-14.3-160-32s71.6-32 160-32 160 14.3 160 32-71.6 32-160 32z"
    ]
};
var $159afdcd077ecfe9$export$672c4d040d7fbc44 = {
    prefix: 'fas',
    iconName: 'single-quote-left',
    icon: [
        192,
        512,
        [],
        "e81b",
        "M128 96c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64L0 216C0 149.7 53.7 96 120 96l8 0z"
    ]
};
var $159afdcd077ecfe9$export$a822dad6e586ee9e = {
    prefix: 'fas',
    iconName: 'money-bills',
    icon: [
        576,
        512,
        [],
        "e1f3",
        "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zm176 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM160 152l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8.1 3.6 7.5 8-3.6 29-26.6 51.9-55.5 55.5-4.4 .5-8-3.1-8-7.5zm0 112c0-4.4 3.6-8.1 8-7.5 29 3.6 51.9 26.6 55.5 55.5 .5 4.4-3.1 8-7.5 8l-48 0c-4.4 0-8-3.6-8-8l0-48zM504 159.5c-29-3.6-51.9-26.6-55.5-55.5-.5-4.4 3.1-8 7.5-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8.1-8 7.5zM512 264l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8.1-3.6-7.5-8 3.6-29 26.6-51.9 55.5-55.5 4.4-.5 8 3.1 8 7.5zM48 152c0-13.3-10.7-24-24-24S0 138.7 0 152L0 416c0 35.3 28.7 64 64 64l392 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L64 432c-8.8 0-16-7.2-16-16l0-264z"
    ]
};
var $159afdcd077ecfe9$export$2d33c367b2b091ac = {
    prefix: 'fas',
    iconName: 'tablet-button',
    icon: [
        448,
        512,
        [],
        "f10a",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM224 400a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$3896694b3e81fba7 = {
    prefix: 'fas',
    iconName: 'rectangle-xmark',
    icon: [
        512,
        512,
        [
            62164,
            "rectangle-times",
            "times-rectangle",
            "window-close"
        ],
        "f410",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM167 167c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$eaaf26416a51dc1 = $159afdcd077ecfe9$export$3896694b3e81fba7;
var $159afdcd077ecfe9$export$10147c0014152a3f = $159afdcd077ecfe9$export$3896694b3e81fba7;
var $159afdcd077ecfe9$export$18b7775f78a3e16 = $159afdcd077ecfe9$export$3896694b3e81fba7;
var $159afdcd077ecfe9$export$3c6c0c8185296ac5 = {
    prefix: 'fas',
    iconName: 'wrench',
    icon: [
        576,
        512,
        [
            128295
        ],
        "f0ad",
        "M509.4 98.6c7.6-7.6 20.3-5.7 24.1 4.3 6.8 17.7 10.5 37 10.5 57.1 0 88.4-71.6 160-160 160-17.5 0-34.4-2.8-50.2-8L146.9 498.9c-28.1 28.1-73.7 28.1-101.8 0s-28.1-73.7 0-101.8L232 210.2c-5.2-15.8-8-32.6-8-50.2 0-88.4 71.6-160 160-160 20.1 0 39.4 3.7 57.1 10.5 10 3.8 11.8 16.5 4.3 24.1l-88.7 88.7c-3 3-4.7 7.1-4.7 11.3l0 41.4c0 8.8 7.2 16 16 16l41.4 0c4.2 0 8.3-1.7 11.3-4.7l88.7-88.7z"
    ]
};
var $159afdcd077ecfe9$export$864bb8d6c21fb792 = {
    prefix: 'fas',
    iconName: 'trash-can',
    icon: [
        448,
        512,
        [
            61460,
            "trash-alt"
        ],
        "f2ed",
        "M136.7 5.9C141.1-7.2 153.3-16 167.1-16l113.9 0c13.8 0 26 8.8 30.4 21.9L320 32 416 32c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 8.7-26.1zM32 144l384 0 0 304c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-304zm88 64c-13.3 0-24 10.7-24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-192c0-13.3-10.7-24-24-24zm104 0c-13.3 0-24 10.7-24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-192c0-13.3-10.7-24-24-24zm104 0c-13.3 0-24 10.7-24 24l0 192c0 13.3 10.7 24 24 24s24-10.7 24-24l0-192c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$88df7ff7eb32f9dc = $159afdcd077ecfe9$export$864bb8d6c21fb792;
var $159afdcd077ecfe9$export$c517dffc18db483f = {
    prefix: 'fas',
    iconName: 'table-cells',
    icon: [
        448,
        512,
        [
            "th"
        ],
        "f00a",
        "M384 96l0 64-64 0 0-64 64 0zm0 128l0 64-64 0 0-64 64 0zm0 128l0 64-64 0 0-64 64 0zM256 288l-64 0 0-64 64 0 0 64zm-64 64l64 0 0 64-64 0 0-64zm-64-64l-64 0 0-64 64 0 0 64zM64 352l64 0 0 64-64 0 0-64zm0-192l0-64 64 0 0 64-64 0zm128 0l0-64 64 0 0 64-64 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
    ]
};
var $159afdcd077ecfe9$export$4d383c83efc0c819 = $159afdcd077ecfe9$export$c517dffc18db483f;
var $159afdcd077ecfe9$export$838459d11f3971df = {
    prefix: 'fas',
    iconName: 'ribbon',
    icon: [
        384,
        512,
        [
            127895
        ],
        "f4d6",
        "M235.1 0c33.4 0 64.5 17.4 81.9 45.9 1.2 2 13 21.3 35.3 57.8 21.1 34.5 18.3 78.5-7 110L278.3 297.7 364.5 406c5.5 6.9 4.4 16.9-2.5 22.5l-80 64c-6.9 5.5-17 4.4-22.5-2.5L38.6 213.8C13.3 182.3 10.5 138.3 31.6 103.8 54 67.2 65.7 47.9 67 45.9 84.4 17.4 115.4 0 148.9 0l86.3 0zM192 189.2l48.6-61.2-97.3 0 48.6 61.2zM75 336.2l86.2 107.8-36.8 46c-5.5 6.9-15.6 8-22.5 2.5l-80-64c-6.9-5.5-8-15.6-2.5-22.5L75 336.2z"
    ]
};
var $159afdcd077ecfe9$export$f4d472cf47be4096 = {
    prefix: 'fas',
    iconName: 'landmark-flag',
    icon: [
        512,
        512,
        [],
        "e51c",
        "M352-32L240-32c-8.8 0-16 7.2-16 16l0 144-176 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0 0 224-51.2 38.4C4.7 460.4 0 469.9 0 480 0 497.7 14.3 512 32 512l448 0c17.7 0 32-14.3 32-32 0-10.1-4.7-19.6-12.8-25.6l-51.2-38.4 0-224 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0 0-64 80 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm48 224l0 224-64 0 0-224 64 0zm-112 0l0 224-64 0 0-224 64 0zm-112 0l0 224-64 0 0-224 64 0z"
    ]
};
var $159afdcd077ecfe9$export$cd7b22f4e6e3834b = {
    prefix: 'fas',
    iconName: 'up-down-left-right',
    icon: [
        512,
        512,
        [
            "arrows-alt"
        ],
        "f0b2",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9S179.1 128 192 128l32 0 0 96-96 0 0-32c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9S128 332.9 128 320l0-32 96 0 0 96-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S332.9 384 320 384l-32 0 0-96 96 0 0 32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9S384 179.1 384 192l0 32-96 0 0-96 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"
    ]
};
var $159afdcd077ecfe9$export$3cdabfff52cfc73a = $159afdcd077ecfe9$export$cd7b22f4e6e3834b;
var $159afdcd077ecfe9$export$6f7218565b1b8d0e = {
    prefix: 'fas',
    iconName: 'car-side',
    icon: [
        640,
        512,
        [
            128663
        ],
        "f5e4",
        "M147 106.7l-29.8 85.3 122.9 0 0-96-77.9 0c-6.8 0-12.9 4.3-15.1 10.7zM48.6 193.9L86.5 85.6C97.8 53.5 128.1 32 162.1 32L360 32c25.2 0 48.9 11.9 64 32l96.2 128.3C587.1 196.5 640 252.1 640 320l0 16c0 35.3-28.7 64-64 64l-16.4 0c-4 44.9-41.7 80-87.6 80s-83.6-35.1-87.6-80l-144.7 0c-4 44.9-41.7 80-87.6 80s-83.6-35.1-87.6-80l-.4 0c-35.3 0-64-28.7-64-64l0-80c0-30.1 20.7-55.3 48.6-62.1zM440 192l-67.2-89.6c-3-4-7.8-6.4-12.8-6.4l-72 0 0 96 152 0zM152 432a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm360-40a40 40 0 1 0 -80 0 40 40 0 1 0 80 0z"
    ]
};
var $159afdcd077ecfe9$export$940cea0f5451895c = {
    prefix: 'fas',
    iconName: 'trash-arrow-up',
    icon: [
        448,
        512,
        [
            "trash-restore"
        ],
        "f829",
        "M167.1-16l113.9 0c13.8 0 26 8.8 30.4 21.9L320 32 416 32c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 8.7-26.1C141.1-7.2 153.3-16 167.1-16zM32 144l384 0-21.1 323.1C393.3 492.4 372.3 512 347 512L101 512c-25.3 0-46.3-19.6-47.9-44.9L32 144zm209 79c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 102.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z"
    ]
};
var $159afdcd077ecfe9$export$d32f45a64ed40e8d = $159afdcd077ecfe9$export$940cea0f5451895c;
var $159afdcd077ecfe9$export$53dd2cacf674142a = {
    prefix: 'fas',
    iconName: 'life-ring',
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M367.2 412.5C335.9 434.9 297.5 448 256 448s-79.9-13.1-111.2-35.5l58-58c15.8 8.6 34 13.5 53.3 13.5s37.4-4.9 53.3-13.5l58 58zm90.7 .8c33.8-43.4 54-98 54-157.3S491.8 142.1 458 98.7c9-12.5 7.9-30.1-3.4-41.3S425.8 45 413.3 54C369.9 20.2 315.3 0 256 0S142.1 20.2 98.7 54c-12.5-9-30.1-7.9-41.3 3.4S45 86.2 54 98.7C20.2 142.1 0 196.7 0 256S20.2 369.9 54 413.3c-9 12.5-7.9 30.1 3.4 41.3S86.2 467 98.7 458c43.4 33.8 98 54 157.3 54s113.9-20.2 157.3-54c12.5 9 30.1 7.9 41.3-3.4s12.4-28.8 3.4-41.3zm-45.5-46.1l-58-58c8.6-15.8 13.5-34 13.5-53.3s-4.9-37.4-13.5-53.3l58-58C434.9 176.1 448 214.5 448 256s-13.1 79.9-35.5 111.2zM367.2 99.5l-58 58c-15.8-8.6-34-13.5-53.3-13.5s-37.4 4.9-53.3 13.5l-58-58C176.1 77.1 214.5 64 256 64s79.9 13.1 111.2 35.5zM157.5 309.3l-58 58C77.1 335.9 64 297.5 64 256s13.1-79.9 35.5-111.2l58 58c-8.6 15.8-13.5 34-13.5 53.3s4.9 37.4 13.5 53.3zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $159afdcd077ecfe9$export$da61665fff8aebfe = {
    prefix: 'fas',
    iconName: 'copyright',
    icon: [
        512,
        512,
        [
            169
        ],
        "f1f9",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM205.1 306.9c28.1 28.1 73.7 28.1 101.8 0 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-46.9 46.9-122.8 46.9-169.7 0s-46.9-122.8 0-169.7 122.8-46.9 169.7 0c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-28.1-28.1-73.7-28.1-101.8 0s-28.1 73.7 0 101.8z"
    ]
};
var $159afdcd077ecfe9$export$a20cb90865b6beb8 = {
    prefix: 'fas',
    iconName: 'file-prescription',
    icon: [
        384,
        512,
        [],
        "f572",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM88 192c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 22.5 0 58.4 55-33.4 31.6c-9.6 9.1-10.1 24.3-.9 33.9s24.3 10.1 33.9 .9l35.4-33.5 35.6 33.5c9.7 9.1 24.8 8.6 33.9-1s8.6-24.8-1-33.9l-33.6-31.6 33.6-31.8c9.6-9.1 10.1-24.3 .9-33.9s-24.3-10.1-33.9-.9l-35.7 33.7-40.9-38.5c12.9-11.7 21.1-28.6 21.1-47.5 0-35.3-28.7-64-64-64l-56 0zm32 80l-8 0 0-32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-24 0z"
    ]
};
var $159afdcd077ecfe9$export$e7fc4fe34e767f28 = {
    prefix: 'fas',
    iconName: 'eraser',
    icon: [
        576,
        512,
        [],
        "f12d",
        "M178.5 416l123 0 65.3-65.3-173.5-173.5-126.7 126.7 112 112zM224 480l-45.5 0c-17 0-33.3-6.7-45.3-18.7L17 345C6.1 334.1 0 319.4 0 304s6.1-30.1 17-41L263 17C273.9 6.1 288.6 0 304 0s30.1 6.1 41 17L527 199c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41l-135 135 120 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0z"
    ]
};
var $159afdcd077ecfe9$export$f0c28584caa8f4b = {
    prefix: 'fas',
    iconName: 'hourglass-start',
    icon: [
        384,
        512,
        [
            "hourglass-1"
        ],
        "f251",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1l67.9 67.9-67.9 67.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1l-67.9-67.9 67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32S369.7 0 352 0L32 0zM288 437l0 11-192 0 0-11c0-25.5 10.1-49.9 28.1-67.9l67.9-67.9 67.9 67.9c18 18 28.1 42.4 28.1 67.9z"
    ]
};
var $159afdcd077ecfe9$export$87929336ab5c59cd = $159afdcd077ecfe9$export$f0c28584caa8f4b;
var $159afdcd077ecfe9$export$5ae86b9da9cca3bd = {
    prefix: 'fas',
    iconName: 'circle-left',
    icon: [
        512,
        512,
        [
            61840,
            "arrow-alt-circle-left"
        ],
        "f359",
        "M512 256a256 256 0 1 0 -512 0 256 256 0 1 0 512 0zM124.7 244.7l104-104c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8l0 56 96 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32l-96 0 0 56c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-104-104c-6.2-6.2-6.2-16.4 0-22.6z"
    ]
};
var $159afdcd077ecfe9$export$5460a5b11a24996f = $159afdcd077ecfe9$export$5ae86b9da9cca3bd;
var $159afdcd077ecfe9$export$64dd1b27affb6572 = {
    prefix: 'fas',
    iconName: 'cruzeiro-sign',
    icon: [
        448,
        512,
        [],
        "e152",
        "M240 96c-88.4 0-160 71.6-160 160 0 71.6 47.1 132.3 112 152.7L192 256c0-13.3 10.7-24 24-24 12.8 0 23.3 10.1 24 22.7 15.5-9.5 33.5-14.7 52.3-14.7l11.8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-11.8 0c-18.8 0-36.1 10-45.4 26.3-4.5 7.9-6.9 16.8-6.9 25.9l0 75.8c42.5 0 81.1-16.6 109.8-43.6 12.9-12.1 33.1-11.5 45.2 1.3s11.5 33.1-1.3 45.2C353.7 456.8 299.5 480 240 480 116.3 480 16 379.7 16 256S116.3 32 240 32c59.5 0 113.7 23.2 153.7 61.1 12.9 12.1 13.4 32.4 1.3 45.2s-32.4 13.4-45.2 1.3C321.1 112.6 282.5 96 240 96z"
    ]
};
var $159afdcd077ecfe9$export$c4ab83701fc591a5 = {
    prefix: 'fas',
    iconName: 'smoking',
    icon: [
        576,
        512,
        [
            128684
        ],
        "f48d",
        "M360 0c13.3 0 24 10.7 24 24l0 19c0 40.3 16 79 44.5 107.5l21 21C469 191 480 217.4 480 245l0 19c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-19c0-14.9-5.9-29.1-16.4-39.6l-21-21C357.1 146.9 336 96 336 43l0-19c0-13.3 10.7-24 24-24zM552 288c-13.3 0-24-10.7-24-24l0-19c0-40.3-16-79-44.5-107.5l-21-21C443 97 432 70.6 432 43l0-19c0-13.3 10.7-24 24-24s24 10.7 24 24l0 19c0 14.9 5.9 29.1 16.4 39.6l21 21C554.9 141.1 576 192 576 245l0 19c0 13.3-10.7 24-24 24zM320 448l96 0 0-32-96 0 0 32zM0 416c0-35.3 28.7-64 64-64l384 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32L64 512c-35.3 0-64-28.7-64-64l0-32zm576-40l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$91d747e5aabe6fe8 = {
    prefix: 'fas',
    iconName: 'square-poll-vertical',
    icon: [
        448,
        512,
        [
            "poll"
        ],
        "f681",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 192c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zm184 88c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48zM224 128c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$bc8ca14ab51f93db = $159afdcd077ecfe9$export$91d747e5aabe6fe8;
var $159afdcd077ecfe9$export$d7ccc6651f90f7cc = {
    prefix: 'fas',
    iconName: 'person-circle-minus',
    icon: [
        640,
        512,
        [],
        "e540",
        "M280 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 212.7L341 286.6c12.8-17.5 28.5-32.7 46.3-45l-56.2-75.7C306 132 266.3 112 224 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L144 236.7 144 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-275.3zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z"
    ]
};
var $159afdcd077ecfe9$export$ae3a453550dec95 = {
    prefix: 'fas',
    iconName: 'biohazard',
    icon: [
        576,
        512,
        [
            9763
        ],
        "f780",
        "M260 12.6c0-8.3-7.6-14.5-15.5-12.1-60.9 18.8-105.1 75.8-105.1 143.1 0 25.1 6.1 48.7 17 69.5-21 1.8-42 8.2-61.5 19.5-57.9 33.6-84.8 100.2-70.9 162.5 1.9 8.4 11.4 12 18.9 7.6 5-2.9 7.6-8.6 7.1-14.4-.3-3.3-.4-6.6-.4-10.1 0-123.5 184.4-123.5 184.4 0 0 88.4-94.5 113.6-148.2 75.4-4.5-3.2-10.5-3.9-15.3-1.1-7 4.1-8.6 13.6-2.7 19.1 46.6 43.8 118 53.9 176.1 20.2 17.9-10.4 32.8-23.9 44.5-39.4 11.7 15.6 26.6 29.1 44.5 39.4 58.1 33.7 129.5 23.6 176.1-20.2 5.9-5.5 4.3-15.1-2.7-19.1-4.8-2.8-10.8-2.1-15.3 1.1-53.7 38.2-148.2 13-148.2-75.4 0-123.5 184.4-123.5 184.4 0 0 3.4-.1 6.8-.4 10.1-.5 5.8 2.1 11.5 7.1 14.4 7.4 4.3 17 .8 18.9-7.6 13.9-62.2-13-128.9-70.9-162.5-19.5-11.3-40.4-17.7-61.5-19.5 10.9-20.8 17-44.4 17-69.5 0-67.3-44.2-124.3-105.1-143.1-7.9-2.4-15.5 3.8-15.5 12.1 0 5.9 4 11 9.5 13.2 83.4 33.6 70.8 178.4-37.8 178.4S167.1 59.4 250.5 25.8c5.5-2.2 9.5-7.3 9.5-13.2zM248.4 288a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM435 317.7c-16.2 0-31.4 5.5-42.1 15-10.1 9.1-18.1 23.4-18.1 45.6 0 21.1 7.2 35 16.5 44.1 32.2-24.6 55.5-60.5 63.9-101.8-6.3-1.9-13.2-3-20.2-3zM202 378.3c0-22.3-8-36.6-18.1-45.6-10.7-9.6-25.9-15-42.1-15-7 0-13.9 1-20.2 3 8.4 41.3 31.6 77.2 63.9 101.8 9.4-9.1 16.5-23.1 16.5-44.2zm41.2-224.3c9 10.2 23.2 18.2 45.2 18.2s36.2-8 45.2-18.2c6.7-7.6 11.5-17.5 13.6-28.4-18.3-6.8-38.2-10.5-58.8-10.5s-40.5 3.7-58.8 10.5c2.2 10.9 6.9 20.8 13.6 28.5z"
    ]
};
var $159afdcd077ecfe9$export$e433538b78718fb3 = {
    prefix: 'fas',
    iconName: 'bell-concierge',
    icon: [
        512,
        512,
        [
            128718,
            "concierge-bell"
        ],
        "f562",
        "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l16 0 0 33.3C124.8 156.7 40.2 243.7 32.6 352l446.9 0C471.8 243.7 387.2 156.7 280 145.3l0-33.3 16 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24l464 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 400z"
    ]
};
var $159afdcd077ecfe9$export$ad92ffbbfbc0fcf3 = $159afdcd077ecfe9$export$e433538b78718fb3;
var $159afdcd077ecfe9$export$46c6347bff3e04a = {
    prefix: 'fas',
    iconName: 'ruler-horizontal',
    icon: [
        576,
        512,
        [],
        "f547",
        "M48 384c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48l24 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 48 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 48 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 48 0 0 104c0 13.3 10.7 24 24 24s24-10.7 24-24l0-104 24 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48L48 384z"
    ]
};
var $159afdcd077ecfe9$export$5b05f097fa38352a = {
    prefix: 'fas',
    iconName: 'horse',
    icon: [
        576,
        512,
        [
            128014
        ],
        "f6f0",
        "M448 238.1l0-78.1 16 0 9.8 19.6c12.5 25.1 42.2 36.4 68.3 26 20.5-8.2 33.9-28 33.9-50.1L576 80c0-19.1-8.4-36.3-21.7-48l5.7 0c8.8 0 16-7.2 16-16S568.8 0 560 0L448 0C377.3 0 320 57.3 320 128l-171.2 0C118.1 128 91.2 144.3 76.3 168.8 33.2 174.5 0 211.4 0 256l0 56c0 13.3 10.7 24 24 24s24-10.7 24-24l0-56c0-13.4 6.6-25.2 16.7-32.5 1.6 13 6.3 25.4 13.6 36.4l28.2 42.4c8.3 12.4 6.4 28.7-1.2 41.6-16.5 28-20.6 62.2-10 93.9l17.5 52.4c4.4 13.1 16.6 21.9 30.4 21.9l33.7 0c21.8 0 37.3-21.4 30.4-42.1l-20.8-62.5c-2.1-6.4-.5-13.4 4.3-18.2l12.7-12.7c13.2-13.2 20.6-31.1 20.6-49.7 0-2.3-.1-4.6-.3-6.9l84 24c4.1 1.2 8.2 2.1 12.3 2.8L320 480c0 17.7 14.3 32 32 32l32 0c17.7 0 32-14.3 32-32l0-164.3c19.2-19.2 31.5-45.7 32-75.7l0 0 0-1.9zM496 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
    ]
};
var $159afdcd077ecfe9$export$34f5c36a3e80efa2 = {
    prefix: 'fas',
    iconName: 'calendar',
    icon: [
        448,
        512,
        [
            128197,
            128198
        ],
        "f133",
        "M128 0C110.3 0 96 14.3 96 32l0 32-32 0C28.7 64 0 92.7 0 128l0 48 448 0 0-48c0-35.3-28.7-64-64-64l-32 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32-128 0 0-32c0-17.7-14.3-32-32-32zM0 224L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-192-448 0z"
    ]
};
var $159afdcd077ecfe9$export$bfb254bf3c0bc50b = {
    prefix: 'fas',
    iconName: 'hands-holding-child',
    icon: [
        640,
        512,
        [],
        "e4fa",
        "M320-32a40 40 0 1 1 0 80 40 40 0 1 1 0-80zM40 64c22.1 0 40 17.9 40 40l0 160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8-7.3-7.3-23.1-23.1-47.2-47.2-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c24.1 24.1 39.9 39.9 47.2 47.2l0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0c7.3-7.3 23.1-23.1 47.2-47.2 12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-24.1 24.1-39.9 39.9-47.2 47.2-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3L560 104c0-22.1 17.9-40 40-40zM384.5 149l-19.8-16.7 11.1 88.8c1.6 13.2-7.7 25.1-20.8 26.8s-25.1-7.7-26.8-20.8l-4.4-35-7.6 0-4.4 35c-1.6 13.2-13.6 22.5-26.8 20.8s-22.5-13.6-20.8-26.8l11.1-88.8-19.8 16.7c-10.1 8.6-25.3 7.3-33.8-2.8s-7.3-25.3 2.8-33.8l27.9-23.6C271.3 72.8 295.3 64 320 64s48.7 8.8 67.6 24.7l27.9 23.6c10.1 8.6 11.4 23.7 2.8 33.8s-23.7 11.4-33.8 2.8z"
    ]
};
var $159afdcd077ecfe9$export$16e344bae4d495ed = {
    prefix: 'fas',
    iconName: 'italic',
    icon: [
        384,
        512,
        [],
        "f033",
        "M128 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-58.7 0-133.3 320 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l58.7 0 133.3-320-64 0c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$8d41d1f1ba3f9217 = {
    prefix: 'fas',
    iconName: 'khanda',
    icon: [
        512,
        512,
        [
            9772
        ],
        "f66d",
        "M240.7 8c8.9-7.4 21.8-7.4 30.7 0l37.8 31.5c8.7 7.3 11.1 19.6 6 29.6-1.2 2.4-2.8 5.5-4.6 9.2 34.2 19.2 57.3 55.8 57.3 97.8s-23.1 78.6-57.3 97.8c1.8 3.7 3.3 6.8 4.6 9.2 5.1 10 2.7 22.3-6 29.6l-37.2 31 0 19.8c22.9-15.7 48.4-33.3 76.7-52.7 42.8-29.4 68.4-78 68.4-130l0-11.1c0-23.9-7.1-47.3-20.4-67.2-5.1-7.7-4.6-17.8 1.7-24.6 6.6-7.1 17.2-8.1 25.2-2.8 27.5 18.1 89.4 67.5 89.4 149.1 0 46.5-20.2 88.6-41.8 120.4-21.6 32-45.6 55-55.3 63.8-7.8 7.1-19 7.9-27.6 3l-70.8-40.3-32.7 22.5 45.5 31.3c1.8-.4 3.7-.7 5.7-.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-12.2 0-22.3-9.1-23.8-21l-40.2-27.6 0 28.9c9.6 5.5 16 15.9 16 27.7 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7l0-28.1-40.3 27.7c-1.8 11.4-11.8 20.1-23.7 20.1-13.3 0-24-10.7-24-24s10.7-24 24-24c2.2 0 4.4 .3 6.5 .9l45.8-31.5-32.7-22.5-70.8 40.3c-8.7 4.9-19.8 4.1-27.6-3-9.7-8.8-33.7-31.9-55.3-63.8-21.5-31.8-41.8-73.9-41.8-120.4 0-81.7 61.9-131.1 89.4-149.1 8.1-5.3 18.6-4.3 25.2 2.8 6.4 6.9 6.8 17 1.7 24.6-13.3 19.9-20.4 43.3-20.4 67.2l0 11.1c0 51.9 25.6 100.6 68.4 130 28.4 19.6 53.7 36.9 75.6 52l0-19.1-37.2-31c-8.7-7.3-11.1-19.6-6-29.6 1.2-2.4 2.8-5.5 4.6-9.2-34.2-19.2-57.3-55.8-57.3-97.8s23.1-78.6 57.3-97.8c-1.8-3.7-3.3-6.8-4.6-9.2-5.1-10-2.7-22.3 6-29.6L240.7 8zM220.3 122.9c-17 11.5-28.2 31-28.2 53.1s11.2 41.6 28.2 53.1c6.8-19.2 11.8-38.4 11.8-53.1s-4.9-33.9-11.8-53.1zm71.5 106.2c17-11.5 28.2-31 28.2-53.1s-11.2-41.6-28.2-53.1c-6.8 19.2-11.8 38.4-11.8 53.1s4.9 33.9 11.8 53.1z"
    ]
};
var $159afdcd077ecfe9$export$c8a28356e07b9ccb = {
    prefix: 'fas',
    iconName: 'face-frown-open',
    icon: [
        512,
        512,
        [
            128550,
            "frown-open"
        ],
        "f57a",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM182.4 382.5c-12.4 5.2-26.5-4.1-21.1-16.4 16-36.6 52.4-62.1 94.8-62.1s78.8 25.6 94.8 62.1c5.4 12.3-8.7 21.6-21.1 16.4-22.4-9.5-47.4-14.8-73.7-14.8s-51.3 5.3-73.7 14.8z"
    ]
};
var $159afdcd077ecfe9$export$c4775e66bed5d96 = $159afdcd077ecfe9$export$c8a28356e07b9ccb;
var $159afdcd077ecfe9$export$62b2c752fccc6a9c = {
    prefix: 'fas',
    iconName: 'check',
    icon: [
        448,
        512,
        [
            10003,
            10004
        ],
        "f00c",
        "M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z"
    ]
};
var $159afdcd077ecfe9$export$614dc068d88655af = {
    prefix: 'fas',
    iconName: 'fingerprint',
    icon: [
        512,
        512,
        [],
        "f577",
        "M48 256c0-114.9 93.1-208 208-208 63.1 0 119.6 28.1 157.8 72.5 8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8C403.3 34.6 333.7 0 256 0 114.6 0 0 114.6 0 256l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40zm458.5-52.9c-2.7-13-15.5-21.3-28.4-18.5s-21.3 15.5-18.5 28.4c2.9 13.9 4.5 28.3 4.5 43.1l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c0-18.1-1.9-35.8-5.5-52.9zM256 80c-19 0-37.4 3-54.5 8.6-15.2 5-18.7 23.7-8.3 35.9 7.1 8.3 18.8 10.8 29.4 7.9 10.6-2.9 21.8-4.4 33.4-4.4 70.7 0 128 57.3 128 128l0 24.9c0 25.2-1.5 50.3-4.4 75.3-1.7 14.6 9.4 27.8 24.2 27.8 11.8 0 21.9-8.6 23.3-20.3 3.3-27.4 5-55 5-82.7l0-24.9c0-97.2-78.8-176-176-176zM150.7 148.7c-9.1-10.6-25.3-11.4-33.9-.4-23.1 29.8-36.8 67.1-36.8 107.7l0 24.9c0 24.2-2.6 48.4-7.8 71.9-3.4 15.6 7.9 31.1 23.9 31.1 10.5 0 19.9-7 22.2-17.3 6.4-28.1 9.7-56.8 9.7-85.8l0-24.9c0-27.2 8.5-52.4 22.9-73.1 7.2-10.4 8-24.6-.2-34.2zM256 160c-53 0-96 43-96 96l0 24.9c0 35.9-4.6 71.5-13.8 106.1-3.8 14.3 6.7 29 21.5 29 9.5 0 17.9-6.2 20.4-15.4 10.5-39 15.9-79.2 15.9-119.7l0-24.9c0-28.7 23.3-52 52-52s52 23.3 52 52l0 24.9c0 36.3-3.5 72.4-10.4 107.9-2.7 13.9 7.7 27.2 21.8 27.2 10.2 0 19-7 21-17 7.7-38.8 11.6-78.3 11.6-118.1l0-24.9c0-53-43-96-96-96zm24 96c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 24.9c0 59.9-11 119.3-32.5 175.2l-5.9 15.3c-4.8 12.4 1.4 26.3 13.8 31s26.3-1.4 31-13.8l5.9-15.3C267.9 411.9 280 346.7 280 280.9l0-24.9z"
    ]
};
var $159afdcd077ecfe9$export$bab2cd86f8c65657 = {
    prefix: 'fas',
    iconName: 'charging-station',
    icon: [
        576,
        512,
        [],
        "f5e7",
        "M64 64C64 28.7 92.7 0 128 0L288 0c35.3 0 64 28.7 64 64l0 224c44.2 0 80 35.8 80 80l0 12c0 11 9 20 20 20s20-9 20-20l0-127.7c-32.5-10.2-56-40.5-56-76.3l0-32c0-8.8 7.2-16 16-16l16 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 16 0c8.8 0 16 7.2 16 16l0 32c0 35.8-23.5 66.1-56 76.3L520 380c0 37.6-30.4 68-68 68s-68-30.4-68-68l0-12c0-17.7-14.3-32-32-32l0 129.4c9.3 3.3 16 12.2 16 22.6 0 13.3-10.7 24-24 24L72 512c-13.3 0-24-10.7-24-24 0-10.5 6.7-19.3 16-22.6L64 64zm82.7 125.7l39 0-20.9 66.9c-2.4 7.6 3.3 15.4 11.3 15.4 2.9 0 5.6-1 7.8-2.9l94.6-82c3.1-2.7 4.9-6.6 4.9-10.7 0-7.8-6.3-14.1-14.1-14.1l-39 0 20.9-66.9c2.4-7.6-3.3-15.4-11.3-15.4-2.9 0-5.6 1-7.8 2.9l-94.6 82c-3.1 2.7-4.9 6.6-4.9 10.7 0 7.8 6.3 14.1 14.1 14.1z"
    ]
};
var $159afdcd077ecfe9$export$d9b89b5872b67a4f = {
    prefix: 'fas',
    iconName: 'user-lock',
    icon: [
        576,
        512,
        [],
        "f502",
        "M224 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zM194.3 304l59.4 0c29.7 0 57.7 7.3 82.3 20.1l0 4.3c-19.6 17.6-32 43.1-32 71.5l0 96c0 5.5 .5 10.9 1.3 16.1L45.7 512C29.3 512 16 498.7 16 482.3 16 383.8 95.8 304 194.3 304zm301.7 .1c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM352 400c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
var $159afdcd077ecfe9$export$da39ed20699ee2d7 = {
    prefix: 'fas',
    iconName: 'mobile-screen-button',
    icon: [
        384,
        512,
        [
            "mobile-alt"
        ],
        "f3cd",
        "M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zm64 0l0 304 224 0 0-304-224 0zM192 472c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $159afdcd077ecfe9$export$e9599bc6cd92234d = $159afdcd077ecfe9$export$da39ed20699ee2d7;
var $159afdcd077ecfe9$export$8bce49e6ae597af8 = {
    prefix: 'fas',
    iconName: 'anchor-circle-check',
    icon: [
        640,
        512,
        [],
        "e4aa",
        "M320 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM288 0c-53 0-96 43-96 96 0 41.8 26.7 77.4 64 90.5l0 257.9c-62.9-14.3-110.2-69.7-111.9-136.5l16.1 14.1c10 8.7 25.1 7.7 33.9-2.3s7.7-25.1-2.3-33.9l-64-56c-9-7.9-22.6-7.9-31.6 0l-64 56c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3L80 307.9c2.1 113.1 94.4 204.1 208 204.1 16.6 0 32.7-1.9 48.2-5.6-20.3-30.5-32.2-67-32.2-106.4 0-27.3 5.7-53.3 16-76.9l0-136.6c37.3-13.2 64-48.7 64-90.5 0-53-43-96-96-96zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-86.6-60.9c7.1 5.2 8.7 15.2 3.5 22.3l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5z"
    ]
};
var $159afdcd077ecfe9$export$2ffee5b2bc935c1f = {
    prefix: 'fas',
    iconName: 'person-walking-with-cane',
    icon: [
        576,
        512,
        [
            "blind"
        ],
        "f29d",
        "M224-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM160 205.3l-22.6 22.6c-6 6-9.4 14.1-9.4 22.6l0 37.5c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-37.5c0-25.5 10.1-49.9 28.1-67.9l34.4-34.4c23.2-23.2 54.6-36.2 87.3-36.2 36.1 0 70.3 15.8 93.8 43.1l68.6 80c11.5 13.4 9.9 33.6-3.5 45.1s-33.6 9.9-45.1-3.5l-55.7-65 0 118.6 34.5 29.6c17.7 15.2 29.3 36.2 32.6 59.3l12.6 88.1c2.5 17.5-9.7 33.7-27.2 36.2s-33.7-9.7-36.2-27.2l-12.6-88.1c-1.1-7.7-5-14.7-10.9-19.8l-71.4-61.2c-21.3-18.2-33.5-44.9-33.5-72.9l0-69.3zm.1 165.8c2.4 2.3 4.8 4.6 7.4 6.8l46 39.4-2.2 7.6c-4.5 15.7-12.9 30-24.4 41.5l-68.3 68.3c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l68.3-68.3c3.8-3.8 6.6-8.6 8.1-13.8L160.1 371zm233.5-62.2c10.6-8 25.6-5.8 33.6 4.8l144 192c8 10.6 5.8 25.6-4.8 33.6s-25.6 5.8-33.6-4.8l-144-192c-8-10.6-5.8-25.6 4.8-33.6z"
    ]
};
var $159afdcd077ecfe9$export$923de21def6ea9b6 = $159afdcd077ecfe9$export$2ffee5b2bc935c1f;
var $159afdcd077ecfe9$export$5e0c19cf315ac1bf = {
    prefix: 'fas',
    iconName: 'file-waveform',
    icon: [
        384,
        512,
        [
            "file-medical-alt"
        ],
        "f478",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-96 60.3 0 48.8 62.7c5.1 6.6 13.3 10 21.6 9.1s15.5-6.1 19.1-13.6l42.9-91.2 9.9 19.8c4.1 8.1 12.4 13.3 21.5 13.3l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-57.2 0-25.4-50.7c-4.1-8.2-12.6-13.4-21.8-13.3s-17.5 5.5-21.4 13.8l-47.3 100.6-32-41.1C86.4 307.4 79.4 304 72 304L0 304 0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5z"
    ]
};
var $159afdcd077ecfe9$export$ef02a0f5b39aa61f = $159afdcd077ecfe9$export$5e0c19cf315ac1bf;
var $159afdcd077ecfe9$export$baa3c215534dbf2a = {
    prefix: 'fas',
    iconName: 'house-crack',
    icon: [
        512,
        512,
        [],
        "e3b1",
        "M277.8 8.6c-12.3-11.4-31.3-11.4-43.5 0l-224 208c-9.6 9-12.8 22.9-8 35.1S18.8 272 32 272l16 0 0 176c0 35.3 28.7 64 64 64l86.4 0-31.3-52.2c-4.1-6.8-2.6-15.5 3.5-20.5L256 368 195.8 285.2c-10.9-15 8.2-33.5 22.8-22l117.9 92.6c8 6.3 8.2 18.4 .4 24.9L256 448 294.4 512 400 512c35.3 0 64-28.7 64-64l0-176 16 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8-35.1l-224-208z"
    ]
};
var $159afdcd077ecfe9$export$7daa48199dcb2ad1 = {
    prefix: 'fas',
    iconName: 'hat-wizard',
    icon: [
        512,
        512,
        [],
        "f6e8",
        "M64 400l85.7-208.2c17-41.3 47.8-75.3 87.2-96.3L383.8 17.2c12.3-6.6 26.5 4.7 23 18.2L369.6 177.8c-1.1 4.1-1.6 8.3-1.6 12.6 0 6.3 1.2 12.6 3.6 18.5l76.4 191.1-207.1 0 11.8-35.4 40.4-13.5c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-40.4-13.5-13.5-40.4C237 260.4 230.9 256 224 256s-13 4.4-15.2 10.9l-13.5 40.4-40.4 13.5C148.4 323 144 329.1 144 336s4.4 13 10.9 15.2l40.4 13.5 11.8 35.4-143.1 0zM279.6 141.5c-1.1-3.3-4.1-5.5-7.6-5.5s-6.5 2.2-7.6 5.5l-6.7 20.2-20.2 6.7c-3.3 1.1-5.5 4.1-5.5 7.6s2.2 6.5 5.5 7.6l20.2 6.7 6.7 20.2c1.1 3.3 4.1 5.5 7.6 5.5s6.5-2.2 7.6-5.5l6.7-20.2 20.2-6.7c3.3-1.1 5.5-4.1 5.5-7.6s-2.2-6.5-5.5-7.6l-20.2-6.7-6.7-20.2zM32 448l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$9884bf227eeb829 = {
    prefix: 'fas',
    iconName: 'user-doctor',
    icon: [
        448,
        512,
        [
            "user-md"
        ],
        "f0f0",
        "M224 8a120 120 0 1 0 0 240 120 120 0 1 0 0-240zm60 312.8c-5.4-.5-11-.8-16.6-.8l-86.9 0c-5.6 0-11.1 .3-16.6 .8l0 67.5c16.5 7.6 28 24.3 28 43.6 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-19.4 11.5-36.1 28-43.6l0-58.4C61 353 16 413.6 16 484.6 16 499.7 28.3 512 43.4 512l361.1 0c15.1 0 27.4-12.3 27.4-27.4 0-71-45-131.5-108-154.6l0 37.4c23.3 8.2 40 30.5 40 56.6l0 32c0 11-9 20-20 20s-20-9-20-20l0-32c0-11-9-20-20-20s-20 9-20 20l0 32c0 11-9 20-20 20s-20-9-20-20l0-32c0-26.1 16.7-48.3 40-56.6l0-46.6z"
    ]
};
var $159afdcd077ecfe9$export$ab0d33a2c03f1794 = $159afdcd077ecfe9$export$9884bf227eeb829;
var $159afdcd077ecfe9$export$b532f5d25de97633 = {
    prefix: 'fas',
    iconName: 'chart-bar',
    icon: [
        512,
        512,
        [
            "bar-chart"
        ],
        "f080",
        "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zm96 64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 80l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 112l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$2d5f754a5e5738b = $159afdcd077ecfe9$export$b532f5d25de97633;
var $159afdcd077ecfe9$export$43832c90c10a7a31 = {
    prefix: 'fas',
    iconName: 'spray-can-sparkles',
    icon: [
        576,
        512,
        [
            "air-freshener"
        ],
        "f5d0",
        "M160 32l0 80 128 0 0-80c0-17.7-14.3-32-32-32L192 0c-17.7 0-32 14.3-32 32zm0 128c-53 0-96 43-96 96l0 208c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-208c0-53-43-96-96-96l-128 0zm64 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM448 48c0-1.4-1-3-2.2-3.6L416 32 403.6 2.2C403 1 401.4 0 400 0s-3 1-3.6 2.2L384 32 354.2 44.4c-1.2 .6-2.2 2.2-2.2 3.6 0 1.4 1 3 2.2 3.6L384 64 396.4 93.8C397 95 398.6 96 400 96s3-1 3.6-2.2L416 64 445.8 51.6C447 51 448 49.4 448 48zm76.4 45.8C525 95 526.6 96 528 96s3-1 3.6-2.2L544 64 573.8 51.6c1.2-.6 2.2-2.2 2.2-3.6 0-1.4-1-3-2.2-3.6L544 32 531.6 2.2C531 1 529.4 0 528 0s-3 1-3.6 2.2L512 32 482.2 44.4c-1.2 .6-2.2 2.2-2.2 3.6 0 1.4 1 3 2.2 3.6L512 64 524.4 93.8zm7.2 100.4c-.6-1.2-2.2-2.2-3.6-2.2s-3 1-3.6 2.2L512 224 482.2 236.4c-1.2 .6-2.2 2.2-2.2 3.6 0 1.4 1 3 2.2 3.6L512 256 524.4 285.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L544 256 573.8 243.6c1.2-.6 2.2-2.2 2.2-3.6 0-1.4-1-3-2.2-3.6L544 224 531.6 194.2zM512 144c0-1.4-1-3-2.2-3.6L480 128 467.6 98.2C467 97 465.4 96 464 96s-3 1-3.6 2.2L448 128 418.2 140.4c-1.2 .6-2.2 2.2-2.2 3.6 0 1.4 1 3 2.2 3.6L448 160 460.4 189.8c.6 1.2 2.2 2.2 3.6 2.2s3-1 3.6-2.2L480 160 509.8 147.6c1.2-.6 2.2-2.2 2.2-3.6z"
    ]
};
var $159afdcd077ecfe9$export$a5e63e89b5ccee83 = $159afdcd077ecfe9$export$43832c90c10a7a31;
var $159afdcd077ecfe9$export$ffc7123046a28ee = {
    prefix: 'fas',
    iconName: 'baht-sign',
    icon: [
        320,
        512,
        [],
        "e0ac",
        "M136 0c-13.3 0-24 10.7-24 24l0 40-74.4 0C16.8 64 0 80.8 0 101.6L0 406.3c0 23 18.7 41.7 41.7 41.7l70.3 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 48 0c61.9 0 112-50.1 112-112 0-40.1-21.1-75.3-52.7-95.1 13.1-18.3 20.7-40.7 20.7-64.9 0-61.9-50.1-112-112-112l-16 0 0-40c0-13.3-10.7-24-24-24zM112 128l0 96-48 0 0-96 48 0zm48 96l0-96 16 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-16 0zm-48 64l0 96-48 0 0-96 48 0zm48 96l0-96 48 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-48 0z"
    ]
};
var $159afdcd077ecfe9$export$d7a5da41ce01461d = {
    prefix: 'fas',
    iconName: 'temperature-arrow-up',
    icon: [
        512,
        512,
        [
            "temperature-up"
        ],
        "e040",
        "M64.5 96c0-53 43-96 96-96s96 43 96 96l0 164.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-42.6 18.5-81 48-107.3L64.5 96zm96 336c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-212.7c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 212.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM439.1 9.4l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-9.4-9.4 0 178.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-178.7-9.4 9.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c6-6 14.1-9.4 22.6-9.4s16.6 3.4 22.6 9.4z"
    ]
};
var $159afdcd077ecfe9$export$872345a0157330a3 = $159afdcd077ecfe9$export$d7a5da41ce01461d;
var $159afdcd077ecfe9$export$5fa0ffae6770a0cc = {
    prefix: 'fas',
    iconName: 'web-awesome',
    icon: [
        640,
        512,
        [],
        "e682",
        "M372.2 52c0 20.9-12.4 39-30.2 47.2L448 192 552.4 171.1c-5.3-7.7-8.4-17.1-8.4-27.1 0-26.5 21.5-48 48-48s48 21.5 48 48c0 26-20.6 47.1-46.4 48L481 442.3c-10.3 23-33.2 37.7-58.4 37.7l-205.2 0c-25.2 0-48-14.8-58.4-37.7L46.4 192C20.6 191.1 0 170 0 144 0 117.5 21.5 96 48 96s48 21.5 48 48c0 10.1-3.1 19.4-8.4 27.1L192 192 298.1 99.1c-17.7-8.3-30-26.3-30-47.1 0-28.7 23.3-52 52-52s52 23.3 52 52z"
    ]
};
var $159afdcd077ecfe9$export$f7742803bef3f397 = {
    prefix: 'fas',
    iconName: 'non-binary',
    icon: [
        384,
        512,
        [],
        "e807",
        "M192 544c-97.2 0-176-78.8-176-176 0-86.3 62.1-158 144-173l0-47.2-49.7 24.8-3 1.3c-15.2 5.7-32.5-.8-39.9-15.7-7.4-14.8-2.2-32.6 11.5-41.3l2.8-1.6 38.8-19.4-38.8-19.4c-15.8-7.9-22.2-27.1-14.3-42.9 7.4-14.8 24.8-21.4 40-15.6l3 1.3 49.7 24.8 0-44.2c0-17.7 14.3-32 32-32s32 14.3 32 32l0 44.2 49.7-24.8 3-1.3c15.2-5.8 32.5 .8 39.9 15.6s2.2 32.7-11.5 41.3l-2.8 1.6-38.7 19.4 38.7 19.3c15.8 7.9 22.2 27.1 14.3 42.9-7.4 14.8-24.7 21.4-39.9 15.6l-3-1.3-49.7-24.8 0 47.2c81.9 15.1 144 86.8 144 173 0 97.2-78.8 176-176 176zm0-64a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
    ]
};
var $159afdcd077ecfe9$export$328a9baf0f9e3405 = {
    prefix: 'fas',
    iconName: 'n',
    icon: [
        384,
        512,
        [
            110
        ],
        "4e",
        "M21.1 33.9c12.7-4.6 26.9-.7 35.5 9.6L320 359.6 320 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 13.5-8.4 25.5-21.1 30.1s-26.9 .7-35.5-9.6L64 152.4 64 448c0 17.7-14.3 32-32 32S0 465.7 0 448L0 64C0 50.5 8.4 38.5 21.1 33.9z"
    ]
};
var $159afdcd077ecfe9$export$ff9a43e3a9cb653c = {
    prefix: 'fas',
    iconName: 'arrows-up-down-left-right',
    icon: [
        512,
        512,
        [
            "arrows"
        ],
        "f047",
        "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l9.4-9.4 0 114.7-114.7 0 9.4-9.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-9.4-9.4 114.7 0 0 114.7-9.4-9.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-9.4 9.4 0-114.7 114.7 0-9.4 9.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l9.4 9.4-114.7 0 0-114.7 9.4 9.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64z"
    ]
};
var $159afdcd077ecfe9$export$d5ae09a305d70340 = $159afdcd077ecfe9$export$ff9a43e3a9cb653c;
var $159afdcd077ecfe9$export$dcadc0d67468dfa8 = {
    prefix: 'fas',
    iconName: 'house',
    icon: [
        512,
        512,
        [
            127968,
            63498,
            63500,
            "home",
            "home-alt",
            "home-lg-alt"
        ],
        "f015",
        "M277.8 8.6c-12.3-11.4-31.3-11.4-43.5 0l-224 208c-9.6 9-12.8 22.9-8 35.1S18.8 272 32 272l16 0 0 176c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-176 16 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8-35.1l-224-208zM240 320l32 0c26.5 0 48 21.5 48 48l0 96-128 0 0-96c0-26.5 21.5-48 48-48z"
    ]
};
var $159afdcd077ecfe9$export$48f10d71ec526479 = $159afdcd077ecfe9$export$dcadc0d67468dfa8;
var $159afdcd077ecfe9$export$279659c4b23dbedb = $159afdcd077ecfe9$export$dcadc0d67468dfa8;
var $159afdcd077ecfe9$export$20d6d52d45f53262 = $159afdcd077ecfe9$export$dcadc0d67468dfa8;
var $159afdcd077ecfe9$export$1025ad641edb49c2 = {
    prefix: 'fas',
    iconName: 'spinner',
    icon: [
        512,
        512,
        [],
        "f110",
        "M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm0 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM48 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm368 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM75 369.1A48 48 0 1 1 142.9 437 48 48 0 1 1 75 369.1zM75 75A48 48 0 1 1 142.9 142.9 48 48 0 1 1 75 75zM437 369.1A48 48 0 1 1 369.1 437 48 48 0 1 1 437 369.1z"
    ]
};
var $159afdcd077ecfe9$export$c36fb40057e2c3aa = {
    prefix: 'fas',
    iconName: 'gavel',
    icon: [
        576,
        512,
        [
            "legal"
        ],
        "f0e3",
        "M169.6 153.4l-18.7-18.7c-12.5-12.5-12.5-32.8 0-45.3L265.6-25.4c12.5-12.5 32.8-12.5 45.3 0L329.6-6.6c12.5 12.5 12.5 32.8 0 45.3L214.9 153.4c-12.5 12.5-32.8 12.5-45.3 0zM276 211.7l-31.4-31.4 112-112 119.4 119.4-112 112-31.4-31.4-232 232c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6l232-232zM390.9 374.6c-12.5-12.5-12.5-32.8 0-45.3L505.6 214.6c12.5-12.5 32.8-12.5 45.3 0l18.7 18.7c12.5 12.5 12.5 32.8 0 45.3L454.9 393.4c-12.5 12.5-32.8 12.5-45.3 0l-18.7-18.7z"
    ]
};
var $159afdcd077ecfe9$export$59d593c2dacb3781 = $159afdcd077ecfe9$export$c36fb40057e2c3aa;
var $159afdcd077ecfe9$export$68ddda3b30ba09f0 = {
    prefix: 'fas',
    iconName: 'ticket-simple',
    icon: [
        576,
        512,
        [
            "ticket-alt"
        ],
        "f3ff",
        "M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 64c0 8.8-7.4 15.7-15.7 18.6-18.8 6.5-32.3 24.4-32.3 45.4s13.5 38.9 32.3 45.4c8.3 2.9 15.7 9.8 15.7 18.6l0 64c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64l0-64C0 311.2 7.4 304.3 15.7 301.4 34.5 294.9 48 277 48 256s-13.5-38.9-32.3-45.4C7.4 207.7 0 200.8 0 192l0-64z"
    ]
};
var $159afdcd077ecfe9$export$75e38ba471fd89c4 = $159afdcd077ecfe9$export$68ddda3b30ba09f0;
var $159afdcd077ecfe9$export$a1ab1e69a300089f = {
    prefix: 'fas',
    iconName: 'dove',
    icon: [
        512,
        512,
        [
            128330
        ],
        "f4ba",
        "M496 64c13.2 0 20.7 15.1 12.8 25.6L480 128 480 304c0 79.5-64.5 144-144 144l-112 0-46.3 46.3c-10.4 10.4-26.5 12.4-39.1 4.8L41.5 440.9c-17-10.2-15-35.5 3.4-42.9L160 352C23.8 311.1 7.5 169.8 22 95.7 25.6 77.9 45.3 71.4 61.3 80.2L320 224 320 144c0-44.2 35.8-80 80-80l96 0zm-96 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM182.5-9.6c12.4-13.7 33.3-8.9 42.5 7.1l56.4 98.3c-5.8 14.4-9.2 30.1-9.4 46.5L138.1 68c10.1-31.6 27-58.4 44.4-77.6z"
    ]
};
var $159afdcd077ecfe9$export$1585b7c3c7109751 = {
    prefix: 'fas',
    iconName: 'tarp-droplet',
    icon: [
        512,
        512,
        [],
        "e57c",
        "M256 160c35.3 0 64-26.9 64-60 0-24-33.7-70.1-52.2-93.5-6.1-7.7-17.5-7.7-23.6 0-18.5 23.4-52.2 69.5-52.2 93.5 0 33.1 28.7 60 64 60zM368 96c0 61.9-50.1 112-112 112S144 157.9 144 96c0-11.1 1.6-21.9 4.6-32L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l277.5 0c17 0 33.3-6.7 45.3-18.7L493.3 322.7c12-12 18.7-28.3 18.7-45.3L512 128c0-35.3-28.7-64-64-64l-84.6 0c3 10.1 4.6 20.9 4.6 32zm85.5 176L336 389.5 336 296c0-13.3 10.7-24 24-24l93.5 0zM96 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$ad95e4f80f98ebe0 = {
    prefix: 'fas',
    iconName: 'tree-city',
    icon: [
        640,
        512,
        [],
        "e587",
        "M288 48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 48 48 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 16 0c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-416zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 304l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM528 192c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM512 304l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM96 480l0-160-16 0c-44.2 0-80-35.8-80-80 0-26.7 13.1-50.3 33.2-64.9-.8-4.9-1.2-10-1.2-15.1 0-53 43-96 96-96s96 43 96 96l0 96c0 35.3-28.7 64-64 64l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$314f5cab62fc6968 = {
    prefix: 'fas',
    iconName: 'turn-up',
    icon: [
        384,
        512,
        [
            10548,
            "level-up-alt"
        ],
        "f3bf",
        "M169.4 9.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9S332.9 192 320 192l-64 0 0 160c0 88.4-71.6 160-160 160l-64 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l64 0c17.7 0 32-14.3 32-32l0-160-64 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128z"
    ]
};
var $159afdcd077ecfe9$export$d6f21a309b179c3d = $159afdcd077ecfe9$export$314f5cab62fc6968;
var $159afdcd077ecfe9$export$f9d1c19925fd7fa8 = {
    prefix: 'fas',
    iconName: 'temperature-quarter',
    icon: [
        320,
        512,
        [
            "temperature-1",
            "thermometer-1",
            "thermometer-quarter"
        ],
        "f2ca",
        "M160 0C107 0 64 43 64 96l0 164.7C34.5 287 16 325.4 16 368 16 447.5 80.5 512 160 512s144-64.5 144-144c0-42.6-18.5-81-48-107.3L256 96c0-53-43-96-96-96zm64 368c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-28.7c0-13.3 10.7-24 24-24s24 10.7 24 24l0 28.7c23.5 9.5 40 32.5 40 59.3z"
    ]
};
var $159afdcd077ecfe9$export$d4f1cd380bde2129 = $159afdcd077ecfe9$export$f9d1c19925fd7fa8;
var $159afdcd077ecfe9$export$3f77fbe2dabe285b = $159afdcd077ecfe9$export$f9d1c19925fd7fa8;
var $159afdcd077ecfe9$export$ed05754fcbec6e46 = $159afdcd077ecfe9$export$f9d1c19925fd7fa8;
var $159afdcd077ecfe9$export$ea6970ed5a15feb6 = {
    prefix: 'fas',
    iconName: 'sliders',
    icon: [
        512,
        512,
        [
            "sliders-h"
        ],
        "f1de",
        "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 224zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384z"
    ]
};
var $159afdcd077ecfe9$export$94d4dcb523f95563 = $159afdcd077ecfe9$export$ea6970ed5a15feb6;
var $159afdcd077ecfe9$export$4999586d7e1087fb = {
    prefix: 'fas',
    iconName: 'mosque',
    icon: [
        576,
        512,
        [
            128332
        ],
        "f678",
        "M174.8 224l226.4 0c43.5 0 78.8-35.3 78.8-78.8 0-25.5-12.3-49.4-33.1-64.2L297.3-25.4c-5.6-3.9-13-3.9-18.5 0L129.1 81C108.3 95.8 96 119.7 96 145.2 96 188.7 131.3 224 174.8 224zM512 512c35.3 0 64-28.7 64-64l0-224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-448 0 0-48c0-17.7-14.3-32-32-32S0 206.3 0 224L0 448c0 35.3 28.7 64 64 64l448 0zM240 384c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80-96 0 0-80z"
    ]
};
var $159afdcd077ecfe9$export$d762b7b66d5875e1 = {
    prefix: 'fas',
    iconName: 'h',
    icon: [
        384,
        512,
        [
            104
        ],
        "48",
        "M320 288l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160-256 0 0-160c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 256 0z"
    ]
};
var $159afdcd077ecfe9$export$d469b770895f47ac = {
    prefix: 'fas',
    iconName: 'info',
    icon: [
        192,
        512,
        [],
        "f129",
        "M48 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM0 192c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 256 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-224-32 0c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$6af1cc5998ca52bc = {
    prefix: 'fas',
    iconName: 'person-walking',
    icon: [
        384,
        512,
        [
            128694,
            "walking"
        ],
        "f554",
        "M192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM105.4 227.9l22.6-22.6 0 69.3c0 28 12.2 54.7 33.5 72.9l71.4 61.2c5.9 5.1 9.8 12.1 10.9 19.8l12.6 88.1c2.5 17.5 18.7 29.7 36.2 27.2s29.7-18.7 27.2-36.2l-12.6-88.1c-3.3-23.1-14.9-44.1-32.6-59.3l-34.5-29.6 0-115.2 3.8 4.7c18.2 22.8 45.8 36 75 36l33.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-33.2 0c-9.7 0-18.9-4.4-25-12l-17.9-22.4c-23-28.8-57.9-45.6-94.8-45.6-32.2 0-63.1 12.8-85.8 35.6L60.1 182.6C42.1 200.6 32 225 32 250.5L32 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-37.5c0-8.5 3.4-16.6 9.4-22.6zm12.4 179.4c-1.5 5.2-4.3 10-8.1 13.8L41.4 489.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.3-68.3c11.5-11.5 19.9-25.8 24.4-41.5l2.2-7.6-46-39.4c-2.5-2.2-5-4.4-7.4-6.8l-10.4 36.2z"
    ]
};
var $159afdcd077ecfe9$export$4886811b7174ec35 = $159afdcd077ecfe9$export$6af1cc5998ca52bc;
var $159afdcd077ecfe9$export$fd4d6cfd52703f50 = {
    prefix: 'fas',
    iconName: 'arrow-turn-down',
    icon: [
        384,
        512,
        [
            "level-down"
        ],
        "f149",
        "M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
    ]
};
var $159afdcd077ecfe9$export$3794c07e7a666c94 = $159afdcd077ecfe9$export$fd4d6cfd52703f50;
var $159afdcd077ecfe9$export$f224567a4851a5e9 = {
    prefix: 'fas',
    iconName: 'road',
    icon: [
        512,
        512,
        [
            128739
        ],
        "f018",
        "M223.9 32l-76.2 0c-29.4 0-55.1 20.1-62.1 48.6L1.4 420.5C-6.1 450.7 16.8 480 48 480l175.9 0 0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64 176.1 0c31.2 0 54.1-29.3 46.6-59.5L426.5 80.6C419.4 52.1 393.8 32 364.3 32l-76.4 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$1b18261a412e2e1c = {
    prefix: 'fas',
    iconName: 'spiral',
    icon: [
        512,
        512,
        [],
        "e80a",
        "M115.5 7.4c13.6-11.3 33.8-9.5 45.1 4.1s9.5 33.8-4.1 45.1C100.2 103.5 64 175.2 64 256 64 362 150 448 256 448s192-86 192-192c0-75.1-60.9-136-136-136S176 180.9 176 256c0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-48.6 39.4-88 88-88s88 39.4 88 88c0 79.5-64.5 144-144 144S112 335.5 112 256c0-110.5 89.5-200 200-200s200 89.5 200 200c0 141.4-114.6 256-256 256S0 397.4 0 256C0 155.8 45 66.1 115.5 7.4z"
    ]
};
var $159afdcd077ecfe9$export$e5f78e87efbb0248 = {
    prefix: 'fas',
    iconName: 'face-frown',
    icon: [
        512,
        512,
        [
            9785,
            "frown"
        ],
        "f119",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm90.6-113.9c-20.4-28-53.4-46.1-90.6-46.1s-70.2 18.1-90.6 46.1c-7.8 10.7-22.8 13.1-33.5 5.3s-13.1-22.8-5.3-33.5C155.7 330 202.8 304 256 304s100.3 26 129.4 65.9c7.8 10.7 5.4 25.7-5.3 33.5s-25.7 5.4-33.5-5.3zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$43b7108508aecc5f = $159afdcd077ecfe9$export$e5f78e87efbb0248;
var $159afdcd077ecfe9$export$b86d7336e68a3f57 = {
    prefix: 'fas',
    iconName: 'wine-glass-empty',
    icon: [
        320,
        512,
        [
            "wine-glass-alt"
        ],
        "f5ce",
        "M64 0C48.7 0 35.6 10.8 32.6 25.7L3.2 173C1.1 183.5 0 194.2 0 205l0 3c0 77.4 55 142 128 156.8l0 115.2-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-115.2C265 350 320 285.4 320 208l0-3c0-10.7-1.1-21.4-3.2-32L287.4 25.7C284.4 10.8 271.3 0 256 0L64 0zm1.9 185.6L90.2 64 229.8 64 254.1 185.6c1.3 6.4 1.9 12.9 1.9 19.4l0 3c0 53-43 96-96 96s-96-43-96-96l0-3c0-6.5 .6-13 1.9-19.4z"
    ]
};
var $159afdcd077ecfe9$export$b8ff3fe2b78aef2f = $159afdcd077ecfe9$export$b86d7336e68a3f57;
var $159afdcd077ecfe9$export$add3b381ced12554 = {
    prefix: 'fas',
    iconName: 'clapperboard',
    icon: [
        512,
        512,
        [],
        "e131",
        "M448 64c2 0 3.9 .1 5.8 .3l-95.7 95.7 67.9 0 72-72c8.8 11 14 24.9 14 40l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l70.1 0-96 96 67.9 0 95-95 1-1 92.1 0-96 96 67.9 0 95-95 1-1 86.1 0z"
    ]
};
var $159afdcd077ecfe9$export$908d699be6717adc = {
    prefix: 'fas',
    iconName: 'forward-step',
    icon: [
        384,
        512,
        [
            "step-forward"
        ],
        "f051",
        "M21 36.8c12.9-7 28.7-6.3 41 1.8L320 208.1 320 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 384c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-144.1-258 169.6c-12.3 8.1-28 8.8-41 1.8S0 454.7 0 440L0 72C0 57.3 8.1 43.8 21 36.8z"
    ]
};
var $159afdcd077ecfe9$export$b303329afce5de18 = $159afdcd077ecfe9$export$908d699be6717adc;
var $159afdcd077ecfe9$export$a47a20ab7bde8c67 = {
    prefix: 'fas',
    iconName: 'square-up-right',
    icon: [
        448,
        512,
        [
            8599,
            "external-link-square-alt"
        ],
        "f360",
        "M384 32c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0zM168 160c-9.7 0-18.5 5.8-22.2 14.8s-1.7 19.3 5.2 26.2l35 35-67 67c-9.4 9.4-9.4 24.6 0 33.9l24 24c9.4 9.4 24.6 9.4 33.9 0l67-67 35 35c6.9 6.9 17.2 8.9 26.2 5.2S320 321.7 320 312l0-128c0-13.3-10.7-24-24-24l-128 0z"
    ]
};
var $159afdcd077ecfe9$export$e4cdf2977151ee26 = $159afdcd077ecfe9$export$a47a20ab7bde8c67;
var $159afdcd077ecfe9$export$d3d49030d557a09b = {
    prefix: 'fas',
    iconName: 'book-journal-whills',
    icon: [
        448,
        512,
        [
            "journal-whills"
        ],
        "f66a",
        "M96 512l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-66.7c18.6-6.6 32-24.4 32-45.3l0-288c0-26.5-21.5-48-48-48L96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96zM64 416c0-17.7 14.3-32 32-32l256 0 0 64-256 0c-17.7 0-32-14.3-32-32zM274.1 99.2c2.6-2.6 6.7-3.1 9.9-1.1 32.1 20 53.4 55.6 53.4 96.2 0 62.6-50.7 113.3-113.3 113.3S110.7 256.9 110.7 194.3c0-40.6 21.4-76.2 53.4-96.2 3.1-2 7.2-1.5 9.9 1.1s3.1 6.7 1.2 9.8c-5.2 8.6-8.2 18.7-8.2 29.5 0 15.1 5.9 28.8 15.5 39.1 2.5 2.7 2.9 6.7 .9 9.7-4.7 7.4-7.4 16.1-7.4 25.5 0 21.6 14.3 39.9 34 45.9l1-24.8c-7.1-4.4-11.8-12.2-11.8-21.1 0-9.6 5.5-18 13.5-22.1l3.3-81.8c.2-4.3 3.7-7.7 8-7.7s7.8 3.4 8 7.7l3.3 81.8c8 4.1 13.5 12.4 13.5 22.1 0 8.9-4.7 16.7-11.8 21.1l1 24.8c19.6-6 33.9-24.1 34-45.6l0-.6c-.1-9.3-2.7-17.9-7.4-25.2-1.9-3.1-1.6-7.1 .9-9.7 9.6-10.2 15.5-23.9 15.5-39.1 0-10.8-3-20.9-8.2-29.5-1.9-3.2-1.4-7.2 1.2-9.8z"
    ]
};
var $159afdcd077ecfe9$export$66a0d8d45aab6631 = $159afdcd077ecfe9$export$d3d49030d557a09b;
var $159afdcd077ecfe9$export$7df1926e9eef8cc3 = {
    prefix: 'fas',
    iconName: 'champagne-glasses',
    icon: [
        640,
        512,
        [
            129346,
            "glass-cheers"
        ],
        "f79f",
        "M155.6 17.3C163 3 179.9-3.6 195 1.9l125 45.6 125-45.6c15.1-5.5 32 1.1 39.4 15.4l78.8 152.9c28.8 55.8 10.3 122.3-38.5 156.6l31.3 86.2 41-15c16.6-6 35 2.5 41 19.1s-2.5 35-19.1 41c-47.4 17.3-94.8 34.5-142.2 51.8-16.6 6.1-35-2.5-41-19.1s2.5-35 19.1-41l41-15-31.3-86.2c-59.4 5.2-116.2-33.9-130-95.2l-14.6-64.7-14.6 64.7c-13.8 61.3-70.6 100.4-130 95.2l-31.3 86.2 41 15c16.6 6.1 25.2 24.4 19.1 41s-24.4 25.2-41 19.1c-47.4-17.3-94.8-34.6-142.2-51.8-16.6-6.1-25.2-24.4-19.1-41S26.3 392 42.9 398l41 15 31.3-86.2C66.5 292.5 48.1 226 76.9 170.2L155.6 17.3zm44 54.4l-27.2 52.8 89.2 32.5 13.1-57.9-75.1-27.4zm240.9 0l-75.1 27.4 13.1 57.9 89.2-32.5-27.2-52.8z"
    ]
};
var $159afdcd077ecfe9$export$20007d7d74cb98fe = $159afdcd077ecfe9$export$7df1926e9eef8cc3;
var $159afdcd077ecfe9$export$3b934e22d1851a3b = {
    prefix: 'fas',
    iconName: 'dumpster',
    icon: [
        576,
        512,
        [],
        "f793",
        "M132.3 64L106.7 192 24 192c-13.3 0-24-10.7-24-24l0-4.1c0-2.6 .4-5.1 1.2-7.6L26.5 80.4C29.8 70.6 39 64 49.3 64l83 0zm23.4 128l25.6-128 82.7 0 0 128-108.3 0zM312 64l82.7 0 25.6 128-108.3 0 0-128zm131.7 0l83 0c10.3 0 19.5 6.6 22.8 16.4l25.3 75.9c.8 2.4 1.2 5 1.2 7.6l0 4.1c0 13.3-10.7 24-24 24l-82.7 0-25.6-128zM25.7 240l524.7 0c-.4 2.1-13.3 73.4-38.9 213.7-3 16.3-17.9 27.6-34.4 26.1S448 464.6 448 448l0-16-320 0 0 16c0 16.6-12.6 30.4-29.1 31.9S67.5 470 64.5 453.7C39 313.3 26 242.1 25.7 240z"
    ]
};
var $159afdcd077ecfe9$export$742f89ae2f8d6b20 = {
    prefix: 'fas',
    iconName: 'heart-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e501",
        "M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 17.6-3.4 35.6-9.5 53.7-21.8-8.6-45.6-13.4-70.5-13.4-106 0-192 86-192 192 0 28.5 6.2 55.6 17.4 80-.5 0-.9 0-1.4 0-15.5 0-30.8-4.6-43.1-14.1-73-55.7-212.9-186-212.9-298.2l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1zM432 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-36.7 36.7-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-36.7-36.7 36.7-36.7z"
    ]
};
var $159afdcd077ecfe9$export$9835883ce9d0fe78 = {
    prefix: 'fas',
    iconName: 'computer',
    icon: [
        576,
        512,
        [],
        "e4e5",
        "M348.8 32C340.7 46.1 336 62.5 336 80l0 16-272 0 0 224 272 0 0 64-272 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l284.8 0zM336 432c0 17.5 4.7 33.9 12.8 48L120 480c-13.3 0-24-10.7-24-24s10.7-24 24-24l216 0zM432 32l96 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-352c0-26.5 21.5-48 48-48zm24 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm56 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $159afdcd077ecfe9$export$8282f5f5dcf6b009 = {
    prefix: 'fas',
    iconName: 'wand-magic',
    icon: [
        512,
        512,
        [
            "magic"
        ],
        "f0d0",
        "M398.5 12.2l-88.2 88.2 101.3 101.3 88.2-88.2C507.6 105.6 512 95 512 84s-4.4-21.6-12.2-29.5L457.5 12.2C449.6 4.4 439 0 428 0s-21.6 4.4-29.5 12.2zM276.4 134.3L12.2 398.5C4.4 406.4 0 417 0 428s4.4 21.6 12.2 29.5l42.3 42.3C62.4 507.6 73 512 84 512s21.6-4.4 29.5-12.2L377.7 235.6 276.4 134.3z"
    ]
};
var $159afdcd077ecfe9$export$e58f9b502d4dd52d = $159afdcd077ecfe9$export$8282f5f5dcf6b009;
var $159afdcd077ecfe9$export$97fa4f4c1006ab1 = {
    prefix: 'fas',
    iconName: 'brain',
    icon: [
        512,
        512,
        [
            129504
        ],
        "f5dc",
        "M120 56c0-30.9 25.1-56 56-56l24 0c17.7 0 32 14.3 32 32l0 448c0 17.7-14.3 32-32 32l-32 0c-29.8 0-54.9-20.4-62-48-.7 0-1.3 0-2 0-44.2 0-80-35.8-80-80 0-18 6-34.6 16-48-19.4-14.6-32-37.8-32-64 0-30.9 17.6-57.8 43.2-71.1-7.1-12-11.2-26-11.2-40.9 0-44.2 35.8-80 80-80l0-24zm272 0l0 24c44.2 0 80 35.8 80 80 0 15-4.1 29-11.2 40.9 25.7 13.3 43.2 40.1 43.2 71.1 0 26.2-12.6 49.4-32 64 10 13.4 16 30 16 48 0 44.2-35.8 80-80 80-.7 0-1.3 0-2 0-7.1 27.6-32.2 48-62 48l-32 0c-17.7 0-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32l24 0c30.9 0 56 25.1 56 56z"
    ]
};
var $159afdcd077ecfe9$export$5000f52ca9819bf5 = {
    prefix: 'fas',
    iconName: 'briefcase-medical',
    icon: [
        512,
        512,
        [],
        "f469",
        "M200 48l112 0c4.4 0 8 3.6 8 8l0 40-128 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-80 0C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-80 0 0-40c0-30.9-25.1-56-56-56L200 0c-30.9 0-56 25.1-56 56zm80 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 40 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-40 0 0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$bc50edea6e121df5 = {
    prefix: 'fas',
    iconName: 'house-medical-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e512",
        "M309.8 8.6c-12.3-11.4-31.3-11.4-43.5 0l-224 208c-9.6 9-12.8 22.9-8 35.1S50.8 272 64 272l16 0 0 176c0 35.3 28.7 64 64 64l196 0c-21.2-29.5-34.3-65.3-35.9-104L272 408c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 20 0c34.9-48.5 91.7-80 156-80 10.7 0 21.1 .9 31.3 2.5L309.8 8.6zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-140c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$d5d870c10bc9f1ce = {
    prefix: 'fas',
    iconName: 'code-commit',
    icon: [
        576,
        512,
        [],
        "f386",
        "M288 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm156.8-48C430 361 365.4 416 288 416S146 361 131.2 288L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l99.2 0C146 151 210.6 96 288 96s142 55 156.8 128l99.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-99.2 0z"
    ]
};
var $159afdcd077ecfe9$export$9b94ed8d16d281f9 = {
    prefix: 'fas',
    iconName: 'person-breastfeeding',
    icon: [
        448,
        512,
        [],
        "e53a",
        "M224 0a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM436.8 382.8L373.5 462c-16.6 20.7-46.8 24.1-67.5 7.5-17.6-14.1-22.7-38.1-13.5-57.7l-.7-.1c-38.9-5.6-74.3-25.1-99.7-54.8l0-36.8c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48c0 .8 0 1.6 .1 2.4l101.4 50.7c23.7 11.9 33.3 40.7 21.5 64.4s-40.7 33.3-64.4 21.5L27.2 427.3c-1.1-.5-2.2-1.1-3.3-1.7-4.9-2.8-9.2-6.4-12.6-10.6-4.6-5.4-7.8-11.7-9.6-18.4-3.3-12-1.9-25.2 4.8-36.6 .6-1.1 1.3-2.2 2-3.2L75.6 256.1c26.7-40.1 71.7-64.1 119.8-64.1l75.2 0c46.5 0 90.1 22.5 117.2 60.3l50.7 70.9c2.2 3 4 6.1 5.5 9.4 2.9 6.7 4.3 13.8 4 20.8-.3 10.6-4.2 21-11.2 29.4zM320 332a44 44 0 1 0 -88 0 44 44 0 1 0 88 0z"
    ]
};
var $159afdcd077ecfe9$export$49577f913f0fe4d2 = {
    prefix: 'fas',
    iconName: 'person-rays',
    icon: [
        512,
        512,
        [],
        "e54d",
        "M312.5 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 212.7l46.3 62.4c10.5 14.2 30.6 17.2 44.8 6.6s17.2-30.6 6.6-44.8l-70.5-95C338.5 132 298.8 112 256.5 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6l46.3-62.4 0 275.3c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-275.3zM7.5 7c-9.4 9.4-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L41.5 7C32.1-2.3 16.9-2.3 7.5 7zm464 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0zM7.5 505c9.4 9.4 24.6 9.4 33.9 0l80-80c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-80 80c-9.4 9.4-9.4 24.6 0 33.9zm464 0c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80z"
    ]
};
var $159afdcd077ecfe9$export$1ff755b523ab2851 = {
    prefix: 'fas',
    iconName: 'manat-sign',
    icon: [
        384,
        512,
        [],
        "e1d5",
        "M192 32c-13.3 0-24 10.7-24 24l0 41.5C73.3 109.3 0 190.1 0 288L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-62.5 44.8-114.5 104-125.8L168 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-293.8c59.2 11.2 104 63.3 104 125.8l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-97.9-73.3-178.7-168-190.5L216 56c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$4941c5969d5399b = {
    prefix: 'fas',
    iconName: 'sort',
    icon: [
        384,
        512,
        [
            "unsorted"
        ],
        "f0dc",
        "M2.4 204.2c5 12 16.6 19.8 29.6 19.8l320 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-9.2 9.2-11.9 22.9-6.9 34.9zm0 103.5c-5 12-2.2 25.7 6.9 34.9l160 160c12.5 12.5 32.8 12.5 45.3 0l160-160c9.2-9.2 11.9-22.9 6.9-34.9S364.9 288 352 288L32 288c-12.9 0-24.6 7.8-29.6 19.8z"
    ]
};
var $159afdcd077ecfe9$export$418597748f0fe52d = $159afdcd077ecfe9$export$4941c5969d5399b;
var $159afdcd077ecfe9$export$55c8e3afd9f6c0b4 = {
    prefix: 'fas',
    iconName: 'circle-radiation',
    icon: [
        512,
        512,
        [
            9762,
            "radiation-alt"
        ],
        "f7ba",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm80 0l64.3 0c8.7 0 15.7-7.1 17.3-15.6 4.4-24.4 18.1-45.5 37.2-59.7 7.4-5.5 10.6-15.6 6-23.6l-32.5-56.3c-4.3-7.5-13.9-10.3-21.2-5.5-48.2 31.5-81.3 84.2-86.3 144.8-.7 8.8 6.5 16 15.3 16zm137.9 89.8c-8.5-3.7-18.8-1.4-23.5 6.6l-31 53.8c-4.3 7.5-1.9 17.2 5.8 21.1 26.1 13.2 55.5 20.7 86.8 20.7s60.7-7.5 86.8-20.7c7.7-3.9 10.1-13.6 5.8-21.1l-31-53.8c-4.6-8-15-10.3-23.5-6.6-11.7 5-24.5 7.8-38.1 7.8s-26.4-2.8-38.1-7.8zM350.4 240.4c1.6 8.6 8.5 15.6 17.3 15.6l64.3 0c8.8 0 16.1-7.2 15.3-16-5-60.6-38.1-113.2-86.3-144.8-7.3-4.8-16.8-2-21.2 5.5L307.3 157c-4.6 8-1.4 18.1 6 23.6 19.1 14.2 32.7 35.4 37.2 59.7zM256 305.7a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $159afdcd077ecfe9$export$2f048fa82bbddf6f = $159afdcd077ecfe9$export$55c8e3afd9f6c0b4;
var $159afdcd077ecfe9$export$94100f4c6ee29932 = {
    prefix: 'fas',
    iconName: 'laptop-code',
    icon: [
        640,
        512,
        [],
        "f5fc",
        "M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 240-64 0 0-240-384 0 0 240-64 0 0-240zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM281 209l-31 31 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM393 175l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$2a9dda2096ce792e = {
    prefix: 'fas',
    iconName: 'sink',
    icon: [
        512,
        512,
        [],
        "e06d",
        "M288 96c0-17.7 14.3-32 32-32s32 14.3 32 32 14.3 32 32 32 32-14.3 32-32c0-53-43-96-96-96s-96 43-96 96l0 192-64 0 0-40c0-30.9-25.1-56-56-56l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c4.4 0 8 3.6 8 8l0 40-80 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l0 64c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-64c17.7 0 32-14.3 32-32s-14.3-32-32-32l-80 0 0-40c0-4.4 3.6-8 8-8l56 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0c-30.9 0-56 25.1-56 56l0 40-64 0 0-192z"
    ]
};
var $159afdcd077ecfe9$export$1a093e7861c5e48f = {
    prefix: 'fas',
    iconName: 'arrow-up-from-water-pump',
    icon: [
        640,
        512,
        [],
        "e4b6",
        "M144 32c-26.5 0-48 21.5-48 48l0 176-16 0c-26.5 0-48 21.5-48 48l0 79.6c17.6-2 36 2.5 51.3 14 3.4 2.6 6.1 1.4 9.8-.3l.8-.4c5.7-2.6 12.9-6.9 21.7-13.5 27.5-20.7 59.9-31.2 92.3-31.4 33.1-.2 66.3 10.2 94.4 31.4 22.1 16.6 29.1 16.6 51.2 0 27.5-20.7 59.9-31.2 92.4-31.4 33.1-.2 66.3 10.2 94.4 31.4 6.9 5.2 12.8 9 18 11.7 .6 .3 1.2 .6 1.8 1 4.2 2.3 8.5 4.6 12.6 1.5 10.7-8.1 22.9-12.7 35.3-14.1l0-79.5c0-26.5-21.5-48-48-48l-56 0 0-142.1 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L497 39c-9.4-9.4-24.6-9.4-33.9 0l-88 88c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 0 142.1-136 0 0-176c0-26.5-21.5-48-48-48L144 32zM474.6 476.1c19 14.4 41.9 28.2 67.2 33.3 26.5 5.4 54.3 .8 80.7-19.1 10.6-8 12.7-23 4.7-33.6s-23-12.7-33.6-4.7c-14.9 11.2-28.6 13.1-42.3 10.3-14.9-3-30.9-11.9-47.8-24.6-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-21.6 16.3-41.3 25.8-58.9 25.7-9.6-.1-19.9-3-31.2-11.5-10.6-8-25.6-5.9-33.6 4.7S7 482.3 17.6 490.3c19.1 14.4 39.4 21 59.8 21.1 33.9 .2 64.3-17.4 88.1-35.3 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9c21.3-16.1 49.9-16.1 71.2 0z"
    ]
};
var $159afdcd077ecfe9$export$4be1b324ac8a71ba = {
    prefix: 'fas',
    iconName: 'microphone-lines-slash',
    icon: [
        576,
        512,
        [
            "microphone-alt-slash"
        ],
        "f539",
        "M7-24.9c9.4-9.4 24.6-9.4 33.9 0l151 151 0-30.2c0-53 43-96 96-96 50.3 0 91.6 38.7 95.7 88L328 88c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 48-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l55.7 0c-1.9 22.9-11.8 43.4-26.9 59l33.9 33.9c25.5-26 41.3-61.6 41.3-100.9l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 52.6-21.1 100.2-55.3 134.8L569 503.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 9.1C-2.3-.3-2.3-15.5 7-24.9zM297.8 367.7l41.4 41.4c-8.8 2.4-17.9 4.3-27.3 5.4l0 49.5 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-49.5C169.3 402.7 96 321.9 96 224l0-40c0-5.1 1.6-9.9 4.4-13.8l43.6 43.6 0 10.2c0 79.5 64.5 144 144 144 3.3 0 6.6-.1 9.8-.3z"
    ]
};
var $159afdcd077ecfe9$export$d2a53a388f30780 = $159afdcd077ecfe9$export$4be1b324ac8a71ba;
var $159afdcd077ecfe9$export$1bf820d499b6202e = {
    prefix: 'fas',
    iconName: 'server',
    icon: [
        448,
        512,
        [],
        "f233",
        "M64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32zm216 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 288zm216 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$f5699fa0844e0188 = {
    prefix: 'fas',
    iconName: 'user',
    icon: [
        448,
        512,
        [
            128100,
            62144,
            62470,
            "user-alt",
            "user-large"
        ],
        "f007",
        "M224 248a120 120 0 1 0 0-240 120 120 0 1 0 0 240zm-29.7 56C95.8 304 16 383.8 16 482.3 16 498.7 29.3 512 45.7 512l356.6 0c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3l-59.4 0z"
    ]
};
var $159afdcd077ecfe9$export$ae9b19c2ac726cfc = $159afdcd077ecfe9$export$f5699fa0844e0188;
var $159afdcd077ecfe9$export$50a28538498238f = $159afdcd077ecfe9$export$f5699fa0844e0188;
var $159afdcd077ecfe9$export$bab8f3647c394f48 = {
    prefix: 'fas',
    iconName: 'snowflake',
    icon: [
        512,
        512,
        [
            10052,
            10054
        ],
        "f2dc",
        "M288.2 0c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 62.1-15-15c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l49 49 0 70.6-61.2-35.3-17.9-66.9c-3.4-12.8-16.6-20.4-29.4-17S95.3 98 98.7 110.8l5.5 20.5-53.7-31C35.2 91.5 15.6 96.7 6.8 112s-3.6 34.9 11.7 43.7l53.7 31-20.5 5.5c-12.8 3.4-20.4 16.6-17 29.4s16.6 20.4 29.4 17l66.9-17.9 61.2 35.3-61.2 35.3-66.9-17.9c-12.8-3.4-26 4.2-29.4 17s4.2 26 17 29.4l20.5 5.5-53.7 31C3.2 365.1-2 384.7 6.8 400s28.4 20.6 43.7 11.7l53.7-31-5.5 20.5c-3.4 12.8 4.2 26 17 29.4s26-4.2 29.4-17l17.9-66.9 61.2-35.3 0 70.6-49 49c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l15-15 0 62.1c0 17.7 14.3 32 32 32s32-14.3 32-32l0-62.1 15 15c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-49-49 0-70.6 61.2 35.3 17.9 66.9c3.4 12.8 16.6 20.4 29.4 17s20.4-16.6 17-29.4l-5.5-20.5 53.7 31c15.3 8.8 34.9 3.6 43.7-11.7s3.6-34.9-11.7-43.7l-53.7-31 20.5-5.5c12.8-3.4 20.4-16.6 17-29.4s-16.6-20.4-29.4-17l-66.9 17.9-61.2-35.3 61.2-35.3 66.9 17.9c12.8 3.4 26-4.2 29.4-17s-4.2-26-17-29.4l-20.5-5.5 53.7-31c15.3-8.8 20.6-28.4 11.7-43.7s-28.4-20.5-43.7-11.7l-53.7 31 5.5-20.5c3.4-12.8-4.2-26-17-29.4s-26 4.2-29.4 17l-17.9 66.9-61.2 35.3 0-70.6 49-49c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-15 15 0-62.1z"
    ]
};
var $159afdcd077ecfe9$export$8717352b90217272 = {
    prefix: 'fas',
    iconName: 'skull-crossbones',
    icon: [
        448,
        512,
        [
            128369,
            9760
        ],
        "f714",
        "M384 144C384 64.5 312.4 0 224 0S64 64.5 64 144c0 47.1 25.1 88.9 64 115.2l0 28.8c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-28.8c38.9-26.3 64-68.1 64-115.2zM160 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM445.5 339.7c-6.8-16.3-25.5-24-41.8-17.2L224 397.3 44.3 322.5c-16.3-6.8-35 .9-41.8 17.2s.9 35 17.2 41.8L140.8 432 19.7 482.5C3.4 489.3-4.3 508 2.5 524.3s25.5 24 41.8 17.2L224 466.7 403.7 541.5c16.3 6.8 35-.9 41.8-17.2s-.9-35-17.2-41.8L307.2 432 428.3 381.5c16.3-6.8 24-25.5 17.2-41.8z"
    ]
};
var $159afdcd077ecfe9$export$c8f99b9b5ea83555 = {
    prefix: 'fas',
    iconName: 'peso-sign',
    icon: [
        448,
        512,
        [],
        "e222",
        "M112 32C94.3 32 80 46.3 80 64l0 64-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 32-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 96 0c65.6 0 122-39.5 146.7-96l37.3 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-24.8 0c.5-5.3 .8-10.6 .8-16s-.3-10.7-.8-16l24.8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-37.3 0C362 71.5 305.6 32 240 32L112 32zm199.6 96l-167.6 0 0-32 96 0c28.4 0 54 12.4 71.6 32zM144 176l190.7 0c.9 5.2 1.3 10.5 1.3 16s-.5 10.8-1.3 16l-190.7 0 0-32zm167.6 80c-17.6 19.6-43.1 32-71.6 32l-96 0 0-32 167.6 0z"
    ]
};
var $159afdcd077ecfe9$export$e06d6607d3577d6e = {
    prefix: 'fas',
    iconName: 'wine-glass',
    icon: [
        320,
        512,
        [
            127863
        ],
        "f4e3",
        "M32.6 25.7C35.6 10.8 48.7 0 64 0L256 0c15.3 0 28.4 10.8 31.4 25.7L316.8 173c2.1 10.5 3.2 21.2 3.2 32l0 3c0 77.4-55 142-128 156.8l0 115.2 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 544c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 0-115.2C55 350 0 285.4 0 208l0-3c0-10.7 1.1-21.4 3.2-32L32.6 25.7zM77.4 128l165.1 0-12.8-64-139.5 0-12.8 64z"
    ]
};
var $159afdcd077ecfe9$export$a3f1d7f13c202adc = {
    prefix: 'fas',
    iconName: 'temperature-half',
    icon: [
        320,
        512,
        [
            127777,
            "temperature-2",
            "thermometer-2",
            "thermometer-half"
        ],
        "f2c9",
        "M160 0C107 0 64 43 64 96l0 164.7C34.5 287 16 325.4 16 368 16 447.5 80.5 512 160 512s144-64.5 144-144c0-42.6-18.5-81-48-107.3L256 96c0-53-43-96-96-96zm64 368c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26.9 16.5-49.9 40-59.3l0-92.7c0-13.3 10.7-24 24-24s24 10.7 24 24l0 92.7c23.5 9.5 40 32.5 40 59.3z"
    ]
};
var $159afdcd077ecfe9$export$8176e649df45b32c = $159afdcd077ecfe9$export$a3f1d7f13c202adc;
var $159afdcd077ecfe9$export$4dd764ac8d512682 = $159afdcd077ecfe9$export$a3f1d7f13c202adc;
var $159afdcd077ecfe9$export$2090f040324b4449 = $159afdcd077ecfe9$export$a3f1d7f13c202adc;
var $159afdcd077ecfe9$export$3604f15924cf0b98 = {
    prefix: 'fas',
    iconName: 'ticket',
    icon: [
        576,
        512,
        [
            127903
        ],
        "f145",
        "M64 64C28.7 64 0 92.7 0 128l0 64C0 200.8 7.4 207.7 15.7 210.6 34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-8.8-7.4-15.7-15.7-18.6-18.8-6.5-32.3-24.4-32.3-45.4s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-64c0-35.3-28.7-64-64-64L64 64zM416 336l0-160-256 0 0 160 256 0zM112 160c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-192z"
    ]
};
var $159afdcd077ecfe9$export$e23367e54f665590 = {
    prefix: 'fas',
    iconName: 'wheat-awn-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e598",
        "M496 576a144 144 0 1 1 0-288 144 144 0 1 1 0 288zM81 529c-9.4 9.3-24.5 9.3-33.9 0-9.4-9.4-9.4-24.6 0-33.9L81 529zm30.2-294.4c6.2-4.1 14.7-3.4 20.1 2.1l46.1 46.1 6.1 6.7c19.7 23.8 26.3 55 19.3 83.9 31.7-7.7 66.2 1 90.6 25.3l12 12c-.8 7-1.2 14.2-1.2 21.4 0 20 3 39.3 8.7 57.4-36.8 21.8-85 17-116.6-14.7L165.6 444.3 81 529C69.7 517.7 58.4 506.3 47 495l84.7-84.7-30.5-30.5c-37.5-37.5-37.5-98.3 0-135.7l7.4-7.4 2.5-2.1zM496 476a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm0-140c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16 8.8 0 16-7.2 16-16l0-80c0-8.8-7.2-16-16-16zM215.2 130.6c6.2-4.1 14.7-3.4 20.1 2.1l46.1 46.1 6.1 6.7c19.7 23.8 26.3 55 19.3 83.9 24.2-5.9 50.1-2.1 71.9 10.8-32.2 24.9-56.2 59.8-67.4 100.1-3.8-2.8-7.5-6-11-9.5l-94.9-94.9c-37.5-37.5-37.5-98.3 0-135.7l7.4-7.4 2.5-2.1zM526.7 15c9.4-9.4 24.6-9.4 33.9 0 8.8 8.8 9.3 22.7 1.7 32.1L560.6 49 446.2 163.4c7.7 1 15.3 3 22.5 5.9L527 111c9.4-9.4 24.6-9.4 34 0 8.8 8.8 9.3 22.7 1.6 32.1l-1.7 1.8-52.7 52.7 39 39c3.2 3.2 4.7 7.4 4.7 11.6-17.7-5.4-36.5-8.3-55.9-8.3-34.2 0-66.3 8.9-94.1 24.6l-92.7-92.7c-37.5-37.5-37.5-98.3 0-135.8l7.4-7.4 2.5-2.1c6.2-4.1 14.7-3.4 20.1 2.1l39 39 52.7-52.7c9.4-9.4 24.6-9.4 34 0 8.8 8.8 9.3 22.7 1.6 32.1L465 49 406.7 107.3c2.8 7.1 4.7 14.5 5.8 22.1L526.7 15z"
    ]
};
var $159afdcd077ecfe9$export$db9f783f15682c4a = {
    prefix: 'fas',
    iconName: 'arrows-turn-right',
    icon: [
        448,
        512,
        [],
        "e4c0",
        "M313.4-6.6c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L338.7 128 128 128c-35.3 0-64 28.7-64 64l0 32c0 17.7-14.3 32-32 32S0 241.7 0 224l0-32C0 121.3 57.3 64 128 64l210.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3zm-96 256c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-80 80c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 384 96 384c-17.7 0-32 14.3-32 32l0 32c0 17.7-14.3 32-32 32S0 465.7 0 448l0-32c0-53 43-96 96-96l146.7 0-25.4-25.4c-12.5-12.5-12.5-32.8 0-45.3z"
    ]
};
var $159afdcd077ecfe9$export$14d66ba7571ae0b9 = {
    prefix: 'fas',
    iconName: 'candy-cane',
    icon: [
        448,
        512,
        [],
        "f786",
        "M421.8 39.6C452 85.2 456.5 142.9 435.1 192l-165.4 0 41.4-41.4c.8-.8 1.5-1.6 2.2-2.4L421.8 39.6zM268 102.9c-.8 .7-1.6 1.4-2.4 2.2l-28.1 28.1c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5L175 14.6C229.9-40.2 314.5-46.7 376.5-5.6L268 102.9zM125.7 336l80-80 181 0-82.5 82.5 0-2.5-178.5 0zm117 64L141.4 501.3c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5l10.7-10.7 181 0z"
    ]
};
var $159afdcd077ecfe9$export$76a9413fbe130a53 = {
    prefix: 'fas',
    iconName: 'wheelchair',
    icon: [
        512,
        512,
        [],
        "f193",
        "M136 40a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM117.9 197.6l12.6 63c-38.6 12.4-66.5 48.7-66.5 91.4 0 53 43 96 96 96 35.6 0 66.7-19.4 83.3-48.2 2.3 .1 4.6 .2 7 .2l4.1 0c1 0 2.1 0 3.1 0l55.2 0c-20.4 64.9-81 112-152.7 112-88.4 0-160-71.6-160-160 0-73.8 50-135.9 117.9-154.4zm148.6-28.1l23.7 118.5 60.5 0c33.3 0 63.2 20.7 74.9 51.9l25.5 68 18.7-6.2c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5l-48 16c-16.3 5.4-34-3-40.1-19.1l-36.3-96.9c-2.3-6.2-8.3-10.4-15-10.4l-86.1 0c-.4 0-.8 0-1.3 0l-13.1 0c-30.5 0-56.8-21.5-62.8-51.4L165.3 189.7c-6.4-31.9 18-61.7 50.6-61.7 24.6 0 45.8 17.4 50.6 41.5z"
    ]
};
var $159afdcd077ecfe9$export$761e747b06ed2e1f = {
    prefix: 'fas',
    iconName: 'spell-check',
    icon: [
        576,
        512,
        [],
        "f891",
        "M120 32c-48.6 0-88 39.4-88 88l0 168c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-168c0-48.6-39.4-88-88-88l-16 0zm40 128l-64 0 0-40c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24l0 40zM304 32c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32l72 0c48.6 0 88-39.4 88-88 0-23.6-9.3-45-24.4-60.8 10.3-14.4 16.4-32.1 16.4-51.2 0-48.6-39.4-88-88-88l-64 0zm64 112l-32 0 0-48 32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24zM336 256l0-48 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0zm233 84c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-105.7 132.1-38.7-38.7c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c6.4 6.4 15.3 9.8 24.4 9.3s17.5-4.9 23.2-12L569 340z"
    ]
};
var $159afdcd077ecfe9$export$d94ba52e980ea0f1 = {
    prefix: 'fas',
    iconName: 'volume-off',
    icon: [
        320,
        512,
        [],
        "f026",
        "M96 352l-48 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l48 0 134.1-119.2c6.4-5.7 14.6-8.8 23.1-8.8 19.2 0 34.8 15.6 34.8 34.8l0 378.4c0 19.2-15.6 34.8-34.8 34.8-8.5 0-16.7-3.1-23.1-8.8L96 352z"
    ]
};
var $159afdcd077ecfe9$export$ba9b387e84727819 = {
    prefix: 'fas',
    iconName: 'lungs',
    icon: [
        576,
        512,
        [
            129729
        ],
        "f604",
        "M320 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 141.9-32 19.2 0-116.7c0-24.5-19.9-44.4-44.4-44.4-12.5 0-24.4 5.3-32.8 14.5l-26.4 29C42.9 160.8 0 271.8 0 387l0 30.5c0 52.2 42.3 94.5 94.5 94.5 22 0 43.7-5.1 63.4-15l5-2.5c37.4-18.7 61-56.9 61-98.8l0-128 64-38.4 64 38.4 0 128c0 41.8 23.6 80.1 61 98.8l5 2.5c19.7 9.8 41.4 15 63.4 15 52.2 0 94.5-42.3 94.5-94.5l0-6.2c0-111.1-36.7-219-104.4-307L428.9 48.7c-8.1-10.6-20.7-16.7-34-16.7-23.7 0-42.9 19.2-42.9 42.9l0 118.2-32-19.2 0-141.9z"
    ]
};
var $159afdcd077ecfe9$export$4ed9da5c3cca0ef1 = {
    prefix: 'fas',
    iconName: 'bookmark',
    icon: [
        384,
        512,
        [
            128278,
            61591
        ],
        "f02e",
        "M64 0C28.7 0 0 28.7 0 64L0 480c0 11.5 6.2 22.2 16.2 27.8s22.3 5.5 32.2-.4L192 421.3 335.5 507.4c9.9 5.9 22.2 6.1 32.2 .4S384 491.5 384 480l0-416c0-35.3-28.7-64-64-64L64 0z"
    ]
};
var $159afdcd077ecfe9$export$3825a842b5afc5aa = {
    prefix: 'fas',
    iconName: 'barcode',
    icon: [
        448,
        512,
        [],
        "f02a",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32L64 64c0-17.7-14.3-32-32-32zm88 0c-13.3 0-24 10.7-24 24l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24zm72 32l0 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32zm208-8l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-96 0l0 400c0 13.3 10.7 24 24 24s24-10.7 24-24l0-400c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $159afdcd077ecfe9$export$3db8f67cd0fc963b = {
    prefix: 'fas',
    iconName: 'list-ol',
    icon: [
        512,
        512,
        [
            "list-1-2",
            "list-numeric"
        ],
        "f0cb",
        "M0 72C0 58.8 10.7 48 24 48l48 0c13.3 0 24 10.7 24 24l0 104 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-80-24 0C10.7 96 0 85.3 0 72zM30.4 301.2C41.8 292.6 55.7 288 70 288l4.9 0c33.7 0 61.1 27.4 61.1 61.1 0 19.6-9.4 37.9-25.2 49.4l-24 17.5 33.2 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-90.7 0C13.1 464 0 450.9 0 434.7 0 425.3 4.5 416.5 12.1 411l70.5-51.3c3.4-2.5 5.4-6.4 5.4-10.6 0-7.2-5.9-13.1-13.1-13.1L70 336c-3.9 0-7.7 1.3-10.8 3.6L38.4 355.2c-10.6 8-25.6 5.8-33.6-4.8S-1 324.8 9.6 316.8l20.8-15.6zM224 64l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$7e3d894cd55296b = $159afdcd077ecfe9$export$3db8f67cd0fc963b;
var $159afdcd077ecfe9$export$cf51408faadac277 = $159afdcd077ecfe9$export$3db8f67cd0fc963b;
var $159afdcd077ecfe9$export$e4686afbe882e24a = {
    prefix: 'fas',
    iconName: 'file-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e5a1",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3l0-38.1c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7l-36.7 36.7 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $159afdcd077ecfe9$export$973ae4f1e4d2ce78 = {
    prefix: 'fas',
    iconName: 'cube',
    icon: [
        512,
        512,
        [],
        "f1b2",
        "M224.3-2.5c19.8-11.4 44.2-11.4 64 0L464.2 99c19.8 11.4 32 32.6 32 55.4l0 203c0 22.9-12.2 44-32 55.4L288.3 514.5c-19.8 11.4-44.2 11.4-64 0L48.5 413c-19.8-11.4-32-32.6-32-55.4l0-203c0-22.9 12.2-44 32-55.4L224.3-2.5zm207.8 360l0-166.1-143.8 83 0 166.1 143.8-83z"
    ]
};
var $159afdcd077ecfe9$export$b88ed5e1e0eac4c6 = {
    prefix: 'fas',
    iconName: 'tape',
    icon: [
        576,
        512,
        [],
        "f4db",
        "M412.8 416c41.5-40.7 67.2-97.3 67.2-160 0-123.7-100.3-224-224-224S32 132.3 32 256 132.3 480 256 480l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-131.2 0zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm48 96a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $159afdcd077ecfe9$export$d59078f6e80b4a67 = {
    prefix: 'fas',
    iconName: 'bomb',
    icon: [
        576,
        512,
        [
            128163
        ],
        "f1e2",
        "M480-16c6.9 0 13 4.4 15.2 10.9l13.5 40.4 40.4 13.5C555.6 51 560 57.1 560 64s-4.4 13-10.9 15.2l-40.4 13.5-13.5 40.4C493 139.6 486.9 144 480 144s-13-4.4-15.2-10.9l-13.5-40.4-40.4-13.5C404.4 77 400 70.9 400 64s4.4-13 10.9-15.2l40.4-13.5 13.5-40.4C467-11.6 473.1-16 480-16zM321.4 97.4c12.5-12.5 32.8-12.5 45.3 0l80 80c12.5 12.5 12.5 32.8 0 45.3l-10.9 10.9c7.9 22 12.2 45.7 12.2 70.5 0 114.9-93.1 208-208 208S32 418.9 32 304 125.1 96 240 96c24.7 0 48.5 4.3 70.5 12.3l10.9-10.9zM144 304c0-53 43-96 96-96 13.3 0 24-10.7 24-24s-10.7-24-24-24c-79.5 0-144 64.5-144 144 0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $159afdcd077ecfe9$export$4d10bcc8d068f454 = {
    prefix: 'fas',
    iconName: 'scale-unbalanced',
    icon: [
        640,
        512,
        [
            "balance-scale-left"
        ],
        "f515",
        "M519.8 62.4c16.8-5.6 25.8-23.7 20.2-40.5S516.3-3.9 499.6 1.6l-113 37.7c-13.9-23.5-39.6-39.3-68.9-39.3-44.2 0-80 35.8-80 80 0 3 .2 5.9 .5 8.8L115.6 129.6c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l135.5-45.2c4.5 3.2 9.3 5.9 14.4 8.2l0 326.7c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-294.7c21-9.2 37.2-27 44.2-49l125.9-42zM437.3 288l72.4-124.2 72.4 124.2-144.9 0zm72.4 96c62.9 0 115.2-34 126-78.9 2.6-11-1-22.3-6.7-32.1L533.8 109.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L390.4 273.1c-5.7 9.8-9.3 21.1-6.7 32.1 10.8 44.8 63.1 78.9 126 78.9zM126.8 291.8l72.4 124.2-144.9 0 72.4-124.2zM.9 433.1C11.7 478 64 512 126.8 512s115.2-34 126-78.9c2.6-11-1-22.3-6.7-32.1L150.9 237.8c-5-8.6-14.2-13.8-24.1-13.8s-19.1 5.3-24.1 13.8L7.6 401.1c-5.7 9.8-9.3 21.1-6.7 32.1z"
    ]
};
var $159afdcd077ecfe9$export$786cb0c775487f19 = $159afdcd077ecfe9$export$4d10bcc8d068f454;
var $159afdcd077ecfe9$export$2c5163541229363 = {
    prefix: 'fas',
    iconName: 'square-caret-left',
    icon: [
        448,
        512,
        [
            "caret-square-left"
        ],
        "f191",
        "M0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96L0 416zM128 256c0-6.7 2.8-13 7.7-17.6l112-104c7-6.5 17.2-8.2 25.9-4.4S288 142.5 288 152l0 208c0 9.5-5.7 18.2-14.4 22s-18.9 2.1-25.9-4.4l-112-104c-4.9-4.5-7.7-10.9-7.7-17.6z"
    ]
};
var $159afdcd077ecfe9$export$d0c8ba444f1f9581 = $159afdcd077ecfe9$export$2c5163541229363;
var $159afdcd077ecfe9$export$8e90575265a56cfc = {
    prefix: 'fas',
    iconName: 'ruler',
    icon: [
        576,
        512,
        [
            128207
        ],
        "f545",
        "M209.1 516.2c-18.7 18.7-49.1 18.7-67.9 0L28.1 403.1c-18.7-18.7-18.7-49.1 0-67.9l17-17 73.5 73.5c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-73.5-73.5 33.9-33.9 50.9 50.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-50.9-50.9 33.9-33.9 73.5 73.5c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-73.5-73.5 33.9-33.9 50.9 50.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-50.9-50.9 33.9-33.9 73.5 73.5c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-73.5-73.5 17-17c18.7-18.7 49.1-18.7 67.9 0L548.5 108.9c18.7 18.7 18.7 49.1 0 67.9L209.1 516.2z"
    ]
};
var $159afdcd077ecfe9$export$aee03ca0815b7c38 = {
    prefix: 'fas',
    iconName: 'i',
    icon: [
        320,
        512,
        [
            105
        ],
        "49",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l96 0 0 320-96 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0 0-320 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32z"
    ]
};
var $159afdcd077ecfe9$export$28cc565c11db6f2e = {
    prefix: 'fas',
    iconName: 'volume-xmark',
    icon: [
        576,
        512,
        [
            "volume-mute",
            "volume-times"
        ],
        "f6a9",
        "M48 352l48 0 134.1 119.2c6.4 5.7 14.6 8.8 23.1 8.8 19.2 0 34.8-15.6 34.8-34.8l0-378.4c0-19.2-15.6-34.8-34.8-34.8-8.5 0-16.7 3.1-23.1 8.8L96 160 48 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48zM367 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$aa8decd057dfd29b = $159afdcd077ecfe9$export$28cc565c11db6f2e;
var $159afdcd077ecfe9$export$a1c7b36ba71dbeca = $159afdcd077ecfe9$export$28cc565c11db6f2e;
var $159afdcd077ecfe9$export$d56753dd2eb5c323 = {
    prefix: 'fas',
    iconName: 'archway',
    icon: [
        512,
        512,
        [],
        "f557",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l448 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32zm0 384c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0 0-128c0-53 43-96 96-96s96 43 96 96l0 128 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-272-448 0 0 272z"
    ]
};
var $159afdcd077ecfe9$export$f4d483fca19a4604 = {
    prefix: 'fas',
    iconName: 'person-digging',
    icon: [
        576,
        512,
        [
            "digging"
        ],
        "f85e",
        "M208 40a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM10.5 181.3c5.9-11.9 20.3-16.7 32.2-10.7l24.6 12.3 12.2-20.4c18.9-31.5 53.2-50.5 89.6-50.5 46.2 0 87.7 30.5 100.5 75.4l32.2 112.7 92.9 46.4 25.8-43c5.8-9.6 16.2-15.5 27.4-15.5s21.7 5.9 27.4 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2S555.5 512 544 512l-192 0c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2L370 387.8 21.3 213.5c-11.9-5.9-16.7-20.3-10.7-32.2zM94.3 307.4l112 56c10.8 5.4 17.7 16.5 17.7 28.6l0 88c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-68.2-61.3-30.7-36.3 109c-5.6 16.8-23.7 25.8-40.5 20.2S-3.9 486.6 1.7 469.9l48-144c2.9-8.8 9.5-15.9 18.1-19.4s18.3-3.2 26.6 .9z"
    ]
};
var $159afdcd077ecfe9$export$7bd93e3343bd5671 = $159afdcd077ecfe9$export$f4d483fca19a4604;
var $159afdcd077ecfe9$export$d262c1f5912046e6 = {
    prefix: 'fas',
    iconName: 'gauge-high',
    icon: [
        512,
        512,
        [
            62461,
            "tachometer-alt",
            "tachometer-alt-fast"
        ],
        "f625",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64 0-16.2-6-31.1-16-42.3l69.5-138.9c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L261.1 288.2c-1.7-.1-3.4-.2-5.1-.2-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $159afdcd077ecfe9$export$38dd17b9f064c10f = $159afdcd077ecfe9$export$d262c1f5912046e6;
var $159afdcd077ecfe9$export$e99d8b85f35b8ca5 = $159afdcd077ecfe9$export$d262c1f5912046e6;
var $159afdcd077ecfe9$export$c093cc22e88981c2 = {
    prefix: 'fas',
    iconName: 'genderless',
    icon: [
        384,
        512,
        [],
        "f22d",
        "M192 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 320a192 192 0 1 0 0-384 192 192 0 1 0 0 384z"
    ]
};
var $159afdcd077ecfe9$export$dcaadfd9c98e42a1 = {
    prefix: 'fas',
    iconName: 'cloud-sun',
    icon: [
        576,
        512,
        [
            9925
        ],
        "f6c4",
        "M453.6-14.8c4.9 2 8.5 6.4 9.5 11.6L480 80 563.2 96.8c5.2 1.1 9.5 4.6 11.6 9.5s1.5 10.5-1.4 14.9l-46.9 70.7 46.9 70.7c2.9 4.4 3.5 10 1.4 14.9s-6.4 8.5-11.6 9.5L501 299.7c-11.9-8.7-25.1-15.6-39.4-20.4-2.5-12.7-6.8-24.7-12.7-35.7 9.5-14.9 15.1-32.6 15.1-51.7 0-53-43-96-96-96-47.9 0-87.6 35.1-94.8 80.9-26.5-20.3-59.5-32.5-95.4-32.9l-15.1-22.7c-2.9-4.4-3.5-10-1.4-14.9s6.4-8.5 11.6-9.5L256 80 272.8-3.2c1.1-5.2 4.6-9.5 9.5-11.6s10.5-1.5 14.9 1.4L368 33.6 438.7-13.3c4.4-2.9 10-3.5 14.9-1.4zM416 192c0 3.8-.4 7.5-1.3 11.1-21.7-17-49-27.1-78.7-27.1-4.6 0-9.1 .2-13.5 .7 6.4-19 24.4-32.7 45.5-32.7 26.5 0 48 21.5 48 48zM96 512c-53 0-96-43-96-96 0-42.5 27.6-78.6 65.9-91.2-1.3-6.7-1.9-13.7-1.9-20.8 0-61.9 50.1-112 112-112 43.1 0 80.5 24.3 99.2 60 14.7-17.1 36.5-28 60.8-28 44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16 .5 0 1.1 0 1.6 0 53 0 96 43 96 96s-43 96-96 96L96 512z"
    ]
};
var $159afdcd077ecfe9$export$b4da69a0247f3620 = {
    prefix: 'fas',
    iconName: 'arrow-right',
    icon: [
        512,
        512,
        [
            8594
        ],
        "f061",
        "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
    ]
};
var $159afdcd077ecfe9$export$b4c63e9bfc7906f1 = {
    prefix: 'fas',
    iconName: 'handshake',
    icon: [
        576,
        512,
        [
            129309,
            62662,
            "handshake-alt",
            "handshake-simple"
        ],
        "f2b5",
        "M268.9 85.2L152.3 214.8c-4.6 5.1-4.4 13 .5 17.9 30.5 30.5 80 30.5 110.5 0l31.8-31.8c4.2-4.2 9.5-6.5 14.9-6.9 6.8-.6 13.8 1.7 19 6.9L505.6 376 576 320 576 32 464 96 440.2 80.1C424.4 69.6 405.9 64 386.9 64l-70.4 0c-1.1 0-2.3 0-3.4 .1-16.9 .9-32.8 8.5-44.2 21.1zM116.6 182.7L223.4 64 183.8 64c-25.5 0-49.9 10.1-67.9 28.1L112 96 0 32 0 320 156.4 450.3c23 19.2 52 29.7 81.9 29.7l15.7 0-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l41 41 9 0c19.1 0 37.8-4.3 54.8-12.3L359 441c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l32 32 17.5-17.5c8.9-8.9 11.5-21.8 7.6-33.1l-137.9-136.8-14.9 14.9c-49.3 49.3-129.1 49.3-178.4 0-23-23-23.9-59.9-2.2-84z"
    ]
};
var $159afdcd077ecfe9$export$e9aa3c6f9f47aa1a = $159afdcd077ecfe9$export$b4c63e9bfc7906f1;
var $159afdcd077ecfe9$export$e8485db4dab0ab30 = $159afdcd077ecfe9$export$b4c63e9bfc7906f1;
var $159afdcd077ecfe9$export$5ebd3cd0630e3ae7 = {
    prefix: 'fas',
    iconName: 'person-skiing',
    icon: [
        576,
        512,
        [
            9975,
            "skiing"
        ],
        "f7c9",
        "M416 56a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM2.7 300.9c6.1-11.8 20.6-16.3 32.4-10.2l197.8 102.7 62.3-87.2-82-92.2c-11-12.4-16.2-27.5-16.2-42.4l111.6 53.4 42.9 48.2c14.9 16.7 16.2 41.6 3.2 59.8l-64.4 90.2 128.3 66.6c13.6 7.1 29.8 7.2 43.6 .3l15.2-7.6c11.9-5.9 26.3-1.1 32.2 10.7s1.1 26.3-10.7 32.2l-15.2 7.6c-27.5 13.7-59.9 13.5-87.2-.7L12.9 333.3C1.2 327.2-3.4 312.7 2.7 300.9zM103 49.6l18 8.7 8.7-17.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-8.5 17 84.8 41 .4-.2 76.1-33.8c31.3-13.9 67.9-.7 83.2 29.9l28.9 57.8 68.7 27.5c16.4 6.6 24.4 25.2 17.8 41.6s-25.2 24.4-41.6 17.8L393.8 224c-10.9-4.4-19.8-12.6-25.1-23.1l-11.5-23.1c-16.4 9.4-25.9 14.8-28.5 16.3l-7.6-3.7-185.6-89.6-9.2 18.3c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-17.9-17.6-8.5C81.1 74.6 77.8 65 81.6 57S95 45.7 103 49.6z"
    ]
};
var $159afdcd077ecfe9$export$eae1acab6fb96708 = $159afdcd077ecfe9$export$5ebd3cd0630e3ae7;
var $159afdcd077ecfe9$export$154e99cb34841765 = {
    prefix: 'fas',
    iconName: 'bridge-water',
    icon: [
        640,
        512,
        [],
        "e4ce",
        "M64 64l512 0 0 112c-37.6 9.4-64 43.2-64 82l0 76.4c-21-9.7-43.5-14.5-66-14.4-10 .1-20.1 1.1-30 3.1l0-35.1c0-53-43-96-96-96s-96 43-96 96l0 32.7c-5.3-.5-10.7-.8-16-.7-27.7 .2-55.4 7.8-80 23l0-85c0-38.8-26.4-72.6-64-82L64 64zM403.4 444.1C379.1 462.3 351.1 480 320 480s-59.1-17.7-83.4-35.9c-21.3-16.1-49.9-16.1-71.2 0-23.8 17.9-54.1 35.5-88.1 35.3-20.4-.1-40.7-6.7-59.8-21.1-10.6-8-12.7-23-4.7-33.6s23-12.7 33.6-4.7c11.3 8.5 21.6 11.4 31.2 11.5 17.6 .1 37.3-9.4 58.9-25.7 38.4-29 90.5-29 129 0 24 18.1 40.7 26.3 54.5 26.3s30.5-8.2 54.5-26.3c38.4-29 90.5-29 129 0 16.9 12.7 32.9 21.5 47.8 24.6 13.7 2.8 27.4 .9 42.3-10.3 10.6-8 25.6-5.9 33.6 4.7s5.9 25.6-4.7 33.6c-26.4 19.9-54.2 24.4-80.7 19.1-25.3-5.1-48.1-18.9-67.2-33.3-21.3-16.1-49.9-16.1-71.2 0z"
    ]
};
var $159afdcd077ecfe9$export$374e1dce366a2175 = {
    prefix: 'fas',
    iconName: 'building-ngo',
    icon: [
        576,
        512,
        [],
        "e4d7",
        "M128 0C92.7 0 64 28.7 64 64l0 384c0 35.3 28.7 64 64 64l48 0 0-112c0-35.3 28.7-64 64-64l208 0 0-272c0-35.3-28.7-64-64-64L128 0zm32 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM304 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm144-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM520 380c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-80c0-24.3-19.7-44-44-44l-16 0zm-4 44c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 80c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80zm-168 0l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-24c0-11-9-20-20-20l-8 0c-11 0-20 9-20 20 0 6.5 3.1 12.4 8 16l0 8c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l20.4 0c1.9 9.1 9.9 16 19.6 16 11 0 20-9 20-20 0-19.9-16.1-36-36-36l-24 0c-24.3 0-44 19.7-44 44zm-90.1-32.9c-4.1-8.3-13.5-12.7-22.5-10.5S220 390.7 220 400l0 128c0 11 9 20 20 20s20-9 20-20l0-43.3 26.1 52.2c4.1 8.3 13.5 12.7 22.5 10.5S324 537.3 324 528l0-128c0-11-9-20-20-20s-20 9-20 20l0 43.3-26.1-52.2z"
    ]
};
var $159afdcd077ecfe9$export$4a284575edd6f1af = {
    prefix: 'fas',
    iconName: 'igloo',
    icon: [
        576,
        512,
        [],
        "f7ae",
        "M320 33.8l0 126.2-271.5 0c51.7-77.2 139.6-128 239.5-128 10.8 0 21.5 .6 32 1.8zM368 160l0-116.7c66 19 122.2 61 159.5 116.7L368 160zM22.6 208l73.4 0 0 112-96 0c0-39.7 8-77.6 22.6-112zM176 320l-32 0 0-112 288 0 0 112-32 0 0 48 176 0 0 64c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-64 176 0 0-48zm304 0l0-112 73.4 0C568 242.4 576 280.3 576 320l-96 0zM288 288c-35.3 0-64 28.7-64 64l0 80 128 0 0-80c0-35.3-28.7-64-64-64z"
    ]
};
var $159afdcd077ecfe9$export$5f92ac3e804644e3 = {
    prefix: 'fas',
    iconName: 'circle-dollar-to-slot',
    icon: [
        576,
        512,
        [
            "donate"
        ],
        "f4b9",
        "M96 224a192 192 0 1 1 384 0 192 192 0 1 1 -384 0zm176-92l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L248 272c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20s-20 9-20 20zM48 344l0 104c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 344c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$40050ae52860cde7 = $159afdcd077ecfe9$export$5f92ac3e804644e3;
var $159afdcd077ecfe9$export$b8c4c058fe7d193c = {
    prefix: 'fas',
    iconName: 'y',
    icon: [
        384,
        512,
        [
            121
        ],
        "59",
        "M58 45.4C47.8 31 27.8 27.7 13.4 38S-4.3 68.2 6 82.6L160 298.3 160 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-149.7 154-215.7c10.3-14.4 6.9-34.4-7.4-44.6S336.2 31 326 45.4L192 232.9 58 45.4z"
    ]
};
var $159afdcd077ecfe9$export$6143da800b0e6626 = {
    prefix: 'fas',
    iconName: 'face-smile-wink',
    icon: [
        512,
        512,
        [
            128521,
            "smile-wink"
        ],
        "f4da",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM165.4 321.9c20.4 28 53.4 46.1 90.6 46.1s70.2-18.1 90.6-46.1c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5C356.3 390 309.2 416 256 416s-100.3-26-129.4-65.9c-7.8-10.7-5.4-25.7 5.3-33.5s25.7-5.4 33.5 5.3zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm164 8c0 11-9 20-20 20s-20-9-20-20c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60 0 11-9 20-20 20s-20-9-20-20-9-20-20-20l-16 0c-11 0-20 9-20 20z"
    ]
};
var $159afdcd077ecfe9$export$f5dbb37f6801ee3f = $159afdcd077ecfe9$export$6143da800b0e6626;
var $159afdcd077ecfe9$export$2df6451abf70a6ff = {
    prefix: 'fas',
    iconName: 'dice-four',
    icon: [
        448,
        512,
        [
            9859
        ],
        "f524",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm160 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM352 160a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM320 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$8ff56f5ebb8416a0 = {
    prefix: 'fas',
    iconName: 'face-grin-squint-tears',
    icon: [
        576,
        512,
        [
            129315,
            "grin-squint-tears"
        ],
        "f586",
        "M560 35.4c0 25.6-18.8 47.3-44.1 50.9L469.1 93c-10.6 1.5-19.6-7.5-18.1-18.1l6.7-46.7C461.3 2.8 483-16 508.6-16 537-16 560 7 560 35.4zM403.5 68.1c-6 42.2 30.2 78.4 72.4 72.4l37.8-5.4C565.7 232 550.8 355.3 469 437s-205 96.6-301.9 44.7l5.4-37.8c6-42.2-30.2-78.4-72.4-72.4l-37.8 5.4C10.3 280 25.2 156.7 107 75S312-21.7 408.9 30.3l-5.4 37.8zM417.8 201c-19.1 36.4-45.6 72.7-78.9 106s-69.6 59.8-106 78.9c-11.1 5.8-12.4 21.4-1.1 26.6 59.2 27.5 131.8 16.8 180.6-32s59.5-121.4 32-180.6c-5.3-11.3-20.8-10-26.6 1.1zM113.9 270.6c1.7 8 9 13.4 17.1 12.7l43.1-3.9-3.9 43.1c-.7 8.1 4.7 15.5 12.7 17.1s15.9-2.9 18.4-10.6l28-84.6c1.9-5.7 .4-12.1-3.9-16.3s-10.6-5.8-16.3-3.9l-84.6 28c-7.7 2.6-12.3 10.5-10.6 18.5zM315.2 99.1c.7-8.1-4.7-15.5-12.7-17.1s-15.9 2.9-18.5 10.6l-28 84.6c-1.9 5.7-.4 12.1 3.9 16.3s10.6 5.8 16.3 3.9l84.6-28c7.7-2.6 12.3-10.5 10.6-18.4s-9-13.4-17.1-12.7l-43.1 3.9 3.9-43.1zM60.1 425.7l46.7-6.7c10.6-1.5 19.6 7.5 18.1 18.1l-6.7 46.7C114.7 509.2 93 528 67.4 528 39 528 16 505 16 476.6 16 451 34.8 429.3 60.1 425.7z"
    ]
};
var $159afdcd077ecfe9$export$542206d6a85f3b42 = $159afdcd077ecfe9$export$8ff56f5ebb8416a0;
var $159afdcd077ecfe9$export$b8d24c57c9e64933 = {
    prefix: 'fas',
    iconName: 'file-audio',
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zm53.8 185.2c-9.1-6.3-21.5-4.1-27.8 5s-4.1 21.5 5 27.8c23.9 16.7 39.4 44.3 39.4 75.5s-15.6 58.9-39.4 75.5c-9.1 6.3-11.3 18.8-5 27.8s18.8 11.3 27.8 5c34.1-23.8 56.6-63.5 56.6-108.3S296 267.5 261.8 243.7zM80 312c-8.8 0-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16l24 0 27.2 34c3 3.8 7.6 6 12.5 6l.3 0c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16l-.3 0c-4.9 0-9.5 2.2-12.5 6l-27.2 34-24 0zm128 72.2c0 10.7 10.5 18.2 18.9 11.6 12.9-10.3 21.1-26.1 21.1-43.8s-8.2-33.5-21.1-43.8c-8.4-6.7-18.9 .9-18.9 11.6l0 64.5z"
    ]
};
var $159afdcd077ecfe9$export$8f2463c7b2fc6ae4 = {
    prefix: 'fas',
    iconName: 'arrows-down-to-line',
    icon: [
        512,
        512,
        [],
        "e4b8",
        "M214.6 310.6l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 274.7 96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 242.7 9.4-9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm256 0l-64 64c-12.5 12.5-32.8 12.5-45.3 0l-64-64c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4 0-242.7c0-17.7 14.3-32 32-32s32 14.3 32 32l0 242.7 9.4-9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512z"
    ]
};
var $159afdcd077ecfe9$export$9f5c2b0db8eedeac = {
    prefix: 'fas',
    iconName: 'g',
    icon: [
        448,
        512,
        [
            103
        ],
        "47",
        "M224 96C135.6 96 64 167.6 64 256s71.6 160 160 160c77.4 0 142-55 156.8-128L256 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l144 0c25.8 0 49.6 21.4 47.2 50.6-9.5 115-105.8 205.4-223.2 205.4-123.7 0-224-100.3-224-224S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57 13.2 11.8 14.3 32 2.5 45.2s-32 14.3-45.2 2.5C302.3 111.4 265 96 224 96z"
    ]
};
var $159afdcd077ecfe9$export$ee4b92e89fe0dfaf = {
    prefix: 'fas',
    iconName: 'vihara',
    icon: [
        576,
        512,
        [],
        "f6a7",
        "M273.6-3.2c8.5-6.4 20.3-6.4 28.8 0L443.2 102.4c8.3 6.2 18.4 9.6 28.8 9.6 13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 48 58.7 64 13.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 48 24.4 32 15.6 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-128 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-128 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-40 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l22.1 0 17.9-32 0-48-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l13.3 0 58.7-64 0-48-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24c10.4 0 20.5-3.4 28.8-9.6L273.6-3.2zM128 368l320 0 0-48-320 0 0 48zM384 160l-192 0 0 48 192 0 0-48z"
    ]
};
var $159afdcd077ecfe9$export$92fad97e19a9fea = {
    prefix: 'fas',
    iconName: 'flag-checkered',
    icon: [
        448,
        512,
        [
            127937
        ],
        "f11e",
        "M32 0C49.7 0 64 14.3 64 32l0 16 69-17.2c38.1-9.5 78.3-5.1 113.5 12.5 46.3 23.2 100.8 23.2 147.1 0l9.6-4.8C423.8 28.1 448 43.1 448 66.1l0 279.7c0 13.3-8.3 25.3-20.8 30l-34.7 13c-46.2 17.3-97.6 14.6-141.7-7.4-37.9-19-81.4-23.7-122.5-13.4L64 384 64 480c0 17.7-14.3 32-32 32S0 497.7 0 480L0 32C0 14.3 14.3 0 32 0zM64 187.1l64-13.9 0 65.5-64 13.9 0 65.5 48.8-12.2c5.1-1.3 10.1-2.4 15.2-3.3l0-63.9 38.9-8.4c8.3-1.8 16.7-2.5 25.1-2.1l0-64c13.6 .4 27.2 2.6 40.4 6.4l23.6 6.9 0 66.7-41.7-12.3c-7.3-2.1-14.8-3.4-22.3-3.8l0 71.4c21.8 1.9 43.3 6.7 64 14.4l0-69.8 22.7 6.7c13.5 4 27.3 6.4 41.3 7.4l0-64.2c-7.8-.8-15.6-2.3-23.2-4.5l-40.8-12 0-62c-13-3.8-25.8-8.8-38.2-15-8.2-4.1-16.9-7-25.8-8.8l0 72.4c-13-.4-26 .8-38.7 3.6l-25.3 5.5 0-75.2-64 16 0 73.1zM320 335.7c16.8 1.5 33.9-.7 50-6.8l14-5.2 0-71.7-7.9 1.8c-18.4 4.3-37.3 5.7-56.1 4.5l0 77.4zm64-149.4l0-70.8c-20.9 6.1-42.4 9.1-64 9.1l0 69.4c13.9 1.4 28 .5 41.7-2.6l22.3-5.2z"
    ]
};
var $159afdcd077ecfe9$export$f3a0a4e6723a86d4 = {
    prefix: 'fas',
    iconName: 'gauge-simple',
    icon: [
        512,
        512,
        [
            "gauge-simple-med",
            "tachometer-average"
        ],
        "f629",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-26.9-16.5-49.9-40-59.3L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 172.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $159afdcd077ecfe9$export$ba8c12ff7cfa2521 = $159afdcd077ecfe9$export$f3a0a4e6723a86d4;
var $159afdcd077ecfe9$export$94fcfd6f6335431b = $159afdcd077ecfe9$export$f3a0a4e6723a86d4;
var $159afdcd077ecfe9$export$a082af56be9786ae = {
    prefix: 'fas',
    iconName: 'right-left',
    icon: [
        512,
        512,
        [
            "exchange-alt"
        ],
        "f362",
        "M502.6 150.6l-96 96c-9.2 9.2-22.9 11.9-34.9 6.9S352 236.9 352 224l0-64-320 0c-17.7 0-32-14.3-32-32S14.3 96 32 96l320 0 0-64c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l96 96c12.5 12.5 12.5 32.8 0 45.3zm-397.3 352l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c9.2-9.2 22.9-11.9 34.9-6.9S160 275.1 160 288l0 64 320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-320 0 0 64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9z"
    ]
};
var $159afdcd077ecfe9$export$f6c6fb20d374b128 = $159afdcd077ecfe9$export$a082af56be9786ae;
var $159afdcd077ecfe9$export$6380e2ed6e69d350 = {
    prefix: 'fas',
    iconName: 'pills',
    icon: [
        512,
        512,
        [],
        "f484",
        "M64 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zM176 368c0-48.7 18.1-93.2 48-127l0-129C224 50.1 173.9 0 112 0S0 50.1 0 112L0 400c0 61.9 50.1 112 112 112 37.3 0 70.3-18.2 90.7-46.3-17-28.6-26.7-62-26.7-97.7zm64.7 67.4c4.6 8.7 16.3 9.7 23.3 2.7L438.1 264c7-7 6-18.7-2.7-23.3-20.1-10.7-43-16.7-67.4-16.7-79.5 0-144 64.5-144 144 0 24.3 6 47.3 16.7 67.4zM297.9 472c-7 7-6 18.7 2.7 23.3 20.1 10.7 43 16.7 67.4 16.7 79.5 0 144-64.5 144-144 0-24.3-6-47.3-16.7-67.4-4.6-8.7-16.3-9.7-23.3-2.7L297.9 472z"
    ]
};
var $159afdcd077ecfe9$export$36b5fbeae4855055 = {
    prefix: 'fas',
    iconName: 'explosion',
    icon: [
        512,
        512,
        [],
        "e4e9",
        "M256-32c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24zm0 160c12.4 0 22.7 9.4 23.9 21.7L293.4 291.6 467.6 11.3c6.7-10.7 20.5-14.5 31.7-8.5s15.8 19.5 10.6 31L372.8 338.6c2.2 2.3 4.3 4.7 6.3 7.1l97.2-54.7c10.5-5.9 23.6-3.1 30.9 6.4s6.3 23-2.2 31.5l-87 87-71.4 0c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64l-79.6 0-75.5-52.3C.6 357-2.8 344.1 2.4 333.5s17.4-15.9 28.7-12.4l97.2 30.4c3-3.9 6.1-7.6 9.4-11.3L75.4 236.3c-6.1-10.1-3.9-23.1 5.1-30.7s22.2-7.5 31.1 .1L214 293.6c1.5-.4 3-.8 4.5-1.1l13.6-142.7c1.2-12.3 11.5-21.7 23.9-21.7zM32 464l456 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0z"
    ]
};
var $159afdcd077ecfe9$export$cfb044c7d35060bb = {
    prefix: 'fas',
    iconName: 'arrows-down-to-people',
    icon: [
        512,
        512,
        [],
        "e4b9",
        "M113 153c-9.4 9.4-24.6 9.4-33.9 0L15 89C5.7 79.6 5.7 64.4 15 55S39.6 45.7 49 55L72 78.1 72-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 86.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64zm320 0c-9.4 9.4-24.6 9.4-33.9 0L335 89c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23 0-86.1c0-13.3 10.7-24 24-24s24 10.7 24 24l0 86.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64zM256 192a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c53 0 96 43 96 96l0 32c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32l0-32c0-53 43-96 96-96zM32 288a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm352 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM80 368c15.3 0 29.6 4.3 41.8 11.8-6.3 16.2-9.8 33.8-9.8 52.2l0 48c0 11.4 2.4 22.2 6.7 32l-87.8 0C13.8 512 0 498.2 0 481.1L0 448c0-44.2 35.8-80 80-80zM393.3 512c4.3-9.8 6.7-20.6 6.7-32l0-48c0-18.4-3.5-36-9.8-52.2 12.2-7.5 26.5-11.8 41.8-11.8 44.2 0 80 35.8 80 80l0 33.1c0 17-13.8 30.9-30.9 30.9l-87.8 0z"
    ]
};
var $159afdcd077ecfe9$export$72b785dcfe44c69b = {
    prefix: 'fas',
    iconName: 'users-viewfinder',
    icon: [
        576,
        512,
        [],
        "e595",
        "M64 0C28.7 0 0 28.7 0 64l0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72c0-8.8 7.2-16 16-16l72 0c13.3 0 24-10.7 24-24S149.3 0 136 0L64 0zM440 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0c8.8 0 16 7.2 16 16l0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72c0-35.3-28.7-64-64-64L440 0zM48 376c0-13.3-10.7-24-24-24S0 362.7 0 376l0 72c0 35.3 28.7 64 64 64l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0c-8.8 0-16-7.2-16-16l0-72zm528 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72c0 8.8-7.2 16-16 16l-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l72 0c35.3 0 64-28.7 64-64l0-72zM288 216a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 40c-53 0-96 43-96 96l0 24c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24l0-24c0-53-43-96-96-96zm192-64a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM168 272.3c-49.3 4.1-88 45.3-88 95.7l0 10.7c0 11.8 9.6 21.3 21.3 21.3l46.8 0c-2.7-7.5-4.1-15.6-4.1-24l0-24c0-29.5 8.8-56.9 24-79.7zM427.9 400l46.8 0c11.8 0 21.3-9.6 21.3-21.3l0-10.7c0-50.3-38.7-91.6-88-95.7 15.2 22.8 24 50.2 24 79.7l0 24c0 8.4-1.4 16.5-4.1 24zM192 192a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $159afdcd077ecfe9$export$d901d50df5cf8d91 = {
    prefix: 'fas',
    iconName: 'car-on',
    icon: [
        448,
        512,
        [],
        "e4dd",
        "M248-8c0-13.3-10.7-24-24-24S200-21.3 200-8l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64zM145.3 208l157.5 0c6.7 0 12.6 4.1 15 10.4l26.1 69.6-239.6 0 26.1-69.6c2.3-6.2 8.3-10.4 15-10.4zM34 292.8l-1.3 3.4C13.2 307.1 0 328 0 352L0 480c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 288 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-128c0-24-13.2-44.9-32.8-55.9l-1.3-3.4-36.3-96.9c-11.7-31.2-41.6-51.9-74.9-51.9l-157.5 0c-33.3 0-63.2 20.7-74.9 51.9L34 292.8zM96 336a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm224 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM7 7C-2.3 16.4-2.3 31.6 7 41L55 89c9.4 9.4 24.6 9.4 33.9 0S98.3 64.4 89 55L41 7C31.6-2.3 16.4-2.3 7 7zM407 7L359 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9S416.4-2.3 407 7z"
    ]
};
var $159afdcd077ecfe9$export$26a8fd1143d2d6c0 = {
    prefix: 'fas',
    iconName: 'sleigh',
    icon: [
        640,
        512,
        [],
        "f7cc",
        "M64 32C46.3 32 32 46.3 32 64S46.3 96 64 96l0 160c0 41.8 26.7 77.4 64 90.5l0 69.5-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l504 0c44.2 0 80-35.8 80-80l0-8c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8c0 17.7-14.3 32-32 32l-80 0 0-64c53 0 96-43 96-96l0-96c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-17.7 0-32 14.3-32 32l0 32c0 35.3-28.7 64-64 64l-48.9 0c-48.5 0-92.8-27.4-114.5-70.8l-25.2-50.5C237.7 59.4 193.4 32 144.9 32L64 32zM432 416l-256 0 0-64 256 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$56700074cf37be5c = {
    prefix: 'fas',
    iconName: 'dumbbell',
    icon: [
        640,
        512,
        [],
        "f44b",
        "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112 256 0 0-112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 16 16 0c26.5 0 48 21.5 48 48l0 48c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 48c0 26.5-21.5 48-48 48l-16 0 0 16c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-112-256 0 0 112c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-16-16 0c-26.5 0-48-21.5-48-48l0-48c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-48c0-26.5 21.5-48 48-48l16 0 0-16z"
    ]
};
var $159afdcd077ecfe9$export$3b3ab4d86bad7d26 = {
    prefix: 'fas',
    iconName: 'baby-carriage',
    icon: [
        512,
        512,
        [
            "carriage-baby"
        ],
        "f77d",
        "M64 208l0 80c0 53 43 96 96 96l192 0c53 0 96-43 96-96l0-112 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-64 0c-13.3 0-24 10.7-24 24l0 56-336 0zm.2-48l223.8 0 0-128c0-17.7-14.3-32-32-32L232 0C141.9 0 68.4 70.9 64.2 160zM160 464a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm288 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $159afdcd077ecfe9$export$9f117d92ccd36cf1 = $159afdcd077ecfe9$export$3b3ab4d86bad7d26;
var $159afdcd077ecfe9$export$d9933d91e1314d02 = {
    prefix: 'fas',
    iconName: 'kiwi-bird',
    icon: [
        576,
        512,
        [],
        "f535",
        "M291.2 388.4c31.2-18.8 64.7-36.4 101.1-36.4l55.7 0c4.6 0 9.1-.2 13.6-.7l85.3 121.9c4 5.7 11.3 8.2 17.9 6.1S576 471 576 464l0-240c0-70.7-57.3-128-128-128l-55.7 0C355.9 96 322.4 78.4 291.2 59.6 262.3 42.1 228.3 32 192 32 86 32 0 118 0 224 0 295.1 38.6 357.1 96 390.3L96 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-46c15.3 3.9 31.4 6 48 6 5.4 0 10.7-.2 16-.7l0 40.7c0 13.3 10.7 24 24 24s24-10.7 24-24l0-50.9c12.4-4.4 24.2-10 35.2-16.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$3c70ffe5660af060 = {
    prefix: 'fas',
    iconName: 'calendar-xmark',
    icon: [
        448,
        512,
        [
            "calendar-times"
        ],
        "f273",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zM291.9 220.1c-9.4-9.4-24.6-9.4-33.9 0l-33.9 33.9-33.9-33.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33.9 33.9-33.9 33.9c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l33.9-33.9 33.9 33.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-33.9-33.9 33.9-33.9c9.4-9.4 9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$99b20d7352fbcf08 = $159afdcd077ecfe9$export$3c70ffe5660af060;
var $159afdcd077ecfe9$export$531badb89cf01312 = {
    prefix: 'fas',
    iconName: 'circle-down',
    icon: [
        512,
        512,
        [
            61466,
            "arrow-alt-circle-down"
        ],
        "f358",
        "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM244.7 387.3l-104-104c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l56 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 56 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-104 104c-6.2 6.2-16.4 6.2-22.6 0z"
    ]
};
var $159afdcd077ecfe9$export$ff3afbc8c0bc5d59 = $159afdcd077ecfe9$export$531badb89cf01312;
var $159afdcd077ecfe9$export$56cbcd962389b090 = {
    prefix: 'fas',
    iconName: 'file-medical',
    icon: [
        384,
        512,
        [],
        "f477",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM160 280l0 40-40 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l40 0 0 40c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-40 40 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-40 0 0-40c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"
    ]
};
var $159afdcd077ecfe9$export$e6e44779b2fa1a5c = {
    prefix: 'fas',
    iconName: 'xmark',
    icon: [
        384,
        512,
        [
            128473,
            10005,
            10006,
            10060,
            215,
            "close",
            "multiply",
            "remove",
            "times"
        ],
        "f00d",
        "M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z"
    ]
};
var $159afdcd077ecfe9$export$23c717133fd81476 = $159afdcd077ecfe9$export$e6e44779b2fa1a5c;
var $159afdcd077ecfe9$export$4ed4ff13d4dbc862 = $159afdcd077ecfe9$export$e6e44779b2fa1a5c;
var $159afdcd077ecfe9$export$34810740c1bd6c54 = $159afdcd077ecfe9$export$e6e44779b2fa1a5c;
var $159afdcd077ecfe9$export$174bd7f477b115b4 = $159afdcd077ecfe9$export$e6e44779b2fa1a5c;
var $159afdcd077ecfe9$export$b17d50542d1fc340 = {
    prefix: 'fas',
    iconName: 'shapes',
    icon: [
        512,
        512,
        [
            "triangle-circle-square"
        ],
        "f61f",
        "M256 0c11.2 0 21.7 5.9 27.4 15.5l96 160c5.9 9.9 6.1 22.2 .4 32.2S363.5 224 352 224l-192 0c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3 .4-32.2l96-160C234.3 5.9 244.8 0 256 0zM128 272a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm200 16l112 0c22.1 0 40 17.9 40 40l0 112c0 22.1-17.9 40-40 40l-112 0c-22.1 0-40-17.9-40-40l0-112c0-22.1 17.9-40 40-40z"
    ]
};
var $159afdcd077ecfe9$export$34261e5aea24fc1d = $159afdcd077ecfe9$export$b17d50542d1fc340;
var $159afdcd077ecfe9$export$d91800b7be5303b0 = {
    prefix: 'fas',
    iconName: 'dice-one',
    icon: [
        448,
        512,
        [
            9856
        ],
        "f525",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM224 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$84b5acad4436d02a = {
    prefix: 'fas',
    iconName: 'lock-open',
    icon: [
        576,
        512,
        [],
        "f3c1",
        "M384 96c0-35.3 28.7-64 64-64s64 28.7 64 64l0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-70.7-57.3-128-128-128S320 25.3 320 96l0 64-160 0c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64l-32 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$4894bf28f771e1f3 = {
    prefix: 'fas',
    iconName: 'pepper-hot',
    icon: [
        576,
        512,
        [
            127798
        ],
        "f816",
        "M545 65c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L478.9 63.2C452.3 43.6 419.5 32 384 32 348.9 32 316.5 43.3 290.1 62.4 274.1 74.1 284.2 96 304 96l24 0c13.3 0 24 10.7 24 24l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24 10.7 24 24l0 24c0 19.8 21.9 29.9 33.6 13.9 19.1-26.4 30.4-58.8 30.4-93.9 0-35.5-11.6-68.3-31.2-94.9L545 65zM270 135.5l-159.6 228C101.3 376.4 86.7 384 71 384l-7 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l27.1 0c65.7 0 129.7-20.2 183.5-57.8L440.5 306.1C435 295.9 432 284.2 432 272l-56 0c-39.8 0-72-32.2-72-72l0-56c-12.2 0-23.9-3-34-8.5z"
    ]
};
var $159afdcd077ecfe9$export$1d6c5a49025d720b = {
    prefix: 'fas',
    iconName: 'droplet-slash',
    icon: [
        576,
        512,
        [
            "tint-slash"
        ],
        "f5c7",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L463.6 397.8c10.5-23.8 16.4-50.1 16.4-77.8 0-91.2-130.2-274.1-166.6-323.5-5.9-8-15.2-12.5-25.2-12.5l-.4 0c-10 0-19.3 4.5-25.2 12.5-15.6 21.2-48.5 66.9-80.9 119.4L41-24.9zm92 227.7c-21.6 43.8-37 85.9-37 117.2 0 106 86 192 192 192 43.4 0 83.4-14.4 115.5-38.6L133 202.8z"
    ]
};
var $159afdcd077ecfe9$export$5d6f0943039b898f = $159afdcd077ecfe9$export$1d6c5a49025d720b;
var $159afdcd077ecfe9$export$cc1b6e60cb98fb90 = {
    prefix: 'fas',
    iconName: 'droplet',
    icon: [
        384,
        512,
        [
            128167,
            "tint"
        ],
        "f043",
        "M192 512C86 512 0 426 0 320 0 228.8 130.2 45.9 166.6-3.5 172.5-11.5 181.8-16 191.8-16l.4 0c10 0 19.3 4.5 25.2 12.5 36.4 49.4 166.6 232.3 166.6 323.5 0 106-86 192-192 192zM112 312c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 75.1 60.9 136 136 136 13.3 0 24-10.7 24-24s-10.7-24-24-24c-48.6 0-88-39.4-88-88z"
    ]
};
var $159afdcd077ecfe9$export$60dd975bd5938c15 = $159afdcd077ecfe9$export$cc1b6e60cb98fb90;
var $159afdcd077ecfe9$export$ef565d07efe2b5e9 = {
    prefix: 'fas',
    iconName: 'file-lines',
    icon: [
        384,
        512,
        [
            128441,
            128462,
            61686,
            "file-alt",
            "file-text"
        ],
        "f15c",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM120 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
var $159afdcd077ecfe9$export$243b47dca32bf0b8 = $159afdcd077ecfe9$export$ef565d07efe2b5e9;
var $159afdcd077ecfe9$export$f466100bf9bf37a5 = $159afdcd077ecfe9$export$ef565d07efe2b5e9;
var $159afdcd077ecfe9$export$d477129b070e5ac4 = {
    prefix: 'fas',
    iconName: 'comments-dollar',
    icon: [
        576,
        512,
        [],
        "f653",
        "M192 320c106 0 192-78.8 192-176S298-32 192-32 0 46.8 0 144c0 39.6 14.3 76.2 38.4 105.6L2.8 316.8C-2.1 326.1-.4 337.5 7 345s18.9 9.2 28.2 4.2L116.8 306c23.1 9 48.5 14 75.2 14zm3.2 48c16.4 81.9 94.7 144 188.8 144 26.7 0 52.1-5 75.2-14l81.6 43.2c9.3 4.9 20.7 3.2 28.2-4.2s9.2-18.9 4.2-28.2l-35.6-67.2c24.1-29.4 38.4-66 38.4-105.6 0-82.4-61.7-151.5-145-170.7-11.5 115.8-115.8 201.2-235.8 202.7zM196 32c11 0 20 9 20 20l0 4 8 0c11 0 20 9 20 20s-9 20-20 20l-47.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 4.7c0 11-9 20-20 20s-20-9-20-20l0-4-24 0c-11 0-20-9-20-20s9-20 20-20l55.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7c-25.3-4.2-43.9-26.1-43.9-51.8 0-28.8 23.2-52.2 52-52.5l0-4c0-11 9-20 20-20z"
    ]
};
var $159afdcd077ecfe9$export$234a18b2b4d530a3 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-location',
    icon: [
        512,
        512,
        [
            "search-location"
        ],
        "f689",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6 6 7.3 16.8 7.3 22.7 0 22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$c33aba6c251a898a = $159afdcd077ecfe9$export$234a18b2b4d530a3;
var $159afdcd077ecfe9$export$bef39294aed2281a = {
    prefix: 'fas',
    iconName: 'file-invoice',
    icon: [
        384,
        512,
        [],
        "f570",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176zM64 384l0-64c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 416c-17.7 0-32-14.3-32-32zM88 64l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24S74.7 64 88 64zm0 96l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$21bf44b82744358d = {
    prefix: 'fas',
    iconName: 'pentagon',
    icon: [
        576,
        512,
        [],
        "e790",
        "M316.4-3.1c-16.8-12.2-39.6-12.2-56.4 0L35.3 160.2c-16.8 12.2-23.9 33.9-17.4 53.7l85.8 264.1c6.4 19.8 24.9 33.2 45.7 33.2l277.7 0c20.8 0 39.2-13.4 45.7-33.2l85.8-264.1c6.4-19.8-.6-41.4-17.4-53.7L316.4-3.1z"
    ]
};
var $159afdcd077ecfe9$export$929518bb4b66a588 = {
    prefix: 'fas',
    iconName: 'republican',
    icon: [
        640,
        512,
        [],
        "f75e",
        "M0 192C0 103.6 71.6 32 160 32l224 0c88.4 0 160 71.6 160 160l0 64-544 0 0-64zm152-32a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm232 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM280 160a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM128 288l416 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48c0-17.7 14.3-32 32-32s32 14.3 32 32l0 48c0 44.2-35.8 80-80 80s-80-35.8-80-80l0-48-32 0 0 96c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-64-192 0 0 64c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-160 128 0z"
    ]
};
var $159afdcd077ecfe9$export$78edc9b98453b6f7 = {
    prefix: 'fas',
    iconName: 'shop',
    icon: [
        576,
        512,
        [
            "store-alt"
        ],
        "f54f",
        "M21.5 181.1L78.3 67.4C89.2 45.7 111.3 32 135.6 32l304.9 0c24.2 0 46.4 13.7 57.2 35.4l56.8 113.7c3.6 7.2 5.5 15.1 5.5 23.2 0 27.3-21.2 49.7-48 51.6L512 448c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192-96 0 0 176c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-176.1c-26.8-1.9-48-24.3-48-51.6 0-8 1.9-16 5.5-23.2zM128 256l0 112c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-112-160 0z"
    ]
};
var $159afdcd077ecfe9$export$1f1871dab9cec9d8 = $159afdcd077ecfe9$export$78edc9b98453b6f7;
var $159afdcd077ecfe9$export$c03de0cc616e77bb = {
    prefix: 'fas',
    iconName: 'film',
    icon: [
        448,
        512,
        [
            127902,
            62368,
            "film-alt",
            "film-simple"
        ],
        "f008",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM48 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm304-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm304-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM48 112l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16L64 96c-8.8 0-16 7.2-16 16zM352 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0z"
    ]
};
var $159afdcd077ecfe9$export$51af5173c6a30484 = $159afdcd077ecfe9$export$c03de0cc616e77bb;
var $159afdcd077ecfe9$export$7f9b091081b7a894 = $159afdcd077ecfe9$export$c03de0cc616e77bb;
var $159afdcd077ecfe9$export$c4c015418a1f24df = {
    prefix: 'fas',
    iconName: 'building-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e4d4",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-10.5-14.6-19-30.7-25.1-48l-74.9 0 0-80c0-17.7 14.3-32 32-32l32 0c2 0 4 .2 5.9 .5 6-23.6 16.3-45.4 30.1-64.5l-4 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 4c27.5-19.8 60.3-32.4 96-35.4L416 64c0-35.3-28.7-64-64-64L96 0zm32 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM272 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM128 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 400z"
    ]
};
var $159afdcd077ecfe9$export$932912e74adb8939 = {
    prefix: 'fas',
    iconName: 'comments',
    icon: [
        576,
        512,
        [
            128490,
            61670
        ],
        "f086",
        "M384 144c0 97.2-86 176-192 176-26.7 0-52.1-5-75.2-14L35.2 349.2c-9.3 4.9-20.7 3.2-28.2-4.2s-9.2-18.9-4.2-28.2l35.6-67.2C14.3 220.2 0 183.6 0 144 0 46.8 86-32 192-32S384 46.8 384 144zm0 368c-94.1 0-172.4-62.1-188.8-144 120-1.5 224.3-86.9 235.8-202.7 83.3 19.2 145 88.3 145 170.7 0 39.6-14.3 76.2-38.4 105.6l35.6 67.2c4.9 9.3 3.2 20.7-4.2 28.2s-18.9 9.2-28.2 4.2L459.2 498c-23.1 9-48.5 14-75.2 14z"
    ]
};
var $159afdcd077ecfe9$export$d55778e3ab6c933f = {
    prefix: 'fas',
    iconName: 'tags',
    icon: [
        576,
        512,
        [],
        "f02c",
        "M401.2 39.1L549.4 189.4c27.7 28.1 27.7 73.1 0 101.2L393 448.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L515.3 256.8c9.2-9.3 9.2-24.4 0-33.7L367 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM32.1 229.5L32.1 96c0-35.3 28.7-64 64-64l133.5 0c17 0 33.3 6.7 45.3 18.7l144 144c25 25 25 65.5 0 90.5L285.4 418.7c-25 25-65.5 25-90.5 0l-144-144c-12-12-18.7-28.3-18.7-45.3zm144-85.5a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $159afdcd077ecfe9$export$e18f576a7b31ba46 = {
    prefix: 'fas',
    iconName: 'gun',
    icon: [
        576,
        512,
        [],
        "e19b",
        "M528 56c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 8-448 0C14.3 64 0 78.3 0 96L0 208c0 17.7 14.3 32 32 32l10 0c20.8 0 36.1 19.6 31 39.8L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480l96 0c14.7 0 27.5-10 31-24.2L217 352 321.4 352c23.7 0 44.8-14.9 52.7-37.2l26.7-74.8 31.1 0c8.5 0 16.6-3.4 22.6-9.4l22.6-22.6 66.7 0c17.7 0 32-14.3 32-32l0-80c0-17.7-14.3-32-32-32l-16 0 0-8zM321.4 304l-92.5 0 16-64 105 0-21 58.7c-1.1 3.2-4.2 5.3-7.5 5.3zM80 128l384 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$c2e9877668862374 = {
    prefix: 'fas',
    iconName: 'circle-check',
    icon: [
        512,
        512,
        [
            61533,
            "check-circle"
        ],
        "f058",
        "M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z"
    ]
};
var $159afdcd077ecfe9$export$be9e388158c74f29 = $159afdcd077ecfe9$export$c2e9877668862374;
var $159afdcd077ecfe9$export$31e6961064ddac7b = {
    prefix: 'fas',
    iconName: 'id-card-clip',
    icon: [
        576,
        512,
        [
            "id-card-alt"
        ],
        "f47f",
        "M256-32l64 0c17.7 0 32 14.3 32 32l0 64-128 0 0-64c0-17.7 14.3-32 32-32zM64 32l112 0 0 32c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-32 112 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32zM176 400c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80zM288 280a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
    ]
};
var $159afdcd077ecfe9$export$dc37ebbac31f6c6c = $159afdcd077ecfe9$export$31e6961064ddac7b;
var $159afdcd077ecfe9$export$c4c2f69a53bab720 = {
    prefix: 'fas',
    iconName: 'moon',
    icon: [
        512,
        512,
        [
            127769,
            9214
        ],
        "f186",
        "M256 0C114.6 0 0 114.6 0 256S114.6 512 256 512c68.8 0 131.3-27.2 177.3-71.4 7.3-7 9.4-17.9 5.3-27.1s-13.7-14.9-23.8-14.1c-4.9 .4-9.8 .6-14.8 .6-101.6 0-184-82.4-184-184 0-72.1 41.5-134.6 102.1-164.8 9.1-4.5 14.3-14.3 13.1-24.4S322.6 8.5 312.7 6.3C294.4 2.2 275.4 0 256 0z"
    ]
};
var $159afdcd077ecfe9$export$b69c6757012a2267 = {
    prefix: 'fas',
    iconName: 'oil-well',
    icon: [
        576,
        512,
        [],
        "e532",
        "M528.3 61.3c-11.4-42.7-55.3-68-98-56.6L414.9 8.8C397.8 13.4 387.7 31 392.3 48l24.5 91.4-108.2 28.1-6.3-18.1C297.7 136.6 285.6 128 272 128s-25.7 8.6-30.2 21.4l-13.6 39-132.2 34.3 0-38.6c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 264-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-137.3 0-61.4-175.4-62.2 16.1 22.1 63.2-66.6 0 19.9-56.9-74.6 19.3-46.7 133.5-41.3 0 0-159.2 337.4-87.5 25.2 94c4.6 17.1 22.1 27.2 39.2 22.6l15.5-4.1c42.7-11.4 68-55.3 56.6-98L528.3 61.3zM205.1 448l16.8-48 100.2 0 16.8 48-133.8 0z"
    ]
};
var $159afdcd077ecfe9$export$73f2bf302381c86a = {
    prefix: 'fas',
    iconName: 'tachograph-digital',
    icon: [
        576,
        512,
        [
            "digital-tachograph"
        ],
        "f566",
        "M0 128C0 92.7 28.7 64 64 64l448 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm64 32l0 32c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-32c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zM88 352c-13.3 0-24 10.7-24 24s10.7 24 24 24l136 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 352zm256 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0zM496 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM88 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$b3bf1994f0fefe98 = $159afdcd077ecfe9$export$73f2bf302381c86a;
var $159afdcd077ecfe9$export$1c92b67c45a4b4fc = {
    prefix: 'fas',
    iconName: 'tablet',
    icon: [
        448,
        512,
        [
            "tablet-android"
        ],
        "f3fb",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM184 400l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$5eddbb7c71278268 = $159afdcd077ecfe9$export$1c92b67c45a4b4fc;
var $159afdcd077ecfe9$export$1ae0a94c8ba4131a = {
    prefix: 'fas',
    iconName: 'ruble-sign',
    icon: [
        448,
        512,
        [
            8381,
            "rouble",
            "rub",
            "ruble"
        ],
        "f158",
        "M112 32C94.3 32 80 46.3 80 64l0 208-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 48-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 152 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-152 0 0-48 112 0c79.5 0 144-64.5 144-144S335.5 32 256 32L112 32zM256 256l-112 0 0-160 112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $159afdcd077ecfe9$export$c5dc3d98c4d8f2a5 = $159afdcd077ecfe9$export$1ae0a94c8ba4131a;
var $159afdcd077ecfe9$export$9c4d936240e1f0b1 = $159afdcd077ecfe9$export$1ae0a94c8ba4131a;
var $159afdcd077ecfe9$export$6c0cf65134387046 = $159afdcd077ecfe9$export$1ae0a94c8ba4131a;
var $159afdcd077ecfe9$export$8e047801a8603af7 = {
    prefix: 'fas',
    iconName: 'closed-captioning',
    icon: [
        512,
        512,
        [],
        "f20a",
        "M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm152 80l32 0c4.4 0 8 3.6 8 8 0 13.3 10.7 24 24 24s24-10.7 24-24c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-80c0-4.4 3.6-8 8-8zm168 8c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8 0 13.3 10.7 24 24 24s24-10.7 24-24c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 80c0 30.9 25.1 56 56 56l32 0c30.9 0 56-25.1 56-56 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 4.4-3.6 8-8 8l-32 0c-4.4 0-8-3.6-8-8l0-80z"
    ]
};
var $159afdcd077ecfe9$export$8f4567331fb0d3bc = {
    prefix: 'fas',
    iconName: 'pen',
    icon: [
        512,
        512,
        [
            128394
        ],
        "f304",
        "M352.9 21.2L308 66.1 445.9 204 490.8 159.1C504.4 145.6 512 127.2 512 108s-7.6-37.6-21.2-51.1L455.1 21.2C441.6 7.6 423.2 0 404 0s-37.6 7.6-51.1 21.2zM274.1 100L58.9 315.1c-10.7 10.7-18.5 24.1-22.6 38.7L.9 481.6c-2.3 8.3 0 17.3 6.2 23.4s15.1 8.5 23.4 6.2l127.8-35.5c14.6-4.1 27.9-11.8 38.7-22.6L412 237.9 274.1 100z"
    ]
};
var $159afdcd077ecfe9$export$f654c69e66b466c0 = {
    prefix: 'fas',
    iconName: 'plane',
    icon: [
        576,
        512,
        [],
        "f072",
        "M520 200c30.9 0 56 25.1 56 56s-25.1 56-56 56l-127.3 0-159.2 173.6c-6.1 6.6-14.6 10.4-23.6 10.4l-43.7 0c-10.9 0-18.6-10.7-15.2-21.1l54.3-162.9-99.7 0-52.8 66c-3 3.8-7.6 6-12.5 6l-19.8 0c-10.4 0-18-9.8-15.5-19.9L32 256 5 147.9C2.4 137.8 10.1 128 20.5 128l19.8 0c4.9 0 9.5 2.2 12.5 6l52.8 66 99.7 0-54.3-162.9C147.6 26.7 155.3 16 166.2 16l43.7 0c9 0 17.5 3.8 23.6 10.4L392.7 200 520 200z"
    ]
};
var $159afdcd077ecfe9$export$74f06b41ed2ca28a = {
    prefix: 'fas',
    iconName: 'images',
    icon: [
        576,
        512,
        [],
        "f302",
        "M96 96c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-320 0c-35.3 0-64-28.7-64-64L96 96zM24 128c13.3 0 24 10.7 24 24l0 296c0 8.8 7.2 16 16 16l360 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L64 512c-35.3 0-64-28.7-64-64L0 152c0-13.3 10.7-24 24-24zm168 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm196.5 11.5c-4.4-7.1-12.1-11.5-20.5-11.5s-16.1 4.4-20.5 11.5l-56.3 92.1-24.5-30.6c-4.6-5.7-11.4-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4S174.8 352 184 352l272 0c8.7 0 16.7-4.7 20.9-12.3s4.1-16.8-.5-24.3l-88-144z"
    ]
};
var $159afdcd077ecfe9$export$8867e7da34bb8bf4 = {
    prefix: 'fas',
    iconName: 'mobile-screen',
    icon: [
        384,
        512,
        [
            "mobile-android-alt"
        ],
        "f3cf",
        "M16 64C16 28.7 44.7 0 80 0L304 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L80 512c-35.3 0-64-28.7-64-64L16 64zM128 440c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-13.3 0-24 10.7-24 24zM304 64l-224 0 0 304 224 0 0-304z"
    ]
};
var $159afdcd077ecfe9$export$cb39d7b468ba5838 = $159afdcd077ecfe9$export$8867e7da34bb8bf4;
var $159afdcd077ecfe9$export$b731a51acb74b00c = {
    prefix: 'fas',
    iconName: 'guarani-sign',
    icon: [
        384,
        512,
        [],
        "e19a",
        "M192 0c-13.3 0-24 10.7-24 24l0 41.5C73.3 77.3 0 158.1 0 256S73.3 434.7 168 446.5l0 41.5c0 13.3 10.7 24 24 24s24-10.7 24-24l0-41.5c94.7-11.8 168-92.6 168-190.5 0-17.7-14.3-32-32-32l-136 0 0-93.8c25.3 4.8 47.9 17 65.6 34.3 12.6 12.4 32.9 12.2 45.3-.4s12.2-32.9-.5-45.3C297.2 90.2 258.8 70.8 216 65.5L216 24c0-13.3-10.7-24-24-24zM168 130.2l0 251.5C108.8 370.5 64 318.5 64 256s44.8-114.5 104-125.8zm48 251.5l0-93.8 100 0c-12.3 47.6-51.2 84.5-100 93.8z"
    ]
};
var $159afdcd077ecfe9$export$b0137b4600e9ab12 = {
    prefix: 'fas',
    iconName: 'bag-shopping',
    icon: [
        448,
        512,
        [
            "shopping-bag"
        ],
        "f290",
        "M160 80c0-35.3 28.7-64 64-64s64 28.7 64 64l0 48-128 0 0-48zm-48 48l-64 0c-26.5 0-48 21.5-48 48L0 384c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-208c0-26.5-21.5-48-48-48l-64 0 0-48c0-61.9-50.1-112-112-112S112 18.1 112 80l0 48zm24 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$5745f8adbc11eb01 = $159afdcd077ecfe9$export$b0137b4600e9ab12;
var $159afdcd077ecfe9$export$1fec48c8bdd69c1d = {
    prefix: 'fas',
    iconName: 'circle-right',
    icon: [
        512,
        512,
        [
            61838,
            "arrow-alt-circle-right"
        ],
        "f35a",
        "M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zm387.3 11.3l-104 104c-4.6 4.6-11.5 5.9-17.4 3.5S256 366.5 256 360l0-56-96 0c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32l96 0 0-56c0-6.5 3.9-12.3 9.9-14.8s12.9-1.1 17.4 3.5l104 104c6.2 6.2 6.2 16.4 0 22.6z"
    ]
};
var $159afdcd077ecfe9$export$88962ffdad8b856d = $159afdcd077ecfe9$export$1fec48c8bdd69c1d;
var $159afdcd077ecfe9$export$c377f240bb8b5d74 = {
    prefix: 'fas',
    iconName: 'phone-volume',
    icon: [
        576,
        512,
        [
            "volume-control-phone"
        ],
        "f2a0",
        "M344-32c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM320 88c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24zM144.1 1.4c19.7-5.4 40.3 4.7 48.1 23.5l40.5 97.3c6.9 16.5 2.1 35.6-11.8 47l-44.1 36.1c32.5 71.6 89 130 159.3 164.9L374.7 323c11.3-13.9 30.4-18.6 47-11.8L519 351.8c18.8 7.8 28.9 28.4 23.5 48.1l-1.5 5.5C523.4 470.1 460.9 525.3 384.6 509.2 209.6 472.1 71.9 334.4 34.8 159.4 18.7 83.1 73.9 20.6 138.5 2.9l5.5-1.5z"
    ]
};
var $159afdcd077ecfe9$export$5358d004fa3d3be2 = $159afdcd077ecfe9$export$c377f240bb8b5d74;
var $159afdcd077ecfe9$export$30523a9441a31e97 = {
    prefix: 'fas',
    iconName: 'cubes',
    icon: [
        512,
        512,
        [],
        "f1b3",
        "M284-1.3c-17.3-10-38.7-10-56 0L143.8 47.3c-17.3 10-28 28.5-28 48.5l0 101.9-88.3 51c-17.3 10-28 28.5-28 48.5l0 97.3c0 20 10.7 38.5 28 48.5l84.3 48.6c17.3 10 38.7 10 56 0l88.3-51 88.3 51c17.3 10 38.7 10 56 0L484.5 443c17.3-10 28-28.5 28-48.5l0-97.3c0-20-10.7-38.5-28-48.5l-88.3-51 0-101.9c0-20-10.7-38.5-28-48.5L284-1.3zM232 292.6l0 106.5-88.3 51c-1.2 .7-2.6 1.1-4 1.1l0-105.3 92.3-53.3zm231.4 .6c.7 1.2 1.1 2.6 1.1 4l0 97.3c0 2.9-1.5 5.5-4 6.9l-84.3 48.6c-1.2 .7-2.6 1.1-4 1.1l0-105.3 91.2-52.6zM348.3 95.8l0 101.9-92.3 53.3 0-106.5 91.2-52.6c.7 1.2 1.1 2.6 1.1 4z"
    ]
};
var $159afdcd077ecfe9$export$ddab067855cf34cb = {
    prefix: 'fas',
    iconName: 'phone',
    icon: [
        512,
        512,
        [
            128222,
            128379
        ],
        "f095",
        "M160.2 25C152.3 6.1 131.7-3.9 112.1 1.4l-5.5 1.5c-64.6 17.6-119.8 80.2-103.7 156.4 37.1 175 174.8 312.7 349.8 349.8 76.3 16.2 138.8-39.1 156.4-103.7l1.5-5.5c5.4-19.7-4.7-40.3-23.5-48.1l-97.3-40.5c-16.5-6.9-35.6-2.1-47 11.8l-38.6 47.2C233.9 335.4 177.3 277 144.8 205.3L189 169.3c13.9-11.3 18.6-30.4 11.8-47L160.2 25z"
    ]
};
var $159afdcd077ecfe9$export$75825a4c2b3375e = {
    prefix: 'fas',
    iconName: 'torii-gate',
    icon: [
        448,
        512,
        [
            9961
        ],
        "f6a1",
        "M0 96L0 28.5C0 21.6 5.6 16 12.5 16 14.8 16 17 16.6 19 17.8L58 41.2C82.9 56.1 111.3 64 140.3 64l167.4 0c29 0 57.5-7.9 82.3-22.8l39-23.4c1.9-1.2 4.2-1.8 6.4-1.8 6.9 0 12.5 5.6 12.5 12.5L448 96c0 35.3-28.7 64-64 64l0 64 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192-192 0 0 192c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-192-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-64C28.7 160 0 131.3 0 96zM128 224l64 0 0-64-64 0 0 64zm128 0l64 0 0-64-64 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$ab07061fe21a3a8e = {
    prefix: 'fas',
    iconName: 'bacon',
    icon: [
        576,
        512,
        [
            129363
        ],
        "f7e5",
        "M557 96.7c14.4 14.4 12.4 38.4-4.3 50.2l-64.6 45.7c-43.7 30.9-79.2 71.9-103.4 119.6l-25.3 49.8c-25.1 49.3-62.1 91.5-107.8 122.6l-74.1 50.6c-13.1 8.9-30.7 7.3-41.8-3.9l-44.9-44.9 86.5-66.5c42.3-32.5 76.7-74.3 100.6-122l24.5-49.1c24.5-49 61.8-90.6 107.9-120.2l108.7-69.9 38 38zM484.2 23.9L384.3 88.2c-53.4 34.3-96.5 82.4-124.9 139.1l-24.5 49.1c-20.6 41.3-50.3 77.3-86.9 105.4l-91.4 70.3-36.9-36.9c-14.4-14.4-12.4-38.4 4.3-50.2l64.6-45.7c43.7-30.9 79.2-71.9 103.4-119.6l25.3-49.8C242.3 100.8 279.3 58.6 325 27.4l74.1-50.6c13.1-8.9 30.6-7.3 41.8 3.9l43.3 43.3z"
    ]
};
var $159afdcd077ecfe9$export$a75569baaf4a6c3a = {
    prefix: 'fas',
    iconName: 'person-falling-burst',
    icon: [
        576,
        512,
        [],
        "e547",
        "M256 0c17.7 0 32 14.3 32 32l0 5.4c0 55.2-23.7 107-63.9 143.1l62.9 75.5 89 0c15.1 0 29.3 7.1 38.4 19.2l43.2 57.6c10.6 14.1 7.7 34.2-6.4 44.8s-34.2 7.7-44.8-6.4L368 320 263.2 320 376.8 459.8c11.1 13.7 9.1 33.9-4.7 45s-33.9 9.1-45-4.7L137.4 266.6c-6.1 15-9.4 31.3-9.4 48l0 69.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-69.4c0-67.4 35.4-129.9 93.2-164.6l4.6-2.8C200.4 124 224 82.4 224 37.4l0-5.4c0-17.7 14.3-32 32-32zM16 88A56 56 0 1 1 128 88 56 56 0 1 1 16 88zm376-7.9c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48zm104 152c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0zm-54.5-97.5c-9.4-9.4-9.4-24.6 0-33.9l33.9-33.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-33.9 33.9c-9.4 9.4-24.6 9.4-33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$54e3a80c9875b74c = {
    prefix: 'fas',
    iconName: 'quote-right',
    icon: [
        448,
        512,
        [
            8221,
            "quote-right-alt"
        ],
        "f10e",
        "M448 296c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 136zm-256 0c0 66.3-53.7 120-120 120l-8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l8 0c30.9 0 56-25.1 56-56l0-8-64 0c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l64 0c35.3 0 64 28.7 64 64l0 136z"
    ]
};
var $159afdcd077ecfe9$export$dd692f2e88bd4b1a = $159afdcd077ecfe9$export$54e3a80c9875b74c;
var $159afdcd077ecfe9$export$86c50f517be57a40 = {
    prefix: 'fas',
    iconName: 'house-medical-flag',
    icon: [
        640,
        512,
        [],
        "e514",
        "M480 0c17.7 0 32 14.3 32 32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0 0 288c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM267.5 59.1L400 186.9 400 503.4c-9.4 5.4-20.3 8.6-32 8.6l-256 0c-35.3 0-64-28.7-64-64l0-144-19.9 0C12.6 304 0 291.4 0 275.9 0 268.3 3.1 261 8.6 255.7L212.5 59.1C219.9 52 229.7 48 240 48s20.1 4 27.5 11.1zM204.8 256.8l0 44-44 0c-9.7 0-17.6 7.9-17.6 17.6l0 35.2c0 9.7 7.9 17.6 17.6 17.6l44 0 0 44c0 9.7 7.9 17.6 17.6 17.6l35.2 0c9.7 0 17.6-7.9 17.6-17.6l0-44 44 0c9.7 0 17.6-7.9 17.6-17.6l0-35.2c0-9.7-7.9-17.6-17.6-17.6l-44 0 0-44c0-9.7-7.9-17.6-17.6-17.6l-35.2 0c-9.7 0-17.6 7.9-17.6 17.6z"
    ]
};
var $159afdcd077ecfe9$export$8767bafb19515ee4 = {
    prefix: 'fas',
    iconName: 'prescription',
    icon: [
        448,
        512,
        [],
        "f5b1",
        "M32 0C14.3 0 0 14.3 0 32L0 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 50.7 0 128 128-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L288 397.3 393.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L333.3 352 438.6 246.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 306.7 202.2 220.9C251.4 209.1 288 164.8 288 112 288 50.1 237.9 0 176 0L32 0zM176 160l-112 0 0-96 112 0c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
    ]
};
var $159afdcd077ecfe9$export$221059e0d5fd8958 = {
    prefix: 'fas',
    iconName: 'dice-three',
    icon: [
        448,
        512,
        [
            9858
        ],
        "f527",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$6f08294ba8a2459c = {
    prefix: 'fas',
    iconName: 'building-lock',
    icon: [
        576,
        512,
        [],
        "e4d6",
        "M32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 121.3c-46.9 19-80 65-80 118.7l0 24.4c-19.6 17.6-32 43.1-32 71.5l0 96c0 5.5 .5 10.9 1.3 16.1L96 512c-35.3 0-64-28.7-64-64L32 64zM176 384l0 80 80 0 0-64.1c0-13.7 1.9-27 5.5-39.6-5.7-5.2-13.2-8.3-21.5-8.3l-32 0c-17.7 0-32 14.3-32 32zM307 224.3c-1-.2-2-.3-3-.3l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l16.7 0c2.1-22.8 8.4-44.3 18.3-63.7zM144 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM144 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm352 80.1c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM352 400c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
var $159afdcd077ecfe9$export$782ac893fc22249b = {
    prefix: 'fas',
    iconName: 'id-card',
    icon: [
        576,
        512,
        [
            62147,
            "drivers-license"
        ],
        "f2c2",
        "M0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64L0 96zm0 48l576 0 0 272c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 144zM247.3 416c20.2 0 35.3-19.4 22.4-35-14.7-17.7-36.9-29-61.7-29l-64 0c-24.8 0-47 11.3-61.7 29-12.9 15.6 2.2 35 22.4 35l142.5 0zM176 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM360 208c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"
    ]
};
var $159afdcd077ecfe9$export$8359c70e609eff64 = $159afdcd077ecfe9$export$782ac893fc22249b;
var $159afdcd077ecfe9$export$86c4e45dc3302d15 = {
    prefix: 'fas',
    iconName: 'circle-play',
    icon: [
        512,
        512,
        [
            61469,
            "play-circle"
        ],
        "f144",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z"
    ]
};
var $159afdcd077ecfe9$export$cf04333781061c5e = $159afdcd077ecfe9$export$86c4e45dc3302d15;
var $159afdcd077ecfe9$export$3f2d51c0547bf984 = {
    prefix: 'fas',
    iconName: 'face-laugh-beam',
    icon: [
        512,
        512,
        [
            128513,
            "laugh-beam"
        ],
        "f59a",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM101.6 314c-3.7-13.7 7.5-26 21.7-26l265.4 0c14.2 0 25.4 12.3 21.7 26-18.5 68-80.6 118-154.4 118S120 382 101.6 314zM176 164c-15.5 0-28 12.5-28 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28zm132 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28s-28 12.5-28 28z"
    ]
};
var $159afdcd077ecfe9$export$a88d1f4073ea9369 = $159afdcd077ecfe9$export$3f2d51c0547bf984;
var $159afdcd077ecfe9$export$7c497bae2754a087 = {
    prefix: 'fas',
    iconName: 'leaf',
    icon: [
        512,
        512,
        [],
        "f06c",
        "M471.3 6.7C477.7 .6 487-1.6 495.6 1.2 505.4 4.5 512 13.7 512 24l0 186.9c0 131.2-108.1 237.1-238.8 237.1-77 0-143.4-49.5-167.5-118.7-35.4 30.8-57.7 76.1-57.7 126.7 0 13.3-10.7 24-24 24S0 469.3 0 456C0 381.1 38.2 315.1 96.1 276.3 131.4 252.7 173.5 240 216 240l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0c-39.7 0-77.3 8.8-111 24.5 23.3-70 89.2-120.5 167-120.5 66.4 0 115.8-22.1 148.7-44 19.2-12.8 35.5-28.1 50.7-45.3z"
    ]
};
var $159afdcd077ecfe9$export$1ddbaebce033a0d = {
    prefix: 'fas',
    iconName: 'house-chimney-user',
    icon: [
        512,
        512,
        [],
        "e065",
        "M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208zM312 256a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM144 432c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80z"
    ]
};
var $159afdcd077ecfe9$export$7f465bf410c6eff7 = {
    prefix: 'fas',
    iconName: 'rotate-right',
    icon: [
        512,
        512,
        [
            "redo-alt",
            "rotate-forward"
        ],
        "f2f9",
        "M488 192l-144 0c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2l46.7-46.7c-75.3-58.6-184.3-53.3-253.5 15.9-75 75-75 196.5 0 271.5s196.5 75 271.5 0c8.2-8.2 15.5-16.9 21.9-26.1 10.1-14.5 30.1-18 44.6-7.9s18 30.1 7.9 44.6c-8.5 12.2-18.2 23.8-29.1 34.7-100 100-262.1 100-362 0S-25 175 75 75c94.3-94.3 243.7-99.6 344.3-16.2L471 7c6.9-6.9 17.2-8.9 26.2-5.2S512 14.3 512 24l0 144c0 13.3-10.7 24-24 24z"
    ]
};
var $159afdcd077ecfe9$export$50c037520c6cfdc1 = $159afdcd077ecfe9$export$7f465bf410c6eff7;
var $159afdcd077ecfe9$export$2507849a0fdd7f64 = $159afdcd077ecfe9$export$7f465bf410c6eff7;
var $159afdcd077ecfe9$export$3a1fa2d16f90d635 = {
    prefix: 'fas',
    iconName: 'tooth',
    icon: [
        448,
        512,
        [
            129463
        ],
        "f5c9",
        "M145 5.7L224 32 303 5.7C314.3 1.9 326 0 337.9 0 398.7 0 448 49.3 448 110.1l0 68.5c0 29.4-9.5 58.1-27.2 81.6l-1.1 1.5c-12.9 17.2-21.3 37.4-24.3 58.7L373.7 471.9c-3.3 23-23 40.1-46.2 40.1-22.8 0-42.3-16.5-46-39L261.3 351.6c-3-18.2-18.8-31.6-37.3-31.6s-34.2 13.4-37.3 31.6L166.5 473c-3.8 22.5-23.2 39-46 39-23.2 0-42.9-17.1-46.2-40.1L52.6 320.5c-3-21.3-11.4-41.5-24.3-58.7l-1.1-1.5C9.5 236.7 0 208.1 0 178.7l0-68.5C0 49.3 49.3 0 110.1 0 122 0 133.7 1.9 145 5.7z"
    ]
};
var $159afdcd077ecfe9$export$792391babe46862d = {
    prefix: 'fas',
    iconName: 'house-chimney-window',
    icon: [
        512,
        512,
        [],
        "e00d",
        "M234.2 8.6c12.3-11.4 31.3-11.4 43.5 0L368 92.3 368 80c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 101.5 37.8 35.1c9.6 9 12.8 22.9 8 35.1S493.2 272 480 272l-16 0 0 176c0 35.3-28.7 64-64 64l-288 0c-35.3 0-64-28.7-64-64l0-176-16 0c-13.2 0-25-8.1-29.8-20.3s-1.6-26.2 8-35.1l224-208zM216 224c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-80 0z"
    ]
};
var $159afdcd077ecfe9$export$f26017bdca99338d = {
    prefix: 'fas',
    iconName: 'motorcycle',
    icon: [
        640,
        512,
        [
            127949
        ],
        "f21c",
        "M280 16c-13.3 0-24 10.7-24 24s10.7 24 24 24l56.6 0 22.5 48.7-95.1 71.3c-33.4-25.1-75-40-120-40l-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0c78.5 0 143.2 59.6 151.2 136l-25.4 0c-11.2-59.2-63.3-104-125.8-104-70.7 0-128 57.3-128 128S73.3 480 144 480c62.5 0 114.5-44.8 125.8-104l50.2 0c13.3 0 24-10.7 24-24l0-22.5c0-45.1 25.7-85.4 65.5-107.7l12.1 26.1c-32.4 23.2-53.5 61.2-53.5 104.1 0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-10.7 0-21 1.3-30.9 3.8L433.8 160 488 160c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-53.3 0c-6.9 0-13.7 2.2-19.2 6.4l-17.1 12.8-24.6-53.3C369.9 21.4 361.4 16 352 16l-72 0zM445.8 300.4l28.4 61.6c5.6 12 19.8 17.3 31.8 11.7s17.3-19.8 11.7-31.8l-28.5-61.6c2.2-.2 4.4-.3 6.7-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72c0-20.2 8.3-38.5 21.8-51.6zM144 424c-39.8 0-72-32.2-72-72s32.2-72 72-72c31.3 0 58 20 67.9 48L144 328c-13.3 0-24 10.7-24 24s10.7 24 24 24l67.9 0c-9.9 28-36.6 48-67.9 48z"
    ]
};
var $159afdcd077ecfe9$export$662cbc6ed5a3c5e8 = {
    prefix: 'fas',
    iconName: 'backward-fast',
    icon: [
        512,
        512,
        [
            9198,
            "fast-backward"
        ],
        "f049",
        "M492.2 477.6c-12 5-25.7 2.2-34.9-6.9L288 301.3 288 448c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9L64 301.3 64 448c0 17.7-14.3 32-32 32S0 465.7 0 448L0 64C0 46.3 14.3 32 32 32S64 46.3 64 64L64 210.7 233.4 41.4c9.2-9.2 22.9-11.9 34.9-6.9S288 51.1 288 64l0 146.7 169.4-169.4c9.2-9.2 22.9-11.9 34.9-6.9S512 51.1 512 64l0 384c0 12.9-7.8 24.6-19.8 29.6z"
    ]
};
var $159afdcd077ecfe9$export$e6246a3279a379b8 = $159afdcd077ecfe9$export$662cbc6ed5a3c5e8;
var $159afdcd077ecfe9$export$853fd1561789e3bb = {
    prefix: 'fas',
    iconName: 'address-book',
    icon: [
        512,
        512,
        [
            62138,
            "contact-book"
        ],
        "f2b9",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM208 288l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16 0-44.2 35.8-80 80-80zm-24-96a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zm0 128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 320c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$594b5a5d4d2e156b = $159afdcd077ecfe9$export$853fd1561789e3bb;
var $159afdcd077ecfe9$export$e363e74e36cce80c = {
    prefix: 'fas',
    iconName: 'sailboat',
    icon: [
        512,
        512,
        [],
        "e445",
        "M240 35.9l0 348.1-224 0c-8.8 0-16 7.2-16 16 0 61.9 50.1 112 112 112l288 0c61.9 0 112-50.1 112-112 0-8.8-7.2-16-16-16l-208 0 0-48 161.7 0c12.9 0 20.5-14.4 13.2-25L269.2 26.9c-8.9-13-29.2-6.7-29.2 9zM192 320l0-184.2c0-16.1-21-22.1-29.6-8.5L47.3 311.5c-6.7 10.7 1 24.5 13.6 24.5L176 336c8.8 0 16-7.2 16-16z"
    ]
};
var $159afdcd077ecfe9$export$3d177ecdf7fc50ec = {
    prefix: 'fas',
    iconName: 'book-bookmark',
    icon: [
        448,
        512,
        [],
        "e0bb",
        "M96 512l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-66.7c18.6-6.6 32-24.4 32-45.3l0-288c0-26.5-21.5-48-48-48l-48 0 0 169.4c0 12.5-10.1 22.6-22.6 22.6-6 0-11.8-2.4-16-6.6L272 144 230.6 185.4c-4.2 4.2-10 6.6-16 6.6-12.5 0-22.6-10.1-22.6-22.6L192 0 96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96zM64 416c0-17.7 14.3-32 32-32l256 0 0 64-256 0c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$382d3376c7fc7fc5 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-arrow-right',
    icon: [
        512,
        512,
        [],
        "e521",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM305 225c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-102.1 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l102.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72z"
    ]
};
var $159afdcd077ecfe9$export$417391ae30b5922e = {
    prefix: 'fas',
    iconName: 'microphone-lines',
    icon: [
        384,
        512,
        [
            127897,
            "microphone-alt"
        ],
        "f3c9",
        "M96 96c0-53 43-96 96-96 50.3 0 91.6 38.7 95.7 88L232 88c-13.3 0-24 10.7-24 24s10.7 24 24 24l56 0 0 48-56 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l55.7 0c-4.1 49.3-45.3 88-95.7 88-53 0-96-43-96-96L96 96zM24 160c13.3 0 24 10.7 24 24l0 40c0 79.5 64.5 144 144 144s144-64.5 144-144l0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40c0 97.9-73.3 178.7-168 190.5l0 49.5 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-49.5C73.3 402.7 0 321.9 0 224l0-40c0-13.3 10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$f08ef94fea14f5ac = $159afdcd077ecfe9$export$417391ae30b5922e;
var $159afdcd077ecfe9$export$ca6fd367f31ecbc5 = {
    prefix: 'fas',
    iconName: 'reply-all',
    icon: [
        576,
        512,
        [
            "mail-reply-all"
        ],
        "f122",
        "M332.2 18.4c12 5 19.8 16.6 19.8 29.6l0 80 48 0c97.2 0 176 78.8 176 176 0 113.3-81.5 163.9-100.2 174.1-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-7.5 4.3-14.4 9.8-19.5 9.4-8.8 22.2-26.4 22.2-56.7 0-53-43-96-96-96l-32 0 0 80c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-160-160c-12.5-12.5-12.5-32.8 0-45.3l160-160c9.2-9.2 22.9-11.9 34.9-6.9zM205.6 23.1c9.4 9.4 9.4 24.6 0 33.9L54.6 208 205.6 358.9c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L10 231.2c-6.4-6-10-14.4-10-23.2s3.6-17.2 10-23.2L171.6 23.1c9.4-9.4 24.6-9.4 33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$8274334f3a2c1841 = $159afdcd077ecfe9$export$ca6fd367f31ecbc5;
var $159afdcd077ecfe9$export$e119aada7f690d05 = {
    prefix: 'fas',
    iconName: 'universal-access',
    icon: [
        512,
        512,
        [],
        "f29a",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm161.5-86.1c-12.2-5.2-26.3 .4-31.5 12.6s.4 26.3 12.6 31.5l11.9 5.1c17.3 7.4 35.2 12.9 53.6 16.3l0 50.1c0 4.3-.7 8.6-2.1 12.6l-28.7 86.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l24.4-73.2c1.3-3.8 4.8-6.4 8.8-6.4s7.6 2.6 8.8 6.4l24.4 73.2c4.2 12.6 17.8 19.4 30.4 15.2S339 397 334.8 384.4l-28.7-86.1c-1.4-4.1-2.1-8.3-2.1-12.6l0-50.1c18.4-3.5 36.3-8.9 53.6-16.3l11.9-5.1c12.2-5.2 17.8-19.3 12.6-31.5s-19.3-17.8-31.5-12.6L338.7 175c-26.1 11.2-54.2 17-82.7 17s-56.5-5.8-82.7-17l-11.9-5.1zM256 160a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $159afdcd077ecfe9$export$c8cc083ccc72b17 = {
    prefix: 'fas',
    iconName: 'toilet-paper',
    icon: [
        512,
        512,
        [
            129531,
            63263,
            "toilet-paper-alt",
            "toilet-paper-blank"
        ],
        "f71e",
        "M327.1 32c-8.8 11.1-16 23.1-21.9 34.8-21.4 42.7-33.2 98.4-33.2 157.2l0 264c0 30.9-25.1 56-56 56L56 544c-30.9 0-56-25.1-56-56L0 224C0 118 43 32 96 32l231.1 0zM416 416c-53 0-96-86-96-192s43-192 96-192 96 86 96 192-43 192-96 192zm0-128c17.7 0 32-28.7 32-64s-14.3-64-32-64-32 28.7-32 64 14.3 64 32 64z"
    ]
};
var $159afdcd077ecfe9$export$b999a758e19c286d = $159afdcd077ecfe9$export$c8cc083ccc72b17;
var $159afdcd077ecfe9$export$53ed521aed6cf942 = $159afdcd077ecfe9$export$c8cc083ccc72b17;
var $159afdcd077ecfe9$export$248171cb6dad4307 = {
    prefix: 'fas',
    iconName: 'vr-cardboard',
    icon: [
        576,
        512,
        [],
        "f729",
        "M512 96L64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l117.5 0c17 0 33.3-6.7 45.3-18.7l33.9-33.9c7.2-7.2 17.1-11.3 27.3-11.3s20.1 4.1 27.3 11.3l33.9 33.9c12 12 28.3 18.7 45.3 18.7L512 416c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64zM80 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm352-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
    ]
};
var $159afdcd077ecfe9$export$c9f93c4667edc585 = {
    prefix: 'fas',
    iconName: 'pizza-slice',
    icon: [
        512,
        512,
        [],
        "f818",
        "M169.7 .9c-22.8-1.6-41.9 14-47.5 34.7L112.5 72C293.3 72.3 439.7 218.7 440 399.5l36.4-9.7c20.8-5.5 36.3-24.7 34.7-47.5-12.6-182.8-158.6-328.8-341.4-341.4zm222 411.5c.2-4.1 .3-8.2 .3-12.4 0-154.6-125.4-280-280-280-4.1 0-8.3 .1-12.4 .3L.5 491.9c-1.5 5.5 .1 11.4 4.1 15.4s9.9 5.6 15.4 4.1l371.6-99.1zM176 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 384a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$4952c502f544cf85 = {
    prefix: 'fas',
    iconName: 'spray-can',
    icon: [
        576,
        512,
        [],
        "f5bd",
        "M192 0l64 0c17.7 0 32 14.3 32 32l0 80-128 0 0-80c0-17.7 14.3-32 32-32zM64 256c0-53 43-96 96-96l128 0c53 0 96 43 96 96l0 208c0 26.5-21.5 48-48 48l-224 0c-26.5 0-48-21.5-48-48l0-208zm240 80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM320 64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm64 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM512 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM448 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$2b1464e7557b18eb = {
    prefix: 'fas',
    iconName: 'volume-low',
    icon: [
        448,
        512,
        [
            128264,
            "volume-down"
        ],
        "f027",
        "M48 352l48 0 134.1 119.2c6.4 5.7 14.6 8.8 23.1 8.8 19.2 0 34.8-15.6 34.8-34.8l0-378.4c0-19.2-15.6-34.8-34.8-34.8-8.5 0-16.7 3.1-23.1 8.8L96 160 48 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48zM380.6 181.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C361.1 227.6 368 241 368 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C402.1 312.9 416 286.1 416 256s-13.9-56.9-35.5-74.5z"
    ]
};
var $159afdcd077ecfe9$export$69fdf57632b6cc29 = $159afdcd077ecfe9$export$2b1464e7557b18eb;
var $159afdcd077ecfe9$export$9d0a89fcd084abb = {
    prefix: 'fas',
    iconName: 'cross',
    icon: [
        384,
        512,
        [
            128327,
            10013
        ],
        "f654",
        "M176 0c-26.5 0-48 21.5-48 48l0 80-80 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l80 0 0 208c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-208 80 0c26.5 0 48-21.5 48-48l0-32c0-26.5-21.5-48-48-48l-80 0 0-80c0-26.5-21.5-48-48-48L176 0z"
    ]
};
var $159afdcd077ecfe9$export$e6619e43cb090a16 = {
    prefix: 'fas',
    iconName: 'person',
    icon: [
        384,
        512,
        [
            129485,
            "male"
        ],
        "f183",
        "M248 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 212.7l46.3 62.4c10.5 14.2 30.6 17.2 44.8 6.6s17.2-30.6 6.6-44.8l-70.5-95C274 132 234.3 112 192 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L112 236.7 112 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-275.3z"
    ]
};
var $159afdcd077ecfe9$export$2e21f9dba1630651 = $159afdcd077ecfe9$export$e6619e43cb090a16;
var $159afdcd077ecfe9$export$b9098a890f61e022 = {
    prefix: 'fas',
    iconName: 'hourglass',
    icon: [
        384,
        512,
        [
            9203,
            62032,
            "hourglass-empty"
        ],
        "f254",
        "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 11c0 42.4-16.9 83.1-46.9 113.1l-67.9 67.9 67.9 67.9c30 30 46.9 70.7 46.9 113.1l0 11c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-11c0-42.4 16.9-83.1 46.9-113.1l67.9-67.9-67.9-67.9C48.9 158.1 32 117.4 32 75l0-11C14.3 64 0 49.7 0 32zM96 64l0 11c0 25.5 10.1 49.9 28.1 67.9l67.9 67.9 67.9-67.9c18-18 28.1-42.4 28.1-67.9l0-11-192 0zm0 384l192 0 0-11c0-25.5-10.1-49.9-28.1-67.9l-67.9-67.9-67.9 67.9c-18 18-28.1 42.4-28.1 67.9l0 11z"
    ]
};
var $159afdcd077ecfe9$export$a2f8176a0161e891 = $159afdcd077ecfe9$export$b9098a890f61e022;
var $159afdcd077ecfe9$export$24228a855c5f6812 = {
    prefix: 'fas',
    iconName: 'fish',
    icon: [
        576,
        512,
        [
            128031
        ],
        "f578",
        "M180.5 141.5C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8 4.7 9.2 4.7 20.1 0 29.3-14.1 27.4-41.9 66.8-81 99.8-39.2 33.1-92 61.5-155.5 61.5s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1L48.1 379.6c-12.5 7.3-28.4 5.3-38.7-4.9s-12.4-26-5.3-38.6L50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1zM448 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $159afdcd077ecfe9$export$482976e9a4ab10f3 = {
    prefix: 'fas',
    iconName: 'drumstick-bite',
    icon: [
        512,
        512,
        [],
        "f6d7",
        "M160 265.2c0 8.5-3.4 16.6-9.4 22.6l-26.8 26.8c-12.3 12.3-32.5 11.4-49.4 7.2-4.6-1.1-9.5-1.8-14.5-1.8-33.1 0-60 26.9-60 60s26.9 60 60 60c6.3 0 12 5.7 12 12 0 33.1 26.9 60 60 60s60-26.9 60-60c0-5-.6-9.8-1.8-14.5-4.2-16.9-5.2-37.1 7.2-49.4l26.8-26.8c6-6 14.1-9.4 22.6-9.4l89.2 0c6.3 0 12.4-.3 18.5-1 11.9-1.2 16.4-15.5 10.8-26-8.5-15.8-13.3-33.8-13.3-53 0-61.9 50.1-112 112-112 8 0 15.7 .8 23.2 2.4 11.7 2.5 24.1-5.9 22-17.6-14.7-82.3-86.7-144.8-173.2-144.8-97.2 0-176 78.8-176 176l0 89.2z"
    ]
};
var $159afdcd077ecfe9$export$8760a1de19ea40b9 = {
    prefix: 'fas',
    iconName: 'chart-simple',
    icon: [
        512,
        512,
        [],
        "e473",
        "M192 80c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-352zM0 272c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 160c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48L0 272zM432 96l32 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48z"
    ]
};
var $159afdcd077ecfe9$export$b5bb295e8ad4ab31 = {
    prefix: 'fas',
    iconName: 'atom',
    icon: [
        448,
        512,
        [
            9883
        ],
        "f5d2",
        "M224 398.8c-11.8 5.1-23.4 9.7-34.9 13.5 16.7 33.8 31 35.7 34.9 35.7s18.1-1.9 34.9-35.7c-11.4-3.9-23.1-8.4-34.9-13.5zM414 256c33 45.2 44.3 90.9 23.6 128-20.2 36.3-62.5 49.3-115.2 43.2-22 52.1-55.7 84.8-98.4 84.8s-76.4-32.7-98.4-84.8C72.9 433.3 30.6 420.3 10.4 384-10.3 346.9 1 301.2 34 256 1 210.8-10.3 165.1 10.4 128 30.6 91.7 72.9 78.7 125.6 84.8 147.6 32.7 181.2 0 224 0s76.4 32.7 98.4 84.8c52.7-6.1 95 6.8 115.2 43.2 20.7 37.1 9.4 82.8-23.6 128zm-65.8 67.4c-1.7 14.2-3.9 28-6.7 41.2 31.8 1.4 38.6-8.7 40.2-11.7 2.3-4.2 7-17.9-11.9-48.1-6.8 6.3-14 12.5-21.6 18.6zm-6.7-175.9c2.8 13.1 5 26.9 6.7 41.2 7.6 6.1 14.8 12.3 21.6 18.6 18.9-30.2 14.2-44 11.9-48.1-1.6-2.9-8.4-13-40.2-11.7zM258.9 99.7C242.1 65.9 227.9 64 224 64s-18.1 1.9-34.9 35.7c11.4 3.9 23.1 8.4 34.9 13.5 11.8-5.1 23.4-9.7 34.9-13.5zm-159 88.9c1.7-14.3 3.9-28 6.7-41.2-31.8-1.4-38.6 8.7-40.2 11.7-2.3 4.2-7 17.9 11.9 48.1 6.8-6.3 14-12.5 21.6-18.6zM78.2 304.8c-18.9 30.2-14.2 44-11.9 48.1 1.6 2.9 8.4 13 40.2 11.7-2.8-13.1-5-26.9-6.7-41.2-7.6-6.1-14.8-12.3-21.6-18.6zM304 256a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$bcb419f1cd5beac3 = {
    prefix: 'fas',
    iconName: 'p',
    icon: [
        320,
        512,
        [
            112
        ],
        "50",
        "M0 64C0 46.3 14.3 32 32 32l128 0c88.4 0 160 71.6 160 160S248.4 352 160 352l-96 0 0 96c0 17.7-14.3 32-32 32S0 465.7 0 448L0 64zM64 288l96 0c53 0 96-43 96-96s-43-96-96-96l-96 0 0 192z"
    ]
};
var $159afdcd077ecfe9$export$b024a52a4ccf5e69 = {
    prefix: 'fas',
    iconName: 'jet-fighter-up',
    icon: [
        512,
        512,
        [],
        "e518",
        "M206.8 47.8C202.3 58.5 200 70 200 81.6l0 100.4-152 114 0-48c0-13.3-10.7-24-24-24S0 234.7 0 248L0 392c0 13.3 10.7 24 24 24s24-10.7 24-24l0-8 152 0 0 54.4-66 52.8c-3.8 3-6 7.6-6 12.5l0 24.3c0 8.8 7.2 16 16 16l88 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 88 0c8.8 0 16-7.2 16-16l0-24.3c0-4.9-2.2-9.5-6-12.5l-66-52.8 0-54.4 152 0 0 8c0 13.3 10.7 24 24 24s24-10.7 24-24l0-144c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48-152-114 0-100.4c0-11.6-2.3-23.1-6.8-33.8l-27.1-65C274.4-26.2 265.7-32 256-32s-18.4 5.8-22.2 14.8l-27.1 65z"
    ]
};
var $159afdcd077ecfe9$export$12ef959394d63192 = {
    prefix: 'fas',
    iconName: 'plug-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e560",
        "M192-32c17.7 0 32 14.3 32 32l0 96 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7C165.2 398.1 96 319.1 96 224l0-64c-17.7 0-32-14.3-32-32S78.3 96 96 96l64 0 0-96c0-17.7 14.3-32 32-32zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-36.7 36.7-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-36.7-36.7 36.7-36.7z"
    ]
};
var $159afdcd077ecfe9$export$57f2bcd070bff91a = {
    prefix: 'fas',
    iconName: 'sheet-plastic',
    icon: [
        384,
        512,
        [],
        "e571",
        "M0 448c0 35.3 28.7 64 64 64l149.5 0c17 0 33.3-6.7 45.3-18.7L365.3 386.7c12-12 18.7-28.3 18.7-45.3L384 64c0-35.3-28.7-64-64-64L64 0C28.7 0 0 28.7 0 64L0 448zm208 5.5l0-93.5c0-13.3 10.7-24 24-24l93.5 0-117.5 117.5zM153 105l-48 48c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zm96 32L137 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L215 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"
    ]
};
var $159afdcd077ecfe9$export$6fb446f784f6b9b3 = {
    prefix: 'fas',
    iconName: 'v',
    icon: [
        384,
        512,
        [
            118
        ],
        "56",
        "M19.7 34.5c16.3-6.8 35 .9 41.8 17.2L192 364.8 322.5 51.7c6.8-16.3 25.5-24 41.8-17.2s24 25.5 17.2 41.8l-160 384c-5 11.9-16.6 19.7-29.5 19.7s-24.6-7.8-29.5-19.7L2.5 76.3c-6.8-16.3 .9-35 17.2-41.8z"
    ]
};
var $159afdcd077ecfe9$export$6cfc59842fedbc16 = {
    prefix: 'fas',
    iconName: 'list',
    icon: [
        512,
        512,
        [
            "list-squares"
        ],
        "f03a",
        "M40 48C26.7 48 16 58.7 16 72l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24L40 48zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM16 232l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"
    ]
};
var $159afdcd077ecfe9$export$e3f160fc949c2b9d = $159afdcd077ecfe9$export$6cfc59842fedbc16;
var $159afdcd077ecfe9$export$b9c649c5e37017f3 = {
    prefix: 'fas',
    iconName: 'solar-panel',
    icon: [
        576,
        512,
        [],
        "f5ba",
        "M121.8 32c-30 0-56 20.8-62.5 50.1L9.6 306.1C.7 346.1 31.1 384 72 384l184.1 0 0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64 184.1 0c40.9 0 71.4-37.9 62.5-77.9l-49.8-224C510.4 52.8 484.5 32 454.5 32L121.8 32zM245.6 96l85.2 0 7.3 88-99.8 0 7.3-88zm-55.5 88l-87.8 0 19.6-88 75.6 0-7.3 88zM91.6 232l94.5 0-7.3 88-106.7 0 19.6-88zm142.6 0l107.8 0 7.3 88-122.5 0 7.3-88zm156 0l94.5 0 19.6 88-106.7 0-7.3-88zM474 184l-87.8 0-7.3-88 75.6 0 19.6 88z"
    ]
};
var $159afdcd077ecfe9$export$567a897fc092e403 = {
    prefix: 'fas',
    iconName: 'land-mine-on',
    icon: [
        576,
        512,
        [],
        "e51b",
        "M312 0l0 128c0 13.3-10.7 24-24 24s-24-10.7-24-24L264 0c0-13.3 10.7-24 24-24s24 10.7 24 24zM160 288c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 32 80 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L80 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l80 0 0-32zM12 114.7c7.4-11 22.3-14 33.3-6.7l96 64c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-96-64c-11-7.4-14-22.3-6.7-33.3zM530.7 108c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l96-64z"
    ]
};
var $159afdcd077ecfe9$export$ad02dd8ca5816958 = {
    prefix: 'fas',
    iconName: 'headphones',
    icon: [
        448,
        512,
        [
            127911,
            62863,
            "headphones-alt",
            "headphones-simple"
        ],
        "f025",
        "M64 224c0-88.4 71.6-160 160-160s160 71.6 160 160l0 37.5c-10-3.5-20.8-5.5-32-5.5l-16 0c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48l16 0c53 0 96-43 96-96l0-160C448 100.3 347.7 0 224 0S0 100.3 0 224L0 384c0 53 43 96 96 96l16 0c26.5 0 48-21.5 48-48l0-128c0-26.5-21.5-48-48-48l-16 0c-11.2 0-22 1.9-32 5.5L64 224z"
    ]
};
var $159afdcd077ecfe9$export$6f0433fa527dd5be = $159afdcd077ecfe9$export$ad02dd8ca5816958;
var $159afdcd077ecfe9$export$ca47801915e5a685 = $159afdcd077ecfe9$export$ad02dd8ca5816958;
var $159afdcd077ecfe9$export$ce69441578ff2fdb = {
    prefix: 'fas',
    iconName: 'bus',
    icon: [
        448,
        512,
        [
            128653
        ],
        "f207",
        "M96 0C43 0 0 43 0 96L0 384c0 29.8 20.4 54.9 48 62l0 34c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-32 192 0 0 32c0 17.7 14.3 32 32 32l16 0c17.7 0 32-14.3 32-32l0-34c27.6-7.1 48-32.2 48-62l0-288c0-53-43-96-96-96L96 0zM64 176c0-17.7 14.3-32 32-32l104 0 0 112-104 0c-17.7 0-32-14.3-32-32l0-48zm184 80l0-112 104 0c17.7 0 32 14.3 32 32l0 48c0 17.7-14.3 32-32 32l-104 0zM96 320a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm256 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM152 72c0-13.3 10.7-24 24-24l96 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-96 0c-13.3 0-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$c341daeecdea449a = {
    prefix: 'fas',
    iconName: 'file-powerpoint',
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM152 256c-13.3 0-24 10.7-24 24l0 144c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 24 0c39.8 0 72-32.2 72-72s-32.2-72-72-72l-48 0zm48 96l-24 0 0-48 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
    ]
};
var $159afdcd077ecfe9$export$932a67a1b1a7a724 = {
    prefix: 'fas',
    iconName: 'quote-left',
    icon: [
        448,
        512,
        [
            8220,
            "quote-left-alt"
        ],
        "f10d",
        "M0 216C0 149.7 53.7 96 120 96l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64L0 216zm256 0c0-66.3 53.7-120 120-120l8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0c-30.9 0-56 25.1-56 56l0 8 64 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64l-64 0c-35.3 0-64-28.7-64-64l0-136z"
    ]
};
var $159afdcd077ecfe9$export$95bb9ad3aa35c741 = $159afdcd077ecfe9$export$932a67a1b1a7a724;
var $159afdcd077ecfe9$export$8db9bc521720fccd = {
    prefix: 'fas',
    iconName: 'chevron-down',
    icon: [
        448,
        512,
        [],
        "f078",
        "M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
    ]
};
var $159afdcd077ecfe9$export$807cdd395fe012cb = {
    prefix: 'fas',
    iconName: 'earth-asia',
    icon: [
        512,
        512,
        [
            127759,
            "globe-asia"
        ],
        "f57e",
        "M50 284.8c4.2 2.1 9 3.2 14 3.2l50.7 0c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3c6 6 14.1 9.4 22.6 9.4l18.7 0c17.7 0 32-14.3 32-32l0-40c0-13.3 10.7-24 24-24s24-10.7 24-24l0-42.7c0-8.5 3.4-16.6 9.4-22.6l13.3-13.3c6-6 9.4-14.1 9.4-22.6L304 57c0-1.2-.1-2.3-.2-3.5-15.4-3.6-31.4-5.5-47.8-5.5-114.9 0-208 93.1-208 208 0 9.8 .7 19.4 2 28.8zm403.3 37.3c-3.2-1.4-6.7-2.1-10.5-2.1L432 320c-8.8 0-16-7.2-16-16s-7.2-16-16-16l-34.7 0c-8.5 0-16.6 3.4-22.6 9.4l-45.3 45.3c-6 6-9.4 14.1-9.4 22.6l0 18.7c0 17.7 14.3 32 32 32l18.7 0c8.5 0 16.6 3.4 22.6 9.4 2.2 2.2 4.7 4.1 7.3 5.5 39.3-25.4 69.5-63.6 84.6-108.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM128 368c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM272 256c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16zm48-112l0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ]
};
var $159afdcd077ecfe9$export$796fdfc909e603f4 = $159afdcd077ecfe9$export$807cdd395fe012cb;
var $159afdcd077ecfe9$export$875b6c94a4b00ea8 = {
    prefix: 'fas',
    iconName: 'cent-sign',
    icon: [
        384,
        512,
        [],
        "e3f5",
        "M208 0c17.7 0 32 14.3 32 32l0 25.4c43.6 5.2 83 24.5 113.3 53.1 12.9 12.1 13.4 32.4 1.3 45.2s-32.4 13.4-45.2 1.3c-24.4-23-57.2-37.1-93.3-37.1-75.1 0-136 60.9-136 136s60.9 136 136 136c36.2 0 69-14.1 93.3-37.1 12.9-12.1 33.1-11.5 45.2 1.3s11.5 33.1-1.3 45.2C323 430.1 283.6 449.4 240 454.6l0 25.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-28C84.7 433.5 16 352.8 16 256S84.7 78.5 176 60l0-28c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$1639f087457d4f58 = {
    prefix: 'fas',
    iconName: 'shield-cat',
    icon: [
        512,
        512,
        [],
        "e572",
        "M269.4 2.9C265.2 1 260.7 0 256 0s-9.2 1-13.4 2.9L54.3 82.8c-22 9.3-38.4 31-38.3 57.2 .5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0 172.4-82.5 213.2-264 213.6-363.2 .1-26.2-16.3-47.9-38.3-57.2L269.4 2.9zM160 154.4c0-5.8 4.7-10.4 10.4-10.4l.2 0c3.4 0 6.5 1.6 8.5 4.3l40 53.3c3 4 7.8 6.4 12.8 6.4l48 0c5 0 9.8-2.4 12.8-6.4l40-53.3c2-2.7 5.2-4.3 8.5-4.3l.2 0c5.8 0 10.4 4.7 10.4 10.4L352 272c0 53-43 96-96 96s-96-43-96-96l0-117.6zM216 288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm96-16a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $159afdcd077ecfe9$export$c8c95c2f9937bf6a = {
    prefix: 'fas',
    iconName: 'school-circle-check',
    icon: [
        640,
        512,
        [],
        "e56b",
        "M64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l276 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-88c0-22.1 17.9-40 40-40l48 0c1 0 1.9 0 2.9 .1 26.3-74.6 97.5-128.1 181.1-128.1 28.6 0 55.6 6.2 80 17.4l0-33.4c0-35.3-28.7-64-64-64l-64 0-127.9-115.1c-18.3-16.4-46-16.4-64.2 0L128 128 64 128zm64 240c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM112 256l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM288 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-86.6-60.9c7.1 5.2 8.7 15.2 3.5 22.3l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5z"
    ]
};
var $159afdcd077ecfe9$export$98401bb29cff68e0 = {
    prefix: 'fas',
    iconName: 'martini-glass',
    icon: [
        512,
        512,
        [
            127864,
            "glass-martini-alt"
        ],
        "f57b",
        "M2.4 51.8C7.4 39.8 19.1 32 32 32l448 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L288 301.3 288 448 352 448c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 0-146.7-214.6-214.6C.2 77.5-2.5 63.7 2.4 51.8zM354.7 144l48-48-293.5 0 48 48 197.5 0z"
    ]
};
var $159afdcd077ecfe9$export$2258439b8f4e7acb = $159afdcd077ecfe9$export$98401bb29cff68e0;
var $159afdcd077ecfe9$export$cae5752c3e3b6545 = {
    prefix: 'fas',
    iconName: 'plug',
    icon: [
        448,
        512,
        [
            128268
        ],
        "f1e6",
        "M128-32c17.7 0 32 14.3 32 32l0 96 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 64c0 95.1-69.2 174.1-160 189.3l0 66.7c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7C101.2 398.1 32 319.1 32 224l0-64c-17.7 0-32-14.3-32-32S14.3 96 32 96l64 0 0-96c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$5dd22dcb6e3ed369 = {
    prefix: 'fas',
    iconName: 'panorama',
    icon: [
        576,
        512,
        [],
        "e209",
        "M43.9 48C19.7 48 0 67.7 0 91.9L0 420.1c0 24.3 19.7 43.9 43.9 43.9 5.5 0 10.7-1 15.7-2.9 12.9-4.9 103.4-37.1 228.4-37.1s215.5 32.3 228.4 37.1c5 1.9 10.2 2.9 15.7 2.9 24.3 0 43.9-19.7 43.9-43.9l0-328.2c0-24.3-19.7-43.9-43.9-43.9-5.5 0-10.7 1-15.7 2.9-12.9 4.9-103.4 37.1-228.4 37.1S72.5 55.7 59.6 50.9C54.6 49 49.4 48 43.9 48zM72 176a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm264.1-16c7.5 0 14.6 3.6 19.1 9.6L479.7 336.2c5.9 7.9 6.4 18.5 1.3 26.9s-14.8 12.8-24.5 11.1c-45.8-7.8-103.3-14.2-168.4-14.2-65.6 0-123.4 6.5-169.3 14.4-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L165.3 249c4.6-5.7 11.5-9 18.7-9s14.2 3.3 18.7 9l27.5 34.4 86.7-113.9c4.6-6 11.7-9.5 19.2-9.5z"
    ]
};
var $159afdcd077ecfe9$export$29be1665d1b36a3b = {
    prefix: 'fas',
    iconName: 'clock-rotate-left',
    icon: [
        576,
        512,
        [
            "history"
        ],
        "f1da",
        "M288 64c106 0 192 86 192 192S394 448 288 448c-65.2 0-122.9-32.5-157.6-82.3-10.1-14.5-30.1-18-44.6-7.9s-18 30.1-7.9 44.6C124.1 468.6 201 512 288 512 429.4 512 544 397.4 544 256S429.4 0 288 0C202.3 0 126.5 42.1 80 106.7L80 80c0-17.7-14.3-32-32-32S16 62.3 16 80l0 112c0 17.7 14.3 32 32 32l24.6 0c.5 0 1 0 1.5 0l86 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-38.3 0C154.9 102.6 217 64 288 64zm24 88c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 104c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65 0-94.1z"
    ]
};
var $159afdcd077ecfe9$export$76d1986559ca7b7a = $159afdcd077ecfe9$export$29be1665d1b36a3b;
var $159afdcd077ecfe9$export$8b503c1d76716ddd = {
    prefix: 'fas',
    iconName: 'jar-wheat',
    icon: [
        320,
        512,
        [],
        "e517",
        "M32-8c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 16C42.7 16 32 5.3 32-8zM0 128C0 92.7 28.7 64 64 64l192 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128zm112 32l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8 0 32.1 26 58.2 58.2 58.2l75.6 0c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8L208 160c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7zm48 117.7c-11.7-13.3-28.9-21.7-48-21.7l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8 0 32.1 26 58.2 58.2 58.2l75.6 0c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8L208 256c-19.1 0-36.3 8.4-48 21.7zM112 352l-42.2 0c-3.2 0-5.8 2.6-5.8 5.8 0 32.1 26 58.2 58.2 58.2l21.8 0 0 32c0 8.8 7.2 16 16 16s16-7.2 16-16l0-32 21.8 0c32.1 0 58.2-26 58.2-58.2 0-3.2-2.6-5.8-5.8-5.8L208 352c-19.1 0-36.3 8.4-48 21.7-11.7-13.3-28.9-21.7-48-21.7z"
    ]
};
var $159afdcd077ecfe9$export$542a9676c5286e01 = {
    prefix: 'fas',
    iconName: 'cloud-arrow-down',
    icon: [
        576,
        512,
        [
            62337,
            "cloud-download",
            "cloud-download-alt"
        ],
        "f0ed",
        "M144 480c-79.5 0-144-64.5-144-144 0-63.4 41-117.2 97.9-136.5-1.3-7.7-1.9-15.5-1.9-23.5 0-79.5 64.5-144 144-144 55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96 0 15.7-3.8 30.6-10.5 43.7 44 20.3 74.5 64.7 74.5 116.3 0 70.7-57.3 128-128 128l-304 0zM377 313c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-102.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72z"
    ]
};
var $159afdcd077ecfe9$export$b318977f29260464 = $159afdcd077ecfe9$export$542a9676c5286e01;
var $159afdcd077ecfe9$export$351357a14c41f824 = $159afdcd077ecfe9$export$542a9676c5286e01;
var $159afdcd077ecfe9$export$37396c36c76937bc = {
    prefix: 'fas',
    iconName: 'truck-ramp-box',
    icon: [
        576,
        512,
        [
            "truck-loading"
        ],
        "f4de",
        "M400 32c-44.2 0-80 35.8-80 80l0 248.2-297.2 89.2C5.9 454.4-3.7 472.3 1.4 489.2s22.9 26.5 39.8 21.5l315.5-94.6 43.7 0c-.2 2.6-.4 5.3-.4 8 0 48.6 39.4 88 88 88s88-39.4 88-88l0-392-176 0zM528 424c0 22.1-17.9 40-40 40s-40-17.9-40-40 17.9-40 40-40c22.1 0 39.9 17.9 40 39.9l0 .1zM51.9 149.5C18.1 159.8-.9 195.6 9.4 229.4l28.1 91.8C47.8 355 83.6 374 117.4 363.7l91.8-28.1c33.8-10.3 52.8-46.1 42.5-79.9l-28.1-91.8c-10.3-33.8-46.1-52.8-79.9-42.5L51.9 149.5z"
    ]
};
var $159afdcd077ecfe9$export$f00c152db7d44638 = $159afdcd077ecfe9$export$37396c36c76937bc;
var $159afdcd077ecfe9$export$4b5be0142d10f342 = {
    prefix: 'fas',
    iconName: 'angle-down',
    icon: [
        384,
        512,
        [
            8964
        ],
        "f107",
        "M169.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 306.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $159afdcd077ecfe9$export$2bd45e99b9afa947 = {
    prefix: 'fas',
    iconName: 'plug-circle-check',
    icon: [
        640,
        512,
        [],
        "e55c",
        "M192-32c17.7 0 32 14.3 32 32l0 96 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7C165.2 398.1 96 319.1 96 224l0-64c-17.7 0-32-14.3-32-32S78.3 96 96 96l64 0 0-96c0-17.7 14.3-32 32-32zM352 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm201.4-60.9c-7.1-5.2-17.2-3.6-22.4 3.5l-53 72.9-26.8-26.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c3.3 3.3 7.9 5 12.6 4.6s8.9-2.8 11.7-6.5l64-88c5.2-7.1 3.6-17.2-3.5-22.3z"
    ]
};
var $159afdcd077ecfe9$export$703cd98be31ec905 = {
    prefix: 'fas',
    iconName: 'window-maximize',
    icon: [
        512,
        512,
        [
            128470
        ],
        "f2d0",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm24 64l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L88 176c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$3aa81d0e606b08b6 = {
    prefix: 'fas',
    iconName: 'hands-holding-circle',
    icon: [
        640,
        512,
        [],
        "e4fb",
        "M320 0a128 128 0 1 1 0 256 128 128 0 1 1 0-256zM40 64c22.1 0 40 17.9 40 40l0 160.2c0 17 6.7 33.3 18.7 45.3l51.1 51.1c8.3 8.3 21.3 9.6 31 3.1 12.9-8.6 14.7-26.9 3.7-37.8-7.3-7.3-23.1-23.1-47.2-47.2-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c24.1 24.1 39.9 39.9 47.2 47.2l0 0 25.3 25.3c21 21 32.8 49.5 32.8 79.2l0 78.9c0 26.5-21.5 48-48 48l-66.7 0c-17 0-33.3-6.7-45.3-18.7L28.1 393.4C10.1 375.4 0 351 0 325.5L0 104C0 81.9 17.9 64 40 64zm560 0c22.1 0 40 17.9 40 40l0 221.5c0 25.5-10.1 49.9-28.1 67.9L512 493.3c-12 12-28.3 18.7-45.3 18.7L400 512c-26.5 0-48-21.5-48-48l0-78.9c0-29.7 11.8-58.2 32.8-79.2l25.3-25.3 0 0c7.3-7.3 23.1-23.1 47.2-47.2 12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-24.1 24.1-39.9 39.9-47.2 47.2-11 11-9.2 29.2 3.7 37.8 9.7 6.5 22.7 5.2 31-3.1l51.1-51.1c12-12 18.7-28.3 18.7-45.3L560 104c0-22.1 17.9-40 40-40z"
    ]
};
var $159afdcd077ecfe9$export$c0b7617de95c0c05 = {
    prefix: 'fas',
    iconName: 'location-pin',
    icon: [
        384,
        512,
        [
            "map-marker"
        ],
        "f041",
        "M192 0C86 0 0 84.4 0 188.6 0 307.9 120.2 450.9 170.4 505.4 182.2 518.2 201.8 518.2 213.6 505.4 263.8 450.9 384 307.9 384 188.6 384 84.4 298 0 192 0z"
    ]
};
var $159afdcd077ecfe9$export$10d360e4f1a554dd = $159afdcd077ecfe9$export$c0b7617de95c0c05;
var $159afdcd077ecfe9$export$5ee2640fe105312d = {
    prefix: 'fas',
    iconName: 'bowling-ball',
    icon: [
        512,
        512,
        [],
        "f436",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM208 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-64-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$df587aaf7765e1ce = {
    prefix: 'fas',
    iconName: 'cart-flatbed',
    icon: [
        576,
        512,
        [
            "dolly-flatbed"
        ],
        "f474",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l16 0c8.8 0 16 7.2 16 16l0 288c0 39.8 29.1 72.8 67.1 79-2 5.3-3.1 11-3.1 17 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l197.5 0c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16l34.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-400 0c-8.8 0-16-7.2-16-16l0-288C128 35.8 92.2 0 48 0L32 0zM224 64c-26.5 0-48 21.5-48 48l0 176c0 26.5 21.5 48 48 48l240 0c26.5 0 48-21.5 48-48l0-176c0-26.5-21.5-48-48-48L224 64z"
    ]
};
var $159afdcd077ecfe9$export$f7c6efb60c53b285 = $159afdcd077ecfe9$export$df587aaf7765e1ce;
var $159afdcd077ecfe9$export$9a513ee921e8e885 = {
    prefix: 'fas',
    iconName: 'house-user',
    icon: [
        512,
        512,
        [
            "home-user"
        ],
        "e1b0",
        "M277.8 8.6c-12.3-11.4-31.3-11.4-43.5 0l-224 208c-9.6 9-12.8 22.9-8 35.1S18.8 272 32 272l16 0 0 176c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-176 16 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8-35.1l-224-208zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM144 432c0-44.2 35.8-80 80-80l64 0c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16z"
    ]
};
var $159afdcd077ecfe9$export$e732fa55ae5bbdf0 = $159afdcd077ecfe9$export$9a513ee921e8e885;
var $159afdcd077ecfe9$export$1a989eb1919c64c1 = {
    prefix: 'fas',
    iconName: 'ghost',
    icon: [
        384,
        512,
        [
            128123
        ],
        "f6e2",
        "M40.1 467.1l-11.2 9C25.7 478.6 21.8 480 17.8 480 8 480 0 472 0 462.2L0 192C0 86 86 0 192 0S384 86 384 192l0 270.2c0 9.8-8 17.8-17.8 17.8-4 0-7.9-1.4-11.1-3.9l-11.2-9c-13.4-10.7-32.8-9-44.1 3.9L269.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6l-26.6-30.5c-12.7-14.6-35.4-14.6-48.2 0L141.3 506c-3.3 3.8-8.2 6-13.3 6s-9.9-2.2-13.3-6L84.2 471c-11.3-12.9-30.7-14.6-44.1-3.9zM160 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$6754d04baba2fe26 = {
    prefix: 'fas',
    iconName: 'comment-nodes',
    icon: [
        640,
        512,
        [],
        "e696",
        "M480 208C503.7 208 525.6 215.3 543.7 227.9 536.9 100.9 425 0 288 0 146.6 0 32 107.5 32 240 32 294.3 51.2 344.3 83.6 384.5L34.8 476.8c-4.8 9-3.3 20 3.6 27.5s17.8 9.8 27.1 5.8l118.4-50.7c27.2 11.4 56.9 18.4 88.1 20.2 .1-18.9 4.9-38 15-55.5 17.1-29.7 45.8-48.5 77-54.2l9.2-16c-3.4-10.7-5.2-22-5.2-33.8 0-61.9 50.1-112 112-112zM328.6 448c-17.7 30.6-7.2 69.7 23.4 87.4s69.7 7.2 87.4-23.4c1.5-2.6 2.8-5.3 3.9-8l73.3 0c1.1 2.7 2.4 5.4 3.9 8 17.7 30.6 56.8 41.1 87.4 23.4s41.1-56.8 23.4-87.4c-13.4-23.2-39.1-34.8-64-31.4l-17.6-30.7c-11 11.7-25 20.6-40.6 25.6l16.5 28.9c-3.8 4.8-6.8 10-9 15.6l-73.4 0c-2.2-5.6-5.3-10.8-9-15.6l33-57.7c4.1 .8 8.4 1.3 12.8 1.3 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 13.4 4.1 25.8 11.2 36.1l-34.6 60.5c-25-3.4-50.6 8.3-64 31.4z"
    ]
};
var $159afdcd077ecfe9$export$f9a5161975928326 = {
    prefix: 'fas',
    iconName: 'person-arrow-down-to-line',
    icon: [
        576,
        512,
        [],
        "e538",
        "M192-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM318.3 299.1l-46.3-62.4 0 243.3 272 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 544c-17.7 0-32-14.3-32-32s14.3-32 32-32l80 0 0-243.3-46.3 62.4c-10.5 14.2-30.6 17.2-44.8 6.6s-17.2-30.6-6.6-44.8l70.5-95C110 132 149.7 112 192 112s82 20 107.2 53.9l70.5 95c10.5 14.2 7.6 34.2-6.6 44.8s-34.2 7.6-44.8-6.6zM176 480l32 0 0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128zM566.6 166.6l-80 80c-12.5 12.5-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L432 146.7 432 0c0-17.7 14.3-32 32-32s32 14.3 32 32l0 146.7 25.4-25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3z"
    ]
};
var $159afdcd077ecfe9$export$f193138a7d21971c = {
    prefix: 'fas',
    iconName: 'plug-circle-plus',
    icon: [
        640,
        512,
        [],
        "e55f",
        "M192-32c17.7 0 32 14.3 32 32l0 96 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7C165.2 398.1 96 319.1 96 224l0-64c-17.7 0-32-14.3-32-32S78.3 96 96 96l64 0 0-96c0-17.7 14.3-32 32-32zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48-48 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0 0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48 48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0 0-48z"
    ]
};
var $159afdcd077ecfe9$export$3fb4da6af843d39f = {
    prefix: 'fas',
    iconName: 'person-swimming',
    icon: [
        640,
        512,
        [
            127946,
            "swimmer"
        ],
        "f5c4",
        "M552 152a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zM293.4 198.2l-88.6 73.9c1.1 0 2.2-.1 3.3-.1 33.1-.2 66.3 10.2 94.4 31.4 22.1 16.6 29.1 16.6 51.2 0 27.5-20.7 59.9-31.2 92.4-31.4 4.8 0 9.7 .2 14.5 .6-8.3-30-24.3-57.7-46.8-80.2-18.4-18.4-40.6-32.7-65-41.8l-68.6-25.7c-27.4-10.3-58-7.5-83.1 7.6l-53.5 32.1c-15.2 9.1-20.1 28.7-11 43.9s28.7 20.1 43.9 11L230 187.3c8.4-5 18.6-5.9 27.7-2.5l35.7 13.4zm110 181.9c21.3-16.1 49.9-16.1 71.2 0 19 14.4 41.9 28.2 67.2 33.3 26.5 5.4 54.3 .8 80.7-19.1 10.6-8 12.7-23 4.7-33.6s-23-12.7-33.6-4.7c-14.9 11.2-28.6 13.1-42.3 10.3-14.9-3-30.9-11.9-47.8-24.6-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-21.6 16.3-41.3 25.8-58.9 25.7-9.6-.1-19.9-3-31.2-11.5-10.6-8-25.6-5.9-33.6 4.7S7 386.3 17.6 394.3c19.1 14.4 39.4 21 59.8 21.1 33.9 .2 64.3-17.4 88.1-35.3 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9z"
    ]
};
var $159afdcd077ecfe9$export$67daf2e2f88c1365 = $159afdcd077ecfe9$export$3fb4da6af843d39f;
var $159afdcd077ecfe9$export$63ffcb3d4e94cb92 = {
    prefix: 'fas',
    iconName: 'comment-dots',
    icon: [
        512,
        512,
        [
            128172,
            62075,
            "commenting"
        ],
        "f4ad",
        "M256 480c141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240c0 54.3 19.2 104.3 51.6 144.5L2.8 476.8c-4.8 9-3.3 20 3.6 27.5s17.8 9.8 27.1 5.8l118.4-50.7C183.7 472.6 218.9 480 256 480zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$49ee382a2425e89c = $159afdcd077ecfe9$export$63ffcb3d4e94cb92;
var $159afdcd077ecfe9$export$1de7b9cf7d1b153b = {
    prefix: 'fas',
    iconName: 'chart-pie',
    icon: [
        576,
        512,
        [
            "pie-chart"
        ],
        "f200",
        "M512.4 240l-176 0c-17.7 0-32-14.3-32-32l0-176c0-17.7 14.4-32.2 31.9-29.9 107 14.2 191.8 99 206 206 2.3 17.5-12.2 31.9-29.9 31.9zM222.6 37.2c18.1-3.8 33.8 11 33.8 29.5l0 197.3c0 5.6 2 11 5.5 15.3L394 438.7c11.7 14.1 9.2 35.4-6.9 44.1-34.1 18.6-73.2 29.2-114.7 29.2-132.5 0-240-107.5-240-240 0-115.5 81.5-211.9 190.2-234.8zM477.8 288l64 0c18.5 0 33.3 15.7 29.5 33.8-10.2 48.4-35 91.4-69.6 124.2-12.3 11.7-31.6 9.2-42.4-3.9L374.9 340.4c-17.3-20.9-2.4-52.4 24.6-52.4l78.2 0z"
    ]
};
var $159afdcd077ecfe9$export$7877286cd337de81 = $159afdcd077ecfe9$export$1de7b9cf7d1b153b;
var $159afdcd077ecfe9$export$fe2358263efac504 = {
    prefix: 'fas',
    iconName: 'frog',
    icon: [
        576,
        512,
        [],
        "f52e",
        "M368 32c41.7 0 75.9 31.8 79.7 72.5l85.6 26.3c25.4 7.8 42.8 31.3 42.8 57.9 0 21.8-11.7 41.9-30.7 52.7l-144.5 82.1 92.5 92.5 50.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-8.5 0-16.6-3.4-22.6-9.4L346.9 360.2c11.7-36 3.2-77.1-25.4-105.7-40.6-40.6-106.3-40.6-146.9-.1L101 324.4c-6.4 6.1-6.7 16.2-.6 22.6s16.2 6.6 22.6 .6l73.8-70.2 .1-.1 .1-.1c3.5-3.5 7.3-6.6 11.3-9.2 27.9-18.5 65.9-15.4 90.5 9.2 24.7 24.7 27.7 62.9 9 90.9-2.6 3.8-5.6 7.5-9 10.9L261.8 416 352 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480C28.7 480 0 451.3 0 416 0 249.6 127 112.9 289.3 97.5 296.2 60.2 328.8 32 368 32zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$770be8b3d5776043 = {
    prefix: 'fas',
    iconName: 'wine-bottle',
    icon: [
        320,
        512,
        [],
        "f72f",
        "M80-32c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32 0 11.8-6.4 22.2-16 27.7l0 145.6c56.5 24.7 96 81.1 96 146.7l0 224c0 35.3-28.7 64-64 64L64 576c-35.3 0-64-28.7-64-64L0 288c0-65.6 39.5-122 96-146.7L96-4.3C86.4-9.8 80-20.2 80-32zM96 288c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 288z"
    ]
};
var $159afdcd077ecfe9$export$366b69cbdce46334 = {
    prefix: 'fas',
    iconName: 'inbox',
    icon: [
        512,
        512,
        [],
        "f01c",
        "M91.8 32C59.9 32 32.9 55.4 28.4 86.9L.6 281.2c-.4 3-.6 6-.6 9.1L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-125.7c0-3-.2-6.1-.6-9.1L483.6 86.9C479.1 55.4 452.1 32 420.2 32L91.8 32zm0 64l328.5 0 27.4 192-59.9 0c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7l-120.4 0c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7L64.3 288 91.8 96z"
    ]
};
var $159afdcd077ecfe9$export$51e3c5be06a49e32 = {
    prefix: 'fas',
    iconName: 'square-h',
    icon: [
        448,
        512,
        [
            "h-square"
        ],
        "f0fd",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM320 168l0 176c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-64-96 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 96 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$f08bbcf8f59eafc2 = $159afdcd077ecfe9$export$51e3c5be06a49e32;
var $159afdcd077ecfe9$export$2d077da983246a68 = {
    prefix: 'fas',
    iconName: 'house-medical',
    icon: [
        512,
        512,
        [],
        "e3b2",
        "M277.8 8.6c-12.3-11.4-31.3-11.4-43.5 0l-224 208c-9.6 9-12.8 22.9-8 35.1S18.8 272 32 272l16 0 0 176c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-176 16 0c13.2 0 25-8.1 29.8-20.3s1.6-26.2-8-35.1l-224-208zM224 248c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 40 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-40 0 0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$a39bab13d51abfd0 = {
    prefix: 'fas',
    iconName: 'circle-chevron-right',
    icon: [
        512,
        512,
        [
            "chevron-circle-right"
        ],
        "f138",
        "M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zM241 377c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l87-87-87-87c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L345 239c9.4 9.4 9.4 24.6 0 33.9L241 377z"
    ]
};
var $159afdcd077ecfe9$export$2a5db4f6eba6f2b = $159afdcd077ecfe9$export$a39bab13d51abfd0;
var $159afdcd077ecfe9$export$82cea4f586f6ec9 = {
    prefix: 'fas',
    iconName: 'file-csv',
    icon: [
        576,
        512,
        [],
        "f6dd",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l80 0 0-112c0-35.3 28.7-64 64-64l176 0 0-165.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM264 380c-24.3 0-44 19.7-44 44l0 80c0 24.3 19.7 44 44 44l16 0c24.3 0 44-19.7 44-44l0-8c0-11-9-20-20-20s-20 9-20 20l0 8c0 2.2-1.8 4-4 4l-16 0c-2.2 0-4-1.8-4-4l0-80c0-2.2 1.8-4 4-4l16 0c2.2 0 4 1.8 4 4l0 8c0 11 9 20 20 20s20-9 20-20l0-8c0-24.3-19.7-44-44-44l-16 0zm136 0c-28.7 0-52 23.3-52 52s23.3 52 52 52c6.6 0 12 5.4 12 12s-5.4 12-12 12l-32 0c-11 0-20 9-20 20s9 20 20 20l32 0c28.7 0 52-23.3 52-52s-23.3-52-52-52c-6.6 0-12-5.4-12-12s5.4-12 12-12l24 0c11 0 20-9 20-20s-9-20-20-20l-24 0zm96 0c-11 0-20 9-20 20l0 31.6c0 35.5 10.5 70.3 30.2 99.8l5.1 7.7c3.7 5.6 10 8.9 16.6 8.9s12.9-3.3 16.6-8.9l5.1-7.7c19.7-29.6 30.2-64.3 30.2-99.8l0-31.6c0-11-9-20-20-20s-20 9-20 20l0 31.6c0 19.6-4.1 38.9-12 56.7-7.9-17.8-12-37.1-12-56.7l0-31.6c0-11-9-20-20-20z"
    ]
};
var $159afdcd077ecfe9$export$37672611144b857b = {
    prefix: 'fas',
    iconName: 'hat-cowboy',
    icon: [
        640,
        512,
        [],
        "f8c0",
        "M182.2 76.1L130.8 307.5C145.5 324.9 167.4 336 192 336l256 0c24.6 0 46.5-11.1 61.2-28.5L457.8 76.1c-5.7-25.8-28.6-44.1-55-44.1-12.2 0-24.1 4-33.8 11.3l-4.7 3.5c-26.3 19.7-62.4 19.7-88.6 0L271 43.3c-9.8-7.3-21.6-11.3-33.8-11.3-26.4 0-49.3 18.3-55 44.1zM64 256c0-17.7-14.3-32-32-32S0 238.3 0 256C0 362 86 448 192 448l256 0c106 0 192-86 192-192 0-17.7-14.3-32-32-32s-32 14.3-32 32c0 70.7-57.3 128-128 128l-256 0c-70.7 0-128-57.3-128-128z"
    ]
};
var $159afdcd077ecfe9$export$4272e56f2429da88 = {
    prefix: 'fas',
    iconName: 'face-grin-tongue-wink',
    icon: [
        512,
        512,
        [
            128540,
            "grin-tongue-wink"
        ],
        "f58b",
        "M152.2 490.1C62.5 450.2 0 360.4 0 256 0 114.6 114.6 0 256 0S512 114.6 512 256c0 104.4-62.5 194.2-152.2 234.1 5.3-13 8.2-27.2 8.2-42.1l0-61.7c16.9-16.5 30.1-36.7 38.3-59.3 4.3-11.8-7.7-21.8-19.6-18.1-39.2 12.2-83.7 19.1-130.7 19.1s-91.5-6.9-130.7-19.1c-11.9-3.7-23.9 6.3-19.6 18.1 8.3 22.6 21.5 42.8 38.3 59.3l0 61.7c0 14.9 2.9 29.1 8.2 42.1zM152 212l16 0c11 0 20 9 20 20s9 20 20 20 20-9 20-20c0-33.1-26.9-60-60-60l-16 0c-33.1 0-60 26.9-60 60 0 11 9 20 20 20s20-9 20-20 9-20 20-20zm184 60a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM320 402.6l0 45.4c0 35.3-28.7 64-64 64s-64-28.7-64-64l0-45.4c0-14.7 11.9-26.6 26.6-26.6l2 0c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9l2 0c14.7 0 26.6 11.9 26.6 26.6zM336 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$58099903d50aefb3 = $159afdcd077ecfe9$export$4272e56f2429da88;
var $159afdcd077ecfe9$export$be32b10ce70a09df = {
    prefix: 'fas',
    iconName: 'l',
    icon: [
        320,
        512,
        [
            108
        ],
        "4c",
        "M64 32c17.7 0 32 14.3 32 32l0 352 192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$a51c464b699200ae = {
    prefix: 'fas',
    iconName: 'arrow-down-short-wide',
    icon: [
        576,
        512,
        [
            "sort-amount-desc",
            "sort-amount-down-alt"
        ],
        "f884",
        "M246.6 374.6l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 370.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 306.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM320 32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 128l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$93835bc31892b5c3 = $159afdcd077ecfe9$export$a51c464b699200ae;
var $159afdcd077ecfe9$export$e7d80d8c226cb77 = $159afdcd077ecfe9$export$a51c464b699200ae;
var $159afdcd077ecfe9$export$703272eebf5e3eea = {
    prefix: 'fas',
    iconName: 'hourglass-half',
    icon: [
        384,
        512,
        [
            "hourglass-2"
        ],
        "f252",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1l67.9 67.9-67.9 67.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1l-67.9-67.9 67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32S369.7 0 352 0L32 0zM96 75l0-11 192 0 0 11c0 19-5.6 37.4-16 53L112 128c-10.3-15.6-16-34-16-53zm16 309c3.5-5.3 7.6-10.3 12.1-14.9l67.9-67.9 67.9 67.9c4.6 4.6 8.6 9.6 12.2 14.9L112 384z"
    ]
};
var $159afdcd077ecfe9$export$f1052bbf6bf361c0 = $159afdcd077ecfe9$export$703272eebf5e3eea;
var $159afdcd077ecfe9$export$faf854a434ce6d0c = {
    prefix: 'fas',
    iconName: 'spoon',
    icon: [
        512,
        512,
        [
            129348,
            61873,
            "utensil-spoon"
        ],
        "f2e5",
        "M245.8 220.9c-14.5-17.6-21.8-39.2-21.8-60.8 0-80.2 96-160.2 192-160.2 53 0 96 43 96 96 0 96-80 192-160.2 192-21.6 0-43.2-7.3-60.8-21.8L54.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L245.8 220.9z"
    ]
};
var $159afdcd077ecfe9$export$fb7af5d245fb9053 = $159afdcd077ecfe9$export$faf854a434ce6d0c;
var $159afdcd077ecfe9$export$3e7437bf6535bef0 = {
    prefix: 'fas',
    iconName: 'credit-card',
    icon: [
        512,
        512,
        [
            128179,
            62083,
            "credit-card-alt"
        ],
        "f09d",
        "M0 128l0 32 512 0 0-32c0-35.3-28.7-64-64-64L64 64C28.7 64 0 92.7 0 128zm0 80L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-176-512 0zM64 360c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm144 0c0-13.3 10.7-24 24-24l64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0c-13.3 0-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$5fffe8e3c36964a2 = $159afdcd077ecfe9$export$3e7437bf6535bef0;
var $159afdcd077ecfe9$export$a3dced32d48cb1ea = {
    prefix: 'fas',
    iconName: 'file-invoice-dollar',
    icon: [
        384,
        512,
        [],
        "f571",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM64 88c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64C74.7 64 64 74.7 64 88zm0 96c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm112 76l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L152 400c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20s-20 9-20 20z"
    ]
};
var $159afdcd077ecfe9$export$3c8d5c62d76c33b8 = {
    prefix: 'fas',
    iconName: 'spaghetti-monster-flying',
    icon: [
        640,
        512,
        [
            "pastafarianism"
        ],
        "f67b",
        "M208 64a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm48 0c0 16.2-6 31.1-16 42.3l15.6 31.2c18.7-6 39.9-9.5 64.4-9.5s45.8 3.5 64.4 9.5L400 106.3c-10-11.3-16-26.1-16-42.3 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-1.7 0-3.4-.1-5.1-.2L427.8 158c21.1 13.6 37.7 30.2 51.4 46.4 7.1 8.3 13.5 16.6 19.3 24l1.4 1.8c6.3 8.1 11.6 14.8 16.7 20.4 10.7 11.7 16.1 13.4 19.4 13.4 2.5 0 4.3-.6 7.1-3.3 3.7-3.5 7.1-8.8 12.5-17.4l.6-.9c4.6-7.4 11-17.6 19.4-25.7 9.7-9.3 22.9-16.7 40.4-16.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-2.5 0-4.3 .6-7.1 3.3-3.7 3.5-7.1 8.8-12.5 17.4l-.6 .9c-4.6 7.4-11 17.6-19.4 25.7-9.7 9.3-22.9 16.7-40.4 16.7-18.5 0-32.9-8.5-44.3-18.6-3.1 4-6.6 8.3-10.5 12.7 1.4 4.3 2.8 8.5 4 12.5 .9 3 1.8 5.8 2.6 8.6 3 9.8 5.5 18.2 8.6 25.9 3.9 9.8 7.4 15.4 10.8 18.5 2.6 2.4 5.9 4.3 12.8 4.3 8.7 0 16.9-4.2 33.7-13.2 15-8 35.7-18.8 62.3-18.8 13.3 0 24 10.7 24 24s-10.7 24-24 24c-13.4 0-24.7 5.2-39.7 13.2-1 .6-2.1 1.1-3.2 1.7-13.1 7.1-31.6 17.1-53.1 17.1-18.4 0-33.6-6.1-45.5-17.2-11.1-10.3-17.9-23.7-22.7-36-3.6-9-6.7-19.1-9.5-28.5-16.4 12.3-36.1 23.6-58.9 31.3 3.6 10.8 8.4 23.5 14.4 36.2 7.5 15.9 16.2 30.4 25.8 40.5 9.6 10.2 17.7 13.7 24.5 13.7 13.3 0 24 10.7 24 24s-10.7 24-24 24c-25.2 0-45-13.5-59.5-28.8-14.5-15.4-25.7-34.9-34.2-53-8-17-14.1-33.8-18.3-46.9-5.2 .4-10.6 .6-16 .6s-10.8-.2-16-.6c-4.2 13-10.3 29.9-18.3 46.9-8.5 18.1-19.8 37.6-34.2 53-14.4 15.3-34.3 28.8-59.5 28.8-13.3 0-24-10.7-24-24s10.7-24 24-24c6.8 0 15-3.5 24.5-13.7 9.5-10.1 18.3-24.6 25.8-40.5 5.9-12.6 10.7-25.4 14.4-36.2-22.8-7.7-42.5-19-58.9-31.3-2.9 9.4-6 19.5-9.5 28.5-4.8 12.2-11.6 25.6-22.7 36-11.9 11.1-27.1 17.2-45.5 17.2-13.1 0-24.5-4.1-33.8-8.9-7.9-4-15.7-9.2-22.1-13.5l0 0-2.4-1.6c-15.3-10.2-25.8-16-37.7-16-13.3 0-24-10.7-24-24s10.7-24 24-24c28.1 0 49.6 14.2 64.3 24l2.4 1.6c6.9 4.6 12.1 8.1 17.2 10.7 5.5 2.8 9.1 3.6 12 3.6 6.8 0 10.2-1.9 12.8-4.3 3.4-3.2 7-8.8 10.8-18.5 3-7.7 5.6-16.1 8.6-25.9 .8-2.7 1.7-5.6 2.6-8.6 1.2-4 2.6-8.2 4-12.5-3.9-4.5-7.4-8.8-10.5-12.7-11.4 10.1-25.9 18.6-44.3 18.6-17.5 0-30.7-7.4-40.4-16.7-8.4-8.1-14.8-18.3-19.4-25.7l-.6-.9c-5.4-8.6-8.8-13.9-12.5-17.4-2.8-2.7-4.6-3.3-7.1-3.3-13.3 0-24-10.7-24-24s10.7-24 24-24c17.5 0 30.7 7.4 40.4 16.7 8.4 8.1 14.8 18.3 19.4 25.7l.6 .9c5.4 8.6 8.8 13.9 12.5 17.4 2.8 2.7 4.6 3.3 7.1 3.3 3.3 0 8.7-1.7 19.4-13.4 5.1-5.6 10.4-12.3 16.7-20.4l1.4-1.8c5.8-7.4 12.2-15.7 19.3-24 13.8-16.2 30.3-32.8 51.4-46.4l-15.1-30.2c-1.7 .1-3.4 .2-5.1 .2-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64zm208 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"
    ]
};
var $159afdcd077ecfe9$export$733efdaec97447be = $159afdcd077ecfe9$export$3c8d5c62d76c33b8;
var $159afdcd077ecfe9$export$c6e76550bdc0255d = {
    prefix: 'fas',
    iconName: 'martini-glass-citrus',
    icon: [
        640,
        512,
        [
            "cocktail"
        ],
        "f561",
        "M576 80c0-44.2-35.8-80-80-80-18 0-34.6 6-48 16l-81 0c23.6-47.4 72.5-80 129-80 79.5 0 144 64.5 144 144S575.5 224 496 224c-6.5 0-13-.4-19.3-1.3l64-74.7c1.1-1.3 2.2-2.7 3.3-4.1 19.4-14.6 32-37.8 32-64zM66.9 82.6C72.2 71.3 83.5 64 96 64l384 0c12.5 0 23.8 7.3 29.1 18.6s3.4 24.7-4.8 34.2l-184.3 215 0 116.2 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0 0-116.2-184.3-215c-8.1-9.5-10-22.8-4.8-34.2zM165.6 128L288 270.8 410.4 128 165.6 128z"
    ]
};
var $159afdcd077ecfe9$export$4be708f1e41d387b = $159afdcd077ecfe9$export$c6e76550bdc0255d;
var $159afdcd077ecfe9$export$dacae2b4ec565333 = {
    prefix: 'fas',
    iconName: 'bullhorn',
    icon: [
        512,
        512,
        [
            128226,
            128363
        ],
        "f0a1",
        "M461.2 18.9C472.7 24 480 35.4 480 48l0 416c0 12.6-7.3 24-18.8 29.1s-24.8 3.2-34.3-5.1l-46.6-40.7c-43.6-38.1-98.7-60.3-156.4-63l0 95.7c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-96C57.3 384 0 326.7 0 256S57.3 128 128 128l84.5 0c61.8-.2 121.4-22.7 167.9-63.3l46.6-40.7c9.4-8.3 22.9-10.2 34.3-5.1zM224 320l0 .2c70.3 2.7 137.8 28.5 192 73.4l0-275.3c-54.2 44.9-121.7 70.7-192 73.4L224 320z"
    ]
};
var $159afdcd077ecfe9$export$f2adc06617bc0c7 = {
    prefix: 'fas',
    iconName: 'box-tissue',
    icon: [
        512,
        512,
        [],
        "e05b",
        "M103.9 32l161 0c13.8 0 26 8.8 30.4 21.9l17.4 52.2c4.4 13.1 16.6 21.9 30.4 21.9l60.5 0c21.8 0 37.3 21.4 30.4 42.1L384 320 128 320 72.7 70.9C68.2 51 83.4 32 103.9 32zM48 256l16.6 0 16.5 74.4C86 352.4 105.5 368 128 368l256 0c20.7 0 39-13.2 45.5-32.8l26.4-79.2 8.1 0c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48L0 304c0-26.5 21.5-48 48-48z"
    ]
};
var $159afdcd077ecfe9$export$f042d3e458efa721 = {
    prefix: 'fas',
    iconName: 'mattress-pillow',
    icon: [
        576,
        512,
        [],
        "e525",
        "M256 64L64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l192 0 0-384zm48 384l208 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-208 0 0 384zM64 160c0-17.7 14.3-32 32-32l64 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-192z"
    ]
};
var $159afdcd077ecfe9$export$75702e3e3dd44a44 = {
    prefix: 'fas',
    iconName: 'chevron-left',
    icon: [
        320,
        512,
        [
            9001
        ],
        "f053",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"
    ]
};
var $159afdcd077ecfe9$export$301c3fab0c4545bd = {
    prefix: 'fas',
    iconName: 'cloud-moon-rain',
    icon: [
        576,
        512,
        [],
        "f73c",
        "M448 0c-68.6 0-127.1 43.1-149.8 103.8 17.1 14.1 29.6 33.5 34.9 55.8 39.9 21.7 66.9 63.9 66.9 112.5 0 13.5-2.1 26.5-5.9 38.7 16.9 6 35 9.3 53.9 9.3 43 0 82.1-17 110.8-44.6 4.6-4.4 5.9-11.2 3.3-17s-8.6-9.3-14.9-8.8c-3 .2-6.1 .4-9.2 .4-63.5 0-115-51.5-115-115 0-45.1 26-84.2 63.8-103 5.7-2.8 9-8.9 8.2-15.2S489.6 5.3 483.4 3.9C472 1.4 460.2 0 448 0zM272 352c44.2 0 80-35.8 80-80 0-39-27.9-71.5-64.8-78.6 .5-3.1 .8-6.2 .8-9.4 0-30.9-25.1-56-56-56-12.4 0-23.9 4-33.1 10.8-13.4-25.5-40.1-42.8-70.9-42.8-44.2 0-80 35.8-80 80 0 7.4 1 14.6 2.9 21.5-29.8 11.6-50.9 40.6-50.9 74.5 0 44.2 35.8 80 80 80l192 0zM69 401.1c-12.6-4.2-26.2 2.6-30.4 15.2L17.2 480.4C13 493 19.8 506.6 32.4 510.8s26.2-2.6 30.4-15.2l21.4-64.1c4.2-12.6-2.6-26.2-15.2-30.4zm120 0c-12.6-4.2-26.2 2.6-30.4 15.2l-21.4 64.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l21.4-64.1c4.2-12.6-2.6-26.2-15.2-30.4zm120 0c-12.6-4.2-26.2 2.6-30.4 15.2l-21.4 64.1c-4.2 12.6 2.6 26.2 15.2 30.4s26.2-2.6 30.4-15.2l21.4-64.1c4.2-12.6-2.6-26.2-15.2-30.4z"
    ]
};
var $159afdcd077ecfe9$export$9a40d582bd4628fb = {
    prefix: 'fas',
    iconName: 'arrow-down-1-9',
    icon: [
        512,
        512,
        [
            "sort-numeric-asc",
            "sort-numeric-down"
        ],
        "f162",
        "M418.7 38c8.3 6 13.3 15.7 13.3 26l0 96 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-51.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4zM365.1 430.6l11.7-18c-32.9-9.9-56.8-40.5-56.8-76.6 0-44.2 35.8-80 80-80s80 35.8 80 80c0 22.9-6.6 45.3-19.1 64.5l-42.1 64.9c-9.6 14.8-29.4 19.1-44.3 9.4s-19.1-29.4-9.4-44.3zM424 336a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM150.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 370.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 306.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96z"
    ]
};
var $159afdcd077ecfe9$export$a4fb1aa2cdfb18d7 = $159afdcd077ecfe9$export$9a40d582bd4628fb;
var $159afdcd077ecfe9$export$835db7eb35b3c29b = $159afdcd077ecfe9$export$9a40d582bd4628fb;
var $159afdcd077ecfe9$export$2262d6b626de1120 = {
    prefix: 'fas',
    iconName: 'hand-spock',
    icon: [
        512,
        512,
        [
            128406
        ],
        "f259",
        "M214.9 23.7C210.3 6.6 192.8-3.5 175.7 1.1s-27.2 22.1-22.6 39.2L206 237.8c2.5 9.2-4.5 18.2-14 18.2-6.4 0-12-4.2-13.9-10.3L134.6 102.7c-5.1-16.9-23-26.4-39.9-21.3s-26.4 23-21.3 39.9l62.8 206.4c2.4 7.9-7.2 13.8-13.2 8.1L67.6 283c-16-15.2-41.3-14.6-56.6 1.4S-3.6 325.7 12.4 341L124.8 448c43.1 41.1 100.4 64 160 64l19.1 0c.1 0 .1-.1 .1-.1s.1-.1 .1-.1c58.3-3.5 108.6-43.2 125.3-99.7l81.2-275c5-16.9-4.7-34.7-21.6-39.8s-34.7 4.7-39.8 21.6L411.5 247.1c-1.6 5.3-6.4 8.9-12 8.9-7.9 0-13.8-7.3-12.2-15.1l36-170.3c3.7-17.3-7.4-34.3-24.7-37.9s-34.3 7.4-37.9 24.7L323.1 235.1c-2.6 12.2-13.3 20.9-25.8 20.9-11.9 0-22.4-8-25.4-19.5l-57-212.8z"
    ]
};
var $159afdcd077ecfe9$export$5325fc72e75360b4 = {
    prefix: 'fas',
    iconName: 'wand-magic-sparkles',
    icon: [
        576,
        512,
        [
            "magic-wand-sparkles"
        ],
        "e2ca",
        "M263.4-27L278.2 9.8 315 24.6c3 1.2 5 4.2 5 7.4s-2 6.2-5 7.4L278.2 54.2 263.4 91c-1.2 3-4.2 5-7.4 5s-6.2-2-7.4-5L233.8 54.2 197 39.4c-3-1.2-5-4.2-5-7.4s2-6.2 5-7.4L233.8 9.8 248.6-27c1.2-3 4.2-5 7.4-5s6.2 2 7.4 5zM110.7 41.7l21.5 50.1 50.1 21.5c5.9 2.5 9.7 8.3 9.7 14.7s-3.8 12.2-9.7 14.7l-50.1 21.5-21.5 50.1c-2.5 5.9-8.3 9.7-14.7 9.7s-12.2-3.8-14.7-9.7L59.8 164.2 9.7 142.7C3.8 140.2 0 134.4 0 128s3.8-12.2 9.7-14.7L59.8 91.8 81.3 41.7C83.8 35.8 89.6 32 96 32s12.2 3.8 14.7 9.7zM464 304c6.4 0 12.2 3.8 14.7 9.7l21.5 50.1 50.1 21.5c5.9 2.5 9.7 8.3 9.7 14.7s-3.8 12.2-9.7 14.7l-50.1 21.5-21.5 50.1c-2.5 5.9-8.3 9.7-14.7 9.7s-12.2-3.8-14.7-9.7l-21.5-50.1-50.1-21.5c-5.9-2.5-9.7-8.3-9.7-14.7s3.8-12.2 9.7-14.7l50.1-21.5 21.5-50.1c2.5-5.9 8.3-9.7 14.7-9.7zM460 0c11 0 21.6 4.4 29.5 12.2l42.3 42.3C539.6 62.4 544 73 544 84s-4.4 21.6-12.2 29.5l-88.2 88.2-101.3-101.3 88.2-88.2C438.4 4.4 449 0 460 0zM44.2 398.5L308.4 134.3 409.7 235.6 145.5 499.8C137.6 507.6 127 512 116 512s-21.6-4.4-29.5-12.2L44.2 457.5C36.4 449.6 32 439 32 428s4.4-21.6 12.2-29.5z"
    ]
};
var $159afdcd077ecfe9$export$c93286938249f0da = $159afdcd077ecfe9$export$5325fc72e75360b4;
var $159afdcd077ecfe9$export$101422b773924276 = {
    prefix: 'fas',
    iconName: 'comment-medical',
    icon: [
        512,
        512,
        [],
        "f7f5",
        "M256 480c141.4 0 256-107.5 256-240S397.4 0 256 0 0 107.5 0 240c0 54.3 19.2 104.3 51.6 144.5L2.8 476.8c-4.8 9-3.3 20 3.6 27.5s17.8 9.8 27.1 5.8l118.4-50.7C183.7 472.6 218.9 480 256 480zM217.6 153.6c0-10.6 8.6-19.2 19.2-19.2l38.4 0c10.6 0 19.2 8.6 19.2 19.2l0 48 48 0c10.6 0 19.2 8.6 19.2 19.2l0 38.4c0 10.6-8.6 19.2-19.2 19.2l-48 0 0 48c0 10.6-8.6 19.2-19.2 19.2l-38.4 0c-10.6 0-19.2-8.6-19.2-19.2l0-48-48 0c-10.6 0-19.2-8.6-19.2-19.2l0-38.4c0-10.6 8.6-19.2 19.2-19.2l48 0 0-48z"
    ]
};
var $159afdcd077ecfe9$export$6b31a1e5968b2378 = {
    prefix: 'fas',
    iconName: 'bell-slash',
    icon: [
        576,
        512,
        [
            128277,
            61943
        ],
        "f1f6",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-87.5-87.5c17.2-2.4 30.5-17.3 30.5-35.2 0-8.1-2.7-15.9-7.8-22.2l-9.8-12.2C464.4 308.5 448 261.8 448 213.7l0-21.7c0-77.4-55-142-128-156.8l0-3.2c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 3.2c-38.6 7.8-72.2 29.6-95.2 59.7L41-24.9zm87 238.5c0 48.1-16.4 94.8-46.4 132.4l-9.8 12.2c-5 6.3-7.8 14.1-7.8 22.2 0 19.6 15.9 35.5 35.5 35.5l235.3 0-206.9-206.9 0 4.5zM288 512c29.8 0 54.9-20.4 62-48l-124 0c7.1 27.6 32.2 48 62 48z"
    ]
};
var $159afdcd077ecfe9$export$2cef3f81ad90fb76 = {
    prefix: 'fas',
    iconName: 'handshake-slash',
    icon: [
        576,
        512,
        [
            57439,
            "handshake-alt-slash",
            "handshake-simple-slash"
        ],
        "e060",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-288-288 14.2-14.2c4.2-4.2 9.5-6.5 14.9-6.9 6.8-.6 13.8 1.7 19 6.9L505.6 376 576 320 576 32 464 96 440.2 80.1C424.4 69.6 405.9 64 386.9 64l-70.4 0c-1.1 0-2.3 0-3.4 .1-16.9 .9-32.8 8.5-44.2 21.1l-55.8 62.1-34-34 44.3-49.2-39.7 0c-15.3 0-30.1 3.6-43.5 10.4L41-24.9zM0 69.8L0 320 156.4 450.3c23 19.2 52 29.7 81.9 29.7l15.7 0-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l41 41 9 0c22.2 0 43.8-5.8 62.8-16.4L0 69.8z"
    ]
};
var $159afdcd077ecfe9$export$ca302f956ae9f1bf = $159afdcd077ecfe9$export$2cef3f81ad90fb76;
var $159afdcd077ecfe9$export$e99ae494101c5e91 = $159afdcd077ecfe9$export$2cef3f81ad90fb76;
var $159afdcd077ecfe9$export$3ee278c67519eeeb = {
    prefix: 'fas',
    iconName: 'bottle-water',
    icon: [
        320,
        512,
        [],
        "e4c5",
        "M112-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0C94.3 32 80 17.7 80 0s14.3-32 32-32zM16 144c0-35.3 28.7-64 64-64l160 0c35.3 0 64 28.7 64 64 0 24.1-13.3 45.1-33 56 19.7 10.9 33 31.9 33 56s-13.3 45.1-33 56c19.7 10.9 33 31.9 33 56s-13.3 45.1-33 56c19.7 10.9 33 31.9 33 56 0 35.3-28.7 64-64 64L80 544c-35.3 0-64-28.7-64-64 0-24.1 13.3-45.1 33-56-19.7-10.9-33-31.9-33-56s13.3-45.1 33-56c-19.7-10.9-33-31.9-33-56s13.3-45.1 33-56c-19.7-10.9-33-31.9-33-56z"
    ]
};
var $159afdcd077ecfe9$export$b06003a02c9055bd = {
    prefix: 'fas',
    iconName: 'dice-d20',
    icon: [
        512,
        512,
        [],
        "f6cf",
        "M224.4-8.2c19.6-11.1 43.6-11.1 63.1 0l192 108.8c20 11.4 32.4 32.6 32.4 55.7l0 215.6c0 23-12.4 44.3-32.4 55.7l-192 108.8c-19.6 11.1-43.6 11.1-63.1 0L32.4 427.5C12.4 416.1 0 394.8 0 371.8L0 156.2c0-23 12.4-44.3 32.4-55.7L224.4-8.2zm52 73.2C267 49.8 245 49.8 235.6 65l-76.6 123.7-85.4-46.3-3.8-1.6c-8.9-2.7-18.8 1.1-23.4 9.6s-2.4 18.9 4.7 24.8l3.3 2.3 83.4 45.2-74.6 120.6C55.3 356.2 61 373 75 378.4l161 61.9 0 39.7c0 11 9 20 20 20s20-9 20-20l0-39.7 161-61.9c14-5.4 19.7-22.2 11.8-35l-74.7-120.6 83.4-45.2c9.7-5.3 13.3-17.4 8.1-27.1s-17.4-13.3-27.1-8.1L353 188.7 276.4 65zm-47 329.9l-122-46.9 54.5-88.1 67.5 135zM404.6 348l-122 46.9 67.5-135 54.5 88.1zM319.3 232L256 358.6 192.7 232 319.3 232zM308 192l-104.1 0 52-84 52 84z"
    ]
};
var $159afdcd077ecfe9$export$cf79d63ad07d943a = {
    prefix: 'fas',
    iconName: 'arrow-down-z-a',
    icon: [
        512,
        512,
        [
            "sort-alpha-desc",
            "sort-alpha-down-alt"
        ],
        "f881",
        "M230.6 390.6l-80 80c-12.5 12.5-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 370.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 306.7 25.4-25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM288 64c0-17.7 14.3-32 32-32l128 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L397.3 160 448 160c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L370.8 96 320 96c-17.7 0-32-14.3-32-32zM412.6 273.7l80 160c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-7.2-14.3-88.4 0-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9l80-160c5.4-10.8 16.5-17.7 28.6-17.7s23.2 6.8 28.6 17.7zM384 359.6l-20.2 40.4 40.4 0-20.2-40.4z"
    ]
};
var $159afdcd077ecfe9$export$7caf99612a55d427 = $159afdcd077ecfe9$export$cf79d63ad07d943a;
var $159afdcd077ecfe9$export$e12d23d82d5c8a89 = $159afdcd077ecfe9$export$cf79d63ad07d943a;
var $159afdcd077ecfe9$export$5824ffe6f8983c83 = {
    prefix: 'fas',
    iconName: 'brush',
    icon: [
        384,
        512,
        [],
        "f55d",
        "M162.4 6c-1.5-3.6-5-6-8.9-6l-19 0c-3.9 0-7.5 2.4-8.9 6L104.9 57.7c-3.2 8-14.6 8-17.8 0L66.4 6c-1.5-3.6-5-6-8.9-6L48 0C21.5 0 0 21.5 0 48l0 208 384 0 0-208c0-26.5-21.5-48-48-48L230.5 0c-3.9 0-7.5 2.4-8.9 6L200.9 57.7c-3.2 8-14.6 8-17.8 0L162.4 6zM0 304l0 16c0 35.3 28.7 64 64 64l64 0 0 64c0 35.3 28.7 64 64 64s64-28.7 64-64l0-64 64 0c35.3 0 64-28.7 64-64l0-16-384 0zM192 464c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
    ]
};
var $159afdcd077ecfe9$export$a1d09c95bee8043b = {
    prefix: 'fas',
    iconName: 'person-walking-dashed-line-arrow-right',
    icon: [
        640,
        512,
        [],
        "e553",
        "M160 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM73.4 227.9l22.6-22.6 0 69.3c0 28 12.2 54.7 33.5 72.9l71.4 61.2c5.9 5.1 9.8 12.1 10.9 19.8l12.6 88.1c2.5 17.5 18.7 29.7 36.2 27.2s29.7-18.7 27.2-36.2l-12.6-88.1c-3.3-23.1-14.9-44.1-32.6-59.3l-34.5-29.6 0-115.2 3.8 4.7c18.2 22.8 45.8 36 75 36l33.2 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-33.2 0c-9.7 0-18.9-4.4-25-12l-17.9-22.4c-23-28.8-57.9-45.6-94.8-45.6-32.2 0-63.1 12.8-85.8 35.6L28.1 182.6C10.1 200.6 0 225 0 250.5L0 288c0 17.7 14.3 32 32 32s32-14.3 32-32l0-37.5c0-8.5 3.4-16.6 9.4-22.6zM85.8 407.3c-1.5 5.2-4.3 10-8.1 13.8L9.4 489.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l68.3-68.3c11.5-11.5 19.9-25.8 24.4-41.5l2.2-7.6-46-39.4c-2.5-2.2-5-4.4-7.4-6.8L85.8 407.3zM432 8c0-13.3-10.7-24-24-24S384-5.3 384 8l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32zm0 128c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32zM408 320c-13.3 0-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32c0-13.3-10.7-24-24-24zm24 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32zM609 273c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-102.1 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l102.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72z"
    ]
};
var $159afdcd077ecfe9$export$be9d5060a4bc3b4b = {
    prefix: 'fas',
    iconName: 'arrow-up-short-wide',
    icon: [
        576,
        512,
        [
            "sort-amount-up-alt"
        ],
        "f885",
        "M320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0zm0 128c-17.7 0-32 14.3-32 32s14.3 32 32 32l224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0zM150.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 141.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96z"
    ]
};
var $159afdcd077ecfe9$export$6e87844b0f151b6a = $159afdcd077ecfe9$export$be9d5060a4bc3b4b;
var $159afdcd077ecfe9$export$cacbd95c283996ec = {
    prefix: 'fas',
    iconName: 'grip-vertical',
    icon: [
        320,
        512,
        [
            "grid-vertical"
        ],
        "f58e",
        "M128 40c0-22.1-17.9-40-40-40L40 0C17.9 0 0 17.9 0 40L0 88c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zm0 192c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zM0 424l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM320 40c0-22.1-17.9-40-40-40L232 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48zM192 232l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40zM320 424c0-22.1-17.9-40-40-40l-48 0c-22.1 0-40 17.9-40 40l0 48c0 22.1 17.9 40 40 40l48 0c22.1 0 40-17.9 40-40l0-48z"
    ]
};
var $159afdcd077ecfe9$export$4ad8d668e60f2ced = $159afdcd077ecfe9$export$cacbd95c283996ec;
var $159afdcd077ecfe9$export$ec5cfe409de2ed37 = {
    prefix: 'fas',
    iconName: 'car-tunnel',
    icon: [
        512,
        512,
        [],
        "e4de",
        "M256 0C114.6 0 0 114.6 0 256L0 448c0 35.3 28.7 64 64 64l42.8 0c-6.6-5.9-10.8-14.4-10.8-24l0-113.1c0-13.5 3.1-26.8 9-38.9l39.7-80.8c9.4-19.1 28.9-31.3 50.2-31.3L317 224c21.3 0 40.8 12.1 50.2 31.3L407 336c5.9 12.1 9 25.4 9 38.9L416 488c0 9.6-4.2 18.1-10.8 24l42.8 0c35.3 0 64-28.7 64-64l0-192C512 114.6 397.4 0 256 0zM362.8 512c-6.6-5.9-10.8-14.4-10.8-24l0-24-192 0 0 24c0 9.6-4.2 18.1-10.8 24l213.7 0zm-175-235.5l-29.3 59.5 194.9 0-29.3-59.5c-1.3-2.7-4.1-4.5-7.2-4.5L195 272c-3 0-5.8 1.7-7.2 4.5zM176 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$d01ddcc9efe7b149 = {
    prefix: 'fas',
    iconName: 'chart-column',
    icon: [
        512,
        512,
        [],
        "e0e3",
        "M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zM144 224c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm144-64l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32s32 14.3 32 32zm80 32c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM512 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$d69fa2b7839ce76 = {
    prefix: 'fas',
    iconName: 'truck-arrow-right',
    icon: [
        576,
        512,
        [],
        "e58b",
        "M64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l3.3 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l3.3 0c35.3 0 64-28.7 64-64l0-146.7c0-17-6.7-33.3-18.7-45.3L512 146.7c-12-12-28.3-18.7-45.3-18.7l-50.7 0 0-32c0-35.3-28.7-64-64-64L64 32zM512 237.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM305 225l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-102.1 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l102.1 0-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9z"
    ]
};
var $159afdcd077ecfe9$export$e0cfed4ba2fe562c = {
    prefix: 'fas',
    iconName: 'tv',
    icon: [
        576,
        512,
        [
            63717,
            "television",
            "tv-alt"
        ],
        "f26c",
        "M64 96l0 240 448 0 0-240-448 0zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 240c0 35.3-28.7 64-64 64L64 400c-35.3 0-64-28.7-64-64L0 96zM160 448l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$9803b0176917be28 = $159afdcd077ecfe9$export$e0cfed4ba2fe562c;
var $159afdcd077ecfe9$export$6aa64ad5a1974ad7 = $159afdcd077ecfe9$export$e0cfed4ba2fe562c;
var $159afdcd077ecfe9$export$a6f4f4a005d91fbd = {
    prefix: 'fas',
    iconName: 'section',
    icon: [
        256,
        512,
        [],
        "e447",
        "M110 0C49.2 0 0 49.2 0 110 0 133.7 7.6 155.8 20.5 174 7.6 192 0 214.1 0 238 0 291.7 38.9 337.6 91.9 346.4l61.7 10.3c22.2 3.7 38.4 22.9 38.4 45.3 0 25.4-20.6 46-46 46l-98 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l98 0c60.7 0 110-49.2 110-110 0-23.7-7.6-45.9-20.5-64 12.9-18 20.5-40.1 20.5-64 0-53.8-38.9-99.6-91.9-108.5l-61.7-10.3C80.2 151.6 64 132.4 64 110 64 84.6 84.6 64 110 64l98 0c17.7 0 32-14.3 32-32S225.7 0 208 0L110 0zm74.7 299.1c-6.5-2.4-13.4-4.3-20.5-5.5l-61.7-10.3c-22.2-3.7-38.4-22.9-38.4-45.3 0-9.2 2.7-17.8 7.4-25 6.5 2.4 13.4 4.3 20.5 5.5l61.7 10.3c22.2 3.7 38.4 22.9 38.4 45.3 0 9.2-2.7 17.8-7.4 25z"
    ]
};
var $159afdcd077ecfe9$export$8614cb1326eacd7a = {
    prefix: 'fas',
    iconName: 'peace',
    icon: [
        512,
        512,
        [
            9774
        ],
        "f67c",
        "M224 445.3l0-121.8-94.3 77.1c26.1 22.8 58.5 38.7 94.3 44.7zM89.2 351.1L224 240.8 224 66.7c-90.8 15.2-160 94.2-160 189.3 0 34.6 9.2 67.1 25.2 95.1zm293.1 49.5l-94.3-77.1 0 121.8c35.7-6 68.1-21.9 94.3-44.7zm40.6-49.5c16-28 25.2-60.5 25.2-95.1 0-95.1-69.2-174.1-160-189.3l0 174.2 134.8 110.3zM0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0z"
    ]
};
var $159afdcd077ecfe9$export$a3b0eb2cd7942125 = {
    prefix: 'fas',
    iconName: 'star',
    icon: [
        576,
        512,
        [
            11088,
            61446
        ],
        "f005",
        "M309.5-18.9c-4.1-8-12.4-13.1-21.4-13.1s-17.3 5.1-21.4 13.1L193.1 125.3 33.2 150.7c-8.9 1.4-16.3 7.7-19.1 16.3s-.5 18 5.8 24.4l114.4 114.5-25.2 159.9c-1.4 8.9 2.3 17.9 9.6 23.2s16.9 6.1 25 2L288.1 417.6 432.4 491c8 4.1 17.7 3.3 25-2s11-14.2 9.6-23.2L441.7 305.9 556.1 191.4c6.4-6.4 8.6-15.8 5.8-24.4s-10.1-14.9-19.1-16.3L383 125.3 309.5-18.9z"
    ]
};
var $159afdcd077ecfe9$export$6591b1ea509be9da = {
    prefix: 'fas',
    iconName: 'flag',
    icon: [
        448,
        512,
        [
            127988,
            61725
        ],
        "f024",
        "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32L0 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-121.6 62.7-18.8c41.9-12.6 87.1-8.7 126.2 10.9 42.7 21.4 92.5 24 137.2 7.2l37.1-13.9c12.5-4.7 20.8-16.6 20.8-30l0-247.7c0-23-24.2-38-44.8-27.7l-11.8 5.9c-44.9 22.5-97.8 22.5-142.8 0-36.4-18.2-78.3-21.8-117.2-10.1L64 54.4 64 32z"
    ]
};
var $159afdcd077ecfe9$export$1cbf6e649ce86166 = {
    prefix: 'fas',
    iconName: 'triangle-exclamation',
    icon: [
        512,
        512,
        [
            9888,
            "exclamation-triangle",
            "warning"
        ],
        "f071",
        "M256 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5S486.1 480 472 480L40 480c-14.1 0-27.2-7.4-34.4-19.5s-7.5-27.1-.8-39.5l216-400c7-12.9 20.5-21 35.2-21zm0 352a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-192c-18.2 0-32.7 15.5-31.4 33.7l7.4 104c.9 12.5 11.4 22.3 23.9 22.3 12.6 0 23-9.7 23.9-22.3l7.4-104c1.3-18.2-13.1-33.7-31.4-33.7z"
    ]
};
var $159afdcd077ecfe9$export$3d249b63b52cce7c = $159afdcd077ecfe9$export$1cbf6e649ce86166;
var $159afdcd077ecfe9$export$2e470a35c38b096a = $159afdcd077ecfe9$export$1cbf6e649ce86166;
var $159afdcd077ecfe9$export$f629fdee00932a01 = {
    prefix: 'fas',
    iconName: 'school-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e56c",
        "M64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l276 0c-10.5-14.6-19-30.7-25.1-48l-90.9 0 0-88c0-22.1 17.9-40 40-40l48 0c1 0 1.9 0 2.9 .1 26.3-74.6 97.5-128.1 181.1-128.1 28.6 0 55.6 6.2 80 17.4l0-33.4c0-35.3-28.7-64-64-64l-64 0-127.9-115.1c-18.3-16.4-46-16.4-64.2 0L128 128 64 128zm64 240c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32zM112 256l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16zM288 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-140c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$874e305fd7920cce = {
    prefix: 'fas',
    iconName: 'graduation-cap',
    icon: [
        576,
        512,
        [
            127891,
            "mortar-board"
        ],
        "f19d",
        "M48 195.8l209.2 86.1c9.8 4 20.2 6.1 30.8 6.1s21-2.1 30.8-6.1l242.4-99.8c9-3.7 14.8-12.4 14.8-22.1s-5.8-18.4-14.8-22.1L318.8 38.1C309 34.1 298.6 32 288 32s-21 2.1-30.8 6.1L14.8 137.9C5.8 141.6 0 150.3 0 160L0 456c0 13.3 10.7 24 24 24s24-10.7 24-24l0-260.2zm48 71.7L96 384c0 53 86 96 192 96s192-43 192-96l0-116.6-142.9 58.9c-15.6 6.4-32.2 9.7-49.1 9.7s-33.5-3.3-49.1-9.7L96 267.4z"
    ]
};
var $159afdcd077ecfe9$export$dd0a013bf23a9d86 = $159afdcd077ecfe9$export$874e305fd7920cce;
var $159afdcd077ecfe9$export$de59c2657a8ace67 = {
    prefix: 'fas',
    iconName: 'store',
    icon: [
        512,
        512,
        [],
        "f54e",
        "M30.7 72.3C37.6 48.4 59.5 32 84.4 32l344 0c24.9 0 46.8 16.4 53.8 40.3l23.4 80.2c12.8 43.7-20.1 87.5-65.6 87.5-26.3 0-49.4-14.9-60.8-37.1-11.6 21.9-34.6 37.1-61.4 37.1-26.6 0-49.7-15-61.3-37-11.6 22-34.7 37-61.3 37-26.8 0-49.8-15.1-61.4-37.1-11.4 22.1-34.5 37.1-60.8 37.1-45.6 0-78.4-43.7-65.6-87.5L30.7 72.3zM96.4 352l320 0 0-66.4c7.6 1.6 15.5 2.4 23.5 2.4 14.3 0 28-2.6 40.5-7.2l0 151.2c0 26.5-21.5 48-48 48l-352 0c-26.5 0-48-21.5-48-48l0-151.2c12.5 4.6 26.1 7.2 40.5 7.2 8.1 0 15.9-.8 23.5-2.4l0 66.4z"
    ]
};
var $159afdcd077ecfe9$export$94363e983c225a04 = {
    prefix: 'fas',
    iconName: 'user-astronaut',
    icon: [
        448,
        512,
        [],
        "f4fb",
        "M224 336c74.6 0 138.4-46.4 164-112l4 0c13.3 0 24-10.7 24-24l0-80c0-13.3-10.7-24-24-24l-4 0C362.4 30.4 298.6-16 224-16S85.6 30.4 60 96l-4 0c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24l4 0c25.6 65.6 89.4 112 164 112zM208 80l32 0c53 0 96 43 96 96s-43 96-96 96l-32 0c-53 0-96-43-96-96s43-96 96-96zM16 484.6C16 499.7 28.3 512 43.4 512l52.6 0 0-48c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 48 52.6 0c15.1 0 27.4-12.3 27.4-27.4 0-59.8-31.9-112.2-79.6-141-36.4 25.5-80.6 40.4-128.4 40.4s-92-14.9-128.4-40.4C47.9 372.4 16 424.8 16 484.6zM183.3 141.5c-.9-3.3-3.9-5.5-7.3-5.5s-6.4 2.2-7.3 5.5l-6 21.2-21.2 6c-3.3 .9-5.5 3.9-5.5 7.3s2.2 6.4 5.5 7.3l21.2 6 6 21.2c.9 3.3 3.9 5.5 7.3 5.5s6.4-2.2 7.3-5.5l6-21.2 21.2-6c3.3-.9 5.5-3.9 5.5-7.3s-2.2-6.4-5.5-7.3l-21.2-6-6-21.2zM152 488l0 24 48 0 0-24c0-13.3-10.7-24-24-24s-24 10.7-24 24zm120-24c-13.3 0-24 10.7-24 24l0 24 48 0 0-24c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$592422b29ab0a914 = {
    prefix: 'fas',
    iconName: 'building-flag',
    icon: [
        640,
        512,
        [],
        "e4d5",
        "M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM176 352l32 0c17.7 0 32 14.3 32 32l0 80-96 0 0-80c0-17.7 14.3-32 32-32zM96 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM240 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm144-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM464 0c-17.7 0-32 14.3-32 32l0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-288 112 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L496 32c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$60048819854688c5 = {
    prefix: 'fas',
    iconName: 'mug-saucer',
    icon: [
        576,
        512,
        [
            "coffee"
        ],
        "f0f4",
        "M64 64c0-17.7 14.3-32 32-32l352 0c70.7 0 128 57.3 128 128S518.7 288 448 288c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L64 64zm448 96c0-35.3-28.7-64-64-64l0 128c35.3 0 64-28.7 64-64zM64 448l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L64 512c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$1d24a9e457278011 = $159afdcd077ecfe9$export$60048819854688c5;
var $159afdcd077ecfe9$export$4fbda8f64648f3b5 = {
    prefix: 'fas',
    iconName: 'lemon',
    icon: [
        448,
        512,
        [
            127819
        ],
        "f094",
        "M448 96c0-35.3-28.7-64-64-64-6.6 0-13 1-19 2.9-22.5 7-48.1 14.9-71 9-75.2-19.1-156.4 11-213.7 68.3S-7.2 250.8 11.9 326c5.8 22.9-2 48.4-9 71-1.9 6-2.9 12.4-2.9 19 0 35.3 28.7 64 64 64 6.6 0 13-1 19.1-2.9 22.5-7 48.1-14.9 71-9 75.2 19.1 156.4-11 213.7-68.3S455.2 261.2 436.1 186c-5.8-22.9 2-48.4 9-71 1.9-6 2.9-12.4 2.9-19.1zM222.7 143c-52 15.2-96.5 59.7-111.7 111.7-3.7 12.7-17.1 20-29.8 16.3S61.2 254 65 241.3c19.8-67.7 76.6-124.5 144.3-144.3 12.7-3.7 26.1 3.6 29.8 16.3s-3.6 26.1-16.3 29.8z"
    ]
};
var $159afdcd077ecfe9$export$afb5d0eee7c1bdb = {
    prefix: 'fas',
    iconName: 'caravan',
    icon: [
        640,
        512,
        [],
        "f8ff",
        "M32 96c0-35.3 28.7-64 64-64l320 0c70.7 0 128 57.3 128 128l0 192 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-296.4 0c.2 2.6 .4 5.3 .4 8 0 48.6-39.4 88-88 88s-88-39.4-88-88c0-2.7 .1-5.4 .4-8L96 416c-35.3 0-64-28.7-64-64L32 96zM352 352l64 0c17.7 0 32-14.3 32-32l0-48-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 160c0 17.7 14.3 32 32 32zM160 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zm64 336a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"
    ]
};
var $159afdcd077ecfe9$export$5a2b164552deda9f = {
    prefix: 'fas',
    iconName: 'q',
    icon: [
        448,
        512,
        [
            113
        ],
        "51",
        "M64 256c0 88.4 71.6 160 160 160 28.9 0 56-7.7 79.4-21.1l-72-86.4c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l70.9 85.1c20.4-26.8 32.5-60.3 32.5-96.6 0-88.4-71.6-160-160-160S64 167.6 64 256zM344.9 444.6C310 467 268.5 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32 448 132.3 448 256c0 56.1-20.6 107.4-54.7 146.7l47.3 56.8c11.3 13.6 9.5 33.8-4.1 45.1s-33.8 9.5-45.1-4.1l-46.6-55.9z"
    ]
};
var $159afdcd077ecfe9$export$7aa08ad5d562578a = {
    prefix: 'fas',
    iconName: 'lock',
    icon: [
        384,
        512,
        [
            128274
        ],
        "f023",
        "M128 96l0 64 128 0 0-64c0-35.3-28.7-64-64-64s-64 28.7-64 64zM64 160l0-64C64 25.3 121.3-32 192-32S320 25.3 320 96l0 64c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64z"
    ]
};
var $159afdcd077ecfe9$export$d1de8d1b815d6a5 = {
    prefix: 'fas',
    iconName: 'paint-roller',
    icon: [
        512,
        512,
        [],
        "f5aa",
        "M0 64C0 28.7 28.7 0 64 0L352 0c35.3 0 64 28.7 64 64l16 0c44.2 0 80 35.8 80 80l0 96c0 44.2-35.8 80-80 80l-160 0c-8.8 0-16 7.2-16 16l0 18.7c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-32 0c-26.5 0-48-21.5-48-48l0-96c0-20.9 13.4-38.7 32-45.3l0-18.7c0-44.2 35.8-80 80-80l160 0c8.8 0 16-7.2 16-16l0-96c0-8.8-7.2-16-16-16l-16 0c0 35.3-28.7 64-64 64L64 192c-35.3 0-64-28.7-64-64L0 64z"
    ]
};
var $159afdcd077ecfe9$export$39461921e738be65 = {
    prefix: 'fas',
    iconName: 'volume-high',
    icon: [
        640,
        512,
        [
            128266,
            "volume-up"
        ],
        "f028",
        "M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.7 640 346.2 640 256S598.5 85.2 533.6 32.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5zM80 352l48 0 134.1 119.2c6.4 5.7 14.6 8.8 23.1 8.8 19.2 0 34.8-15.6 34.8-34.8l0-378.4c0-19.2-15.6-34.8-34.8-34.8-8.5 0-16.7 3.1-23.1 8.8L128 160 80 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48z"
    ]
};
var $159afdcd077ecfe9$export$5940d3e475d90cc4 = $159afdcd077ecfe9$export$39461921e738be65;
var $159afdcd077ecfe9$export$e18e05ffa2045d3b = {
    prefix: 'fas',
    iconName: 'folder-plus',
    icon: [
        512,
        512,
        [],
        "f65e",
        "M512 384c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l138.7 0c13.8 0 27.3 4.5 38.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L448 80c35.3 0 64 28.7 64 64l0 240zM256 160c-13.3 0-24 10.7-24 24l0 48-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0 0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-48 48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0 0-48c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$e134ecd00b622a47 = {
    prefix: 'fas',
    iconName: 'mercury',
    icon: [
        384,
        512,
        [
            9791
        ],
        "f223",
        "M117-4C106-17.8 85.8-20 72.1-9s-16 31.2-5 45C74.9 45.7 83.7 54.5 93.5 62.1 46.7 93.7 16 147.3 16 208 16 294.3 78.1 366.1 160 381.1l0 34.9-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-34.9c81.9-15 144-86.8 144-173.1 0-60.7-30.7-114.3-77.5-145.9 9.8-7.7 18.7-16.4 26.4-26.1 11.1-13.8 8.8-33.9-5-45S278-17.8 267-4c-17.6 22-44.7 36-75 36S134.7 18 117-4zm75 324c-61.9 0-112-50.1-112-112S130.1 96 192 96 304 146.1 304 208c0 61.8-50.1 112-111.9 112l-.1 0z"
    ]
};
var $159afdcd077ecfe9$export$12a35719f889cd1 = {
    prefix: 'fas',
    iconName: 'anchor',
    icon: [
        576,
        512,
        [
            9875
        ],
        "f13d",
        "M288 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM192 96c0-53 43-96 96-96s96 43 96 96c0 41.8-26.7 77.4-64 90.5l0 257.9c62.9-14.3 110.2-69.7 111.9-136.5l-16.1 14.1c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9l64-56c9-7.9 22.6-7.9 31.6 0l64 56c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3L496 307.9C493.9 421 401.6 512 288 512S82.1 421 80 307.9L63.8 322.1c-10 8.7-25.1 7.7-33.9-2.3s-7.7-25.1 2.3-33.9l64-56c9-7.9 22.6-7.9 31.6 0l64 56c10 8.7 11 23.9 2.3 33.9s-23.9 11-33.9 2.3l-16.1-14.1c1.8 66.8 49.1 122.2 111.9 136.5l0-257.9c-37.3-13.2-64-48.7-64-90.5z"
    ]
};
var $159afdcd077ecfe9$export$f2cfa036d76f69ab = {
    prefix: 'fas',
    iconName: 'square-parking',
    icon: [
        448,
        512,
        [
            127359,
            "parking"
        ],
        "f540",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM192 256l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-48 0 0 64zm48 64l-48 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-184c0-22.1 17.9-40 40-40l72 0c53 0 96 43 96 96s-43 96-96 96z"
    ]
};
var $159afdcd077ecfe9$export$fda29c8f99573a4e = $159afdcd077ecfe9$export$f2cfa036d76f69ab;
var $159afdcd077ecfe9$export$3dcd4ca3f7108a82 = {
    prefix: 'fas',
    iconName: 'hanukiah',
    icon: [
        640,
        512,
        [
            128334
        ],
        "f6e6",
        "M314.2 3.3c-5.1 8.8-18.2 33.3-18.2 52.7 0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zm-288 48C21.1 60.1 8 84.6 8 104 8 117.3 18.7 128 32 128s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM88 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C101.1 60.1 88 84.6 88 104zm82.2-52.7c-5.1 8.8-18.2 33.3-18.2 52.7 0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM216 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C229.1 60.1 216 84.6 216 104zM394.2 51.3c-5.1 8.8-18.2 33.3-18.2 52.7 0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM440 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C453.1 60.1 440 84.6 440 104zm82.2-52.7c-5.1 8.8-18.2 33.3-18.2 52.7 0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3zM584 104c0 13.3 10.7 24 24 24s24-10.7 24-24c0-19.4-13.1-43.9-18.2-52.7-1.2-2.1-3.4-3.3-5.8-3.3s-4.6 1.2-5.8 3.3C597.1 60.1 584 84.6 584 104zM112 160c-8.8 0-16 7.2-16 16l0 112 32 0 0-112c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 112 32 0 0-112c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 112 32 0 0-112c0-8.8-7.2-16-16-16zm160 0c-8.8 0-16 7.2-16 16l0 112 32 0 0-112c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 112 32 0 0-112c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16l0 112 32 0 0-112c0-8.8-7.2-16-16-16zM352 144c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176-192 0c-17.7 0-32-14.3-32-32l0-96c0-17.7-14.3-32-32-32S0 174.3 0 192l0 96c0 53 43 96 96 96l192 0 0 64-128 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0 0-64 192 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32l-192 0 0-176z"
    ]
};
var $159afdcd077ecfe9$export$7adaa412bd8eb08f = {
    prefix: 'fas',
    iconName: 'rotate-left',
    icon: [
        512,
        512,
        [
            "rotate-back",
            "rotate-backward",
            "undo-alt"
        ],
        "f2ea",
        "M24 192l144 0c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2l-46.7-46.7c75.3-58.6 184.3-53.3 253.5 15.9 75 75 75 196.5 0 271.5s-196.5 75-271.5 0c-10.2-10.2-19-21.3-26.4-33-9.5-14.9-29.3-19.3-44.2-9.8s-19.3 29.3-9.8 44.2C49.7 408.7 61.4 423.5 75 437 175 537 337 537 437 437S537 175 437 75C342.8-19.3 193.3-24.7 92.7 58.8L41 7C34.1 .2 23.8-1.9 14.8 1.8S0 14.3 0 24L0 168c0 13.3 10.7 24 24 24z"
    ]
};
var $159afdcd077ecfe9$export$9706706f1bc7b12 = $159afdcd077ecfe9$export$7adaa412bd8eb08f;
var $159afdcd077ecfe9$export$4ceb0b05fed961a9 = $159afdcd077ecfe9$export$7adaa412bd8eb08f;
var $159afdcd077ecfe9$export$c8197b992c46c4a6 = $159afdcd077ecfe9$export$7adaa412bd8eb08f;
var $159afdcd077ecfe9$export$4805b8d175aeb9fb = {
    prefix: 'fas',
    iconName: 'heading',
    icon: [
        448,
        512,
        [
            "header"
        ],
        "f1dc",
        "M0 64C0 46.3 14.3 32 32 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 112 224 0 0-112-16 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-16 0 0 320 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-144-224 0 0 144 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-320-16 0C14.3 96 0 81.7 0 64z"
    ]
};
var $159afdcd077ecfe9$export$579f9604bb10a61a = $159afdcd077ecfe9$export$4805b8d175aeb9fb;
var $159afdcd077ecfe9$export$721c101130c40043 = {
    prefix: 'fas',
    iconName: 'crosshairs',
    icon: [
        576,
        512,
        [],
        "f05b",
        "M288-16c17.7 0 32 14.3 32 32l0 18.3c98.1 14 175.7 91.6 189.7 189.7l18.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-18.3 0c-14 98.1-91.6 175.7-189.7 189.7l0 18.3c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.3C157.9 463.7 80.3 386.1 66.3 288L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l18.3 0C80.3 125.9 157.9 48.3 256 34.3L256 16c0-17.7 14.3-32 32-32zM131.2 288c12.7 62.7 62.1 112.1 124.8 124.8l0-12.8c0-17.7 14.3-32 32-32s32 14.3 32 32l0 12.8c62.7-12.7 112.1-62.1 124.8-124.8L432 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l12.8 0C432.1 161.3 382.7 111.9 320 99.2l0 12.8c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-12.8C193.3 111.9 143.9 161.3 131.2 224l12.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-12.8 0zM288 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $159afdcd077ecfe9$export$de462dd5a18e80d4 = {
    prefix: 'fas',
    iconName: 'circle-nodes',
    icon: [
        512,
        512,
        [],
        "e4e2",
        "M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9 0-44.2-35.8-80-80-80-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128 35.8 128 0 163.8 0 208s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"
    ]
};
var $159afdcd077ecfe9$export$eccfff9bfd585652 = {
    prefix: 'fas',
    iconName: 'window-restore',
    icon: [
        576,
        512,
        [],
        "f2d2",
        "M512 96L160 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-48 0 0-64 48 0 0-192zM0 224c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 224zm64 40c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 240c-13.3 0-24 10.7-24 24z"
    ]
};
var $159afdcd077ecfe9$export$eb4c616de6eef46f = {
    prefix: 'fas',
    iconName: 'r',
    icon: [
        320,
        512,
        [
            114
        ],
        "52",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 95.3 0 102.4 146.4c10.1 14.5 30.1 18 44.6 7.9s18-30.1 7.9-44.6L230.1 309.5C282.8 288.1 320 236.4 320 176 320 96.5 255.5 32 176 32L32 32zM176 256l-112 0 0-160 112 0c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
    ]
};
var $159afdcd077ecfe9$export$fb5ab619c34ea613 = {
    prefix: 'fas',
    iconName: 'filter-circle-xmark',
    icon: [
        576,
        512,
        [],
        "e17b",
        "M32 64C19.1 64 7.4 71.8 2.4 83.8S.2 109.5 9.4 118.6L192 301.3 192 416c0 8.5 3.4 16.6 9.4 22.6l64 64c2.5 2.5 5.3 4.5 8.3 6-21.2-30.9-33.6-68.3-33.6-108.6 0-99.4 75.5-181.1 172.3-191l90.4-90.4c9.2-9.2 11.9-22.9 6.9-34.9S492.9 64 480 64L32 64zM432 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7l-36.7 36.7 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $159afdcd077ecfe9$export$31f89d8ac1d14ed6 = {
    prefix: 'fas',
    iconName: 'gopuram',
    icon: [
        512,
        512,
        [],
        "f664",
        "M120 0c13.3 0 24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 48 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 8 40 0 0-8c0-13.3 10.7-24 24-24s24 10.7 24 24l0 136c26.5 0 48 21.5 48 48l0 80c26.5 0 48 21.5 48 48l0 128c0 26.5-21.5 48-48 48l-48 0 0-224-32 0 0-128-48 0 0 128 32 0 0 224-224 0 0-224 32 0 0-128-48 0 0 128-32 0 0 224-48 0c-26.5 0-48-21.5-48-48L0 336c0-26.5 21.5-48 48-48l0-80c0-26.5 21.5-48 48-48L96 24c0-13.3 10.7-24 24-24zM256 208c-17.7 0-32 14.3-32 32l0 48 64 0 0-48c0-17.7-14.3-32-32-32zM208 400l0 64 96 0 0-64c0-26.5-21.5-48-48-48s-48 21.5-48 48zM256 96c-17.7 0-32 14.3-32 32l0 32 64 0 0-32c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$24c21c3ca00f3625 = {
    prefix: 'fas',
    iconName: 'heart-circle-minus',
    icon: [
        576,
        512,
        [],
        "e4ff",
        "M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 17.6-3.4 35.6-9.5 53.7-21.8-8.6-45.6-13.4-70.5-13.4-106 0-192 86-192 192 0 28.5 6.2 55.6 17.4 80-.5 0-.9 0-1.4 0-15.5 0-30.8-4.6-43.1-14.1-73-55.7-212.9-186-212.9-298.2l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"
    ]
};
var $159afdcd077ecfe9$export$aa3c4c1c5a47bf98 = {
    prefix: 'fas',
    iconName: 'star-of-life',
    icon: [
        512,
        512,
        [],
        "f621",
        "M208.5 32c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 140.9 122-70.4c15.3-8.8 34.9-3.6 43.7 11.7l16 27.7c8.8 15.3 3.6 34.9-11.7 43.7l-122 70.4 122 70.4c15.3 8.8 20.6 28.4 11.7 43.7l-16 27.7c-8.8 15.3-28.4 20.6-43.7 11.7l-122-70.4 0 140.9c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-140.9-122 70.4c-15.3 8.8-34.9 3.6-43.7-11.7l-16-27.7c-8.8-15.3-3.6-34.9 11.7-43.7l122-70.4-122-70.4c-15.3-8.8-20.5-28.4-11.7-43.7l16-27.7c8.8-15.3 28.4-20.5 43.7-11.7l122 70.4 0-140.9z"
    ]
};
var $159afdcd077ecfe9$export$694b7e88782dec12 = {
    prefix: 'fas',
    iconName: 'business-time',
    icon: [
        640,
        512,
        [
            "briefcase-clock"
        ],
        "f64a",
        "M264 48l112 0c4.4 0 8 3.6 8 8l0 40-128 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-80 0c-35.3 0-64 28.7-64 64l0 96 305 0c33.8-29.9 78.3-48 127-48 28.6 0 55.6 6.2 80 17.4l0-65.4c0-35.3-28.7-64-64-64l-80 0 0-40c0-30.9-25.1-56-56-56L264 0c-30.9 0-56 25.1-56 56zm80 296c-17.7 0-32-14.3-32-32l0-16-192 0 0 112c0 35.3 28.7 64 64 64l193.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-16.6 2.1-32.7 6-48l-22 0zm352 48a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM496 320c8.8 0 16 7.2 16 16l0 48 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$8b00ae94743552ce = $159afdcd077ecfe9$export$694b7e88782dec12;
var $159afdcd077ecfe9$export$d75fb6743634a0a = {
    prefix: 'fas',
    iconName: 'fire-extinguisher',
    icon: [
        512,
        512,
        [
            129519
        ],
        "f134",
        "M512 32c0-9.6-4.3-18.7-11.7-24.7S483.1-1.3 473.7 .6l-160 32C301.5 35.1 292 44.3 289 56l-65 0 0-24c0-17.7-14.3-32-32-32L160 0c-17.7 0-32 14.3-32 32l0 28.4c-55.3 12.3-101.3 49.5-125.5 99.1-5.8 11.9-.9 26.3 11.1 32.1s26.3 .9 32.1-11.1C62 146.9 91.8 121.1 128 110l0 28.8c-37.8 18-64 56.5-64 101.2l0 128 224 0 0-128c0-44.7-26.2-83.2-64-101.2l0-34.8 65 0c3 11.7 12.5 20.9 24.7 23.4l160 32c9.4 1.9 19.1-.6 26.6-6.6S512 137.6 512 128l0-96zM288 448l0-32-224 0 0 32c0 35.3 28.7 64 64 64l96 0c35.3 0 64-28.7 64-64z"
    ]
};
var $159afdcd077ecfe9$export$5977e8de7e65b20 = {
    prefix: 'fas',
    iconName: 'arrow-down-long',
    icon: [
        320,
        512,
        [
            "long-arrow-down"
        ],
        "f175",
        "M137.4 534.6c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 434.7 192 0c0-17.7-14.3-32-32-32S128-17.7 128 0l0 434.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128z"
    ]
};
var $159afdcd077ecfe9$export$52ecf90b62f3f030 = $159afdcd077ecfe9$export$5977e8de7e65b20;
var $159afdcd077ecfe9$export$d6e17c0df8ed1bf7 = {
    prefix: 'fas',
    iconName: 'user-minus',
    icon: [
        640,
        512,
        [],
        "f503",
        "M136 128a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zM48 482.3C48 383.8 127.8 304 226.3 304l59.4 0c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7L77.7 512C61.3 512 48 498.7 48 482.3zM472 168l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$be069f641c85d0b3 = {
    prefix: 'fas',
    iconName: 'money-check',
    icon: [
        512,
        512,
        [],
        "f53c",
        "M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM96 312c0 13.3 10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0c-13.3 0-24 10.7-24 24zm24-136c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-272 0z"
    ]
};
var $159afdcd077ecfe9$export$6486d62e77b910 = {
    prefix: 'fas',
    iconName: 'house-laptop',
    icon: [
        640,
        512,
        [
            "laptop-house"
        ],
        "e066",
        "M448 240l19.9 0c15.5 0 28.1-12.6 28.1-28.1 0-7.6-3.1-14.9-8.6-20.2L283.5-4.9C276.1-12 266.3-16 256-16s-20.1 4-27.5 11.1L24.6 191.7C19.1 197 16 204.3 16 211.9 16 227.4 28.6 240 44.1 240l19.9 0 0 144c0 35.3 28.7 64 64 64l85.7 0c7.4-6.6 16.4-11.4 26.3-14l0-130c0-5.5 .7-10.9 2-16l-10 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 24 144 0zM352 352l160 0 0 128-160 0 0-128zm-64-32l0 160-32 0c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16l-32 0 0-160c0-17.7-14.3-32-32-32l-224 0c-17.7 0-32 14.3-32 32z"
    ]
};
var $159afdcd077ecfe9$export$efd983de5e4d6ad3 = $159afdcd077ecfe9$export$6486d62e77b910;
var $159afdcd077ecfe9$export$8f734e51d72ca13a = {
    prefix: 'fas',
    iconName: 'download',
    icon: [
        448,
        512,
        [],
        "f019",
        "M256 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 210.7-41.4-41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c12.5 12.5 32.8 12.5 45.3 0l96-96c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 242.7 256 32zM64 320c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-46.9 0-56.6 56.6c-31.2 31.2-81.9 31.2-113.1 0L110.9 320 64 320zm304 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$ce96e32767a7dd51 = {
    prefix: 'fas',
    iconName: 'couch',
    icon: [
        640,
        512,
        [],
        "f4b8",
        "M144 272C144 224.7 109.8 185.4 64.8 177.5 72 113.6 126.2 64 192 64l256 0c65.8 0 120 49.6 127.2 113.5-45 8-79.2 47.2-79.2 94.5l0 32-352 0 0-32zM0 384L0 272c0-26.5 21.5-48 48-48s48 21.5 48 48l0 80 448 0 0-80c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64z"
    ]
};
var $159afdcd077ecfe9$export$b81a894d5bc3eb17 = {
    prefix: 'fas',
    iconName: 'road-lock',
    icon: [
        576,
        512,
        [],
        "e567",
        "M256 32l-76.3 0c-29.4 0-55.1 20.1-62.1 48.6L33.4 420.5C25.9 450.7 48.8 480 80 480l175.9 0 0-64c0-17.7 14.3-32 32-32 6.1 0 11.8 1.7 16.7 4.7 2.8-23.9 14.3-45.1 31.4-60.3l0-24.4c0-70.7 57.3-128 128-128 6.2 0 12.4 .4 18.4 1.3L458.5 80.6C451.4 52.1 425.8 32 396.3 32l-76.4 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zm64 192l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32zm176 80.1l0 47.9-64 0 0-47.9c0-17.7 14.3-32 32-32s32 14.3 32 32zM352 400l0 96c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-96c0-20.9-13.4-38.7-32-45.3l0-50.6c0-44.2-35.8-80-80-80s-80 35.8-80 80l0 50.6c-18.6 6.6-32 24.4-32 45.3z"
    ]
};
var $159afdcd077ecfe9$export$b2a906a5928c6404 = {
    prefix: 'fas',
    iconName: 'scissors',
    icon: [
        512,
        512,
        [
            9984,
            9986,
            9988,
            "cut"
        ],
        "f0c4",
        "M192 256l-39.5 39.5c-12.6-4.9-26.2-7.5-40.5-7.5-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112c0-14.3-2.7-27.9-7.5-40.5L499.2 76.8c7.1-7.1 7.1-18.5 0-25.6-28.3-28.3-74.1-28.3-102.4 0L256 192 216.5 152.5c4.9-12.6 7.5-26.2 7.5-40.5 0-61.9-50.1-112-112-112S0 50.1 0 112 50.1 224 112 224c14.3 0 27.9-2.7 40.5-7.5L192 256zm97.9 97.9L396.8 460.8c28.3 28.3 74.1 28.3 102.4 0 7.1-7.1 7.1-18.5 0-25.6l-145.3-145.3-64 64zM64 112a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48 240a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
    ]
};
var $159afdcd077ecfe9$export$66847f2a71b260e7 = $159afdcd077ecfe9$export$b2a906a5928c6404;
var $159afdcd077ecfe9$export$a18cfac400116d9f = {
    prefix: 'fas',
    iconName: 'bug',
    icon: [
        576,
        512,
        [],
        "f188",
        "M192 96c0-53 43-96 96-96s96 43 96 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4l-135.1 0c-15.7 0-28.4-12.7-28.4-28.4l0-3.6zm345.6 12.8c10.6 14.1 7.7 34.2-6.4 44.8l-97.8 73.3c5.3 8.9 9.3 18.7 11.8 29.1l98.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 32c0 2.6-.1 5.3-.2 7.9l83.4 62.5c14.1 10.6 17 30.7 6.4 44.8s-30.7 17-44.8 6.4l-63.1-47.3c-23.2 44.2-66.5 76.2-117.7 83.9L312 280c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 230.2c-51.2-7.7-94.5-39.7-117.7-83.9L83.2 473.6c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l83.4-62.5c-.1-2.6-.2-5.2-.2-7.9l0-32-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l98.8 0c2.5-10.4 6.5-20.2 11.8-29.1L44.8 153.6c-14.1-10.6-17-30.7-6.4-44.8s30.7-17 44.8-6.4L192 184c12.3-5.1 25.8-8 40-8l112 0c14.2 0 27.7 2.8 40 8l108.8-81.6c14.1-10.6 34.2-7.7 44.8 6.4z"
    ]
};
var $159afdcd077ecfe9$export$ca14f1b4d6afb7aa = {
    prefix: 'fas',
    iconName: 'arrow-right-from-bracket',
    icon: [
        512,
        512,
        [
            "sign-out"
        ],
        "f08b",
        "M160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0zM502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 192 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l210.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"
    ]
};
var $159afdcd077ecfe9$export$33e2b60243ca6d92 = $159afdcd077ecfe9$export$ca14f1b4d6afb7aa;
var $159afdcd077ecfe9$export$6638511b28df3be5 = {
    prefix: 'fas',
    iconName: 'hand-holding-hand',
    icon: [
        576,
        512,
        [],
        "e4f7",
        "M466.8 186.5l42.5-42.5 34.7 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L223.6 16c-29 0-57.3 9.3-80.7 26.5L16.3 135.8c-17.8 13.1-21.6 38.1-8.5 55.9s38.1 21.6 55.9 8.5L183.4 112 296 112c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l152.2 0c33.9 0 66.5-13.5 90.5-37.5zm-357.5 139L66.7 368 32 368c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 400 280 400c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z"
    ]
};
var $159afdcd077ecfe9$export$195780ddabd8e0c6 = {
    prefix: 'fas',
    iconName: 'stroopwafel',
    icon: [
        512,
        512,
        [],
        "f551",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM312.6 63.7c-6.2-6.2-16.4-6.2-22.6 0L256 97.6 222.1 63.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l33.9 33.9-45.3 45.3-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6-45.3 45.3-33.9-33.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L97.6 256 63.7 289.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 45.3 45.3-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6 45.3 45.3-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 45.3-45.3 56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6 45.3-45.3 33.9 33.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-33.9-33.9 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9-45.3-45.3 56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6-45.3-45.3 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6zM142.9 256l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zm67.9 67.9l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zM278.6 256l45.3-45.3 45.3 45.3-45.3 45.3-45.3-45.3zm22.6-67.9l-45.3 45.3-45.3-45.3 45.3-45.3 45.3 45.3z"
    ]
};
var $159afdcd077ecfe9$export$60b41e3581d1739a = {
    prefix: 'fas',
    iconName: 'child',
    icon: [
        320,
        512,
        [],
        "f1ae",
        "M96 64A64 64 0 1 1 224 64 64 64 0 1 1 96 64zm48 320l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32L80 287.8 59.1 321c-9.4 15-29.2 19.4-44.1 10S-4.5 301.9 4.9 287l39.9-63.3C69.7 184 113.2 160 160 160s90.3 24 115.2 63.6L315.1 287c9.4 15 4.9 34.7-10 44.1s-34.7 4.9-44.1-10L240 287.8 240 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-32 0z"
    ]
};
var $159afdcd077ecfe9$export$dd52741c60cc638f = {
    prefix: 'fas',
    iconName: 'ice-cream',
    icon: [
        384,
        512,
        [
            127848
        ],
        "f810",
        "M335.1 160c.6-5.3 .9-10.6 .9-16 0-79.5-64.5-144-144-144S48 64.5 48 144c0 5.4 .3 10.7 .9 16l-.9 0c-26.5 0-48 21.5-48 48s21.5 48 48 48l288 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-.9 0zM64 304L169.2 529.5c4.1 8.8 13 14.5 22.8 14.5s18.6-5.7 22.8-14.5L320 304 64 304z"
    ]
};
var $159afdcd077ecfe9$export$72cf138e5ddda6eb = {
    prefix: 'fas',
    iconName: 'computer-mouse',
    icon: [
        384,
        512,
        [
            128433,
            "mouse"
        ],
        "f8cc",
        "M0 192l168 0 0-192-8 0C71.6 0 0 71.6 0 160l0 32zm0 48L0 352c0 88.4 71.6 160 160 160l64 0c88.4 0 160-71.6 160-160l0-112-384 0zm384-48l0-32C384 71.6 312.4 0 224 0l-8 0 0 192 168 0z"
    ]
};
var $159afdcd077ecfe9$export$198b96b894c66074 = $159afdcd077ecfe9$export$72cf138e5ddda6eb;
var $159afdcd077ecfe9$export$a0856b225f3b0614 = {
    prefix: 'fas',
    iconName: 'faucet',
    icon: [
        512,
        512,
        [],
        "e005",
        "M192 64c0-17.7 14.3-32 32-32s32 14.3 32 32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 64 18.7 0c8.5 0 16.6 3.4 22.6 9.4l22.6 22.6 32 0c88.4 0 160 71.6 160 160 0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s-14.3-32-32-32l-36.1 0c-20.2 29-53.9 48-91.9 48s-71.7-19-91.9-48L32 352c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l96 0 22.6-22.6c6-6 14.1-9.4 22.6-9.4l18.7 0 0-64-96 0c-17.7 0-32-14.3-32-32S78.3 64 96 64l96 0z"
    ]
};
var $159afdcd077ecfe9$export$f8db2747dadd48f7 = {
    prefix: 'fas',
    iconName: 'award',
    icon: [
        448,
        512,
        [],
        "f559",
        "M245.9-25.9c-13.4-8.2-30.3-8.2-43.7 0-24.4 14.9-39.5 18.9-68.1 18.3-15.7-.4-30.3 8.1-37.9 21.9-13.7 25.1-24.8 36.2-49.9 49.9-13.8 7.5-22.2 22.2-21.9 37.9 .7 28.6-3.4 43.7-18.3 68.1-8.2 13.4-8.2 30.3 0 43.7 14.9 24.4 18.9 39.5 18.3 68.1-.4 15.7 8.1 30.3 21.9 37.9 22.1 12.1 33.3 22.1 45.1 41.5L42.7 458.5c-5.9 11.9-1.1 26.3 10.7 32.2l86 43c11.5 5.7 25.5 1.4 31.7-9.8l52.8-95.1 52.8 95.1c6.2 11.2 20.2 15.6 31.7 9.8l86-43c11.9-5.9 16.7-20.3 10.7-32.2l-48.6-97.2c11.7-19.4 23-29.4 45.1-41.5 13.8-7.5 22.2-22.2 21.9-37.9-.7-28.6 3.4-43.7 18.3-68.1 8.2-13.4 8.2-30.3 0-43.7-14.9-24.4-18.9-39.5-18.3-68.1 .4-15.7-8.1-30.3-21.9-37.9-25.1-13.7-36.2-24.8-49.9-49.9-7.5-13.8-22.2-22.2-37.9-21.9-28.6 .7-43.7-3.4-68.1-18.3zM224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $159afdcd077ecfe9$export$bac321083217fd4 = {
    prefix: 'fas',
    iconName: 'person-drowning',
    icon: [
        640,
        512,
        [],
        "e545",
        "M264 88a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM133.9 65.6c16.8-5.6 34.9 3.5 40.5 20.2l10.9 32.8c9.4 28.3 33.2 49.5 62.5 55.6 5.6 1.2 11.3 1.8 17.1 1.8l88 0c17.2 0 34.3-2.8 50.6-8.2l114.4-38.1c16.8-5.6 34.9 3.5 40.5 20.2s-3.5 34.9-20.2 40.5L423.7 228.5c-8.4 2.8-17 5.1-25.7 6.9l-26.5 88.3c-6.1 3.4-12.1 7.3-17.9 11.7-22.1 16.6-29.1 16.6-51.2 0-26.2-19.7-56.9-30.2-87.8-31.3l20.2-67.2c-51.5-10.7-93.5-48.1-110.2-98l-10.9-32.8c-5.6-16.8 3.5-34.9 20.2-40.5zM403.4 412.1C379.1 430.3 351.1 448 320 448s-59.1-17.7-83.4-35.9c-21.3-16.1-49.9-16.1-71.2 0-23.8 17.9-54.1 35.5-88.1 35.3-20.4-.1-40.7-6.7-59.8-21.1-10.6-8-12.7-23-4.7-33.6s23-12.7 33.6-4.7c11.3 8.5 21.6 11.4 31.2 11.5 17.6 .1 37.3-9.4 58.9-25.7 38.4-29 90.5-29 129 0 24 18.1 40.7 26.3 54.5 26.3s30.5-8.2 54.5-26.3c38.4-29 90.5-29 129 0 16.9 12.7 32.9 21.5 47.8 24.6 13.7 2.8 27.4 .9 42.3-10.3 10.6-8 25.6-5.9 33.6 4.7s5.9 25.6-4.7 33.6c-26.4 19.9-54.2 24.4-80.7 19.1-25.3-5.1-48.1-18.9-67.2-33.3-21.3-16.1-49.9-16.1-71.2 0z"
    ]
};
var $159afdcd077ecfe9$export$e0ce7d1aba7105e7 = {
    prefix: 'fas',
    iconName: 'camera-rotate',
    icon: [
        512,
        512,
        [],
        "e0d8",
        "M138.7 96l10.4-31.2C155.6 45.2 173.9 32 194.6 32l122.8 0c20.7 0 39 13.2 45.5 32.8L373.3 96 448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l74.7 0zM96 305.9c0 3.9 1.4 7.7 4 10.6l48 54c6.4 7.2 17.6 7.2 23.9 0l48-54c2.6-2.9 4-6.7 4-10.6l0-1.9c0-8.8-7.2-16-16-16l-24 0c0-39.8 32.2-72 72-72 4.4 0 8.7 .4 12.9 1.2l34.9-39.3c-14.6-6.4-30.8-9.9-47.8-9.9-66.3 0-120 53.7-120 120l-24 0c-8.8 0-16 7.2-16 16l0 1.9zm196-46.5c-2.6 2.9-4 6.7-4 10.6l0 1.9c0 8.8 7.2 16 16 16l24 0c0 39.8-32.2 72-72 72-4.4 0-8.7-.4-12.9-1.2l-34.9 39.3c14.7 6.4 30.8 9.9 47.8 9.9 66.3 0 120-53.7 120-120l24 0c8.8 0 16-7.2 16-16l0-1.9c0-3.9-1.4-7.7-4-10.6l-48-54c-6.4-7.2-17.6-7.2-23.9 0l-48 54z"
    ]
};
var $159afdcd077ecfe9$export$fbb22081b65e4f33 = {
    prefix: 'fas',
    iconName: 'face-grin-hearts',
    icon: [
        512,
        512,
        [
            128525,
            "grin-hearts"
        ],
        "f584",
        "M256 512c141.4 0 256-114.6 256-256 0-23.3-3.1-45.9-8.9-67.3 5.5-13.5 8.9-28.4 8.9-44.7 0-53-43-96-96-96l-2.9 0c-2.5 0-5 .1-7.4 .3-42.1-30.4-93.8-48.3-149.7-48.3S148.4 17.9 106.3 48.3c-2.5-.2-4.9-.3-7.4-.3L96 48c-53 0-96 43-96 96 0 16.3 3.5 31.2 8.9 44.7-5.8 21.4-8.9 44-8.9 67.3 0 141.4 114.6 256 256 256zM386.7 324.9c11.9-3.7 23.9 6.3 19.6 18.1-22.4 61.3-81.3 105.1-150.3 105.1S128.1 404.2 105.7 342.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1zM322.9 96c13.5 0 26.5 5.4 36 14.9l9.1 9.1 9.1-9.1c9.5-9.5 22.5-14.9 36-14.9l2.9 0c26.5 0 48 21.5 48 48 0 53.4-66.9 95.7-89 108.2-4.4 2.5-9.6 2.5-14 0-22.1-12.5-89-54.8-89-108.2 0-26.5 21.5-48 48-48l2.9 0zm-188 14.9l9.1 9.1 9.1-9.1c9.5-9.5 22.5-14.9 36-14.9l2.9 0c26.5 0 48 21.5 48 48 0 53.4-66.9 95.7-89 108.2-4.4 2.5-9.6 2.5-14 0-22.1-12.5-89-54.8-89-108.2 0-26.5 21.5-48 48-48l2.9 0c13.5 0 26.5 5.4 36 14.9z"
    ]
};
var $159afdcd077ecfe9$export$c56cf0e0c3bc5ed2 = $159afdcd077ecfe9$export$fbb22081b65e4f33;
var $159afdcd077ecfe9$export$876f7406f579ec02 = {
    prefix: 'fas',
    iconName: 'file-fragment',
    icon: [
        384,
        512,
        [],
        "e697",
        "M64 0C28.7 0 0 28.7 0 64l0 240 128 0c44.2 0 80 35.8 80 80l0 128 112 0c35.3 0 64-28.7 64-64l0-277.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176zM32 352c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0z"
    ]
};
var $159afdcd077ecfe9$export$842b988dae95ccb8 = {
    prefix: 'fas',
    iconName: 'person-military-rifle',
    icon: [
        448,
        512,
        [],
        "e54b",
        "M128 39c0-13 10-23.8 22.9-24.9L302.7 1.4C312 .7 320 8 320 17.4L320 48c0 8.8-7.2 16-16 16L153 64c-13.8 0-25-11.2-25-25zm17.6 57l156.8 0c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16zm228 364.3L320 369.7 320 480c0 1.3-.1 2.5-.2 3.8L145.5 234.9c16.6-7.1 34.6-10.9 53.3-10.9l50.4 0c15.9 0 31.3 2.8 45.8 7.9L389.9 67.7c-7.7-4.4-10.3-14.2-5.9-21.9s14.2-10.3 21.9-5.9l27.7 16c7.7 4.4 10.3 14.2 5.9 21.9l-55.5 96.1 1.6 .9c15.3 8.8 20.6 28.4 11.7 43.7L360.7 282c2 2.8 3.9 5.8 5.7 8.8l76.1 128.8c11.2 19 4.9 43.5-14.1 54.8s-43.5 4.9-54.8-14.1zM288 512l-128 0c-17.7 0-32-14.3-32-32l0-110.3-53.6 90.6c-11.2 19-35.8 25.3-54.8 14.1S-5.7 438.7 5.6 419.7L81.7 290.8c9.4-15.8 21.7-29.3 36-40L299.1 510c-3.5 1.3-7.2 2-11.1 2zM264 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$5cffc34afa81e517 = {
    prefix: 'fas',
    iconName: 'toggle-on',
    icon: [
        576,
        512,
        [],
        "f205",
        "M192 64C86 64 0 150 0 256S86 448 192 448l192 0c106 0 192-86 192-192S490 64 384 64L192 64zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $159afdcd077ecfe9$export$895159d10626af74 = {
    prefix: 'fas',
    iconName: 'lungs-virus',
    icon: [
        576,
        512,
        [],
        "e067",
        "M288 0c-17.7 0-32 14.3-32 32l0 151.3c9.6-4.8 20.5-7.5 32-7.5s22.4 2.7 32 7.5L320 32c0-17.7-14.3-32-32-32zM450.1 451c8 18.3 8.1 39.2 .2 57.5 10.2 2.3 20.6 3.5 31.2 3.5 52.2 0 94.5-42.3 94.5-94.5l0-6.2c0-111.1-36.7-219-104.4-307L428.9 48.7c-8.1-10.6-20.7-16.7-34-16.7-23.7 0-42.9 19.2-42.9 42.9l0 139.9c1.2 2.2 2.2 4.6 3.1 6.9 26.4-11.6 58.3-6.6 79.9 15s26.6 53.6 15 79.9C477 327.2 496 353.3 496 383.8s-19 56.7-45.9 67.1zM220.9 221.8c.9-2.4 2-4.7 3.1-6.9l0-138.5c0-24.5-19.9-44.4-44.4-44.4-12.5 0-24.4 5.3-32.8 14.5l-26.4 29C42.9 160.8 0 271.8 0 387l0 30.5c0 52.2 42.3 94.5 94.5 94.5 10.5 0 21-1.2 31.2-3.5-7.9-18.3-7.8-39.3 .2-57.5-26.9-10.4-45.9-36.6-45.9-67.1s19-56.7 45.9-67.1c-11.6-26.4-6.6-58.3 15-79.9s53.6-26.6 79.9-15zM152 408c28.8 0 43.2 34.8 22.9 55.2-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.4-20.4 55.2-5.9 55.2 22.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-28.8 34.8-43.2 55.2-22.9 9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.4-20.4-5.9-55.2 22.9-55.2 13.3 0 24-10.7 24-24s-10.7-24-24-24c-28.8 0-43.2-34.8-22.9-55.2 9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.4 20.4-55.2 5.9-55.2-22.9 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 28.8-34.8 43.2-55.2 22.9-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.4 20.4 5.9 55.2-22.9 55.2-13.3 0-24 10.7-24 24s10.7 24 24 24zm104-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$eabe53838d45ac6a = {
    prefix: 'fas',
    iconName: 'table-tennis-paddle-ball',
    icon: [
        512,
        512,
        [
            127955,
            "ping-pong-paddle-ball",
            "table-tennis"
        ],
        "f45d",
        "M97 127l67.4-67.4c38.2-38.2 90-59.6 144-59.6 112.5 0 203.7 91.2 203.7 203.6 0 46.4-15.8 91.1-44.5 127-23.6-16.8-52.4-26.7-83.5-26.7-31.1 0-59.9 9.9-83.4 26.6L97 127zM240 448c0 9.7 1 19.1 2.8 28.2-19.8-5.2-38-15.5-52.7-30.2-12.2-12.2-31.9-12.2-44.1 0L96.6 495.4c-10.6 10.6-25 16.6-40 16.6-31.2 0-56.6-25.3-56.6-56.6 0-15 6-29.4 16.6-40l49.4-49.4c12.2-12.2 12.2-31.9 0-44.1-21.7-21.7-33.9-51.2-33.9-81.9 0-29.4 11.1-57.6 31.1-79L266.6 364.6C249.9 388.1 240 416.9 240 448zm144-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $159afdcd077ecfe9$export$ebb246c621751737 = $159afdcd077ecfe9$export$eabe53838d45ac6a;
var $159afdcd077ecfe9$export$f378fbb4e0ef7edf = $159afdcd077ecfe9$export$eabe53838d45ac6a;
var $159afdcd077ecfe9$export$e81e7f3390fe84fe = {
    prefix: 'fas',
    iconName: 'boxes-packing',
    icon: [
        576,
        512,
        [],
        "e4c7",
        "M208 0l80 0 0 56c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-56 80 0c26.5 0 48 21.5 48 48l0 416c0 26.5-21.5 48-48 48l-108.8 0c8.2-14.1 12.8-30.5 12.8-48l0-160c10-13.4 16-30 16-48l0-32c0-44.2-35.8-80-80-80l-176 0 0-96c0-26.5 21.5-48 48-48zM32 336l320 0 0 128c0 26.5-21.5 48-48 48L80 512c-26.5 0-48-21.5-48-48l0-128zM48 192l288 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32l0-32c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$c9dc1583b207b7ff = {
    prefix: 'fas',
    iconName: 'person-chalkboard',
    icon: [
        640,
        512,
        [],
        "e53d",
        "M192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM176 512l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-48 192 0 0 192-192 0 0-32-64 0 0 48c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 64-122.7 0c-45.6 0-88.5 21.6-115.6 58.2L14.3 260.9c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L112 236.7 112 512c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $159afdcd077ecfe9$export$4d85df590065572f = {
    prefix: 'fas',
    iconName: 'dice-two',
    icon: [
        448,
        512,
        [
            9857
        ],
        "f528",
        "M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM352 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM128 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$56b6d3d7d0e67a1c = {
    prefix: 'fas',
    iconName: 'arrow-right-arrow-left',
    icon: [
        512,
        512,
        [
            8644,
            "exchange"
        ],
        "f0ec",
        "M502.6 150.6l-96 96c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L402.7 160 32 160c-17.7 0-32-14.3-32-32S14.3 96 32 96l370.7 0-41.4-41.4c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3zm-397.3 352l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L109.3 352 480 352c17.7 0 32 14.3 32 32s-14.3 32-32 32l-370.7 0 41.4 41.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var $159afdcd077ecfe9$export$1aab915ca61b734a = $159afdcd077ecfe9$export$56b6d3d7d0e67a1c;
var $159afdcd077ecfe9$export$e15f65e77f717c29 = {
    prefix: 'fas',
    iconName: 'football',
    icon: [
        512,
        512,
        [
            127944,
            "football-ball"
        ],
        "f44e",
        "M261.1 22.6c-89 18-150.5 63.4-190 123.9-23.3 35.6-38.1 75.3-46.7 115.5L251.9 489.4c89-18 150.5-63.4 190.1-123.9 23.3-35.6 38.1-75.3 46.7-115.5L261.1 22.6zm236 168.1c3.2-42.3 .7-83.3-4.8-118.7-4.4-27.8-26.8-48-53.1-51.6-43-5.9-82.2-7.5-117.8-5.4L497.1 190.6zM191.7 497.1L15.9 321.4c-3.2 42.3-.7 83.3 4.8 118.7 4.4 27.8 26.8 48 53.1 51.6 43 5.9 82.2 7.5 117.8 5.4zM271.5 143c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9zm-64 64c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9zm-64 64c9.4-9.4 24.6-9.4 33.9 0l64 64c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$e8fd664711e31704 = $159afdcd077ecfe9$export$e15f65e77f717c29;
var $159afdcd077ecfe9$export$24b8a0147653649a = {
    prefix: 'fas',
    iconName: 'truck-monster',
    icon: [
        576,
        512,
        [],
        "f63b",
        "M336 96l48 64-128 0 0-64 80 0zm128 64L387.2 57.6C375.1 41.5 356.1 32 336 32L224 32c-17.7 0-32 14.3-32 32l0 96-144 0c-26.5 0-48 21.5-48 48l0 64c0 18.1 10.1 33.9 24.9 42.1-.5 5.7 1.1 11.6 4.7 16.4-3.7 6.9-6.8 14.1-9 21.8-11.6 1.7-20.6 11.7-20.6 23.8l0 16c0 12.1 8.9 22.1 20.6 23.8 2.2 7.6 5.3 14.9 9 21.8-7 9.4-6.3 22.8 2.3 31.3l11.3 11.3c8.6 8.6 21.9 9.3 31.3 2.2 6.8 3.7 14.1 6.8 21.7 9 1.7 11.6 11.7 20.6 23.8 20.6l16 0c12.1 0 22.1-8.9 23.8-20.6 7.6-2.2 14.9-5.3 21.7-9 9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.3-31.3 3.7-6.8 6.8-14.1 9-21.7 11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8-2.2-7.6-5.3-14.9-9-21.7 2.4-3.2 3.9-6.8 4.5-10.5l114.2 0c.6 3.7 2.1 7.3 4.5 10.5-3.7 6.9-6.8 14.1-9 21.8-11.6 1.7-20.6 11.7-20.6 23.8l0 16c0 12.1 8.9 22.1 20.6 23.8 2.2 7.6 5.3 14.9 9 21.8-7 9.4-6.3 22.8 2.2 31.3l11.3 11.3c8.5 8.6 21.9 9.3 31.3 2.2 6.8 3.7 14.1 6.8 21.7 9 1.7 11.6 11.7 20.6 23.8 20.6l16 0c12.1 0 22.1-8.9 23.8-20.6 7.6-2.2 14.9-5.3 21.8-9 9.4 7 22.8 6.3 31.3-2.2l11.3-11.3c8.6-8.6 9.3-21.9 2.2-31.3 3.7-6.8 6.8-14.1 9-21.7 11.6-1.7 20.6-11.7 20.6-23.8l0-16c0-12.1-8.9-22.1-20.6-23.8-2.2-7.6-5.3-14.9-9-21.7 3.6-4.8 5.2-10.7 4.7-16.4 14.8-8.2 24.9-23.9 24.9-42.1l0-64c0-26.5-21.5-48-48-48l-64 0zM128 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm272 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $159afdcd077ecfe9$export$19eff32c0fd4f99f = {
    prefix: 'fas',
    iconName: 'asterisk',
    icon: [
        448,
        512,
        [
            10033,
            61545
        ],
        "2a",
        "M224 0c17.7 0 32 14.3 32 32l0 168.6 144-83.1c15.3-8.8 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7L288 256 432 339.1c15.3 8.8 20.6 28.4 11.7 43.7s-28.4 20.6-43.7 11.7L256 311.4 256 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-168.6-144 83.1c-15.3 8.8-34.9 3.6-43.7-11.7S.7 348 16 339.1L160 256 16 172.9C.7 164-4.5 144.5 4.3 129.1S32.7 108.6 48 117.4L192 200.6 192 32c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$9338fc4614cfc0cf = {
    prefix: 'fas',
    iconName: 'battery-full',
    icon: [
        640,
        512,
        [
            128267,
            "battery",
            "battery-5"
        ],
        "f240",
        "M528 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l416 0zM112 64c-44.2 0-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80l416 0c44.2 0 80-35.8 80-80l0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80L112 64zm56 112c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l304 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-304 0z"
    ]
};
var $159afdcd077ecfe9$export$214720d39635cea8 = $159afdcd077ecfe9$export$9338fc4614cfc0cf;
var $159afdcd077ecfe9$export$e426617482c711a7 = $159afdcd077ecfe9$export$9338fc4614cfc0cf;
var $159afdcd077ecfe9$export$f31a37ecbfd4e707 = {
    prefix: 'fas',
    iconName: 'child-dress',
    icon: [
        320,
        512,
        [],
        "e59c",
        "M224 64A64 64 0 1 0 96 64 64 64 0 1 0 224 64zM88 400l0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 16 0 0 80c0 17.7 14.3 32 32 32s32-14.3 32-32l0-80 17.8 0c10.9 0 18.6-10.7 15.2-21.1l-31.1-93.4 28.7 37.8c10.7 14.1 30.8 16.8 44.8 6.2s16.8-30.7 6.2-44.8L254.6 207c-22.4-29.6-57.5-47-94.6-47s-72.2 17.4-94.6 47L6.5 284.7c-10.7 14.1-7.9 34.2 6.2 44.8s34.2 7.9 44.8-6.2L86.2 285.5 55 378.9C51.6 389.3 59.3 400 70.2 400L88 400z"
    ]
};
var $159afdcd077ecfe9$export$eca99665af566fe1 = {
    prefix: 'fas',
    iconName: 'face-kiss-beam',
    icon: [
        512,
        512,
        [
            128537,
            "kiss-beam"
        ],
        "f597",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM240 288l32 0c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32 7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM176 180c-15.5 0-28 12.5-28 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28zm132 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28s-28 12.5-28 28z"
    ]
};
var $159afdcd077ecfe9$export$d6ff8a73c0812e63 = $159afdcd077ecfe9$export$eca99665af566fe1;
var $159afdcd077ecfe9$export$60430351cdb4ba89 = {
    prefix: 'fas',
    iconName: 'trash-can-arrow-up',
    icon: [
        448,
        512,
        [
            "trash-restore-alt"
        ],
        "f82a",
        "M167.1-16l113.9 0c13.8 0 26 8.8 30.4 21.9L320 32 416 32c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64S14.3 32 32 32l96 0 8.7-26.1C141.1-7.2 153.3-16 167.1-16zM32 144l384 0 0 304c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l0-304zm209 79c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 102.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z"
    ]
};
var $159afdcd077ecfe9$export$d075b19b21cb9856 = $159afdcd077ecfe9$export$60430351cdb4ba89;
var $159afdcd077ecfe9$export$a5dc297d3f60936 = {
    prefix: 'fas',
    iconName: 'font',
    icon: [
        512,
        512,
        [],
        "f031",
        "M285.1 50.7C279.9 39.3 268.5 32 256 32s-23.9 7.3-29.1 18.7L59.5 416 48 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l88 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-6.1 0 22-48 208.3 0 22 48-6.1 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l88 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-11.5 0-167.4-365.3zM330.8 304L181.2 304 256 140.8 330.8 304z"
    ]
};
var $159afdcd077ecfe9$export$cd79eeea6201e9d4 = {
    prefix: 'fas',
    iconName: 'bore-hole',
    icon: [
        512,
        512,
        [],
        "e4c3",
        "M256 0c-17.7 0-32 14.3-32 32l0 232.6c-19.1 11.1-32 31.7-32 55.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-23.7-12.9-44.4-32-55.4L288 32c0-17.7-14.3-32-32-32zM0 384l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-272c0-26.5-21.5-48-48-48l-48 0c-26.5 0-48 21.5-48 48l0 144c0 61.9-50.1 112-112 112S144 381.9 144 320l0-144c0-26.5-21.5-48-48-48l-48 0c-26.5 0-48 21.5-48 48L0 384z"
    ]
};
var $159afdcd077ecfe9$export$1df4e031b8ee4f84 = {
    prefix: 'fas',
    iconName: 'virus-covid',
    icon: [
        512,
        512,
        [],
        "e4a8",
        "M192 24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 33.6c30.7 4.2 58.8 16.3 82.3 34.1L386.1 92 374.8 80.6c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-11.3-11.3-23.8 23.8c17.9 23.5 29.9 51.7 34.1 82.3l33.6 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-16-33.6 0c-4.2 30.7-16.3 58.8-34.1 82.3l23.8 23.8 11.3-11.3c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-56.6 56.6c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l11.3-11.3-23.8-23.8c-23.5 17.9-51.7 29.9-82.3 34.1l0 33.6 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-33.6c-30.7-4.2-58.8-16.3-82.3-34.1l-23.8 23.8 11.3 11.3c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L46.7 408.7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l11.3 11.3 23.8-23.8C97.9 338.8 85.8 310.7 81.6 280l-33.6 0 0 16c0 13.3-10.7 24-24 24S0 309.3 0 296l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 33.6 0c4.2-30.7 16.3-58.8 34.1-82.3L92 125.9 80.6 137.2c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l56.6-56.6c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L125.9 92 149.7 115.7c23.5-17.9 51.7-29.9 82.3-34.1l0-33.6-16 0c-13.3 0-24-10.7-24-24zm32 200a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$38611f1c776aba73 = {
    prefix: 'fas',
    iconName: 'file-pdf',
    icon: [
        576,
        512,
        [],
        "f1c1",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l80 0 0-112c0-35.3 28.7-64 64-64l176 0 0-165.5c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM240 380c-11 0-20 9-20 20l0 128c0 11 9 20 20 20s20-9 20-20l0-28 12 0c33.1 0 60-26.9 60-60s-26.9-60-60-60l-32 0zm32 80l-12 0 0-40 12 0c11 0 20 9 20 20s-9 20-20 20zm96-80c-11 0-20 9-20 20l0 128c0 11 9 20 20 20l32 0c28.7 0 52-23.3 52-52l0-64c0-28.7-23.3-52-52-52l-32 0zm20 128l0-88 12 0c6.6 0 12 5.4 12 12l0 64c0 6.6-5.4 12-12 12l-12 0zm88-108l0 128c0 11 9 20 20 20s20-9 20-20l0-44 28 0c11 0 20-9 20-20s-9-20-20-20l-28 0 0-24 28 0c11 0 20-9 20-20s-9-20-20-20l-48 0c-11 0-20 9-20 20z"
    ]
};
var $159afdcd077ecfe9$export$8a7bee49fdf8c954 = {
    prefix: 'fas',
    iconName: 'language',
    icon: [
        576,
        512,
        [],
        "f1ab",
        "M160 0c17.7 0 32 14.3 32 32l0 32 128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-9.6 0-8.4 23.1c-16.4 45.2-41.1 86.5-72.2 122 14.2 8.8 29 16.6 44.4 23.5l50.4 22.4 62.2-140c5.1-11.6 16.6-19 29.2-19s24.1 7.4 29.2 19l128 288c7.2 16.2-.1 35.1-16.2 42.2s-35.1-.1-42.2-16.2l-20-45-157.5 0-20 45c-7.2 16.2-26.1 23.4-42.2 16.2s-23.4-26.1-16.2-42.2l39.8-89.5-50.4-22.4c-23-10.2-45-22.4-65.8-36.4-21.3 17.2-44.6 32.2-69.5 44.7L78.3 380.6c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l34.5-17.3c16.3-8.2 31.8-17.7 46.4-28.3-13.8-12.7-26.8-26.4-38.9-40.9L81.6 224.7c-11.3-13.6-9.5-33.8 4.1-45.1s33.8-9.5 45.1 4.1l10.2 12.2c11.5 13.9 24.1 26.8 37.4 38.7 27.5-30.4 49.2-66.1 63.5-105.4l.5-1.2-210.3 0C14.3 128 0 113.7 0 96S14.3 64 32 64l96 0 0-32c0-17.7 14.3-32 32-32zM416 270.8L365.7 384 466.3 384 416 270.8z"
    ]
};
var $159afdcd077ecfe9$export$36e034ccc72554a9 = {
    prefix: 'fas',
    iconName: 'shield-halved',
    icon: [
        512,
        512,
        [
            "shield-alt"
        ],
        "f3ed",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.8 82.8c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0-172.4-82.5-213.1-264-213.6-363.2-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.9 1 251.4 0 256 0zm0 66.8l0 378.1c138-66.8 175.1-214.8 176-303.4l-176-74.6 0 0z"
    ]
};
var $159afdcd077ecfe9$export$d6508d18a824f291 = $159afdcd077ecfe9$export$36e034ccc72554a9;
var $159afdcd077ecfe9$export$7de776bdab4e536d = {
    prefix: 'fas',
    iconName: 'caret-up',
    icon: [
        384,
        512,
        [],
        "f0d8",
        "M32 352c-12.9 0-24.6-7.8-29.6-19.8S.2 306.5 9.4 297.4l160-160c12.5-12.5 32.8-12.5 45.3 0l160 160c9.2 9.2 11.9 22.9 6.9 34.9S364.9 352 352 352L32 352z"
    ]
};
var $159afdcd077ecfe9$export$27f34878d8ed7a76 = {
    prefix: 'fas',
    iconName: 'file-pen',
    icon: [
        640,
        512,
        [
            128221,
            "file-edit"
        ],
        "f31c",
        "M128.1 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l146.2 0 10.9-54.5c4.3-21.7 15-41.6 30.6-57.2l132.2-132.2 0-97.5c0-17-6.7-33.3-18.7-45.3L322.8 18.7C310.8 6.7 294.5 0 277.6 0L128.1 0zM389.6 176l-93.5 0c-13.3 0-24-10.7-24-24l0-93.5 117.5 117.5zM332.3 466.9l-11.9 59.6c-.2 .9-.3 1.9-.3 2.9 0 8 6.5 14.6 14.6 14.6 1 0 1.9-.1 2.9-.3l59.6-11.9c12.4-2.5 23.8-8.6 32.7-17.5l118.9-118.9-80-80-118.9 118.9c-8.9 8.9-15 20.3-17.5 32.7zm267.8-123c22.1-22.1 22.1-57.9 0-80s-57.9-22.1-80 0l-28.8 28.8 80 80 28.8-28.8z"
    ]
};
var $159afdcd077ecfe9$export$e343e19f1757c5ae = $159afdcd077ecfe9$export$27f34878d8ed7a76;
var $159afdcd077ecfe9$export$cf152282d5de300d = {
    prefix: 'fas',
    iconName: 'person-biking',
    icon: [
        576,
        512,
        [
            128692,
            "biking"
        ],
        "f84a",
        "M368 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L256 305.1 256 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L263 232.9 323.3 184.4 364 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zM112 512a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm352 0a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
    ]
};
var $159afdcd077ecfe9$export$a5bcf835dbf9c0b = $159afdcd077ecfe9$export$cf152282d5de300d;
var $159afdcd077ecfe9$export$cb6e40528b98a5b = {
    prefix: 'fas',
    iconName: 'book-open-reader',
    icon: [
        512,
        512,
        [
            "book-reader"
        ],
        "f5da",
        "M256 152a88 88 0 1 0 0-176 88 88 0 1 0 0 176zm0 298.7l0-149.3c16.3-6.8 32.9-13.7 49.7-20.7 39-16.2 80.8-24.6 123.1-24.6l19.2 0 0 160-19.2 0c-59.1 0-117.7 11.7-172.3 34.5l-.5 .2zM256 232l-25.1-10.5C184.1 202 133.9 192 83.2 192L48 192c-26.5 0-48 21.5-48 48L0 432c0 26.5 21.5 48 48 48l35.2 0c50.7 0 100.9 10 147.7 29.5l12.8 5.3c7.9 3.3 16.7 3.3 24.6 0l12.8-5.3c46.8-19.5 97-29.5 147.7-29.5l35.2 0c26.5 0 48-21.5 48-48l0-192c0-26.5-21.5-48-48-48l-35.2 0c-50.7 0-100.9 10-147.7 29.5L256 232z"
    ]
};
var $159afdcd077ecfe9$export$cee14fe33262fa7d = $159afdcd077ecfe9$export$cb6e40528b98a5b;
var $159afdcd077ecfe9$export$b7ae54b4078b2060 = {
    prefix: 'fas',
    iconName: 'glass-water-droplet',
    icon: [
        384,
        512,
        [],
        "e4f5",
        "M32 0C23.1 0 14.6 3.7 8.6 10.2S-.6 25.4 .1 34.3L28.9 437.7c3 41.9 37.8 74.3 79.8 74.3l166.6 0c42 0 76.8-32.4 79.8-74.3L383.9 34.3c.6-8.9-2.4-17.6-8.5-24.1S360.9 0 352 0L32 0zM83 297.5L66.4 64 317.6 64 301 297.5 288 304c-20.1 10.1-43.9 10.1-64 0s-43.9-10.1-64 0-43.9 10.1-64 0l-13-6.5zM256 196c0-24-33.7-70.1-52.2-93.5-6.1-7.7-17.5-7.7-23.6 0-18.5 23.4-52.2 69.5-52.2 93.5 0 33.1 28.7 60 64 60s64-26.9 64-60z"
    ]
};
var $159afdcd077ecfe9$export$fd06ff4ce9799eb0 = {
    prefix: 'fas',
    iconName: 'tower-broadcast',
    icon: [
        576,
        512,
        [
            "broadcast-tower"
        ],
        "f519",
        "M87.9 11.5c-11.3-6.9-26.1-3.2-33 8.1-24.8 41-39 89.1-39 140.4s14.2 99.4 39 140.4c6.9 11.3 21.6 15 33 8.1s15-21.6 8.1-33C75.7 241.9 64 202.3 64 160S75.7 78.1 96.1 44.4c6.9-11.3 3.2-26.1-8.1-33zm400.1 0c-11.3 6.9-15 21.6-8.1 33 20.4 33.7 32.1 73.3 32.1 115.6s-11.7 81.9-32.1 115.6c-6.9 11.3-3.2 26.1 8.1 33s26.1 3.2 33-8.1c24.8-41 39-89.1 39-140.4S545.8 60.6 521 19.6c-6.9-11.3-21.6-15-33-8.1zM320 215.4c19.1-11.1 32-31.7 32-55.4 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 23.7 12.9 44.4 32 55.4L256 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-264.6zM180.2 91c7.2-11.2 3.9-26-7.2-33.2s-26-3.9-33.2 7.2c-17.6 27.4-27.8 60-27.8 95s10.2 67.6 27.8 95c7.2 11.2 22 14.4 33.2 7.2s14.4-22 7.2-33.2c-12.8-19.9-20.2-43.6-20.2-69s7.4-49.1 20.2-69zM436.2 65c-7.2-11.2-22-14.4-33.2-7.2s-14.4 22-7.2 33.2c12.8 19.9 20.2 43.6 20.2 69s-7.4 49.1-20.2 69c-7.2 11.2-3.9 26 7.2 33.2s26 3.9 33.2-7.2c17.6-27.4 27.8-60 27.8-95s-10.2-67.6-27.8-95z"
    ]
};
var $159afdcd077ecfe9$export$f68b38d51f5c0ed = $159afdcd077ecfe9$export$fd06ff4ce9799eb0;
var $159afdcd077ecfe9$export$e0601b1f239fec74 = {
    prefix: 'fas',
    iconName: 'minimize',
    icon: [
        512,
        512,
        [
            "compress-arrows-alt"
        ],
        "f78c",
        "M456 224l-144 0c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2S322.1 32.2 329 39l40 40 73.4-73.4C446 2 450.9 0 456 0s10 2 13.7 5.7l36.7 36.7C510 46 512 50.9 512 56s-2 10-5.7 13.7L433 143 473 183c6.9 6.9 8.9 17.2 5.2 26.2S465.7 224 456 224zm0 64c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-40 40 73.4 73.4c3.6 3.6 5.7 8.5 5.7 13.7s-2 10-5.7 13.7l-36.7 36.7C466 510 461.1 512 456 512s-10-2-13.7-5.7L369 433 329 473c-6.9 6.9-17.2 8.9-26.2 5.2S288 465.7 288 456l0-144c0-13.3 10.7-24 24-24l144 0zm-256 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-40-40-73.4 73.4C66 510 61.1 512 56 512s-10-2-13.7-5.7L5.7 469.7C2 466 0 461.1 0 456s2-10 5.7-13.7L79 369 39 329c-6.9-6.9-8.9-17.2-5.2-26.2S46.3 288 56 288l144 0zM56 224c-9.7 0-18.5-5.8-22.2-14.8S32.2 189.9 39 183L79 143 5.7 69.7C2 66 0 61.1 0 56S2 46 5.7 42.3L42.3 5.7C46 2 50.9 0 56 0S66 2 69.7 5.7L143 79 183 39c6.9-6.9 17.2-8.9 26.2-5.2S224 46.3 224 56l0 144c0 13.3-10.7 24-24 24L56 224z"
    ]
};
var $159afdcd077ecfe9$export$39205db0ea980efd = $159afdcd077ecfe9$export$e0601b1f239fec74;
var $159afdcd077ecfe9$export$e201217e5046cd15 = {
    prefix: 'fas',
    iconName: 'arrow-right-to-city',
    icon: [
        640,
        512,
        [],
        "e4b3",
        "M288 48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 80 48 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 16 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-256 0c-26.5 0-48-21.5-48-48l0-416zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM352 304l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm176-80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM512 336l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM153 167l72 72c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-102.1 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l102.1 0-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$ba2fa38f7bcc6930 = {
    prefix: 'fas',
    iconName: 'laptop-medical',
    icon: [
        640,
        512,
        [],
        "f812",
        "M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 240-64 0 0-240-384 0 0 240-64 0 0-240zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 40 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-40 0 0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$d78e8b0681279167 = {
    prefix: 'fas',
    iconName: 'bread-slice',
    icon: [
        512,
        512,
        [],
        "f7ec",
        "M64 432l0-176c-35.3 0-64-28.7-64-64 0-216.5 512-216.5 512 0 0 35.3-28.7 64-64 64l0 176c0 26.5-21.5 48-48 48l-288 0c-26.5 0-48-21.5-48-48z"
    ]
};
var $159afdcd077ecfe9$export$b1b1cdce4a19c682 = {
    prefix: 'fas',
    iconName: 'globe',
    icon: [
        512,
        512,
        [
            127760
        ],
        "f0ac",
        "M351.9 280l-190.9 0c2.9 64.5 17.2 123.9 37.5 167.4 11.4 24.5 23.7 41.8 35.1 52.4 11.2 10.5 18.9 12.2 22.9 12.2s11.7-1.7 22.9-12.2c11.4-10.6 23.7-28 35.1-52.4 20.3-43.5 34.6-102.9 37.5-167.4zM160.9 232l190.9 0C349 167.5 334.7 108.1 314.4 64.6 303 40.2 290.7 22.8 279.3 12.2 268.1 1.7 260.4 0 256.4 0s-11.7 1.7-22.9 12.2c-11.4 10.6-23.7 28-35.1 52.4-20.3 43.5-34.6 102.9-37.5 167.4zm-48 0C116.4 146.4 138.5 66.9 170.8 14.7 78.7 47.3 10.9 131.2 1.5 232l111.4 0zM1.5 280c9.4 100.8 77.2 184.7 169.3 217.3-32.3-52.2-54.4-131.7-57.9-217.3L1.5 280zm398.4 0c-3.5 85.6-25.6 165.1-57.9 217.3 92.1-32.7 159.9-116.5 169.3-217.3l-111.4 0zm111.4-48C501.9 131.2 434.1 47.3 342 14.7 374.3 66.9 396.4 146.4 399.9 232l111.4 0z"
    ]
};
var $159afdcd077ecfe9$export$758f1fb3784e4080 = {
    prefix: 'fas',
    iconName: 'folder-minus',
    icon: [
        512,
        512,
        [],
        "f65d",
        "M448 448L64 448c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l138.7 0c13.8 0 27.3 4.5 38.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L448 80c35.3 0 64 28.7 64 64l0 240c0 35.3-28.7 64-64 64zM184 240c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
var $159afdcd077ecfe9$export$140d4da0adbaf435 = {
    prefix: 'fas',
    iconName: 'mask-face',
    icon: [
        640,
        512,
        [],
        "e1d7",
        "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8c-15.8 10.5-34.3 16.1-53.3 16.1L64 128c-35.3 0-64 28.7-64 64l0 78.7c0 62.6 45.2 116 107 126.3l97.9 16.3c33 22 72.6 34.7 115.1 34.7s82.2-12.8 115.1-34.7L533 396.9c61.7-10.3 107-63.7 107-126.3l0-78.7c0-35.3-28.7-64-64-64l-89.2 0c-19 0-37.5-5.6-53.3-16.1L396.4 87.1C373.8 72 347.2 64 320 64zM135.9 336.9l-18.4-3.1C86.6 328.7 64 302 64 270.7l0-78.7 48 0 0 48c0 35 8.6 67.9 23.9 96.9zm386.6-3.1l-18.4 3.1C519.4 307.9 528 275 528 240l0-48 48 0 0 78.7c0 31.3-22.6 58-53.5 63.1zM192 232c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm56 56l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$e74974fac77c468e = {
    prefix: 'fas',
    iconName: 'bong',
    icon: [
        512,
        512,
        [],
        "f55c",
        "M448.5 384c0 41.5-13.1 79.9-35.5 111.3-7.9 11.1-21.2 16.7-34.8 16.7l-243.3 0c-13.7 0-26.9-5.6-34.8-16.7-22.4-31.4-35.5-69.8-35.5-111.3 0-71.1 38.6-133.1 96-166.3l0-153.7c-17.7 0-32-14.3-32-32s14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 153.7c14.2 8.2 27.2 18.2 38.8 29.6l39.3-39.3-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16 16 32 32 48 48 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-7-7-43.3 43.3c17.3 28.9 27.3 62.6 27.3 98.8zM288.5 64l-64 0 0 190.6-32 18.5c-19.5 11.3-35.7 27.5-46.9 46.9l221.8 0c-11.2-19.4-27.4-35.6-46.9-46.9l-32-18.5 0-190.6z"
    ]
};
var $159afdcd077ecfe9$export$4d6835e7175dec24 = {
    prefix: 'fas',
    iconName: 'road-bridge',
    icon: [
        576,
        512,
        [],
        "e563",
        "M32 32l208 0 0 64-24 0 0 64 24 0 0 129.3c-45.4 7.6-80 47.1-80 94.7l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-94c0-38.8-26.4-72.6-64-82l0-112 40 0 0-64-8 0C14.3 96 0 81.7 0 64S14.3 32 32 32zM88 96l0 64 80 0 0-64-80 0zM336 32l72 0 0 72c0 13.3 10.7 24 24 24s24-10.7 24-24l0-72 72 0c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-72 0 0-72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 72-72 0c-26.5 0-48-21.5-48-48l0-352c0-26.5 21.5-48 48-48zm96 160c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$25218e5886296cb9 = {
    prefix: 'fas',
    iconName: 'arrow-up-9-1',
    icon: [
        512,
        512,
        [
            "sort-numeric-up-alt"
        ],
        "f887",
        "M150.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 141.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM365.1 206.6c-9.6 14.8-5.4 34.6 9.4 44.3s34.6 5.4 44.3-9.4l42.1-64.9c12.4-19.2 19.1-41.6 19.1-64.5 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.1 23.9 66.7 56.8 76.6l-11.7 18zM376 112a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm42.7 182c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26z"
    ]
};
var $159afdcd077ecfe9$export$d41859f1bbb9e086 = $159afdcd077ecfe9$export$25218e5886296cb9;
var $159afdcd077ecfe9$export$28f06bbf9c17c3af = {
    prefix: 'fas',
    iconName: 'mountain-city',
    icon: [
        640,
        512,
        [],
        "e52e",
        "M256.3 48c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 48 48 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 72 16 0c26.5 0 48 21.5 48 48l0 320c0 26.5-21.5 48-48 48l-77.8 0c4-15.4 2.4-32.6-6.7-48.2L354.6 256 368.3 256c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-6.1 0-11.4 3.4-14.1 8.5l-42.6-73c-6-10.2-14.1-18-23.3-23.3l0-56.2zm64 64l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm160 96l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm-272-64.7l-65.1 111.6 33.1 33.1 48-48 40.4 0-56.4-96.7zm-27.6-47.9c12.3-21.2 42.9-21.2 55.3 0L420.3 463.9c12.4 21.3-2.9 48.1-27.6 48.1L56 512c-24.7 0-40.1-26.8-27.6-48.1L196.7 175.4z"
    ]
};
var $159afdcd077ecfe9$export$6cc91ce23eb3fae1 = {
    prefix: 'fas',
    iconName: 'arrow-down-9-1',
    icon: [
        512,
        512,
        [
            "sort-numeric-desc",
            "sort-numeric-down-alt"
        ],
        "f886",
        "M230.6 390.6l-80 80c-12.5 12.5-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 370.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 306.7 25.4-25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm134.5-184l11.7-18c-32.9-9.9-56.8-40.5-56.8-76.6 0-44.2 35.8-80 80-80s80 35.8 80 80c0 22.9-6.6 45.3-19.1 64.5l-42.1 64.9c-9.6 14.8-29.4 19.1-44.3 9.4s-19.1-29.4-9.4-44.3zM424 112a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-5.3 182c8.3 6 13.3 15.7 13.3 26l0 96 16 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0 0-51.6-5.9 2c-16.8 5.6-34.9-3.5-40.5-20.2s3.5-34.9 20.2-40.5l48-16c9.8-3.3 20.5-1.6 28.8 4.4z"
    ]
};
var $159afdcd077ecfe9$export$99f058110e2c82a8 = $159afdcd077ecfe9$export$6cc91ce23eb3fae1;
var $159afdcd077ecfe9$export$857385fda7a5a98e = $159afdcd077ecfe9$export$6cc91ce23eb3fae1;
var $159afdcd077ecfe9$export$bdbabf493c478cde = {
    prefix: 'fas',
    iconName: 'face-grin-wide',
    icon: [
        512,
        512,
        [
            128515,
            "grin-alt"
        ],
        "f581",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM386.7 308.9c11.9-3.7 23.9 6.3 19.6 18.1-22.4 61.3-81.3 105.1-150.3 105.1S128.1 388.2 105.7 326.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1zM208 192c0 35.3-14.3 64-32 64s-32-28.7-32-64 14.3-64 32-64 32 28.7 32 64zm128 64c-17.7 0-32-28.7-32-64s14.3-64 32-64 32 28.7 32 64-14.3 64-32 64z"
    ]
};
var $159afdcd077ecfe9$export$b4abebfe416d36ba = $159afdcd077ecfe9$export$bdbabf493c478cde;
var $159afdcd077ecfe9$export$bb45b6b87d1adf27 = {
    prefix: 'fas',
    iconName: 'poop',
    icon: [
        512,
        512,
        [],
        "f619",
        "M254.4 6.6c3.5-4.3 9-6.5 14.5-5.7 46.9 6.3 83.1 46.5 83.1 95.1 0 11.2-1.9 22-5.5 32l5.5 0c35.3 0 64 28.7 64 64 0 19.1-8.4 36.3-21.7 48l13.7 0c39.8 0 72 32.2 72 72 0 23.2-11 43.8-28 57 34.1 5.7 60 35.3 60 71 0 39.8-32.2 72-72 72L72 512c-39.8 0-72-32.2-72-72 0-35.7 25.9-65.3 60-71-17-13.2-28-33.8-28-57 0-39.8 32.2-72 72-72l13.7 0c-13.3-11.7-21.7-28.9-21.7-48 0-35.3 28.7-64 64-64l16.2 0c44.1-.1 79.8-35.9 79.8-80 0-9.2-1.5-17.9-4.3-26.1-1.8-5.2-.8-11.1 2.8-15.4z"
    ]
};
var $159afdcd077ecfe9$export$45cbd92c28deb2c7 = {
    prefix: 'fas',
    iconName: 'dharmachakra',
    icon: [
        512,
        512,
        [
            9784
        ],
        "f655",
        "M337.8 205.7l48.6-42.5c13.8 19.3 23.4 41.9 27.4 66.2l-64.4 4.3c-2.4-10.1-6.4-19.5-11.6-28zm140.1 19.5c-5.3-38.8-20.6-74.5-43.2-104.3l.8-.7C449 108.4 449.7 87.6 437 75s-33.4-12-45.2 1.5l-.7 .8c-29.8-22.6-65.5-37.9-104.3-43.2l.1-1.1c1.2-17.9-13-33-30.9-33s-32.1 15.2-30.9 33l.1 1.1c-38.8 5.3-74.5 20.6-104.3 43.2l-.7-.8C108.4 63 87.6 62.3 75 75s-12 33.4 1.5 45.2l.8 .7c-22.6 29.8-37.9 65.5-43.2 104.3l-1.1-.1c-17.9-1.2-33 13-33 30.9s15.2 32.1 33 30.9l1.1-.1c5.3 38.8 20.6 74.5 43.2 104.3l-.8 .7C63 403.6 62.3 424.4 75 437s33.4 12 45.2-1.5l.7-.8c29.8 22.6 65.5 37.9 104.3 43.2l-.1 1.1c-1.2 17.9 13 33 30.9 33s32.1-15.2 30.9-33l-.1-1.1c38.8-5.3 74.5-20.6 104.3-43.2l.7 .8c11.8 13.5 32.5 14.2 45.2 1.5s12-33.4-1.5-45.2l-.8-.7c22.6-29.8 37.9-65.5 43.2-104.3l1.1 .1c17.9 1.2 33-13 33-30.9s-15.2-32.1-33-30.9l-1.1 .1zM163.2 125.6c19.3-13.8 41.9-23.4 66.2-27.5l4.3 64.4c-10 2.4-19.5 6.4-28 11.6l-42.5-48.6zm-65 103.8c4.1-24.4 13.7-46.9 27.5-66.2l48.6 42.5c-5.3 8.5-9.2 18-11.6 28l-64.4-4.3zm27.5 119.4c-13.8-19.3-23.4-41.9-27.5-66.2l64.4-4.3c2.4 10.1 6.4 19.5 11.6 28l-48.6 42.5zm103.8 65c-24.4-4.1-46.9-13.7-66.2-27.4l42.5-48.6c8.5 5.3 18 9.2 28 11.6l-4.3 64.4zm119.4-27.4c-19.3 13.8-41.9 23.4-66.2 27.4l-4.3-64.4c10-2.4 19.5-6.4 28-11.6l42.5 48.6zm65-103.8c-4.1 24.4-13.7 46.9-27.4 66.2l-48.6-42.5c5.3-8.6 9.2-18 11.6-28l64.4 4.3zm-65-156.9l-42.5 48.6c-8.6-5.3-18-9.2-28-11.6l4.3-64.4c24.4 4.1 46.9 13.7 66.2 27.5zM256 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$acec92052ac2183 = {
    prefix: 'fas',
    iconName: 'battery-quarter',
    icon: [
        640,
        512,
        [
            "battery-2"
        ],
        "f243",
        "M528 128c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16l-416 0c-8.8 0-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16l416 0zM112 64c-44.2 0-80 35.8-80 80l0 224c0 44.2 35.8 80 80 80l416 0c44.2 0 80-35.8 80-80l0-48c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80L112 64zm56 112c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24l0-112c0-13.3-10.7-24-24-24l-64 0z"
    ]
};
var $159afdcd077ecfe9$export$23ca8a94c555576 = $159afdcd077ecfe9$export$acec92052ac2183;
var $159afdcd077ecfe9$export$8736909014b15ca9 = {
    prefix: 'fas',
    iconName: 'ankh',
    icon: [
        320,
        512,
        [
            9765
        ],
        "f644",
        "M96 128c0-35.3 28.7-64 64-64s64 28.7 64 64c0 41.6-20.7 76.6-46.6 104.1-5.9 6.2-11.8 11.8-17.4 16.7-5.6-4.9-11.5-10.5-17.4-16.7-25.9-27.5-46.6-62.6-46.6-104.1zM160 0C89.3 0 32 57.3 32 128 32 180.4 53.5 223.5 78.8 256L32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-46.8 0C266.5 223.5 288 180.4 288 128 288 57.3 230.7 0 160 0z"
    ]
};
var $159afdcd077ecfe9$export$f214f827e0023247 = {
    prefix: 'fas',
    iconName: 'diamond',
    icon: [
        512,
        512,
        [
            9830
        ],
        "f219",
        "M17 215L215 17C225.9 6.1 240.6 0 256 0s30.1 6.1 41 17L495 215c10.9 10.9 17 25.6 17 41s-6.1 30.1-17 41L297 495c-10.9 10.9-25.6 17-41 17s-30.1-6.1-41-17L17 297C6.1 286.1 0 271.4 0 256s6.1-30.1 17-41z"
    ]
};
var $159afdcd077ecfe9$export$34c1e678c32ed646 = {
    prefix: 'fas',
    iconName: 'subscript',
    icon: [
        576,
        512,
        [],
        "f12c",
        "M96 64C78.3 64 64 78.3 64 96s14.3 32 32 32l15.3 0 89.6 128-89.6 128-15.3 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0c10.4 0 20.2-5.1 26.2-13.6L240 311.8 325.8 434.4c6 8.6 15.8 13.6 26.2 13.6l32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-15.3 0-89.6-128 89.6-128 15.3 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0c-10.4 0-20.2 5.1-26.2 13.6L240 200.2 154.2 77.6C148.2 69.1 138.4 64 128 64L96 64zM544 320c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-32 16c-15.8 7.9-22.2 27.1-14.3 42.9 5.6 11.2 16.9 17.7 28.6 17.7l0 80c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-128z"
    ]
};
var $159afdcd077ecfe9$export$8bf9e3f7f57d486a = {
    prefix: 'fas',
    iconName: 'rupee-sign',
    icon: [
        448,
        512,
        [
            8360,
            "rupee"
        ],
        "f156",
        "M0 64C0 46.3 14.3 32 32 32l80 0c79.5 0 144 64.5 144 144 0 54.3-30 101.5-74.4 126.1l41 136.7c5.1 16.9-4.5 34.8-21.5 39.8s-34.8-4.5-39.8-21.5L120.1 319.8c-2.7 .1-5.4 .2-8.1 .2l-48 0 0 128c0 17.7-14.3 32-32 32S0 465.7 0 448L0 64zM64 256l48 0c44.2 0 80-35.8 80-80s-35.8-80-80-80l-48 0 0 160zm285.1-32l34.9 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-34.9 0c-7.2 0-13.1 5.9-13.1 13.1 0 5.7 3.7 10.7 9.1 12.5l49.4 15.9c31.9 10.3 53.5 39.9 53.5 73.4 0 42.6-34.5 77.1-77.1 77.1L320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l50.9 0c7.2 0 13.1-5.9 13.1-13.1 0-5.7-3.7-10.7-9.1-12.5l-49.4-15.9c-31.9-10.3-53.5-39.9-53.5-73.4 0-42.6 34.5-77.1 77.1-77.1z"
    ]
};
var $159afdcd077ecfe9$export$9da25a46cfcb6fa4 = $159afdcd077ecfe9$export$8bf9e3f7f57d486a;
var $159afdcd077ecfe9$export$b16df914812cedbe = {
    prefix: 'fas',
    iconName: 'person-rifle',
    icon: [
        512,
        512,
        [],
        "e54e",
        "M416 0L384 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l0 100.3c-9.6 5.5-16 15.9-16 27.7l0 32c-17.7 0-32 14.3-32 32l0 144c0 17.7 14.3 32 32 32l16 0 0 96c0 8.8 7.2 16 16 16l59.5 0c10.4 0 18-9.8 15.5-19.9l-23-92.1 44 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-48 0 0-26.7 53.1-17.7c6.5-2.2 10.9-8.3 10.9-15.2l0-84.5c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16l0 56-16 5.3 0-109.3c0-11.8-6.4-22.2-16-27.7L432 16c0-8.8-7.2-16-16-16zM224 208C118 208 32 294 32 400l0 48c0 17.7 14.3 32 32 32s32-14.3 32-32l0-48c0-32.5 12.1-62.1 32-84.7l0 196.7 160 0 0-293.1c-20-7.1-41.6-10.9-64-10.9zM280 88a72 72 0 1 0 -144 0 72 72 0 1 0 144 0z"
    ]
};
var $159afdcd077ecfe9$export$56c73b799aac2555 = {
    prefix: 'fas',
    iconName: 'd',
    icon: [
        384,
        512,
        [
            100
        ],
        "44",
        "M0 64C0 46.3 14.3 32 32 32l128 0c123.7 0 224 100.3 224 224S283.7 480 160 480L32 480c-17.7 0-32-14.3-32-32L0 64zM64 96l0 320 96 0c88.4 0 160-71.6 160-160S248.4 96 160 96L64 96z"
    ]
};
var $159afdcd077ecfe9$export$5498258519fc5b72 = {
    prefix: 'fas',
    iconName: 'square-nfi',
    icon: [
        448,
        512,
        [],
        "e576",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM93 172.3l35 63 0-51.4c0-13.3 10.7-24 24-24s24 10.7 24 24l0 144c0 10.9-7.4 20.5-18 23.2s-21.7-2-27-11.6l-35-63 0 51.4c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-10.9 7.4-20.5 18-23.2s21.7 2 27 11.6zM208 184c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0 32 40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144zm192 0l0 144c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-144c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$b4619aeaf0b9d18e = {
    prefix: 'fas',
    iconName: 'teeth',
    icon: [
        512,
        512,
        [],
        "f62e",
        "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM144 208l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zm128 0l0 24c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-24c0-26.5-21.5-48-48-48s-48 21.5-48 48zM80 176c-17.7 0-32 14.3-32 32l0 24c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-24c0-17.7-14.3-32-32-32zm320 32l0 24c0 13.3 10.7 24 24 24l16 0c13.3 0 24-10.7 24-24l0-24c0-17.7-14.3-32-32-32s-32 14.3-32 32zM48 336c0 17.7 14.3 32 32 32s32-14.3 32-32l0-16c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 16zm144 48c26.5 0 48-21.5 48-48l0-16c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 16c0 26.5 21.5 48 48 48zm128 0c26.5 0 48-21.5 48-48l0-16c0-8.8-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16l0 16c0 26.5 21.5 48 48 48zm112-16c17.7 0 32-14.3 32-32l0-16c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 16c0 17.7 14.3 32 32 32z"
    ]
};
var $159afdcd077ecfe9$export$fa4f1ead37dc1dce = {
    prefix: 'fas',
    iconName: 'magnifying-glass-dollar',
    icon: [
        512,
        512,
        [
            "search-dollar"
        ],
        "f688",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM212 96c-11 0-20 9-20 20l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L168 256c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20z"
    ]
};
var $159afdcd077ecfe9$export$65b49a6767630708 = $159afdcd077ecfe9$export$fa4f1ead37dc1dce;
var $159afdcd077ecfe9$export$25e9b29b3f2230b5 = {
    prefix: 'fas',
    iconName: 'dumpster-fire',
    icon: [
        640,
        512,
        [],
        "f794",
        "M164.3 64L138.7 192 56 192c-13.3 0-24-10.7-24-24l0-4.1c0-2.6 .4-5.1 1.2-7.6L58.5 80.4C61.8 70.6 71 64 81.3 64l83 0zm23.4 128l25.6-128 82.7 0 0 128-108.3 0zM344 64l82.7 0 16 80c-14.7 .2-29.3 5.5-40.9 15.9-11.5 10.3-22.5 21-32.8 32.1l-24.9 0 0-128zM96 240l233.2 0c-6.4 8.8-12.3 17.6-17.7 26.3-21.4 34.7-39.5 76.1-39.5 115.8 0 17.1 2.1 33.8 6 49.9l-120.4 0 1.9 10.3c3.2 17.4-8.4 34-25.8 37.2s-34-8.4-37.2-25.8C71 313.3 58 242.1 57.7 240L96 240zm512-72c0 11-7.4 20.3-17.5 23.1-.9-.8-1.7-1.6-2.6-2.4-21.8-20-54.3-21.8-78-5.5-4.2-4.3-8.5-8.5-12.9-12.6l-21.3-106.6 83 0c10.3 0 19.5 6.6 22.8 16.4l25.3 75.9c.8 2.4 1.2 5 1.2 7.6l0 4.1zM505.7 240.3L518 226.5c5.4-6.1 13.3-8.8 20.9-8.9 7.2 0 14.3 2.6 19.9 7.8 19.7 18.3 39.8 43.2 55 70.6 15.1 27.2 26.2 58.1 26.2 88.1 0 88.7-71.3 159.8-160 159.8-89.6 0-160-71.3-160-159.8 0-37.3 16-73.4 36.8-104.5 20.9-31.3 47.5-59 70.9-80.2 5.7-5.2 13.1-7.7 20.3-7.5s13.4 3.2 18.8 7.5c14.4 11.4 38.9 40.7 38.9 40.7zM544 432.2c0-36.5-37-73-54.8-88.4-5.4-4.7-13.1-4.7-18.5 0-17.7 15.4-54.8 51.9-54.8 88.4 0 35.3 28.7 64 64 64s64-28.7 64-64z"
    ]
};
var $159afdcd077ecfe9$export$a9578350255b2b79 = {
    prefix: 'fas',
    iconName: 'upload',
    icon: [
        448,
        512,
        [],
        "f093",
        "M256 109.3L256 320c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-210.7-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 109.3zM224 400c44.2 0 80-35.8 80-80l80 0c35.3 0 64 28.7 64 64l0 32c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-32c0-35.3 28.7-64 64-64l80 0c0 44.2 35.8 80 80 80zm144 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$3924ab4d3ef9b5ef = {
    prefix: 'fas',
    iconName: 'user-slash',
    icon: [
        576,
        512,
        [
            62714,
            "user-alt-slash",
            "user-large-slash"
        ],
        "f506",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L311.5 245.7c55-10.9 96.5-59.5 96.5-117.7 0-66.3-53.7-120-120-120-58.2 0-106.8 41.5-117.7 96.5L41-24.9zM235.6 305.4C147.9 316.6 80 391.5 80 482.3 80 498.7 93.3 512 109.7 512l332.5 0-206.6-206.6z"
    ]
};
var $159afdcd077ecfe9$export$46185fab4772ada6 = $159afdcd077ecfe9$export$3924ab4d3ef9b5ef;
var $159afdcd077ecfe9$export$ae7fc6b7f0534be9 = $159afdcd077ecfe9$export$3924ab4d3ef9b5ef;
var $159afdcd077ecfe9$export$b7fac681e7d09400 = {
    prefix: 'fas',
    iconName: 'arrow-left',
    icon: [
        512,
        512,
        [
            8592
        ],
        "f060",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 288 480 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-370.7 0 105.4-105.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
    ]
};
var $159afdcd077ecfe9$export$a56b2b0a1073620c = {
    prefix: 'fas',
    iconName: 'vial-virus',
    icon: [
        576,
        512,
        [],
        "e597",
        "M64 32C64 14.3 78.3 0 96 0L320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 151.7c-18.5 0-37 7-51.1 21.1-21.6 21.6-26.6 53.6-15 79.9-26.9 10.4-45.9 36.6-45.9 67.1s19 56.7 45.9 67.1c-7.3 16.5-8 35.2-2.3 52.2-13.4 5.7-28.2 8.8-43.6 8.8-61.9 0-112-50.1-112-112L96 64C78.3 64 64 49.7 64 32zm96 32l0 128 96 0 0-128-96 0zM280 408c-13.3 0-24-10.7-24-24s10.7-24 24-24c28.8 0 43.2-34.8 22.9-55.2-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.4 20.4 55.2 5.9 55.2-22.9 0-13.3 10.7-24 24-24s24 10.7 24 24c0 28.8 34.8 43.2 55.2 22.9 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.4 20.4-5.9 55.2 22.9 55.2 13.3 0 24 10.7 24 24s-10.7 24-24 24c-28.8 0-43.2 34.8-22.9 55.2 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.4-20.4-55.2-5.9-55.2 22.9 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-28.8-34.8-43.2-55.2-22.9-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.4-20.4 5.9-55.2-22.9-55.2zm104-32a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$f178c8c2ad3cc861 = {
    prefix: 'fas',
    iconName: 'check-double',
    icon: [
        384,
        512,
        [],
        "f560",
        "M249.9 66.8c10.4-14.3 7.2-34.3-7.1-44.7s-34.3-7.2-44.7 7.1l-106 145.7-37.5-37.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c6.6 6.6 15.8 10 25.1 9.3s17.9-5.5 23.4-13.1l128-176zm128 136c10.4-14.3 7.2-34.3-7.1-44.7s-34.3-7.2-44.7 7.1l-170 233.7-69.5-69.5c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l96 96c6.6 6.6 15.8 10 25.1 9.3s17.9-5.5 23.4-13.1l192-264z"
    ]
};
var $159afdcd077ecfe9$export$7bc6e4d977673e69 = {
    prefix: 'fas',
    iconName: 'paw',
    icon: [
        512,
        512,
        [],
        "f1b0",
        "M234.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5 .3-86.2 32.6-96.8 70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3-14.3-70.1 10.2-84.1 59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5l0 1.6c0 25.8-20.9 46.7-46.7 46.7-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2-25.8 0-46.7-20.9-46.7-46.7l0-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3 29.1 51.7 10.2 84.1-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5 46.9 53.9 32.6 96.8-52.1 69.1-84.4 58.5z"
    ]
};
var $159afdcd077ecfe9$export$aacaf42fba617981 = {
    prefix: 'fas',
    iconName: 'helmet-safety',
    icon: [
        576,
        512,
        [
            "hard-hat",
            "hat-hard"
        ],
        "f807",
        "M352 264l0-200c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 200c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-185.9C90 109.8 32 191.8 32 288l0 64 512 0 0-64c-1-95.2-58.4-177.7-144-209.8L400 264c0 13.3-10.7 24-24 24s-24-10.7-24-24zM40 400c-22.1 0-40 17.9-40 40s17.9 40 40 40l496 0c22.1 0 40-17.9 40-40s-17.9-40-40-40L40 400z"
    ]
};
var $159afdcd077ecfe9$export$7b72177558a98b6f = $159afdcd077ecfe9$export$aacaf42fba617981;
var $159afdcd077ecfe9$export$c0e235dbf1644a2f = $159afdcd077ecfe9$export$aacaf42fba617981;
var $159afdcd077ecfe9$export$86923e6fe1b42f5e = {
    prefix: 'fas',
    iconName: 'e',
    icon: [
        320,
        512,
        [
            101
        ],
        "45",
        "M32 32C14.3 32 0 46.3 0 64L0 448c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-224 0 0-128 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-128 224 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32z"
    ]
};
var $159afdcd077ecfe9$export$67ca89c1ca38d559 = {
    prefix: 'fas',
    iconName: 'face-laugh-squint',
    icon: [
        512,
        512,
        [
            "laugh-squint"
        ],
        "f59b",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM107.7 332.1C102 318 113.4 304 128.6 304l254.9 0c15.2 0 26.6 14 20.9 28.1-23.8 58.6-81.2 99.9-148.3 99.9s-124.6-41.3-148.3-99.9zm15-188.8c4.5-6.8 13.3-9.2 20.6-5.5l79.6 40c5.4 2.7 8.8 8.2 8.8 14.3s-3.4 11.6-8.8 14.3l-79.6 40c-7.3 3.6-16.1 1.3-20.6-5.5s-3.1-15.9 3.1-21.1L159 192 125.8 164.3c-6.2-5.2-7.6-14.3-3.1-21.1zm263.6 21.1L353 192 386.2 219.7c6.2 5.2 7.6 14.3 3.1 21.1s-13.3 9.2-20.6 5.5l-79.6-40c-5.4-2.7-8.8-8.2-8.8-14.3s3.4-11.6 8.8-14.3l79.6-40c7.3-3.6 16.1-1.3 20.6 5.5s3.1 15.9-3.1 21.1z"
    ]
};
var $159afdcd077ecfe9$export$b206e700cf7084e1 = $159afdcd077ecfe9$export$67ca89c1ca38d559;
var $159afdcd077ecfe9$export$d56736f5800b3f0d = {
    prefix: 'fas',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
        512,
        512,
        [
            "compress-alt"
        ],
        "f422",
        "M439.5 7c9.4-9.4 24.6-9.4 33.9 0l32 32c9.4 9.4 9.4 24.6 0 33.9l-87 87 39 39c6.9 6.9 8.9 17.2 5.2 26.2S450.2 240 440.5 240l-144 0c-13.3 0-24-10.7-24-24l0-144c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2l39 39 87-87zM72.5 272l144 0c13.3 0 24 10.7 24 24l0 144c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-39-39-87 87c-9.4 9.4-24.6 9.4-33.9 0l-32-32c-9.4-9.4-9.4-24.6 0-33.9l87-87-39-39c-6.9-6.9-8.9-17.2-5.2-26.2S62.8 272 72.5 272z"
    ]
};
var $159afdcd077ecfe9$export$a05650ebe54bede = $159afdcd077ecfe9$export$d56736f5800b3f0d;
var $159afdcd077ecfe9$export$de9a67b55dbe819a = {
    prefix: 'fas',
    iconName: 'gifts',
    icon: [
        576,
        512,
        [],
        "f79c",
        "M202-30.6c12.5 4.4 19 18.1 14.6 30.6l-8.2 23.1 25.4-18.5c10.7-7.8 25.7-5.4 33.5 5.3s5.4 25.7-5.3 33.5L233.8 64 272 64c26.5 0 48 21.5 48 48l0 2.1c-54.7 10.4-96 58.4-96 116l0 1.9c0 8.9 1 17.5 2.8 25.9-11.9 17.8-18.8 39.1-18.8 62.1l0 128c0 23.8 7.4 45.9 20.1 64L48 512c-26.5 0-48-21.5-48-48L0 112C0 85.5 21.5 64 48 64l38.2 0-28.3-20.6C47.2 35.6 44.8 20.6 52.6 9.9S75.4-3.2 86.1 4.6l27.4 20-8.3-25C101-13 107.8-26.6 120.4-30.8s26.2 2.6 30.4 15.2l9.9 29.8 10.7-30.2c4.4-12.5 18.1-19 30.6-14.6zM489.9 208c-7.5 0-14.5 3.8-18.6 10.1L446.9 256 488 256c13.3 0 24-10.7 24-24l0-1.9c0-12.2-9.9-22.1-22.1-22.1zM385.1 256l-24.4-37.9c-4.1-6.3-11.1-10.1-18.6-10.1-12.2 0-22.1 9.9-22.1 22.1l0 1.9c0 13.3 10.7 24 24 24l41.1 0zM281.9 268.5c-6.3-10.7-9.9-23.2-9.9-36.5l0-1.9c0-38.7 31.4-70.1 70.1-70.1 23.8 0 46 12.1 58.9 32.1l15 23.2 15-23.2c12.9-20 35.1-32.1 58.9-32.1 38.7 0 70.1 31.4 70.1 70.1l0 1.9c0 13.3-3.6 25.8-9.9 36.5 15.7 11.7 25.9 30.4 25.9 51.5l0 128c0 35.3-28.7 64-64 64l-72 0 0-208-48 0 0 208-72 0c-35.3 0-64-28.7-64-64l0-128c0-21.1 10.2-39.8 25.9-51.5z"
    ]
};
var $159afdcd077ecfe9$export$f24e0fce77994d4d = {
    prefix: 'fas',
    iconName: 'bed',
    icon: [
        576,
        512,
        [
            128716
        ],
        "f236",
        "M32 32c17.7 0 32 14.3 32 32l0 224 224 0 0-128c0-17.7 14.3-32 32-32l160 0c53 0 96 43 96 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-448 0 0 64c0 17.7-14.3 32-32 32S0 465.7 0 448L0 64C0 46.3 14.3 32 32 32zm80 160a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $159afdcd077ecfe9$export$1b71392d9effbe = {
    prefix: 'fas',
    iconName: 'money-bill-transfer',
    icon: [
        640,
        512,
        [],
        "e528",
        "M31 105c-9.4-9.4-9.4-24.6 0-33.9L103-1c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-31 31 67.7 0 0 0 338.3 0c35.3 0 64 28.7 64 64l0 178.2-5.1-5.1c-28.1-28.1-73.7-28.1-101.8 0-27.2 27.2-28.1 70.6-2.8 98.9l67.7 0-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-406.1 0c-35.3 0-64-28.7-64-64l0-178.2 5.1 5.1c28.1 28.1 73.7 28.1 101.8 0 27.2-27.2 28.1-70.6 2.8-98.9l-67.7 0 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L31 105zM416 256a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zm88-64.5c4.4 .5 8-3.1 8-7.5l0-48c0-4.4-3.6-8-8-8l-48 0c-4.4 0-8.1 3.6-7.5 8 3.6 29 26.6 51.9 55.5 55.5zm-368 129c-4.4-.5-8 3.1-8 7.5l0 48c0 4.4 3.6 8 8 8l48 0c4.4 0 8.1-3.6 7.5-8-3.6-29-26.6-51.9-55.5-55.5z"
    ]
};
var $159afdcd077ecfe9$export$f48814ae62850c74 = {
    prefix: 'fas',
    iconName: 'person-running',
    icon: [
        448,
        512,
        [
            127939,
            "running"
        ],
        "f70c",
        "M256.5-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM123.6 176c-3.3 0-6.2 2-7.4 5L94.2 235.9c-6.6 16.4-25.2 24.4-41.6 17.8s-24.4-25.2-17.8-41.6l21.9-54.9C67.7 129.9 94.1 112 123.6 112l97.3 0c28.5 0 54.8 15.1 69.1 39.7l32.8 56.3 61.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-61.6 0c-22.8 0-43.8-12.1-55.3-31.8l-10-17.1-20.7 70.4 75.4 22.6c27.7 8.3 41.8 39 30.1 65.5L285.7 509c-7.2 16.2-26.1 23.4-42.2 16.2s-23.4-26.1-16.2-42.2l49.2-110.8-95.9-28.8c-32.7-9.8-52-43.7-43.7-76.8l22.7-90.6-35.9 0zm-8 181c13.3 14.9 30.7 26.3 51.2 32.4l4.7 1.4-6.9 19.3c-5.8 16.3-16 30.8-29.3 41.8L52.9 519.8c-13.6 11.2-33.8 9.3-45-4.3s-9.3-33.8 4.3-45l82.4-67.9c4.5-3.7 7.8-8.5 9.8-13.9L115.6 357z"
    ]
};
var $159afdcd077ecfe9$export$5dfd1cb43dc9eadb = $159afdcd077ecfe9$export$f48814ae62850c74;
var $159afdcd077ecfe9$export$aca07924996218d8 = {
    prefix: 'fas',
    iconName: 'circle-chevron-down',
    icon: [
        512,
        512,
        [
            "chevron-circle-down"
        ],
        "f13a",
        "M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"
    ]
};
var $159afdcd077ecfe9$export$9926124d75b2ecab = $159afdcd077ecfe9$export$aca07924996218d8;
var $159afdcd077ecfe9$export$ab9af5aa013d2162 = {
    prefix: 'fas',
    iconName: 'user-nurse',
    icon: [
        448,
        512,
        [],
        "f82f",
        "M96 44.9c0-12.7 7.5-24.2 19.2-29.3l96-42c8.2-3.6 17.5-3.6 25.7 0l96 42C344.5 20.7 352 32.2 352 44.9l0 99.1c0 70.7-57.3 128-128 128S96 214.7 96 144l0-99.1zM304 128l-111.6 0-.4 0-48 0 0 16c0 44.2 35.8 80 80 80s80-35.8 80-80l0-16zM208 16l0 16-16 0c-4.4 0-8 3.6-8 8l0 16c0 4.4 3.6 8 8 8l16 0 0 16c0 4.4 3.6 8 8 8l16 0c4.4 0 8-3.6 8-8l0-16 16 0c4.4 0 8-3.6 8-8l0-16c0-4.4-3.6-8-8-8l-16 0 0-16c0-4.4-3.6-8-8-8L216 8c-4.4 0-8 3.6-8 8zM142.6 323c-6.5-4.9-15.2-6.2-22.6-2.8-61.4 28.2-104.1 90.2-104.1 162.1 0 16.4 13.3 29.7 29.7 29.7l356.6 0c16.4 0 29.7-13.3 29.7-29.7 0-72-42.7-134-104.1-162.1-7.4-3.4-16.1-2.1-22.6 2.8l-67 50.2c-8.5 6.4-20.3 6.4-28.8 0l-67-50.2z"
    ]
};
var $159afdcd077ecfe9$export$611ae61f02de0aa = {
    prefix: 'fas',
    iconName: 'face-kiss-wink-heart',
    icon: [
        640,
        512,
        [
            128536,
            "kiss-wink-heart"
        ],
        "f598",
        "M543.7 268.3c.2-4.1 .3-8.2 .3-12.3 0-141.4-114.6-256-256-256S32 114.6 32 256 146.6 512 288 512c41.4 0 80.5-9.8 115.1-27.3-7.6-17.1-16.1-38.8-21.8-61.7-7.7-30.5-14.1-76.2 8.2-114.7l2.7-4.6c29.5-51 94.7-68.5 145.7-39 2 1.2 4 2.4 5.9 3.7zM240 304c0-8.8 7.2-16 16-16l32 0c26.5 0 48 21.5 48 48 0 12.3-4.6 23.5-12.2 32 7.6 8.5 12.2 19.7 12.2 32 0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0c-8.8 0-16-7.2-16-16zM208 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm152 20c-11 0-20 9-20 20s-9 20-20 20-20-9-20-20c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60 0 11-9 20-20 20s-20-9-20-20-9-20-20-20l-16 0zM542.8 350c-2.2-18.3-12.9-34.6-28.9-43.8-28.1-16.2-63.9-6.6-80.1 21.5l-2.7 4.6c-24.5 42.5 7.9 117.9 24.4 150.8 5.1 10.1 15.5 16.1 26.8 15.5 36.7-2.2 118.2-11.7 142.8-54.2l2.7-4.6c16.2-28.1 6.6-63.9-21.5-80.1-16-9.2-35.4-10.4-52.4-3.1l-9.8 4.2-1.3-10.6z"
    ]
};
var $159afdcd077ecfe9$export$ebba617701dfb917 = $159afdcd077ecfe9$export$611ae61f02de0aa;
var $159afdcd077ecfe9$export$d3c2bcfd3b861e4a = {
    prefix: 'fas',
    iconName: 'fill',
    icon: [
        512,
        512,
        [],
        "f575",
        "M296 64c6.9 0 13.5 2.7 18.3 7.6L440.4 197.7c4.9 4.9 7.6 11.5 7.6 18.3s-2.7 13.5-7.6 18.3L386.7 288 65.3 288c1.3-3.9 3.4-7.4 6.3-10.3l96.4-96.4 33.4 33.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L213.3 136 277.7 71.6c4.9-4.9 11.5-7.6 18.3-7.6zM122.7 136L26.3 232.4C9.5 249.3 0 272.1 0 296s9.5 46.7 26.3 63.6L152.4 485.7C169.3 502.5 192.1 512 216 512s46.7-9.5 63.6-26.3L485.7 279.6C502.5 262.7 512 239.9 512 216s-9.5-46.7-26.3-63.6L359.6 26.3C342.7 9.5 319.9 0 296 0s-46.7 9.5-63.6 26.3L168 90.7 118.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L122.7 136z"
    ]
};
var $159afdcd077ecfe9$export$52e3e96cd1564779 = {
    prefix: 'fas',
    iconName: 'money-bill-1-wave',
    icon: [
        512,
        512,
        [
            "money-bill-wave-alt"
        ],
        "f53b",
        "M0 109.5L0 419.6c0 19.4 11.8 37.3 30.3 43.3 94 30 158.8 8.4 223.3-13.1 62.4-20.8 124.4-41.5 212.1-15.3 22.2 6.6 46.2-8.8 46.2-32l0-310.1c0-19.4-11.8-37.3-30.3-43.3-94-30-158.8-8.4-223.3 13.1-62.4 20.8-124.4 41.5-212.1 15.3-22.2-6.6-46.3 8.8-46.3 32zM256 368c-53 0-96-50.1-96-112s43-112 96-112 96 50.1 96 112-43 112-96 112zM127.1 405.5c.7 4.4-2.8 8.1-7.2 8.1-15.7 0-32.1-1.8-50-6.1-3.5-.8-6-4-6-7.7L64 360c0-4.4 3.6-8.1 8-7.5 28.1 3.5 50.6 25.2 55.2 53zM448 354.6c0 5-4.6 8.8-9.5 8-15.4-2.5-30.2-3.9-44.4-4.3-4.9-.1-8.7-4.5-7.2-9.2 7.3-23.7 28-41.4 53.2-44.6 4.4-.5 8 3.1 8 7.5l0 42.6zm-8-195.1c-28.1-3.5-50.6-25.2-55.2-53-.7-4.4 2.8-8.1 7.2-8.1 15.7 0 32.1 1.8 50 6.1 3.5 .8 6 4 6 7.7l0 39.9c0 4.4-3.6 8.1-8 7.5zm-322.1-5.8c4.9 .1 8.7 4.5 7.2 9.2-7.3 23.7-28 41.4-53.2 44.6-4.4 .5-8-3.1-8-7.5l0-42.6c0-5 4.6-8.8 9.5-8 15.4 2.5 30.2 3.9 44.4 4.3zM240 188c-11 0-20 9-20 20 0 9.7 6.9 17.7 16 19.6l0 48.4-4 0c-11 0-20 9-20 20s9 20 20 20l48 0c11 0 20-9 20-20s-9-20-20-20l-4 0 0-68c0-11-9-20-20-20l-16 0z"
    ]
};
var $159afdcd077ecfe9$export$1613858e873cbb3e = $159afdcd077ecfe9$export$52e3e96cd1564779;
var $159afdcd077ecfe9$export$2bebc54c51db6505 = {
    prefix: 'fas',
    iconName: 'landmark',
    icon: [
        512,
        512,
        [
            127963
        ],
        "f66f",
        "M238.7 5.1c10.5-6.8 24.1-6.8 34.6 0l224 144c11.9 7.7 17.4 22.3 13.4 35.9s-16.5 23-30.7 23l-32 0 0 208 51.2 38.4c8.1 6 12.8 15.5 12.8 25.6 0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32 0-10.1 4.7-19.6 12.8-25.6l51.2-38.4 0 0 0-208-32 0c-14.2 0-26.7-9.4-30.7-23s1.5-28.3 13.4-35.9l224-144zM336 208l0 208 64 0 0-208-64 0zM224 416l64 0 0-208-64 0 0 208zM112 208l0 208 64 0 0-208-64 0z"
    ]
};
var $159afdcd077ecfe9$export$fcb0647a5340b5b8 = {
    prefix: 'fas',
    iconName: 'music',
    icon: [
        512,
        512,
        [
            127925
        ],
        "f001",
        "M468 7c7.6 6.1 12 15.3 12 25l0 304c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c11.2 0 22 1.6 32 4.6l0-116.7-224 49.8 0 206.3c0 44.2-43 80-96 80s-96-35.8-96-80 43-80 96-80c11.2 0 22 1.6 32 4.6L128 96c0-15 10.4-28 25.1-31.2l288-64c9.5-2.1 19.4 .2 27 6.3z"
    ]
};
var $159afdcd077ecfe9$export$6feb44fec53ba30d = {
    prefix: 'fas',
    iconName: 'book-medical',
    icon: [
        448,
        512,
        [],
        "f7e6",
        "M96 512l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-66.7c18.6-6.6 32-24.4 32-45.3l0-288c0-26.5-21.5-48-48-48L96 0C43 0 0 43 0 96L0 416c0 53 43 96 96 96zM64 416c0-17.7 14.3-32 32-32l256 0 0 64-256 0c-17.7 0-32-14.3-32-32zM192 120c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 40 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-40 0 0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$ee94b652453ad208 = {
    prefix: 'fas',
    iconName: 'shuffle',
    icon: [
        512,
        512,
        [
            128256,
            "random"
        ],
        "f074",
        "M403.8 34.4c12-5 25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9S384 204.9 384 192l0-32-32 0c-10.1 0-19.6 4.7-25.6 12.8l-32.4 43.2-40-53.3 21.2-28.3C293.3 110.2 321.8 96 352 96l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6zM154 296l40 53.3-21.2 28.3C154.7 401.8 126.2 416 96 416l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c10.1 0 19.6-4.7 25.6-12.8L154 296zM438.6 470.6c-9.2 9.2-22.9 11.9-34.9 6.9S384 460.9 384 448l0-32-32 0c-30.2 0-58.7-14.2-76.8-38.4L121.6 172.8c-6-8.1-15.5-12.8-25.6-12.8l-64 0c-17.7 0-32-14.3-32-32S14.3 96 32 96l64 0c30.2 0 58.7 14.2 76.8 38.4L326.4 339.2c6 8.1 15.5 12.8 25.6 12.8l32 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c6 6 9.4 14.1 9.4 22.6s-3.4 16.6-9.4 22.6l-64 64z"
    ]
};
var $159afdcd077ecfe9$export$8357bf8cc666d5f0 = $159afdcd077ecfe9$export$ee94b652453ad208;
var $159afdcd077ecfe9$export$22346afd6a3cddf8 = {
    prefix: 'fas',
    iconName: 'underline',
    icon: [
        384,
        512,
        [],
        "f0cd",
        "M0 32C0 14.3 14.3 0 32 0L96 0c17.7 0 32 14.3 32 32S113.7 64 96 64l0 160c0 53 43 96 96 96s96-43 96-96l0-160c-17.7 0-32-14.3-32-32S270.3 0 288 0l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 160c0 88.4-71.6 160-160 160S32 312.4 32 224L32 64C14.3 64 0 49.7 0 32zM0 480c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$d65aef1ed7db1dae = {
    prefix: 'fas',
    iconName: 'building-user',
    icon: [
        640,
        512,
        [],
        "e4da",
        "M64 64C64 28.7 92.7 0 128 0L384 0c35.3 0 64 28.7 64 64l0 121.3c-46.9 19-80 65-80 118.7 0 27.7 8.8 53.4 23.8 74.4-51.5 21-87.8 71.6-87.8 130.7 0 1 0 1.9 0 2.9l-176 0c-35.3 0-64-28.7-64-64L64 64zM208 400l0 64 53.4 0c7.2-29.4 21.3-56.1 40.4-78.3-6.1-19.5-24.3-33.7-45.8-33.7-26.5 0-48 21.5-48 48zM339 224.3c-1-.2-2-.3-3-.3l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l16.7 0c2.1-22.8 8.4-44.3 18.3-63.7zM176 96c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zM176 224c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm240 80a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM352 512c0-53 43-96 96-96l96 0c53 0 96 43 96 96 0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$30a5bb4ad3fa716c = {
    prefix: 'fas',
    iconName: 'robot',
    icon: [
        640,
        512,
        [
            129302
        ],
        "f544",
        "M352 0c0-17.7-14.3-32-32-32S288-17.7 288 0l0 64-96 0c-53 0-96 43-96 96l0 224c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-224c0-53-43-96-96-96l-96 0 0-64zM160 368c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm120 0c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm120 0c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM64 224c0-17.7-14.3-32-32-32S0 206.3 0 224l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96zm544-32c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32z"
    ]
};
var $159afdcd077ecfe9$export$a105e7b44ca0eb9e = {
    prefix: 'fas',
    iconName: 'plus',
    icon: [
        448,
        512,
        [
            10133,
            61543,
            "add"
        ],
        "2b",
        "M256 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 160-160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0 0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160 160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-160 0 0-160z"
    ]
};
var $159afdcd077ecfe9$export$9e8f9a9d4ad32c0f = $159afdcd077ecfe9$export$a105e7b44ca0eb9e;
var $159afdcd077ecfe9$export$e9bd786d30cb716c = {
    prefix: 'fas',
    iconName: 'copy',
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z"
    ]
};
var $159afdcd077ecfe9$export$d5713874f8fefe1b = {
    prefix: 'fas',
    iconName: 'chess-king',
    icon: [
        448,
        512,
        [
            9818
        ],
        "f43f",
        "M224-32c17.7 0 32 14.3 32 32l0 32 32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0 0 64 153.8 0c21.1 0 38.2 17.1 38.2 38.2 0 6.4-1.6 12.7-4.7 18.3L352 384 408.2 454.3c5 6.3 7.8 14.1 7.8 22.2 0 19.6-15.9 35.5-35.5 35.5L67.5 512c-19.6 0-35.5-15.9-35.5-35.5 0-8.1 2.7-15.9 7.8-22.2L96 384 4.7 216.6C1.6 210.9 0 204.6 0 198.2 0 177.1 17.1 160 38.2 160l153.8 0 0-64-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-32c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$70fd6006b4e54a5 = {
    prefix: 'fas',
    iconName: 'house-flood-water',
    icon: [
        640,
        512,
        [],
        "e50e",
        "M496 208l4.5 0c15.2 0 27.5-12.3 27.5-27.5 0-7.9-3.4-15.5-9.4-20.7L348 10.5C340.3 3.7 330.3 0 320 0s-20.3 3.7-28 10.5L121.4 159.8c-6 5.2-9.4 12.8-9.4 20.7 0 15.2 12.3 27.5 27.5 27.5l4.5 0 0 94.4c20.3-9.4 42.1-14.2 64-14.4 33.1-.2 66.3 10.2 94.4 31.4 22.1 16.6 29.1 16.6 51.2 0 27.5-20.7 59.9-31.2 92.4-31.4 16.9-.1 33.8 2.6 50 8l0-88zm-224-8c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zM474.6 412.1c19 14.4 41.9 28.2 67.2 33.3 26.5 5.4 54.3 .8 80.7-19.1 10.6-8 12.7-23 4.7-33.6s-23-12.7-33.6-4.7c-14.9 11.2-28.6 13.1-42.3 10.3-14.9-3-30.9-11.9-47.8-24.6-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-21.6 16.3-41.3 25.8-58.9 25.7-9.6-.1-19.9-3-31.2-11.5-10.6-8-25.6-5.9-33.6 4.7S7 418.3 17.6 426.3c19.1 14.4 39.4 21 59.8 21.1 33.9 .2 64.3-17.4 88.1-35.3 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9c21.3-16.1 49.9-16.1 71.2 0zm-71.2 96c21.3-16.1 49.9-16.1 71.2 0 19 14.4 41.9 28.2 67.2 33.3 26.5 5.4 54.3 .8 80.7-19.1 10.6-8 12.7-23 4.7-33.6s-23-12.7-33.6-4.7c-14.9 11.2-28.6 13.1-42.3 10.3-14.9-3-30.9-11.9-47.8-24.6-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-21.6 16.3-41.3 25.8-58.9 25.7-9.6-.1-19.9-3-31.2-11.5-10.6-8-25.6-5.9-33.6 4.7S7 514.3 17.6 522.3c19.1 14.4 39.4 21 59.8 21.1 33.9 .2 64.3-17.4 88.1-35.3 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9z"
    ]
};
var $159afdcd077ecfe9$export$441bfc8058328ce8 = {
    prefix: 'fas',
    iconName: 'bitcoin-sign',
    icon: [
        320,
        512,
        [],
        "e0b4",
        "M64 24C64 10.7 74.7 0 88 0s24 10.7 24 24l0 40 32 0 0-40c0-13.3 10.7-24 24-24s24 10.7 24 24l0 41.1c54.3 7.8 96 54.4 96 110.9 0 24.2-7.7 46.6-20.7 64.9 31.7 19.8 52.7 55 52.7 95.1 0 61.9-50.1 112-112 112l-16 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-32 0 0 40c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-40-22.3 0C18.7 448 0 429.3 0 406.3L0 101.6C0 80.8 16.8 64 37.6 64L64 64 64 24zm0 200l112 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-112 0 0 96zm112 64l-112 0 0 96 144 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-32 0z"
    ]
};
var $159afdcd077ecfe9$export$6e7cf270cda52323 = {
    prefix: 'fas',
    iconName: 'box',
    icon: [
        448,
        512,
        [
            128230
        ],
        "f466",
        "M369.4 128l-34.3-48-222.1 0-34.3 48 290.7 0zM0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.9 42.8C72.9 26 92.3 16 112.9 16l222.1 0c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.8 10.9 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5z"
    ]
};
var $159afdcd077ecfe9$export$eaf727acca5a35e4 = {
    prefix: 'fas',
    iconName: 'square-plus',
    icon: [
        448,
        512,
        [
            61846,
            "plus-square"
        ],
        "f0fe",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$b6359eebfe900c35 = $159afdcd077ecfe9$export$eaf727acca5a35e4;
var $159afdcd077ecfe9$export$672e2f590b189583 = {
    prefix: 'fas',
    iconName: 'arrows-left-right',
    icon: [
        576,
        512,
        [
            "arrows-h"
        ],
        "f07e",
        "M470.6 374.6l96-96c12.5-12.5 12.5-32.8 0-45.3l-96-96c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l41.4 41.4-357.5 0 41.4-41.4c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-96 96c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6l96 96c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-41.4-41.4 357.5 0-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $159afdcd077ecfe9$export$de517642cdb40354 = $159afdcd077ecfe9$export$672e2f590b189583;
var $159afdcd077ecfe9$export$55145a3dae4f984a = {
    prefix: 'fas',
    iconName: 'fan',
    icon: [
        512,
        512,
        [],
        "f863",
        "M160 144c0-79.5 64.5-144 144-144 8.8 0 16 7.2 16 16l0 152.2c15-5.3 31.2-8.2 48-8.2 79.5 0 144 64.5 144 144 0 8.8-7.2 16-16 16l-152.2 0c5.3 15 8.2 31.2 8.2 48 0 79.5-64.5 144-144 144-8.8 0-16-7.2-16-16l0-152.2c-15 5.3-31.2 8.2-48 8.2-79.5 0-144-64.5-144-144 0-8.8 7.2-16 16-16l152.2 0c-5.3-15-8.2-31.2-8.2-48zm96 144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$bfa312207b788ed9 = {
    prefix: 'fas',
    iconName: 'crow',
    icon: [
        640,
        512,
        [],
        "f520",
        "M456.5 0c-48.6 0-88 39.4-88 88l0 36-355.2 266.4C-.8 401-3.7 421 6.9 435.2s30.6 17 44.8 6.4l76.8-57.6 131.3 0 46.6 113.1 1 2.2c5.7 10.7 18.8 15.5 30.3 10.8s17.3-17.3 13.9-29l-.8-2.3-39.1-94.9 40.9 0c1.1 0 2.2 0 3.2 0l46.6 113.2 1 2.2c5.7 10.7 18.8 15.5 30.3 10.8s17.3-17.3 13.9-29l-.8-2.3-42-102C485.3 354.1 544.5 280 544.5 192l0-72 80.5-20.1c8.6-2.1 13.8-10.8 11.6-19.4-7.1-28.5-32.7-48.5-62.1-48.5l-50.1 0C508.2 12.5 483.8 0 456.5 0zm0 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$8547e9f3a2ddab5b = {
    prefix: 'fas',
    iconName: 'file-circle-check',
    icon: [
        576,
        512,
        [],
        "e5a0",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3l0-38.1c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-86.6-60.9c7.1 5.2 8.7 15.2 3.5 22.3l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5z"
    ]
};
var $159afdcd077ecfe9$export$22965c7f4d903953 = {
    prefix: 'fas',
    iconName: 'link-slash',
    icon: [
        576,
        512,
        [
            "chain-broken",
            "chain-slash",
            "unlink"
        ],
        "f127",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-122-122c4.2-3.4 8.3-7.1 12.1-10.9l71.1-71.1c29.3-29.3 45.8-69.1 45.8-110.6 0-86.4-70-156.5-156.5-156.5-37.3 0-73.1 13.3-101.3 37.2 20.3 10.1 38.7 23.5 54.5 39.5 14.1-8.3 30.2-12.7 46.8-12.7 51.1 0 92.5 41.4 92.5 92.5 0 24.5-9.7 48-27.1 65.4l-71.1 71.1c-3.9 3.9-8.1 7.4-12.6 10.5l-47.5-47.5c16.5-.9 29.7-14.4 30.2-31.1 0-1.3 0-2.6 0-3.9 0-86.3-69.9-156.9-156.5-156.9-19.2 0-37.9 3.5-55.5 10.2L41-24.9zM225.9 160c.6 0 1.1 0 1.7 0 15.1 0 29.5 3.7 42.1 10.2 1.8 1.2 3.6 2.3 5.5 3.1 26.8 16.3 44.8 45.9 44.8 79.6 0 .4 0 .8 0 1.2L225.9 160zM346.2 416L192 261.8c1.2 84.6 69.6 152.9 154.1 154.1zM139.7 209.5l-45.3-45.3-48.6 48.6c-29.3 29.3-45.8 69.1-45.8 110.6 0 86.4 70 156.5 156.5 156.5 37.2 0 73.1-13.3 101.3-37.2-20.3-10.1-38.8-23.5-54.6-39.5-14 8.2-30.1 12.6-46.7 12.6-51.1 0-92.5-41.4-92.5-92.5 0-24.5 9.7-48 27.1-65.4l48.6-48.6z"
    ]
};
var $159afdcd077ecfe9$export$382551e04f32620a = $159afdcd077ecfe9$export$22965c7f4d903953;
var $159afdcd077ecfe9$export$12f09d657be59586 = $159afdcd077ecfe9$export$22965c7f4d903953;
var $159afdcd077ecfe9$export$2f546f7d8ba01e18 = $159afdcd077ecfe9$export$22965c7f4d903953;
var $159afdcd077ecfe9$export$9c58ddc4b3356f98 = {
    prefix: 'fas',
    iconName: 'arrow-rotate-right',
    icon: [
        512,
        512,
        [
            8635,
            "arrow-right-rotate",
            "arrow-rotate-forward",
            "redo"
        ],
        "f01e",
        "M436.7 74.7L448 85.4 448 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 128c0 17.7-14.3 32-32 32l-128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l47.9 0-7.6-7.2c-.2-.2-.4-.4-.6-.6-75-75-196.5-75-271.5 0s-75 196.5 0 271.5 196.5 75 271.5 0c8.2-8.2 15.5-16.9 21.9-26.1 10.1-14.5 30.1-18 44.6-7.9s18 30.1 7.9 44.6c-8.5 12.2-18.2 23.8-29.1 34.7-100 100-262.1 100-362 0S-25 175 75 75c99.9-99.9 261.7-100 361.7-.3z"
    ]
};
var $159afdcd077ecfe9$export$ffa1245982c1b28b = $159afdcd077ecfe9$export$9c58ddc4b3356f98;
var $159afdcd077ecfe9$export$89c59b5f47067f4c = $159afdcd077ecfe9$export$9c58ddc4b3356f98;
var $159afdcd077ecfe9$export$3d9f98aa1c24c776 = $159afdcd077ecfe9$export$9c58ddc4b3356f98;
var $159afdcd077ecfe9$export$eff4bdcafd3b8d1c = {
    prefix: 'fas',
    iconName: 'pen-clip',
    icon: [
        512,
        512,
        [
            "pen-alt"
        ],
        "f305",
        "M404 0c19.2 0 37.6 7.6 51.1 21.2l35.7 35.7C504.4 70.4 512 88.8 512 108s-7.6 37.6-21.2 51.1L445.9 204 308 66.1 352.9 21.2C366.4 7.6 384.8 0 404 0zM274.1 100l0 0 137.9 137.9-215.1 215.1c-10.7 10.7-24.1 18.5-38.7 22.6L30.4 511.1c-8.3 2.3-17.3 0-23.4-6.2s-8.5-15.1-6.2-23.4L36.4 353.8c4.1-14.6 11.8-27.9 22.6-38.7L240.1 133.9 223 116.9c-9.4-9.4-24.6-9.4-33.9 0L89 217c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L155.1 82.9c28.1-28.1 73.7-28.1 101.8 0L274.1 100z"
    ]
};
var $159afdcd077ecfe9$export$a3d3e92e430d3beb = $159afdcd077ecfe9$export$eff4bdcafd3b8d1c;
var $159afdcd077ecfe9$export$2c79e1a422528bba = {
    prefix: 'fas',
    iconName: 'door-closed',
    icon: [
        448,
        512,
        [
            128682
        ],
        "f52a",
        "M32 64C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 384c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32L32 64zM320 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$4229d00802c33062 = {
    prefix: 'fas',
    iconName: 'arrow-down-wide-short',
    icon: [
        576,
        512,
        [
            "sort-amount-asc",
            "sort-amount-down"
        ],
        "f160",
        "M246.6 374.6l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 370.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 306.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM320 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-160 0zm0-128c-17.7 0-32-14.3-32-32s14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L320 96z"
    ]
};
var $159afdcd077ecfe9$export$ddf8b8dd5983367d = $159afdcd077ecfe9$export$4229d00802c33062;
var $159afdcd077ecfe9$export$4b2a02d50e417b5f = $159afdcd077ecfe9$export$4229d00802c33062;
var $159afdcd077ecfe9$export$f9395ef707603e40 = {
    prefix: 'fas',
    iconName: 'caret-down',
    icon: [
        384,
        512,
        [],
        "f0d7",
        "M352 160c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-160 160c-12.5 12.5-32.8 12.5-45.3 0l-160-160c-9.2-9.2-11.9-22.9-6.9-34.9S19.1 160 32 160l320 0z"
    ]
};
var $159afdcd077ecfe9$export$3f85413cb67e7f67 = {
    prefix: 'fas',
    iconName: 'k',
    icon: [
        320,
        512,
        [
            107
        ],
        "4b",
        "M311 86.3c12.3-12.7 12-32.9-.7-45.2s-32.9-12-45.2 .7C143.4 167.2 76.4 236.3 64 249L64 64c0-17.7-14.3-32-32-32S0 46.3 0 64L0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-107 64.7-66.7 133 192c10.1 14.5 30 18.1 44.5 8.1s18.1-30 8.1-44.5L174.1 227.4 311 86.3z"
    ]
};
var $159afdcd077ecfe9$export$6999832247e52c2b = {
    prefix: 'fas',
    iconName: 'check-to-slot',
    icon: [
        576,
        512,
        [
            "vote-yea"
        ],
        "f772",
        "M552 288c13.3 0 24 10.7 24 24l0 104c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 312c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-104c0-13.3 10.7-24 24-24zM416 32c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64L96 96c0-35.3 28.7-64 64-64l256 0zm-37.1 84.6c-10.7-7.8-25.7-5.4-33.5 5.3l-85.6 117.7-26.5-27.4c-9.2-9.5-24.4-9.8-33.9-.6-9.5 9.2-9.8 24.4-.6 33.9l46.4 48c4.9 5.1 11.8 7.8 18.9 7.3s13.6-4.1 17.8-9.8L384.2 150.1c7.8-10.7 5.4-25.7-5.3-33.5z"
    ]
};
var $159afdcd077ecfe9$export$e87bb3db1608b850 = $159afdcd077ecfe9$export$6999832247e52c2b;
var $159afdcd077ecfe9$export$e7af4f0123222b6f = {
    prefix: 'fas',
    iconName: 'fish-fins',
    icon: [
        576,
        512,
        [],
        "e4f2",
        "M275.2 38.4c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5-15.3 11.5-29 23.9-40.7 36.3L48.1 132.4c-12.5-7.3-28.4-5.3-38.7 4.9s-12.4 26-5.3 38.6L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3 15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8 39.2-29.4 67.2-64.7 81.6-89.5 5.8-9.9 5.8-22.2 0-32.1-14.4-24.8-42.5-60.1-81.6-89.5-35.8-26.8-82.3-49.8-137.2-53.8L275.2 38.4zM384 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$83632d1150d3541f = {
    prefix: 'fas',
    iconName: 'compress',
    icon: [
        448,
        512,
        [],
        "f066",
        "M160 64c0-17.7-14.3-32-32-32S96 46.3 96 64l0 64-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-96zM32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0 0 64c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-96 0zM352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0-64zM320 320c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-64 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0z"
    ]
};
var $159afdcd077ecfe9$export$fb00fdd8857804c7 = {
    prefix: 'fas',
    iconName: 'arrow-up-a-z',
    icon: [
        512,
        512,
        [
            "sort-alpha-up"
        ],
        "f15e",
        "M412.6 49.7C407.2 38.8 396.1 32 384 32s-23.2 6.8-28.6 17.7c-50.7 101.3-77.3 154.7-80 160-7.9 15.8-1.5 35 14.3 42.9s35 1.5 42.9-14.3l7.2-14.3 88.4 0 7.2 14.3c7.9 15.8 27.1 22.2 42.9 14.3s22.2-27.1 14.3-42.9c-2.7-5.3-29.3-58.7-80-160zM384 135.6l20.2 40.4-40.4 0 20.2-40.4zM288 320c0 17.7 14.3 32 32 32l50.7 0-73.4 73.4c-9.2 9.2-11.9 22.9-6.9 34.9S307.1 480 320 480l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-50.7 0 73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9S460.9 288 448 288l-128 0c-17.7 0-32 14.3-32 32zM150.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 141.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 25.4 25.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-80-80z"
    ]
};
var $159afdcd077ecfe9$export$3c4115b156be730d = $159afdcd077ecfe9$export$fb00fdd8857804c7;
var $159afdcd077ecfe9$export$10f5839059d22f7e = {
    prefix: 'fas',
    iconName: 'user-graduate',
    icon: [
        448,
        512,
        [],
        "f501",
        "M241.3-13c-11.4-2.3-23.1-2.3-34.5 0L19.3 24.5C8.1 26.7 0 36.6 0 48 0 58.3 6.5 67.3 16 70.6L16 144 .3 222.6c-.2 .9-.3 1.9-.3 2.9 0 8 6.5 14.6 14.6 14.6l34.9 0c8 0 14.6-6.5 14.6-14.6 0-1-.1-1.9-.3-2.9L48 144 48 77.3 96 86.9 96 144c0 70.7 57.3 128 128 128s128-57.3 128-128l0-57.1 76.7-15.3C439.9 69.3 448 59.4 448 48s-8.1-21.3-19.3-23.5L241.3-13zM224 224c-44.2 0-80-35.8-80-80l160 0c0 44.2-35.8 80-80 80zM120.1 320.1C58.7 348.3 16 410.3 16 482.3 16 498.7 29.3 512 45.7 512l154.3 0 0-146-57.4-43c-6.5-4.9-15.2-6.2-22.6-2.8zM248 512l154.3 0c16.4 0 29.7-13.3 29.7-29.7 0-72-42.7-134-104.1-162.1-7.4-3.4-16.1-2.1-22.6 2.8l-57.4 43 0 146z"
    ]
};
var $159afdcd077ecfe9$export$143d0ca7d2200f20 = {
    prefix: 'fas',
    iconName: 'file-code',
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM154.2 295.6c8.6-10.1 7.5-25.2-2.6-33.8s-25.2-7.5-33.8 2.6l-48 56c-7.7 9-7.7 22.2 0 31.2l48 56c8.6 10.1 23.8 11.2 33.8 2.6s11.2-23.8 2.6-33.8l-34.6-40.4 34.6-40.4zm112-31.2c-8.6-10.1-23.8-11.2-33.8-2.6s-11.2 23.8-2.6 33.8l34.6 40.4-34.6 40.4c-8.6 10.1-7.5 25.2 2.6 33.8s25.2 7.5 33.8-2.6l48-56c7.7-9 7.7-22.2 0-31.2l-48-56z"
    ]
};
var $159afdcd077ecfe9$export$64f1c53b21f310ac = {
    prefix: 'fas',
    iconName: 'soap',
    icon: [
        512,
        512,
        [
            129532
        ],
        "e06e",
        "M208-32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM320 96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM352 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM96 160l112 0c0 23.8 7.4 45.9 20.1 64L160 224c-53 0-96 43-96 96s43 96 96 96l192 0c53 0 96-43 96-96 0-35.1-18.9-65.9-47-82.6 19-19.8 30.7-46.6 31-76.1 45.4 7.6 80 47.1 80 94.7l0 128c0 53-43 96-96 96L96 480c-53 0-96-43-96-96L0 256c0-53 43-96 96-96zm64 112l192 0c26.5 0 48 21.5 48 48s-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48s21.5-48 48-48z"
    ]
};
var $159afdcd077ecfe9$export$a65c441f12cb6bd = {
    prefix: 'fas',
    iconName: 'recycle',
    icon: [
        512,
        512,
        [
            9842,
            9850,
            9851
        ],
        "f1b8",
        "M152.3 60C198.5-20 314-20 360.2 60l37.3 64.6 27.7-16c8.4-4.9 18.9-4.2 26.6 1.7s11.1 15.9 8.6 25.3L436.9 223c-3.4 12.8-16.6 20.4-29.4 17l-87.4-23.4c-9.4-2.5-16.3-10.4-17.6-20s3.4-19.1 11.8-23.9l27.7-16-37.3-64.6c-21.6-37.3-75.4-37.3-97 0l-5.3 9.1c-8.8 15.3-28.4 20.5-43.7 11.7S138.2 84.5 147 69.1l5.3-9.1zM449.7 279.1c15.3-8.8 34.9-3.6 43.7 11.7l5.3 9.1c46.2 80-11.5 180-103.9 180l-74.6 0 0 32c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-64-64c-9.4-9.4-9.4-24.6 0-33.9l64-64c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2l0 32 74.6 0c43.1 0 70.1-46.7 48.5-84l-5.3-9.1c-8.8-15.3-3.6-34.9 11.7-43.7zM51 235.4l-27.7-16c-8.4-4.9-13.1-14.3-11.8-23.9s8.2-17.5 17.6-20L116.5 152c12.8-3.4 26 4.2 29.4 17l23.4 87.4c2.5 9.4-.9 19.3-8.6 25.3s-18.2 6.6-26.6 1.7l-27.7-16-37.3 64.6c-21.6 37.3 5.4 84 48.5 84l10.6 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-10.6 0C25.3 480-32.4 380 13.8 300L51 235.4z"
    ]
};
var $159afdcd077ecfe9$export$1dd161850c5bc64e = {
    prefix: 'fas',
    iconName: 'face-grin-wink',
    icon: [
        512,
        512,
        [
            "grin-wink"
        ],
        "f58c",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM386.7 308.9c11.9-3.7 23.9 6.3 19.6 18.1-22.4 61.3-81.3 105.1-150.3 105.1S128.1 388.2 105.7 326.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1zM328 196c-11 0-20 9-20 20s-9 20-20 20-20-9-20-20c0-33.1 26.9-60 60-60l16 0c33.1 0 60 26.9 60 60 0 11-9 20-20 20s-20-9-20-20-9-20-20-20l-16 0zM176 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$2397fcd34eb12177 = $159afdcd077ecfe9$export$1dd161850c5bc64e;
var $159afdcd077ecfe9$export$5930e9bdfd790d77 = {
    prefix: 'fas',
    iconName: 'water-ladder',
    icon: [
        640,
        512,
        [
            "ladder-water",
            "swimming-pool"
        ],
        "f5c5",
        "M374.5 405.7c38.4-29 90.5-29 129 0 16.9 12.7 32.9 21.5 47.8 24.6 13.7 2.8 27.4 .9 42.3-10.3 10.6-8 25.6-5.9 33.6 4.7s5.8 25.7-4.8 33.6c-26.4 19.9-54.2 24.4-80.7 19.1-25.3-5.1-48.1-18.9-67.2-33.3-21.3-16.1-49.9-16.1-71.2 0-24.2 18.3-52.3 35.9-83.4 35.9s-59.1-17.7-83.3-35.9c-21.3-16.1-49.9-16.1-71.2 0-23.8 17.9-54.1 35.5-88.1 35.3-20.4-.1-40.7-6.7-59.8-21.1-10.6-8-12.7-23-4.7-33.6s23-12.7 33.6-4.7c11.3 8.5 21.6 11.4 31.2 11.5 17.6 .1 37.3-9.4 58.9-25.7 38.4-29 90.6-29 129 0 24 18.1 40.7 26.3 54.5 26.3s30.5-8.2 54.5-26.3zM511.8 32c48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8-17.5 0-31.8 14.2-31.8 31.8l0 211.8c-23.1-5.1-44.9-4.4-64-.4l0-51.2-192 0 0 48.7c-5.3-.5-10.7-.8-16-.7-16.2 .1-32.4 2.7-48 8l0-216.2c0-52.9 42.9-95.8 95.7-95.8 48.3 0 89 36 95 83.9l1 8.2c2.2 17.5-10.2 33.5-27.8 35.7s-33.5-10.2-35.7-27.8l-1-8.2c-2-15.9-15.5-27.8-31.5-27.8-17.5 0-31.7 14.2-31.7 31.8l0 96.2 192 0 0-96.2C416 74.9 458.9 32 511.8 32z"
    ]
};
var $159afdcd077ecfe9$export$c5ea6eeef2db2b3b = $159afdcd077ecfe9$export$5930e9bdfd790d77;
var $159afdcd077ecfe9$export$4dee691631c67d5c = $159afdcd077ecfe9$export$5930e9bdfd790d77;
var $159afdcd077ecfe9$export$f4b64c3a138c1b59 = {
    prefix: 'fas',
    iconName: 'tower-cell',
    icon: [
        576,
        512,
        [],
        "e585",
        "M59.6 9.8C47.3 4.8 33.3 10.7 28.4 23 15.2 55.5 8 90.9 8 128s7.2 72.5 20.4 105c5 12.3 19 18.2 31.3 13.2s18.2-19 13.2-31.3C62 188.2 56 158.8 56 128s6-60.2 16.9-87c5-12.3-1-26.3-13.2-31.3zm456.8 0c-12.3 5-18.2 19-13.2 31.3 10.9 26.8 16.9 56.2 16.9 87s-6 60.2-16.9 87c-5 12.3 1 26.3 13.2 31.3s26.3-1 31.3-13.2c13.1-32.5 20.4-67.9 20.4-105s-7.2-72.5-20.4-105c-5-12.3-19-18.2-31.3-13.2zM340.1 165.2c7.5-10.5 11.9-23.3 11.9-37.2 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 13.9 4.4 26.7 11.9 37.2L98.9 466.8c-7.3 16.1-.2 35.1 15.9 42.4s35.1 .2 42.4-15.9l20.6-45.2 220.6 0 20.6 45.2c7.3 16.1 26.3 23.2 42.4 15.9s23.2-26.3 15.9-42.4L340.1 165.2zM376.5 400l-177 0 21.8-48 133.3 0 21.8 48zM288 205.3l44.8 98.7-89.7 0 44.8-98.7zM163.3 73.6c5.3-12.1-.2-26.3-12.4-31.6s-26.3 .2-31.6 12.4C109.5 77 104 101.9 104 128s5.5 51 15.3 73.6c5.3 12.1 19.5 17.7 31.6 12.4s17.7-19.5 12.4-31.6C156 165.8 152 147.4 152 128s4-37.8 11.3-54.4zM456.7 54.4c-5.3-12.1-19.5-17.7-31.6-12.4s-17.7 19.5-12.4 31.6C420 90.2 424 108.6 424 128s-4 37.8-11.3 54.4c-5.3 12.1 .2 26.3 12.4 31.6s26.3-.2 31.6-12.4C466.5 179 472 154.1 472 128s-5.5-51-15.3-73.6z"
    ]
};
var $159afdcd077ecfe9$export$dec10d4c2c113312 = {
    prefix: 'fas',
    iconName: 'colon-sign',
    icon: [
        384,
        512,
        [],
        "e140",
        "M213.8 8.7c12.9 3.2 20.7 16.2 17.5 29.1l-4.6 18.5c15.4 .8 30.4 3.4 44.7 7.5l9.4-37.6C283.9 13.3 297 5.5 309.8 8.7S330.5 25 327.3 37.8L316 82.8c13.5 7.8 26 17.1 37.2 27.8 12.9 12.1 13.4 32.4 1.3 45.2s-32.4 13.4-45.2 1.3c-3.1-2.9-6.4-5.8-9.8-8.4L239.2 390c26.9-4.6 51.1-17.1 70.1-35.1 12.9-12.1 33.1-11.5 45.2 1.3s11.5 33.1-1.3 45.2c-34.3 32.3-80 52.8-130.5 54.4l-7.5 29.9c-3.2 12.9-16.2 20.7-29.1 17.5s-20.7-16.2-17.5-29.1l5.6-22.5c-15-3.2-29.4-8-42.9-14.4l-12.1 48.5c-3.2 12.9-16.2 20.7-29.1 17.5S69.5 487 72.7 474.2l16-63.9C44.3 373.6 16 318.1 16 256 16 159.2 84.8 78.4 176.3 60l8.4-33.8C187.9 13.3 201 5.5 213.8 8.7zM158 132.9c-46.1 21.8-78 68.7-78 123.1 0 30.5 10 58.6 26.9 81.3L158 132.9zM147.4 373.4c13 7.6 27.3 13.1 42.5 16.1l65.9-263.6c-12.6-3.8-25.9-5.9-39.8-5.9-1.8 0-3.5 0-5.3 .1L147.4 373.4z"
    ]
};
var $159afdcd077ecfe9$export$e1046cf83da9b7ef = {
    prefix: 'fas',
    iconName: 'laptop-file',
    icon: [
        576,
        512,
        [],
        "e51d",
        "M64 64C64 28.7 92.7 0 128 0L416 0c35.3 0 64 28.7 64 64l0 48-64 0 0-48-288 0 0 192 112 0 0 96-163.2 0C34.4 352 0 317.6 0 275.2 0 264.6 8.6 256 19.2 256L64 256 64 64zM529.9 257.9c9 9 14.1 21.2 14.1 33.9L544 464c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-256c0-26.5 21.5-48 48-48l76.1 0c12.7 0 24.9 5.1 33.9 14.1 20 20 47.9 47.9 83.9 83.9zM416 272c0 8.8 7.2 16 16 16l60.1 0-76.1-76.1 0 60.1z"
    ]
};
var $159afdcd077ecfe9$export$6d636565b3ec36b4 = {
    prefix: 'fas',
    iconName: 'bahai',
    icon: [
        576,
        512,
        [
            "haykal"
        ],
        "f666",
        "M288.4-8c13.2 0 25 8.1 29.8 20.4l31.9 82 77.2-42.3c11.6-6.3 25.8-4.9 35.9 3.5s14 22.3 9.7 34.8l-28.2 83.3 86.3 17.2c12.9 2.6 23 12.8 25.3 25.8s-3.6 26.1-14.9 32.9l-75.2 45.7 55 68.6c8.3 10.3 9.3 24.6 2.7 36s-19.5 17.6-32.6 15.6l-87-13.3-2 88c-.3 13.2-8.6 24.8-21 29.4s-26.3 1-35-9l-58-66.1-58 66.1c-8.7 9.9-22.6 13.5-35 9s-20.8-16.2-21-29.4l-2-88-87 13.3c-13 2-26-4.2-32.6-15.6s-5.5-25.7 2.7-36l55-68.6-75.2-45.7c-11.3-6.8-17.2-19.9-14.9-32.9s12.3-23.2 25.3-25.8l86.3-17.2-28.2-83.3c-4.2-12.5-.4-26.3 9.7-34.8s24.4-9.9 35.9-3.5l77.1 42.3 31.9-82C263.3 .1 275.2-8 288.4-8zm0 120.2L273 151.6c-3.3 8.6-10.2 15.3-18.9 18.5s-18.2 2.4-26.3-2l-37-20.3 13.6 40c3 8.7 2 18.3-2.6 26.3s-12.4 13.6-21.5 15.4l-41.4 8.3 36.1 21.9c7.9 4.8 13.3 12.7 14.9 21.8s-.8 18.4-6.5 25.6l-26.4 33 41.8-6.4c9.1-1.4 18.4 1.2 25.4 7.1s11.2 14.6 11.4 23.8l.9 42.2 27.9-31.8c6.1-6.9 14.8-10.9 24.1-10.9s18 4 24.1 10.9l27.9 31.8 .9-42.2c.2-9.2 4.4-17.9 11.4-23.8s16.3-8.5 25.4-7.1l41.8 6.4-26.4-33c-5.8-7.2-8.2-16.5-6.6-25.6s7-17 14.9-21.8l36.1-21.9-41.4-8.3c-9-1.8-16.9-7.4-21.5-15.4s-5.5-17.6-2.6-26.3l13.6-40-37 20.3c-8.1 4.4-17.7 5.2-26.3 2s-15.5-9.9-18.9-18.5l-15.3-39.4z"
    ]
};
var $159afdcd077ecfe9$export$5c15e34e0e43f15c = $159afdcd077ecfe9$export$6d636565b3ec36b4;
var $159afdcd077ecfe9$export$a312c7d58dd44a75 = {
    prefix: 'fas',
    iconName: 'money-bill-1',
    icon: [
        512,
        512,
        [
            "money-bill-alt"
        ],
        "f3d1",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm192 80a112 112 0 1 1 0 224 112 112 0 1 1 0-224zM64 184l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8.1 3.6 7.5 8-3.6 29-26.6 51.9-55.5 55.5-4.4 .5-8-3.1-8-7.5zm0 144c0-4.4 3.6-8.1 8-7.5 29 3.6 51.9 26.6 55.5 55.5 .5 4.4-3.1 8-7.5 8l-48 0c-4.4 0-8-3.6-8-8l0-48zM440 191.5c-29-3.6-51.9-26.6-55.5-55.5-.5-4.4 3.1-8 7.5-8l48 0c4.4 0 8 3.6 8 8l0 48c0 4.4-3.6 8.1-8 7.5zM448 328l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8.1-3.6-7.5-8 3.6-29 26.6-51.9 55.5-55.5 4.4-.5 8 3.1 8 7.5zM240 188c-11 0-20 9-20 20 0 9.7 6.9 17.7 16 19.6l0 48.4-4 0c-11 0-20 9-20 20s9 20 20 20l48 0c11 0 20-9 20-20s-9-20-20-20l-4 0 0-68c0-11-9-20-20-20l-16 0z"
    ]
};
var $159afdcd077ecfe9$export$a35d573395884c3d = $159afdcd077ecfe9$export$a312c7d58dd44a75;
var $159afdcd077ecfe9$export$cdd116afa0309c17 = {
    prefix: 'fas',
    iconName: 'cloud-bolt',
    icon: [
        512,
        512,
        [
            127785,
            "thunderstorm"
        ],
        "f76c",
        "M0 224c0 53 43 96 96 96l38.6 0 124.1-111c12.2-10.9 28-17 44.4-17 44.6 0 76.5 43 63.7 85.7L354.1 320 416 320c53 0 96-43 96-96s-43-96-96-96c-.5 0-1.1 0-1.6 0 1.1-5.2 1.6-10.5 1.6-16 0-44.2-35.8-80-80-80-24.3 0-46.1 10.9-60.8 28-18.7-35.7-56.1-60-99.2-60-61.9 0-112 50.1-112 112 0 7.1 .7 14.1 1.9 20.8-38.3 12.6-65.9 48.7-65.9 91.2zM160.6 400l61.8 0-31.2 104.1c-3.6 11.9 5.3 23.9 17.8 23.9 4.6 0 9-1.7 12.4-4.7L362.5 396.9c3.5-3.1 5.5-7.6 5.5-12.4 0-9.2-7.4-16.6-16.6-16.6l-61.8 0 31.2-104.1c3.6-11.9-5.3-23.9-17.8-23.9-4.6 0-9 1.7-12.4 4.7L149.5 371.1c-3.5 3.1-5.5 7.6-5.5 12.4 0 9.2 7.4 16.6 16.6 16.6z"
    ]
};
var $159afdcd077ecfe9$export$bbf9e3d433f8f6de = $159afdcd077ecfe9$export$cdd116afa0309c17;
var $159afdcd077ecfe9$export$6bad2c9f317b52e5 = {
    prefix: 'fas',
    iconName: 'ethernet',
    icon: [
        512,
        512,
        [],
        "f796",
        "M0 224L0 416c0 17.7 14.3 32 32 32l32 0 0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 64 0 0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 64 0 0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 64 0 0-104c0-13.3 10.7-24 24-24s24 10.7 24 24l0 104 32 0c17.7 0 32-14.3 32-32l0-192c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32l-32 0 0-32c0-17.7-14.3-32-32-32L160 64c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32l0 32-32 0c-17.7 0-32 14.3-32 32z"
    ]
};
var $159afdcd077ecfe9$export$22a9491150c64fef = {
    prefix: 'fas',
    iconName: 'hryvnia-sign',
    icon: [
        384,
        512,
        [
            8372,
            "hryvnia"
        ],
        "f6f2",
        "M336 149.4C336 77 268.5 23.5 198 40.1L93.2 64.9C76 68.9 65.4 86.2 69.4 103.4s21.3 27.9 38.5 23.8l104.8-24.7c30.3-7.1 59.3 15.8 59.3 46.9 0 17.6-9.6 33.8-25 42.3l-.7 .4-222.3 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l336 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32.4 0c5.5-13.3 8.4-27.8 8.4-42.6zM360 272L24 272c-13.3 0-24 10.7-24 24s10.7 24 24 24l33.3 0c-6.1 13.4-9.3 28.1-9.3 43.3 0 64.1 56.9 113.4 120.4 104.2l137.9-19.9c17.5-2.5 29.6-18.7 27.1-36.2s-18.8-29.6-36.2-27.1L159.2 404.2c-24.9 3.6-47.2-15.7-47.2-40.9 0-15.1 8.2-28.9 21.4-36.2l13-7.1 213.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24z"
    ]
};
var $159afdcd077ecfe9$export$33d5f94bd6f75f59 = $159afdcd077ecfe9$export$22a9491150c64fef;
var $159afdcd077ecfe9$export$ed3f2918429d029a = {
    prefix: 'fas',
    iconName: 'eye-slash',
    icon: [
        576,
        512,
        [],
        "f070",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96.4-96.4c2.7-2.4 5.4-4.8 8-7.2 46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6-56.8 0-105.6 18.2-146 44.2L41-24.9zM204.5 138.7c23.5-16.8 52.4-26.7 83.5-26.7 79.5 0 144 64.5 144 144 0 31.1-9.9 59.9-26.7 83.5l-34.7-34.7c12.7-21.4 17-47.7 10.1-73.7-13.7-51.2-66.4-81.6-117.6-67.9-8.6 2.3-16.7 5.7-24 10l-34.7-34.7zM325.3 395.1c-11.9 3.2-24.4 4.9-37.3 4.9-79.5 0-144-64.5-144-144 0-12.9 1.7-25.4 4.9-37.3L69.4 139.2c-32.6 36.8-55 75.8-66.9 104.5-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47.1 43.7 111.8 80.6 192.6 80.6 37.3 0 71.2-7.9 101.5-20.6l-64.2-64.2z"
    ]
};
var $159afdcd077ecfe9$export$ab81ff863770d996 = {
    prefix: 'fas',
    iconName: 'cart-flatbed-suitcase',
    icon: [
        576,
        512,
        [
            "luggage-cart"
        ],
        "f59d",
        "M0 32C0 14.3 14.3 0 32 0L48 0c44.2 0 80 35.8 80 80l0 288c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-34.7 0c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16l-197.5 0c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-6 1.1-11.7 3.1-17-38.1-6.2-67.1-39.2-67.1-79L64 80c0-8.8-7.2-16-16-16L32 64C14.3 64 0 49.7 0 32zM176 144c0-26.5 21.5-48 48-48l32 0 0-24c0-30.9 25.1-56 56-56l64 0c30.9 0 56 25.1 56 56l0 24 32 0c26.5 0 48 21.5 48 48l0 144c0 26.5-21.5 48-48 48l-240 0c-26.5 0-48-21.5-48-48l0-144zM384 96l0-24c0-4.4-3.6-8-8-8l-64 0c-4.4 0-8 3.6-8 8l0 24 80 0z"
    ]
};
var $159afdcd077ecfe9$export$bd1e24dd3cde8514 = $159afdcd077ecfe9$export$ab81ff863770d996;
var $159afdcd077ecfe9$export$4c4e509518093d6d = {
    prefix: 'fas',
    iconName: 'radiation',
    icon: [
        576,
        512,
        [],
        "f7b9",
        "M446.2 34.5c-14.2-10.1-33.5-4.6-42.2 10.5L331.6 170.3c31.3 15.8 52.8 48.3 52.8 85.7l144 0c17.7 0 32.2-14.4 30.1-31.9-9.1-78.1-51.4-146.1-112.3-189.6zM172.7 44.9C164 29.8 144.7 24.3 130.5 34.5 69.6 77.9 27.3 145.9 18.2 224.1 16.1 241.6 30.7 256 48.3 256l144 0c0-37.5 21.5-69.9 52.8-85.7L172.7 44.9zm-9.4 416.8c-8.7 15.1-3.8 34.5 12 41.8 34.4 15.7 72.7 24.5 113 24.5s78.6-8.8 113-24.5c15.8-7.2 20.7-26.7 12-41.8L341 336.3c-15.1 9.9-33.2 15.7-52.6 15.7s-37.5-5.8-52.6-15.7L163.3 461.7zM288.3 304a48 48 0 1 0 -.7-96 48 48 0 1 0 .7 96z"
    ]
};
var $159afdcd077ecfe9$export$f0858dff6e769cf6 = {
    prefix: 'fas',
    iconName: 'file-word',
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM135.4 274.8c-2.9-12.9-15.7-21.1-28.6-18.2s-21.1 15.7-18.2 28.6l32 144c2.3 10.5 11.4 18.2 22.2 18.8s20.6-6.1 24-16.4l25.2-75.7 25.2 75.7c3.4 10.2 13.2 16.9 24 16.4s19.9-8.2 22.2-18.8l32-144c2.9-12.9-5.3-25.8-18.2-28.6s-25.8 5.3-28.6 18.2l-13.2 59.4-20.6-61.8c-3.3-9.8-12.4-16.4-22.8-16.4s-19.5 6.6-22.8 16.4l-20.6 61.8-13.2-59.4z"
    ]
};
var $159afdcd077ecfe9$export$580ae0d0bbd809fb = {
    prefix: 'fas',
    iconName: 'bed-pulse',
    icon: [
        640,
        512,
        [
            "procedures"
        ],
        "f487",
        "M531.2-22.4L572 32 616 32c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0c-7.6 0-14.7-3.6-19.2-9.6l-24.1-32.1-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L387.2 80 344 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5c3.6-7.6 10.9-12.8 19.3-13.7s16.6 2.7 21.6 9.5zM320 160c0-17.7 14.3-32 32-32l9.5 0 26.6 39.9c14.4 21.6 39.3 33.8 65.2 31.9s48.8-17.6 59.8-41.1L527 129.2c45.9 7.2 81 46.9 81 94.8l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-448 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32S96 46.3 96 64l0 224 224 0 0-128zM144 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"
    ]
};
var $159afdcd077ecfe9$export$5f9e1870e1866dde = $159afdcd077ecfe9$export$580ae0d0bbd809fb;
var $159afdcd077ecfe9$export$c93b950e845a4ee7 = {
    prefix: 'fas',
    iconName: 'tents',
    icon: [
        576,
        512,
        [],
        "e582",
        "M539.9 352l-95.6 0-8.4-66.1c-2.9-23.2-15.9-43.9-35.4-56.8L252.2 131.5c-18-11.9-39.7-15.7-60.1-11.5 2.5-4.3 5.9-7.9 10.1-10.7L350.6 11.6c10.7-7 24.5-7 35.2 0l148.4 97.7c7.8 5.1 13 13.4 14.2 22.7l23.3 184c2.4 19.1-12.5 36-31.7 36zM4.8 476l23.3-184c1.2-9.3 6.3-17.6 14.2-22.7l148.4-97.7c10.7-7 24.5-7 35.2 0l148.4 97.7c7.8 5.1 13 13.4 14.2 22.7l23.3 184c2.4 19.1-12.5 36-31.7 36l-49.7 0c-11.2 0-21.5-5.8-27.3-15.4l-77-126.7c-1.7-2.8-4.8-4.6-8.1-4.6-5.3 0-9.5 4.3-9.5 9.5l0 105.2c0 17.7-14.3 32-32 32L36.5 512c-19.3 0-34.2-16.9-31.7-36z"
    ]
};
var $159afdcd077ecfe9$export$47a822c30184e8af = {
    prefix: 'fas',
    iconName: 'mug-hot',
    icon: [
        576,
        512,
        [
            9749
        ],
        "f7b6",
        "M152-16c-13.3 0-24 10.7-24 24 0 38.9 23.4 59.4 39.1 73.1l1.1 1c16.3 14.3 23.8 21.8 23.8 37.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C183.5 31.7 176 24.1 176 8 176-5.3 165.3-16 152-16zM96 192c-17.7 0-32 14.3-32 32l0 192c0 53 43 96 96 96l192 0c41.8 0 77.4-26.7 90.5-64l5.5 0c70.7 0 128-57.3 128-128S518.7 192 448 192L96 192zM448 384l0-128c35.3 0 64 28.7 64 64s-28.7 64-64 64zM288 8c0-13.3-10.7-24-24-24S240-5.3 240 8c0 38.9 23.4 59.4 39.1 73.1l1.1 1c16.3 14.3 23.8 21.8 23.8 37.9 0 13.3 10.7 24 24 24s24-10.7 24-24c0-38.9-23.4-59.4-39.1-73.1l-1.1-1C295.5 31.7 288 24.1 288 8z"
    ]
};
var $159afdcd077ecfe9$export$6869964aa308dd31 = {
    prefix: 'fas',
    iconName: 'bolt',
    icon: [
        448,
        512,
        [
            9889,
            "zap"
        ],
        "f0e7",
        "M338.8-9.9c11.9 8.6 16.3 24.2 10.9 37.8L271.3 224 416 224c13.5 0 25.5 8.4 30.1 21.1s.7 26.9-9.6 35.5l-288 240c-11.3 9.4-27.4 9.9-39.3 1.3s-16.3-24.2-10.9-37.8L176.7 288 32 288c-13.5 0-25.5-8.4-30.1-21.1s-.7-26.9 9.6-35.5l288-240c11.3-9.4 27.4-9.9 39.3-1.3z"
    ]
};
var $159afdcd077ecfe9$export$d62abb82664f55ca = $159afdcd077ecfe9$export$6869964aa308dd31;
var $159afdcd077ecfe9$export$53583b459a87a01 = {
    prefix: 'fas',
    iconName: 'jar',
    icon: [
        320,
        512,
        [],
        "e516",
        "M32-8c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L56 16C42.7 16 32 5.3 32-8zM0 128C0 92.7 28.7 64 64 64l192 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128zm96 64c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32L96 192z"
    ]
};
var $159afdcd077ecfe9$export$e1d5ceed99060d76 = {
    prefix: 'fas',
    iconName: 'truck-plane',
    icon: [
        640,
        512,
        [],
        "e58f",
        "M144 48c0-26.5 21.5-48 48-48s48 21.5 48 48l0 320c0 32.5 12.1 62.1 32 84.7l0 27.3c0 7.1 .9 14.1 2.7 20.7L192 480 83.9 507C73.8 509.6 64 501.9 64 491.5l0-19.8c0-4.9 2.2-9.5 6-12.5l74-59.2 0-57.6-122.1 48.8C11.4 395.4 0 387.7 0 376.4l0-44c0-8 3-15.6 8.3-21.5L144 161.6 144 48zm224 80l192 0c44.2 0 80 35.8 80 80l0 160c0 26.2-12.6 49.4-32 64l0 48c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-160 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-48c-19.4-14.6-32-37.8-32-64l0-160c0-44.2 35.8-80 80-80zm0 176l192 0 0-32c0-17.7-14.3-32-32-32l-128 0c-17.7 0-32 14.3-32 32l0 32zm0 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$97e5ef3e80a0fbef = {
    prefix: 'fas',
    iconName: 'hand-holding-heart',
    icon: [
        576,
        512,
        [],
        "f4be",
        "M279.6 31C265.5 11.5 242.9 0 218.9 0 177.5 0 144 33.5 144 74.9l0 2.4c0 64.4 82 133.4 122.2 163.3 13 9.7 30.5 9.7 43.5 0 40.2-30 122.2-98.9 122.2-163.3l0-2.4c0-41.4-33.5-74.9-74.9-74.9-24 0-46.6 11.5-60.7 31L288 42.7 279.6 31zM109.3 341.5L66.7 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 280 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z"
    ]
};
var $159afdcd077ecfe9$export$89b706873769c180 = {
    prefix: 'fas',
    iconName: 'arrow-rotate-left',
    icon: [
        512,
        512,
        [
            8634,
            "arrow-left-rotate",
            "arrow-rotate-back",
            "arrow-rotate-backward",
            "undo"
        ],
        "f0e2",
        "M256 64c-56.8 0-107.9 24.7-143.1 64l47.1 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 192c-17.7 0-32-14.3-32-32L0 32C0 14.3 14.3 0 32 0S64 14.3 64 32l0 54.7C110.9 33.6 179.5 0 256 0 397.4 0 512 114.6 512 256S397.4 512 256 512c-87 0-163.9-43.4-210.1-109.7-10.1-14.5-6.6-34.4 7.9-44.6s34.4-6.6 44.6 7.9c34.8 49.8 92.4 82.3 157.6 82.3 106 0 192-86 192-192S362 64 256 64z"
    ]
};
var $159afdcd077ecfe9$export$1aea864c3e1d79b = $159afdcd077ecfe9$export$89b706873769c180;
var $159afdcd077ecfe9$export$a34701878babe5fc = $159afdcd077ecfe9$export$89b706873769c180;
var $159afdcd077ecfe9$export$fce381d12e4535cd = $159afdcd077ecfe9$export$89b706873769c180;
var $159afdcd077ecfe9$export$a5e5ba60b1dfe2b2 = $159afdcd077ecfe9$export$89b706873769c180;
var $159afdcd077ecfe9$export$67a047c738fb34da = {
    prefix: 'fas',
    iconName: 'face-angry',
    icon: [
        512,
        512,
        [
            128544,
            "angry"
        ],
        "f556",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM256 368c24.1 0 45.4 11.8 58.5 30 7.7 10.8 22.7 13.2 33.5 5.5s13.2-22.7 5.5-33.5c-21.7-30.2-57.3-50-97.5-50s-75.7 19.8-97.5 50c-7.7 10.8-5.3 25.8 5.5 33.5s25.8 5.3 33.5-5.5c13.1-18.2 34.4-30 58.5-30zm-80-96c17.7 0 32-14.3 32-32l0-.3 9.7 3.2c10.5 3.5 21.8-2.2 25.3-12.6s-2.2-21.8-12.6-25.3l-96-32c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3l28.9 9.6c-4.1 5.4-6.6 12.1-6.6 19.4 0 17.7 14.3 32 32 32zm192-32c0-7.3-2.4-14-6.6-19.4l28.9-9.6c10.5-3.5 16.1-14.8 12.6-25.3s-14.8-16.1-25.3-12.6l-96 32c-10.5 3.5-16.1 14.8-12.6 25.3s14.8 16.1 25.3 12.6l9.7-3.2 0 .3c0 17.7 14.3 32 32 32s32-14.3 32-32z"
    ]
};
var $159afdcd077ecfe9$export$3c96c08e234498c5 = $159afdcd077ecfe9$export$67a047c738fb34da;
var $159afdcd077ecfe9$export$ea2986b45ba5d2cf = {
    prefix: 'fas',
    iconName: 'burst',
    icon: [
        512,
        512,
        [],
        "e4dc",
        "M37.6 4.2C28-2.3 15.2-1.1 7 7S-2.3 28 4.2 37.6l112 163.3-99.6 32.3C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l103.1 33.4-52.9 100.6c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l100.6-52.9 33.4 103.1c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l33.4-103.1 100.6 52.9c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1l-52.9-100.6 103.1-33.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-106.5-34.5 25.7-70.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-70.4 25.7-34.5-106.5C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6L200.9 116.2 37.6 4.2z"
    ]
};
var $159afdcd077ecfe9$export$3481c1aa28972f9b = {
    prefix: 'fas',
    iconName: 'z',
    icon: [
        384,
        512,
        [
            122
        ],
        "5a",
        "M0 64C0 46.3 14.3 32 32 32l320 0c12.4 0 23.7 7.2 29 18.4s3.6 24.5-4.4 34.1L100.3 416 352 416c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-12.4 0-23.7-7.2-29-18.4s-3.6-24.5 4.4-34.1L283.7 96 32 96C14.3 96 0 81.7 0 64z"
    ]
};
var $159afdcd077ecfe9$export$658a137d3845bca7 = {
    prefix: 'fas',
    iconName: 'bandage',
    icon: [
        576,
        512,
        [
            129657,
            "band-aid"
        ],
        "f462",
        "M464 416l48 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64l-48 0 0 320zM416 96l-256 0 0 320 256 0 0-320zM64 96C28.7 96 0 124.7 0 160L0 352c0 35.3 28.7 64 64 64l48 0 0-320-48 0zM216 208a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM216 304a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$b14a1014df2fdf46 = $159afdcd077ecfe9$export$658a137d3845bca7;
var $159afdcd077ecfe9$export$f201ba865ea1b8dc = {
    prefix: 'fas',
    iconName: 'plane-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e556",
        "M232 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 78 71.5c-69.3 29-118 97.4-118 177.2 0 49.3 18.6 94.3 49.1 128.3L288 512 179.9 539c-10.1 2.5-19.9-5.1-19.9-15.5l0-19.8c0-4.9 2.2-9.5 6-12.5l66-52.8 0-99.7-162.9 54.3C58.7 396.4 48 388.7 48 377.8l0-43.7c0-9 3.8-17.5 10.4-23.6L232 151.3 232 24zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 228a20 20 0 1 0 0-40 20 20 0 1 0 0 40zm0-180c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$b520530474846664 = {
    prefix: 'fas',
    iconName: 'bus-side',
    icon: [
        640,
        512,
        [],
        "e81d",
        "M480 0c88.4 0 160 71.6 160 160l0 224c0 35.3-28.7 64-64 64l-5.6 0c-13.2 37.3-48.6 64-90.4 64s-77.3-26.7-90.4-64l-139.1 0c-13.2 37.3-48.7 64-90.4 64s-77.2-26.7-90.4-64L64 448c-35.3 0-64-28.7-64-64L0 96C0 43 43 0 96 0L480 0zM160 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm320 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-304c-17.7 0-32 14.3-32 32l0 192c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-128c0-53-43-96-96-96zM248 224l104 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-104 0 0 160zM96 64C78.3 64 64 78.3 64 96l0 96c0 17.7 14.3 32 32 32l104 0 0-160-104 0z"
    ]
};
var $159afdcd077ecfe9$export$f5bfd1271b8b71d1 = {
    prefix: 'fas',
    iconName: 'bugs',
    icon: [
        576,
        512,
        [],
        "e4d0",
        "M447.5 174.6c8.8-8.4 22.7-8.9 32.2-.8s11 21.9 4.1 31.9l-1.5 1.9-23 26.7c26.7 13.5 46.3 39.1 51.4 69.6l25.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 32 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-25.3 0c-7.6 45.4-47.1 80-94.7 80s-87-34.6-94.7-80L296 432c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-32-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l25.3 0c5.1-30.5 24.7-56.1 51.4-69.6l-22.9-26.7c-8.6-10.1-7.5-25.2 2.6-33.8s25.2-7.5 33.8 2.6l29.8 34.8 29.8-34.8 1.7-1.8zm-256-192c8.8-8.4 22.7-8.9 32.2-.8s11 21.9 4.1 31.9l-1.5 1.9-23 26.7C230 55.9 249.5 81.5 254.7 112l25.3 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-24 0 0 32 24 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-25.3 0c-7.6 45.4-47.1 80-94.7 80s-87-34.6-94.7-80L40 240c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-32-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l25.3 0C70.5 81.5 90 55.9 116.7 42.4L93.8 15.6C85.2 5.6 86.3-9.6 96.4-18.2s25.2-7.5 33.8 2.6l29.8 34.8 29.8-34.8 1.7-1.8z"
    ]
};
var $159afdcd077ecfe9$export$b957c27bc5330472 = {
    prefix: 'fas',
    iconName: 'beer-mug-empty',
    icon: [
        576,
        512,
        [
            "beer"
        ],
        "f0fc",
        "M64 80c0-26.5 21.5-48 48-48l288 0c26.5 0 48 21.5 48 48l0 16 64 0c35.3 0 64 28.7 64 64l0 108.2c0 24.2-13.7 46.4-35.4 57.2L448 371.8 448 384c0 53-43 96-96 96l-192 0c-53 0-96-43-96-96L64 80zM448 300.2l64-32 0-108.2-64 0 0 140.2zM192 152c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208zm88 0c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 208c0 13.3 10.7 24 24 24s24-10.7 24-24l0-208z"
    ]
};
var $159afdcd077ecfe9$export$f74725691538983b = $159afdcd077ecfe9$export$b957c27bc5330472;
var $159afdcd077ecfe9$export$30294c81ac4031ca = {
    prefix: 'fas',
    iconName: 'person-circle-check',
    icon: [
        640,
        512,
        [],
        "e53e",
        "M280 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 212.7L341 286.6c12.8-17.5 28.5-32.7 46.3-45l-56.2-75.7C306 132 266.3 112 224 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L144 236.7 144 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-275.3zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-86.6-60.9c7.1 5.2 8.7 15.2 3.5 22.3l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5z"
    ]
};
var $159afdcd077ecfe9$export$c7e014b7e3ac3d83 = {
    prefix: 'fas',
    iconName: 'stapler',
    icon: [
        640,
        512,
        [],
        "e5af",
        "M640 299.3L640 432c0 26.5-21.5 48-48 48L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0 0-48-352 0c-17.7 0-32-14.3-32-32l0-116.6-30.2-5.4c-19.6-3.5-33.8-20.5-33.8-40.4 0-8.9 2.9-17.5 8.2-24.6l35.6-47.5c32.8-43.8 84.4-69.6 139.1-69.6 27 0 53.6 6.3 77.8 18.4L586.9 213.5C619.5 229.7 640 263 640 299.3zM448 304l0-16-320-57.1 0 73.1 320 0z"
    ]
};
var $159afdcd077ecfe9$export$5d08d08f88a96aac = {
    prefix: 'fas',
    iconName: 'house-medical-circle-check',
    icon: [
        640,
        512,
        [],
        "e511",
        "M309.8 8.6c-12.3-11.4-31.3-11.4-43.5 0l-224 208c-9.6 9-12.8 22.9-8 35.1S50.8 272 64 272l16 0 0 176c0 35.3 28.7 64 64 64l196 0c-21.2-29.5-34.3-65.3-35.9-104L272 408c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 20 0c34.9-48.5 91.7-80 156-80 10.7 0 21.1 .9 31.3 2.5L309.8 8.6zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-86.6-60.9c7.1 5.2 8.7 15.2 3.5 22.3l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5z"
    ]
};
var $159afdcd077ecfe9$export$58b7558ca9822358 = {
    prefix: 'fas',
    iconName: 'naira-sign',
    icon: [
        448,
        512,
        [],
        "e1f6",
        "M122.6 46.3c-7.8-11.7-22.4-17-35.9-12.9S64 49.9 64 64l0 192-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 89.5 0 107.8 161.8c7.8 11.7 22.4 17 35.9 12.9S384 462.1 384 448l0-144 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 192-57.5 0-139.8-209.7zM294.5 304l25.5 0 0 38.3-25.5-38.3zM185.5 256l-57.5 0 0-86.3 57.5 86.3z"
    ]
};
var $159afdcd077ecfe9$export$1642419fe3db2857 = {
    prefix: 'fas',
    iconName: 'wifi',
    icon: [
        576,
        512,
        [
            "wifi-3",
            "wifi-strong"
        ],
        "f1eb",
        "M288 96c-90.9 0-173.2 36-233.7 94.6-12.7 12.3-33 12-45.2-.7s-12-33 .7-45.2C81.7 74.9 179.9 32 288 32S494.3 74.9 566.3 144.7c12.7 12.3 13 32.6 .7 45.2s-32.6 13-45.2 .7C461.2 132 378.9 96 288 96zM240 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM168 326.2c-11.7 13.3-31.9 14.5-45.2 2.8s-14.5-31.9-2.8-45.2C161 237.4 221.1 208 288 208s127 29.4 168 75.8c11.7 13.3 10.4 33.5-2.8 45.2s-33.5 10.4-45.2-2.8C378.6 292.9 335.8 272 288 272s-90.6 20.9-120 54.2z"
    ]
};
var $159afdcd077ecfe9$export$2349bb04a04f4b2d = $159afdcd077ecfe9$export$1642419fe3db2857;
var $159afdcd077ecfe9$export$4b3167c852f4c4aa = $159afdcd077ecfe9$export$1642419fe3db2857;
var $159afdcd077ecfe9$export$eeb59dd1825c6a65 = {
    prefix: 'fas',
    iconName: 'money-check-dollar',
    icon: [
        512,
        512,
        [
            "money-check-alt"
        ],
        "f53d",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM296 288l128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm-24-88c0-13.3 10.7-24 24-24l128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-13.3 0-24-10.7-24-24zM148 144c11 0 20 9 20 20l0 4 8 0c11 0 20 9 20 20s-9 20-20 20l-47.5 0c-6.9 0-12.5 5.6-12.5 12.5 0 6.1 4.4 11.3 10.4 12.3l41.7 7c25.3 4.2 43.9 26.1 43.9 51.8 0 26.1-19 47.7-44 51.8l0 4.7c0 11-9 20-20 20s-20-9-20-20l0-4-24 0c-11 0-20-9-20-20s9-20 20-20l55.5 0c6.9 0 12.5-5.6 12.5-12.5 0-6.1-4.4-11.3-10.4-12.3l-41.7-7C94.5 268 76 246.1 76 220.5 76 191.7 99.2 168.3 128 168l0-4c0-11 9-20 20-20z"
    ]
};
var $159afdcd077ecfe9$export$8c6ccc9745897cb2 = $159afdcd077ecfe9$export$eeb59dd1825c6a65;
var $159afdcd077ecfe9$export$23a892b1a4b994bd = {
    prefix: 'fas',
    iconName: 'eye-low-vision',
    icon: [
        576,
        512,
        [
            "low-vision"
        ],
        "f2a8",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-96.4-96.4c2.7-2.4 5.4-4.8 8-7.2 46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1-47.1-43.7-111.8-80.6-192.6-80.6-56.8 0-105.6 18.2-146 44.2L41-24.9zM204.5 138.7c23.5-16.8 52.4-26.7 83.5-26.7 79.5 0 144 64.5 144 144 0 31.1-9.9 59.9-26.7 83.5l-34.7-34.7c12.7-21.4 17-47.7 10.1-73.7-13.7-51.2-66.4-81.6-117.6-67.9-8.6 2.3-16.7 5.7-24 10l-34.7-34.7zM88 157.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L328.2 466c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L88 157.9zM45.7 251.3c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L181.9 455.5c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L45.7 251.3z"
    ]
};
var $159afdcd077ecfe9$export$7a65d2aa54cb4e93 = $159afdcd077ecfe9$export$23a892b1a4b994bd;
var $159afdcd077ecfe9$export$a29c8ea43e92771d = {
    prefix: 'fas',
    iconName: 'circle-arrow-up',
    icon: [
        512,
        512,
        [
            "arrow-circle-up"
        ],
        "f0aa",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm17-377l80 80c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-39-39 0 150.1c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-150.1-39 39c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l80-80c9.4-9.4 24.6-9.4 33.9 0z"
    ]
};
var $159afdcd077ecfe9$export$a2f6f3baa50af0b1 = $159afdcd077ecfe9$export$a29c8ea43e92771d;
var $159afdcd077ecfe9$export$41dbdadc07a89b05 = {
    prefix: 'fas',
    iconName: 'camera-retro',
    icon: [
        512,
        512,
        [
            128247
        ],
        "f083",
        "M0 416l0-208 136.2 0c13.5-20.2 32-36.8 53.7-48L0 160 0 125.7c0-35.3 28.7-64 64-64l.1 0C65.3 45.1 79.1 32 96 32l32 0c16.9 0 30.7 13.1 31.9 29.7l32.1 0 51.2-23.8c8.4-3.9 17.6-6 26.9-6L448 32c35.3 0 64 28.7 64 64l0 64-190 0c21.7 11.2 40.2 27.8 53.7 48l136.2 0 0 208c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64zM256 192a96.1 96.1 0 1 0 0 192.1 96.1 96.1 0 1 0 0-192.1z"
    ]
};
var $159afdcd077ecfe9$export$ba6fd4a436804a48 = {
    prefix: 'fas',
    iconName: 'capsules',
    icon: [
        576,
        512,
        [],
        "f46b",
        "M96 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zm-64 0l0 288c0 61.9 50.1 112 112 112s112-50.1 112-112l0-105.8 116.3 169.5c35.5 51.7 105.3 64.3 156 28.1s63-107.5 27.5-159.2L427.3 145.3c-35.5-51.7-105.3-64.3-156-28.1-5.6 4-10.7 8.4-15.3 13.1l0-18.3C256 50.1 205.9 0 144 0S32 50.1 32 112zM296.6 240.2c-16-23.3-10-55.3 11.9-71 21.2-15.1 50.5-10.3 66 12.2l67 97.6-79.9 55.9-65-94.8z"
    ]
};
var $159afdcd077ecfe9$export$dd0ede1713d2d2f9 = {
    prefix: 'fas',
    iconName: 'poo',
    icon: [
        512,
        512,
        [
            128169
        ],
        "f2fe",
        "M268.9 .9c-5.5-.7-11 1.4-14.5 5.7s-4.6 10.1-2.8 15.4c2.8 8.2 4.3 16.9 4.3 26.1 0 44.1-35.7 79.9-79.8 80L160 128c-35.3 0-64 28.7-64 64 0 19.1 8.4 36.3 21.7 48L104 240c-39.8 0-72 32.2-72 72 0 23.2 11 43.8 28 57-34.1 5.7-60 35.3-60 71 0 39.8 32.2 72 72 72l368 0c39.8 0 72-32.2 72-72 0-35.7-25.9-65.3-60-71 17-13.2 28-33.8 28-57 0-39.8-32.2-72-72-72l-13.7 0c13.3-11.7 21.7-28.9 21.7-48 0-35.3-28.7-64-64-64l-5.5 0c3.5-10 5.5-20.8 5.5-32 0-48.6-36.2-88.8-83.1-95.1zM192 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm64 108.3c0 2.4-.7 4.8-2.2 6.7-8.2 10.5-39.5 45-93.8 45s-85.6-34.6-93.8-45c-1.5-1.9-2.2-4.3-2.2-6.7 0-6.8 5.5-12.3 12.3-12.3l167.4 0c6.8 0 12.3 5.5 12.3 12.3z"
    ]
};
var $159afdcd077ecfe9$export$c7a833ce065e0ea4 = {
    prefix: 'fas',
    iconName: 'elevator',
    icon: [
        512,
        512,
        [],
        "e16d",
        "M292.7-4.7l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S438.5-32 432-32L304-32c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4zm-160-22.6l-64 64c-4.6 4.6-5.9 11.5-3.5 17.4S73.5 64 80 64l128 0c6.5 0 12.3-3.9 14.8-9.9s1.1-12.9-3.5-17.4l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 128zm96 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 400c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm192 0c0-26.5 21.5-48 48-48l64 0c26.5 0 48 21.5 48 48l0 16c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-16zm32-128a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"
    ]
};
var $159afdcd077ecfe9$export$cb61f447f29887e = {
    prefix: 'fas',
    iconName: 'tag',
    icon: [
        512,
        512,
        [
            127991
        ],
        "f02b",
        "M32.5 96l0 149.5c0 17 6.7 33.3 18.7 45.3l192 192c25 25 65.5 25 90.5 0L483.2 333.3c25-25 25-65.5 0-90.5l-192-192C279.2 38.7 263 32 246 32L96.5 32c-35.3 0-64 28.7-64 64zm112 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$4b89fabf50a10951 = {
    prefix: 'fas',
    iconName: 'file-circle-minus',
    icon: [
        576,
        512,
        [],
        "e4ed",
        "M96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l180 0c-22.7-31.5-36-70.2-36-112 0-100.6 77.4-183.2 176-191.3l0-38.1c0-17-6.7-33.3-18.7-45.3L290.7 18.7C278.7 6.7 262.5 0 245.5 0L96 0zM357.5 176L264 176c-13.3 0-24-10.7-24-24L240 58.5 357.5 176zM576 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-64 0c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16z"
    ]
};
var $159afdcd077ecfe9$export$e88ba08d4f4d65b6 = {
    prefix: 'fas',
    iconName: 'down-long',
    icon: [
        320,
        512,
        [
            "long-arrow-alt-down"
        ],
        "f309",
        "M137.4 534.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9S300.9 352 288 352l-64 0 0-336c0-26.5-21.5-48-48-48l-32 0c-26.5 0-48 21.5-48 48l0 336-64 0c-12.9 0-24.6 7.8-29.6 19.8S.2 397.5 9.4 406.6l128 128z"
    ]
};
var $159afdcd077ecfe9$export$8b92530ca6418c2f = $159afdcd077ecfe9$export$e88ba08d4f4d65b6;
var $159afdcd077ecfe9$export$84021631df0f831b = {
    prefix: 'fas',
    iconName: 'compact-disc',
    icon: [
        512,
        512,
        [
            128191,
            128192,
            128440
        ],
        "f51f",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm256 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-96-32a96 96 0 1 0 192 0 96 96 0 1 0 -192 0zm-56-16c0-32.4 16.3-66.6 42.8-93.2S207.6 104 240 104c13.3 0 24-10.7 24-24s-10.7-24-24-24c-47.9 0-93.7 23.5-127.1 56.9S56 192.1 56 240c0 13.3 10.7 24 24 24s24-10.7 24-24z"
    ]
};
var $159afdcd077ecfe9$export$957e62a9b80ff4e3 = {
    prefix: 'fas',
    iconName: 'suitcase-rolling',
    icon: [
        384,
        512,
        [],
        "f5c1",
        "M144 24c0-4.4 3.6-8 8-8l80 0c4.4 0 8 3.6 8 8l0 72-96 0 0-72zM320 96l-32 0 0-72c0-30.9-25.1-56-56-56l-80 0C121.1-32 96-6.9 96 24l0 72-32 0C28.7 96 0 124.7 0 160L0 448c0 35.3 28.7 64 64 64 0 17.7 14.3 32 32 32s32-14.3 32-32l128 0c0 17.7 14.3 32 32 32s32-14.3 32-32c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64zM120 208l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 128l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$ad3212bc3fa1595b = {
    prefix: 'fas',
    iconName: 'book-quran',
    icon: [
        448,
        512,
        [
            "quran"
        ],
        "f687",
        "M64 512l288 0c53 0 96-43 96-96l0-320c0-53-43-96-96-96L48 0C21.5 0 0 21.5 0 48L0 336c0 20.9 13.4 38.7 32 45.3L32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0zM352 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0 0-64 256 0zM273.1 144.4c2.5-6.1 11.2-6.1 13.7 0l10.3 24.8 26.8 2.1c6.6 .5 9.2 8.7 4.2 13L307.8 201.9 314 228c1.5 6.4-5.5 11.5-11.1 8.1l-22.9-14-22.9 14c-5.6 3.4-12.6-1.6-11.1-8.1l6.2-26.1-20.4-17.5c-5-4.3-2.3-12.5 4.2-13l26.8-2.1 10.3-24.8zM100 192c0-68.5 55.5-124 124-124 23.8 0 46.1 6.7 65 18.4 4.8 2.9 6.9 8.8 5 14.1s-7.1 8.6-12.7 8c-3.1-.3-6.2-.5-9.4-.5-46.4 0-84 37.6-84 84s37.6 84 84 84c3.2 0 6.3-.2 9.4-.5 5.6-.6 10.8 2.7 12.7 8s-.3 11.2-5 14.1c-18.9 11.7-41.2 18.4-65 18.4-68.5 0-124-55.5-124-124z"
    ]
};
var $159afdcd077ecfe9$export$46f29ea84ed4c5f1 = $159afdcd077ecfe9$export$ad3212bc3fa1595b;
var $159afdcd077ecfe9$export$4c60a3aade08b6c2 = {
    prefix: 'fas',
    iconName: 'phone-slash',
    icon: [
        576,
        512,
        [],
        "f3dd",
        "M535-24.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L41 537.1c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L141.5 368.6C89.2 310.5 51.6 238.8 34.8 159.4 18.7 83.1 73.9 20.6 138.5 2.9l5.5-1.5c19.7-5.4 40.3 4.7 48.1 23.5l40.5 97.3c6.9 16.5 2.1 35.6-11.8 47l-44.1 36.1c12.9 28.5 29.6 54.8 49.5 78.5L535-24.9zm-150.4 534c-63-13.4-121.3-39.8-171.7-76.3L297.8 348c12.2 8.2 25 15.6 38.3 22.2L374.7 323c11.3-13.9 30.4-18.6 47-11.8L519 351.8c18.8 7.8 28.9 28.4 23.5 48.1l-1.5 5.5c-17.6 64.6-80.2 119.8-156.4 103.7z"
    ]
};
var $159afdcd077ecfe9$export$3f22db9ae9b6be1c = {
    prefix: 'fas',
    iconName: 'road-circle-check',
    icon: [
        640,
        512,
        [],
        "e564",
        "M288 32l-76.3 0c-29.4 0-55.1 20.1-62.1 48.6L65.4 420.5C57.9 450.7 80.8 480 112 480l209.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-28.6 6.2-55.7 17.4-80-.5 0-1 0-1.5 0-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 49c35.2-39.9 86.7-65 144-65 9 0 17.8 .6 26.5 1.8l-32-129.2C483.4 52.1 457.8 32 428.3 32l-76.4 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zM640 400a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zm-86.6-60.9c7.1 5.2 8.7 15.2 3.5 22.3l-64 88c-2.8 3.8-7 6.2-11.7 6.5s-9.3-1.3-12.6-4.6l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l26.8 26.8 53-72.9c5.2-7.1 15.2-8.7 22.4-3.5z"
    ]
};
var $159afdcd077ecfe9$export$452410c103c2403b = {
    prefix: 'fas',
    iconName: 'shop-lock',
    icon: [
        640,
        512,
        [],
        "e4a5",
        "M21.5 181.1L78.3 67.4C89.2 45.7 111.3 32 135.6 32l304.9 0c24.2 0 46.4 13.7 57.2 35.4l55.6 111.1c-8.2-1.6-16.6-2.5-25.2-2.5-53.7 0-99.7 33.1-118.7 80l-57.3 0 0 176c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-176.1c-26.8-1.9-48-24.3-48-51.6 0-8 1.9-16 5.5-23.2zM128 256l0 112c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-112-160 0zm432 48.1c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM416 400c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
var $159afdcd077ecfe9$export$c23fd8b91a7ed48 = {
    prefix: 'fas',
    iconName: 'image-portrait',
    icon: [
        384,
        512,
        [
            "portrait"
        ],
        "f3e0",
        "M0 64C0 28.7 28.7 0 64 0L320 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM80 368c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80l-64 0c-44.2 0-80 35.8-80 80zM192 248a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
    ]
};
var $159afdcd077ecfe9$export$e3d25f819c7ee7d7 = $159afdcd077ecfe9$export$c23fd8b91a7ed48;
var $159afdcd077ecfe9$export$cffe7d85a82d8116 = {
    prefix: 'fas',
    iconName: 'bridge-lock',
    icon: [
        576,
        512,
        [],
        "e4cc",
        "M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-8 0 0 32.2c13.8 .6 27.2 2.8 40 6.4l0 50.7c-14.8-6-31-9.3-48-9.3-70.7 0-128 57.3-128 128l0 24.4c-.4 .3-.7 .6-1.1 1-17.3-25-46.2-41.3-78.9-41.3-53 0-96 43-96 96l0 64c0 17.7-14.3 32-32 32l-32 0c-17.7 0-32-14.3-32-32l0-94c0-38.8-26.4-72.6-64-82l0-112 40 0 0-64-8 0C14.3 96 0 81.7 0 64zm424 68.6l0-36.6-80 0 0 64 18.8 0c18.2-12.8 38.9-22.2 61.2-27.4zM216 96l0 64 80 0 0-64-80 0zm-48 0l-80 0 0 64 80 0 0-64zM496 304.1c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0 0-47.9zM352 400c0-20.9 13.4-38.7 32-45.3l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96z"
    ]
};
var $159afdcd077ecfe9$export$6310f315e1ebbca5 = {
    prefix: 'fas',
    iconName: 'hammer',
    icon: [
        640,
        512,
        [
            128296
        ],
        "f6e3",
        "M246.9 18.3L271 3.8c21.6-13 46.3-19.8 71.5-19.8 36.8 0 72.2 14.6 98.2 40.7l63.9 63.9c15 15 23.4 35.4 23.4 56.6l0 30.9 19.7 19.7 0 0c15.6-15.6 40.9-15.6 56.6 0s15.6 40.9 0 56.6l-64 64c-15.6 15.6-40.9 15.6-56.6 0s-15.6-40.9 0-56.6L464 240 433.1 240c-21.2 0-41.6-8.4-56.6-23.4l-49.1-49.1c-15-15-23.4-35.4-23.4-56.6l0-12.7c0-11.2-5.9-21.7-15.5-27.4l-41.6-25c-10.4-6.2-10.4-21.2 0-27.4zM50.7 402.7l222.1-222.1 90.5 90.5-222.1 222.1c-25 25-65.5 25-90.5 0s-25-65.5 0-90.5z"
    ]
};
var $159afdcd077ecfe9$export$bbbff45e04f4abab = {
    prefix: 'fas',
    iconName: 'arrow-up-1-9',
    icon: [
        512,
        512,
        [
            "sort-numeric-up"
        ],
        "f163",
        "M150.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L96 141.3 96 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-306.7 41.4 41.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-96-96zM418.7 38c-8.3-6-19.1-7.7-28.8-4.4l-48 16c-16.8 5.6-25.8 23.7-20.2 40.5s23.7 25.8 40.5 20.2l5.9-2 0 51.6-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-96c0-10.3-4.9-19.9-13.3-26zM365.1 430.6c-9.6 14.8-5.4 34.6 9.4 44.3s34.6 5.4 44.3-9.4l42.1-64.9c12.4-19.2 19.1-41.6 19.1-64.5 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.1 23.9 66.7 56.8 76.6l-11.7 18zM376 336a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$d213a3ba3cabed48 = $159afdcd077ecfe9$export$bbbff45e04f4abab;
var $159afdcd077ecfe9$export$861b1f13085cf122 = {
    prefix: 'fas',
    iconName: 'chess-knight',
    icon: [
        384,
        512,
        [
            9822
        ],
        "f441",
        "M192-32c106 0 192 86 192 192l0 133.5c0 17-6.8 33.2-18.7 45.2L320 384 370.8 434.7c8.5 8.5 13.2 20 13.2 32 0 25-20.3 45.2-45.2 45.3L45.3 512c-25 0-45.2-20.3-45.2-45.3 0-12 4.8-23.5 13.2-32L64 384 64 349.4c0-18.7 8.2-36.4 22.3-48.6l89.7-76.8-48 0-12.1 12.1c-12.7 12.7-30 19.9-48 19.9-37.5 0-67.9-30.4-67.9-67.9l0-8.7c0-22.8 8.2-44.9 23.1-62.3L96 32 96 0c0-17.7 14.3-32 32-32l64 0zM160 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
    ]
};
var $159afdcd077ecfe9$export$30d3e64480aa266b = {
    prefix: 'fas',
    iconName: 'house-flood-water-circle-arrow-right',
    icon: [
        640,
        512,
        [],
        "e50f",
        "M288.5 112a144 144 0 1 0 -288 0 144 144 0 1 0 288 0zM141.2 44.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7-89.4 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l89.4 0-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6zM336.5 112c0 71.1-38.6 133.1-96 166.3l0 12.8c22.1 4.5 43.4 13.9 62.4 28.2 22.1 16.6 29.1 16.6 51.2 0 27.5-20.7 59.9-31.2 92.4-31.4 33.1-.2 66.3 10.2 94.4 31.4 6.9 5.2 12.8 9 18 11.7 .6 .3 1.2 .6 1.8 1 4.2 2.3 8.5 4.6 12.6 1.5 6-4.5 12.6-8 19.3-10.4l0-115.2 4.5 0c15.2 0 27.5-12.3 27.5-27.5 0-7.9-3.4-15.5-9.4-20.7L444.5 10.5C436.8 3.7 426.8 0 416.5 0s-20.3 3.7-28 10.5L329.9 61.8c4.3 16 6.6 32.8 6.6 50.2zm32 88c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-48zM475.1 412.1c19 14.4 41.9 28.2 67.2 33.3 26.5 5.4 54.3 .8 80.7-19.1 10.6-8 12.7-23 4.7-33.6s-23-12.7-33.6-4.7c-14.9 11.2-28.6 13.1-42.3 10.3-14.9-3-30.9-11.9-47.8-24.6-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3S290 391.8 266 373.7c-38.4-29-90.5-29-129 0-21.6 16.3-41.3 25.8-58.9 25.7-9.6-.1-19.9-3-31.2-11.5-10.6-8-25.6-5.9-33.6 4.7s-5.9 25.6 4.7 33.6c19.1 14.4 39.4 21 59.8 21.1 33.9 .2 64.3-17.4 88.1-35.3 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9c21.3-16.1 49.9-16.1 71.2 0zm-71.2 96c21.3-16.1 49.9-16.1 71.2 0 19 14.4 41.9 28.2 67.2 33.3 26.5 5.4 54.3 .8 80.7-19.1 10.6-8 12.7-23 4.7-33.6s-23-12.7-33.6-4.7c-14.9 11.2-28.6 13.1-42.3 10.3-14.9-3-30.9-11.9-47.8-24.6-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3S290 487.8 266 469.7c-38.4-29-90.5-29-129 0-21.6 16.3-41.3 25.8-58.9 25.7-9.6-.1-19.9-3-31.2-11.5-10.6-8-25.6-5.9-33.6 4.7s-5.9 25.6 4.7 33.6c19.1 14.4 39.4 21 59.8 21.1 33.9 .2 64.3-17.4 88.1-35.3 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9z"
    ]
};
var $159afdcd077ecfe9$export$5ad84e891223f2c3 = {
    prefix: 'fas',
    iconName: 'arrow-up-right-from-square',
    icon: [
        512,
        512,
        [
            "external-link"
        ],
        "f08e",
        "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0-201.4 201.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3 448 192c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 96C35.8 96 0 131.8 0 176L0 432c0 44.2 35.8 80 80 80l256 0c44.2 0 80-35.8 80-80l0-80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 80c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-256c0-8.8 7.2-16 16-16l80 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 96z"
    ]
};
var $159afdcd077ecfe9$export$f4c613289034e5ef = $159afdcd077ecfe9$export$5ad84e891223f2c3;
var $159afdcd077ecfe9$export$9fe0c42ede2dd003 = {
    prefix: 'fas',
    iconName: 'arrow-down-up-across-line',
    icon: [
        512,
        512,
        [],
        "e4af",
        "M265.4 105.4l96-96c12.5-12.5 32.8-12.5 45.3 0l96 96c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-41.4-41.4 0 114.7 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-320 0 0 114.7 41.4-41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 402.7 96 288 32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l320 0 0-114.7-41.4 41.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3zM416 336l0 144c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-144 64 0zM96 176L96 32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 144-64 0z"
    ]
};
var $159afdcd077ecfe9$export$3de52eeb00462407 = {
    prefix: 'fas',
    iconName: 'face-grin-beam',
    icon: [
        512,
        512,
        [
            128516,
            "grin-beam"
        ],
        "f582",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM386.7 308.9c11.9-3.7 23.9 6.3 19.6 18.1-22.4 61.3-81.3 105.1-150.3 105.1S128.1 388.2 105.7 326.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1zM176 180c-15.5 0-28 12.5-28 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28zm132 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28s-28 12.5-28 28z"
    ]
};
var $159afdcd077ecfe9$export$734da5249381ec7e = $159afdcd077ecfe9$export$3de52eeb00462407;
var $159afdcd077ecfe9$export$d0ccaddca9e06d1e = {
    prefix: 'fas',
    iconName: 'rectangle-ad',
    icon: [
        512,
        512,
        [
            "ad"
        ],
        "f641",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM416 184l0 144c0 13.3-10.7 24-24 24-7.1 0-13.5-3.1-17.9-8-10.2 5.1-21.8 8-34.1 8-42 0-76-34-76-76s34-76 76-76c9.9 0 19.3 1.9 28 5.3l0-21.3c0-13.3 10.7-24 24-24s24 10.7 24 24zm-48 92a28 28 0 1 0 -56 0 28 28 0 1 0 56 0zM160 208c-8.8 0-16 7.2-16 16l0 32 48 0 0-32c0-8.8-7.2-16-16-16l-16 0zm32 96l-48 0 0 24c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-35.3 28.7-64 64-64l16 0c35.3 0 64 28.7 64 64l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-24z"
    ]
};
var $159afdcd077ecfe9$export$7af266c3465b1ff2 = $159afdcd077ecfe9$export$d0ccaddca9e06d1e;
var $159afdcd077ecfe9$export$24c764717169f536 = {
    prefix: 'fas',
    iconName: 'book-tanakh',
    icon: [
        448,
        512,
        [
            "tanakh"
        ],
        "f827",
        "M352 512L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l0-66.7C13.4 374.7 0 356.9 0 336L0 48C0 21.5 21.5 0 48 0L352 0c53 0 96 43 96 96l0 320c0 53-43 96-96 96zm32-96c0-17.7-14.3-32-32-32l-256 0 0 64 256 0c17.7 0 32-14.3 32-32zM113.9 229c-1.2 2-1.9 4.2-1.9 6.6 0 6.9 5.6 12.5 12.5 12.5l56.9 0 30.5 49.2c2.6 4.2 7.2 6.8 12.2 6.8s9.6-2.6 12.2-6.8l30.5-49.2 56.9 0c6.9 0 12.5-5.6 12.5-12.5 0-2.3-.6-4.6-1.9-6.6l-27.8-45 27.8-45c1.2-2 1.9-4.2 1.9-6.6 0-6.9-5.6-12.5-12.5-12.5l-56.9 0-30.5-49.2C233.6 66.6 229 64 224 64s-9.6 2.6-12.2 6.8l-30.5 49.2-56.9 0c-6.9 0-12.5 5.6-12.5 12.5 0 2.3 .6 4.6 1.9 6.6l27.8 45-27.8 45z"
    ]
};
var $159afdcd077ecfe9$export$7fd4a58929315448 = $159afdcd077ecfe9$export$24c764717169f536;
var $159afdcd077ecfe9$export$6e6bd68568c17bbf = {
    prefix: 'fas',
    iconName: 'hot-tub-person',
    icon: [
        448,
        512,
        [
            "hot-tub"
        ],
        "f593",
        "M240 40c0 13.6 5.8 26.5 15.8 35.6l26.5 23.8c24 21.6 37.7 52.3 37.7 84.6 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-18.7-7.9-36.4-21.8-48.9l-26.5-23.8C203.5 93.1 192 67.2 192 40 192 26.7 202.7 16 216 16s24 10.7 24 24zM0 336l0-80c0-35.3 28.7-64 64-64l19.7 0c8.1 0 16.2 1.6 23.8 4.6l137.1 54.8c7.6 3 15.6 4.6 23.8 4.6L384 256c35.3 0 64 28.7 64 64l0 128c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 336zm96-16c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zm152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80zm104-24c-13.3 0-24 10.7-24 24l0 80c0 13.3 10.7 24 24 24s24-10.7 24-24l0-80c0-13.3-10.7-24-24-24zM328 16c13.3 0 24 10.7 24 24 0 13.6 5.8 26.5 15.8 35.6l26.5 23.8c24 21.6 37.7 52.3 37.7 84.6 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-18.7-7.9-36.4-21.8-48.9l-26.5-23.8C315.5 93.1 304 67.2 304 40 304 26.7 314.7 16 328 16zM64 40a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
    ]
};
var $159afdcd077ecfe9$export$4842af92b516c40b = $159afdcd077ecfe9$export$6e6bd68568c17bbf;
var $159afdcd077ecfe9$export$a8fabd50d8cb3ffd = {
    prefix: 'fas',
    iconName: 'file-half-dashed',
    icon: [
        384,
        512,
        [],
        "e698",
        "M64 0C28.7 0 0 28.7 0 64l0 256 384 0 0-149.5c0-17-6.7-33.3-18.7-45.3L258.7 18.7C246.7 6.7 230.5 0 213.5 0L64 0zM325.5 176L232 176c-13.3 0-24-10.7-24-24L208 58.5 325.5 176zM0 352l0 64 64 0 0-64-64 0zM64 512l0-64-64 0c0 35.3 28.7 64 64 64zm32 0l80 0 0-64-80 0 0 64zm112 0l80 0 0-64-80 0 0 64zm112 0c35.3 0 64-28.7 64-64l-64 0 0 64zm64-160l-64 0 0 64 64 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$e21cfc4f23776bff = {
    prefix: 'fas',
    iconName: 'outdent',
    icon: [
        448,
        512,
        [
            "dedent"
        ],
        "f03b",
        "M.4 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0C14.8 96 .4 81.7 .4 64zm192 128c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 96l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM.4 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32zM.7 268.6c-8.2-6.4-8.2-18.9 0-25.3l101.9-79.3c10.5-8.2 25.8-.7 25.8 12.6l0 158.6c0 13.3-15.3 20.8-25.8 12.6L.7 268.6z"
    ]
};
var $159afdcd077ecfe9$export$cbffb369d9299db7 = $159afdcd077ecfe9$export$e21cfc4f23776bff;
var $159afdcd077ecfe9$export$e49e3cfceea441cc = {
    prefix: 'fas',
    iconName: 'hand-peace',
    icon: [
        448,
        512,
        [
            9996
        ],
        "f25b",
        "M192 0c17.7 0 32 14.3 32 32l0 208-64 0 0-208c0-17.7 14.3-32 32-32zm96 160c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm64 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zM61.3 51.2L143.9 240 74.1 240 2.7 76.8C-4.4 60.6 3 41.8 19.2 34.7S54.2 35 61.3 51.2zm27 221.3l-.2-.5 95.9 0c22.1 0 40 17.9 40 40s-17.9 40-40 40l-56 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l56 0c39.8 0 72-32.2 72-72l0-.6c9.4 5.4 20.3 8.6 32 8.6 13.2 0 25.4-4 35.6-10.8 8.7 24.9 32.5 42.8 60.4 42.8 11.7 0 22.6-3.1 32-8.6l0 8.6c0 88.4-71.6 160-160 160l-61.7 0c-42.4 0-83.1-16.9-113.1-46.9L69.5 453.5C45.5 429.5 32 396.9 32 363l0-27c0-32.7 24.6-59.7 56.3-63.5z"
    ]
};
var $159afdcd077ecfe9$export$5b64b916710da7c7 = {
    prefix: 'fas',
    iconName: 'head-side-virus',
    icon: [
        512,
        512,
        [],
        "e064",
        "M329.7 448c-5.1 0-9.7 3.7-9.7 8.8l0 7.2c0 26.5-21.5 48-48 48l-160 0c-26.5 0-48-21.5-48-48l0-63.6c0-12.6-5.1-24.5-13.1-34.2-31.8-38.7-50.9-88.2-50.9-142.2 0-123.7 100.3-224 224-224 112.7 0 206 83.3 221.7 191.7 .4 3 1.7 5.9 3.6 8.3l35.8 42.9c7 8.4 10.9 19.1 10.9 30.1 0 25.9-21 47-47 47l-1 0c-8.8 0-16 7.2-16 16l0 48c0 35.3-28.7 64-64 64l-38.3 0zM224 64c-13.3 0-24 10.7-24 24 0 22.9-27.7 34.4-43.9 18.2-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c16.2 16.2 4.7 43.9-18.2 43.9-13.3 0-24 10.7-24 24s10.7 24 24 24c22.9 0 34.4 27.7 18.2 43.9-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c16.2-16.2 43.9-4.7 43.9 18.2 0 13.3 10.7 24 24 24s24-10.7 24-24c0-22.9 27.7-34.4 43.9-18.2 9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-16.2-16.2-4.7-43.9 18.2-43.9 13.3 0 24-10.7 24-24s-10.7-24-24-24c-22.9 0-34.4-27.7-18.2-43.9 9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-16.2 16.2-43.9 4.7-43.9-18.2 0-13.3-10.7-24-24-24zm-32 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm40 88a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$b4d344633433e50e = {
    prefix: 'fas',
    iconName: 'compass',
    icon: [
        512,
        512,
        [
            129517
        ],
        "f14e",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $159afdcd077ecfe9$export$a82594dcc75a49f5 = {
    prefix: 'fas',
    iconName: 'pen-nib',
    icon: [
        512,
        512,
        [
            10001
        ],
        "f5ad",
        "M368.5 18.3l-50.1 50.1 125.3 125.3 50.1-50.1c21.9-21.9 21.9-57.3 0-79.2L447.7 18.3c-21.9-21.9-57.3-21.9-79.2 0zM279.3 97.2l-.5 .1-144.1 43.2c-19.9 6-35.7 21.2-42.3 41L3.8 445.8c-2.9 8.7-1.9 18.2 2.5 26L161.7 316.4c-1.1-4-1.6-8.1-1.6-12.4 0-26.5 21.5-48 48-48s48 21.5 48 48-21.5 48-48 48c-4.3 0-8.5-.6-12.4-1.6L40.3 505.7c7.8 4.4 17.2 5.4 26 2.5l264.3-88.6c19.7-6.6 35-22.4 41-42.3l43.2-144.1 .1-.5-135.5-135.5z"
    ]
};
var $159afdcd077ecfe9$export$51adfe7c9ee4f428 = {
    prefix: 'fas',
    iconName: 'tent-arrows-down',
    icon: [
        512,
        512,
        [],
        "e581",
        "M185.5 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-102.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72zm248 72l72-72c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-102.1c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 102.1-31-31c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c9.4 9.4 24.6 9.4 33.9 0zM60.3 292.6L37.1 476c-2.4 19.1 12.5 36 31.7 36l154.5 0c17.7 0 32-14.3 32-32l0-117.4c0-5.9 4.7-10.6 10.6-10.6 4 0 7.7 2.3 9.5 5.9l68.2 136.5c5.4 10.8 16.5 17.7 28.6 17.7l71.9 0c19.3 0 34.2-16.9 31.7-36L452.7 292.7c-1.2-9.7-6.9-18.4-15.3-23.4L271.9 169.9c-10.2-6.1-22.9-6.1-33.1 .1L75.4 269.3c-8.3 5.1-13.9 13.7-15.1 23.3z"
    ]
};
var $159afdcd077ecfe9$export$dc9cc4280bee320d = {
    prefix: 'fas',
    iconName: 'forward-fast',
    icon: [
        512,
        512,
        [
            9197,
            "fast-forward"
        ],
        "f050",
        "M19.8 477.6c12 5 25.7 2.2 34.9-6.9L224 301.3 224 448c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9L448 301.3 448 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-384c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 146.7-169.4-169.4c-9.2-9.2-22.9-11.9-34.9-6.9S224 51.1 224 64L224 210.7 54.6 41.4c-9.2-9.2-22.9-11.9-34.9-6.9S0 51.1 0 64L0 448c0 12.9 7.8 24.6 19.8 29.6z"
    ]
};
var $159afdcd077ecfe9$export$61a8cdc53c2e078d = $159afdcd077ecfe9$export$dc9cc4280bee320d;
var $159afdcd077ecfe9$export$afa58590dfb6fca2 = {
    prefix: 'fas',
    iconName: 'crop',
    icon: [
        512,
        512,
        [],
        "f125",
        "M448 109.3l54.6-54.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L402.7 64 176 64 176 128 338.7 128 128 338.7 128 32c0-17.7-14.3-32-32-32S64 14.3 64 32l0 32-32 0C14.3 64 0 78.3 0 96s14.3 32 32 32l32 0 0 256c0 35.3 28.7 64 64 64l208 0 0-64-162.7 0 210.7-210.7 0 306.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-274.7z"
    ]
};
var $159afdcd077ecfe9$export$f1304dd34ea2afbd = {
    prefix: 'fas',
    iconName: 'whiskey-glass',
    icon: [
        448,
        512,
        [
            129347,
            "glass-whiskey"
        ],
        "f7a0",
        "M32 32C14.3 32 0 46.3 0 64L0 352c0 70.7 57.3 128 128 128l192 0c70.7 0 128-57.3 128-128l0-288c0-17.7-14.3-32-32-32L32 32zM64 256l0-160 320 0 0 160-320 0z"
    ]
};
var $159afdcd077ecfe9$export$fdec0f5f1a169419 = $159afdcd077ecfe9$export$f1304dd34ea2afbd;
var $159afdcd077ecfe9$export$90b4406457aae8cc = {
    prefix: 'fas',
    iconName: 'square',
    icon: [
        448,
        512,
        [
            9632,
            9723,
            9724,
            61590
        ],
        "f0c8",
        "M64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32z"
    ]
};
var $159afdcd077ecfe9$export$92292137ef3cf4c8 = {
    prefix: 'fas',
    iconName: 'face-grin',
    icon: [
        512,
        512,
        [
            128512,
            "grin"
        ],
        "f580",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM386.7 308.9c11.9-3.7 23.9 6.3 19.6 18.1-22.4 61.3-81.3 105.1-150.3 105.1S128.1 388.2 105.7 326.9c-4.3-11.8 7.7-21.8 19.6-18.1 39.2 12.2 83.7 19.1 130.7 19.1s91.5-6.9 130.7-19.1zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$37e1f10b6de76621 = $159afdcd077ecfe9$export$92292137ef3cf4c8;
var $159afdcd077ecfe9$export$70fde3f3fdaa6a6a = {
    prefix: 'fas',
    iconName: 'file-contract',
    icon: [
        384,
        512,
        [],
        "f56c",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM88 64C74.7 64 64 74.7 64 88s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm70.3 160c-11.3 0-21.9 5.1-28.9 13.9L69.3 409c-8.3 10.3-6.6 25.5 3.7 33.7s25.5 6.6 33.7-3.8l47.1-58.8 15.2 50.7c3 10.2 12.4 17.1 23 17.1l104 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-86.1 0-16.1-53.6c-4.7-15.7-19.1-26.4-35.5-26.4z"
    ]
};
var $159afdcd077ecfe9$export$887340269e6d6cac = {
    prefix: 'fas',
    iconName: 'angle-up',
    icon: [
        384,
        512,
        [
            8963
        ],
        "f106",
        "M169.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 205.3 54.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z"
    ]
};
var $159afdcd077ecfe9$export$b5023c446f10324 = {
    prefix: 'fas',
    iconName: 'face-smile',
    icon: [
        512,
        512,
        [
            128578,
            "smile"
        ],
        "f118",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM165.4 321.9c20.4 28 53.4 46.1 90.6 46.1s70.2-18.1 90.6-46.1c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5C356.3 390 309.2 416 256 416s-100.3-26-129.4-65.9c-7.8-10.7-5.4-25.7 5.3-33.5s25.7-5.4 33.5 5.3zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$c632b2334f0913bc = $159afdcd077ecfe9$export$b5023c446f10324;
var $159afdcd077ecfe9$export$523180e731928397 = {
    prefix: 'fas',
    iconName: 'person-dress-burst',
    icon: [
        640,
        512,
        [],
        "e544",
        "M208 40.1c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24zM8 144.1c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24zm92.5 141.4l33.9-33.9c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L66.6 251.6c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0zM66.6 2.7c-9.4 9.4-9.4 24.6 0 33.9l33.9 33.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L100.5 2.7C91.1-6.7 76-6.7 66.6 2.7zM352 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM246.2 384l25.8 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 32 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 25.8 0c10.9 0 18.6-10.7 15.2-21.1l-43-129 48.3 65.1c10.5 14.2 30.6 17.2 44.8 6.6s17.2-30.6 6.6-44.8l-70.5-95C434 132 394.3 112 352 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6l48.3-65.1-43 129c-3.5 10.4 4.3 21.1 15.2 21.1z"
    ]
};
var $159afdcd077ecfe9$export$89fa217ec5503ac9 = {
    prefix: 'fas',
    iconName: 'divide',
    icon: [
        448,
        512,
        [
            10135,
            247
        ],
        "f529",
        "M224 48a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM168 408a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z"
    ]
};
var $159afdcd077ecfe9$export$f54081bdbf6d4eb5 = {
    prefix: 'fas',
    iconName: 'code-fork',
    icon: [
        448,
        512,
        [],
        "e13b",
        "M80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-24c0 32.8-19.7 61-48 73.3l0 22.7c0 26.5 21.5 48 48 48l128 0c26.5 0 48-21.5 48-48l0-22.7c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3l0 22.7c0 61.9-50.1 112-112 112l-32 0 0 70.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3l0-70.7-32 0C98.1 288 48 237.9 48 176l0-22.7C19.7 141 0 112.8 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm208 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM248 432a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$9a3d31c75a465b9a = {
    prefix: 'fas',
    iconName: 'house-flag',
    icon: [
        640,
        512,
        [],
        "e50d",
        "M472 0c17.7 0 32 14.3 32 32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0 0 288c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM283.5 59.1l100.5 96.9 0 356-256 0c-35.3 0-64-28.7-64-64l0-144-19.9 0c-15.5 0-28.1-12.6-28.1-28.1 0-7.6 3.1-14.9 8.6-20.2L228.5 59.1C235.9 52 245.7 48 256 48s20.1 4 27.5 11.1zM232 256c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0z"
    ]
};
var $159afdcd077ecfe9$export$a411e7e26cb63d5e = {
    prefix: 'fas',
    iconName: 'building-columns',
    icon: [
        512,
        512,
        [
            "bank",
            "institution",
            "museum",
            "university"
        ],
        "f19c",
        "M271.9 20.2c-9.8-5.6-21.9-5.6-31.8 0l-224 128c-12.6 7.2-18.8 22-15.1 36S17.5 208 32 208l32 0 0 208 0 0-51.2 38.4C4.7 460.4 0 469.9 0 480 0 497.7 14.3 512 32 512l448 0c17.7 0 32-14.3 32-32 0-10.1-4.7-19.6-12.8-25.6l-51.2-38.4 0-208 32 0c14.5 0 27.2-9.8 30.9-23.8s-2.5-28.8-15.1-36l-224-128zM400 208l0 208-64 0 0-208 64 0zm-112 0l0 208-64 0 0-208 64 0zm-112 0l0 208-64 0 0-208 64 0zM256 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$6e379b829ea8b99 = $159afdcd077ecfe9$export$a411e7e26cb63d5e;
var $159afdcd077ecfe9$export$1dba320226a34c1f = $159afdcd077ecfe9$export$a411e7e26cb63d5e;
var $159afdcd077ecfe9$export$9b3953adff472ad2 = $159afdcd077ecfe9$export$a411e7e26cb63d5e;
var $159afdcd077ecfe9$export$f2e1460ebe1a8cb0 = $159afdcd077ecfe9$export$a411e7e26cb63d5e;
var $159afdcd077ecfe9$export$7cee7480f25f5289 = {
    prefix: 'fas',
    iconName: 'rug',
    icon: [
        576,
        512,
        [],
        "e569",
        "M24 64l56 0 0 384-56 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-40-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-32-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-32-8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 0-40-8 0C10.7 112 0 101.3 0 88S10.7 64 24 64zm104 0l320 0 0 384-320 0 0-384zM576 88c0 13.3-10.7 24-24 24l-8 0 0 40 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 32 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 32 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 40 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0 0-384 56 0c13.3 0 24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$e151fe5abf6db993 = {
    prefix: 'fas',
    iconName: 'code-merge',
    icon: [
        448,
        512,
        [],
        "f387",
        "M80 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32.4 97.2c28-12.4 47.6-40.5 47.6-73.2 0-44.2-35.8-80-80-80S0 35.8 0 80c0 32.8 19.7 61 48 73.3l0 205.3C19.7 371 0 399.2 0 432 0 476.2 35.8 512 80 512s80-35.8 80-80c0-32.8-19.7-61-48-73.3l0-86.6c26.7 20.1 60 32 96 32l86.7 0c12.3 28.3 40.5 48 73.3 48 44.2 0 80-35.8 80-80s-35.8-80-80-80c-32.8 0-61 19.7-73.3 48L208 240c-49.9 0-91-38.1-95.6-86.8zM80 408a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM344 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$197b9567e88a0b1d = {
    prefix: 'fas',
    iconName: 'house-tsunami',
    icon: [
        640,
        512,
        [],
        "e515",
        "M288 16C155.5 16 48 123.5 48 256S155.5 496 288 496c7.4 0 19.7-2.3 33.7-7.3 13.8-4.9 27.1-11.7 36.7-18.9 38.4-29 90.5-29 129 0 15.4 11.6 35.3 21.1 55 24.4 19.5 3.3 37 .4 51.1-10.2 10.6-8 25.6-5.9 33.6 4.7s5.9 25.6-4.7 33.6c-27.3 20.5-59.2 24-87.9 19.2-28.5-4.8-55.4-18-75.9-33.4-21.3-16.1-49.9-16.1-71.2 0-14.5 10.9-32.4 19.7-49.5 25.8-16.8 6-34.9 10.1-49.9 10.1l-.1 0C128.9 543.9 0 415 0 256 0 96.9 128.9-32 288-32 301.3-32 312-21.3 312-8s-10.7 24-24 24zm44.8 166.4l96-72c11.4-8.5 27.1-8.5 38.5 0l95.5 72c8 6 12.7 15.5 12.7 25.5l.3 121.5c-2.2 1.3-4.3 2.6-6.4 4.2-4.3 3.1-8.7 .8-13.2-1.5l-1.2-.6-.7-.3c-5.4-2.7-11.7-6.6-18.9-11.7-29.5-21.1-64.3-31.6-99.1-31.4-34.1 .2-68.1 10.7-97 31.4-7.8 5.6-13.8 9.3-19.3 11.2L320 208c0-10.1 4.7-19.6 12.8-25.6zm54.6 229.7c-14.5 10.9-32.4 19.7-49.5 25.8-16.8 6-34.9 10.1-49.9 10.1-106 0-192-86-192-192S182 64 288 64c13.3 0 24 10.7 24 24s-10.7 24-24 24c-79.5 0-144 64.5-144 144s64.5 144 144 144c7.4 0 19.7-2.3 33.7-7.3 13.8-4.9 27.1-11.7 36.7-18.9 38.4-29 90.5-29 129 0 15.4 11.6 35.3 21.1 55 24.4 19.5 3.3 37 .4 51.1-10.2 10.6-8 25.6-5.9 33.6 4.7s5.9 25.6-4.7 33.6c-27.3 20.5-59.2 24-87.9 19.2-28.5-4.8-55.4-18-75.9-33.4-21.3-16.1-49.9-16.1-71.2 0z"
    ]
};
var $159afdcd077ecfe9$export$6a1e4cdbb8ca10c5 = {
    prefix: 'fas',
    iconName: 'magnifying-glass-chart',
    icon: [
        512,
        512,
        [],
        "e522",
        "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zm-312 8l0 64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96l0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64l0 96c0 13.3 10.7 24 24 24s24-10.7 24-24l0-96c0-13.3-10.7-24-24-24s-24 10.7-24 24z"
    ]
};
var $159afdcd077ecfe9$export$9ff64ffae70e08c0 = {
    prefix: 'fas',
    iconName: 'umbrella',
    icon: [
        512,
        512,
        [],
        "f0e9",
        "M256-32c17.7 0 32 14.3 32 32l0 2c126.3 15.7 224 123.5 224 254 0 3.8-.1 7.5-.2 11.3-.3 6.9-5 12.8-11.7 14.7s-13.8-.7-17.6-6.5c-14.4-21.4-38.8-35.5-66.5-35.5-29.3 0-54.9 15.7-68.9 39.3-2.7 4.6-7.6 7.6-13 7.8s-10.5-2.2-13.7-6.5c-14.6-19.8-38-32.6-64.5-32.6s-49.9 12.8-64.5 32.6c-3.2 4.3-8.3 6.8-13.7 6.5s-10.2-3.2-13-7.8c-14-23.6-39.6-39.3-68.9-39.3-27.7 0-52.1 14.1-66.5 35.5-3.9 5.7-11 8.4-17.6 6.5S.5 274.2 .2 267.3C.1 263.5 0 259.8 0 256 0 125.5 97.7 17.7 224 2l0-2c0-17.7 14.3-32 32-32zm32 360l0 102.6c0 45-36.5 81.4-81.4 81.4-30.8 0-59-17.4-72.8-45l-2.3-4.7c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l2.3 4.7c3 5.9 9 9.6 15.6 9.6 9.6 0 17.4-7.8 17.4-17.4L224 328c0-17.7 14.3-32 32-32s32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$7ec15a32285f6c22 = {
    prefix: 'fas',
    iconName: 'hill-rockslide',
    icon: [
        576,
        512,
        [],
        "e508",
        "M252.4 103.8l27 48c2.8 5 8.2 8.2 13.9 8.2l53.3 0c5.8 0 11.1-3.1 13.9-8.2l27-48c2.7-4.9 2.7-10.8 0-15.7l-27-48c-2.8-5-8.2-8.2-13.9-8.2l-53.3 0c-5.8 0-11.1 3.1-13.9 8.2l-27 48c-2.7 4.9-2.7 10.8 0 15.7zM68.3 87C43.1 61.8 0 79.7 0 115.3L0 432c0 44.2 35.8 80 80 80l316.7 0c35.6 0 53.5-43.1 28.3-68.3L68.3 87zM504.2 403.6c4.9 2.7 10.8 2.7 15.7 0l48-27c5-2.8 8.2-8.2 8.2-13.9l0-53.3c0-5.8-3.1-11.1-8.2-13.9l-48-27c-4.9-2.7-10.8-2.7-15.7 0l-48 27c-5 2.8-8.2 8.2-8.2 13.9l0 53.3c0 5.8 3.1 11.1 8.2 13.9l48 27zM192 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$597826232327559b = {
    prefix: 'fas',
    iconName: 'user-secret',
    icon: [
        448,
        512,
        [
            128373
        ],
        "f21b",
        "M171-16c-36.4 0-57.8 58.3-68.3 112L72 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 32c0 17 3.3 33.2 9.3 48l-9.3 0 0 0-20.5 0c-15.2 0-27.5 12.3-27.5 27.5 0 3 .5 5.9 1.4 8.7l28.9 86.6C40.2 379.6 16 428.1 16 482.3 16 498.7 29.3 512 45.7 512l356.6 0c16.4 0 29.7-13.3 29.7-29.7 0-54.2-24.2-102.7-62.3-135.4l28.9-86.6c.9-2.8 1.4-5.7 1.4-8.7 0-15.2-12.3-27.5-27.5-27.5l-20.5 0 0 0-9.3 0c6-14.8 9.3-31 9.3-48l0-32 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-30.7 0c-10.4-53.7-31.9-112-68.3-112-9.6 0-19 3.9-27.5 8.2-8.2 4.1-18.4 7.8-25.5 7.8s-17.3-3.7-25.5-7.8C190-12.1 180.6-16 171-16zm93.7 484.4l-24.8-70.9 27.9-32.5c2.7-3.2 4.2-7.2 4.2-11.4 0-9.7-7.8-17.5-17.5-17.5l-61 0c-9.7 0-17.5 7.8-17.5 17.5 0 4.2 1.5 8.2 4.2 11.4l27.9 32.5-24.8 70.9-57-180.4 35.7 0c18.4 10.2 39.5 16 62 16s43.6-5.8 62-16l35.7 0-57 180.4zM224 256c-34.7 0-64.2-22.1-75.3-53 5.7 3.2 12.3 5 19.3 5l12.4 0c16.5 0 31.1-10.6 36.3-26.2 2.3-7 12.2-7 14.5 0 5.2 15.6 19.9 26.2 36.3 26.2l12.4 0c7 0 13.6-1.8 19.3-5-11.1 30.9-40.6 53-75.3 53z"
    ]
};
var $159afdcd077ecfe9$export$e1611f373a10a98c = {
    prefix: 'fas',
    iconName: 'pager',
    icon: [
        512,
        512,
        [
            128223
        ],
        "f815",
        "M0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zm64 32l0 64c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L96 128c-17.7 0-32 14.3-32 32zM88 320c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0z"
    ]
};
var $159afdcd077ecfe9$export$8da450d063b0eb37 = {
    prefix: 'fas',
    iconName: 'briefcase',
    icon: [
        512,
        512,
        [
            128188
        ],
        "f0b1",
        "M200 48l112 0c4.4 0 8 3.6 8 8l0 40-128 0 0-40c0-4.4 3.6-8 8-8zm-56 8l0 40-80 0C28.7 96 0 124.7 0 160l0 96 512 0 0-96c0-35.3-28.7-64-64-64l-80 0 0-40c0-30.9-25.1-56-56-56L200 0c-30.9 0-56 25.1-56 56zM512 304l-192 0 0 16c0 17.7-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32l0-16-192 0 0 112c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-112z"
    ]
};
var $159afdcd077ecfe9$export$b6c20c10ddbd9898 = {
    prefix: 'fas',
    iconName: 'trowel-bricks',
    icon: [
        512,
        512,
        [],
        "e58a",
        "M224 32c0-11.5-6.2-22.2-16.2-27.8s-22.3-5.5-32.2 .4l-160 96C5.9 106.3 0 116.8 0 128s5.9 21.7 15.5 27.4l160 96c9.9 5.9 22.2 6.1 32.2 .4S224 235.5 224 224l0-64 256 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-256 0 0-64zm96 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-160 0zM0 416l0 64c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32zm224-32c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-256 0z"
    ]
};
var $159afdcd077ecfe9$export$8d36a54dbf1e6bce = {
    prefix: 'fas',
    iconName: 'socks',
    icon: [
        512,
        512,
        [
            129510
        ],
        "f696",
        "M252.8 0L176 0c-26.5 0-48 21.5-48 48l0 16 112 0 0-16c0-17.5 4.7-33.9 12.8-48zM128 112l0 128c0 20.1-9.5 39.1-25.6 51.2l-64 48c-24.2 18.1-38.4 46.6-38.4 76.8 0 53 43 96 96 96 15.4 0 30.5-3.7 44-10.7-17.6-23.9-28-53.4-28-85.3 0-45.3 21.3-88 57.6-115.2l64-48c4-3 6.4-7.8 6.4-12.8l0-128-112 0zm160 0l0 128c0 20.1-9.5 39.1-25.6 51.2l-64 48c-24.2 18.1-38.4 46.6-38.4 76.8 0 53 43 96 96 96 20.8 0 41-6.7 57.6-19.2l115.2-86.4C461 382.2 480 344.3 480 304l0-192-192 0zM480 64l0-16c0-26.5-21.5-48-48-48L336 0c-26.5 0-48 21.5-48 48l0 16 192 0z"
    ]
};
var $159afdcd077ecfe9$export$6e625d2e7790c860 = {
    prefix: 'fas',
    iconName: 't',
    icon: [
        384,
        512,
        [
            116
        ],
        "54",
        "M32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l128 0 0 352c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 32z"
    ]
};
var $159afdcd077ecfe9$export$4a7bb4be15f35178 = {
    prefix: 'fas',
    iconName: 'microchip',
    icon: [
        512,
        512,
        [],
        "f2db",
        "M176 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40c-35.3 0-64 28.7-64 64l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 56-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0c0 35.3 28.7 64 64 64l0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40 56 0 0 40c0 13.3 10.7 24 24 24s24-10.7 24-24l0-40c35.3 0 64-28.7 64-64l40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-56 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0c0-35.3-28.7-64-64-64l0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 40-56 0 0-40zM160 128l192 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32l0-192c0-17.7 14.3-32 32-32zm16 48l0 160 160 0 0-160-160 0z"
    ]
};
var $159afdcd077ecfe9$export$fb6bd43f079f72e2 = {
    prefix: 'fas',
    iconName: 'truck-medical',
    icon: [
        576,
        512,
        [
            128657,
            "ambulance"
        ],
        "f0f9",
        "M64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l3.3 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l3.3 0c35.3 0 64-28.7 64-64l0-146.7c0-17-6.7-33.3-18.7-45.3L512 146.7c-12-12-28.3-18.7-45.3-18.7l-50.7 0 0-32c0-35.3-28.7-64-64-64L64 32zM512 237.3l0 50.7-96 0 0-96 50.7 0 45.3 45.3zM152 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm232 40a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM176 136c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 40 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-40 0 0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$f5c7042778b51765 = $159afdcd077ecfe9$export$fb6bd43f079f72e2;
var $159afdcd077ecfe9$export$8de8eb94230028a5 = {
    prefix: 'fas',
    iconName: 'om',
    icon: [
        576,
        512,
        [
            128329
        ],
        "f679",
        "M388.7 4.7c6.2-6.2 16.4-6.2 22.6 0l16 16c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6l16-16zM176 160c-10.8 0-20.8 3.6-28.8 9.6-14.1 10.6-34.2 7.8-44.8-6.4s-7.8-34.2 6.4-44.8c18.7-14.1 42-22.4 67.2-22.4 61.9 0 112 50.1 112 112 0 17.2-3.9 33.5-10.8 48l49.7 0c12.7 0 24.9-5 33.9-14.1l20.7-20.7c18.7-18.7 44.1-29.3 70.6-29.3 55.2 0 99.9 44.7 99.9 99.9l0 96.1c0 55.2-44.8 100-100 100S352 443.2 352 388l0-4c0-17.7 14.3-32 32-32s32 14.3 32 32l0 4c0 19.9 16.1 36 36 36s36-16.1 36-36l0-96.1c0-19.8-16.1-35.9-35.9-35.9-9.5 0-18.6 3.8-25.4 10.5l-20.7 20.7c-21 21-49.4 32.8-79.1 32.8l-26.8 0c12.6 19.6 19.9 42.8 19.9 68 0 75.2-65 132-140 132S40 463.2 40 388c0-17.7 14.3-32 32-32s32 14.3 32 32c0 35.3 31.7 68 76 68s76-32.7 76-68-31.7-68-76-68l-20 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l16 0c26.5 0 48-21.5 48-48s-21.5-48-48-48zM337.1 60.1c-11-13.8-31.1-16.2-45-5.2s-16.2 31.1-5.2 45C312.6 132.2 354.4 152 400 152s87.4-19.8 113.1-52.1c11-13.8 8.7-34-5.2-45s-34-8.7-45 5.2C450.3 76 427.5 88 400 88s-50.3-12-62.9-27.9z"
    ]
};
var $159afdcd077ecfe9$export$f3858ce1b3218e2 = {
    prefix: 'fas',
    iconName: 'mosquito-net',
    icon: [
        640,
        512,
        [],
        "e52c",
        "M576 352c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 48 16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0 0 16-.1 2.5C598.6 566.6 588.4 576 576 576s-22.6-9.4-23.9-21.5l-.1-2.5 0-16-48 0 0 16-.1 2.5C502.6 566.6 492.4 576 480 576s-22.6-9.4-23.9-21.5l-.1-2.5 0-16-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-48-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24s24 10.7 24 24l0 16 48 0 0-16c0-13.3 10.7-24 24-24zM429.9 16.3c7.7-9.4 21.3-11.5 31.4-4.3 10.1 7.1 13.1 20.9 7.4 31.7l-1.3 2.1-25.9 38.9 13.3 53.4c2 8-.1 16.3-5.3 22.3l-2.4 2.4-44.7 38.3 130.5 14.5c42.8 4.8 75.1 40.9 75.1 83.9 0 3.9-.4 7.7-.9 11.5-7.3-3.5-15.3-5.8-23.8-6.7L576 304c-18.5 0-35.3 7-48 18.4-11-9.9-25.1-16.5-40.6-18.1L480 304c-30.3 0-56.1 18.7-66.8 45.2-12.5 5-23.2 13.4-31.1 24l-30.2-40.1 0 74.7c0 17.7-14.3 32-32 32-16.6 0-30.2-12.6-31.8-28.7l-.2-3.3 0-74.6-32.3 43 0 39.8c0 3.5-.7 6.9-2.1 10.1l-1.6 3.1-40 64-1.4 2c-7.5 9.6-21 12.1-31.3 5.3-10.3-6.8-13.7-20.5-8.3-31.5l1.2-2.2 36.2-58 0-41 .3-4c.6-3.9 2.2-7.7 4.6-10.9l39.3-52.2-66.2 59.5c-17 15.3-39 23.7-61.9 23.8l-8.1 0c-46.6 0-84.4-37.8-84.4-84.4 0-43 32.4-79.2 75.1-83.9l130.5-14.5-44.7-38.3-2.4-2.4c-5.2-6-7.3-14.4-5.3-22.3l13.3-53.4-25.9-38.9-1.2-2.1c-5.7-10.8-2.7-24.6 7.4-31.7 10.1-7.1 23.7-5.1 31.4 4.3l1.5 2 32 48 1.4 2.2c2.8 5.3 3.5 11.6 2.1 17.6l-12.3 49.2 53.3 45.7 0-28.8 .2-3.2c1.1-10.4 7.2-19.4 15.8-24.4l0-60.5 .3-3.2c1.5-7.3 8-12.7 15.7-12.8 7.7 0 14.2 5.5 15.7 12.8l.3 3.2 0 60.5c8.7 5 14.8 14 15.8 24.4l.2 3.2 0 28.9 53.4-45.7-12.3-49.2c-1.5-5.9-.7-12.2 2.1-17.6l1.4-2.2 32-48 1.5-2zM504 488l48 0 0-48-48 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$214f9ce665590486 = {
    prefix: 'fas',
    iconName: 'prescription-bottle',
    icon: [
        384,
        512,
        [],
        "f485",
        "M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zM32 144l320 0 0 304c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-48 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-48 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$3a18218720110fc0 = {
    prefix: 'fas',
    iconName: 'users-gear',
    icon: [
        640,
        512,
        [
            "users-cog"
        ],
        "f509",
        "M320 224a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM96 232a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM0 416l0 32c0 17.7 14.3 32 32 32l86.7 0c-4.3-9.8-6.7-20.6-6.7-32l0-16c0-53.2 20-101.8 52.9-138.6-11.7-3.5-24.1-5.4-36.9-5.4-70.7 0-128 57.3-128 128zM616 160a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zM160 432l0 16c0 17.7 14.3 32 32 32l156.8 0c-7.1-21.6-6.3-44.4 10.7-64-14-16.2-20.5-39.7-11.4-63.3 6.6-17.1 15.9-33.1 27.4-47.3 5.4-6.6 11.6-11.7 18.3-15.4-22.1-11.5-47.2-18-73.8-18-88.4 0-160 71.6-160 160zm464.6-44.1c6.3-3.6 9.5-11.1 6.8-18-4.8-12.4-11.5-24.1-19.9-34.4-4.6-5.7-12.7-6.7-19-3-21.8 12.6-48.6-2.8-48.6-28.1 0-7.3-4.9-13.8-12.1-14.9-12.9-2-26.8-2-39.7 0-7.2 1.1-12.1 7.6-12.1 14.9 0 25.2-26.8 40.7-48.6 28.1-6.3-3.6-14.4-2.6-19 3-8.4 10.3-15.1 22-19.9 34.4-2.6 6.8 .5 14.3 6.8 17.9 21.9 12.6 21.9 43.5 0 56.2-6.3 3.6-9.5 11.1-6.8 17.9 4.8 12.4 11.5 24.1 19.9 34.4 4.6 5.7 12.7 6.7 19 3 21.8-12.6 48.6 2.9 48.6 28.1 0 7.3 4.9 13.8 12.1 14.9 12.9 2 26.8 2 39.7 0 7.2-1.1 12.1-7.6 12.1-14.9 0-25.2 26.8-40.7 48.6-28.1 6.3 3.6 14.4 2.6 19-3 8.4-10.3 15.1-22 19.9-34.4 2.6-6.8-.5-14.3-6.8-17.9-21.9-12.6-21.9-43.5 0-56.2zM472 416a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"
    ]
};
var $159afdcd077ecfe9$export$5e0b06753fc69b81 = $159afdcd077ecfe9$export$3a18218720110fc0;
var $159afdcd077ecfe9$export$79753c2153535b01 = {
    prefix: 'fas',
    iconName: 'road-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e565",
        "M288 32l-76.3 0c-29.4 0-55.1 20.1-62.1 48.6L65.4 420.5C57.9 450.7 80.8 480 112 480l209.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-28.6 6.2-55.7 17.4-80-.5 0-1 0-1.5 0-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 49c35.2-39.9 86.7-65 144-65 9 0 17.8 .6 26.5 1.8l-32-129.2C483.4 52.1 457.8 32 428.3 32l-76.4 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-100a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm0-140c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$da79f048408b1722 = {
    prefix: 'fas',
    iconName: 'pause',
    icon: [
        384,
        512,
        [
            9208
        ],
        "f04c",
        "M48 32C21.5 32 0 53.5 0 80L0 432c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 32zm224 0c-26.5 0-48 21.5-48 48l0 352c0 26.5 21.5 48 48 48l64 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48l-64 0z"
    ]
};
var $159afdcd077ecfe9$export$76d998742bc186eb = {
    prefix: 'fas',
    iconName: 'staff-snake',
    icon: [
        448,
        512,
        [
            "rod-asclepius",
            "rod-snake",
            "staff-aesculapius"
        ],
        "e579",
        "M192 32l0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 64 0c53 0 96 43 96 96s-43 96-96 96l-16 0 0-64 16 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0 0 192 32 0c53 0 96 43 96 96 0 47.6-34.6 87.1-80 94.7l0-67c9.6-5.5 16-15.9 16-27.7 0-17.7-14.3-32-32-32l-32 0 0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-32 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l32 0 0-64-32 0c-53 0-96-43-96-96 0-47.6 34.6-87.1 80-94.7l0 67c-9.6 5.5-16 15.9-16 27.7 0 17.7 14.3 32 32 32l32 0 0-192-72.6 0c-11.1 19.1-31.7 32-55.4 32l-16 0C21.5 128 0 106.5 0 80S21.5 32 48 32l144 0z"
    ]
};
var $159afdcd077ecfe9$export$f2c3e92ee37a8d89 = $159afdcd077ecfe9$export$76d998742bc186eb;
var $159afdcd077ecfe9$export$5d61dcb598296af0 = $159afdcd077ecfe9$export$76d998742bc186eb;
var $159afdcd077ecfe9$export$97c8a2cdba3b7700 = $159afdcd077ecfe9$export$76d998742bc186eb;
var $159afdcd077ecfe9$export$46d49a6734c4872a = {
    prefix: 'fas',
    iconName: 'piggy-bank',
    icon: [
        576,
        512,
        [],
        "f4d3",
        "M288-32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM48 304c0-70.1 47-131.4 117.1-164.9 25.3 41.3 70.9 68.9 122.9 68.9 55.7 0 104.1-31.7 128-78 15.8-11.3 35.1-18 56-18l19.5 0c10.4 0 18 9.8 15.5 19.9l-17.1 68.3c9.9 12.4 18.2 25.7 24.4 39.8l21.7 0c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24l-40 0c-16.5 22-38.5 39.6-64 50.7l0 29.3c0 17.7-14.3 32-32 32l-33 0c-14.3 0-26.8-9.5-30.8-23.2l-7.1-24.8-82.3 0-7.1 24.8C235.8 502.5 223.3 512 209 512l-33 0c-17.7 0-32-14.3-32-32l0-29.3C87.5 426 48 369.6 48 304zm376 16a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
    ]
};
var $159afdcd077ecfe9$export$6f9b0bfc012deb25 = {
    prefix: 'fas',
    iconName: 'monument',
    icon: [
        384,
        512,
        [],
        "f5a6",
        "M209-33c-9.4-9.4-24.6-9.4-33.9 0L95 47c-4.1 4.1-6.5 9.4-7 15.1L58.4 448 48 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-10.4 0-29.7-385.8c-.4-5.7-2.9-11.1-7-15.1L209-33zM128 296c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$48b60f1720e09944 = {
    prefix: 'fas',
    iconName: 'angles-right',
    icon: [
        448,
        512,
        [
            187,
            "angle-double-right"
        ],
        "f101",
        "M439.1 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L371.2 256 233.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L179.2 256 41.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z"
    ]
};
var $159afdcd077ecfe9$export$792931403404faf0 = $159afdcd077ecfe9$export$48b60f1720e09944;
var $159afdcd077ecfe9$export$6e6ddc253102e596 = {
    prefix: 'fas',
    iconName: 'desktop',
    icon: [
        512,
        512,
        [
            128421,
            61704,
            "desktop-alt"
        ],
        "f390",
        "M64 32C28.7 32 0 60.7 0 96L0 352c0 35.3 28.7 64 64 64l144 0-16 48-72 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0-16-48 144 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 32zM96 96l320 0c17.7 0 32 14.3 32 32l0 160c0 17.7-14.3 32-32 32L96 320c-17.7 0-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$ff09a62b9e0fa899 = $159afdcd077ecfe9$export$6e6ddc253102e596;
var $159afdcd077ecfe9$export$94ef668f5108e431 = {
    prefix: 'fas',
    iconName: 'plane-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e557",
        "M232 24c0-30.9 25.1-56 56-56s56 25.1 56 56l0 127.3 78 71.5c-69.3 29-118 97.4-118 177.2 0 49.3 18.6 94.3 49.1 128.3L288 512 179.9 539c-10.1 2.5-19.9-5.1-19.9-15.5l0-19.8c0-4.9 2.2-9.5 6-12.5l66-52.8 0-99.7-162.9 54.3C58.7 396.4 48 388.7 48 377.8l0-43.7c0-9 3.8-17.5 10.4-23.6L232 151.3 232 24zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm59.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-36.7 36.7-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-36.7-36.7 36.7-36.7z"
    ]
};
var $159afdcd077ecfe9$export$cebc76f79478e40e = {
    prefix: 'fas',
    iconName: 'retweet',
    icon: [
        576,
        512,
        [],
        "f079",
        "M118.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9S19.1 160 32 160l32 0 0 224c0 53 43 96 96 96l128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-128 0c-17.7 0-32-14.3-32-32l0-224 32 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM457.4 470.6c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9S556.9 352 544 352l-32 0 0-224c0-53-43-96-96-96L288 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32 14.3 32 32l0 224-32 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64z"
    ]
};
var $159afdcd077ecfe9$export$f504a6909b677146 = {
    prefix: 'fas',
    iconName: 'user-gear',
    icon: [
        640,
        512,
        [
            "user-cog"
        ],
        "f4fe",
        "M256.5 8a120 120 0 1 1 0 240 120 120 0 1 1 0-240zM226.7 304l59.4 0 1.5 0c-12.9 26.8-7.8 58.2 11.5 79.5-20.2 22.3-24.8 55.8-9.4 83.4l22.5 40.4c.9 1.6 1.9 3.2 2.9 4.7l-237 0c-16.4 0-29.7-13.3-29.7-29.7 0-98.5 79.8-178.3 178.3-178.3zm205.9-56.4c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 6.1c0 18.9 24.1 32.8 40.5 23.4l5-2.9c11.6-6.7 26.5-2.6 33 9.1l22.4 40.2c6.2 11.2 2.6 25.2-8.2 32l-4.7 2.9c-16.2 10.1-16.2 39.9 0 50.1l4.6 2.9c10.8 6.8 14.5 20.8 8.3 32L607 483.8c-6.5 11.7-21.4 15.9-33 9.1l-4.9-2.9c-16.4-9.5-40.5 4.5-40.5 23.4l0 6.1c0 13.3-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24l0-5.9c0-19-24.2-33-40.7-23.5l-4.8 2.8c-11.6 6.7-26.4 2.6-33-9.1l-22.6-40.4c-6.2-11.2-2.6-25.3 8.3-32.1l4.4-2.7c16.3-10.1 16.3-40.1 0-50.2l-4.5-2.8c-10.9-6.8-14.5-20.9-8.3-32.1l22.5-40.3c6.5-11.7 21.4-15.8 32.9-9.1l4.8 2.8c16.5 9.5 40.7-4.5 40.7-23.5l0-5.9zm99.9 136.2a52 52 0 1 0 -104 0 52 52 0 1 0 104 0z"
    ]
};
var $159afdcd077ecfe9$export$474108c2b86e730e = $159afdcd077ecfe9$export$f504a6909b677146;
var $159afdcd077ecfe9$export$93a5eb721c9c0d25 = {
    prefix: 'fas',
    iconName: 'border-all',
    icon: [
        448,
        512,
        [],
        "f84c",
        "M384 96l0 128-128 0 0-128 128 0zm0 192l0 128-128 0 0-128 128 0zM192 224l-128 0 0-128 128 0 0 128zM64 288l128 0 0 128-128 0 0-128zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z"
    ]
};
var $159afdcd077ecfe9$export$bc5da164799a0e = {
    prefix: 'fas',
    iconName: 'coins',
    icon: [
        512,
        512,
        [],
        "f51e",
        "M128 96l0-16c0-44.2 86-80 192-80S512 35.8 512 80l0 16c0 30.6-41.3 57.2-102 70.7-2.4-2.8-4.9-5.5-7.4-8-15.5-15.3-35.5-26.9-56.4-35.5-41.9-17.5-96.5-27.1-154.2-27.1-21.9 0-43.3 1.4-63.8 4.1-.2-1.3-.2-2.7-.2-4.1zM432 353l0-46.2c15.1-3.9 29.3-8.5 42.2-13.9 13.2-5.5 26.1-12.2 37.8-20.3l0 15.4c0 26.8-31.5 50.5-80 65zm0-96l0-33c0-4.5-.4-8.8-1-13 15.5-3.9 30-8.6 43.2-14.2s26.1-12.2 37.8-20.3l0 15.4c0 26.8-31.5 50.5-80 65zM0 240l0-16c0-44.2 86-80 192-80s192 35.8 192 80l0 16c0 44.2-86 80-192 80S0 284.2 0 240zm384 96c0 44.2-86 80-192 80S0 380.2 0 336l0-15.4c11.6 8.1 24.5 14.7 37.8 20.3 41.9 17.5 96.5 27.1 154.2 27.1s112.3-9.7 154.2-27.1c13.2-5.5 26.1-12.2 37.8-20.3l0 15.4zm0 80.6l0 15.4c0 44.2-86 80-192 80S0 476.2 0 432l0-15.4c11.6 8.1 24.5 14.7 37.8 20.3 41.9 17.5 96.5 27.1 154.2 27.1s112.3-9.7 154.2-27.1c13.2-5.5 26.1-12.2 37.8-20.3z"
    ]
};
var $159afdcd077ecfe9$export$aa05fce255a5d269 = {
    prefix: 'fas',
    iconName: 'mars-stroke',
    icon: [
        576,
        512,
        [
            9894
        ],
        "f229",
        "M416-32c-17.7 0-32 14.3-32 32s14.3 32 32 32l50.7 0-58.7 58.7-17.4-17.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l17.4 17.4-23 23c-28.4-19.5-62.7-31-99.8-31-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176c0-37-11.4-71.4-31-99.8l23-23 17.4 17.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L453.3 136 512 77.3 512 128c0 17.7 14.3 32 32 32s32-14.3 32-32L576 0c0-17.7-14.3-32-32-32L416-32zM128 304a112 112 0 1 1 224 0 112 112 0 1 1 -224 0z"
    ]
};
var $159afdcd077ecfe9$export$503f458ca5cf64c2 = {
    prefix: 'fas',
    iconName: 'handshake-angle',
    icon: [
        576,
        512,
        [
            "hands-helping"
        ],
        "f4c4",
        "M268.9 53.2L152.3 182.8c-4.6 5.1-4.4 13 .5 17.9 30.5 30.5 80 30.5 110.5 0l31.8-31.8c4.2-4.2 9.5-6.5 14.9-6.9 6.8-.6 13.8 1.7 19 6.9L505.6 344 576 288 576 0 464 64 440.2 48.1C424.4 37.6 405.9 32 386.9 32l-70.4 0c-1.1 0-2.3 0-3.4 .1-16.9 .9-32.8 8.5-44.2 21.1zM116.6 150.7L223.4 32 183.8 32c-25.5 0-49.9 10.1-67.9 28.1L0 192 0 544 144 408 156.4 418.3c23 19.2 52 29.7 81.9 29.7l15.7 0-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l41 41 9 0c19.1 0 37.8-4.3 54.8-12.3L359 409c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l32 32 17.5-17.5c8.9-8.9 11.5-21.8 7.6-33.1l-137.9-136.8-14.9 14.9c-49.3 49.3-129.1 49.3-178.4 0-23-23-23.9-59.9-2.2-84z"
    ]
};
var $159afdcd077ecfe9$export$287dbb1632da0d44 = $159afdcd077ecfe9$export$503f458ca5cf64c2;
var $159afdcd077ecfe9$export$9686eff8d817f770 = {
    prefix: 'fas',
    iconName: 'arrow-down',
    icon: [
        384,
        512,
        [
            8595
        ],
        "f063",
        "M169.4 502.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 402.7 224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 370.7-105.4-105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"
    ]
};
var $159afdcd077ecfe9$export$90a475e93ff4bb8a = {
    prefix: 'fas',
    iconName: 'location-dot',
    icon: [
        384,
        512,
        [
            "map-marker-alt"
        ],
        "f3c5",
        "M0 188.6C0 84.4 86 0 192 0S384 84.4 384 188.6c0 119.3-120.2 262.3-170.4 316.8-11.8 12.8-31.5 12.8-43.3 0-50.2-54.5-170.4-197.5-170.4-316.8zM192 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
    ]
};
var $159afdcd077ecfe9$export$4be92fa780613f93 = $159afdcd077ecfe9$export$90a475e93ff4bb8a;
var $159afdcd077ecfe9$export$d893dd9509763a17 = {
    prefix: 'fas',
    iconName: 'plug-circle-exclamation',
    icon: [
        640,
        512,
        [],
        "e55d",
        "M192-32c17.7 0 32 14.3 32 32l0 96 128 0 0-96c0-17.7 14.3-32 32-32s32 14.3 32 32l0 96 64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l0 48.7c-98.6 8.1-176 90.7-176 191.3 0 27.3 5.7 53.3 16 76.9l0 3.1c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-66.7C165.2 398.1 96 319.1 96 224l0-64c-17.7 0-32-14.3-32-32S78.3 96 96 96l64 0 0-96c0-17.7 14.3-32 32-32zM496 256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 228a20 20 0 1 0 0-40 20 20 0 1 0 0 40zm0-180c-8.8 0-16 7.2-16 16l0 80c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80c0-8.8-7.2-16-16-16z"
    ]
};
var $159afdcd077ecfe9$export$317dde8664f7de71 = {
    prefix: 'fas',
    iconName: 'cookie-bite',
    icon: [
        512,
        512,
        [],
        "f564",
        "M257.5 27.6c-.8-5.4-4.9-9.8-10.3-10.6-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9-.9-5.3-5.3-9.3-10.6-10.1-51.5-8.2-92.8-47.1-104.5-97.4-1.8-7.6-8-13.4-15.7-14.6-54.6-8.7-97.7-52-106.2-106.8zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$158a12f36bbecf9 = {
    prefix: 'fas',
    iconName: 'screwdriver-wrench',
    icon: [
        576,
        512,
        [
            "tools"
        ],
        "f7d9",
        "M70.8-6.7c5.4-5.4 13.8-6.2 20.2-2L209.9 70.5c8.9 5.9 14.2 15.9 14.2 26.6l0 49.6 90.8 90.8c33.3-15 73.9-8.9 101.2 18.5L542.2 382.1c18.7 18.7 18.7 49.1 0 67.9l-60.1 60.1c-18.7 18.7-49.1 18.7-67.9 0L288.1 384c-27.4-27.4-33.5-67.9-18.5-101.2l-90.8-90.8-49.6 0c-10.7 0-20.7-5.3-26.6-14.2L23.4 58.9c-4.2-6.3-3.4-14.8 2-20.2L70.8-6.7zm145 303.5c-6.3 36.9 2.3 75.9 26.2 107.2l-94.9 95c-28.1 28.1-73.7 28.1-101.8 0s-28.1-73.7 0-101.8l135.4-135.5 35.2 35.1zM384.1 0c20.1 0 39.4 3.7 57.1 10.5 10 3.8 11.8 16.5 4.3 24.1L388.8 91.3c-3 3-4.7 7.1-4.7 11.3l0 41.4c0 8.8 7.2 16 16 16l41.4 0c4.2 0 8.3-1.7 11.3-4.7l56.7-56.7c7.6-7.5 20.3-5.7 24.1 4.3 6.8 17.7 10.5 37 10.5 57.1 0 43.2-17.2 82.3-45 111.1l-49.1-49.1c-33.1-33-78.5-45.7-121.1-38.4l-56.8-56.8 0-29.7-.2-5c-.8-12.4-4.4-24.3-10.5-34.9 29.4-35 73.4-57.2 122.7-57.3z"
    ]
};
var $159afdcd077ecfe9$export$646e4e7a8c6172aa = $159afdcd077ecfe9$export$158a12f36bbecf9;
var $159afdcd077ecfe9$export$318208bc30aeebcc = {
    prefix: 'fas',
    iconName: 'indent',
    icon: [
        448,
        512,
        [],
        "f03c",
        "M0 64C0 46.3 14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 96l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 480c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3L0 176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
    ]
};
var $159afdcd077ecfe9$export$36e9cf7887265da2 = {
    prefix: 'fas',
    iconName: 'bars',
    icon: [
        448,
        512,
        [
            "navicon"
        ],
        "f0c9",
        "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"
    ]
};
var $159afdcd077ecfe9$export$409fa7bcaa0e4cd9 = $159afdcd077ecfe9$export$36e9cf7887265da2;
var $159afdcd077ecfe9$export$a96374faedb12593 = {
    prefix: 'fas',
    iconName: 'hands-praying',
    icon: [
        640,
        512,
        [
            "praying-hands"
        ],
        "f684",
        "M224 296c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112.6 88.2-119.7c13.1-17.8 9.3-42.8-8.5-55.9s-42.8-9.3-55.9 8.5L106.5 142.9C89.3 166.2 80 194.5 80 223.6l0 110.7-58.1 19.4C8.8 358 0 370.2 0 384l0 96c0 10 4.7 19.5 12.7 25.5s18.4 8 28.1 5.2l154.4-44.1c55-15.7 92.8-65.9 92.8-123.1L288 224c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 72zm192 0l0-72c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 119.6c0 57.2 37.9 107.4 92.8 123.1l154.4 44.1c9.7 2.8 20 .8 28.1-5.2S640 490 640 480l0-96c0-13.8-8.8-26-21.9-30.4l-58.1-19.4 0-110.7c0-29-9.3-57.3-26.5-80.7L440.2 16.3C427.1-1.5 402.1-5.3 384.3 7.8s-21.6 38.1-8.5 55.9L464 183.4 464 296c0 13.3-10.7 24-24 24s-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$95e08e91b0929943 = $159afdcd077ecfe9$export$a96374faedb12593;
var $159afdcd077ecfe9$export$ee194b18f5c6f6b6 = {
    prefix: 'fas',
    iconName: 'viruses',
    icon: [
        640,
        512,
        [],
        "e076",
        "M192 0c17.7 0 32 14.3 32 32 0 30.5 36.9 45.8 58.5 24.2 12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-21.6 21.6-6.3 58.5 24.2 58.5 17.7 0 32 14.3 32 32s-14.3 32-32 32c-30.5 0-45.8 36.9-24.2 58.5 12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0c-21.6-21.6-58.5-6.3-58.5 24.2 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-30.5-36.9-45.8-58.5-24.2-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3C77.8 260.9 62.5 224 32 224 14.3 224 0 209.7 0 192s14.3-32 32-32c30.5 0 45.8-36.9 24.2-58.5-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0C123.1 77.8 160 62.5 160 32 160 14.3 174.3 0 192 0zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm248 40c0 22.9 27.7 34.4 43.9 18.2 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-16.2 16.2-4.7 43.9 18.2 43.9 13.3 0 24 10.7 24 24s-10.7 24-24 24c-22.9 0-34.4 27.7-18.2 43.9 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-16.2-16.2-43.9-4.7-43.9 18.2 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-22.9-27.7-34.4-43.9-18.2-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c16.2-16.2 4.7-43.9-18.2-43.9-13.3 0-24-10.7-24-24s10.7-24 24-24c22.9 0 34.4-27.7 18.2-43.9-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c16.2 16.2 43.9 4.7 43.9-18.2 0-13.3 10.7-24 24-24s24 10.7 24 24zM504 384a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$9b263780a7312c8c = {
    prefix: 'fas',
    iconName: 'school-flag',
    icon: [
        576,
        512,
        [],
        "e56e",
        "M256-8c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-72 0 0 19.2 128 76.8 64 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 128-76.8 0-91.2zM240 384l0 80 96 0 0-80c0-26.5-21.5-48-48-48s-48 21.5-48 48zM112 416c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm16-144l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zM496 416c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm16-144l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm-224 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $159afdcd077ecfe9$export$9c9b2fbddd59047d = {
    prefix: 'fas',
    iconName: 'trademark',
    icon: [
        640,
        512,
        [
            8482
        ],
        "f25c",
        "M346.6 110.2c-7.8-11.7-22.4-17-35.9-12.9S288 113.9 288 128l0 256c0 17.7 14.3 32 32 32s32-14.3 32-32l0-150.3 69.4 104.1c5.9 8.9 15.9 14.2 26.6 14.2s20.7-5.3 26.6-14.2L544 233.7 544 384c0 17.7 14.3 32 32 32s32-14.3 32-32l0-256c0-14.1-9.2-26.5-22.7-30.6s-28.1 1.1-35.9 12.9L448 262.3 346.6 110.2zM32 96C14.3 96 0 110.3 0 128s14.3 32 32 32l64 0 0 224c0 17.7 14.3 32 32 32s32-14.3 32-32l0-224 64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 96z"
    ]
};
var $159afdcd077ecfe9$export$e4e44f7b1886fef = {
    prefix: 'fas',
    iconName: 'fire-burner',
    icon: [
        512,
        512,
        [],
        "e4f1",
        "M281.7 48.3L294 34.5c5.4-6.1 13.3-8.8 20.9-8.9 7.2 0 14.3 2.6 19.9 7.8 19.7 18.3 39.8 43.2 55 70.6 15.1 27.2 26.2 58.1 26.2 88.1 0 88.7-71.3 159.8-160 159.8-89.6 0-160-71.3-160-159.8 0-37.3 16-73.4 36.8-104.5 20.9-31.3 47.5-59 70.9-80.2 5.7-5.2 13.1-7.7 20.3-7.5s13.4 3.2 18.8 7.5c14.4 11.4 38.9 40.7 38.9 40.7zM320 240.2c0-36.5-37-73-54.8-88.4-5.4-4.7-13.1-4.7-18.5 0-17.7 15.4-54.8 51.9-54.8 88.4 0 35.3 28.7 64 64 64s64-28.7 64-64zM92.8 320c37.7 48.3 96.1 80 163.2 80 66.5 0 125.1-31.7 163-80l45 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48l44.8 0zM456 400a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"
    ]
};
var $159afdcd077ecfe9$export$e3c56ed54f074063 = {
    prefix: 'fas',
    iconName: 'face-smile-beam',
    icon: [
        512,
        512,
        [
            128522,
            "smile-beam"
        ],
        "f5b8",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM165.4 321.9c20.4 28 53.4 46.1 90.6 46.1s70.2-18.1 90.6-46.1c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5C356.3 390 309.2 416 256 416s-100.3-26-129.4-65.9c-7.8-10.7-5.4-25.7 5.3-33.5s25.7-5.4 33.5 5.3zM176 180c-15.5 0-28 12.5-28 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28zm132 28l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-37.6 30.4-68 68-68s68 30.4 68 68l0 8c0 11-9 20-20 20s-20-9-20-20l0-8c0-15.5-12.5-28-28-28s-28 12.5-28 28z"
    ]
};
var $159afdcd077ecfe9$export$54ada6dc9690e0ca = $159afdcd077ecfe9$export$e3c56ed54f074063;
var $159afdcd077ecfe9$export$fa95eb7418c0e2b8 = {
    prefix: 'fas',
    iconName: 'tent-arrow-left-right',
    icon: [
        512,
        512,
        [],
        "e57f",
        "M-.5 113c-9.4-9.4-9.4-24.6 0-33.9l72-72c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-31 31 310.1 0 54.1 0-31-31c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l72 72c9.4 9.4 9.4 24.6 0 33.9l-72 72c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l31-31-102.1 0-.1 0-262 0 31 31c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72zM37.1 476L60.3 292.6c1.2-9.7 6.8-18.3 15.1-23.3L238.8 170c10.2-6.2 22.9-6.2 33.1-.1l165.5 99.4c8.4 5 14 13.7 15.3 23.4L475.9 476c2.4 19.1-12.5 36-31.7 36l-71.9 0c-12.1 0-23.2-6.8-28.6-17.7L275.4 357.9c-1.8-3.6-5.5-5.9-9.5-5.9-5.9 0-10.6 4.7-10.6 10.6l0 117.4c0 17.7-14.3 32-32 32L68.8 512c-19.3 0-34.2-16.9-31.7-36z"
    ]
};
var $159afdcd077ecfe9$export$806c0a45a7ecd6e8 = {
    prefix: 'fas',
    iconName: 'route',
    icon: [
        512,
        512,
        [],
        "f4d7",
        "M512 96c0 50.2-59.1 125.1-84.6 155-3.8 4.4-9.4 6.1-14.5 5L320 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96 43 96 96s-43 96-96 96l-276.4 0c8.7-9.9 19.3-22.6 30-36.8 6.3-8.4 12.8-17.6 19-27.2L416 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-53 0-96-43-96-96s43-96 96-96l39.8 0c-21-31.5-39.8-67.7-39.8-96 0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8-25.2-27.4-85-97.9-85-148.4 0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$152ef92a4f9d80a7 = {
    prefix: 'fas',
    iconName: 'angles-up',
    icon: [
        384,
        512,
        [
            "angle-double-up"
        ],
        "f102",
        "M214.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 109.3 329.4 246.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-160-160zm160 352l-160-160c-12.5-12.5-32.8-12.5-45.3 0l-160 160c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 329.4 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3z"
    ]
};
var $159afdcd077ecfe9$export$9bb51e1a2c07db7c = $159afdcd077ecfe9$export$152ef92a4f9d80a7;
var $159afdcd077ecfe9$export$2124c7628e573b84 = {
    prefix: 'fas',
    iconName: 'bucket',
    icon: [
        448,
        512,
        [],
        "e4cf",
        "M443.7 208c2.7 4.7 4.3 10.2 4.3 16 0 17.7-14.3 32-32 32l-5.1 0-22.4 213c-2.6 24.4-23.2 43-47.8 43l-233.6 0c-24.6 0-45.2-18.5-47.8-43L37.1 256 32 256c-17.7 0-32-14.3-32-32 0-5.8 1.6-11.3 4.3-16l439.4 0zM224-16c79.5 0 144 64.5 144 144l0 32-48 0 0-32c0-53-43-96-96-96s-96 43-96 96l0 32-48 0 0-32C80 48.5 144.5-16 224-16z"
    ]
};
var $159afdcd077ecfe9$export$b2c723344cff0d8 = {
    prefix: 'fas',
    iconName: 'less-than-equal',
    icon: [
        448,
        512,
        [],
        "f537",
        "M426.1 94.4c16.8-5.6 25.8-23.7 20.2-40.5s-23.7-25.8-40.5-20.2l-384 128C8.8 166 0 178.2 0 192s8.8 26 21.9 30.4l384 128c16.8 5.6 34.9-3.5 40.5-20.2s-3.5-34.9-20.2-40.5L133.2 192 426.1 94.4zM32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416z"
    ]
};
var $159afdcd077ecfe9$export$5e30548b7f8eeb95 = {
    prefix: 'fas',
    iconName: 'folder-closed',
    icon: [
        512,
        512,
        [],
        "e185",
        "M448 448L64 448c-35.3 0-64-28.7-64-64l0-176 512 0 0 176c0 35.3-28.7 64-64 64zm64-288L0 160 0 96C0 60.7 28.7 32 64 32l138.7 0c13.8 0 27.3 4.5 38.4 12.8l38.4 28.8c5.5 4.2 12.3 6.4 19.2 6.4L448 80c35.3 0 64 28.7 64 64l0 16z"
    ]
};
var $159afdcd077ecfe9$export$a77a2f6da72f89e3 = {
    prefix: 'fas',
    iconName: 'person-through-window',
    icon: [
        640,
        512,
        [],
        "e5a9",
        "M64 64l224 0 0 9.8c0 39-23.7 74-59.9 88.4-60.5 24.2-100.1 82.7-100.1 147.9l0 73.8-64 0 0-320zm288 0l224 0 0 320-67.7 0-3.7-4.5-75.2-90.2c-9.1-10.9-22.6-17.3-36.9-17.3l-71.1 0-41-63.1c-.3-.5-.6-1-1-1.4 44.7-29 72.5-79 72.5-133.6l0-9.8zm73 320l-26.6 0 42.7 64 150.9 0c26.5 0 48-21.5 48-48l0-352c0-26.5-21.5-48-48-48L48 0C21.5 0 0 21.5 0 48L0 400c0 26.5 21.5 48 48 48l260.2 0 33.2 49.8c9.8 14.7 29.7 18.7 44.4 8.9s18.7-29.7 8.9-44.4l-84.2-126.2 74.6 0 40 48zm-159.5 0l-73.5 0 0-73.8c0-10.2 1.6-20.1 4.7-29.5L265.5 384zM192 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $159afdcd077ecfe9$export$8845cce2a763ee07 = {
    prefix: 'fas',
    iconName: 'school-lock',
    icon: [
        640,
        512,
        [],
        "e56f",
        "M0 192c0-35.3 28.7-64 64-64l64 0 127.9-115.1c18.3-16.4 46-16.4 64.2 0L448 128 512 128c33 0 60.2 25 63.6 57.2-14.7-5.9-30.8-9.2-47.6-9.2-70.7 0-128 57.3-128 128l0 24.4c-19.6 17.6-32 43.1-32 71.5l0 96c0 5.5 .5 10.9 1.3 16.1L64 512c-35.3 0-64-28.7-64-64L0 192zM332.3 341.5c-6-3.5-12.9-5.5-20.3-5.5l-48 0c-22.1 0-40 17.9-40 40l0 88 96 0 0-64.1c0-20.8 4.4-40.5 12.3-58.4zM112 384c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0zm16-144l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16zm224-48a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM560 352l0-47.9c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 47.9 64 0zm-112 2.7l0-50.6c0-44.2 35.8-80 80-80s80 35.8 80 80l0 50.6c18.6 6.6 32 24.4 32 45.3l0 96c0 26.5-21.5 48-48 48l-128 0c-26.5 0-48-21.5-48-48l0-96c0-20.9 13.4-38.7 32-45.3z"
    ]
};
var $159afdcd077ecfe9$export$ae02241644924482 = {
    prefix: 'fas',
    iconName: 'person-burst',
    icon: [
        640,
        512,
        [],
        "e53b",
        "M204 40.1c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 48c0 13.3-10.7 24-24 24zM4 144.1c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zM96.5 285.5c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l33.9-33.9c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L96.5 285.5zM62.6 2.7c9.4-9.4 24.6-9.4 33.9 0l33.9 33.9c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L62.6 36.6c-9.4-9.4-9.4-24.6 0-33.9zM352.4-32a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM478.7 299.1l-46.3-62.4 0 275.3c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-275.3-46.3 62.4c-10.5 14.2-30.6 17.2-44.8 6.6s-17.2-30.6-6.6-44.8l70.5-95c25.2-33.9 65-53.9 107.2-53.9s82 20 107.2 53.9l70.5 95c10.5 14.2 7.6 34.2-6.6 44.8s-34.2 7.6-44.8-6.6z"
    ]
};
var $159afdcd077ecfe9$export$1db7e2ee10d36035 = {
    prefix: 'fas',
    iconName: 'left-long',
    icon: [
        576,
        512,
        [
            "long-arrow-alt-left"
        ],
        "f30a",
        "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c9.2-9.2 22.9-11.9 34.9-6.9S192 115.1 192 128l0 64 336 0c26.5 0 48 21.5 48 48l0 32c0 26.5-21.5 48-48 48l-336 0 0 64c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-128-128z"
    ]
};
var $159afdcd077ecfe9$export$a8b3226b2bf323d = $159afdcd077ecfe9$export$1db7e2ee10d36035;
var $159afdcd077ecfe9$export$14e1096ad1719098 = {
    prefix: 'fas',
    iconName: 'location-crosshairs',
    icon: [
        576,
        512,
        [
            "location"
        ],
        "f601",
        "M288-16c17.7 0 32 14.3 32 32l0 18.3c98.1 14 175.7 91.6 189.7 189.7l18.3 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-18.3 0c-14 98.1-91.6 175.7-189.7 189.7l0 18.3c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-18.3C157.9 463.7 80.3 386.1 66.3 288L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l18.3 0C80.3 125.9 157.9 48.3 256 34.3L256 16c0-17.7 14.3-32 32-32zM128 256a160 160 0 1 0 320 0 160 160 0 1 0 -320 0zm160-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $159afdcd077ecfe9$export$45e012c32174eb5d = $159afdcd077ecfe9$export$14e1096ad1719098;
var $159afdcd077ecfe9$export$cdcec8ca7ec0d381 = {
    prefix: 'fas',
    iconName: 'person-dots-from-line',
    icon: [
        512,
        512,
        [
            "diagnoses"
        ],
        "f470",
        "M184 72a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM160 299.3c-19.9 22.6-32 52.2-32 84.7l0 32-64 0 0-32c0-106 86-192 192-192s192 86 192 192l0 32-64 0 0-32c0-32.5-12.1-62.1-32-84.7l0 116.7-192 0 0-116.7zM232 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM24 464l464 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L24 512c-13.3 0-24-10.7-24-24s10.7-24 24-24zM64 184a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm424 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
    ]
};
var $159afdcd077ecfe9$export$68bad2b52a90d1fa = $159afdcd077ecfe9$export$cdcec8ca7ec0d381;
var $159afdcd077ecfe9$export$cc4351eb13da27d8 = {
    prefix: 'fas',
    iconName: 'gauge-simple-high',
    icon: [
        512,
        512,
        [
            61668,
            "tachometer",
            "tachometer-fast"
        ],
        "f62a",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-16.2-6-31.1-16-42.3l69.5-138.9c5.9-11.9 1.1-26.3-10.7-32.2s-26.3-1.1-32.2 10.7L261.1 288.2c-1.7-.1-3.4-.2-5.1-.2-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64z"
    ]
};
var $159afdcd077ecfe9$export$362d0f652c3fbca2 = $159afdcd077ecfe9$export$cc4351eb13da27d8;
var $159afdcd077ecfe9$export$375b6a8680f980ed = $159afdcd077ecfe9$export$cc4351eb13da27d8;
var $159afdcd077ecfe9$export$2ebd565813951f81 = {
    prefix: 'fas',
    iconName: 'angles-left',
    icon: [
        448,
        512,
        [
            171,
            "angle-double-left"
        ],
        "f100",
        "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L269.3 256 406.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"
    ]
};
var $159afdcd077ecfe9$export$21b0833b3cf929a7 = $159afdcd077ecfe9$export$2ebd565813951f81;
var $159afdcd077ecfe9$export$e36c32dd5cba9b90 = {
    prefix: 'fas',
    iconName: 'up-down',
    icon: [
        512,
        512,
        [
            8597,
            11021,
            "arrows-alt-v"
        ],
        "f338",
        "M406.6 502.6l96-96c9.2-9.2 11.9-22.9 6.9-34.9S492.9 352 480 352l-64 0 0-320c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 320-64 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l96 96c12.5 12.5 32.8 12.5 45.3 0zM150.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-96 96c-9.2 9.2-11.9 22.9-6.9 34.9S19.1 160 32 160l64 0 0 320c0 17.7 14.3 32 32 32s32-14.3 32-32l0-320 64 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-96-96z"
    ]
};
var $159afdcd077ecfe9$export$138cb56a3f8f7040 = $159afdcd077ecfe9$export$e36c32dd5cba9b90;
var $159afdcd077ecfe9$export$1344b64f6e922e12 = {
    prefix: 'fas',
    iconName: 'battery-empty',
    icon: [
        640,
        512,
        [
            "battery-0"
        ],
        "f244",
        "M112 160c-8.8 0-16 7.2-16 16l0 224c0 8.8 7.2 16 16 16l416 0c8.8 0 16-7.2 16-16l0-224c0-8.8-7.2-16-16-16l-416 0zM32 176c0-44.2 35.8-80 80-80l416 0c44.2 0 80 35.8 80 80l0 48c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 48c0 44.2-35.8 80-80 80l-416 0c-44.2 0-80-35.8-80-80l0-224z"
    ]
};
var $159afdcd077ecfe9$export$de8d0338927394c1 = $159afdcd077ecfe9$export$1344b64f6e922e12;
var $159afdcd077ecfe9$export$fb61df5d98785fa8 = {
    prefix: 'fas',
    iconName: 'keyboard',
    icon: [
        576,
        512,
        [
            9000
        ],
        "f11c",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm16 64l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM64 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM176 128l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM160 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l224 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm16 80l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"
    ]
};
var $159afdcd077ecfe9$export$b3e64f5f68c6623f = {
    prefix: 'fas',
    iconName: 'cookie',
    icon: [
        512,
        512,
        [
            127850
        ],
        "f563",
        "M247.2 17c-22.1-3.1-44.6 .9-64.4 11.4l-74 39.5C89.1 78.4 73.2 94.9 63.4 115L26.7 190.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9l-14.6-82.8c-3.9-22.1-14.6-42.3-30.7-57.9L388.9 57.5c-16.1-15.6-36.6-25.6-58.7-28.7L247.2 17zM208 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM144 336a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm224-64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$b85a7300fc7960b6 = {
    prefix: 'fas',
    iconName: 'stopwatch',
    icon: [
        448,
        512,
        [
            9201
        ],
        "f2f2",
        "M168.5 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 25.3c-108 11.9-192 103.5-192 214.7 0 119.3 96.7 216 216 216s216-96.7 216-216c0-39.8-10.8-77.1-29.6-109.2l28.2-28.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-23.4 23.4c-32.9-30.2-75.2-50.3-122-55.5l0-25.3 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0zm80 184l0 104c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-104c0-13.3 10.7-24 24-24s24 10.7 24 24z"
    ]
};
var $159afdcd077ecfe9$export$8484041d5b209494 = {
    prefix: 'fas',
    iconName: 'eject',
    icon: [
        448,
        512,
        [
            9167
        ],
        "f052",
        "M224 32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 320 400 320L48 320c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192C197.7 37.6 210.5 32 224 32zM0 432c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48s-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48z"
    ]
};
var $159afdcd077ecfe9$export$219ccae0e4da3c92 = {
    prefix: 'fas',
    iconName: 'satellite-dish',
    icon: [
        512,
        512,
        [
            128225
        ],
        "f7c0",
        "M232 0c154.6 0 280 125.4 280 280 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-128.1-103.9-232-232-232-13.3 0-24-10.7-24-24S218.7 0 232 0zM208 120c0-13.3 10.7-24 24-24 101.6 0 184 82.4 184 184 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-75.1-60.9-136-136-136-13.3 0-24-10.7-24-24zM26.4 142.7c8.8-17.9 32.4-19.9 46.5-5.8l128.5 128.5 32-32c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-32 32 128.5 128.5c14.1 14.1 12 37.6-5.8 46.5-34.2 16.9-72.6 26.4-113.3 26.4-141.4 0-256-114.6-256-256 0-40.7 9.5-79.2 26.4-113.3z"
    ]
};
var $159afdcd077ecfe9$export$a6d72a9a068392b5 = {
    prefix: 'fas',
    iconName: 'face-rolling-eyes',
    icon: [
        512,
        512,
        [
            128580,
            "meh-rolling-eyes"
        ],
        "f5a5",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 352l128 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-128 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm32-128c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-26 15.5-48.4 37.8-58.4-3.7 5.2-5.8 11.6-5.8 18.4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4 22.3 10 37.8 32.4 37.8 58.4zm128 64c-35.3 0-64-28.7-64-64 0-26 15.5-48.4 37.8-58.4-3.7 5.2-5.8 11.6-5.8 18.4 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.9-2.2-13.2-5.8-18.4 22.3 10 37.8 32.4 37.8 58.4 0 35.3-28.7 64-64 64z"
    ]
};
var $159afdcd077ecfe9$export$fdc62a1bea767cc2 = $159afdcd077ecfe9$export$a6d72a9a068392b5;
var $159afdcd077ecfe9$export$350a84fd0f833f4d = {
    prefix: 'fas',
    iconName: 'list-check',
    icon: [
        512,
        512,
        [
            "tasks"
        ],
        "f0ae",
        "M133.8 36.3c10.9 7.6 13.5 22.6 5.9 33.4l-56 80c-4.1 5.8-10.5 9.5-17.6 10.1S52 158 47 153L7 113C-2.3 103.6-2.3 88.4 7 79S31.6 69.7 41 79l19.8 19.8 39.6-56.6c7.6-10.9 22.6-13.5 33.4-5.9zm0 160c10.9 7.6 13.5 22.6 5.9 33.4l-56 80c-4.1 5.8-10.5 9.5-17.6 10.1S52 318 47 313L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l19.8 19.8 39.6-56.6c7.6-10.9 22.6-13.5 33.4-5.9zM224 96c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32l224 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32l288 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32zM64 376a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"
    ]
};
var $159afdcd077ecfe9$export$2f6d5b2fec286d63 = $159afdcd077ecfe9$export$350a84fd0f833f4d;
var $159afdcd077ecfe9$export$2bad98c38bea5994 = {
    prefix: 'fas',
    iconName: 'sack-xmark',
    icon: [
        512,
        512,
        [],
        "e56a",
        "M328 112l-144 0-37.3-74.5c-1.8-3.6-2.7-7.6-2.7-11.6 0-14.3 11.6-25.9 25.9-25.9L342.1 0c14.3 0 25.9 11.6 25.9 25.9 0 4-.9 8-2.7 11.6L328 112zM169.6 160l172.8 0 48.7 40.6C457.6 256 496 338 496 424.5 496 472.8 456.8 512 408.5 512l-305.1 0C55.2 512 16 472.8 16 424.5 16 338 54.4 256 120.9 200.6L169.6 160zM323.9 284.1c-9.4-9.4-24.6-9.4-33.9 0l-33.9 33.9-33.9-33.9c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l33.9 33.9-33.9 33.9c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l33.9-33.9 33.9 33.9c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-33.9-33.9 33.9-33.9c9.4-9.4 9.4-24.6 0-33.9z"
    ]
};
var $159afdcd077ecfe9$export$c92c903bade56844 = {
    prefix: 'fas',
    iconName: 'hashtag',
    icon: [
        512,
        512,
        [
            62098
        ],
        "23",
        "M214.7 .7c17.3 3.7 28.3 20.7 24.6 38l-19.1 89.3 126.5 0 22-102.7C372.4 8 389.4-3 406.7 .7s28.3 20.7 24.6 38L412.2 128 480 128c17.7 0 32 14.3 32 32s-14.3 32-32 32l-81.6 0-27.4 128 67.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-81.6 0-22 102.7c-3.7 17.3-20.7 28.3-38 24.6s-28.3-20.7-24.6-38l19.1-89.3-126.5 0-22 102.7c-3.7 17.3-20.7 28.3-38 24.6s-28.3-20.7-24.6-38L99.8 384 32 384c-17.7 0-32-14.3-32-32s14.3-32 32-32l81.6 0 27.4-128-67.8 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l81.6 0 22-102.7C180.4 8 197.4-3 214.7 .7zM206.4 192l-27.4 128 126.5 0 27.4-128-126.5 0z"
    ]
};
var $159afdcd077ecfe9$export$17cde74bf6f1ee89 = {
    prefix: 'fas',
    iconName: 'train',
    icon: [
        384,
        512,
        [
            128646
        ],
        "f238",
        "M0 96C0 43 43 0 96 0L288 0c53 0 96 43 96 96l0 256c0 40.1-24.6 74.5-59.5 88.8l53.9 63.7c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8l-74-87.5-151.3 0-74 87.5c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8l53.9-63.7C24.6 426.5 0 392.1 0 352L0 96zm64 32l0 96c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32L96 96c-17.7 0-32 14.3-32 32zM192 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$6a66b1b639455bef = {
    prefix: 'fas',
    iconName: 'gamepad',
    icon: [
        640,
        512,
        [],
        "f11b",
        "M448 64c106 0 192 86 192 192S554 448 448 448l-256 0C86 448 0 362 0 256S86 64 192 64l256 0zM192 176c-13.3 0-24 10.7-24 24l0 32-32 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l32 0 0 32c0 13.3 10.7 24 24 24s24-10.7 24-24l0-32 32 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-32 0 0-32c0-13.3-10.7-24-24-24zm240 96a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64-96a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$364f19abcfac1b0a = {
    prefix: 'fas',
    iconName: 'file-export',
    icon: [
        576,
        512,
        [
            "arrow-right-from-file"
        ],
        "f56e",
        "M96.5 0c-35.3 0-64 28.7-64 64l0 384c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-96 78.1 0-31 31c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l72-72c9.4-9.4 9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l31 31-78.1 0 0-133.5c0-17-6.7-33.3-18.7-45.3L291.2 18.7C279.2 6.7 263 0 246 0L96.5 0zM358 176l-93.5 0c-13.3 0-24-10.7-24-24L240.5 58.5 358 176zM224.5 328c0-13.3 10.7-24 24-24l104 0 0 48-104 0c-13.3 0-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$b9c76255b38e1df1 = $159afdcd077ecfe9$export$364f19abcfac1b0a;
var $159afdcd077ecfe9$export$bd5bd2ef56b793b1 = {
    prefix: 'fas',
    iconName: 'face-grimace',
    icon: [
        512,
        512,
        [
            128556,
            "grimace"
        ],
        "f57f",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM400 352c0 25.2-19.4 45.8-44 47.8l0-95.7c24.6 2 44 22.7 44 47.8zM276 304l40 0 0 96-40 0 0-96zm-80 96l0-96 40 0 0 96-40 0zm-40-95.8l0 95.7c-24.6-2-44-22.7-44-47.8s19.4-45.8 44-47.8zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$3d08cd36ac1ef231 = $159afdcd077ecfe9$export$bd5bd2ef56b793b1;
var $159afdcd077ecfe9$export$cda326cc3bce41c = {
    prefix: 'fas',
    iconName: 'train-subway',
    icon: [
        384,
        512,
        [
            "subway"
        ],
        "f239",
        "M0 96C0 43 43 0 96 0L288 0c53 0 96 43 96 96l0 256c0 40.1-24.6 74.5-59.5 88.8l53.9 63.7c8.6 10.1 7.3 25.3-2.8 33.8s-25.3 7.3-33.8-2.8l-74-87.5-151.3 0-74 87.5c-8.6 10.1-23.7 11.4-33.8 2.8s-11.4-23.7-2.8-33.8l53.9-63.7C24.6 426.5 0 392.1 0 352L0 96zm64 32l0 96c0 17.7 14.3 32 32 32l72 0 0-160-72 0c-17.7 0-32 14.3-32 32zM216 256l72 0c17.7 0 32-14.3 32-32l0-96c0-17.7-14.3-32-32-32l-72 0 0 160zM96 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm224-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
    ]
};
var $159afdcd077ecfe9$export$4cabc8a12d4e2f9 = $159afdcd077ecfe9$export$cda326cc3bce41c;
var $159afdcd077ecfe9$export$aa13d9234890e8d3 = {
    prefix: 'fas',
    iconName: 'circle-dot',
    icon: [
        512,
        512,
        [
            128280,
            "dot-circle"
        ],
        "f192",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-352a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
    ]
};
var $159afdcd077ecfe9$export$92bc269cb244d66a = $159afdcd077ecfe9$export$aa13d9234890e8d3;
var $159afdcd077ecfe9$export$40cdac24aa94a57a = {
    prefix: 'fas',
    iconName: 'object-group',
    icon: [
        576,
        512,
        [],
        "f247",
        "M32 119.4C12.9 108.4 0 87.7 0 64 0 28.7 28.7 0 64 0 87.7 0 108.4 12.9 119.4 32l337.1 0c11.1-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4l0 273.1c19.1 11.1 32 31.7 32 55.4 0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32l-337.1 0c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64 0-23.7 12.9-44.4 32-55.4l0-273.1zm448 0c-9.7-5.6-17.8-13.7-23.4-23.4L119.4 96c-5.6 9.7-13.7 17.8-23.4 23.4l0 273.1c9.7 5.6 17.8 13.7 23.4 23.4l337.1 0c5.6-9.7 13.7-17.8 23.4-23.4l0-273.1zM144 176c0-17.7 14.3-32 32-32l112 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-112 0c-17.7 0-32-14.3-32-32l0-64zM256 320l32 0c44.2 0 80-35.8 80-80l32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l-112 0c-17.7 0-32-14.3-32-32l0-16z"
    ]
};
var $159afdcd077ecfe9$export$6c645741140616af = {
    prefix: 'fas',
    iconName: 'ship',
    icon: [
        640,
        512,
        [
            128674
        ],
        "f21a",
        "M272 0c-26.5 0-48 21.5-48 48l0 16-16 0c-44.2 0-80 35.8-80 80l0 108.8-21.6 8.6c-14.8 5.9-22.5 22.4-17.4 37.5 10.4 31.3 26.8 59.3 47.7 83.1 20.1-9.2 41.7-13.9 63.3-14 33.1-.2 66.3 10.2 94.4 31.4l1.6 1.2 0-215-104 41.6 0-83.2c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16l0 83.2-104-41.6 0 215 1.6-1.2c27.5-20.7 59.9-31.2 92.4-31.4 22.3-.1 44.6 4.5 65.3 14 20.9-23.7 37.3-51.8 47.7-83.1 5-15.2-2.6-31.6-17.4-37.5L512 252.8 512 144c0-44.2-35.8-80-80-80l-16 0 0-16c0-26.5-21.5-48-48-48L272 0zM403.4 476.1c21.3-16.1 49.9-16.1 71.2 0 19 14.4 41.9 28.2 67.2 33.3 26.5 5.4 54.3 .8 80.7-19.1 10.6-8 12.7-23 4.7-33.6s-23-12.7-33.6-4.7c-14.9 11.2-28.6 13.1-42.3 10.3-14.9-3-30.9-11.9-47.8-24.6-38.4-29-90.5-29-129 0-24 18.1-40.7 26.3-54.5 26.3s-30.5-8.2-54.5-26.3c-38.4-29-90.5-29-129 0-21.6 16.3-41.3 25.8-58.9 25.7-9.6-.1-19.9-3-31.2-11.5-10.6-8-25.6-5.9-33.6 4.7S7 482.3 17.6 490.3c19.1 14.4 39.4 21 59.8 21.1 33.9 .2 64.3-17.4 88.1-35.3 21.3-16.1 49.9-16.1 71.2 0 24.2 18.3 52.3 35.9 83.4 35.9s59.1-17.7 83.4-35.9z"
    ]
};
var $159afdcd077ecfe9$export$a2c1c457834fc6d8 = {
    prefix: 'fas',
    iconName: 'c',
    icon: [
        384,
        512,
        [
            99
        ],
        "43",
        "M329.1 142.9c-62.5-62.5-155.8-62.5-218.3 0s-62.5 163.8 0 226.3 155.8 62.5 218.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-221.3 87.5-308.8 0s-87.5-229.3 0-316.8 221.3-87.5 308.8 0c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0z"
    ]
};
var $159afdcd077ecfe9$export$318ed022991eef56 = {
    prefix: 'fas',
    iconName: 'square-phone',
    icon: [
        448,
        512,
        [
            "phone-square"
        ],
        "f098",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm88 96.7c9.8-2.7 20.1 2.4 24 11.8l20.3 48.7c3.4 8.3 1.1 17.8-5.9 23.5l-22.1 18c16.2 35.8 44.5 65 79.6 82.4l19.3-23.6c5.7-6.9 15.2-9.3 23.5-5.9l48.7 20.3c9.4 3.9 14.4 14.2 11.8 24l-.8 2.8c-8.8 32.3-40.1 59.9-78.2 51.8-87.5-18.5-156.3-87.4-174.9-174.9-8.1-38.1 19.5-69.4 51.8-78.2l2.8-.8z"
    ]
};
var $159afdcd077ecfe9$export$8ba22605a641ebdf = $159afdcd077ecfe9$export$318ed022991eef56;
var $159afdcd077ecfe9$export$613f406c1b5802a8 = {
    prefix: 'fas',
    iconName: 'ruler-combined',
    icon: [
        448,
        512,
        [],
        "f546",
        "M1 441.7C5.5 463.5 24.8 480 48 480l352 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-48 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-64 0 0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0 0-64-72 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0 0-48c0-26.5-21.5-48-48-48L48 32C21.5 32 0 53.5 0 80L0 432c0 3.3 .3 6.6 1 9.7z"
    ]
};
var $159afdcd077ecfe9$export$2fd091cb98dc8ab8 = {
    prefix: 'fas',
    iconName: 'arrows-rotate',
    icon: [
        512,
        512,
        [
            128472,
            "refresh",
            "sync"
        ],
        "f021",
        "M65.9 228.5c13.3-93 93.4-164.5 190.1-164.5 53 0 101 21.5 135.8 56.2 .2 .2 .4 .4 .6 .6l7.6 7.2-47.9 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 53.4-11.3-10.7C390.5 28.6 326.5 0 256 0 127 0 20.3 95.4 2.6 219.5 .1 237 12.2 253.2 29.7 255.7s33.7-9.7 36.2-27.1zm443.5 64c2.5-17.5-9.7-33.7-27.1-36.2s-33.7 9.7-36.2 27.1c-13.3 93-93.4 164.5-190.1 164.5-53 0-101-21.5-135.8-56.2-.2-.2-.4-.4-.6-.6l-7.6-7.2 47.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 320c-8.5 0-16.7 3.4-22.7 9.5S-.1 343.7 0 352.3l1 127c.1 17.7 14.6 31.9 32.3 31.7S65.2 496.4 65 478.7l-.4-51.5 10.7 10.1c46.3 46.1 110.2 74.7 180.7 74.7 129 0 235.7-95.4 253.4-219.5z"
    ]
};
var $159afdcd077ecfe9$export$fd4359e93d7b3d14 = $159afdcd077ecfe9$export$2fd091cb98dc8ab8;
var $159afdcd077ecfe9$export$ff87319002e3dae9 = $159afdcd077ecfe9$export$2fd091cb98dc8ab8;
var $159afdcd077ecfe9$export$27f7383b96c3f4b4 = {
    prefix: 'fas',
    iconName: 'person-dress',
    icon: [
        384,
        512,
        [
            "female"
        ],
        "f182",
        "M136 24a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zM112 384l-25.8 0c-10.9 0-18.6-10.7-15.2-21.1l43-129-48.3 65.1c-10.5 14.2-30.6 17.2-44.8 6.6s-17.2-30.6-6.6-44.8l70.5-95C110 132 149.7 112 192 112s82 20 107.2 53.9l70.5 95c10.5 14.2 7.6 34.2-6.6 44.8s-34.2 7.6-44.8-6.6L270 234 313 362.9c3.5 10.4-4.3 21.1-15.2 21.1l-25.8 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128-32 0 0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128z"
    ]
};
var $159afdcd077ecfe9$export$70e8e75e61dd7169 = $159afdcd077ecfe9$export$27f7383b96c3f4b4;
var $159afdcd077ecfe9$export$8a3071811b2b7979 = {
    prefix: 'fas',
    iconName: 'book-open',
    icon: [
        512,
        512,
        [
            128214,
            128366
        ],
        "f518",
        "M256 141.3l0 309.3 .5-.2C311.1 427.7 369.7 416 428.8 416l19.2 0 0-320-19.2 0c-42.2 0-84.1 8.4-123.1 24.6-16.8 7-33.4 13.9-49.7 20.7zM230.9 61.5L256 72 281.1 61.5C327.9 42 378.1 32 428.8 32L464 32c26.5 0 48 21.5 48 48l0 352c0 26.5-21.5 48-48 48l-35.2 0c-50.7 0-100.9 10-147.7 29.5l-12.8 5.3c-7.9 3.3-16.7 3.3-24.6 0l-12.8-5.3C184.1 490 133.9 480 83.2 480L48 480c-26.5 0-48-21.5-48-48L0 80C0 53.5 21.5 32 48 32l35.2 0c50.7 0 100.9 10 147.7 29.5z"
    ]
};
var $159afdcd077ecfe9$export$54d16fa2e445d3fe = {
    prefix: 'fas',
    iconName: 'folder-tree',
    icon: [
        576,
        512,
        [],
        "f802",
        "M48 24C48 10.7 37.3 0 24 0S0 10.7 0 24L0 392c0 30.9 25.1 56 56 56l184 0 0-48-184 0c-4.4 0-8-3.6-8-8l0-232 192 0 0-48-192 0 0-88zM336 224l192 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-82.7 0c-8.5 0-16.6-3.4-22.6-9.4l-8.6-8.6c-9-9-21.2-14.1-33.9-14.1L336 0c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48zm0 288l192 0c26.5 0 48-21.5 48-48l0-96c0-26.5-21.5-48-48-48l-82.7 0c-8.5 0-16.6-3.4-22.6-9.4l-8.6-8.6c-9-9-21.2-14.1-33.9-14.1L336 288c-26.5 0-48 21.5-48 48l0 128c0 26.5 21.5 48 48 48z"
    ]
};
var $159afdcd077ecfe9$export$2a0fcb66c3d79d00 = {
    prefix: 'fas',
    iconName: 'box-archive',
    icon: [
        512,
        512,
        [
            "archive"
        ],
        "f187",
        "M0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96L0 64zM32 176l448 0 0 240c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-240zm152 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
var $159afdcd077ecfe9$export$26b3e1c454273f34 = $159afdcd077ecfe9$export$2a0fcb66c3d79d00;
var $159afdcd077ecfe9$export$8a4f323f00a91606 = {
    prefix: 'fas',
    iconName: 'tent-arrow-down-to-line',
    icon: [
        576,
        512,
        [],
        "e57e",
        "M185 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-31 31 0-102.1C120 2.7 109.3-8 96-8S72 2.7 72 16l0 102.1-31-31C31.6 77.7 16.4 77.7 7 87S-2.3 111.6 7 121l72 72c9.4 9.4 24.6 9.4 33.9 0l72-72zM155.8 260.6L132.1 448 32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32 0-2.8-.4-5.5-1-8L548.2 260.7c-1.2-9.7-6.9-18.4-15.3-23.4L367.4 137.9c-10.2-6.1-22.9-6.1-33.1 .1L170.9 237.3c-8.3 5.1-13.9 13.7-15.1 23.3zM448 448l-97.1 0 0-149.4c0-5.9 4.7-10.6 10.6-10.6 4 0 7.7 2.3 9.5 5.9L448 448z"
    ]
};
var $159afdcd077ecfe9$export$fc19ca0fe15e73bc = {
    prefix: 'fas',
    iconName: 'qrcode',
    icon: [
        448,
        512,
        [],
        "f029",
        "M64 160l64 0 0-64-64 0 0 64zM0 80C0 53.5 21.5 32 48 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48L0 80zM64 416l64 0 0-64-64 0 0 64zM0 336c0-26.5 21.5-48 48-48l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96zM320 96l0 64 64 0 0-64-64 0zM304 32l96 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48l-96 0c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zM288 352a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm96 32c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm32-96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"
    ]
};
var $159afdcd077ecfe9$export$ae1875ba975aa0e9 = {
    prefix: 'fas',
    iconName: 'dragon',
    icon: [
        640,
        512,
        [
            128009
        ],
        "f6d5",
        "M352 124.5l-51.9-13c-6.5-1.6-11.3-7.1-12-13.8s2.8-13.1 8.7-16.1l40.8-20.4-43.3-32.5c-5.5-4.1-7.8-11.3-5.6-17.9S297.1 0 304 0L464 0c30.2 0 58.7 14.2 76.8 38.4l57.6 76.8c6.2 8.3 9.6 18.4 9.6 28.8 0 26.5-21.5 48-48 48l-21.5 0c-17 0-33.3-6.7-45.3-18.7l-13.3-13.3-32 0 0 21.5c0 24.8 12.8 47.9 33.8 61.1l106.6 66.6c32.1 20.1 51.6 55.2 51.6 93.1 0 60.6-49.1 109.8-109.8 109.8L32.3 512c-3.3 0-6.6-.4-9.6-1.4-9.2-2.8-16.7-9.6-20.4-18.6-1.3-3.3-2.2-6.9-2.3-10.7-.2-3.7 .3-7.3 1.3-10.7 2.8-9.2 9.6-16.7 18.6-20.4 3-1.2 6.2-2 9.5-2.2L433.3 412c8.3-.7 14.7-7.7 14.7-16.1 0-4.3-1.7-8.4-4.7-11.4l-44.4-44.4c-30-30-46.9-70.7-46.9-113.1l0-102.5zM512 72.3c0-.1 0-.2 0-.3s0-.2 0-.3l0 .6zm-1.3 7.4L464.3 68.1c-.2 1.3-.3 2.6-.3 3.9 0 13.3 10.7 24 24 24 10.6 0 19.5-6.8 22.7-16.3zM130.9 116.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87 0 27.5c0 32.8 8.4 64.8 24 93l-232 0c-6.7 0-12.7-4.2-15-10.4s-.5-13.3 4.6-17.7L171 232.3 18.4 255.8c-7 1.1-13.9-2.6-16.9-9S.1 232.8 5.4 228L130.9 116.5z"
    ]
};
var $159afdcd077ecfe9$export$52757ecc5b1e25b9 = {
    prefix: 'fas',
    iconName: 'hourglass-end',
    icon: [
        384,
        512,
        [
            8987,
            "hourglass-3"
        ],
        "f253",
        "M32 0C14.3 0 0 14.3 0 32S14.3 64 32 64l0 11c0 42.4 16.9 83.1 46.9 113.1l67.9 67.9-67.9 67.9C48.9 353.9 32 394.6 32 437l0 11c-17.7 0-32 14.3-32 32s14.3 32 32 32l320 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l0-11c0-42.4-16.9-83.1-46.9-113.1l-67.9-67.9 67.9-67.9c30-30 46.9-70.7 46.9-113.1l0-11c17.7 0 32-14.3 32-32S369.7 0 352 0L32 0zM96 75l0-11 192 0 0 11c0 25.5-10.1 49.9-28.1 67.9l-67.9 67.9-67.9-67.9C106.1 124.9 96 100.4 96 75z"
    ]
};
var $159afdcd077ecfe9$export$1ec43c81fef8ffd6 = $159afdcd077ecfe9$export$52757ecc5b1e25b9;
var $159afdcd077ecfe9$export$eb83fb404127db75 = {
    prefix: 'fas',
    iconName: 'grip',
    icon: [
        512,
        512,
        [
            58119,
            "grid-horizontal",
            "grip-horizontal"
        ],
        "f58d",
        "M88 96c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0zM280 224l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm192 0l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zm0 192l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40zM280 288c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0zM88 416l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40z"
    ]
};
var $159afdcd077ecfe9$export$60d9066b1172be72 = $159afdcd077ecfe9$export$eb83fb404127db75;
var $159afdcd077ecfe9$export$4a45308d6c8decc1 = $159afdcd077ecfe9$export$eb83fb404127db75;
var $159afdcd077ecfe9$export$cf897c3e0abd59e4 = {
    prefix: 'fas',
    iconName: 'border-top-left',
    icon: [
        448,
        512,
        [
            "border-style"
        ],
        "f853",
        "M0 448c0 17.7 14.3 32 32 32s32-14.3 32-32l0-352 352 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L64 32C28.7 32 0 60.7 0 96L0 448zm128 0c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm128 0c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm160 32c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zM384 192a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm32 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$c2867ca78120d644 = $159afdcd077ecfe9$export$cf897c3e0abd59e4;
var $159afdcd077ecfe9$export$f8a219cf4f516384 = {
    prefix: 'fas',
    iconName: 'list-ul',
    icon: [
        512,
        512,
        [
            "list-dots"
        ],
        "f0ca",
        "M48 144a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l288 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-288 0zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM96 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"
    ]
};
var $159afdcd077ecfe9$export$e6f4ba30d84fa6ea = $159afdcd077ecfe9$export$f8a219cf4f516384;
var $159afdcd077ecfe9$export$75ce8513e1f1c5c4 = {
    prefix: 'fas',
    iconName: 'people-robbery',
    icon: [
        576,
        512,
        [],
        "e536",
        "M488.2 59.1C478.1 99.6 441.7 128 400 128s-78.1-28.4-88.2-68.9L303 24.2C298.8 7.1 281.4-3.3 264.2 1S236.7 22.6 241 39.8l8.7 34.9c11 44 40.2 79.6 78.3 99.6L328 480c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-305.7c38.1-20 67.3-55.6 78.3-99.6L559 39.8c4.3-17.1-6.1-34.5-23.3-38.8S501.2 7.1 497 24.2l-8.7 34.9zM400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-8 32c-35.3 0-64 28.7-64 64l0 96 0 .6 0 191.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128 16 0 0 128c0 17.7 14.3 32 32 32s32-14.3 32-32l0-227.3 13 20.5c5.9 9.2 16.1 14.9 27 14.9l48 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-30.4 0-37.4-58.9C157.6 142 132.1 128 104.7 128L72 128z"
    ]
};
var $159afdcd077ecfe9$export$c93d62849efbdd11 = {
    prefix: 'fas',
    iconName: 'mobile-button',
    icon: [
        384,
        512,
        [],
        "f10b",
        "M80 0C44.7 0 16 28.7 16 64l0 384c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L80 0zM192 464c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
    ]
};
var $159afdcd077ecfe9$export$43b642fac7053978 = {
    prefix: 'fas',
    iconName: 'arrow-down-a-z',
    icon: [
        512,
        512,
        [
            "sort-alpha-asc",
            "sort-alpha-down"
        ],
        "f15d",
        "M230.6 390.6l-80 80c-12.5 12.5-32.8 12.5-45.3 0l-80-80c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L96 370.7 96 64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 306.7 25.4-25.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zm182-340.9c50.7 101.3 77.3 154.7 80 160 7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-7.2-14.3-88.4 0-7.2 14.3c-7.9 15.8-27.1 22.2-42.9 14.3s-22.2-27.1-14.3-42.9c2.7-5.3 29.3-58.7 80-160 5.4-10.8 16.5-17.7 28.6-17.7s23.2 6.8 28.6 17.7zM384 135.6l-20.2 40.4 40.4 0-20.2-40.4zM288 320c0-17.7 14.3-32 32-32l128 0c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9L397.3 416 448 416c17.7 0 32 14.3 32 32s-14.3 32-32 32l-128 0c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l73.4-73.4-50.7 0c-17.7 0-32-14.3-32-32z"
    ]
};
var $159afdcd077ecfe9$export$cb87697f2fa77cfc = $159afdcd077ecfe9$export$43b642fac7053978;
var $159afdcd077ecfe9$export$7658045270aafde3 = $159afdcd077ecfe9$export$43b642fac7053978;
var $159afdcd077ecfe9$export$608138a7337b5d1a = {
    prefix: 'fas',
    iconName: 'money-bill',
    icon: [
        512,
        512,
        [],
        "f0d6",
        "M64 64C28.7 64 0 92.7 0 128L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zm192 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm192 24c0 4.4-3.6 8.1-8 7.5-29-3.6-51.9-26.6-55.5-55.5-.5-4.4 3.1-8 7.5-8l48 0c4.4 0 8 3.6 8 8l0 48zM64 328c0-4.4 3.6-8.1 8-7.5 29 3.6 51.9 26.6 55.5 55.5 .5 4.4-3.1 8-7.5 8l-48 0c-4.4 0-8-3.6-8-8l0-48zm8-136.5c-4.4 .5-8-3.1-8-7.5l0-48c0-4.4 3.6-8 8-8l48 0c4.4 0 8.1 3.6 7.5 8-3.6 29-26.6 51.9-55.5 55.5zm368 129c4.4-.5 8 3.1 8 7.5l0 48c0 4.4-3.6 8-8 8l-48 0c-4.4 0-8.1-3.6-7.5-8 3.6-29 26.6-51.9 55.5-55.5z"
    ]
};
var $159afdcd077ecfe9$export$d0163707993a8110 = {
    prefix: 'fas',
    iconName: 'circle-minus',
    icon: [
        512,
        512,
        [
            "minus-circle"
        ],
        "f056",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM168 232l176 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-176 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$f3979b49bf57313c = $159afdcd077ecfe9$export$d0163707993a8110;
var $159afdcd077ecfe9$export$e4f903bc63db445 = {
    prefix: 'fas',
    iconName: 'arrow-pointer',
    icon: [
        448,
        512,
        [
            "mouse-pointer"
        ],
        "f245",
        "M77.3 2.5c8.1-4.1 17.9-3.2 25.1 2.3l320 239.9c8.3 6.2 11.6 17 8.4 26.8s-12.4 16.4-22.8 16.4l-152.3 0 88.9 177.7c7.9 15.8 1.5 35-14.3 42.9s-35 1.5-42.9-14.3l-88.9-177.7-91.3 121.8c-6.2 8.3-17 11.6-26.8 8.4S64 434.3 64 424L64 24c0-9.1 5.1-17.4 13.3-21.5z"
    ]
};
var $159afdcd077ecfe9$export$2e19a69cc26b147 = $159afdcd077ecfe9$export$e4f903bc63db445;
var $159afdcd077ecfe9$export$1bdb0ec5af3fea99 = {
    prefix: 'fas',
    iconName: 'square-share-nodes',
    icon: [
        448,
        512,
        [
            "share-alt-square"
        ],
        "f1e1",
        "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM368 160c0 35.3-28.7 64-64 64-15.4 0-29.5-5.4-40.6-14.5l-85.3 46.5 85.3 46.5c11-9.1 25.2-14.5 40.6-14.5 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-2.5 .1-4.9 .4-7.3L158.5 300c-11.7 12.3-28.2 20-46.5 20-35.3 0-64-28.7-64-64s28.7-64 64-64c18.3 0 34.8 7.7 46.5 20l81.9-44.7c-.3-2.4-.4-4.9-.4-7.3 0-35.3 28.7-64 64-64s64 28.7 64 64z"
    ]
};
var $159afdcd077ecfe9$export$3799c2d8fd7e493b = $159afdcd077ecfe9$export$1bdb0ec5af3fea99;
var $159afdcd077ecfe9$export$d2bcaf492dfb3817 = {
    prefix: 'fas',
    iconName: 'table-cells-large',
    icon: [
        448,
        512,
        [
            "th-large"
        ],
        "f009",
        "M384 96l-128 0 0 128 128 0 0-128zm64 128l0 192c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 128zM64 288l0 128 128 0 0-128-128 0zm128-64l0-128-128 0 0 128 128 0zm64 64l0 128 128 0 0-128-128 0z"
    ]
};
var $159afdcd077ecfe9$export$69782f333e90cdc6 = $159afdcd077ecfe9$export$d2bcaf492dfb3817;
var $159afdcd077ecfe9$export$ab927dada03be4b3 = {
    prefix: 'fas',
    iconName: 'cat',
    icon: [
        576,
        512,
        [
            128008
        ],
        "f6be",
        "M64 96c53 0 96 43 96 96l0 85.8c29.7-44.7 77.8-76.2 133.4-84 25.6 60 85.2 102.1 154.6 102.1 10.9 0 21.6-1.1 32-3.1L480 480c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-140.8-136 108.8 56 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-144 0c-53 0-96-43-96-96l0-224c0-16.6-12.6-30.2-28.7-31.8l-6.6-.3C44.6 158.2 32 144.6 32 128 32 110.3 46.3 96 64 96zM533.8 3.2C544.2-5.5 560 1.9 560 15.5L560 128c0 61.9-50.1 112-112 112S336 189.9 336 128l0-112.5c0-13.6 15.8-21 26.2-12.3L416 48 480 48 533.8 3.2zM400 108a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm96 0a20 20 0 1 0 0 40 20 20 0 1 0 0-40z"
    ]
};
var $159afdcd077ecfe9$export$39be5cb4aed5a521 = {
    prefix: 'fas',
    iconName: 'calendar-week',
    icon: [
        448,
        512,
        [],
        "f784",
        "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zm0 256c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-192 0z"
    ]
};
var $159afdcd077ecfe9$export$ca4c5b4dcff58860 = {
    prefix: 'fas',
    iconName: 'code-compare',
    icon: [
        512,
        512,
        [],
        "e13a",
        "M198.8 1.8c9-3.7 19.3-1.7 26.2 5.2l56 56c9.4 9.4 9.4 24.6 0 33.9l-56 56c-6.9 6.9-17.2 8.9-26.2 5.2S184 145.7 184 136l0-24-24 0c-17.7 0-32 14.3-32 32l0 214.7c28.3 12.3 48 40.5 48 73.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-32.8 19.7-61 48-73.3L64 144c0-53 43-96 96-96l24 0 0-24c0-9.7 5.8-18.5 14.8-22.2zM392 80a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-8 73.3c-28.3-12.3-48-40.5-48-73.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 32.8-19.7 61-48 73.3L448 368c0 53-43 96-96 96l-24 0 0 24c0 9.7-5.8 18.5-14.8 22.2s-19.3 1.7-26.2-5.2l-56-56c-9.4-9.4-9.4-24.6 0-33.9l56-56c6.9-6.9 17.2-8.9 26.2-5.2S328 366.3 328 376l0 24 24 0c17.7 0 32-14.3 32-32l0-214.7zM72 432a24 24 0 1 0 48 0 24 24 0 1 0 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$2ffc88a4d31e8ffc = {
    prefix: 'fas',
    iconName: 'road-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e566",
        "M287.9 32l-76.2 0c-29.4 0-55.1 20.1-62.1 48.6L65.4 420.5C57.9 450.7 80.8 480 112 480l209.4 0c-11.2-24.4-17.4-51.4-17.4-80 0-28.6 6.2-55.7 17.4-80-.5 0-1 0-1.6 0-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32s32 14.3 32 32l0 49.2c35.2-40 86.7-65.2 144.2-65.2 9 0 17.8 .6 26.4 1.8l-32-129.2C483.4 52.1 457.8 32 428.3 32l-76.5 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7l-36.7 36.7 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $159afdcd077ecfe9$export$d7ff2047dbc34562 = {
    prefix: 'fas',
    iconName: 'pallet',
    icon: [
        576,
        512,
        [],
        "f482",
        "M32 320c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 64-32 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l512 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-32 0 0-64 32 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 320zm96 64l128 0 0 64-128 0 0-64zm192 0l128 0 0 64-128 0 0-64z"
    ]
};
var $159afdcd077ecfe9$export$e4019fe302a972e1 = {
    prefix: 'fas',
    iconName: 'cake-candles',
    icon: [
        448,
        512,
        [
            127874,
            "birthday-cake",
            "cake"
        ],
        "f1fd",
        "M86.4-10.5L61.8 31.6C58 38.1 56 45.6 56 53.2L56 56c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L105.6-10.5c-2-3.4-5.7-5.5-9.6-5.5s-7.6 2.1-9.6 5.5zm128 0L189.8 31.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L233.6-10.5c-2-3.4-5.7-5.5-9.6-5.5s-7.6 2.1-9.6 5.5zM317.8 31.6c-3.8 6.5-5.8 14-5.8 21.6l0 2.8c0 22.1 17.9 40 40 40s40-17.9 40-40l0-2.8c0-7.6-2-15-5.8-21.6L361.6-10.5c-2-3.4-5.7-5.5-9.6-5.5s-7.6 2.1-9.6 5.5L317.8 31.6zM128 160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 53.5C26.7 226.6 0 262.2 0 304l0 20.8c20.9 1.3 41.6 7.3 60.3 18l7.1 4.1c26.3 15 58.9 13.4 83.6-4.2 43.7-31.2 102.3-31.2 146 0 24.6 17.6 57.3 19.3 83.6 4.2l7.1-4.1c18.7-10.7 39.3-16.7 60.3-18l0-20.8c0-41.8-26.7-77.4-64-90.5l0-53.5c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-64 0 0-48c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 48-64 0 0-48zM448 373c-12.7 1.2-25.1 5-36.5 11.5l-7.1 4.1c-42.6 24.3-95.4 21.7-135.3-6.8-27-19.3-63.2-19.3-90.2 0-39.9 28.5-92.7 31.2-135.3 6.8l-7.1-4.1C25.1 378 12.7 374.1 0 373l0 75c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-75z"
    ]
};
var $159afdcd077ecfe9$export$bdcf98f725a7241a = $159afdcd077ecfe9$export$e4019fe302a972e1;
var $159afdcd077ecfe9$export$707bc1c80c0177c1 = $159afdcd077ecfe9$export$e4019fe302a972e1;
var $159afdcd077ecfe9$export$fc4dd5feed8df23 = {
    prefix: 'fas',
    iconName: 'bug-slash',
    icon: [
        576,
        512,
        [],
        "e490",
        "M7-24.9c9.4-9.4 24.6-9.4 33.9 0L241.8 176 344 176c14.2 0 27.7 2.8 40 8l108.8-81.6c14.1-10.6 34.2-7.7 44.8 6.4s7.7 34.2-6.4 44.8l-97.8 73.3c5.3 8.9 9.3 18.7 11.8 29.1l98.8 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 32c0 9.5-.8 18.7-2.4 27.8L569 503.1c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 9.1C-2.3-.3-2.3-15.5 7-24.9zM398.2 468c-23.2 22.1-53 37.2-86.2 42.2l0-128.4 86.2 86.2zM264 333.8l0 176.4c-51.2-7.7-94.5-39.7-117.7-83.9L83.2 473.6c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l83.4-62.5c-.1-2.6-.2-5.2-.2-7.9l0-32-96 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l98.8 0c3.3-13.9 9.3-26.7 17.6-37.8L264 333.8zM355.6 128l-82.4 0-72.3-72.3C216.1 22.8 249.4 0 288 0 341 0 384 43 384 96l0 3.6c0 15.7-12.7 28.4-28.4 28.4z"
    ]
};
var $159afdcd077ecfe9$export$2305b1a41b3f914 = {
    prefix: 'fas',
    iconName: 'tarp',
    icon: [
        512,
        512,
        [],
        "e57b",
        "M448 64c35.3 0 64 28.7 64 64l0 149.5c0 17-6.7 33.3-18.7 45.3L386.7 429.3c-12 12-28.3 18.7-45.3 18.7L64 448c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l384 0zm5.5 208L360 272c-13.3 0-24 10.7-24 24l0 93.5 117.5-117.5zM96 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
    ]
};
var $159afdcd077ecfe9$export$1852c99deca7bee8 = {
    prefix: 'fas',
    iconName: 'diagram-predecessor',
    icon: [
        448,
        512,
        [],
        "e477",
        "M289.2 137.9c2.5-6 8.3-9.9 14.8-9.9l40 0 0-24c0-13.3-10.7-24-24-24l-98 0c1.3 5.1 2 10.5 2 16l0 64c0 35.3-28.7 64-64 64l-96 0c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l256 0c39.8 0 72 32.2 72 72l0 24 40 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-4.6-4.6-5.9-11.5-3.5-17.4zM384 352l-320 0 0 64 320 0 0-64zm64 64c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l320 0c35.3 0 64 28.7 64 64l0 64z"
    ]
};
var $159afdcd077ecfe9$export$ba5dc4287853ecbd = {
    prefix: 'fas',
    iconName: 'face-flushed',
    icon: [
        512,
        512,
        [
            128563,
            "flushed"
        ],
        "f579",
        "M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zM168 392c0 13.3 10.7 24 24 24l128 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-128 0c-13.3 0-24 10.7-24 24zm-8-96a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm264-72a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zm-288 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm192 0a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"
    ]
};
var $159afdcd077ecfe9$export$dfd2bd012685aeac = $159afdcd077ecfe9$export$ba5dc4287853ecbd;
var $159afdcd077ecfe9$export$2faddf1690e14e11 = {
    prefix: 'fas',
    iconName: 'diagram-next',
    icon: [
        448,
        512,
        [],
        "e476",
        "M384 224c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64L64 32C28.7 32 0 60.7 0 96l0 64c0 35.3 28.7 64 64 64l128 0 0 64-32 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c4.6-4.6 5.9-11.5 3.5-17.4S294.5 288 288 288l-32 0 0-64 128 0zM64 288c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-34 0c5.6 21.7-.5 45.1-16.7 61.3l-64 64c-25 25-65.5 25-90.5 0l-64-64C98.6 333.1 92.4 309.7 98 288l-34 0z"
    ]
};
var $159afdcd077ecfe9$export$f6773af4219eebd = {
    prefix: 'fas',
    iconName: 'anchor-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e4ac",
        "M320.5 96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-32-96c-53 0-96 43-96 96 0 41.8 26.7 77.4 64 90.5l0 257.9c-62.9-14.3-110.2-69.7-111.9-136.5l16.1 14.1c10 8.7 25.1 7.7 33.9-2.3s7.7-25.1-2.3-33.9l-64-56c-9-7.9-22.6-7.9-31.6 0l-64 56c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l16.2-14.2c2.1 113.1 94.4 204.1 208 204.1 16.6 0 32.7-1.9 48.2-5.6-20.3-30.5-32.2-67-32.2-106.4 0-27.3 5.7-53.3 16-76.9l0-136.6c37.3-13.2 64-48.7 64-90.5 0-53-43-96-96-96zm208 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm59.3-180.7l-36.7 36.7 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
    ]
};
var $159afdcd077ecfe9$export$16c9e0374c346c6e = {
    prefix: 'fas',
    iconName: 'person-circle-xmark',
    icon: [
        640,
        512,
        [],
        "e543",
        "M280 24a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm24 212.7L341 286.6c12.8-17.5 28.5-32.7 46.3-45l-56.2-75.7C306 132 266.3 112 224 112s-82 20-107.2 53.9l-70.5 95c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L144 236.7 144 512c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-275.3zM496 544a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm22.6-144l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-36.7-36.7-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 400z"
    ]
};
var $159afdcd077ecfe9$export$f9a38ef7b046ab51 = {
    prefix: 'fas',
    iconName: 'spa',
    icon: [
        576,
        512,
        [],
        "f5bb",
        "M169.7 227.5c34.3 18.7 64.5 44.1 88.8 74.5 11.1 13.9 21 28.9 29.4 44.8 8.5-15.9 18.3-30.8 29.4-44.8 24.3-30.5 54.5-55.9 88.8-74.5 41.7-22.7 89.4-35.5 139.7-35.5l9.9 0c11.1 0 20.1 9 20.1 20.1 0 148-119.9 267.9-267.9 267.9l-40.2 0C119.9 480 0 360.1 0 212.1 0 201 9 192 20.1 192l9.9 0c50.4 0 98.1 12.8 139.7 35.5zM303.9 38c16.9 15.9 61.4 63.4 89 142.3-40.1 20.2-75.8 48.2-104.9 82.1-29.2-33.9-64.8-61.8-104.9-82.1 27.6-78.9 72.2-126.4 89-142.3 4.3-4.1 10-6 15.9-6s11.6 2 15.9 6z"
    ]
};
var $159afdcd077ecfe9$export$ee3a02da18715b2 = {
    prefix: 'fas',
    iconName: 'bars-progress',
    icon: [
        448,
        512,
        [
            "tasks-alt"
        ],
        "f828",
        "M288 160l96 0 0-64-96 0 0 64zM0 160L0 80C0 53.5 21.5 32 48 32l352 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 224c-26.5 0-48-21.5-48-48l0-16zM160 416l224 0 0-64-224 0 0 64zM0 416l0-80c0-26.5 21.5-48 48-48l352 0c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48L48 480c-26.5 0-48-21.5-48-48l0-16z"
    ]
};
var $159afdcd077ecfe9$export$bbc0784fc1578f7f = $159afdcd077ecfe9$export$ee3a02da18715b2;
var $159afdcd077ecfe9$export$5e4b6785eedecc1a = {
    prefix: 'fas',
    iconName: 'heart-circle-check',
    icon: [
        576,
        512,
        [],
        "e4fd",
        "M241 87.1l15 20.7 15-20.7C296 52.5 336.2 32 378.9 32 452.4 32 512 91.6 512 165.1l0 2.6c0 17.6-3.4 35.6-9.5 53.7-21.8-8.6-45.6-13.4-70.5-13.4-106 0-192 86-192 192 0 28.5 6.2 55.6 17.4 80-.5 0-.9 0-1.4 0-15.5 0-30.8-4.6-43.1-14.1-73-55.7-212.9-186-212.9-298.2l0-2.6C0 91.6 59.6 32 133.1 32 175.8 32 216 52.5 241 87.1zM288 400a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm201.4-60.9c-7.1-5.2-17.2-3.6-22.4 3.5l-53 72.9-26.8-26.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c3.3 3.3 7.9 5 12.6 4.6s8.9-2.8 11.7-6.5l64-88c5.2-7.1 3.6-17.2-3.5-22.3z"
    ]
};
var $159afdcd077ecfe9$export$321e84e6a900c2d6 = {
    prefix: 'fas',
    iconName: 'mars-stroke-right',
    icon: [
        640,
        512,
        [
            9897,
            "mars-stroke-h"
        ],
        "f22b",
        "M320.5 256a112 112 0 1 0 -224 0 112 112 0 1 0 224 0zM208.5 80c86.3 0 158.1 62.1 173.1 144.1 1-.1 1.9-.1 2.9-.1l16 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 61.4 0-22.4-28c-11-13.8-8.8-33.9 5-45s33.9-8.8 45 5l64 80c9.3 11.7 9.3 28.3 0 40l-64 80c-11 13.8-31.2 16-45 5s-16-31.2-5-45l22.4-28-61.4 0 0 32c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-32-16 0c-1 0-1.9 0-2.9-.1-15 82-86.8 144.1-173.1 144.1-97.2 0-176-78.8-176-176s78.8-176 176-176z"
    ]
};
var $159afdcd077ecfe9$export$5cb0daeafbcdabe3 = $159afdcd077ecfe9$export$321e84e6a900c2d6;
var $159afdcd077ecfe9$export$5b2f0f631f559d51 = {
    prefix: 'fas',
    iconName: 'tower-observation',
    icon: [
        448,
        512,
        [],
        "e586",
        "M209.7 3.4c9-4.5 19.6-4.5 28.6 0l160 80c15.8 7.9 22.2 27.1 14.3 42.9-5.6 11.2-16.9 17.7-28.6 17.7l0 80c0 17.7-14.3 32-32 32l-13 0 32 192 45 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32s14.3-32 32-32l45 0 32-192-13 0c-17.7 0-32-14.3-32-32l0-80c-11.7 0-23-6.5-28.6-17.7-7.9-15.8-1.5-35 14.3-42.9l160-80zM310.7 448l-86.7-61.9-86.7 61.9 173.4 0zm-153-192l-3.5 21.2 69.9 49.9 69.9-49.9-3.5-21.2-132.7 0zm-12.3 73.9l-10.1 60.6 47.5-33.9-37.4-26.7zm119.9 26.7l47.5 33.9-10.1-60.6-37.4 26.7zM152 128c-13.3 0-24 10.7-24 24s10.7 24 24 24l144 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-144 0z"
    ]
};
var $159afdcd077ecfe9$export$170c56774c8e7961 = {
    prefix: 'fas',
    iconName: 'sterling-sign',
    icon: [
        384,
        512,
        [
            163,
            "gbp",
            "pound-sign"
        ],
        "f154",
        "M91.3 288l-34.8 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l21.4 0C37.3 147.3 105.1 42 207.6 42l8.2 0c33.6 0 66.2 11.3 92.5 32.2l16.1 12.7c13.9 11 16.2 31.1 5.2 45s-31.1 16.2-45 5.2l-16.1-12.7c-15-11.9-33.6-18.4-52.8-18.4l-8.2 0c-57.3 0-94.7 59.9-69.7 111.4 3.6 7.4 6.6 14.9 9.1 22.6l149.5 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-141.2 0c1 35.3-8.7 70.6-28.9 100.9l-18.1 27.1 212.2 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-272 0c-11.8 0-22.6-6.5-28.2-16.9s-5-23 1.6-32.9l51.2-76.8c13.1-19.6 19.2-42.6 18.2-65.4z"
    ]
};
var $159afdcd077ecfe9$export$3d9479ec1d1ae83e = $159afdcd077ecfe9$export$170c56774c8e7961;
var $159afdcd077ecfe9$export$9ce041dfec8319b = $159afdcd077ecfe9$export$170c56774c8e7961;
var $159afdcd077ecfe9$export$7a255960242435f6 = {
    prefix: 'fas',
    iconName: 'faucet-drip',
    icon: [
        512,
        512,
        [
            128688
        ],
        "e006",
        "M224 32c-17.7 0-32 14.3-32 32L96 64C78.3 64 64 78.3 64 96s14.3 32 32 32l96 0 0 64-18.7 0c-8.5 0-16.6 3.4-22.6 9.4L128 224 32 224c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l100.1 0c20.2 29 53.9 48 91.9 48s71.7-19 91.9-48l36.1 0c17.7 0 32 14.3 32 32s14.3 32 32 32l64 0c17.7 0 32-14.3 32-32 0-88.4-71.6-160-160-160l-32 0-22.6-22.6c-6-6-14.1-9.4-22.6-9.4l-18.7 0 0-64 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c0-17.7-14.3-32-32-32zM436.8 455.4l-18.2 42.4c-1.8 4.1-2.7 8.6-2.7 13.1l0 1.2c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.2c0-4.5-.9-8.9-2.7-13.1l-18.2-42.4c-1.9-4.5-6.3-7.4-11.2-7.4s-9.2 2.9-11.2 7.4z"
    ]
};
var $159afdcd077ecfe9$export$317f99f46b39906e = {
    prefix: 'fas',
    iconName: 'circle-info',
    icon: [
        512,
        512,
        [
            "info-circle"
        ],
        "f05a",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM224 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-8 64l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$aa9288aeadf882fa = $159afdcd077ecfe9$export$317f99f46b39906e;
var $159afdcd077ecfe9$export$5e19aea195b31816 = {
    prefix: 'fas',
    iconName: 'feather',
    icon: [
        512,
        512,
        [
            129718
        ],
        "f52d",
        "M352 0c41 0 80.3 16.3 109.2 45.2l5.5 5.5c29 29 45.3 68.3 45.3 109.2 0 24.1-5.7 47.6-16.2 68.8-1.9 3.7-5.3 6.5-9.3 7.7L374.5 270c-3.9 1.2-6.5 4.7-6.5 8.8 0 5.1 4.1 9.2 9.2 9.2l32.2 0c14.3 0 21.4 17.2 11.3 27.3l-22.4 22.4c-1.9 1.9-4.2 3.2-6.7 4l-81 24.3c-3.9 1.2-6.5 4.7-6.5 8.8 0 5.1 4.1 9.2 9.2 9.2 13.2 0 18.9 15.7 7.8 22.9-41.1 26.6-89.3 41.1-139 41.1l-86 0-48 48c-8.8 8.8-23.2 8.8-32 0s-8.8-23.2 0-32L256 224c8.8-8.8 8.8-23.2 0-32s-23.2-8.8-32 0L79.5 336.5c-5.7 5.7-15.5 1.7-15.5-6.4 0-67.9 27-133 75-181L242.8 45.2C271.7 16.3 311 0 352 0z"
    ]
};
var $159afdcd077ecfe9$export$86079bc65a716451 = {
    prefix: 'fas',
    iconName: 'bowl-rice',
    icon: [
        512,
        512,
        [],
        "e2eb",
        "M176 40c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm24 48l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM56 160l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM0 283.4C0 268.3 12.3 256 27.4 256l457.1 0c15.1 0 27.4 12.3 27.4 27.4 0 70.5-44.4 130.7-106.7 154.1L403.5 452c-2 16-15.6 28-31.8 28l-231.5 0c-16.1 0-29.8-12-31.8-28l-1.8-14.4C44.4 414.1 0 353.9 0 283.4zM224 184c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zm-96 0c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zM104 88l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm216 96c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zM296 88l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm120 96c0-13.3 10.7-24 24-24l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24zM392 88l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zM296 16l16 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-16 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
    ]
};
var $159afdcd077ecfe9$export$3e4892d8bf919edd = {
    prefix: 'fas',
    iconName: 'star-half-stroke',
    icon: [
        576,
        512,
        [
            "star-half-alt"
        ],
        "f5c0",
        "M288.1 353.6c10 0 19.9 2.3 29 7l74.4 37.9-13-82.5c-3.2-20.2 3.5-40.7 17.9-55.2l59-59.1-82.5-13.1c-20.2-3.2-37.7-15.9-47-34.1l-38-74.4 0 273.6zM457.4 489c-7.3 5.3-17 6.1-25 2L288.1 417.6 143.8 491c-8 4.1-17.7 3.3-25-2s-11-14.2-9.6-23.2L134.4 305.9 20 191.4c-6.4-6.4-8.6-15.8-5.8-24.4s10.1-14.9 19.1-16.3l159.9-25.4 73.6-144.2c4.1-8 12.4-13.1 21.4-13.1s17.3 5.1 21.4 13.1L383 125.3 542.9 150.7c8.9 1.4 16.3 7.7 19.1 16.3s.5 18-5.8 24.4L441.7 305.9 467 465.8c1.4 8.9-2.3 17.9-9.6 23.2z"
    ]
};
var $159afdcd077ecfe9$export$c13575f42532efb3 = $159afdcd077ecfe9$export$3e4892d8bf919edd;
var $159afdcd077ecfe9$export$4520eb1840c4e110 = {
    prefix: 'fas',
    iconName: 'temperature-arrow-down',
    icon: [
        512,
        512,
        [
            "temperature-down"
        ],
        "e03f",
        "M64.5 96c0-53 43-96 96-96s96 43 96 96l0 164.7c29.5 26.4 48 64.7 48 107.3 0 79.5-64.5 144-144 144s-144-64.5-144-144c0-42.6 18.5-81 48-107.3L64.5 96zm96 336c35.3 0 64-28.7 64-64 0-26.9-16.5-49.9-40-59.3l0-28.7c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 28.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64zM439.1 310.6c-6 6-14.1 9.4-22.6 9.4s-16.6-3.4-22.6-9.4l-64-64c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l9.4 9.4 0-178.7c0-17.7 14.3-32 32-32s32 14.3 32 32l0 178.7 9.4-9.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64z"
    ]
};
var $159afdcd077ecfe9$export$f0b2aca3866f00f6 = $159afdcd077ecfe9$export$4520eb1840c4e110;
var $159afdcd077ecfe9$export$122c8413a0dc5ff6 = {
    prefix: 'fas',
    iconName: 'mask-ventilator',
    icon: [
        640,
        512,
        [],
        "e524",
        "M152.2 192c-15.4 38.3-24.2 77.2-24.2 108.8 0 13.3 1.5 26.2 4.4 38.7l-17-3.4c-29.9-6-51.4-32.2-51.4-62.8l0-81.3 88.2 0zm32.9-64L64 128c-35.3 0-64 28.7-64 64l0 81.3c0 61 43.1 113.5 102.9 125.5l66.3 13.3c18.7 22.1 42.9 40 70.8 51.8l0-87.8c-10.1-14.2-16-31.3-16-49.7 0-49.5 43-134.4 96-134.4 52.5 0 96 84.9 96 134.4 0 18.4-5.9 35.4-16 49.6l0 87.7c27.6-11.8 51.7-29.6 70.4-51.6l66.7-13.3c59.8-12 102.9-64.5 102.9-125.5l0-81.3c0-35.3-28.7-64-64-64l-121.5 0c-34.8-54.2-82.5-96-134.5-96-52.6 0-100.2 41.8-134.9 96zm302.5 64l88.4 0 0 81.3c0 30.5-21.5 56.8-51.4 62.8l-17 3.4c2.9-12.4 4.5-25.4 4.5-38.7 0-31.6-8.9-70.5-24.4-108.8zM288 320l0 192 64 0 0-192c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
    ]
};
var $159afdcd077ecfe9$export$b44eb38345c6a964 = {
    prefix: 'fas',
    iconName: 'file-video',
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M0 64C0 28.7 28.7 0 64 0L213.5 0c17 0 33.3 6.7 45.3 18.7L365.3 125.3c12 12 18.7 28.3 18.7 45.3L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm208-5.5l0 93.5c0 13.3 10.7 24 24 24L325.5 176 208 58.5zM80 304l0 96c0 17.7 14.3 32 32 32l96 0c17.7 0 32-14.3 32-32l0-24 35 35c3.2 3.2 7.5 5 12 5 9.4 0 17-7.6 17-17l0-94.1c0-9.4-7.6-17-17-17-4.5 0-8.8 1.8-12 5l-35 35 0-24c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32z"
    ]
};
var $159afdcd077ecfe9$export$d2caed5e37174c23 = {
    prefix: 'fas',
    iconName: 'arrow-trend-down',
    icon: [
        576,
        512,
        [],
        "e097",
        "M384 352c-17.7 0-32 14.3-32 32s14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-160c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 82.7-169.4-169.4c-12.5-12.5-32.8-12.5-45.3 0L192 242.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0L320 205.3 466.7 352 384 352z"
    ]
};
var $159afdcd077ecfe9$export$2599126c3a57f727 = {
    prefix: 'fas',
    iconName: 'oil-can',
    icon: [
        640,
        512,
        [],
        "f613",
        "M320 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32l32 0 0 32-176 0c-26.5 0-48 21.5-48 48l0 64.8c0 19 11.2 36.2 28.5 43.9l67.5 30 0 21.3c0 26.5 21.5 48 48 48l259.1 0c18.4 0 35.8-7.9 48-21.7L633.5 187.7c12.3-13.9-.3-35.4-18.4-31.5L448 192 397.5 166.8c-8.9-4.4-18.7-6.8-28.6-6.8l-80.9 0 0-32 32 0zM96 208l0 86.1-48-21.3 0-64.8 48 0z"
    ]
};
var $159afdcd077ecfe9$export$7754cc6d5559ff38 = {
    prefix: 'fas',
    iconName: 'people-carry-box',
    icon: [
        576,
        512,
        [
            "people-carry"
        ],
        "f4ce",
        "M64-32A56 56 0 1 1 64 80 56 56 0 1 1 64-32zM0 171.1c0-32.6 26.5-59.1 59.1-59.1 23.5 0 45.5 11.3 59.1 30.4l48.7 68.2c5.8 8.2 15.1 13.1 25.1 13.4l0-96c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32l0 96c10-.3 19.3-5.2 25.1-13.4l48.7-68.2c13.6-19.1 35.6-30.4 59.1-30.4 32.6 0 59.1 26.5 59.1 59.1L576 272c0 30.2-14.2 58.7-38.4 76.8l-76.8 57.6c-8.1 6-12.8 15.5-12.8 25.6l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80c0-30.2 14.2-58.7 38.4-76.8l41.6-31.2 0-80.1-2.8 3.9c-18 25.2-47.1 40.2-78.1 40.2L352 288c-.6 0-1.3 0-1.9-.1-.6 0-1.3 .1-1.9 .1l-120.4 0c-.6 0-1.3 0-1.9-.1-.6 0-1.3 .1-1.9 .1l-31.1 0c-31 0-60.1-15-78.1-40.2l-2.8-3.9 0 80.1 41.6 31.2C177.8 373.3 192 401.8 192 432l0 80c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-80c0-10.1-4.7-19.6-12.8-25.6L38.4 348.8C14.2 330.7 0 302.2 0 272L0 171.1zM0 379.3c3.1 2.7 6.3 5.4 9.6 7.9L64 428 64 512c0 17.7-14.3 32-32 32S0 529.7 0 512L0 379.3zM568 24a56 56 0 1 1 -112 0 56 56 0 1 1 112 0zm8 488c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-84 54.4-40.8c3.3-2.5 6.5-5.1 9.6-7.9L576 512z"
    ]
};
var $159afdcd077ecfe9$export$35fbd4ff1265acd5 = $159afdcd077ecfe9$export$7754cc6d5559ff38;
var $159afdcd077ecfe9$export$a339864ee3df7e9a = {
    prefix: 'fas',
    iconName: 'chair',
    icon: [
        448,
        512,
        [
            129681
        ],
        "f6c0",
        "M152 256l0-181.8c-24.5 20.5-40 51.4-40 85.8l0 96 40 0zm48 0l48 0 0-205.4c-7.7-1.7-15.8-2.6-24-2.6s-16.3 .9-24 2.6L200 256zM296 74.2l0 181.8 40 0 0-96c0-34.4-15.5-65.2-40-85.8zM32 256l32 0 0-96C64 71.6 135.6 0 224 0S384 71.6 384 160l0 96 32 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96-256 0 0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32z"
    ]
};
var $159afdcd077ecfe9$export$cc58cb0f2257a6a9 = {
    prefix: 'fas',
    iconName: 'wind',
    icon: [
        512,
        512,
        [],
        "f72e",
        "M288 32c0 17.7 14.3 32 32 32l40 0c13.3 0 24 10.7 24 24s-10.7 24-24 24L32 112c-17.7 0-32 14.3-32 32s14.3 32 32 32l328 0c48.6 0 88-39.4 88-88S408.6 0 360 0L320 0c-17.7 0-32 14.3-32 32zm64 352c0 17.7 14.3 32 32 32l32 0c53 0 96-43 96-96s-43-96-96-96L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-32 0c-17.7 0-32 14.3-32 32zM128 512l40 0c48.6 0 88-39.4 88-88s-39.4-88-88-88L32 336c-17.7 0-32 14.3-32 32s14.3 32 32 32l136 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-40 0c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
    ]
};
var $159afdcd077ecfe9$export$a137712e11e257dd = {
    prefix: 'fas',
    iconName: 'layer-group',
    icon: [
        512,
        512,
        [],
        "f5fd",
        "M232.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L13.9 149.8C5.4 145.8 0 137.3 0 128s5.4-17.9 13.9-21.8L232.5 5.2zM48.1 218.4l164.3 75.9c27.7 12.8 59.6 12.8 87.3 0l164.3-75.9 34.1 15.8c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L13.9 277.8C5.4 273.8 0 265.3 0 256s5.4-17.9 13.9-21.8l34.1-15.8zM13.9 362.2l34.1-15.8 164.3 75.9c27.7 12.8 59.6 12.8 87.3 0l164.3-75.9 34.1 15.8c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L13.9 405.8C5.4 401.8 0 393.3 0 384s5.4-17.9 13.9-21.8z"
    ]
};
var $159afdcd077ecfe9$export$280300af4baa1a3e = {
    prefix: 'fas',
    iconName: 'head-side-mask',
    icon: [
        512,
        512,
        [],
        "e063",
        "M445.9 193c-.1-.4-.2-.9-.2-1.3-15.7-108.4-108.9-191.7-221.7-191.7-85 0-159 47.4-196.9 117.2L283.3 288 456 288 442.9 336 336 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l98.2 0-8.7 32-89.5 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80.6 0c-6.7 19.1-24.8 32-45.3 32L288 464c-17.7 0-32-14.3-32-32l0-104.5-247.5-165C3 182.1 0 202.7 0 224 0 278 19.1 327.5 50.9 366.2 58.9 375.9 64 387.8 64 400.4L64 464c0 26.5 21.5 48 48 48l127.3 0 .7 0 131.3 0c44.9 0 83.8-31.1 93.6-74.9l33.9-150.3c3.3-14.4-.3-29.5-9.7-41L445.9 193zM288 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
    ]
};
var $159afdcd077ecfe9$export$f9712d0cf5150f0c = {
    prefix: 'fas',
    iconName: 'hands',
    icon: [
        512,
        512,
        [
            "sign-language",
            "signing"
        ],
        "f2a7",
        "M512 160l-.1 72.6c0 44.8-17.6 87.1-47.9 118.4-.3-77-40.1-148.4-105.4-189.3l-1.9-1.2c2.5-3.7 2.8-8.6 .4-12.7l-62-107.4c-6.6-11.5-2.7-26.2 8.8-32.8S330 5 336.6 16.5l68 117.8 0 0 0 0 43.3 75 .1-49.3c0-17.7 14.4-32 32-32s32 14.4 32 32zM298.4 124.2c-14.1-8.8-29.8-12.7-45.2-12.1L216.7 48.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8l67.1 116.2-27-16.9zM211.9 88.5l16.4 28.4c-15.1 5.5-28.6 15.6-38.3 29.7l-19.7-34.2c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zm-46.4 63.7l12.5 21.7c-2 8.6-2.5 17.5-1.7 26.1l-4.3 0 0 0-34.4 0-13.7-23.8c-6.6-11.5-2.7-26.2 8.8-32.8s26.2-2.7 32.8 8.8zM228.9 175c9.4-15 29.1-19.5 44.1-10.2l60.2 37.6C384.7 234.7 416 291.2 416 352l0 8c0 83.9-68.1 152-152 152L88 512c-13.3 0-24-10.7-24-24s10.7-24 24-24l92 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L56 440c-13.3 0-24-10.7-24-24s10.7-24 24-24l124 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L24 368c-13.3 0-24-10.7-24-24s10.7-24 24-24l156 0c6.6 0 12-5.4 12-12s-5.4-12-12-12L56 296c-13.3 0-24-10.7-24-24s10.7-24 24-24l136 0 0 0 0 0 93.2 0-46.2-28.9c-15-9.4-19.5-29.1-10.2-44.1z"
    ]
};
var $159afdcd077ecfe9$export$20993813350f9671 = $159afdcd077ecfe9$export$f9712d0cf5150f0c;
var $159afdcd077ecfe9$export$5cc0e6f5191f4f02 = $159afdcd077ecfe9$export$f9712d0cf5150f0c;
var $159afdcd077ecfe9$export$bed2b0ed4ae45e0d = {
    prefix: 'fas',
    iconName: 'tablets',
    icon: [
        512,
        512,
        [],
        "f490",
        "M495.3 76.6c-4.6-8.7-16.3-9.7-23.3-2.7L297.9 248c-7 7-6 18.7 2.7 23.3 20.1 10.7 43 16.7 67.4 16.7 79.5 0 144-64.5 144-144 0-24.3-6-47.3-16.7-67.4zM240.7 211.4c4.6 8.7 16.3 9.7 23.3 2.7L438.1 40c7-7 6-18.7-2.7-23.3-20.1-10.7-43-16.7-67.4-16.7-79.5 0-144 64.5-144 144 0 24.3 6 47.3 16.7 67.4zM144 224C79.2 224 24.4 266.8 6.3 325.6 3.4 335.1 11 344 20.9 344l246.2 0c9.9 0 17.5-8.9 14.6-18.4-.9-3-1.9-5.9-3-8.7-37.4-18.1-68-48-87-84.8-14.9-5.2-30.9-8.1-47.6-8.1zM281.7 410.4c2.9-9.5-4.7-18.4-14.6-18.4L20.9 392C11 392 3.4 400.9 6.3 410.4 24.4 469.2 79.2 512 144 512s119.6-42.8 137.7-101.6z"
    ]
};
var $159afdcd077ecfe9$export$43d1fa6671908715 = {
    prefix: 'fas',
    iconName: 'weight-hanging',
    icon: [
        512,
        512,
        [],
        "f5cd",
        "M224 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm122.5 32c3.5-10 5.5-20.8 5.5-32 0-53-43-96-96-96s-96 43-96 96c0 11.2 1.9 22 5.5 32l-21.8 0c-28.3 0-53.2 18.5-61.3 45.6L2.4 440.2C.8 445.4 0 450.8 0 456.2 0 487 25 512 55.8 512l400.4 0c30.8 0 55.8-25 55.8-55.8 0-5.4-.8-10.8-2.4-16l-80-266.5c-8.1-27.1-33-45.6-61.3-45.6l-21.8 0z"
    ]
};
var $159afdcd077ecfe9$export$4ed8206e6619cc8f = {
    prefix: 'fas',
    iconName: 'dice',
    icon: [
        512,
        512,
        [
            127922
        ],
        "f522",
        "M141.4 2.3C103-8 63.5 14.8 53.3 53.2L2.5 242.7C-7.8 281.1 15 320.6 53.4 330.9l189.5 50.8c38.4 10.3 77.9-12.5 88.2-50.9l50.8-189.5c10.3-38.4-12.5-77.9-50.9-88.2L141.4 2.3zm23 205.7a32 32 0 1 1 55.4-32 32 32 0 1 1 -55.4 32zM79.2 220.3a32 32 0 1 1 32 55.4 32 32 0 1 1 -32-55.4zm185 96.4a32 32 0 1 1 -32-55.4 32 32 0 1 1 32 55.4zm9-208.4a32 32 0 1 1 32 55.4 32 32 0 1 1 -32-55.4zm-121 14.4a32 32 0 1 1 -32-55.4 32 32 0 1 1 32 55.4zM418 192L377.4 343.2c-17.2 64-83 102-147 84.9l-38.3-10.3 0 30.2c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-192c0-35.3-28.7-64-64-64L418 192z"
    ]
};
var $159afdcd077ecfe9$export$b3d636689da4a3e5 = {
    prefix: 'fas',
    iconName: 'shop-slash',
    icon: [
        576,
        512,
        [
            "store-alt-slash"
        ],
        "e070",
        "M41-24.9c-9.4-9.4-24.6-9.4-33.9 0S-2.3-.3 7 9.1l528 528c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-57-57 0-190.3c26.8-1.9 48-24.3 48-51.6 0-8-1.9-16-5.5-23.2L497.7 67.4C486.8 45.7 464.7 32 440.4 32L135.6 32c-10.7 0-21 2.7-30.2 7.6L41-24.9zM321.8 256L448 256 448 382.2 321.8 256zM352 421.8l-64-64 0 10.2c0 8.8-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16l0-112 58.2 0-134.8-134.8-29.9 59.9c-3.6 7.2-5.5 15.1-5.5 23.2 0 27.3 21.2 49.7 48 51.6L64 432c0 26.5 21.5 48 48 48l192 0c26.5 0 48-21.5 48-48l0-10.2z"
    ]
};
var $159afdcd077ecfe9$export$b932a586f6ff48b4 = $159afdcd077ecfe9$export$b3d636689da4a3e5;
var $159afdcd077ecfe9$export$58e2577a373e7d4 = {
    prefix: 'fas',
    iconName: 'sort-down',
    icon: [
        384,
        512,
        [
            "sort-desc"
        ],
        "f0dd",
        "M32 288c-12.9 0-24.6 7.8-29.6 19.8S.2 333.5 9.4 342.6l160 160c12.5 12.5 32.8 12.5 45.3 0l160-160c9.2-9.2 11.9-22.9 6.9-34.9S364.9 288 352 288L32 288z"
    ]
};
var $159afdcd077ecfe9$export$e24f016f5f78af6a = $159afdcd077ecfe9$export$58e2577a373e7d4;
var $159afdcd077ecfe9$export$a6f8654bcd49a39f = {
    prefix: 'fas',
    iconName: 'peseta-sign',
    icon: [
        448,
        512,
        [],
        "e221",
        "M112 32C94.3 32 80 46.3 80 64l0 104-24 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 232c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96 96 0c80.2 0 146.6-59 158.2-136l25.8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-25.8 0C386.6 91 320.2 32 240 32L112 32zM333 168l-189 0 0-72 96 0c44.7 0 82.3 30.6 93 72zM144 216l189 0c-10.7 41.4-48.2 72-93 72l-96 0 0-72z"
    ]
};
var $159afdcd077ecfe9$export$df1e253fc358ade4 = {
    prefix: 'fas',
    iconName: 'tablet-screen-button',
    icon: [
        448,
        512,
        [
            "tablet-alt"
        ],
        "f3fa",
        "M0 64C0 28.7 28.7 0 64 0L384 0c35.3 0 64 28.7 64 64l0 384c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM256 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM384 64l-320 0 0 288 320 0 0-288z"
    ]
};
var $159afdcd077ecfe9$export$db0cac088255eacc = $159afdcd077ecfe9$export$df1e253fc358ade4;
var $159afdcd077ecfe9$export$61a67f5f8ab39be = {
    prefix: 'fas',
    iconName: 'hand-holding-dollar',
    icon: [
        576,
        512,
        [
            "hand-holding-usd"
        ],
        "f4c0",
        "M288-16c-13.3 0-24 10.7-24 24l0 12-1.8 0c-36.6 0-66.2 29.7-66.2 66.2 0 33.4 24.9 61.6 58 65.7l61 7.6c5.1 .6 9 5 9 10.2 0 5.7-4.6 10.2-10.2 10.2L240 180c-15.5 0-28 12.5-28 28s12.5 28 28 28l24 0 0 12c0 13.3 10.7 24 24 24s24-10.7 24-24l0-12 1.8 0c36.6 0 66.2-29.7 66.2-66.2 0-33.4-24.9-61.6-58-65.7l-61-7.6c-5.1-.6-9-5-9-10.2 0-5.7 4.6-10.2 10.2-10.2L328 76c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0 0-12c0-13.3-10.7-24-24-24zM109.3 341.5L66.7 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 280 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z"
    ]
};
var $159afdcd077ecfe9$export$47d27bc305b59690 = $159afdcd077ecfe9$export$61a67f5f8ab39be;
var $159afdcd077ecfe9$export$8241bd5b9163ca12 = {
    prefix: 'fas',
    iconName: 'shield',
    icon: [
        512,
        512,
        [
            128737,
            "shield-blank"
        ],
        "f132",
        "M256 0c4.6 0 9.2 1 13.4 2.9L457.8 82.8c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0-172.4-82.5-213.1-264-213.6-363.2-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.9 1 251.4 0 256 0z"
    ]
};
var $159afdcd077ecfe9$export$64f54da8fbaba8ee = $159afdcd077ecfe9$export$8241bd5b9163ca12;
var $159afdcd077ecfe9$export$2f203616c892d415 = {
    prefix: 'fas',
    iconName: 'face-laugh',
    icon: [
        512,
        512,
        [
            "laugh"
        ],
        "f599",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM101.6 314c-3.7-13.7 7.5-26 21.7-26l265.4 0c14.2 0 25.4 12.3 21.7 26-18.5 68-80.6 118-154.4 118S120 382 101.6 314zM144 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
    ]
};
var $159afdcd077ecfe9$export$6c74e314e801a4fe = $159afdcd077ecfe9$export$2f203616c892d415;
var $159afdcd077ecfe9$export$96891bbcda1dbb7b = {
    prefix: 'fas',
    iconName: 'hands-holding',
    icon: [
        640,
        512,
        [],
        "f4c2",
        "M80 104c0-22.1-17.9-40-40-40S0 81.9 0 104L0 325.5c0 25.5 10.1 49.9 28.1 67.9L128 493.3c12 12 28.3 18.7 45.3 18.7l66.7 0c26.5 0 48-21.5 48-48l0-78.9c0-29.7-11.8-58.2-32.8-79.2l-25.3-25.3 0 0c-7.3-7.3-23.1-23.1-47.2-47.2-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c24.1 24.1 39.9 39.9 47.2 47.2 11 11 9.2 29.2-3.7 37.8-9.7 6.5-22.7 5.2-31-3.1L98.7 309.5c-12-12-18.7-28.3-18.7-45.3L80 104zm480 0l0 160.2c0 17-6.7 33.3-18.7 45.3l-51.1 51.1c-8.3 8.3-21.3 9.6-31 3.1-12.9-8.6-14.7-26.9-3.7-37.8 7.3-7.3 23.1-23.1 47.2-47.2 12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-24.1 24.1-39.9 39.9-47.2 47.2l0 0-25.3 25.3c-21 21-32.8 49.5-32.8 79.2l0 78.9c0 26.5 21.5 48 48 48l66.7 0c17 0 33.3-6.7 45.3-18.7l99.9-99.9c18-18 28.1-42.4 28.1-67.9L640 104c0-22.1-17.9-40-40-40s-40 17.9-40 40z"
    ]
};
var $159afdcd077ecfe9$export$c790b41dc166ae13 = {
    prefix: 'fas',
    iconName: 'cart-shopping',
    icon: [
        640,
        512,
        [
            128722,
            "shopping-cart"
        ],
        "f07a",
        "M24-16C10.7-16 0-5.3 0 8S10.7 32 24 32l45.3 0c3.9 0 7.2 2.8 7.9 6.6l52.1 286.3c6.2 34.2 36 59.1 70.8 59.1L456 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-255.9 0c-11.6 0-21.5-8.3-23.6-19.7l-5.1-28.3 303.6 0c30.8 0 57.2-21.9 62.9-52.2L568.9 69.9C572.6 50.2 557.5 32 537.4 32l-412.7 0-.4-2c-4.8-26.6-28-46-55.1-46L24-16zM208 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm224 0a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
    ]
};
var $159afdcd077ecfe9$export$51da406e5aa1388c = $159afdcd077ecfe9$export$c790b41dc166ae13;
var $159afdcd077ecfe9$export$64f52ad9eeb58eda = {
    prefix: 'fas',
    iconName: 'octagon',
    icon: [
        512,
        512,
        [
            128721
        ],
        "f306",
        "M188.6 .1c-17 0-33.3 6.7-45.3 18.7L19.2 143C7.2 155 .5 171.2 .5 188.2l0 135.6c0 17 6.7 33.3 18.7 45.3L143.4 493.2c12 12 28.3 18.7 45.3 18.7l135.6 0c17 0 33.3-6.7 45.3-18.7L493.6 369c12-12 18.7-28.3 18.7-45.3l0-135.6c0-17-6.7-33.3-18.7-45.3L369.5 18.8c-12-12-28.3-18.7-45.3-18.7L188.6 .1z"
    ]
};
var $159afdcd077ecfe9$export$d97ff927c450c87f = {
    prefix: 'fas',
    iconName: 'hand-pointer',
    icon: [
        448,
        512,
        [],
        "f25a",
        "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40l0 148.2c8.5-7.6 19.7-12.2 32-12.2 20.6 0 38.2 13 45 31.2 8.8-9.3 21.2-15.2 35-15.2 25.3 0 46 19.5 47.9 44.3 8.5-7.7 19.8-12.3 32.1-12.3 26.5 0 48 21.5 48 48l0 112c0 70.7-57.3 128-128 128l-85.3 0c-5 0-9.9-.3-14.7-1-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7 0-322.7zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"
    ]
};
var $159afdcd077ecfe9$export$5f519e9ac15ab8c3 = {
    prefix: 'fas',
    iconName: 'registered',
    icon: [
        512,
        512,
        [
            174
        ],
        "f25d",
        "M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM200 144l80 0c39.8 0 72 32.2 72 72 0 28.9-17 53.8-41.6 65.3l30.2 50.3c6.8 11.4 3.1 26.1-8.2 32.9s-26.1 3.1-32.9-8.2l-41-68.3-34.4 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-176c0-13.3 10.7-24 24-24zm72 96l8 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-56 0 0 48 48 0z"
    ]
};
var $159afdcd077ecfe9$export$58845db8e7e9a199 = {
    prefix: 'fas',
    iconName: 'house-signal',
    icon: [
        576,
        512,
        [],
        "e012",
        "M515.9 240l-19.9 0 0 144c0 35.3-28.7 64-64 64l-137 0c-24-91.7-93.5-165-183-194.3l0-13.7-19.9 0c-15.5 0-28.1-12.6-28.1-28.1 0-7.6 3.1-14.9 8.6-20.2L276.5-4.9C283.9-12 293.7-16 304-16s20.1 4 27.5 11.1L535.4 191.7c5.5 5.3 8.6 12.6 8.6 20.2 0 15.5-12.6 28.1-28.1 28.1zM280 192c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24l48 0c13.3 0 24-10.7 24-24l0-48c0-13.3-10.7-24-24-24l-48 0zM24 288c128.1 0 232 103.9 232 232 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-101.6-82.4-184-184-184-13.3 0-24-10.7-24-24s10.7-24 24-24zm8 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 408c0-13.3 10.7-24 24-24 75.1 0 136 60.9 136 136 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-48.6-39.4-88-88-88-13.3 0-24-10.7-24-24z"
    ]
};
var $159afdcd077ecfe9$export$469d376940e10d37 = {
    prefix: 'fas',
    iconName: 'bangladeshi-taka-sign',
    icon: [
        384,
        512,
        [],
        "e2e6",
        "M36 32.3C18.4 30.1 2.4 42.5 .3 60S10.5 93.6 28 95.8l7.9 1c16 2 28 15.6 28 31.8l0 31.5-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 176c0 53 43 96 96 96l32 0c106 0 192-86 192-192l0-32c0-53-43-96-96-96l-16 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l16 0c17.7 0 32 14.3 32 32l0 32c0 70.7-57.3 128-128 128l-32 0c-17.7 0-32-14.3-32-32l0-176 40 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-40 0 0-31.5C128 80.1 92 39.2 43.9 33.2l-7.9-1z"
    ]
};
var $159afdcd077ecfe9$export$da048c47c8dcd50a = {
    fa0: $159afdcd077ecfe9$export$f22454595d96c106,
    fa1: $159afdcd077ecfe9$export$8398cb2addc9e182,
    fa2: $159afdcd077ecfe9$export$ed1a0ff7bd680a1d,
    fa3: $159afdcd077ecfe9$export$74b7ff79ce1818d6,
    fa4: $159afdcd077ecfe9$export$969b2215780d58fd,
    fa5: $159afdcd077ecfe9$export$3919f68a5b3825a9,
    fa6: $159afdcd077ecfe9$export$580ac17b31ffb5c3,
    fa7: $159afdcd077ecfe9$export$ee79cab31be16d23,
    fa8: $159afdcd077ecfe9$export$45d84c4b2c560d2f,
    fa9: $159afdcd077ecfe9$export$a120f1e4223629f2,
    faDollarSign: $159afdcd077ecfe9$export$fb420d3e4d8c6a18,
    faDollar: $159afdcd077ecfe9$export$a4ffb0775547fcdf,
    faUsd: $159afdcd077ecfe9$export$72cca07d38a28589,
    faDog: $159afdcd077ecfe9$export$c6406747800cf702,
    faTruckMoving: $159afdcd077ecfe9$export$a06617a1a4ccea67,
    faRotate: $159afdcd077ecfe9$export$decde496a29c5b23,
    faSyncAlt: $159afdcd077ecfe9$export$2ff2056be8c281e4,
    faSquareMinus: $159afdcd077ecfe9$export$814c9edba7b84aa4,
    faMinusSquare: $159afdcd077ecfe9$export$ffe9387966b3e681,
    faAlignJustify: $159afdcd077ecfe9$export$97c42b56d462df72,
    faCalendarCheck: $159afdcd077ecfe9$export$5655108e1162ba45,
    faFaceKiss: $159afdcd077ecfe9$export$5a54c83033a0a56a,
    faKiss: $159afdcd077ecfe9$export$c762a77aabf64fd0,
    faKitchenSet: $159afdcd077ecfe9$export$64c1570509eaf40d,
    faDna: $159afdcd077ecfe9$export$c062100d54a2da00,
    faChildReaching: $159afdcd077ecfe9$export$84a2f9476730c40e,
    faPaste: $159afdcd077ecfe9$export$6f95f90dd1f6d86b,
    faFileClipboard: $159afdcd077ecfe9$export$ca3229c47de163fa,
    faMeteor: $159afdcd077ecfe9$export$1439f0d6365138da,
    faGears: $159afdcd077ecfe9$export$4aac79b9ae3cfdb8,
    faCogs: $159afdcd077ecfe9$export$af1575770afc9559,
    faFileCirclePlus: $159afdcd077ecfe9$export$430d63b54b1d4009,
    faIcicles: $159afdcd077ecfe9$export$78792ed87d92a3ad,
    faArrowTrendUp: $159afdcd077ecfe9$export$cf36928a9c52e98a,
    faHexagonNodesBolt: $159afdcd077ecfe9$export$f0f9d0c0b0d511dd,
    faQuestion: $159afdcd077ecfe9$export$d96973f90e8f6e47,
    faHandsBound: $159afdcd077ecfe9$export$740142a89118fbc0,
    faPersonWalkingLuggage: $159afdcd077ecfe9$export$1ae0a37b36ace746,
    faFileArrowDown: $159afdcd077ecfe9$export$148bcede94488555,
    faFileDownload: $159afdcd077ecfe9$export$1013b9966d758343,
    faPersonBooth: $159afdcd077ecfe9$export$2337c975289bdd84,
    faLocust: $159afdcd077ecfe9$export$4982360d3b844c19,
    faRightLong: $159afdcd077ecfe9$export$b356b1dbe7d7f736,
    faLongArrowAltRight: $159afdcd077ecfe9$export$533e1f578f74c066,
    faTruckDroplet: $159afdcd077ecfe9$export$41ce20639e8fef2b,
    faHandHoldingMedical: $159afdcd077ecfe9$export$bb2a6b1b5e852300,
    faHandPointLeft: $159afdcd077ecfe9$export$b276ec3dc9760d39,
    faCalculator: $159afdcd077ecfe9$export$693bd40950ed2c3a,
    faMinus: $159afdcd077ecfe9$export$fee0376c250cdef,
    faSubtract: $159afdcd077ecfe9$export$f8cb2531ef1fc4a2,
    faArrowUpZA: $159afdcd077ecfe9$export$a0a53d8e3c68e9f1,
    faSortAlphaUpAlt: $159afdcd077ecfe9$export$95ef20828693fb0f,
    faMicrophoneSlash: $159afdcd077ecfe9$export$843f63d64e6f7951,
    faSquarePen: $159afdcd077ecfe9$export$3643b719db23d46e,
    faPenSquare: $159afdcd077ecfe9$export$fbb231ccb3d960bc,
    faPencilSquare: $159afdcd077ecfe9$export$35d253ecd249e771,
    faHandFist: $159afdcd077ecfe9$export$ca492f58fe30a42f,
    faFistRaised: $159afdcd077ecfe9$export$fa0323a4d7489a8d,
    faCommentSms: $159afdcd077ecfe9$export$435fe17e9d6170d6,
    faSms: $159afdcd077ecfe9$export$9dbcc3443daa7323,
    faSimCard: $159afdcd077ecfe9$export$3bee83bf278fddbe,
    faScaleBalanced: $159afdcd077ecfe9$export$33fb4280dc20f0dd,
    faBalanceScale: $159afdcd077ecfe9$export$fec323dcfd81d750,
    faCar: $159afdcd077ecfe9$export$9eefe7fcdf123b76,
    faAutomobile: $159afdcd077ecfe9$export$240a6c53cf7ac525,
    faCropSimple: $159afdcd077ecfe9$export$c3605731beb92daf,
    faCropAlt: $159afdcd077ecfe9$export$d932915fde4f1010,
    faMedal: $159afdcd077ecfe9$export$b48a5be96314835a,
    faScroll: $159afdcd077ecfe9$export$7c265716d4399676,
    faFileExcel: $159afdcd077ecfe9$export$77cb1a465c4fe84,
    faFilter: $159afdcd077ecfe9$export$f253a38d7142e29f,
    faDrum: $159afdcd077ecfe9$export$5b9205e1042594b7,
    faMapPin: $159afdcd077ecfe9$export$184725965b3402dc,
    faScaleUnbalancedFlip: $159afdcd077ecfe9$export$f4d7840209109993,
    faBalanceScaleRight: $159afdcd077ecfe9$export$2238e05f8920005a,
    faArrowsToCircle: $159afdcd077ecfe9$export$917a3d30f6cd766,
    faEnvelope: $159afdcd077ecfe9$export$6f095630677adc,
    faBaby: $159afdcd077ecfe9$export$8afab767536f59ad,
    faSquareCaretDown: $159afdcd077ecfe9$export$a1ab39cd66c4e50e,
    faCaretSquareDown: $159afdcd077ecfe9$export$61aea18df1c84401,
    faTent: $159afdcd077ecfe9$export$e5075400db564e24,
    faA: $159afdcd077ecfe9$export$406fe05808a3753e,
    faParachuteBox: $159afdcd077ecfe9$export$ca9e3368f1d9500a,
    faCartArrowDown: $159afdcd077ecfe9$export$9206260ff0c0c616,
    faBridgeCircleExclamation: $159afdcd077ecfe9$export$4f25939fdf728c27,
    faCloudArrowUp: $159afdcd077ecfe9$export$3507214fff1cc655,
    faCloudUpload: $159afdcd077ecfe9$export$a48720e6366f5d9a,
    faCloudUploadAlt: $159afdcd077ecfe9$export$e73b3e819b9d14a5,
    faAt: $159afdcd077ecfe9$export$c115e8063ee02632,
    faIndianRupeeSign: $159afdcd077ecfe9$export$1d2b135cc5a2c852,
    faIndianRupee: $159afdcd077ecfe9$export$be886a4def17c565,
    faInr: $159afdcd077ecfe9$export$12c6d8b3e052490b,
    faTruck: $159afdcd077ecfe9$export$d7895f386f8bd8b8,
    faChalkboardUser: $159afdcd077ecfe9$export$fd7622d4b8d3674b,
    faChalkboardTeacher: $159afdcd077ecfe9$export$443fcf69b0155291,
    faUserCheck: $159afdcd077ecfe9$export$76de2a120043c9f8,
    faUserNinja: $159afdcd077ecfe9$export$a9174995732e03c5,
    faPlantWilt: $159afdcd077ecfe9$export$77a38850ff8b0407,
    faWeightScale: $159afdcd077ecfe9$export$e521c542d18b85c3,
    faWeight: $159afdcd077ecfe9$export$cf3bafa68a60bae4,
    faCaretRight: $159afdcd077ecfe9$export$f1011352b01c1c0,
    faFlorinSign: $159afdcd077ecfe9$export$6248ec7440b2ffcb,
    faBell: $159afdcd077ecfe9$export$9b6162797ab1b255,
    faLariSign: $159afdcd077ecfe9$export$d317bc452442782d,
    faMillSign: $159afdcd077ecfe9$export$9b53510cf4010e4d,
    faPersonSnowboarding: $159afdcd077ecfe9$export$22c642403aeeaeaf,
    faSnowboarding: $159afdcd077ecfe9$export$72683772d587302a,
    faTty: $159afdcd077ecfe9$export$7c85aba0f9624b29,
    faTeletype: $159afdcd077ecfe9$export$14bcd5c43dc736f9,
    faUsersRectangle: $159afdcd077ecfe9$export$a28757068b9a3a9a,
    faMobile: $159afdcd077ecfe9$export$59edacfad04cd121,
    faMobileAndroid: $159afdcd077ecfe9$export$82f602311a698c32,
    faMobilePhone: $159afdcd077ecfe9$export$475a9be8da747e57,
    faArrowsTurnToDots: $159afdcd077ecfe9$export$b9d8fdf63999a76d,
    faExclamation: $159afdcd077ecfe9$export$de6218b649cbb6a9,
    faChurch: $159afdcd077ecfe9$export$16a3f12c6ae9650,
    faToggleOff: $159afdcd077ecfe9$export$d20aaceb882ca545,
    faShoePrints: $159afdcd077ecfe9$export$cdbdd2118099ae07,
    faFileCircleExclamation: $159afdcd077ecfe9$export$61fa9809253098e5,
    faWallet: $159afdcd077ecfe9$export$79204db8777905c8,
    faMessage: $159afdcd077ecfe9$export$6563a67224e7f879,
    faCommentAlt: $159afdcd077ecfe9$export$6e96904d9af0ec4a,
    faTrophy: $159afdcd077ecfe9$export$29c432d69ccf85a5,
    faFaceDizzy: $159afdcd077ecfe9$export$635e4d8cc8428961,
    faDizzy: $159afdcd077ecfe9$export$89a2b10dabc487e8,
    faBacteria: $159afdcd077ecfe9$export$7fc18cf2d526c341,
    faEarDeaf: $159afdcd077ecfe9$export$c9c5b76ec992eab4,
    faDeaf: $159afdcd077ecfe9$export$4b666adf83f0de01,
    faDeafness: $159afdcd077ecfe9$export$85c6a9ab2fa2631e,
    faHardOfHearing: $159afdcd077ecfe9$export$ebecf90a5676e17a,
    faPeopleArrows: $159afdcd077ecfe9$export$804bfc5c390e1a2a,
    faPeopleArrowsLeftRight: $159afdcd077ecfe9$export$da01f044c59e3598,
    faHandsClapping: $159afdcd077ecfe9$export$765c446e974b5e59,
    faVirusCovidSlash: $159afdcd077ecfe9$export$61c2a6b698f55df6,
    faCalendarDays: $159afdcd077ecfe9$export$31c6cf6f5d38dc0,
    faCalendarAlt: $159afdcd077ecfe9$export$cbc139f33cff356,
    faDiamondTurnRight: $159afdcd077ecfe9$export$99749ac517cbef07,
    faDirections: $159afdcd077ecfe9$export$6a6973de44442fe5,
    faHandPointUp: $159afdcd077ecfe9$export$cdc9f5e7e94e76da,
    faBezierCurve: $159afdcd077ecfe9$export$a527a6267c55a54c,
    faPersonHalfDress: $159afdcd077ecfe9$export$f3d75c19191f1688,
    faSquarePollHorizontal: $159afdcd077ecfe9$export$287bdd70ab874659,
    faPollH: $159afdcd077ecfe9$export$456a238f0144d430,
    faSchoolCircleXmark: $159afdcd077ecfe9$export$5e17b20e0f6b132b,
    faHandLizard: $159afdcd077ecfe9$export$54608d0a883fea4d,
    faChalkboard: $159afdcd077ecfe9$export$49a36efd66df775,
    faBlackboard: $159afdcd077ecfe9$export$f497e01bf522fd9c,
    faUpRightFromSquare: $159afdcd077ecfe9$export$c1a3ba061b4f60c4,
    faExternalLinkAlt: $159afdcd077ecfe9$export$d7f107e456ab0306,
    faSquareFull: $159afdcd077ecfe9$export$7ec6541fee081990,
    faClover: $159afdcd077ecfe9$export$57813571c0e10a0a,
    faTeethOpen: $159afdcd077ecfe9$export$c88ac21fe7c88ae6,
    faBarsStaggered: $159afdcd077ecfe9$export$2f8a7938c06a2142,
    faReorder: $159afdcd077ecfe9$export$75d2bb378a2fc102,
    faStream: $159afdcd077ecfe9$export$ed81ab40fc4e904,
    faWarehouse: $159afdcd077ecfe9$export$e3a174a50618c208,
    faSwatchbook: $159afdcd077ecfe9$export$c74a20c81b957b6a,
    faCampground: $159afdcd077ecfe9$export$295287303c0e9c7c,
    faPersonWalkingArrowRight: $159afdcd077ecfe9$export$3e15790fe68c095b,
    faGlasses: $159afdcd077ecfe9$export$58d7d709c0a8ca5f,
    faCirclePause: $159afdcd077ecfe9$export$fbeef2513e05ad08,
    faPauseCircle: $159afdcd077ecfe9$export$d8cf08a0362da8db,
    faMemory: $159afdcd077ecfe9$export$5f9bd9f6df021f93,
    faGift: $159afdcd077ecfe9$export$b2727de8ccdbb5ec,
    faMoneyBillWheat: $159afdcd077ecfe9$export$6a4ef2ef77625063,
    faDungeon: $159afdcd077ecfe9$export$1156dc6acb0058bd,
    faSuitcaseMedical: $159afdcd077ecfe9$export$25ea11267429d202,
    faMedkit: $159afdcd077ecfe9$export$e75f02bae5b7d34b,
    faPersonCane: $159afdcd077ecfe9$export$c48422e9da776c1b,
    faGauge: $159afdcd077ecfe9$export$dbfb0a9f89ad94a4,
    faDashboard: $159afdcd077ecfe9$export$b7ce24136743d0f1,
    faGaugeMed: $159afdcd077ecfe9$export$f948a9dd257979f3,
    faTachometerAltAverage: $159afdcd077ecfe9$export$6f22c345e5a92d1a,
    faEnvelopeOpenText: $159afdcd077ecfe9$export$f5c53ce8ec380d11,
    faToolbox: $159afdcd077ecfe9$export$b34d64c205c732a9,
    faPowerOff: $159afdcd077ecfe9$export$a1cca9928dcf9798,
    faSignal: $159afdcd077ecfe9$export$79046b073b6c584d,
    faSignal5: $159afdcd077ecfe9$export$3417071118065933,
    faSignalPerfect: $159afdcd077ecfe9$export$1aea50ab3e99cc95,
    faArrowsSpin: $159afdcd077ecfe9$export$7e05388be208e313,
    faJoint: $159afdcd077ecfe9$export$e5a289fb22ffb8cb,
    faBraille: $159afdcd077ecfe9$export$983e9c27cac7ed1c,
    faBasketShopping: $159afdcd077ecfe9$export$1d307c13b511e8e1,
    faShoppingBasket: $159afdcd077ecfe9$export$ca6d443595a6578f,
    faBridge: $159afdcd077ecfe9$export$f402c7c97f3383f0,
    faPlaneArrival: $159afdcd077ecfe9$export$9b2dbe133273f284,
    faCashRegister: $159afdcd077ecfe9$export$6357093f67788b33,
    faRing: $159afdcd077ecfe9$export$a95486586631edc7,
    faShareNodes: $159afdcd077ecfe9$export$cdaf45d4e50ac035,
    faShareAlt: $159afdcd077ecfe9$export$f8e8bb0b3aa8c658,
    faPersonCircleExclamation: $159afdcd077ecfe9$export$38c8c32017dd9cc,
    faBinoculars: $159afdcd077ecfe9$export$8a910017964bb8c2,
    faKipSign: $159afdcd077ecfe9$export$a6df39524c41472c,
    faHardDrive: $159afdcd077ecfe9$export$4cb736b866cbb7ec,
    faHdd: $159afdcd077ecfe9$export$62551e9c5ba7093f,
    faRankingStar: $159afdcd077ecfe9$export$e6fd420a918b43b5,
    faUserTie: $159afdcd077ecfe9$export$48c51dda34e9f04c,
    faEllipsis: $159afdcd077ecfe9$export$37fe3659ba7b6b54,
    faEllipsisH: $159afdcd077ecfe9$export$c9f2fedd4489a2ee,
    faStoreSlash: $159afdcd077ecfe9$export$4ab2f33219630bad,
    faPercent: $159afdcd077ecfe9$export$89a1764fbb7ad2cb,
    faPercentage: $159afdcd077ecfe9$export$89333857fc063a2e,
    faFileZipper: $159afdcd077ecfe9$export$7a4a0e4caa1e4e6f,
    faFileArchive: $159afdcd077ecfe9$export$bf2047a9946b5c3f,
    faDisplay: $159afdcd077ecfe9$export$e9d85839f7751f01,
    faIcons: $159afdcd077ecfe9$export$7fe2894454d8eb8a,
    faHeartMusicCameraBolt: $159afdcd077ecfe9$export$ec74c13cedb0791d,
    faRulerVertical: $159afdcd077ecfe9$export$a6ad5df9d9f29553,
    faMapLocationDot: $159afdcd077ecfe9$export$757f50b8af780c19,
    faMapMarkedAlt: $159afdcd077ecfe9$export$a977d47c74d8e86c,
    faHeartCrack: $159afdcd077ecfe9$export$8e521ef33062b00e,
    faHeartBroken: $159afdcd077ecfe9$export$4a565395cb65b282,
    faCow: $159afdcd077ecfe9$export$1da3b2e53dcafa2d,
    faRss: $159afdcd077ecfe9$export$7329a1ca27b90c5b,
    faFeed: $159afdcd077ecfe9$export$67ad3d0233cd7b33,
    faMagnifyingGlass: $159afdcd077ecfe9$export$34c8b97060c09ff,
    faSearch: $159afdcd077ecfe9$export$871a78837687ffe8,
    faCloudMoon: $159afdcd077ecfe9$export$482eb125aaf0fbc2,
    faBoxesStacked: $159afdcd077ecfe9$export$2088efcf62cf3b1,
    faBoxes: $159afdcd077ecfe9$export$2007320dd6cde6db,
    faBoxesAlt: $159afdcd077ecfe9$export$e6ef1d896ed63b3e,
    faCodeBranch: $159afdcd077ecfe9$export$aa054a78ab078db3,
    faBan: $159afdcd077ecfe9$export$76f704d256def3c7,
    faCancel: $159afdcd077ecfe9$export$6d25ef56192f6d69,
    faJugDetergent: $159afdcd077ecfe9$export$3fe50bd8062cd141,
    faReply: $159afdcd077ecfe9$export$bb06d4a7bb6736fe,
    faMailReply: $159afdcd077ecfe9$export$12e45ff70d2646a1,
    faSunPlantWilt: $159afdcd077ecfe9$export$8db7f2f70484e17e,
    faBacterium: $159afdcd077ecfe9$export$b0babe4230e35ebe,
    faRecordVinyl: $159afdcd077ecfe9$export$fe2d5012d9982673,
    faFloppyDisk: $159afdcd077ecfe9$export$f62f2879ccaea13f,
    faSave: $159afdcd077ecfe9$export$1aaa83ff70706e1e,
    faToiletsPortable: $159afdcd077ecfe9$export$c00f55f36d386cb7,
    faO: $159afdcd077ecfe9$export$9db87eabf605857e,
    faPalette: $159afdcd077ecfe9$export$5c390baea5db4f77,
    faUnlock: $159afdcd077ecfe9$export$db1382cd406cc506,
    faEarListen: $159afdcd077ecfe9$export$837bc776b490934d,
    faAssistiveListeningSystems: $159afdcd077ecfe9$export$8eeef3dc0035b165,
    faCodePullRequest: $159afdcd077ecfe9$export$37576dfab037d8bf,
    faKey: $159afdcd077ecfe9$export$fa6ecc35e7315db,
    faSkull: $159afdcd077ecfe9$export$138b45e2afb1dfa4,
    faMarsStrokeUp: $159afdcd077ecfe9$export$efc6d53e0dedceee,
    faMarsStrokeV: $159afdcd077ecfe9$export$ed7aa1c25104f333,
    faFireFlameSimple: $159afdcd077ecfe9$export$9ebfff5c90672059,
    faBurn: $159afdcd077ecfe9$export$80ed4535efc60402,
    faTree: $159afdcd077ecfe9$export$1744430f718caf6b,
    faSmog: $159afdcd077ecfe9$export$aa11b8edb09fed14,
    faS: $159afdcd077ecfe9$export$cb39585371b75720,
    faJedi: $159afdcd077ecfe9$export$859f204e59641ca4,
    faPersonHiking: $159afdcd077ecfe9$export$baf9f153991b2ea,
    faHiking: $159afdcd077ecfe9$export$b2ab0105a901499e,
    faArrowsUpToLine: $159afdcd077ecfe9$export$159982ce2622211e,
    faMarsDouble: $159afdcd077ecfe9$export$2f8a28204bb4b86f,
    faThermometer: $159afdcd077ecfe9$export$f576739e9b18ea4f,
    faPaintbrush: $159afdcd077ecfe9$export$7c8b56f3f296a814,
    faPaintBrush: $159afdcd077ecfe9$export$594db3339e212bc9,
    faNeuter: $159afdcd077ecfe9$export$771cf879fba0cf93,
    faSquarePhoneFlip: $159afdcd077ecfe9$export$b627121801cad756,
    faPhoneSquareAlt: $159afdcd077ecfe9$export$a41e77f0de98bba7,
    faFaceGrinTongueSquint: $159afdcd077ecfe9$export$8eee2c17ff89e724,
    faGrinTongueSquint: $159afdcd077ecfe9$export$4edf34c3def09a31,
    faCommentDollar: $159afdcd077ecfe9$export$7a088030853df12c,
    faHippo: $159afdcd077ecfe9$export$d4c909619093de2d,
    faBowlFood: $159afdcd077ecfe9$export$8b89ca3201039376,
    faSquareVirus: $159afdcd077ecfe9$export$f9409a7b020dbec4,
    faCloudSunRain: $159afdcd077ecfe9$export$dd9dc9b4227dbe94,
    faArrowRightLong: $159afdcd077ecfe9$export$becbc35d3541bcc,
    faLongArrowRight: $159afdcd077ecfe9$export$7ec6527cf8651899,
    faBuildingUn: $159afdcd077ecfe9$export$fbbc7601eb465ac7,
    faTemperatureLow: $159afdcd077ecfe9$export$9e9af12b90a1abd2,
    faDoorOpen: $159afdcd077ecfe9$export$41821b9a6fd703de,
    faAlignLeft: $159afdcd077ecfe9$export$e490f662af4d1c78,
    faCamera: $159afdcd077ecfe9$export$84ffbd7161ca2008,
    faCameraAlt: $159afdcd077ecfe9$export$8872b5664e88e793,
    faUsersRays: $159afdcd077ecfe9$export$9c0b63b698611d06,
    faRainbow: $159afdcd077ecfe9$export$92ab27739d3a91b2,
    faSitemap: $159afdcd077ecfe9$export$b2ce5e79d0eccaf8,
    faFaceGrinStars: $159afdcd077ecfe9$export$1d1fbac384a76a12,
    faGrinStars: $159afdcd077ecfe9$export$64347a5c8c402ef4,
    faSortUp: $159afdcd077ecfe9$export$f9dd5b1410e95035,
    faSortAsc: $159afdcd077ecfe9$export$e4c8c924b1cc43a7,
    faEye: $159afdcd077ecfe9$export$b8c3e79e8c99c95b,
    faCaretLeft: $159afdcd077ecfe9$export$85a918a11b7643c2,
    faAppleWhole: $159afdcd077ecfe9$export$12de8220d30453a3,
    faAppleAlt: $159afdcd077ecfe9$export$bcdd94f3977a0884,
    faScrollTorah: $159afdcd077ecfe9$export$4e3fe5b42a6cd494,
    faTorah: $159afdcd077ecfe9$export$54d07baabd8c2acb,
    faHouseLock: $159afdcd077ecfe9$export$aa54b16c409e882f,
    faArrowsLeftRightToLine: $159afdcd077ecfe9$export$a63cecc8a4166c49,
    faTrash: $159afdcd077ecfe9$export$ed8c149a0ea54bb4,
    faFaceSadTear: $159afdcd077ecfe9$export$8a5a0dbb2a17e253,
    faSadTear: $159afdcd077ecfe9$export$4b5241926f692f91,
    faFax: $159afdcd077ecfe9$export$b5698497901d7197,
    faPersonCirclePlus: $159afdcd077ecfe9$export$55686b1eb7d00307,
    faHamsa: $159afdcd077ecfe9$export$38d20d399463edf9,
    faPersonCircleQuestion: $159afdcd077ecfe9$export$c8f8a597ffd676c0,
    faClipboardCheck: $159afdcd077ecfe9$export$7babcb2c90eb609a,
    faShareFromSquare: $159afdcd077ecfe9$export$928280bdd54fa173,
    faShareSquare: $159afdcd077ecfe9$export$ae9e1434571f373c,
    faReceipt: $159afdcd077ecfe9$export$32b0cd6133c2742,
    faEquals: $159afdcd077ecfe9$export$a7c5f5e4805fdab,
    faChevronUp: $159afdcd077ecfe9$export$877e5ae47a854215,
    faVirusSlash: $159afdcd077ecfe9$export$c4ff5306c5470939,
    faSlash: $159afdcd077ecfe9$export$f54d004dd5f1cb5e,
    faExpand: $159afdcd077ecfe9$export$1fe4a9976a241685,
    faNoteSticky: $159afdcd077ecfe9$export$4a4e034527c933f5,
    faStickyNote: $159afdcd077ecfe9$export$80889adc5d98bf4a,
    faTableColumns: $159afdcd077ecfe9$export$ccaa019a3fd4563f,
    faColumns: $159afdcd077ecfe9$export$bb861166644ac28a,
    faPersonShelter: $159afdcd077ecfe9$export$d359c2cc7640953c,
    faCircleNotch: $159afdcd077ecfe9$export$9429fd8df55155d,
    faWater: $159afdcd077ecfe9$export$efaeddad0a6e901b,
    faDeleteLeft: $159afdcd077ecfe9$export$bbcc9e0b6022772b,
    faBackspace: $159afdcd077ecfe9$export$e43e3f67102fc526,
    faBroomBall: $159afdcd077ecfe9$export$3e1327487ce53231,
    faQuidditch: $159afdcd077ecfe9$export$c00c446e6db1605f,
    faQuidditchBroomBall: $159afdcd077ecfe9$export$791bfe29b97b4d42,
    faJ: $159afdcd077ecfe9$export$bbf24078bd1f73e6,
    faShuttleSpace: $159afdcd077ecfe9$export$76d92e7f30d064c5,
    faSpaceShuttle: $159afdcd077ecfe9$export$4d1c12ba2b4ca565,
    faYinYang: $159afdcd077ecfe9$export$6ec1acbf3f610b8f,
    faStop: $159afdcd077ecfe9$export$51577929c676143b,
    faTrowel: $159afdcd077ecfe9$export$12ca996a6f686fe1,
    faHandBackFist: $159afdcd077ecfe9$export$be38a892fe9b4098,
    faHandRock: $159afdcd077ecfe9$export$97a81eba394c8c44,
    faTemperatureHigh: $159afdcd077ecfe9$export$15d012277c3ecf9a,
    faGreaterThan: $159afdcd077ecfe9$export$da07b6bc24a496ca,
    faCrutch: $159afdcd077ecfe9$export$e94134641c0e2,
    faSeptagon: $159afdcd077ecfe9$export$90261b091a6ebcaa,
    faHeptagon: $159afdcd077ecfe9$export$5946c0574351cb6f,
    faStreetView: $159afdcd077ecfe9$export$6aab6c3359c2554c,
    faWaveSquare: $159afdcd077ecfe9$export$c38cf504b3bc58a2,
    faAngleLeft: $159afdcd077ecfe9$export$3cbcd1b7e35945d2,
    faScrewdriver: $159afdcd077ecfe9$export$7484ff654cd6474f,
    faTractor: $159afdcd077ecfe9$export$e87e41787bbedc98,
    faBridgeCircleXmark: $159afdcd077ecfe9$export$834071278537f121,
    faVials: $159afdcd077ecfe9$export$507e8edd7676b2e9,
    faStethoscope: $159afdcd077ecfe9$export$acb2d72d28cd92d9,
    faPodcast: $159afdcd077ecfe9$export$5c0b4709125e92f8,
    faArrowUpRightDots: $159afdcd077ecfe9$export$bc804c6ab898f610,
    faChessQueen: $159afdcd077ecfe9$export$7b8ce73615739d30,
    faAnchorCircleExclamation: $159afdcd077ecfe9$export$61add9eca991b5ec,
    faEllipsisVertical: $159afdcd077ecfe9$export$7480721bf113be3e,
    faEllipsisV: $159afdcd077ecfe9$export$e58494c7fcb5380,
    faHeartCircleExclamation: $159afdcd077ecfe9$export$3772719b170306e2,
    faBuildingCircleExclamation: $159afdcd077ecfe9$export$c49f030b19083ebe,
    faPersonArrowUpFromLine: $159afdcd077ecfe9$export$5709329dd2b70bdc,
    faNotEqual: $159afdcd077ecfe9$export$6a15ccae09bbaf93,
    faTrainTram: $159afdcd077ecfe9$export$d401d4aeba21cdf3,
    faPlaneDeparture: $159afdcd077ecfe9$export$6ccbeeccfea6dc8a,
    faRightToBracket: $159afdcd077ecfe9$export$a5fd2acfcb5247c6,
    faSignInAlt: $159afdcd077ecfe9$export$e6709746115bd2ea,
    faSdCard: $159afdcd077ecfe9$export$303efb6031da122,
    faHouseCircleExclamation: $159afdcd077ecfe9$export$8403e4b31e8aa805,
    faShekelSign: $159afdcd077ecfe9$export$3570be7b68efb8db,
    faIls: $159afdcd077ecfe9$export$ecadeff45b05a451,
    faShekel: $159afdcd077ecfe9$export$27e0e10e74d98736,
    faSheqel: $159afdcd077ecfe9$export$28b3b26a80030d4e,
    faSheqelSign: $159afdcd077ecfe9$export$d84993fb5e8c6edd,
    faRadio: $159afdcd077ecfe9$export$11b26516cae2104f,
    faHandDots: $159afdcd077ecfe9$export$8846d49caaed1c0a,
    faAllergies: $159afdcd077ecfe9$export$dcae2101babbffff,
    faBookSkull: $159afdcd077ecfe9$export$a57d448e8969ce8a,
    faBookDead: $159afdcd077ecfe9$export$b98a3f8c3941a74a,
    faUnlockKeyhole: $159afdcd077ecfe9$export$c98fdd5082b333ec,
    faUnlockAlt: $159afdcd077ecfe9$export$b19f508797f3d9c3,
    faFileArrowUp: $159afdcd077ecfe9$export$929df388c07f293d,
    faFileUpload: $159afdcd077ecfe9$export$dd55ded1264643d2,
    faFaceGrinTears: $159afdcd077ecfe9$export$8ac6d81a3d5b40a1,
    faGrinTears: $159afdcd077ecfe9$export$b2f7512221512b5b,
    faPenToSquare: $159afdcd077ecfe9$export$ba236543926e3569,
    faEdit: $159afdcd077ecfe9$export$7be713e57d023733,
    faEarthEurope: $159afdcd077ecfe9$export$7adefae4a1be1d97,
    faGlobeEurope: $159afdcd077ecfe9$export$5318b8ede86cc96b,
    faFaceGrinBeamSweat: $159afdcd077ecfe9$export$2ff38f330c834084,
    faGrinBeamSweat: $159afdcd077ecfe9$export$14d0ccc54c5b6826,
    faCircleHalfStroke: $159afdcd077ecfe9$export$625fb3848216f28c,
    faAdjust: $159afdcd077ecfe9$export$cfa06e4b68edca2d,
    faPersonMilitaryToPerson: $159afdcd077ecfe9$export$41b1e14a6b0fe11b,
    faTableCellsColumnLock: $159afdcd077ecfe9$export$257af4c5fc557105,
    faTruckFieldUn: $159afdcd077ecfe9$export$40cb0a4a3a74dc03,
    faClock: $159afdcd077ecfe9$export$95b9968e7fceb821,
    faClockFour: $159afdcd077ecfe9$export$9a575facf1cab48f,
    faBook: $159afdcd077ecfe9$export$c9d7ef726d1a8742,
    faFaceLaughWink: $159afdcd077ecfe9$export$600a1b26b33c3d47,
    faLaughWink: $159afdcd077ecfe9$export$77ac40095f39933e,
    faCloudMeatball: $159afdcd077ecfe9$export$5d120e8b87ad33f4,
    faChartArea: $159afdcd077ecfe9$export$2acab8312b7a999b,
    faAreaChart: $159afdcd077ecfe9$export$fc2e595f0e0612cb,
    faRupiahSign: $159afdcd077ecfe9$export$fe44d4c71644ea0,
    faTextWidth: $159afdcd077ecfe9$export$d8724cf433389700,
    faSatellite: $159afdcd077ecfe9$export$da3f1730d013e224,
    faMagnifyingGlassMinus: $159afdcd077ecfe9$export$56d810b9ab2e30bc,
    faSearchMinus: $159afdcd077ecfe9$export$efca97eef6a7a17d,
    faPeopleGroup: $159afdcd077ecfe9$export$be015e72863c3635,
    faSquareBinary: $159afdcd077ecfe9$export$3cbda23149da6f11,
    faMasksTheater: $159afdcd077ecfe9$export$bf5896cc1ce4d55,
    faTheaterMasks: $159afdcd077ecfe9$export$3dbedc487b0159ac,
    faCartPlus: $159afdcd077ecfe9$export$6675e2bf21fdb87e,
    faHandsAslInterpreting: $159afdcd077ecfe9$export$bc43eb4655c78f49,
    faAmericanSignLanguageInterpreting: $159afdcd077ecfe9$export$23a7517099ab1b86,
    faAslInterpreting: $159afdcd077ecfe9$export$beb51abfb05a4eca,
    faHandsAmericanSignLanguageInterpreting: $159afdcd077ecfe9$export$82846008645b0301,
    faTableCellsRowUnlock: $159afdcd077ecfe9$export$59ce5ca5da74ff72,
    faRocket: $159afdcd077ecfe9$export$b24d84ed5657d89a,
    faShrimp: $159afdcd077ecfe9$export$ac094c06f566cca3,
    faTengeSign: $159afdcd077ecfe9$export$c04e864469c1d117,
    faTenge: $159afdcd077ecfe9$export$af6ebee83047b793,
    faHouseChimneyMedical: $159afdcd077ecfe9$export$9c73560282dceccd,
    faClinicMedical: $159afdcd077ecfe9$export$20d8a680febc7434,
    faUsersSlash: $159afdcd077ecfe9$export$b71a093b86e3da1f,
    faPaperPlane: $159afdcd077ecfe9$export$b5378818301da1be,
    faBookAtlas: $159afdcd077ecfe9$export$7fb8daedae341012,
    faAtlas: $159afdcd077ecfe9$export$380a9050e42fe5d7,
    faTable: $159afdcd077ecfe9$export$36583f5d3d5a971f,
    faHeart: $159afdcd077ecfe9$export$e4b51a47a2f8b9db,
    faCircleChevronUp: $159afdcd077ecfe9$export$7b69b3617b84259b,
    faChevronCircleUp: $159afdcd077ecfe9$export$b786cf5db03f2c36,
    faBatteryHalf: $159afdcd077ecfe9$export$e6dadc1155c4ee48,
    faBattery3: $159afdcd077ecfe9$export$f9138caac2aedaed,
    faFontAwesome: $159afdcd077ecfe9$export$aa4baaed1c60f58d,
    faFontAwesomeFlag: $159afdcd077ecfe9$export$102c25fde54d4843,
    faFontAwesomeLogoFull: $159afdcd077ecfe9$export$6e20d421a2e0f320,
    faHandcuffs: $159afdcd077ecfe9$export$74d1f89b5feb9d42,
    faHatCowboySide: $159afdcd077ecfe9$export$ab6f71fd6878da90,
    faIndustry: $159afdcd077ecfe9$export$5548c3eb51060fa8,
    faLinesLeaning: $159afdcd077ecfe9$export$4d384ffc907ddaff,
    faPassport: $159afdcd077ecfe9$export$2c31ca0d9bee400f,
    faInfinity: $159afdcd077ecfe9$export$a590003279d671b8,
    faClone: $159afdcd077ecfe9$export$76c1aa4bf9a39458,
    faForward: $159afdcd077ecfe9$export$a8710cdb23198d53,
    faM: $159afdcd077ecfe9$export$bd6a7788954842b5,
    faRoadSpikes: $159afdcd077ecfe9$export$b372a24046126ad8,
    faMountain: $159afdcd077ecfe9$export$64f9eb99c9749cce,
    faChess: $159afdcd077ecfe9$export$442fddbbd741c590,
    faTemperatureThreeQuarters: $159afdcd077ecfe9$export$7ed2bad15ae6237f,
    faTemperature3: $159afdcd077ecfe9$export$89def3268ed9b4bc,
    faThermometer3: $159afdcd077ecfe9$export$2f653125f4e6463,
    faThermometerThreeQuarters: $159afdcd077ecfe9$export$6c632d1dc30d4a77,
    faB: $159afdcd077ecfe9$export$fa30fcd1e0d0d8,
    faShieldVirus: $159afdcd077ecfe9$export$bea811bbf570f05a,
    faLitecoinSign: $159afdcd077ecfe9$export$4a157bd81dcd8d80,
    faDiceD6: $159afdcd077ecfe9$export$64bfd48ed353c031,
    faGripLinesVertical: $159afdcd077ecfe9$export$523960de087f5198,
    faGolfBallTee: $159afdcd077ecfe9$export$14c9f1d85e53ae99,
    faGolfBall: $159afdcd077ecfe9$export$2251487a9a33c682,
    faHexagon: $159afdcd077ecfe9$export$ab681aaf692a5a8a,
    faFolderOpen: $159afdcd077ecfe9$export$ff7e93418af88b78,
    faKaaba: $159afdcd077ecfe9$export$ab1408bfbe914cc9,
    faHandHolding: $159afdcd077ecfe9$export$e6094d25274088ab,
    faSingleQuoteRight: $159afdcd077ecfe9$export$a59391493212cfa2,
    faBottleDroplet: $159afdcd077ecfe9$export$8f534e1e0ab75bfe,
    faWindowMinimize: $159afdcd077ecfe9$export$26a3f9d2784b90d8,
    faChevronRight: $159afdcd077ecfe9$export$930de8c26eb20490,
    faEgg: $159afdcd077ecfe9$export$1199a8ce85311ab5,
    faLandmarkDome: $159afdcd077ecfe9$export$8a56136f40511e5d,
    faLandmarkAlt: $159afdcd077ecfe9$export$8b9c180efffc50ab,
    faWorm: $159afdcd077ecfe9$export$2571e33fa6c25993,
    faUserInjured: $159afdcd077ecfe9$export$c950c1ba7f227d5b,
    faStrikethrough: $159afdcd077ecfe9$export$eff51ea25b4de135,
    faBlog: $159afdcd077ecfe9$export$890d5e011054935a,
    faStopwatch20: $159afdcd077ecfe9$export$df6244b0501f2112,
    faTruckPickup: $159afdcd077ecfe9$export$f846b848b3ba3064,
    faSeedling: $159afdcd077ecfe9$export$d7b60b8dbd03cfe4,
    faSprout: $159afdcd077ecfe9$export$9f3035e3a8c62323,
    faTransgender: $159afdcd077ecfe9$export$7e3f1701aa95ef01,
    faTransgenderAlt: $159afdcd077ecfe9$export$9c36cf9334c052f,
    faStarHalf: $159afdcd077ecfe9$export$228008b5e11032fa,
    faPhotoFilm: $159afdcd077ecfe9$export$ed36ad335b36be22,
    faPhotoVideo: $159afdcd077ecfe9$export$739f6a6a12dfb6ed,
    faPumpMedical: $159afdcd077ecfe9$export$f1b881c73328720c,
    faFire: $159afdcd077ecfe9$export$7b24b34ef6cc130c,
    faMagnifyingGlassPlus: $159afdcd077ecfe9$export$f48a3ba52a0a9e56,
    faSearchPlus: $159afdcd077ecfe9$export$378f00e6b1a8185,
    faFlask: $159afdcd077ecfe9$export$f9b579ba06048af,
    faAlignRight: $159afdcd077ecfe9$export$7370f36a39a38737,
    faCableCar: $159afdcd077ecfe9$export$85cb04eaefaf2d8b,
    faTram: $159afdcd077ecfe9$export$a7a36674c079f293,
    faKitMedical: $159afdcd077ecfe9$export$f04e7a0f1033a0cd,
    faFirstAid: $159afdcd077ecfe9$export$5b01ccb2da4c4387,
    faGripLines: $159afdcd077ecfe9$export$1412f35381064d7d,
    faBurger: $159afdcd077ecfe9$export$128a6cab12423493,
    faHamburger: $159afdcd077ecfe9$export$bab3bb9f4f59363,
    faSnowman: $159afdcd077ecfe9$export$b23df6bafb174693,
    faHotel: $159afdcd077ecfe9$export$c402efcf01d5ca07,
    faPrint: $159afdcd077ecfe9$export$ae64371e02ee8e56,
    faVolleyball: $159afdcd077ecfe9$export$cc519c9529a46c5c,
    faVolleyballBall: $159afdcd077ecfe9$export$a15e6fc8e68a76b0,
    faTrafficLight: $159afdcd077ecfe9$export$bf0b19daceaec9c2,
    faPlaneCircleCheck: $159afdcd077ecfe9$export$9cbf8612c6cadc74,
    faUsers: $159afdcd077ecfe9$export$e5a8f011aef571ac,
    faCertificate: $159afdcd077ecfe9$export$a881f37164b11fbf,
    faAlarmClock: $159afdcd077ecfe9$export$cca6f644647deaf3,
    faHelicopterSymbol: $159afdcd077ecfe9$export$2a66e6044c1f7036,
    faHouseChimneyCrack: $159afdcd077ecfe9$export$e824540f5a6a8a57,
    faHouseDamage: $159afdcd077ecfe9$export$8d7e943005ce0b49,
    faPersonMilitaryPointing: $159afdcd077ecfe9$export$50b6dcaa9ec03439,
    faDatabase: $159afdcd077ecfe9$export$24680dede86b1883,
    faNewspaper: $159afdcd077ecfe9$export$d91b374112d4f8c1,
    faCloudRain: $159afdcd077ecfe9$export$a6c308ee087b4ded,
    faMaximize: $159afdcd077ecfe9$export$8d2b1b230601e804,
    faExpandArrowsAlt: $159afdcd077ecfe9$export$6219dcd88b5fa6c2,
    faLocationArrow: $159afdcd077ecfe9$export$4ac9c4c370f7b157,
    faCity: $159afdcd077ecfe9$export$a9947c2888b3c8fd,
    faXRay: $159afdcd077ecfe9$export$8cf137aceaaf4de0,
    faUmbrellaBeach: $159afdcd077ecfe9$export$20932e4d438e4e4c,
    faArrowRightToBracket: $159afdcd077ecfe9$export$a02c5909359525be,
    faSignIn: $159afdcd077ecfe9$export$a55eff0ca4f9c3df,
    faHeadset: $159afdcd077ecfe9$export$23b086400a31acfe,
    faSplotch: $159afdcd077ecfe9$export$d6f21e17ea797702,
    faUpLong: $159afdcd077ecfe9$export$5608156cc81126e7,
    faLongArrowAltUp: $159afdcd077ecfe9$export$43c8f2a46326c55f,
    faHexagonNodes: $159afdcd077ecfe9$export$b75f0f1ba423de5f,
    faHospital: $159afdcd077ecfe9$export$7a76c9d35b42d691,
    faHospitalAlt: $159afdcd077ecfe9$export$cea7736417b94a3b,
    faHospitalWide: $159afdcd077ecfe9$export$69c8cc0360f017e8,
    faPersonHarassing: $159afdcd077ecfe9$export$dcd74f2821882a49,
    faMoneyBillTrendUp: $159afdcd077ecfe9$export$18ab80cba7d5044f,
    faPenRuler: $159afdcd077ecfe9$export$85ba06027671d290,
    faPencilRuler: $159afdcd077ecfe9$export$e3a7a1affea005f5,
    faRepeat: $159afdcd077ecfe9$export$cb8434288c91ae83,
    faBone: $159afdcd077ecfe9$export$5902c007d5703f2d,
    faFireFlameCurved: $159afdcd077ecfe9$export$769724fc1434d618,
    faFireAlt: $159afdcd077ecfe9$export$70dc26b4926d0b1b,
    faBusSimple: $159afdcd077ecfe9$export$d3724faf0c559353,
    faBusAlt: $159afdcd077ecfe9$export$40616edfab6d332a,
    faVenusMars: $159afdcd077ecfe9$export$63f2d9e5f4689aa8,
    faBlender: $159afdcd077ecfe9$export$db34f7a6de38784f,
    faU: $159afdcd077ecfe9$export$4f39e8dbaf09ea8b,
    faShare: $159afdcd077ecfe9$export$c08b4b0e2b0dc027,
    faMailForward: $159afdcd077ecfe9$export$81df7693d3f2f8da,
    faPhoneFlip: $159afdcd077ecfe9$export$d86c56ab43eb0deb,
    faPhoneAlt: $159afdcd077ecfe9$export$a07a9b305deebf32,
    faToiletPortable: $159afdcd077ecfe9$export$a3a5de5f6e2513ba,
    faPersonPregnant: $159afdcd077ecfe9$export$e7b4c26b5857fe9c,
    faLessThan: $159afdcd077ecfe9$export$7f24f1bf98af5411,
    faSuperscript: $159afdcd077ecfe9$export$4fa56a54e822dd25,
    faCircleStop: $159afdcd077ecfe9$export$229de76dfef2687f,
    faStopCircle: $159afdcd077ecfe9$export$47af2aad60ab3e7c,
    faArrowsUpDown: $159afdcd077ecfe9$export$64185f27d82c259f,
    faArrowsV: $159afdcd077ecfe9$export$cec5f1bc9e068e48,
    faPooStorm: $159afdcd077ecfe9$export$48a38da471b097a2,
    faPooBolt: $159afdcd077ecfe9$export$9a24e77f74d9cbd9,
    faVideoSlash: $159afdcd077ecfe9$export$a714fc79f58cc9ef,
    faSquareXmark: $159afdcd077ecfe9$export$5a17e58bb7afb1d7,
    faTimesSquare: $159afdcd077ecfe9$export$c0248ac97142ea2a,
    faXmarkSquare: $159afdcd077ecfe9$export$9a364781d6b7602b,
    faHandHoldingDroplet: $159afdcd077ecfe9$export$b9c3f9a906f96b82,
    faHandHoldingWater: $159afdcd077ecfe9$export$4265371b99d38b95,
    faWonSign: $159afdcd077ecfe9$export$51790ddd26e431bc,
    faKrw: $159afdcd077ecfe9$export$2f65e07a45b95b50,
    faWon: $159afdcd077ecfe9$export$5a1fd3ed9564d7fa,
    faObjectUngroup: $159afdcd077ecfe9$export$887f6345573abcac,
    faComment: $159afdcd077ecfe9$export$805cd88398a70581,
    faHillAvalanche: $159afdcd077ecfe9$export$50d11c98c99e3b2d,
    faArrowsToEye: $159afdcd077ecfe9$export$9adae865350879af,
    faSnowplow: $159afdcd077ecfe9$export$695fae58f55c3a87,
    faChartGantt: $159afdcd077ecfe9$export$dce43b02b3fe0c18,
    faVideo: $159afdcd077ecfe9$export$5c6bd8729527871b,
    faVideoCamera: $159afdcd077ecfe9$export$3a530df752193ccf,
    faChessPawn: $159afdcd077ecfe9$export$3db75d5ac9e98468,
    faSynagogue: $159afdcd077ecfe9$export$20d991385719b5b4,
    faBuildingCircleCheck: $159afdcd077ecfe9$export$5559de5f969b9590,
    faCalendarPlus: $159afdcd077ecfe9$export$16768a660ae3ca9d,
    faWheelchairMove: $159afdcd077ecfe9$export$1482162f7fe04ac,
    faWheelchairAlt: $159afdcd077ecfe9$export$7db9460785019040,
    faUserShield: $159afdcd077ecfe9$export$d1886bc596424e6c,
    faBold: $159afdcd077ecfe9$export$7e0c7fd2a2e88823,
    faHeartPulse: $159afdcd077ecfe9$export$a6d8e50dcd4b4294,
    faHeartbeat: $159afdcd077ecfe9$export$ca880e19206e80aa,
    faSquareRootVariable: $159afdcd077ecfe9$export$60b44cfa7af18422,
    faSquareRootAlt: $159afdcd077ecfe9$export$28e4b96627e00057,
    faHandsBubbles: $159afdcd077ecfe9$export$2f78563e14e49916,
    faHandsWash: $159afdcd077ecfe9$export$996b5dea53b124e3,
    faMarker: $159afdcd077ecfe9$export$e6789173649caa25,
    faClipboard: $159afdcd077ecfe9$export$97d84347d71ba297,
    faPlaceOfWorship: $159afdcd077ecfe9$export$c5a9302c8c13c79a,
    faCannabis: $159afdcd077ecfe9$export$8ec2f752344b69bd,
    faPeopleRoof: $159afdcd077ecfe9$export$b96e695bdcf3f3f5,
    faDisease: $159afdcd077ecfe9$export$c7675a37487adc45,
    faBookBible: $159afdcd077ecfe9$export$df8194b081d34b27,
    faBible: $159afdcd077ecfe9$export$2eac809b0670d139,
    faChessBoard: $159afdcd077ecfe9$export$bd301515df6246af,
    faMars: $159afdcd077ecfe9$export$a9f5c0b9c1e77a6f,
    faLaptop: $159afdcd077ecfe9$export$c2dee3bd177275a2,
    faUserXmark: $159afdcd077ecfe9$export$e585697127cda27,
    faUserTimes: $159afdcd077ecfe9$export$45b996d071667753,
    faFlagUsa: $159afdcd077ecfe9$export$19357abad396e723,
    faHandMiddleFinger: $159afdcd077ecfe9$export$bd40d3a3a16fb147,
    faMortarPestle: $159afdcd077ecfe9$export$55ceb5d0c144580a,
    faHeadSideCough: $159afdcd077ecfe9$export$3cd04b7c1624f598,
    faPlaneLock: $159afdcd077ecfe9$export$1125ac57be52258c,
    faBatteryThreeQuarters: $159afdcd077ecfe9$export$cfb37069d38f379e,
    faBattery4: $159afdcd077ecfe9$export$35ffefed200d123c,
    faFrancSign: $159afdcd077ecfe9$export$acef3e5c2029d285,
    faFilterCircleDollar: $159afdcd077ecfe9$export$3300e4b4d1d1936f,
    faFunnelDollar: $159afdcd077ecfe9$export$cebe38ad8f0a143d,
    faCheese: $159afdcd077ecfe9$export$549b99473b7201e6,
    faCircleH: $159afdcd077ecfe9$export$bf5674308c61894f,
    faHospitalSymbol: $159afdcd077ecfe9$export$c8a3c78d99c23fed,
    faSchool: $159afdcd077ecfe9$export$51e9b8434982947d,
    faDiceFive: $159afdcd077ecfe9$export$d9769fb795c2db82,
    faTornado: $159afdcd077ecfe9$export$6d274258ba4b0089,
    faJetFighter: $159afdcd077ecfe9$export$2130e629ab767ab3,
    faFighterJet: $159afdcd077ecfe9$export$102b809faf56e033,
    faThumbsDown: $159afdcd077ecfe9$export$aba24ca305bbe8c1,
    faBroom: $159afdcd077ecfe9$export$2a533051418ff4ca,
    faFileImport: $159afdcd077ecfe9$export$d796c05153b1255c,
    faArrowRightToFile: $159afdcd077ecfe9$export$32f14beaf6294476,
    faUtensils: $159afdcd077ecfe9$export$750d52edc1dafc7,
    faCutlery: $159afdcd077ecfe9$export$7034e54a8036c5c8,
    faIdBadge: $159afdcd077ecfe9$export$a75288855ea05282,
    faSpider: $159afdcd077ecfe9$export$6daa96b1986e2ef0,
    faMobileRetro: $159afdcd077ecfe9$export$7955f08360418647,
    faSignsPost: $159afdcd077ecfe9$export$905f45f8ffd6b8e5,
    faMapSigns: $159afdcd077ecfe9$export$743f4b1071b3333a,
    faGroupArrowsRotate: $159afdcd077ecfe9$export$88a8383ecdd39a54,
    faArrowsSplitUpAndLeft: $159afdcd077ecfe9$export$7df274119d2469d1,
    faFillDrip: $159afdcd077ecfe9$export$38320138fc0262d0,
    faShieldHeart: $159afdcd077ecfe9$export$7b96388ca2be471b,
    faPersonSkiingNordic: $159afdcd077ecfe9$export$c8cd1786449517d3,
    faSkiingNordic: $159afdcd077ecfe9$export$6ea48260d7d09b1b,
    faSquareCheck: $159afdcd077ecfe9$export$5bb6a0c94ad2f4bb,
    faCheckSquare: $159afdcd077ecfe9$export$f0c8040f596df7fe,
    faBath: $159afdcd077ecfe9$export$1ea66a88b8f620c9,
    faBathtub: $159afdcd077ecfe9$export$40ae013b5e6269d8,
    faChessBishop: $159afdcd077ecfe9$export$a831eedd2f59c62f,
    faPrescriptionBottleMedical: $159afdcd077ecfe9$export$99cfe064ff0b71c9,
    faPrescriptionBottleAlt: $159afdcd077ecfe9$export$65d1c884b8581d1a,
    faDrawPolygon: $159afdcd077ecfe9$export$df9bd3777d1154d2,
    faVectorPolygon: $159afdcd077ecfe9$export$2294366830f9b562,
    faICursor: $159afdcd077ecfe9$export$7fddf76ec23943d8,
    faHeartCirclePlus: $159afdcd077ecfe9$export$2a155a6e20f64134,
    faShieldDog: $159afdcd077ecfe9$export$2a5c6f182c0cbcb,
    faGreaterThanEqual: $159afdcd077ecfe9$export$7bf8dfe2e6661a54,
    faEnvelopeOpen: $159afdcd077ecfe9$export$c6c3bd5f7d9b8bf2,
    faMound: $159afdcd077ecfe9$export$ac54ffffdb218383,
    faVoicemail: $159afdcd077ecfe9$export$4f1ce88b2b4cd5cd,
    faVest: $159afdcd077ecfe9$export$c8370e53051a657,
    faAudioDescription: $159afdcd077ecfe9$export$b6b464c98c009494,
    faW: $159afdcd077ecfe9$export$c7f24bdea332f90a,
    faEyeDropper: $159afdcd077ecfe9$export$1bc3e0ad56dc9eb0,
    faEyeDropperEmpty: $159afdcd077ecfe9$export$ef304e9b7524c1f9,
    faEyedropper: $159afdcd077ecfe9$export$91549a375c0b6d25,
    faCircleXmark: $159afdcd077ecfe9$export$30262489773a79a3,
    faTimesCircle: $159afdcd077ecfe9$export$ab0ec50720a747eb,
    faXmarkCircle: $159afdcd077ecfe9$export$90ac4096df8efdee,
    faTrailer: $159afdcd077ecfe9$export$3a48b9820e92f5ab,
    faTurkishLiraSign: $159afdcd077ecfe9$export$b458d393151b6960,
    faTry: $159afdcd077ecfe9$export$970dda513e46c41f,
    faTurkishLira: $159afdcd077ecfe9$export$40e66e5966827199,
    faVolcano: $159afdcd077ecfe9$export$bae30a76735500e1,
    faWandSparkles: $159afdcd077ecfe9$export$76cc39f249b6864e,
    faMicrophone: $159afdcd077ecfe9$export$eed3c491effe6d12,
    faCrown: $159afdcd077ecfe9$export$dc1083dcd1d7b9d6,
    faTentArrowTurnLeft: $159afdcd077ecfe9$export$89af87b7d6c15adf,
    faTruckFast: $159afdcd077ecfe9$export$27de16299ddd171,
    faShippingFast: $159afdcd077ecfe9$export$5e419f47aaeb3c05,
    faUserPen: $159afdcd077ecfe9$export$3842882ea09b25af,
    faUserEdit: $159afdcd077ecfe9$export$a68a6960fc8eef82,
    faUserClock: $159afdcd077ecfe9$export$b00596a09aa07311,
    faShower: $159afdcd077ecfe9$export$f7f7c15f18cc19a1,
    faSquareCaretUp: $159afdcd077ecfe9$export$66068918abb14406,
    faCaretSquareUp: $159afdcd077ecfe9$export$307ae80b26533ce5,
    faMapLocation: $159afdcd077ecfe9$export$9a8788ec0e4a9a0b,
    faMapMarked: $159afdcd077ecfe9$export$df04458e7e32352c,
    faPenFancy: $159afdcd077ecfe9$export$8bdfe14ac72a8b17,
    faEuroSign: $159afdcd077ecfe9$export$902a3969bb113dff,
    faEur: $159afdcd077ecfe9$export$4b859160cfeb12ff,
    faEuro: $159afdcd077ecfe9$export$bdabbefede2d3a2,
    faHouseCircleXmark: $159afdcd077ecfe9$export$423555e8708eb4c7,
    faLiraSign: $159afdcd077ecfe9$export$f0f37dbc60110b10,
    faYenSign: $159afdcd077ecfe9$export$30f1437f5a4e991d,
    faCny: $159afdcd077ecfe9$export$268a23eee8f089a2,
    faJpy: $159afdcd077ecfe9$export$5460a9192eb79bf5,
    faRmb: $159afdcd077ecfe9$export$e2a8016afc962883,
    faYen: $159afdcd077ecfe9$export$cf914b1afb9455a2,
    faBoxOpen: $159afdcd077ecfe9$export$9010ed816a8b9c97,
    faTruckField: $159afdcd077ecfe9$export$f4419f7b2e53b340,
    faLocationPinLock: $159afdcd077ecfe9$export$db853fbb474326cc,
    faPersonPraying: $159afdcd077ecfe9$export$8ecd436ef91fc02e,
    faPray: $159afdcd077ecfe9$export$3b32c982141cad51,
    faClipboardList: $159afdcd077ecfe9$export$2c5a9d8548d8810e,
    faSackDollar: $159afdcd077ecfe9$export$15854c4475080853,
    faMountainSun: $159afdcd077ecfe9$export$af9eaee7db3ba7a9,
    faArrowUpWideShort: $159afdcd077ecfe9$export$63f4908401ded049,
    faSortAmountUp: $159afdcd077ecfe9$export$28ef3e933e4b5364,
    faUsersLine: $159afdcd077ecfe9$export$d7e538fddb81da68,
    faStarOfDavid: $159afdcd077ecfe9$export$f823fee3712b2601,
    faNotesMedical: $159afdcd077ecfe9$export$b2d79133c81d6697,
    faAustralSign: $159afdcd077ecfe9$export$299c200ad3db97b4,
    faClipboardUser: $159afdcd077ecfe9$export$1204f2d171424659,
    faFileImage: $159afdcd077ecfe9$export$6440b286d3cbac9b,
    faSquareCaretRight: $159afdcd077ecfe9$export$5b1d41cdd118ea6d,
    faCaretSquareRight: $159afdcd077ecfe9$export$ae86c9de7e0f62fa,
    faVial: $159afdcd077ecfe9$export$aa014b06d2d70598,
    faHelicopter: $159afdcd077ecfe9$export$612d3e1afaf45fa5,
    faMitten: $159afdcd077ecfe9$export$5030322c5fc886d7,
    faGasPump: $159afdcd077ecfe9$export$84666c793cb2a347,
    faEnvelopeCircleCheck: $159afdcd077ecfe9$export$74d890536dbd21b7,
    faPersonSkating: $159afdcd077ecfe9$export$f3854553fe688388,
    faSkating: $159afdcd077ecfe9$export$21bd1d54bd4f2c5a,
    faSun: $159afdcd077ecfe9$export$2fa35dcbc038dbe9,
    faBaseball: $159afdcd077ecfe9$export$dc3654cf8a596fbf,
    faBaseballBall: $159afdcd077ecfe9$export$63a3f8ceae07c7f3,
    faImage: $159afdcd077ecfe9$export$7e9f0928967e03b,
    faNotdef: $159afdcd077ecfe9$export$3db5bca65a1be8dc,
    faBasketball: $159afdcd077ecfe9$export$44dee69e3a29b0e,
    faBasketballBall: $159afdcd077ecfe9$export$36550ab8ffcc5b28,
    faPencil: $159afdcd077ecfe9$export$c72de95adaca18b8,
    faPencilAlt: $159afdcd077ecfe9$export$8210adc172262df,
    faPersonWalkingArrowLoopLeft: $159afdcd077ecfe9$export$5a200e8504b7367a,
    faDiceSix: $159afdcd077ecfe9$export$3397c7b4679acccc,
    faAnglesDown: $159afdcd077ecfe9$export$52783a541b1bb03,
    faAngleDoubleDown: $159afdcd077ecfe9$export$fd504117f273ca92,
    faSyringe: $159afdcd077ecfe9$export$1aa9423ec6b1d609,
    faWheatAwn: $159afdcd077ecfe9$export$79d4dac715a51fdf,
    faWheatAlt: $159afdcd077ecfe9$export$deaf03a29aa05e3a,
    faPlaneUp: $159afdcd077ecfe9$export$a5f2976a01fdc970,
    faAlignCenter: $159afdcd077ecfe9$export$70e29dd05344623e,
    faHockeyPuck: $159afdcd077ecfe9$export$a274b02dc75663dc,
    faCircleArrowLeft: $159afdcd077ecfe9$export$827fbb87bdbe1028,
    faArrowCircleLeft: $159afdcd077ecfe9$export$728262abb9f58d0a,
    faPlugCircleBolt: $159afdcd077ecfe9$export$4f3b3144ce966486,
    faRestroom: $159afdcd077ecfe9$export$5fbcef35138741a5,
    faAnchorLock: $159afdcd077ecfe9$export$217195c80db39097,
    faTimeline: $159afdcd077ecfe9$export$5e239d90ef904a84,
    faLightbulb: $159afdcd077ecfe9$export$1e80f89fe84a215b,
    faCircleArrowRight: $159afdcd077ecfe9$export$2f1e22e081a1ad05,
    faArrowCircleRight: $159afdcd077ecfe9$export$7d3d828103aa3be7,
    faMarsAndVenus: $159afdcd077ecfe9$export$808b88e8735e31e8,
    faNetworkWired: $159afdcd077ecfe9$export$882cabd11f4943b8,
    faBuildingShield: $159afdcd077ecfe9$export$18ba6a500873dba9,
    faCode: $159afdcd077ecfe9$export$eba095993e51cc97,
    faFeatherPointed: $159afdcd077ecfe9$export$2a9d3e120019c92d,
    faFeatherAlt: $159afdcd077ecfe9$export$68cf766c786bcd78,
    faFileCircleQuestion: $159afdcd077ecfe9$export$877d3692c1f94bda,
    faSignature: $159afdcd077ecfe9$export$afa7b53ac8ebcb5d,
    faEarthAmericas: $159afdcd077ecfe9$export$9c4218a898614082,
    faEarth: $159afdcd077ecfe9$export$c2118d3775773870,
    faEarthAmerica: $159afdcd077ecfe9$export$8b0f3a26397cf632,
    faGlobeAmericas: $159afdcd077ecfe9$export$e96bcc7bde9498db,
    faCarrot: $159afdcd077ecfe9$export$28e93ec9f5e2ddf3,
    faTemperatureFull: $159afdcd077ecfe9$export$bf4d97a79734997f,
    faTemperature4: $159afdcd077ecfe9$export$db946f8dc50a57ca,
    faThermometer4: $159afdcd077ecfe9$export$92b2e2293472dd50,
    faThermometerFull: $159afdcd077ecfe9$export$74e07083cef79a6f,
    faTableCellsRowLock: $159afdcd077ecfe9$export$2c0ab34218da6651,
    faBoltLightning: $159afdcd077ecfe9$export$b16dcd08f3da1ba2,
    faCloudShowersWater: $159afdcd077ecfe9$export$b416056e795d2eac,
    faArrowUpLong: $159afdcd077ecfe9$export$92c58defe6e4c5a7,
    faLongArrowUp: $159afdcd077ecfe9$export$ede1d50ec4b01670,
    faAddressCard: $159afdcd077ecfe9$export$6ea408c7266ed557,
    faContactCard: $159afdcd077ecfe9$export$4ac51eb0b298b190,
    faVcard: $159afdcd077ecfe9$export$91228257deb1bf18,
    faAngleRight: $159afdcd077ecfe9$export$6bce1afb61f2eb66,
    faFaceMeh: $159afdcd077ecfe9$export$dc130582748497c6,
    faMeh: $159afdcd077ecfe9$export$6d2db489aaeeecd2,
    faArrowUpFromGroundWater: $159afdcd077ecfe9$export$cbe485a104805f4f,
    faMap: $159afdcd077ecfe9$export$fc82fb79180cd17c,
    faUserPlus: $159afdcd077ecfe9$export$4c17261776a709f2,
    faVenus: $159afdcd077ecfe9$export$f89d028573ffc0a6,
    faDiagramSuccessor: $159afdcd077ecfe9$export$ff7f40159cadb0ac,
    faHeadSideCoughSlash: $159afdcd077ecfe9$export$b293ee8fb8e6b0c4,
    faDiagramProject: $159afdcd077ecfe9$export$59c351869dc27435,
    faProjectDiagram: $159afdcd077ecfe9$export$30bf9f5b96509df1,
    faTerminal: $159afdcd077ecfe9$export$5e63e8b85b5f119c,
    faHouseFire: $159afdcd077ecfe9$export$947ee033a6942aa8,
    faMask: $159afdcd077ecfe9$export$7b028758c03b9655,
    faHurricane: $159afdcd077ecfe9$export$4cf54a379be7e59a,
    faEarthAfrica: $159afdcd077ecfe9$export$11afa141d42099d0,
    faGlobeAfrica: $159afdcd077ecfe9$export$64af36f3b403a57c,
    faThumbtack: $159afdcd077ecfe9$export$b6314cdc01bb5c43,
    faThumbTack: $159afdcd077ecfe9$export$b63d0c7b519a9aae,
    faHandPointDown: $159afdcd077ecfe9$export$f6dcbf0a940428f4,
    faFaceMehBlank: $159afdcd077ecfe9$export$38c072b870a9e4ab,
    faMehBlank: $159afdcd077ecfe9$export$e945435725f71e88,
    faTemperatureEmpty: $159afdcd077ecfe9$export$ac389bf5cc37feb5,
    faTemperature0: $159afdcd077ecfe9$export$e99b7d2ccc282383,
    faThermometer0: $159afdcd077ecfe9$export$4c13a186ecce3b80,
    faThermometerEmpty: $159afdcd077ecfe9$export$81a2f8298cf523f9,
    faBorderNone: $159afdcd077ecfe9$export$2b488402ec335d97,
    faHighlighter: $159afdcd077ecfe9$export$73801ed54b42fabe,
    faMoneyBillWave: $159afdcd077ecfe9$export$53e23123cc9a6796,
    faToiletPaperSlash: $159afdcd077ecfe9$export$7a494edbf9b65575,
    faFileShield: $159afdcd077ecfe9$export$348a01df65a66c99,
    faTextHeight: $159afdcd077ecfe9$export$3313bce3924ea7da,
    faFaceGrinTongue: $159afdcd077ecfe9$export$95a7394c24f57943,
    faGrinTongue: $159afdcd077ecfe9$export$ef222816a43a4b3a,
    faFileSignature: $159afdcd077ecfe9$export$d0de575ac166712b,
    faBuildingWheat: $159afdcd077ecfe9$export$6c0cfe6d58faf860,
    faPlugCircleMinus: $159afdcd077ecfe9$export$2a44d62160972254,
    faFutbol: $159afdcd077ecfe9$export$65a345b33858a655,
    faFutbolBall: $159afdcd077ecfe9$export$51a344ca0a215620,
    faSoccerBall: $159afdcd077ecfe9$export$f4a29712c724ba2d,
    faCirclePlus: $159afdcd077ecfe9$export$eeda28b8ca4cb18e,
    faPlusCircle: $159afdcd077ecfe9$export$d9cc3a81499af48c,
    faBrazilianRealSign: $159afdcd077ecfe9$export$9d355b4e79216962,
    faStarAndCrescent: $159afdcd077ecfe9$export$cafa834c96ebcb1a,
    faFaceSurprise: $159afdcd077ecfe9$export$c938968e28178994,
    faSurprise: $159afdcd077ecfe9$export$46647c72213f53ba,
    faHospitalUser: $159afdcd077ecfe9$export$684703c93d630cc5,
    faArrowDownUpLock: $159afdcd077ecfe9$export$fc9f7bd981c34c45,
    faFolder: $159afdcd077ecfe9$export$72b780186370e953,
    faFolderBlank: $159afdcd077ecfe9$export$9ef114244d26da0,
    faHollyBerry: $159afdcd077ecfe9$export$273296afacf93991,
    faVenusDouble: $159afdcd077ecfe9$export$6a6f9cba7a1e5fe4,
    faClipboardQuestion: $159afdcd077ecfe9$export$d4aa151a4554b74e,
    faHotdog: $159afdcd077ecfe9$export$9fae219b4d3ce0be,
    faArrowUpFromBracket: $159afdcd077ecfe9$export$c2af1be14cd87640,
    faMicroscope: $159afdcd077ecfe9$export$6a99139787bf9967,
    faCloud: $159afdcd077ecfe9$export$8bb3c4d5c2f50243,
    faBaseballBatBall: $159afdcd077ecfe9$export$59669f486ab41d86,
    faCarRear: $159afdcd077ecfe9$export$ff2b8d5628da5f14,
    faCarAlt: $159afdcd077ecfe9$export$7937ed2462a665c0,
    faThumbtackSlash: $159afdcd077ecfe9$export$e1ef956136031821,
    faThumbTackSlash: $159afdcd077ecfe9$export$e7a52e4a0831fa96,
    faPlusMinus: $159afdcd077ecfe9$export$37bd38cf96417095,
    faHouseCircleCheck: $159afdcd077ecfe9$export$c9382fa3394ef53a,
    faCalendarDay: $159afdcd077ecfe9$export$80968bcfef6481ca,
    faCircle: $159afdcd077ecfe9$export$4280b2387fbdad12,
    faMobileVibrate: $159afdcd077ecfe9$export$e6a2ba52560007f5,
    faFaceGrinSquint: $159afdcd077ecfe9$export$5d53da7627754bc6,
    faGrinSquint: $159afdcd077ecfe9$export$243ae757907b1580,
    faUsersBetweenLines: $159afdcd077ecfe9$export$6ea1decf8bb3513d,
    faHouseMedicalCircleXmark: $159afdcd077ecfe9$export$bf221f0e8296233e,
    faTableList: $159afdcd077ecfe9$export$6e989c3c7050dbb,
    faThList: $159afdcd077ecfe9$export$daf2614a457122c0,
    faFlaskVial: $159afdcd077ecfe9$export$a25a266ce0c95019,
    faCircleExclamation: $159afdcd077ecfe9$export$59573943f9eebbd5,
    faExclamationCircle: $159afdcd077ecfe9$export$220e07e14c5d7e5d,
    faTaxi: $159afdcd077ecfe9$export$9958afcdfece1b58,
    faCab: $159afdcd077ecfe9$export$7bf12d9380f0971b,
    faTextSlash: $159afdcd077ecfe9$export$ec658c0f040c3e1a,
    faRemoveFormat: $159afdcd077ecfe9$export$d91179f327329532,
    faPeoplePulling: $159afdcd077ecfe9$export$dace56f632fecf6f,
    faBackward: $159afdcd077ecfe9$export$ae65f96ea7a4078d,
    faCarBurst: $159afdcd077ecfe9$export$6d2be7c5d395dd16,
    faCarCrash: $159afdcd077ecfe9$export$8ff55566398404cd,
    faLink: $159afdcd077ecfe9$export$88bc01ff8dbecc55,
    faChain: $159afdcd077ecfe9$export$b5d071e02a25554f,
    faBackwardStep: $159afdcd077ecfe9$export$5d2b6a700940df16,
    faStepBackward: $159afdcd077ecfe9$export$2884e379aed297d4,
    faX: $159afdcd077ecfe9$export$476af662c0c32cbc,
    faCircleUser: $159afdcd077ecfe9$export$9a5c11a5e3d7f1e7,
    faUserCircle: $159afdcd077ecfe9$export$be7d974e9e0dba1a,
    faRectangleList: $159afdcd077ecfe9$export$1f7600fa9fdb3978,
    faListAlt: $159afdcd077ecfe9$export$c6327a203ffc65a3,
    faHand: $159afdcd077ecfe9$export$f69db0b876f7d753,
    faHandPaper: $159afdcd077ecfe9$export$6e6216c8b50471bb,
    faVanShuttle: $159afdcd077ecfe9$export$ecbd233b96906ee1,
    faShuttleVan: $159afdcd077ecfe9$export$9d63d851db698c09,
    faStairs: $159afdcd077ecfe9$export$68b3af7444c89df7,
    faHorseHead: $159afdcd077ecfe9$export$5bcca85203ebd1e8,
    faVault: $159afdcd077ecfe9$export$4689a147513594a7,
    faDrumSteelpan: $159afdcd077ecfe9$export$48d1206500db2e9d,
    faThumbsUp: $159afdcd077ecfe9$export$47e4e0d519d33497,
    faStamp: $159afdcd077ecfe9$export$722e92d2d93ffc68,
    faMenorah: $159afdcd077ecfe9$export$232452c59d77c56e,
    faChildren: $159afdcd077ecfe9$export$f2819bf60df55912,
    faChartLine: $159afdcd077ecfe9$export$e022f62a119e1d93,
    faLineChart: $159afdcd077ecfe9$export$f729617a20de475b,
    faSquareEnvelope: $159afdcd077ecfe9$export$15da4ef8c0fb20d6,
    faEnvelopeSquare: $159afdcd077ecfe9$export$354e159473e73552,
    faBanSmoking: $159afdcd077ecfe9$export$130df7ed74437774,
    faSmokingBan: $159afdcd077ecfe9$export$e50452a49dec29f,
    faTruckFront: $159afdcd077ecfe9$export$4a5a13c01d46357c,
    faBuilding: $159afdcd077ecfe9$export$f26673f8b10c3d46,
    faBullseye: $159afdcd077ecfe9$export$554720e3bf74fe90,
    faArrowLeftLong: $159afdcd077ecfe9$export$6e5225f0e6c0bacd,
    faLongArrowLeft: $159afdcd077ecfe9$export$80896efc906118b4,
    faChessRook: $159afdcd077ecfe9$export$5d65c40a109eb09c,
    faBlenderPhone: $159afdcd077ecfe9$export$f35a116a762ef8fc,
    faArrowTurnUp: $159afdcd077ecfe9$export$2d3ccb9b2099f3fe,
    faLevelUp: $159afdcd077ecfe9$export$c227d3ba1de97ceb,
    faBicycle: $159afdcd077ecfe9$export$36cb1885ad7a570f,
    faCircleArrowDown: $159afdcd077ecfe9$export$a30c52cde32bec7e,
    faArrowCircleDown: $159afdcd077ecfe9$export$6cfa36bbb3a057,
    faGear: $159afdcd077ecfe9$export$ec05accb7226d001,
    faCog: $159afdcd077ecfe9$export$d6298bbfd1912a78,
    faMarsAndVenusBurst: $159afdcd077ecfe9$export$1dc6221efb867885,
    faOtter: $159afdcd077ecfe9$export$743cce3ca4eb1d7d,
    faCircleChevronLeft: $159afdcd077ecfe9$export$f2b13ad44c03c40f,
    faChevronCircleLeft: $159afdcd077ecfe9$export$4a42c8c2451a33fd,
    faCircleQuestion: $159afdcd077ecfe9$export$d7cf0978afd90002,
    faQuestionCircle: $159afdcd077ecfe9$export$5ba67d7f2265c1a5,
    faWalkieTalkie: $159afdcd077ecfe9$export$8a322f740d64e9fc,
    faUserGroup: $159afdcd077ecfe9$export$3d626cfc365a7e36,
    faUserFriends: $159afdcd077ecfe9$export$46073bec205635d9,
    faHouseChimney: $159afdcd077ecfe9$export$af554427144a7e5c,
    faHomeLg: $159afdcd077ecfe9$export$dbab81727ec94698,
    faRightFromBracket: $159afdcd077ecfe9$export$122a80ae0f87f726,
    faSignOutAlt: $159afdcd077ecfe9$export$c844d6923b7096c2,
    faFile: $159afdcd077ecfe9$export$cad54bead856a678,
    faPlaneSlash: $159afdcd077ecfe9$export$cfee4df0d5df6d21,
    faCloudShowersHeavy: $159afdcd077ecfe9$export$af51c741ee9cc090,
    faPersonFalling: $159afdcd077ecfe9$export$e94ab3a30cf4aca5,
    faTurnDown: $159afdcd077ecfe9$export$b5dc9dd0347bbb6,
    faLevelDownAlt: $159afdcd077ecfe9$export$c07eb6ff5a382cbd,
    faUpRightAndDownLeftFromCenter: $159afdcd077ecfe9$export$95457ede07b81517,
    faExpandAlt: $159afdcd077ecfe9$export$bcb8d86a3a1d6eb6,
    faUserTag: $159afdcd077ecfe9$export$9eec597148166b36,
    faHandSparkles: $159afdcd077ecfe9$export$72e2d874a963de0c,
    faArrowsToDot: $159afdcd077ecfe9$export$ab3a06d4b53c0fc0,
    faFaceSadCry: $159afdcd077ecfe9$export$e8ea88c55e55be7c,
    faSadCry: $159afdcd077ecfe9$export$8e924e6bd422cef9,
    faDongSign: $159afdcd077ecfe9$export$18659308f17918a5,
    faPeopleLine: $159afdcd077ecfe9$export$d12c2d6def120efe,
    faSquareRss: $159afdcd077ecfe9$export$97d1903b1e012ff7,
    faRssSquare: $159afdcd077ecfe9$export$89c9b1cca2c11484,
    faCalendarMinus: $159afdcd077ecfe9$export$23e8b4955c2d951b,
    faChartDiagram: $159afdcd077ecfe9$export$eae84dfa654882b1,
    faFaceTired: $159afdcd077ecfe9$export$5352cbdc070ce8d,
    faTired: $159afdcd077ecfe9$export$3d016d62cda18371,
    faHandPointRight: $159afdcd077ecfe9$export$f7bc8714c970afa4,
    faArrowUp: $159afdcd077ecfe9$export$8e144ed4d52eef49,
    faCubesStacked: $159afdcd077ecfe9$export$b1f00c433aabac05,
    faChildCombatant: $159afdcd077ecfe9$export$f7367a7301f2dc0f,
    faChildRifle: $159afdcd077ecfe9$export$9b027cdb5db3ae5c,
    faVestPatches: $159afdcd077ecfe9$export$750a64470c2e0f3f,
    faMartiniGlassEmpty: $159afdcd077ecfe9$export$a8a0de30198815a3,
    faGlassMartini: $159afdcd077ecfe9$export$e96f280e39af4a91,
    faMagnet: $159afdcd077ecfe9$export$78932e9c9abea6b7,
    faRoadBarrier: $159afdcd077ecfe9$export$f3e925217e396f44,
    faCompassDrafting: $159afdcd077ecfe9$export$aaaddd2cf7e20f64,
    faDraftingCompass: $159afdcd077ecfe9$export$c8c2b127d13b9d79,
    faSquarePersonConfined: $159afdcd077ecfe9$export$8aaca358568da0e0,
    faPlateWheat: $159afdcd077ecfe9$export$2eff9f6cbe00a643,
    faSignHanging: $159afdcd077ecfe9$export$5c1f29f4c7cad367,
    faSign: $159afdcd077ecfe9$export$d21d0d6c8e9e8bf9,
    faCarBattery: $159afdcd077ecfe9$export$a44d0c11093d9c1e,
    faBatteryCar: $159afdcd077ecfe9$export$9133165ca669dd4b,
    faShirt: $159afdcd077ecfe9$export$312f2c01c6fedca8,
    faTShirt: $159afdcd077ecfe9$export$144e5f8bc4d705a6,
    faTshirt: $159afdcd077ecfe9$export$36edce3ba87c2b17,
    faParagraph: $159afdcd077ecfe9$export$dec46f8df1860e0,
    faEnvelopesBulk: $159afdcd077ecfe9$export$dc2cce064a1e70bb,
    faMailBulk: $159afdcd077ecfe9$export$dd24f40c5337e2e1,
    faGuitar: $159afdcd077ecfe9$export$790dd5b32282b6fb,
    faSuitcase: $159afdcd077ecfe9$export$60710f3921019268,
    faCircleUp: $159afdcd077ecfe9$export$72ea8a5e4e86cd69,
    faArrowAltCircleUp: $159afdcd077ecfe9$export$3747a8ef0995eadf,
    faF: $159afdcd077ecfe9$export$a2f384a559654618,
    faXmarksLines: $159afdcd077ecfe9$export$f4595f012786d346,
    faEarthOceania: $159afdcd077ecfe9$export$bd931e906edf2f47,
    faGlobeOceania: $159afdcd077ecfe9$export$8ac3f5271448657d,
    faCommentSlash: $159afdcd077ecfe9$export$3786a0422a3f33ea,
    faPlay: $159afdcd077ecfe9$export$436587205947bca5,
    faVialCircleCheck: $159afdcd077ecfe9$export$2db4f9712313eafa,
    faBridgeCircleCheck: $159afdcd077ecfe9$export$ea908d3d80c57d08,
    faCediSign: $159afdcd077ecfe9$export$66c557f70914132c,
    faPuzzlePiece: $159afdcd077ecfe9$export$7ee0dbd1e92e2859,
    faHelmetUn: $159afdcd077ecfe9$export$5e975cb293c48461,
    faGlassWater: $159afdcd077ecfe9$export$b80f542550a05ea7,
    faHeartCircleBolt: $159afdcd077ecfe9$export$2a376a9d0d8fee96,
    faPumpSoap: $159afdcd077ecfe9$export$821aeede187f23c9,
    faHandScissors: $159afdcd077ecfe9$export$c578e919f2c5c135,
    faDolly: $159afdcd077ecfe9$export$5879d0bca1aa497b,
    faDollyBox: $159afdcd077ecfe9$export$461bbb9e92cc531b,
    faPaperclip: $159afdcd077ecfe9$export$4b24ca1552f410af,
    faDemocrat: $159afdcd077ecfe9$export$a1672d808fbed0bd,
    faSquareArrowUpRight: $159afdcd077ecfe9$export$38150b61dfd06fff,
    faExternalLinkSquare: $159afdcd077ecfe9$export$e04d83fed5ebcebf,
    faFerry: $159afdcd077ecfe9$export$fd312949b97346ae,
    faMosquito: $159afdcd077ecfe9$export$67c7a1518d0715ff,
    faBuildingCircleArrowRight: $159afdcd077ecfe9$export$37584b1a5e175b47,
    faLeftRight: $159afdcd077ecfe9$export$47d93e9001818ee7,
    faArrowsAltH: $159afdcd077ecfe9$export$7937ea574fb1389,
    faVirus: $159afdcd077ecfe9$export$37c67e0b3dc6bd1b,
    faGem: $159afdcd077ecfe9$export$31ee86ac717db552,
    faToilet: $159afdcd077ecfe9$export$505476859b9691c0,
    faSingleQuoteLeft: $159afdcd077ecfe9$export$672c4d040d7fbc44,
    faMoneyBills: $159afdcd077ecfe9$export$a822dad6e586ee9e,
    faTabletButton: $159afdcd077ecfe9$export$2d33c367b2b091ac,
    faRectangleXmark: $159afdcd077ecfe9$export$3896694b3e81fba7,
    faRectangleTimes: $159afdcd077ecfe9$export$eaaf26416a51dc1,
    faTimesRectangle: $159afdcd077ecfe9$export$10147c0014152a3f,
    faWindowClose: $159afdcd077ecfe9$export$18b7775f78a3e16,
    faWrench: $159afdcd077ecfe9$export$3c6c0c8185296ac5,
    faTrashCan: $159afdcd077ecfe9$export$864bb8d6c21fb792,
    faTrashAlt: $159afdcd077ecfe9$export$88df7ff7eb32f9dc,
    faTableCells: $159afdcd077ecfe9$export$c517dffc18db483f,
    faTh: $159afdcd077ecfe9$export$4d383c83efc0c819,
    faRibbon: $159afdcd077ecfe9$export$838459d11f3971df,
    faLandmarkFlag: $159afdcd077ecfe9$export$f4d472cf47be4096,
    faUpDownLeftRight: $159afdcd077ecfe9$export$cd7b22f4e6e3834b,
    faArrowsAlt: $159afdcd077ecfe9$export$3cdabfff52cfc73a,
    faCarSide: $159afdcd077ecfe9$export$6f7218565b1b8d0e,
    faTrashArrowUp: $159afdcd077ecfe9$export$940cea0f5451895c,
    faTrashRestore: $159afdcd077ecfe9$export$d32f45a64ed40e8d,
    faLifeRing: $159afdcd077ecfe9$export$53dd2cacf674142a,
    faCopyright: $159afdcd077ecfe9$export$da61665fff8aebfe,
    faFilePrescription: $159afdcd077ecfe9$export$a20cb90865b6beb8,
    faEraser: $159afdcd077ecfe9$export$e7fc4fe34e767f28,
    faHourglassStart: $159afdcd077ecfe9$export$f0c28584caa8f4b,
    faHourglass1: $159afdcd077ecfe9$export$87929336ab5c59cd,
    faCircleLeft: $159afdcd077ecfe9$export$5ae86b9da9cca3bd,
    faArrowAltCircleLeft: $159afdcd077ecfe9$export$5460a5b11a24996f,
    faCruzeiroSign: $159afdcd077ecfe9$export$64dd1b27affb6572,
    faSmoking: $159afdcd077ecfe9$export$c4ab83701fc591a5,
    faSquarePollVertical: $159afdcd077ecfe9$export$91d747e5aabe6fe8,
    faPoll: $159afdcd077ecfe9$export$bc8ca14ab51f93db,
    faPersonCircleMinus: $159afdcd077ecfe9$export$d7ccc6651f90f7cc,
    faBiohazard: $159afdcd077ecfe9$export$ae3a453550dec95,
    faBellConcierge: $159afdcd077ecfe9$export$e433538b78718fb3,
    faConciergeBell: $159afdcd077ecfe9$export$ad92ffbbfbc0fcf3,
    faRulerHorizontal: $159afdcd077ecfe9$export$46c6347bff3e04a,
    faHorse: $159afdcd077ecfe9$export$5b05f097fa38352a,
    faCalendar: $159afdcd077ecfe9$export$34f5c36a3e80efa2,
    faHandsHoldingChild: $159afdcd077ecfe9$export$bfb254bf3c0bc50b,
    faItalic: $159afdcd077ecfe9$export$16e344bae4d495ed,
    faKhanda: $159afdcd077ecfe9$export$8d41d1f1ba3f9217,
    faFaceFrownOpen: $159afdcd077ecfe9$export$c8a28356e07b9ccb,
    faFrownOpen: $159afdcd077ecfe9$export$c4775e66bed5d96,
    faCheck: $159afdcd077ecfe9$export$62b2c752fccc6a9c,
    faFingerprint: $159afdcd077ecfe9$export$614dc068d88655af,
    faChargingStation: $159afdcd077ecfe9$export$bab2cd86f8c65657,
    faUserLock: $159afdcd077ecfe9$export$d9b89b5872b67a4f,
    faMobileScreenButton: $159afdcd077ecfe9$export$da39ed20699ee2d7,
    faMobileAlt: $159afdcd077ecfe9$export$e9599bc6cd92234d,
    faAnchorCircleCheck: $159afdcd077ecfe9$export$8bce49e6ae597af8,
    faPersonWalkingWithCane: $159afdcd077ecfe9$export$2ffee5b2bc935c1f,
    faBlind: $159afdcd077ecfe9$export$923de21def6ea9b6,
    faFileWaveform: $159afdcd077ecfe9$export$5e0c19cf315ac1bf,
    faFileMedicalAlt: $159afdcd077ecfe9$export$ef02a0f5b39aa61f,
    faHouseCrack: $159afdcd077ecfe9$export$baa3c215534dbf2a,
    faHatWizard: $159afdcd077ecfe9$export$7daa48199dcb2ad1,
    faUserDoctor: $159afdcd077ecfe9$export$9884bf227eeb829,
    faUserMd: $159afdcd077ecfe9$export$ab0d33a2c03f1794,
    faChartBar: $159afdcd077ecfe9$export$b532f5d25de97633,
    faBarChart: $159afdcd077ecfe9$export$2d5f754a5e5738b,
    faSprayCanSparkles: $159afdcd077ecfe9$export$43832c90c10a7a31,
    faAirFreshener: $159afdcd077ecfe9$export$a5e63e89b5ccee83,
    faBahtSign: $159afdcd077ecfe9$export$ffc7123046a28ee,
    faTemperatureArrowUp: $159afdcd077ecfe9$export$d7a5da41ce01461d,
    faTemperatureUp: $159afdcd077ecfe9$export$872345a0157330a3,
    faWebAwesome: $159afdcd077ecfe9$export$5fa0ffae6770a0cc,
    faNonBinary: $159afdcd077ecfe9$export$f7742803bef3f397,
    faN: $159afdcd077ecfe9$export$328a9baf0f9e3405,
    faArrowsUpDownLeftRight: $159afdcd077ecfe9$export$ff9a43e3a9cb653c,
    faArrows: $159afdcd077ecfe9$export$d5ae09a305d70340,
    faHouse: $159afdcd077ecfe9$export$dcadc0d67468dfa8,
    faHome: $159afdcd077ecfe9$export$48f10d71ec526479,
    faHomeAlt: $159afdcd077ecfe9$export$279659c4b23dbedb,
    faHomeLgAlt: $159afdcd077ecfe9$export$20d6d52d45f53262,
    faSpinner: $159afdcd077ecfe9$export$1025ad641edb49c2,
    faGavel: $159afdcd077ecfe9$export$c36fb40057e2c3aa,
    faLegal: $159afdcd077ecfe9$export$59d593c2dacb3781,
    faTicketSimple: $159afdcd077ecfe9$export$68ddda3b30ba09f0,
    faTicketAlt: $159afdcd077ecfe9$export$75e38ba471fd89c4,
    faDove: $159afdcd077ecfe9$export$a1ab1e69a300089f,
    faTarpDroplet: $159afdcd077ecfe9$export$1585b7c3c7109751,
    faTreeCity: $159afdcd077ecfe9$export$ad95e4f80f98ebe0,
    faTurnUp: $159afdcd077ecfe9$export$314f5cab62fc6968,
    faLevelUpAlt: $159afdcd077ecfe9$export$d6f21a309b179c3d,
    faTemperatureQuarter: $159afdcd077ecfe9$export$f9d1c19925fd7fa8,
    faTemperature1: $159afdcd077ecfe9$export$d4f1cd380bde2129,
    faThermometer1: $159afdcd077ecfe9$export$3f77fbe2dabe285b,
    faThermometerQuarter: $159afdcd077ecfe9$export$ed05754fcbec6e46,
    faSliders: $159afdcd077ecfe9$export$ea6970ed5a15feb6,
    faSlidersH: $159afdcd077ecfe9$export$94d4dcb523f95563,
    faMosque: $159afdcd077ecfe9$export$4999586d7e1087fb,
    faH: $159afdcd077ecfe9$export$d762b7b66d5875e1,
    faInfo: $159afdcd077ecfe9$export$d469b770895f47ac,
    faPersonWalking: $159afdcd077ecfe9$export$6af1cc5998ca52bc,
    faWalking: $159afdcd077ecfe9$export$4886811b7174ec35,
    faArrowTurnDown: $159afdcd077ecfe9$export$fd4d6cfd52703f50,
    faLevelDown: $159afdcd077ecfe9$export$3794c07e7a666c94,
    faRoad: $159afdcd077ecfe9$export$f224567a4851a5e9,
    faSpiral: $159afdcd077ecfe9$export$1b18261a412e2e1c,
    faFaceFrown: $159afdcd077ecfe9$export$e5f78e87efbb0248,
    faFrown: $159afdcd077ecfe9$export$43b7108508aecc5f,
    faWineGlassEmpty: $159afdcd077ecfe9$export$b86d7336e68a3f57,
    faWineGlassAlt: $159afdcd077ecfe9$export$b8ff3fe2b78aef2f,
    faClapperboard: $159afdcd077ecfe9$export$add3b381ced12554,
    faForwardStep: $159afdcd077ecfe9$export$908d699be6717adc,
    faStepForward: $159afdcd077ecfe9$export$b303329afce5de18,
    faSquareUpRight: $159afdcd077ecfe9$export$a47a20ab7bde8c67,
    faExternalLinkSquareAlt: $159afdcd077ecfe9$export$e4cdf2977151ee26,
    faBookJournalWhills: $159afdcd077ecfe9$export$d3d49030d557a09b,
    faJournalWhills: $159afdcd077ecfe9$export$66a0d8d45aab6631,
    faChampagneGlasses: $159afdcd077ecfe9$export$7df1926e9eef8cc3,
    faGlassCheers: $159afdcd077ecfe9$export$20007d7d74cb98fe,
    faDumpster: $159afdcd077ecfe9$export$3b934e22d1851a3b,
    faHeartCircleXmark: $159afdcd077ecfe9$export$742f89ae2f8d6b20,
    faComputer: $159afdcd077ecfe9$export$9835883ce9d0fe78,
    faWandMagic: $159afdcd077ecfe9$export$8282f5f5dcf6b009,
    faMagic: $159afdcd077ecfe9$export$e58f9b502d4dd52d,
    faBrain: $159afdcd077ecfe9$export$97fa4f4c1006ab1,
    faBriefcaseMedical: $159afdcd077ecfe9$export$5000f52ca9819bf5,
    faHouseMedicalCircleExclamation: $159afdcd077ecfe9$export$bc50edea6e121df5,
    faCodeCommit: $159afdcd077ecfe9$export$d5d870c10bc9f1ce,
    faPersonBreastfeeding: $159afdcd077ecfe9$export$9b94ed8d16d281f9,
    faPersonRays: $159afdcd077ecfe9$export$49577f913f0fe4d2,
    faManatSign: $159afdcd077ecfe9$export$1ff755b523ab2851,
    faSort: $159afdcd077ecfe9$export$4941c5969d5399b,
    faUnsorted: $159afdcd077ecfe9$export$418597748f0fe52d,
    faCircleRadiation: $159afdcd077ecfe9$export$55c8e3afd9f6c0b4,
    faRadiationAlt: $159afdcd077ecfe9$export$2f048fa82bbddf6f,
    faLaptopCode: $159afdcd077ecfe9$export$94100f4c6ee29932,
    faSink: $159afdcd077ecfe9$export$2a9dda2096ce792e,
    faArrowUpFromWaterPump: $159afdcd077ecfe9$export$1a093e7861c5e48f,
    faMicrophoneLinesSlash: $159afdcd077ecfe9$export$4be1b324ac8a71ba,
    faMicrophoneAltSlash: $159afdcd077ecfe9$export$d2a53a388f30780,
    faServer: $159afdcd077ecfe9$export$1bf820d499b6202e,
    faUser: $159afdcd077ecfe9$export$f5699fa0844e0188,
    faUserAlt: $159afdcd077ecfe9$export$ae9b19c2ac726cfc,
    faUserLarge: $159afdcd077ecfe9$export$50a28538498238f,
    faSnowflake: $159afdcd077ecfe9$export$bab8f3647c394f48,
    faSkullCrossbones: $159afdcd077ecfe9$export$8717352b90217272,
    faPesoSign: $159afdcd077ecfe9$export$c8f99b9b5ea83555,
    faWineGlass: $159afdcd077ecfe9$export$e06d6607d3577d6e,
    faTemperatureHalf: $159afdcd077ecfe9$export$a3f1d7f13c202adc,
    faTemperature2: $159afdcd077ecfe9$export$8176e649df45b32c,
    faThermometer2: $159afdcd077ecfe9$export$4dd764ac8d512682,
    faThermometerHalf: $159afdcd077ecfe9$export$2090f040324b4449,
    faTicket: $159afdcd077ecfe9$export$3604f15924cf0b98,
    faWheatAwnCircleExclamation: $159afdcd077ecfe9$export$e23367e54f665590,
    faArrowsTurnRight: $159afdcd077ecfe9$export$db9f783f15682c4a,
    faCandyCane: $159afdcd077ecfe9$export$14d66ba7571ae0b9,
    faWheelchair: $159afdcd077ecfe9$export$76a9413fbe130a53,
    faSpellCheck: $159afdcd077ecfe9$export$761e747b06ed2e1f,
    faVolumeOff: $159afdcd077ecfe9$export$d94ba52e980ea0f1,
    faLungs: $159afdcd077ecfe9$export$ba9b387e84727819,
    faBookmark: $159afdcd077ecfe9$export$4ed9da5c3cca0ef1,
    faBarcode: $159afdcd077ecfe9$export$3825a842b5afc5aa,
    faListOl: $159afdcd077ecfe9$export$3db8f67cd0fc963b,
    faList12: $159afdcd077ecfe9$export$7e3d894cd55296b,
    faListNumeric: $159afdcd077ecfe9$export$cf51408faadac277,
    faFileCircleXmark: $159afdcd077ecfe9$export$e4686afbe882e24a,
    faCube: $159afdcd077ecfe9$export$973ae4f1e4d2ce78,
    faTape: $159afdcd077ecfe9$export$b88ed5e1e0eac4c6,
    faBomb: $159afdcd077ecfe9$export$d59078f6e80b4a67,
    faScaleUnbalanced: $159afdcd077ecfe9$export$4d10bcc8d068f454,
    faBalanceScaleLeft: $159afdcd077ecfe9$export$786cb0c775487f19,
    faSquareCaretLeft: $159afdcd077ecfe9$export$2c5163541229363,
    faCaretSquareLeft: $159afdcd077ecfe9$export$d0c8ba444f1f9581,
    faRuler: $159afdcd077ecfe9$export$8e90575265a56cfc,
    faI: $159afdcd077ecfe9$export$aee03ca0815b7c38,
    faVolumeXmark: $159afdcd077ecfe9$export$28cc565c11db6f2e,
    faVolumeMute: $159afdcd077ecfe9$export$aa8decd057dfd29b,
    faVolumeTimes: $159afdcd077ecfe9$export$a1c7b36ba71dbeca,
    faArchway: $159afdcd077ecfe9$export$d56753dd2eb5c323,
    faPersonDigging: $159afdcd077ecfe9$export$f4d483fca19a4604,
    faDigging: $159afdcd077ecfe9$export$7bd93e3343bd5671,
    faGaugeHigh: $159afdcd077ecfe9$export$d262c1f5912046e6,
    faTachometerAlt: $159afdcd077ecfe9$export$38dd17b9f064c10f,
    faTachometerAltFast: $159afdcd077ecfe9$export$e99d8b85f35b8ca5,
    faGenderless: $159afdcd077ecfe9$export$c093cc22e88981c2,
    faCloudSun: $159afdcd077ecfe9$export$dcaadfd9c98e42a1,
    faArrowRight: $159afdcd077ecfe9$export$b4da69a0247f3620,
    faHandshake: $159afdcd077ecfe9$export$b4c63e9bfc7906f1,
    faHandshakeAlt: $159afdcd077ecfe9$export$e9aa3c6f9f47aa1a,
    faHandshakeSimple: $159afdcd077ecfe9$export$e8485db4dab0ab30,
    faPersonSkiing: $159afdcd077ecfe9$export$5ebd3cd0630e3ae7,
    faSkiing: $159afdcd077ecfe9$export$eae1acab6fb96708,
    faBridgeWater: $159afdcd077ecfe9$export$154e99cb34841765,
    faBuildingNgo: $159afdcd077ecfe9$export$374e1dce366a2175,
    faIgloo: $159afdcd077ecfe9$export$4a284575edd6f1af,
    faCircleDollarToSlot: $159afdcd077ecfe9$export$5f92ac3e804644e3,
    faDonate: $159afdcd077ecfe9$export$40050ae52860cde7,
    faY: $159afdcd077ecfe9$export$b8c4c058fe7d193c,
    faFaceSmileWink: $159afdcd077ecfe9$export$6143da800b0e6626,
    faSmileWink: $159afdcd077ecfe9$export$f5dbb37f6801ee3f,
    faDiceFour: $159afdcd077ecfe9$export$2df6451abf70a6ff,
    faFaceGrinSquintTears: $159afdcd077ecfe9$export$8ff56f5ebb8416a0,
    faGrinSquintTears: $159afdcd077ecfe9$export$542206d6a85f3b42,
    faFileAudio: $159afdcd077ecfe9$export$b8d24c57c9e64933,
    faArrowsDownToLine: $159afdcd077ecfe9$export$8f2463c7b2fc6ae4,
    faG: $159afdcd077ecfe9$export$9f5c2b0db8eedeac,
    faVihara: $159afdcd077ecfe9$export$ee4b92e89fe0dfaf,
    faFlagCheckered: $159afdcd077ecfe9$export$92fad97e19a9fea,
    faGaugeSimple: $159afdcd077ecfe9$export$f3a0a4e6723a86d4,
    faGaugeSimpleMed: $159afdcd077ecfe9$export$ba8c12ff7cfa2521,
    faTachometerAverage: $159afdcd077ecfe9$export$94fcfd6f6335431b,
    faRightLeft: $159afdcd077ecfe9$export$a082af56be9786ae,
    faExchangeAlt: $159afdcd077ecfe9$export$f6c6fb20d374b128,
    faPills: $159afdcd077ecfe9$export$6380e2ed6e69d350,
    faExplosion: $159afdcd077ecfe9$export$36b5fbeae4855055,
    faArrowsDownToPeople: $159afdcd077ecfe9$export$cfb044c7d35060bb,
    faUsersViewfinder: $159afdcd077ecfe9$export$72b785dcfe44c69b,
    faCarOn: $159afdcd077ecfe9$export$d901d50df5cf8d91,
    faSleigh: $159afdcd077ecfe9$export$26a8fd1143d2d6c0,
    faDumbbell: $159afdcd077ecfe9$export$56700074cf37be5c,
    faBabyCarriage: $159afdcd077ecfe9$export$3b3ab4d86bad7d26,
    faCarriageBaby: $159afdcd077ecfe9$export$9f117d92ccd36cf1,
    faKiwiBird: $159afdcd077ecfe9$export$d9933d91e1314d02,
    faCalendarXmark: $159afdcd077ecfe9$export$3c70ffe5660af060,
    faCalendarTimes: $159afdcd077ecfe9$export$99b20d7352fbcf08,
    faCircleDown: $159afdcd077ecfe9$export$531badb89cf01312,
    faArrowAltCircleDown: $159afdcd077ecfe9$export$ff3afbc8c0bc5d59,
    faFileMedical: $159afdcd077ecfe9$export$56cbcd962389b090,
    faXmark: $159afdcd077ecfe9$export$e6e44779b2fa1a5c,
    faClose: $159afdcd077ecfe9$export$23c717133fd81476,
    faMultiply: $159afdcd077ecfe9$export$4ed4ff13d4dbc862,
    faRemove: $159afdcd077ecfe9$export$34810740c1bd6c54,
    faTimes: $159afdcd077ecfe9$export$174bd7f477b115b4,
    faShapes: $159afdcd077ecfe9$export$b17d50542d1fc340,
    faTriangleCircleSquare: $159afdcd077ecfe9$export$34261e5aea24fc1d,
    faDiceOne: $159afdcd077ecfe9$export$d91800b7be5303b0,
    faLockOpen: $159afdcd077ecfe9$export$84b5acad4436d02a,
    faPepperHot: $159afdcd077ecfe9$export$4894bf28f771e1f3,
    faDropletSlash: $159afdcd077ecfe9$export$1d6c5a49025d720b,
    faTintSlash: $159afdcd077ecfe9$export$5d6f0943039b898f,
    faDroplet: $159afdcd077ecfe9$export$cc1b6e60cb98fb90,
    faTint: $159afdcd077ecfe9$export$60dd975bd5938c15,
    faFileLines: $159afdcd077ecfe9$export$ef565d07efe2b5e9,
    faFileAlt: $159afdcd077ecfe9$export$243b47dca32bf0b8,
    faFileText: $159afdcd077ecfe9$export$f466100bf9bf37a5,
    faCommentsDollar: $159afdcd077ecfe9$export$d477129b070e5ac4,
    faMagnifyingGlassLocation: $159afdcd077ecfe9$export$234a18b2b4d530a3,
    faSearchLocation: $159afdcd077ecfe9$export$c33aba6c251a898a,
    faFileInvoice: $159afdcd077ecfe9$export$bef39294aed2281a,
    faPentagon: $159afdcd077ecfe9$export$21bf44b82744358d,
    faRepublican: $159afdcd077ecfe9$export$929518bb4b66a588,
    faShop: $159afdcd077ecfe9$export$78edc9b98453b6f7,
    faStoreAlt: $159afdcd077ecfe9$export$1f1871dab9cec9d8,
    faFilm: $159afdcd077ecfe9$export$c03de0cc616e77bb,
    faFilmAlt: $159afdcd077ecfe9$export$51af5173c6a30484,
    faFilmSimple: $159afdcd077ecfe9$export$7f9b091081b7a894,
    faBuildingCircleXmark: $159afdcd077ecfe9$export$c4c015418a1f24df,
    faComments: $159afdcd077ecfe9$export$932912e74adb8939,
    faTags: $159afdcd077ecfe9$export$d55778e3ab6c933f,
    faGun: $159afdcd077ecfe9$export$e18f576a7b31ba46,
    faCircleCheck: $159afdcd077ecfe9$export$c2e9877668862374,
    faCheckCircle: $159afdcd077ecfe9$export$be9e388158c74f29,
    faIdCardClip: $159afdcd077ecfe9$export$31e6961064ddac7b,
    faIdCardAlt: $159afdcd077ecfe9$export$dc37ebbac31f6c6c,
    faMoon: $159afdcd077ecfe9$export$c4c2f69a53bab720,
    faOilWell: $159afdcd077ecfe9$export$b69c6757012a2267,
    faTachographDigital: $159afdcd077ecfe9$export$73f2bf302381c86a,
    faDigitalTachograph: $159afdcd077ecfe9$export$b3bf1994f0fefe98,
    faTablet: $159afdcd077ecfe9$export$1c92b67c45a4b4fc,
    faTabletAndroid: $159afdcd077ecfe9$export$5eddbb7c71278268,
    faRubleSign: $159afdcd077ecfe9$export$1ae0a94c8ba4131a,
    faRouble: $159afdcd077ecfe9$export$c5dc3d98c4d8f2a5,
    faRub: $159afdcd077ecfe9$export$9c4d936240e1f0b1,
    faRuble: $159afdcd077ecfe9$export$6c0cf65134387046,
    faClosedCaptioning: $159afdcd077ecfe9$export$8e047801a8603af7,
    faPen: $159afdcd077ecfe9$export$8f4567331fb0d3bc,
    faPlane: $159afdcd077ecfe9$export$f654c69e66b466c0,
    faImages: $159afdcd077ecfe9$export$74f06b41ed2ca28a,
    faMobileScreen: $159afdcd077ecfe9$export$8867e7da34bb8bf4,
    faMobileAndroidAlt: $159afdcd077ecfe9$export$cb39d7b468ba5838,
    faGuaraniSign: $159afdcd077ecfe9$export$b731a51acb74b00c,
    faBagShopping: $159afdcd077ecfe9$export$b0137b4600e9ab12,
    faShoppingBag: $159afdcd077ecfe9$export$5745f8adbc11eb01,
    faCircleRight: $159afdcd077ecfe9$export$1fec48c8bdd69c1d,
    faArrowAltCircleRight: $159afdcd077ecfe9$export$88962ffdad8b856d,
    faPhoneVolume: $159afdcd077ecfe9$export$c377f240bb8b5d74,
    faVolumeControlPhone: $159afdcd077ecfe9$export$5358d004fa3d3be2,
    faCubes: $159afdcd077ecfe9$export$30523a9441a31e97,
    faPhone: $159afdcd077ecfe9$export$ddab067855cf34cb,
    faToriiGate: $159afdcd077ecfe9$export$75825a4c2b3375e,
    faBacon: $159afdcd077ecfe9$export$ab07061fe21a3a8e,
    faPersonFallingBurst: $159afdcd077ecfe9$export$a75569baaf4a6c3a,
    faQuoteRight: $159afdcd077ecfe9$export$54e3a80c9875b74c,
    faQuoteRightAlt: $159afdcd077ecfe9$export$dd692f2e88bd4b1a,
    faHouseMedicalFlag: $159afdcd077ecfe9$export$86c50f517be57a40,
    faPrescription: $159afdcd077ecfe9$export$8767bafb19515ee4,
    faDiceThree: $159afdcd077ecfe9$export$221059e0d5fd8958,
    faBuildingLock: $159afdcd077ecfe9$export$6f08294ba8a2459c,
    faIdCard: $159afdcd077ecfe9$export$782ac893fc22249b,
    faDriversLicense: $159afdcd077ecfe9$export$8359c70e609eff64,
    faCirclePlay: $159afdcd077ecfe9$export$86c4e45dc3302d15,
    faPlayCircle: $159afdcd077ecfe9$export$cf04333781061c5e,
    faFaceLaughBeam: $159afdcd077ecfe9$export$3f2d51c0547bf984,
    faLaughBeam: $159afdcd077ecfe9$export$a88d1f4073ea9369,
    faLeaf: $159afdcd077ecfe9$export$7c497bae2754a087,
    faHouseChimneyUser: $159afdcd077ecfe9$export$1ddbaebce033a0d,
    faRotateRight: $159afdcd077ecfe9$export$7f465bf410c6eff7,
    faRedoAlt: $159afdcd077ecfe9$export$50c037520c6cfdc1,
    faRotateForward: $159afdcd077ecfe9$export$2507849a0fdd7f64,
    faTooth: $159afdcd077ecfe9$export$3a1fa2d16f90d635,
    faHouseChimneyWindow: $159afdcd077ecfe9$export$792391babe46862d,
    faMotorcycle: $159afdcd077ecfe9$export$f26017bdca99338d,
    faBackwardFast: $159afdcd077ecfe9$export$662cbc6ed5a3c5e8,
    faFastBackward: $159afdcd077ecfe9$export$e6246a3279a379b8,
    faAddressBook: $159afdcd077ecfe9$export$853fd1561789e3bb,
    faContactBook: $159afdcd077ecfe9$export$594b5a5d4d2e156b,
    faSailboat: $159afdcd077ecfe9$export$e363e74e36cce80c,
    faBookBookmark: $159afdcd077ecfe9$export$3d177ecdf7fc50ec,
    faMagnifyingGlassArrowRight: $159afdcd077ecfe9$export$382d3376c7fc7fc5,
    faMicrophoneLines: $159afdcd077ecfe9$export$417391ae30b5922e,
    faMicrophoneAlt: $159afdcd077ecfe9$export$f08ef94fea14f5ac,
    faReplyAll: $159afdcd077ecfe9$export$ca6fd367f31ecbc5,
    faMailReplyAll: $159afdcd077ecfe9$export$8274334f3a2c1841,
    faUniversalAccess: $159afdcd077ecfe9$export$e119aada7f690d05,
    faToiletPaper: $159afdcd077ecfe9$export$c8cc083ccc72b17,
    faToiletPaperAlt: $159afdcd077ecfe9$export$b999a758e19c286d,
    faToiletPaperBlank: $159afdcd077ecfe9$export$53ed521aed6cf942,
    faVrCardboard: $159afdcd077ecfe9$export$248171cb6dad4307,
    faPizzaSlice: $159afdcd077ecfe9$export$c9f93c4667edc585,
    faSprayCan: $159afdcd077ecfe9$export$4952c502f544cf85,
    faVolumeLow: $159afdcd077ecfe9$export$2b1464e7557b18eb,
    faVolumeDown: $159afdcd077ecfe9$export$69fdf57632b6cc29,
    faCross: $159afdcd077ecfe9$export$9d0a89fcd084abb,
    faPerson: $159afdcd077ecfe9$export$e6619e43cb090a16,
    faMale: $159afdcd077ecfe9$export$2e21f9dba1630651,
    faHourglass: $159afdcd077ecfe9$export$b9098a890f61e022,
    faHourglassEmpty: $159afdcd077ecfe9$export$a2f8176a0161e891,
    faFish: $159afdcd077ecfe9$export$24228a855c5f6812,
    faDrumstickBite: $159afdcd077ecfe9$export$482976e9a4ab10f3,
    faChartSimple: $159afdcd077ecfe9$export$8760a1de19ea40b9,
    faAtom: $159afdcd077ecfe9$export$b5bb295e8ad4ab31,
    faP: $159afdcd077ecfe9$export$bcb419f1cd5beac3,
    faJetFighterUp: $159afdcd077ecfe9$export$b024a52a4ccf5e69,
    faPlugCircleXmark: $159afdcd077ecfe9$export$12ef959394d63192,
    faSheetPlastic: $159afdcd077ecfe9$export$57f2bcd070bff91a,
    faV: $159afdcd077ecfe9$export$6fb446f784f6b9b3,
    faList: $159afdcd077ecfe9$export$6cfc59842fedbc16,
    faListSquares: $159afdcd077ecfe9$export$e3f160fc949c2b9d,
    faSolarPanel: $159afdcd077ecfe9$export$b9c649c5e37017f3,
    faLandMineOn: $159afdcd077ecfe9$export$567a897fc092e403,
    faHeadphones: $159afdcd077ecfe9$export$ad02dd8ca5816958,
    faHeadphonesAlt: $159afdcd077ecfe9$export$6f0433fa527dd5be,
    faHeadphonesSimple: $159afdcd077ecfe9$export$ca47801915e5a685,
    faBus: $159afdcd077ecfe9$export$ce69441578ff2fdb,
    faFilePowerpoint: $159afdcd077ecfe9$export$c341daeecdea449a,
    faQuoteLeft: $159afdcd077ecfe9$export$932a67a1b1a7a724,
    faQuoteLeftAlt: $159afdcd077ecfe9$export$95bb9ad3aa35c741,
    faChevronDown: $159afdcd077ecfe9$export$8db9bc521720fccd,
    faEarthAsia: $159afdcd077ecfe9$export$807cdd395fe012cb,
    faGlobeAsia: $159afdcd077ecfe9$export$796fdfc909e603f4,
    faCentSign: $159afdcd077ecfe9$export$875b6c94a4b00ea8,
    faShieldCat: $159afdcd077ecfe9$export$1639f087457d4f58,
    faSchoolCircleCheck: $159afdcd077ecfe9$export$c8c95c2f9937bf6a,
    faMartiniGlass: $159afdcd077ecfe9$export$98401bb29cff68e0,
    faGlassMartiniAlt: $159afdcd077ecfe9$export$2258439b8f4e7acb,
    faPlug: $159afdcd077ecfe9$export$cae5752c3e3b6545,
    faPanorama: $159afdcd077ecfe9$export$5dd22dcb6e3ed369,
    faClockRotateLeft: $159afdcd077ecfe9$export$29be1665d1b36a3b,
    faHistory: $159afdcd077ecfe9$export$76d1986559ca7b7a,
    faJarWheat: $159afdcd077ecfe9$export$8b503c1d76716ddd,
    faCloudArrowDown: $159afdcd077ecfe9$export$542a9676c5286e01,
    faCloudDownload: $159afdcd077ecfe9$export$b318977f29260464,
    faCloudDownloadAlt: $159afdcd077ecfe9$export$351357a14c41f824,
    faTruckRampBox: $159afdcd077ecfe9$export$37396c36c76937bc,
    faTruckLoading: $159afdcd077ecfe9$export$f00c152db7d44638,
    faAngleDown: $159afdcd077ecfe9$export$4b5be0142d10f342,
    faPlugCircleCheck: $159afdcd077ecfe9$export$2bd45e99b9afa947,
    faWindowMaximize: $159afdcd077ecfe9$export$703cd98be31ec905,
    faHandsHoldingCircle: $159afdcd077ecfe9$export$3aa81d0e606b08b6,
    faLocationPin: $159afdcd077ecfe9$export$c0b7617de95c0c05,
    faMapMarker: $159afdcd077ecfe9$export$10d360e4f1a554dd,
    faBowlingBall: $159afdcd077ecfe9$export$5ee2640fe105312d,
    faCartFlatbed: $159afdcd077ecfe9$export$df587aaf7765e1ce,
    faDollyFlatbed: $159afdcd077ecfe9$export$f7c6efb60c53b285,
    faHouseUser: $159afdcd077ecfe9$export$9a513ee921e8e885,
    faHomeUser: $159afdcd077ecfe9$export$e732fa55ae5bbdf0,
    faGhost: $159afdcd077ecfe9$export$1a989eb1919c64c1,
    faCommentNodes: $159afdcd077ecfe9$export$6754d04baba2fe26,
    faPersonArrowDownToLine: $159afdcd077ecfe9$export$f9a5161975928326,
    faPlugCirclePlus: $159afdcd077ecfe9$export$f193138a7d21971c,
    faPersonSwimming: $159afdcd077ecfe9$export$3fb4da6af843d39f,
    faSwimmer: $159afdcd077ecfe9$export$67daf2e2f88c1365,
    faCommentDots: $159afdcd077ecfe9$export$63ffcb3d4e94cb92,
    faCommenting: $159afdcd077ecfe9$export$49ee382a2425e89c,
    faChartPie: $159afdcd077ecfe9$export$1de7b9cf7d1b153b,
    faPieChart: $159afdcd077ecfe9$export$7877286cd337de81,
    faFrog: $159afdcd077ecfe9$export$fe2358263efac504,
    faWineBottle: $159afdcd077ecfe9$export$770be8b3d5776043,
    faInbox: $159afdcd077ecfe9$export$366b69cbdce46334,
    faSquareH: $159afdcd077ecfe9$export$51e3c5be06a49e32,
    faHSquare: $159afdcd077ecfe9$export$f08bbcf8f59eafc2,
    faHouseMedical: $159afdcd077ecfe9$export$2d077da983246a68,
    faCircleChevronRight: $159afdcd077ecfe9$export$a39bab13d51abfd0,
    faChevronCircleRight: $159afdcd077ecfe9$export$2a5db4f6eba6f2b,
    faFileCsv: $159afdcd077ecfe9$export$82cea4f586f6ec9,
    faHatCowboy: $159afdcd077ecfe9$export$37672611144b857b,
    faFaceGrinTongueWink: $159afdcd077ecfe9$export$4272e56f2429da88,
    faGrinTongueWink: $159afdcd077ecfe9$export$58099903d50aefb3,
    faL: $159afdcd077ecfe9$export$be32b10ce70a09df,
    faArrowDownShortWide: $159afdcd077ecfe9$export$a51c464b699200ae,
    faSortAmountDesc: $159afdcd077ecfe9$export$93835bc31892b5c3,
    faSortAmountDownAlt: $159afdcd077ecfe9$export$e7d80d8c226cb77,
    faHourglassHalf: $159afdcd077ecfe9$export$703272eebf5e3eea,
    faHourglass2: $159afdcd077ecfe9$export$f1052bbf6bf361c0,
    faSpoon: $159afdcd077ecfe9$export$faf854a434ce6d0c,
    faUtensilSpoon: $159afdcd077ecfe9$export$fb7af5d245fb9053,
    faCreditCard: $159afdcd077ecfe9$export$3e7437bf6535bef0,
    faCreditCardAlt: $159afdcd077ecfe9$export$5fffe8e3c36964a2,
    faFileInvoiceDollar: $159afdcd077ecfe9$export$a3dced32d48cb1ea,
    faSpaghettiMonsterFlying: $159afdcd077ecfe9$export$3c8d5c62d76c33b8,
    faPastafarianism: $159afdcd077ecfe9$export$733efdaec97447be,
    faMartiniGlassCitrus: $159afdcd077ecfe9$export$c6e76550bdc0255d,
    faCocktail: $159afdcd077ecfe9$export$4be708f1e41d387b,
    faBullhorn: $159afdcd077ecfe9$export$dacae2b4ec565333,
    faBoxTissue: $159afdcd077ecfe9$export$f2adc06617bc0c7,
    faMattressPillow: $159afdcd077ecfe9$export$f042d3e458efa721,
    faChevronLeft: $159afdcd077ecfe9$export$75702e3e3dd44a44,
    faCloudMoonRain: $159afdcd077ecfe9$export$301c3fab0c4545bd,
    faArrowDown19: $159afdcd077ecfe9$export$9a40d582bd4628fb,
    faSortNumericAsc: $159afdcd077ecfe9$export$a4fb1aa2cdfb18d7,
    faSortNumericDown: $159afdcd077ecfe9$export$835db7eb35b3c29b,
    faHandSpock: $159afdcd077ecfe9$export$2262d6b626de1120,
    faWandMagicSparkles: $159afdcd077ecfe9$export$5325fc72e75360b4,
    faMagicWandSparkles: $159afdcd077ecfe9$export$c93286938249f0da,
    faCommentMedical: $159afdcd077ecfe9$export$101422b773924276,
    faBellSlash: $159afdcd077ecfe9$export$6b31a1e5968b2378,
    faHandshakeSlash: $159afdcd077ecfe9$export$2cef3f81ad90fb76,
    faHandshakeAltSlash: $159afdcd077ecfe9$export$ca302f956ae9f1bf,
    faHandshakeSimpleSlash: $159afdcd077ecfe9$export$e99ae494101c5e91,
    faBottleWater: $159afdcd077ecfe9$export$3ee278c67519eeeb,
    faDiceD20: $159afdcd077ecfe9$export$b06003a02c9055bd,
    faArrowDownZA: $159afdcd077ecfe9$export$cf79d63ad07d943a,
    faSortAlphaDesc: $159afdcd077ecfe9$export$7caf99612a55d427,
    faSortAlphaDownAlt: $159afdcd077ecfe9$export$e12d23d82d5c8a89,
    faBrush: $159afdcd077ecfe9$export$5824ffe6f8983c83,
    faPersonWalkingDashedLineArrowRight: $159afdcd077ecfe9$export$a1d09c95bee8043b,
    faArrowUpShortWide: $159afdcd077ecfe9$export$be9d5060a4bc3b4b,
    faSortAmountUpAlt: $159afdcd077ecfe9$export$6e87844b0f151b6a,
    faGripVertical: $159afdcd077ecfe9$export$cacbd95c283996ec,
    faGridVertical: $159afdcd077ecfe9$export$4ad8d668e60f2ced,
    faCarTunnel: $159afdcd077ecfe9$export$ec5cfe409de2ed37,
    faChartColumn: $159afdcd077ecfe9$export$d01ddcc9efe7b149,
    faTruckArrowRight: $159afdcd077ecfe9$export$d69fa2b7839ce76,
    faTv: $159afdcd077ecfe9$export$e0cfed4ba2fe562c,
    faTelevision: $159afdcd077ecfe9$export$9803b0176917be28,
    faTvAlt: $159afdcd077ecfe9$export$6aa64ad5a1974ad7,
    faSection: $159afdcd077ecfe9$export$a6f4f4a005d91fbd,
    faPeace: $159afdcd077ecfe9$export$8614cb1326eacd7a,
    faStar: $159afdcd077ecfe9$export$a3b0eb2cd7942125,
    faFlag: $159afdcd077ecfe9$export$6591b1ea509be9da,
    faTriangleExclamation: $159afdcd077ecfe9$export$1cbf6e649ce86166,
    faExclamationTriangle: $159afdcd077ecfe9$export$3d249b63b52cce7c,
    faWarning: $159afdcd077ecfe9$export$2e470a35c38b096a,
    faSchoolCircleExclamation: $159afdcd077ecfe9$export$f629fdee00932a01,
    faGraduationCap: $159afdcd077ecfe9$export$874e305fd7920cce,
    faMortarBoard: $159afdcd077ecfe9$export$dd0a013bf23a9d86,
    faStore: $159afdcd077ecfe9$export$de59c2657a8ace67,
    faUserAstronaut: $159afdcd077ecfe9$export$94363e983c225a04,
    faBuildingFlag: $159afdcd077ecfe9$export$592422b29ab0a914,
    faMugSaucer: $159afdcd077ecfe9$export$60048819854688c5,
    faCoffee: $159afdcd077ecfe9$export$1d24a9e457278011,
    faLemon: $159afdcd077ecfe9$export$4fbda8f64648f3b5,
    faCaravan: $159afdcd077ecfe9$export$afb5d0eee7c1bdb,
    faQ: $159afdcd077ecfe9$export$5a2b164552deda9f,
    faLock: $159afdcd077ecfe9$export$7aa08ad5d562578a,
    faPaintRoller: $159afdcd077ecfe9$export$d1de8d1b815d6a5,
    faVolumeHigh: $159afdcd077ecfe9$export$39461921e738be65,
    faVolumeUp: $159afdcd077ecfe9$export$5940d3e475d90cc4,
    faFolderPlus: $159afdcd077ecfe9$export$e18e05ffa2045d3b,
    faMercury: $159afdcd077ecfe9$export$e134ecd00b622a47,
    faAnchor: $159afdcd077ecfe9$export$12a35719f889cd1,
    faSquareParking: $159afdcd077ecfe9$export$f2cfa036d76f69ab,
    faParking: $159afdcd077ecfe9$export$fda29c8f99573a4e,
    faHanukiah: $159afdcd077ecfe9$export$3dcd4ca3f7108a82,
    faRotateLeft: $159afdcd077ecfe9$export$7adaa412bd8eb08f,
    faRotateBack: $159afdcd077ecfe9$export$9706706f1bc7b12,
    faRotateBackward: $159afdcd077ecfe9$export$4ceb0b05fed961a9,
    faUndoAlt: $159afdcd077ecfe9$export$c8197b992c46c4a6,
    faHeading: $159afdcd077ecfe9$export$4805b8d175aeb9fb,
    faHeader: $159afdcd077ecfe9$export$579f9604bb10a61a,
    faCrosshairs: $159afdcd077ecfe9$export$721c101130c40043,
    faCircleNodes: $159afdcd077ecfe9$export$de462dd5a18e80d4,
    faWindowRestore: $159afdcd077ecfe9$export$eccfff9bfd585652,
    faR: $159afdcd077ecfe9$export$eb4c616de6eef46f,
    faFilterCircleXmark: $159afdcd077ecfe9$export$fb5ab619c34ea613,
    faGopuram: $159afdcd077ecfe9$export$31f89d8ac1d14ed6,
    faHeartCircleMinus: $159afdcd077ecfe9$export$24c21c3ca00f3625,
    faStarOfLife: $159afdcd077ecfe9$export$aa3c4c1c5a47bf98,
    faBusinessTime: $159afdcd077ecfe9$export$694b7e88782dec12,
    faBriefcaseClock: $159afdcd077ecfe9$export$8b00ae94743552ce,
    faFireExtinguisher: $159afdcd077ecfe9$export$d75fb6743634a0a,
    faArrowDownLong: $159afdcd077ecfe9$export$5977e8de7e65b20,
    faLongArrowDown: $159afdcd077ecfe9$export$52ecf90b62f3f030,
    faUserMinus: $159afdcd077ecfe9$export$d6e17c0df8ed1bf7,
    faMoneyCheck: $159afdcd077ecfe9$export$be069f641c85d0b3,
    faHouseLaptop: $159afdcd077ecfe9$export$6486d62e77b910,
    faLaptopHouse: $159afdcd077ecfe9$export$efd983de5e4d6ad3,
    faDownload: $159afdcd077ecfe9$export$8f734e51d72ca13a,
    faCouch: $159afdcd077ecfe9$export$ce96e32767a7dd51,
    faRoadLock: $159afdcd077ecfe9$export$b81a894d5bc3eb17,
    faScissors: $159afdcd077ecfe9$export$b2a906a5928c6404,
    faCut: $159afdcd077ecfe9$export$66847f2a71b260e7,
    faBug: $159afdcd077ecfe9$export$a18cfac400116d9f,
    faArrowRightFromBracket: $159afdcd077ecfe9$export$ca14f1b4d6afb7aa,
    faSignOut: $159afdcd077ecfe9$export$33e2b60243ca6d92,
    faHandHoldingHand: $159afdcd077ecfe9$export$6638511b28df3be5,
    faStroopwafel: $159afdcd077ecfe9$export$195780ddabd8e0c6,
    faChild: $159afdcd077ecfe9$export$60b41e3581d1739a,
    faIceCream: $159afdcd077ecfe9$export$dd52741c60cc638f,
    faComputerMouse: $159afdcd077ecfe9$export$72cf138e5ddda6eb,
    faMouse: $159afdcd077ecfe9$export$198b96b894c66074,
    faFaucet: $159afdcd077ecfe9$export$a0856b225f3b0614,
    faAward: $159afdcd077ecfe9$export$f8db2747dadd48f7,
    faPersonDrowning: $159afdcd077ecfe9$export$bac321083217fd4,
    faCameraRotate: $159afdcd077ecfe9$export$e0ce7d1aba7105e7,
    faFaceGrinHearts: $159afdcd077ecfe9$export$fbb22081b65e4f33,
    faGrinHearts: $159afdcd077ecfe9$export$c56cf0e0c3bc5ed2,
    faFileFragment: $159afdcd077ecfe9$export$876f7406f579ec02,
    faPersonMilitaryRifle: $159afdcd077ecfe9$export$842b988dae95ccb8,
    faToggleOn: $159afdcd077ecfe9$export$5cffc34afa81e517,
    faLungsVirus: $159afdcd077ecfe9$export$895159d10626af74,
    faTableTennisPaddleBall: $159afdcd077ecfe9$export$eabe53838d45ac6a,
    faPingPongPaddleBall: $159afdcd077ecfe9$export$ebb246c621751737,
    faTableTennis: $159afdcd077ecfe9$export$f378fbb4e0ef7edf,
    faBoxesPacking: $159afdcd077ecfe9$export$e81e7f3390fe84fe,
    faPersonChalkboard: $159afdcd077ecfe9$export$c9dc1583b207b7ff,
    faDiceTwo: $159afdcd077ecfe9$export$4d85df590065572f,
    faArrowRightArrowLeft: $159afdcd077ecfe9$export$56b6d3d7d0e67a1c,
    faExchange: $159afdcd077ecfe9$export$1aab915ca61b734a,
    faFootball: $159afdcd077ecfe9$export$e15f65e77f717c29,
    faFootballBall: $159afdcd077ecfe9$export$e8fd664711e31704,
    faTruckMonster: $159afdcd077ecfe9$export$24b8a0147653649a,
    faAsterisk: $159afdcd077ecfe9$export$19eff32c0fd4f99f,
    faBatteryFull: $159afdcd077ecfe9$export$9338fc4614cfc0cf,
    faBattery: $159afdcd077ecfe9$export$214720d39635cea8,
    faBattery5: $159afdcd077ecfe9$export$e426617482c711a7,
    faChildDress: $159afdcd077ecfe9$export$f31a37ecbfd4e707,
    faFaceKissBeam: $159afdcd077ecfe9$export$eca99665af566fe1,
    faKissBeam: $159afdcd077ecfe9$export$d6ff8a73c0812e63,
    faTrashCanArrowUp: $159afdcd077ecfe9$export$60430351cdb4ba89,
    faTrashRestoreAlt: $159afdcd077ecfe9$export$d075b19b21cb9856,
    faFont: $159afdcd077ecfe9$export$a5dc297d3f60936,
    faBoreHole: $159afdcd077ecfe9$export$cd79eeea6201e9d4,
    faVirusCovid: $159afdcd077ecfe9$export$1df4e031b8ee4f84,
    faFilePdf: $159afdcd077ecfe9$export$38611f1c776aba73,
    faLanguage: $159afdcd077ecfe9$export$8a7bee49fdf8c954,
    faShieldHalved: $159afdcd077ecfe9$export$36e034ccc72554a9,
    faShieldAlt: $159afdcd077ecfe9$export$d6508d18a824f291,
    faCaretUp: $159afdcd077ecfe9$export$7de776bdab4e536d,
    faFilePen: $159afdcd077ecfe9$export$27f34878d8ed7a76,
    faFileEdit: $159afdcd077ecfe9$export$e343e19f1757c5ae,
    faPersonBiking: $159afdcd077ecfe9$export$cf152282d5de300d,
    faBiking: $159afdcd077ecfe9$export$a5bcf835dbf9c0b,
    faBookOpenReader: $159afdcd077ecfe9$export$cb6e40528b98a5b,
    faBookReader: $159afdcd077ecfe9$export$cee14fe33262fa7d,
    faGlassWaterDroplet: $159afdcd077ecfe9$export$b7ae54b4078b2060,
    faTowerBroadcast: $159afdcd077ecfe9$export$fd06ff4ce9799eb0,
    faBroadcastTower: $159afdcd077ecfe9$export$f68b38d51f5c0ed,
    faMinimize: $159afdcd077ecfe9$export$e0601b1f239fec74,
    faCompressArrowsAlt: $159afdcd077ecfe9$export$39205db0ea980efd,
    faArrowRightToCity: $159afdcd077ecfe9$export$e201217e5046cd15,
    faLaptopMedical: $159afdcd077ecfe9$export$ba2fa38f7bcc6930,
    faBreadSlice: $159afdcd077ecfe9$export$d78e8b0681279167,
    faGlobe: $159afdcd077ecfe9$export$b1b1cdce4a19c682,
    faFolderMinus: $159afdcd077ecfe9$export$758f1fb3784e4080,
    faMaskFace: $159afdcd077ecfe9$export$140d4da0adbaf435,
    faBong: $159afdcd077ecfe9$export$e74974fac77c468e,
    faRoadBridge: $159afdcd077ecfe9$export$4d6835e7175dec24,
    faArrowUp91: $159afdcd077ecfe9$export$25218e5886296cb9,
    faSortNumericUpAlt: $159afdcd077ecfe9$export$d41859f1bbb9e086,
    faMountainCity: $159afdcd077ecfe9$export$28f06bbf9c17c3af,
    faArrowDown91: $159afdcd077ecfe9$export$6cc91ce23eb3fae1,
    faSortNumericDesc: $159afdcd077ecfe9$export$99f058110e2c82a8,
    faSortNumericDownAlt: $159afdcd077ecfe9$export$857385fda7a5a98e,
    faFaceGrinWide: $159afdcd077ecfe9$export$bdbabf493c478cde,
    faGrinAlt: $159afdcd077ecfe9$export$b4abebfe416d36ba,
    faPoop: $159afdcd077ecfe9$export$bb45b6b87d1adf27,
    faDharmachakra: $159afdcd077ecfe9$export$45cbd92c28deb2c7,
    faBatteryQuarter: $159afdcd077ecfe9$export$acec92052ac2183,
    faBattery2: $159afdcd077ecfe9$export$23ca8a94c555576,
    faAnkh: $159afdcd077ecfe9$export$8736909014b15ca9,
    faDiamond: $159afdcd077ecfe9$export$f214f827e0023247,
    faSubscript: $159afdcd077ecfe9$export$34c1e678c32ed646,
    faRupeeSign: $159afdcd077ecfe9$export$8bf9e3f7f57d486a,
    faRupee: $159afdcd077ecfe9$export$9da25a46cfcb6fa4,
    faPersonRifle: $159afdcd077ecfe9$export$b16df914812cedbe,
    faD: $159afdcd077ecfe9$export$56c73b799aac2555,
    faSquareNfi: $159afdcd077ecfe9$export$5498258519fc5b72,
    faTeeth: $159afdcd077ecfe9$export$b4619aeaf0b9d18e,
    faMagnifyingGlassDollar: $159afdcd077ecfe9$export$fa4f1ead37dc1dce,
    faSearchDollar: $159afdcd077ecfe9$export$65b49a6767630708,
    faDumpsterFire: $159afdcd077ecfe9$export$25e9b29b3f2230b5,
    faUpload: $159afdcd077ecfe9$export$a9578350255b2b79,
    faUserSlash: $159afdcd077ecfe9$export$3924ab4d3ef9b5ef,
    faUserAltSlash: $159afdcd077ecfe9$export$46185fab4772ada6,
    faUserLargeSlash: $159afdcd077ecfe9$export$ae7fc6b7f0534be9,
    faArrowLeft: $159afdcd077ecfe9$export$b7fac681e7d09400,
    faVialVirus: $159afdcd077ecfe9$export$a56b2b0a1073620c,
    faCheckDouble: $159afdcd077ecfe9$export$f178c8c2ad3cc861,
    faPaw: $159afdcd077ecfe9$export$7bc6e4d977673e69,
    faHelmetSafety: $159afdcd077ecfe9$export$aacaf42fba617981,
    faHardHat: $159afdcd077ecfe9$export$7b72177558a98b6f,
    faHatHard: $159afdcd077ecfe9$export$c0e235dbf1644a2f,
    faE: $159afdcd077ecfe9$export$86923e6fe1b42f5e,
    faFaceLaughSquint: $159afdcd077ecfe9$export$67ca89c1ca38d559,
    faLaughSquint: $159afdcd077ecfe9$export$b206e700cf7084e1,
    faDownLeftAndUpRightToCenter: $159afdcd077ecfe9$export$d56736f5800b3f0d,
    faCompressAlt: $159afdcd077ecfe9$export$a05650ebe54bede,
    faGifts: $159afdcd077ecfe9$export$de9a67b55dbe819a,
    faBed: $159afdcd077ecfe9$export$f24e0fce77994d4d,
    faMoneyBillTransfer: $159afdcd077ecfe9$export$1b71392d9effbe,
    faPersonRunning: $159afdcd077ecfe9$export$f48814ae62850c74,
    faRunning: $159afdcd077ecfe9$export$5dfd1cb43dc9eadb,
    faCircleChevronDown: $159afdcd077ecfe9$export$aca07924996218d8,
    faChevronCircleDown: $159afdcd077ecfe9$export$9926124d75b2ecab,
    faUserNurse: $159afdcd077ecfe9$export$ab9af5aa013d2162,
    faFaceKissWinkHeart: $159afdcd077ecfe9$export$611ae61f02de0aa,
    faKissWinkHeart: $159afdcd077ecfe9$export$ebba617701dfb917,
    faFill: $159afdcd077ecfe9$export$d3c2bcfd3b861e4a,
    faMoneyBill1Wave: $159afdcd077ecfe9$export$52e3e96cd1564779,
    faMoneyBillWaveAlt: $159afdcd077ecfe9$export$1613858e873cbb3e,
    faLandmark: $159afdcd077ecfe9$export$2bebc54c51db6505,
    faMusic: $159afdcd077ecfe9$export$fcb0647a5340b5b8,
    faBookMedical: $159afdcd077ecfe9$export$6feb44fec53ba30d,
    faShuffle: $159afdcd077ecfe9$export$ee94b652453ad208,
    faRandom: $159afdcd077ecfe9$export$8357bf8cc666d5f0,
    faUnderline: $159afdcd077ecfe9$export$22346afd6a3cddf8,
    faBuildingUser: $159afdcd077ecfe9$export$d65aef1ed7db1dae,
    faRobot: $159afdcd077ecfe9$export$30a5bb4ad3fa716c,
    faPlus: $159afdcd077ecfe9$export$a105e7b44ca0eb9e,
    faAdd: $159afdcd077ecfe9$export$9e8f9a9d4ad32c0f,
    faCopy: $159afdcd077ecfe9$export$e9bd786d30cb716c,
    faChessKing: $159afdcd077ecfe9$export$d5713874f8fefe1b,
    faHouseFloodWater: $159afdcd077ecfe9$export$70fd6006b4e54a5,
    faBitcoinSign: $159afdcd077ecfe9$export$441bfc8058328ce8,
    faBox: $159afdcd077ecfe9$export$6e7cf270cda52323,
    faSquarePlus: $159afdcd077ecfe9$export$eaf727acca5a35e4,
    faPlusSquare: $159afdcd077ecfe9$export$b6359eebfe900c35,
    faArrowsLeftRight: $159afdcd077ecfe9$export$672e2f590b189583,
    faArrowsH: $159afdcd077ecfe9$export$de517642cdb40354,
    faFan: $159afdcd077ecfe9$export$55145a3dae4f984a,
    faCrow: $159afdcd077ecfe9$export$bfa312207b788ed9,
    faFileCircleCheck: $159afdcd077ecfe9$export$8547e9f3a2ddab5b,
    faLinkSlash: $159afdcd077ecfe9$export$22965c7f4d903953,
    faChainBroken: $159afdcd077ecfe9$export$382551e04f32620a,
    faChainSlash: $159afdcd077ecfe9$export$12f09d657be59586,
    faUnlink: $159afdcd077ecfe9$export$2f546f7d8ba01e18,
    faArrowRotateRight: $159afdcd077ecfe9$export$9c58ddc4b3356f98,
    faArrowRightRotate: $159afdcd077ecfe9$export$ffa1245982c1b28b,
    faArrowRotateForward: $159afdcd077ecfe9$export$89c59b5f47067f4c,
    faRedo: $159afdcd077ecfe9$export$3d9f98aa1c24c776,
    faPenClip: $159afdcd077ecfe9$export$eff4bdcafd3b8d1c,
    faPenAlt: $159afdcd077ecfe9$export$a3d3e92e430d3beb,
    faDoorClosed: $159afdcd077ecfe9$export$2c79e1a422528bba,
    faArrowDownWideShort: $159afdcd077ecfe9$export$4229d00802c33062,
    faSortAmountAsc: $159afdcd077ecfe9$export$ddf8b8dd5983367d,
    faSortAmountDown: $159afdcd077ecfe9$export$4b2a02d50e417b5f,
    faCaretDown: $159afdcd077ecfe9$export$f9395ef707603e40,
    faK: $159afdcd077ecfe9$export$3f85413cb67e7f67,
    faCheckToSlot: $159afdcd077ecfe9$export$6999832247e52c2b,
    faVoteYea: $159afdcd077ecfe9$export$e87bb3db1608b850,
    faFishFins: $159afdcd077ecfe9$export$e7af4f0123222b6f,
    faCompress: $159afdcd077ecfe9$export$83632d1150d3541f,
    faArrowUpAZ: $159afdcd077ecfe9$export$fb00fdd8857804c7,
    faSortAlphaUp: $159afdcd077ecfe9$export$3c4115b156be730d,
    faUserGraduate: $159afdcd077ecfe9$export$10f5839059d22f7e,
    faFileCode: $159afdcd077ecfe9$export$143d0ca7d2200f20,
    faSoap: $159afdcd077ecfe9$export$64f1c53b21f310ac,
    faRecycle: $159afdcd077ecfe9$export$a65c441f12cb6bd,
    faFaceGrinWink: $159afdcd077ecfe9$export$1dd161850c5bc64e,
    faGrinWink: $159afdcd077ecfe9$export$2397fcd34eb12177,
    faWaterLadder: $159afdcd077ecfe9$export$5930e9bdfd790d77,
    faLadderWater: $159afdcd077ecfe9$export$c5ea6eeef2db2b3b,
    faSwimmingPool: $159afdcd077ecfe9$export$4dee691631c67d5c,
    faTowerCell: $159afdcd077ecfe9$export$f4b64c3a138c1b59,
    faColonSign: $159afdcd077ecfe9$export$dec10d4c2c113312,
    faLaptopFile: $159afdcd077ecfe9$export$e1046cf83da9b7ef,
    faBahai: $159afdcd077ecfe9$export$6d636565b3ec36b4,
    faHaykal: $159afdcd077ecfe9$export$5c15e34e0e43f15c,
    faMoneyBill1: $159afdcd077ecfe9$export$a312c7d58dd44a75,
    faMoneyBillAlt: $159afdcd077ecfe9$export$a35d573395884c3d,
    faCloudBolt: $159afdcd077ecfe9$export$cdd116afa0309c17,
    faThunderstorm: $159afdcd077ecfe9$export$bbf9e3d433f8f6de,
    faEthernet: $159afdcd077ecfe9$export$6bad2c9f317b52e5,
    faHryvniaSign: $159afdcd077ecfe9$export$22a9491150c64fef,
    faHryvnia: $159afdcd077ecfe9$export$33d5f94bd6f75f59,
    faEyeSlash: $159afdcd077ecfe9$export$ed3f2918429d029a,
    faCartFlatbedSuitcase: $159afdcd077ecfe9$export$ab81ff863770d996,
    faLuggageCart: $159afdcd077ecfe9$export$bd1e24dd3cde8514,
    faRadiation: $159afdcd077ecfe9$export$4c4e509518093d6d,
    faFileWord: $159afdcd077ecfe9$export$f0858dff6e769cf6,
    faBedPulse: $159afdcd077ecfe9$export$580ae0d0bbd809fb,
    faProcedures: $159afdcd077ecfe9$export$5f9e1870e1866dde,
    faTents: $159afdcd077ecfe9$export$c93b950e845a4ee7,
    faMugHot: $159afdcd077ecfe9$export$47a822c30184e8af,
    faBolt: $159afdcd077ecfe9$export$6869964aa308dd31,
    faZap: $159afdcd077ecfe9$export$d62abb82664f55ca,
    faJar: $159afdcd077ecfe9$export$53583b459a87a01,
    faTruckPlane: $159afdcd077ecfe9$export$e1d5ceed99060d76,
    faHandHoldingHeart: $159afdcd077ecfe9$export$97e5ef3e80a0fbef,
    faArrowRotateLeft: $159afdcd077ecfe9$export$89b706873769c180,
    faArrowLeftRotate: $159afdcd077ecfe9$export$1aea864c3e1d79b,
    faArrowRotateBack: $159afdcd077ecfe9$export$a34701878babe5fc,
    faArrowRotateBackward: $159afdcd077ecfe9$export$fce381d12e4535cd,
    faUndo: $159afdcd077ecfe9$export$a5e5ba60b1dfe2b2,
    faFaceAngry: $159afdcd077ecfe9$export$67a047c738fb34da,
    faAngry: $159afdcd077ecfe9$export$3c96c08e234498c5,
    faBurst: $159afdcd077ecfe9$export$ea2986b45ba5d2cf,
    faZ: $159afdcd077ecfe9$export$3481c1aa28972f9b,
    faBandage: $159afdcd077ecfe9$export$658a137d3845bca7,
    faBandAid: $159afdcd077ecfe9$export$b14a1014df2fdf46,
    faPlaneCircleExclamation: $159afdcd077ecfe9$export$f201ba865ea1b8dc,
    faBusSide: $159afdcd077ecfe9$export$b520530474846664,
    faBugs: $159afdcd077ecfe9$export$f5bfd1271b8b71d1,
    faBeerMugEmpty: $159afdcd077ecfe9$export$b957c27bc5330472,
    faBeer: $159afdcd077ecfe9$export$f74725691538983b,
    faPersonCircleCheck: $159afdcd077ecfe9$export$30294c81ac4031ca,
    faStapler: $159afdcd077ecfe9$export$c7e014b7e3ac3d83,
    faHouseMedicalCircleCheck: $159afdcd077ecfe9$export$5d08d08f88a96aac,
    faNairaSign: $159afdcd077ecfe9$export$58b7558ca9822358,
    faWifi: $159afdcd077ecfe9$export$1642419fe3db2857,
    faWifi3: $159afdcd077ecfe9$export$2349bb04a04f4b2d,
    faWifiStrong: $159afdcd077ecfe9$export$4b3167c852f4c4aa,
    faMoneyCheckDollar: $159afdcd077ecfe9$export$eeb59dd1825c6a65,
    faMoneyCheckAlt: $159afdcd077ecfe9$export$8c6ccc9745897cb2,
    faEyeLowVision: $159afdcd077ecfe9$export$23a892b1a4b994bd,
    faLowVision: $159afdcd077ecfe9$export$7a65d2aa54cb4e93,
    faCircleArrowUp: $159afdcd077ecfe9$export$a29c8ea43e92771d,
    faArrowCircleUp: $159afdcd077ecfe9$export$a2f6f3baa50af0b1,
    faCameraRetro: $159afdcd077ecfe9$export$41dbdadc07a89b05,
    faCapsules: $159afdcd077ecfe9$export$ba6fd4a436804a48,
    faPoo: $159afdcd077ecfe9$export$dd0ede1713d2d2f9,
    faElevator: $159afdcd077ecfe9$export$c7a833ce065e0ea4,
    faTag: $159afdcd077ecfe9$export$cb61f447f29887e,
    faFileCircleMinus: $159afdcd077ecfe9$export$4b89fabf50a10951,
    faDownLong: $159afdcd077ecfe9$export$e88ba08d4f4d65b6,
    faLongArrowAltDown: $159afdcd077ecfe9$export$8b92530ca6418c2f,
    faCompactDisc: $159afdcd077ecfe9$export$84021631df0f831b,
    faSuitcaseRolling: $159afdcd077ecfe9$export$957e62a9b80ff4e3,
    faBookQuran: $159afdcd077ecfe9$export$ad3212bc3fa1595b,
    faQuran: $159afdcd077ecfe9$export$46f29ea84ed4c5f1,
    faPhoneSlash: $159afdcd077ecfe9$export$4c60a3aade08b6c2,
    faRoadCircleCheck: $159afdcd077ecfe9$export$3f22db9ae9b6be1c,
    faShopLock: $159afdcd077ecfe9$export$452410c103c2403b,
    faImagePortrait: $159afdcd077ecfe9$export$c23fd8b91a7ed48,
    faPortrait: $159afdcd077ecfe9$export$e3d25f819c7ee7d7,
    faBridgeLock: $159afdcd077ecfe9$export$cffe7d85a82d8116,
    faHammer: $159afdcd077ecfe9$export$6310f315e1ebbca5,
    faArrowUp19: $159afdcd077ecfe9$export$bbbff45e04f4abab,
    faSortNumericUp: $159afdcd077ecfe9$export$d213a3ba3cabed48,
    faChessKnight: $159afdcd077ecfe9$export$861b1f13085cf122,
    faHouseFloodWaterCircleArrowRight: $159afdcd077ecfe9$export$30d3e64480aa266b,
    faArrowUpRightFromSquare: $159afdcd077ecfe9$export$5ad84e891223f2c3,
    faExternalLink: $159afdcd077ecfe9$export$f4c613289034e5ef,
    faArrowDownUpAcrossLine: $159afdcd077ecfe9$export$9fe0c42ede2dd003,
    faFaceGrinBeam: $159afdcd077ecfe9$export$3de52eeb00462407,
    faGrinBeam: $159afdcd077ecfe9$export$734da5249381ec7e,
    faRectangleAd: $159afdcd077ecfe9$export$d0ccaddca9e06d1e,
    faAd: $159afdcd077ecfe9$export$7af266c3465b1ff2,
    faBookTanakh: $159afdcd077ecfe9$export$24c764717169f536,
    faTanakh: $159afdcd077ecfe9$export$7fd4a58929315448,
    faHotTubPerson: $159afdcd077ecfe9$export$6e6bd68568c17bbf,
    faHotTub: $159afdcd077ecfe9$export$4842af92b516c40b,
    faFileHalfDashed: $159afdcd077ecfe9$export$a8fabd50d8cb3ffd,
    faOutdent: $159afdcd077ecfe9$export$e21cfc4f23776bff,
    faDedent: $159afdcd077ecfe9$export$cbffb369d9299db7,
    faHandPeace: $159afdcd077ecfe9$export$e49e3cfceea441cc,
    faHeadSideVirus: $159afdcd077ecfe9$export$5b64b916710da7c7,
    faCompass: $159afdcd077ecfe9$export$b4d344633433e50e,
    faPenNib: $159afdcd077ecfe9$export$a82594dcc75a49f5,
    faTentArrowsDown: $159afdcd077ecfe9$export$51adfe7c9ee4f428,
    faForwardFast: $159afdcd077ecfe9$export$dc9cc4280bee320d,
    faFastForward: $159afdcd077ecfe9$export$61a8cdc53c2e078d,
    faCrop: $159afdcd077ecfe9$export$afa58590dfb6fca2,
    faWhiskeyGlass: $159afdcd077ecfe9$export$f1304dd34ea2afbd,
    faGlassWhiskey: $159afdcd077ecfe9$export$fdec0f5f1a169419,
    faSquare: $159afdcd077ecfe9$export$90b4406457aae8cc,
    faFaceGrin: $159afdcd077ecfe9$export$92292137ef3cf4c8,
    faGrin: $159afdcd077ecfe9$export$37e1f10b6de76621,
    faFileContract: $159afdcd077ecfe9$export$70fde3f3fdaa6a6a,
    faAngleUp: $159afdcd077ecfe9$export$887340269e6d6cac,
    faFaceSmile: $159afdcd077ecfe9$export$b5023c446f10324,
    faSmile: $159afdcd077ecfe9$export$c632b2334f0913bc,
    faPersonDressBurst: $159afdcd077ecfe9$export$523180e731928397,
    faDivide: $159afdcd077ecfe9$export$89fa217ec5503ac9,
    faCodeFork: $159afdcd077ecfe9$export$f54081bdbf6d4eb5,
    faHouseFlag: $159afdcd077ecfe9$export$9a3d31c75a465b9a,
    faBuildingColumns: $159afdcd077ecfe9$export$a411e7e26cb63d5e,
    faBank: $159afdcd077ecfe9$export$6e379b829ea8b99,
    faInstitution: $159afdcd077ecfe9$export$1dba320226a34c1f,
    faMuseum: $159afdcd077ecfe9$export$9b3953adff472ad2,
    faUniversity: $159afdcd077ecfe9$export$f2e1460ebe1a8cb0,
    faRug: $159afdcd077ecfe9$export$7cee7480f25f5289,
    faCodeMerge: $159afdcd077ecfe9$export$e151fe5abf6db993,
    faHouseTsunami: $159afdcd077ecfe9$export$197b9567e88a0b1d,
    faMagnifyingGlassChart: $159afdcd077ecfe9$export$6a1e4cdbb8ca10c5,
    faUmbrella: $159afdcd077ecfe9$export$9ff64ffae70e08c0,
    faHillRockslide: $159afdcd077ecfe9$export$7ec15a32285f6c22,
    faUserSecret: $159afdcd077ecfe9$export$597826232327559b,
    faPager: $159afdcd077ecfe9$export$e1611f373a10a98c,
    faBriefcase: $159afdcd077ecfe9$export$8da450d063b0eb37,
    faTrowelBricks: $159afdcd077ecfe9$export$b6c20c10ddbd9898,
    faSocks: $159afdcd077ecfe9$export$8d36a54dbf1e6bce,
    faT: $159afdcd077ecfe9$export$6e625d2e7790c860,
    faMicrochip: $159afdcd077ecfe9$export$4a7bb4be15f35178,
    faTruckMedical: $159afdcd077ecfe9$export$fb6bd43f079f72e2,
    faAmbulance: $159afdcd077ecfe9$export$f5c7042778b51765,
    faOm: $159afdcd077ecfe9$export$8de8eb94230028a5,
    faMosquitoNet: $159afdcd077ecfe9$export$f3858ce1b3218e2,
    faPrescriptionBottle: $159afdcd077ecfe9$export$214f9ce665590486,
    faUsersGear: $159afdcd077ecfe9$export$3a18218720110fc0,
    faUsersCog: $159afdcd077ecfe9$export$5e0b06753fc69b81,
    faRoadCircleExclamation: $159afdcd077ecfe9$export$79753c2153535b01,
    faPause: $159afdcd077ecfe9$export$da79f048408b1722,
    faStaffSnake: $159afdcd077ecfe9$export$76d998742bc186eb,
    faRodAsclepius: $159afdcd077ecfe9$export$f2c3e92ee37a8d89,
    faRodSnake: $159afdcd077ecfe9$export$5d61dcb598296af0,
    faStaffAesculapius: $159afdcd077ecfe9$export$97c8a2cdba3b7700,
    faPiggyBank: $159afdcd077ecfe9$export$46d49a6734c4872a,
    faMonument: $159afdcd077ecfe9$export$6f9b0bfc012deb25,
    faAnglesRight: $159afdcd077ecfe9$export$48b60f1720e09944,
    faAngleDoubleRight: $159afdcd077ecfe9$export$792931403404faf0,
    faDesktop: $159afdcd077ecfe9$export$6e6ddc253102e596,
    faDesktopAlt: $159afdcd077ecfe9$export$ff09a62b9e0fa899,
    faPlaneCircleXmark: $159afdcd077ecfe9$export$94ef668f5108e431,
    faRetweet: $159afdcd077ecfe9$export$cebc76f79478e40e,
    faUserGear: $159afdcd077ecfe9$export$f504a6909b677146,
    faUserCog: $159afdcd077ecfe9$export$474108c2b86e730e,
    faBorderAll: $159afdcd077ecfe9$export$93a5eb721c9c0d25,
    faCoins: $159afdcd077ecfe9$export$bc5da164799a0e,
    faMarsStroke: $159afdcd077ecfe9$export$aa05fce255a5d269,
    faHandshakeAngle: $159afdcd077ecfe9$export$503f458ca5cf64c2,
    faHandsHelping: $159afdcd077ecfe9$export$287dbb1632da0d44,
    faArrowDown: $159afdcd077ecfe9$export$9686eff8d817f770,
    faLocationDot: $159afdcd077ecfe9$export$90a475e93ff4bb8a,
    faMapMarkerAlt: $159afdcd077ecfe9$export$4be92fa780613f93,
    faPlugCircleExclamation: $159afdcd077ecfe9$export$d893dd9509763a17,
    faCookieBite: $159afdcd077ecfe9$export$317dde8664f7de71,
    faScrewdriverWrench: $159afdcd077ecfe9$export$158a12f36bbecf9,
    faTools: $159afdcd077ecfe9$export$646e4e7a8c6172aa,
    faIndent: $159afdcd077ecfe9$export$318208bc30aeebcc,
    faBars: $159afdcd077ecfe9$export$36e9cf7887265da2,
    faNavicon: $159afdcd077ecfe9$export$409fa7bcaa0e4cd9,
    faHandsPraying: $159afdcd077ecfe9$export$a96374faedb12593,
    faPrayingHands: $159afdcd077ecfe9$export$95e08e91b0929943,
    faViruses: $159afdcd077ecfe9$export$ee194b18f5c6f6b6,
    faSchoolFlag: $159afdcd077ecfe9$export$9b263780a7312c8c,
    faTrademark: $159afdcd077ecfe9$export$9c9b2fbddd59047d,
    faFireBurner: $159afdcd077ecfe9$export$e4e44f7b1886fef,
    faFaceSmileBeam: $159afdcd077ecfe9$export$e3c56ed54f074063,
    faSmileBeam: $159afdcd077ecfe9$export$54ada6dc9690e0ca,
    faTentArrowLeftRight: $159afdcd077ecfe9$export$fa95eb7418c0e2b8,
    faRoute: $159afdcd077ecfe9$export$806c0a45a7ecd6e8,
    faAnglesUp: $159afdcd077ecfe9$export$152ef92a4f9d80a7,
    faAngleDoubleUp: $159afdcd077ecfe9$export$9bb51e1a2c07db7c,
    faBucket: $159afdcd077ecfe9$export$2124c7628e573b84,
    faLessThanEqual: $159afdcd077ecfe9$export$b2c723344cff0d8,
    faFolderClosed: $159afdcd077ecfe9$export$5e30548b7f8eeb95,
    faPersonThroughWindow: $159afdcd077ecfe9$export$a77a2f6da72f89e3,
    faSchoolLock: $159afdcd077ecfe9$export$8845cce2a763ee07,
    faPersonBurst: $159afdcd077ecfe9$export$ae02241644924482,
    faLeftLong: $159afdcd077ecfe9$export$1db7e2ee10d36035,
    faLongArrowAltLeft: $159afdcd077ecfe9$export$a8b3226b2bf323d,
    faLocationCrosshairs: $159afdcd077ecfe9$export$14e1096ad1719098,
    faLocation: $159afdcd077ecfe9$export$45e012c32174eb5d,
    faPersonDotsFromLine: $159afdcd077ecfe9$export$cdcec8ca7ec0d381,
    faDiagnoses: $159afdcd077ecfe9$export$68bad2b52a90d1fa,
    faGaugeSimpleHigh: $159afdcd077ecfe9$export$cc4351eb13da27d8,
    faTachometer: $159afdcd077ecfe9$export$362d0f652c3fbca2,
    faTachometerFast: $159afdcd077ecfe9$export$375b6a8680f980ed,
    faAnglesLeft: $159afdcd077ecfe9$export$2ebd565813951f81,
    faAngleDoubleLeft: $159afdcd077ecfe9$export$21b0833b3cf929a7,
    faUpDown: $159afdcd077ecfe9$export$e36c32dd5cba9b90,
    faArrowsAltV: $159afdcd077ecfe9$export$138cb56a3f8f7040,
    faBatteryEmpty: $159afdcd077ecfe9$export$1344b64f6e922e12,
    faBattery0: $159afdcd077ecfe9$export$de8d0338927394c1,
    faKeyboard: $159afdcd077ecfe9$export$fb61df5d98785fa8,
    faCookie: $159afdcd077ecfe9$export$b3e64f5f68c6623f,
    faStopwatch: $159afdcd077ecfe9$export$b85a7300fc7960b6,
    faEject: $159afdcd077ecfe9$export$8484041d5b209494,
    faSatelliteDish: $159afdcd077ecfe9$export$219ccae0e4da3c92,
    faFaceRollingEyes: $159afdcd077ecfe9$export$a6d72a9a068392b5,
    faMehRollingEyes: $159afdcd077ecfe9$export$fdc62a1bea767cc2,
    faListCheck: $159afdcd077ecfe9$export$350a84fd0f833f4d,
    faTasks: $159afdcd077ecfe9$export$2f6d5b2fec286d63,
    faSackXmark: $159afdcd077ecfe9$export$2bad98c38bea5994,
    faHashtag: $159afdcd077ecfe9$export$c92c903bade56844,
    faTrain: $159afdcd077ecfe9$export$17cde74bf6f1ee89,
    faGamepad: $159afdcd077ecfe9$export$6a66b1b639455bef,
    faFileExport: $159afdcd077ecfe9$export$364f19abcfac1b0a,
    faArrowRightFromFile: $159afdcd077ecfe9$export$b9c76255b38e1df1,
    faFaceGrimace: $159afdcd077ecfe9$export$bd5bd2ef56b793b1,
    faGrimace: $159afdcd077ecfe9$export$3d08cd36ac1ef231,
    faTrainSubway: $159afdcd077ecfe9$export$cda326cc3bce41c,
    faSubway: $159afdcd077ecfe9$export$4cabc8a12d4e2f9,
    faCircleDot: $159afdcd077ecfe9$export$aa13d9234890e8d3,
    faDotCircle: $159afdcd077ecfe9$export$92bc269cb244d66a,
    faObjectGroup: $159afdcd077ecfe9$export$40cdac24aa94a57a,
    faShip: $159afdcd077ecfe9$export$6c645741140616af,
    faC: $159afdcd077ecfe9$export$a2c1c457834fc6d8,
    faSquarePhone: $159afdcd077ecfe9$export$318ed022991eef56,
    faPhoneSquare: $159afdcd077ecfe9$export$8ba22605a641ebdf,
    faRulerCombined: $159afdcd077ecfe9$export$613f406c1b5802a8,
    faArrowsRotate: $159afdcd077ecfe9$export$2fd091cb98dc8ab8,
    faRefresh: $159afdcd077ecfe9$export$fd4359e93d7b3d14,
    faSync: $159afdcd077ecfe9$export$ff87319002e3dae9,
    faPersonDress: $159afdcd077ecfe9$export$27f7383b96c3f4b4,
    faFemale: $159afdcd077ecfe9$export$70e8e75e61dd7169,
    faBookOpen: $159afdcd077ecfe9$export$8a3071811b2b7979,
    faFolderTree: $159afdcd077ecfe9$export$54d16fa2e445d3fe,
    faBoxArchive: $159afdcd077ecfe9$export$2a0fcb66c3d79d00,
    faArchive: $159afdcd077ecfe9$export$26b3e1c454273f34,
    faTentArrowDownToLine: $159afdcd077ecfe9$export$8a4f323f00a91606,
    faQrcode: $159afdcd077ecfe9$export$fc19ca0fe15e73bc,
    faDragon: $159afdcd077ecfe9$export$ae1875ba975aa0e9,
    faHourglassEnd: $159afdcd077ecfe9$export$52757ecc5b1e25b9,
    faHourglass3: $159afdcd077ecfe9$export$1ec43c81fef8ffd6,
    faGrip: $159afdcd077ecfe9$export$eb83fb404127db75,
    faGridHorizontal: $159afdcd077ecfe9$export$60d9066b1172be72,
    faGripHorizontal: $159afdcd077ecfe9$export$4a45308d6c8decc1,
    faBorderTopLeft: $159afdcd077ecfe9$export$cf897c3e0abd59e4,
    faBorderStyle: $159afdcd077ecfe9$export$c2867ca78120d644,
    faListUl: $159afdcd077ecfe9$export$f8a219cf4f516384,
    faListDots: $159afdcd077ecfe9$export$e6f4ba30d84fa6ea,
    faPeopleRobbery: $159afdcd077ecfe9$export$75ce8513e1f1c5c4,
    faMobileButton: $159afdcd077ecfe9$export$c93d62849efbdd11,
    faArrowDownAZ: $159afdcd077ecfe9$export$43b642fac7053978,
    faSortAlphaAsc: $159afdcd077ecfe9$export$cb87697f2fa77cfc,
    faSortAlphaDown: $159afdcd077ecfe9$export$7658045270aafde3,
    faMoneyBill: $159afdcd077ecfe9$export$608138a7337b5d1a,
    faCircleMinus: $159afdcd077ecfe9$export$d0163707993a8110,
    faMinusCircle: $159afdcd077ecfe9$export$f3979b49bf57313c,
    faArrowPointer: $159afdcd077ecfe9$export$e4f903bc63db445,
    faMousePointer: $159afdcd077ecfe9$export$2e19a69cc26b147,
    faSquareShareNodes: $159afdcd077ecfe9$export$1bdb0ec5af3fea99,
    faShareAltSquare: $159afdcd077ecfe9$export$3799c2d8fd7e493b,
    faTableCellsLarge: $159afdcd077ecfe9$export$d2bcaf492dfb3817,
    faThLarge: $159afdcd077ecfe9$export$69782f333e90cdc6,
    faCat: $159afdcd077ecfe9$export$ab927dada03be4b3,
    faCalendarWeek: $159afdcd077ecfe9$export$39be5cb4aed5a521,
    faCodeCompare: $159afdcd077ecfe9$export$ca4c5b4dcff58860,
    faRoadCircleXmark: $159afdcd077ecfe9$export$2ffc88a4d31e8ffc,
    faPallet: $159afdcd077ecfe9$export$d7ff2047dbc34562,
    faCakeCandles: $159afdcd077ecfe9$export$e4019fe302a972e1,
    faBirthdayCake: $159afdcd077ecfe9$export$bdcf98f725a7241a,
    faCake: $159afdcd077ecfe9$export$707bc1c80c0177c1,
    faBugSlash: $159afdcd077ecfe9$export$fc4dd5feed8df23,
    faTarp: $159afdcd077ecfe9$export$2305b1a41b3f914,
    faDiagramPredecessor: $159afdcd077ecfe9$export$1852c99deca7bee8,
    faFaceFlushed: $159afdcd077ecfe9$export$ba5dc4287853ecbd,
    faFlushed: $159afdcd077ecfe9$export$dfd2bd012685aeac,
    faDiagramNext: $159afdcd077ecfe9$export$2faddf1690e14e11,
    faAnchorCircleXmark: $159afdcd077ecfe9$export$f6773af4219eebd,
    faPersonCircleXmark: $159afdcd077ecfe9$export$16c9e0374c346c6e,
    faSpa: $159afdcd077ecfe9$export$f9a38ef7b046ab51,
    faBarsProgress: $159afdcd077ecfe9$export$ee3a02da18715b2,
    faTasksAlt: $159afdcd077ecfe9$export$bbc0784fc1578f7f,
    faHeartCircleCheck: $159afdcd077ecfe9$export$5e4b6785eedecc1a,
    faMarsStrokeRight: $159afdcd077ecfe9$export$321e84e6a900c2d6,
    faMarsStrokeH: $159afdcd077ecfe9$export$5cb0daeafbcdabe3,
    faTowerObservation: $159afdcd077ecfe9$export$5b2f0f631f559d51,
    faSterlingSign: $159afdcd077ecfe9$export$170c56774c8e7961,
    faGbp: $159afdcd077ecfe9$export$3d9479ec1d1ae83e,
    faPoundSign: $159afdcd077ecfe9$export$9ce041dfec8319b,
    faFaucetDrip: $159afdcd077ecfe9$export$7a255960242435f6,
    faCircleInfo: $159afdcd077ecfe9$export$317f99f46b39906e,
    faInfoCircle: $159afdcd077ecfe9$export$aa9288aeadf882fa,
    faFeather: $159afdcd077ecfe9$export$5e19aea195b31816,
    faBowlRice: $159afdcd077ecfe9$export$86079bc65a716451,
    faStarHalfStroke: $159afdcd077ecfe9$export$3e4892d8bf919edd,
    faStarHalfAlt: $159afdcd077ecfe9$export$c13575f42532efb3,
    faTemperatureArrowDown: $159afdcd077ecfe9$export$4520eb1840c4e110,
    faTemperatureDown: $159afdcd077ecfe9$export$f0b2aca3866f00f6,
    faMaskVentilator: $159afdcd077ecfe9$export$122c8413a0dc5ff6,
    faFileVideo: $159afdcd077ecfe9$export$b44eb38345c6a964,
    faArrowTrendDown: $159afdcd077ecfe9$export$d2caed5e37174c23,
    faOilCan: $159afdcd077ecfe9$export$2599126c3a57f727,
    faPeopleCarryBox: $159afdcd077ecfe9$export$7754cc6d5559ff38,
    faPeopleCarry: $159afdcd077ecfe9$export$35fbd4ff1265acd5,
    faChair: $159afdcd077ecfe9$export$a339864ee3df7e9a,
    faWind: $159afdcd077ecfe9$export$cc58cb0f2257a6a9,
    faLayerGroup: $159afdcd077ecfe9$export$a137712e11e257dd,
    faHeadSideMask: $159afdcd077ecfe9$export$280300af4baa1a3e,
    faHands: $159afdcd077ecfe9$export$f9712d0cf5150f0c,
    faSignLanguage: $159afdcd077ecfe9$export$20993813350f9671,
    faSigning: $159afdcd077ecfe9$export$5cc0e6f5191f4f02,
    faTablets: $159afdcd077ecfe9$export$bed2b0ed4ae45e0d,
    faWeightHanging: $159afdcd077ecfe9$export$43d1fa6671908715,
    faDice: $159afdcd077ecfe9$export$4ed8206e6619cc8f,
    faShopSlash: $159afdcd077ecfe9$export$b3d636689da4a3e5,
    faStoreAltSlash: $159afdcd077ecfe9$export$b932a586f6ff48b4,
    faSortDown: $159afdcd077ecfe9$export$58e2577a373e7d4,
    faSortDesc: $159afdcd077ecfe9$export$e24f016f5f78af6a,
    faPesetaSign: $159afdcd077ecfe9$export$a6f8654bcd49a39f,
    faTabletScreenButton: $159afdcd077ecfe9$export$df1e253fc358ade4,
    faTabletAlt: $159afdcd077ecfe9$export$db0cac088255eacc,
    faHandHoldingDollar: $159afdcd077ecfe9$export$61a67f5f8ab39be,
    faHandHoldingUsd: $159afdcd077ecfe9$export$47d27bc305b59690,
    faShield: $159afdcd077ecfe9$export$8241bd5b9163ca12,
    faShieldBlank: $159afdcd077ecfe9$export$64f54da8fbaba8ee,
    faFaceLaugh: $159afdcd077ecfe9$export$2f203616c892d415,
    faLaugh: $159afdcd077ecfe9$export$6c74e314e801a4fe,
    faHandsHolding: $159afdcd077ecfe9$export$96891bbcda1dbb7b,
    faCartShopping: $159afdcd077ecfe9$export$c790b41dc166ae13,
    faShoppingCart: $159afdcd077ecfe9$export$51da406e5aa1388c,
    faOctagon: $159afdcd077ecfe9$export$64f52ad9eeb58eda,
    faHandPointer: $159afdcd077ecfe9$export$d97ff927c450c87f,
    faRegistered: $159afdcd077ecfe9$export$5f519e9ac15ab8c3,
    faHouseSignal: $159afdcd077ecfe9$export$58845db8e7e9a199,
    faBangladeshiTakaSign: $159afdcd077ecfe9$export$469d376940e10d37
};



var $baslc = parcelRequire("baslc");
/*!
 * Font Awesome Free 7.0.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2025 Fonticons, Inc.
 */ function $87ca9af917cac014$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $87ca9af917cac014$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $87ca9af917cac014$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $87ca9af917cac014$var$_arrayLikeToArray(r);
}
function $87ca9af917cac014$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $87ca9af917cac014$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $87ca9af917cac014$var$_toPropertyKey(o.key), o);
    }
}
function $87ca9af917cac014$var$_createClass(e, r, t) {
    return r && $87ca9af917cac014$var$_defineProperties(e.prototype, r), t && $87ca9af917cac014$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $87ca9af917cac014$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $87ca9af917cac014$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var n = 0, F = function() {};
            return {
                s: F,
                n: function() {
                    return n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[n++]
                    };
                },
                e: function(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function() {
            t = t.call(r);
        },
        n: function() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function(r) {
            u = !0, o = r;
        },
        f: function() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $87ca9af917cac014$var$_defineProperty(e, r, t) {
    return (r = $87ca9af917cac014$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $87ca9af917cac014$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $87ca9af917cac014$var$_setPrototypeOf(t, e);
}
function $87ca9af917cac014$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $87ca9af917cac014$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $87ca9af917cac014$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $87ca9af917cac014$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $87ca9af917cac014$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87ca9af917cac014$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87ca9af917cac014$var$ownKeys(Object(t), !0).forEach(function(r) {
            $87ca9af917cac014$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87ca9af917cac014$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $87ca9af917cac014$var$_setPrototypeOf(t, e) {
    return $87ca9af917cac014$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $87ca9af917cac014$var$_setPrototypeOf(t, e);
}
function $87ca9af917cac014$var$_slicedToArray(r, e) {
    return $87ca9af917cac014$var$_arrayWithHoles(r) || $87ca9af917cac014$var$_iterableToArrayLimit(r, e) || $87ca9af917cac014$var$_unsupportedIterableToArray(r, e) || $87ca9af917cac014$var$_nonIterableRest();
}
function $87ca9af917cac014$var$_toConsumableArray(r) {
    return $87ca9af917cac014$var$_arrayWithoutHoles(r) || $87ca9af917cac014$var$_iterableToArray(r) || $87ca9af917cac014$var$_unsupportedIterableToArray(r) || $87ca9af917cac014$var$_nonIterableSpread();
}
function $87ca9af917cac014$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $87ca9af917cac014$var$_toPropertyKey(t) {
    var i = $87ca9af917cac014$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $87ca9af917cac014$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $87ca9af917cac014$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $87ca9af917cac014$var$_typeof(o);
}
function $87ca9af917cac014$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $87ca9af917cac014$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $87ca9af917cac014$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $87ca9af917cac014$var$_wrapRegExp() {
    $87ca9af917cac014$var$_wrapRegExp = function(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $87ca9af917cac014$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $87ca9af917cac014$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function(e, r, t) {
                if ("" === t) return e;
                var p = o[r];
                return Array.isArray(p) ? "$" + p.join("$") : "number" == typeof p ? "$" + p : "";
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $87ca9af917cac014$var$_wrapRegExp.apply(this, arguments);
}
var $87ca9af917cac014$var$noop = function noop() {};
var $87ca9af917cac014$var$_WINDOW = {};
var $87ca9af917cac014$var$_DOCUMENT = {};
var $87ca9af917cac014$var$_MUTATION_OBSERVER = null;
var $87ca9af917cac014$var$_PERFORMANCE = {
    mark: $87ca9af917cac014$var$noop,
    measure: $87ca9af917cac014$var$noop
};
try {
    if (typeof window !== 'undefined') $87ca9af917cac014$var$_WINDOW = window;
    if (typeof document !== 'undefined') $87ca9af917cac014$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $87ca9af917cac014$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $87ca9af917cac014$var$_PERFORMANCE = performance;
} catch (e) {} // eslint-disable-line no-empty
var $87ca9af917cac014$var$_ref = $87ca9af917cac014$var$_WINDOW.navigator || {}, $87ca9af917cac014$var$_ref$userAgent = $87ca9af917cac014$var$_ref.userAgent, $87ca9af917cac014$var$userAgent = $87ca9af917cac014$var$_ref$userAgent === void 0 ? '' : $87ca9af917cac014$var$_ref$userAgent;
var $87ca9af917cac014$var$WINDOW = $87ca9af917cac014$var$_WINDOW;
var $87ca9af917cac014$var$DOCUMENT = $87ca9af917cac014$var$_DOCUMENT;
var $87ca9af917cac014$var$MUTATION_OBSERVER = $87ca9af917cac014$var$_MUTATION_OBSERVER;
var $87ca9af917cac014$var$PERFORMANCE = $87ca9af917cac014$var$_PERFORMANCE;
var $87ca9af917cac014$var$IS_BROWSER = !!$87ca9af917cac014$var$WINDOW.document;
var $87ca9af917cac014$var$IS_DOM = !!$87ca9af917cac014$var$DOCUMENT.documentElement && !!$87ca9af917cac014$var$DOCUMENT.head && typeof $87ca9af917cac014$var$DOCUMENT.addEventListener === 'function' && typeof $87ca9af917cac014$var$DOCUMENT.createElement === 'function';
var $87ca9af917cac014$var$IS_IE = ~$87ca9af917cac014$var$userAgent.indexOf('MSIE') || ~$87ca9af917cac014$var$userAgent.indexOf('Trident/');
var $87ca9af917cac014$var$_so;
var $87ca9af917cac014$var$K = /fa(k|kd|s|r|l|t|d|dr|dl|dt|b|slr|slpr|wsb|tl|ns|nds|es|jr|jfr|jdr|cr|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, $87ca9af917cac014$var$W = /Font ?Awesome ?([567 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit|Notdog Duo|Notdog|Chisel|Etch|Thumbprint|Jelly Fill|Jelly Duo|Jelly|Slab Press|Slab|Whiteboard)?.*/i;
var $87ca9af917cac014$var$z = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    },
    slab: {
        "fa-regular": "regular",
        faslr: "regular"
    },
    "slab-press": {
        "fa-regular": "regular",
        faslpr: "regular"
    },
    thumbprint: {
        "fa-light": "light",
        fatl: "light"
    },
    whiteboard: {
        "fa-semibold": "semibold",
        fawsb: "semibold"
    },
    notdog: {
        "fa-solid": "solid",
        fans: "solid"
    },
    "notdog-duo": {
        "fa-solid": "solid",
        fands: "solid"
    },
    etch: {
        "fa-solid": "solid",
        faes: "solid"
    },
    jelly: {
        "fa-regular": "regular",
        fajr: "regular"
    },
    "jelly-fill": {
        "fa-regular": "regular",
        fajfr: "regular"
    },
    "jelly-duo": {
        "fa-regular": "regular",
        fajdr: "regular"
    },
    chisel: {
        "fa-regular": "regular",
        facr: "regular"
    }
}, $87ca9af917cac014$var$O = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $87ca9af917cac014$var$G = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-thumbprint",
    "fa-whiteboard",
    "fa-notdog",
    "fa-notdog-duo",
    "fa-chisel",
    "fa-etch",
    "fa-jelly",
    "fa-jelly-fill",
    "fa-jelly-duo",
    "fa-slab",
    "fa-slab-press"
];
var $87ca9af917cac014$var$a = "classic", $87ca9af917cac014$var$o = "duotone", $87ca9af917cac014$var$d = "sharp", $87ca9af917cac014$var$t = "sharp-duotone", $87ca9af917cac014$var$i = "chisel", $87ca9af917cac014$var$n = "etch", $87ca9af917cac014$var$h = "jelly", $87ca9af917cac014$var$s = "jelly-duo", $87ca9af917cac014$var$f = "jelly-fill", $87ca9af917cac014$var$g = "notdog", $87ca9af917cac014$var$l = "notdog-duo", $87ca9af917cac014$var$u = "slab", $87ca9af917cac014$var$p = "slab-press", $87ca9af917cac014$var$e = "thumbprint", $87ca9af917cac014$var$w = "whiteboard", $87ca9af917cac014$var$m = "Classic", $87ca9af917cac014$var$y = "Duotone", $87ca9af917cac014$var$x = "Sharp", $87ca9af917cac014$var$c = "Sharp Duotone", $87ca9af917cac014$var$I = "Chisel", $87ca9af917cac014$var$b = "Etch", $87ca9af917cac014$var$F = "Jelly", $87ca9af917cac014$var$v = "Jelly Duo", $87ca9af917cac014$var$S = "Jelly Fill", $87ca9af917cac014$var$A = "Notdog", $87ca9af917cac014$var$P = "Notdog Duo", $87ca9af917cac014$var$j = "Slab", $87ca9af917cac014$var$B = "Slab Press", $87ca9af917cac014$var$N = "Thumbprint", $87ca9af917cac014$var$k = "Whiteboard", $87ca9af917cac014$var$oo = [
    $87ca9af917cac014$var$a,
    $87ca9af917cac014$var$o,
    $87ca9af917cac014$var$d,
    $87ca9af917cac014$var$t,
    $87ca9af917cac014$var$i,
    $87ca9af917cac014$var$n,
    $87ca9af917cac014$var$h,
    $87ca9af917cac014$var$s,
    $87ca9af917cac014$var$f,
    $87ca9af917cac014$var$g,
    $87ca9af917cac014$var$l,
    $87ca9af917cac014$var$u,
    $87ca9af917cac014$var$p,
    $87ca9af917cac014$var$e,
    $87ca9af917cac014$var$w
], $87ca9af917cac014$var$so = ($87ca9af917cac014$var$_so = {}, $87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_so, $87ca9af917cac014$var$a, $87ca9af917cac014$var$m), $87ca9af917cac014$var$o, $87ca9af917cac014$var$y), $87ca9af917cac014$var$d, $87ca9af917cac014$var$x), $87ca9af917cac014$var$t, $87ca9af917cac014$var$c), $87ca9af917cac014$var$i, $87ca9af917cac014$var$I), $87ca9af917cac014$var$n, $87ca9af917cac014$var$b), $87ca9af917cac014$var$h, $87ca9af917cac014$var$F), $87ca9af917cac014$var$s, $87ca9af917cac014$var$v), $87ca9af917cac014$var$f, $87ca9af917cac014$var$S), $87ca9af917cac014$var$g, $87ca9af917cac014$var$A), $87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_so, $87ca9af917cac014$var$l, $87ca9af917cac014$var$P), $87ca9af917cac014$var$u, $87ca9af917cac014$var$j), $87ca9af917cac014$var$p, $87ca9af917cac014$var$B), $87ca9af917cac014$var$e, $87ca9af917cac014$var$N), $87ca9af917cac014$var$w, $87ca9af917cac014$var$k));
var $87ca9af917cac014$var$io = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    },
    slab: {
        400: "faslr"
    },
    "slab-press": {
        400: "faslpr"
    },
    whiteboard: {
        600: "fawsb"
    },
    thumbprint: {
        300: "fatl"
    },
    notdog: {
        900: "fans"
    },
    "notdog-duo": {
        900: "fands"
    },
    etch: {
        900: "faes"
    },
    chisel: {
        400: "facr"
    },
    jelly: {
        400: "fajr"
    },
    "jelly-fill": {
        400: "fajfr"
    },
    "jelly-duo": {
        400: "fajdr"
    }
};
var $87ca9af917cac014$var$Bo = {
    "Font Awesome 7 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 7 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 7 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 7 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 7 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 7 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    },
    "Font Awesome 7 Jelly": {
        400: "fajr",
        normal: "fajr"
    },
    "Font Awesome 7 Jelly Fill": {
        400: "fajfr",
        normal: "fajfr"
    },
    "Font Awesome 7 Jelly Duo": {
        400: "fajdr",
        normal: "fajdr"
    },
    "Font Awesome 7 Slab": {
        400: "faslr",
        normal: "faslr"
    },
    "Font Awesome 7 Slab Press": {
        400: "faslpr",
        normal: "faslpr"
    },
    "Font Awesome 7 Thumbprint": {
        300: "fatl",
        normal: "fatl"
    },
    "Font Awesome 7 Notdog": {
        900: "fans",
        normal: "fans"
    },
    "Font Awesome 7 Notdog Duo": {
        900: "fands",
        normal: "fands"
    },
    "Font Awesome 7 Etch": {
        900: "faes",
        normal: "faes"
    },
    "Font Awesome 7 Chisel": {
        400: "facr",
        normal: "facr"
    },
    "Font Awesome 7 Whiteboard": {
        600: "fawsb",
        normal: "fawsb"
    }
};
var $87ca9af917cac014$var$Co = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "chisel",
        {
            defaultShortPrefixId: "facr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "etch",
        {
            defaultShortPrefixId: "faes",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "jelly",
        {
            defaultShortPrefixId: "fajr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "jelly-duo",
        {
            defaultShortPrefixId: "fajdr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "jelly-fill",
        {
            defaultShortPrefixId: "fajfr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "notdog",
        {
            defaultShortPrefixId: "fans",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "notdog-duo",
        {
            defaultShortPrefixId: "fands",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "slab",
        {
            defaultShortPrefixId: "faslr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab-press",
        {
            defaultShortPrefixId: "faslpr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "thumbprint",
        {
            defaultShortPrefixId: "fatl",
            defaultStyleId: "light",
            styleIds: [
                "light"
            ],
            futureStyleIds: [],
            defaultFontWeight: 300
        }
    ],
    [
        "whiteboard",
        {
            defaultShortPrefixId: "fawsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ]
]), $87ca9af917cac014$var$Ro = {
    chisel: {
        regular: "facr"
    },
    classic: {
        brands: "fab",
        light: "fal",
        regular: "far",
        solid: "fas",
        thin: "fat"
    },
    duotone: {
        light: "fadl",
        regular: "fadr",
        solid: "fad",
        thin: "fadt"
    },
    etch: {
        solid: "faes"
    },
    jelly: {
        regular: "fajr"
    },
    "jelly-duo": {
        regular: "fajdr"
    },
    "jelly-fill": {
        regular: "fajfr"
    },
    notdog: {
        solid: "fans"
    },
    "notdog-duo": {
        solid: "fands"
    },
    sharp: {
        light: "fasl",
        regular: "fasr",
        solid: "fass",
        thin: "fast"
    },
    "sharp-duotone": {
        light: "fasdl",
        regular: "fasdr",
        solid: "fasds",
        thin: "fasdt"
    },
    slab: {
        regular: "faslr"
    },
    "slab-press": {
        regular: "faslpr"
    },
    thumbprint: {
        light: "fatl"
    },
    whiteboard: {
        semibold: "fawsb"
    }
};
var $87ca9af917cac014$var$zo = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $87ca9af917cac014$var$Oo = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $87ca9af917cac014$var$Go = [
    "kit"
];
var $87ca9af917cac014$var$D = "kit", $87ca9af917cac014$var$r = "kit-duotone", $87ca9af917cac014$var$T = "Kit", $87ca9af917cac014$var$C = "Kit Duotone", $87ca9af917cac014$var$qo = $87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty({}, $87ca9af917cac014$var$D, $87ca9af917cac014$var$T), $87ca9af917cac014$var$r, $87ca9af917cac014$var$C);
var $87ca9af917cac014$var$Xo = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
};
var $87ca9af917cac014$var$lt = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
}, $87ca9af917cac014$var$et = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
};
var $87ca9af917cac014$var$dt = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
var $87ca9af917cac014$var$_fl;
var $87ca9af917cac014$var$l$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $87ca9af917cac014$var$i$1 = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-thumbprint",
    "fa-whiteboard",
    "fa-notdog",
    "fa-notdog-duo",
    "fa-chisel",
    "fa-etch",
    "fa-jelly",
    "fa-jelly-fill",
    "fa-jelly-duo",
    "fa-slab",
    "fa-slab-press"
];
var $87ca9af917cac014$var$f$1 = "classic", $87ca9af917cac014$var$a$1 = "duotone", $87ca9af917cac014$var$n$1 = "sharp", $87ca9af917cac014$var$t$1 = "sharp-duotone", $87ca9af917cac014$var$h$1 = "chisel", $87ca9af917cac014$var$g$1 = "etch", $87ca9af917cac014$var$u$1 = "jelly", $87ca9af917cac014$var$s$1 = "jelly-duo", $87ca9af917cac014$var$p$1 = "jelly-fill", $87ca9af917cac014$var$y$1 = "notdog", $87ca9af917cac014$var$e$1 = "notdog-duo", $87ca9af917cac014$var$m$1 = "slab", $87ca9af917cac014$var$c$1 = "slab-press", $87ca9af917cac014$var$r$1 = "thumbprint", $87ca9af917cac014$var$w$1 = "whiteboard", $87ca9af917cac014$var$x$1 = "Classic", $87ca9af917cac014$var$I$1 = "Duotone", $87ca9af917cac014$var$b$1 = "Sharp", $87ca9af917cac014$var$F$1 = "Sharp Duotone", $87ca9af917cac014$var$v$1 = "Chisel", $87ca9af917cac014$var$S$1 = "Etch", $87ca9af917cac014$var$A$1 = "Jelly", $87ca9af917cac014$var$j$1 = "Jelly Duo", $87ca9af917cac014$var$P$1 = "Jelly Fill", $87ca9af917cac014$var$B$1 = "Notdog", $87ca9af917cac014$var$k$1 = "Notdog Duo", $87ca9af917cac014$var$N$1 = "Slab", $87ca9af917cac014$var$D$1 = "Slab Press", $87ca9af917cac014$var$C$1 = "Thumbprint", $87ca9af917cac014$var$T$1 = "Whiteboard", $87ca9af917cac014$var$fl = ($87ca9af917cac014$var$_fl = {}, $87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_fl, $87ca9af917cac014$var$f$1, $87ca9af917cac014$var$x$1), $87ca9af917cac014$var$a$1, $87ca9af917cac014$var$I$1), $87ca9af917cac014$var$n$1, $87ca9af917cac014$var$b$1), $87ca9af917cac014$var$t$1, $87ca9af917cac014$var$F$1), $87ca9af917cac014$var$h$1, $87ca9af917cac014$var$v$1), $87ca9af917cac014$var$g$1, $87ca9af917cac014$var$S$1), $87ca9af917cac014$var$u$1, $87ca9af917cac014$var$A$1), $87ca9af917cac014$var$s$1, $87ca9af917cac014$var$j$1), $87ca9af917cac014$var$p$1, $87ca9af917cac014$var$P$1), $87ca9af917cac014$var$y$1, $87ca9af917cac014$var$B$1), $87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_fl, $87ca9af917cac014$var$e$1, $87ca9af917cac014$var$k$1), $87ca9af917cac014$var$m$1, $87ca9af917cac014$var$N$1), $87ca9af917cac014$var$c$1, $87ca9af917cac014$var$D$1), $87ca9af917cac014$var$r$1, $87ca9af917cac014$var$C$1), $87ca9af917cac014$var$w$1, $87ca9af917cac014$var$T$1));
var $87ca9af917cac014$var$L = "kit", $87ca9af917cac014$var$d$1 = "kit-duotone", $87ca9af917cac014$var$R$1 = "Kit", $87ca9af917cac014$var$W$1 = "Kit Duotone", $87ca9af917cac014$var$lo$1 = $87ca9af917cac014$var$_defineProperty($87ca9af917cac014$var$_defineProperty({}, $87ca9af917cac014$var$L, $87ca9af917cac014$var$R$1), $87ca9af917cac014$var$d$1, $87ca9af917cac014$var$W$1);
var $87ca9af917cac014$var$zo$1 = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    },
    slab: {
        "fa-regular": "faslr"
    },
    "slab-press": {
        "fa-regular": "faslpr"
    },
    whiteboard: {
        "fa-semibold": "fawsb"
    },
    thumbprint: {
        "fa-light": "fatl"
    },
    notdog: {
        "fa-solid": "fans"
    },
    "notdog-duo": {
        "fa-solid": "fands"
    },
    etch: {
        "fa-solid": "faes"
    },
    jelly: {
        "fa-regular": "fajr"
    },
    "jelly-fill": {
        "fa-regular": "fajfr"
    },
    "jelly-duo": {
        "fa-regular": "fajdr"
    },
    chisel: {
        "fa-regular": "facr"
    }
}, $87ca9af917cac014$var$J$1 = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat",
        "fad"
    ],
    duotone: [
        "fadr",
        "fadl",
        "fadt"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds",
        "fasdr",
        "fasdl",
        "fasdt"
    ],
    slab: [
        "faslr"
    ],
    "slab-press": [
        "faslpr"
    ],
    whiteboard: [
        "fawsb"
    ],
    thumbprint: [
        "fatl"
    ],
    notdog: [
        "fans"
    ],
    "notdog-duo": [
        "fands"
    ],
    etch: [
        "faes"
    ],
    jelly: [
        "fajr"
    ],
    "jelly-fill": [
        "fajfr"
    ],
    "jelly-duo": [
        "fajdr"
    ],
    chisel: [
        "facr"
    ]
}, $87ca9af917cac014$var$Go$1 = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    },
    slab: {
        faslr: "fa-regular"
    },
    "slab-press": {
        faslpr: "fa-regular"
    },
    whiteboard: {
        fawsb: "fa-semibold"
    },
    thumbprint: {
        fatl: "fa-light"
    },
    notdog: {
        fans: "fa-solid"
    },
    "notdog-duo": {
        fands: "fa-solid"
    },
    etch: {
        faes: "fa-solid"
    },
    jelly: {
        fajr: "fa-regular"
    },
    "jelly-fill": {
        fajfr: "fa-regular"
    },
    "jelly-duo": {
        fajdr: "fa-regular"
    },
    chisel: {
        facr: "fa-regular"
    }
}, $87ca9af917cac014$var$E$1 = [
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands",
    "fa-semibold"
], $87ca9af917cac014$var$$o$1 = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    "faslr",
    "faslpr",
    "fawsb",
    "fatl",
    "fans",
    "fands",
    "faes",
    "fajr",
    "fajfr",
    "fajdr",
    "facr"
].concat($87ca9af917cac014$var$i$1, $87ca9af917cac014$var$E$1), $87ca9af917cac014$var$_$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands",
    "semibold"
], $87ca9af917cac014$var$K$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $87ca9af917cac014$var$M$1 = $87ca9af917cac014$var$K$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $87ca9af917cac014$var$O$1 = [
    "aw",
    "fw",
    "pull-left",
    "pull-right"
], $87ca9af917cac014$var$Ho$1 = [].concat($87ca9af917cac014$var$_toConsumableArray(Object.keys($87ca9af917cac014$var$J$1)), $87ca9af917cac014$var$_$1, $87ca9af917cac014$var$O$1, [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "border",
    "fade",
    "beat-fade",
    "bounce",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "inverse",
    "layers",
    "layers-bottom-left",
    "layers-bottom-right",
    "layers-counter",
    "layers-text",
    "layers-top-left",
    "layers-top-right",
    "li",
    "pull-end",
    "pull-start",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "stack-1x",
    "stack-2x",
    "stack",
    "ul",
    "width-auto",
    "width-fixed",
    $87ca9af917cac014$var$l$1.GROUP,
    $87ca9af917cac014$var$l$1.SWAP_OPACITY,
    $87ca9af917cac014$var$l$1.PRIMARY,
    $87ca9af917cac014$var$l$1.SECONDARY
]).concat($87ca9af917cac014$var$K$1.map(function(o) {
    return "".concat(o, "x");
})).concat($87ca9af917cac014$var$M$1.map(function(o) {
    return "w-".concat(o);
}));
var $87ca9af917cac014$var$oa = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
var $87ca9af917cac014$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $87ca9af917cac014$var$UNITS_IN_GRID = 16;
var $87ca9af917cac014$var$DEFAULT_CSS_PREFIX = 'fa';
var $87ca9af917cac014$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $87ca9af917cac014$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $87ca9af917cac014$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $87ca9af917cac014$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $87ca9af917cac014$var$DATA_PREFIX = 'data-prefix';
var $87ca9af917cac014$var$DATA_ICON = 'data-icon';
var $87ca9af917cac014$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $87ca9af917cac014$var$MUTATION_APPROACH_ASYNC = 'async';
var $87ca9af917cac014$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $87ca9af917cac014$var$PSEUDO_ELEMENTS = [
    '::before',
    '::after',
    ':before',
    ':after'
];
var $87ca9af917cac014$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
}();
function $87ca9af917cac014$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$87ca9af917cac014$var$a];
        }
    });
}
var $87ca9af917cac014$var$_PREFIX_TO_STYLE = $87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$z);
// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
$87ca9af917cac014$var$_PREFIX_TO_STYLE[$87ca9af917cac014$var$a] = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, {
    'fa-duotone': 'duotone'
}), $87ca9af917cac014$var$z[$87ca9af917cac014$var$a]), $87ca9af917cac014$var$Oo['kit']), $87ca9af917cac014$var$Oo['kit-duotone']);
var $87ca9af917cac014$var$PREFIX_TO_STYLE = $87ca9af917cac014$var$familyProxy($87ca9af917cac014$var$_PREFIX_TO_STYLE);
var $87ca9af917cac014$var$_STYLE_TO_PREFIX = $87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$Ro);
// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
$87ca9af917cac014$var$_STYLE_TO_PREFIX[$87ca9af917cac014$var$a] = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, {
    duotone: 'fad'
}), $87ca9af917cac014$var$_STYLE_TO_PREFIX[$87ca9af917cac014$var$a]), $87ca9af917cac014$var$dt['kit']), $87ca9af917cac014$var$dt['kit-duotone']);
var $87ca9af917cac014$var$STYLE_TO_PREFIX = $87ca9af917cac014$var$familyProxy($87ca9af917cac014$var$_STYLE_TO_PREFIX);
var $87ca9af917cac014$var$_PREFIX_TO_LONG_STYLE = $87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$Go$1);
$87ca9af917cac014$var$_PREFIX_TO_LONG_STYLE[$87ca9af917cac014$var$a] = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$_PREFIX_TO_LONG_STYLE[$87ca9af917cac014$var$a]), $87ca9af917cac014$var$et['kit']);
var $87ca9af917cac014$var$PREFIX_TO_LONG_STYLE = $87ca9af917cac014$var$familyProxy($87ca9af917cac014$var$_PREFIX_TO_LONG_STYLE);
var $87ca9af917cac014$var$_LONG_STYLE_TO_PREFIX = $87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$zo$1);
$87ca9af917cac014$var$_LONG_STYLE_TO_PREFIX[$87ca9af917cac014$var$a] = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$_LONG_STYLE_TO_PREFIX[$87ca9af917cac014$var$a]), $87ca9af917cac014$var$Xo['kit']);
var $87ca9af917cac014$var$LONG_STYLE_TO_PREFIX = $87ca9af917cac014$var$familyProxy($87ca9af917cac014$var$_LONG_STYLE_TO_PREFIX);
var $87ca9af917cac014$var$ICON_SELECTION_SYNTAX_PATTERN = $87ca9af917cac014$var$K;
var $87ca9af917cac014$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $87ca9af917cac014$var$FONT_FAMILY_PATTERN = $87ca9af917cac014$var$W;
var $87ca9af917cac014$var$_FONT_WEIGHT_TO_PREFIX = $87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$io);
var $87ca9af917cac014$var$FONT_WEIGHT_TO_PREFIX = $87ca9af917cac014$var$familyProxy($87ca9af917cac014$var$_FONT_WEIGHT_TO_PREFIX);
var $87ca9af917cac014$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $87ca9af917cac014$var$DUOTONE_CLASSES = $87ca9af917cac014$var$O;
var $87ca9af917cac014$var$RESERVED_CLASSES = [].concat($87ca9af917cac014$var$_toConsumableArray($87ca9af917cac014$var$Go), $87ca9af917cac014$var$_toConsumableArray($87ca9af917cac014$var$Ho$1));
var $87ca9af917cac014$var$initial = $87ca9af917cac014$var$WINDOW.FontAwesomeConfig || {};
function $87ca9af917cac014$var$getAttrConfig(attr) {
    var element = $87ca9af917cac014$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $87ca9af917cac014$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($87ca9af917cac014$var$DOCUMENT && typeof $87ca9af917cac014$var$DOCUMENT.querySelector === 'function') {
    var $87ca9af917cac014$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-search-pseudo-elements-warnings',
            'searchPseudoElementsWarnings'
        ],
        [
            'data-search-pseudo-elements-full-scan',
            'searchPseudoElementsFullScan'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $87ca9af917cac014$var$attrs.forEach(function(_ref) {
        var _ref2 = $87ca9af917cac014$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $87ca9af917cac014$var$coerce($87ca9af917cac014$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $87ca9af917cac014$var$initial[key] = val;
    });
}
var $87ca9af917cac014$var$_default = {
    styleDefault: 'solid',
    familyDefault: $87ca9af917cac014$var$a,
    cssPrefix: $87ca9af917cac014$var$DEFAULT_CSS_PREFIX,
    replacementClass: $87ca9af917cac014$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    searchPseudoElements: false,
    searchPseudoElementsWarnings: true,
    searchPseudoElementsFullScan: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
// familyPrefix is deprecated but we must still support it if present
if ($87ca9af917cac014$var$initial.familyPrefix) $87ca9af917cac014$var$initial.cssPrefix = $87ca9af917cac014$var$initial.familyPrefix;
var $87ca9af917cac014$var$_config = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$_default), $87ca9af917cac014$var$initial);
if (!$87ca9af917cac014$var$_config.autoReplaceSvg) $87ca9af917cac014$var$_config.observeMutations = false;
var $87ca9af917cac014$var$config = {};
Object.keys($87ca9af917cac014$var$_default).forEach(function(key) {
    Object.defineProperty($87ca9af917cac014$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $87ca9af917cac014$var$_config[key] = val;
            $87ca9af917cac014$var$_onChangeCb.forEach(function(cb) {
                return cb($87ca9af917cac014$var$config);
            });
        },
        get: function get() {
            return $87ca9af917cac014$var$_config[key];
        }
    });
});
// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($87ca9af917cac014$var$config, 'familyPrefix', {
    enumerable: true,
    set: function set(val) {
        $87ca9af917cac014$var$_config.cssPrefix = val;
        $87ca9af917cac014$var$_onChangeCb.forEach(function(cb) {
            return cb($87ca9af917cac014$var$config);
        });
    },
    get: function get() {
        return $87ca9af917cac014$var$_config.cssPrefix;
    }
});
$87ca9af917cac014$var$WINDOW.FontAwesomeConfig = $87ca9af917cac014$var$config;
var $87ca9af917cac014$var$_onChangeCb = [];
function $87ca9af917cac014$var$onChange(cb) {
    $87ca9af917cac014$var$_onChangeCb.push(cb);
    return function() {
        $87ca9af917cac014$var$_onChangeCb.splice($87ca9af917cac014$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $87ca9af917cac014$var$d$2 = $87ca9af917cac014$var$UNITS_IN_GRID;
var $87ca9af917cac014$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $87ca9af917cac014$var$insertCss(css) {
    if (!css || !$87ca9af917cac014$var$IS_DOM) return;
    var style = $87ca9af917cac014$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $87ca9af917cac014$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $87ca9af917cac014$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $87ca9af917cac014$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $87ca9af917cac014$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $87ca9af917cac014$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $87ca9af917cac014$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $87ca9af917cac014$var$classArray(node) {
    if (node.classList) return $87ca9af917cac014$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $87ca9af917cac014$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $87ca9af917cac014$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($87ca9af917cac014$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $87ca9af917cac014$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $87ca9af917cac014$var$transformIsMeaningful(transform) {
    return transform.size !== $87ca9af917cac014$var$meaninglessTransform.size || transform.x !== $87ca9af917cac014$var$meaninglessTransform.x || transform.y !== $87ca9af917cac014$var$meaninglessTransform.y || transform.rotate !== $87ca9af917cac014$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $87ca9af917cac014$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $87ca9af917cac014$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $87ca9af917cac014$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $87ca9af917cac014$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $87ca9af917cac014$var$IS_IE) val += "translate(".concat(transform.x / $87ca9af917cac014$var$d$2 - width / 2, "em, ").concat(transform.y / $87ca9af917cac014$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $87ca9af917cac014$var$d$2, "em), calc(-50% + ").concat(transform.y / $87ca9af917cac014$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $87ca9af917cac014$var$d$2, "em, ").concat(transform.y / $87ca9af917cac014$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $87ca9af917cac014$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $87ca9af917cac014$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $87ca9af917cac014$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 \"Font Awesome 7 Free\";\n  --fa-font-regular: normal 400 1em/1 \"Font Awesome 7 Free\";\n  --fa-font-light: normal 300 1em/1 \"Font Awesome 7 Pro\";\n  --fa-font-thin: normal 100 1em/1 \"Font Awesome 7 Pro\";\n  --fa-font-duotone: normal 900 1em/1 \"Font Awesome 7 Duotone\";\n  --fa-font-duotone-regular: normal 400 1em/1 \"Font Awesome 7 Duotone\";\n  --fa-font-duotone-light: normal 300 1em/1 \"Font Awesome 7 Duotone\";\n  --fa-font-duotone-thin: normal 100 1em/1 \"Font Awesome 7 Duotone\";\n  --fa-font-brands: normal 400 1em/1 \"Font Awesome 7 Brands\";\n  --fa-font-sharp-solid: normal 900 1em/1 \"Font Awesome 7 Sharp\";\n  --fa-font-sharp-regular: normal 400 1em/1 \"Font Awesome 7 Sharp\";\n  --fa-font-sharp-light: normal 300 1em/1 \"Font Awesome 7 Sharp\";\n  --fa-font-sharp-thin: normal 100 1em/1 \"Font Awesome 7 Sharp\";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 \"Font Awesome 7 Sharp Duotone\";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 \"Font Awesome 7 Sharp Duotone\";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 \"Font Awesome 7 Sharp Duotone\";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 \"Font Awesome 7 Sharp Duotone\";\n  --fa-font-slab-regular: normal 400 1em/1 \"Font Awesome 7 Slab\";\n  --fa-font-slab-press-regular: normal 400 1em/1 \"Font Awesome 7 Slab Press\";\n  --fa-font-whiteboard-semibold: normal 600 1em/1 \"Font Awesome 7 Whiteboard\";\n  --fa-font-thumbprint-light: normal 300 1em/1 \"Font Awesome 7 Thumbprint\";\n  --fa-font-notdog-solid: normal 900 1em/1 \"Font Awesome 7 Notdog\";\n  --fa-font-notdog-duo-solid: normal 900 1em/1 \"Font Awesome 7 Notdog Duo\";\n  --fa-font-etch-solid: normal 900 1em/1 \"Font Awesome 7 Etch\";\n  --fa-font-jelly-regular: normal 400 1em/1 \"Font Awesome 7 Jelly\";\n  --fa-font-jelly-fill-regular: normal 400 1em/1 \"Font Awesome 7 Jelly Fill\";\n  --fa-font-jelly-duo-regular: normal 400 1em/1 \"Font Awesome 7 Jelly Duo\";\n  --fa-font-chisel-regular: normal 400 1em/1 \"Font Awesome 7 Chisel\";\n}\n\n.svg-inline--fa {\n  box-sizing: content-box;\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n  width: var(--fa-width, 1.25em);\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285714em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left,\n.svg-inline--fa .fa-pull-start {\n  float: inline-start;\n  margin-inline-end: var(--fa-pull-margin, 0.3em);\n}\n.svg-inline--fa.fa-pull-right,\n.svg-inline--fa .fa-pull-end {\n  float: inline-end;\n  margin-inline-start: var(--fa-pull-margin, 0.3em);\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));\n  inset-block-start: 0.25em; /* syncing vertical alignment with Web Font rendering */\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: var(--fa-width, 1.25em);\n}\n.fa-layers .svg-inline--fa {\n  inset: 0;\n  margin: auto;\n  position: absolute;\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: calc(10 / 16 * 1em); /* converts a 10px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 10 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 10 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-xs {\n  font-size: calc(12 / 16 * 1em); /* converts a 12px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 12 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 12 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-sm {\n  font-size: calc(14 / 16 * 1em); /* converts a 14px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 14 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 14 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-lg {\n  font-size: calc(20 / 16 * 1em); /* converts a 20px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 20 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 20 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-xl {\n  font-size: calc(24 / 16 * 1em); /* converts a 24px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 24 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 24 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-2xl {\n  font-size: calc(32 / 16 * 1em); /* converts a 32px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 32 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 32 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-width-auto {\n  --fa-width: auto;\n}\n\n.fa-fw,\n.fa-width-fixed {\n  --fa-width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-inline-start: var(--fa-li-margin, 2.5em);\n  padding-inline-start: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n/* Heads Up: Bordered Icons will not be supported in the future!\n  - This feature will be deprecated in the next major release of Font Awesome (v8)!\n  - You may continue to use it in this version *v7), but it will not be supported in Font Awesome v8.\n*/\n/* Notes:\n* --@{v.$css-prefix}-border-width = 1/16 by default (to render as ~1px based on a 16px default font-size)\n* --@{v.$css-prefix}-border-padding =\n  ** 3/16 for vertical padding (to give ~2px of vertical whitespace around an icon considering it's vertical alignment)\n  ** 4/16 for horizontal padding (to give ~4px of horizontal whitespace around an icon)\n*/\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.0625em);\n  box-sizing: var(--fa-border-box-sizing, content-box);\n  padding: var(--fa-border-padding, 0.1875em 0.25em);\n}\n\n.fa-pull-left,\n.fa-pull-start {\n  float: inline-start;\n  margin-inline-end: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right,\n.fa-pull-end {\n  float: inline-end;\n  margin-inline-start: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n  .fa-bounce,\n  .fa-fade,\n  .fa-beat-fade,\n  .fa-flip,\n  .fa-pulse,\n  .fa-shake,\n  .fa-spin,\n  .fa-spin-pulse {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.svg-inline--fa.fa-inverse {\n  fill: var(--fa-inverse, #fff);\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  --fa-width: 1.25em;\n  height: 1em;\n  width: var(--fa-width);\n}\n.svg-inline--fa.fa-stack-2x {\n  --fa-width: 2.5em;\n  height: 2em;\n  width: var(--fa-width);\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  inset: 0;\n  margin: auto;\n  position: absolute;\n  z-index: var(--fa-stack-z-index, auto);\n}";
function $87ca9af917cac014$var$css() {
    var dcp = $87ca9af917cac014$var$DEFAULT_CSS_PREFIX;
    var drc = $87ca9af917cac014$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $87ca9af917cac014$var$config.cssPrefix;
    var rc = $87ca9af917cac014$var$config.replacementClass;
    var s = $87ca9af917cac014$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $87ca9af917cac014$var$_cssInserted = false;
function $87ca9af917cac014$var$ensureCss() {
    if ($87ca9af917cac014$var$config.autoAddCss && !$87ca9af917cac014$var$_cssInserted) {
        $87ca9af917cac014$var$insertCss($87ca9af917cac014$var$css());
        $87ca9af917cac014$var$_cssInserted = true;
    }
}
var $87ca9af917cac014$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $87ca9af917cac014$var$css,
                insertCss: $87ca9af917cac014$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $87ca9af917cac014$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $87ca9af917cac014$var$ensureCss();
            }
        };
    }
};
var $87ca9af917cac014$var$w$2 = $87ca9af917cac014$var$WINDOW || {};
if (!$87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER]) $87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER] = {};
if (!$87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER].styles) $87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER].hooks) $87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER].shims) $87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER].shims = [];
var $87ca9af917cac014$var$namespace = $87ca9af917cac014$var$w$2[$87ca9af917cac014$var$NAMESPACE_IDENTIFIER];
var $87ca9af917cac014$var$functions = [];
var $87ca9af917cac014$var$_listener = function listener() {
    $87ca9af917cac014$var$DOCUMENT.removeEventListener('DOMContentLoaded', $87ca9af917cac014$var$_listener);
    $87ca9af917cac014$var$loaded = 1;
    $87ca9af917cac014$var$functions.map(function(fn) {
        return fn();
    });
};
var $87ca9af917cac014$var$loaded = false;
if ($87ca9af917cac014$var$IS_DOM) {
    $87ca9af917cac014$var$loaded = ($87ca9af917cac014$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($87ca9af917cac014$var$DOCUMENT.readyState);
    if (!$87ca9af917cac014$var$loaded) $87ca9af917cac014$var$DOCUMENT.addEventListener('DOMContentLoaded', $87ca9af917cac014$var$_listener);
}
function $87ca9af917cac014$var$domready(fn) {
    if (!$87ca9af917cac014$var$IS_DOM) return;
    $87ca9af917cac014$var$loaded ? setTimeout(fn, 0) : $87ca9af917cac014$var$functions.push(fn);
}
function $87ca9af917cac014$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $87ca9af917cac014$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($87ca9af917cac014$var$joinAttributes(attributes), ">").concat(children.map($87ca9af917cac014$var$toHtml).join(''), "</").concat(tag, ">");
}
function $87ca9af917cac014$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $87ca9af917cac014$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $87ca9af917cac014$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $87ca9af917cac014$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * Return hexadecimal string for a unicode character
 * Returns `null` when more than one character (not bytes!) are passed
 * For example: 'K' → '7B'
 */ function $87ca9af917cac014$var$toHex(unicode) {
    if ($87ca9af917cac014$var$_toConsumableArray(unicode).length !== 1) return null;
    return unicode.codePointAt(0).toString(16);
}
function $87ca9af917cac014$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $87ca9af917cac014$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $87ca9af917cac014$var$normalizeIcons(icons);
    if (typeof $87ca9af917cac014$var$namespace.hooks.addPack === 'function' && !skipHooks) $87ca9af917cac014$var$namespace.hooks.addPack(prefix, $87ca9af917cac014$var$normalizeIcons(icons));
    else $87ca9af917cac014$var$namespace.styles[prefix] = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $87ca9af917cac014$var$defineIcons('fa', icons);
}
var $87ca9af917cac014$var$MONO = 0x1;
var $87ca9af917cac014$var$DUO = 0x2;
// New v7 compatible matchers using the style attribute to determine layer membership
var $87ca9af917cac014$var$modernMatches = [
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path opacity="([^"]*)".*d="([^"]*)".*path.*d="([^"]*)"/, {
            d2: 2,
            d1: 3
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path opacity="([^"]*)".*d="([^"]*)"/, {
            d2: 2
        })
    ],
    [
        $87ca9af917cac014$var$MONO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path fill="currentColor".*d="([^"]+)"/, {
            d1: 1
        })
    ]
];
// Old <= v6 matchers, these should rarely get used.
//
// Why are there so many? Over the lifecycle of version 5 and 6 we modified the
// syntax for our source SVG files several times. These patterns match the
// historical record and attempt to handle backwards-compatibility in rare edge
// cases (loading version 6 SVG source files using the version 7 SVG parser)
var $87ca9af917cac014$var$legacyMatches = [
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path class="([^"]*secondary[^"]*)".*d="([^"]+)".*path class="([^"]*primary[^"]*)".*d="([^"]+)"/, {
            attr2: 1,
            d2: 2,
            attr1: 3,
            d1: 4
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path class="([^"]*primary[^"]*)".*d="([^"]+)".*path class="([^"]*secondary[^"]*)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2,
            attr2: 3,
            d2: 4
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path class="([^"]*primary[^"]*)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path class="([^"]*secondary[^"]*)".*d="([^"]+)"/, {
            attr2: 1,
            d2: 2
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*secondary[^"]*)".*path d="([^"]+)".*class="([^"]*primary[^"]*)"/, {
            d2: 1,
            attr2: 2,
            d1: 3,
            attr1: 4
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*primary[^"]*)".*path d="([^"]+)".*class="([^"]*secondary[^"]*)"/, {
            d1: 1,
            attr1: 2,
            d2: 3,
            attr2: 4
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*primary[^"]*)"/, {
            d1: 1,
            attr1: 2
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*secondary[^"]*)"/, {
            d2: 1,
            attr2: 2
        })
    ],
    [
        $87ca9af917cac014$var$DUO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
            d1: 1,
            d2: 2
        })
    ],
    [
        $87ca9af917cac014$var$MONO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path d="([^"]+)"/, {
            d1: 1
        })
    ],
    [
        $87ca9af917cac014$var$MONO,
        /*#__PURE__*/ $87ca9af917cac014$var$_wrapRegExp(/path style="([^"]+)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2
        })
    ]
];
var $87ca9af917cac014$var$styles = $87ca9af917cac014$var$namespace.styles, $87ca9af917cac014$var$shims = $87ca9af917cac014$var$namespace.shims;
var $87ca9af917cac014$var$FAMILY_NAMES = Object.keys($87ca9af917cac014$var$PREFIX_TO_LONG_STYLE);
var $87ca9af917cac014$var$PREFIXES_FOR_FAMILY = $87ca9af917cac014$var$FAMILY_NAMES.reduce(function(acc, familyId) {
    acc[familyId] = Object.keys($87ca9af917cac014$var$PREFIX_TO_LONG_STYLE[familyId]);
    return acc;
}, {});
var $87ca9af917cac014$var$_defaultUsablePrefix = null;
var $87ca9af917cac014$var$_byUnicode = {};
var $87ca9af917cac014$var$_byLigature = {};
var $87ca9af917cac014$var$_byOldName = {};
var $87ca9af917cac014$var$_byOldUnicode = {};
var $87ca9af917cac014$var$_byAlias = {};
function $87ca9af917cac014$var$isReserved(name) {
    return ~$87ca9af917cac014$var$RESERVED_CLASSES.indexOf(name);
}
function $87ca9af917cac014$var$getIconName(cssPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$87ca9af917cac014$var$isReserved(iconName)) return iconName;
    else return null;
}
var $87ca9af917cac014$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $87ca9af917cac014$var$reduce($87ca9af917cac014$var$styles, function(o$$1, style, prefix) {
            o$$1[prefix] = $87ca9af917cac014$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $87ca9af917cac014$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a$$1) {
                return typeof a$$1 === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $87ca9af917cac014$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a$$1) {
                return typeof a$$1 === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $87ca9af917cac014$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    });
    // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in $87ca9af917cac014$var$styles || $87ca9af917cac014$var$config.autoFetchSvg;
    var shimLookups = $87ca9af917cac014$var$reduce($87ca9af917cac014$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $87ca9af917cac014$var$_byOldName = shimLookups.names;
    $87ca9af917cac014$var$_byOldUnicode = shimLookups.unicodes;
    $87ca9af917cac014$var$_defaultUsablePrefix = $87ca9af917cac014$var$getCanonicalPrefix($87ca9af917cac014$var$config.styleDefault, {
        family: $87ca9af917cac014$var$config.familyDefault
    });
};
$87ca9af917cac014$var$onChange(function(c$$1) {
    $87ca9af917cac014$var$_defaultUsablePrefix = $87ca9af917cac014$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $87ca9af917cac014$var$config.familyDefault
    });
});
$87ca9af917cac014$var$build();
function $87ca9af917cac014$var$byUnicode(prefix, unicode) {
    return ($87ca9af917cac014$var$_byUnicode[prefix] || {})[unicode];
}
function $87ca9af917cac014$var$byLigature(prefix, ligature) {
    return ($87ca9af917cac014$var$_byLigature[prefix] || {})[ligature];
}
function $87ca9af917cac014$var$byAlias(prefix, alias) {
    return ($87ca9af917cac014$var$_byAlias[prefix] || {})[alias];
}
function $87ca9af917cac014$var$byOldName(name) {
    return $87ca9af917cac014$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $87ca9af917cac014$var$byOldUnicode(unicode) {
    var oldUnicode = $87ca9af917cac014$var$_byOldUnicode[unicode];
    var newUnicode = $87ca9af917cac014$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $87ca9af917cac014$var$getDefaultUsablePrefix() {
    return $87ca9af917cac014$var$_defaultUsablePrefix;
}
var $87ca9af917cac014$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $87ca9af917cac014$var$getFamilyId(values) {
    var family = $87ca9af917cac014$var$a;
    var famProps = $87ca9af917cac014$var$FAMILY_NAMES.reduce(function(acc, familyId) {
        acc[familyId] = "".concat($87ca9af917cac014$var$config.cssPrefix, "-").concat(familyId);
        return acc;
    }, {});
    $87ca9af917cac014$var$oo.forEach(function(familyId) {
        if (values.includes(famProps[familyId]) || values.some(function(v$$1) {
            return $87ca9af917cac014$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1);
        })) family = familyId;
    });
    return family;
}
function $87ca9af917cac014$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $87ca9af917cac014$var$a : _params$family;
    var style = $87ca9af917cac014$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    // handles the exception of passing in only a family of 'duotone' with no style
    if (family === $87ca9af917cac014$var$o && !styleOrPrefix) return 'fad';
    var prefix = $87ca9af917cac014$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $87ca9af917cac014$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $87ca9af917cac014$var$namespace.styles ? styleOrPrefix : null;
    var result = prefix || defined || null;
    return result;
}
function $87ca9af917cac014$var$moveNonFaClassesToRest(classNames) {
    var rest = [];
    var iconName = null;
    classNames.forEach(function(cls) {
        var result = $87ca9af917cac014$var$getIconName($87ca9af917cac014$var$config.cssPrefix, cls);
        if (result) iconName = result;
        else if (cls) rest.push(cls);
    });
    return {
        iconName: iconName,
        rest: rest
    };
}
function $87ca9af917cac014$var$sortedUniqueValues(arr) {
    return arr.sort().filter(function(value, index, arr) {
        return arr.indexOf(value) === index;
    });
}
var $87ca9af917cac014$var$_faCombinedClasses = $87ca9af917cac014$var$$o$1.concat($87ca9af917cac014$var$zo);
function $87ca9af917cac014$var$getCanonicalIcon(values) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var givenPrefix = null;
    var faStyleOrFamilyClasses = $87ca9af917cac014$var$sortedUniqueValues(values.filter(function(cls) {
        return $87ca9af917cac014$var$_faCombinedClasses.includes(cls);
    }));
    var nonStyleOrFamilyClasses = $87ca9af917cac014$var$sortedUniqueValues(values.filter(function(cls) {
        return !$87ca9af917cac014$var$_faCombinedClasses.includes(cls);
    }));
    var faStyles = faStyleOrFamilyClasses.filter(function(cls) {
        givenPrefix = cls;
        return !$87ca9af917cac014$var$G.includes(cls);
    });
    var _faStyles = $87ca9af917cac014$var$_slicedToArray(faStyles, 1), _faStyles$ = _faStyles[0], styleFromValues = _faStyles$ === void 0 ? null : _faStyles$;
    var family = $87ca9af917cac014$var$getFamilyId(faStyleOrFamilyClasses);
    var canonical = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
        prefix: $87ca9af917cac014$var$getCanonicalPrefix(styleFromValues, {
            family: family
        })
    });
    return $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, canonical), $87ca9af917cac014$var$getDefaultCanonicalPrefix({
        values: values,
        family: family,
        styles: $87ca9af917cac014$var$styles,
        config: $87ca9af917cac014$var$config,
        canonical: canonical,
        givenPrefix: givenPrefix
    })), $87ca9af917cac014$var$applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function $87ca9af917cac014$var$applyShimAndAlias(skipLookups, givenPrefix, canonical) {
    var prefix = canonical.prefix, iconName = canonical.iconName;
    if (skipLookups || !prefix || !iconName) return {
        prefix: prefix,
        iconName: iconName
    };
    var shim = givenPrefix === 'fa' ? $87ca9af917cac014$var$byOldName(iconName) : {};
    var aliasIconName = $87ca9af917cac014$var$byAlias(prefix, iconName);
    iconName = shim.iconName || aliasIconName || iconName;
    prefix = shim.prefix || prefix;
    if (prefix === 'far' && !$87ca9af917cac014$var$styles['far'] && $87ca9af917cac014$var$styles['fas'] && !$87ca9af917cac014$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
    return {
        prefix: prefix,
        iconName: iconName
    };
}
var $87ca9af917cac014$var$newCanonicalFamilies = $87ca9af917cac014$var$oo.filter(function(familyId) {
    return familyId !== $87ca9af917cac014$var$a || familyId !== $87ca9af917cac014$var$o;
});
var $87ca9af917cac014$var$newCanonicalStyles = Object.keys($87ca9af917cac014$var$Go$1).filter(function(key) {
    return key !== $87ca9af917cac014$var$a;
}).map(function(key) {
    return Object.keys($87ca9af917cac014$var$Go$1[key]);
}).flat();
function $87ca9af917cac014$var$getDefaultCanonicalPrefix(prefixOptions) {
    var values = prefixOptions.values, family = prefixOptions.family, canonical = prefixOptions.canonical, _prefixOptions$givenP = prefixOptions.givenPrefix, givenPrefix = _prefixOptions$givenP === void 0 ? '' : _prefixOptions$givenP, _prefixOptions$styles = prefixOptions.styles, styles = _prefixOptions$styles === void 0 ? {} : _prefixOptions$styles, _prefixOptions$config = prefixOptions.config, config$$1 = _prefixOptions$config === void 0 ? {} : _prefixOptions$config;
    var isDuotoneFamily = family === $87ca9af917cac014$var$o;
    var valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
    var defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
    var canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
    if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) canonical.prefix = 'fad';
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (!canonical.prefix && $87ca9af917cac014$var$newCanonicalFamilies.includes(family)) {
        var validPrefix = Object.keys(styles).find(function(key) {
            return $87ca9af917cac014$var$newCanonicalStyles.includes(key);
        });
        if (validPrefix || config$$1.autoFetchSvg) {
            var defaultPrefix = $87ca9af917cac014$var$Co.get(family).defaultShortPrefixId;
            canonical.prefix = defaultPrefix;
            canonical.iconName = $87ca9af917cac014$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
        }
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $87ca9af917cac014$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var $87ca9af917cac014$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $87ca9af917cac014$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    return $87ca9af917cac014$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $87ca9af917cac014$var$defineIcons(key, additions[key]);
                    // To keep support for older Classic styles, also add longer prefixes
                    var longPrefix = $87ca9af917cac014$var$PREFIX_TO_LONG_STYLE[$87ca9af917cac014$var$a][key];
                    if (longPrefix) $87ca9af917cac014$var$defineIcons(longPrefix, additions[key]);
                    $87ca9af917cac014$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
}();
var $87ca9af917cac014$var$_plugins = [];
var $87ca9af917cac014$var$_hooks = {};
var $87ca9af917cac014$var$providers = {};
var $87ca9af917cac014$var$defaultProviderKeys = Object.keys($87ca9af917cac014$var$providers);
function $87ca9af917cac014$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $87ca9af917cac014$var$_plugins = nextPlugins;
    $87ca9af917cac014$var$_hooks = {};
    Object.keys($87ca9af917cac014$var$providers).forEach(function(k) {
        if ($87ca9af917cac014$var$defaultProviderKeys.indexOf(k) === -1) delete $87ca9af917cac014$var$providers[k];
    });
    $87ca9af917cac014$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if ($87ca9af917cac014$var$_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$87ca9af917cac014$var$_hooks[hook]) $87ca9af917cac014$var$_hooks[hook] = [];
                $87ca9af917cac014$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($87ca9af917cac014$var$providers);
    });
    return obj;
}
function $87ca9af917cac014$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $87ca9af917cac014$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args));
    });
    return accumulator;
}
function $87ca9af917cac014$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $87ca9af917cac014$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $87ca9af917cac014$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $87ca9af917cac014$var$providers[hook] ? $87ca9af917cac014$var$providers[hook].apply(null, args) : undefined;
}
function $87ca9af917cac014$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $87ca9af917cac014$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $87ca9af917cac014$var$byAlias(prefix, iconName) || iconName;
    return $87ca9af917cac014$var$iconFromMapping($87ca9af917cac014$var$library.definitions, prefix, iconName) || $87ca9af917cac014$var$iconFromMapping($87ca9af917cac014$var$namespace.styles, prefix, iconName);
}
var $87ca9af917cac014$var$library = new $87ca9af917cac014$var$Library();
var $87ca9af917cac014$var$noAuto = function noAuto() {
    $87ca9af917cac014$var$config.autoReplaceSvg = false;
    $87ca9af917cac014$var$config.observeMutations = false;
    $87ca9af917cac014$var$callHooks('noAuto');
};
var $87ca9af917cac014$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($87ca9af917cac014$var$IS_DOM) {
            $87ca9af917cac014$var$callHooks('beforeI2svg', params);
            $87ca9af917cac014$var$callProvided('pseudoElements2svg', params);
            return $87ca9af917cac014$var$callProvided('i2svg', params);
        } else return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($87ca9af917cac014$var$config.autoReplaceSvg === false) $87ca9af917cac014$var$config.autoReplaceSvg = true;
        $87ca9af917cac014$var$config.observeMutations = true;
        $87ca9af917cac014$var$domready(function() {
            $87ca9af917cac014$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $87ca9af917cac014$var$callHooks('watch', params);
        });
    }
};
var $87ca9af917cac014$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($87ca9af917cac014$var$_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $87ca9af917cac014$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $87ca9af917cac014$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $87ca9af917cac014$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat($87ca9af917cac014$var$config.cssPrefix, "-")) > -1 || _icon.match($87ca9af917cac014$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $87ca9af917cac014$var$getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $87ca9af917cac014$var$getDefaultUsablePrefix(),
                iconName: $87ca9af917cac014$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = $87ca9af917cac014$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $87ca9af917cac014$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $87ca9af917cac014$export$644d8ea042df96a6 = {
    noAuto: $87ca9af917cac014$var$noAuto,
    config: $87ca9af917cac014$var$config,
    dom: $87ca9af917cac014$var$dom,
    parse: $87ca9af917cac014$var$parse,
    library: $87ca9af917cac014$var$library,
    findIconDefinition: $87ca9af917cac014$var$findIconDefinition,
    toHtml: $87ca9af917cac014$var$toHtml
};
var $87ca9af917cac014$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $87ca9af917cac014$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($87ca9af917cac014$var$namespace.styles).length > 0 || $87ca9af917cac014$var$config.autoFetchSvg) && $87ca9af917cac014$var$IS_DOM && $87ca9af917cac014$var$config.autoReplaceSvg) $87ca9af917cac014$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $87ca9af917cac014$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return $87ca9af917cac014$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$87ca9af917cac014$var$IS_DOM) return undefined;
            var container = $87ca9af917cac014$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $87ca9af917cac014$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($87ca9af917cac014$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $87ca9af917cac014$var$joinStyles($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $87ca9af917cac014$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($87ca9af917cac014$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
// If any of these attributes are present, don't assume the icon is decorative
function $87ca9af917cac014$var$isLabeled(attributes) {
    var labels = [
        'aria-label',
        'aria-labelledby',
        'title',
        'role'
    ];
    return labels.some(function(label) {
        return label in attributes;
    });
}
function $87ca9af917cac014$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, maskId = params.maskId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var attrClass = [
        $87ca9af917cac014$var$config.replacementClass,
        iconName ? "".concat($87ca9af917cac014$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    if (!$87ca9af917cac014$var$isLabeled(extra.attributes) && !extra.attributes['aria-hidden']) content.attributes['aria-hidden'] = 'true';
    if (watchable) content.attributes[$87ca9af917cac014$var$DATA_FA_I2SVG] = '';
    var args = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $87ca9af917cac014$var$_objectSpread2({}, extra.styles)
    });
    var _ref2 = mask.found && main.found ? $87ca9af917cac014$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $87ca9af917cac014$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $87ca9af917cac014$var$asSymbol(args);
    else return $87ca9af917cac014$var$asIcon(args);
}
function $87ca9af917cac014$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, extra.attributes), {}, {
        class: extra.classes.join(' ')
    });
    if (watchable) attributes[$87ca9af917cac014$var$DATA_FA_I2SVG] = '';
    var styles = $87ca9af917cac014$var$_objectSpread2({}, extra.styles);
    if ($87ca9af917cac014$var$transformIsMeaningful(transform)) {
        styles['transform'] = $87ca9af917cac014$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $87ca9af917cac014$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    return val;
}
function $87ca9af917cac014$var$makeLayersCounterAbstract(params) {
    var content = params.content, extra = params.extra;
    var attributes = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, extra.attributes), {}, {
        class: extra.classes.join(' ')
    });
    var styleString = $87ca9af917cac014$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    return val;
}
var $87ca9af917cac014$var$styles$1 = $87ca9af917cac014$var$namespace.styles;
function $87ca9af917cac014$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $87ca9af917cac014$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($87ca9af917cac014$var$config.cssPrefix, "-").concat($87ca9af917cac014$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($87ca9af917cac014$var$config.cssPrefix, "-").concat($87ca9af917cac014$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($87ca9af917cac014$var$config.cssPrefix, "-").concat($87ca9af917cac014$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $87ca9af917cac014$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $87ca9af917cac014$var$maybeNotifyMissing(iconName, prefix) {
    if (!$87ca9af917cac014$var$PRODUCTION && !$87ca9af917cac014$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $87ca9af917cac014$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && $87ca9af917cac014$var$config.styleDefault !== null) prefix = $87ca9af917cac014$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        if (givenPrefix === 'fa') {
            var shim = $87ca9af917cac014$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $87ca9af917cac014$var$styles$1[prefix] && $87ca9af917cac014$var$styles$1[prefix][iconName]) {
            var icon = $87ca9af917cac014$var$styles$1[prefix][iconName];
            return resolve($87ca9af917cac014$var$asFoundIcon(icon));
        }
        $87ca9af917cac014$var$maybeNotifyMissing(iconName, prefix);
        resolve($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$missingIconResolutionMixin), {}, {
            icon: $87ca9af917cac014$var$config.showMissingIcons && iconName ? $87ca9af917cac014$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var $87ca9af917cac014$var$noop$1 = function noop() {};
var $87ca9af917cac014$var$p$2 = $87ca9af917cac014$var$config.measurePerformance && $87ca9af917cac014$var$PERFORMANCE && $87ca9af917cac014$var$PERFORMANCE.mark && $87ca9af917cac014$var$PERFORMANCE.measure ? $87ca9af917cac014$var$PERFORMANCE : {
    mark: $87ca9af917cac014$var$noop$1,
    measure: $87ca9af917cac014$var$noop$1
};
var $87ca9af917cac014$var$preamble = "FA \"7.0.1\"";
var $87ca9af917cac014$var$begin = function begin(name) {
    $87ca9af917cac014$var$p$2.mark("".concat($87ca9af917cac014$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $87ca9af917cac014$var$end(name);
    };
};
var $87ca9af917cac014$var$end = function end(name) {
    $87ca9af917cac014$var$p$2.mark("".concat($87ca9af917cac014$var$preamble, " ").concat(name, " ends"));
    $87ca9af917cac014$var$p$2.measure("".concat($87ca9af917cac014$var$preamble, " ").concat(name), "".concat($87ca9af917cac014$var$preamble, " ").concat(name, " begins"), "".concat($87ca9af917cac014$var$preamble, " ").concat(name, " ends"));
};
var $87ca9af917cac014$var$perf = {
    begin: $87ca9af917cac014$var$begin,
    end: $87ca9af917cac014$var$end
};
var $87ca9af917cac014$var$noop$2 = function noop() {};
function $87ca9af917cac014$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($87ca9af917cac014$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $87ca9af917cac014$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($87ca9af917cac014$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($87ca9af917cac014$var$DATA_ICON) : null;
    return prefix && icon;
}
function $87ca9af917cac014$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($87ca9af917cac014$var$config.replacementClass);
}
function $87ca9af917cac014$var$getMutator() {
    if ($87ca9af917cac014$var$config.autoReplaceSvg === true) return $87ca9af917cac014$var$mutators.replace;
    var mutator = $87ca9af917cac014$var$mutators[$87ca9af917cac014$var$config.autoReplaceSvg];
    return mutator || $87ca9af917cac014$var$mutators.replace;
}
function $87ca9af917cac014$var$createElementNS(tag) {
    return $87ca9af917cac014$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $87ca9af917cac014$var$createElement(tag) {
    return $87ca9af917cac014$var$DOCUMENT.createElement(tag);
}
function $87ca9af917cac014$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? $87ca9af917cac014$var$createElementNS : $87ca9af917cac014$var$createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return $87ca9af917cac014$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($87ca9af917cac014$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $87ca9af917cac014$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $87ca9af917cac014$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore($87ca9af917cac014$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($87ca9af917cac014$var$DATA_FA_I2SVG) === null && $87ca9af917cac014$var$config.keepOriginalSource) {
                var comment = $87ca9af917cac014$var$DOCUMENT.createComment($87ca9af917cac014$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1];
        // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$87ca9af917cac014$var$classArray(node).indexOf($87ca9af917cac014$var$config.replacementClass)) return $87ca9af917cac014$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($87ca9af917cac014$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === $87ca9af917cac014$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = abstract.map(function(a) {
            return $87ca9af917cac014$var$toHtml(a);
        }).join('\n');
        node.setAttribute($87ca9af917cac014$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $87ca9af917cac014$var$performOperationSync(op) {
    op();
}
function $87ca9af917cac014$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $87ca9af917cac014$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $87ca9af917cac014$var$performOperationSync;
        if ($87ca9af917cac014$var$config.mutateApproach === $87ca9af917cac014$var$MUTATION_APPROACH_ASYNC) frame = $87ca9af917cac014$var$WINDOW.requestAnimationFrame || $87ca9af917cac014$var$performOperationSync;
        frame(function() {
            var mutator = $87ca9af917cac014$var$getMutator();
            var mark = $87ca9af917cac014$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $87ca9af917cac014$var$disabled = false;
function $87ca9af917cac014$var$disableObservation() {
    $87ca9af917cac014$var$disabled = true;
}
function $87ca9af917cac014$var$enableObservation() {
    $87ca9af917cac014$var$disabled = false;
}
var $87ca9af917cac014$var$mo = null;
function $87ca9af917cac014$var$observe(options) {
    if (!$87ca9af917cac014$var$MUTATION_OBSERVER) return;
    if (!$87ca9af917cac014$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $87ca9af917cac014$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $87ca9af917cac014$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $87ca9af917cac014$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $87ca9af917cac014$var$DOCUMENT : _options$observeMutat;
    $87ca9af917cac014$var$mo = new $87ca9af917cac014$var$MUTATION_OBSERVER(function(objects) {
        if ($87ca9af917cac014$var$disabled) return;
        var defaultPrefix = $87ca9af917cac014$var$getDefaultUsablePrefix();
        $87ca9af917cac014$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$87ca9af917cac014$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($87ca9af917cac014$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $87ca9af917cac014$var$config.searchPseudoElements) pseudoElementsCallback([
                mutationRecord.target
            ], true);
            if (mutationRecord.type === 'attributes' && $87ca9af917cac014$var$isWatched(mutationRecord.target) && ~$87ca9af917cac014$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $87ca9af917cac014$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $87ca9af917cac014$var$getCanonicalIcon($87ca9af917cac014$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($87ca9af917cac014$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($87ca9af917cac014$var$DATA_ICON, iconName);
                } else if ($87ca9af917cac014$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$87ca9af917cac014$var$IS_DOM) return;
    $87ca9af917cac014$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $87ca9af917cac014$var$disconnect() {
    if (!$87ca9af917cac014$var$mo) return;
    $87ca9af917cac014$var$mo.disconnect();
}
function $87ca9af917cac014$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $87ca9af917cac014$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $87ca9af917cac014$var$getCanonicalIcon($87ca9af917cac014$var$classArray(node));
    if (!val.prefix) val.prefix = $87ca9af917cac014$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $87ca9af917cac014$var$byLigature(val.prefix, node.innerText) || $87ca9af917cac014$var$byUnicode(val.prefix, $87ca9af917cac014$var$toHex(node.innerText));
    if (!val.iconName && $87ca9af917cac014$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $87ca9af917cac014$var$attributesParser(node) {
    var extraAttributes = $87ca9af917cac014$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    return extraAttributes;
}
function $87ca9af917cac014$var$blankMeta() {
    return {
        iconName: null,
        prefix: null,
        transform: $87ca9af917cac014$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $87ca9af917cac014$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $87ca9af917cac014$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $87ca9af917cac014$var$attributesParser(node);
    var pluginMeta = $87ca9af917cac014$var$chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? $87ca9af917cac014$var$styleParser(node) : [];
    return $87ca9af917cac014$var$_objectSpread2({
        iconName: iconName,
        prefix: prefix,
        transform: $87ca9af917cac014$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $87ca9af917cac014$var$styles$2 = $87ca9af917cac014$var$namespace.styles;
function $87ca9af917cac014$var$generateMutation(node) {
    var nodeMeta = $87ca9af917cac014$var$config.autoReplaceSvg === 'nest' ? $87ca9af917cac014$var$parseMeta(node, {
        styleParser: false
    }) : $87ca9af917cac014$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($87ca9af917cac014$var$LAYERS_TEXT_CLASSNAME)) return $87ca9af917cac014$var$callProvided('generateLayersText', node, nodeMeta);
    else return $87ca9af917cac014$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $87ca9af917cac014$var$getKnownPrefixes() {
    return [].concat($87ca9af917cac014$var$_toConsumableArray($87ca9af917cac014$var$zo), $87ca9af917cac014$var$_toConsumableArray($87ca9af917cac014$var$$o$1));
}
function $87ca9af917cac014$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$87ca9af917cac014$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $87ca9af917cac014$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($87ca9af917cac014$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($87ca9af917cac014$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $87ca9af917cac014$var$config.autoFetchSvg ? $87ca9af917cac014$var$getKnownPrefixes() : $87ca9af917cac014$var$G.concat(Object.keys($87ca9af917cac014$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    var prefixesDomQuery = [
        ".".concat($87ca9af917cac014$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($87ca9af917cac014$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p$$1) {
        return ".".concat(p$$1, ":not([").concat($87ca9af917cac014$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $87ca9af917cac014$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {
    // noop
    }
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = $87ca9af917cac014$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $87ca9af917cac014$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$87ca9af917cac014$var$PRODUCTION) {
                if (e$$1.name === 'MissingIcon') console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $87ca9af917cac014$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e$$1) {
            mark();
            reject(e$$1);
        });
    });
}
function $87ca9af917cac014$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $87ca9af917cac014$var$generateMutation(node).then(function(mutation) {
        if (mutation) $87ca9af917cac014$var$perform([
            mutation
        ], callback);
    });
}
function $87ca9af917cac014$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $87ca9af917cac014$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $87ca9af917cac014$var$findIconDefinition(mask || {});
        return next(iconDefinition, $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $87ca9af917cac014$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $87ca9af917cac014$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $87ca9af917cac014$var$domVariants($87ca9af917cac014$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        $87ca9af917cac014$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        return $87ca9af917cac014$var$makeInlineSvgAbstract({
            icons: {
                main: $87ca9af917cac014$var$asFoundIcon(icon),
                mask: mask ? $87ca9af917cac014$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$meaninglessTransform), transform),
            symbol: symbol,
            maskId: maskId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $87ca9af917cac014$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $87ca9af917cac014$var$resolveIcons($87ca9af917cac014$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $87ca9af917cac014$var$onTree;
                accumulator.nodeCallback = $87ca9af917cac014$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $87ca9af917cac014$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
            return $87ca9af917cac014$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $87ca9af917cac014$var$findIcon(iconName, prefix),
                    mask.iconName ? $87ca9af917cac014$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $87ca9af917cac014$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $87ca9af917cac014$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $87ca9af917cac014$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if ($87ca9af917cac014$var$transformIsMeaningful(transform)) nextChild = $87ca9af917cac014$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $87ca9af917cac014$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $87ca9af917cac014$var$domVariants({
                    type: 'layer'
                }, function() {
                    $87ca9af917cac014$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($87ca9af917cac014$var$config.cssPrefix, "-layers")
                                ].concat($87ca9af917cac014$var$_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $87ca9af917cac014$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $87ca9af917cac014$var$domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    $87ca9af917cac014$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $87ca9af917cac014$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($87ca9af917cac014$var$config.cssPrefix, "-layers-counter")
                            ].concat($87ca9af917cac014$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $87ca9af917cac014$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $87ca9af917cac014$var$meaninglessTransform : _params$transform, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $87ca9af917cac014$var$domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    $87ca9af917cac014$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $87ca9af917cac014$var$makeLayersTextAbstract({
                        content: content,
                        transform: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$meaninglessTransform), transform),
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($87ca9af917cac014$var$config.cssPrefix, "-layers-text")
                            ].concat($87ca9af917cac014$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($87ca9af917cac014$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            return Promise.resolve([
                node,
                $87ca9af917cac014$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $87ca9af917cac014$var$CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var $87ca9af917cac014$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
var $87ca9af917cac014$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, {
    FontAwesome: {
        normal: 'fas',
        400: 'fas'
    }
}), $87ca9af917cac014$var$Bo), $87ca9af917cac014$var$oa), $87ca9af917cac014$var$lt);
var $87ca9af917cac014$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($87ca9af917cac014$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce(function(acc, key) {
    acc[key.toLowerCase()] = $87ca9af917cac014$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
var $87ca9af917cac014$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($87ca9af917cac014$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce(function(acc, fontFamily) {
    var weights = $87ca9af917cac014$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || $87ca9af917cac014$var$_toConsumableArray(Object.entries(weights))[0][1];
    return acc;
}, {});
// Return hex value of *first* character in `content`
function $87ca9af917cac014$var$hexValueFromContent(content) {
    var cleaned = content.replace($87ca9af917cac014$var$CLEAN_CONTENT_PATTERN, '');
    return $87ca9af917cac014$var$toHex($87ca9af917cac014$var$_toConsumableArray(cleaned)[0] || '');
}
// Check if it's a secondary Duotone layer, by checking if:
// - Unicode value in `content` is repeated
// - Unicode value in `content` is above 0x10000
// - The "ss01" font feature is enabled on the `content`
function $87ca9af917cac014$var$isSecondaryLayer(styles) {
    var hasStylisticSet = styles.getPropertyValue('font-feature-settings').includes('ss01');
    var content = styles.getPropertyValue('content');
    var cleaned = content.replace($87ca9af917cac014$var$CLEAN_CONTENT_PATTERN, '');
    var codePoint = cleaned.codePointAt(0);
    var isPrependTen = codePoint >= $87ca9af917cac014$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $87ca9af917cac014$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return isPrependTen || isDoubled || hasStylisticSet;
}
function $87ca9af917cac014$var$getPrefix(fontFamily, fontWeight) {
    var fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
    var fontWeightInteger = parseInt(fontWeight);
    var fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
    return ($87ca9af917cac014$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $87ca9af917cac014$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $87ca9af917cac014$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($87ca9af917cac014$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $87ca9af917cac014$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c$$1) {
            return c$$1.getAttribute($87ca9af917cac014$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $87ca9af917cac014$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family');
        var fontFamilyMatch = fontFamily.match($87ca9af917cac014$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var prefix = $87ca9af917cac014$var$getPrefix(fontFamily, fontWeight);
            var hexValue = $87ca9af917cac014$var$hexValueFromContent(_content);
            var isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
            var isSecondary = $87ca9af917cac014$var$isSecondaryLayer(styles);
            var iconName = $87ca9af917cac014$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $87ca9af917cac014$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($87ca9af917cac014$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($87ca9af917cac014$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $87ca9af917cac014$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$87ca9af917cac014$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $87ca9af917cac014$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $87ca9af917cac014$var$makeInlineSvgAbstract($87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $87ca9af917cac014$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $87ca9af917cac014$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a$$1) {
                        return $87ca9af917cac014$var$toHtml(a$$1);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $87ca9af917cac014$var$replace(node) {
    return Promise.all([
        $87ca9af917cac014$var$replaceForPosition(node, '::before'),
        $87ca9af917cac014$var$replaceForPosition(node, '::after')
    ]);
}
function $87ca9af917cac014$var$processable(node) {
    return node.parentNode !== document.head && !~$87ca9af917cac014$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($87ca9af917cac014$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
var $87ca9af917cac014$var$hasPseudoElement = function hasPseudoElement(selector) {
    return !!selector && $87ca9af917cac014$var$PSEUDO_ELEMENTS.some(function(pseudoSelector) {
        return selector.includes(pseudoSelector);
    });
};
// Return selectors from all available stylesheets that have
// pseudo-elements defined.
var $87ca9af917cac014$var$parseCSSRuleForPseudos = function parseCSSRuleForPseudos(selectorText) {
    if (!selectorText) return [];
    var selectorSet = new Set();
    var selectors = selectorText.split(/,(?![^()]*\))/).map(function(s$$1) {
        return s$$1.trim();
    });
    selectors = selectors.flatMap(function(selector) {
        return selector.includes('(') ? selector : selector.split(',').map(function(s$$1) {
            return s$$1.trim();
        });
    });
    var _iterator = $87ca9af917cac014$var$_createForOfIteratorHelper(selectors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var selector = _step.value;
            if ($87ca9af917cac014$var$hasPseudoElement(selector)) {
                // Remove pseudo-elements from the selector
                var selectorWithoutPseudo = $87ca9af917cac014$var$PSEUDO_ELEMENTS.reduce(function(acc, pseudoSelector) {
                    return acc.replace(pseudoSelector, '');
                }, selector);
                if (selectorWithoutPseudo !== '' && selectorWithoutPseudo !== '*') selectorSet.add(selectorWithoutPseudo);
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return selectorSet;
};
function $87ca9af917cac014$var$searchPseudoElements(root) {
    var useAsNodeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!$87ca9af917cac014$var$IS_DOM) return;
    var nodeList;
    if (useAsNodeList) nodeList = root;
    else if ($87ca9af917cac014$var$config.searchPseudoElementsFullScan) nodeList = root.querySelectorAll('*');
    else {
        // Get elements that have pseudo elements defined in the CSS
        var selectorSet = new Set();
        var _iterator2 = $87ca9af917cac014$var$_createForOfIteratorHelper(document.styleSheets), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var stylesheet = _step2.value;
                try {
                    var _iterator3 = $87ca9af917cac014$var$_createForOfIteratorHelper(stylesheet.cssRules), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var rule = _step3.value;
                            var parsedSelectors = $87ca9af917cac014$var$parseCSSRuleForPseudos(rule.selectorText);
                            var _iterator4 = $87ca9af917cac014$var$_createForOfIteratorHelper(parsedSelectors), _step4;
                            try {
                                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                    var selector = _step4.value;
                                    selectorSet.add(selector);
                                }
                            } catch (err) {
                                _iterator4.e(err);
                            } finally{
                                _iterator4.f();
                            }
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                } catch (e$$1) {
                    if ($87ca9af917cac014$var$config.searchPseudoElementsWarnings) console.warn("Font Awesome: cannot parse stylesheet: ".concat(stylesheet.href, " (").concat(e$$1.message, ")\nIf it declares any Font Awesome CSS pseudo-elements, they will not be rendered as SVG icons. Add crossorigin=\"anonymous\" to the <link>, enable searchPseudoElementsFullScan for slower but more thorough DOM parsing, or suppress this warning by setting searchPseudoElementsWarnings to false."));
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        if (!selectorSet.size) return;
        var cleanSelectors = Array.from(selectorSet).join(', ');
        try {
            nodeList = root.querySelectorAll(cleanSelectors);
        } catch (_unused) {} // eslint-disable-line no-empty
    }
    return new Promise(function(resolve, reject) {
        var operations = $87ca9af917cac014$var$toArray(nodeList).filter($87ca9af917cac014$var$processable).map($87ca9af917cac014$var$replace);
        var end = $87ca9af917cac014$var$perf.begin('searchPseudoElements');
        $87ca9af917cac014$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $87ca9af917cac014$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $87ca9af917cac014$var$enableObservation();
            reject();
        });
    });
}
var $87ca9af917cac014$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $87ca9af917cac014$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $87ca9af917cac014$var$DOCUMENT : _params$node;
            if ($87ca9af917cac014$var$config.searchPseudoElements) $87ca9af917cac014$var$searchPseudoElements(node);
        };
    }
};
var $87ca9af917cac014$var$_unwatched = false;
var $87ca9af917cac014$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $87ca9af917cac014$var$disableObservation();
                    $87ca9af917cac014$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $87ca9af917cac014$var$observe($87ca9af917cac014$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                $87ca9af917cac014$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($87ca9af917cac014$var$_unwatched) $87ca9af917cac014$var$enableObservation();
                else $87ca9af917cac014$var$observe($87ca9af917cac014$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $87ca9af917cac014$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $87ca9af917cac014$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $87ca9af917cac014$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $87ca9af917cac014$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $87ca9af917cac014$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $87ca9af917cac014$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $87ca9af917cac014$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $87ca9af917cac014$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $87ca9af917cac014$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $87ca9af917cac014$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? $87ca9af917cac014$var$emptyCanonicalIcon() : $87ca9af917cac014$var$getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $87ca9af917cac014$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $87ca9af917cac014$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($87ca9af917cac014$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: $87ca9af917cac014$var$_objectSpread2({}, trans.inner),
                children: [
                    $87ca9af917cac014$var$fillBlack($87ca9af917cac014$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: $87ca9af917cac014$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $87ca9af917cac014$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $87ca9af917cac014$var$nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, $87ca9af917cac014$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $87ca9af917cac014$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $87ca9af917cac014$var$_objectSpread2({
                    'fill': 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    'mask': "url(#".concat(maskId, ")")
                }, $87ca9af917cac014$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $87ca9af917cac014$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($87ca9af917cac014$var$WINDOW.matchMedia) reduceMotion = $87ca9af917cac014$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            };
            // Ring
            gChildren.push({
                tag: 'path',
                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $87ca9af917cac014$var$_objectSpread2($87ca9af917cac014$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    class: 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $87ca9af917cac014$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $87ca9af917cac014$var$plugins = [
    $87ca9af917cac014$var$InjectCSS,
    $87ca9af917cac014$var$ReplaceElements,
    $87ca9af917cac014$var$Layers,
    $87ca9af917cac014$var$LayersCounter,
    $87ca9af917cac014$var$LayersText,
    $87ca9af917cac014$var$PseudoElements,
    $87ca9af917cac014$var$MutationObserver$1,
    $87ca9af917cac014$var$PowerTransforms,
    $87ca9af917cac014$var$Masks,
    $87ca9af917cac014$var$MissingIconIndicator,
    $87ca9af917cac014$var$SvgSymbols
];
$87ca9af917cac014$var$registerPlugins($87ca9af917cac014$var$plugins, {
    mixoutsTo: $87ca9af917cac014$export$644d8ea042df96a6
});
var $87ca9af917cac014$export$4f8e844b2782642c = $87ca9af917cac014$export$644d8ea042df96a6.noAuto;
var $87ca9af917cac014$export$e506a1d27d1eaa20 = $87ca9af917cac014$export$644d8ea042df96a6.config;
var $87ca9af917cac014$export$b839f963c7dc0e34 = $87ca9af917cac014$export$644d8ea042df96a6.library;
var $87ca9af917cac014$export$df3a06d6289f983e = $87ca9af917cac014$export$644d8ea042df96a6.dom;
var $87ca9af917cac014$export$98e6a39c04603d36 = $87ca9af917cac014$export$644d8ea042df96a6.parse;
var $87ca9af917cac014$export$221fed4a47f597a5 = $87ca9af917cac014$export$644d8ea042df96a6.findIconDefinition;
var $87ca9af917cac014$export$a10125c086a4df16 = $87ca9af917cac014$export$644d8ea042df96a6.toHtml;
var $87ca9af917cac014$export$1ca1ec8b29a4ce27 = $87ca9af917cac014$export$644d8ea042df96a6.icon;
var $87ca9af917cac014$export$50a222d9023da98b = $87ca9af917cac014$export$644d8ea042df96a6.layer;
var $87ca9af917cac014$export$6f093cfa640b7166 = $87ca9af917cac014$export$644d8ea042df96a6.text;
var $87ca9af917cac014$export$e575061ef2a070eb = $87ca9af917cac014$export$644d8ea042df96a6.counter;


// src/components/FontAwesomeIcon.tsx
// src/utils/camelize.ts
function $23985f7ea325d88e$var$_isNumerical(object) {
    object = object - 0;
    return object === object;
}
function $23985f7ea325d88e$var$camelize(string) {
    if ($23985f7ea325d88e$var$_isNumerical(string)) return string;
    string = string.replaceAll(/[_-]+(.)?/g, (_, chr)=>{
        return chr ? chr.toUpperCase() : "";
    });
    return string.charAt(0).toLowerCase() + string.slice(1);
}
// src/converter.ts
function $23985f7ea325d88e$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
var $23985f7ea325d88e$var$styleCache = /* @__PURE__ */ new Map();
var $23985f7ea325d88e$var$STYLE_CACHE_LIMIT = 1e3;
function $23985f7ea325d88e$var$styleToObject(style) {
    if ($23985f7ea325d88e$var$styleCache.has(style)) return $23985f7ea325d88e$var$styleCache.get(style);
    const result = {};
    let start = 0;
    const len = style.length;
    while(start < len){
        const semicolonIndex = style.indexOf(";", start);
        const end = semicolonIndex === -1 ? len : semicolonIndex;
        const pair = style.slice(start, end).trim();
        if (pair) {
            const colonIndex = pair.indexOf(":");
            if (colonIndex > 0) {
                const rawProp = pair.slice(0, colonIndex).trim();
                const value = pair.slice(colonIndex + 1).trim();
                if (rawProp && value) {
                    const prop = $23985f7ea325d88e$var$camelize(rawProp);
                    result[prop.startsWith("webkit") ? $23985f7ea325d88e$var$capitalize(prop) : prop] = value;
                }
            }
        }
        start = end + 1;
    }
    if ($23985f7ea325d88e$var$styleCache.size === $23985f7ea325d88e$var$STYLE_CACHE_LIMIT) {
        const oldestKey = $23985f7ea325d88e$var$styleCache.keys().next().value;
        if (oldestKey) $23985f7ea325d88e$var$styleCache.delete(oldestKey);
    }
    $23985f7ea325d88e$var$styleCache.set(style, result);
    return result;
}
function $23985f7ea325d88e$var$convert(createElement, element, extraProps = {}) {
    if (typeof element === "string") return element;
    const children = (element.children || []).map((child)=>{
        return $23985f7ea325d88e$var$convert(createElement, child);
    });
    const elementAttributes = element.attributes || {};
    const attrs = {};
    for (const [key, val] of Object.entries(elementAttributes))switch(true){
        case key === "class":
            attrs.className = val;
            delete elementAttributes.class;
            break;
        case key === "style":
            attrs.style = $23985f7ea325d88e$var$styleToObject(String(val));
            break;
        case key.startsWith("aria-"):
        case key.startsWith("data-"):
            attrs[key.toLowerCase()] = val;
            break;
        default:
            attrs[$23985f7ea325d88e$var$camelize(key)] = val;
    }
    const { style: existingStyle, "aria-label": ariaLabel, ...remaining } = extraProps;
    if (existingStyle) attrs.style = attrs.style ? {
        ...attrs.style,
        ...existingStyle
    } : existingStyle;
    if (ariaLabel) {
        attrs["aria-label"] = ariaLabel;
        attrs["aria-hidden"] = "false";
    }
    return createElement(element.tag, {
        ...remaining,
        ...attrs
    }, ...children);
}
var $23985f7ea325d88e$var$useAccessibilityId = (id, hasAccessibleProps)=>{
    const generatedId = (0, $baslc.useId)();
    return id || (hasAccessibleProps ? generatedId : void 0);
};
// src/logger.ts
var $23985f7ea325d88e$var$Logger = class {
    constructor(scope = "react-fontawesome"){
        this.enabled = false;
        let IS_DEV = false;
        try {
            IS_DEV = false;
        } catch  {}
        this.scope = scope;
        this.enabled = IS_DEV;
    }
    /**
   * Logs messages to the console if not in production.
   * @param args - The message and/or data to log.
   */ log(...args) {
        if (!this.enabled) return;
        console.log(`[${this.scope}]`, ...args);
    }
    /**
   * Logs warnings to the console if not in production.
   * @param args - The warning message and/or data to log.
   */ warn(...args) {
        if (!this.enabled) return;
        console.warn(`[${this.scope}]`, ...args);
    }
    /**
   * Logs errors to the console if not in production.
   * @param args - The error message and/or data to log.
   */ error(...args) {
        if (!this.enabled) return;
        console.error(`[${this.scope}]`, ...args);
    }
};
"7.0.0";
var $23985f7ea325d88e$var$SVG_CORE_VERSION = // @ts-expect-error TS2872 - Expression is always truthy - This is true when v7 of SVGCore is used, but not when v6 is used.
// This is the point of this check - if the property exists on config, we have v7, otherwise we have v6.
// TS is checking this against the dev dependencies which uses v7, so it reports a false error here.
"searchPseudoElementsFullScan" in (0, $87ca9af917cac014$export$e506a1d27d1eaa20) ? "7.0.0" : "6.0.0";
var $23985f7ea325d88e$var$IS_VERSION_7_OR_LATER = Number.parseInt($23985f7ea325d88e$var$SVG_CORE_VERSION) >= 7;
var $23985f7ea325d88e$var$ANIMATION_CLASSES = {
    beat: "fa-beat",
    fade: "fa-fade",
    beatFade: "fa-beat-fade",
    bounce: "fa-bounce",
    shake: "fa-shake",
    spin: "fa-spin",
    spinPulse: "fa-spin-pulse",
    spinReverse: "fa-spin-reverse",
    pulse: "fa-pulse"
};
var $23985f7ea325d88e$var$PULL_CLASSES = {
    left: "fa-pull-left",
    right: "fa-pull-right"
};
var $23985f7ea325d88e$var$ROTATE_CLASSES = {
    "90": "fa-rotate-90",
    "180": "fa-rotate-180",
    "270": "fa-rotate-270"
};
var $23985f7ea325d88e$var$SIZE_CLASSES = {
    "2xs": "fa-2xs",
    xs: "fa-xs",
    sm: "fa-sm",
    lg: "fa-lg",
    xl: "fa-xl",
    "2xl": "fa-2xl",
    "1x": "fa-1x",
    "2x": "fa-2x",
    "3x": "fa-3x",
    "4x": "fa-4x",
    "5x": "fa-5x",
    "6x": "fa-6x",
    "7x": "fa-7x",
    "8x": "fa-8x",
    "9x": "fa-9x",
    "10x": "fa-10x"
};
var $23985f7ea325d88e$var$STYLE_CLASSES = {
    border: "fa-border",
    /** @deprecated */ fixedWidth: "fa-fw",
    flip: "fa-flip",
    flipHorizontal: "fa-flip-horizontal",
    flipVertical: "fa-flip-vertical",
    inverse: "fa-inverse",
    rotateBy: "fa-rotate-by",
    swapOpacity: "fa-swap-opacity",
    widthAuto: "fa-width-auto"
};
// src/utils/get-class-list-from-props.ts
function $23985f7ea325d88e$var$getClassListFromProps(props) {
    const { beat: beat, fade: fade, beatFade: beatFade, bounce: bounce, shake: shake, spin: spin, spinPulse: spinPulse, spinReverse: spinReverse, pulse: pulse, fixedWidth: fixedWidth, inverse: inverse, border: border, flip: flip, size: size, rotation: rotation, pull: pull, swapOpacity: swapOpacity, rotateBy: rotateBy, widthAuto: widthAuto, className: className } = props;
    const result = [];
    if (className) result.push(...className.split(" "));
    if (beat) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.beat);
    if (fade) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.fade);
    if (beatFade) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.beatFade);
    if (bounce) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.bounce);
    if (shake) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.shake);
    if (spin) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.spin);
    if (spinReverse) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.spinReverse);
    if (spinPulse) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.spinPulse);
    if (pulse) result.push($23985f7ea325d88e$var$ANIMATION_CLASSES.pulse);
    if (fixedWidth) result.push($23985f7ea325d88e$var$STYLE_CLASSES.fixedWidth);
    if (inverse) result.push($23985f7ea325d88e$var$STYLE_CLASSES.inverse);
    if (border) result.push($23985f7ea325d88e$var$STYLE_CLASSES.border);
    if (flip === true) result.push($23985f7ea325d88e$var$STYLE_CLASSES.flip);
    if (flip === "horizontal" || flip === "both") result.push($23985f7ea325d88e$var$STYLE_CLASSES.flipHorizontal);
    if (flip === "vertical" || flip === "both") result.push($23985f7ea325d88e$var$STYLE_CLASSES.flipVertical);
    if (size !== void 0 && size !== null) result.push($23985f7ea325d88e$var$SIZE_CLASSES[size]);
    if (rotation !== void 0 && rotation !== null && rotation !== 0) result.push($23985f7ea325d88e$var$ROTATE_CLASSES[rotation]);
    if (pull !== void 0 && pull !== null) result.push($23985f7ea325d88e$var$PULL_CLASSES[pull]);
    if (swapOpacity) result.push($23985f7ea325d88e$var$STYLE_CLASSES.swapOpacity);
    if (!$23985f7ea325d88e$var$IS_VERSION_7_OR_LATER) return result;
    if (rotateBy) result.push($23985f7ea325d88e$var$STYLE_CLASSES.rotateBy);
    if (widthAuto) result.push($23985f7ea325d88e$var$STYLE_CLASSES.widthAuto);
    return result;
}
var $23985f7ea325d88e$var$isIconDefinition = (icon)=>typeof icon === "object" && "icon" in icon && !!icon.icon;
function $23985f7ea325d88e$var$normalizeIconArgs(icon) {
    if (!icon) return void 0;
    if ($23985f7ea325d88e$var$isIconDefinition(icon)) return icon;
    return (0, $87ca9af917cac014$export$98e6a39c04603d36).icon(icon);
}
// src/utils/typed-object-keys.ts
function $23985f7ea325d88e$var$typedObjectKeys(obj) {
    return Object.keys(obj);
}
// src/components/FontAwesomeIcon.tsx
var $23985f7ea325d88e$var$logger = new $23985f7ea325d88e$var$Logger("FontAwesomeIcon");
var $23985f7ea325d88e$var$DEFAULT_PROPS = {
    border: false,
    className: "",
    mask: void 0,
    maskId: void 0,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: void 0,
    listItem: false,
    pull: void 0,
    pulse: false,
    rotation: void 0,
    rotateBy: false,
    size: void 0,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: void 0,
    transform: void 0,
    swapOpacity: false,
    widthAuto: false
};
var $23985f7ea325d88e$var$DEFAULT_PROP_KEYS = new Set(Object.keys($23985f7ea325d88e$var$DEFAULT_PROPS));
var $23985f7ea325d88e$export$2b9260d4a45c8710 = (0, (/*@__PURE__*/$parcel$interopDefault($baslc))).forwardRef((props, ref)=>{
    const allProps = {
        ...$23985f7ea325d88e$var$DEFAULT_PROPS,
        ...props
    };
    const { icon: iconArgs, mask: maskArgs, symbol: symbol, title: title, titleId: titleIdFromProps, maskId: maskIdFromProps, transform: transform } = allProps;
    const maskId = $23985f7ea325d88e$var$useAccessibilityId(maskIdFromProps, Boolean(maskArgs));
    const titleId = $23985f7ea325d88e$var$useAccessibilityId(titleIdFromProps, Boolean(title));
    const iconLookup = $23985f7ea325d88e$var$normalizeIconArgs(iconArgs);
    if (!iconLookup) {
        $23985f7ea325d88e$var$logger.error("Icon lookup is undefined", iconArgs);
        return null;
    }
    const classList = $23985f7ea325d88e$var$getClassListFromProps(allProps);
    const transformProps = typeof transform === "string" ? (0, $87ca9af917cac014$export$98e6a39c04603d36).transform(transform) : transform;
    const normalizedMaskArgs = $23985f7ea325d88e$var$normalizeIconArgs(maskArgs);
    const renderedIcon = (0, $87ca9af917cac014$export$1ca1ec8b29a4ce27)(iconLookup, {
        ...classList.length > 0 && {
            classes: classList
        },
        ...transformProps && {
            transform: transformProps
        },
        ...normalizedMaskArgs && {
            mask: normalizedMaskArgs
        },
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    });
    if (!renderedIcon) {
        $23985f7ea325d88e$var$logger.error("Could not find icon", iconLookup);
        return null;
    }
    const { abstract: abstract } = renderedIcon;
    const extraProps = {
        ref: ref
    };
    for (const key of $23985f7ea325d88e$var$typedObjectKeys(allProps)){
        if ($23985f7ea325d88e$var$DEFAULT_PROP_KEYS.has(key)) continue;
        extraProps[key] = allProps[key];
    }
    return $23985f7ea325d88e$var$convertCurry(abstract[0], extraProps);
});
$23985f7ea325d88e$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
var $23985f7ea325d88e$var$convertCurry = $23985f7ea325d88e$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($baslc))).createElement);


function $acda8832e42feae3$export$7f7cbe89f1eacd2({ size: size }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
        spinPulse: true,
        className: "animate-spin",
        icon: (0, $159afdcd077ecfe9$export$1025ad641edb49c2),
        size: size
    });
}


function $275ef3258ca67a90$export$353f5b6fc5456de1({ type: type = "button", severity: severity = "primary", link: link = false, text: text = false, outline: outline = false, size: size = "md", children: children, disabled: disabled, route: route, href: href, target: target, onClick: onClick, title: title, className: className, loading: loading = false }) {
    const isDisabled = disabled || loading;
    const backgroundClass = link || text || outline ? "bg-transparent" : severity === "secondary" ? "bg-gray-500" : severity === "danger" ? "bg-red-500" : "bg-blue-500";
    const textClass = `${link ? "text-blue-500" : text || outline ? `${severity === "danger" ? "text-red-500" : "text-black"}` : "text-white uppercase"} ${size === "sm" ? "text-xs" : size === "md" ? "text-sm" : "text-base"}`;
    const paddingClass = link || text ? "" : size === "sm" ? "px-2 py-1" : size === "md" ? "px-4 py-2" : "px-2 py-1 sm:px-6 sm:py-3";
    const outlineClass = outline ? severity === "danger" ? "border border-red-500" : severity === "secondary" ? "border border-gray-500" : "border border-blue-500" : "";
    if (route) return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $c9ac255259af38e5$export$a6c7ac8248d6e38a), {
        className: `${paddingClass} ${backgroundClass} ${outlineClass} ${textClass} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""} flex items-center relative cursor-pointer rounded-md ${className ?? ""}`,
        title: title,
        to: route,
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($275ef3258ca67a90$var$ButtonContent, {
            loading: loading,
            children: children
        })
    });
    if (href) return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("a", {
        className: `${paddingClass} ${backgroundClass} ${outlineClass} ${textClass} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""} flex items-center relative cursor-pointer rounded-md ${className ?? ""}`,
        href: href,
        target: target,
        title: title,
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($275ef3258ca67a90$var$ButtonContent, {
            loading: loading,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("button", {
        className: `${paddingClass} ${backgroundClass} ${outlineClass} ${textClass} flex items-center relative cursor-pointer rounded-md disabled:opacity-50 disabled:cursor-not-allowed ${className ?? ""}`,
        disabled: isDisabled,
        title: title,
        type: type,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($275ef3258ca67a90$var$ButtonContent, {
            loading: loading,
            children: children
        })
    });
}
function $275ef3258ca67a90$var$ButtonContent({ loading: loading, children: children }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $d6899a6188537778$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                className: "absolute top-0 left-0 w-full h-full flex justify-center items-center",
                children: loading && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $acda8832e42feae3$export$7f7cbe89f1eacd2), {})
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                className: loading ? "opacity-0" : "",
                children: children
            })
        ]
    });
}



function $9a68f0ca0a43dd03$export$5523b16adee8048({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("h1", {
        className: `text-3xl ${className}`,
        children: children
    });
}






var $baslc = parcelRequire("baslc");
function $5876bcf854e2183c$export$2b77a92f1a5ad772({ open: open = true, size: size = "md", zIndex: zIndex = 100, children: children, onClose: onClose }) {
    (0, $baslc.useEffect)(()=>{
        let handleEsc;
        if (onClose) {
            // Listen to esc key
            handleEsc = (event)=>{
                if (event.key === "Escape") onClose();
            };
            window.addEventListener("keydown", handleEsc);
        }
        return ()=>{
            if (handleEsc) window.removeEventListener("keydown", handleEsc);
        };
    });
    (0, $baslc.useEffect)(()=>{
        if (open) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "auto";
        return ()=>{
            document.body.style.overflow = "auto";
        };
    }, [
        open
    ]);
    if (!open) return null;
    let sizeClasses = "";
    if (size === "xs") sizeClasses = "sm:min-h-auto sm:min-w-[30%] lg:min-w-[20%] xl:min-w-[15%]";
    else if (size === "sm") sizeClasses = "sm:min-h-[50%] sm:min-w-[50%] lg:min-w-[40%] xl:min-w-[35%]";
    else if (size === "md") sizeClasses = "sm:min-h-[75%] sm:min-w-[70%] lg:min-w-[50%]";
    else if (size === "lg") sizeClasses = "sm:min-h-[90%] sm:min-w-[90%] lg:min-w-[80%]";
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        className: "fixed inset-0 bg-black/50 flex justify-center items-center",
        style: {
            zIndex: zIndex
        },
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
            className: `bg-white sm:rounded-md px-6 pt-12 pb-6 relative max-h-full overflow-y-scroll min-h-[100%] min-w-[100%] ${sizeClasses} flex flex-col`,
            children: [
                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                    className: "absolute top-6 right-6 cursor-pointer",
                    icon: (0, $159afdcd077ecfe9$export$174bd7f477b115b4),
                    size: "lg",
                    onClick: ()=>{
                        onClose?.();
                    }
                }),
                children
            ]
        })
    });
}


function $a35ec5317329e70e$export$caec2af78bcc877f({ isOpen: isOpen, header: header, message: message, onClose: onClose }) {
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const closeModal = ()=>{
        onClose();
    };
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $5876bcf854e2183c$export$2b77a92f1a5ad772), {
        open: isOpen,
        size: "xs",
        zIndex: 1000,
        onClose: closeModal,
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
            className: "flex flex-col items-center gap-4",
            children: [
                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $9a68f0ca0a43dd03$export$5523b16adee8048), {
                    children: header
                }),
                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("p", {
                    children: message
                }),
                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                    severity: "primary",
                    onClick: closeModal,
                    children: t.ok
                })
            ]
        })
    });
}



function $6ee62976b4be268e$export$42a852a2b6b56249({ children: children, className: className }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        className: `mx-auto w-full max-w-7xl ${className}`,
        children: children
    });
}





function $35370380133e286e$export$a06f1c675e846f6f() {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        className: "min-h-[100px] pt-2 pb-4 px-5 bg-black text-white",
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6ee62976b4be268e$export$42a852a2b6b56249), {
            className: "md:flex justify-between",
            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                className: "flex flex-col flex-1/3",
                children: "\xa9 2026 Agile Architchs AB"
            })
        })
    });
}






var $baslc = parcelRequire("baslc");

const $55514a0d9d2a8586$export$bb53295897f4f117 = {
    en: "\uD83C\uDDEC\uD83C\uDDE7",
    sv: "\uD83C\uDDF8\uD83C\uDDEA",
    fr: "\uD83C\uDDEB\uD83C\uDDF7",
    de: "\uD83C\uDDE9\uD83C\uDDEA",
    it: "\uD83C\uDDEE\uD83C\uDDF9",
    es: "\uD83C\uDDEA\uD83C\uDDF8",
    pt: "\uD83C\uDDF5\uD83C\uDDF9",
    nl: "\uD83C\uDDF3\uD83C\uDDF1",
    pl: "\uD83C\uDDF5\uD83C\uDDF1",
    ro: "\uD83C\uDDF7\uD83C\uDDF4",
    ru: "\uD83C\uDDF7\uD83C\uDDFA",
    tr: "\uD83C\uDDF9\uD83C\uDDF7",
    ar: "\uD83C\uDDF8\uD83C\uDDE6",
    hi: "\uD83C\uDDEE\uD83C\uDDF3",
    bn: "\uD83C\uDDEE\uD83C\uDDF3",
    te: "\uD83C\uDDEE\uD83C\uDDF3",
    ta: "\uD83C\uDDEE\uD83C\uDDF3",
    mr: "\uD83C\uDDEE\uD83C\uDDF3",
    gu: "\uD83C\uDDEE\uD83C\uDDF3",
    kn: "\uD83C\uDDEE\uD83C\uDDF3",
    ml: "\uD83C\uDDEE\uD83C\uDDF3",
    pa: "\uD83C\uDDEE\uD83C\uDDF3",
    ur: "\uD83C\uDDF5\uD83C\uDDF0",
    fa: "\uD83C\uDDEE\uD83C\uDDF7",
    zh: "\uD83C\uDDE8\uD83C\uDDF3",
    ja: "\uD83C\uDDEF\uD83C\uDDF5",
    ko: "\uD83C\uDDF0\uD83C\uDDF7",
    vi: "\uD83C\uDDFB\uD83C\uDDF3",
    th: "\uD83C\uDDF9\uD83C\uDDED",
    id: "\uD83C\uDDEE\uD83C\uDDE9",
    ms: "\uD83C\uDDF2\uD83C\uDDFE",
    fil: "\uD83C\uDDF5\uD83C\uDDED"
};


const $e040d10fa3eea40e$export$b00263a5213e5421 = {
    en: "english",
    sv: "swedish"
};








var $baslc = parcelRequire("baslc");



function $6e3e385dd5320e62$export$48513f6b9f8ce62d({ label: label, value: value, onClick: onClick, className: className, checked: checked, disabled: disabled }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("label", {
        className: `${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500"} ${className}`,
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("input", {
                checked: !!checked,
                disabled: disabled,
                type: "checkbox",
                value: value,
                onChange: (e)=>onClick(!e.target.checked)
            }),
            label
        ]
    });
}


function $6fc41a6ad1597c99$export$931cbfb6bfb85fc({ label: label, options: options, className: className, buttonText: buttonText = false, buttonSize: buttonSize = "md", buttonSeverity: buttonSeverity = "primary", disabled: disabled = false, asCheckbox: asCheckbox = false, showSelectAll: showSelectAll = false, listClassName: listClassName, itemClassName: itemClassName, onSelectAll: onSelectAll, onSelect: onSelect }) {
    const [open, setOpen] = (0, $baslc.useState)(false);
    const ref = (0, $baslc.useRef)(null);
    (0, $baslc.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) setOpen(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        ref: ref,
        className: `relative h-full whitespace-nowrap ${className}`,
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                disabled: disabled,
                severity: buttonSeverity,
                size: buttonSize,
                text: buttonText,
                type: "button",
                onClick: ()=>setOpen(!open),
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                    className: "flex items-center gap-2 h-[16px]",
                    children: [
                        label,
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                            icon: (0, $159afdcd077ecfe9$export$8db9bc521720fccd)
                        })
                    ]
                })
            }),
            open && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("ul", {
                className: `absolute z-10 top-[calc(100%+1px)] right-0 min-w-full ${listClassName}`,
                children: [
                    showSelectAll && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("li", {
                        className: `px-2 py-1 text-left ${itemClassName}`,
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6e3e385dd5320e62$export$48513f6b9f8ce62d), {
                            checked: options.every((option)=>"checked" in option && option.checked),
                            className: "w-full block",
                            label: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("strong", {
                                children: "Select All"
                            }),
                            onClick: (v)=>{
                                onSelectAll?.(v);
                            }
                        })
                    }),
                    options.map((option, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("li", {
                            className: `px-2 py-1 text-left ${itemClassName}`,
                            children: [
                                !("route" in option) && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $d6899a6188537778$exports.Fragment), {
                                    children: asCheckbox ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6e3e385dd5320e62$export$48513f6b9f8ce62d), {
                                        checked: option.checked,
                                        className: "w-full block",
                                        disabled: option.disabled,
                                        label: option.label ?? "",
                                        value: option.value ?? "",
                                        onClick: ()=>{
                                            if (onSelect && option.value) onSelect(option.value);
                                        }
                                    }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("button", {
                                        className: `w-full ${onSelect ? "cursor-pointer" : ""}`,
                                        type: "button",
                                        onClick: ()=>{
                                            if (!onSelect) return;
                                            if (onSelect && option.value) onSelect(option.value);
                                        },
                                        children: option.label
                                    })
                                }),
                                "route" in option && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $c9ac255259af38e5$export$a6c7ac8248d6e38a), {
                                    className: "flex",
                                    to: option.route,
                                    children: option.label
                                })
                            ]
                        }, index))
                ]
            })
        ]
    });
}




var $baslc = parcelRequire("baslc");
function $7aae2eb8538a8629$export$ab2d9ae062af1562({ src: src, fallback: fallback, alt: alt, className: className }) {
    const [useFallback, setUseFallback] = (0, $baslc.useState)(false);
    return useFallback ? fallback : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("img", {
        alt: alt,
        className: className,
        src: src,
        onError: ()=>setUseFallback(true)
    });
}






var $baslc = parcelRequire("baslc");

function $d4d351111bba9ee0$export$130e28f611a1ca4e({ pagesTree: pagesTree, className: className }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("ul", {
        className: `flex flex-col ${className}`,
        children: pagesTree.map((page, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("li", {
                className: "w-full",
                children: "separator" in page ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                    className: "h-[1px] w-full bg-gray-200"
                }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($d4d351111bba9ee0$var$TreeMenuItem, {
                    page: page
                })
            }, `tree-menu-item-${index}`))
    });
}
function $d4d351111bba9ee0$var$TreeMenuItem({ page: page, isChild: isChild }) {
    const location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    const [open, setOpen] = (0, $baslc.useState)(false);
    const hasChildren = page.children && page.children.length > 0;
    const className = `w-full flex items-center py-3 hover:bg-pink-600 text-white ${!isChild ? "font-bold" : ""} ${$d4d351111bba9ee0$var$isActive(page.slug, location.pathname) ? "bg-pink-600" : ""}`;
    if (hasChildren) return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $d6899a6188537778$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("button", {
                className: `${className} min-w-[100px]`,
                onClick: ()=>setOpen(!open),
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        className: "w-[50px]",
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                            icon: open ? (0, $159afdcd077ecfe9$export$8db9bc521720fccd) : (0, $159afdcd077ecfe9$export$930de8c26eb20490)
                        })
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        children: page.title
                    })
                ]
            }),
            open && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("ul", {
                children: page.children.map((child, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("li", {
                        children: "separator" in child ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                            className: "h-[1px] w-full bg-gray-200"
                        }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($d4d351111bba9ee0$var$TreeMenuItem, {
                            isChild: true,
                            page: child
                        })
                    }, `tree-menu-item-${index}`))
            })
        ]
    });
    else return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $c9ac255259af38e5$export$b0d92dbee9b5b60d), {
        className: `${className} pl-[50px]`,
        to: page.slug,
        children: page.title
    });
}
function $d4d351111bba9ee0$var$isActive(slug, pathname) {
    return pathname.startsWith(slug);
}


const $26a14be0a203a6c0$export$8f45430ccf837300 = {
    pink: {
        background: "bg-pink-500",
        active: "bg-pink-600",
        hover: "hover:bg-pink-600",
        text: "text-white"
    },
    blue: {
        background: "bg-blue-500",
        active: "bg-blue-600",
        hover: "hover:bg-blue-600",
        text: "text-white"
    }
};
function $26a14be0a203a6c0$export$42cfbb80f7861e77({ menu: menu, profileMenu: profileMenu, color: color, name: name, logoImgUrl: logoImgUrl, availableLanguages: availableLanguages, onLanguageChange: onLanguageChange, showSearch: showSearch = true, searchValue: searchValue, onSearch: onSearch }) {
    const location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    const { locale: t } = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)();
    const [open, setOpen] = (0, $baslc.useState)(false);
    const prevKeyRef = (0, $baslc.useRef)(location.key);
    const [searchQuery, setSearchQuery] = (0, $baslc.useState)("");
    const hasProfileMenu = profileMenu && profileMenu.length > 0;
    (0, $baslc.useEffect)(()=>{
        setSearchQuery(searchValue ?? "");
    }, [
        searchValue
    ]);
    // Close drawer on route change
    (0, $baslc.useEffect)(()=>{
        if (prevKeyRef.current !== location.key) {
            prevKeyRef.current = location.key;
            setOpen(false);
        }
    }, [
        location
    ]);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        className: `w-full ${open ? `${$26a14be0a203a6c0$export$8f45430ccf837300[color].background} md:bg-inherit h-dvh md:h-auto` : ""}`,
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $6ee62976b4be268e$export$42a852a2b6b56249), {
                className: "hidden md:flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($26a14be0a203a6c0$var$Logo, {
                        className: "h-[60px] p-3",
                        logoImgUrl: logoImgUrl,
                        name: name
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                        className: "mr-4 flex gap-2",
                        children: [
                            availableLanguages && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6fc41a6ad1597c99$export$931cbfb6bfb85fc), {
                                buttonText: true,
                                itemClassName: `px-2 py-1 text-white ${$26a14be0a203a6c0$export$8f45430ccf837300[color].hover}`,
                                label: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                    icon: (0, $159afdcd077ecfe9$export$b1b1cdce4a19c682)
                                }),
                                listClassName: `${$26a14be0a203a6c0$export$8f45430ccf837300[color].background} whitespace-nowrap rounded-sm border-1 border-black`,
                                options: availableLanguages.map((language)=>({
                                        label: `${(0, $55514a0d9d2a8586$export$bb53295897f4f117)[language]} ${t.locale[(0, $e040d10fa3eea40e$export$b00263a5213e5421)[language]]}`,
                                        value: language
                                    })),
                                onSelect: (language)=>onLanguageChange?.(language)
                            }),
                            hasProfileMenu && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6fc41a6ad1597c99$export$931cbfb6bfb85fc), {
                                buttonText: true,
                                itemClassName: `px-2 py-1 text-center ${$26a14be0a203a6c0$export$8f45430ccf837300[color].hover}`,
                                label: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                    icon: (0, $159afdcd077ecfe9$export$f5699fa0844e0188)
                                }),
                                listClassName: `${$26a14be0a203a6c0$export$8f45430ccf837300[color].background} whitespace-nowrap rounded-sm border-1 border-black`,
                                options: profileMenu.map((menuItem)=>({
                                        label: menuItem.title || menuItem.slug,
                                        route: menuItem.redirectTo || menuItem.slug
                                    })),
                                onSelect: (language)=>onLanguageChange?.(language)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                className: `h-[50px] flex ${$26a14be0a203a6c0$export$8f45430ccf837300[color].background}`,
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $6ee62976b4be268e$export$42a852a2b6b56249), {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($26a14be0a203a6c0$var$Logo, {
                            className: `flex md:hidden p-5 ${$26a14be0a203a6c0$export$8f45430ccf837300[color].text}`,
                            name: name
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("ul", {
                            className: "hidden md:flex flex-1 h-full items-center",
                            children: menu && menu.map((menuItem, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("li", {
                                    className: `h-full flex items-center ${"separator" in menuItem ? "flex-1" : ""}`,
                                    children: !("separator" in menuItem) && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $c9ac255259af38e5$export$b0d92dbee9b5b60d), {
                                        className: `px-5 py-3 ${$26a14be0a203a6c0$export$8f45430ccf837300[color].text} ${$26a14be0a203a6c0$export$8f45430ccf837300[color].hover} ${$26a14be0a203a6c0$var$isActive(menuItem.slug, location.pathname) ? $26a14be0a203a6c0$export$8f45430ccf837300[color].active : ""}`,
                                        to: menuItem.redirectTo || menuItem.slug,
                                        children: menuItem.title || menuItem.slug
                                    })
                                }, `menu-${index}`))
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                            className: "flex-1 md:flex-none flex justify-end h-full items-center pr-4",
                            children: [
                                showSearch && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("form", {
                                    className: "relative w-full h-full py-2",
                                    onSubmit: (e)=>{
                                        e.preventDefault();
                                        onSearch?.(searchQuery);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                            className: "absolute left-2 top-1/2 -translate-y-1/2 text-gray-500",
                                            icon: (0, $159afdcd077ecfe9$export$871a78837687ffe8)
                                        }),
                                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("input", {
                                            className: "w-full h-full bg-white rounded-sm pl-8",
                                            name: "query",
                                            type: "text",
                                            value: searchQuery,
                                            onChange: (e)=>setSearchQuery(e.target.value)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                                    className: "md:hidden flex mx-2 gap-2 flex-nowrap",
                                    children: [
                                        availableLanguages && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6fc41a6ad1597c99$export$931cbfb6bfb85fc), {
                                            buttonText: true,
                                            itemClassName: `px-2 py-1 text-center hover:bg-gray-200 ${$26a14be0a203a6c0$export$8f45430ccf837300[color].hover}`,
                                            label: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                                icon: (0, $159afdcd077ecfe9$export$b1b1cdce4a19c682)
                                            }),
                                            listClassName: `${$26a14be0a203a6c0$export$8f45430ccf837300[color].background} ${$26a14be0a203a6c0$export$8f45430ccf837300[color].text} whitespace-nowrap rounded-b-sm`,
                                            options: availableLanguages.map((language)=>({
                                                    label: `${(0, $55514a0d9d2a8586$export$bb53295897f4f117)[language]} ${t.locale[(0, $e040d10fa3eea40e$export$b00263a5213e5421)[language]]}`,
                                                    value: language
                                                })),
                                            onSelect: (language)=>onLanguageChange?.(language)
                                        }),
                                        profileMenu && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6fc41a6ad1597c99$export$931cbfb6bfb85fc), {
                                            buttonText: true,
                                            itemClassName: `px-2 py-1 text-center hover:bg-gray-200 ${$26a14be0a203a6c0$export$8f45430ccf837300[color].hover}`,
                                            label: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                                icon: (0, $159afdcd077ecfe9$export$f5699fa0844e0188)
                                            }),
                                            listClassName: `${$26a14be0a203a6c0$export$8f45430ccf837300[color].background} ${$26a14be0a203a6c0$export$8f45430ccf837300[color].text} whitespace-nowrap rounded-b-sm`,
                                            options: profileMenu.map((menuItem)=>({
                                                    label: menuItem.title || menuItem.slug,
                                                    route: menuItem.redirectTo || menuItem.slug
                                                })),
                                            onSelect: (language)=>onLanguageChange?.(language)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("button", {
                                    className: `sm:block md:hidden ${$26a14be0a203a6c0$export$8f45430ccf837300[color].text} w-[32px]`,
                                    onClick: ()=>setOpen(!open),
                                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                        icon: open ? (0, $159afdcd077ecfe9$export$e6e44779b2fa1a5c) : (0, $159afdcd077ecfe9$export$36e9cf7887265da2)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            open && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $d4d351111bba9ee0$export$130e28f611a1ca4e), {
                className: "flex md:hidden",
                pagesTree: menu
            })
        ]
    });
}
function $26a14be0a203a6c0$var$Logo({ className: className, name: name, logoImgUrl: logoImgUrl }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        className: `flex items-center gap-2 ${className}`,
        children: logoImgUrl ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $c9ac255259af38e5$export$b0d92dbee9b5b60d), {
            className: "h-full",
            to: "/",
            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $7aae2eb8538a8629$export$ab2d9ae062af1562), {
                alt: "logo",
                className: "h-full",
                fallback: fallback(name),
                src: logoImgUrl
            })
        }) : fallback(name, false)
    });
    function fallback(name, withIcon = true) {
        return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
            className: "flex items-center gap-2",
            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $c9ac255259af38e5$export$b0d92dbee9b5b60d), {
                to: "/",
                children: [
                    withIcon && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                        icon: (0, $159afdcd077ecfe9$export$dcadc0d67468dfa8)
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("p", {
                        className: "font-bold",
                        children: name
                    })
                ]
            })
        });
    }
}
function $26a14be0a203a6c0$var$isActive(slug, pathname) {
    const slugParts = slug.split("/");
    const pathnameParts = pathname.split("/");
    if (slugParts.length > pathnameParts.length) return false;
    return slugParts.every((part, index)=>part === pathnameParts[index]);
}


function $48b172856632ebca$export$c84671f46d6a1ca({ menu: menu = [], profileMenu: profileMenu, color: color, children: children, name: name, logoUrl: logoUrl, availableLanguages: availableLanguages, onLanguageChange: onLanguageChange, showSearch: showSearch = true, searchValue: searchValue, onSearch: onSearch }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        className: "min-h-dvh flex flex-col",
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $26a14be0a203a6c0$export$42cfbb80f7861e77), {
                availableLanguages: availableLanguages,
                color: color,
                logoImgUrl: logoUrl,
                menu: menu,
                name: name,
                profileMenu: profileMenu,
                searchValue: searchValue,
                showSearch: showSearch,
                onLanguageChange: onLanguageChange,
                onSearch: onSearch
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("main", {
                className: "flex flex-1 my-5 mx-5",
                children: children
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $35370380133e286e$export$a06f1c675e846f6f), {})
        ]
    });
}





function $811ac5f8ab6a4794$export$a9c522a6d7beb830({ menu: menu, color: color }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("ul", {
        className: `w-full rounded-xs py-2 flex flex-col ${(0, $26a14be0a203a6c0$export$8f45430ccf837300)[color].background}`,
        children: menu.map((page, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("li", {
                children: "separator" in page ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                    className: "h-[1px] w-full bg-gray-200"
                }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $c9ac255259af38e5$export$b0d92dbee9b5b60d), {
                    className: `px-3 py-2 block ${(0, $26a14be0a203a6c0$export$8f45430ccf837300)[color].text} ${(0, $26a14be0a203a6c0$export$8f45430ccf837300)[color].hover} ${$811ac5f8ab6a4794$var$isActive(page.slug, location.pathname) ? (0, $26a14be0a203a6c0$export$8f45430ccf837300)[color].active : ""}`,
                    to: page.slug,
                    children: page.title || page.slug
                })
            }, `sub-menu-${index}`))
    });
}
function $811ac5f8ab6a4794$var$isActive(slug, pathname) {
    var part, index;
    return pathname.startsWith(slug);
}


function $668b279d534888b2$export$ef88aa0d34c34520({ children: children }) {
    const navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    const { setLocale: setLocale } = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)();
    const authStore = (0, $45422d7966ef8166$export$650ce9f0b4df82fd)();
    const alertMessage = (0, $e0f39c23c3c9ecf4$export$da6ac23acb078b0d)();
    const setIsAuthRef = (0, $baslc.useRef)(authStore.setIsAuth);
    const navigateRef = (0, $baslc.useRef)(navigate);
    const menu = (0, $4063212f19a2e3fa$export$38eaa17faae8f579)();
    const subMenu = (0, $dfaad8cc0baf2ff9$export$b359ddbc2eba6d20)();
    const profileMenu = (0, $68b4b3b014c4b751$export$36aebdc2569f2447)();
    (0, $baslc.useEffect)(()=>{
        const subs = (0, $d9482e4a5ea3dee8$export$af631764ddc44097)("error", (payload)=>{
            const parsedPayload = $8ad647561ba7dbe6$export$be5493f9613cbbe({
                code: $8ad647561ba7dbe6$export$22b082955e083ec3(),
                message: $8ad647561ba7dbe6$export$22b082955e083ec3().optional(),
                info: $8ad647561ba7dbe6$export$22b082955e083ec3().optional()
            }).parse(payload);
            if (parsedPayload.code === (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED.toString()) {
                (0, $2ccd26ee17720849$export$a0973bcfe11b05c9)();
                setIsAuthRef.current(false);
                navigateRef.current("/");
            }
            alertMessage.open(parsedPayload);
            alertMessage.setIsOpen(true);
        });
        return ()=>{
            subs.unsubscribe();
        };
    });
    const color = "blue";
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $48b172856632ebca$export$c84671f46d6a1ca), {
        availableLanguages: [
            "en",
            "sv"
        ],
        color: color,
        menu: menu,
        name: "Companies Admin",
        profileMenu: profileMenu || undefined,
        showSearch: false,
        onLanguageChange: (language)=>{
            setLocale(language);
        },
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $a35ec5317329e70e$export$caec2af78bcc877f), {
                header: alertMessage.header,
                isOpen: alertMessage.isOpen,
                message: alertMessage.message,
                onClose: ()=>alertMessage.setIsOpen(false)
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $6ee62976b4be268e$export$42a852a2b6b56249), {
                className: "flex gap-5",
                children: [
                    subMenu.length > 0 && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        className: "hidden md:block min-w-[230px]",
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $811ac5f8ab6a4794$export$a9c522a6d7beb830), {
                            color: color,
                            menu: subMenu
                        })
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        className: "flex-1 min-w-0",
                        children: children
                    })
                ]
            })
        ]
    });
}






function $a0b46b89485c073d$export$b94310965bed44e6() {
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        className: "grow flex items-center justify-center",
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $9a68f0ca0a43dd03$export$5523b16adee8048), {
            children: t.home.welcome
        })
    });
}




var $baslc = parcelRequire("baslc");





function $173e23f76111c8c7$export$f5b8910cec6cf069({ ref: ref, id: id, className: className, inputClassName: inputClassName, placeholder: placeholder, label: label, suffix: suffix, suffixNoStyle: suffixNoStyle = false, prefix: prefix, prefixNoStyle: prefixNoStyle = false, type: type, rows: rows = 3, onChange: onChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, value: value, clearButton: clearButton = false, size: size = "md", hasError: hasError, disabled: disabled, required: required }) {
    const hasPrefix = prefix !== undefined;
    const hasSuffix = suffix !== undefined;
    let inputRoundnessClass = "";
    if (hasPrefix && !hasSuffix) inputRoundnessClass = "rounded-r-md";
    else if (!hasPrefix && hasSuffix) inputRoundnessClass = "rounded-l-md";
    else inputRoundnessClass = "rounded-md";
    const isTextarea = type === "textarea";
    const inputcc = `
    w-full
    border-1
    border-gray-300
    ${inputRoundnessClass}
    p-2
    bg-white
    disabled:bg-gray-100
    disabled:text-gray-400
    disabled:cursor-not-allowed
    focus-visible:outline-2
    focus-visible:outline-offset-[-2px]
    focus-visible:outline-style-solid
    focus-visible:outline-blue-500
    ${inputClassName}
    ${hasError ? "border-red-500" : " " + (size === "sm" ? "text-xs" : size === "md" ? "text-sm" : "text-base")}`;
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        className: `${className ?? ""}`,
        children: [
            label && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("label", {
                className: `block text-sm font-medium ${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500"}`,
                children: [
                    label,
                    " ",
                    required && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("span", {
                        className: "text-red-500",
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                className: "flex",
                children: [
                    prefix && prefixNoStyle && prefix,
                    prefix && !prefixNoStyle && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        className: "border-y-1 border-l-1 border-gray-300 rounded-l-md bg-gray-200 px-3 flex items-center justify-center",
                        children: prefix
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                        className: "relative grow",
                        children: [
                            isTextarea ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("textarea", {
                                ref: ref,
                                className: inputcc,
                                disabled: disabled,
                                id: id,
                                placeholder: placeholder,
                                rows: rows,
                                value: value,
                                onBlur: onBlur,
                                onChange: onChange,
                                onFocus: onFocus,
                                onKeyDown: onKeyDown
                            }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("input", {
                                ref: ref,
                                className: inputcc,
                                disabled: disabled,
                                id: id,
                                placeholder: placeholder,
                                type: type,
                                value: value,
                                onBlur: onBlur,
                                onChange: onChange,
                                onFocus: onFocus,
                                onKeyDown: onKeyDown
                            }),
                            clearButton && value !== "" && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("button", {
                                className: `absolute ${type === "date" ? "right-8" : "right-2"} top-1/2 -translate-y-1/2 cursor-pointer`,
                                type: "button",
                                onClick: ()=>onChange?.({
                                        target: {
                                            value: ""
                                        }
                                    }),
                                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                    icon: (0, $159afdcd077ecfe9$export$174bd7f477b115b4)
                                })
                            })
                        ]
                    }),
                    suffix && suffixNoStyle && suffix,
                    suffix && !suffixNoStyle && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        className: "border-y-1 border-r-1 border-gray-300 rounded-r-md bg-gray-200 px-3 flex items-center justify-center",
                        children: suffix
                    })
                ]
            })
        ]
    });
}



parcelRequire("baslc");
function $853f6cf8788e07d7$export$f69c19e57285b83a({ className: className, children: children, severity: severity = "info" }) {
    let bgColor = "bg-blue-100 text-blue-800";
    if (severity === "error") bgColor = "bg-red-100 text-red-800";
    else if (severity === "warning") bgColor = "bg-yellow-100 text-yellow-800";
    else if (severity === "success") bgColor = "bg-green-100 text-green-800";
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        className: `p-4 rounded-md border ${bgColor} ${className || ""}`,
        role: "alert",
        children: children
    });
}





function $401fc7c7dcb14efc$export$21a94553ffa41578() {
    const navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    const authStore = (0, $45422d7966ef8166$export$650ce9f0b4df82fd)();
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const [authError, setAuthError] = (0, $baslc.useState)(false);
    const [isLoading, setIsLoading] = (0, $baslc.useState)(false);
    const [email, setEmail] = (0, $baslc.useState)("");
    const [password, setPassword] = (0, $baslc.useState)("");
    const isValid = email.length > 0 && password.length > 0;
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        className: "mt-10 mx-auto lg:w-8/12 xl:w-6/12",
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("h1", {
                className: "text-3xl",
                children: t.login.title
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("form", {
                onSubmit: (e)=>{
                    (async ()=>{
                        setIsLoading(true);
                        e.preventDefault();
                        try {
                            await (0, $2ccd26ee17720849$export$596d806903d1f59e)(email, password);
                            authStore.setIsAuth(true);
                            navigate("/");
                        } catch (error) {
                            setAuthError(true);
                        } finally{
                            setIsLoading(false);
                        }
                    })();
                },
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                        className: "my-2",
                        children: [
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("label", {
                                htmlFor: "email",
                                children: t.login.email
                            }),
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                                className: "w-full",
                                disabled: isLoading,
                                hasError: authError,
                                id: "email",
                                size: "lg",
                                type: "email",
                                value: email,
                                onChange: (event)=>setEmail(event.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                        className: "mt-5",
                        children: [
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("label", {
                                htmlFor: "password",
                                children: t.login.password
                            }),
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                                className: "w-full",
                                disabled: isLoading,
                                hasError: authError,
                                id: "password",
                                size: "lg",
                                type: "password",
                                value: password,
                                onChange: (event)=>setPassword(event.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                        className: "mt-5 flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                                className: "grow",
                                children: authError && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $853f6cf8788e07d7$export$f69c19e57285b83a), {
                                    className: "w-full",
                                    severity: "error",
                                    children: t.login.error
                                })
                            }),
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                                className: "min-w-32 flex justify-end",
                                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    disabled: !isValid,
                                    loading: isLoading,
                                    size: "lg",
                                    type: "submit",
                                    children: t.login.submit
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $baslc = parcelRequire("baslc");



function $df26a3ab557252de$export$cad1a703886b4e3a() {
    const navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    const authStore = (0, $45422d7966ef8166$export$650ce9f0b4df82fd)();
    const setIsAuthRef = (0, $baslc.useRef)(authStore.setIsAuth);
    const navigateRef = (0, $baslc.useRef)(navigate);
    (0, $baslc.useEffect)(()=>{
        (async ()=>{
            await (0, $2ccd26ee17720849$export$a0973bcfe11b05c9)();
            setIsAuthRef.current(false);
            navigateRef.current("/");
        })();
    });
    return null;
}




var $baslc = parcelRequire("baslc");


var $baslc = parcelRequire("baslc");








var $66c77ea26ba00d38$var$_client, $66c77ea26ba00d38$var$_currentQuery, $66c77ea26ba00d38$var$_currentQueryInitialState, $66c77ea26ba00d38$var$_currentResult, $66c77ea26ba00d38$var$_currentResultState, $66c77ea26ba00d38$var$_currentResultOptions, $66c77ea26ba00d38$var$_currentThenable, $66c77ea26ba00d38$var$_selectError, $66c77ea26ba00d38$var$_selectFn, $66c77ea26ba00d38$var$_selectResult, $66c77ea26ba00d38$var$_lastQueryWithDefinedData, $66c77ea26ba00d38$var$_staleTimeoutId, $66c77ea26ba00d38$var$_refetchIntervalId, $66c77ea26ba00d38$var$_currentRefetchInterval, $66c77ea26ba00d38$var$_trackedProps, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$executeFetch_fn, $66c77ea26ba00d38$var$updateStaleTimeout_fn, $66c77ea26ba00d38$var$computeRefetchInterval_fn, $66c77ea26ba00d38$var$updateRefetchInterval_fn, $66c77ea26ba00d38$var$updateTimers_fn, $66c77ea26ba00d38$var$clearStaleTimeout_fn, $66c77ea26ba00d38$var$clearRefetchInterval_fn, $66c77ea26ba00d38$var$updateQuery_fn, $66c77ea26ba00d38$var$notify_fn;
var $66c77ea26ba00d38$export$a06cf8c0066f0d4c = class extends (0, $15818b8c37ef3cb7$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_QueryObserver_instances);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_client);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_currentQuery);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_currentQueryInitialState);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_currentResult);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_currentResultState);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_currentResultOptions);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_currentThenable);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_selectError);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_selectFn);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_selectResult);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_lastQueryWithDefinedData);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_staleTimeoutId);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_refetchIntervalId);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_currentRefetchInterval);
        (0, $fee147b415f7ff33$export$addf369becd23283)(this, $66c77ea26ba00d38$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_client, client);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_selectError, null);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentThenable, (0, $1cb7992ab8b9cdb7$export$d54630db02a12b72)());
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery).addObserver(this);
            if ($66c77ea26ba00d38$var$shouldFetchOnMount((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery), this.options)) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $66c77ea26ba00d38$var$shouldFetchOn((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $66c77ea26ba00d38$var$shouldFetchOn((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$clearStaleTimeout_fn).call(this);
        (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$clearRefetchInterval_fn).call(this);
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery);
        this.options = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(this.options.enabled, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$updateQuery_fn).call(this);
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, $b204d4f45461ab39$export$3e67810a3f0e9f1c)(this.options, prevOptions)) (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $66c77ea26ba00d38$var$shouldFetchOptionally((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$executeFetch_fn).call(this);
        this.updateResult();
        if (mounted && ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery) !== prevQuery || (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(this.options.enabled, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) !== (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) || (0, $b204d4f45461ab39$export$cb3145f011bda3ac)(this.options.staleTime, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) !== (0, $b204d4f45461ab39$export$cb3145f011bda3ac)(prevOptions.staleTime, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)))) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery) !== prevQuery || (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(this.options.enabled, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) !== (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(prevOptions.enabled, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) || nextRefetchInterval !== (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentRefetchInterval))) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client).getQueryCache().build((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client), options);
        const result = this.createResult(query, options);
        if ($66c77ea26ba00d38$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentResult, result);
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentResultOptions, this.options);
            (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentResultState, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked == null || onPropTracked(key);
                if (key === "promise" && !this.options.experimental_prefetchInRender && (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentThenable).status === "pending") (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client).defaultQueryOptions(options);
        const query = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client).getQueryCache().build((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult);
        const prevResultState = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResultState);
        const prevResultOptions = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQueryInitialState);
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $66c77ea26ba00d38$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $66c77ea26ba00d38$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $857b44af3733d895$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $b204d4f45461ab39$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_selectFn)) data = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_selectResult);
            else try {
                (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_selectFn, options.select);
                data = options.select(data);
                data = (0, $b204d4f45461ab39$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_selectResult, data);
                (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_selectError, null);
            } catch (selectError) {
                (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_selectError, selectError);
            }
        }
        if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_selectError)) {
            error = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_selectError);
            data = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $66c77ea26ba00d38$var$isStale(query, options),
            refetch: this.refetch,
            promise: (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentThenable),
            isEnabled: (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentThenable, nextResult.promise = (0, $1cb7992ab8b9cdb7$export$d54630db02a12b72)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult);
        const nextResult = this.createResult((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery), this.options);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentResultState, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery).state);
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentResultOptions, this.options);
        if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResultState).data !== void 0) (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_lastQueryWithDefinedData, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery));
        if ((0, $b204d4f45461ab39$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$notify_fn).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$updateTimers_fn).call(this);
    }
};
$66c77ea26ba00d38$var$_client = new WeakMap();
$66c77ea26ba00d38$var$_currentQuery = new WeakMap();
$66c77ea26ba00d38$var$_currentQueryInitialState = new WeakMap();
$66c77ea26ba00d38$var$_currentResult = new WeakMap();
$66c77ea26ba00d38$var$_currentResultState = new WeakMap();
$66c77ea26ba00d38$var$_currentResultOptions = new WeakMap();
$66c77ea26ba00d38$var$_currentThenable = new WeakMap();
$66c77ea26ba00d38$var$_selectError = new WeakMap();
$66c77ea26ba00d38$var$_selectFn = new WeakMap();
$66c77ea26ba00d38$var$_selectResult = new WeakMap();
$66c77ea26ba00d38$var$_lastQueryWithDefinedData = new WeakMap();
$66c77ea26ba00d38$var$_staleTimeoutId = new WeakMap();
$66c77ea26ba00d38$var$_refetchIntervalId = new WeakMap();
$66c77ea26ba00d38$var$_currentRefetchInterval = new WeakMap();
$66c77ea26ba00d38$var$_trackedProps = new WeakMap();
$66c77ea26ba00d38$var$_QueryObserver_instances = new WeakSet();
$66c77ea26ba00d38$var$executeFetch_fn = function(fetchOptions) {
    (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$updateQuery_fn).call(this);
    let promise = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $b204d4f45461ab39$export$8793edee2d425525));
    return promise;
};
$66c77ea26ba00d38$var$updateStaleTimeout_fn = function() {
    (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$clearStaleTimeout_fn).call(this);
    const staleTime = (0, $b204d4f45461ab39$export$cb3145f011bda3ac)(this.options.staleTime, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery));
    if ((0, $b204d4f45461ab39$export$6acf61af03e62db) || (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult).isStale || !(0, $b204d4f45461ab39$export$e539f754e934e270)(staleTime)) return;
    const time = (0, $b204d4f45461ab39$export$811b83d62bcf47f0)((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$66c77ea26ba00d38$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$66c77ea26ba00d38$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$clearRefetchInterval_fn).call(this);
    (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentRefetchInterval, nextInterval);
    if ((0, $b204d4f45461ab39$export$6acf61af03e62db) || (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(this.options.enabled, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) === false || !(0, $b204d4f45461ab39$export$e539f754e934e270)((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentRefetchInterval)) || (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentRefetchInterval) === 0) return;
    (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $5ae4d1fd12e36b30$export$6bf54661be5b02cf).isFocused()) (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$executeFetch_fn).call(this);
    }, (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentRefetchInterval)));
};
$66c77ea26ba00d38$var$updateTimers_fn = function() {
    (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$updateStaleTimeout_fn).call(this);
    (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$updateRefetchInterval_fn).call(this, (0, $fee147b415f7ff33$export$fa92d15b718fce20)(this, $66c77ea26ba00d38$var$_QueryObserver_instances, $66c77ea26ba00d38$var$computeRefetchInterval_fn).call(this));
};
$66c77ea26ba00d38$var$clearStaleTimeout_fn = function() {
    if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_staleTimeoutId)) {
        clearTimeout((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_staleTimeoutId));
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_staleTimeoutId, void 0);
    }
};
$66c77ea26ba00d38$var$clearRefetchInterval_fn = function() {
    if ((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_refetchIntervalId)) {
        clearInterval((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_refetchIntervalId));
        (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_refetchIntervalId, void 0);
    }
};
$66c77ea26ba00d38$var$updateQuery_fn = function() {
    const query = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client).getQueryCache().build((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client), this.options);
    if (query === (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery)) return;
    const prevQuery = (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery);
    (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentQuery, query);
    (0, $fee147b415f7ff33$export$42432efe6614d3b4)(this, $66c77ea26ba00d38$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$66c77ea26ba00d38$var$notify_fn = function(notifyOptions) {
    (0, $f6f1973e83103746$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentResult));
        });
        (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_client).getQueryCache().notify({
            query: (0, $fee147b415f7ff33$export$18a094aefa070634)(this, $66c77ea26ba00d38$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $66c77ea26ba00d38$var$shouldLoadOnMount(query, options) {
    return (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $66c77ea26ba00d38$var$shouldFetchOnMount(query, options) {
    return $66c77ea26ba00d38$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $66c77ea26ba00d38$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $66c77ea26ba00d38$var$shouldFetchOn(query, options, field) {
    if ((0, $b204d4f45461ab39$export$8c88ee6f2357230d)(options.enabled, query) !== false && (0, $b204d4f45461ab39$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $66c77ea26ba00d38$var$isStale(query, options);
    }
    return false;
}
function $66c77ea26ba00d38$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $66c77ea26ba00d38$var$isStale(query, options);
}
function $66c77ea26ba00d38$var$isStale(query, options) {
    return (0, $b204d4f45461ab39$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $b204d4f45461ab39$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $66c77ea26ba00d38$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $b204d4f45461ab39$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $baslc = parcelRequire("baslc");



var $baslc = parcelRequire("baslc");

"use client";
function $5ff3857034570e5b$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $5ff3857034570e5b$var$QueryErrorResetBoundaryContext = $baslc.createContext($5ff3857034570e5b$var$createValue());
var $5ff3857034570e5b$export$50dfac555130cafd = ()=>$baslc.useContext($5ff3857034570e5b$var$QueryErrorResetBoundaryContext);
var $5ff3857034570e5b$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $baslc.useState(()=>$5ff3857034570e5b$var$createValue());
    return /* @__PURE__ */ (0, $d6899a6188537778$exports.jsx)($5ff3857034570e5b$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $baslc = parcelRequire("baslc");

"use client";
var $069db08b58a81dc6$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $069db08b58a81dc6$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $baslc.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $069db08b58a81dc6$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $b204d4f45461ab39$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $baslc = parcelRequire("baslc");
"use client";
var $ba8245eca6c18ce6$var$IsRestoringContext = $baslc.createContext(false);
var $ba8245eca6c18ce6$export$4da0178d6b5f553 = ()=>$baslc.useContext($ba8245eca6c18ce6$var$IsRestoringContext);
var $ba8245eca6c18ce6$export$593807d4e94f9621 = $ba8245eca6c18ce6$var$IsRestoringContext.Provider;


// src/suspense.ts
var $486669e018c7e8e4$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $486669e018c7e8e4$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $486669e018c7e8e4$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $486669e018c7e8e4$export$88d3586dfed64df9 = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var $486669e018c7e8e4$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $3811e7848f7bf351$export$fff0865807e996c5(options, Observer, queryClient) {
    var _a, _b, _c, _d, _e;
    const isRestoring = (0, $ba8245eca6c18ce6$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $5ff3857034570e5b$export$50dfac555130cafd)();
    const client = (0, $797f0ac2fbf7fdb2$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $486669e018c7e8e4$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $069db08b58a81dc6$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $069db08b58a81dc6$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $baslc.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $baslc.useSyncExternalStore($baslc.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $f6f1973e83103746$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $b204d4f45461ab39$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $baslc.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $486669e018c7e8e4$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $486669e018c7e8e4$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $069db08b58a81dc6$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $b204d4f45461ab39$export$6acf61af03e62db) && (0, $486669e018c7e8e4$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $486669e018c7e8e4$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        (_e = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e.promise;
        promise == null || promise.catch((0, $b204d4f45461ab39$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $0da705b248c5c0f3$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $3811e7848f7bf351$export$fff0865807e996c5)(options, (0, $66c77ea26ba00d38$export$a06cf8c0066f0d4c), queryClient);
}




const $a057e605a561b024$export$33cda15ae01f583c = $8ad647561ba7dbe6$export$be5493f9613cbbe({
    name: $8ad647561ba7dbe6$export$22b082955e083ec3(),
    hours: $8ad647561ba7dbe6$export$98e628dec113755e()
});
const $a057e605a561b024$export$4d22362d9e759546 = $8ad647561ba7dbe6$export$2f23118c22fb2630($a057e605a561b024$export$33cda15ae01f583c);



const $fb6f63336e19db2f$var$API_BASE_URL = "/api";
async function $fb6f63336e19db2f$export$20b82b4a32771893(project) {
    const response = await fetch(`${$fb6f63336e19db2f$var$API_BASE_URL}/task?project=${encodeURIComponent(project)}`);
    if (response.status === 401) throw (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED;
    else if (!response.ok) throw new Error("Failed to get tasks");
    return (0, $a057e605a561b024$export$4d22362d9e759546).parse(await response.json());
}


const $fd27c95543d7b34e$export$ed5c3368304694 = (project)=>{
    return (0, $0da705b248c5c0f3$export$dd0a697e1782aedd)({
        queryKey: [
            "get-tasks",
            project
        ],
        queryFn: ()=>(0, $fb6f63336e19db2f$export$20b82b4a32771893)(project),
        staleTime: 3600000,
        retry: (_failureCount, error)=>error !== (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED
    });
};




var $9c5cd6eef751ac06$exports = {};

$parcel$export($9c5cd6eef751ac06$exports, "string", () => $9c5cd6eef751ac06$export$22b082955e083ec3);
$parcel$export($9c5cd6eef751ac06$exports, "number", () => $9c5cd6eef751ac06$export$98e628dec113755e);
$parcel$export($9c5cd6eef751ac06$exports, "boolean", () => $9c5cd6eef751ac06$export$4a21f16c33752377);
$parcel$export($9c5cd6eef751ac06$exports, "bigint", () => $9c5cd6eef751ac06$export$a0f65b52274bcc00);
$parcel$export($9c5cd6eef751ac06$exports, "date", () => $9c5cd6eef751ac06$export$324d90190a8b822a);


function $9c5cd6eef751ac06$export$22b082955e083ec3(params) {
    return $b93bb84d2922cb59$export$614049477c642ce0($8ad647561ba7dbe6$export$1230eb29b8d3b502, params);
}
function $9c5cd6eef751ac06$export$98e628dec113755e(params) {
    return $b93bb84d2922cb59$export$272511620e4661dd($8ad647561ba7dbe6$export$5b070a55c0c43e09, params);
}
function $9c5cd6eef751ac06$export$4a21f16c33752377(params) {
    return $b93bb84d2922cb59$export$c3eb0e1c7c887e5c($8ad647561ba7dbe6$export$723d146f80596191, params);
}
function $9c5cd6eef751ac06$export$a0f65b52274bcc00(params) {
    return $b93bb84d2922cb59$export$8ff745acc355d077($8ad647561ba7dbe6$export$67d741fd70ff98f4, params);
}
function $9c5cd6eef751ac06$export$324d90190a8b822a(params) {
    return $b93bb84d2922cb59$export$2efeac445ea43f33($8ad647561ba7dbe6$export$e974be33bdc55521, params);
}



const $4cea6874d9fea58d$export$811cd59e56ff5546 = $8ad647561ba7dbe6$export$971dd5b0dfd021b6([
    $8ad647561ba7dbe6$export$22b082955e083ec3(),
    $8ad647561ba7dbe6$export$4c00f665f0d4b443((val)=>val !== null && typeof val === "object" && typeof val.toString === "function", "Expected object with toString()")
]);
const $4cea6874d9fea58d$export$b90e6cfc6f49ae2c = $8ad647561ba7dbe6$export$be5493f9613cbbe({
    id: $4cea6874d9fea58d$export$811cd59e56ff5546
});


const $ff2003bc1ca03230$export$f34525526d860353 = (0, $4cea6874d9fea58d$export$b90e6cfc6f49ae2c).extend({
    from: $9c5cd6eef751ac06$exports.date(),
    to: $9c5cd6eef751ac06$exports.date().optional(),
    hours: $8ad647561ba7dbe6$export$98e628dec113755e(),
    project: $8ad647561ba7dbe6$export$22b082955e083ec3(),
    task: $8ad647561ba7dbe6$export$22b082955e083ec3(),
    description: $8ad647561ba7dbe6$export$22b082955e083ec3().optional()
});
const $ff2003bc1ca03230$export$ff7c53142e86cb94 = $8ad647561ba7dbe6$export$2f23118c22fb2630($ff2003bc1ca03230$export$f34525526d860353);
const $ff2003bc1ca03230$export$5209ab621307cb87 = $ff2003bc1ca03230$export$f34525526d860353.omit({
    id: true,
    hours: true
});
const $ff2003bc1ca03230$export$34d0edd018abeb3d = $ff2003bc1ca03230$export$f34525526d860353.omit({
    id: true,
    hours: true
}).partial();



function $711b938d01d2606f$export$bc3bea8325045070(value, length, char = "0") {
    return value.toString().padStart(length, char);
}


function $40ab97940cbcc966$export$4e4cb19dd88cd821(date) {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${(0, $711b938d01d2606f$export$bc3bea8325045070)(month, 2)}-${(0, $711b938d01d2606f$export$bc3bea8325045070)(day, 2)}`;
}


const $56c35c168e39dea0$var$API_BASE_URL = "/api";
async function $56c35c168e39dea0$export$11856c07b6ee0df4(input) {
    const queryParams = `${"date" in input ? `date=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(input.date)}` : `from=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(input.from)}&to=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(input.to)}`}${input.project ? `&project=${encodeURIComponent(input.project)}` : ""}`;
    const response = await fetch(`${$56c35c168e39dea0$var$API_BASE_URL}/time?${queryParams}`);
    if (response.status === 401) throw (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED;
    else if (!response.ok) throw new Error("Failed to get times");
    return (0, $ff2003bc1ca03230$export$ff7c53142e86cb94).parse(await response.json());
}
async function $56c35c168e39dea0$export$1428f42a7de81803(id) {
    const response = await fetch(`${$56c35c168e39dea0$var$API_BASE_URL}/time/${id}`);
    if (response.status === 401) throw (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED;
    else if (!response.ok) throw new Error("Failed to get time");
    return (0, $ff2003bc1ca03230$export$f34525526d860353).parse(await response.json());
}
async function $56c35c168e39dea0$export$b9cfd76caec8e929(time) {
    const response = await fetch(`${$56c35c168e39dea0$var$API_BASE_URL}/time`, {
        method: "POST",
        body: JSON.stringify(time),
        headers: {
            "Content-Type": "application/json"
        }
    });
    if (response.status === 401) throw (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED;
    else if (!response.ok) throw new Error("Failed to create time");
    return (0, $ff2003bc1ca03230$export$f34525526d860353).parse(await response.json());
}
async function $56c35c168e39dea0$export$8a41ea59a31e0100(id, time) {
    const response = await fetch(`${$56c35c168e39dea0$var$API_BASE_URL}/time/${id}`, {
        method: "PATCH",
        body: JSON.stringify(time),
        headers: {
            "Content-Type": "application/json"
        }
    });
    if (response.status === 401) throw (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED;
    else if (!response.ok) throw new Error("Failed to update time");
    return (0, $ff2003bc1ca03230$export$f34525526d860353).parse(await response.json());
}
async function $56c35c168e39dea0$export$6d22acf1594fc61d(id) {
    const response = await fetch(`${$56c35c168e39dea0$var$API_BASE_URL}/time/${id}`, {
        method: "DELETE"
    });
    if (response.status === 401) throw (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED;
    else if (!response.ok) throw new Error("Failed to delete time");
}


const $f95462c870cb2158$export$81f28d8f5590a939 = (input, cacheKey)=>{
    const queryKey = [
        "get-times",
        ...cacheKey ? [
            cacheKey
        ] : "date" in input ? [
            input.date
        ] : [
            input.from,
            input.to
        ],
        ...input.project ? [
            input.project
        ] : []
    ];
    return (0, $0da705b248c5c0f3$export$dd0a697e1782aedd)({
        queryKey: queryKey,
        queryFn: ()=>(0, $56c35c168e39dea0$export$11856c07b6ee0df4)(input),
        staleTime: 3600000,
        retry: (_failureCount, error)=>error !== (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED
    });
};



/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ /*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $4161b97720ac8d78$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $4161b97720ac8d78$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $4161b97720ac8d78$export$bcc6e673dfa14d36(v) {
    return $4161b97720ac8d78$export$837ba5c449269406($4161b97720ac8d78$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $4161b97720ac8d78$export$869b26d4e1bbdb63(v) {
    return $4161b97720ac8d78$export$837ba5c449269406($4161b97720ac8d78$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $4161b97720ac8d78$export$ed9bd8dcaeba14f6(v) {
    return $4161b97720ac8d78$export$837ba5c449269406($4161b97720ac8d78$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $4161b97720ac8d78$export$dbf961a8d278dbef(v) {
    return $4161b97720ac8d78$export$837ba5c449269406($4161b97720ac8d78$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $4161b97720ac8d78$export$aa35ef1f24408ab9(v) {
    return $4161b97720ac8d78$export$837ba5c449269406($4161b97720ac8d78$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $4161b97720ac8d78$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $4161b97720ac8d78$var$hex = [
    ...'0123456789ABCDEF'
];
const $4161b97720ac8d78$var$h1 = (b)=>$4161b97720ac8d78$var$hex[b & 0xF];
const $4161b97720ac8d78$var$h2 = (b)=>$4161b97720ac8d78$var$hex[(b & 0xF0) >> 4] + $4161b97720ac8d78$var$hex[b & 0xF];
const $4161b97720ac8d78$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $4161b97720ac8d78$var$isShort = (v)=>$4161b97720ac8d78$var$eq(v.r) && $4161b97720ac8d78$var$eq(v.g) && $4161b97720ac8d78$var$eq(v.b) && $4161b97720ac8d78$var$eq(v.a);
function $4161b97720ac8d78$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $4161b97720ac8d78$var$map$1[str[1]] * 17,
            g: 255 & $4161b97720ac8d78$var$map$1[str[2]] * 17,
            b: 255 & $4161b97720ac8d78$var$map$1[str[3]] * 17,
            a: len === 5 ? $4161b97720ac8d78$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $4161b97720ac8d78$var$map$1[str[1]] << 4 | $4161b97720ac8d78$var$map$1[str[2]],
            g: $4161b97720ac8d78$var$map$1[str[3]] << 4 | $4161b97720ac8d78$var$map$1[str[4]],
            b: $4161b97720ac8d78$var$map$1[str[5]] << 4 | $4161b97720ac8d78$var$map$1[str[6]],
            a: len === 9 ? $4161b97720ac8d78$var$map$1[str[7]] << 4 | $4161b97720ac8d78$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $4161b97720ac8d78$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $4161b97720ac8d78$export$1b06654353ef9f67(v) {
    var f = $4161b97720ac8d78$var$isShort(v) ? $4161b97720ac8d78$var$h1 : $4161b97720ac8d78$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $4161b97720ac8d78$var$alpha(v.a, f) : undefined;
}
const $4161b97720ac8d78$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $4161b97720ac8d78$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $4161b97720ac8d78$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $4161b97720ac8d78$var$hwb2rgbn(h, w, b) {
    const rgb = $4161b97720ac8d78$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $4161b97720ac8d78$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $4161b97720ac8d78$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $4161b97720ac8d78$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $4161b97720ac8d78$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($4161b97720ac8d78$export$ed9bd8dcaeba14f6);
}
function $4161b97720ac8d78$export$4c15bd42559b811d(h, s, l) {
    return $4161b97720ac8d78$var$calln($4161b97720ac8d78$var$hsl2rgbn, h, s, l);
}
function $4161b97720ac8d78$export$e2710022c70fc9ee(h, w, b) {
    return $4161b97720ac8d78$var$calln($4161b97720ac8d78$var$hwb2rgbn, h, w, b);
}
function $4161b97720ac8d78$export$b785a357c84e4a04(h, s, v) {
    return $4161b97720ac8d78$var$calln($4161b97720ac8d78$var$hsv2rgbn, h, s, v);
}
function $4161b97720ac8d78$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $4161b97720ac8d78$export$5e91288c399be4f9(str) {
    const m = $4161b97720ac8d78$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $4161b97720ac8d78$export$bcc6e673dfa14d36(+m[5]) : $4161b97720ac8d78$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $4161b97720ac8d78$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $4161b97720ac8d78$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $4161b97720ac8d78$export$b785a357c84e4a04(h, p1, p2);
    else v = $4161b97720ac8d78$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $4161b97720ac8d78$export$bb628a54ab399bc9(v, deg) {
    var h = $4161b97720ac8d78$export$b5ba70b240f8f7f(v);
    h[0] = $4161b97720ac8d78$var$hue(h[0] + deg);
    h = $4161b97720ac8d78$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $4161b97720ac8d78$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $4161b97720ac8d78$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $4161b97720ac8d78$export$aa35ef1f24408ab9(a[1]);
    const l = $4161b97720ac8d78$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$4161b97720ac8d78$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $4161b97720ac8d78$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $4161b97720ac8d78$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $4161b97720ac8d78$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($4161b97720ac8d78$var$names$1);
    const tkeys = Object.keys($4161b97720ac8d78$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $4161b97720ac8d78$var$map[k]);
        }
        k = parseInt($4161b97720ac8d78$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $4161b97720ac8d78$var$names;
function $4161b97720ac8d78$export$b2f06b640faad956(str) {
    if (!$4161b97720ac8d78$var$names) {
        $4161b97720ac8d78$var$names = $4161b97720ac8d78$var$unpack();
        $4161b97720ac8d78$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $4161b97720ac8d78$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $4161b97720ac8d78$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $4161b97720ac8d78$export$91aedb20f296e541(str) {
    const m = $4161b97720ac8d78$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $4161b97720ac8d78$export$bcc6e673dfa14d36(v) : $4161b97720ac8d78$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $4161b97720ac8d78$export$bcc6e673dfa14d36(r) : $4161b97720ac8d78$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $4161b97720ac8d78$export$bcc6e673dfa14d36(g) : $4161b97720ac8d78$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $4161b97720ac8d78$export$bcc6e673dfa14d36(b) : $4161b97720ac8d78$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $4161b97720ac8d78$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$4161b97720ac8d78$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $4161b97720ac8d78$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $4161b97720ac8d78$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $4161b97720ac8d78$var$interpolate(rgb1, rgb2, t) {
    const r = $4161b97720ac8d78$var$from($4161b97720ac8d78$export$dbf961a8d278dbef(rgb1.r));
    const g = $4161b97720ac8d78$var$from($4161b97720ac8d78$export$dbf961a8d278dbef(rgb1.g));
    const b = $4161b97720ac8d78$var$from($4161b97720ac8d78$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $4161b97720ac8d78$export$ed9bd8dcaeba14f6($4161b97720ac8d78$var$to(r + t * ($4161b97720ac8d78$var$from($4161b97720ac8d78$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $4161b97720ac8d78$export$ed9bd8dcaeba14f6($4161b97720ac8d78$var$to(g + t * ($4161b97720ac8d78$var$from($4161b97720ac8d78$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $4161b97720ac8d78$export$ed9bd8dcaeba14f6($4161b97720ac8d78$var$to(b + t * ($4161b97720ac8d78$var$from($4161b97720ac8d78$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $4161b97720ac8d78$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $4161b97720ac8d78$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $4161b97720ac8d78$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $4161b97720ac8d78$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $4161b97720ac8d78$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $4161b97720ac8d78$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $4161b97720ac8d78$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $4161b97720ac8d78$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $4161b97720ac8d78$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $4161b97720ac8d78$export$91aedb20f296e541(str);
    return $4161b97720ac8d78$export$5e91288c399be4f9(str);
}
class $4161b97720ac8d78$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $4161b97720ac8d78$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $4161b97720ac8d78$var$fromObject(input);
        else if (type === 'string') v = $4161b97720ac8d78$export$625a38b961e8b5e9(input) || $4161b97720ac8d78$export$b2f06b640faad956(input) || $4161b97720ac8d78$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $4161b97720ac8d78$var$clone(this._rgb);
        if (v) v.a = $4161b97720ac8d78$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $4161b97720ac8d78$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $4161b97720ac8d78$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $4161b97720ac8d78$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $4161b97720ac8d78$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $4161b97720ac8d78$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $4161b97720ac8d78$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $4161b97720ac8d78$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $4161b97720ac8d78$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $4161b97720ac8d78$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $4161b97720ac8d78$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $4161b97720ac8d78$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $4161b97720ac8d78$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $4161b97720ac8d78$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $4161b97720ac8d78$export$2e2bcd8739ae039(input) {
    return new $4161b97720ac8d78$export$892596cec99bc70e(input);
}


/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $3abdb5770b94b18a$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $3abdb5770b94b18a$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $3abdb5770b94b18a$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $3abdb5770b94b18a$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $3abdb5770b94b18a$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $3abdb5770b94b18a$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $3abdb5770b94b18a$export$c4ce752e73470fba(value, defaultValue) {
    return $3abdb5770b94b18a$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $3abdb5770b94b18a$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $3abdb5770b94b18a$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $3abdb5770b94b18a$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $3abdb5770b94b18a$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $3abdb5770b94b18a$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($3abdb5770b94b18a$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($3abdb5770b94b18a$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $3abdb5770b94b18a$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $3abdb5770b94b18a$export$667d3bf0c5f83305(source) {
    if ($3abdb5770b94b18a$export$8b22cf2602fb60ce(source)) return source.map($3abdb5770b94b18a$export$667d3bf0c5f83305);
    if ($3abdb5770b94b18a$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $3abdb5770b94b18a$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $3abdb5770b94b18a$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $3abdb5770b94b18a$export$317a3d46287192d8(key, target, source, options) {
    if (!$3abdb5770b94b18a$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($3abdb5770b94b18a$export$23f2a1d2818174ef(tval) && $3abdb5770b94b18a$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $3abdb5770b94b18a$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $3abdb5770b94b18a$export$667d3bf0c5f83305(sval);
}
function $3abdb5770b94b18a$export$efca4cbe5dd06740(target, source, options) {
    const sources = $3abdb5770b94b18a$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$3abdb5770b94b18a$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $3abdb5770b94b18a$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$3abdb5770b94b18a$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $3abdb5770b94b18a$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $3abdb5770b94b18a$export$efca4cbe5dd06740(target, source, {
        merger: $3abdb5770b94b18a$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $3abdb5770b94b18a$export$1ee57be6f6687d2c(key, target, source) {
    if (!$3abdb5770b94b18a$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($3abdb5770b94b18a$export$23f2a1d2818174ef(tval) && $3abdb5770b94b18a$export$23f2a1d2818174ef(sval)) $3abdb5770b94b18a$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $3abdb5770b94b18a$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $3abdb5770b94b18a$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $3abdb5770b94b18a$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $3abdb5770b94b18a$var$_getKeyResolver(key) {
    const keys = $3abdb5770b94b18a$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $3abdb5770b94b18a$export$2d1720544b23b823(obj, key) {
    const resolver = $3abdb5770b94b18a$var$keyResolvers[key] || ($3abdb5770b94b18a$var$keyResolvers[key] = $3abdb5770b94b18a$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $3abdb5770b94b18a$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $3abdb5770b94b18a$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $3abdb5770b94b18a$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $3abdb5770b94b18a$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $3abdb5770b94b18a$export$56c0d5a1e737357d = Math.PI;
const $3abdb5770b94b18a$export$971d5caa766a69d7 = 2 * $3abdb5770b94b18a$export$56c0d5a1e737357d;
const $3abdb5770b94b18a$export$2ec5befb9e6c97d4 = $3abdb5770b94b18a$export$971d5caa766a69d7 + $3abdb5770b94b18a$export$56c0d5a1e737357d;
const $3abdb5770b94b18a$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $3abdb5770b94b18a$export$39c1cc7c062529d4 = $3abdb5770b94b18a$export$56c0d5a1e737357d / 180;
const $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd = $3abdb5770b94b18a$export$56c0d5a1e737357d / 2;
const $3abdb5770b94b18a$export$7a0bdf7d4a91ea88 = $3abdb5770b94b18a$export$56c0d5a1e737357d / 4;
const $3abdb5770b94b18a$export$c18d01048907ea92 = $3abdb5770b94b18a$export$56c0d5a1e737357d * 2 / 3;
const $3abdb5770b94b18a$export$faec65b429be379 = Math.log10;
const $3abdb5770b94b18a$export$2408f22a0fab9ae5 = Math.sign;
function $3abdb5770b94b18a$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $3abdb5770b94b18a$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $3abdb5770b94b18a$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($3abdb5770b94b18a$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $3abdb5770b94b18a$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $3abdb5770b94b18a$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $3abdb5770b94b18a$export$d141bba7fdc215a3(n) {
    return !$3abdb5770b94b18a$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $3abdb5770b94b18a$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $3abdb5770b94b18a$export$625550452a3fa3ec(degrees) {
    return degrees * ($3abdb5770b94b18a$export$56c0d5a1e737357d / 180);
}
function $3abdb5770b94b18a$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $3abdb5770b94b18a$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $3abdb5770b94b18a$export$91477dc880baac21(x) {
    if (!$3abdb5770b94b18a$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $3abdb5770b94b18a$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $3abdb5770b94b18a$export$56c0d5a1e737357d) angle += $3abdb5770b94b18a$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $3abdb5770b94b18a$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $3abdb5770b94b18a$export$f074adc9fbd50943(a, b) {
    return (a - b + $3abdb5770b94b18a$export$2ec5befb9e6c97d4) % $3abdb5770b94b18a$export$971d5caa766a69d7 - $3abdb5770b94b18a$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $3abdb5770b94b18a$export$ab83b03e4111b1d0(a) {
    return (a % $3abdb5770b94b18a$export$971d5caa766a69d7 + $3abdb5770b94b18a$export$971d5caa766a69d7) % $3abdb5770b94b18a$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $3abdb5770b94b18a$export$ab83b03e4111b1d0(angle);
    const s = $3abdb5770b94b18a$export$ab83b03e4111b1d0(start);
    const e = $3abdb5770b94b18a$export$ab83b03e4111b1d0(end);
    const angleToStart = $3abdb5770b94b18a$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $3abdb5770b94b18a$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $3abdb5770b94b18a$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $3abdb5770b94b18a$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $3abdb5770b94b18a$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $3abdb5770b94b18a$export$71cec2538cb2c617(value) {
    return $3abdb5770b94b18a$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $3abdb5770b94b18a$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $3abdb5770b94b18a$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $3abdb5770b94b18a$export$ef35774e6d314e91 = (table, key, value, last)=>$3abdb5770b94b18a$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $3abdb5770b94b18a$export$ebd11618f299a286 = (table, key, value)=>$3abdb5770b94b18a$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $3abdb5770b94b18a$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $3abdb5770b94b18a$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $3abdb5770b94b18a$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $3abdb5770b94b18a$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $3abdb5770b94b18a$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $3abdb5770b94b18a$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $3abdb5770b94b18a$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $3abdb5770b94b18a$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $3abdb5770b94b18a$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $3abdb5770b94b18a$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $3abdb5770b94b18a$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $3abdb5770b94b18a$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $3abdb5770b94b18a$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $3abdb5770b94b18a$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $3abdb5770b94b18a$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $3abdb5770b94b18a$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $3abdb5770b94b18a$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($3abdb5770b94b18a$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $3abdb5770b94b18a$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$3abdb5770b94b18a$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $3abdb5770b94b18a$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($3abdb5770b94b18a$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $3abdb5770b94b18a$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$3abdb5770b94b18a$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $3abdb5770b94b18a$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $3abdb5770b94b18a$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $3abdb5770b94b18a$var$atEdge = (t)=>t === 0 || t === 1;
const $3abdb5770b94b18a$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $3abdb5770b94b18a$export$971d5caa766a69d7 / p));
const $3abdb5770b94b18a$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $3abdb5770b94b18a$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $3abdb5770b94b18a$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($3abdb5770b94b18a$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$3abdb5770b94b18a$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$3abdb5770b94b18a$var$atEdge(t) ? t : $3abdb5770b94b18a$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$3abdb5770b94b18a$var$atEdge(t) ? t : $3abdb5770b94b18a$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $3abdb5770b94b18a$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $3abdb5770b94b18a$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $3abdb5770b94b18a$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $3abdb5770b94b18a$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $3abdb5770b94b18a$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $3abdb5770b94b18a$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $3abdb5770b94b18a$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $3abdb5770b94b18a$export$db3b6bfb95261072(value) {
    return $3abdb5770b94b18a$export$738ab4df8bf92ae9(value) ? value : new (0, $4161b97720ac8d78$export$892596cec99bc70e)(value);
}
function $3abdb5770b94b18a$export$d377dcb2b61d6c4e(value) {
    return $3abdb5770b94b18a$export$738ab4df8bf92ae9(value) ? value : new (0, $4161b97720ac8d78$export$892596cec99bc70e)(value).saturate(0.5).darken(0.1).hexString();
}
const $3abdb5770b94b18a$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $3abdb5770b94b18a$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $3abdb5770b94b18a$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $3abdb5770b94b18a$var$colors
        },
        numbers: {
            type: 'number',
            properties: $3abdb5770b94b18a$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $3abdb5770b94b18a$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $3abdb5770b94b18a$var$intlCache = new Map();
function $3abdb5770b94b18a$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $3abdb5770b94b18a$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $3abdb5770b94b18a$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $3abdb5770b94b18a$export$ae1af26003f05816(num, locale, options) {
    return $3abdb5770b94b18a$var$getNumberFormat(locale, options).format(num);
}
const $3abdb5770b94b18a$var$formatters = {
    values (value) {
        return $3abdb5770b94b18a$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $3abdb5770b94b18a$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $3abdb5770b94b18a$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $3abdb5770b94b18a$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($3abdb5770b94b18a$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $3abdb5770b94b18a$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $3abdb5770b94b18a$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $3abdb5770b94b18a$export$9f4f30ee63539e24 = {
    formatters: $3abdb5770b94b18a$var$formatters
};
function $3abdb5770b94b18a$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $3abdb5770b94b18a$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $3abdb5770b94b18a$export$6559d589eb85fbb6 = Object.create(null);
const $3abdb5770b94b18a$export$2e2af4578d910ddf = Object.create(null);
function $3abdb5770b94b18a$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $3abdb5770b94b18a$var$set(root, scope, values) {
    if (typeof scope === 'string') return $3abdb5770b94b18a$export$efca4cbe5dd06740($3abdb5770b94b18a$var$getScope$1(root, scope), values);
    return $3abdb5770b94b18a$export$efca4cbe5dd06740($3abdb5770b94b18a$var$getScope$1(root, ''), scope);
}
class $3abdb5770b94b18a$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$3abdb5770b94b18a$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$3abdb5770b94b18a$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$3abdb5770b94b18a$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $3abdb5770b94b18a$var$set(this, scope, values);
    }
    get(scope) {
        return $3abdb5770b94b18a$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $3abdb5770b94b18a$var$set($3abdb5770b94b18a$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $3abdb5770b94b18a$var$set($3abdb5770b94b18a$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $3abdb5770b94b18a$var$getScope$1(this, scope);
        const targetScopeObject = $3abdb5770b94b18a$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($3abdb5770b94b18a$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $3abdb5770b94b18a$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $3abdb5770b94b18a$export$4368d992c4eafac0 = /* #__PURE__ */ new $3abdb5770b94b18a$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $3abdb5770b94b18a$var$applyAnimationsDefaults,
    $3abdb5770b94b18a$var$applyLayoutsDefaults,
    $3abdb5770b94b18a$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $3abdb5770b94b18a$export$e171bab687b50e0(font) {
    if (!font || $3abdb5770b94b18a$export$342063e11d6c3cad(font.size) || $3abdb5770b94b18a$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $3abdb5770b94b18a$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$3abdb5770b94b18a$export$8b22cf2602fb60ce(thing)) longest = $3abdb5770b94b18a$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($3abdb5770b94b18a$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$3abdb5770b94b18a$export$8b22cf2602fb60ce(nestedThing)) longest = $3abdb5770b94b18a$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $3abdb5770b94b18a$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $3abdb5770b94b18a$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $3abdb5770b94b18a$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $3abdb5770b94b18a$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $3abdb5770b94b18a$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $3abdb5770b94b18a$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $3abdb5770b94b18a$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $3abdb5770b94b18a$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $3abdb5770b94b18a$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $3abdb5770b94b18a$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $3abdb5770b94b18a$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $3abdb5770b94b18a$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $3abdb5770b94b18a$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $3abdb5770b94b18a$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $3abdb5770b94b18a$export$56c0d5a1e737357d, rad - $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd, rad + $3abdb5770b94b18a$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $3abdb5770b94b18a$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $3abdb5770b94b18a$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $3abdb5770b94b18a$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $3abdb5770b94b18a$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $3abdb5770b94b18a$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $3abdb5770b94b18a$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $3abdb5770b94b18a$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$3abdb5770b94b18a$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $3abdb5770b94b18a$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $3abdb5770b94b18a$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $3abdb5770b94b18a$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $3abdb5770b94b18a$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $3abdb5770b94b18a$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $3abdb5770b94b18a$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$3abdb5770b94b18a$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $3abdb5770b94b18a$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $3abdb5770b94b18a$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $3abdb5770b94b18a$export$56c0d5a1e737357d, $3abdb5770b94b18a$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $3abdb5770b94b18a$export$56c0d5a1e737357d, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$3abdb5770b94b18a$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $3abdb5770b94b18a$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $3abdb5770b94b18a$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $3abdb5770b94b18a$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($3abdb5770b94b18a$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $3abdb5770b94b18a$var$numberOrZero = (v)=>+v || 0;
function $3abdb5770b94b18a$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $3abdb5770b94b18a$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $3abdb5770b94b18a$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$3abdb5770b94b18a$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $3abdb5770b94b18a$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $3abdb5770b94b18a$export$9fa96a7d116ea3ce(value) {
    return $3abdb5770b94b18a$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $3abdb5770b94b18a$export$28f7fcd39efa255(value) {
    return $3abdb5770b94b18a$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $3abdb5770b94b18a$export$a9c23c6ac3fc3eca(value) {
    const obj = $3abdb5770b94b18a$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $3abdb5770b94b18a$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $3abdb5770b94b18a$export$4368d992c4eafac0.font;
    let size = $3abdb5770b94b18a$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $3abdb5770b94b18a$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($3abdb5770b94b18a$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $3abdb5770b94b18a$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $3abdb5770b94b18a$export$d29e374196577086($3abdb5770b94b18a$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $3abdb5770b94b18a$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $3abdb5770b94b18a$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $3abdb5770b94b18a$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $3abdb5770b94b18a$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $3abdb5770b94b18a$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $3abdb5770b94b18a$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $3abdb5770b94b18a$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $3abdb5770b94b18a$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $3abdb5770b94b18a$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$3abdb5770b94b18a$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $3abdb5770b94b18a$var$_cached(target, prop, ()=>$3abdb5770b94b18a$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $3abdb5770b94b18a$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $3abdb5770b94b18a$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $3abdb5770b94b18a$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $3abdb5770b94b18a$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$3abdb5770b94b18a$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$3abdb5770b94b18a$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $3abdb5770b94b18a$var$_cached(target, prop, ()=>$3abdb5770b94b18a$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $3abdb5770b94b18a$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $3abdb5770b94b18a$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $3abdb5770b94b18a$var$readKey = (prefix, name)=>prefix ? prefix + $3abdb5770b94b18a$export$a8550f7dbe79f93a(name) : name;
const $3abdb5770b94b18a$var$needsSubResolver = (prop, value)=>$3abdb5770b94b18a$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $3abdb5770b94b18a$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $3abdb5770b94b18a$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($3abdb5770b94b18a$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $3abdb5770b94b18a$var$_resolveScriptable(prop, value, target, receiver);
    if ($3abdb5770b94b18a$export$8b22cf2602fb60ce(value) && value.length) value = $3abdb5770b94b18a$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($3abdb5770b94b18a$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $3abdb5770b94b18a$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $3abdb5770b94b18a$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($3abdb5770b94b18a$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $3abdb5770b94b18a$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $3abdb5770b94b18a$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($3abdb5770b94b18a$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $3abdb5770b94b18a$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($3abdb5770b94b18a$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $3abdb5770b94b18a$var$resolveFallback(fallback, prop, value) {
    return $3abdb5770b94b18a$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $3abdb5770b94b18a$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $3abdb5770b94b18a$export$2d1720544b23b823(parent, key) : undefined;
function $3abdb5770b94b18a$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $3abdb5770b94b18a$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $3abdb5770b94b18a$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $3abdb5770b94b18a$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $3abdb5770b94b18a$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $3abdb5770b94b18a$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $3abdb5770b94b18a$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $3abdb5770b94b18a$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$3abdb5770b94b18a$var$subGetTarget(resolver, prop, value));
}
function $3abdb5770b94b18a$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $3abdb5770b94b18a$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $3abdb5770b94b18a$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($3abdb5770b94b18a$export$8b22cf2602fb60ce(target) && $3abdb5770b94b18a$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $3abdb5770b94b18a$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $3abdb5770b94b18a$var$_resolve($3abdb5770b94b18a$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $3abdb5770b94b18a$var$needsSubResolver(prop, value) ? $3abdb5770b94b18a$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $3abdb5770b94b18a$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $3abdb5770b94b18a$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $3abdb5770b94b18a$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $3abdb5770b94b18a$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $3abdb5770b94b18a$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($3abdb5770b94b18a$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $3abdb5770b94b18a$var$EPSILON = Number.EPSILON || 1e-14;
const $3abdb5770b94b18a$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $3abdb5770b94b18a$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $3abdb5770b94b18a$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $3abdb5770b94b18a$export$cf2f7c5792f80b46(current, previous);
    const d12 = $3abdb5770b94b18a$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $3abdb5770b94b18a$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $3abdb5770b94b18a$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $3abdb5770b94b18a$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($3abdb5770b94b18a$export$23ebac1979863676(deltaK[i], 0, $3abdb5770b94b18a$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $3abdb5770b94b18a$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $3abdb5770b94b18a$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $3abdb5770b94b18a$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $3abdb5770b94b18a$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $3abdb5770b94b18a$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $3abdb5770b94b18a$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $3abdb5770b94b18a$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $3abdb5770b94b18a$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $3abdb5770b94b18a$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $3abdb5770b94b18a$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $3abdb5770b94b18a$var$monotoneAdjust(points, deltaK, mK);
    $3abdb5770b94b18a$var$monotoneCompute(points, mK, indexAxis);
}
function $3abdb5770b94b18a$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $3abdb5770b94b18a$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $3abdb5770b94b18a$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $3abdb5770b94b18a$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $3abdb5770b94b18a$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $3abdb5770b94b18a$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $3abdb5770b94b18a$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $3abdb5770b94b18a$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $3abdb5770b94b18a$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $3abdb5770b94b18a$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $3abdb5770b94b18a$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $3abdb5770b94b18a$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $3abdb5770b94b18a$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $3abdb5770b94b18a$export$fef3dfd9bad05307(el, property) {
    return $3abdb5770b94b18a$var$getComputedStyle(el).getPropertyValue(property);
}
const $3abdb5770b94b18a$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $3abdb5770b94b18a$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $3abdb5770b94b18a$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $3abdb5770b94b18a$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $3abdb5770b94b18a$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($3abdb5770b94b18a$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $3abdb5770b94b18a$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $3abdb5770b94b18a$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $3abdb5770b94b18a$var$getPositionedStyle(style, 'padding');
    const borders = $3abdb5770b94b18a$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $3abdb5770b94b18a$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $3abdb5770b94b18a$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $3abdb5770b94b18a$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $3abdb5770b94b18a$var$getComputedStyle(container);
            const containerBorder = $3abdb5770b94b18a$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $3abdb5770b94b18a$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $3abdb5770b94b18a$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $3abdb5770b94b18a$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $3abdb5770b94b18a$export$53c86fa97d611818,
        maxHeight: maxHeight || $3abdb5770b94b18a$export$53c86fa97d611818
    };
}
const $3abdb5770b94b18a$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $3abdb5770b94b18a$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $3abdb5770b94b18a$var$getComputedStyle(canvas);
    const margins = $3abdb5770b94b18a$var$getPositionedStyle(style, 'margin');
    const maxWidth = $3abdb5770b94b18a$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $3abdb5770b94b18a$export$53c86fa97d611818;
    const maxHeight = $3abdb5770b94b18a$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $3abdb5770b94b18a$export$53c86fa97d611818;
    const containerSize = $3abdb5770b94b18a$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $3abdb5770b94b18a$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $3abdb5770b94b18a$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $3abdb5770b94b18a$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $3abdb5770b94b18a$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $3abdb5770b94b18a$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $3abdb5770b94b18a$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $3abdb5770b94b18a$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = $3abdb5770b94b18a$var$round1(chart.height * pixelRatio);
    const deviceWidth = $3abdb5770b94b18a$var$round1(chart.width * pixelRatio);
    chart.height = $3abdb5770b94b18a$var$round1(chart.height);
    chart.width = $3abdb5770b94b18a$var$round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $3abdb5770b94b18a$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($3abdb5770b94b18a$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $3abdb5770b94b18a$export$b4171a6734a65d42(element, property) {
    const value = $3abdb5770b94b18a$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $3abdb5770b94b18a$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $3abdb5770b94b18a$export$6554612db691658e(p1, cp1, t);
    const b = $3abdb5770b94b18a$export$6554612db691658e(cp1, cp2, t);
    const c = $3abdb5770b94b18a$export$6554612db691658e(cp2, p2, t);
    const d = $3abdb5770b94b18a$export$6554612db691658e(a, b, t);
    const e = $3abdb5770b94b18a$export$6554612db691658e(b, c, t);
    return $3abdb5770b94b18a$export$6554612db691658e(d, e, t);
}
const $3abdb5770b94b18a$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $3abdb5770b94b18a$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $3abdb5770b94b18a$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $3abdb5770b94b18a$var$getRightToLeftAdapter(rectX, width) : $3abdb5770b94b18a$var$getLeftToRightAdapter();
}
function $3abdb5770b94b18a$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $3abdb5770b94b18a$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $3abdb5770b94b18a$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $3abdb5770b94b18a$export$ffb5f4729a158638,
        compare: $3abdb5770b94b18a$export$f074adc9fbd50943,
        normalize: $3abdb5770b94b18a$export$ab83b03e4111b1d0
    };
    return {
        between: $3abdb5770b94b18a$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $3abdb5770b94b18a$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $3abdb5770b94b18a$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $3abdb5770b94b18a$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $3abdb5770b94b18a$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $3abdb5770b94b18a$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $3abdb5770b94b18a$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($3abdb5770b94b18a$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($3abdb5770b94b18a$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $3abdb5770b94b18a$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $3abdb5770b94b18a$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $3abdb5770b94b18a$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $3abdb5770b94b18a$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $3abdb5770b94b18a$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $3abdb5770b94b18a$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $3abdb5770b94b18a$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $3abdb5770b94b18a$var$splitByStyles(line, $3abdb5770b94b18a$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $3abdb5770b94b18a$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $3abdb5770b94b18a$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $3abdb5770b94b18a$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $3abdb5770b94b18a$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $3abdb5770b94b18a$var$readStyle(segmentOptions.setContext($3abdb5770b94b18a$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($3abdb5770b94b18a$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $3abdb5770b94b18a$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $3abdb5770b94b18a$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$3abdb5770b94b18a$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $3abdb5770b94b18a$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $3abdb5770b94b18a$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $3abdb5770b94b18a$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $3abdb5770b94b18a$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $3abdb5770b94b18a$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $3abdb5770b94b18a$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $3abdb5770b94b18a$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $3abdb5770b94b18a$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}



class $8cf3bd7ac14d1f7c$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $3abdb5770b94b18a$export$43caf9889c228507).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $8cf3bd7ac14d1f7c$export$a424a0aa8f687495 = /* #__PURE__ */ new $8cf3bd7ac14d1f7c$var$Animator();
const $8cf3bd7ac14d1f7c$var$transparent = 'transparent';
const $8cf3bd7ac14d1f7c$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $3abdb5770b94b18a$export$db3b6bfb95261072)(from || $8cf3bd7ac14d1f7c$var$transparent);
        const c1 = c0.valid && (0, $3abdb5770b94b18a$export$db3b6bfb95261072)(to || $8cf3bd7ac14d1f7c$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $8cf3bd7ac14d1f7c$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $3abdb5770b94b18a$export$407448d2b89b1813)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $3abdb5770b94b18a$export$407448d2b89b1813)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $8cf3bd7ac14d1f7c$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $3abdb5770b94b18a$export$f1e1789686576879)[cfg.easing] || (0, $3abdb5770b94b18a$export$f1e1789686576879).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $3abdb5770b94b18a$export$407448d2b89b1813)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $3abdb5770b94b18a$export$407448d2b89b1813)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $8cf3bd7ac14d1f7c$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(config)) return;
        const animationOptions = Object.keys((0, $3abdb5770b94b18a$export$4368d992c4eafac0).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $8cf3bd7ac14d1f7c$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $8cf3bd7ac14d1f7c$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $8cf3bd7ac14d1f7c$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $8cf3bd7ac14d1f7c$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $8cf3bd7ac14d1f7c$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $8cf3bd7ac14d1f7c$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $8cf3bd7ac14d1f7c$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $8cf3bd7ac14d1f7c$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $8cf3bd7ac14d1f7c$var$scaleClip(xScale, allowedOverflow);
    const y = $8cf3bd7ac14d1f7c$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $8cf3bd7ac14d1f7c$var$toClip(value) {
    let t, r, b, l;
    if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $8cf3bd7ac14d1f7c$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $8cf3bd7ac14d1f7c$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $3abdb5770b94b18a$export$39b482c5e57630a8)(otherValue) && (singleMode || value === 0 || (0, $3abdb5770b94b18a$export$2408f22a0fab9ae5)(value) === (0, $3abdb5770b94b18a$export$2408f22a0fab9ae5)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $8cf3bd7ac14d1f7c$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $8cf3bd7ac14d1f7c$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $8cf3bd7ac14d1f7c$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $8cf3bd7ac14d1f7c$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $8cf3bd7ac14d1f7c$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $8cf3bd7ac14d1f7c$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $8cf3bd7ac14d1f7c$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $8cf3bd7ac14d1f7c$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $8cf3bd7ac14d1f7c$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $8cf3bd7ac14d1f7c$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $8cf3bd7ac14d1f7c$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $8cf3bd7ac14d1f7c$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $8cf3bd7ac14d1f7c$var$createDatasetContext(parent, index) {
    return (0, $3abdb5770b94b18a$export$35e795649ee09318)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $8cf3bd7ac14d1f7c$var$createDataContext(parent, index, element) {
    return (0, $3abdb5770b94b18a$export$35e795649ee09318)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $8cf3bd7ac14d1f7c$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $8cf3bd7ac14d1f7c$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $8cf3bd7ac14d1f7c$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $8cf3bd7ac14d1f7c$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $8cf3bd7ac14d1f7c$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $8cf3bd7ac14d1f7c$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $8cf3bd7ac14d1f7c$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $8cf3bd7ac14d1f7c$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(dataset.xAxisID, $8cf3bd7ac14d1f7c$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(dataset.yAxisID, $8cf3bd7ac14d1f7c$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(dataset.rAxisID, $8cf3bd7ac14d1f7c$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $3abdb5770b94b18a$export$3b14a55fb2447963)(this._data, this);
        if (meta._stacked) $8cf3bd7ac14d1f7c$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(data)) {
            const meta = this._cachedMeta;
            this._data = $8cf3bd7ac14d1f7c$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $3abdb5770b94b18a$export$3b14a55fb2447963)(_data, this);
                const meta = this._cachedMeta;
                $8cf3bd7ac14d1f7c$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $3abdb5770b94b18a$export$882b5998b3b9117c)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $8cf3bd7ac14d1f7c$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $8cf3bd7ac14d1f7c$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $8cf3bd7ac14d1f7c$var$updateStacks(this, meta._parsed);
            meta._stacked = $8cf3bd7ac14d1f7c$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $8cf3bd7ac14d1f7c$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $3abdb5770b94b18a$export$2d1720544b23b823)(item, xAxisKey), index),
                y: yScale.parse((0, $3abdb5770b94b18a$export$2d1720544b23b823)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $8cf3bd7ac14d1f7c$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $8cf3bd7ac14d1f7c$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $8cf3bd7ac14d1f7c$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $8cf3bd7ac14d1f7c$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $8cf3bd7ac14d1f7c$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $3abdb5770b94b18a$export$39b482c5e57630a8)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $3abdb5770b94b18a$export$39b482c5e57630a8)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $8cf3bd7ac14d1f7c$var$toClip((0, $3abdb5770b94b18a$export$90a7f3efeed30595)(this.options.clip, $8cf3bd7ac14d1f7c$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $8cf3bd7ac14d1f7c$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $8cf3bd7ac14d1f7c$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $3abdb5770b94b18a$export$dda1d9f60106f0e9)(index);
        if (cached) return $8cf3bd7ac14d1f7c$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $3abdb5770b94b18a$export$4368d992c4eafac0).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($8cf3bd7ac14d1f7c$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $8cf3bd7ac14d1f7c$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $8cf3bd7ac14d1f7c$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($8cf3bd7ac14d1f7c$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$8cf3bd7ac14d1f7c$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $8cf3bd7ac14d1f7c$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $8cf3bd7ac14d1f7c$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $3abdb5770b94b18a$export$71511d61b312f219)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $8cf3bd7ac14d1f7c$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $8cf3bd7ac14d1f7c$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $3abdb5770b94b18a$export$dda1d9f60106f0e9)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $8cf3bd7ac14d1f7c$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $8cf3bd7ac14d1f7c$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $8cf3bd7ac14d1f7c$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $8cf3bd7ac14d1f7c$var$parseValue(entry, item, vScale, i) {
    if ((0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(entry)) $8cf3bd7ac14d1f7c$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $8cf3bd7ac14d1f7c$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($8cf3bd7ac14d1f7c$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $8cf3bd7ac14d1f7c$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $8cf3bd7ac14d1f7c$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $3abdb5770b94b18a$export$2408f22a0fab9ae5)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $8cf3bd7ac14d1f7c$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $8cf3bd7ac14d1f7c$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $8cf3bd7ac14d1f7c$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$8cf3bd7ac14d1f7c$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$8cf3bd7ac14d1f7c$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $8cf3bd7ac14d1f7c$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $8cf3bd7ac14d1f7c$var$swap(edge, a, b);
        edge = $8cf3bd7ac14d1f7c$var$startEnd(edge, b, a);
    } else edge = $8cf3bd7ac14d1f7c$var$startEnd(edge, a, b);
    return edge;
}
function $8cf3bd7ac14d1f7c$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $8cf3bd7ac14d1f7c$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $8cf3bd7ac14d1f7c$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $8cf3bd7ac14d1f7c$export$e97d5dc64e999004 extends $8cf3bd7ac14d1f7c$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $8cf3bd7ac14d1f7c$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $8cf3bd7ac14d1f7c$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $3abdb5770b94b18a$export$2d1720544b23b823)(obj, iAxisKey), i);
            parsed.push($8cf3bd7ac14d1f7c$var$parseValue((0, $3abdb5770b94b18a$export$2d1720544b23b823)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $8cf3bd7ac14d1f7c$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $3abdb5770b94b18a$export$342063e11d6c3cad)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $8cf3bd7ac14d1f7c$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $8cf3bd7ac14d1f7c$var$setBorderSkipped(properties, options, stack, index);
            $8cf3bd7ac14d1f7c$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $3abdb5770b94b18a$export$90a7f3efeed30595)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $8cf3bd7ac14d1f7c$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $8cf3bd7ac14d1f7c$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $3abdb5770b94b18a$export$2408f22a0fab9ae5)(value) !== (0, $3abdb5770b94b18a$export$2408f22a0fab9ae5)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $8cf3bd7ac14d1f7c$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $3abdb5770b94b18a$export$2408f22a0fab9ae5)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $8cf3bd7ac14d1f7c$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $8cf3bd7ac14d1f7c$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $3abdb5770b94b18a$export$90a7f3efeed30595)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $8cf3bd7ac14d1f7c$export$19b5c4773f17abe extends $8cf3bd7ac14d1f7c$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(parsed && parsed._custom, radius);
        return values;
    }
}
function $8cf3bd7ac14d1f7c$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $3abdb5770b94b18a$export$971d5caa766a69d7)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $3abdb5770b94b18a$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $3abdb5770b94b18a$export$ffb5f4729a158638)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd), startY, endY);
        const minX = calcMin((0, $3abdb5770b94b18a$export$56c0d5a1e737357d), startX, endX);
        const minY = calcMin((0, $3abdb5770b94b18a$export$56c0d5a1e737357d) + (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $8cf3bd7ac14d1f7c$export$e04603e7d8b77172 extends $8cf3bd7ac14d1f7c$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        const { labels: { pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                        if (data.labels.length && data.datasets.length) return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                fontColor: color,
                                hidden: !chart.getDataVisibility(i),
                                lineDash: style.borderDash,
                                lineDashOffset: style.borderDashOffset,
                                lineJoin: style.borderJoinStyle,
                                lineWidth: style.borderWidth,
                                strokeStyle: style.borderColor,
                                textAlign: textAlign,
                                pointStyle: pointStyle,
                                borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                                index: i
                            };
                        });
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $3abdb5770b94b18a$export$2d1720544b23b823)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $3abdb5770b94b18a$export$971d5caa766a69d7);
        let max = -(0, $3abdb5770b94b18a$export$971d5caa766a69d7);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $3abdb5770b94b18a$export$953cecd6e717a553)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $8cf3bd7ac14d1f7c$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $3abdb5770b94b18a$export$7ccc53e8f1e7dfc5)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $3abdb5770b94b18a$export$971d5caa766a69d7));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $3abdb5770b94b18a$export$971d5caa766a69d7) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $3abdb5770b94b18a$export$ae1af26003f05816)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $3abdb5770b94b18a$export$90a7f3efeed30595)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $8cf3bd7ac14d1f7c$export$3c9b5d28c11cbfd0 extends $8cf3bd7ac14d1f7c$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $3abdb5770b94b18a$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $3abdb5770b94b18a$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $3abdb5770b94b18a$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $3abdb5770b94b18a$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $8cf3bd7ac14d1f7c$export$2a270b3a0d973c85 extends $8cf3bd7ac14d1f7c$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $3abdb5770b94b18a$export$ae1af26003f05816)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $3abdb5770b94b18a$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $3abdb5770b94b18a$export$56c0d5a1e737357d);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $8cf3bd7ac14d1f7c$export$b21a3f1286706191 extends $8cf3bd7ac14d1f7c$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $8cf3bd7ac14d1f7c$export$48dbc6ac651bf8be extends $8cf3bd7ac14d1f7c$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $3abdb5770b94b18a$export$4a5767248b18ef41).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $8cf3bd7ac14d1f7c$export$b2f2bae6713db87 extends $8cf3bd7ac14d1f7c$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $3abdb5770b94b18a$export$9e5f44173e64f162)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $3abdb5770b94b18a$export$efccba1c4a2ef57b)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $3abdb5770b94b18a$export$d141bba7fdc215a3)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $3abdb5770b94b18a$export$342063e11d6c3cad)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $8cf3bd7ac14d1f7c$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $8cf3bd7ac14d1f7c$export$e97d5dc64e999004,
    BubbleController: $8cf3bd7ac14d1f7c$export$19b5c4773f17abe,
    DoughnutController: $8cf3bd7ac14d1f7c$export$e04603e7d8b77172,
    LineController: $8cf3bd7ac14d1f7c$export$3c9b5d28c11cbfd0,
    PieController: $8cf3bd7ac14d1f7c$export$b21a3f1286706191,
    PolarAreaController: $8cf3bd7ac14d1f7c$export$2a270b3a0d973c85,
    RadarController: $8cf3bd7ac14d1f7c$export$48dbc6ac651bf8be,
    ScatterController: $8cf3bd7ac14d1f7c$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $8cf3bd7ac14d1f7c$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $8cf3bd7ac14d1f7c$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($8cf3bd7ac14d1f7c$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $8cf3bd7ac14d1f7c$var$abstract();
    }
    parse() {
        return $8cf3bd7ac14d1f7c$var$abstract();
    }
    format() {
        return $8cf3bd7ac14d1f7c$var$abstract();
    }
    add() {
        return $8cf3bd7ac14d1f7c$var$abstract();
    }
    diff() {
        return $8cf3bd7ac14d1f7c$var$abstract();
    }
    startOf() {
        return $8cf3bd7ac14d1f7c$var$abstract();
    }
    endOf() {
        return $8cf3bd7ac14d1f7c$var$abstract();
    }
}
var $8cf3bd7ac14d1f7c$export$f32766ea09ec8bc4 = {
    _date: $8cf3bd7ac14d1f7c$var$DateAdapterBase
};
function $8cf3bd7ac14d1f7c$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $3abdb5770b94b18a$export$ebd11618f299a286) : (0, $3abdb5770b94b18a$export$ef35774e6d314e91);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $8cf3bd7ac14d1f7c$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $8cf3bd7ac14d1f7c$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $8cf3bd7ac14d1f7c$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $8cf3bd7ac14d1f7c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $3abdb5770b94b18a$export$e7094788287c5e9b)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $8cf3bd7ac14d1f7c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $8cf3bd7ac14d1f7c$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $3abdb5770b94b18a$export$96f57966bedc81b4)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $3abdb5770b94b18a$export$ffb5f4729a158638)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $8cf3bd7ac14d1f7c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $8cf3bd7ac14d1f7c$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $8cf3bd7ac14d1f7c$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $8cf3bd7ac14d1f7c$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $8cf3bd7ac14d1f7c$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $8cf3bd7ac14d1f7c$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $8cf3bd7ac14d1f7c$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $8cf3bd7ac14d1f7c$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $8cf3bd7ac14d1f7c$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $8cf3bd7ac14d1f7c$export$a13296960cae0384 = {
    evaluateInteractionItems: $8cf3bd7ac14d1f7c$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $3abdb5770b94b18a$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $8cf3bd7ac14d1f7c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $8cf3bd7ac14d1f7c$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $3abdb5770b94b18a$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $8cf3bd7ac14d1f7c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $8cf3bd7ac14d1f7c$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $3abdb5770b94b18a$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $8cf3bd7ac14d1f7c$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $3abdb5770b94b18a$export$df995fae86a55f06)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $8cf3bd7ac14d1f7c$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $3abdb5770b94b18a$export$df995fae86a55f06)(e, chart);
            return $8cf3bd7ac14d1f7c$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $3abdb5770b94b18a$export$df995fae86a55f06)(e, chart);
            return $8cf3bd7ac14d1f7c$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $8cf3bd7ac14d1f7c$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $8cf3bd7ac14d1f7c$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $8cf3bd7ac14d1f7c$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$8cf3bd7ac14d1f7c$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $8cf3bd7ac14d1f7c$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $8cf3bd7ac14d1f7c$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $8cf3bd7ac14d1f7c$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$8cf3bd7ac14d1f7c$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $8cf3bd7ac14d1f7c$var$setLayoutDims(layouts, params) {
    const stacks = $8cf3bd7ac14d1f7c$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $8cf3bd7ac14d1f7c$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $8cf3bd7ac14d1f7c$var$wrapBoxes(boxes);
    const fullSize = $8cf3bd7ac14d1f7c$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $8cf3bd7ac14d1f7c$var$sortByWeight($8cf3bd7ac14d1f7c$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $8cf3bd7ac14d1f7c$var$sortByWeight($8cf3bd7ac14d1f7c$var$filterByPosition(layoutBoxes, 'right'));
    const top = $8cf3bd7ac14d1f7c$var$sortByWeight($8cf3bd7ac14d1f7c$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $8cf3bd7ac14d1f7c$var$sortByWeight($8cf3bd7ac14d1f7c$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $8cf3bd7ac14d1f7c$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $8cf3bd7ac14d1f7c$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $8cf3bd7ac14d1f7c$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $8cf3bd7ac14d1f7c$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $8cf3bd7ac14d1f7c$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $8cf3bd7ac14d1f7c$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $8cf3bd7ac14d1f7c$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $8cf3bd7ac14d1f7c$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $8cf3bd7ac14d1f7c$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $8cf3bd7ac14d1f7c$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $8cf3bd7ac14d1f7c$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $8cf3bd7ac14d1f7c$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $8cf3bd7ac14d1f7c$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $8cf3bd7ac14d1f7c$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $8cf3bd7ac14d1f7c$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $8cf3bd7ac14d1f7c$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $8cf3bd7ac14d1f7c$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $3abdb5770b94b18a$export$dda1d9f60106f0e9)(stack.start)) y = stack.start;
            if (box.fullSize) $8cf3bd7ac14d1f7c$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $8cf3bd7ac14d1f7c$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $3abdb5770b94b18a$export$dda1d9f60106f0e9)(stack.start)) x = stack.start;
            if (box.fullSize) $8cf3bd7ac14d1f7c$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $8cf3bd7ac14d1f7c$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $8cf3bd7ac14d1f7c$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $3abdb5770b94b18a$export$d66501df72047452)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $8cf3bd7ac14d1f7c$var$updateMaxPadding(maxPadding, (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $8cf3bd7ac14d1f7c$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $8cf3bd7ac14d1f7c$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $8cf3bd7ac14d1f7c$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($8cf3bd7ac14d1f7c$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $8cf3bd7ac14d1f7c$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $8cf3bd7ac14d1f7c$var$handleMaxPadding(chartArea);
        $8cf3bd7ac14d1f7c$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $8cf3bd7ac14d1f7c$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $3abdb5770b94b18a$export$d66501df72047452)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $8cf3bd7ac14d1f7c$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $8cf3bd7ac14d1f7c$export$a40a96b24b46cf35 extends $8cf3bd7ac14d1f7c$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $8cf3bd7ac14d1f7c$var$EXPANDO_KEY = '$chartjs';
const $8cf3bd7ac14d1f7c$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $8cf3bd7ac14d1f7c$var$isNullOrEmpty = (value)=>value === null || value === '';
function $8cf3bd7ac14d1f7c$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$8cf3bd7ac14d1f7c$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($8cf3bd7ac14d1f7c$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $3abdb5770b94b18a$export$b4171a6734a65d42)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($8cf3bd7ac14d1f7c$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $3abdb5770b94b18a$export$b4171a6734a65d42)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $8cf3bd7ac14d1f7c$var$eventListenerOptions = (0, $3abdb5770b94b18a$export$3466f893ebf79586) ? {
    passive: true
} : false;
function $8cf3bd7ac14d1f7c$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $8cf3bd7ac14d1f7c$var$eventListenerOptions);
}
function $8cf3bd7ac14d1f7c$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $8cf3bd7ac14d1f7c$var$eventListenerOptions);
}
function $8cf3bd7ac14d1f7c$var$fromNativeEvent(event, chart) {
    const type = $8cf3bd7ac14d1f7c$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $3abdb5770b94b18a$export$df995fae86a55f06)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $8cf3bd7ac14d1f7c$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $8cf3bd7ac14d1f7c$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $8cf3bd7ac14d1f7c$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$8cf3bd7ac14d1f7c$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $8cf3bd7ac14d1f7c$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $8cf3bd7ac14d1f7c$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$8cf3bd7ac14d1f7c$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $8cf3bd7ac14d1f7c$var$drpListeningCharts = new Map();
let $8cf3bd7ac14d1f7c$var$oldDevicePixelRatio = 0;
function $8cf3bd7ac14d1f7c$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $8cf3bd7ac14d1f7c$var$oldDevicePixelRatio) return;
    $8cf3bd7ac14d1f7c$var$oldDevicePixelRatio = dpr;
    $8cf3bd7ac14d1f7c$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $8cf3bd7ac14d1f7c$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$8cf3bd7ac14d1f7c$var$drpListeningCharts.size) window.addEventListener('resize', $8cf3bd7ac14d1f7c$var$onWindowResize);
    $8cf3bd7ac14d1f7c$var$drpListeningCharts.set(chart, resize);
}
function $8cf3bd7ac14d1f7c$var$unlistenDevicePixelRatioChanges(chart) {
    $8cf3bd7ac14d1f7c$var$drpListeningCharts.delete(chart);
    if (!$8cf3bd7ac14d1f7c$var$drpListeningCharts.size) window.removeEventListener('resize', $8cf3bd7ac14d1f7c$var$onWindowResize);
}
function $8cf3bd7ac14d1f7c$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $3abdb5770b94b18a$export$9bb611d729802a56)(canvas);
    if (!container) return;
    const resize = (0, $3abdb5770b94b18a$export$61196ced6d74a310)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $8cf3bd7ac14d1f7c$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $8cf3bd7ac14d1f7c$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $8cf3bd7ac14d1f7c$var$unlistenDevicePixelRatioChanges(chart);
}
function $8cf3bd7ac14d1f7c$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $3abdb5770b94b18a$export$61196ced6d74a310)((event)=>{
        if (chart.ctx !== null) listener($8cf3bd7ac14d1f7c$var$fromNativeEvent(event, chart));
    }, chart);
    $8cf3bd7ac14d1f7c$var$addListener(canvas, type, proxy);
    return proxy;
}
class $8cf3bd7ac14d1f7c$export$f02da7f882cf6b2e extends $8cf3bd7ac14d1f7c$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $8cf3bd7ac14d1f7c$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$8cf3bd7ac14d1f7c$var$EXPANDO_KEY]) return false;
        const initial = canvas[$8cf3bd7ac14d1f7c$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$8cf3bd7ac14d1f7c$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $8cf3bd7ac14d1f7c$var$createAttachObserver,
            detach: $8cf3bd7ac14d1f7c$var$createDetachObserver,
            resize: $8cf3bd7ac14d1f7c$var$createResizeObserver
        };
        const handler = handlers[type] || $8cf3bd7ac14d1f7c$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $8cf3bd7ac14d1f7c$var$releaseObserver,
            detach: $8cf3bd7ac14d1f7c$var$releaseObserver,
            resize: $8cf3bd7ac14d1f7c$var$releaseObserver
        };
        const handler = handlers[type] || $8cf3bd7ac14d1f7c$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $3abdb5770b94b18a$export$2329c99376c9d0a4)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $3abdb5770b94b18a$export$9bb611d729802a56)(canvas);
        return !!(container && container.isConnected);
    }
}
function $8cf3bd7ac14d1f7c$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $3abdb5770b94b18a$export$3a1a48c8f6ef640e)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $8cf3bd7ac14d1f7c$export$a40a96b24b46cf35;
    return $8cf3bd7ac14d1f7c$export$f02da7f882cf6b2e;
}
class $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $3abdb5770b94b18a$export$d141bba7fdc215a3)(this.x) && (0, $3abdb5770b94b18a$export$d141bba7fdc215a3)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $8cf3bd7ac14d1f7c$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $8cf3bd7ac14d1f7c$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $8cf3bd7ac14d1f7c$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $8cf3bd7ac14d1f7c$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $8cf3bd7ac14d1f7c$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $8cf3bd7ac14d1f7c$var$skip(ticks, newTicks, spacing, (0, $3abdb5770b94b18a$export$342063e11d6c3cad)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$8cf3bd7ac14d1f7c$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $8cf3bd7ac14d1f7c$var$skip(ticks, newTicks, spacing, last, (0, $3abdb5770b94b18a$export$342063e11d6c3cad)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $8cf3bd7ac14d1f7c$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $8cf3bd7ac14d1f7c$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $8cf3bd7ac14d1f7c$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $8cf3bd7ac14d1f7c$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $3abdb5770b94b18a$export$a07804094c3ecf2d)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $8cf3bd7ac14d1f7c$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $8cf3bd7ac14d1f7c$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $8cf3bd7ac14d1f7c$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(majorStart, 0);
    const end = Math.min((0, $3abdb5770b94b18a$export$90a7f3efeed30595)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $8cf3bd7ac14d1f7c$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $8cf3bd7ac14d1f7c$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $8cf3bd7ac14d1f7c$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $8cf3bd7ac14d1f7c$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $8cf3bd7ac14d1f7c$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $8cf3bd7ac14d1f7c$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $8cf3bd7ac14d1f7c$var$garbageCollect(caches, length) {
    (0, $3abdb5770b94b18a$export$d66501df72047452)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $8cf3bd7ac14d1f7c$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $8cf3bd7ac14d1f7c$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $3abdb5770b94b18a$export$34aec0b863436764)(options.font, fallback);
    const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(options.padding);
    const lines = (0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $8cf3bd7ac14d1f7c$var$createScaleContext(parent, scale) {
    return (0, $3abdb5770b94b18a$export$35e795649ee09318)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $8cf3bd7ac14d1f7c$var$createTickContext(parent, index, tick) {
    return (0, $3abdb5770b94b18a$export$35e795649ee09318)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $8cf3bd7ac14d1f7c$var$titleAlign(align, position, reverse) {
    let ret = (0, $3abdb5770b94b18a$export$3c2fa207a37baaea)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $8cf3bd7ac14d1f7c$var$reverseAlign(ret);
    return ret;
}
function $8cf3bd7ac14d1f7c$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, left, right);
        if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $8cf3bd7ac14d1f7c$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $8cf3bd7ac14d1f7c$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, bottom, top);
        rotation = position === 'left' ? -(0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd) : (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $8cf3bd7ac14d1f7c$export$d60cfc58d3c358b6 extends $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(_userMin, _suggestedMin),
            max: (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(_userMax, _suggestedMax),
            minDefined: (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(_userMin),
            maxDefined: (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(min, (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(max, min)),
            max: (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(max, (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $3abdb5770b94b18a$export$db202ddc8be9136)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $8cf3bd7ac14d1f7c$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $8cf3bd7ac14d1f7c$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $8cf3bd7ac14d1f7c$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $8cf3bd7ac14d1f7c$var$getTickMarkLength(options.grid) - tickOpts.padding - $8cf3bd7ac14d1f7c$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $3abdb5770b94b18a$export$3a6d5c9ae78a2c08)(Math.min(Math.asin((0, $3abdb5770b94b18a$export$25ce5a424b770e84)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $3abdb5770b94b18a$export$25ce5a424b770e84)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $3abdb5770b94b18a$export$25ce5a424b770e84)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $8cf3bd7ac14d1f7c$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $8cf3bd7ac14d1f7c$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $8cf3bd7ac14d1f7c$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $8cf3bd7ac14d1f7c$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $8cf3bd7ac14d1f7c$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(label) && !(0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(label)) {
                width = (0, $3abdb5770b94b18a$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(nestedLabel) && !(0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(nestedLabel)) {
                    width = (0, $3abdb5770b94b18a$export$e7c866399fa523f5)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $8cf3bd7ac14d1f7c$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $3abdb5770b94b18a$export$71cec2538cb2c617)(this._alignToPixels ? (0, $3abdb5770b94b18a$export$78acf4525d8a74c4)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $8cf3bd7ac14d1f7c$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $8cf3bd7ac14d1f7c$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $8cf3bd7ac14d1f7c$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $3abdb5770b94b18a$export$78acf4525d8a74c4)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $8cf3bd7ac14d1f7c$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $3abdb5770b94b18a$export$78acf4525d8a74c4)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $8cf3bd7ac14d1f7c$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $3abdb5770b94b18a$export$78acf4525d8a74c4)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $3abdb5770b94b18a$export$78acf4525d8a74c4)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $3abdb5770b94b18a$export$78acf4525d8a74c4)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $3abdb5770b94b18a$export$78acf4525d8a74c4)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $3abdb5770b94b18a$export$8743009a87fcb00f)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $3abdb5770b94b18a$export$dc98b0b04f4c7758)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $3abdb5770b94b18a$export$3d8c2f653ac9d0b9)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $3abdb5770b94b18a$export$34aec0b863436764)(title.font);
        const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(position)) {
            offset += padding.bottom;
            if ((0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $8cf3bd7ac14d1f7c$var$titleArgs(this, offset, position, align);
        (0, $3abdb5770b94b18a$export$dc98b0b04f4c7758)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $8cf3bd7ac14d1f7c$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(opts.grid && opts.grid.z, -1);
        const bz = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $8cf3bd7ac14d1f7c$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $3abdb5770b94b18a$export$34aec0b863436764)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $8cf3bd7ac14d1f7c$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($8cf3bd7ac14d1f7c$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $8cf3bd7ac14d1f7c$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $3abdb5770b94b18a$export$4368d992c4eafac0).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $3abdb5770b94b18a$export$4368d992c4eafac0)[scope]) {
            delete (0, $3abdb5770b94b18a$export$4368d992c4eafac0)[scope][id];
            if (this.override) delete (0, $3abdb5770b94b18a$export$6559d589eb85fbb6)[id];
        }
    }
}
function $8cf3bd7ac14d1f7c$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $3abdb5770b94b18a$export$efca4cbe5dd06740)(Object.create(null), [
        parentScope ? (0, $3abdb5770b94b18a$export$4368d992c4eafac0).get(parentScope) : {},
        (0, $3abdb5770b94b18a$export$4368d992c4eafac0).get(scope),
        item.defaults
    ]);
    (0, $3abdb5770b94b18a$export$4368d992c4eafac0).set(scope, itemDefaults);
    if (item.defaultRoutes) $8cf3bd7ac14d1f7c$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $3abdb5770b94b18a$export$4368d992c4eafac0).describe(scope, item.descriptors);
}
function $8cf3bd7ac14d1f7c$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $3abdb5770b94b18a$export$4368d992c4eafac0).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $8cf3bd7ac14d1f7c$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $8cf3bd7ac14d1f7c$var$Registry {
    constructor(){
        this.controllers = new $8cf3bd7ac14d1f7c$var$TypedRegistry($8cf3bd7ac14d1f7c$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $8cf3bd7ac14d1f7c$var$TypedRegistry($8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $8cf3bd7ac14d1f7c$var$TypedRegistry(Object, 'plugins');
        this.scales = new $8cf3bd7ac14d1f7c$var$TypedRegistry($8cf3bd7ac14d1f7c$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $3abdb5770b94b18a$export$d66501df72047452)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $3abdb5770b94b18a$export$a8550f7dbe79f93a)(method);
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $8cf3bd7ac14d1f7c$var$Registry();
class $8cf3bd7ac14d1f7c$var$PluginService {
    constructor(){
        this._init = undefined;
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) return;
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(config.options && config.options.plugins, {});
        const plugins = $8cf3bd7ac14d1f7c$var$allPlugins(config);
        return options === false && !all ? [] : $8cf3bd7ac14d1f7c$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $8cf3bd7ac14d1f7c$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $8cf3bd7ac14d1f7c$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $8cf3bd7ac14d1f7c$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $8cf3bd7ac14d1f7c$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $8cf3bd7ac14d1f7c$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $8cf3bd7ac14d1f7c$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $8cf3bd7ac14d1f7c$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $3abdb5770b94b18a$export$4368d992c4eafac0).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $8cf3bd7ac14d1f7c$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $8cf3bd7ac14d1f7c$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $8cf3bd7ac14d1f7c$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $8cf3bd7ac14d1f7c$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $8cf3bd7ac14d1f7c$var$determineAxis(id, ...scaleOptions) {
    if ($8cf3bd7ac14d1f7c$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $8cf3bd7ac14d1f7c$var$axisFromPosition(opts.position) || id.length > 1 && $8cf3bd7ac14d1f7c$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $8cf3bd7ac14d1f7c$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $8cf3bd7ac14d1f7c$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $8cf3bd7ac14d1f7c$var$getAxisFromDataset(id, 'x', boundDs[0]) || $8cf3bd7ac14d1f7c$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $8cf3bd7ac14d1f7c$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $3abdb5770b94b18a$export$6559d589eb85fbb6)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $8cf3bd7ac14d1f7c$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $8cf3bd7ac14d1f7c$var$determineAxis(id, scaleConf, $8cf3bd7ac14d1f7c$var$retrieveAxisFromDatasets(id, config), (0, $3abdb5770b94b18a$export$4368d992c4eafac0).scales[scaleConf.type]);
        const defaultId = $8cf3bd7ac14d1f7c$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $3abdb5770b94b18a$export$555508cbc6add439)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $8cf3bd7ac14d1f7c$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $3abdb5770b94b18a$export$6559d589eb85fbb6)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $8cf3bd7ac14d1f7c$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $3abdb5770b94b18a$export$555508cbc6add439)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $3abdb5770b94b18a$export$555508cbc6add439)(scale, [
            (0, $3abdb5770b94b18a$export$4368d992c4eafac0).scales[scale.type],
            (0, $3abdb5770b94b18a$export$4368d992c4eafac0).scale
        ]);
    });
    return scales;
}
function $8cf3bd7ac14d1f7c$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(options.plugins, {});
    options.scales = $8cf3bd7ac14d1f7c$var$mergeScaleConfig(config, options);
}
function $8cf3bd7ac14d1f7c$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $8cf3bd7ac14d1f7c$var$initConfig(config) {
    config = config || {};
    config.data = $8cf3bd7ac14d1f7c$var$initData(config.data);
    $8cf3bd7ac14d1f7c$var$initOptions(config);
    return config;
}
const $8cf3bd7ac14d1f7c$var$keyCache = new Map();
const $8cf3bd7ac14d1f7c$var$keysCached = new Set();
function $8cf3bd7ac14d1f7c$var$cachedKeys(cacheKey, generate) {
    let keys = $8cf3bd7ac14d1f7c$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $8cf3bd7ac14d1f7c$var$keyCache.set(cacheKey, keys);
        $8cf3bd7ac14d1f7c$var$keysCached.add(keys);
    }
    return keys;
}
const $8cf3bd7ac14d1f7c$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $3abdb5770b94b18a$export$2d1720544b23b823)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $8cf3bd7ac14d1f7c$var$Config {
    constructor(config){
        this._config = $8cf3bd7ac14d1f7c$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $8cf3bd7ac14d1f7c$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $8cf3bd7ac14d1f7c$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $8cf3bd7ac14d1f7c$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $8cf3bd7ac14d1f7c$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $8cf3bd7ac14d1f7c$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $8cf3bd7ac14d1f7c$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$8cf3bd7ac14d1f7c$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$8cf3bd7ac14d1f7c$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$8cf3bd7ac14d1f7c$var$addIfFound(scopes, (0, $3abdb5770b94b18a$export$6559d589eb85fbb6)[type] || {}, key));
            keys.forEach((key)=>$8cf3bd7ac14d1f7c$var$addIfFound(scopes, (0, $3abdb5770b94b18a$export$4368d992c4eafac0), key));
            keys.forEach((key)=>$8cf3bd7ac14d1f7c$var$addIfFound(scopes, (0, $3abdb5770b94b18a$export$2e2af4578d910ddf), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($8cf3bd7ac14d1f7c$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $3abdb5770b94b18a$export$6559d589eb85fbb6)[type] || {},
            (0, $3abdb5770b94b18a$export$4368d992c4eafac0).datasets[type] || {},
            {
                type: type
            },
            (0, $3abdb5770b94b18a$export$4368d992c4eafac0),
            (0, $3abdb5770b94b18a$export$2e2af4578d910ddf)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $8cf3bd7ac14d1f7c$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($8cf3bd7ac14d1f7c$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $3abdb5770b94b18a$export$a93c5207d687da10)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $3abdb5770b94b18a$export$c3950d9923825c02)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $8cf3bd7ac14d1f7c$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(context) ? (0, $3abdb5770b94b18a$export$c3950d9923825c02)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $8cf3bd7ac14d1f7c$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $3abdb5770b94b18a$export$a9c996f45e5784d0)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $8cf3bd7ac14d1f7c$var$hasFunction = (value)=>(0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $3abdb5770b94b18a$export$a93c5207d687da10)(value[key]));
function $8cf3bd7ac14d1f7c$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $3abdb5770b94b18a$export$7910e0436ed8d1de)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $3abdb5770b94b18a$export$a93c5207d687da10)(value) || $8cf3bd7ac14d1f7c$var$hasFunction(value)) || indexable && (0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(value)) return true;
    }
    return false;
}
var $8cf3bd7ac14d1f7c$var$version = "4.5.1";
const $8cf3bd7ac14d1f7c$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $8cf3bd7ac14d1f7c$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $8cf3bd7ac14d1f7c$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $8cf3bd7ac14d1f7c$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $8cf3bd7ac14d1f7c$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $8cf3bd7ac14d1f7c$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $8cf3bd7ac14d1f7c$var$getCanvas(item) {
    if ((0, $3abdb5770b94b18a$export$3a1a48c8f6ef640e)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $8cf3bd7ac14d1f7c$var$instances = {};
const $8cf3bd7ac14d1f7c$var$getChart = (key)=>{
    const canvas = $8cf3bd7ac14d1f7c$var$getCanvas(key);
    return Object.values($8cf3bd7ac14d1f7c$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $8cf3bd7ac14d1f7c$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $8cf3bd7ac14d1f7c$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $8cf3bd7ac14d1f7c$export$acaa6426d77a227e {
    static defaults = (0, $3abdb5770b94b18a$export$4368d992c4eafac0);
    static instances = $8cf3bd7ac14d1f7c$var$instances;
    static overrides = (0, $3abdb5770b94b18a$export$6559d589eb85fbb6);
    static registry = $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5;
    static version = $8cf3bd7ac14d1f7c$var$version;
    static getChart = $8cf3bd7ac14d1f7c$var$getChart;
    static register(...items) {
        $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5.add(...items);
        $8cf3bd7ac14d1f7c$var$invalidatePlugins();
    }
    static unregister(...items) {
        $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5.remove(...items);
        $8cf3bd7ac14d1f7c$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $8cf3bd7ac14d1f7c$var$Config(userConfig);
        const initialCanvas = $8cf3bd7ac14d1f7c$var$getCanvas(item);
        const existingChart = $8cf3bd7ac14d1f7c$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $8cf3bd7ac14d1f7c$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $3abdb5770b94b18a$export$2219238a014317b0)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $8cf3bd7ac14d1f7c$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $3abdb5770b94b18a$export$4c3d22f3d993c33f)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $8cf3bd7ac14d1f7c$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $8cf3bd7ac14d1f7c$export$a424a0aa8f687495.listen(this, 'complete', $8cf3bd7ac14d1f7c$var$onAnimationsComplete);
        $8cf3bd7ac14d1f7c$export$a424a0aa8f687495.listen(this, 'progress', $8cf3bd7ac14d1f7c$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $3abdb5770b94b18a$export$f787f51d84a910ad)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $3abdb5770b94b18a$export$c9170ad7d4cd7e57)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $8cf3bd7ac14d1f7c$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$8cf3bd7ac14d1f7c$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $3abdb5770b94b18a$export$f787f51d84a910ad)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $3abdb5770b94b18a$export$d66501df72047452)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $8cf3bd7ac14d1f7c$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $3abdb5770b94b18a$export$d66501df72047452)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $8cf3bd7ac14d1f7c$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $8cf3bd7ac14d1f7c$var$positionIsHorizontal(scaleOptions.position, axis) !== $8cf3bd7ac14d1f7c$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $3abdb5770b94b18a$export$d66501df72047452)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $3abdb5770b94b18a$export$d66501df72047452)(scales, (scale)=>{
            $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($8cf3bd7ac14d1f7c$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $8cf3bd7ac14d1f7c$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $3abdb5770b94b18a$export$4368d992c4eafac0).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $8cf3bd7ac14d1f7c$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $3abdb5770b94b18a$export$d66501df72047452)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $3abdb5770b94b18a$export$d66501df72047452)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($8cf3bd7ac14d1f7c$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $3abdb5770b94b18a$export$d66501df72047452)(this.scales, (scale)=>{
            $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $3abdb5770b94b18a$export$ee7c8ad385a60b7b)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $8cf3bd7ac14d1f7c$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $3abdb5770b94b18a$export$ee7c8ad385a60b7b)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $3abdb5770b94b18a$export$d66501df72047452)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $3abdb5770b94b18a$export$a93c5207d687da10)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($8cf3bd7ac14d1f7c$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$8cf3bd7ac14d1f7c$export$a424a0aa8f687495.running(this)) $8cf3bd7ac14d1f7c$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $8cf3bd7ac14d1f7c$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $3abdb5770b94b18a$export$995eb9fca571757)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $3abdb5770b94b18a$export$8743009a87fcb00f)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $3abdb5770b94b18a$export$3d8c2f653ac9d0b9)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $3abdb5770b94b18a$export$e7094788287c5e9b)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $8cf3bd7ac14d1f7c$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $3abdb5770b94b18a$export$35e795649ee09318)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $3abdb5770b94b18a$export$dda1d9f60106f0e9)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $8cf3bd7ac14d1f7c$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $3abdb5770b94b18a$export$c9170ad7d4cd7e57)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $8cf3bd7ac14d1f7c$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $3abdb5770b94b18a$export$d66501df72047452)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $3abdb5770b94b18a$export$d66501df72047452)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $3abdb5770b94b18a$export$d66501df72047452)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $3abdb5770b94b18a$export$f38c853ae54ed474)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $3abdb5770b94b18a$export$3b513254972cfc9c)(e);
        const lastEvent = $8cf3bd7ac14d1f7c$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $3abdb5770b94b18a$export$f38c853ae54ed474)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $8cf3bd7ac14d1f7c$var$invalidatePlugins() {
    return (0, $3abdb5770b94b18a$export$d66501df72047452)($8cf3bd7ac14d1f7c$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $8cf3bd7ac14d1f7c$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $3abdb5770b94b18a$export$ab83b03e4111b1d0)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $3abdb5770b94b18a$export$ab83b03e4111b1d0)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $3abdb5770b94b18a$export$ab83b03e4111b1d0)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) / 2, startAngle + (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $8cf3bd7ac14d1f7c$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd), startAngle - (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd));
    ctx.closePath();
    ctx.clip();
}
function $8cf3bd7ac14d1f7c$var$toRadiusCorners(value) {
    return (0, $3abdb5770b94b18a$export$1a82df3d29112e01)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $8cf3bd7ac14d1f7c$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $8cf3bd7ac14d1f7c$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $8cf3bd7ac14d1f7c$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $8cf3bd7ac14d1f7c$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $3abdb5770b94b18a$export$56c0d5a1e737357d)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $8cf3bd7ac14d1f7c$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $8cf3bd7ac14d1f7c$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 3 to point 4
        const p4 = $8cf3bd7ac14d1f7c$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $8cf3bd7ac14d1f7c$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $8cf3bd7ac14d1f7c$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd));
        }
        // The line from point 7 to point 8
        const p8 = $8cf3bd7ac14d1f7c$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $8cf3bd7ac14d1f7c$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $8cf3bd7ac14d1f7c$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $8cf3bd7ac14d1f7c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $3abdb5770b94b18a$export$971d5caa766a69d7) || (0, $3abdb5770b94b18a$export$971d5caa766a69d7));
    }
    $8cf3bd7ac14d1f7c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $8cf3bd7ac14d1f7c$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $8cf3bd7ac14d1f7c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $3abdb5770b94b18a$export$971d5caa766a69d7) || (0, $3abdb5770b94b18a$export$971d5caa766a69d7));
    }
    if (inner) $8cf3bd7ac14d1f7c$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) && borderRadius === 0 && borderJoinStyle !== 'miter') $8cf3bd7ac14d1f7c$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $8cf3bd7ac14d1f7c$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $8cf3bd7ac14d1f7c$export$d48203c759d6a1fc extends $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $3abdb5770b94b18a$export$96f57966bedc81b4)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $3abdb5770b94b18a$export$ffb5f4729a158638)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $3abdb5770b94b18a$export$971d5caa766a69d7) || nonZeroBetween;
        const withinRadius = (0, $3abdb5770b94b18a$export$21579262ef46735b)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $3abdb5770b94b18a$export$971d5caa766a69d7) ? Math.floor(circumference / (0, $3abdb5770b94b18a$export$971d5caa766a69d7)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $3abdb5770b94b18a$export$56c0d5a1e737357d), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $8cf3bd7ac14d1f7c$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $8cf3bd7ac14d1f7c$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $8cf3bd7ac14d1f7c$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $3abdb5770b94b18a$export$90a7f3efeed30595)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(style.borderColor, options.borderColor);
}
function $8cf3bd7ac14d1f7c$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $8cf3bd7ac14d1f7c$var$getLineMethod(options) {
    if (options.stepped) return 0, $3abdb5770b94b18a$export$493d36ec626b6698;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $3abdb5770b94b18a$export$1fbe638ecf81657e;
    return $8cf3bd7ac14d1f7c$var$lineTo;
}
function $8cf3bd7ac14d1f7c$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $8cf3bd7ac14d1f7c$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $8cf3bd7ac14d1f7c$var$pathVars(points, segment, params);
    const lineMethod = $8cf3bd7ac14d1f7c$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $8cf3bd7ac14d1f7c$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $8cf3bd7ac14d1f7c$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $8cf3bd7ac14d1f7c$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $8cf3bd7ac14d1f7c$var$fastPathSegment : $8cf3bd7ac14d1f7c$var$pathSegment;
}
function $8cf3bd7ac14d1f7c$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $3abdb5770b94b18a$export$8a5498727ef6be21;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $3abdb5770b94b18a$export$d24c54395ce0c509;
    return 0, $3abdb5770b94b18a$export$6554612db691658e;
}
function $8cf3bd7ac14d1f7c$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $8cf3bd7ac14d1f7c$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $8cf3bd7ac14d1f7c$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $8cf3bd7ac14d1f7c$var$_getSegmentMethod(line);
    for (const segment of segments){
        $8cf3bd7ac14d1f7c$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $8cf3bd7ac14d1f7c$var$usePath2D = typeof Path2D === 'function';
function $8cf3bd7ac14d1f7c$var$draw(ctx, line, start, count) {
    if ($8cf3bd7ac14d1f7c$var$usePath2D && !line.options.segment) $8cf3bd7ac14d1f7c$var$strokePathWithCache(ctx, line, start, count);
    else $8cf3bd7ac14d1f7c$var$strokePathDirect(ctx, line, start, count);
}
class $8cf3bd7ac14d1f7c$export$55e463fa7bcd3469 extends $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $3abdb5770b94b18a$export$306ddfe3a8403e2)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $3abdb5770b94b18a$export$7a38258bbe170828)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $3abdb5770b94b18a$export$2f6ca3d3b1f80bf5)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $8cf3bd7ac14d1f7c$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $8cf3bd7ac14d1f7c$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $8cf3bd7ac14d1f7c$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $8cf3bd7ac14d1f7c$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $8cf3bd7ac14d1f7c$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $8cf3bd7ac14d1f7c$export$bd159b522b230b7a extends $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $8cf3bd7ac14d1f7c$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $8cf3bd7ac14d1f7c$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $3abdb5770b94b18a$export$e7094788287c5e9b)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $3abdb5770b94b18a$export$d66dc83d8cfc8dd)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $8cf3bd7ac14d1f7c$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $8cf3bd7ac14d1f7c$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(value, min, max);
}
function $8cf3bd7ac14d1f7c$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $3abdb5770b94b18a$export$9fa96a7d116ea3ce)(value);
    return {
        t: $8cf3bd7ac14d1f7c$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $8cf3bd7ac14d1f7c$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $8cf3bd7ac14d1f7c$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $8cf3bd7ac14d1f7c$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $8cf3bd7ac14d1f7c$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $3abdb5770b94b18a$export$28f7fcd39efa255)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(value);
    return {
        topLeft: $8cf3bd7ac14d1f7c$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $8cf3bd7ac14d1f7c$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $8cf3bd7ac14d1f7c$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $8cf3bd7ac14d1f7c$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $8cf3bd7ac14d1f7c$var$boundingRects(bar) {
    const bounds = $8cf3bd7ac14d1f7c$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $8cf3bd7ac14d1f7c$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $8cf3bd7ac14d1f7c$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $8cf3bd7ac14d1f7c$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $8cf3bd7ac14d1f7c$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $3abdb5770b94b18a$export$21579262ef46735b)(x, bounds.left, bounds.right)) && (skipY || (0, $3abdb5770b94b18a$export$21579262ef46735b)(y, bounds.top, bounds.bottom));
}
function $8cf3bd7ac14d1f7c$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $8cf3bd7ac14d1f7c$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $8cf3bd7ac14d1f7c$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $8cf3bd7ac14d1f7c$export$a16ed71bf4b07672 extends $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $8cf3bd7ac14d1f7c$var$boundingRects(this);
        const addRectPath = $8cf3bd7ac14d1f7c$var$hasRadius(outer.radius) ? (0, $3abdb5770b94b18a$export$92108d983e8ee699) : $8cf3bd7ac14d1f7c$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $8cf3bd7ac14d1f7c$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $8cf3bd7ac14d1f7c$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $8cf3bd7ac14d1f7c$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $8cf3bd7ac14d1f7c$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $8cf3bd7ac14d1f7c$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $8cf3bd7ac14d1f7c$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $8cf3bd7ac14d1f7c$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $8cf3bd7ac14d1f7c$export$d48203c759d6a1fc,
    BarElement: $8cf3bd7ac14d1f7c$export$a16ed71bf4b07672,
    LineElement: $8cf3bd7ac14d1f7c$export$55e463fa7bcd3469,
    PointElement: $8cf3bd7ac14d1f7c$export$bd159b522b230b7a
});
const $8cf3bd7ac14d1f7c$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $8cf3bd7ac14d1f7c$var$BACKGROUND_COLORS = /* #__PURE__ */ $8cf3bd7ac14d1f7c$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $8cf3bd7ac14d1f7c$var$getBorderColor(i) {
    return $8cf3bd7ac14d1f7c$var$BORDER_COLORS[i % $8cf3bd7ac14d1f7c$var$BORDER_COLORS.length];
}
function $8cf3bd7ac14d1f7c$var$getBackgroundColor(i) {
    return $8cf3bd7ac14d1f7c$var$BACKGROUND_COLORS[i % $8cf3bd7ac14d1f7c$var$BACKGROUND_COLORS.length];
}
function $8cf3bd7ac14d1f7c$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $8cf3bd7ac14d1f7c$var$getBorderColor(i);
    dataset.backgroundColor = $8cf3bd7ac14d1f7c$var$getBackgroundColor(i);
    return ++i;
}
function $8cf3bd7ac14d1f7c$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$8cf3bd7ac14d1f7c$var$getBorderColor(i++));
    return i;
}
function $8cf3bd7ac14d1f7c$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$8cf3bd7ac14d1f7c$var$getBackgroundColor(i++));
    return i;
}
function $8cf3bd7ac14d1f7c$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $8cf3bd7ac14d1f7c$export$e04603e7d8b77172) i = $8cf3bd7ac14d1f7c$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $8cf3bd7ac14d1f7c$export$2a270b3a0d973c85) i = $8cf3bd7ac14d1f7c$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $8cf3bd7ac14d1f7c$var$colorizeDefaultDataset(dataset, i);
    };
}
function $8cf3bd7ac14d1f7c$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $8cf3bd7ac14d1f7c$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $8cf3bd7ac14d1f7c$var$containsDefaultColorsDefenitions() {
    return (0, $3abdb5770b94b18a$export$4368d992c4eafac0).borderColor !== 'rgba(0,0,0,0.1)' || (0, $3abdb5770b94b18a$export$4368d992c4eafac0).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $8cf3bd7ac14d1f7c$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $8cf3bd7ac14d1f7c$var$containsColorsDefinitions(datasets) || $8cf3bd7ac14d1f7c$var$containsColorsDefinition(chartOptions) || elements && $8cf3bd7ac14d1f7c$var$containsColorsDefinitions(elements) || $8cf3bd7ac14d1f7c$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $8cf3bd7ac14d1f7c$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $8cf3bd7ac14d1f7c$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $8cf3bd7ac14d1f7c$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(minIndex) && !(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $8cf3bd7ac14d1f7c$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $8cf3bd7ac14d1f7c$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $8cf3bd7ac14d1f7c$var$cleanDecimatedDataset(dataset);
    });
}
function $8cf3bd7ac14d1f7c$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $3abdb5770b94b18a$export$25ce5a424b770e84)((0, $3abdb5770b94b18a$export$ef35774e6d314e91)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $3abdb5770b94b18a$export$25ce5a424b770e84)((0, $3abdb5770b94b18a$export$ef35774e6d314e91)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $8cf3bd7ac14d1f7c$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $8cf3bd7ac14d1f7c$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $3abdb5770b94b18a$export$407448d2b89b1813)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $8cf3bd7ac14d1f7c$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $8cf3bd7ac14d1f7c$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $8cf3bd7ac14d1f7c$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $8cf3bd7ac14d1f7c$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $8cf3bd7ac14d1f7c$var$cleanDecimatedData(chart);
    }
};
function $8cf3bd7ac14d1f7c$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $8cf3bd7ac14d1f7c$var$_findSegmentEnd(start, end, points);
        const bounds = $8cf3bd7ac14d1f7c$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $3abdb5770b94b18a$export$2f6ca3d3b1f80bf5)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $8cf3bd7ac14d1f7c$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $3abdb5770b94b18a$export$3d12bd131bb975d1)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $8cf3bd7ac14d1f7c$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $8cf3bd7ac14d1f7c$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $8cf3bd7ac14d1f7c$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $3abdb5770b94b18a$export$ab83b03e4111b1d0)(start);
        end = (0, $3abdb5770b94b18a$export$ab83b03e4111b1d0)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $8cf3bd7ac14d1f7c$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $8cf3bd7ac14d1f7c$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $8cf3bd7ac14d1f7c$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $8cf3bd7ac14d1f7c$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $8cf3bd7ac14d1f7c$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $8cf3bd7ac14d1f7c$var$_pointsFromSegments(boundary, line);
    return points.length ? new $8cf3bd7ac14d1f7c$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $8cf3bd7ac14d1f7c$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $8cf3bd7ac14d1f7c$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $3abdb5770b94b18a$export$39b482c5e57630a8)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $8cf3bd7ac14d1f7c$var$_decodeFill(line, index, count) {
    const fill = $8cf3bd7ac14d1f7c$var$parseFillOption(line);
    if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $3abdb5770b94b18a$export$39b482c5e57630a8)(target) && Math.floor(target) === target) return $8cf3bd7ac14d1f7c$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $8cf3bd7ac14d1f7c$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $8cf3bd7ac14d1f7c$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $8cf3bd7ac14d1f7c$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $8cf3bd7ac14d1f7c$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $8cf3bd7ac14d1f7c$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $8cf3bd7ac14d1f7c$var$getLinesBelow(scale, index);
    linesBelow.push($8cf3bd7ac14d1f7c$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$8cf3bd7ac14d1f7c$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $8cf3bd7ac14d1f7c$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $8cf3bd7ac14d1f7c$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $8cf3bd7ac14d1f7c$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $8cf3bd7ac14d1f7c$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $8cf3bd7ac14d1f7c$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $3abdb5770b94b18a$export$21579262ef46735b)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $8cf3bd7ac14d1f7c$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $3abdb5770b94b18a$export$971d5caa766a69d7)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $8cf3bd7ac14d1f7c$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $3abdb5770b94b18a$export$39b482c5e57630a8)(fill)) return $8cf3bd7ac14d1f7c$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $8cf3bd7ac14d1f7c$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $8cf3bd7ac14d1f7c$var$computeBoundary(source);
    if (boundary instanceof $8cf3bd7ac14d1f7c$var$simpleArc) return boundary;
    return $8cf3bd7ac14d1f7c$var$_createBoundaryLine(boundary, line);
}
function $8cf3bd7ac14d1f7c$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $8cf3bd7ac14d1f7c$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $8cf3bd7ac14d1f7c$var$computeCircularBoundary(source);
    return $8cf3bd7ac14d1f7c$var$computeLinearBoundary(source);
}
function $8cf3bd7ac14d1f7c$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $8cf3bd7ac14d1f7c$var$_getTargetPixel(fill, scale);
    if ((0, $3abdb5770b94b18a$export$39b482c5e57630a8)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $8cf3bd7ac14d1f7c$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $8cf3bd7ac14d1f7c$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $8cf3bd7ac14d1f7c$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $8cf3bd7ac14d1f7c$var$_drawfill(ctx, source, area) {
    const target = $8cf3bd7ac14d1f7c$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $3abdb5770b94b18a$export$995eb9fca571757)(chart, meta);
    if (target && line.points.length) {
        (0, $3abdb5770b94b18a$export$8743009a87fcb00f)(ctx, area);
        $8cf3bd7ac14d1f7c$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $3abdb5770b94b18a$export$3d8c2f653ac9d0b9)(ctx);
    }
}
function $8cf3bd7ac14d1f7c$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $8cf3bd7ac14d1f7c$var$clipVertical(ctx, target, area.top);
            $8cf3bd7ac14d1f7c$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $8cf3bd7ac14d1f7c$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $8cf3bd7ac14d1f7c$var$clipHorizontal(ctx, target, area.left);
            $8cf3bd7ac14d1f7c$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $8cf3bd7ac14d1f7c$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $8cf3bd7ac14d1f7c$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $8cf3bd7ac14d1f7c$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$8cf3bd7ac14d1f7c$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $8cf3bd7ac14d1f7c$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$8cf3bd7ac14d1f7c$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $8cf3bd7ac14d1f7c$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $8cf3bd7ac14d1f7c$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $8cf3bd7ac14d1f7c$var$clipBounds(ctx, scale, clip, notShape && $8cf3bd7ac14d1f7c$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $8cf3bd7ac14d1f7c$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $8cf3bd7ac14d1f7c$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $8cf3bd7ac14d1f7c$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $8cf3bd7ac14d1f7c$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $8cf3bd7ac14d1f7c$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $8cf3bd7ac14d1f7c$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $8cf3bd7ac14d1f7c$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $8cf3bd7ac14d1f7c$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $8cf3bd7ac14d1f7c$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($8cf3bd7ac14d1f7c$var$_shouldApplyFill(source)) $8cf3bd7ac14d1f7c$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$8cf3bd7ac14d1f7c$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $8cf3bd7ac14d1f7c$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $8cf3bd7ac14d1f7c$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $8cf3bd7ac14d1f7c$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $8cf3bd7ac14d1f7c$var$Legend extends $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $8cf3bd7ac14d1f7c$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $8cf3bd7ac14d1f7c$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $3abdb5770b94b18a$export$91c6e00c14e7e6fd)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $3abdb5770b94b18a$export$8743009a87fcb00f)(ctx, this);
            this._draw();
            (0, $3abdb5770b94b18a$export$3d8c2f653ac9d0b9)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $3abdb5770b94b18a$export$4368d992c4eafac0).color;
        const rtlHelper = (0, $3abdb5770b94b18a$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const labelFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $8cf3bd7ac14d1f7c$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $3abdb5770b94b18a$export$90a7f3efeed30595)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $3abdb5770b94b18a$export$158acd800e1ef08b)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $3abdb5770b94b18a$export$28f7fcd39efa255)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $3abdb5770b94b18a$export$92108d983e8ee699)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $3abdb5770b94b18a$export$dc98b0b04f4c7758)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $3abdb5770b94b18a$export$9d398bebfec1c039)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $3abdb5770b94b18a$export$890c4ad488842ce7)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $8cf3bd7ac14d1f7c$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $3abdb5770b94b18a$export$24baa2b76016ce0e)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $3abdb5770b94b18a$export$91c6e00c14e7e6fd)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $3abdb5770b94b18a$export$3c2fa207a37baaea)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $3abdb5770b94b18a$export$dc98b0b04f4c7758)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(titleOpts.font);
        const titlePadding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $3abdb5770b94b18a$export$21579262ef46735b)(x, this.left, this.right) && (0, $3abdb5770b94b18a$export$21579262ef46735b)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $3abdb5770b94b18a$export$21579262ef46735b)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $3abdb5770b94b18a$export$21579262ef46735b)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$8cf3bd7ac14d1f7c$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $8cf3bd7ac14d1f7c$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $8cf3bd7ac14d1f7c$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $8cf3bd7ac14d1f7c$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $8cf3bd7ac14d1f7c$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $8cf3bd7ac14d1f7c$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $8cf3bd7ac14d1f7c$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $8cf3bd7ac14d1f7c$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $8cf3bd7ac14d1f7c$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $8cf3bd7ac14d1f7c$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $8cf3bd7ac14d1f7c$export$ed247974535929c7 = {
    id: 'legend',
    _element: $8cf3bd7ac14d1f7c$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $8cf3bd7ac14d1f7c$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $8cf3bd7ac14d1f7c$var$Title extends $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(opts.padding);
        const textSize = lineCount * (0, $3abdb5770b94b18a$export$34aec0b863436764)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, bottom, top);
                rotation = (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $3abdb5770b94b18a$export$ce26c07117d59d6a)(align, top, bottom);
                rotation = (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $3abdb5770b94b18a$export$34aec0b863436764)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $3abdb5770b94b18a$export$dc98b0b04f4c7758)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $3abdb5770b94b18a$export$3c2fa207a37baaea)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $8cf3bd7ac14d1f7c$var$createTitle(chart, titleOpts) {
    const title = new $8cf3bd7ac14d1f7c$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $8cf3bd7ac14d1f7c$export$f99233281efd08a0 = {
    id: 'title',
    _element: $8cf3bd7ac14d1f7c$var$Title,
    start (chart, _args, options) {
        $8cf3bd7ac14d1f7c$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $8cf3bd7ac14d1f7c$var$map = new WeakMap();
var $8cf3bd7ac14d1f7c$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $8cf3bd7ac14d1f7c$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.configure(chart, title, options);
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.addBox(chart, title);
        $8cf3bd7ac14d1f7c$var$map.set(chart, title);
    },
    stop (chart) {
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.removeBox(chart, $8cf3bd7ac14d1f7c$var$map.get(chart));
        $8cf3bd7ac14d1f7c$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $8cf3bd7ac14d1f7c$var$map.get(chart);
        $8cf3bd7ac14d1f7c$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $8cf3bd7ac14d1f7c$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $3abdb5770b94b18a$export$cf2f7c5792f80b46)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $8cf3bd7ac14d1f7c$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $8cf3bd7ac14d1f7c$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $8cf3bd7ac14d1f7c$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $8cf3bd7ac14d1f7c$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(options.bodyFont);
    const titleFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(options.titleFont);
    const footerFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $3abdb5770b94b18a$export$d66501df72047452)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $3abdb5770b94b18a$export$d66501df72047452)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $3abdb5770b94b18a$export$d66501df72047452)(body, (bodyItem)=>{
        (0, $3abdb5770b94b18a$export$d66501df72047452)(bodyItem.before, maxLineWidth);
        (0, $3abdb5770b94b18a$export$d66501df72047452)(bodyItem.lines, maxLineWidth);
        (0, $3abdb5770b94b18a$export$d66501df72047452)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $3abdb5770b94b18a$export$d66501df72047452)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $8cf3bd7ac14d1f7c$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $8cf3bd7ac14d1f7c$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $8cf3bd7ac14d1f7c$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($8cf3bd7ac14d1f7c$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $8cf3bd7ac14d1f7c$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $8cf3bd7ac14d1f7c$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $8cf3bd7ac14d1f7c$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $8cf3bd7ac14d1f7c$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $8cf3bd7ac14d1f7c$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $8cf3bd7ac14d1f7c$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $3abdb5770b94b18a$export$28f7fcd39efa255)(cornerRadius);
    let x = $8cf3bd7ac14d1f7c$var$alignX(size, xAlign);
    const y = $8cf3bd7ac14d1f7c$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(x, 0, chart.width - size.width),
        y: (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(y, 0, chart.height - size.height)
    };
}
function $8cf3bd7ac14d1f7c$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $8cf3bd7ac14d1f7c$var$getBeforeAfterBodyLines(callback) {
    return $8cf3bd7ac14d1f7c$var$pushOrConcat([], $8cf3bd7ac14d1f7c$var$splitNewlines(callback));
}
function $8cf3bd7ac14d1f7c$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $3abdb5770b94b18a$export$35e795649ee09318)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $8cf3bd7ac14d1f7c$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $8cf3bd7ac14d1f7c$var$defaultCallbacks = {
    beforeTitle: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346),
    beforeBody: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346),
    beforeLabel: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346),
    afterBody: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346),
    beforeFooter: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346),
    footer: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346),
    afterFooter: (0, $3abdb5770b94b18a$export$53a70dd1ebbae346)
};
function $8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $8cf3bd7ac14d1f7c$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $8cf3bd7ac14d1f7c$var$Tooltip extends $8cf3bd7ac14d1f7c$export$db77ccec0bb4ccac {
    static positioners = $8cf3bd7ac14d1f7c$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $8cf3bd7ac14d1f7c$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $8cf3bd7ac14d1f7c$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $8cf3bd7ac14d1f7c$var$pushOrConcat(lines, $8cf3bd7ac14d1f7c$var$splitNewlines(beforeTitle));
        lines = $8cf3bd7ac14d1f7c$var$pushOrConcat(lines, $8cf3bd7ac14d1f7c$var$splitNewlines(title));
        lines = $8cf3bd7ac14d1f7c$var$pushOrConcat(lines, $8cf3bd7ac14d1f7c$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $8cf3bd7ac14d1f7c$var$getBeforeAfterBodyLines($8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $3abdb5770b94b18a$export$d66501df72047452)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $8cf3bd7ac14d1f7c$var$overrideCallbacks(callbacks, context);
            $8cf3bd7ac14d1f7c$var$pushOrConcat(bodyItem.before, $8cf3bd7ac14d1f7c$var$splitNewlines($8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $8cf3bd7ac14d1f7c$var$pushOrConcat(bodyItem.lines, $8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $8cf3bd7ac14d1f7c$var$pushOrConcat(bodyItem.after, $8cf3bd7ac14d1f7c$var$splitNewlines($8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $8cf3bd7ac14d1f7c$var$getBeforeAfterBodyLines($8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $8cf3bd7ac14d1f7c$var$pushOrConcat(lines, $8cf3bd7ac14d1f7c$var$splitNewlines(beforeFooter));
        lines = $8cf3bd7ac14d1f7c$var$pushOrConcat(lines, $8cf3bd7ac14d1f7c$var$splitNewlines(footer));
        lines = $8cf3bd7ac14d1f7c$var$pushOrConcat(lines, $8cf3bd7ac14d1f7c$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($8cf3bd7ac14d1f7c$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $3abdb5770b94b18a$export$d66501df72047452)(tooltipItems, (context)=>{
            const scoped = $8cf3bd7ac14d1f7c$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($8cf3bd7ac14d1f7c$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $8cf3bd7ac14d1f7c$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $8cf3bd7ac14d1f7c$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $8cf3bd7ac14d1f7c$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $8cf3bd7ac14d1f7c$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $3abdb5770b94b18a$export$28f7fcd39efa255)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $3abdb5770b94b18a$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $8cf3bd7ac14d1f7c$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(options.bodyFont);
        const colorX = $8cf3bd7ac14d1f7c$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $3abdb5770b94b18a$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $3abdb5770b94b18a$export$d66dc83d8cfc8dd)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $3abdb5770b94b18a$export$23f2a1d2818174ef)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $3abdb5770b94b18a$export$28f7fcd39efa255)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $3abdb5770b94b18a$export$92108d983e8ee699)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $3abdb5770b94b18a$export$92108d983e8ee699)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $3abdb5770b94b18a$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $8cf3bd7ac14d1f7c$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $3abdb5770b94b18a$export$d66501df72047452)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $3abdb5770b94b18a$export$d66501df72047452)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $3abdb5770b94b18a$export$d66501df72047452)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $3abdb5770b94b18a$export$d66501df72047452)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $3abdb5770b94b18a$export$91c6e00c14e7e6fd)(options.rtl, this.x, this.width);
            pt.x = $8cf3bd7ac14d1f7c$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $3abdb5770b94b18a$export$28f7fcd39efa255)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $8cf3bd7ac14d1f7c$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $8cf3bd7ac14d1f7c$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $8cf3bd7ac14d1f7c$var$determineAlignment(chart, options, positionAndSize);
            const point = $8cf3bd7ac14d1f7c$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $3abdb5770b94b18a$export$9d398bebfec1c039)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $3abdb5770b94b18a$export$24baa2b76016ce0e)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $3abdb5770b94b18a$export$f38c853ae54ed474)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $3abdb5770b94b18a$export$f38c853ae54ed474)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $8cf3bd7ac14d1f7c$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $8cf3bd7ac14d1f7c$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $8cf3bd7ac14d1f7c$var$Tooltip,
    positioners: $8cf3bd7ac14d1f7c$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $8cf3bd7ac14d1f7c$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $8cf3bd7ac14d1f7c$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $8cf3bd7ac14d1f7c$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $8cf3bd7ac14d1f7c$export$c537fa0d021d010b,
    Decimation: $8cf3bd7ac14d1f7c$export$be17f937e9aa7533,
    Filler: $8cf3bd7ac14d1f7c$export$d19ba4d812bed757,
    Legend: $8cf3bd7ac14d1f7c$export$ed247974535929c7,
    SubTitle: $8cf3bd7ac14d1f7c$export$d5c56664638992a4,
    Title: $8cf3bd7ac14d1f7c$export$f99233281efd08a0,
    Tooltip: $8cf3bd7ac14d1f7c$export$28c660c63b792dea
});
const $8cf3bd7ac14d1f7c$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $8cf3bd7ac14d1f7c$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $8cf3bd7ac14d1f7c$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $8cf3bd7ac14d1f7c$var$validIndex = (index, max)=>index === null ? null : (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(Math.round(index), 0, max);
function $8cf3bd7ac14d1f7c$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $8cf3bd7ac14d1f7c$export$29e663ba4d09fe7 extends $8cf3bd7ac14d1f7c$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $8cf3bd7ac14d1f7c$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $8cf3bd7ac14d1f7c$var$findOrAddLabel(labels, raw, (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(index, raw), this._addedLabels);
        return $8cf3bd7ac14d1f7c$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $8cf3bd7ac14d1f7c$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $8cf3bd7ac14d1f7c$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(min);
    const maxDefined = !(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(max);
    const countDefined = !(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $3abdb5770b94b18a$export$b9a6b53f9be3734)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $3abdb5770b94b18a$export$b9a6b53f9be3734)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $3abdb5770b94b18a$export$a05254e7c3aeba6e)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $3abdb5770b94b18a$export$23ebac1979863676)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $3abdb5770b94b18a$export$91477dc880baac21)(spacing), (0, $3abdb5770b94b18a$export$91477dc880baac21)(niceMin));
    factor = Math.pow(10, (0, $3abdb5770b94b18a$export$342063e11d6c3cad)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $3abdb5770b94b18a$export$23ebac1979863676)(Math.round((niceMin + j * spacing) * factor) / factor, min, $8cf3bd7ac14d1f7c$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $3abdb5770b94b18a$export$23ebac1979863676)(ticks[ticks.length - 1].value, max, $8cf3bd7ac14d1f7c$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $8cf3bd7ac14d1f7c$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $8cf3bd7ac14d1f7c$var$LinearScaleBase extends $8cf3bd7ac14d1f7c$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $3abdb5770b94b18a$export$2408f22a0fab9ae5)(min);
            const maxSign = (0, $3abdb5770b94b18a$export$2408f22a0fab9ae5)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $8cf3bd7ac14d1f7c$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $3abdb5770b94b18a$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $3abdb5770b94b18a$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $8cf3bd7ac14d1f7c$export$e7f4e5e8656f0b93 extends $8cf3bd7ac14d1f7c$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $3abdb5770b94b18a$export$9f4f30ee63539e24).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(min) ? min : 0;
        this.max = (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $8cf3bd7ac14d1f7c$var$log10Floor = (v)=>Math.floor((0, $3abdb5770b94b18a$export$faec65b429be379)(v));
const $8cf3bd7ac14d1f7c$var$changeExponent = (v, m)=>Math.pow(10, $8cf3bd7ac14d1f7c$var$log10Floor(v) + m);
function $8cf3bd7ac14d1f7c$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $8cf3bd7ac14d1f7c$var$log10Floor(tickVal));
    return remain === 1;
}
function $8cf3bd7ac14d1f7c$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $8cf3bd7ac14d1f7c$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $8cf3bd7ac14d1f7c$var$log10Floor(range);
    while($8cf3bd7ac14d1f7c$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($8cf3bd7ac14d1f7c$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $8cf3bd7ac14d1f7c$var$log10Floor(min));
}
function $8cf3bd7ac14d1f7c$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(generationOptions.min, min);
    const ticks = [];
    const minExp = $8cf3bd7ac14d1f7c$var$log10Floor(min);
    let exp = $8cf3bd7ac14d1f7c$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $8cf3bd7ac14d1f7c$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $3abdb5770b94b18a$export$c4ce752e73470fba)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $8cf3bd7ac14d1f7c$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $8cf3bd7ac14d1f7c$export$85295eaf7cb3ac3e extends $8cf3bd7ac14d1f7c$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $3abdb5770b94b18a$export$9f4f30ee63539e24).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $8cf3bd7ac14d1f7c$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(min) ? Math.max(0, min) : null;
        this.max = (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $3abdb5770b94b18a$export$39b482c5e57630a8)(this._userMin)) this.min = min === $8cf3bd7ac14d1f7c$var$changeExponent(this.min, 0) ? $8cf3bd7ac14d1f7c$var$changeExponent(this.min, -1) : $8cf3bd7ac14d1f7c$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($8cf3bd7ac14d1f7c$var$changeExponent(min, -1));
                setMax($8cf3bd7ac14d1f7c$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($8cf3bd7ac14d1f7c$var$changeExponent(max, -1));
        if (max <= 0) setMax($8cf3bd7ac14d1f7c$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $8cf3bd7ac14d1f7c$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $3abdb5770b94b18a$export$a33b77bbdbb8366c)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $3abdb5770b94b18a$export$ae1af26003f05816)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $3abdb5770b94b18a$export$faec65b429be379)(start);
        this._valueRange = (0, $3abdb5770b94b18a$export$faec65b429be379)(this.max) - (0, $3abdb5770b94b18a$export$faec65b429be379)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $3abdb5770b94b18a$export$faec65b429be379)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $8cf3bd7ac14d1f7c$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(tickOpts.backdropPadding);
        return (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(tickOpts.font && tickOpts.font.size, (0, $3abdb5770b94b18a$export$4368d992c4eafac0).font.size) + padding.height;
    }
    return 0;
}
function $8cf3bd7ac14d1f7c$var$measureLabelSize(ctx, font, label) {
    label = (0, $3abdb5770b94b18a$export$8b22cf2602fb60ce)(label) ? label : [
        label
    ];
    return {
        w: (0, $3abdb5770b94b18a$export$c03999cb2f36933f)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $8cf3bd7ac14d1f7c$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $8cf3bd7ac14d1f7c$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(opts.font);
        const textSize = $8cf3bd7ac14d1f7c$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $3abdb5770b94b18a$export$ab83b03e4111b1d0)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $3abdb5770b94b18a$export$3a6d5c9ae78a2c08)(angleRadians));
        const hLimits = $8cf3bd7ac14d1f7c$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $8cf3bd7ac14d1f7c$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $8cf3bd7ac14d1f7c$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $8cf3bd7ac14d1f7c$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $8cf3bd7ac14d1f7c$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $8cf3bd7ac14d1f7c$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $3abdb5770b94b18a$export$3a6d5c9ae78a2c08)((0, $3abdb5770b94b18a$export$ab83b03e4111b1d0)(pointLabelPosition.angle + (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd))));
    const y = $8cf3bd7ac14d1f7c$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $8cf3bd7ac14d1f7c$var$getTextAlignForAngle(angle);
    const left = $8cf3bd7ac14d1f7c$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $8cf3bd7ac14d1f7c$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $3abdb5770b94b18a$export$e7094788287c5e9b)({
        x: left,
        y: top
    }, area) || (0, $3abdb5770b94b18a$export$e7094788287c5e9b)({
        x: left,
        y: bottom
    }, area) || (0, $3abdb5770b94b18a$export$e7094788287c5e9b)({
        x: right,
        y: top
    }, area) || (0, $3abdb5770b94b18a$export$e7094788287c5e9b)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $8cf3bd7ac14d1f7c$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $8cf3bd7ac14d1f7c$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $3abdb5770b94b18a$export$56c0d5a1e737357d) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $8cf3bd7ac14d1f7c$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $8cf3bd7ac14d1f7c$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $8cf3bd7ac14d1f7c$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $8cf3bd7ac14d1f7c$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $8cf3bd7ac14d1f7c$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $8cf3bd7ac14d1f7c$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $3abdb5770b94b18a$export$342063e11d6c3cad)(backdropColor)) {
        const borderRadius = (0, $3abdb5770b94b18a$export$28f7fcd39efa255)(opts.borderRadius);
        const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $3abdb5770b94b18a$export$92108d983e8ee699)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $8cf3bd7ac14d1f7c$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $8cf3bd7ac14d1f7c$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $3abdb5770b94b18a$export$dc98b0b04f4c7758)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $8cf3bd7ac14d1f7c$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $3abdb5770b94b18a$export$971d5caa766a69d7));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $8cf3bd7ac14d1f7c$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $8cf3bd7ac14d1f7c$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $8cf3bd7ac14d1f7c$var$createPointLabelContext(parent, index, label) {
    return (0, $3abdb5770b94b18a$export$35e795649ee09318)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $8cf3bd7ac14d1f7c$export$cfafc36d95386d38 extends $8cf3bd7ac14d1f7c$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $3abdb5770b94b18a$export$9f4f30ee63539e24).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)($8cf3bd7ac14d1f7c$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $8cf3bd7ac14d1f7c$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $8cf3bd7ac14d1f7c$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $8cf3bd7ac14d1f7c$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $3abdb5770b94b18a$export$971d5caa766a69d7) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $3abdb5770b94b18a$export$ab83b03e4111b1d0)(index * angleMultiplier + (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $8cf3bd7ac14d1f7c$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $3abdb5770b94b18a$export$7f8ddf7c7c20b3cd) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $8cf3bd7ac14d1f7c$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $8cf3bd7ac14d1f7c$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $8cf3bd7ac14d1f7c$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $3abdb5770b94b18a$export$34aec0b863436764)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $3abdb5770b94b18a$export$a9c23c6ac3fc3eca)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $3abdb5770b94b18a$export$dc98b0b04f4c7758)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $8cf3bd7ac14d1f7c$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $8cf3bd7ac14d1f7c$var$UNITS = /* #__PURE__ */ Object.keys($8cf3bd7ac14d1f7c$var$INTERVALS);
function $8cf3bd7ac14d1f7c$var$sorter(a, b) {
    return a - b;
}
function $8cf3bd7ac14d1f7c$var$parse(scale, input) {
    if ((0, $3abdb5770b94b18a$export$342063e11d6c3cad)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $3abdb5770b94b18a$export$39b482c5e57630a8)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $3abdb5770b94b18a$export$d141bba7fdc215a3)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $8cf3bd7ac14d1f7c$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $8cf3bd7ac14d1f7c$var$UNITS.length;
    for(let i = $8cf3bd7ac14d1f7c$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $8cf3bd7ac14d1f7c$var$INTERVALS[$8cf3bd7ac14d1f7c$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $8cf3bd7ac14d1f7c$var$UNITS[i];
    }
    return $8cf3bd7ac14d1f7c$var$UNITS[ilen - 1];
}
function $8cf3bd7ac14d1f7c$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $8cf3bd7ac14d1f7c$var$UNITS.length - 1; i >= $8cf3bd7ac14d1f7c$var$UNITS.indexOf(minUnit); i--){
        const unit = $8cf3bd7ac14d1f7c$var$UNITS[i];
        if ($8cf3bd7ac14d1f7c$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $8cf3bd7ac14d1f7c$var$UNITS[minUnit ? $8cf3bd7ac14d1f7c$var$UNITS.indexOf(minUnit) : 0];
}
function $8cf3bd7ac14d1f7c$var$determineMajorUnit(unit) {
    for(let i = $8cf3bd7ac14d1f7c$var$UNITS.indexOf(unit) + 1, ilen = $8cf3bd7ac14d1f7c$var$UNITS.length; i < ilen; ++i){
        if ($8cf3bd7ac14d1f7c$var$INTERVALS[$8cf3bd7ac14d1f7c$var$UNITS[i]].common) return $8cf3bd7ac14d1f7c$var$UNITS[i];
    }
}
function $8cf3bd7ac14d1f7c$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $3abdb5770b94b18a$export$f96d196f7728bb5)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $8cf3bd7ac14d1f7c$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $8cf3bd7ac14d1f7c$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $8cf3bd7ac14d1f7c$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $8cf3bd7ac14d1f7c$export$a894c72689ff3ec extends $8cf3bd7ac14d1f7c$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $8cf3bd7ac14d1f7c$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $3abdb5770b94b18a$export$555508cbc6add439)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $8cf3bd7ac14d1f7c$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $3abdb5770b94b18a$export$39b482c5e57630a8)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $3abdb5770b94b18a$export$2ed0fc6709e59212)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $8cf3bd7ac14d1f7c$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $8cf3bd7ac14d1f7c$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $8cf3bd7ac14d1f7c$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $8cf3bd7ac14d1f7c$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(start, 0, limit);
        end = (0, $3abdb5770b94b18a$export$25ce5a424b770e84)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $8cf3bd7ac14d1f7c$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $3abdb5770b94b18a$export$90a7f3efeed30595)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $3abdb5770b94b18a$export$d141bba7fdc215a3)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$8cf3bd7ac14d1f7c$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $8cf3bd7ac14d1f7c$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($8cf3bd7ac14d1f7c$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $3abdb5770b94b18a$export$3722cfe417b6ed86)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $3abdb5770b94b18a$export$625550452a3fa3ec)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $8cf3bd7ac14d1f7c$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($8cf3bd7ac14d1f7c$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $3abdb5770b94b18a$export$71511d61b312f219)(values.sort($8cf3bd7ac14d1f7c$var$sorter));
    }
}
function $8cf3bd7ac14d1f7c$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $3abdb5770b94b18a$export$ef35774e6d314e91)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $3abdb5770b94b18a$export$ef35774e6d314e91)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $8cf3bd7ac14d1f7c$export$85df64a8eb6dc986 extends $8cf3bd7ac14d1f7c$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $8cf3bd7ac14d1f7c$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $8cf3bd7ac14d1f7c$var$interpolate(table, this.min);
        this._tableRange = $8cf3bd7ac14d1f7c$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($8cf3bd7ac14d1f7c$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $8cf3bd7ac14d1f7c$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $8cf3bd7ac14d1f7c$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $8cf3bd7ac14d1f7c$export$29e663ba4d09fe7,
    LinearScale: $8cf3bd7ac14d1f7c$export$e7f4e5e8656f0b93,
    LogarithmicScale: $8cf3bd7ac14d1f7c$export$85295eaf7cb3ac3e,
    RadialLinearScale: $8cf3bd7ac14d1f7c$export$cfafc36d95386d38,
    TimeScale: $8cf3bd7ac14d1f7c$export$a894c72689ff3ec,
    TimeSeriesScale: $8cf3bd7ac14d1f7c$export$85df64a8eb6dc986
});
const $8cf3bd7ac14d1f7c$export$e8959e79e3af550f = [
    $8cf3bd7ac14d1f7c$export$a6506504f799c5d5,
    $8cf3bd7ac14d1f7c$export$7a5d735b2ab6389d,
    $8cf3bd7ac14d1f7c$export$8b3ca321c77fdea6,
    $8cf3bd7ac14d1f7c$export$bcac1c16f1530ec2
];




var $baslc = parcelRequire("baslc");

const $4f032197ddc5851f$var$defaultDatasetIdKey = 'label';
function $4f032197ddc5851f$var$reforwardRef(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}
function $4f032197ddc5851f$var$setOptions(chart, nextOptions) {
    const options = chart.options;
    if (options && nextOptions) Object.assign(options, nextOptions);
}
function $4f032197ddc5851f$var$setLabels(currentData, nextLabels) {
    currentData.labels = nextLabels;
}
function $4f032197ddc5851f$var$setDatasets(currentData, nextDatasets, datasetIdKey = $4f032197ddc5851f$var$defaultDatasetIdKey) {
    const addedDatasets = [];
    currentData.datasets = nextDatasets.map((nextDataset)=>{
        // given the new set, find it's current match
        const currentDataset = currentData.datasets.find((dataset)=>dataset[datasetIdKey] === nextDataset[datasetIdKey]);
        // There is no original to update, so simply add new one
        if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) return {
            ...nextDataset
        };
        addedDatasets.push(currentDataset);
        Object.assign(currentDataset, nextDataset);
        return currentDataset;
    });
}
function $4f032197ddc5851f$var$cloneData(data, datasetIdKey = $4f032197ddc5851f$var$defaultDatasetIdKey) {
    const nextData = {
        labels: [],
        datasets: []
    };
    $4f032197ddc5851f$var$setLabels(nextData, data.labels);
    $4f032197ddc5851f$var$setDatasets(nextData, data.datasets, datasetIdKey);
    return nextData;
}
/**
 * Get dataset from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $4f032197ddc5851f$export$b2390aa6eb9120be(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'dataset', {
        intersect: true
    }, false);
}
/**
 * Get single dataset element from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $4f032197ddc5851f$export$7786cd514625a1ff(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'nearest', {
        intersect: true
    }, false);
}
/**
 * Get all dataset elements from mouse click event
 * @param chart - Chart.js instance
 * @param event - Mouse click event
 * @returns Dataset
 */ function $4f032197ddc5851f$export$6e8ebb3a5733e348(chart, event) {
    return chart.getElementsAtEventForMode(event.nativeEvent, 'index', {
        intersect: true
    }, false);
}
function $4f032197ddc5851f$var$ChartComponent(props, ref) {
    const { height: height = 150, width: width = 300, redraw: redraw = false, datasetIdKey: datasetIdKey, type: type, data: data, options: options, plugins: plugins = [], fallbackContent: fallbackContent, updateMode: updateMode, ...canvasProps } = props;
    const canvasRef = (0, $baslc.useRef)(null);
    const chartRef = (0, $baslc.useRef)(null);
    const renderChart = ()=>{
        if (!canvasRef.current) return;
        chartRef.current = new (0, $8cf3bd7ac14d1f7c$export$acaa6426d77a227e)(canvasRef.current, {
            type: type,
            data: $4f032197ddc5851f$var$cloneData(data, datasetIdKey),
            options: options && {
                ...options
            },
            plugins: plugins
        });
        $4f032197ddc5851f$var$reforwardRef(ref, chartRef.current);
    };
    const destroyChart = ()=>{
        $4f032197ddc5851f$var$reforwardRef(ref, null);
        if (chartRef.current) {
            chartRef.current.destroy();
            chartRef.current = null;
        }
    };
    (0, $baslc.useEffect)(()=>{
        if (!redraw && chartRef.current && options) $4f032197ddc5851f$var$setOptions(chartRef.current, options);
    }, [
        redraw,
        options
    ]);
    (0, $baslc.useEffect)(()=>{
        if (!redraw && chartRef.current) $4f032197ddc5851f$var$setLabels(chartRef.current.config.data, data.labels);
    }, [
        redraw,
        data.labels
    ]);
    (0, $baslc.useEffect)(()=>{
        if (!redraw && chartRef.current && data.datasets) $4f032197ddc5851f$var$setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }, [
        redraw,
        data.datasets
    ]);
    (0, $baslc.useEffect)(()=>{
        if (!chartRef.current) return;
        if (redraw) {
            destroyChart();
            setTimeout(renderChart);
        } else chartRef.current.update(updateMode);
    }, [
        redraw,
        options,
        data.labels,
        data.datasets,
        updateMode
    ]);
    (0, $baslc.useEffect)(()=>{
        if (!chartRef.current) return;
        destroyChart();
        setTimeout(renderChart);
    }, [
        type
    ]);
    (0, $baslc.useEffect)(()=>{
        renderChart();
        return ()=>destroyChart();
    }, []);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("canvas", {
        ref: canvasRef,
        role: "img",
        height: height,
        width: width,
        ...canvasProps,
        children: fallbackContent
    });
}
const $4f032197ddc5851f$export$acaa6426d77a227e = /*#__PURE__*/ (0, $baslc.forwardRef)($4f032197ddc5851f$var$ChartComponent);
function $4f032197ddc5851f$var$createTypedChart(type, registerables) {
    (0, $8cf3bd7ac14d1f7c$export$acaa6426d77a227e).register(registerables);
    return /*#__PURE__*/ (0, $baslc.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($4f032197ddc5851f$export$acaa6426d77a227e, {
            ...props,
            ref: ref,
            type: type
        }));
}
const $4f032197ddc5851f$export$17d680238e50603e = /* #__PURE__ */ $4f032197ddc5851f$var$createTypedChart('line', (0, $8cf3bd7ac14d1f7c$export$3c9b5d28c11cbfd0));
const $4f032197ddc5851f$export$bbc6c6369b38e3d1 = /* #__PURE__ */ $4f032197ddc5851f$var$createTypedChart('bar', (0, $8cf3bd7ac14d1f7c$export$e97d5dc64e999004));
const $4f032197ddc5851f$export$bace472c466fdd25 = /* #__PURE__ */ $4f032197ddc5851f$var$createTypedChart('radar', (0, $8cf3bd7ac14d1f7c$export$48dbc6ac651bf8be));
const $4f032197ddc5851f$export$b8b3cfdc3fe36b10 = /* #__PURE__ */ $4f032197ddc5851f$var$createTypedChart('doughnut', (0, $8cf3bd7ac14d1f7c$export$e04603e7d8b77172));
const $4f032197ddc5851f$export$d0dcaac1fc41ea1e = /* #__PURE__ */ $4f032197ddc5851f$var$createTypedChart('polarArea', (0, $8cf3bd7ac14d1f7c$export$2a270b3a0d973c85));
const $4f032197ddc5851f$export$646feb54fbadbe06 = /* #__PURE__ */ $4f032197ddc5851f$var$createTypedChart('bubble', (0, $8cf3bd7ac14d1f7c$export$19b5c4773f17abe));
const $4f032197ddc5851f$export$2ae8800cf67c848c = /* #__PURE__ */ $4f032197ddc5851f$var$createTypedChart('pie', (0, $8cf3bd7ac14d1f7c$export$b21a3f1286706191));
const $4f032197ddc5851f$export$1c460fb4285edadc = /* #__PURE__ */ $4f032197ddc5851f$var$createTypedChart('scatter', (0, $8cf3bd7ac14d1f7c$export$b2f2bae6713db87));


(0, $8cf3bd7ac14d1f7c$export$acaa6426d77a227e).register((0, $8cf3bd7ac14d1f7c$export$29e663ba4d09fe7), (0, $8cf3bd7ac14d1f7c$export$e7f4e5e8656f0b93), (0, $8cf3bd7ac14d1f7c$export$a16ed71bf4b07672), (0, $8cf3bd7ac14d1f7c$export$f99233281efd08a0), (0, $8cf3bd7ac14d1f7c$export$28c660c63b792dea), (0, $8cf3bd7ac14d1f7c$export$ed247974535929c7));
function $b250f783ccc87671$export$2d84115b1316e023({ data: data, options: options }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $4f032197ddc5851f$export$bbc6c6369b38e3d1), {
        data: data,
        options: {
            ...options,
            indexAxis: "y"
        }
    });
}




function $963dfd78a324624b$export$3f063810d7bf01bd(array, key) {
    return array.reduce((acc, item)=>{
        const groupKey = item[key];
        if (!acc[groupKey]) acc[groupKey] = [];
        acc[groupKey].push(item);
        return acc;
    }, {});
}





var $baslc = parcelRequire("baslc");
function $4d3dd54bcacc8247$export$6ab1df3197f7c641(a, b, operator, { caseSensitive: caseSensitive } = {
    caseSensitive: false
}) {
    if (operator === "eq") {
        // First try with simple equality
        if (caseSensitive ? a == b : $4d3dd54bcacc8247$var$asLowerCase(a) == $4d3dd54bcacc8247$var$asLowerCase(b)) return true;
        // If b is an array, check if a is in the array
        if (b instanceof Array) return b.some((item)=>(caseSensitive ? $4d3dd54bcacc8247$var$asLowerCase(item) : item) == (caseSensitive ? $4d3dd54bcacc8247$var$asLowerCase(a) : a));
    } else if (operator === "neq") return !$4d3dd54bcacc8247$export$6ab1df3197f7c641(a, b, "eq", {
        caseSensitive: caseSensitive
    });
    else if (operator === "contains") {
        const aAsString = caseSensitive ? $4d3dd54bcacc8247$var$asString(a) : $4d3dd54bcacc8247$var$asString($4d3dd54bcacc8247$var$asLowerCase(a));
        const bAsString = caseSensitive ? $4d3dd54bcacc8247$var$asString(b) : $4d3dd54bcacc8247$var$asString($4d3dd54bcacc8247$var$asLowerCase(b));
        if (aAsString !== undefined && bAsString !== undefined) return aAsString.includes(bAsString);
        if (a instanceof Array && b instanceof Array) return a.some((item)=>b.includes(item));
    } else if (operator === "notContains") return !$4d3dd54bcacc8247$export$6ab1df3197f7c641(a, b, "contains", {
        caseSensitive: caseSensitive
    });
    else if (operator === "startsWith") {
        const aAsString = caseSensitive ? $4d3dd54bcacc8247$var$asString(a) : $4d3dd54bcacc8247$var$asString($4d3dd54bcacc8247$var$asLowerCase(a));
        const bAsString = caseSensitive ? $4d3dd54bcacc8247$var$asString(b) : $4d3dd54bcacc8247$var$asString($4d3dd54bcacc8247$var$asLowerCase(b));
        if (aAsString !== undefined && bAsString !== undefined) return aAsString.startsWith(bAsString);
    } else if (operator === "endsWith") {
        const aAsString = caseSensitive ? $4d3dd54bcacc8247$var$asString(a) : $4d3dd54bcacc8247$var$asString($4d3dd54bcacc8247$var$asLowerCase(a));
        const bAsString = caseSensitive ? $4d3dd54bcacc8247$var$asString(b) : $4d3dd54bcacc8247$var$asString($4d3dd54bcacc8247$var$asLowerCase(b));
        if (aAsString !== undefined && bAsString !== undefined) return aAsString.endsWith(bAsString);
    } else if (operator === "between") {
        const aAsString = caseSensitive ? $4d3dd54bcacc8247$var$asString(a) : $4d3dd54bcacc8247$var$asString($4d3dd54bcacc8247$var$asLowerCase(a));
        const bAsString = caseSensitive ? $4d3dd54bcacc8247$var$asString(b) : $4d3dd54bcacc8247$var$asString($4d3dd54bcacc8247$var$asLowerCase(b));
        if (aAsString !== undefined && bAsString !== undefined) return aAsString >= bAsString && aAsString <= bAsString;
        if (a instanceof Date && b instanceof Date) return a.getTime() >= b.getTime() && a.getTime() <= b.getTime();
    }
    return false;
}
function $4d3dd54bcacc8247$var$asLowerCase(value) {
    if (typeof value === "string") return value.toLowerCase();
    return value;
}
function $4d3dd54bcacc8247$var$asString(value) {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return value.toString();
    else if (typeof value === "object" && value !== null && value !== undefined && "toString" in value && typeof value.toString === "function") {
        const stringValue = value.toString();
        if (typeof stringValue === "string") return stringValue;
    }
}








var $baslc = parcelRequire("baslc");
function $723857eee6c9c7df$export$5b6b19405a83ff9d({ children: children, handler: handler, offset: offset = {
    x: 0,
    y: 20
}, ref: ref }) {
    const [open, setOpen] = (0, $baslc.useState)(false);
    const divRef = (0, $baslc.useRef)(null);
    (0, $baslc.useImperativeHandle)(ref, ()=>({
            open: ()=>setOpen(true),
            close: ()=>setOpen(false)
        }));
    (0, $baslc.useEffect)(()=>{
        function handleClickOutside(event) {
            if (divRef.current && !divRef.current.contains(event.target)) setOpen(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    const handleClick = ()=>{
        setOpen(!open);
    };
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        ref: divRef,
        className: "relative",
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("button", {
                className: "cursor-pointer",
                onClick: handleClick,
                children: handler
            }),
            open && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                className: "absolute z-100",
                style: {
                    top: offset.y,
                    right: offset.x
                },
                children: children
            })
        ]
    });
}


function $adc96f1fffecb045$export$816b5d811295e6bc(_props) {
    return null;
}
function $adc96f1fffecb045$export$69b11f8bdc00efe8({ children: children, tdClassName: tdClassName }) {
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($baslc))).Children.toArray(children).filter((child)=>typeof child === "object" && child !== null && "type" in child && typeof child.type === "string" && child.type === "td");
    return columns.map((column, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("td", {
            ...column.props,
            className: `${tdClassName} ${column.props.className ?? ""}`,
            children: column.props.children
        }, index));
}
function $adc96f1fffecb045$export$3e502d9a2f7b0e57({ children: children, tdClassName: tdClassName }) {
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($baslc))).Children.toArray(children).filter((child)=>typeof child === "object" && child !== null && "type" in child && typeof child.type === "string" && child.type === "td");
    return columns.map((column, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("td", {
            ...column.props,
            className: `${tdClassName} ${column.props.className ?? ""}`,
            children: column.props.children
        }, index));
}
function $adc96f1fffecb045$export$54ec01a60f47d33d({ data: data, subListBy: subListBy, children: children, sortable: sortable = true, sortBy: sortBy, sortByDirection: sortByDirection = "asc", groupBy: groupBy, onSort: onSort, filterBy: filterBy = [], onFilter: onFilter, showFieldSelector: showFieldSelector = false, onFieldSelectorChange: onFieldSelectorChange, selectedColumns: selectedColumns, actions: actions, viewRouteButton: viewRouteButton, editRouteButton: editRouteButton, removeRouteButton: removeRouteButton, locale: locale }) {
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($baslc))).Children.toArray(children).filter((child)=>typeof child === "object" && child !== null && "type" in child && typeof child.type === "function" && child.type.name === $adc96f1fffecb045$export$816b5d811295e6bc.name);
    const prefixRow = (0, (/*@__PURE__*/$parcel$interopDefault($baslc))).Children.toArray(children).filter((child)=>typeof child === "object" && child !== null && "type" in child && typeof child.type === "function" && child.type.name === $adc96f1fffecb045$export$69b11f8bdc00efe8.name)[0];
    const suffixRow = (0, (/*@__PURE__*/$parcel$interopDefault($baslc))).Children.toArray(children).filter((child)=>typeof child === "object" && child !== null && "type" in child && typeof child.type === "function" && child.type.name === $adc96f1fffecb045$export$3e502d9a2f7b0e57.name)[0];
    const [sortField, setSortField] = (0, $baslc.useState)(sortBy ?? "");
    const sortColumnCallback = (0, $baslc.useRef)(undefined);
    const [sortDirection, setSortDirection] = (0, $baslc.useState)(sortByDirection ?? "asc");
    const sortedData = (0, $baslc.useMemo)(()=>{
        const a = [
            ...data
        ].sort((a, b)=>{
            const fieldValueA = (0, $c4ca4a382efaa136$export$649085c284c9b129)(a, sortField);
            const fieldValueB = (0, $c4ca4a382efaa136$export$649085c284c9b129)(b, sortField);
            if (sortColumnCallback.current) return sortColumnCallback.current(a, b, sortField, sortDirection);
            let result = 0;
            if (typeof fieldValueA === "string" && typeof fieldValueB === "string") result = fieldValueA.localeCompare(fieldValueB);
            else if (typeof fieldValueA === "number" && typeof fieldValueB === "number") result = fieldValueA - fieldValueB;
            else if (fieldValueA instanceof Date && fieldValueB instanceof Date) result = fieldValueA.getTime() - fieldValueB.getTime();
            else // Last resort comparing values as numbers. This might fail if values are not comparable
            result = fieldValueA - fieldValueB;
            if (fieldValueA === undefined) return -1;
            if (fieldValueB === undefined) return 1;
            if (sortDirection === "asc") return result;
            return -result;
        });
        if (groupBy) return (0, $963dfd78a324624b$export$3f063810d7bf01bd)(a, groupBy);
        else return {
            all: a
        };
    }, [
        data,
        sortField,
        sortDirection,
        sortColumnCallback,
        groupBy
    ]);
    const cellPadding = "py-2 px-4";
    const cellAlign = "text-left";
    const headerClassName = `${cellPadding} ${cellAlign} font-normal bg-gray-100 border-b-1 border-gray-300 whitespace-nowrap`;
    const cellClassName = `${cellPadding} ${cellAlign} text-gray-500 border-b-1 border-gray-300`;
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        className: "w-full flex flex-col gap-2",
        children: [
            showFieldSelector && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6fc41a6ad1597c99$export$931cbfb6bfb85fc), {
                asCheckbox: true,
                showSelectAll: true,
                buttonSeverity: "secondary",
                buttonSize: "sm",
                itemClassName: "hover:bg-gray-400",
                label: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                    icon: (0, $159afdcd077ecfe9$export$f253a38d7142e29f)
                }),
                listClassName: "bg-gray-200 whitespace-nowrap rounded-sm border-1 border-black",
                options: columns.map((column)=>({
                        label: column.props.children ?? column.props.label ?? column.props.field,
                        value: column.props.field,
                        checked: selectedColumns?.some((c)=>{
                            return c === column.props.field;
                        }) || column.props.alwaysShow,
                        disabled: column.props.alwaysShow
                    })),
                onSelect: (value)=>{
                    onFieldSelectorChange?.($adc96f1fffecb045$var$toggleValueFromArray(selectedColumns ?? [], value));
                },
                onSelectAll: ()=>{
                    if (selectedColumns?.length === columns.filter((column)=>!column.props.alwaysShow).length) onFieldSelectorChange?.([]);
                    else onFieldSelectorChange?.(columns.filter((column)=>column.props.field && !column.props.alwaysShow).map((column)=>column.props.field ?? ""));
                }
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("table", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("tr", {
                            children: [
                                subListBy && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("th", {
                                    className: `${headerClassName} text-left w-1`
                                }),
                                columns.filter((column)=>!showFieldSelector || column.props.alwaysShow || column.props.field === undefined || selectedColumns === undefined || selectedColumns?.includes(column.props.field)).map((column, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$var$TableHeader, {
                                        className: `${headerClassName} ${column.props.headerClassName ?? ""}`,
                                        field: column.props.field,
                                        filterableBy: column.props.filterableBy,
                                        filterBy: filterBy,
                                        filterOptions: column.props.filterOptions?.(data),
                                        header: column.props.header,
                                        hideFilter: column.props.hideFilter,
                                        sortable: sortable ? column.props.sortable : false,
                                        sortDirection: sortByDirection,
                                        sortField: sortBy,
                                        onFilter: onFilter,
                                        onSort: (field, direction)=>{
                                            onSort?.(field, direction);
                                            sortColumnCallback.current = column.props.sortCallback;
                                            setSortField(field);
                                            setSortDirection(direction);
                                        },
                                        children: column.props.children
                                    }, column.props.field ?? `header-${index}`)),
                                (actions || viewRouteButton || editRouteButton || removeRouteButton) && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("th", {
                                    className: `${headerClassName} text-right`,
                                    children: locale && locale.actions ? locale.actions : "ACTIONS"
                                })
                            ]
                        })
                    }),
                    prefixRow && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("tbody", {
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("tr", {
                            className: `${prefixRow.props.className ?? ""}`,
                            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$export$69b11f8bdc00efe8, {
                                tdClassName: `${cellClassName}`,
                                ...prefixRow.props
                            })
                        })
                    }),
                    Object.entries(sortedData).map(([key, value])=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$var$TableGroup, {
                            actions: actions,
                            cellClassName: cellClassName,
                            columns: columns,
                            editRouteButton: editRouteButton,
                            filterBy: filterBy,
                            groupBy: groupBy,
                            groupName: key,
                            locale: locale,
                            removeRouteButton: removeRouteButton,
                            rows: value,
                            selectedColumns: selectedColumns,
                            showFieldSelector: showFieldSelector,
                            subListBy: subListBy,
                            viewRouteButton: viewRouteButton
                        }, key)),
                    suffixRow && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("tbody", {
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("tr", {
                            className: `${suffixRow.props.className ?? ""}`,
                            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$export$3e502d9a2f7b0e57, {
                                tdClassName: `${cellClassName}`,
                                ...suffixRow.props
                            })
                        })
                    })
                ]
            })
        ]
    });
}
function $adc96f1fffecb045$var$TableHeader({ field: field, header: header, className: className, children: children, sortable: sortable = true, filterableBy: filterableBy, hideFilter: hideFilter, filterOptions: filterOptions, onFilter: onFilter, sortField: sortField, sortDirection: sortDirection, filterBy: filterBy, onSort: onSort }) {
    const isSortedByField = sortField === field;
    const isSortedAsc = isSortedByField && sortDirection === "asc";
    let sortIcon = (0, $159afdcd077ecfe9$export$4941c5969d5399b);
    if (isSortedByField) sortIcon = isSortedAsc ? (0, $159afdcd077ecfe9$export$7de776bdab4e536d) : (0, $159afdcd077ecfe9$export$f9395ef707603e40);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("th", {
        className: className,
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("button", {
                    className: `flex items-center gap-2 ${sortable ? "cursor-pointer" : ""}`,
                    onClick: ()=>{
                        if (sortable && field) onSort(field, isSortedAsc ? "desc" : "asc");
                    },
                    children: [
                        header?.() ?? children ?? field,
                        sortable && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                            icon: sortIcon
                        })
                    ]
                }),
                field && filterableBy && !hideFilter && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$var$ColumnFilter, {
                    field: field,
                    filterableBy: filterableBy,
                    filterOptions: filterOptions,
                    value: filterBy?.find((filter)=>filter.field === field)?.value ?? [],
                    onFilter: (filter)=>{
                        onFilter?.([
                            // Remove already existing filters for this field
                            ...filterBy?.filter((filter)=>filter.field !== field) ?? [],
                            // Add new filter if it's not empty
                            ...!$adc96f1fffecb045$var$isFilterValueEmpty(filter) ? [
                                filter
                            ] : []
                        ]);
                    }
                })
            ]
        })
    }, field);
}
function $adc96f1fffecb045$var$TableGroup({ rows: rows, groupBy: groupBy, filterBy: filterBy, cellClassName: cellClassName, columns: columns, groupName: groupName, actions: actions, editRouteButton: editRouteButton, locale: locale, removeRouteButton: removeRouteButton, selectedColumns: selectedColumns, showFieldSelector: showFieldSelector, subListBy: subListBy, viewRouteButton: viewRouteButton }) {
    const [folded, setFolded] = (0, $baslc.useState)(false);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $d6899a6188537778$exports.Fragment), {
        children: [
            groupBy && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("tr", {
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("td", {
                    className: `${cellClassName} font-bold`,
                    colSpan: columns.length + 1,
                    children: [
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("button", {
                            onClick: ()=>setFolded(!folded),
                            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                icon: folded ? (0, $159afdcd077ecfe9$export$930de8c26eb20490) : (0, $159afdcd077ecfe9$export$8db9bc521720fccd)
                            })
                        }),
                        groupName
                    ]
                })
            }),
            !folded && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("tbody", {
                children: rows.filter((row)=>$adc96f1fffecb045$var$filterData(row, filterBy ?? [])).map((row, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$var$TableRow, {
                        actions: actions,
                        cellClassName: cellClassName,
                        columns: columns,
                        editRouteButton: editRouteButton,
                        index: index,
                        locale: locale,
                        removeRouteButton: removeRouteButton,
                        row: row,
                        selectedColumns: selectedColumns,
                        showFieldSelector: showFieldSelector,
                        subListBy: subListBy,
                        viewRouteButton: viewRouteButton
                    }, `row-${index}`))
            })
        ]
    });
}
function $adc96f1fffecb045$var$TableRow({ index: index, columns: columns, showFieldSelector: showFieldSelector, selectedColumns: selectedColumns, cellClassName: cellClassName, row: row, actions: actions, viewRouteButton: viewRouteButton, editRouteButton: editRouteButton, removeRouteButton: removeRouteButton, locale: locale, subListBy: subListBy, isSubList: isSubList = false }) {
    const subList = subListBy ? (0, $c4ca4a382efaa136$export$649085c284c9b129)(row, subListBy) : undefined;
    const subListCount = subList ? subList.length : 0;
    const isSubListView = subListBy || isSubList;
    const [isSubListExpanded, setIsSubListExpanded] = (0, $baslc.useState)(false);
    const subListClassName = `${cellClassName} ${isSubList ? "bg-gray-300" : ""}`;
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $d6899a6188537778$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("tr", {
                children: [
                    isSubListView && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("td", {
                        className: `${subListClassName} text-left`,
                        children: subListCount > 0 && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                            size: "sm",
                            text: true,
                            onClick: ()=>setIsSubListExpanded(!isSubListExpanded),
                            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                icon: isSubListExpanded ? (0, $159afdcd077ecfe9$export$8db9bc521720fccd) : (0, $159afdcd077ecfe9$export$930de8c26eb20490)
                            })
                        })
                    }),
                    columns.filter((column)=>!showFieldSelector || column.props.alwaysShow || column.props.field === undefined || selectedColumns === undefined || selectedColumns.includes(column.props.field)).map((column, columnIndex)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$var$TableBody, {
                            body: column.props.body,
                            className: `${subListClassName} ${column.props.bodyClassName ?? ""}`,
                            data: row,
                            field: column.props.field,
                            index: index,
                            locale: locale
                        }, column.props.field ?? `body-${columnIndex}`)),
                    (actions || viewRouteButton || editRouteButton || removeRouteButton) && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("td", {
                        className: `${cellClassName} text-right`,
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                            className: "flex gap-2 justify-end",
                            children: [
                                actions && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$var$ActionsDropdown, {
                                    actions: actions(row, index),
                                    index: index,
                                    row: row
                                }),
                                viewRouteButton && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    route: viewRouteButton(row, index),
                                    size: "sm",
                                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                        icon: (0, $159afdcd077ecfe9$export$b8c3e79e8c99c95b)
                                    })
                                }),
                                editRouteButton && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    route: editRouteButton(row, index),
                                    severity: "secondary",
                                    size: "sm",
                                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                        icon: (0, $159afdcd077ecfe9$export$7be713e57d023733)
                                    })
                                }),
                                removeRouteButton && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    route: removeRouteButton(row, index),
                                    severity: "danger",
                                    size: "sm",
                                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                        icon: (0, $159afdcd077ecfe9$export$ed8c149a0ea54bb4)
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            subList && isSubListExpanded && subList.map((subRow, subIndex)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($adc96f1fffecb045$var$TableRow, {
                    actions: actions,
                    cellClassName: cellClassName,
                    columns: columns,
                    editRouteButton: editRouteButton,
                    index: subIndex,
                    isSubList: true,
                    locale: locale,
                    removeRouteButton: removeRouteButton,
                    row: subRow,
                    selectedColumns: selectedColumns,
                    showFieldSelector: showFieldSelector,
                    viewRouteButton: viewRouteButton
                }, `subRow-${subIndex}`))
        ]
    });
}
function $adc96f1fffecb045$var$TableBody({ field: field, className: className, body: body, index: index, data: data, locale: locale }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("td", {
        className: className,
        children: body?.(data, index) ?? (field && $adc96f1fffecb045$var$formatFieldValue((0, $c4ca4a382efaa136$export$649085c284c9b129)(data, field), locale))
    });
}
function $adc96f1fffecb045$var$ColumnFilter({ field: field, filterableBy: filterableBy, filterOptions: filterOptions, value: value, fromValue: fromValue, toValue: toValue, onFilter: onFilter }) {
    const [inputValue, setInputValue] = (0, $baslc.useState)(value?.toString() ?? "");
    const [inputFromValue, setInputFromValue] = (0, $baslc.useState)(fromValue?.toString() ?? "");
    const [inputToValue, setInputToValue] = (0, $baslc.useState)(toValue?.toString() ?? "");
    const isFilterApplied = value && value instanceof Array ? value.length > 0 : value !== "";
    const popoverRef = (0, $baslc.useRef)(null);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $723857eee6c9c7df$export$5b6b19405a83ff9d), {
        ref: popoverRef,
        handler: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
            className: `border-b-2 relative top-[2px] ${isFilterApplied ? "border-black" : "border-transparent"}`,
            icon: (0, $159afdcd077ecfe9$export$f253a38d7142e29f)
        }),
        offset: {
            x: 0,
            y: 22
        },
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
            className: "flex flex-col gap-2 bg-gray-200 p-2 min-w-[250px] border-1 border-gray-300",
            children: [
                filterableBy === "date" && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("form", {
                    className: "flex flex-col gap-2",
                    onSubmit: (e)=>{
                        e.preventDefault();
                        onFilter({
                            field: field,
                            fromValue: inputFromValue,
                            toValue: inputToValue,
                            operator: "between"
                        });
                        popoverRef.current?.close();
                    },
                    children: [
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                            className: "flex items-center gap-2 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("span", {
                                    className: "w-[50px]",
                                    children: "From"
                                }),
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                                    clearButton: true,
                                    type: "date",
                                    value: inputFromValue,
                                    onChange: (e)=>setInputFromValue(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                            className: "flex items-center gap-2 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("span", {
                                    className: "w-[50px]",
                                    children: "To"
                                }),
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                                    clearButton: true,
                                    type: "date",
                                    value: inputToValue,
                                    onChange: (e)=>setInputToValue(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                            className: "flex gap-2 justify-between",
                            children: [
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    size: "sm",
                                    type: "submit",
                                    children: "Apply"
                                }),
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    severity: "danger",
                                    size: "sm",
                                    type: "button",
                                    onClick: ()=>{
                                        setInputFromValue("");
                                        setInputToValue("");
                                        onFilter({
                                            field: field,
                                            fromValue: "",
                                            toValue: "",
                                            operator: "between"
                                        });
                                        popoverRef.current?.close();
                                    },
                                    children: "Clear"
                                })
                            ]
                        })
                    ]
                }),
                filterableBy === "select" && filterOptions && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("ul", {
                    className: "flex flex-col gap-2",
                    children: filterOptions.map((option, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6e3e385dd5320e62$export$48513f6b9f8ce62d), {
                                checked: value && value instanceof Array ? value.includes(option.value) : false,
                                className: "flex items-center gap-2",
                                label: option.label,
                                onClick: ()=>{
                                    if (value && value instanceof Array) onFilter({
                                        field: field,
                                        value: $adc96f1fffecb045$var$toggleValueFromArray(value && value instanceof Array ? value : [], option.value),
                                        operator: "eq"
                                    });
                                }
                            })
                        }, index))
                }),
                " ",
                filterableBy === "text" && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("form", {
                    className: "flex gap-2",
                    onSubmit: (e)=>{
                        e.preventDefault();
                        onFilter({
                            field: field,
                            value: inputValue,
                            operator: "contains"
                        });
                        popoverRef.current?.close();
                    },
                    children: [
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                            clearButton: true,
                            inputClassName: "min-w-[150px]",
                            size: "sm",
                            type: "text",
                            value: inputValue,
                            onChange: (e)=>setInputValue(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                            size: "sm",
                            type: "submit",
                            children: "Apply"
                        })
                    ]
                })
            ]
        })
    });
}
function $adc96f1fffecb045$var$ActionsDropdown({ actions: actions, row: row, index: index }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6fc41a6ad1597c99$export$931cbfb6bfb85fc), {
        buttonSeverity: "secondary",
        buttonSize: "sm",
        disabled: actions.length === 0,
        itemClassName: "hover:bg-gray-400",
        label: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
            icon: (0, $159afdcd077ecfe9$export$d6298bbfd1912a78)
        }),
        listClassName: "bg-gray-200 whitespace-nowrap rounded-sm border-1 border-black",
        options: actions.map((action, index)=>({
                label: action.label,
                value: index.toString(),
                ...action.route ? {
                    route: action.route
                } : {}
            })),
        onSelect: (value)=>{
            const action = actions[parseInt(value)];
            action?.onClick?.(row, index);
        }
    });
}
function $adc96f1fffecb045$var$formatFieldValue(value, locale) {
    if (value instanceof Date) return value.toLocaleDateString();
    else if (typeof value === "boolean") {
        if (locale) return value ? locale.yes : locale.no;
        return value ? "TRUE" : "FALSE";
    }
    return value;
}
function $adc96f1fffecb045$var$toggleValueFromArray(array, value) {
    if (array.includes(value)) return array.filter((v)=>v !== value);
    return [
        ...array,
        value
    ];
}
function $adc96f1fffecb045$var$isFilterValueEmpty(filter) {
    const value = filter.value;
    return value instanceof Array && value.length === 0 || value === "" && value !== undefined || filter.fromValue === "" && filter.fromValue !== undefined && filter.toValue === "" && filter.toValue !== undefined;
}
function $adc96f1fffecb045$var$filterData(row, filterBy) {
    return filterBy.every((filter)=>{
        return (0, $4d3dd54bcacc8247$export$6ab1df3197f7c641)((0, $c4ca4a382efaa136$export$649085c284c9b129)(row, filter.field), filter.value, filter.operator);
    });
}


function $8d77b77ae509536d$export$a3d29e8c181d435({ project: project }) {
    const [searchParams, setSearchParams] = (0, $c9ac255259af38e5$export$f1a78c17382fe22a)();
    function updateSearchParams(params) {
        setSearchParams({
            ...Object.fromEntries(searchParams.entries()),
            ...params
        });
    }
    const { data: tasks } = (0, $fd27c95543d7b34e$export$ed5c3368304694)(project);
    const { data: times } = (0, $f95462c870cb2158$export$81f28d8f5590a939)({
        project: project,
        from: new Date("2026-01-01"),
        to: new Date("2026-12-31")
    });
    const [sortBy, setSortBy] = (0, $baslc.useState)({
        field: "from",
        direction: "desc"
    });
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $adc96f1fffecb045$export$54ec01a60f47d33d), {
                data: times || [],
                filterBy: JSON.parse(searchParams.get("filterBy") || "[]"),
                groupBy: "task",
                sortBy: sortBy.field,
                sortByDirection: sortBy.direction,
                onFilter: (value)=>{
                    updateSearchParams({
                        filterBy: JSON.stringify(value)
                    });
                },
                onSort: (field, direction)=>setSortBy({
                        field: field,
                        direction: direction
                    }),
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $adc96f1fffecb045$export$816b5d811295e6bc), {
                        field: "from",
                        filterableBy: "date",
                        children: "Date"
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $adc96f1fffecb045$export$816b5d811295e6bc), {
                        field: "hours",
                        children: "Hours"
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $adc96f1fffecb045$export$816b5d811295e6bc), {
                        field: "description",
                        children: "description"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $b250f783ccc87671$export$2d84115b1316e023), {
                data: {
                    labels: tasks?.map((task)=>task.name) || [],
                    datasets: [
                        {
                            data: tasks?.map((task)=>task.hours) || []
                        }
                    ]
                },
                options: {
                    animation: false,
                    plugins: {
                        legend: {
                            display: false
                        }
                    }
                }
            })
        ]
    });
}





function $a5c0bab2dd46a481$export$ef9b1a59e592288f({ label: label, value: value, onChange: onChange, placeholder: placeholder, allowEmpty: allowEmpty = false, options: options, disabled: disabled = false, className: className }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        className: `relative ${className ?? ""}`,
        children: [
            label && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("label", {
                className: `block text-sm font-medium ${disabled ? "text-gray-400 cursor-not-allowed" : "text-gray-500"}`,
                children: label
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("select", {
                className: "w-full border-1 border-gray-300 rounded-xs p-2 bg-white disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed",
                disabled: disabled,
                value: value,
                onChange: (e)=>onChange?.(e.target.value),
                children: [
                    placeholder && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("option", {
                        disabled: true,
                        value: "",
                        children: placeholder
                    }),
                    options.map((option)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("option", {
                            disabled: option.disabled,
                            value: option.value,
                            children: option.label
                        }, option.value))
                ]
            }),
            allowEmpty && value !== "" && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("button", {
                className: "absolute right-5 top-7 cursor-pointer",
                type: "button",
                onClick: ()=>onChange?.(""),
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                    icon: (0, $159afdcd077ecfe9$export$174bd7f477b115b4)
                })
            })
        ]
    });
}





const $039ea3b1cea48a20$export$5dbe7eae4180916c = $8ad647561ba7dbe6$export$22b082955e083ec3();
const $039ea3b1cea48a20$export$e2d323ecae4dde49 = $8ad647561ba7dbe6$export$2f23118c22fb2630($039ea3b1cea48a20$export$5dbe7eae4180916c);



const $f733fd43720a7a91$var$API_BASE_URL = "/api";
async function $f733fd43720a7a91$export$b00a271f69f3d728() {
    const response = await fetch(`${$f733fd43720a7a91$var$API_BASE_URL}/project`);
    if (response.status === 401) throw (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED;
    else if (!response.ok) throw new Error("Failed to get projects");
    return (0, $039ea3b1cea48a20$export$e2d323ecae4dde49).parse(await response.json());
}


const $236361917f440320$export$39d4f31fc4866d70 = ()=>{
    return (0, $0da705b248c5c0f3$export$dd0a697e1782aedd)({
        queryKey: [
            "get-projects"
        ],
        queryFn: ()=>(0, $f733fd43720a7a91$export$b00a271f69f3d728)(),
        staleTime: 3600000,
        retry: (_failureCount, error)=>error !== (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED
    });
};



function $12d80cfc63c01b2f$export$33aa3110c4070c17() {
    const { data: projects, isLoading: isProjectsLoading } = (0, $236361917f440320$export$39d4f31fc4866d70)();
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const [selectedProject, setSelectedProject] = (0, $baslc.useState)(projects?.[0] ?? "");
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        children: isProjectsLoading ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
            children: "Loading..."
        }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $d6899a6188537778$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $a5c0bab2dd46a481$export$ef9b1a59e592288f), {
                    label: t.time.project,
                    options: projects?.map((project)=>({
                            label: project,
                            value: project
                        })) || [],
                    placeholder: t.time.project,
                    value: selectedProject,
                    onChange: setSelectedProject
                }),
                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $8d77b77ae509536d$export$a3d29e8c181d435), {
                    project: selectedProject
                })
            ]
        })
    });
}







var $baslc = parcelRequire("baslc");



function $245ba416705dd1ed$export$69b1032f2ecdf404({ children: children }) {
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        className: "flex [&>*:not(:first-child):not(:last-child)]:rounded-none [&>*:first-child]:rounded-r-none [&>*:last-child]:rounded-l-none",
        children: children
    });
}






function $133d3bfd6646424c$export$9a59ccf3e6623d30({ date: date }) {
    const localeName = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.currentLocaleName);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $9a68f0ca0a43dd03$export$5523b16adee8048), {
        className: "flex items-center gap-2",
        children: [
            $133d3bfd6646424c$var$getDayName(date, localeName),
            " ",
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("span", {
                className: "text-gray-400",
                children: [
                    $133d3bfd6646424c$var$getDay(date),
                    " ",
                    $133d3bfd6646424c$var$getShortMonth(date, localeName)
                ]
            })
        ]
    });
}
function $133d3bfd6646424c$var$getDayName(date, localeName) {
    return date.toLocaleDateString(localeName, {
        weekday: "long"
    });
}
function $133d3bfd6646424c$var$getShortMonth(date, localeName) {
    return date.toLocaleDateString(localeName, {
        month: "short"
    });
}
function $133d3bfd6646424c$var$getDay(date) {
    return (0, $711b938d01d2606f$export$bc3bea8325045070)(date.getDate(), 2);
}



function $ae64181859a03e44$export$218c8c3169c024d2(id) {
    return id.split(":")[1] || id;
}







var $baslc = parcelRequire("baslc");




const $1acd7cd2e978431e$var$ConfirmContext = /*#__PURE__*/ (0, $baslc.createContext)(null);
function $1acd7cd2e978431e$export$2245215e6bd26540({ children: children }) {
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const [open, setOpen] = (0, $baslc.useState)(false);
    const [opts, setOpts] = (0, $baslc.useState)(null);
    const [loading, setLoading] = (0, $baslc.useState)(false);
    // store the resolver for the active promise
    const resolverRef = (0, $baslc.useRef)(null);
    const close = (0, $baslc.useCallback)((result)=>{
        setOpen(false);
        setOpts(null);
        setLoading(false);
        resolverRef.current?.(result);
        resolverRef.current = null;
    }, []);
    const confirm = (0, $baslc.useCallback)((options)=>{
        setOpts(options);
        setOpen(true);
        setLoading(false);
        return new Promise((resolve)=>{
            resolverRef.current = resolve;
        });
    }, []);
    const value = (0, $baslc.useMemo)(()=>({
            confirm: confirm
        }), [
        confirm
    ]);
    const type = opts?.type || "yes-no";
    const header = opts?.header || t.confirmation;
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)($1acd7cd2e978431e$var$ConfirmContext.Provider, {
        value: value,
        children: [
            children,
            open && opts && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $5876bcf854e2183c$export$2b77a92f1a5ad772), {
                open: true,
                size: "xs",
                onClose: ()=>close(false),
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("form", {
                    className: "flex-1 flex flex-col items-center gap-4",
                    onSubmit: (e)=>{
                        e.preventDefault();
                        (async ()=>{
                            if (opts.resolverBeforeClose) {
                                setLoading(true);
                                await opts.resolverBeforeClose();
                                setLoading(false);
                            }
                            close(true);
                        })();
                    },
                    children: [
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $9a68f0ca0a43dd03$export$5523b16adee8048), {
                            children: header
                        }),
                        opts.message && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("p", {
                            children: opts.message
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                            className: "flex-1 flex items-center gap-4",
                            children: [
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    loading: loading,
                                    severity: type === "yes-no" ? "primary" : "danger",
                                    type: "submit",
                                    children: type === "yes-no" ? t.yes : t.ok
                                }),
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    disabled: loading,
                                    severity: "secondary",
                                    type: "button",
                                    onClick: ()=>close(false),
                                    children: type === "yes-no" ? t.no : t.cancel
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $1acd7cd2e978431e$export$bf4da147a5964edb() {
    const ctx = (0, $baslc.useContext)($1acd7cd2e978431e$var$ConfirmContext);
    if (!ctx) throw new Error("useConfirm must be used within a ConfirmProvider");
    return ctx.confirm;
}





function $59db8e72061ca567$export$c14ce44379ce803a(surrealId) {
    const id = surrealId.split(":")[1];
    if (id === undefined) throw new Error("Invalid surreal id");
    return id;
}
function $59db8e72061ca567$export$198e933fb11dc097(table, id) {
    return `${table}:${id}`;
}


function $b6e0b58b8c4d7e7d$export$b2da1ca3b2ae4215(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0, 0);
}


function $41979425e36fe33c$export$ea39ec197993aef0(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
}


function $14901507c0465732$export$30a06c8d3562193f(obj, keys) {
    return Object.fromEntries(Object.entries(obj).filter(([key])=>!keys.includes(key)));
}





var $baslc = parcelRequire("baslc");

function $55a2f4e915921dc6$export$9b34edc570ae20bd({ times: times, flashColonIfActive: flashColonIfActive = true }) {
    const [value, setValue] = (0, $baslc.useState)(undefined);
    function isAnyActive(times) {
        return times.some((t)=>!t.to);
    }
    (0, $baslc.useEffect)(()=>{
        setValue($55a2f4e915921dc6$var$totalTime(times, true));
        if (isAnyActive(times)) {
            let showColon = false;
            const interval = setInterval(()=>{
                setValue($55a2f4e915921dc6$var$totalTime(times, showColon || !flashColonIfActive));
                showColon = !showColon;
            }, 1000);
            return ()=>clearInterval(interval);
        }
    }, [
        times,
        flashColonIfActive
    ]);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $d6899a6188537778$exports.Fragment), {
        children: value
    });
}
function $55a2f4e915921dc6$var$totalTime(times, showColon = true) {
    const totalTime1 = times.reduce((acc, t)=>{
        return acc + $55a2f4e915921dc6$export$c675f156110dd138(t.from, t.to ?? new Date());
    }, 0);
    const totalHours = Math.floor(totalTime1 / 3600000);
    const totalMinutes = Math.floor(totalTime1 % 3600000 / 60000);
    return `${totalHours}${showColon ? ":" : " "}${(0, $711b938d01d2606f$export$bc3bea8325045070)(totalMinutes, 2)}`;
}
function $55a2f4e915921dc6$export$c675f156110dd138(from, to) {
    return to.getTime() - from.getTime();
}


function $869c29730bfd90b0$export$2b1f73527d7bd6b5({ date: date, times: times, queryParamForEditLink: queryParamForEditLink, onListChange: onListChange }) {
    const navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    const confirm = (0, $1acd7cd2e978431e$export$bf4da147a5964edb)();
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    function isActive(time) {
        return !time.to;
    }
    function startTime(time) {
        (async ()=>{
            let redirectToNow = false;
            const now = (0, $b6e0b58b8c4d7e7d$export$b2da1ca3b2ae4215)(new Date());
            if (!(0, $41979425e36fe33c$export$ea39ec197993aef0)(now, date)) try {
                await confirm({
                    message: t.time.confirmStartDifferentDay,
                    header: t.confirmation
                });
                redirectToNow = true;
            } catch (error) {
                return;
            }
            await (0, $56c35c168e39dea0$export$b9cfd76caec8e929)({
                ...(0, $14901507c0465732$export$30a06c8d3562193f)(time, [
                    "id",
                    "from",
                    "to"
                ]),
                from: now
            });
            if (redirectToNow) navigate(`/time?date=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(now)}`);
            else onListChange?.();
        })();
    }
    function stopTime(time) {
        (async ()=>{
            await (0, $56c35c168e39dea0$export$8a41ea59a31e0100)((0, $ae64181859a03e44$export$218c8c3169c024d2)(time.id), {
                ...time,
                to: (0, $b6e0b58b8c4d7e7d$export$b2da1ca3b2ae4215)(new Date())
            });
            onListChange?.();
        })();
    }
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $d6899a6188537778$exports.Fragment), {
        children: [
            times.map((t)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                    className: `p-4 min-h-24 flex gap-5 border-b border-gray-200 ${isActive(t) ? "bg-gray-100" : ""}`,
                    children: [
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                            className: "grow flex flex-col",
                            children: [
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("p", {
                                    className: "font-bold",
                                    children: t.project
                                }),
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                                    children: [
                                        t.task,
                                        " - ",
                                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("span", {
                                            className: "text-gray-500",
                                            children: t.description
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                            className: "flex items-center",
                            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $55a2f4e915921dc6$export$9b34edc570ae20bd), {
                                times: [
                                    t
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                isActive(t) ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    onClick: ()=>stopTime(t),
                                    children: [
                                        "Stop ",
                                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                            icon: (0, $159afdcd077ecfe9$export$95b9968e7fceb821)
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                    onClick: ()=>startTime(t),
                                    children: [
                                        "Start",
                                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                            icon: (0, $159afdcd077ecfe9$export$95b9968e7fceb821)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $c9ac255259af38e5$export$b0d92dbee9b5b60d), {
                                    to: `/time/edit/${(0, $59db8e72061ca567$export$c14ce44379ce803a)(t.id)}${queryParamForEditLink ? `?${queryParamForEditLink}` : ""}`,
                                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                        severity: "secondary",
                                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                            icon: (0, $159afdcd077ecfe9$export$7be713e57d023733)
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }, t.id)),
            times.length > 0 ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                className: "p-4 flex gap-5",
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                        className: "grow flex justify-end",
                        children: [
                            "Total:\xa0",
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $55a2f4e915921dc6$export$9b34edc570ae20bd), {
                                times: times
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        className: "w-28"
                    })
                ]
            }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                className: "p-4 flex h-96 items-center justify-center",
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("p", {
                    className: "italic",
                    children: "No times logged for this day"
                })
            })
        ]
    });
}







function $2b46ae43e0c598af$export$efe19b760242b2fc(date) {
    const MondayofWeekForDate = $2b46ae43e0c598af$export$57c1751413111a8(date);
    const week = [];
    for(let i = 0; i < 7; i++)week.push(new Date(MondayofWeekForDate.getTime() + i * 86400000));
    return week;
}
function $2b46ae43e0c598af$export$57c1751413111a8(date) {
    const monday = new Date(date);
    let weekDay = date.getDay();
    if (weekDay === 0) weekDay = 7;
    monday.setDate(date.getDate() - (weekDay - 1));
    return monday;
}



function $b4611adc6351a409$export$1dfab8a1a753a680({ date: date }) {
    const { locale: t, currentLocaleName: localeName } = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state);
    const weekDays = (0, $2b46ae43e0c598af$export$efe19b760242b2fc)(date);
    if (!weekDays[0] || !weekDays[6]) throw new Error("Invalid week days");
    const { data: times } = (0, $f95462c870cb2158$export$81f28d8f5590a939)({
        from: $b4611adc6351a409$var$firstSecondOfDay(weekDays[0]),
        to: $b4611adc6351a409$var$lastSecondOfDay(weekDays[6])
    });
    if (!times) return;
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
        className: "grid grid-cols-8 w-full border-b-2 border-gray-200",
        children: [
            weekDays.map((day)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $c9ac255259af38e5$export$b0d92dbee9b5b60d), {
                    className: `flex flex-col ${$b4611adc6351a409$var$isCurrentDate(day, date) ? "font-bold" : ""}`,
                    to: `/time?date=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(day)}`,
                    children: [
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("span", {
                            children: [
                                $b4611adc6351a409$var$getWeekDayShort(day, localeName),
                                " (",
                                $b4611adc6351a409$var$getShortDateFormat(day, localeName),
                                ")"
                            ]
                        }),
                        /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $55a2f4e915921dc6$export$9b34edc570ae20bd), {
                            flashColonIfActive: false,
                            times: timesForDate(day, times)
                        })
                    ]
                }, day.toISOString())),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                className: "flex items-center justify-center",
                children: [
                    t.time.total,
                    ": ",
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $55a2f4e915921dc6$export$9b34edc570ae20bd), {
                        flashColonIfActive: false,
                        times: times
                    })
                ]
            })
        ]
    });
    function timesForDate(date, times) {
        return times.filter((time)=>time.from >= $b4611adc6351a409$var$startOfDay(date) && time.from <= $b4611adc6351a409$var$endOfDay(date));
    }
}
function $b4611adc6351a409$var$startOfDay(date) {
    const startOfDay = new Date(date);
    startOfDay.setHours(0, 0, 0, 0);
    return startOfDay;
}
function $b4611adc6351a409$var$endOfDay(date) {
    const endOfDay = new Date(date);
    endOfDay.setHours(23, 59, 59, 999);
    return endOfDay;
}
function $b4611adc6351a409$var$isCurrentDate(date1, date2) {
    return date1.toISOString() === date2.toISOString();
}
function $b4611adc6351a409$var$getWeekDayShort(date, locale) {
    return date.toLocaleDateString(locale, {
        weekday: "short"
    });
}
function $b4611adc6351a409$var$getShortDateFormat(date, locale) {
    return date.toLocaleDateString(locale, {
        day: "numeric",
        month: "numeric"
    });
}
function $b4611adc6351a409$var$firstSecondOfDay(date) {
    // Get date at 00:00:00
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
function $b4611adc6351a409$var$lastSecondOfDay(date) {
    // Get date at 23:59:59
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
}





function $f1b3c665e328a827$export$680ea196effce5f() {
    const navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    const [searchParams] = (0, $c9ac255259af38e5$export$f1a78c17382fe22a)();
    const dateParam = searchParams.get("date");
    const queryClient = (0, $797f0ac2fbf7fdb2$export$22e77b9572c4fded)();
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    (0, $baslc.useEffect)(()=>{
        if (dateParam === null) navigate(`?date=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(new Date())}`);
    }, [
        dateParam,
        navigate
    ]);
    const date = dateParam ? new Date(dateParam) : new Date();
    const { data: times } = (0, $f95462c870cb2158$export$81f28d8f5590a939)({
        date: date
    });
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $d6899a6188537778$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $548c01f246e0e865$export$910ae8079b2c2852), {}),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                className: "flex gap-4 mb-4",
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                        route: `/time/create?date=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(date)}`,
                        size: "lg",
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                            icon: (0, $159afdcd077ecfe9$export$a105e7b44ca0eb9e)
                        })
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $245ba416705dd1ed$export$69b1032f2ecdf404), {
                        children: [
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                route: `/time/?date=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)($f1b3c665e328a827$var$previousDay(date))}`,
                                size: "lg",
                                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                    icon: (0, $159afdcd077ecfe9$export$85a918a11b7643c2)
                                })
                            }),
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                route: `/time/?date=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(new Date())}`,
                                size: "lg",
                                children: t.time.today
                            }),
                            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                                route: `/time/?date=${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)($f1b3c665e328a827$var$nextDay(date))}`,
                                size: "lg",
                                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $23985f7ea325d88e$export$2b9260d4a45c8710), {
                                    icon: (0, $159afdcd077ecfe9$export$f1011352b01c1c0)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $133d3bfd6646424c$export$9a59ccf3e6623d30), {
                        date: new Date(date)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                className: "hidden sm:block",
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $b4611adc6351a409$export$1dfab8a1a753a680), {
                    date: date
                })
            }),
            !times ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                className: "border-b border-gray-200 bg-gray-100 h-24 flex items-center justify-center",
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("p", {
                    className: "italic",
                    children: t.loading
                })
            }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $869c29730bfd90b0$export$2b1f73527d7bd6b5), {
                date: date,
                queryParamForEditLink: `date=${dateParam}`,
                times: times,
                onListChange: ()=>{
                    queryClient.invalidateQueries({
                        queryKey: [
                            "get-times",
                            date
                        ]
                    });
                }
            })
        ]
    });
}
function $f1b3c665e328a827$var$nextDay(date) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + 1);
    return newDate;
}
function $f1b3c665e328a827$var$previousDay(date) {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() - 1);
    return newDate;
}





var $baslc = parcelRequire("baslc");





var $baslc = parcelRequire("baslc");






var $baslc = parcelRequire("baslc");


function $93846199db1c8f99$export$6b41f50dc0c59fb3({ id: id, options: options, value: value, label: label, placeholder: placeholder, dropdown: dropdown, disabled: disabled, clearButton: clearButton, onChange: onChange }) {
    const [selectedIndex, setSelectedIndex] = (0, $baslc.useState)(-1);
    const [open, setOpen] = (0, $baslc.useState)(false);
    const [useFilter, setUseFilter] = (0, $baslc.useState)(false);
    const ref = (0, $baslc.useRef)(null);
    const allRef = (0, $baslc.useRef)(null);
    const filteredOptions = useFilter ? options.filter((option)=>option.toLowerCase().includes((value ?? "").toLowerCase())) : options;
    const isOpen = (0, $baslc.useMemo)(()=>{
        return open && filteredOptions.length > 0 && (filteredOptions[0] !== value || !useFilter);
    }, [
        open,
        filteredOptions,
        value,
        useFilter
    ]);
    // Register outside click event to close the dropdown
    (0, $baslc.useMemo)(()=>{
        function handleClickOutside(event) {
            if (allRef.current && !allRef.current.contains(event.target)) {
                setOpen(false);
                setSelectedIndex(-1);
            }
        }
        if (isOpen) document.addEventListener("mousedown", handleClickOutside);
        else document.removeEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
        ref: allRef,
        className: "flex w-full",
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
            className: "flex-grow relative",
            children: [
                /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                    ref: ref,
                    clearButton: clearButton,
                    disabled: disabled,
                    id: id,
                    inputClassName: dropdown ? "rounded-r-none" : "",
                    label: label,
                    placeholder: placeholder,
                    suffix: dropdown && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                        className: "!rounded-l-none w-[42px]",
                        disabled: disabled,
                        onClick: ()=>{
                            setUseFilter(false);
                            setOpen(true);
                            ref.current?.focus();
                        },
                        children: "\u25BC"
                    }),
                    suffixNoStyle: true,
                    type: "text",
                    value: value,
                    onChange: (event)=>{
                        setUseFilter(true);
                        onChange?.(event.target.value ?? "");
                    },
                    onFocus: ()=>{
                        if (value && value !== "") setOpen(true);
                    },
                    onKeyDown: (event)=>{
                        if (event.key === "ArrowDown") {
                            if (!open) setOpen(true);
                            setSelectedIndex((prevIndex)=>Math.min(prevIndex + 1, filteredOptions.length - 1));
                        } else if (event.key === "ArrowUp") setSelectedIndex((prevIndex)=>Math.max(0, prevIndex - 1));
                        else if (event.key === "Enter") {
                            event.preventDefault();
                            const option = filteredOptions[selectedIndex];
                            if (option) {
                                setOpen(false);
                                onChange?.(option);
                            }
                        }
                    }
                }),
                isOpen && filteredOptions.length > 0 && /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                    className: "bg-white absolute z-10 bg-white border border-gray-300 w-[calc(100%-43px)] max-h-60 overflow-y-auto flex flex-col",
                    children: filteredOptions.map((option, index)=>/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("button", {
                            className: `text-left px-2 py-1 ${index === selectedIndex ? "bg-gray-200" : ""}`,
                            type: "button",
                            onClick: ()=>{
                                onChange?.(option);
                                setOpen(false);
                            },
                            children: option
                        }, index))
                })
            ]
        })
    });
}




function $4f0e2a90c5455425$export$a8cb3edc180a0d41({ value: value, onSubmit: onSubmit, onCancel: onCancel, onChange: onChange, initChange: initChange = false, isValid: isValid = true, loading: loading = false, submitting: submitting = false, extraButtons: extraButtons }) {
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const [form, setForm] = (0, $baslc.useState)(value ? {
        ...value
    } : {
        project: "",
        task: "",
        description: "",
        startTime: "",
        endTime: ""
    });
    (0, $baslc.useEffect)(()=>{
        if (initChange && onChange) onChange(form);
    }, [
        initChange,
        onChange,
        form
    ]);
    const isLoading = (0, $baslc.useMemo)(()=>loading || submitting, [
        loading,
        submitting
    ]);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("form", {
        className: "flex flex-col gap-4 flex-grow",
        onSubmit: (event)=>{
            event.preventDefault();
            onSubmit(form);
        },
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                className: "flex gap-2",
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        className: "w-1/2",
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($4f0e2a90c5455425$var$ProjectSelector, {
                            disabled: isLoading,
                            value: form.project,
                            onChange: (project)=>{
                                const change = {
                                    ...form,
                                    project: project,
                                    task: ""
                                };
                                setForm(change);
                                if (onChange) onChange(change);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                        className: "w-1/2",
                        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($4f0e2a90c5455425$var$TaskSelector, {
                            disabled: form.project === "" || isLoading,
                            project: form.project,
                            value: form.task,
                            onChange: (task)=>{
                                setForm({
                                    ...form,
                                    task: task
                                });
                                if (onChange) onChange({
                                    ...form,
                                    task: task
                                });
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                    disabled: isLoading,
                    label: t.time.description,
                    rows: 10,
                    type: "textarea",
                    value: form.description,
                    onChange: (event)=>{
                        setForm({
                            ...form,
                            description: event.target.value
                        });
                        if (onChange) onChange(form);
                    }
                })
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                className: "flex gap-5 w-2/3 sm:w-1/3",
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                        className: "w-1/2",
                        disabled: isLoading,
                        label: t.time.startTime,
                        placeholder: "(now)",
                        type: "text",
                        value: form.startTime,
                        onBlur: ()=>{
                            setForm({
                                ...form,
                                startTime: $4f0e2a90c5455425$var$parseTime(form.startTime)
                            });
                            if (onChange) onChange({
                                ...form,
                                startTime: $4f0e2a90c5455425$var$parseTime(form.startTime)
                            });
                        },
                        onChange: (event)=>{
                            setForm({
                                ...form,
                                startTime: event.target.value
                            });
                            if (onChange) onChange({
                                ...form,
                                startTime: $4f0e2a90c5455425$var$parseTime(event.target.value)
                            });
                        }
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $173e23f76111c8c7$export$f5b8910cec6cf069), {
                        className: "w-1/2",
                        disabled: isLoading,
                        label: t.time.endTime,
                        type: "text",
                        value: form.endTime,
                        onBlur: ()=>setForm({
                                ...form,
                                endTime: $4f0e2a90c5455425$var$parseTime(form.endTime)
                            }),
                        onChange: (event)=>{
                            setForm({
                                ...form,
                                endTime: event.target.value
                            });
                            if (onChange) onChange({
                                ...form,
                                endTime: $4f0e2a90c5455425$var$parseTime(event.target.value)
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)("div", {
                className: "flex justify-end gap-2 mt-auto",
                children: [
                    extraButtons,
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                        disabled: isLoading,
                        severity: "secondary",
                        type: "button",
                        onClick: ()=>{
                            onCancel();
                        },
                        children: t.cancel
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
                        disabled: !isValid || isLoading,
                        loading: submitting,
                        type: "submit",
                        children: t.time.submit
                    })
                ]
            })
        ]
    });
}
function $4f0e2a90c5455425$var$ProjectSelector({ value: value, onChange: onChange, disabled: disabled = false }) {
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const { data: projects } = (0, $236361917f440320$export$39d4f31fc4866d70)();
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $93846199db1c8f99$export$6b41f50dc0c59fb3), {
        dropdown: true,
        disabled: disabled,
        id: "project",
        label: t.time.project,
        options: projects ?? [],
        value: value,
        onChange: (value)=>onChange(value)
    });
}
function $4f0e2a90c5455425$var$TaskSelector({ disabled: disabled = false, value: value, project: project, onChange: onChange }) {
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const { data: tasks } = (0, $fd27c95543d7b34e$export$ed5c3368304694)(project);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $93846199db1c8f99$export$6b41f50dc0c59fb3), {
        dropdown: true,
        disabled: disabled,
        id: "task",
        label: t.time.task,
        options: tasks?.map((task)=>task.name) ?? [],
        value: value,
        onChange: onChange
    });
}
function $4f0e2a90c5455425$var$parseTime(input) {
    input = input.trim();
    if (input === "") return "";
    const split = input.split(":");
    if (split.length === 2) {
        const hour = parseInt(split[0] ?? "0");
        const minute = parseInt(split[1] ?? "0");
        if (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59) return `${hour}:${(0, $711b938d01d2606f$export$bc3bea8325045070)(minute, 2)}`;
    } else if (split.length === 1) {
        if (input.length <= 2) {
            const hour = parseInt(input);
            if (hour >= 0 && hour <= 23) return `${hour}:00`;
        } else if (input.length <= 4) {
            const hour = parseInt(input.slice(0, 2));
            const minute = parseInt(input.slice(2));
            if (hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59) return `${hour}:${(0, $711b938d01d2606f$export$bc3bea8325045070)(minute, 2)}`;
        }
    }
    return "";
}










function $1b3206ef741e01d7$export$c03bb0116ee09d4b(date) {
    const dateObj = new Date(date);
    return !isNaN(dateObj.getTime());
}



function $e75d5b7a276278af$export$875e4e4b974329c0() {
    const navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    const [searchParams] = (0, $c9ac255259af38e5$export$f1a78c17382fe22a)();
    const [isValid, setIsValid] = (0, $baslc.useState)(false);
    const queryClient = (0, $797f0ac2fbf7fdb2$export$22e77b9572c4fded)();
    const confirm = (0, $1acd7cd2e978431e$export$bf4da147a5964edb)();
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const dateParam = searchParams.get("date");
    if (dateParam === null || dateParam !== null && !(0, $1b3206ef741e01d7$export$c03bb0116ee09d4b)(dateParam)) throw new Error("Invalid date");
    const date = new Date(dateParam);
    const [saving, setSaving] = (0, $baslc.useState)(false);
    function onHide() {
        navigate(`/time?date=${dateParam}`);
    }
    function onChange(time) {
        // Not valid if project or task is empty or toTime is set but not fromTime
        setIsValid(time.project.trim() !== "" && time.task.trim() !== "" && (!time.endTime.trim() || time.startTime.trim() !== ""));
    }
    function onSubmit(time) {
        (async ()=>{
            setSaving(true);
            const now = (0, $b6e0b58b8c4d7e7d$export$b2da1ca3b2ae4215)(new Date());
            const fromTime = time.startTime.trim() === "" ? now : new Date(`${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(date)} ${time.startTime}`);
            const toTime = time.endTime.trim() ? new Date(`${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(date)} ${time.endTime}`) : undefined;
            if (fromTime > now && !toTime) // Set fromTime to the previous day if it is before now
            fromTime.setDate(fromTime.getDate() - 1);
            if (toTime && toTime < fromTime) // Set toTime to the next day if it is before fromTime
            toTime.setDate(toTime.getDate() + 1);
            if (!(0, $41979425e36fe33c$export$ea39ec197993aef0)(fromTime, date) && !await confirm({
                message: t.time.confirmStartDifferentDay,
                header: t.confirmation
            })) return;
            try {
                await (0, $56c35c168e39dea0$export$b9cfd76caec8e929)((0, $ff2003bc1ca03230$export$5209ab621307cb87).parse({
                    ...time.project.trim() ? {
                        project: time.project.trim()
                    } : {},
                    ...time.task.trim() ? {
                        task: time.task.trim()
                    } : {},
                    ...time.description.trim() ? {
                        description: time.description.trim()
                    } : {},
                    from: fromTime,
                    ...toTime ? {
                        to: toTime
                    } : {}
                }));
            } catch (error) {
                if (error === (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED) {
                    (0, $d9482e4a5ea3dee8$export$8f35fbd5db0f3634)("error", error);
                    return;
                }
                throw error;
            }
            const weekDates = (0, $2b46ae43e0c598af$export$efe19b760242b2fc)(date);
            // Invalidate time for date
            await queryClient.refetchQueries({
                queryKey: [
                    "get-times",
                    date
                ]
            });
            // Invalidate time for week
            await queryClient.refetchQueries({
                queryKey: [
                    "get-times",
                    weekDates[0],
                    weekDates[6]
                ]
            });
            navigate(`/time?date=${dateParam}`);
        })();
    }
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $d6899a6188537778$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $5876bcf854e2183c$export$2b77a92f1a5ad772), {
            onClose: onHide,
            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $4f0e2a90c5455425$export$a8cb3edc180a0d41), {
                isValid: isValid,
                submitting: saving,
                onCancel: onHide,
                onChange: onChange,
                onSubmit: onSubmit
            })
        })
    });
}





var $baslc = parcelRequire("baslc");














function $414f7aebce7a16f3$export$94f4d87fad5dcf9a(date) {
    const hour = date.getHours();
    const minute = date.getMinutes();
    return `${hour}:${(0, $711b938d01d2606f$export$bc3bea8325045070)(minute, 2)}`;
}



function $0d697503cef37a68$export$bf2832b6206e743e() {
    const navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    const [searchParams] = (0, $c9ac255259af38e5$export$f1a78c17382fe22a)();
    const { id: id } = (0, $548c01f246e0e865$export$99eaa27ddbbb95ef)();
    const [loading, setLoading] = (0, $baslc.useState)(true);
    const [time, setTime] = (0, $baslc.useState)();
    const dateParam = searchParams.get("date");
    if (!id) throw new Error("Invalid id");
    (0, $baslc.useEffect)(()=>{
        (async ()=>{
            setLoading(true);
            setTime(await (0, $56c35c168e39dea0$export$1428f42a7de81803)(id));
            setLoading(false);
        })();
    }, [
        id
    ]);
    function onHide() {
        navigate(`/time?date=${dateParam}`);
    }
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $5876bcf854e2183c$export$2b77a92f1a5ad772), {
        onClose: onHide,
        children: loading || !time ? /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)("div", {
            className: "flex justify-center items-center h-full",
            children: "Loading..."
        }) : /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($0d697503cef37a68$var$Form, {
            id: id,
            time: time,
            onHide: onHide
        })
    });
}
function $0d697503cef37a68$var$Form({ id: id, time: time, onHide: onHide }) {
    const [isValid, setIsValid] = (0, $baslc.useState)(false);
    const queryClient = (0, $797f0ac2fbf7fdb2$export$22e77b9572c4fded)();
    const confirm = (0, $1acd7cd2e978431e$export$bf4da147a5964edb)();
    const t = (0, $eaf53d8fc6d3f278$export$43bb16f9c6d9e3f7)((state)=>state.locale);
    const [deleting, setDeleting] = (0, $baslc.useState)(false);
    const [saving, setSaving] = (0, $baslc.useState)(false);
    function onChange(timeForm) {
        // Not valid if project or task is empty or toTime is set but not fromTime or toTime is not set but original toTime is set
        setIsValid(timeForm.project.trim() !== "" && timeForm.task.trim() !== "" && (!timeForm.endTime.trim() || timeForm.startTime.trim() !== "") && (!time.to || timeForm.startTime.trim() !== ""));
    }
    function onSubmit(timeForm) {
        (async ()=>{
            setSaving(true);
            const now = (0, $b6e0b58b8c4d7e7d$export$b2da1ca3b2ae4215)(new Date());
            const fromTime = timeForm.startTime.trim() === "" ? now : new Date(`${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(time.from)} ${timeForm.startTime}`);
            const toTime = timeForm.endTime.trim() ? new Date(`${(0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(time.from)} ${timeForm.endTime}`) : undefined;
            if (fromTime > now && !toTime) // Set fromTime to the previous day if it is before now
            fromTime.setDate(fromTime.getDate() - 1);
            if (toTime && toTime < fromTime) // Set toTime to the next day if it is before fromTime
            toTime.setDate(toTime.getDate() + 1);
            if (!(0, $41979425e36fe33c$export$ea39ec197993aef0)(fromTime, time.from)) {
                if (!await confirm({
                    message: "Start time is not on the same day as the original time. Are you sure you want to proceed?",
                    header: "Confirmation"
                })) {
                    setSaving(false);
                    return;
                }
            }
            let updatedTime;
            try {
                updatedTime = await (0, $56c35c168e39dea0$export$8a41ea59a31e0100)(id, (0, $ff2003bc1ca03230$export$34d0edd018abeb3d).parse({
                    ...timeForm.project.trim() ? {
                        project: timeForm.project.trim()
                    } : {},
                    ...timeForm.task.trim() ? {
                        task: timeForm.task.trim()
                    } : {},
                    ...timeForm.description.trim() ? {
                        description: timeForm.description.trim()
                    } : {},
                    from: fromTime,
                    ...toTime ? {
                        to: toTime
                    } : {}
                }));
            } catch (error) {
                if (error === (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED) {
                    (0, $d9482e4a5ea3dee8$export$8f35fbd5db0f3634)("error", error);
                    return;
                }
                throw error;
            } finally{
                setSaving(false);
            }
            const originalDate = new Date((0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(time.from));
            const updatedDate = new Date((0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(updatedTime.from));
            const refreshDates = [
                originalDate
            ];
            if ((0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(originalDate) !== (0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(updatedDate)) refreshDates.push(updatedDate);
            for (const date of refreshDates){
                const weekDates = (0, $2b46ae43e0c598af$export$efe19b760242b2fc)(date);
                await queryClient.refetchQueries({
                    queryKey: [
                        "get-times",
                        date
                    ]
                });
                await queryClient.refetchQueries({
                    queryKey: [
                        "get-times",
                        weekDates[0],
                        weekDates[6]
                    ]
                });
            }
            onHide();
        })();
    }
    function deleteTime(id) {
        (async ()=>{
            if (!await confirm({
                message: t.time.confirmDelete,
                header: t.confirmation
            })) return;
            setDeleting(true);
            try {
                await (0, $56c35c168e39dea0$export$6d22acf1594fc61d)(id);
            } catch (error) {
                if (error === (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED) {
                    (0, $d9482e4a5ea3dee8$export$8f35fbd5db0f3634)("error", error);
                    return;
                }
                setDeleting(false);
                throw error;
            }
            const date = new Date((0, $40ab97940cbcc966$export$4e4cb19dd88cd821)(time.from));
            const weekDates = (0, $2b46ae43e0c598af$export$efe19b760242b2fc)(date);
            // Invalidate time for date
            await queryClient.refetchQueries({
                queryKey: [
                    "get-times",
                    date
                ]
            });
            // Invalidate time for week
            await queryClient.refetchQueries({
                queryKey: [
                    "get-times",
                    weekDates[0],
                    weekDates[6]
                ]
            });
            onHide();
        })();
    }
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $4f0e2a90c5455425$export$a8cb3edc180a0d41), {
        extraButtons: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $275ef3258ca67a90$export$353f5b6fc5456de1), {
            outline: true,
            disabled: deleting || saving,
            loading: deleting,
            severity: "danger",
            type: "button",
            onClick: ()=>deleteTime(id),
            children: t.time.delete
        }),
        initChange: true,
        isValid: isValid,
        loading: deleting,
        submitting: saving,
        value: time ? {
            ...time,
            startTime: (0, $414f7aebce7a16f3$export$94f4d87fad5dcf9a)(time.from),
            endTime: time.to ? (0, $414f7aebce7a16f3$export$94f4d87fad5dcf9a)(time.to) : "",
            description: time.description ?? ""
        } : undefined,
        onCancel: onHide,
        onChange: onChange,
        onSubmit: onSubmit
    });
}






function $6840e8b44f75a905$export$86fbec116b87613f() {
    const queryClient = new (0, $79c9c45c793aba73$export$405d0624ed55a03f)();
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($baslc))).StrictMode, {
        children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $797f0ac2fbf7fdb2$export$45604f0cc8ae667b), {
            client: queryClient,
            children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $1acd7cd2e978431e$export$2245215e6bd26540), {
                children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $c9ac255259af38e5$export$9ba4e89fdfa1fc54), {
                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)($6840e8b44f75a905$var$Paths, {})
                })
            })
        })
    });
}
function $6840e8b44f75a905$var$Paths() {
    const navigate = (0, $548c01f246e0e865$export$9770f232ac06a008)();
    const location = (0, $548c01f246e0e865$export$45d76561a5302f2b)();
    const authStore = (0, $45422d7966ef8166$export$650ce9f0b4df82fd)();
    const setIsAuthRef = (0, $baslc.useRef)(authStore.setIsAuth);
    const navigateRef = (0, $baslc.useRef)(navigate);
    (0, $baslc.useEffect)(()=>{
        if (location.pathname === "/") navigate("/home");
    });
    (0, $baslc.useEffect)(()=>{
        let handleEsc;
        if (!authStore.isAuth) {
            // Listen to esc key
            handleEsc = (event)=>{
                if (event.ctrlKey && event.key === "Escape") // navigate to login page
                navigate("/login");
            };
            window.addEventListener("keydown", handleEsc);
        }
        return ()=>{
            if (handleEsc) window.removeEventListener("keydown", handleEsc);
        };
    });
    // Logout and redirect to home if fetch error is encountered
    (0, $baslc.useEffect)(()=>{
        const { unsubscribe: unsubscribe } = (0, $d9482e4a5ea3dee8$export$af631764ddc44097)("error", (error)=>{
            if (error === (0, $37be088548bec045$export$a71624947af1f122).UNAUTHORIZED) (async ()=>{
                await (0, $2ccd26ee17720849$export$a0973bcfe11b05c9)();
                setIsAuthRef.current(false);
                navigateRef.current("/");
            })();
        });
        return ()=>{
            unsubscribe();
        };
    }, []);
    return /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $548c01f246e0e865$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $548c01f246e0e865$export$e7b0ac011bb776c6), {
                index: true,
                element: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $668b279d534888b2$export$ef88aa0d34c34520), {
                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $a0b46b89485c073d$export$b94310965bed44e6), {})
                }),
                path: "/home"
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsxs)((0, $548c01f246e0e865$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $668b279d534888b2$export$ef88aa0d34c34520), {
                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $f1b3c665e328a827$export$680ea196effce5f), {})
                }),
                path: "/time",
                children: [
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $548c01f246e0e865$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $e75d5b7a276278af$export$875e4e4b974329c0), {}),
                        path: "create"
                    }),
                    /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $548c01f246e0e865$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $0d697503cef37a68$export$bf2832b6206e743e), {}),
                        path: "edit/:id"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $548c01f246e0e865$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $668b279d534888b2$export$ef88aa0d34c34520), {
                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $12d80cfc63c01b2f$export$33aa3110c4070c17), {})
                }),
                path: "/report"
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $548c01f246e0e865$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $668b279d534888b2$export$ef88aa0d34c34520), {
                    children: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $401fc7c7dcb14efc$export$21a94553ffa41578), {})
                }),
                path: "/login"
            }),
            /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $548c01f246e0e865$export$e7b0ac011bb776c6), {
                element: /*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $df26a3ab557252de$export$cad1a703886b4e3a), {}),
                path: "/logout"
            })
        ]
    });
}


const $70fc9a727fa662ae$var$container = document.getElementById("root");
if (!$70fc9a727fa662ae$var$container) throw new Error("No container found");
const $70fc9a727fa662ae$var$root = (0, $feb3c2d3b6de7499$exports.createRoot)($70fc9a727fa662ae$var$container);
$70fc9a727fa662ae$var$root.render(/*#__PURE__*/ (0, $d6899a6188537778$exports.jsx)((0, $6840e8b44f75a905$export$86fbec116b87613f), {}));


//# sourceMappingURL=spa.4b8ba6e8.js.map
